let polygonCampos = [
  {
    lng: -41.8883322,
    lat: -21.8644968
  },
  {
    lng: -41.8879389,
    lat: -21.864312
  },
  {
    lng: -41.8877007,
    lat: -21.8641462
  },
  {
    lng: -41.8877526,
    lat: -21.8637441
  },
  {
    lng: -41.8879365,
    lat: -21.8632316
  },
  {
    lng: -41.8879461,
    lat: -21.8627884
  },
  {
    lng: -41.8878939,
    lat: -21.8624085
  },
  {
    lng: -41.887136,
    lat: -21.8619105
  },
  {
    lng: -41.8865764,
    lat: -21.8614323
  },
  {
    lng: -41.8863716,
    lat: -21.8613155
  },
  {
    lng: -41.8861016,
    lat: -21.8606252
  },
  {
    lng: -41.8859012,
    lat: -21.860307
  },
  {
    lng: -41.8854043,
    lat: -21.8597252
  },
  {
    lng: -41.8852048,
    lat: -21.8593667
  },
  {
    lng: -41.8848948,
    lat: -21.8585304
  },
  {
    lng: -41.8847193,
    lat: -21.858261
  },
  {
    lng: -41.8838866,
    lat: -21.8581778
  },
  {
    lng: -41.8832166,
    lat: -21.8580166
  },
  {
    lng: -41.8826632,
    lat: -21.8578916
  },
  {
    lng: -41.882101,
    lat: -21.8575343
  },
  {
    lng: -41.8814174,
    lat: -21.8571989
  },
  {
    lng: -41.8809164,
    lat: -21.8568024
  },
  {
    lng: -41.8806372,
    lat: -21.8565391
  },
  {
    lng: -41.8803133,
    lat: -21.8563395
  },
  {
    lng: -41.8797918,
    lat: -21.8560958
  },
  {
    lng: -41.8792691,
    lat: -21.8559086
  },
  {
    lng: -41.8789625,
    lat: -21.8557093
  },
  {
    lng: -41.8786743,
    lat: -21.8554619
  },
  {
    lng: -41.8782681,
    lat: -21.8550753
  },
  {
    lng: -41.8775183,
    lat: -21.8546097
  },
  {
    lng: -41.8767859,
    lat: -21.8541362
  },
  {
    lng: -41.8764263,
    lat: -21.8539924
  },
  {
    lng: -41.875459,
    lat: -21.8535359
  },
  {
    lng: -41.8749005,
    lat: -21.8533901
  },
  {
    lng: -41.874299,
    lat: -21.852951
  },
  {
    lng: -41.8739882,
    lat: -21.8522303
  },
  {
    lng: -41.8735647,
    lat: -21.8514251
  },
  {
    lng: -41.8730017,
    lat: -21.8510545
  },
  {
    lng: -41.8724229,
    lat: -21.8508226
  },
  {
    lng: -41.8717848,
    lat: -21.8504014
  },
  {
    lng: -41.8713195,
    lat: -21.8502885
  },
  {
    lng: -41.8700282,
    lat: -21.8496194
  },
  {
    lng: -41.8693219,
    lat: -21.8493351
  },
  {
    lng: -41.8686147,
    lat: -21.8491374
  },
  {
    lng: -41.8683308,
    lat: -21.8490532
  },
  {
    lng: -41.8678245,
    lat: -21.8490067
  },
  {
    lng: -41.8673746,
    lat: -21.8490145
  },
  {
    lng: -41.8670924,
    lat: -21.8489669
  },
  {
    lng: -41.866795,
    lat: -21.8488671
  },
  {
    lng: -41.8664831,
    lat: -21.8487412
  },
  {
    lng: -41.8661423,
    lat: -21.8485764
  },
  {
    lng: -41.8659443,
    lat: -21.8484247
  },
  {
    lng: -41.8656128,
    lat: -21.8484003
  },
  {
    lng: -41.8653053,
    lat: -21.8483538
  },
  {
    lng: -41.8647993,
    lat: -21.8482321
  },
  {
    lng: -41.8646145,
    lat: -21.8481303
  },
  {
    lng: -41.8636907,
    lat: -21.8476474
  },
  {
    lng: -41.8631705,
    lat: -21.8474616
  },
  {
    lng: -41.8629211,
    lat: -21.8470761
  },
  {
    lng: -41.8627608,
    lat: -21.8467507
  },
  {
    lng: -41.8624057,
    lat: -21.8465722
  },
  {
    lng: -41.8620708,
    lat: -21.8463113
  },
  {
    lng: -41.8617503,
    lat: -21.8460946
  },
  {
    lng: -41.8612216,
    lat: -21.8458767
  },
  {
    lng: -41.8608036,
    lat: -21.8455743
  },
  {
    lng: -41.8604033,
    lat: -21.845335
  },
  {
    lng: -41.8598682,
    lat: -21.8451188
  },
  {
    lng: -41.8586589,
    lat: -21.844914
  },
  {
    lng: -41.8581683,
    lat: -21.8446214
  },
  {
    lng: -41.8579043,
    lat: -21.8443839
  },
  {
    lng: -41.8574106,
    lat: -21.843664
  },
  {
    lng: -41.8569233,
    lat: -21.8434605
  },
  {
    lng: -41.8564361,
    lat: -21.8432101
  },
  {
    lng: -41.8558518,
    lat: -21.842683
  },
  {
    lng: -41.855206,
    lat: -21.842156
  },
  {
    lng: -41.8547398,
    lat: -21.8418072
  },
  {
    lng: -41.8537569,
    lat: -21.841345
  },
  {
    lng: -41.8533075,
    lat: -21.8409656
  },
  {
    lng: -41.8527913,
    lat: -21.8400931
  },
  {
    lng: -41.8517443,
    lat: -21.8392123
  },
  {
    lng: -41.8512618,
    lat: -21.8385644
  },
  {
    lng: -41.8508472,
    lat: -21.8377826
  },
  {
    lng: -41.8504763,
    lat: -21.8373724
  },
  {
    lng: -41.8502034,
    lat: -21.837214
  },
  {
    lng: -41.8499756,
    lat: -21.8372029
  },
  {
    lng: -41.8492855,
    lat: -21.8373335
  },
  {
    lng: -41.8486133,
    lat: -21.8372723
  },
  {
    lng: -41.8484138,
    lat: -21.8373168
  },
  {
    lng: -41.8480326,
    lat: -21.837374
  },
  {
    lng: -41.8477793,
    lat: -21.8375063
  },
  {
    lng: -41.8471448,
    lat: -21.8369056
  },
  {
    lng: -41.846877,
    lat: -21.8365003
  },
  {
    lng: -41.8466485,
    lat: -21.8363076
  },
  {
    lng: -41.8458728,
    lat: -21.8362444
  },
  {
    lng: -41.8454382,
    lat: -21.8363731
  },
  {
    lng: -41.8451743,
    lat: -21.8365938
  },
  {
    lng: -41.8448347,
    lat: -21.8367243
  },
  {
    lng: -41.844336,
    lat: -21.8366261
  },
  {
    lng: -41.8441306,
    lat: -21.8365416
  },
  {
    lng: -41.8437954,
    lat: -21.8364707
  },
  {
    lng: -41.8432039,
    lat: -21.8364001
  },
  {
    lng: -41.8427549,
    lat: -21.8363263
  },
  {
    lng: -41.842505,
    lat: -21.8362525
  },
  {
    lng: -41.841841,
    lat: -21.8358205
  },
  {
    lng: -41.8413721,
    lat: -21.8355455
  },
  {
    lng: -41.8406886,
    lat: -21.835218
  },
  {
    lng: -41.840322,
    lat: -21.8350014
  },
  {
    lng: -41.8398722,
    lat: -21.8346461
  },
  {
    lng: -41.8394502,
    lat: -21.8342027
  },
  {
    lng: -41.8391003,
    lat: -21.8340186
  },
  {
    lng: -41.8385111,
    lat: -21.8337171
  },
  {
    lng: -41.838239,
    lat: -21.8335264
  },
  {
    lng: -41.8377752,
    lat: -21.8332338
  },
  {
    lng: -41.8373679,
    lat: -21.8330905
  },
  {
    lng: -41.8372362,
    lat: -21.8327977
  },
  {
    lng: -41.837269,
    lat: -21.832484
  },
  {
    lng: -41.8375061,
    lat: -21.8319081
  },
  {
    lng: -41.8379945,
    lat: -21.8312071
  },
  {
    lng: -41.838368,
    lat: -21.830409
  },
  {
    lng: -41.8389933,
    lat: -21.8290666
  },
  {
    lng: -41.8390373,
    lat: -21.8278501
  },
  {
    lng: -41.8391841,
    lat: -21.8268686
  },
  {
    lng: -41.8389726,
    lat: -21.8263491
  },
  {
    lng: -41.8384826,
    lat: -21.8259853
  },
  {
    lng: -41.8381282,
    lat: -21.8260027
  },
  {
    lng: -41.8372768,
    lat: -21.8258493
  },
  {
    lng: -41.8369478,
    lat: -21.8258118
  },
  {
    lng: -41.8364969,
    lat: -21.8257001
  },
  {
    lng: -41.8364135,
    lat: -21.8254538
  },
  {
    lng: -41.8359188,
    lat: -21.8247833
  },
  {
    lng: -41.8354683,
    lat: -21.8244602
  },
  {
    lng: -41.8352229,
    lat: -21.8238428
  },
  {
    lng: -41.8352596,
    lat: -21.8233518
  },
  {
    lng: -41.8355815,
    lat: -21.822455
  },
  {
    lng: -41.8354144,
    lat: -21.8217841
  },
  {
    lng: -41.8351444,
    lat: -21.8214604
  },
  {
    lng: -41.8347426,
    lat: -21.8211391
  },
  {
    lng: -41.8344945,
    lat: -21.8208151
  },
  {
    lng: -41.8341834,
    lat: -21.8206358
  },
  {
    lng: -41.8339689,
    lat: -21.8204086
  },
  {
    lng: -41.8334291,
    lat: -21.8202209
  },
  {
    lng: -41.8330123,
    lat: -21.8199388
  },
  {
    lng: -41.8326009,
    lat: -21.8194029
  },
  {
    lng: -41.8323567,
    lat: -21.8190382
  },
  {
    lng: -41.8320286,
    lat: -21.8187348
  },
  {
    lng: -41.8316979,
    lat: -21.8184625
  },
  {
    lng: -41.831257,
    lat: -21.8180243
  },
  {
    lng: -41.8306017,
    lat: -21.8176675
  },
  {
    lng: -41.8300617,
    lat: -21.8177267
  },
  {
    lng: -41.8295808,
    lat: -21.8177098
  },
  {
    lng: -41.8293156,
    lat: -21.8179423
  },
  {
    lng: -41.8291525,
    lat: -21.8180024
  },
  {
    lng: -41.8288817,
    lat: -21.8179682
  },
  {
    lng: -41.8286134,
    lat: -21.8179207
  },
  {
    lng: -41.8280444,
    lat: -21.8175585
  },
  {
    lng: -41.8275681,
    lat: -21.8174376
  },
  {
    lng: -41.8270316,
    lat: -21.8172624
  },
  {
    lng: -41.826516,
    lat: -21.8172263
  },
  {
    lng: -41.8258662,
    lat: -21.8174716
  },
  {
    lng: -41.8256689,
    lat: -21.8170244
  },
  {
    lng: -41.825108,
    lat: -21.8166186
  },
  {
    lng: -41.8246255,
    lat: -21.8164002
  },
  {
    lng: -41.8242023,
    lat: -21.81619
  },
  {
    lng: -41.8239788,
    lat: -21.8157584
  },
  {
    lng: -41.823704,
    lat: -21.8153017
  },
  {
    lng: -41.8234737,
    lat: -21.8150556
  },
  {
    lng: -41.8230419,
    lat: -21.8147891
  },
  {
    lng: -41.8224759,
    lat: -21.814617
  },
  {
    lng: -41.8219359,
    lat: -21.8144373
  },
  {
    lng: -41.8215096,
    lat: -21.8141953
  },
  {
    lng: -41.8210601,
    lat: -21.8138063
  },
  {
    lng: -41.8206711,
    lat: -21.8134616
  },
  {
    lng: -41.8202903,
    lat: -21.8131157
  },
  {
    lng: -41.8199246,
    lat: -21.8128668
  },
  {
    lng: -41.8192729,
    lat: -21.8122738
  },
  {
    lng: -41.8190281,
    lat: -21.8116322
  },
  {
    lng: -41.8189546,
    lat: -21.8111504
  },
  {
    lng: -41.8189052,
    lat: -21.8109446
  },
  {
    lng: -41.8185749,
    lat: -21.81074
  },
  {
    lng: -41.8179756,
    lat: -21.8104268
  },
  {
    lng: -41.8173232,
    lat: -21.8101735
  },
  {
    lng: -41.8167414,
    lat: -21.8100241
  },
  {
    lng: -41.8162572,
    lat: -21.8096681
  },
  {
    lng: -41.8161158,
    lat: -21.8094236
  },
  {
    lng: -41.815794,
    lat: -21.8091432
  },
  {
    lng: -41.8155616,
    lat: -21.8087196
  },
  {
    lng: -41.8154154,
    lat: -21.8083056
  },
  {
    lng: -41.8153665,
    lat: -21.8081757
  },
  {
    lng: -41.8151154,
    lat: -21.8074291
  },
  {
    lng: -41.815132,
    lat: -21.8066797
  },
  {
    lng: -41.814957,
    lat: -21.8063942
  },
  {
    lng: -41.8144279,
    lat: -21.8061179
  },
  {
    lng: -41.8137994,
    lat: -21.8060413
  },
  {
    lng: -41.8131695,
    lat: -21.8060291
  },
  {
    lng: -41.8127909,
    lat: -21.8059735
  },
  {
    lng: -41.8122875,
    lat: -21.8057058
  },
  {
    lng: -41.8117365,
    lat: -21.8053757
  },
  {
    lng: -41.8112626,
    lat: -21.8051301
  },
  {
    lng: -41.8108983,
    lat: -21.8048969
  },
  {
    lng: -41.8107381,
    lat: -21.8048163
  },
  {
    lng: -41.8106215,
    lat: -21.8045288
  },
  {
    lng: -41.810349,
    lat: -21.8043623
  },
  {
    lng: -41.8103574,
    lat: -21.8039836
  },
  {
    lng: -41.810284,
    lat: -21.8037887
  },
  {
    lng: -41.8101393,
    lat: -21.8036972
  },
  {
    lng: -41.810108,
    lat: -21.8035515
  },
  {
    lng: -41.8103921,
    lat: -21.8031942
  },
  {
    lng: -41.8103344,
    lat: -21.8026852
  },
  {
    lng: -41.8102149,
    lat: -21.8022315
  },
  {
    lng: -41.8099052,
    lat: -21.8014032
  },
  {
    lng: -41.8099742,
    lat: -21.8010946
  },
  {
    lng: -41.8100745,
    lat: -21.8007777
  },
  {
    lng: -41.8102105,
    lat: -21.800482
  },
  {
    lng: -41.8102962,
    lat: -21.8001209
  },
  {
    lng: -41.8102985,
    lat: -21.7996292
  },
  {
    lng: -41.8101755,
    lat: -21.7993366
  },
  {
    lng: -41.8100516,
    lat: -21.7990968
  },
  {
    lng: -41.8099085,
    lat: -21.7989203
  },
  {
    lng: -41.8097179,
    lat: -21.7985619
  },
  {
    lng: -41.8094489,
    lat: -21.7982342
  },
  {
    lng: -41.8090074,
    lat: -21.7979032
  },
  {
    lng: -41.8086674,
    lat: -21.7976629
  },
  {
    lng: -41.8080709,
    lat: -21.7973127
  },
  {
    lng: -41.8075414,
    lat: -21.796927
  },
  {
    lng: -41.8070485,
    lat: -21.7967045
  },
  {
    lng: -41.8065486,
    lat: -21.7966305
  },
  {
    lng: -41.8056185,
    lat: -21.7965172
  },
  {
    lng: -41.8049679,
    lat: -21.7965651
  },
  {
    lng: -41.8044643,
    lat: -21.796461
  },
  {
    lng: -41.8031442,
    lat: -21.7968224
  },
  {
    lng: -41.8024855,
    lat: -21.7968417
  },
  {
    lng: -41.8018737,
    lat: -21.7968945
  },
  {
    lng: -41.801471,
    lat: -21.7967206
  },
  {
    lng: -41.7999773,
    lat: -21.7963821
  },
  {
    lng: -41.7996085,
    lat: -21.7961527
  },
  {
    lng: -41.7989442,
    lat: -21.7958703
  },
  {
    lng: -41.7979251,
    lat: -21.7959046
  },
  {
    lng: -41.7974674,
    lat: -21.7959062
  },
  {
    lng: -41.7969362,
    lat: -21.7953396
  },
  {
    lng: -41.7962667,
    lat: -21.7947784
  },
  {
    lng: -41.7957853,
    lat: -21.7943015
  },
  {
    lng: -41.7955601,
    lat: -21.793996
  },
  {
    lng: -41.7954894,
    lat: -21.7936347
  },
  {
    lng: -41.7954507,
    lat: -21.7930455
  },
  {
    lng: -41.795301,
    lat: -21.7927927
  },
  {
    lng: -41.7947829,
    lat: -21.7920248
  },
  {
    lng: -41.7947807,
    lat: -21.7917346
  },
  {
    lng: -41.7948301,
    lat: -21.7914534
  },
  {
    lng: -41.7949223,
    lat: -21.7911891
  },
  {
    lng: -41.7952417,
    lat: -21.7908003
  },
  {
    lng: -41.795489,
    lat: -21.7903261
  },
  {
    lng: -41.7955122,
    lat: -21.7902816
  },
  {
    lng: -41.7955253,
    lat: -21.7896933
  },
  {
    lng: -41.795309,
    lat: -21.7889394
  },
  {
    lng: -41.7952711,
    lat: -21.7883179
  },
  {
    lng: -41.7953027,
    lat: -21.7876736
  },
  {
    lng: -41.7954941,
    lat: -21.7872178
  },
  {
    lng: -41.7960229,
    lat: -21.7867283
  },
  {
    lng: -41.7963636,
    lat: -21.7857675
  },
  {
    lng: -41.7966154,
    lat: -21.7849259
  },
  {
    lng: -41.7963858,
    lat: -21.7843813
  },
  {
    lng: -41.79588,
    lat: -21.7838395
  },
  {
    lng: -41.7951552,
    lat: -21.7834385
  },
  {
    lng: -41.7947776,
    lat: -21.7837294
  },
  {
    lng: -41.7941739,
    lat: -21.7840966
  },
  {
    lng: -41.793351,
    lat: -21.7842257
  },
  {
    lng: -41.7926998,
    lat: -21.7840115
  },
  {
    lng: -41.7925009,
    lat: -21.7838518
  },
  {
    lng: -41.7922744,
    lat: -21.7837372
  },
  {
    lng: -41.791896,
    lat: -21.7832865
  },
  {
    lng: -41.7916161,
    lat: -21.7830634
  },
  {
    lng: -41.7910891,
    lat: -21.7826984
  },
  {
    lng: -41.7904713,
    lat: -21.7821463
  },
  {
    lng: -41.7900042,
    lat: -21.7818067
  },
  {
    lng: -41.7893341,
    lat: -21.7816647
  },
  {
    lng: -41.7890325,
    lat: -21.7816427
  },
  {
    lng: -41.788627,
    lat: -21.7816348
  },
  {
    lng: -41.7882861,
    lat: -21.7822167
  },
  {
    lng: -41.7879176,
    lat: -21.7824836
  },
  {
    lng: -41.7874105,
    lat: -21.7830039
  },
  {
    lng: -41.7869418,
    lat: -21.7836658
  },
  {
    lng: -41.7862351,
    lat: -21.7834413
  },
  {
    lng: -41.7856804,
    lat: -21.7833401
  },
  {
    lng: -41.7851532,
    lat: -21.783365
  },
  {
    lng: -41.7847316,
    lat: -21.7836953
  },
  {
    lng: -41.7841642,
    lat: -21.7836766
  },
  {
    lng: -41.7832035,
    lat: -21.7838796
  },
  {
    lng: -41.7826101,
    lat: -21.7840006
  },
  {
    lng: -41.7824095,
    lat: -21.7840935
  },
  {
    lng: -41.7816776,
    lat: -21.7840147
  },
  {
    lng: -41.7813479,
    lat: -21.7840889
  },
  {
    lng: -41.7807012,
    lat: -21.7841246
  },
  {
    lng: -41.7802878,
    lat: -21.7841869
  },
  {
    lng: -41.7794754,
    lat: -21.7844555
  },
  {
    lng: -41.7788161,
    lat: -21.7846038
  },
  {
    lng: -41.7780181,
    lat: -21.7847817
  },
  {
    lng: -41.7774925,
    lat: -21.7847392
  },
  {
    lng: -41.7773467,
    lat: -21.78547
  },
  {
    lng: -41.7773059,
    lat: -21.7857513
  },
  {
    lng: -41.7774393,
    lat: -21.7859311
  },
  {
    lng: -41.7776469,
    lat: -21.7864623
  },
  {
    lng: -41.7774345,
    lat: -21.7867055
  },
  {
    lng: -41.7770662,
    lat: -21.787062
  },
  {
    lng: -41.7766714,
    lat: -21.7874883
  },
  {
    lng: -41.7766975,
    lat: -21.7878677
  },
  {
    lng: -41.776593,
    lat: -21.7882929
  },
  {
    lng: -41.7760546,
    lat: -21.7884356
  },
  {
    lng: -41.7757837,
    lat: -21.788769
  },
  {
    lng: -41.7754842,
    lat: -21.7889693
  },
  {
    lng: -41.7751836,
    lat: -21.7887894
  },
  {
    lng: -41.7748566,
    lat: -21.7887427
  },
  {
    lng: -41.7747018,
    lat: -21.7891024
  },
  {
    lng: -41.774437,
    lat: -21.7893633
  },
  {
    lng: -41.7740455,
    lat: -21.7895007
  },
  {
    lng: -41.773623,
    lat: -21.7894844
  },
  {
    lng: -41.7733828,
    lat: -21.7894152
  },
  {
    lng: -41.7726788,
    lat: -21.7892483
  },
  {
    lng: -41.7720233,
    lat: -21.7888319
  },
  {
    lng: -41.7712333,
    lat: -21.788635
  },
  {
    lng: -41.7709565,
    lat: -21.7886826
  },
  {
    lng: -41.770483,
    lat: -21.7886292
  },
  {
    lng: -41.7699963,
    lat: -21.7887766
  },
  {
    lng: -41.7694551,
    lat: -21.7886613
  },
  {
    lng: -41.768871,
    lat: -21.788537
  },
  {
    lng: -41.768183,
    lat: -21.7884268
  },
  {
    lng: -41.7678001,
    lat: -21.7881774
  },
  {
    lng: -41.7674499,
    lat: -21.7880095
  },
  {
    lng: -41.7670553,
    lat: -21.7879049
  },
  {
    lng: -41.7665108,
    lat: -21.7875556
  },
  {
    lng: -41.766219,
    lat: -21.7874774
  },
  {
    lng: -41.7657968,
    lat: -21.7874449
  },
  {
    lng: -41.7653196,
    lat: -21.7875565
  },
  {
    lng: -41.7647714,
    lat: -21.7877553
  },
  {
    lng: -41.7643414,
    lat: -21.7880694
  },
  {
    lng: -41.764051,
    lat: -21.7883136
  },
  {
    lng: -41.7636399,
    lat: -21.7885554
  },
  {
    lng: -41.7632644,
    lat: -21.7887496
  },
  {
    lng: -41.7627566,
    lat: -21.7890702
  },
  {
    lng: -41.7622202,
    lat: -21.7891241
  },
  {
    lng: -41.7619042,
    lat: -21.7890863
  },
  {
    lng: -41.761369,
    lat: -21.7889785
  },
  {
    lng: -41.7609813,
    lat: -21.7890566
  },
  {
    lng: -41.7605148,
    lat: -21.7888847
  },
  {
    lng: -41.7600461,
    lat: -21.7886945
  },
  {
    lng: -41.7597541,
    lat: -21.7886324
  },
  {
    lng: -41.7594268,
    lat: -21.7882148
  },
  {
    lng: -41.7590559,
    lat: -21.7882075
  },
  {
    lng: -41.758774,
    lat: -21.78846
  },
  {
    lng: -41.7583377,
    lat: -21.7886691
  },
  {
    lng: -41.7578583,
    lat: -21.7890193
  },
  {
    lng: -41.757331,
    lat: -21.7894025
  },
  {
    lng: -41.756707,
    lat: -21.7897161
  },
  {
    lng: -41.7563364,
    lat: -21.7897664
  },
  {
    lng: -41.7557068,
    lat: -21.789746
  },
  {
    lng: -41.7554233,
    lat: -21.789684
  },
  {
    lng: -41.7550732,
    lat: -21.7895159
  },
  {
    lng: -41.754256,
    lat: -21.789395
  },
  {
    lng: -41.753711,
    lat: -21.7894488
  },
  {
    lng: -41.7530604,
    lat: -21.7895891
  },
  {
    lng: -41.7526183,
    lat: -21.7896772
  },
  {
    lng: -41.752152,
    lat: -21.7896841
  },
  {
    lng: -41.7519291,
    lat: -21.7896153
  },
  {
    lng: -41.7516349,
    lat: -21.7896498
  },
  {
    lng: -41.7513412,
    lat: -21.7896601
  },
  {
    lng: -41.7511018,
    lat: -21.789752
  },
  {
    lng: -41.750631,
    lat: -21.7897671
  },
  {
    lng: -41.7502529,
    lat: -21.7896951
  },
  {
    lng: -41.7500345,
    lat: -21.7894248
  },
  {
    lng: -41.7498604,
    lat: -21.789107
  },
  {
    lng: -41.7495393,
    lat: -21.7888024
  },
  {
    lng: -41.7490134,
    lat: -21.7887759
  },
  {
    lng: -41.7484932,
    lat: -21.7888785
  },
  {
    lng: -41.7478127,
    lat: -21.7888168
  },
  {
    lng: -41.7471831,
    lat: -21.7887963
  },
  {
    lng: -41.7469496,
    lat: -21.788437
  },
  {
    lng: -41.7467467,
    lat: -21.7882476
  },
  {
    lng: -41.7464931,
    lat: -21.7880088
  },
  {
    lng: -41.7460022,
    lat: -21.78758
  },
  {
    lng: -41.7464132,
    lat: -21.7872479
  },
  {
    lng: -41.7470504,
    lat: -21.7870283
  },
  {
    lng: -41.7476446,
    lat: -21.7870883
  },
  {
    lng: -41.7479319,
    lat: -21.7869811
  },
  {
    lng: -41.7483712,
    lat: -21.7866351
  },
  {
    lng: -41.7487389,
    lat: -21.7864086
  },
  {
    lng: -41.7492447,
    lat: -21.7861767
  },
  {
    lng: -41.7494473,
    lat: -21.7857822
  },
  {
    lng: -41.7495816,
    lat: -21.7856862
  },
  {
    lng: -41.7496441,
    lat: -21.7853059
  },
  {
    lng: -41.7497066,
    lat: -21.7848315
  },
  {
    lng: -41.7499997,
    lat: -21.7844664
  },
  {
    lng: -41.7501619,
    lat: -21.7841633
  },
  {
    lng: -41.7504359,
    lat: -21.7838785
  },
  {
    lng: -41.7505022,
    lat: -21.7832349
  },
  {
    lng: -41.7506351,
    lat: -21.7826974
  },
  {
    lng: -41.7507584,
    lat: -21.7822081
  },
  {
    lng: -41.7510312,
    lat: -21.7815927
  },
  {
    lng: -41.7512701,
    lat: -21.7813314
  },
  {
    lng: -41.7516798,
    lat: -21.7811541
  },
  {
    lng: -41.7513056,
    lat: -21.7809049
  },
  {
    lng: -41.7510537,
    lat: -21.7805936
  },
  {
    lng: -41.7508257,
    lat: -21.7804656
  },
  {
    lng: -41.7502267,
    lat: -21.780142
  },
  {
    lng: -41.7498341,
    lat: -21.7799489
  },
  {
    lng: -41.7487508,
    lat: -21.7801452
  },
  {
    lng: -41.747903,
    lat: -21.7792922
  },
  {
    lng: -41.7474609,
    lat: -21.7787897
  },
  {
    lng: -41.7469368,
    lat: -21.7779168
  },
  {
    lng: -41.7466216,
    lat: -21.7773544
  },
  {
    lng: -41.7465011,
    lat: -21.776957
  },
  {
    lng: -41.7462125,
    lat: -21.7767417
  },
  {
    lng: -41.7458817,
    lat: -21.7766082
  },
  {
    lng: -41.745646,
    lat: -21.7762227
  },
  {
    lng: -41.7454291,
    lat: -21.7758879
  },
  {
    lng: -41.7451016,
    lat: -21.7754864
  },
  {
    lng: -41.74481,
    lat: -21.7749195
  },
  {
    lng: -41.7442071,
    lat: -21.7742032
  },
  {
    lng: -41.7436512,
    lat: -21.7739826
  },
  {
    lng: -41.7433745,
    lat: -21.7736225
  },
  {
    lng: -41.7430537,
    lat: -21.7729229
  },
  {
    lng: -41.7420053,
    lat: -21.7719591
  },
  {
    lng: -41.7411524,
    lat: -21.7713644
  },
  {
    lng: -41.740588,
    lat: -21.7705204
  },
  {
    lng: -41.7393604,
    lat: -21.7698513
  },
  {
    lng: -41.7389288,
    lat: -21.7694719
  },
  {
    lng: -41.7387306,
    lat: -21.7691017
  },
  {
    lng: -41.7383026,
    lat: -21.7681617
  },
  {
    lng: -41.7379702,
    lat: -21.767212
  },
  {
    lng: -41.7376675,
    lat: -21.7668594
  },
  {
    lng: -41.7374522,
    lat: -21.7664601
  },
  {
    lng: -41.7366187,
    lat: -21.7659197
  },
  {
    lng: -41.7355009,
    lat: -21.7653575
  },
  {
    lng: -41.7352257,
    lat: -21.7649329
  },
  {
    lng: -41.7347713,
    lat: -21.764803
  },
  {
    lng: -41.7343343,
    lat: -21.7646654
  },
  {
    lng: -41.7341772,
    lat: -21.764364
  },
  {
    lng: -41.7340732,
    lat: -21.7639992
  },
  {
    lng: -41.7341374,
    lat: -21.7634523
  },
  {
    lng: -41.7343071,
    lat: -21.7628188
  },
  {
    lng: -41.7342395,
    lat: -21.762753
  },
  {
    lng: -41.7341092,
    lat: -21.7627907
  },
  {
    lng: -41.7337533,
    lat: -21.7632674
  },
  {
    lng: -41.7334,
    lat: -21.7636231
  },
  {
    lng: -41.7329166,
    lat: -21.7640086
  },
  {
    lng: -41.7323769,
    lat: -21.7642156
  },
  {
    lng: -41.7316004,
    lat: -21.7638294
  },
  {
    lng: -41.7312906,
    lat: -21.763791
  },
  {
    lng: -41.7306249,
    lat: -21.7636
  },
  {
    lng: -41.7300586,
    lat: -21.7633871
  },
  {
    lng: -41.7295356,
    lat: -21.7631678
  },
  {
    lng: -41.7291311,
    lat: -21.7627406
  },
  {
    lng: -41.7290664,
    lat: -21.762167
  },
  {
    lng: -41.7290297,
    lat: -21.7618841
  },
  {
    lng: -41.7290027,
    lat: -21.7615531
  },
  {
    lng: -41.7287925,
    lat: -21.7613071
  },
  {
    lng: -41.7286064,
    lat: -21.7611422
  },
  {
    lng: -41.7281367,
    lat: -21.7605444
  },
  {
    lng: -41.7278161,
    lat: -21.7602237
  },
  {
    lng: -41.7274004,
    lat: -21.7599091
  },
  {
    lng: -41.7271241,
    lat: -21.7595329
  },
  {
    lng: -41.7266835,
    lat: -21.7591775
  },
  {
    lng: -41.7261802,
    lat: -21.7589675
  },
  {
    lng: -41.7254314,
    lat: -21.7588376
  },
  {
    lng: -41.7244865,
    lat: -21.7586422
  },
  {
    lng: -41.7241519,
    lat: -21.758555
  },
  {
    lng: -41.7238054,
    lat: -21.7578549
  },
  {
    lng: -41.7232118,
    lat: -21.7569551
  },
  {
    lng: -41.7228547,
    lat: -21.7564011
  },
  {
    lng: -41.7226724,
    lat: -21.756067
  },
  {
    lng: -41.7223289,
    lat: -21.7559957
  },
  {
    lng: -41.7214656,
    lat: -21.755632
  },
  {
    lng: -41.7209525,
    lat: -21.7552551
  },
  {
    lng: -41.7200819,
    lat: -21.755008
  },
  {
    lng: -41.7194311,
    lat: -21.7547855
  },
  {
    lng: -41.7190556,
    lat: -21.7542218
  },
  {
    lng: -41.7188779,
    lat: -21.7541782
  },
  {
    lng: -41.7185469,
    lat: -21.7542037
  },
  {
    lng: -41.7181467,
    lat: -21.7543489
  },
  {
    lng: -41.7177885,
    lat: -21.7545433
  },
  {
    lng: -41.7173734,
    lat: -21.7545834
  },
  {
    lng: -41.717003,
    lat: -21.754512
  },
  {
    lng: -41.7161278,
    lat: -21.7547118
  },
  {
    lng: -41.7152407,
    lat: -21.7546378
  },
  {
    lng: -41.7146379,
    lat: -21.7545855
  },
  {
    lng: -41.7144968,
    lat: -21.7543409
  },
  {
    lng: -41.7140637,
    lat: -21.754034
  },
  {
    lng: -41.7131997,
    lat: -21.7533236
  },
  {
    lng: -41.7123391,
    lat: -21.7526748
  },
  {
    lng: -41.7118657,
    lat: -21.7524916
  },
  {
    lng: -41.7117673,
    lat: -21.7524536
  },
  {
    lng: -41.7110985,
    lat: -21.7523789
  },
  {
    lng: -41.7103564,
    lat: -21.7520014
  },
  {
    lng: -41.7092256,
    lat: -21.7516404
  },
  {
    lng: -41.7091821,
    lat: -21.7514285
  },
  {
    lng: -41.7091745,
    lat: -21.7508574
  },
  {
    lng: -41.7088425,
    lat: -21.7506573
  },
  {
    lng: -41.7079637,
    lat: -21.7502207
  },
  {
    lng: -41.7071183,
    lat: -21.749833
  },
  {
    lng: -41.7061901,
    lat: -21.7492906
  },
  {
    lng: -41.7052185,
    lat: -21.7487634
  },
  {
    lng: -41.7042078,
    lat: -21.7479142
  },
  {
    lng: -41.703807,
    lat: -21.7472945
  },
  {
    lng: -41.7038332,
    lat: -21.7467044
  },
  {
    lng: -41.7036147,
    lat: -21.7462674
  },
  {
    lng: -41.703455,
    lat: -21.7458827
  },
  {
    lng: -41.7033945,
    lat: -21.7448974
  },
  {
    lng: -41.7032777,
    lat: -21.7442024
  },
  {
    lng: -41.7032675,
    lat: -21.7438959
  },
  {
    lng: -41.7030455,
    lat: -21.7436322
  },
  {
    lng: -41.7029453,
    lat: -21.7432688
  },
  {
    lng: -41.7025793,
    lat: -21.7422942
  },
  {
    lng: -41.7022111,
    lat: -21.7417452
  },
  {
    lng: -41.7016687,
    lat: -21.7413651
  },
  {
    lng: -41.7007705,
    lat: -21.7410213
  },
  {
    lng: -41.6998335,
    lat: -21.7406326
  },
  {
    lng: -41.6989938,
    lat: -21.7402396
  },
  {
    lng: -41.6984685,
    lat: -21.739818
  },
  {
    lng: -41.6979665,
    lat: -21.7395097
  },
  {
    lng: -41.6977224,
    lat: -21.7392389
  },
  {
    lng: -41.6981045,
    lat: -21.7391336
  },
  {
    lng: -41.6987963,
    lat: -21.7390668
  },
  {
    lng: -41.6990159,
    lat: -21.7388939
  },
  {
    lng: -41.6991007,
    lat: -21.7385812
  },
  {
    lng: -41.6994128,
    lat: -21.7377911
  },
  {
    lng: -41.6995756,
    lat: -21.7372431
  },
  {
    lng: -41.6997743,
    lat: -21.7363106
  },
  {
    lng: -41.6995317,
    lat: -21.7360519
  },
  {
    lng: -41.6990777,
    lat: -21.7350581
  },
  {
    lng: -41.6989556,
    lat: -21.7343624
  },
  {
    lng: -41.6988382,
    lat: -21.7338361
  },
  {
    lng: -41.6989438,
    lat: -21.7335162
  },
  {
    lng: -41.6989135,
    lat: -21.7330521
  },
  {
    lng: -41.6987346,
    lat: -21.7327055
  },
  {
    lng: -41.6986992,
    lat: -21.7323662
  },
  {
    lng: -41.6987083,
    lat: -21.7319714
  },
  {
    lng: -41.6986135,
    lat: -21.7312118
  },
  {
    lng: -41.6988873,
    lat: -21.7305562
  },
  {
    lng: -41.6989493,
    lat: -21.730106
  },
  {
    lng: -41.6989758,
    lat: -21.7293246
  },
  {
    lng: -41.6995221,
    lat: -21.728598
  },
  {
    lng: -41.699598,
    lat: -21.7280312
  },
  {
    lng: -41.6995264,
    lat: -21.7275058
  },
  {
    lng: -41.6996321,
    lat: -21.7270323
  },
  {
    lng: -41.7004639,
    lat: -21.725743
  },
  {
    lng: -41.7004069,
    lat: -21.7255968
  },
  {
    lng: -41.7000552,
    lat: -21.7251303
  },
  {
    lng: -41.6998273,
    lat: -21.7249081
  },
  {
    lng: -41.6996673,
    lat: -21.7247356
  },
  {
    lng: -41.6993109,
    lat: -21.7244786
  },
  {
    lng: -41.6986792,
    lat: -21.723805
  },
  {
    lng: -41.6981197,
    lat: -21.7229958
  },
  {
    lng: -41.6980115,
    lat: -21.7228243
  },
  {
    lng: -41.6970861,
    lat: -21.7221691
  },
  {
    lng: -41.6969531,
    lat: -21.7219488
  },
  {
    lng: -41.6969972,
    lat: -21.7215305
  },
  {
    lng: -41.6971801,
    lat: -21.7210746
  },
  {
    lng: -41.6973779,
    lat: -21.7207239
  },
  {
    lng: -41.6972541,
    lat: -21.7204796
  },
  {
    lng: -41.6965731,
    lat: -21.7200203
  },
  {
    lng: -41.6961094,
    lat: -21.7196192
  },
  {
    lng: -41.6956849,
    lat: -21.7193117
  },
  {
    lng: -41.6953647,
    lat: -21.7189748
  },
  {
    lng: -41.6953268,
    lat: -21.7187483
  },
  {
    lng: -41.6953342,
    lat: -21.718426
  },
  {
    lng: -41.6953681,
    lat: -21.718072
  },
  {
    lng: -41.695556,
    lat: -21.7177775
  },
  {
    lng: -41.6957237,
    lat: -21.7173677
  },
  {
    lng: -41.6962572,
    lat: -21.7165421
  },
  {
    lng: -41.6960717,
    lat: -21.7159741
  },
  {
    lng: -41.6960136,
    lat: -21.7154973
  },
  {
    lng: -41.6960175,
    lat: -21.7149492
  },
  {
    lng: -41.6960145,
    lat: -21.7144136
  },
  {
    lng: -41.695773,
    lat: -21.7142155
  },
  {
    lng: -41.6951196,
    lat: -21.7138511
  },
  {
    lng: -41.6945758,
    lat: -21.7134856
  },
  {
    lng: -41.6942704,
    lat: -21.7132619
  },
  {
    lng: -41.693883,
    lat: -21.7128511
  },
  {
    lng: -41.6934286,
    lat: -21.7125366
  },
  {
    lng: -41.6930346,
    lat: -21.7122296
  },
  {
    lng: -41.6928363,
    lat: -21.7118467
  },
  {
    lng: -41.6924457,
    lat: -21.7115729
  },
  {
    lng: -41.692238,
    lat: -21.7112833
  },
  {
    lng: -41.6917256,
    lat: -21.7106235
  },
  {
    lng: -41.6912883,
    lat: -21.7101311
  },
  {
    lng: -41.6908687,
    lat: -21.7103726
  },
  {
    lng: -41.6904363,
    lat: -21.7104203
  },
  {
    lng: -41.6901745,
    lat: -21.7105521
  },
  {
    lng: -41.6898439,
    lat: -21.7107508
  },
  {
    lng: -41.6889702,
    lat: -21.711094
  },
  {
    lng: -41.6885105,
    lat: -21.7112685
  },
  {
    lng: -41.6879528,
    lat: -21.7111365
  },
  {
    lng: -41.6871513,
    lat: -21.7107254
  },
  {
    lng: -41.6867707,
    lat: -21.7103954
  },
  {
    lng: -41.686265,
    lat: -21.7098774
  },
  {
    lng: -41.6857266,
    lat: -21.7095478
  },
  {
    lng: -41.6851771,
    lat: -21.7091705
  },
  {
    lng: -41.6845941,
    lat: -21.7086348
  },
  {
    lng: -41.6834643,
    lat: -21.7082495
  },
  {
    lng: -41.6833574,
    lat: -21.7080216
  },
  {
    lng: -41.6829385,
    lat: -21.7074812
  },
  {
    lng: -41.6827761,
    lat: -21.7066638
  },
  {
    lng: -41.6828016,
    lat: -21.7059308
  },
  {
    lng: -41.6829797,
    lat: -21.7051103
  },
  {
    lng: -41.6829905,
    lat: -21.7048383
  },
  {
    lng: -41.6828167,
    lat: -21.7045073
  },
  {
    lng: -41.682406,
    lat: -21.703976
  },
  {
    lng: -41.6823888,
    lat: -21.7036171
  },
  {
    lng: -41.6818571,
    lat: -21.7028865
  },
  {
    lng: -41.681634,
    lat: -21.702683
  },
  {
    lng: -41.6812938,
    lat: -21.7025368
  },
  {
    lng: -41.6809996,
    lat: -21.7025091
  },
  {
    lng: -41.680125,
    lat: -21.7026608
  },
  {
    lng: -41.679442,
    lat: -21.7027277
  },
  {
    lng: -41.6788384,
    lat: -21.703051
  },
  {
    lng: -41.6782928,
    lat: -21.7031883
  },
  {
    lng: -41.6777203,
    lat: -21.70333
  },
  {
    lng: -41.6773343,
    lat: -21.7032336
  },
  {
    lng: -41.6771219,
    lat: -21.7030923
  },
  {
    lng: -41.6763808,
    lat: -21.7024903
  },
  {
    lng: -41.675873,
    lat: -21.7019126
  },
  {
    lng: -41.6755094,
    lat: -21.7013946
  },
  {
    lng: -41.6752264,
    lat: -21.7012724
  },
  {
    lng: -41.6747964,
    lat: -21.7012585
  },
  {
    lng: -41.6743234,
    lat: -21.7011094
  },
  {
    lng: -41.6733256,
    lat: -21.7009235
  },
  {
    lng: -41.6723453,
    lat: -21.7005151
  },
  {
    lng: -41.6714451,
    lat: -21.7001409
  },
  {
    lng: -41.6710974,
    lat: -21.699884
  },
  {
    lng: -41.6709065,
    lat: -21.6995577
  },
  {
    lng: -41.6707255,
    lat: -21.6991752
  },
  {
    lng: -41.6702834,
    lat: -21.6989003
  },
  {
    lng: -41.669802,
    lat: -21.6985764
  },
  {
    lng: -41.6693263,
    lat: -21.6985638
  },
  {
    lng: -41.6685961,
    lat: -21.6983828
  },
  {
    lng: -41.6677443,
    lat: -21.6983469
  },
  {
    lng: -41.6670532,
    lat: -21.6983782
  },
  {
    lng: -41.6665011,
    lat: -21.6983406
  },
  {
    lng: -41.6659845,
    lat: -21.698298
  },
  {
    lng: -41.6656505,
    lat: -21.6981945
  },
  {
    lng: -41.6654479,
    lat: -21.698005
  },
  {
    lng: -41.6652623,
    lat: -21.697824
  },
  {
    lng: -41.6651336,
    lat: -21.69758
  },
  {
    lng: -41.6648596,
    lat: -21.6971694
  },
  {
    lng: -41.6647785,
    lat: -21.6967834
  },
  {
    lng: -41.6647839,
    lat: -21.6965004
  },
  {
    lng: -41.6647552,
    lat: -21.6962499
  },
  {
    lng: -41.6646344,
    lat: -21.6958767
  },
  {
    lng: -41.6638445,
    lat: -21.6949741
  },
  {
    lng: -41.6636086,
    lat: -21.6947275
  },
  {
    lng: -41.6630455,
    lat: -21.6943822
  },
  {
    lng: -41.662553,
    lat: -21.6943003
  },
  {
    lng: -41.6620808,
    lat: -21.6944066
  },
  {
    lng: -41.6615984,
    lat: -21.6943052
  },
  {
    lng: -41.661439,
    lat: -21.6941841
  },
  {
    lng: -41.6607105,
    lat: -21.6940889
  },
  {
    lng: -41.660139,
    lat: -21.694135
  },
  {
    lng: -41.6596661,
    lat: -21.694274
  },
  {
    lng: -41.659257,
    lat: -21.6943636
  },
  {
    lng: -41.6589786,
    lat: -21.6943162
  },
  {
    lng: -41.6583808,
    lat: -21.6940257
  },
  {
    lng: -41.6576556,
    lat: -21.6939637
  },
  {
    lng: -41.6567478,
    lat: -21.6941459
  },
  {
    lng: -41.6562569,
    lat: -21.6943094
  },
  {
    lng: -41.6554331,
    lat: -21.6939339
  },
  {
    lng: -41.6551295,
    lat: -21.6936376
  },
  {
    lng: -41.6549581,
    lat: -21.693215
  },
  {
    lng: -41.6546584,
    lat: -21.6927495
  },
  {
    lng: -41.6544867,
    lat: -21.6920752
  },
  {
    lng: -41.6541709,
    lat: -21.691353
  },
  {
    lng: -41.6539723,
    lat: -21.6907124
  },
  {
    lng: -41.6536483,
    lat: -21.6905527
  },
  {
    lng: -41.6531219,
    lat: -21.6905662
  },
  {
    lng: -41.6527624,
    lat: -21.6904461
  },
  {
    lng: -41.6527928,
    lat: -21.6895036
  },
  {
    lng: -41.6525977,
    lat: -21.6893626
  },
  {
    lng: -41.6519716,
    lat: -21.689213
  },
  {
    lng: -41.6514474,
    lat: -21.6889926
  },
  {
    lng: -41.6507301,
    lat: -21.6888171
  },
  {
    lng: -41.6505279,
    lat: -21.6886115
  },
  {
    lng: -41.6504946,
    lat: -21.6883793
  },
  {
    lng: -41.6503176,
    lat: -21.6880107
  },
  {
    lng: -41.6495301,
    lat: -21.687753
  },
  {
    lng: -41.64907,
    lat: -21.6875099
  },
  {
    lng: -41.6487742,
    lat: -21.6868752
  },
  {
    lng: -41.6487484,
    lat: -21.6857542
  },
  {
    lng: -41.6488677,
    lat: -21.6854423
  },
  {
    lng: -41.6485621,
    lat: -21.6841141
  },
  {
    lng: -41.6485851,
    lat: -21.6837658
  },
  {
    lng: -41.6485432,
    lat: -21.6826554
  },
  {
    lng: -41.6484324,
    lat: -21.6813239
  },
  {
    lng: -41.6484094,
    lat: -21.6810238
  },
  {
    lng: -41.6480648,
    lat: -21.6806379
  },
  {
    lng: -41.6473264,
    lat: -21.680494
  },
  {
    lng: -41.6467537,
    lat: -21.6802729
  },
  {
    lng: -41.6464514,
    lat: -21.6799201
  },
  {
    lng: -41.6460723,
    lat: -21.6795336
  },
  {
    lng: -41.6458043,
    lat: -21.6792578
  },
  {
    lng: -41.6454628,
    lat: -21.6786668
  },
  {
    lng: -41.6453822,
    lat: -21.6784234
  },
  {
    lng: -41.6448199,
    lat: -21.6770094
  },
  {
    lng: -41.6444683,
    lat: -21.6758093
  },
  {
    lng: -41.6443822,
    lat: -21.6754287
  },
  {
    lng: -41.6442079,
    lat: -21.675135
  },
  {
    lng: -41.6436189,
    lat: -21.6745024
  },
  {
    lng: -41.6433577,
    lat: -21.6742392
  },
  {
    lng: -41.6430403,
    lat: -21.6736525
  },
  {
    lng: -41.6427302,
    lat: -21.6734043
  },
  {
    lng: -41.6425003,
    lat: -21.6732787
  },
  {
    lng: -41.6421429,
    lat: -21.67307
  },
  {
    lng: -41.6420071,
    lat: -21.6726078
  },
  {
    lng: -41.6417376,
    lat: -21.6723282
  },
  {
    lng: -41.6415309,
    lat: -21.6719452
  },
  {
    lng: -41.640967,
    lat: -21.6713624
  },
  {
    lng: -41.6399304,
    lat: -21.6706795
  },
  {
    lng: -41.6395056,
    lat: -21.6704049
  },
  {
    lng: -41.6387645,
    lat: -21.6702863
  },
  {
    lng: -41.6381564,
    lat: -21.6702002
  },
  {
    lng: -41.6378311,
    lat: -21.6700588
  },
  {
    lng: -41.6370383,
    lat: -21.6697019
  },
  {
    lng: -41.6366463,
    lat: -21.6694074
  },
  {
    lng: -41.6363418,
    lat: -21.6692445
  },
  {
    lng: -41.6359608,
    lat: -21.6694218
  },
  {
    lng: -41.6356613,
    lat: -21.6695882
  },
  {
    lng: -41.6353013,
    lat: -21.669998
  },
  {
    lng: -41.6349627,
    lat: -21.6703289
  },
  {
    lng: -41.6347697,
    lat: -21.67047
  },
  {
    lng: -41.6344188,
    lat: -21.6707289
  },
  {
    lng: -41.634249,
    lat: -21.6709834
  },
  {
    lng: -41.6340739,
    lat: -21.6714316
  },
  {
    lng: -41.6339723,
    lat: -21.6713889
  },
  {
    lng: -41.6337528,
    lat: -21.6711829
  },
  {
    lng: -41.6332707,
    lat: -21.6707781
  },
  {
    lng: -41.632835,
    lat: -21.6706
  },
  {
    lng: -41.6322853,
    lat: -21.6705082
  },
  {
    lng: -41.631674,
    lat: -21.6704636
  },
  {
    lng: -41.631173,
    lat: -21.670131
  },
  {
    lng: -41.630303,
    lat: -21.6700891
  },
  {
    lng: -41.6296985,
    lat: -21.6701252
  },
  {
    lng: -41.6291606,
    lat: -21.6702674
  },
  {
    lng: -41.6284555,
    lat: -21.6702884
  },
  {
    lng: -41.6277376,
    lat: -21.6702707
  },
  {
    lng: -41.6268659,
    lat: -21.6703014
  },
  {
    lng: -41.6263892,
    lat: -21.6704045
  },
  {
    lng: -41.6260844,
    lat: -21.6705353
  },
  {
    lng: -41.6255669,
    lat: -21.6706978
  },
  {
    lng: -41.6249528,
    lat: -21.6706171
  },
  {
    lng: -41.6244815,
    lat: -21.6704321
  },
  {
    lng: -41.6235063,
    lat: -21.6702859
  },
  {
    lng: -41.6224212,
    lat: -21.6700405
  },
  {
    lng: -41.6215454,
    lat: -21.669927
  },
  {
    lng: -41.6213194,
    lat: -21.670003
  },
  {
    lng: -41.6208268,
    lat: -21.670162
  },
  {
    lng: -41.6206878,
    lat: -21.6703043
  },
  {
    lng: -41.62044,
    lat: -21.6704354
  },
  {
    lng: -41.6199006,
    lat: -21.6704843
  },
  {
    lng: -41.6193176,
    lat: -21.6705138
  },
  {
    lng: -41.6188132,
    lat: -21.670684
  },
  {
    lng: -41.6186208,
    lat: -21.6707863
  },
  {
    lng: -41.6184302,
    lat: -21.6708861
  },
  {
    lng: -41.6181506,
    lat: -21.6709735
  },
  {
    lng: -41.6179668,
    lat: -21.6710309
  },
  {
    lng: -41.6175982,
    lat: -21.6709347
  },
  {
    lng: -41.6173645,
    lat: -21.6709703
  },
  {
    lng: -41.6168699,
    lat: -21.6709482
  },
  {
    lng: -41.6166309,
    lat: -21.6707729
  },
  {
    lng: -41.6165892,
    lat: -21.6705675
  },
  {
    lng: -41.6164786,
    lat: -21.6703292
  },
  {
    lng: -41.6164068,
    lat: -21.6700398
  },
  {
    lng: -41.6163438,
    lat: -21.6696275
  },
  {
    lng: -41.616123,
    lat: -21.6690794
  },
  {
    lng: -41.6160719,
    lat: -21.6687192
  },
  {
    lng: -41.6159258,
    lat: -21.6686052
  },
  {
    lng: -41.6156381,
    lat: -21.6684604
  },
  {
    lng: -41.6154594,
    lat: -21.6683601
  },
  {
    lng: -41.6149058,
    lat: -21.6676959
  },
  {
    lng: -41.6147023,
    lat: -21.6671758
  },
  {
    lng: -41.6144843,
    lat: -21.6669134
  },
  {
    lng: -41.6139209,
    lat: -21.6662974
  },
  {
    lng: -41.6135288,
    lat: -21.6657332
  },
  {
    lng: -41.6126987,
    lat: -21.6650956
  },
  {
    lng: -41.6122151,
    lat: -21.6647552
  },
  {
    lng: -41.6115428,
    lat: -21.6647415
  },
  {
    lng: -41.6112851,
    lat: -21.6649233
  },
  {
    lng: -41.6107502,
    lat: -21.66508
  },
  {
    lng: -41.6104776,
    lat: -21.6649374
  },
  {
    lng: -41.6103132,
    lat: -21.6649588
  },
  {
    lng: -41.6096566,
    lat: -21.6650173
  },
  {
    lng: -41.6092444,
    lat: -21.6649444
  },
  {
    lng: -41.6086817,
    lat: -21.6646669
  },
  {
    lng: -41.6079267,
    lat: -21.6645064
  },
  {
    lng: -41.607373,
    lat: -21.6645837
  },
  {
    lng: -41.6067022,
    lat: -21.6648763
  },
  {
    lng: -41.6061661,
    lat: -21.6649378
  },
  {
    lng: -41.6057316,
    lat: -21.6650821
  },
  {
    lng: -41.6049925,
    lat: -21.665341
  },
  {
    lng: -41.6042523,
    lat: -21.6652856
  },
  {
    lng: -41.6036276,
    lat: -21.6650793
  },
  {
    lng: -41.6028989,
    lat: -21.6648732
  },
  {
    lng: -41.6022471,
    lat: -21.6646814
  },
  {
    lng: -41.6012089,
    lat: -21.6646371
  },
  {
    lng: -41.6005272,
    lat: -21.6645483
  },
  {
    lng: -41.5999046,
    lat: -21.6642534
  },
  {
    lng: -41.5993166,
    lat: -21.6639592
  },
  {
    lng: -41.5986224,
    lat: -21.6637757
  },
  {
    lng: -41.5973794,
    lat: -21.6638308
  },
  {
    lng: -41.5966965,
    lat: -21.6635347
  },
  {
    lng: -41.5961244,
    lat: -21.6632973
  },
  {
    lng: -41.5956639,
    lat: -21.6632477
  },
  {
    lng: -41.5952822,
    lat: -21.6631752
  },
  {
    lng: -41.5948455,
    lat: -21.6629977
  },
  {
    lng: -41.5942286,
    lat: -21.6628795
  },
  {
    lng: -41.5939353,
    lat: -21.6628816
  },
  {
    lng: -41.5937022,
    lat: -21.6630172
  },
  {
    lng: -41.5932144,
    lat: -21.6635299
  },
  {
    lng: -41.5926968,
    lat: -21.6638475
  },
  {
    lng: -41.5920995,
    lat: -21.6640322
  },
  {
    lng: -41.5912066,
    lat: -21.6641474
  },
  {
    lng: -41.5913614,
    lat: -21.6634332
  },
  {
    lng: -41.5916937,
    lat: -21.6628677
  },
  {
    lng: -41.5915326,
    lat: -21.6623889
  },
  {
    lng: -41.5913026,
    lat: -21.6619005
  },
  {
    lng: -41.5912098,
    lat: -21.6614472
  },
  {
    lng: -41.5909986,
    lat: -21.6608948
  },
  {
    lng: -41.5908194,
    lat: -21.6604478
  },
  {
    lng: -41.590596,
    lat: -21.6600482
  },
  {
    lng: -41.5903483,
    lat: -21.6595837
  },
  {
    lng: -41.5901379,
    lat: -21.6593617
  },
  {
    lng: -41.5898903,
    lat: -21.6592599
  },
  {
    lng: -41.589661,
    lat: -21.6591101
  },
  {
    lng: -41.5894732,
    lat: -21.6586629
  },
  {
    lng: -41.5892913,
    lat: -21.6583287
  },
  {
    lng: -41.5888077,
    lat: -21.6579963
  },
  {
    lng: -41.5881269,
    lat: -21.6576116
  },
  {
    lng: -41.5876543,
    lat: -21.6575454
  },
  {
    lng: -41.5869483,
    lat: -21.6574987
  },
  {
    lng: -41.5856601,
    lat: -21.6572787
  },
  {
    lng: -41.5851726,
    lat: -21.6574782
  },
  {
    lng: -41.5845001,
    lat: -21.6572012
  },
  {
    lng: -41.5842603,
    lat: -21.6570403
  },
  {
    lng: -41.5841809,
    lat: -21.6563858
  },
  {
    lng: -41.5842164,
    lat: -21.6559754
  },
  {
    lng: -41.5839938,
    lat: -21.6555436
  },
  {
    lng: -41.5838976,
    lat: -21.6552945
  },
  {
    lng: -41.5838008,
    lat: -21.6550131
  },
  {
    lng: -41.5836087,
    lat: -21.6548694
  },
  {
    lng: -41.5832474,
    lat: -21.6545933
  },
  {
    lng: -41.5828693,
    lat: -21.6540481
  },
  {
    lng: -41.5825488,
    lat: -21.6535633
  },
  {
    lng: -41.5820378,
    lat: -21.6532357
  },
  {
    lng: -41.5811833,
    lat: -21.6529064
  },
  {
    lng: -41.5807985,
    lat: -21.652834
  },
  {
    lng: -41.5799902,
    lat: -21.6527258
  },
  {
    lng: -41.5790659,
    lat: -21.6530028
  },
  {
    lng: -41.5783105,
    lat: -21.653055
  },
  {
    lng: -41.5780505,
    lat: -21.6530186
  },
  {
    lng: -41.5778287,
    lat: -21.6526988
  },
  {
    lng: -41.5775616,
    lat: -21.6522585
  },
  {
    lng: -41.5773589,
    lat: -21.651797
  },
  {
    lng: -41.5770605,
    lat: -21.6508117
  },
  {
    lng: -41.5768144,
    lat: -21.650163
  },
  {
    lng: -41.5765226,
    lat: -21.649941
  },
  {
    lng: -41.5758975,
    lat: -21.6498196
  },
  {
    lng: -41.5752051,
    lat: -21.6498418
  },
  {
    lng: -41.575572,
    lat: -21.6492119
  },
  {
    lng: -41.5756694,
    lat: -21.6488129
  },
  {
    lng: -41.5757939,
    lat: -21.6481985
  },
  {
    lng: -41.5759103,
    lat: -21.6474606
  },
  {
    lng: -41.5759962,
    lat: -21.6471852
  },
  {
    lng: -41.5759656,
    lat: -21.6465157
  },
  {
    lng: -41.5753984,
    lat: -21.6460495
  },
  {
    lng: -41.5747622,
    lat: -21.6455139
  },
  {
    lng: -41.5743259,
    lat: -21.6452783
  },
  {
    lng: -41.5741683,
    lat: -21.6451644
  },
  {
    lng: -41.5737786,
    lat: -21.6448827
  },
  {
    lng: -41.5728461,
    lat: -21.6440144
  },
  {
    lng: -41.5719746,
    lat: -21.6430722
  },
  {
    lng: -41.5715311,
    lat: -21.642414
  },
  {
    lng: -41.5709512,
    lat: -21.6414113
  },
  {
    lng: -41.5705811,
    lat: -21.6411913
  },
  {
    lng: -41.5702587,
    lat: -21.6408762
  },
  {
    lng: -41.5698092,
    lat: -21.6403784
  },
  {
    lng: -41.5691563,
    lat: -21.6400514
  },
  {
    lng: -41.567987,
    lat: -21.6406647
  },
  {
    lng: -41.5674316,
    lat: -21.6409
  },
  {
    lng: -41.5664078,
    lat: -21.6410977
  },
  {
    lng: -41.5658091,
    lat: -21.641144
  },
  {
    lng: -41.565164,
    lat: -21.6412203
  },
  {
    lng: -41.5647726,
    lat: -21.6416021
  },
  {
    lng: -41.5646531,
    lat: -21.6420744
  },
  {
    lng: -41.5642894,
    lat: -21.6429245
  },
  {
    lng: -41.5635521,
    lat: -21.6432342
  },
  {
    lng: -41.5630472,
    lat: -21.6429072
  },
  {
    lng: -41.5626024,
    lat: -21.6422396
  },
  {
    lng: -41.5619268,
    lat: -21.6414132
  },
  {
    lng: -41.561066,
    lat: -21.6407906
  },
  {
    lng: -41.5610821,
    lat: -21.6403883
  },
  {
    lng: -41.561275,
    lat: -21.6395798
  },
  {
    lng: -41.560171,
    lat: -21.639232
  },
  {
    lng: -41.5592769,
    lat: -21.6388235
  },
  {
    lng: -41.558354,
    lat: -21.6389997
  },
  {
    lng: -41.5577364,
    lat: -21.6395143
  },
  {
    lng: -41.556991,
    lat: -21.6401318
  },
  {
    lng: -41.5564148,
    lat: -21.6405448
  },
  {
    lng: -41.5560051,
    lat: -21.6405915
  },
  {
    lng: -41.5556757,
    lat: -21.6402935
  },
  {
    lng: -41.5552567,
    lat: -21.6398151
  },
  {
    lng: -41.5552464,
    lat: -21.6392294
  },
  {
    lng: -41.5554918,
    lat: -21.6384377
  },
  {
    lng: -41.555571,
    lat: -21.6368001
  },
  {
    lng: -41.5549094,
    lat: -21.6360426
  },
  {
    lng: -41.5536493,
    lat: -21.6344255
  },
  {
    lng: -41.553072,
    lat: -21.6337227
  },
  {
    lng: -41.5531987,
    lat: -21.6323804
  },
  {
    lng: -41.5533325,
    lat: -21.6315713
  },
  {
    lng: -41.5534678,
    lat: -21.6308544
  },
  {
    lng: -41.5533344,
    lat: -21.63028
  },
  {
    lng: -41.5527835,
    lat: -21.6298043
  },
  {
    lng: -41.552134,
    lat: -21.6293161
  },
  {
    lng: -41.5509437,
    lat: -21.6289563
  },
  {
    lng: -41.5505218,
    lat: -21.6285946
  },
  {
    lng: -41.5497979,
    lat: -21.6281626
  },
  {
    lng: -41.5492082,
    lat: -21.6281179
  },
  {
    lng: -41.5485741,
    lat: -21.6284224
  },
  {
    lng: -41.5478673,
    lat: -21.6287767
  },
  {
    lng: -41.5472211,
    lat: -21.6288877
  },
  {
    lng: -41.5462401,
    lat: -21.6283976
  },
  {
    lng: -41.5453428,
    lat: -21.6277447
  },
  {
    lng: -41.5446066,
    lat: -21.6276549
  },
  {
    lng: -41.5435021,
    lat: -21.6275102
  },
  {
    lng: -41.5424203,
    lat: -21.6274258
  },
  {
    lng: -41.5413544,
    lat: -21.6270178
  },
  {
    lng: -41.5403459,
    lat: -21.6261847
  },
  {
    lng: -41.5399381,
    lat: -21.6247903
  },
  {
    lng: -41.5392707,
    lat: -21.6229194
  },
  {
    lng: -41.5381356,
    lat: -21.6218659
  },
  {
    lng: -41.5377208,
    lat: -21.6221088
  },
  {
    lng: -41.5361002,
    lat: -21.6226779
  },
  {
    lng: -41.5348619,
    lat: -21.6231517
  },
  {
    lng: -41.5340756,
    lat: -21.6234526
  },
  {
    lng: -41.5331368,
    lat: -21.6239037
  },
  {
    lng: -41.5325548,
    lat: -21.6241834
  },
  {
    lng: -41.5312494,
    lat: -21.6250088
  },
  {
    lng: -41.5309665,
    lat: -21.6249117
  },
  {
    lng: -41.5307266,
    lat: -21.6249049
  },
  {
    lng: -41.5304902,
    lat: -21.6249368
  },
  {
    lng: -41.5302903,
    lat: -21.6250447
  },
  {
    lng: -41.5301295,
    lat: -21.6251899
  },
  {
    lng: -41.5297858,
    lat: -21.6255137
  },
  {
    lng: -41.5268049,
    lat: -21.62972
  },
  {
    lng: -41.5267374,
    lat: -21.629815
  },
  {
    lng: -41.5232054,
    lat: -21.6330109
  },
  {
    lng: -41.5219918,
    lat: -21.6341089
  },
  {
    lng: -41.5218912,
    lat: -21.6342999
  },
  {
    lng: -41.5196611,
    lat: -21.6350744
  },
  {
    lng: -41.5176553,
    lat: -21.6359255
  },
  {
    lng: -41.516702,
    lat: -21.6366235
  },
  {
    lng: -41.5162508,
    lat: -21.6374721
  },
  {
    lng: -41.5163346,
    lat: -21.6386647
  },
  {
    lng: -41.5155281,
    lat: -21.6394883
  },
  {
    lng: -41.5146482,
    lat: -21.6411632
  },
  {
    lng: -41.5136765,
    lat: -21.6430126
  },
  {
    lng: -41.5128761,
    lat: -21.6433316
  },
  {
    lng: -41.5096249,
    lat: -21.6459306
  },
  {
    lng: -41.5093603,
    lat: -21.6499521
  },
  {
    lng: -41.5084576,
    lat: -21.651077
  },
  {
    lng: -41.5074981,
    lat: -21.6522726
  },
  {
    lng: -41.5059095,
    lat: -21.6542522
  },
  {
    lng: -41.5052225,
    lat: -21.6551083
  },
  {
    lng: -41.5045744,
    lat: -21.6558657
  },
  {
    lng: -41.5037868,
    lat: -21.6565166
  },
  {
    lng: -41.4977242,
    lat: -21.6615264
  },
  {
    lng: -41.4963752,
    lat: -21.6629121
  },
  {
    lng: -41.4942818,
    lat: -21.6650623
  },
  {
    lng: -41.4933724,
    lat: -21.670273
  },
  {
    lng: -41.491971,
    lat: -21.6728805
  },
  {
    lng: -41.4912857,
    lat: -21.6741555
  },
  {
    lng: -41.4899798,
    lat: -21.6748948
  },
  {
    lng: -41.4280782,
    lat: -21.6172886
  },
  {
    lng: -41.4272525,
    lat: -21.61652
  },
  {
    lng: -41.4273836,
    lat: -21.6162832
  },
  {
    lng: -41.4275745,
    lat: -21.6158786
  },
  {
    lng: -41.4277131,
    lat: -21.6156114
  },
  {
    lng: -41.4277855,
    lat: -21.6154365
  },
  {
    lng: -41.4278074,
    lat: -21.6152855
  },
  {
    lng: -41.4278095,
    lat: -21.6151486
  },
  {
    lng: -41.4277981,
    lat: -21.6149977
  },
  {
    lng: -41.4277557,
    lat: -21.6147137
  },
  {
    lng: -41.4277298,
    lat: -21.6144747
  },
  {
    lng: -41.4277209,
    lat: -21.6142122
  },
  {
    lng: -41.4277071,
    lat: -21.614051
  },
  {
    lng: -41.4276694,
    lat: -21.6139171
  },
  {
    lng: -41.427594,
    lat: -21.6137794
  },
  {
    lng: -41.4273565,
    lat: -21.6134981
  },
  {
    lng: -41.4270429,
    lat: -21.6131508
  },
  {
    lng: -41.4264895,
    lat: -21.6125448
  },
  {
    lng: -41.4255297,
    lat: -21.6113402
  },
  {
    lng: -41.4253833,
    lat: -21.6111892
  },
  {
    lng: -41.4251923,
    lat: -21.6110693
  },
  {
    lng: -41.4249027,
    lat: -21.6109722
  },
  {
    lng: -41.424576,
    lat: -21.6109086
  },
  {
    lng: -41.4242322,
    lat: -21.6108785
  },
  {
    lng: -41.4236792,
    lat: -21.610874
  },
  {
    lng: -41.4229235,
    lat: -21.6108581
  },
  {
    lng: -41.4221852,
    lat: -21.6108725
  },
  {
    lng: -41.421634,
    lat: -21.610893
  },
  {
    lng: -41.4209485,
    lat: -21.6109216
  },
  {
    lng: -41.4206515,
    lat: -21.6109073
  },
  {
    lng: -41.4204673,
    lat: -21.6108913
  },
  {
    lng: -41.4200605,
    lat: -21.6108041
  },
  {
    lng: -41.4192721,
    lat: -21.6106182
  },
  {
    lng: -41.4186998,
    lat: -21.6104579
  },
  {
    lng: -41.4158224,
    lat: -21.6096664
  },
  {
    lng: -41.4155393,
    lat: -21.6096087
  },
  {
    lng: -41.4154062,
    lat: -21.6095983
  },
  {
    lng: -41.4151871,
    lat: -21.6096181
  },
  {
    lng: -41.4149289,
    lat: -21.6096673
  },
  {
    lng: -41.4146152,
    lat: -21.6097173
  },
  {
    lng: -41.4144526,
    lat: -21.6097278
  },
  {
    lng: -41.4143347,
    lat: -21.6097005
  },
  {
    lng: -41.4138249,
    lat: -21.60941
  },
  {
    lng: -41.4135145,
    lat: -21.6092614
  },
  {
    lng: -41.4132122,
    lat: -21.6091554
  },
  {
    lng: -41.4128919,
    lat: -21.6090752
  },
  {
    lng: -41.4121561,
    lat: -21.608921
  },
  {
    lng: -41.4120962,
    lat: -21.6089088
  },
  {
    lng: -41.4119759,
    lat: -21.6088691
  },
  {
    lng: -41.4118735,
    lat: -21.6088396
  },
  {
    lng: -41.4117891,
    lat: -21.6088263
  },
  {
    lng: -41.4116173,
    lat: -21.6088221
  },
  {
    lng: -41.4114602,
    lat: -21.6088328
  },
  {
    lng: -41.4107734,
    lat: -21.6089607
  },
  {
    lng: -41.4102508,
    lat: -21.6090514
  },
  {
    lng: -41.4100008,
    lat: -21.6090653
  },
  {
    lng: -41.4094909,
    lat: -21.6090396
  },
  {
    lng: -41.4093529,
    lat: -21.6089982
  },
  {
    lng: -41.4092342,
    lat: -21.6089213
  },
  {
    lng: -41.4090599,
    lat: -21.6087792
  },
  {
    lng: -41.4088087,
    lat: -21.6085392
  },
  {
    lng: -41.4084125,
    lat: -21.6081539
  },
  {
    lng: -41.4080705,
    lat: -21.6078784
  },
  {
    lng: -41.4077296,
    lat: -21.6075943
  },
  {
    lng: -41.4076055,
    lat: -21.6074858
  },
  {
    lng: -41.4074942,
    lat: -21.6073474
  },
  {
    lng: -41.4074253,
    lat: -21.6072036
  },
  {
    lng: -41.4073055,
    lat: -21.606926
  },
  {
    lng: -41.4071809,
    lat: -21.6066411
  },
  {
    lng: -41.4070952,
    lat: -21.6065149
  },
  {
    lng: -41.4069512,
    lat: -21.6064106
  },
  {
    lng: -41.4068081,
    lat: -21.606334
  },
  {
    lng: -41.4062872,
    lat: -21.6061065
  },
  {
    lng: -41.4060549,
    lat: -21.6059857
  },
  {
    lng: -41.405862,
    lat: -21.6058436
  },
  {
    lng: -41.4056822,
    lat: -21.6056848
  },
  {
    lng: -41.4054877,
    lat: -21.6054651
  },
  {
    lng: -41.4051762,
    lat: -21.6050072
  },
  {
    lng: -41.4050518,
    lat: -21.6048538
  },
  {
    lng: -41.4048058,
    lat: -21.604578
  },
  {
    lng: -41.4044846,
    lat: -21.6042174
  },
  {
    lng: -41.4042854,
    lat: -21.6039534
  },
  {
    lng: -41.4040314,
    lat: -21.6036159
  },
  {
    lng: -41.4038758,
    lat: -21.6034526
  },
  {
    lng: -41.4037452,
    lat: -21.60332
  },
  {
    lng: -41.4036501,
    lat: -21.6031972
  },
  {
    lng: -41.4034095,
    lat: -21.6028664
  },
  {
    lng: -41.4033056,
    lat: -21.6027459
  },
  {
    lng: -41.4031073,
    lat: -21.6025418
  },
  {
    lng: -41.4028005,
    lat: -21.6022345
  },
  {
    lng: -41.4027417,
    lat: -21.602165
  },
  {
    lng: -41.4026938,
    lat: -21.6020829
  },
  {
    lng: -41.4026476,
    lat: -21.6019636
  },
  {
    lng: -41.4025153,
    lat: -21.6016166
  },
  {
    lng: -41.4025016,
    lat: -21.6015662
  },
  {
    lng: -41.402454,
    lat: -21.6013899
  },
  {
    lng: -41.4023652,
    lat: -21.6009843
  },
  {
    lng: -41.4021443,
    lat: -21.5999616
  },
  {
    lng: -41.4016341,
    lat: -21.5977981
  },
  {
    lng: -41.4015683,
    lat: -21.5975673
  },
  {
    lng: -41.4015319,
    lat: -21.5973801
  },
  {
    lng: -41.4015316,
    lat: -21.597227
  },
  {
    lng: -41.4015455,
    lat: -21.5971402
  },
  {
    lng: -41.4015732,
    lat: -21.597065
  },
  {
    lng: -41.4016205,
    lat: -21.5969816
  },
  {
    lng: -41.4016835,
    lat: -21.5969041
  },
  {
    lng: -41.4017925,
    lat: -21.596797
  },
  {
    lng: -41.4018684,
    lat: -21.5967028
  },
  {
    lng: -41.4020299,
    lat: -21.5965351
  },
  {
    lng: -41.4021959,
    lat: -21.596392
  },
  {
    lng: -41.4022806,
    lat: -21.5962915
  },
  {
    lng: -41.402349,
    lat: -21.5962104
  },
  {
    lng: -41.4023995,
    lat: -21.5961139
  },
  {
    lng: -41.4024505,
    lat: -21.5959828
  },
  {
    lng: -41.4025031,
    lat: -21.5958144
  },
  {
    lng: -41.4025353,
    lat: -21.5956121
  },
  {
    lng: -41.4025342,
    lat: -21.5954114
  },
  {
    lng: -41.4025072,
    lat: -21.5952504
  },
  {
    lng: -41.4024276,
    lat: -21.5949938
  },
  {
    lng: -41.4023176,
    lat: -21.5947719
  },
  {
    lng: -41.4020762,
    lat: -21.5943832
  },
  {
    lng: -41.4017154,
    lat: -21.5937375
  },
  {
    lng: -41.4010953,
    lat: -21.5926813
  },
  {
    lng: -41.4008728,
    lat: -21.5923647
  },
  {
    lng: -41.4007701,
    lat: -21.5921841
  },
  {
    lng: -41.4006506,
    lat: -21.5919382
  },
  {
    lng: -41.4005877,
    lat: -21.5917508
  },
  {
    lng: -41.400549,
    lat: -21.5915548
  },
  {
    lng: -41.4004575,
    lat: -21.5908469
  },
  {
    lng: -41.4004528,
    lat: -21.5905635
  },
  {
    lng: -41.4004656,
    lat: -21.5902682
  },
  {
    lng: -41.400485,
    lat: -21.5899637
  },
  {
    lng: -41.4006853,
    lat: -21.5863617
  },
  {
    lng: -41.4007701,
    lat: -21.5848383
  },
  {
    lng: -41.4008392,
    lat: -21.5836575
  },
  {
    lng: -41.4008534,
    lat: -21.5834841
  },
  {
    lng: -41.4009003,
    lat: -21.5833065
  },
  {
    lng: -41.4009286,
    lat: -21.583206
  },
  {
    lng: -41.4009348,
    lat: -21.5831314
  },
  {
    lng: -41.4009258,
    lat: -21.5830384
  },
  {
    lng: -41.4009205,
    lat: -21.5830048
  },
  {
    lng: -41.4009063,
    lat: -21.5829144
  },
  {
    lng: -41.4008852,
    lat: -21.5825469
  },
  {
    lng: -41.400863,
    lat: -21.5824052
  },
  {
    lng: -41.4007058,
    lat: -21.5821384
  },
  {
    lng: -41.4006006,
    lat: -21.5820019
  },
  {
    lng: -41.4004782,
    lat: -21.5818834
  },
  {
    lng: -41.4002643,
    lat: -21.5818379
  },
  {
    lng: -41.3999914,
    lat: -21.5818104
  },
  {
    lng: -41.3996181,
    lat: -21.5817673
  },
  {
    lng: -41.3993808,
    lat: -21.5817118
  },
  {
    lng: -41.3991183,
    lat: -21.5816361
  },
  {
    lng: -41.3987836,
    lat: -21.5815435
  },
  {
    lng: -41.398565,
    lat: -21.5814906
  },
  {
    lng: -41.398329,
    lat: -21.5813848
  },
  {
    lng: -41.3981761,
    lat: -21.5813224
  },
  {
    lng: -41.3980571,
    lat: -21.5813089
  },
  {
    lng: -41.397914,
    lat: -21.5813255
  },
  {
    lng: -41.3978245,
    lat: -21.5813477
  },
  {
    lng: -41.3977028,
    lat: -21.5813494
  },
  {
    lng: -41.3975859,
    lat: -21.5813219
  },
  {
    lng: -41.3975232,
    lat: -21.5812854
  },
  {
    lng: -41.3974923,
    lat: -21.5812645
  },
  {
    lng: -41.3971455,
    lat: -21.581026
  },
  {
    lng: -41.3968368,
    lat: -21.5807741
  },
  {
    lng: -41.3966821,
    lat: -21.580633
  },
  {
    lng: -41.3965846,
    lat: -21.580508
  },
  {
    lng: -41.3964755,
    lat: -21.5803434
  },
  {
    lng: -41.3963818,
    lat: -21.5802156
  },
  {
    lng: -41.3963185,
    lat: -21.5801418
  },
  {
    lng: -41.3962015,
    lat: -21.5800419
  },
  {
    lng: -41.3959772,
    lat: -21.5798917
  },
  {
    lng: -41.3957045,
    lat: -21.5796583
  },
  {
    lng: -41.3956399,
    lat: -21.5795855
  },
  {
    lng: -41.3955192,
    lat: -21.5794495
  },
  {
    lng: -41.3953759,
    lat: -21.5792381
  },
  {
    lng: -41.3952001,
    lat: -21.5789514
  },
  {
    lng: -41.3945503,
    lat: -21.5776522
  },
  {
    lng: -41.3944612,
    lat: -21.5774959
  },
  {
    lng: -41.3943406,
    lat: -21.5773132
  },
  {
    lng: -41.3941435,
    lat: -21.5770852
  },
  {
    lng: -41.3939183,
    lat: -21.5768791
  },
  {
    lng: -41.3925279,
    lat: -21.575769
  },
  {
    lng: -41.3916414,
    lat: -21.574801
  },
  {
    lng: -41.3912706,
    lat: -21.5743626
  },
  {
    lng: -41.3908325,
    lat: -21.5738378
  },
  {
    lng: -41.390626,
    lat: -21.5735322
  },
  {
    lng: -41.3890864,
    lat: -21.5717226
  },
  {
    lng: -41.3874819,
    lat: -21.5697214
  },
  {
    lng: -41.3871385,
    lat: -21.5693743
  },
  {
    lng: -41.3870343,
    lat: -21.5692452
  },
  {
    lng: -41.3869453,
    lat: -21.569091
  },
  {
    lng: -41.3868784,
    lat: -21.5689386
  },
  {
    lng: -41.386797,
    lat: -21.5687311
  },
  {
    lng: -41.3867515,
    lat: -21.5685244
  },
  {
    lng: -41.3863553,
    lat: -21.5666553
  },
  {
    lng: -41.3863227,
    lat: -21.5665864
  },
  {
    lng: -41.3863016,
    lat: -21.5665419
  },
  {
    lng: -41.3862286,
    lat: -21.5664341
  },
  {
    lng: -41.3861226,
    lat: -21.5663257
  },
  {
    lng: -41.3860877,
    lat: -21.5663
  },
  {
    lng: -41.3855973,
    lat: -21.5659559
  },
  {
    lng: -41.3833484,
    lat: -21.5646132
  },
  {
    lng: -41.3806856,
    lat: -21.5629641
  },
  {
    lng: -41.3804037,
    lat: -21.5628126
  },
  {
    lng: -41.3803385,
    lat: -21.5627617
  },
  {
    lng: -41.380262,
    lat: -21.5626944
  },
  {
    lng: -41.3801311,
    lat: -21.5625554
  },
  {
    lng: -41.3801049,
    lat: -21.562519
  },
  {
    lng: -41.3799718,
    lat: -21.5623346
  },
  {
    lng: -41.3798396,
    lat: -21.5621188
  },
  {
    lng: -41.379773,
    lat: -21.561983
  },
  {
    lng: -41.37945,
    lat: -21.5611107
  },
  {
    lng: -41.3793851,
    lat: -21.5609637
  },
  {
    lng: -41.3792753,
    lat: -21.5607825
  },
  {
    lng: -41.3791316,
    lat: -21.5606502
  },
  {
    lng: -41.3790012,
    lat: -21.5605422
  },
  {
    lng: -41.3788782,
    lat: -21.5604859
  },
  {
    lng: -41.378653,
    lat: -21.5604125
  },
  {
    lng: -41.3783225,
    lat: -21.5603229
  },
  {
    lng: -41.3777101,
    lat: -21.5602005
  },
  {
    lng: -41.3773022,
    lat: -21.5601055
  },
  {
    lng: -41.3765412,
    lat: -21.5599225
  },
  {
    lng: -41.376391,
    lat: -21.5598854
  },
  {
    lng: -41.3758803,
    lat: -21.5597761
  },
  {
    lng: -41.3744368,
    lat: -21.5593861
  },
  {
    lng: -41.3740978,
    lat: -21.5593139
  },
  {
    lng: -41.3740424,
    lat: -21.5593022
  },
  {
    lng: -41.3738996,
    lat: -21.5592834
  },
  {
    lng: -41.3734926,
    lat: -21.5592007
  },
  {
    lng: -41.3731004,
    lat: -21.5591128
  },
  {
    lng: -41.3729925,
    lat: -21.5590918
  },
  {
    lng: -41.3725237,
    lat: -21.558996
  },
  {
    lng: -41.3723278,
    lat: -21.5589634
  },
  {
    lng: -41.3719956,
    lat: -21.5588805
  },
  {
    lng: -41.3714695,
    lat: -21.5587191
  },
  {
    lng: -41.3712495,
    lat: -21.5585455
  },
  {
    lng: -41.3709155,
    lat: -21.5583116
  },
  {
    lng: -41.3706127,
    lat: -21.5581135
  },
  {
    lng: -41.3703531,
    lat: -21.5579989
  },
  {
    lng: -41.3702068,
    lat: -21.5579592
  },
  {
    lng: -41.369796,
    lat: -21.5578976
  },
  {
    lng: -41.3694935,
    lat: -21.5578551
  },
  {
    lng: -41.3689309,
    lat: -21.5577786
  },
  {
    lng: -41.3685879,
    lat: -21.5577241
  },
  {
    lng: -41.3682557,
    lat: -21.557649
  },
  {
    lng: -41.3678706,
    lat: -21.5575994
  },
  {
    lng: -41.3662881,
    lat: -21.5573499
  },
  {
    lng: -41.3654012,
    lat: -21.5571901
  },
  {
    lng: -41.3652437,
    lat: -21.5570721
  },
  {
    lng: -41.3649925,
    lat: -21.5567977
  },
  {
    lng: -41.3648075,
    lat: -21.5565448
  },
  {
    lng: -41.3645751,
    lat: -21.5559414
  },
  {
    lng: -41.3644119,
    lat: -21.5555688
  },
  {
    lng: -41.3643148,
    lat: -21.5553301
  },
  {
    lng: -41.3641919,
    lat: -21.555007
  },
  {
    lng: -41.3640406,
    lat: -21.5546528
  },
  {
    lng: -41.3637057,
    lat: -21.5538356
  },
  {
    lng: -41.3636756,
    lat: -21.553749
  },
  {
    lng: -41.3630748,
    lat: -21.5521811
  },
  {
    lng: -41.3626903,
    lat: -21.5511534
  },
  {
    lng: -41.3626288,
    lat: -21.550953
  },
  {
    lng: -41.3615045,
    lat: -21.5482617
  },
  {
    lng: -41.3613289,
    lat: -21.547767
  },
  {
    lng: -41.361164,
    lat: -21.5474246
  },
  {
    lng: -41.3610952,
    lat: -21.5472583
  },
  {
    lng: -41.3610389,
    lat: -21.5470861
  },
  {
    lng: -41.3608676,
    lat: -21.5466918
  },
  {
    lng: -41.3608094,
    lat: -21.5465066
  },
  {
    lng: -41.360589,
    lat: -21.5459461
  },
  {
    lng: -41.3603192,
    lat: -21.5453739
  },
  {
    lng: -41.3601074,
    lat: -21.5445395
  },
  {
    lng: -41.3601047,
    lat: -21.5441691
  },
  {
    lng: -41.3602458,
    lat: -21.5436006
  },
  {
    lng: -41.3603535,
    lat: -21.5434033
  },
  {
    lng: -41.3605083,
    lat: -21.5429902
  },
  {
    lng: -41.3605938,
    lat: -21.5428493
  },
  {
    lng: -41.3607791,
    lat: -21.5425405
  },
  {
    lng: -41.3608839,
    lat: -21.5423363
  },
  {
    lng: -41.36097,
    lat: -21.542213
  },
  {
    lng: -41.3610383,
    lat: -21.5420249
  },
  {
    lng: -41.3610403,
    lat: -21.5418755
  },
  {
    lng: -41.3610748,
    lat: -21.5417577
  },
  {
    lng: -41.3612396,
    lat: -21.5412924
  },
  {
    lng: -41.3613226,
    lat: -21.5411533
  },
  {
    lng: -41.361626,
    lat: -21.5405085
  },
  {
    lng: -41.3617379,
    lat: -21.5403237
  },
  {
    lng: -41.361773,
    lat: -21.5402522
  },
  {
    lng: -41.3619129,
    lat: -21.5399052
  },
  {
    lng: -41.3619607,
    lat: -21.539806
  },
  {
    lng: -41.3620365,
    lat: -21.5396645
  },
  {
    lng: -41.3621938,
    lat: -21.5394903
  },
  {
    lng: -41.3622994,
    lat: -21.5393059
  },
  {
    lng: -41.3624831,
    lat: -21.538938
  },
  {
    lng: -41.3625819,
    lat: -21.538756
  },
  {
    lng: -41.3627481,
    lat: -21.5382921
  },
  {
    lng: -41.3629386,
    lat: -21.5378968
  },
  {
    lng: -41.3636619,
    lat: -21.5369832
  },
  {
    lng: -41.3636714,
    lat: -21.5369307
  },
  {
    lng: -41.3636924,
    lat: -21.5368731
  },
  {
    lng: -41.3639174,
    lat: -21.5364598
  },
  {
    lng: -41.3639881,
    lat: -21.5362183
  },
  {
    lng: -41.3639941,
    lat: -21.5360641
  },
  {
    lng: -41.3639968,
    lat: -21.5360376
  },
  {
    lng: -41.3640064,
    lat: -21.5359441
  },
  {
    lng: -41.3640918,
    lat: -21.5356622
  },
  {
    lng: -41.3640689,
    lat: -21.5353999
  },
  {
    lng: -41.3640719,
    lat: -21.5353664
  },
  {
    lng: -41.3640964,
    lat: -21.5350968
  },
  {
    lng: -41.3641242,
    lat: -21.5347544
  },
  {
    lng: -41.3641432,
    lat: -21.5345964
  },
  {
    lng: -41.3641364,
    lat: -21.5345087
  },
  {
    lng: -41.3641317,
    lat: -21.5342911
  },
  {
    lng: -41.3641446,
    lat: -21.5341557
  },
  {
    lng: -41.3641928,
    lat: -21.5340905
  },
  {
    lng: -41.3641775,
    lat: -21.533857
  },
  {
    lng: -41.3642309,
    lat: -21.5335477
  },
  {
    lng: -41.3642367,
    lat: -21.5333106
  },
  {
    lng: -41.3642519,
    lat: -21.532949
  },
  {
    lng: -41.3643699,
    lat: -21.5326463
  },
  {
    lng: -41.3644253,
    lat: -21.532365
  },
  {
    lng: -41.3644758,
    lat: -21.532201
  },
  {
    lng: -41.3644798,
    lat: -21.532185
  },
  {
    lng: -41.3645052,
    lat: -21.5320835
  },
  {
    lng: -41.364556,
    lat: -21.5318518
  },
  {
    lng: -41.3647175,
    lat: -21.5315077
  },
  {
    lng: -41.3648193,
    lat: -21.5313675
  },
  {
    lng: -41.3649293,
    lat: -21.5312362
  },
  {
    lng: -41.3649932,
    lat: -21.5311805
  },
  {
    lng: -41.3650097,
    lat: -21.5311661
  },
  {
    lng: -41.3650604,
    lat: -21.5310484
  },
  {
    lng: -41.3652571,
    lat: -21.5307843
  },
  {
    lng: -41.3653766,
    lat: -21.5305403
  },
  {
    lng: -41.3655098,
    lat: -21.53031
  },
  {
    lng: -41.3655917,
    lat: -21.5301823
  },
  {
    lng: -41.3657248,
    lat: -21.5299779
  },
  {
    lng: -41.3658672,
    lat: -21.5298071
  },
  {
    lng: -41.366057,
    lat: -21.5294905
  },
  {
    lng: -41.3661802,
    lat: -21.529267
  },
  {
    lng: -41.3662342,
    lat: -21.5291688
  },
  {
    lng: -41.3663429,
    lat: -21.528815
  },
  {
    lng: -41.3665468,
    lat: -21.5285071
  },
  {
    lng: -41.3668643,
    lat: -21.5282969
  },
  {
    lng: -41.367041,
    lat: -21.5279682
  },
  {
    lng: -41.367172,
    lat: -21.5276273
  },
  {
    lng: -41.3673965,
    lat: -21.5273282
  },
  {
    lng: -41.3675519,
    lat: -21.5269883
  },
  {
    lng: -41.367786,
    lat: -21.5267193
  },
  {
    lng: -41.3678011,
    lat: -21.526702
  },
  {
    lng: -41.3678143,
    lat: -21.5266842
  },
  {
    lng: -41.368013,
    lat: -21.5263725
  },
  {
    lng: -41.3681055,
    lat: -21.5263362
  },
  {
    lng: -41.3681774,
    lat: -21.5262723
  },
  {
    lng: -41.3683505,
    lat: -21.5259444
  },
  {
    lng: -41.368531,
    lat: -21.5256242
  },
  {
    lng: -41.3685995,
    lat: -21.5255071
  },
  {
    lng: -41.3688643,
    lat: -21.5252974
  },
  {
    lng: -41.3691048,
    lat: -21.5250127
  },
  {
    lng: -41.3692233,
    lat: -21.524666
  },
  {
    lng: -41.3693592,
    lat: -21.5243242
  },
  {
    lng: -41.3696505,
    lat: -21.5240785
  },
  {
    lng: -41.3698054,
    lat: -21.5238396
  },
  {
    lng: -41.369827,
    lat: -21.5237051
  },
  {
    lng: -41.369819,
    lat: -21.5236537
  },
  {
    lng: -41.3698153,
    lat: -21.52363
  },
  {
    lng: -41.3698925,
    lat: -21.5233444
  },
  {
    lng: -41.3700937,
    lat: -21.5230336
  },
  {
    lng: -41.3703048,
    lat: -21.5227212
  },
  {
    lng: -41.3705088,
    lat: -21.5223957
  },
  {
    lng: -41.3707036,
    lat: -21.522073
  },
  {
    lng: -41.3709032,
    lat: -21.5217565
  },
  {
    lng: -41.3711174,
    lat: -21.5214521
  },
  {
    lng: -41.3712394,
    lat: -21.5213977
  },
  {
    lng: -41.3714685,
    lat: -21.5212576
  },
  {
    lng: -41.371667,
    lat: -21.5209447
  },
  {
    lng: -41.371864,
    lat: -21.5206177
  },
  {
    lng: -41.3720608,
    lat: -21.5202979
  },
  {
    lng: -41.3722356,
    lat: -21.5199663
  },
  {
    lng: -41.3723499,
    lat: -21.5197344
  },
  {
    lng: -41.3723995,
    lat: -21.5196336
  },
  {
    lng: -41.3724828,
    lat: -21.5194805
  },
  {
    lng: -41.3725701,
    lat: -21.5193202
  },
  {
    lng: -41.3727491,
    lat: -21.518971
  },
  {
    lng: -41.3729455,
    lat: -21.5186541
  },
  {
    lng: -41.3731384,
    lat: -21.5183309
  },
  {
    lng: -41.3733595,
    lat: -21.518018
  },
  {
    lng: -41.373507,
    lat: -21.5176732
  },
  {
    lng: -41.3735993,
    lat: -21.5174766
  },
  {
    lng: -41.373639,
    lat: -21.5171138
  },
  {
    lng: -41.373651,
    lat: -21.5167407
  },
  {
    lng: -41.3736788,
    lat: -21.5163791
  },
  {
    lng: -41.3736416,
    lat: -21.5160011
  },
  {
    lng: -41.3735858,
    lat: -21.5156377
  },
  {
    lng: -41.3736596,
    lat: -21.5152694
  },
  {
    lng: -41.3736325,
    lat: -21.5151274
  },
  {
    lng: -41.3736183,
    lat: -21.5150525
  },
  {
    lng: -41.3735878,
    lat: -21.5149009
  },
  {
    lng: -41.3735555,
    lat: -21.5147271
  },
  {
    lng: -41.37357,
    lat: -21.5146611
  },
  {
    lng: -41.3735847,
    lat: -21.5146444
  },
  {
    lng: -41.3735634,
    lat: -21.5142991
  },
  {
    lng: -41.3735665,
    lat: -21.5142889
  },
  {
    lng: -41.373584,
    lat: -21.5142298
  },
  {
    lng: -41.3735918,
    lat: -21.5141647
  },
  {
    lng: -41.373574,
    lat: -21.514023
  },
  {
    lng: -41.3735685,
    lat: -21.5136615
  },
  {
    lng: -41.3735584,
    lat: -21.513586
  },
  {
    lng: -41.3735411,
    lat: -21.513458
  },
  {
    lng: -41.3735869,
    lat: -21.5132017
  },
  {
    lng: -41.373593,
    lat: -21.5129424
  },
  {
    lng: -41.3735379,
    lat: -21.5126981
  },
  {
    lng: -41.3734639,
    lat: -21.512503
  },
  {
    lng: -41.3734519,
    lat: -21.5123434
  },
  {
    lng: -41.3734442,
    lat: -21.5121336
  },
  {
    lng: -41.3734125,
    lat: -21.5118134
  },
  {
    lng: -41.3734059,
    lat: -21.5117392
  },
  {
    lng: -41.3733824,
    lat: -21.5116165
  },
  {
    lng: -41.3733629,
    lat: -21.5114962
  },
  {
    lng: -41.3733534,
    lat: -21.5114372
  },
  {
    lng: -41.3733956,
    lat: -21.5113515
  },
  {
    lng: -41.3734087,
    lat: -21.5112609
  },
  {
    lng: -41.3734057,
    lat: -21.5111947
  },
  {
    lng: -41.373398,
    lat: -21.5110424
  },
  {
    lng: -41.3733933,
    lat: -21.5110285
  },
  {
    lng: -41.3733817,
    lat: -21.5108353
  },
  {
    lng: -41.3733965,
    lat: -21.5106553
  },
  {
    lng: -41.3733688,
    lat: -21.5104754
  },
  {
    lng: -41.3733659,
    lat: -21.5102429
  },
  {
    lng: -41.373365,
    lat: -21.5100133
  },
  {
    lng: -41.3733442,
    lat: -21.5097736
  },
  {
    lng: -41.3733119,
    lat: -21.5095428
  },
  {
    lng: -41.3732874,
    lat: -21.5092963
  },
  {
    lng: -41.3732861,
    lat: -21.5092752
  },
  {
    lng: -41.3732726,
    lat: -21.5091526
  },
  {
    lng: -41.3732457,
    lat: -21.5089075
  },
  {
    lng: -41.3732475,
    lat: -21.5085902
  },
  {
    lng: -41.3732382,
    lat: -21.5082288
  },
  {
    lng: -41.3732258,
    lat: -21.508024
  },
  {
    lng: -41.3731712,
    lat: -21.507886
  },
  {
    lng: -41.3731608,
    lat: -21.5077421
  },
  {
    lng: -41.3731528,
    lat: -21.5076561
  },
  {
    lng: -41.373152,
    lat: -21.5076421
  },
  {
    lng: -41.3731508,
    lat: -21.5075648
  },
  {
    lng: -41.3731472,
    lat: -21.5073416
  },
  {
    lng: -41.3731127,
    lat: -21.5072343
  },
  {
    lng: -41.3731075,
    lat: -21.5071024
  },
  {
    lng: -41.3730893,
    lat: -21.5069155
  },
  {
    lng: -41.3730888,
    lat: -21.5068474
  },
  {
    lng: -41.3730718,
    lat: -21.5067788
  },
  {
    lng: -41.3730676,
    lat: -21.5067622
  },
  {
    lng: -41.3730963,
    lat: -21.5067195
  },
  {
    lng: -41.3731296,
    lat: -21.5065631
  },
  {
    lng: -41.3730352,
    lat: -21.506371
  },
  {
    lng: -41.3730298,
    lat: -21.5062761
  },
  {
    lng: -41.3730601,
    lat: -21.5061594
  },
  {
    lng: -41.3730796,
    lat: -21.5060931
  },
  {
    lng: -41.3730477,
    lat: -21.5060156
  },
  {
    lng: -41.3730189,
    lat: -21.5059561
  },
  {
    lng: -41.3730259,
    lat: -21.5058206
  },
  {
    lng: -41.3730338,
    lat: -21.5056974
  },
  {
    lng: -41.3730862,
    lat: -21.5053569
  },
  {
    lng: -41.3730944,
    lat: -21.5053349
  },
  {
    lng: -41.3731323,
    lat: -21.5052621
  },
  {
    lng: -41.3731473,
    lat: -21.5052372
  },
  {
    lng: -41.3732248,
    lat: -21.5051087
  },
  {
    lng: -41.3733383,
    lat: -21.5049207
  },
  {
    lng: -41.3734153,
    lat: -21.5047258
  },
  {
    lng: -41.3734567,
    lat: -21.5045023
  },
  {
    lng: -41.3734962,
    lat: -21.5044316
  },
  {
    lng: -41.3736285,
    lat: -21.5043082
  },
  {
    lng: -41.3737026,
    lat: -21.5042695
  },
  {
    lng: -41.3737491,
    lat: -21.5042174
  },
  {
    lng: -41.3739824,
    lat: -21.5039782
  },
  {
    lng: -41.3740975,
    lat: -21.5038782
  },
  {
    lng: -41.3742106,
    lat: -21.5037338
  },
  {
    lng: -41.3742799,
    lat: -21.5036453
  },
  {
    lng: -41.3743272,
    lat: -21.503547
  },
  {
    lng: -41.3743584,
    lat: -21.5034502
  },
  {
    lng: -41.3743645,
    lat: -21.5034187
  },
  {
    lng: -41.3744459,
    lat: -21.503064
  },
  {
    lng: -41.374464,
    lat: -21.5028319
  },
  {
    lng: -41.3745424,
    lat: -21.5024782
  },
  {
    lng: -41.3746089,
    lat: -21.5021088
  },
  {
    lng: -41.3746924,
    lat: -21.5017601
  },
  {
    lng: -41.3747837,
    lat: -21.5014074
  },
  {
    lng: -41.3747862,
    lat: -21.5013869
  },
  {
    lng: -41.3747866,
    lat: -21.5013835
  },
  {
    lng: -41.3748065,
    lat: -21.5010216
  },
  {
    lng: -41.3748474,
    lat: -21.5004966
  },
  {
    lng: -41.3749436,
    lat: -21.5001587
  },
  {
    lng: -41.3750956,
    lat: -21.4998362
  },
  {
    lng: -41.3752867,
    lat: -21.4996445
  },
  {
    lng: -41.3758749,
    lat: -21.4990355
  },
  {
    lng: -41.3761735,
    lat: -21.4987334
  },
  {
    lng: -41.3763812,
    lat: -21.4985359
  },
  {
    lng: -41.3765803,
    lat: -21.4983204
  },
  {
    lng: -41.3768962,
    lat: -21.4981339
  },
  {
    lng: -41.377024,
    lat: -21.4979925
  },
  {
    lng: -41.3770889,
    lat: -21.4979205
  },
  {
    lng: -41.3771698,
    lat: -21.497831
  },
  {
    lng: -41.3771946,
    lat: -21.4978041
  },
  {
    lng: -41.3772714,
    lat: -21.4977214
  },
  {
    lng: -41.3774489,
    lat: -21.4975301
  },
  {
    lng: -41.3776839,
    lat: -21.4973071
  },
  {
    lng: -41.3777764,
    lat: -21.4972193
  },
  {
    lng: -41.3778726,
    lat: -21.4971309
  },
  {
    lng: -41.3779618,
    lat: -21.497049
  },
  {
    lng: -41.3781651,
    lat: -21.496862
  },
  {
    lng: -41.3785654,
    lat: -21.4964534
  },
  {
    lng: -41.379029,
    lat: -21.4959945
  },
  {
    lng: -41.3792654,
    lat: -21.4957693
  },
  {
    lng: -41.3795579,
    lat: -21.4955279
  },
  {
    lng: -41.3797417,
    lat: -21.4953714
  },
  {
    lng: -41.3798004,
    lat: -21.4953055
  },
  {
    lng: -41.3798552,
    lat: -21.4952648
  },
  {
    lng: -41.379909,
    lat: -21.4952249
  },
  {
    lng: -41.380042,
    lat: -21.4950904
  },
  {
    lng: -41.3800498,
    lat: -21.4950823
  },
  {
    lng: -41.3801287,
    lat: -21.4950013
  },
  {
    lng: -41.3801902,
    lat: -21.4949573
  },
  {
    lng: -41.3802555,
    lat: -21.4949106
  },
  {
    lng: -41.3805055,
    lat: -21.4946739
  },
  {
    lng: -41.3807071,
    lat: -21.494466
  },
  {
    lng: -41.3809239,
    lat: -21.49424
  },
  {
    lng: -41.3809478,
    lat: -21.4942152
  },
  {
    lng: -41.3809777,
    lat: -21.4941915
  },
  {
    lng: -41.3810529,
    lat: -21.4941319
  },
  {
    lng: -41.3810763,
    lat: -21.4941133
  },
  {
    lng: -41.381082,
    lat: -21.4941088
  },
  {
    lng: -41.3813339,
    lat: -21.4939162
  },
  {
    lng: -41.3814513,
    lat: -21.4937929
  },
  {
    lng: -41.3815583,
    lat: -21.4936996
  },
  {
    lng: -41.3817225,
    lat: -21.4935588
  },
  {
    lng: -41.3818338,
    lat: -21.493437
  },
  {
    lng: -41.3819225,
    lat: -21.4933396
  },
  {
    lng: -41.3820567,
    lat: -21.4932332
  },
  {
    lng: -41.3821652,
    lat: -21.4931342
  },
  {
    lng: -41.382322,
    lat: -21.4930049
  },
  {
    lng: -41.3824653,
    lat: -21.4928999
  },
  {
    lng: -41.3825437,
    lat: -21.4928296
  },
  {
    lng: -41.3826262,
    lat: -21.4927237
  },
  {
    lng: -41.3826768,
    lat: -21.4926109
  },
  {
    lng: -41.3826985,
    lat: -21.4924955
  },
  {
    lng: -41.3827186,
    lat: -21.4923773
  },
  {
    lng: -41.3827633,
    lat: -21.492276
  },
  {
    lng: -41.3828121,
    lat: -21.4921419
  },
  {
    lng: -41.3828364,
    lat: -21.4920527
  },
  {
    lng: -41.3828591,
    lat: -21.4919695
  },
  {
    lng: -41.3828838,
    lat: -21.4918512
  },
  {
    lng: -41.3829007,
    lat: -21.4917089
  },
  {
    lng: -41.3829031,
    lat: -21.4916506
  },
  {
    lng: -41.3828882,
    lat: -21.4915213
  },
  {
    lng: -41.3828573,
    lat: -21.4914661
  },
  {
    lng: -41.382758,
    lat: -21.4914115
  },
  {
    lng: -41.3826876,
    lat: -21.4913566
  },
  {
    lng: -41.3826447,
    lat: -21.4913157
  },
  {
    lng: -41.3826062,
    lat: -21.4912677
  },
  {
    lng: -41.3825878,
    lat: -21.4912464
  },
  {
    lng: -41.3825463,
    lat: -21.4911985
  },
  {
    lng: -41.3824894,
    lat: -21.4911279
  },
  {
    lng: -41.3824732,
    lat: -21.4911058
  },
  {
    lng: -41.382451,
    lat: -21.4910756
  },
  {
    lng: -41.382423,
    lat: -21.4910161
  },
  {
    lng: -41.38242,
    lat: -21.4909975
  },
  {
    lng: -41.3824134,
    lat: -21.4909579
  },
  {
    lng: -41.3824004,
    lat: -21.4908727
  },
  {
    lng: -41.3824029,
    lat: -21.4908143
  },
  {
    lng: -41.3824083,
    lat: -21.4907489
  },
  {
    lng: -41.3824183,
    lat: -21.4906805
  },
  {
    lng: -41.3824252,
    lat: -21.4906108
  },
  {
    lng: -41.3824222,
    lat: -21.4905757
  },
  {
    lng: -41.3824167,
    lat: -21.4905113
  },
  {
    lng: -41.3823914,
    lat: -21.4904035
  },
  {
    lng: -41.3823676,
    lat: -21.490297
  },
  {
    lng: -41.3823517,
    lat: -21.490226
  },
  {
    lng: -41.382316,
    lat: -21.4901439
  },
  {
    lng: -41.3822695,
    lat: -21.4900504
  },
  {
    lng: -41.3822401,
    lat: -21.489998
  },
  {
    lng: -41.3822245,
    lat: -21.4899569
  },
  {
    lng: -41.3822317,
    lat: -21.4899085
  },
  {
    lng: -41.3822512,
    lat: -21.4898842
  },
  {
    lng: -41.3822671,
    lat: -21.4898722
  },
  {
    lng: -41.38231,
    lat: -21.4898396
  },
  {
    lng: -41.3823536,
    lat: -21.4897866
  },
  {
    lng: -41.3823549,
    lat: -21.4897845
  },
  {
    lng: -41.382382,
    lat: -21.4897423
  },
  {
    lng: -41.3824211,
    lat: -21.4897036
  },
  {
    lng: -41.3824908,
    lat: -21.4896746
  },
  {
    lng: -41.382542,
    lat: -21.4896343
  },
  {
    lng: -41.3825737,
    lat: -21.4896056
  },
  {
    lng: -41.382605,
    lat: -21.4895442
  },
  {
    lng: -41.3826412,
    lat: -21.4895155
  },
  {
    lng: -41.3826607,
    lat: -21.4895138
  },
  {
    lng: -41.3827074,
    lat: -21.4895098
  },
  {
    lng: -41.3827156,
    lat: -21.4895092
  },
  {
    lng: -41.3827552,
    lat: -21.4895282
  },
  {
    lng: -41.3827736,
    lat: -21.4895371
  },
  {
    lng: -41.382836,
    lat: -21.4895522
  },
  {
    lng: -41.3828728,
    lat: -21.4895482
  },
  {
    lng: -41.3828961,
    lat: -21.4895456
  },
  {
    lng: -41.3829058,
    lat: -21.4895445
  },
  {
    lng: -41.3830195,
    lat: -21.489518
  },
  {
    lng: -41.3831243,
    lat: -21.4895057
  },
  {
    lng: -41.3832426,
    lat: -21.4894848
  },
  {
    lng: -41.3832917,
    lat: -21.4894499
  },
  {
    lng: -41.3833316,
    lat: -21.4894215
  },
  {
    lng: -41.3833708,
    lat: -21.4893885
  },
  {
    lng: -41.3834413,
    lat: -21.4892955
  },
  {
    lng: -41.3834651,
    lat: -21.4892398
  },
  {
    lng: -41.3834886,
    lat: -21.48915
  },
  {
    lng: -41.3834981,
    lat: -21.4890365
  },
  {
    lng: -41.3834995,
    lat: -21.4890205
  },
  {
    lng: -41.3835034,
    lat: -21.4889579
  },
  {
    lng: -41.3835316,
    lat: -21.4888852
  },
  {
    lng: -41.3835948,
    lat: -21.4888192
  },
  {
    lng: -41.3836643,
    lat: -21.4887845
  },
  {
    lng: -41.3837462,
    lat: -21.4887639
  },
  {
    lng: -41.3838115,
    lat: -21.4887591
  },
  {
    lng: -41.3838649,
    lat: -21.4887814
  },
  {
    lng: -41.3839319,
    lat: -21.4888036
  },
  {
    lng: -41.3839381,
    lat: -21.4888059
  },
  {
    lng: -41.3840189,
    lat: -21.4888356
  },
  {
    lng: -41.384029,
    lat: -21.4888394
  },
  {
    lng: -41.3840966,
    lat: -21.4888648
  },
  {
    lng: -41.3841545,
    lat: -21.48888
  },
  {
    lng: -41.3842686,
    lat: -21.4888946
  },
  {
    lng: -41.3843888,
    lat: -21.4889107
  },
  {
    lng: -41.3844568,
    lat: -21.4889094
  },
  {
    lng: -41.384524,
    lat: -21.4889082
  },
  {
    lng: -41.384614,
    lat: -21.4889009
  },
  {
    lng: -41.3847016,
    lat: -21.4888939
  },
  {
    lng: -41.3847548,
    lat: -21.4888839
  },
  {
    lng: -41.3847627,
    lat: -21.4888824
  },
  {
    lng: -41.3848442,
    lat: -21.4888671
  },
  {
    lng: -41.3849562,
    lat: -21.4888277
  },
  {
    lng: -41.3850394,
    lat: -21.4887858
  },
  {
    lng: -41.3851509,
    lat: -21.4886853
  },
  {
    lng: -41.3852129,
    lat: -21.4886564
  },
  {
    lng: -41.3852705,
    lat: -21.4886445
  },
  {
    lng: -41.3853018,
    lat: -21.4886429
  },
  {
    lng: -41.3853677,
    lat: -21.4886394
  },
  {
    lng: -41.385442,
    lat: -21.4886189
  },
  {
    lng: -41.3855203,
    lat: -21.48855
  },
  {
    lng: -41.3855517,
    lat: -21.4884929
  },
  {
    lng: -41.3856012,
    lat: -21.4884299
  },
  {
    lng: -41.3856359,
    lat: -21.4884001
  },
  {
    lng: -41.385663,
    lat: -21.4883767
  },
  {
    lng: -41.3857218,
    lat: -21.4883307
  },
  {
    lng: -41.3857637,
    lat: -21.488265
  },
  {
    lng: -41.3857889,
    lat: -21.4881951
  },
  {
    lng: -41.3857926,
    lat: -21.4881055
  },
  {
    lng: -41.3857797,
    lat: -21.4880302
  },
  {
    lng: -41.3857621,
    lat: -21.4879393
  },
  {
    lng: -41.3857427,
    lat: -21.4878144
  },
  {
    lng: -41.3857553,
    lat: -21.4877062
  },
  {
    lng: -41.385798,
    lat: -21.4875551
  },
  {
    lng: -41.3858261,
    lat: -21.4874838
  },
  {
    lng: -41.3858528,
    lat: -21.4874096
  },
  {
    lng: -41.3858762,
    lat: -21.4873198
  },
  {
    lng: -41.3858721,
    lat: -21.4872004
  },
  {
    lng: -41.3858606,
    lat: -21.4871138
  },
  {
    lng: -41.385866,
    lat: -21.4870412
  },
  {
    lng: -41.3858986,
    lat: -21.4869556
  },
  {
    lng: -41.3859646,
    lat: -21.4868683
  },
  {
    lng: -41.3859988,
    lat: -21.4867855
  },
  {
    lng: -41.3860314,
    lat: -21.4866999
  },
  {
    lng: -41.3860354,
    lat: -21.4866487
  },
  {
    lng: -41.3859968,
    lat: -21.4865779
  },
  {
    lng: -41.3859675,
    lat: -21.4865412
  },
  {
    lng: -41.3859513,
    lat: -21.4864361
  },
  {
    lng: -41.3859612,
    lat: -21.4863578
  },
  {
    lng: -41.3859804,
    lat: -21.4862979
  },
  {
    lng: -41.3860268,
    lat: -21.4862222
  },
  {
    lng: -41.3861464,
    lat: -21.4861771
  },
  {
    lng: -41.3862468,
    lat: -21.4861905
  },
  {
    lng: -41.3863244,
    lat: -21.4862055
  },
  {
    lng: -41.3864429,
    lat: -21.4862016
  },
  {
    lng: -41.3865034,
    lat: -21.4861684
  },
  {
    lng: -41.3865289,
    lat: -21.4861383
  },
  {
    lng: -41.3865466,
    lat: -21.4860856
  },
  {
    lng: -41.3865446,
    lat: -21.4860372
  },
  {
    lng: -41.3865321,
    lat: -21.4860018
  },
  {
    lng: -41.3865303,
    lat: -21.4859634
  },
  {
    lng: -41.3865617,
    lat: -21.4859148
  },
  {
    lng: -41.3866071,
    lat: -21.4858959
  },
  {
    lng: -41.3866176,
    lat: -21.4858974
  },
  {
    lng: -41.3866558,
    lat: -21.4859026
  },
  {
    lng: -41.3867786,
    lat: -21.4858817
  },
  {
    lng: -41.386865,
    lat: -21.4858525
  },
  {
    lng: -41.3869405,
    lat: -21.4858078
  },
  {
    lng: -41.3869842,
    lat: -21.4857662
  },
  {
    lng: -41.3869965,
    lat: -21.4857471
  },
  {
    lng: -41.3870118,
    lat: -21.4857235
  },
  {
    lng: -41.3870156,
    lat: -21.4857176
  },
  {
    lng: -41.3870379,
    lat: -21.4856648
  },
  {
    lng: -41.3870402,
    lat: -21.4855923
  },
  {
    lng: -41.3870138,
    lat: -21.4855285
  },
  {
    lng: -41.3869936,
    lat: -21.485486
  },
  {
    lng: -41.386982,
    lat: -21.4854672
  },
  {
    lng: -41.3869288,
    lat: -21.4853813
  },
  {
    lng: -41.3869355,
    lat: -21.4853245
  },
  {
    lng: -41.3869359,
    lat: -21.4853215
  },
  {
    lng: -41.386952,
    lat: -21.4852645
  },
  {
    lng: -41.3869866,
    lat: -21.4852273
  },
  {
    lng: -41.3870274,
    lat: -21.4852056
  },
  {
    lng: -41.3870932,
    lat: -21.4851234
  },
  {
    lng: -41.387095,
    lat: -21.4851211
  },
  {
    lng: -41.3871508,
    lat: -21.4850766
  },
  {
    lng: -41.3871977,
    lat: -21.4850534
  },
  {
    lng: -41.3872766,
    lat: -21.4850456
  },
  {
    lng: -41.3873493,
    lat: -21.4850237
  },
  {
    lng: -41.3874054,
    lat: -21.4850062
  },
  {
    lng: -41.3875022,
    lat: -21.484967
  },
  {
    lng: -41.3875308,
    lat: -21.4849397
  },
  {
    lng: -41.3875529,
    lat: -21.4848656
  },
  {
    lng: -41.3875402,
    lat: -21.4848088
  },
  {
    lng: -41.3875443,
    lat: -21.4847618
  },
  {
    lng: -41.3875849,
    lat: -21.4847117
  },
  {
    lng: -41.3876801,
    lat: -21.484664
  },
  {
    lng: -41.3877331,
    lat: -21.4846479
  },
  {
    lng: -41.3877548,
    lat: -21.4846477
  },
  {
    lng: -41.3878,
    lat: -21.4846474
  },
  {
    lng: -41.3878671,
    lat: -21.484671
  },
  {
    lng: -41.3879401,
    lat: -21.484686
  },
  {
    lng: -41.3879705,
    lat: -21.4846857
  },
  {
    lng: -41.388028,
    lat: -21.4846611
  },
  {
    lng: -41.388052,
    lat: -21.484631
  },
  {
    lng: -41.3881019,
    lat: -21.484605
  },
  {
    lng: -41.3881284,
    lat: -21.4846077
  },
  {
    lng: -41.3881658,
    lat: -21.4846116
  },
  {
    lng: -41.3882041,
    lat: -21.484644
  },
  {
    lng: -41.388238,
    lat: -21.4846906
  },
  {
    lng: -41.3882658,
    lat: -21.4847416
  },
  {
    lng: -41.3882818,
    lat: -21.4848253
  },
  {
    lng: -41.3882871,
    lat: -21.4849021
  },
  {
    lng: -41.3882968,
    lat: -21.4849646
  },
  {
    lng: -41.3883108,
    lat: -21.4849986
  },
  {
    lng: -41.3883506,
    lat: -21.485031
  },
  {
    lng: -41.3884162,
    lat: -21.4850517
  },
  {
    lng: -41.3884647,
    lat: -21.4850442
  },
  {
    lng: -41.3885226,
    lat: -21.485058
  },
  {
    lng: -41.3885457,
    lat: -21.4850947
  },
  {
    lng: -41.3885743,
    lat: -21.4851197
  },
  {
    lng: -41.3885764,
    lat: -21.4851215
  },
  {
    lng: -41.3886143,
    lat: -21.4851183
  },
  {
    lng: -41.3886629,
    lat: -21.4851193
  },
  {
    lng: -41.3887194,
    lat: -21.4851473
  },
  {
    lng: -41.3887426,
    lat: -21.4851855
  },
  {
    lng: -41.3887732,
    lat: -21.4852037
  },
  {
    lng: -41.3887945,
    lat: -21.4852164
  },
  {
    lng: -41.3888173,
    lat: -21.4852095
  },
  {
    lng: -41.3888627,
    lat: -21.4851959
  },
  {
    lng: -41.3889183,
    lat: -21.4851343
  },
  {
    lng: -41.3889316,
    lat: -21.4850972
  },
  {
    lng: -41.3889365,
    lat: -21.4850736
  },
  {
    lng: -41.3889462,
    lat: -21.4850274
  },
  {
    lng: -41.3889542,
    lat: -21.4849884
  },
  {
    lng: -41.3889665,
    lat: -21.4849291
  },
  {
    lng: -41.3889715,
    lat: -21.4848139
  },
  {
    lng: -41.3889648,
    lat: -21.4847542
  },
  {
    lng: -41.3889863,
    lat: -21.4846175
  },
  {
    lng: -41.389025,
    lat: -21.4845304
  },
  {
    lng: -41.3891125,
    lat: -21.48447
  },
  {
    lng: -41.3891683,
    lat: -21.4844212
  },
  {
    lng: -41.3892508,
    lat: -21.4843124
  },
  {
    lng: -41.3892762,
    lat: -21.4842695
  },
  {
    lng: -41.3893162,
    lat: -21.4841611
  },
  {
    lng: -41.3893332,
    lat: -21.4840834
  },
  {
    lng: -41.3893336,
    lat: -21.4840813
  },
  {
    lng: -41.3893586,
    lat: -21.4839944
  },
  {
    lng: -41.3893689,
    lat: -21.4839516
  },
  {
    lng: -41.389388,
    lat: -21.4838903
  },
  {
    lng: -41.3894421,
    lat: -21.4838216
  },
  {
    lng: -41.3894626,
    lat: -21.4837992
  },
  {
    lng: -41.3894863,
    lat: -21.4837734
  },
  {
    lng: -41.3894947,
    lat: -21.4837643
  },
  {
    lng: -41.3895169,
    lat: -21.4837552
  },
  {
    lng: -41.3895552,
    lat: -21.4837396
  },
  {
    lng: -41.3896097,
    lat: -21.4837207
  },
  {
    lng: -41.389652,
    lat: -21.4836933
  },
  {
    lng: -41.389685,
    lat: -21.4836432
  },
  {
    lng: -41.3897041,
    lat: -21.4835748
  },
  {
    lng: -41.3897101,
    lat: -21.4835356
  },
  {
    lng: -41.3897169,
    lat: -21.4834908
  },
  {
    lng: -41.3897253,
    lat: -21.4834125
  },
  {
    lng: -41.3897489,
    lat: -21.4833341
  },
  {
    lng: -41.3898013,
    lat: -21.4832555
  },
  {
    lng: -41.3898281,
    lat: -21.4832327
  },
  {
    lng: -41.3898721,
    lat: -21.4831952
  },
  {
    lng: -41.3899559,
    lat: -21.4830579
  },
  {
    lng: -41.39002,
    lat: -21.4829351
  },
  {
    lng: -41.3900691,
    lat: -21.4828252
  },
  {
    lng: -41.3900956,
    lat: -21.4827311
  },
  {
    lng: -41.3901236,
    lat: -21.4826456
  },
  {
    lng: -41.3901702,
    lat: -21.4825897
  },
  {
    lng: -41.3902561,
    lat: -21.4825551
  },
  {
    lng: -41.3902746,
    lat: -21.4825476
  },
  {
    lng: -41.3903703,
    lat: -21.4825482
  },
  {
    lng: -41.390422,
    lat: -21.4825549
  },
  {
    lng: -41.3905009,
    lat: -21.4825443
  },
  {
    lng: -41.3905812,
    lat: -21.4825152
  },
  {
    lng: -41.3906036,
    lat: -21.4824959
  },
  {
    lng: -41.390643,
    lat: -21.482462
  },
  {
    lng: -41.390668,
    lat: -21.4824211
  },
  {
    lng: -41.3906848,
    lat: -21.4823934
  },
  {
    lng: -41.3907183,
    lat: -21.4822424
  },
  {
    lng: -41.3907087,
    lat: -21.4821828
  },
  {
    lng: -41.3907033,
    lat: -21.482175
  },
  {
    lng: -41.3906979,
    lat: -21.4821672
  },
  {
    lng: -41.3906673,
    lat: -21.4821518
  },
  {
    lng: -41.3905957,
    lat: -21.4821014
  },
  {
    lng: -41.3905109,
    lat: -21.4819953
  },
  {
    lng: -41.3905059,
    lat: -21.4819484
  },
  {
    lng: -41.3905101,
    lat: -21.4819133
  },
  {
    lng: -41.3905143,
    lat: -21.4818787
  },
  {
    lng: -41.3905077,
    lat: -21.4818247
  },
  {
    lng: -41.3904841,
    lat: -21.4817438
  },
  {
    lng: -41.3904823,
    lat: -21.4817054
  },
  {
    lng: -41.3904577,
    lat: -21.4816397
  },
  {
    lng: -41.3904526,
    lat: -21.4816261
  },
  {
    lng: -41.3904186,
    lat: -21.4815581
  },
  {
    lng: -41.390395,
    lat: -21.4814772
  },
  {
    lng: -41.3903898,
    lat: -21.4814161
  },
  {
    lng: -41.3903986,
    lat: -21.4813748
  },
  {
    lng: -41.3904084,
    lat: -21.4813598
  },
  {
    lng: -41.390433,
    lat: -21.4813219
  },
  {
    lng: -41.3904569,
    lat: -21.4812762
  },
  {
    lng: -41.3904778,
    lat: -21.4812433
  },
  {
    lng: -41.3905078,
    lat: -21.4812033
  },
  {
    lng: -41.3905317,
    lat: -21.4811576
  },
  {
    lng: -41.3905253,
    lat: -21.4811249
  },
  {
    lng: -41.3904825,
    lat: -21.4810997
  },
  {
    lng: -41.3904247,
    lat: -21.4810902
  },
  {
    lng: -41.3903532,
    lat: -21.4810794
  },
  {
    lng: -41.390277,
    lat: -21.481053
  },
  {
    lng: -41.3902251,
    lat: -21.4810293
  },
  {
    lng: -41.3901746,
    lat: -21.4809913
  },
  {
    lng: -41.3901529,
    lat: -21.4809489
  },
  {
    lng: -41.3901416,
    lat: -21.4808821
  },
  {
    lng: -41.3900832,
    lat: -21.4808101
  },
  {
    lng: -41.3900216,
    lat: -21.480759
  },
  {
    lng: -41.3900204,
    lat: -21.480758
  },
  {
    lng: -41.3899818,
    lat: -21.4806958
  },
  {
    lng: -41.3899632,
    lat: -21.480649
  },
  {
    lng: -41.3899459,
    lat: -21.4805866
  },
  {
    lng: -41.3899347,
    lat: -21.4805369
  },
  {
    lng: -41.389928,
    lat: -21.4804658
  },
  {
    lng: -41.3899396,
    lat: -21.480406
  },
  {
    lng: -41.389957,
    lat: -21.4803248
  },
  {
    lng: -41.3899504,
    lat: -21.4802723
  },
  {
    lng: -41.3899423,
    lat: -21.4802197
  },
  {
    lng: -41.3899426,
    lat: -21.4802025
  },
  {
    lng: -41.3899433,
    lat: -21.4801571
  },
  {
    lng: -41.3899564,
    lat: -21.4800987
  },
  {
    lng: -41.3899495,
    lat: -21.4800177
  },
  {
    lng: -41.3899171,
    lat: -21.4799611
  },
  {
    lng: -41.3898606,
    lat: -21.4799374
  },
  {
    lng: -41.3898036,
    lat: -21.4799289
  },
  {
    lng: -41.3897709,
    lat: -21.479924
  },
  {
    lng: -41.3897116,
    lat: -21.4799216
  },
  {
    lng: -41.3896704,
    lat: -21.479902
  },
  {
    lng: -41.389652,
    lat: -21.4798823
  },
  {
    lng: -41.3896488,
    lat: -21.4798681
  },
  {
    lng: -41.3896543,
    lat: -21.479814
  },
  {
    lng: -41.3896754,
    lat: -21.4797868
  },
  {
    lng: -41.3897283,
    lat: -21.4797636
  },
  {
    lng: -41.3897422,
    lat: -21.4797613
  },
  {
    lng: -41.3897829,
    lat: -21.4797546
  },
  {
    lng: -41.3898437,
    lat: -21.4797513
  },
  {
    lng: -41.389863,
    lat: -21.4797426
  },
  {
    lng: -41.3899208,
    lat: -21.4797165
  },
  {
    lng: -41.3899755,
    lat: -21.4796923
  },
  {
    lng: -41.3900191,
    lat: -21.479673
  },
  {
    lng: -41.3901232,
    lat: -21.4795968
  },
  {
    lng: -41.3901638,
    lat: -21.4795524
  },
  {
    lng: -41.3901877,
    lat: -21.4795095
  },
  {
    lng: -41.3902023,
    lat: -21.4794482
  },
  {
    lng: -41.3901943,
    lat: -21.4794056
  },
  {
    lng: -41.3901833,
    lat: -21.4793616
  },
  {
    lng: -41.3901555,
    lat: -21.4793135
  },
  {
    lng: -41.3901517,
    lat: -21.4793105
  },
  {
    lng: -41.3901203,
    lat: -21.4792854
  },
  {
    lng: -41.3900455,
    lat: -21.4792505
  },
  {
    lng: -41.3900043,
    lat: -21.4792295
  },
  {
    lng: -41.3899385,
    lat: -21.4791874
  },
  {
    lng: -41.3898847,
    lat: -21.479121
  },
  {
    lng: -41.3898614,
    lat: -21.4790671
  },
  {
    lng: -41.3898617,
    lat: -21.4790591
  },
  {
    lng: -41.3898639,
    lat: -21.4790088
  },
  {
    lng: -41.3898922,
    lat: -21.478956
  },
  {
    lng: -41.3899284,
    lat: -21.4789258
  },
  {
    lng: -41.3899768,
    lat: -21.4789055
  },
  {
    lng: -41.3900588,
    lat: -21.4788948
  },
  {
    lng: -41.3901104,
    lat: -21.4788873
  },
  {
    lng: -41.3901421,
    lat: -21.4788728
  },
  {
    lng: -41.3902192,
    lat: -21.4788281
  },
  {
    lng: -41.3902963,
    lat: -21.4787905
  },
  {
    lng: -41.39037,
    lat: -21.4787173
  },
  {
    lng: -41.3904196,
    lat: -21.4786558
  },
  {
    lng: -41.3904541,
    lat: -21.4786292
  },
  {
    lng: -41.3904829,
    lat: -21.4786069
  },
  {
    lng: -41.3905495,
    lat: -21.4785736
  },
  {
    lng: -41.3906268,
    lat: -21.4785559
  },
  {
    lng: -41.390686,
    lat: -21.4785582
  },
  {
    lng: -41.3907727,
    lat: -21.4785675
  },
  {
    lng: -41.3908259,
    lat: -21.4785628
  },
  {
    lng: -41.390873,
    lat: -21.4785624
  },
  {
    lng: -41.3909334,
    lat: -21.4785708
  },
  {
    lng: -41.3909399,
    lat: -21.4785718
  },
  {
    lng: -41.3910021,
    lat: -21.4785641
  },
  {
    lng: -41.3910869,
    lat: -21.4785335
  },
  {
    lng: -41.3911838,
    lat: -21.4784943
  },
  {
    lng: -41.3911921,
    lat: -21.4784903
  },
  {
    lng: -41.3912503,
    lat: -21.4784625
  },
  {
    lng: -41.3912972,
    lat: -21.4784422
  },
  {
    lng: -41.3913578,
    lat: -21.4784204
  },
  {
    lng: -41.3914275,
    lat: -21.4784098
  },
  {
    lng: -41.3915233,
    lat: -21.4784118
  },
  {
    lng: -41.3915552,
    lat: -21.4784187
  },
  {
    lng: -41.3916285,
    lat: -21.4784508
  },
  {
    lng: -41.3916638,
    lat: -21.4784889
  },
  {
    lng: -41.3916868,
    lat: -21.4785157
  },
  {
    lng: -41.391763,
    lat: -21.478535
  },
  {
    lng: -41.3918269,
    lat: -21.4785415
  },
  {
    lng: -41.3918816,
    lat: -21.478551
  },
  {
    lng: -41.3919426,
    lat: -21.4785747
  },
  {
    lng: -41.3920069,
    lat: -21.4786168
  },
  {
    lng: -41.3920888,
    lat: -21.4786633
  },
  {
    lng: -41.3920909,
    lat: -21.4786645
  },
  {
    lng: -41.392141,
    lat: -21.4786612
  },
  {
    lng: -41.3921607,
    lat: -21.4786721
  },
  {
    lng: -41.3921699,
    lat: -21.4786771
  },
  {
    lng: -41.3921792,
    lat: -21.4786822
  },
  {
    lng: -41.3922156,
    lat: -21.4786819
  },
  {
    lng: -41.3922488,
    lat: -21.4786546
  },
  {
    lng: -41.3922439,
    lat: -21.4786177
  },
  {
    lng: -41.3922206,
    lat: -21.4785667
  },
  {
    lng: -41.3922156,
    lat: -21.4785226
  },
  {
    lng: -41.392241,
    lat: -21.4784741
  },
  {
    lng: -41.3922817,
    lat: -21.4784453
  },
  {
    lng: -41.3923348,
    lat: -21.4784335
  },
  {
    lng: -41.3923378,
    lat: -21.4784337
  },
  {
    lng: -41.3924093,
    lat: -21.4784385
  },
  {
    lng: -41.3924489,
    lat: -21.4784524
  },
  {
    lng: -41.3925345,
    lat: -21.47851
  },
  {
    lng: -41.3925988,
    lat: -21.4785592
  },
  {
    lng: -41.3926538,
    lat: -21.4785915
  },
  {
    lng: -41.3927134,
    lat: -21.4786265
  },
  {
    lng: -41.3927503,
    lat: -21.4786731
  },
  {
    lng: -41.3927494,
    lat: -21.4787371
  },
  {
    lng: -41.3927271,
    lat: -21.4787857
  },
  {
    lng: -41.3926623,
    lat: -21.4788459
  },
  {
    lng: -41.3926308,
    lat: -21.478886
  },
  {
    lng: -41.3926235,
    lat: -21.4789117
  },
  {
    lng: -41.3926267,
    lat: -21.4789287
  },
  {
    lng: -41.3926421,
    lat: -21.4789528
  },
  {
    lng: -41.392662,
    lat: -21.4789697
  },
  {
    lng: -41.3927017,
    lat: -21.4789892
  },
  {
    lng: -41.3927627,
    lat: -21.4790129
  },
  {
    lng: -41.3928145,
    lat: -21.4790295
  },
  {
    lng: -41.3928558,
    lat: -21.4790533
  },
  {
    lng: -41.3929306,
    lat: -21.4790982
  },
  {
    lng: -41.3929825,
    lat: -21.479122
  },
  {
    lng: -41.393048,
    lat: -21.4791427
  },
  {
    lng: -41.3931103,
    lat: -21.4791408
  },
  {
    lng: -41.3931618,
    lat: -21.479119
  },
  {
    lng: -41.3931918,
    lat: -21.4790818
  },
  {
    lng: -41.3932004,
    lat: -21.4790249
  },
  {
    lng: -41.393224,
    lat: -21.4789507
  },
  {
    lng: -41.3932753,
    lat: -21.4789147
  },
  {
    lng: -41.3933208,
    lat: -21.4789058
  },
  {
    lng: -41.3933603,
    lat: -21.4789083
  },
  {
    lng: -41.3934273,
    lat: -21.4789262
  },
  {
    lng: -41.3934834,
    lat: -21.4789158
  },
  {
    lng: -41.3935257,
    lat: -21.4788927
  },
  {
    lng: -41.3935646,
    lat: -21.4788284
  },
  {
    lng: -41.3935852,
    lat: -21.4787614
  },
  {
    lng: -41.3935966,
    lat: -21.4786774
  },
  {
    lng: -41.3936005,
    lat: -21.4786134
  },
  {
    lng: -41.3936101,
    lat: -21.4785009
  },
  {
    lng: -41.3936293,
    lat: -21.4784425
  },
  {
    lng: -41.3936654,
    lat: -21.4784052
  },
  {
    lng: -41.3937109,
    lat: -21.4783963
  },
  {
    lng: -41.3937504,
    lat: -21.4783974
  },
  {
    lng: -41.3937687,
    lat: -21.4784043
  },
  {
    lng: -41.3938008,
    lat: -21.4784282
  },
  {
    lng: -41.3938409,
    lat: -21.4784848
  },
  {
    lng: -41.3938578,
    lat: -21.4785102
  },
  {
    lng: -41.3939102,
    lat: -21.4785837
  },
  {
    lng: -41.3939469,
    lat: -21.4786133
  },
  {
    lng: -41.3940157,
    lat: -21.4786582
  },
  {
    lng: -41.3940541,
    lat: -21.478702
  },
  {
    lng: -41.3941124,
    lat: -21.4787541
  },
  {
    lng: -41.3941475,
    lat: -21.478778
  },
  {
    lng: -41.3941949,
    lat: -21.4788074
  },
  {
    lng: -41.3942712,
    lat: -21.4788395
  },
  {
    lng: -41.3943458,
    lat: -21.4788531
  },
  {
    lng: -41.3944293,
    lat: -21.4788524
  },
  {
    lng: -41.3945341,
    lat: -21.4788472
  },
  {
    lng: -41.394598,
    lat: -21.4788538
  },
  {
    lng: -41.3946573,
    lat: -21.4788675
  },
  {
    lng: -41.3947122,
    lat: -21.4788884
  },
  {
    lng: -41.3947702,
    lat: -21.4789135
  },
  {
    lng: -41.3948251,
    lat: -21.4789344
  },
  {
    lng: -41.3948936,
    lat: -21.478948
  },
  {
    lng: -41.3949544,
    lat: -21.4789461
  },
  {
    lng: -41.3950088,
    lat: -21.4789158
  },
  {
    lng: -41.3950888,
    lat: -21.4788653
  },
  {
    lng: -41.3951875,
    lat: -21.4788631
  },
  {
    lng: -41.3952543,
    lat: -21.4788511
  },
  {
    lng: -41.3953252,
    lat: -21.4788022
  },
  {
    lng: -41.3953508,
    lat: -21.4787821
  },
  {
    lng: -41.3954125,
    lat: -21.4787204
  },
  {
    lng: -41.3954395,
    lat: -21.4786846
  },
  {
    lng: -41.3954815,
    lat: -21.4786217
  },
  {
    lng: -41.3955112,
    lat: -21.4785546
  },
  {
    lng: -41.3955271,
    lat: -21.4784663
  },
  {
    lng: -41.3955264,
    lat: -21.4783995
  },
  {
    lng: -41.3955031,
    lat: -21.4783428
  },
  {
    lng: -41.3954752,
    lat: -21.4782833
  },
  {
    lng: -41.3954488,
    lat: -21.4782309
  },
  {
    lng: -41.3954378,
    lat: -21.4781841
  },
  {
    lng: -41.3954493,
    lat: -21.4781243
  },
  {
    lng: -41.3954733,
    lat: -21.4780914
  },
  {
    lng: -41.3955234,
    lat: -21.4780838
  },
  {
    lng: -41.3956528,
    lat: -21.4781169
  },
  {
    lng: -41.3957073,
    lat: -21.4780965
  },
  {
    lng: -41.395774,
    lat: -21.4780789
  },
  {
    lng: -41.3958391,
    lat: -21.478057
  },
  {
    lng: -41.3958828,
    lat: -21.4780248
  },
  {
    lng: -41.3958843,
    lat: -21.4780236
  },
  {
    lng: -41.3958859,
    lat: -21.4780225
  },
  {
    lng: -41.3959398,
    lat: -21.4779367
  },
  {
    lng: -41.3959467,
    lat: -21.4778726
  },
  {
    lng: -41.3959005,
    lat: -21.4778019
  },
  {
    lng: -41.3958774,
    lat: -21.4777737
  },
  {
    lng: -41.3958252,
    lat: -21.4777158
  },
  {
    lng: -41.3957747,
    lat: -21.4776736
  },
  {
    lng: -41.3957392,
    lat: -21.4776198
  },
  {
    lng: -41.3957356,
    lat: -21.4775602
  },
  {
    lng: -41.3957563,
    lat: -21.4774974
  },
  {
    lng: -41.395786,
    lat: -21.4774246
  },
  {
    lng: -41.3957994,
    lat: -21.4773961
  },
  {
    lng: -41.3958154,
    lat: -21.4773291
  },
  {
    lng: -41.3958164,
    lat: -21.4772708
  },
  {
    lng: -41.3958006,
    lat: -21.4772069
  },
  {
    lng: -41.3957664,
    lat: -21.4771333
  },
  {
    lng: -41.39574,
    lat: -21.4770695
  },
  {
    lng: -41.3957378,
    lat: -21.4770013
  },
  {
    lng: -41.3957511,
    lat: -21.4769628
  },
  {
    lng: -41.3957691,
    lat: -21.4769399
  },
  {
    lng: -41.3958417,
    lat: -21.4769051
  },
  {
    lng: -41.395893,
    lat: -21.4768692
  },
  {
    lng: -41.3959095,
    lat: -21.4768477
  },
  {
    lng: -41.3959165,
    lat: -21.4767865
  },
  {
    lng: -41.3958888,
    lat: -21.476744
  },
  {
    lng: -41.3958596,
    lat: -21.476713
  },
  {
    lng: -41.3958304,
    lat: -21.4766763
  },
  {
    lng: -41.3958162,
    lat: -21.4766181
  },
  {
    lng: -41.3958184,
    lat: -21.4765313
  },
  {
    lng: -41.3958054,
    lat: -21.476449
  },
  {
    lng: -41.3957987,
    lat: -21.4763808
  },
  {
    lng: -41.3957874,
    lat: -21.4763083
  },
  {
    lng: -41.3957758,
    lat: -21.476216
  },
  {
    lng: -41.3957914,
    lat: -21.476095
  },
  {
    lng: -41.3958053,
    lat: -21.4759598
  },
  {
    lng: -41.3958458,
    lat: -21.4759125
  },
  {
    lng: -41.3959092,
    lat: -21.4758608
  },
  {
    lng: -41.3959651,
    lat: -21.4758362
  },
  {
    lng: -41.3960212,
    lat: -21.4758257
  },
  {
    lng: -41.3960607,
    lat: -21.4758197
  },
  {
    lng: -41.3960932,
    lat: -21.4758002
  },
  {
    lng: -41.3961256,
    lat: -21.4757808
  },
  {
    lng: -41.396142,
    lat: -21.4757437
  },
  {
    lng: -41.3961352,
    lat: -21.4756698
  },
  {
    lng: -41.396121,
    lat: -21.4756201
  },
  {
    lng: -41.3960959,
    lat: -21.4755364
  },
  {
    lng: -41.3960908,
    lat: -21.4754739
  },
  {
    lng: -41.396122,
    lat: -21.475404
  },
  {
    lng: -41.3961702,
    lat: -21.4753595
  },
  {
    lng: -41.3962186,
    lat: -21.4753335
  },
  {
    lng: -41.3962716,
    lat: -21.475316
  },
  {
    lng: -41.3963534,
    lat: -21.4752996
  },
  {
    lng: -41.3964157,
    lat: -21.4752934
  },
  {
    lng: -41.3964945,
    lat: -21.4752757
  },
  {
    lng: -41.3965224,
    lat: -21.4752506
  },
  {
    lng: -41.3965502,
    lat: -21.4752255
  },
  {
    lng: -41.3966194,
    lat: -21.4751467
  },
  {
    lng: -41.3966661,
    lat: -21.4751064
  },
  {
    lng: -41.3967097,
    lat: -21.4750634
  },
  {
    lng: -41.3967546,
    lat: -21.4749891
  },
  {
    lng: -41.3967811,
    lat: -21.4749064
  },
  {
    lng: -41.3968043,
    lat: -21.4747853
  },
  {
    lng: -41.3968157,
    lat: -21.4747084
  },
  {
    lng: -41.3968344,
    lat: -21.4746045
  },
  {
    lng: -41.3968686,
    lat: -21.4745288
  },
  {
    lng: -41.3969,
    lat: -21.4744731
  },
  {
    lng: -41.396933,
    lat: -21.4744316
  },
  {
    lng: -41.3969533,
    lat: -21.4744115
  },
  {
    lng: -41.3969635,
    lat: -21.4744015
  },
  {
    lng: -41.3969737,
    lat: -21.4743914
  },
  {
    lng: -41.3970233,
    lat: -21.4743384
  },
  {
    lng: -41.3970591,
    lat: -21.4742727
  },
  {
    lng: -41.397095,
    lat: -21.4742141
  },
  {
    lng: -41.3971659,
    lat: -21.474158
  },
  {
    lng: -41.3972234,
    lat: -21.4741319
  },
  {
    lng: -41.3973036,
    lat: -21.4741014
  },
  {
    lng: -41.3973415,
    lat: -21.474094
  },
  {
    lng: -41.3973974,
    lat: -21.4740665
  },
  {
    lng: -41.3974352,
    lat: -21.4740406
  },
  {
    lng: -41.3975061,
    lat: -21.4739888
  },
  {
    lng: -41.3976302,
    lat: -21.473938
  },
  {
    lng: -41.3977937,
    lat: -21.4738854
  },
  {
    lng: -41.3978819,
    lat: -21.4738601
  },
  {
    lng: -41.3979474,
    lat: -21.4738233
  },
  {
    lng: -41.3980022,
    lat: -21.4737737
  },
  {
    lng: -41.3980222,
    lat: -21.4737268
  },
  {
    lng: -41.3980177,
    lat: -21.473687
  },
  {
    lng: -41.3980088,
    lat: -21.4736514
  },
  {
    lng: -41.397974,
    lat: -21.4735987
  },
  {
    lng: -41.3979575,
    lat: -21.4735475
  },
  {
    lng: -41.3979471,
    lat: -21.4734749
  },
  {
    lng: -41.397964,
    lat: -21.4734309
  },
  {
    lng: -41.397999,
    lat: -21.4733997
  },
  {
    lng: -41.3980507,
    lat: -21.4733857
  },
  {
    lng: -41.3981465,
    lat: -21.4733703
  },
  {
    lng: -41.3982756,
    lat: -21.4733807
  },
  {
    lng: -41.3983682,
    lat: -21.4733795
  },
  {
    lng: -41.3984656,
    lat: -21.4733386
  },
  {
    lng: -41.3984885,
    lat: -21.4732989
  },
  {
    lng: -41.3984872,
    lat: -21.4732377
  },
  {
    lng: -41.3984661,
    lat: -21.4731936
  },
  {
    lng: -41.3984359,
    lat: -21.4731508
  },
  {
    lng: -41.398392,
    lat: -21.4730938
  },
  {
    lng: -41.3983725,
    lat: -21.4730312
  },
  {
    lng: -41.3983803,
    lat: -21.47298
  },
  {
    lng: -41.3984093,
    lat: -21.4729417
  },
  {
    lng: -41.3984824,
    lat: -21.4728879
  },
  {
    lng: -41.3985767,
    lat: -21.4728541
  },
  {
    lng: -41.398636,
    lat: -21.4728315
  },
  {
    lng: -41.3986863,
    lat: -21.472789
  },
  {
    lng: -41.3987336,
    lat: -21.4727379
  },
  {
    lng: -41.3987367,
    lat: -21.4727081
  },
  {
    lng: -41.3987292,
    lat: -21.4726853
  },
  {
    lng: -41.3986655,
    lat: -21.4726666
  },
  {
    lng: -41.3986002,
    lat: -21.4726707
  },
  {
    lng: -41.3985348,
    lat: -21.4726947
  },
  {
    lng: -41.3984633,
    lat: -21.4727215
  },
  {
    lng: -41.3983812,
    lat: -21.4727383
  },
  {
    lng: -41.3983053,
    lat: -21.4727181
  },
  {
    lng: -41.398237,
    lat: -21.4726824
  },
  {
    lng: -41.3981916,
    lat: -21.4726367
  },
  {
    lng: -41.39816,
    lat: -21.4725741
  },
  {
    lng: -41.398151,
    lat: -21.4725214
  },
  {
    lng: -41.3981542,
    lat: -21.4724773
  },
  {
    lng: -41.3981696,
    lat: -21.4724248
  },
  {
    lng: -41.3982122,
    lat: -21.4723922
  },
  {
    lng: -41.3982625,
    lat: -21.4723682
  },
  {
    lng: -41.3983354,
    lat: -21.4723656
  },
  {
    lng: -41.3983992,
    lat: -21.4723644
  },
  {
    lng: -41.3984631,
    lat: -21.4723432
  },
  {
    lng: -41.3985422,
    lat: -21.4723207
  },
  {
    lng: -41.3986136,
    lat: -21.4722953
  },
  {
    lng: -41.3986881,
    lat: -21.4722799
  },
  {
    lng: -41.3988036,
    lat: -21.4722647
  },
  {
    lng: -41.3988584,
    lat: -21.4722478
  },
  {
    lng: -41.398901,
    lat: -21.4722223
  },
  {
    lng: -41.3989179,
    lat: -21.4721825
  },
  {
    lng: -41.3988937,
    lat: -21.4721327
  },
  {
    lng: -41.3988361,
    lat: -21.4721226
  },
  {
    lng: -41.3987555,
    lat: -21.4721323
  },
  {
    lng: -41.3986551,
    lat: -21.4721632
  },
  {
    lng: -41.3985199,
    lat: -21.4721856
  },
  {
    lng: -41.398485,
    lat: -21.472167
  },
  {
    lng: -41.3984472,
    lat: -21.4721213
  },
  {
    lng: -41.3984351,
    lat: -21.4720815
  },
  {
    lng: -41.3984292,
    lat: -21.4720388
  },
  {
    lng: -41.3984476,
    lat: -21.4720119
  },
  {
    lng: -41.3985114,
    lat: -21.4719879
  },
  {
    lng: -41.3985767,
    lat: -21.4719952
  },
  {
    lng: -41.3986512,
    lat: -21.4719812
  },
  {
    lng: -41.3986938,
    lat: -21.4719586
  },
  {
    lng: -41.3987441,
    lat: -21.471926
  },
  {
    lng: -41.3987958,
    lat: -21.4719134
  },
  {
    lng: -41.3988536,
    lat: -21.4718837
  },
  {
    lng: -41.3988735,
    lat: -21.4718511
  },
  {
    lng: -41.3988781,
    lat: -21.4718355
  },
  {
    lng: -41.3988797,
    lat: -21.4717999
  },
  {
    lng: -41.3989241,
    lat: -21.4717162
  },
  {
    lng: -41.3989712,
    lat: -21.4717135
  },
  {
    lng: -41.3990334,
    lat: -21.4717435
  },
  {
    lng: -41.3990516,
    lat: -21.4717493
  },
  {
    lng: -41.3991078,
    lat: -21.471748
  },
  {
    lng: -41.3991518,
    lat: -21.4717553
  },
  {
    lng: -41.3992168,
    lat: -21.4718408
  },
  {
    lng: -41.3992773,
    lat: -21.4719348
  },
  {
    lng: -41.399368,
    lat: -21.4720489
  },
  {
    lng: -41.3994316,
    lat: -21.4721159
  },
  {
    lng: -41.3995104,
    lat: -21.4721588
  },
  {
    lng: -41.3995894,
    lat: -21.4721747
  },
  {
    lng: -41.3996654,
    lat: -21.4721578
  },
  {
    lng: -41.3997156,
    lat: -21.472131
  },
  {
    lng: -41.3997553,
    lat: -21.4720771
  },
  {
    lng: -41.3997813,
    lat: -21.4720146
  },
  {
    lng: -41.3998091,
    lat: -21.4718867
  },
  {
    lng: -41.399829,
    lat: -21.4718441
  },
  {
    lng: -41.3998595,
    lat: -21.47182
  },
  {
    lng: -41.3999021,
    lat: -21.471813
  },
  {
    lng: -41.3999385,
    lat: -21.4718203
  },
  {
    lng: -41.3999748,
    lat: -21.4718659
  },
  {
    lng: -41.3999806,
    lat: -21.4719342
  },
  {
    lng: -41.4000093,
    lat: -21.4719797
  },
  {
    lng: -41.4000686,
    lat: -21.4719814
  },
  {
    lng: -41.4001203,
    lat: -21.4719687
  },
  {
    lng: -41.4001721,
    lat: -21.4719234
  },
  {
    lng: -41.4002301,
    lat: -21.4718525
  },
  {
    lng: -41.4002851,
    lat: -21.4717517
  },
  {
    lng: -41.4003067,
    lat: -21.4716622
  },
  {
    lng: -41.4003115,
    lat: -21.4715811
  },
  {
    lng: -41.4003227,
    lat: -21.4714461
  },
  {
    lng: -41.4003688,
    lat: -21.4712983
  },
  {
    lng: -41.400404,
    lat: -21.4712245
  },
  {
    lng: -41.400471,
    lat: -21.4711593
  },
  {
    lng: -41.4005305,
    lat: -21.4711083
  },
  {
    lng: -41.400596,
    lat: -21.4710488
  },
  {
    lng: -41.4006433,
    lat: -21.4709821
  },
  {
    lng: -41.400685,
    lat: -21.4707988
  },
  {
    lng: -41.4006841,
    lat: -21.4706182
  },
  {
    lng: -41.4007391,
    lat: -21.4705373
  },
  {
    lng: -41.4007893,
    lat: -21.4705204
  },
  {
    lng: -41.4008744,
    lat: -21.4705107
  },
  {
    lng: -41.400964,
    lat: -21.4705209
  },
  {
    lng: -41.4010389,
    lat: -21.4705116
  },
  {
    lng: -41.4010415,
    lat: -21.4705112
  },
  {
    lng: -41.4010933,
    lat: -21.4704545
  },
  {
    lng: -41.4011057,
    lat: -21.4703991
  },
  {
    lng: -41.4011166,
    lat: -21.470311
  },
  {
    lng: -41.4011307,
    lat: -21.4701973
  },
  {
    lng: -41.4011583,
    lat: -21.4701149
  },
  {
    lng: -41.401198,
    lat: -21.470061
  },
  {
    lng: -41.4012574,
    lat: -21.4700284
  },
  {
    lng: -41.4013395,
    lat: -21.4700145
  },
  {
    lng: -41.401505,
    lat: -21.4700164
  },
  {
    lng: -41.4017723,
    lat: -21.4700457
  },
  {
    lng: -41.4018391,
    lat: -21.4700558
  },
  {
    lng: -41.4018938,
    lat: -21.4700503
  },
  {
    lng: -41.4019714,
    lat: -21.4700122
  },
  {
    lng: -41.402028,
    lat: -21.4699142
  },
  {
    lng: -41.4020696,
    lat: -21.469748
  },
  {
    lng: -41.4021371,
    lat: -21.4695662
  },
  {
    lng: -41.402192,
    lat: -21.4694881
  },
  {
    lng: -41.4022484,
    lat: -21.4694556
  },
  {
    lng: -41.402294,
    lat: -21.4694401
  },
  {
    lng: -41.4023547,
    lat: -21.4694417
  },
  {
    lng: -41.4024458,
    lat: -21.4694576
  },
  {
    lng: -41.4025551,
    lat: -21.4694907
  },
  {
    lng: -41.402663,
    lat: -21.4694825
  },
  {
    lng: -41.402698,
    lat: -21.4694556
  },
  {
    lng: -41.4027316,
    lat: -21.4694045
  },
  {
    lng: -41.4027639,
    lat: -21.4693079
  },
  {
    lng: -41.4027854,
    lat: -21.4692298
  },
  {
    lng: -41.4028329,
    lat: -21.4691247
  },
  {
    lng: -41.4028924,
    lat: -21.4690452
  },
  {
    lng: -41.4030022,
    lat: -21.468929
  },
  {
    lng: -41.4030495,
    lat: -21.4688538
  },
  {
    lng: -41.4031089,
    lat: -21.4688084
  },
  {
    lng: -41.4031957,
    lat: -21.4687703
  },
  {
    lng: -41.4032793,
    lat: -21.4687507
  },
  {
    lng: -41.4033659,
    lat: -21.4687296
  },
  {
    lng: -41.4034208,
    lat: -21.4686786
  },
  {
    lng: -41.4034605,
    lat: -21.4686147
  },
  {
    lng: -41.403476,
    lat: -21.4685494
  },
  {
    lng: -41.4035115,
    lat: -21.4683845
  },
  {
    lng: -41.4035406,
    lat: -21.4683149
  },
  {
    lng: -41.4035772,
    lat: -21.4682667
  },
  {
    lng: -41.403629,
    lat: -21.4682214
  },
  {
    lng: -41.4037051,
    lat: -21.468196
  },
  {
    lng: -41.4037537,
    lat: -21.4681919
  },
  {
    lng: -41.4038448,
    lat: -21.4681993
  },
  {
    lng: -41.4039603,
    lat: -21.4681897
  },
  {
    lng: -41.404047,
    lat: -21.4681516
  },
  {
    lng: -41.4041202,
    lat: -21.4680864
  },
  {
    lng: -41.4041461,
    lat: -21.4680424
  },
  {
    lng: -41.4041585,
    lat: -21.4679969
  },
  {
    lng: -41.4041647,
    lat: -21.4679443
  },
  {
    lng: -41.4041771,
    lat: -21.4678818
  },
  {
    lng: -41.4041955,
    lat: -21.4678406
  },
  {
    lng: -41.4042442,
    lat: -21.4677981
  },
  {
    lng: -41.4043005,
    lat: -21.4677741
  },
  {
    lng: -41.4043644,
    lat: -21.4677629
  },
  {
    lng: -41.4044448,
    lat: -21.4677745
  },
  {
    lng: -41.4045055,
    lat: -21.4677889
  },
  {
    lng: -41.4045616,
    lat: -21.4678275
  },
  {
    lng: -41.40463,
    lat: -21.4678249
  },
  {
    lng: -41.4047715,
    lat: -21.4677528
  },
  {
    lng: -41.4049191,
    lat: -21.4676807
  },
  {
    lng: -41.40498,
    lat: -21.467644
  },
  {
    lng: -41.405044,
    lat: -21.4675873
  },
  {
    lng: -41.4050837,
    lat: -21.467522
  },
  {
    lng: -41.4051174,
    lat: -21.4674453
  },
  {
    lng: -41.4051557,
    lat: -21.4673644
  },
  {
    lng: -41.4052062,
    lat: -21.4672693
  },
  {
    lng: -41.405252,
    lat: -21.4671827
  },
  {
    lng: -41.4053039,
    lat: -21.4671075
  },
  {
    lng: -41.4053542,
    lat: -21.4670721
  },
  {
    lng: -41.4054166,
    lat: -21.4670452
  },
  {
    lng: -41.4054774,
    lat: -21.4670269
  },
  {
    lng: -41.4056127,
    lat: -21.4669946
  },
  {
    lng: -41.4056615,
    lat: -21.4669507
  },
  {
    lng: -41.4056859,
    lat: -21.4669167
  },
  {
    lng: -41.405715,
    lat: -21.4668442
  },
  {
    lng: -41.40577,
    lat: -21.4667705
  },
  {
    lng: -41.4058188,
    lat: -21.4667152
  },
  {
    lng: -41.4058766,
    lat: -21.4666883
  },
  {
    lng: -41.4059616,
    lat: -21.4667042
  },
  {
    lng: -41.4059797,
    lat: -21.4667412
  },
  {
    lng: -41.4059871,
    lat: -21.4667981
  },
  {
    lng: -41.4059762,
    lat: -21.4668649
  },
  {
    lng: -41.4059956,
    lat: -21.4669617
  },
  {
    lng: -41.406044,
    lat: -21.4670216
  },
  {
    lng: -41.4061411,
    lat: -21.4670674
  },
  {
    lng: -41.4062201,
    lat: -21.4670747
  },
  {
    lng: -41.4063295,
    lat: -21.467058
  },
  {
    lng: -41.4063721,
    lat: -21.4670411
  },
  {
    lng: -41.4064436,
    lat: -21.4669944
  },
  {
    lng: -41.4065472,
    lat: -21.4669193
  },
  {
    lng: -41.4066356,
    lat: -21.4668485
  },
  {
    lng: -41.4067132,
    lat: -21.4667961
  },
  {
    lng: -41.4068212,
    lat: -21.4667495
  },
  {
    lng: -41.4069595,
    lat: -21.4667286
  },
  {
    lng: -41.4070613,
    lat: -21.4667303
  },
  {
    lng: -41.4071478,
    lat: -21.4667505
  },
  {
    lng: -41.4072403,
    lat: -21.4668091
  },
  {
    lng: -41.4072993,
    lat: -21.4668761
  },
  {
    lng: -41.4073553,
    lat: -21.4669417
  },
  {
    lng: -41.4074537,
    lat: -21.4670401
  },
  {
    lng: -41.4075158,
    lat: -21.467083
  },
  {
    lng: -41.4076008,
    lat: -21.4671159
  },
  {
    lng: -41.4076949,
    lat: -21.467129
  },
  {
    lng: -41.4077798,
    lat: -21.4671719
  },
  {
    lng: -41.407807,
    lat: -21.4672118
  },
  {
    lng: -41.4078341,
    lat: -21.4672844
  },
  {
    lng: -41.4078445,
    lat: -21.4673456
  },
  {
    lng: -41.4078579,
    lat: -21.4674253
  },
  {
    lng: -41.4078728,
    lat: -21.4675178
  },
  {
    lng: -41.4079015,
    lat: -21.467552
  },
  {
    lng: -41.4079562,
    lat: -21.4675464
  },
  {
    lng: -41.4079852,
    lat: -21.4675153
  },
  {
    lng: -41.4080355,
    lat: -21.4674813
  },
  {
    lng: -41.4081389,
    lat: -21.4674418
  },
  {
    lng: -41.4082256,
    lat: -21.4674179
  },
  {
    lng: -41.4082893,
    lat: -21.4674252
  },
  {
    lng: -41.4083652,
    lat: -21.4674624
  },
  {
    lng: -41.4084364,
    lat: -21.4674996
  },
  {
    lng: -41.4084819,
    lat: -21.4675338
  },
  {
    lng: -41.4085472,
    lat: -21.4675497
  },
  {
    lng: -41.4086444,
    lat: -21.46754
  },
  {
    lng: -41.4087752,
    lat: -21.4674963
  },
  {
    lng: -41.4089775,
    lat: -21.4674088
  },
  {
    lng: -41.4091114,
    lat: -21.4673523
  },
  {
    lng: -41.4092135,
    lat: -21.4672702
  },
  {
    lng: -41.4093263,
    lat: -21.4671525
  },
  {
    lng: -41.4093721,
    lat: -21.4670773
  },
  {
    lng: -41.4093987,
    lat: -21.4668754
  },
  {
    lng: -41.4094738,
    lat: -21.4666666
  },
  {
    lng: -41.4095686,
    lat: -21.466492
  },
  {
    lng: -41.4096647,
    lat: -21.4663942
  },
  {
    lng: -41.4097363,
    lat: -21.4663333
  },
  {
    lng: -41.4098382,
    lat: -21.466281
  },
  {
    lng: -41.4100101,
    lat: -21.4662204
  },
  {
    lng: -41.410159,
    lat: -21.4662251
  },
  {
    lng: -41.4102546,
    lat: -21.466241
  },
  {
    lng: -41.4103319,
    lat: -21.4662825
  },
  {
    lng: -41.4104184,
    lat: -21.4663126
  },
  {
    lng: -41.410508,
    lat: -21.4663285
  },
  {
    lng: -41.4105992,
    lat: -21.4663203
  },
  {
    lng: -41.4107892,
    lat: -21.4662725
  },
  {
    lng: -41.4109245,
    lat: -21.4662317
  },
  {
    lng: -41.410993,
    lat: -21.4661978
  },
  {
    lng: -41.4110586,
    lat: -21.4661368
  },
  {
    lng: -41.4111196,
    lat: -21.4660545
  },
  {
    lng: -41.4111761,
    lat: -21.4659623
  },
  {
    lng: -41.4112192,
    lat: -21.465816
  },
  {
    lng: -41.411259,
    lat: -21.4657165
  },
  {
    lng: -41.4113003,
    lat: -21.4656356
  },
  {
    lng: -41.4113688,
    lat: -21.4655875
  },
  {
    lng: -41.4115011,
    lat: -21.4655637
  },
  {
    lng: -41.4117305,
    lat: -21.4655587
  },
  {
    lng: -41.4119355,
    lat: -21.4655807
  },
  {
    lng: -41.4120859,
    lat: -21.4655598
  },
  {
    lng: -41.4121605,
    lat: -21.4655245
  },
  {
    lng: -41.4122138,
    lat: -21.465482
  },
  {
    lng: -41.4122993,
    lat: -21.46535
  },
  {
    lng: -41.4123802,
    lat: -21.465255
  },
  {
    lng: -41.4124365,
    lat: -21.4652167
  },
  {
    lng: -41.412546,
    lat: -21.4651858
  },
  {
    lng: -41.4126463,
    lat: -21.4651619
  },
  {
    lng: -41.4127194,
    lat: -21.4651238
  },
  {
    lng: -41.4127621,
    lat: -21.4650784
  },
  {
    lng: -41.4127881,
    lat: -21.465023
  },
  {
    lng: -41.4127913,
    lat: -21.4649576
  },
  {
    lng: -41.4127763,
    lat: -21.4649092
  },
  {
    lng: -41.412734,
    lat: -21.4648508
  },
  {
    lng: -41.4126764,
    lat: -21.4648122
  },
  {
    lng: -41.4126005,
    lat: -21.4647949
  },
  {
    lng: -41.4124897,
    lat: -21.4647562
  },
  {
    lng: -41.4124474,
    lat: -21.4646978
  },
  {
    lng: -41.4124219,
    lat: -21.4646209
  },
  {
    lng: -41.4124222,
    lat: -21.4645157
  },
  {
    lng: -41.4124576,
    lat: -21.4643992
  },
  {
    lng: -41.4125066,
    lat: -21.4642742
  },
  {
    lng: -41.4126103,
    lat: -21.4641707
  },
  {
    lng: -41.4127276,
    lat: -21.4640587
  },
  {
    lng: -41.4128525,
    lat: -21.4639752
  },
  {
    lng: -41.4129667,
    lat: -21.463886
  },
  {
    lng: -41.4130124,
    lat: -21.4638364
  },
  {
    lng: -41.4130445,
    lat: -21.4637867
  },
  {
    lng: -41.4130538,
    lat: -21.4637313
  },
  {
    lng: -41.4130628,
    lat: -21.4636831
  },
  {
    lng: -41.4130647,
    lat: -21.463673
  },
  {
    lng: -41.4130998,
    lat: -21.4636205
  },
  {
    lng: -41.4131181,
    lat: -21.463585
  },
  {
    lng: -41.4131442,
    lat: -21.4635268
  },
  {
    lng: -41.4131656,
    lat: -21.4634828
  },
  {
    lng: -41.4132189,
    lat: -21.4634275
  },
  {
    lng: -41.413286,
    lat: -21.463368
  },
  {
    lng: -41.4133378,
    lat: -21.4633155
  },
  {
    lng: -41.4134308,
    lat: -21.4632063
  },
  {
    lng: -41.4134462,
    lat: -21.4631637
  },
  {
    lng: -41.4134401,
    lat: -21.4631416
  },
  {
    lng: -41.4134312,
    lat: -21.4631096
  },
  {
    lng: -41.4134024,
    lat: -21.4630811
  },
  {
    lng: -41.4133341,
    lat: -21.4630709
  },
  {
    lng: -41.4132475,
    lat: -21.463082
  },
  {
    lng: -41.4131866,
    lat: -21.4631046
  },
  {
    lng: -41.4131197,
    lat: -21.4631442
  },
  {
    lng: -41.4130435,
    lat: -21.4632108
  },
  {
    lng: -41.4129385,
    lat: -21.4632588
  },
  {
    lng: -41.4128687,
    lat: -21.4632472
  },
  {
    lng: -41.4128475,
    lat: -21.4632216
  },
  {
    lng: -41.4128415,
    lat: -21.4631818
  },
  {
    lng: -41.4128509,
    lat: -21.463105
  },
  {
    lng: -41.4128771,
    lat: -21.4630013
  },
  {
    lng: -41.4129553,
    lat: -21.4627811
  },
  {
    lng: -41.4130348,
    lat: -21.462632
  },
  {
    lng: -41.413073,
    lat: -21.4625923
  },
  {
    lng: -41.4131431,
    lat: -21.46253
  },
  {
    lng: -41.4131858,
    lat: -21.4624676
  },
  {
    lng: -41.4132043,
    lat: -21.4623866
  },
  {
    lng: -41.4131955,
    lat: -21.4623126
  },
  {
    lng: -41.413176,
    lat: -21.4622414
  },
  {
    lng: -41.4131397,
    lat: -21.4621759
  },
  {
    lng: -41.4131329,
    lat: -21.4621669
  },
  {
    lng: -41.4130823,
    lat: -21.4621004
  },
  {
    lng: -41.4129261,
    lat: -21.4620288
  },
  {
    lng: -41.4127075,
    lat: -21.4619755
  },
  {
    lng: -41.4125162,
    lat: -21.4619465
  },
  {
    lng: -41.4123462,
    lat: -21.4619104
  },
  {
    lng: -41.4122658,
    lat: -21.4618704
  },
  {
    lng: -41.4122023,
    lat: -21.4617948
  },
  {
    lng: -41.4121676,
    lat: -21.4617208
  },
  {
    lng: -41.4121331,
    lat: -21.4615913
  },
  {
    lng: -41.4120731,
    lat: -21.4613892
  },
  {
    lng: -41.4119944,
    lat: -21.461288
  },
  {
    lng: -41.4119308,
    lat: -21.4612437
  },
  {
    lng: -41.4118718,
    lat: -21.4611781
  },
  {
    lng: -41.4118492,
    lat: -21.4611041
  },
  {
    lng: -41.4118648,
    lat: -21.4609904
  },
  {
    lng: -41.4118696,
    lat: -21.4609179
  },
  {
    lng: -41.4119063,
    lat: -21.4608455
  },
  {
    lng: -41.4119582,
    lat: -21.4607802
  },
  {
    lng: -41.4120086,
    lat: -21.4607036
  },
  {
    lng: -41.4120377,
    lat: -21.4606283
  },
  {
    lng: -41.412073,
    lat: -21.4605403
  },
  {
    lng: -41.4120762,
    lat: -21.460482
  },
  {
    lng: -41.4120566,
    lat: -21.4604336
  },
  {
    lng: -41.4120173,
    lat: -21.4603794
  },
  {
    lng: -41.4119719,
    lat: -21.4603309
  },
  {
    lng: -41.4118977,
    lat: -21.4602667
  },
  {
    lng: -41.4118387,
    lat: -21.4602154
  },
  {
    lng: -41.4118009,
    lat: -21.4601555
  },
  {
    lng: -41.4117571,
    lat: -21.4600871
  },
  {
    lng: -41.4117328,
    lat: -21.46007
  },
  {
    lng: -41.4116205,
    lat: -21.4600398
  },
  {
    lng: -41.4115249,
    lat: -21.4600281
  },
  {
    lng: -41.411408,
    lat: -21.4600121
  },
  {
    lng: -41.4113245,
    lat: -21.4599863
  },
  {
    lng: -41.4112669,
    lat: -21.459952
  },
  {
    lng: -41.4112139,
    lat: -21.4599006
  },
  {
    lng: -41.4111883,
    lat: -21.4598551
  },
  {
    lng: -41.4111732,
    lat: -21.4598195
  },
  {
    lng: -41.4111657,
    lat: -21.4597768
  },
  {
    lng: -41.4111659,
    lat: -21.4597185
  },
  {
    lng: -41.4111829,
    lat: -21.4596574
  },
  {
    lng: -41.4112393,
    lat: -21.4595964
  },
  {
    lng: -41.4112819,
    lat: -21.4595695
  },
  {
    lng: -41.411437,
    lat: -21.4595288
  },
  {
    lng: -41.4115146,
    lat: -21.4594991
  },
  {
    lng: -41.4115754,
    lat: -21.4594695
  },
  {
    lng: -41.4116651,
    lat: -21.4594456
  },
  {
    lng: -41.4117609,
    lat: -21.4594331
  },
  {
    lng: -41.4118415,
    lat: -21.4594034
  },
  {
    lng: -41.4118978,
    lat: -21.4593581
  },
  {
    lng: -41.4119375,
    lat: -21.459317
  },
  {
    lng: -41.4119953,
    lat: -21.4592759
  },
  {
    lng: -41.4121944,
    lat: -21.4592609
  },
  {
    lng: -41.4122702,
    lat: -21.4592924
  },
  {
    lng: -41.412311,
    lat: -21.4593523
  },
  {
    lng: -41.4123502,
    lat: -21.459432
  },
  {
    lng: -41.4124077,
    lat: -21.4594947
  },
  {
    lng: -41.412473,
    lat: -21.4595191
  },
  {
    lng: -41.4125185,
    lat: -21.4595193
  },
  {
    lng: -41.4125824,
    lat: -21.4594896
  },
  {
    lng: -41.4126571,
    lat: -21.4594287
  },
  {
    lng: -41.4127424,
    lat: -21.4593493
  },
  {
    lng: -41.4128124,
    lat: -21.4593154
  },
  {
    lng: -41.4129007,
    lat: -21.4592716
  },
  {
    lng: -41.4129343,
    lat: -21.4592248
  },
  {
    lng: -41.4129451,
    lat: -21.4591551
  },
  {
    lng: -41.4128909,
    lat: -21.4590241
  },
  {
    lng: -41.4128456,
    lat: -21.458933
  },
  {
    lng: -41.4127959,
    lat: -21.4588942
  },
  {
    lng: -41.4127365,
    lat: -21.4589053
  },
  {
    lng: -41.4126926,
    lat: -21.4588809
  },
  {
    lng: -41.412676,
    lat: -21.4588623
  },
  {
    lng: -41.4126657,
    lat: -21.4588068
  },
  {
    lng: -41.4126358,
    lat: -21.4587199
  },
  {
    lng: -41.4125559,
    lat: -21.458627
  },
  {
    lng: -41.4123817,
    lat: -21.4585422
  },
  {
    lng: -41.4122863,
    lat: -21.4584962
  },
  {
    lng: -41.4122577,
    lat: -21.4584534
  },
  {
    lng: -41.4122551,
    lat: -21.4583794
  },
  {
    lng: -41.4123027,
    lat: -21.4583043
  },
  {
    lng: -41.4123592,
    lat: -21.4582406
  },
  {
    lng: -41.41237,
    lat: -21.4582137
  },
  {
    lng: -41.4123873,
    lat: -21.4581284
  },
  {
    lng: -41.412421,
    lat: -21.458076
  },
  {
    lng: -41.412435,
    lat: -21.4580178
  },
  {
    lng: -41.4124217,
    lat: -21.4579594
  },
  {
    lng: -41.4124104,
    lat: -21.4579416
  },
  {
    lng: -41.4123809,
    lat: -21.4579121
  },
  {
    lng: -41.4123357,
    lat: -21.4578597
  },
  {
    lng: -41.4122488,
    lat: -21.4577416
  },
  {
    lng: -41.4121793,
    lat: -21.4576483
  },
  {
    lng: -41.4120978,
    lat: -21.457521
  },
  {
    lng: -41.4120493,
    lat: -21.4574234
  },
  {
    lng: -41.4120346,
    lat: -21.4573717
  },
  {
    lng: -41.4120339,
    lat: -21.4573293
  },
  {
    lng: -41.4120418,
    lat: -21.4572773
  },
  {
    lng: -41.4120572,
    lat: -21.4572147
  },
  {
    lng: -41.4120751,
    lat: -21.4570842
  },
  {
    lng: -41.4120722,
    lat: -21.4569853
  },
  {
    lng: -41.4120827,
    lat: -21.4569297
  },
  {
    lng: -41.4121358,
    lat: -21.4567905
  },
  {
    lng: -41.4121456,
    lat: -21.4566949
  },
  {
    lng: -41.4121483,
    lat: -21.4566301
  },
  {
    lng: -41.412141,
    lat: -21.4564808
  },
  {
    lng: -41.412172,
    lat: -21.4563561
  },
  {
    lng: -41.4121517,
    lat: -21.4562024
  },
  {
    lng: -41.4121338,
    lat: -21.4561512
  },
  {
    lng: -41.4121386,
    lat: -21.4561114
  },
  {
    lng: -41.4121661,
    lat: -21.4560745
  },
  {
    lng: -41.4122133,
    lat: -21.4560535
  },
  {
    lng: -41.4122454,
    lat: -21.4560309
  },
  {
    lng: -41.4122593,
    lat: -21.4559926
  },
  {
    lng: -41.4122964,
    lat: -21.4558875
  },
  {
    lng: -41.4123866,
    lat: -21.4557814
  },
  {
    lng: -41.4124858,
    lat: -21.4557179
  },
  {
    lng: -41.4126478,
    lat: -21.455572
  },
  {
    lng: -41.412795,
    lat: -21.4553266
  },
  {
    lng: -41.4128543,
    lat: -21.4552085
  },
  {
    lng: -41.4128878,
    lat: -21.4551107
  },
  {
    lng: -41.4128987,
    lat: -21.4550165
  },
  {
    lng: -41.4129114,
    lat: -21.4549465
  },
  {
    lng: -41.4129274,
    lat: -21.4548583
  },
  {
    lng: -41.4129453,
    lat: -21.4547832
  },
  {
    lng: -41.4130188,
    lat: -21.4547057
  },
  {
    lng: -41.4130977,
    lat: -21.4546221
  },
  {
    lng: -41.4131275,
    lat: -21.4545523
  },
  {
    lng: -41.4131397,
    lat: -21.45447
  },
  {
    lng: -41.4131271,
    lat: -21.4543799
  },
  {
    lng: -41.4131112,
    lat: -21.4543165
  },
  {
    lng: -41.4130716,
    lat: -21.4542407
  },
  {
    lng: -41.4130003,
    lat: -21.4541449
  },
  {
    lng: -41.4128939,
    lat: -21.4540401
  },
  {
    lng: -41.4127875,
    lat: -21.4539354
  },
  {
    lng: -41.4126994,
    lat: -21.453838
  },
  {
    lng: -41.4125873,
    lat: -21.4537142
  },
  {
    lng: -41.4125679,
    lat: -21.4536953
  },
  {
    lng: -41.4124741,
    lat: -21.4536036
  },
  {
    lng: -41.4123752,
    lat: -21.4535147
  },
  {
    lng: -41.412277,
    lat: -21.453469
  },
  {
    lng: -41.4121416,
    lat: -21.4534345
  },
  {
    lng: -41.4120322,
    lat: -21.4534026
  },
  {
    lng: -41.411955,
    lat: -21.4533475
  },
  {
    lng: -41.4119145,
    lat: -21.4532584
  },
  {
    lng: -41.4119068,
    lat: -21.4532104
  },
  {
    lng: -41.4119286,
    lat: -21.4531255
  },
  {
    lng: -41.4119519,
    lat: -21.4530621
  },
  {
    lng: -41.4120185,
    lat: -21.4529463
  },
  {
    lng: -41.4120797,
    lat: -21.4528397
  },
  {
    lng: -41.412136,
    lat: -21.4527695
  },
  {
    lng: -41.4122232,
    lat: -21.4526676
  },
  {
    lng: -41.4123955,
    lat: -21.4525519
  },
  {
    lng: -41.4125359,
    lat: -21.4524474
  },
  {
    lng: -41.4125895,
    lat: -21.4523866
  },
  {
    lng: -41.412643,
    lat: -21.4523257
  },
  {
    lng: -41.4128102,
    lat: -21.4520508
  },
  {
    lng: -41.4129646,
    lat: -21.4518286
  },
  {
    lng: -41.413014,
    lat: -21.4517575
  },
  {
    lng: -41.413098,
    lat: -21.4516797
  },
  {
    lng: -41.4131498,
    lat: -21.4516587
  },
  {
    lng: -41.4132167,
    lat: -21.4516491
  },
  {
    lng: -41.4132988,
    lat: -21.4516282
  },
  {
    lng: -41.4133341,
    lat: -21.4515814
  },
  {
    lng: -41.4133373,
    lat: -21.451553
  },
  {
    lng: -41.4133208,
    lat: -21.4515089
  },
  {
    lng: -41.4133044,
    lat: -21.4514618
  },
  {
    lng: -41.4132806,
    lat: -21.4513764
  },
  {
    lng: -41.4132705,
    lat: -21.4512882
  },
  {
    lng: -41.4132604,
    lat: -21.4511985
  },
  {
    lng: -41.4132288,
    lat: -21.4511543
  },
  {
    lng: -41.4131806,
    lat: -21.4510915
  },
  {
    lng: -41.4130385,
    lat: -21.4509841
  },
  {
    lng: -41.4129839,
    lat: -21.4509625
  },
  {
    lng: -41.412946,
    lat: -21.4509509
  },
  {
    lng: -41.412881,
    lat: -21.4509008
  },
  {
    lng: -41.4128538,
    lat: -21.450875
  },
  {
    lng: -41.4127721,
    lat: -21.4508177
  },
  {
    lng: -41.4127132,
    lat: -21.4507605
  },
  {
    lng: -41.4126756,
    lat: -21.4507106
  },
  {
    lng: -41.4126425,
    lat: -21.4506592
  },
  {
    lng: -41.4126122,
    lat: -21.4506377
  },
  {
    lng: -41.4125683,
    lat: -21.4506147
  },
  {
    lng: -41.4125351,
    lat: -21.4505889
  },
  {
    lng: -41.4125079,
    lat: -21.4505632
  },
  {
    lng: -41.4124474,
    lat: -21.4505216
  },
  {
    lng: -41.4123443,
    lat: -21.4504926
  },
  {
    lng: -41.4123017,
    lat: -21.450491
  },
  {
    lng: -41.4122623,
    lat: -21.4504865
  },
  {
    lng: -41.4122562,
    lat: -21.4504836
  },
  {
    lng: -41.4122396,
    lat: -21.4504594
  },
  {
    lng: -41.412243,
    lat: -21.4504111
  },
  {
    lng: -41.4122644,
    lat: -21.4503898
  },
  {
    lng: -41.4123086,
    lat: -21.4503588
  },
  {
    lng: -41.4123255,
    lat: -21.4503262
  },
  {
    lng: -41.4123075,
    lat: -21.4502877
  },
  {
    lng: -41.4122544,
    lat: -21.4502746
  },
  {
    lng: -41.4121998,
    lat: -21.4502672
  },
  {
    lng: -41.4121679,
    lat: -21.4502742
  },
  {
    lng: -41.4120583,
    lat: -21.4503034
  },
  {
    lng: -41.4120507,
    lat: -21.4503034
  },
  {
    lng: -41.412022,
    lat: -21.4502748
  },
  {
    lng: -41.4120132,
    lat: -21.4502236
  },
  {
    lng: -41.4120439,
    lat: -21.4501697
  },
  {
    lng: -41.4120897,
    lat: -21.4501315
  },
  {
    lng: -41.4121249,
    lat: -21.4500919
  },
  {
    lng: -41.4121146,
    lat: -21.4500449
  },
  {
    lng: -41.4120358,
    lat: -21.4500161
  },
  {
    lng: -41.4120009,
    lat: -21.4500002
  },
  {
    lng: -41.4119615,
    lat: -21.4499844
  },
  {
    lng: -41.4119479,
    lat: -21.4499801
  },
  {
    lng: -41.4118948,
    lat: -21.4499712
  },
  {
    lng: -41.411869,
    lat: -21.449964
  },
  {
    lng: -41.4118311,
    lat: -21.4499453
  },
  {
    lng: -41.4117949,
    lat: -21.4499167
  },
  {
    lng: -41.4117661,
    lat: -21.4498881
  },
  {
    lng: -41.4117632,
    lat: -21.4498852
  },
  {
    lng: -41.4117527,
    lat: -21.4498624
  },
  {
    lng: -41.4117392,
    lat: -21.4498367
  },
  {
    lng: -41.4117227,
    lat: -21.4497997
  },
  {
    lng: -41.4117032,
    lat: -21.4497498
  },
  {
    lng: -41.411658,
    lat: -21.4497012
  },
  {
    lng: -41.4116141,
    lat: -21.4496626
  },
  {
    lng: -41.4115854,
    lat: -21.4496369
  },
  {
    lng: -41.4115415,
    lat: -21.4496267
  },
  {
    lng: -41.4114549,
    lat: -21.4496205
  },
  {
    lng: -41.4113564,
    lat: -21.449583
  },
  {
    lng: -41.4113292,
    lat: -21.4495672
  },
  {
    lng: -41.4113035,
    lat: -21.4495443
  },
  {
    lng: -41.4112643,
    lat: -21.4495001
  },
  {
    lng: -41.4112448,
    lat: -21.4494502
  },
  {
    lng: -41.4112391,
    lat: -21.4493862
  },
  {
    lng: -41.4112408,
    lat: -21.4493592
  },
  {
    lng: -41.4112563,
    lat: -21.4493123
  },
  {
    lng: -41.4113327,
    lat: -21.4492331
  },
  {
    lng: -41.4114196,
    lat: -21.4491838
  },
  {
    lng: -41.4114775,
    lat: -21.4491542
  },
  {
    lng: -41.4115293,
    lat: -21.4491332
  },
  {
    lng: -41.4115963,
    lat: -21.4490937
  },
  {
    lng: -41.411607,
    lat: -21.4490824
  },
  {
    lng: -41.4116303,
    lat: -21.4489986
  },
  {
    lng: -41.4116688,
    lat: -21.4489178
  },
  {
    lng: -41.411698,
    lat: -21.4488568
  },
  {
    lng: -41.4117393,
    lat: -21.4488044
  },
  {
    lng: -41.4118567,
    lat: -21.4487396
  },
  {
    lng: -41.4119282,
    lat: -21.4487158
  },
  {
    lng: -41.4119693,
    lat: -21.4487047
  },
  {
    lng: -41.4120394,
    lat: -21.4486666
  },
  {
    lng: -41.4120456,
    lat: -21.4486496
  },
  {
    lng: -41.4120564,
    lat: -21.4486184
  },
  {
    lng: -41.412049,
    lat: -21.4485928
  },
  {
    lng: -41.412019,
    lat: -21.4485243
  },
  {
    lng: -41.4120041,
    lat: -21.4484844
  },
  {
    lng: -41.4119802,
    lat: -21.4484132
  },
  {
    lng: -41.4119788,
    lat: -21.4483876
  },
  {
    lng: -41.4119867,
    lat: -21.4483464
  },
  {
    lng: -41.4120203,
    lat: -21.4483082
  },
  {
    lng: -41.412104,
    lat: -21.4482774
  },
  {
    lng: -41.4121664,
    lat: -21.4482578
  },
  {
    lng: -41.4122424,
    lat: -21.4482525
  },
  {
    lng: -41.4123155,
    lat: -21.4482273
  },
  {
    lng: -41.4123292,
    lat: -21.4482188
  },
  {
    lng: -41.4123463,
    lat: -21.4481592
  },
  {
    lng: -41.4123391,
    lat: -21.4480923
  },
  {
    lng: -41.4122606,
    lat: -21.448018
  },
  {
    lng: -41.4121484,
    lat: -21.4479847
  },
  {
    lng: -41.4119101,
    lat: -21.4479521
  },
  {
    lng: -41.4118662,
    lat: -21.4479334
  },
  {
    lng: -41.4118542,
    lat: -21.4479021
  },
  {
    lng: -41.4118758,
    lat: -21.447841
  },
  {
    lng: -41.4119583,
    lat: -21.4477718
  },
  {
    lng: -41.4120712,
    lat: -21.4476828
  },
  {
    lng: -41.4122334,
    lat: -21.4474832
  },
  {
    lng: -41.4123267,
    lat: -21.4473841
  },
  {
    lng: -41.412391,
    lat: -21.447302
  },
  {
    lng: -41.4124552,
    lat: -21.4472369
  },
  {
    lng: -41.4125499,
    lat: -21.4471393
  },
  {
    lng: -41.412576,
    lat: -21.4471291
  },
  {
    lng: -41.4126717,
    lat: -21.4470916
  },
  {
    lng: -41.4127994,
    lat: -21.4470724
  },
  {
    lng: -41.4129254,
    lat: -21.4470816
  },
  {
    lng: -41.413056,
    lat: -21.4470866
  },
  {
    lng: -41.4132157,
    lat: -21.4470519
  },
  {
    lng: -41.4134273,
    lat: -21.4469748
  },
  {
    lng: -41.4135173,
    lat: -21.4469098
  },
  {
    lng: -41.4135298,
    lat: -21.4468601
  },
  {
    lng: -41.4135362,
    lat: -21.4468019
  },
  {
    lng: -41.4135017,
    lat: -21.4467249
  },
  {
    lng: -41.4134367,
    lat: -21.4466734
  },
  {
    lng: -41.4133624,
    lat: -21.4466531
  },
  {
    lng: -41.4132866,
    lat: -21.4466427
  },
  {
    lng: -41.4132168,
    lat: -21.446621
  },
  {
    lng: -41.4131852,
    lat: -21.4465825
  },
  {
    lng: -41.4131762,
    lat: -21.4465625
  },
  {
    lng: -41.4131704,
    lat: -21.446507
  },
  {
    lng: -41.4131951,
    lat: -21.4464375
  },
  {
    lng: -41.413229,
    lat: -21.4463637
  },
  {
    lng: -41.4132413,
    lat: -21.4463453
  },
  {
    lng: -41.4132796,
    lat: -21.4462872
  },
  {
    lng: -41.4132922,
    lat: -21.4462105
  },
  {
    lng: -41.413267,
    lat: -21.4461051
  },
  {
    lng: -41.413255,
    lat: -21.4460794
  },
  {
    lng: -41.413251,
    lat: -21.4460012
  },
  {
    lng: -41.4132744,
    lat: -21.4458862
  },
  {
    lng: -41.4133194,
    lat: -21.4457343
  },
  {
    lng: -41.4133459,
    lat: -21.4456306
  },
  {
    lng: -41.4133523,
    lat: -21.4455737
  },
  {
    lng: -41.4133328,
    lat: -21.4455239
  },
  {
    lng: -41.4133103,
    lat: -21.4454868
  },
  {
    lng: -41.4132757,
    lat: -21.4454354
  },
  {
    lng: -41.4132623,
    lat: -21.445377
  },
  {
    lng: -41.4132823,
    lat: -21.4453487
  },
  {
    lng: -41.4133829,
    lat: -21.4452909
  },
  {
    lng: -41.4135368,
    lat: -21.4451965
  },
  {
    lng: -41.4136526,
    lat: -21.4451331
  },
  {
    lng: -41.4136954,
    lat: -21.4450921
  },
  {
    lng: -41.4137261,
    lat: -21.4450382
  },
  {
    lng: -41.4137037,
    lat: -21.4449727
  },
  {
    lng: -41.4136646,
    lat: -21.4449199
  },
  {
    lng: -41.4135784,
    lat: -21.4448512
  },
  {
    lng: -41.4134743,
    lat: -21.4447326
  },
  {
    lng: -41.4133629,
    lat: -21.4445813
  },
  {
    lng: -41.4132817,
    lat: -21.4444429
  },
  {
    lng: -41.4132595,
    lat: -21.4443489
  },
  {
    lng: -41.4133011,
    lat: -21.4442439
  },
  {
    lng: -41.4133683,
    lat: -21.4441789
  },
  {
    lng: -41.4134476,
    lat: -21.4441395
  },
  {
    lng: -41.4135009,
    lat: -21.4441156
  },
  {
    lng: -41.413577,
    lat: -21.4440748
  },
  {
    lng: -41.4136138,
    lat: -21.4440337
  },
  {
    lng: -41.4136535,
    lat: -21.4439927
  },
  {
    lng: -41.4136553,
    lat: -21.4439373
  },
  {
    lng: -41.4136388,
    lat: -21.4439059
  },
  {
    lng: -41.4135875,
    lat: -21.4438573
  },
  {
    lng: -41.4135148,
    lat: -21.4438284
  },
  {
    lng: -41.4134222,
    lat: -21.4438137
  },
  {
    lng: -41.4133326,
    lat: -21.4438061
  },
  {
    lng: -41.4132263,
    lat: -21.4438084
  },
  {
    lng: -41.4131548,
    lat: -21.4438223
  },
  {
    lng: -41.413103,
    lat: -21.4438447
  },
  {
    lng: -41.4129767,
    lat: -21.4438853
  },
  {
    lng: -41.4128885,
    lat: -21.443909
  },
  {
    lng: -41.4127791,
    lat: -21.4439155
  },
  {
    lng: -41.4127108,
    lat: -21.4439081
  },
  {
    lng: -41.4126137,
    lat: -21.4438933
  },
  {
    lng: -41.4124832,
    lat: -21.4438628
  },
  {
    lng: -41.4124349,
    lat: -21.4438198
  },
  {
    lng: -41.412408,
    lat: -21.4437557
  },
  {
    lng: -41.4124219,
    lat: -21.4437032
  },
  {
    lng: -41.4124056,
    lat: -21.4436448
  },
  {
    lng: -41.4123649,
    lat: -21.4435962
  },
  {
    lng: -41.4123486,
    lat: -21.4435307
  },
  {
    lng: -41.4123536,
    lat: -21.443444
  },
  {
    lng: -41.4123781,
    lat: -21.4434129
  },
  {
    lng: -41.4124238,
    lat: -21.4434003
  },
  {
    lng: -41.4125088,
    lat: -21.443405
  },
  {
    lng: -41.4125513,
    lat: -21.4434095
  },
  {
    lng: -41.4126046,
    lat: -21.4433828
  },
  {
    lng: -41.4126521,
    lat: -21.4433119
  },
  {
    lng: -41.4126857,
    lat: -21.4432865
  },
  {
    lng: -41.4127179,
    lat: -21.4432369
  },
  {
    lng: -41.4127581,
    lat: -21.4431248
  },
  {
    lng: -41.4127766,
    lat: -21.4430723
  },
  {
    lng: -41.4128393,
    lat: -21.4430072
  },
  {
    lng: -41.4129098,
    lat: -21.4429052
  },
  {
    lng: -41.4129625,
    lat: -21.4427235
  },
  {
    lng: -41.4129805,
    lat: -21.4425188
  },
  {
    lng: -41.4129547,
    lat: -21.4422599
  },
  {
    lng: -41.4129074,
    lat: -21.4418032
  },
  {
    lng: -41.4128874,
    lat: -21.441301
  },
  {
    lng: -41.4128863,
    lat: -21.4412727
  },
  {
    lng: -41.4128785,
    lat: -21.441048
  },
  {
    lng: -41.4128531,
    lat: -21.4409796
  },
  {
    lng: -41.4127481,
    lat: -21.4407629
  },
  {
    lng: -41.4127243,
    lat: -21.4406831
  },
  {
    lng: -41.4126883,
    lat: -21.4406161
  },
  {
    lng: -41.4126476,
    lat: -21.4405561
  },
  {
    lng: -41.4126205,
    lat: -21.4405176
  },
  {
    lng: -41.4125755,
    lat: -21.4404249
  },
  {
    lng: -41.4125715,
    lat: -21.4403439
  },
  {
    lng: -41.4125868,
    lat: -21.440324
  },
  {
    lng: -41.4125976,
    lat: -21.4402886
  },
  {
    lng: -41.4125993,
    lat: -21.4402601
  },
  {
    lng: -41.4126314,
    lat: -21.4402304
  },
  {
    lng: -41.4126939,
    lat: -21.4401966
  },
  {
    lng: -41.4127824,
    lat: -21.440126
  },
  {
    lng: -41.412791,
    lat: -21.4401183
  },
  {
    lng: -41.4128984,
    lat: -21.4400228
  },
  {
    lng: -41.4129975,
    lat: -21.4399665
  },
  {
    lng: -41.4130511,
    lat: -21.4398971
  },
  {
    lng: -41.4131154,
    lat: -21.4398107
  },
  {
    lng: -41.4131871,
    lat: -21.439757
  },
  {
    lng: -41.4132299,
    lat: -21.4397174
  },
  {
    lng: -41.4133261,
    lat: -21.439627
  },
  {
    lng: -41.4133854,
    lat: -21.4396088
  },
  {
    lng: -41.4134492,
    lat: -21.4396191
  },
  {
    lng: -41.4135385,
    lat: -21.4396594
  },
  {
    lng: -41.4136084,
    lat: -21.4396626
  },
  {
    lng: -41.413674,
    lat: -21.4396117
  },
  {
    lng: -41.413749,
    lat: -21.4395197
  },
  {
    lng: -41.4137583,
    lat: -21.4394814
  },
  {
    lng: -41.4137436,
    lat: -21.4394045
  },
  {
    lng: -41.4137092,
    lat: -21.4393247
  },
  {
    lng: -41.4136792,
    lat: -21.4392577
  },
  {
    lng: -41.4136599,
    lat: -21.4391837
  },
  {
    lng: -41.4136757,
    lat: -21.4390799
  },
  {
    lng: -41.4136809,
    lat: -21.4389804
  },
  {
    lng: -41.4136677,
    lat: -21.4388993
  },
  {
    lng: -41.4135999,
    lat: -21.4388037
  },
  {
    lng: -41.413547,
    lat: -21.4387622
  },
  {
    lng: -41.4134624,
    lat: -21.4386977
  },
  {
    lng: -41.4134156,
    lat: -21.4386434
  },
  {
    lng: -41.4133827,
    lat: -21.4385622
  },
  {
    lng: -41.4133801,
    lat: -21.4384797
  },
  {
    lng: -41.4134142,
    lat: -21.4383761
  },
  {
    lng: -41.4134938,
    lat: -21.4382727
  },
  {
    lng: -41.4135478,
    lat: -21.4381393
  },
  {
    lng: -41.4136338,
    lat: -21.437972
  },
  {
    lng: -41.4137078,
    lat: -21.4377946
  },
  {
    lng: -41.4137343,
    lat: -21.4376768
  },
  {
    lng: -41.4137334,
    lat: -21.4375886
  },
  {
    lng: -41.4136974,
    lat: -21.4375102
  },
  {
    lng: -41.4136952,
    lat: -21.4374788
  },
  {
    lng: -41.41372,
    lat: -21.4373964
  },
  {
    lng: -41.4137673,
    lat: -21.4373512
  },
  {
    lng: -41.4138614,
    lat: -21.437363
  },
  {
    lng: -41.4140067,
    lat: -21.4374477
  },
  {
    lng: -41.4141352,
    lat: -21.4375103
  },
  {
    lng: -41.4142462,
    lat: -21.4375603
  },
  {
    lng: -41.414334,
    lat: -21.4376091
  },
  {
    lng: -41.4144051,
    lat: -21.4376578
  },
  {
    lng: -41.4144352,
    lat: -21.4376992
  },
  {
    lng: -41.4144442,
    lat: -21.4377192
  },
  {
    lng: -41.4144728,
    lat: -21.4377634
  },
  {
    lng: -41.4145561,
    lat: -21.4377951
  },
  {
    lng: -41.4146152,
    lat: -21.4378182
  },
  {
    lng: -41.4146742,
    lat: -21.4378626
  },
  {
    lng: -41.4146998,
    lat: -21.437894
  },
  {
    lng: -41.414733,
    lat: -21.4379397
  },
  {
    lng: -41.4147343,
    lat: -21.437971
  },
  {
    lng: -41.414766,
    lat: -21.4380109
  },
  {
    lng: -41.4148099,
    lat: -21.4380197
  },
  {
    lng: -41.4148677,
    lat: -21.4380086
  },
  {
    lng: -41.4149059,
    lat: -21.4379804
  },
  {
    lng: -41.4149214,
    lat: -21.4379222
  },
  {
    lng: -41.4149188,
    lat: -21.4378497
  },
  {
    lng: -41.4149054,
    lat: -21.437814
  },
  {
    lng: -41.4148493,
    lat: -21.4377967
  },
  {
    lng: -41.414787,
    lat: -21.4377935
  },
  {
    lng: -41.4147522,
    lat: -21.4377748
  },
  {
    lng: -41.4146887,
    lat: -21.4377332
  },
  {
    lng: -41.4146312,
    lat: -21.4376931
  },
  {
    lng: -41.4145996,
    lat: -21.4376418
  },
  {
    lng: -41.4146166,
    lat: -21.4375992
  },
  {
    lng: -41.4146562,
    lat: -21.4375767
  },
  {
    lng: -41.4147186,
    lat: -21.4375514
  },
  {
    lng: -41.4147538,
    lat: -21.4375103
  },
  {
    lng: -41.4147692,
    lat: -21.4374375
  },
  {
    lng: -41.4147578,
    lat: -21.4373209
  },
  {
    lng: -41.4147176,
    lat: -21.4371842
  },
  {
    lng: -41.4147046,
    lat: -21.4370661
  },
  {
    lng: -41.4147158,
    lat: -21.4369709
  },
  {
    lng: -41.414742,
    lat: -21.4369084
  },
  {
    lng: -41.4148501,
    lat: -21.4368706
  },
  {
    lng: -41.4150021,
    lat: -21.4368572
  },
  {
    lng: -41.4151177,
    lat: -21.4368166
  },
  {
    lng: -41.4152316,
    lat: -21.43683
  },
  {
    lng: -41.4153115,
    lat: -21.4369243
  },
  {
    lng: -41.4153638,
    lat: -21.4370667
  },
  {
    lng: -41.4154539,
    lat: -21.4372279
  },
  {
    lng: -41.4155583,
    lat: -21.4372953
  },
  {
    lng: -41.4156283,
    lat: -21.4372843
  },
  {
    lng: -41.415677,
    lat: -21.4372533
  },
  {
    lng: -41.4156864,
    lat: -21.437205
  },
  {
    lng: -41.4156403,
    lat: -21.4370454
  },
  {
    lng: -41.4155837,
    lat: -21.4368631
  },
  {
    lng: -41.4155903,
    lat: -21.4367793
  },
  {
    lng: -41.4156125,
    lat: -21.4367467
  },
  {
    lng: -41.4156347,
    lat: -21.4367141
  },
  {
    lng: -41.4157125,
    lat: -21.4366719
  },
  {
    lng: -41.4157478,
    lat: -21.4366038
  },
  {
    lng: -41.4157376,
    lat: -21.4365341
  },
  {
    lng: -41.4156818,
    lat: -21.4364684
  },
  {
    lng: -41.4156091,
    lat: -21.4364357
  },
  {
    lng: -41.4155727,
    lat: -21.4364194
  },
  {
    lng: -41.4154463,
    lat: -21.4362396
  },
  {
    lng: -41.4154423,
    lat: -21.4361429
  },
  {
    lng: -41.4154963,
    lat: -21.4359981
  },
  {
    lng: -41.4155137,
    lat: -21.4358788
  },
  {
    lng: -41.4155635,
    lat: -21.4356928
  },
  {
    lng: -41.4156326,
    lat: -21.4355666
  },
  {
    lng: -41.4157747,
    lat: -21.4354265
  },
  {
    lng: -41.4158864,
    lat: -21.4352864
  },
  {
    lng: -41.415997,
    lat: -21.4350722
  },
  {
    lng: -41.4160143,
    lat: -21.4349827
  },
  {
    lng: -41.4159982,
    lat: -21.4348732
  },
  {
    lng: -41.4159247,
    lat: -21.4347263
  },
  {
    lng: -41.4158979,
    lat: -21.4346394
  },
  {
    lng: -41.4159001,
    lat: -21.4345992
  },
  {
    lng: -41.415903,
    lat: -21.434547
  },
  {
    lng: -41.4160206,
    lat: -21.434441
  },
  {
    lng: -41.416133,
    lat: -21.4344373
  },
  {
    lng: -41.4162392,
    lat: -21.4344649
  },
  {
    lng: -41.4163299,
    lat: -21.4345365
  },
  {
    lng: -41.4164144,
    lat: -21.4346194
  },
  {
    lng: -41.4165036,
    lat: -21.4346938
  },
  {
    lng: -41.4165792,
    lat: -21.4347383
  },
  {
    lng: -41.4166916,
    lat: -21.4347446
  },
  {
    lng: -41.4168787,
    lat: -21.4346973
  },
  {
    lng: -41.4170325,
    lat: -21.4346327
  },
  {
    lng: -41.4171184,
    lat: -21.4344895
  },
  {
    lng: -41.4171508,
    lat: -21.4344015
  },
  {
    lng: -41.41715,
    lat: -21.4342749
  },
  {
    lng: -41.4171491,
    lat: -21.4341797
  },
  {
    lng: -41.4171937,
    lat: -21.4340932
  },
  {
    lng: -41.4173142,
    lat: -21.4340014
  },
  {
    lng: -41.4174771,
    lat: -21.4339326
  },
  {
    lng: -41.4176001,
    lat: -21.433946
  },
  {
    lng: -41.4177426,
    lat: -21.4339809
  },
  {
    lng: -41.4178535,
    lat: -21.4339758
  },
  {
    lng: -41.41796,
    lat: -21.4339522
  },
  {
    lng: -41.418202,
    lat: -21.4338639
  },
  {
    lng: -41.4184136,
    lat: -21.4337854
  },
  {
    lng: -41.4185661,
    lat: -21.4336753
  },
  {
    lng: -41.418719,
    lat: -21.433504
  },
  {
    lng: -41.4188882,
    lat: -21.433404
  },
  {
    lng: -41.4189307,
    lat: -21.4334013
  },
  {
    lng: -41.4189506,
    lat: -21.433397
  },
  {
    lng: -41.4190007,
    lat: -21.4333861
  },
  {
    lng: -41.4190222,
    lat: -21.4333492
  },
  {
    lng: -41.4190381,
    lat: -21.4332227
  },
  {
    lng: -41.4191029,
    lat: -21.4330524
  },
  {
    lng: -41.419209,
    lat: -21.4328497
  },
  {
    lng: -41.4193486,
    lat: -21.4326129
  },
  {
    lng: -41.4195121,
    lat: -21.4324489
  },
  {
    lng: -41.4196339,
    lat: -21.4324026
  },
  {
    lng: -41.4197158,
    lat: -21.4324172
  },
  {
    lng: -41.4197961,
    lat: -21.4324404
  },
  {
    lng: -41.4199495,
    lat: -21.4324384
  },
  {
    lng: -41.420105,
    lat: -21.4323553
  },
  {
    lng: -41.4202332,
    lat: -21.4322394
  },
  {
    lng: -41.4203844,
    lat: -21.4321022
  },
  {
    lng: -41.4205398,
    lat: -21.4320291
  },
  {
    lng: -41.4206721,
    lat: -21.4319957
  },
  {
    lng: -41.4207025,
    lat: -21.4319944
  },
  {
    lng: -41.420804,
    lat: -21.4320319
  },
  {
    lng: -41.4208886,
    lat: -21.4321035
  },
  {
    lng: -41.4209947,
    lat: -21.4321353
  },
  {
    lng: -41.4210449,
    lat: -21.4321242
  },
  {
    lng: -41.4210985,
    lat: -21.4320463
  },
  {
    lng: -41.4211314,
    lat: -21.4318915
  },
  {
    lng: -41.4211463,
    lat: -21.4316754
  },
  {
    lng: -41.4211442,
    lat: -21.4315304
  },
  {
    lng: -41.4211693,
    lat: -21.4313897
  },
  {
    lng: -41.4212015,
    lat: -21.4313444
  },
  {
    lng: -41.4212913,
    lat: -21.4313079
  },
  {
    lng: -41.4214069,
    lat: -21.4312872
  },
  {
    lng: -41.4214281,
    lat: -21.4312816
  },
  {
    lng: -41.421509,
    lat: -21.4312195
  },
  {
    lng: -41.4215371,
    lat: -21.4310959
  },
  {
    lng: -41.4215775,
    lat: -21.4309454
  },
  {
    lng: -41.4216937,
    lat: -21.4308066
  },
  {
    lng: -41.4217257,
    lat: -21.4307898
  },
  {
    lng: -41.421785,
    lat: -21.4307801
  },
  {
    lng: -41.4218409,
    lat: -21.4308302
  },
  {
    lng: -41.4218915,
    lat: -21.4310025
  },
  {
    lng: -41.4219881,
    lat: -21.4311025
  },
  {
    lng: -41.4220654,
    lat: -21.4311328
  },
  {
    lng: -41.4221001,
    lat: -21.4311236
  },
  {
    lng: -41.4221232,
    lat: -21.4311175
  },
  {
    lng: -41.4221844,
    lat: -21.4310424
  },
  {
    lng: -41.4222031,
    lat: -21.4309586
  },
  {
    lng: -41.4222009,
    lat: -21.4308193
  },
  {
    lng: -41.4221636,
    lat: -21.4307096
  },
  {
    lng: -41.4221505,
    lat: -21.4306114
  },
  {
    lng: -41.4221345,
    lat: -21.4304933
  },
  {
    lng: -41.4221035,
    lat: -21.4303524
  },
  {
    lng: -41.4221086,
    lat: -21.4302657
  },
  {
    lng: -41.4221717,
    lat: -21.4301224
  },
  {
    lng: -41.4222104,
    lat: -21.430006
  },
  {
    lng: -41.4222218,
    lat: -21.4298724
  },
  {
    lng: -41.4221893,
    lat: -21.42972
  },
  {
    lng: -41.4221913,
    lat: -21.4296376
  },
  {
    lng: -41.4222067,
    lat: -21.4295993
  },
  {
    lng: -41.4222709,
    lat: -21.4295456
  },
  {
    lng: -41.4222769,
    lat: -21.4295442
  },
  {
    lng: -41.4223482,
    lat: -21.4295673
  },
  {
    lng: -41.4224301,
    lat: -21.4295777
  },
  {
    lng: -41.422491,
    lat: -21.4295638
  },
  {
    lng: -41.4225354,
    lat: -21.4295
  },
  {
    lng: -41.4225757,
    lat: -21.4293566
  },
  {
    lng: -41.4225808,
    lat: -21.4292728
  },
  {
    lng: -41.4225647,
    lat: -21.4291731
  },
  {
    lng: -41.4225408,
    lat: -21.4290977
  },
  {
    lng: -41.4225537,
    lat: -21.4289769
  },
  {
    lng: -41.4226075,
    lat: -21.4288776
  },
  {
    lng: -41.422748,
    lat: -21.4287447
  },
  {
    lng: -41.4228731,
    lat: -21.4286487
  },
  {
    lng: -41.4230028,
    lat: -21.4285526
  },
  {
    lng: -41.4231143,
    lat: -21.4284423
  },
  {
    lng: -41.4231834,
    lat: -21.4283104
  },
  {
    lng: -41.4232953,
    lat: -21.4281361
  },
  {
    lng: -41.4233412,
    lat: -21.4280902
  },
  {
    lng: -41.4234298,
    lat: -21.4280018
  },
  {
    lng: -41.4235837,
    lat: -21.4279087
  },
  {
    lng: -41.4236963,
    lat: -21.427878
  },
  {
    lng: -41.423801,
    lat: -21.4278928
  },
  {
    lng: -41.4238798,
    lat: -21.4279245
  },
  {
    lng: -41.4239754,
    lat: -21.4279307
  },
  {
    lng: -41.4240135,
    lat: -21.4279081
  },
  {
    lng: -41.4240412,
    lat: -21.4278514
  },
  {
    lng: -41.4240525,
    lat: -21.4277334
  },
  {
    lng: -41.4240095,
    lat: -21.4275612
  },
  {
    lng: -41.424007,
    lat: -21.4274787
  },
  {
    lng: -41.4240316,
    lat: -21.4274191
  },
  {
    lng: -41.4241384,
    lat: -21.4273372
  },
  {
    lng: -41.4242052,
    lat: -21.4273404
  },
  {
    lng: -41.4242489,
    lat: -21.4274017
  },
  {
    lng: -41.4242877,
    lat: -21.4275157
  },
  {
    lng: -41.4243202,
    lat: -21.4276623
  },
  {
    lng: -41.4243759,
    lat: -21.4277479
  },
  {
    lng: -41.4244199,
    lat: -21.427761
  },
  {
    lng: -41.4245158,
    lat: -21.4277259
  },
  {
    lng: -41.4245646,
    lat: -21.4276821
  },
  {
    lng: -41.4245862,
    lat: -21.4276324
  },
  {
    lng: -41.4245777,
    lat: -21.4275329
  },
  {
    lng: -41.4245468,
    lat: -21.4274526
  },
  {
    lng: -41.4245085,
    lat: -21.4273167
  },
  {
    lng: -41.4244818,
    lat: -21.4272139
  },
  {
    lng: -41.4244977,
    lat: -21.4271779
  },
  {
    lng: -41.4245273,
    lat: -21.4271525
  },
  {
    lng: -41.4246085,
    lat: -21.4271756
  },
  {
    lng: -41.4247645,
    lat: -21.4271722
  },
  {
    lng: -41.4249167,
    lat: -21.4270499
  },
  {
    lng: -41.4249844,
    lat: -21.426936
  },
  {
    lng: -41.4250008,
    lat: -21.4268151
  },
  {
    lng: -41.4249883,
    lat: -21.4266701
  },
  {
    lng: -41.4249224,
    lat: -21.4264783
  },
  {
    lng: -41.4248126,
    lat: -21.4263037
  },
  {
    lng: -41.42461,
    lat: -21.4260895
  },
  {
    lng: -41.4244576,
    lat: -21.4259207
  },
  {
    lng: -41.4244499,
    lat: -21.4258695
  },
  {
    lng: -41.4245498,
    lat: -21.4257484
  },
  {
    lng: -41.4246923,
    lat: -21.4256727
  },
  {
    lng: -41.4248182,
    lat: -21.4256397
  },
  {
    lng: -41.4248622,
    lat: -21.4256097
  },
  {
    lng: -41.4248815,
    lat: -21.4255616
  },
  {
    lng: -41.4248833,
    lat: -21.425557
  },
  {
    lng: -41.4248664,
    lat: -21.4254845
  },
  {
    lng: -41.4247324,
    lat: -21.4253441
  },
  {
    lng: -41.4245058,
    lat: -21.4252338
  },
  {
    lng: -41.424343,
    lat: -21.4251304
  },
  {
    lng: -41.4242759,
    lat: -21.4250495
  },
  {
    lng: -41.4242573,
    lat: -21.4249073
  },
  {
    lng: -41.424272,
    lat: -21.4247594
  },
  {
    lng: -41.4243459,
    lat: -21.4245502
  },
  {
    lng: -41.424423,
    lat: -21.424442
  },
  {
    lng: -41.42462,
    lat: -21.4243021
  },
  {
    lng: -41.4247235,
    lat: -21.4242211
  },
  {
    lng: -41.4248094,
    lat: -21.4241538
  },
  {
    lng: -41.4249214,
    lat: -21.4240326
  },
  {
    lng: -41.4249833,
    lat: -21.4239016
  },
  {
    lng: -41.4250088,
    lat: -21.4237693
  },
  {
    lng: -41.4250403,
    lat: -21.4236612
  },
  {
    lng: -41.4251161,
    lat: -21.423607
  },
  {
    lng: -41.4252467,
    lat: -21.423618
  },
  {
    lng: -41.4253456,
    lat: -21.4236689
  },
  {
    lng: -41.4253746,
    lat: -21.4237229
  },
  {
    lng: -41.4253917,
    lat: -21.4238608
  },
  {
    lng: -41.4254527,
    lat: -21.4239602
  },
  {
    lng: -41.4255457,
    lat: -21.4240751
  },
  {
    lng: -41.4256278,
    lat: -21.4240991
  },
  {
    lng: -41.4257082,
    lat: -21.4240875
  },
  {
    lng: -41.4258325,
    lat: -21.4239805
  },
  {
    lng: -41.4258369,
    lat: -21.4239507
  },
  {
    lng: -41.4258292,
    lat: -21.4238938
  },
  {
    lng: -41.4258047,
    lat: -21.4238427
  },
  {
    lng: -41.4257286,
    lat: -21.4237846
  },
  {
    lng: -41.4256174,
    lat: -21.4236455
  },
  {
    lng: -41.4256246,
    lat: -21.423526
  },
  {
    lng: -41.425679,
    lat: -21.4234249
  },
  {
    lng: -41.4257015,
    lat: -21.4233339
  },
  {
    lng: -41.4257358,
    lat: -21.4230963
  },
  {
    lng: -41.4257765,
    lat: -21.4230052
  },
  {
    lng: -41.4258462,
    lat: -21.422951
  },
  {
    lng: -41.4258703,
    lat: -21.4229571
  },
  {
    lng: -41.4259131,
    lat: -21.4229679
  },
  {
    lng: -41.4259557,
    lat: -21.4230105
  },
  {
    lng: -41.426067,
    lat: -21.4231723
  },
  {
    lng: -41.4261948,
    lat: -21.4232431
  },
  {
    lng: -41.4262905,
    lat: -21.4232371
  },
  {
    lng: -41.4263784,
    lat: -21.4231743
  },
  {
    lng: -41.4264342,
    lat: -21.4230576
  },
  {
    lng: -41.4265462,
    lat: -21.422935
  },
  {
    lng: -41.4266856,
    lat: -21.422811
  },
  {
    lng: -41.4268371,
    lat: -21.4226883
  },
  {
    lng: -41.4269915,
    lat: -21.4225144
  },
  {
    lng: -41.4270518,
    lat: -21.4223735
  },
  {
    lng: -41.4270559,
    lat: -21.4221957
  },
  {
    lng: -41.4270765,
    lat: -21.4219852
  },
  {
    lng: -41.4271186,
    lat: -21.4218344
  },
  {
    lng: -41.4271958,
    lat: -21.4217475
  },
  {
    lng: -41.4272714,
    lat: -21.4216264
  },
  {
    lng: -41.4273089,
    lat: -21.4214898
  },
  {
    lng: -41.4273253,
    lat: -21.4213632
  },
  {
    lng: -41.4273173,
    lat: -21.4212168
  },
  {
    lng: -41.4272392,
    lat: -21.4209952
  },
  {
    lng: -41.4271736,
    lat: -21.4209029
  },
  {
    lng: -41.427143,
    lat: -21.4208347
  },
  {
    lng: -41.4271535,
    lat: -21.4207906
  },
  {
    lng: -41.4272036,
    lat: -21.4207606
  },
  {
    lng: -41.4272961,
    lat: -21.4207305
  },
  {
    lng: -41.4273828,
    lat: -21.4207602
  },
  {
    lng: -41.4274817,
    lat: -21.4208509
  },
  {
    lng: -41.4276292,
    lat: -21.4209131
  },
  {
    lng: -41.427734,
    lat: -21.4209157
  },
  {
    lng: -41.4277613,
    lat: -21.42089
  },
  {
    lng: -41.4277718,
    lat: -21.4208474
  },
  {
    lng: -41.42775,
    lat: -21.4206882
  },
  {
    lng: -41.4277512,
    lat: -21.4205573
  },
  {
    lng: -41.4277768,
    lat: -21.4204833
  },
  {
    lng: -41.4278555,
    lat: -21.420385
  },
  {
    lng: -41.4279372,
    lat: -21.4202824
  },
  {
    lng: -41.4280978,
    lat: -21.4201725
  },
  {
    lng: -41.4283163,
    lat: -21.4201137
  },
  {
    lng: -41.4284758,
    lat: -21.4201303
  },
  {
    lng: -41.4286203,
    lat: -21.4201954
  },
  {
    lng: -41.428736,
    lat: -21.4203088
  },
  {
    lng: -41.4288076,
    lat: -21.4203854
  },
  {
    lng: -41.4288958,
    lat: -21.4204179
  },
  {
    lng: -41.4289641,
    lat: -21.4204121
  },
  {
    lng: -41.4289914,
    lat: -21.4203963
  },
  {
    lng: -41.4290111,
    lat: -21.4203807
  },
  {
    lng: -41.429026,
    lat: -21.4202896
  },
  {
    lng: -41.4290255,
    lat: -21.4201161
  },
  {
    lng: -41.4290024,
    lat: -21.4200067
  },
  {
    lng: -41.4289945,
    lat: -21.4199143
  },
  {
    lng: -41.4290428,
    lat: -21.4197905
  },
  {
    lng: -41.4291033,
    lat: -21.4197206
  },
  {
    lng: -41.4292214,
    lat: -21.4196793
  },
  {
    lng: -41.4293105,
    lat: -21.419446
  },
  {
    lng: -41.4294211,
    lat: -21.4193319
  },
  {
    lng: -41.4295515,
    lat: -21.4192676
  },
  {
    lng: -41.4296592,
    lat: -21.4192304
  },
  {
    lng: -41.429691,
    lat: -21.419199
  },
  {
    lng: -41.4297121,
    lat: -21.4191378
  },
  {
    lng: -41.4297057,
    lat: -21.4190326
  },
  {
    lng: -41.4297084,
    lat: -21.4189359
  },
  {
    lng: -41.4297536,
    lat: -21.418795
  },
  {
    lng: -41.4297683,
    lat: -21.4186499
  },
  {
    lng: -41.429768,
    lat: -21.4185433
  },
  {
    lng: -41.4297419,
    lat: -21.4184282
  },
  {
    lng: -41.4297491,
    lat: -21.4183172
  },
  {
    lng: -41.4297758,
    lat: -21.4182944
  },
  {
    lng: -41.4297991,
    lat: -21.4182745
  },
  {
    lng: -41.4299145,
    lat: -21.4182671
  },
  {
    lng: -41.4299388,
    lat: -21.4182741
  },
  {
    lng: -41.4300088,
    lat: -21.4183109
  },
  {
    lng: -41.4300741,
    lat: -21.4183121
  },
  {
    lng: -41.4301226,
    lat: -21.4182651
  },
  {
    lng: -41.4300995,
    lat: -21.4181543
  },
  {
    lng: -41.4299928,
    lat: -21.4180294
  },
  {
    lng: -41.4298574,
    lat: -21.4179444
  },
  {
    lng: -41.4298162,
    lat: -21.4178919
  },
  {
    lng: -41.4298113,
    lat: -21.417764
  },
  {
    lng: -41.4299462,
    lat: -21.4176612
  },
  {
    lng: -41.4301494,
    lat: -21.4175569
  },
  {
    lng: -41.4302193,
    lat: -21.4175738
  },
  {
    lng: -41.4302315,
    lat: -21.4175908
  },
  {
    lng: -41.4302392,
    lat: -21.4176392
  },
  {
    lng: -41.4302244,
    lat: -21.4177629
  },
  {
    lng: -41.4302019,
    lat: -21.4178611
  },
  {
    lng: -41.4302157,
    lat: -21.417925
  },
  {
    lng: -41.4302477,
    lat: -21.417942
  },
  {
    lng: -41.4303023,
    lat: -21.4179291
  },
  {
    lng: -41.4303371,
    lat: -21.4178949
  },
  {
    lng: -41.4303718,
    lat: -21.4178109
  },
  {
    lng: -41.4304183,
    lat: -21.4176273
  },
  {
    lng: -41.4304955,
    lat: -21.417529
  },
  {
    lng: -41.4305743,
    lat: -21.4174847
  },
  {
    lng: -41.4307063,
    lat: -21.4174474
  },
  {
    lng: -41.4308549,
    lat: -21.4173518
  },
  {
    lng: -41.4308623,
    lat: -21.4172977
  },
  {
    lng: -41.4308302,
    lat: -21.4172381
  },
  {
    lng: -41.4307436,
    lat: -21.4172141
  },
  {
    lng: -41.430578,
    lat: -21.4171904
  },
  {
    lng: -41.4303728,
    lat: -21.4171155
  },
  {
    lng: -41.4303027,
    lat: -21.4170119
  },
  {
    lng: -41.4302782,
    lat: -21.4169233
  },
  {
    lng: -41.4302745,
    lat: -21.4168593
  },
  {
    lng: -41.4303034,
    lat: -21.4167445
  },
  {
    lng: -41.4303831,
    lat: -21.4165819
  },
  {
    lng: -41.4304863,
    lat: -21.4163627
  },
  {
    lng: -41.4305555,
    lat: -21.4162995
  },
  {
    lng: -41.4305773,
    lat: -21.4162557
  },
  {
    lng: -41.430595,
    lat: -21.4161819
  },
  {
    lng: -41.4305996,
    lat: -21.4160668
  },
  {
    lng: -41.430599,
    lat: -21.4157781
  },
  {
    lng: -41.4305865,
    lat: -21.4154666
  },
  {
    lng: -41.430568,
    lat: -21.4152658
  },
  {
    lng: -41.4305667,
    lat: -21.4151364
  },
  {
    lng: -41.4306094,
    lat: -21.4149009
  },
  {
    lng: -41.4306274,
    lat: -21.414692
  },
  {
    lng: -41.4306371,
    lat: -21.4145343
  },
  {
    lng: -41.4306632,
    lat: -21.4144052
  },
  {
    lng: -41.4307478,
    lat: -21.4142142
  },
  {
    lng: -41.4307706,
    lat: -21.4141813
  },
  {
    lng: -41.4308779,
    lat: -21.4140266
  },
  {
    lng: -41.4310164,
    lat: -21.4138875
  },
  {
    lng: -41.4311448,
    lat: -21.4137155
  },
  {
    lng: -41.4312065,
    lat: -21.4136466
  },
  {
    lng: -41.4313073,
    lat: -21.4135995
  },
  {
    lng: -41.431398,
    lat: -21.4135223
  },
  {
    lng: -41.4314376,
    lat: -21.4135114
  },
  {
    lng: -41.4315444,
    lat: -21.4135866
  },
  {
    lng: -41.4316008,
    lat: -21.4136854
  },
  {
    lng: -41.4316247,
    lat: -21.4137113
  },
  {
    lng: -41.4316639,
    lat: -21.4137317
  },
  {
    lng: -41.4317248,
    lat: -21.4138348
  },
  {
    lng: -41.4317552,
    lat: -21.4139432
  },
  {
    lng: -41.4317954,
    lat: -21.4140048
  },
  {
    lng: -41.4318829,
    lat: -21.41405
  },
  {
    lng: -41.431995,
    lat: -21.4140684
  },
  {
    lng: -41.4320403,
    lat: -21.4140874
  },
  {
    lng: -41.4320992,
    lat: -21.4141094
  },
  {
    lng: -41.4321343,
    lat: -21.4140956
  },
  {
    lng: -41.4321365,
    lat: -21.4140516
  },
  {
    lng: -41.4320963,
    lat: -21.4139928
  },
  {
    lng: -41.4319715,
    lat: -21.4138989
  },
  {
    lng: -41.4318787,
    lat: -21.413794
  },
  {
    lng: -41.4318345,
    lat: -21.4136996
  },
  {
    lng: -41.4318294,
    lat: -21.4136263
  },
  {
    lng: -41.4318243,
    lat: -21.413553
  },
  {
    lng: -41.4318329,
    lat: -21.4134806
  },
  {
    lng: -41.4318687,
    lat: -21.4134184
  },
  {
    lng: -41.431941,
    lat: -21.4133468
  },
  {
    lng: -41.4320483,
    lat: -21.4132741
  },
  {
    lng: -41.43207,
    lat: -21.4132431
  },
  {
    lng: -41.432094,
    lat: -21.4131495
  },
  {
    lng: -41.4321,
    lat: -21.4130415
  },
  {
    lng: -41.4321879,
    lat: -21.4128335
  },
  {
    lng: -41.4323008,
    lat: -21.4126841
  },
  {
    lng: -41.4323988,
    lat: -21.4126213
  },
  {
    lng: -41.4324797,
    lat: -21.4125895
  },
  {
    lng: -41.4326601,
    lat: -21.4126187
  },
  {
    lng: -41.4329092,
    lat: -21.4126088
  },
  {
    lng: -41.4331514,
    lat: -21.4125577
  },
  {
    lng: -41.4332692,
    lat: -21.4124922
  },
  {
    lng: -41.4333052,
    lat: -21.4124173
  },
  {
    lng: -41.4333314,
    lat: -21.412274
  },
  {
    lng: -41.433335,
    lat: -21.4121176
  },
  {
    lng: -41.4333508,
    lat: -21.4120723
  },
  {
    lng: -41.433415,
    lat: -21.4120418
  },
  {
    lng: -41.4334637,
    lat: -21.4120381
  },
  {
    lng: -41.4335059,
    lat: -21.4120599
  },
  {
    lng: -41.4335312,
    lat: -21.4120972
  },
  {
    lng: -41.4335854,
    lat: -21.4121291
  },
  {
    lng: -41.4337217,
    lat: -21.4121634
  },
  {
    lng: -41.4338652,
    lat: -21.4121068
  },
  {
    lng: -41.43389,
    lat: -21.4120659
  },
  {
    lng: -41.4338858,
    lat: -21.4120402
  },
  {
    lng: -41.4338546,
    lat: -21.4119929
  },
  {
    lng: -41.4337945,
    lat: -21.4119425
  },
  {
    lng: -41.4337659,
    lat: -21.4119251
  },
  {
    lng: -41.4337314,
    lat: -21.4118934
  },
  {
    lng: -41.4337242,
    lat: -21.4118606
  },
  {
    lng: -41.4337385,
    lat: -21.4118167
  },
  {
    lng: -41.4337755,
    lat: -21.4117773
  },
  {
    lng: -41.4338349,
    lat: -21.4117595
  },
  {
    lng: -41.4339275,
    lat: -21.4117649
  },
  {
    lng: -41.4340563,
    lat: -21.4117863
  },
  {
    lng: -41.4341384,
    lat: -21.4117759
  },
  {
    lng: -41.4342286,
    lat: -21.4117372
  },
  {
    lng: -41.4342936,
    lat: -21.4116469
  },
  {
    lng: -41.4343033,
    lat: -21.4115987
  },
  {
    lng: -41.4342947,
    lat: -21.4115644
  },
  {
    lng: -41.4342524,
    lat: -21.411544
  },
  {
    lng: -41.4340916,
    lat: -21.4115322
  },
  {
    lng: -41.4339673,
    lat: -21.4115151
  },
  {
    lng: -41.4339211,
    lat: -21.4114562
  },
  {
    lng: -41.4339092,
    lat: -21.4113195
  },
  {
    lng: -41.4339329,
    lat: -21.4112558
  },
  {
    lng: -41.4340134,
    lat: -21.4111388
  },
  {
    lng: -41.4341697,
    lat: -21.4109245
  },
  {
    lng: -41.434351,
    lat: -21.410655
  },
  {
    lng: -41.4344878,
    lat: -21.4105386
  },
  {
    lng: -41.4346314,
    lat: -21.4104763
  },
  {
    lng: -41.4347146,
    lat: -21.4104958
  },
  {
    lng: -41.4348077,
    lat: -21.4105723
  },
  {
    lng: -41.4348895,
    lat: -21.4105903
  },
  {
    lng: -41.4350176,
    lat: -21.4105506
  },
  {
    lng: -41.4351282,
    lat: -21.4104538
  },
  {
    lng: -41.4352409,
    lat: -21.4104324
  },
  {
    lng: -41.4353045,
    lat: -21.4104459
  },
  {
    lng: -41.4353624,
    lat: -21.4105447
  },
  {
    lng: -41.435425,
    lat: -21.4107445
  },
  {
    lng: -41.4354469,
    lat: -21.4110335
  },
  {
    lng: -41.4354889,
    lat: -21.4111805
  },
  {
    lng: -41.4355416,
    lat: -21.4112152
  },
  {
    lng: -41.4356919,
    lat: -21.4112227
  },
  {
    lng: -41.4358494,
    lat: -21.4111421
  },
  {
    lng: -41.4359542,
    lat: -21.4110253
  },
  {
    lng: -41.4361446,
    lat: -21.410874
  },
  {
    lng: -41.4362902,
    lat: -21.4108856
  },
  {
    lng: -41.4363443,
    lat: -21.4109289
  },
  {
    lng: -41.4363844,
    lat: -21.4109934
  },
  {
    lng: -41.4364208,
    lat: -21.4109995
  },
  {
    lng: -41.436465,
    lat: -21.410983
  },
  {
    lng: -41.4365129,
    lat: -21.4109253
  },
  {
    lng: -41.4365609,
    lat: -21.4108547
  },
  {
    lng: -41.436587,
    lat: -21.4108323
  },
  {
    lng: -41.436633,
    lat: -21.4107987
  },
  {
    lng: -41.4366366,
    lat: -21.4107589
  },
  {
    lng: -41.4365785,
    lat: -21.4106772
  },
  {
    lng: -41.4364788,
    lat: -21.4106348
  },
  {
    lng: -41.4363258,
    lat: -21.410613
  },
  {
    lng: -41.4362075,
    lat: -21.4105974
  },
  {
    lng: -41.436173,
    lat: -21.41057
  },
  {
    lng: -41.4361599,
    lat: -21.4105272
  },
  {
    lng: -41.4361651,
    lat: -21.4104746
  },
  {
    lng: -41.4361929,
    lat: -21.4104437
  },
  {
    lng: -41.4363169,
    lat: -21.4103669
  },
  {
    lng: -41.4364091,
    lat: -21.4103512
  },
  {
    lng: -41.4365042,
    lat: -21.410335
  },
  {
    lng: -41.4366648,
    lat: -21.4103597
  },
  {
    lng: -41.4367156,
    lat: -21.4104214
  },
  {
    lng: -41.436722,
    lat: -21.4105082
  },
  {
    lng: -41.4367347,
    lat: -21.4105766
  },
  {
    lng: -41.4367781,
    lat: -21.4106241
  },
  {
    lng: -41.4368281,
    lat: -21.4106346
  },
  {
    lng: -41.4369072,
    lat: -21.4106228
  },
  {
    lng: -41.4369928,
    lat: -21.4105868
  },
  {
    lng: -41.4370537,
    lat: -21.4105762
  },
  {
    lng: -41.4371384,
    lat: -21.4105985
  },
  {
    lng: -41.4372251,
    lat: -21.4107019
  },
  {
    lng: -41.4372434,
    lat: -21.4108088
  },
  {
    lng: -41.437237,
    lat: -21.4108286
  },
  {
    lng: -41.4371971,
    lat: -21.4108594
  },
  {
    lng: -41.4371485,
    lat: -21.4108617
  },
  {
    lng: -41.4369955,
    lat: -21.4108314
  },
  {
    lng: -41.4369531,
    lat: -21.4108281
  },
  {
    lng: -41.4368893,
    lat: -21.4108302
  },
  {
    lng: -41.436846,
    lat: -21.4108837
  },
  {
    lng: -41.4368127,
    lat: -21.4109885
  },
  {
    lng: -41.4368121,
    lat: -21.4112559
  },
  {
    lng: -41.4368398,
    lat: -21.4113444
  },
  {
    lng: -41.4369682,
    lat: -21.4113928
  },
  {
    lng: -41.4371278,
    lat: -21.4113833
  },
  {
    lng: -41.4372704,
    lat: -21.4112784
  },
  {
    lng: -41.4373893,
    lat: -21.4111376
  },
  {
    lng: -41.4374936,
    lat: -21.4110563
  },
  {
    lng: -41.4375764,
    lat: -21.411035
  },
  {
    lng: -41.4377219,
    lat: -21.4110538
  },
  {
    lng: -41.4378559,
    lat: -21.4111379
  },
  {
    lng: -41.437965,
    lat: -21.4112686
  },
  {
    lng: -41.4380975,
    lat: -21.4114635
  },
  {
    lng: -41.4382603,
    lat: -21.4115593
  },
  {
    lng: -41.4383649,
    lat: -21.4115705
  },
  {
    lng: -41.4386382,
    lat: -21.4115737
  },
  {
    lng: -41.4388914,
    lat: -21.4116023
  },
  {
    lng: -41.4389786,
    lat: -21.4115579
  },
  {
    lng: -41.4390225,
    lat: -21.4114517
  },
  {
    lng: -41.4390104,
    lat: -21.4113364
  },
  {
    lng: -41.4389717,
    lat: -21.4112776
  },
  {
    lng: -41.4389502,
    lat: -21.4111878
  },
  {
    lng: -41.4389708,
    lat: -21.4111184
  },
  {
    lng: -41.4390631,
    lat: -21.4110341
  },
  {
    lng: -41.4392331,
    lat: -21.4109295
  },
  {
    lng: -41.4393757,
    lat: -21.4108288
  },
  {
    lng: -41.4394956,
    lat: -21.4107165
  },
  {
    lng: -41.439656,
    lat: -21.4105363
  },
  {
    lng: -41.4399259,
    lat: -21.4103419
  },
  {
    lng: -41.4401359,
    lat: -21.4103116
  },
  {
    lng: -41.4402476,
    lat: -21.410357
  },
  {
    lng: -41.4402982,
    lat: -21.4104344
  },
  {
    lng: -41.4403215,
    lat: -21.4106224
  },
  {
    lng: -41.4403001,
    lat: -21.4107473
  },
  {
    lng: -41.4402931,
    lat: -21.4108098
  },
  {
    lng: -41.4403206,
    lat: -21.4109111
  },
  {
    lng: -41.440492,
    lat: -21.4110368
  },
  {
    lng: -41.4405813,
    lat: -21.4110629
  },
  {
    lng: -41.4405934,
    lat: -21.4110665
  },
  {
    lng: -41.4406527,
    lat: -21.4110601
  },
  {
    lng: -41.4407307,
    lat: -21.4110169
  },
  {
    lng: -41.4408118,
    lat: -21.41086
  },
  {
    lng: -41.4408843,
    lat: -21.410777
  },
  {
    lng: -41.4410566,
    lat: -21.4106155
  },
  {
    lng: -41.4411587,
    lat: -21.4105897
  },
  {
    lng: -41.4412101,
    lat: -21.4106017
  },
  {
    lng: -41.4412973,
    lat: -21.4106695
  },
  {
    lng: -41.4414137,
    lat: -21.4108174
  },
  {
    lng: -41.441572,
    lat: -21.4109046
  },
  {
    lng: -41.4416921,
    lat: -21.4108932
  },
  {
    lng: -41.441732,
    lat: -21.4108666
  },
  {
    lng: -41.4418002,
    lat: -21.4107594
  },
  {
    lng: -41.4418318,
    lat: -21.4106702
  },
  {
    lng: -41.4418907,
    lat: -21.4105841
  },
  {
    lng: -41.4419414,
    lat: -21.410542
  },
  {
    lng: -41.442042,
    lat: -21.4105091
  },
  {
    lng: -41.4421848,
    lat: -21.410508
  },
  {
    lng: -41.4423388,
    lat: -21.4105709
  },
  {
    lng: -41.4424782,
    lat: -21.4107119
  },
  {
    lng: -41.4427518,
    lat: -21.4109142
  },
  {
    lng: -41.4428757,
    lat: -21.4109612
  },
  {
    lng: -41.4429228,
    lat: -21.4109618
  },
  {
    lng: -41.4429655,
    lat: -21.4109466
  },
  {
    lng: -41.4430024,
    lat: -21.4109115
  },
  {
    lng: -41.4430017,
    lat: -21.4108561
  },
  {
    lng: -41.4429448,
    lat: -21.4107928
  },
  {
    lng: -41.4428978,
    lat: -21.4107468
  },
  {
    lng: -41.4428744,
    lat: -21.4107237
  },
  {
    lng: -41.4428329,
    lat: -21.4106436
  },
  {
    lng: -41.4428368,
    lat: -21.4105825
  },
  {
    lng: -41.4428706,
    lat: -21.4104407
  },
  {
    lng: -41.4428795,
    lat: -21.4103398
  },
  {
    lng: -41.4429001,
    lat: -21.4102818
  },
  {
    lng: -41.4429566,
    lat: -21.4102568
  },
  {
    lng: -41.4430618,
    lat: -21.410224
  },
  {
    lng: -41.4432186,
    lat: -21.4101974
  },
  {
    lng: -41.4434141,
    lat: -21.4102253
  },
  {
    lng: -41.4438864,
    lat: -21.4102266
  },
  {
    lng: -41.4439019,
    lat: -21.4102059
  },
  {
    lng: -41.4439606,
    lat: -21.4101279
  },
  {
    lng: -41.4440124,
    lat: -21.4099977
  },
  {
    lng: -41.4440109,
    lat: -21.4098868
  },
  {
    lng: -41.4439458,
    lat: -21.4097623
  },
  {
    lng: -41.4438416,
    lat: -21.4097127
  },
  {
    lng: -41.443751,
    lat: -21.4096789
  },
  {
    lng: -41.4436155,
    lat: -21.4095877
  },
  {
    lng: -41.4435934,
    lat: -21.4095391
  },
  {
    lng: -41.4435999,
    lat: -21.4095108
  },
  {
    lng: -41.4436383,
    lat: -21.4094799
  },
  {
    lng: -41.4436916,
    lat: -21.4094678
  },
  {
    lng: -41.4438965,
    lat: -21.409473
  },
  {
    lng: -41.444195,
    lat: -21.4095192
  },
  {
    lng: -41.4442863,
    lat: -21.4095061
  },
  {
    lng: -41.4443128,
    lat: -21.4094609
  },
  {
    lng: -41.4443248,
    lat: -21.409353
  },
  {
    lng: -41.4442942,
    lat: -21.4092602
  },
  {
    lng: -41.4442806,
    lat: -21.409142
  },
  {
    lng: -41.4443018,
    lat: -21.4090342
  },
  {
    lng: -41.4443496,
    lat: -21.4089793
  },
  {
    lng: -41.4443998,
    lat: -21.4089713
  },
  {
    lng: -41.4444128,
    lat: -21.4090241
  },
  {
    lng: -41.4444224,
    lat: -21.409101
  },
  {
    lng: -41.4444496,
    lat: -21.4091113
  },
  {
    lng: -41.4444768,
    lat: -21.4091215
  },
  {
    lng: -41.4444878,
    lat: -21.4091195
  },
  {
    lng: -41.4445209,
    lat: -21.4091135
  },
  {
    lng: -41.4445551,
    lat: -21.4090556
  },
  {
    lng: -41.4445668,
    lat: -21.4089804
  },
  {
    lng: -41.4446527,
    lat: -21.4089103
  },
  {
    lng: -41.4447409,
    lat: -21.4089028
  },
  {
    lng: -41.4448438,
    lat: -21.4089311
  },
  {
    lng: -41.4449759,
    lat: -21.408934
  },
  {
    lng: -41.4450722,
    lat: -21.4088883
  },
  {
    lng: -41.445107,
    lat: -21.4087834
  },
  {
    lng: -41.445087,
    lat: -21.4086908
  },
  {
    lng: -41.445034,
    lat: -21.4085664
  },
  {
    lng: -41.4450303,
    lat: -21.4085024
  },
  {
    lng: -41.4450462,
    lat: -21.4084485
  },
  {
    lng: -41.4451167,
    lat: -21.4084024
  },
  {
    lng: -41.4451652,
    lat: -21.408403
  },
  {
    lng: -41.4452199,
    lat: -21.4084022
  },
  {
    lng: -41.4452491,
    lat: -21.4083798
  },
  {
    lng: -41.4452643,
    lat: -21.4082634
  },
  {
    lng: -41.4452812,
    lat: -21.408137
  },
  {
    lng: -41.4453184,
    lat: -21.4080806
  },
  {
    lng: -41.4454379,
    lat: -21.4080024
  },
  {
    lng: -41.4455925,
    lat: -21.4079132
  },
  {
    lng: -41.4457266,
    lat: -21.4078792
  },
  {
    lng: -41.4458318,
    lat: -21.4078435
  },
  {
    lng: -41.4458844,
    lat: -21.407773
  },
  {
    lng: -41.4459282,
    lat: -21.4076768
  },
  {
    lng: -41.4459505,
    lat: -21.4076032
  },
  {
    lng: -41.4459858,
    lat: -21.4075751
  },
  {
    lng: -41.4461181,
    lat: -21.4075625
  },
  {
    lng: -41.4462896,
    lat: -21.4075631
  },
  {
    lng: -41.4463767,
    lat: -21.4075257
  },
  {
    lng: -41.446429,
    lat: -21.4074751
  },
  {
    lng: -41.4464437,
    lat: -21.4074014
  },
  {
    lng: -41.4464984,
    lat: -21.4072854
  },
  {
    lng: -41.4465566,
    lat: -21.4072477
  },
  {
    lng: -41.4467328,
    lat: -21.4072469
  },
  {
    lng: -41.4468757,
    lat: -21.407233
  },
  {
    lng: -41.4469139,
    lat: -21.4072121
  },
  {
    lng: -41.4470471,
    lat: -21.4070245
  },
  {
    lng: -41.4471312,
    lat: -21.4067496
  },
  {
    lng: -41.447133,
    lat: -21.4065079
  },
  {
    lng: -41.4471385,
    lat: -21.4064383
  },
  {
    lng: -41.4471529,
    lat: -21.4063788
  },
  {
    lng: -41.4472006,
    lat: -21.406331
  },
  {
    lng: -41.4474023,
    lat: -21.4061286
  },
  {
    lng: -41.4475858,
    lat: -21.4059217
  },
  {
    lng: -41.4477052,
    lat: -21.4057397
  },
  {
    lng: -41.4477689,
    lat: -21.4056267
  },
  {
    lng: -41.4478182,
    lat: -21.4055732
  },
  {
    lng: -41.4479823,
    lat: -21.4055709
  },
  {
    lng: -41.4480426,
    lat: -21.4056029
  },
  {
    lng: -41.4481427,
    lat: -21.4056083
  },
  {
    lng: -41.4481979,
    lat: -21.4055734
  },
  {
    lng: -41.4482305,
    lat: -21.4055198
  },
  {
    lng: -41.448271,
    lat: -21.4054435
  },
  {
    lng: -41.4483906,
    lat: -21.4053581
  },
  {
    lng: -41.4485048,
    lat: -21.4053339
  },
  {
    lng: -41.4486721,
    lat: -21.4053131
  },
  {
    lng: -41.4487424,
    lat: -21.4052769
  },
  {
    lng: -41.4487597,
    lat: -21.4052373
  },
  {
    lng: -41.4487393,
    lat: -21.4051703
  },
  {
    lng: -41.448636,
    lat: -21.4051353
  },
  {
    lng: -41.4486305,
    lat: -21.4051334
  },
  {
    lng: -41.4484594,
    lat: -21.405093
  },
  {
    lng: -41.4483283,
    lat: -21.4050218
  },
  {
    lng: -41.4483014,
    lat: -21.4049888
  },
  {
    lng: -41.4482777,
    lat: -21.4049416
  },
  {
    lng: -41.4482828,
    lat: -21.4049032
  },
  {
    lng: -41.4483273,
    lat: -21.4048682
  },
  {
    lng: -41.4484878,
    lat: -21.4047905
  },
  {
    lng: -41.4486149,
    lat: -21.4045957
  },
  {
    lng: -41.4486731,
    lat: -21.4044457
  },
  {
    lng: -41.4486608,
    lat: -21.4043488
  },
  {
    lng: -41.4486058,
    lat: -21.4042572
  },
  {
    lng: -41.4485774,
    lat: -21.4042255
  },
  {
    lng: -41.4485627,
    lat: -21.4041898
  },
  {
    lng: -41.4485775,
    lat: -21.4041075
  },
  {
    lng: -41.4486008,
    lat: -21.4040666
  },
  {
    lng: -41.4486244,
    lat: -21.4040085
  },
  {
    lng: -41.4486089,
    lat: -21.4039145
  },
  {
    lng: -41.4485406,
    lat: -21.4037999
  },
  {
    lng: -41.4484683,
    lat: -21.4037578
  },
  {
    lng: -41.4483907,
    lat: -21.4037711
  },
  {
    lng: -41.4483002,
    lat: -21.4038355
  },
  {
    lng: -41.4481758,
    lat: -21.4039435
  },
  {
    lng: -41.4481136,
    lat: -21.404048
  },
  {
    lng: -41.4480929,
    lat: -21.4041231
  },
  {
    lng: -41.4480668,
    lat: -21.4041427
  },
  {
    lng: -41.4480395,
    lat: -21.4041396
  },
  {
    lng: -41.448005,
    lat: -21.4041093
  },
  {
    lng: -41.4479647,
    lat: -21.4040548
  },
  {
    lng: -41.4479563,
    lat: -21.4040006
  },
  {
    lng: -41.4479646,
    lat: -21.403951
  },
  {
    lng: -41.4479653,
    lat: -21.4039012
  },
  {
    lng: -41.4479434,
    lat: -21.4038355
  },
  {
    lng: -41.4479194,
    lat: -21.4038125
  },
  {
    lng: -41.4478833,
    lat: -21.4037836
  },
  {
    lng: -41.4478761,
    lat: -21.4037594
  },
  {
    lng: -41.4478917,
    lat: -21.403724
  },
  {
    lng: -41.4480344,
    lat: -21.4036134
  },
  {
    lng: -41.4481843,
    lat: -21.4034653
  },
  {
    lng: -41.4482873,
    lat: -21.4033464
  },
  {
    lng: -41.4483768,
    lat: -21.4032767
  },
  {
    lng: -41.4484121,
    lat: -21.4031752
  },
  {
    lng: -41.4484515,
    lat: -21.4030804
  },
  {
    lng: -41.4484203,
    lat: -21.4029302
  },
  {
    lng: -41.4482438,
    lat: -21.4028413
  },
  {
    lng: -41.4481352,
    lat: -21.402726
  },
  {
    lng: -41.4480202,
    lat: -21.4025671
  },
  {
    lng: -41.4479683,
    lat: -21.4024064
  },
  {
    lng: -41.4478948,
    lat: -21.4023037
  },
  {
    lng: -41.447987,
    lat: -21.4018084
  },
  {
    lng: -41.448405,
    lat: -21.4004213
  },
  {
    lng: -41.4491875,
    lat: -21.3989699
  },
  {
    lng: -41.4494536,
    lat: -21.3985851
  },
  {
    lng: -41.5123984,
    lat: -21.4178786
  },
  {
    lng: -41.5427414,
    lat: -21.4271792
  },
  {
    lng: -41.5457164,
    lat: -21.4280911
  },
  {
    lng: -41.5462767,
    lat: -21.4282628
  },
  {
    lng: -41.5463736,
    lat: -21.4282925
  },
  {
    lng: -41.5474538,
    lat: -21.4286236
  },
  {
    lng: -41.5475379,
    lat: -21.4286494
  },
  {
    lng: -41.5507639,
    lat: -21.4296382
  },
  {
    lng: -41.550866,
    lat: -21.4296695
  },
  {
    lng: -41.5508827,
    lat: -21.4296145
  },
  {
    lng: -41.5510548,
    lat: -21.4290496
  },
  {
    lng: -41.5522435,
    lat: -21.4251473
  },
  {
    lng: -41.5673854,
    lat: -21.3754412
  },
  {
    lng: -41.5725079,
    lat: -21.3586245
  },
  {
    lng: -41.5726237,
    lat: -21.3582453
  },
  {
    lng: -41.5850715,
    lat: -21.3173829
  },
  {
    lng: -41.5848815,
    lat: -21.3168608
  },
  {
    lng: -41.5845844,
    lat: -21.3165043
  },
  {
    lng: -41.5846422,
    lat: -21.3162096
  },
  {
    lng: -41.5848027,
    lat: -21.3159141
  },
  {
    lng: -41.5849468,
    lat: -21.3155917
  },
  {
    lng: -41.5852045,
    lat: -21.3152582
  },
  {
    lng: -41.5852878,
    lat: -21.3151952
  },
  {
    lng: -41.585543,
    lat: -21.3149474
  },
  {
    lng: -41.585676,
    lat: -21.3146995
  },
  {
    lng: -41.5856818,
    lat: -21.314607
  },
  {
    lng: -41.5856689,
    lat: -21.3145068
  },
  {
    lng: -41.5856538,
    lat: -21.3142433
  },
  {
    lng: -41.5856942,
    lat: -21.3141699
  },
  {
    lng: -41.5857198,
    lat: -21.3140257
  },
  {
    lng: -41.5856836,
    lat: -21.3139267
  },
  {
    lng: -41.585746,
    lat: -21.3135693
  },
  {
    lng: -41.5857481,
    lat: -21.3135248
  },
  {
    lng: -41.58574,
    lat: -21.3132385
  },
  {
    lng: -41.585729,
    lat: -21.3131655
  },
  {
    lng: -41.5858634,
    lat: -21.3129628
  },
  {
    lng: -41.5859332,
    lat: -21.3128265
  },
  {
    lng: -41.5860241,
    lat: -21.3127632
  },
  {
    lng: -41.5860551,
    lat: -21.3127614
  },
  {
    lng: -41.5862818,
    lat: -21.3126541
  },
  {
    lng: -41.5865543,
    lat: -21.3126678
  },
  {
    lng: -41.5869019,
    lat: -21.3126494
  },
  {
    lng: -41.5872518,
    lat: -21.3124916
  },
  {
    lng: -41.5873818,
    lat: -21.3123734
  },
  {
    lng: -41.5873952,
    lat: -21.3121941
  },
  {
    lng: -41.5872344,
    lat: -21.3118553
  },
  {
    lng: -41.5869983,
    lat: -21.3115643
  },
  {
    lng: -41.5867123,
    lat: -21.3113198
  },
  {
    lng: -41.586674,
    lat: -21.3112375
  },
  {
    lng: -41.586607,
    lat: -21.3112312
  },
  {
    lng: -41.5863484,
    lat: -21.3111884
  },
  {
    lng: -41.586097,
    lat: -21.3109142
  },
  {
    lng: -41.5859623,
    lat: -21.3108821
  },
  {
    lng: -41.5858,
    lat: -21.3108072
  },
  {
    lng: -41.5856478,
    lat: -21.3106193
  },
  {
    lng: -41.5855172,
    lat: -21.3104947
  },
  {
    lng: -41.5853363,
    lat: -21.3104492
  },
  {
    lng: -41.5851296,
    lat: -21.3104782
  },
  {
    lng: -41.5850728,
    lat: -21.3104348
  },
  {
    lng: -41.5848692,
    lat: -21.3102793
  },
  {
    lng: -41.5846875,
    lat: -21.3100551
  },
  {
    lng: -41.5847309,
    lat: -21.3099141
  },
  {
    lng: -41.5846845,
    lat: -21.3097987
  },
  {
    lng: -41.5845244,
    lat: -21.309603
  },
  {
    lng: -41.584404,
    lat: -21.3097252
  },
  {
    lng: -41.584345,
    lat: -21.3097721
  },
  {
    lng: -41.5842231,
    lat: -21.3096274
  },
  {
    lng: -41.5842404,
    lat: -21.3095744
  },
  {
    lng: -41.5841658,
    lat: -21.3093682
  },
  {
    lng: -41.5840841,
    lat: -21.309491
  },
  {
    lng: -41.5839771,
    lat: -21.3095108
  },
  {
    lng: -41.5839725,
    lat: -21.3095116
  },
  {
    lng: -41.5839501,
    lat: -21.3094368
  },
  {
    lng: -41.5838144,
    lat: -21.3094089
  },
  {
    lng: -41.5837319,
    lat: -21.3094351
  },
  {
    lng: -41.5836211,
    lat: -21.3092343
  },
  {
    lng: -41.5834406,
    lat: -21.309177
  },
  {
    lng: -41.5832945,
    lat: -21.3091953
  },
  {
    lng: -41.583104,
    lat: -21.3092387
  },
  {
    lng: -41.5828733,
    lat: -21.3092414
  },
  {
    lng: -41.5826557,
    lat: -21.3090367
  },
  {
    lng: -41.5824592,
    lat: -21.3088649
  },
  {
    lng: -41.5823062,
    lat: -21.3086498
  },
  {
    lng: -41.5820711,
    lat: -21.3084683
  },
  {
    lng: -41.5818869,
    lat: -21.3083513
  },
  {
    lng: -41.5817481,
    lat: -21.308293
  },
  {
    lng: -41.5817265,
    lat: -21.308284
  },
  {
    lng: -41.5817369,
    lat: -21.3081719
  },
  {
    lng: -41.5816018,
    lat: -21.3080999
  },
  {
    lng: -41.581405,
    lat: -21.3080531
  },
  {
    lng: -41.5812175,
    lat: -21.3079011
  },
  {
    lng: -41.5811089,
    lat: -21.307813
  },
  {
    lng: -41.5810253,
    lat: -21.3076897
  },
  {
    lng: -41.5807859,
    lat: -21.307639
  },
  {
    lng: -41.5806301,
    lat: -21.3076703
  },
  {
    lng: -41.5804472,
    lat: -21.3075981
  },
  {
    lng: -41.5803146,
    lat: -21.3074968
  },
  {
    lng: -41.5800981,
    lat: -21.3075357
  },
  {
    lng: -41.5800665,
    lat: -21.3075348
  },
  {
    lng: -41.5799752,
    lat: -21.3075321
  },
  {
    lng: -41.579771,
    lat: -21.307496
  },
  {
    lng: -41.5795137,
    lat: -21.3074962
  },
  {
    lng: -41.5793397,
    lat: -21.3075109
  },
  {
    lng: -41.579288,
    lat: -21.3075152
  },
  {
    lng: -41.5792131,
    lat: -21.3074737
  },
  {
    lng: -41.5790862,
    lat: -21.3074632
  },
  {
    lng: -41.5790676,
    lat: -21.3073887
  },
  {
    lng: -41.579241,
    lat: -21.3073771
  },
  {
    lng: -41.5793154,
    lat: -21.3073495
  },
  {
    lng: -41.5791093,
    lat: -21.3072497
  },
  {
    lng: -41.5790323,
    lat: -21.3071742
  },
  {
    lng: -41.5790023,
    lat: -21.3070774
  },
  {
    lng: -41.5787905,
    lat: -21.3069698
  },
  {
    lng: -41.5786924,
    lat: -21.3068525
  },
  {
    lng: -41.5786198,
    lat: -21.3067639
  },
  {
    lng: -41.5784722,
    lat: -21.3066105
  },
  {
    lng: -41.5784596,
    lat: -21.3066183
  },
  {
    lng: -41.5782767,
    lat: -21.3067312
  },
  {
    lng: -41.5780629,
    lat: -21.3067587
  },
  {
    lng: -41.5780499,
    lat: -21.3067555
  },
  {
    lng: -41.5778233,
    lat: -21.3066981
  },
  {
    lng: -41.5775633,
    lat: -21.3066244
  },
  {
    lng: -41.5773183,
    lat: -21.3065983
  },
  {
    lng: -41.5769498,
    lat: -21.3064927
  },
  {
    lng: -41.5769199,
    lat: -21.3064908
  },
  {
    lng: -41.5765097,
    lat: -21.3063985
  },
  {
    lng: -41.576437,
    lat: -21.3063561
  },
  {
    lng: -41.5763489,
    lat: -21.3062915
  },
  {
    lng: -41.5759693,
    lat: -21.3062646
  },
  {
    lng: -41.5756348,
    lat: -21.3062785
  },
  {
    lng: -41.5754947,
    lat: -21.3062564
  },
  {
    lng: -41.5754393,
    lat: -21.3061883
  },
  {
    lng: -41.5752746,
    lat: -21.3061811
  },
  {
    lng: -41.5750775,
    lat: -21.3060931
  },
  {
    lng: -41.5748549,
    lat: -21.3060841
  },
  {
    lng: -41.5745811,
    lat: -21.3058257
  },
  {
    lng: -41.5745183,
    lat: -21.3057154
  },
  {
    lng: -41.5743061,
    lat: -21.3054318
  },
  {
    lng: -41.5741582,
    lat: -21.3053041
  },
  {
    lng: -41.5741325,
    lat: -21.3052818
  },
  {
    lng: -41.5738666,
    lat: -21.30502
  },
  {
    lng: -41.5737566,
    lat: -21.304865
  },
  {
    lng: -41.5736364,
    lat: -21.3048191
  },
  {
    lng: -41.5734405,
    lat: -21.3048817
  },
  {
    lng: -41.5732753,
    lat: -21.3048578
  },
  {
    lng: -41.5730579,
    lat: -21.3047061
  },
  {
    lng: -41.5729924,
    lat: -21.3045994
  },
  {
    lng: -41.5729486,
    lat: -21.3044564
  },
  {
    lng: -41.5729555,
    lat: -21.3042272
  },
  {
    lng: -41.5728631,
    lat: -21.3041584
  },
  {
    lng: -41.5726643,
    lat: -21.3039713
  },
  {
    lng: -41.5726043,
    lat: -21.3038996
  },
  {
    lng: -41.5722916,
    lat: -21.3036862
  },
  {
    lng: -41.5722802,
    lat: -21.3036797
  },
  {
    lng: -41.5722022,
    lat: -21.3038111
  },
  {
    lng: -41.5721034,
    lat: -21.3038882
  },
  {
    lng: -41.5719052,
    lat: -21.3039955
  },
  {
    lng: -41.5717828,
    lat: -21.3040163
  },
  {
    lng: -41.5715966,
    lat: -21.3040745
  },
  {
    lng: -41.5715109,
    lat: -21.3042185
  },
  {
    lng: -41.5713766,
    lat: -21.3042013
  },
  {
    lng: -41.571081,
    lat: -21.3041923
  },
  {
    lng: -41.570827,
    lat: -21.3042194
  },
  {
    lng: -41.5706514,
    lat: -21.3041717
  },
  {
    lng: -41.5705141,
    lat: -21.3041131
  },
  {
    lng: -41.5703849,
    lat: -21.3039904
  },
  {
    lng: -41.5702524,
    lat: -21.3039177
  },
  {
    lng: -41.5702476,
    lat: -21.3037747
  },
  {
    lng: -41.5702374,
    lat: -21.3036393
  },
  {
    lng: -41.5701165,
    lat: -21.3036296
  },
  {
    lng: -41.5702421,
    lat: -21.3034316
  },
  {
    lng: -41.570244,
    lat: -21.3033449
  },
  {
    lng: -41.5702233,
    lat: -21.3033387
  },
  {
    lng: -41.570139,
    lat: -21.3033137
  },
  {
    lng: -41.5698292,
    lat: -21.3033797
  },
  {
    lng: -41.5696212,
    lat: -21.3033774
  },
  {
    lng: -41.5695593,
    lat: -21.3034512
  },
  {
    lng: -41.569405,
    lat: -21.303544
  },
  {
    lng: -41.5691734,
    lat: -21.3036791
  },
  {
    lng: -41.5690113,
    lat: -21.3038027
  },
  {
    lng: -41.5686833,
    lat: -21.3036127
  },
  {
    lng: -41.5686712,
    lat: -21.3035971
  },
  {
    lng: -41.5684903,
    lat: -21.3035415
  },
  {
    lng: -41.5684485,
    lat: -21.3033556
  },
  {
    lng: -41.5683423,
    lat: -21.3033232
  },
  {
    lng: -41.5680571,
    lat: -21.3031989
  },
  {
    lng: -41.5678044,
    lat: -21.3032116
  },
  {
    lng: -41.5676126,
    lat: -21.3031362
  },
  {
    lng: -41.5673919,
    lat: -21.3030378
  },
  {
    lng: -41.5671135,
    lat: -21.3030623
  },
  {
    lng: -41.5670519,
    lat: -21.3030707
  },
  {
    lng: -41.5667249,
    lat: -21.3031157
  },
  {
    lng: -41.5666893,
    lat: -21.3031143
  },
  {
    lng: -41.5666449,
    lat: -21.3030653
  },
  {
    lng: -41.5667882,
    lat: -21.3028651
  },
  {
    lng: -41.5666977,
    lat: -21.3027647
  },
  {
    lng: -41.5664922,
    lat: -21.3027346
  },
  {
    lng: -41.5663546,
    lat: -21.3028031
  },
  {
    lng: -41.5662453,
    lat: -21.3027084
  },
  {
    lng: -41.5661748,
    lat: -21.3024069
  },
  {
    lng: -41.5659171,
    lat: -21.3022824
  },
  {
    lng: -41.5658241,
    lat: -21.3022363
  },
  {
    lng: -41.5657471,
    lat: -21.3021141
  },
  {
    lng: -41.5655605,
    lat: -21.3021101
  },
  {
    lng: -41.5655068,
    lat: -21.3019909
  },
  {
    lng: -41.5655677,
    lat: -21.3018225
  },
  {
    lng: -41.5654739,
    lat: -21.3017263
  },
  {
    lng: -41.5652331,
    lat: -21.301647
  },
  {
    lng: -41.5651152,
    lat: -21.3016417
  },
  {
    lng: -41.5650864,
    lat: -21.3016404
  },
  {
    lng: -41.5647494,
    lat: -21.3014841
  },
  {
    lng: -41.5645799,
    lat: -21.3014978
  },
  {
    lng: -41.5645424,
    lat: -21.3013319
  },
  {
    lng: -41.5646738,
    lat: -21.3012457
  },
  {
    lng: -41.5647078,
    lat: -21.3011338
  },
  {
    lng: -41.5645277,
    lat: -21.3010113
  },
  {
    lng: -41.5643886,
    lat: -21.3008768
  },
  {
    lng: -41.5643304,
    lat: -21.3007495
  },
  {
    lng: -41.5642519,
    lat: -21.3005997
  },
  {
    lng: -41.564182,
    lat: -21.3004695
  },
  {
    lng: -41.5640847,
    lat: -21.300407
  },
  {
    lng: -41.5640169,
    lat: -21.3004146
  },
  {
    lng: -41.563959,
    lat: -21.3005013
  },
  {
    lng: -41.5638179,
    lat: -21.3005586
  },
  {
    lng: -41.563638,
    lat: -21.3005441
  },
  {
    lng: -41.5635856,
    lat: -21.3005086
  },
  {
    lng: -41.5635954,
    lat: -21.3003753
  },
  {
    lng: -41.5636669,
    lat: -21.3002092
  },
  {
    lng: -41.5635358,
    lat: -21.3001091
  },
  {
    lng: -41.5634786,
    lat: -21.3000315
  },
  {
    lng: -41.5635211,
    lat: -21.2999007
  },
  {
    lng: -41.5635432,
    lat: -21.2997939
  },
  {
    lng: -41.5634415,
    lat: -21.2996847
  },
  {
    lng: -41.5633837,
    lat: -21.2996542
  },
  {
    lng: -41.5633649,
    lat: -21.2996588
  },
  {
    lng: -41.5633794,
    lat: -21.2997647
  },
  {
    lng: -41.5633522,
    lat: -21.2998238
  },
  {
    lng: -41.5633002,
    lat: -21.2998009
  },
  {
    lng: -41.5632217,
    lat: -21.2996898
  },
  {
    lng: -41.5630874,
    lat: -21.2997364
  },
  {
    lng: -41.5630215,
    lat: -21.2997287
  },
  {
    lng: -41.5629615,
    lat: -21.2996458
  },
  {
    lng: -41.5629076,
    lat: -21.2995745
  },
  {
    lng: -41.5626619,
    lat: -21.299535
  },
  {
    lng: -41.562388,
    lat: -21.299416
  },
  {
    lng: -41.5621664,
    lat: -21.2993889
  },
  {
    lng: -41.56183,
    lat: -21.2992458
  },
  {
    lng: -41.5618174,
    lat: -21.2991786
  },
  {
    lng: -41.5614928,
    lat: -21.2990882
  },
  {
    lng: -41.5613635,
    lat: -21.2990382
  },
  {
    lng: -41.5613253,
    lat: -21.2990234
  },
  {
    lng: -41.5612154,
    lat: -21.2990661
  },
  {
    lng: -41.5611174,
    lat: -21.2991668
  },
  {
    lng: -41.5610105,
    lat: -21.2991578
  },
  {
    lng: -41.5609605,
    lat: -21.2991882
  },
  {
    lng: -41.5608597,
    lat: -21.2992191
  },
  {
    lng: -41.5605944,
    lat: -21.2991859
  },
  {
    lng: -41.560487,
    lat: -21.2991933
  },
  {
    lng: -41.5604299,
    lat: -21.2991582
  },
  {
    lng: -41.5603858,
    lat: -21.2991186
  },
  {
    lng: -41.5601486,
    lat: -21.2989822
  },
  {
    lng: -41.5598034,
    lat: -21.2988189
  },
  {
    lng: -41.5594405,
    lat: -21.2986899
  },
  {
    lng: -41.5590638,
    lat: -21.2985799
  },
  {
    lng: -41.5587809,
    lat: -21.298514
  },
  {
    lng: -41.5587645,
    lat: -21.298481
  },
  {
    lng: -41.5587839,
    lat: -21.2984169
  },
  {
    lng: -41.5587444,
    lat: -21.2983494
  },
  {
    lng: -41.5586739,
    lat: -21.2982984
  },
  {
    lng: -41.5586199,
    lat: -21.2983129
  },
  {
    lng: -41.5585478,
    lat: -21.2982453
  },
  {
    lng: -41.5584287,
    lat: -21.2979278
  },
  {
    lng: -41.5582357,
    lat: -21.2977469
  },
  {
    lng: -41.5580598,
    lat: -21.297774
  },
  {
    lng: -41.5577611,
    lat: -21.2977621
  },
  {
    lng: -41.5577755,
    lat: -21.2978571
  },
  {
    lng: -41.5577943,
    lat: -21.29792
  },
  {
    lng: -41.5577974,
    lat: -21.2979301
  },
  {
    lng: -41.5577426,
    lat: -21.2980381
  },
  {
    lng: -41.5576678,
    lat: -21.2980703
  },
  {
    lng: -41.5575049,
    lat: -21.2978892
  },
  {
    lng: -41.557412,
    lat: -21.2977952
  },
  {
    lng: -41.55732,
    lat: -21.2977444
  },
  {
    lng: -41.5569341,
    lat: -21.2977211
  },
  {
    lng: -41.5568881,
    lat: -21.2977291
  },
  {
    lng: -41.5567195,
    lat: -21.2977019
  },
  {
    lng: -41.556515,
    lat: -21.2975084
  },
  {
    lng: -41.5564468,
    lat: -21.2974439
  },
  {
    lng: -41.5564003,
    lat: -21.2973036
  },
  {
    lng: -41.5564021,
    lat: -21.2972407
  },
  {
    lng: -41.556348,
    lat: -21.2971461
  },
  {
    lng: -41.5562793,
    lat: -21.2971148
  },
  {
    lng: -41.5561276,
    lat: -21.2971349
  },
  {
    lng: -41.5559537,
    lat: -21.2970582
  },
  {
    lng: -41.555839,
    lat: -21.2969834
  },
  {
    lng: -41.5557527,
    lat: -21.2968509
  },
  {
    lng: -41.5556862,
    lat: -21.2968224
  },
  {
    lng: -41.5556079,
    lat: -21.2968131
  },
  {
    lng: -41.5553862,
    lat: -21.2966927
  },
  {
    lng: -41.5550976,
    lat: -21.2964469
  },
  {
    lng: -41.555091,
    lat: -21.2964441
  },
  {
    lng: -41.5547567,
    lat: -21.2962551
  },
  {
    lng: -41.554388,
    lat: -21.2963821
  },
  {
    lng: -41.5540131,
    lat: -21.2964893
  },
  {
    lng: -41.5539803,
    lat: -21.2964891
  },
  {
    lng: -41.5538653,
    lat: -21.2965119
  },
  {
    lng: -41.5538017,
    lat: -21.2964514
  },
  {
    lng: -41.5537659,
    lat: -21.2963598
  },
  {
    lng: -41.5536832,
    lat: -21.2963516
  },
  {
    lng: -41.5535397,
    lat: -21.2963694
  },
  {
    lng: -41.5534616,
    lat: -21.2963049
  },
  {
    lng: -41.5533791,
    lat: -21.2961352
  },
  {
    lng: -41.5534059,
    lat: -21.2960296
  },
  {
    lng: -41.5535617,
    lat: -21.295986
  },
  {
    lng: -41.5537449,
    lat: -21.2959268
  },
  {
    lng: -41.5537105,
    lat: -21.2957853
  },
  {
    lng: -41.5537269,
    lat: -21.2956636
  },
  {
    lng: -41.5536606,
    lat: -21.2955932
  },
  {
    lng: -41.5535446,
    lat: -21.2956304
  },
  {
    lng: -41.5533031,
    lat: -21.2955792
  },
  {
    lng: -41.5531593,
    lat: -21.2955575
  },
  {
    lng: -41.5529972,
    lat: -21.2955709
  },
  {
    lng: -41.55287,
    lat: -21.2956517
  },
  {
    lng: -41.5527516,
    lat: -21.2956283
  },
  {
    lng: -41.5527508,
    lat: -21.2953331
  },
  {
    lng: -41.5527078,
    lat: -21.2952816
  },
  {
    lng: -41.5526099,
    lat: -21.2951371
  },
  {
    lng: -41.552642,
    lat: -21.2948695
  },
  {
    lng: -41.55261,
    lat: -21.2947897
  },
  {
    lng: -41.5524636,
    lat: -21.2948131
  },
  {
    lng: -41.5522912,
    lat: -21.2947764
  },
  {
    lng: -41.552109,
    lat: -21.2948529
  },
  {
    lng: -41.5520646,
    lat: -21.294839
  },
  {
    lng: -41.5520338,
    lat: -21.2948294
  },
  {
    lng: -41.5519479,
    lat: -21.2946896
  },
  {
    lng: -41.5519644,
    lat: -21.2945725
  },
  {
    lng: -41.5520283,
    lat: -21.2943258
  },
  {
    lng: -41.5520318,
    lat: -21.2942582
  },
  {
    lng: -41.5519957,
    lat: -21.294197
  },
  {
    lng: -41.5517216,
    lat: -21.2939762
  },
  {
    lng: -41.551585,
    lat: -21.2938336
  },
  {
    lng: -41.55148,
    lat: -21.2938068
  },
  {
    lng: -41.5513449,
    lat: -21.2938234
  },
  {
    lng: -41.5511748,
    lat: -21.2937313
  },
  {
    lng: -41.5508751,
    lat: -21.2936822
  },
  {
    lng: -41.5507141,
    lat: -21.2935183
  },
  {
    lng: -41.5505487,
    lat: -21.2934094
  },
  {
    lng: -41.5502464,
    lat: -21.2933864
  },
  {
    lng: -41.5500931,
    lat: -21.2934196
  },
  {
    lng: -41.5500412,
    lat: -21.2932406
  },
  {
    lng: -41.5500472,
    lat: -21.2930997
  },
  {
    lng: -41.5499711,
    lat: -21.293022
  },
  {
    lng: -41.5498766,
    lat: -21.2930325
  },
  {
    lng: -41.5498087,
    lat: -21.2930985
  },
  {
    lng: -41.5496136,
    lat: -21.2931501
  },
  {
    lng: -41.5496039,
    lat: -21.2931401
  },
  {
    lng: -41.5495003,
    lat: -21.2930331
  },
  {
    lng: -41.5494445,
    lat: -21.292932
  },
  {
    lng: -41.5495153,
    lat: -21.2928356
  },
  {
    lng: -41.5494148,
    lat: -21.2927971
  },
  {
    lng: -41.5493114,
    lat: -21.2928198
  },
  {
    lng: -41.5492267,
    lat: -21.2927841
  },
  {
    lng: -41.5491786,
    lat: -21.2927119
  },
  {
    lng: -41.549194,
    lat: -21.2926009
  },
  {
    lng: -41.5492861,
    lat: -21.2924896
  },
  {
    lng: -41.5491492,
    lat: -21.2925032
  },
  {
    lng: -41.5490645,
    lat: -21.292465
  },
  {
    lng: -41.5490753,
    lat: -21.2921929
  },
  {
    lng: -41.5488436,
    lat: -21.2920749
  },
  {
    lng: -41.5487111,
    lat: -21.2919942
  },
  {
    lng: -41.5486609,
    lat: -21.2918054
  },
  {
    lng: -41.5487374,
    lat: -21.2916894
  },
  {
    lng: -41.5488097,
    lat: -21.2915149
  },
  {
    lng: -41.5488197,
    lat: -21.29134
  },
  {
    lng: -41.5487084,
    lat: -21.2912436
  },
  {
    lng: -41.5486752,
    lat: -21.2911873
  },
  {
    lng: -41.5485821,
    lat: -21.2911315
  },
  {
    lng: -41.5486393,
    lat: -21.2909277
  },
  {
    lng: -41.5486301,
    lat: -21.2908512
  },
  {
    lng: -41.5485753,
    lat: -21.2906081
  },
  {
    lng: -41.5484971,
    lat: -21.2904957
  },
  {
    lng: -41.5483814,
    lat: -21.2905063
  },
  {
    lng: -41.5482729,
    lat: -21.2902806
  },
  {
    lng: -41.5480077,
    lat: -21.2902373
  },
  {
    lng: -41.5477223,
    lat: -21.2901946
  },
  {
    lng: -41.5475872,
    lat: -21.2898685
  },
  {
    lng: -41.5472818,
    lat: -21.2896345
  },
  {
    lng: -41.5470535,
    lat: -21.2894845
  },
  {
    lng: -41.5468566,
    lat: -21.2895058
  },
  {
    lng: -41.5466659,
    lat: -21.2894874
  },
  {
    lng: -41.5463731,
    lat: -21.2892847
  },
  {
    lng: -41.5462968,
    lat: -21.2892314
  },
  {
    lng: -41.5461782,
    lat: -21.2892388
  },
  {
    lng: -41.5461015,
    lat: -21.2892525
  },
  {
    lng: -41.5460497,
    lat: -21.289229
  },
  {
    lng: -41.546069,
    lat: -21.2891744
  },
  {
    lng: -41.5459048,
    lat: -21.2889161
  },
  {
    lng: -41.5459095,
    lat: -21.2887062
  },
  {
    lng: -41.5459355,
    lat: -21.2886664
  },
  {
    lng: -41.5460626,
    lat: -21.2886272
  },
  {
    lng: -41.5461053,
    lat: -21.2886221
  },
  {
    lng: -41.5461048,
    lat: -21.2885643
  },
  {
    lng: -41.5459838,
    lat: -21.2884422
  },
  {
    lng: -41.5458101,
    lat: -21.288352
  },
  {
    lng: -41.5456267,
    lat: -21.2883405
  },
  {
    lng: -41.5455336,
    lat: -21.2882985
  },
  {
    lng: -41.5455535,
    lat: -21.2881778
  },
  {
    lng: -41.5456129,
    lat: -21.2880257
  },
  {
    lng: -41.5455951,
    lat: -21.287986
  },
  {
    lng: -41.5455487,
    lat: -21.2878824
  },
  {
    lng: -41.5454648,
    lat: -21.2877712
  },
  {
    lng: -41.5455288,
    lat: -21.2876858
  },
  {
    lng: -41.5455786,
    lat: -21.2875818
  },
  {
    lng: -41.5455697,
    lat: -21.2874728
  },
  {
    lng: -41.5455093,
    lat: -21.2874096
  },
  {
    lng: -41.5453569,
    lat: -21.2873961
  },
  {
    lng: -41.5452735,
    lat: -21.2873941
  },
  {
    lng: -41.5452415,
    lat: -21.2872948
  },
  {
    lng: -41.5451692,
    lat: -21.2872468
  },
  {
    lng: -41.5450573,
    lat: -21.2872484
  },
  {
    lng: -41.5448694,
    lat: -21.2871688
  },
  {
    lng: -41.5448066,
    lat: -21.28701
  },
  {
    lng: -41.5447062,
    lat: -21.2869011
  },
  {
    lng: -41.5446561,
    lat: -21.2868107
  },
  {
    lng: -41.5446206,
    lat: -21.2867027
  },
  {
    lng: -41.5444477,
    lat: -21.2866693
  },
  {
    lng: -41.5442477,
    lat: -21.2864653
  },
  {
    lng: -41.5441685,
    lat: -21.2862724
  },
  {
    lng: -41.5439648,
    lat: -21.2863299
  },
  {
    lng: -41.5438871,
    lat: -21.2862577
  },
  {
    lng: -41.5438939,
    lat: -21.285895
  },
  {
    lng: -41.5439401,
    lat: -21.2855332
  },
  {
    lng: -41.5439355,
    lat: -21.2854111
  },
  {
    lng: -41.5437784,
    lat: -21.2853752
  },
  {
    lng: -41.5435599,
    lat: -21.2853722
  },
  {
    lng: -41.5434623,
    lat: -21.2853502
  },
  {
    lng: -41.5434217,
    lat: -21.285301
  },
  {
    lng: -41.5433919,
    lat: -21.2852344
  },
  {
    lng: -41.5433302,
    lat: -21.2852047
  },
  {
    lng: -41.5431668,
    lat: -21.2852379
  },
  {
    lng: -41.5429948,
    lat: -21.2852213
  },
  {
    lng: -41.5428786,
    lat: -21.285179
  },
  {
    lng: -41.5428625,
    lat: -21.2850776
  },
  {
    lng: -41.5427499,
    lat: -21.2848115
  },
  {
    lng: -41.5427441,
    lat: -21.2845275
  },
  {
    lng: -41.5426409,
    lat: -21.2844809
  },
  {
    lng: -41.5423102,
    lat: -21.2844741
  },
  {
    lng: -41.5422404,
    lat: -21.2844006
  },
  {
    lng: -41.5422045,
    lat: -21.2842038
  },
  {
    lng: -41.5421763,
    lat: -21.284152
  },
  {
    lng: -41.5421499,
    lat: -21.2841037
  },
  {
    lng: -41.5421428,
    lat: -21.2840234
  },
  {
    lng: -41.5421276,
    lat: -21.2839996
  },
  {
    lng: -41.5421061,
    lat: -21.2840068
  },
  {
    lng: -41.5420832,
    lat: -21.284028
  },
  {
    lng: -41.5420647,
    lat: -21.2840597
  },
  {
    lng: -41.5420047,
    lat: -21.2840974
  },
  {
    lng: -41.5419401,
    lat: -21.284115
  },
  {
    lng: -41.5418736,
    lat: -21.2841028
  },
  {
    lng: -41.5418061,
    lat: -21.2840379
  },
  {
    lng: -41.5417533,
    lat: -21.2839605
  },
  {
    lng: -41.5417171,
    lat: -21.2837268
  },
  {
    lng: -41.541694,
    lat: -21.2836335
  },
  {
    lng: -41.5415618,
    lat: -21.2833435
  },
  {
    lng: -41.5415395,
    lat: -21.2833086
  },
  {
    lng: -41.5414729,
    lat: -21.2832885
  },
  {
    lng: -41.5413975,
    lat: -21.2833158
  },
  {
    lng: -41.541271,
    lat: -21.2833627
  },
  {
    lng: -41.541238,
    lat: -21.2833801
  },
  {
    lng: -41.5411627,
    lat: -21.2834053
  },
  {
    lng: -41.5410415,
    lat: -21.283428
  },
  {
    lng: -41.540955,
    lat: -21.2834415
  },
  {
    lng: -41.5408381,
    lat: -21.2834711
  },
  {
    lng: -41.5407694,
    lat: -21.2834584
  },
  {
    lng: -41.5407066,
    lat: -21.2834494
  },
  {
    lng: -41.5406953,
    lat: -21.2833977
  },
  {
    lng: -41.5407142,
    lat: -21.2833432
  },
  {
    lng: -41.5407652,
    lat: -21.2833053
  },
  {
    lng: -41.5409017,
    lat: -21.2832764
  },
  {
    lng: -41.5410046,
    lat: -21.2832438
  },
  {
    lng: -41.541159,
    lat: -21.2830372
  },
  {
    lng: -41.5411637,
    lat: -21.2829114
  },
  {
    lng: -41.5411331,
    lat: -21.2828208
  },
  {
    lng: -41.5410255,
    lat: -21.2826538
  },
  {
    lng: -41.5409804,
    lat: -21.2825896
  },
  {
    lng: -41.5408926,
    lat: -21.2825751
  },
  {
    lng: -41.5407808,
    lat: -21.2826089
  },
  {
    lng: -41.5406886,
    lat: -21.282712
  },
  {
    lng: -41.5406641,
    lat: -21.2828648
  },
  {
    lng: -41.5407231,
    lat: -21.2828793
  },
  {
    lng: -41.5407693,
    lat: -21.2828938
  },
  {
    lng: -41.5407663,
    lat: -21.2829252
  },
  {
    lng: -41.5407168,
    lat: -21.2829659
  },
  {
    lng: -41.5406425,
    lat: -21.2829863
  },
  {
    lng: -41.540549,
    lat: -21.2829755
  },
  {
    lng: -41.5405486,
    lat: -21.2829531
  },
  {
    lng: -41.5405604,
    lat: -21.2828491
  },
  {
    lng: -41.5405046,
    lat: -21.2827656
  },
  {
    lng: -41.5405033,
    lat: -21.2827635
  },
  {
    lng: -41.5404577,
    lat: -21.2827363
  },
  {
    lng: -41.5403743,
    lat: -21.2826974
  },
  {
    lng: -41.5403409,
    lat: -21.2826527
  },
  {
    lng: -41.540399,
    lat: -21.2825497
  },
  {
    lng: -41.5404722,
    lat: -21.2823891
  },
  {
    lng: -41.5404872,
    lat: -21.2823021
  },
  {
    lng: -41.5404711,
    lat: -21.2822482
  },
  {
    lng: -41.5403951,
    lat: -21.2821717
  },
  {
    lng: -41.5403341,
    lat: -21.282156
  },
  {
    lng: -41.5401858,
    lat: -21.2821422
  },
  {
    lng: -41.5400787,
    lat: -21.2821258
  },
  {
    lng: -41.5399342,
    lat: -21.2821207
  },
  {
    lng: -41.5398482,
    lat: -21.2820813
  },
  {
    lng: -41.5398221,
    lat: -21.2820332
  },
  {
    lng: -41.5398344,
    lat: -21.2819546
  },
  {
    lng: -41.5398758,
    lat: -21.2818516
  },
  {
    lng: -41.5398968,
    lat: -21.2817014
  },
  {
    lng: -41.5399012,
    lat: -21.2816085
  },
  {
    lng: -41.539894,
    lat: -21.2815239
  },
  {
    lng: -41.5398825,
    lat: -21.2814889
  },
  {
    lng: -41.5397884,
    lat: -21.2814352
  },
  {
    lng: -41.5396473,
    lat: -21.2813791
  },
  {
    lng: -41.5395031,
    lat: -21.2813512
  },
  {
    lng: -41.5393704,
    lat: -21.2813018
  },
  {
    lng: -41.5393047,
    lat: -21.2813017
  },
  {
    lng: -41.5390197,
    lat: -21.2812469
  },
  {
    lng: -41.53887,
    lat: -21.2811502
  },
  {
    lng: -41.5387541,
    lat: -21.2810581
  },
  {
    lng: -41.5386897,
    lat: -21.2809889
  },
  {
    lng: -41.5386892,
    lat: -21.2808882
  },
  {
    lng: -41.5385844,
    lat: -21.2808506
  },
  {
    lng: -41.5385394,
    lat: -21.2807458
  },
  {
    lng: -41.5384919,
    lat: -21.2806955
  },
  {
    lng: -41.538325,
    lat: -21.2807188
  },
  {
    lng: -41.5382988,
    lat: -21.2807051
  },
  {
    lng: -41.5381537,
    lat: -21.2805735
  },
  {
    lng: -41.5379808,
    lat: -21.2805585
  },
  {
    lng: -41.5379313,
    lat: -21.2805842
  },
  {
    lng: -41.5378206,
    lat: -21.280635
  },
  {
    lng: -41.5377377,
    lat: -21.2805891
  },
  {
    lng: -41.5377743,
    lat: -21.2805003
  },
  {
    lng: -41.5377025,
    lat: -21.2803307
  },
  {
    lng: -41.537718,
    lat: -21.2802328
  },
  {
    lng: -41.537744,
    lat: -21.2801517
  },
  {
    lng: -41.5376376,
    lat: -21.2800624
  },
  {
    lng: -41.5375215,
    lat: -21.2799699
  },
  {
    lng: -41.5374341,
    lat: -21.2799138
  },
  {
    lng: -41.5373165,
    lat: -21.2798223
  },
  {
    lng: -41.5371896,
    lat: -21.2797379
  },
  {
    lng: -41.537073,
    lat: -21.2796978
  },
  {
    lng: -41.5370177,
    lat: -21.2797716
  },
  {
    lng: -41.5370122,
    lat: -21.2798856
  },
  {
    lng: -41.5371413,
    lat: -21.2799626
  },
  {
    lng: -41.5373351,
    lat: -21.2800059
  },
  {
    lng: -41.5373346,
    lat: -21.2800799
  },
  {
    lng: -41.5373917,
    lat: -21.2802066
  },
  {
    lng: -41.5374281,
    lat: -21.2802915
  },
  {
    lng: -41.5373893,
    lat: -21.2803849
  },
  {
    lng: -41.5372778,
    lat: -21.2803908
  },
  {
    lng: -41.5371915,
    lat: -21.2803336
  },
  {
    lng: -41.5371271,
    lat: -21.2802579
  },
  {
    lng: -41.5370611,
    lat: -21.2802533
  },
  {
    lng: -41.5370282,
    lat: -21.2802783
  },
  {
    lng: -41.5370478,
    lat: -21.2803588
  },
  {
    lng: -41.5370708,
    lat: -21.2804564
  },
  {
    lng: -41.5370288,
    lat: -21.2805709
  },
  {
    lng: -41.5369802,
    lat: -21.2805888
  },
  {
    lng: -41.5368861,
    lat: -21.2806838
  },
  {
    lng: -41.5367901,
    lat: -21.2807313
  },
  {
    lng: -41.5366473,
    lat: -21.2807683
  },
  {
    lng: -41.5365023,
    lat: -21.2807639
  },
  {
    lng: -41.5364538,
    lat: -21.2807954
  },
  {
    lng: -41.5364329,
    lat: -21.2809469
  },
  {
    lng: -41.5363502,
    lat: -21.2810412
  },
  {
    lng: -41.5363163,
    lat: -21.2812552
  },
  {
    lng: -41.5362519,
    lat: -21.281334
  },
  {
    lng: -41.5360978,
    lat: -21.2813513
  },
  {
    lng: -41.5360206,
    lat: -21.2813334
  },
  {
    lng: -41.5359182,
    lat: -21.2812864
  },
  {
    lng: -41.5358299,
    lat: -21.2813497
  },
  {
    lng: -41.5357818,
    lat: -21.2813419
  },
  {
    lng: -41.5357537,
    lat: -21.2813373
  },
  {
    lng: -41.5355964,
    lat: -21.2812226
  },
  {
    lng: -41.5355776,
    lat: -21.2811954
  },
  {
    lng: -41.5355733,
    lat: -21.2811422
  },
  {
    lng: -41.5355083,
    lat: -21.2809216
  },
  {
    lng: -41.5354653,
    lat: -21.2807678
  },
  {
    lng: -41.5353966,
    lat: -21.2806476
  },
  {
    lng: -41.5353086,
    lat: -21.280667
  },
  {
    lng: -41.535223,
    lat: -21.28065
  },
  {
    lng: -41.5352089,
    lat: -21.2805276
  },
  {
    lng: -41.5352692,
    lat: -21.2804726
  },
  {
    lng: -41.5353184,
    lat: -21.2804157
  },
  {
    lng: -41.53531,
    lat: -21.280338
  },
  {
    lng: -41.5352801,
    lat: -21.2802644
  },
  {
    lng: -41.5352538,
    lat: -21.2801854
  },
  {
    lng: -41.5352017,
    lat: -21.2801135
  },
  {
    lng: -41.5350964,
    lat: -21.280121
  },
  {
    lng: -41.5350074,
    lat: -21.2801311
  },
  {
    lng: -41.5348714,
    lat: -21.2800833
  },
  {
    lng: -41.5347137,
    lat: -21.2800797
  },
  {
    lng: -41.5345523,
    lat: -21.2800504
  },
  {
    lng: -41.5345197,
    lat: -21.2800578
  },
  {
    lng: -41.5344508,
    lat: -21.2800231
  },
  {
    lng: -41.534454,
    lat: -21.2799085
  },
  {
    lng: -41.5344122,
    lat: -21.2798826
  },
  {
    lng: -41.5343139,
    lat: -21.2798217
  },
  {
    lng: -41.5340854,
    lat: -21.2797576
  },
  {
    lng: -41.533941,
    lat: -21.2797089
  },
  {
    lng: -41.5338724,
    lat: -21.2796624
  },
  {
    lng: -41.5338625,
    lat: -21.2795578
  },
  {
    lng: -41.5338031,
    lat: -21.2794058
  },
  {
    lng: -41.5337855,
    lat: -21.2792921
  },
  {
    lng: -41.5338371,
    lat: -21.2791537
  },
  {
    lng: -41.5338132,
    lat: -21.2790493
  },
  {
    lng: -41.5337633,
    lat: -21.2790213
  },
  {
    lng: -41.533663,
    lat: -21.2790313
  },
  {
    lng: -41.5334638,
    lat: -21.2788853
  },
  {
    lng: -41.5333504,
    lat: -21.2788179
  },
  {
    lng: -41.533256,
    lat: -21.2788482
  },
  {
    lng: -41.5331588,
    lat: -21.2788385
  },
  {
    lng: -41.5330814,
    lat: -21.2789645
  },
  {
    lng: -41.5330436,
    lat: -21.2790704
  },
  {
    lng: -41.5329707,
    lat: -21.2791038
  },
  {
    lng: -41.532865,
    lat: -21.2790511
  },
  {
    lng: -41.5328274,
    lat: -21.2788639
  },
  {
    lng: -41.5327831,
    lat: -21.2785937
  },
  {
    lng: -41.5328116,
    lat: -21.2784777
  },
  {
    lng: -41.5329212,
    lat: -21.2784127
  },
  {
    lng: -41.5328736,
    lat: -21.2782889
  },
  {
    lng: -41.5327187,
    lat: -21.2782812
  },
  {
    lng: -41.5326078,
    lat: -21.2783282
  },
  {
    lng: -41.5325431,
    lat: -21.2783864
  },
  {
    lng: -41.5323444,
    lat: -21.2783461
  },
  {
    lng: -41.5322161,
    lat: -21.2782994
  },
  {
    lng: -41.5318485,
    lat: -21.2781902
  },
  {
    lng: -41.5318457,
    lat: -21.2781888
  },
  {
    lng: -41.5317561,
    lat: -21.2781467
  },
  {
    lng: -41.5316443,
    lat: -21.2781131
  },
  {
    lng: -41.5315579,
    lat: -21.2780192
  },
  {
    lng: -41.5313895,
    lat: -21.2780248
  },
  {
    lng: -41.5312924,
    lat: -21.2779411
  },
  {
    lng: -41.5311969,
    lat: -21.2778121
  },
  {
    lng: -41.5311071,
    lat: -21.2777586
  },
  {
    lng: -41.5309974,
    lat: -21.2777497
  },
  {
    lng: -41.5308248,
    lat: -21.2777515
  },
  {
    lng: -41.5306466,
    lat: -21.2778315
  },
  {
    lng: -41.5305091,
    lat: -21.2778932
  },
  {
    lng: -41.5302332,
    lat: -21.2781402
  },
  {
    lng: -41.530055,
    lat: -21.2782899
  },
  {
    lng: -41.5299813,
    lat: -21.2783445
  },
  {
    lng: -41.5298366,
    lat: -21.2783886
  },
  {
    lng: -41.5297412,
    lat: -21.2783541
  },
  {
    lng: -41.5297326,
    lat: -21.2782497
  },
  {
    lng: -41.5298049,
    lat: -21.2781452
  },
  {
    lng: -41.5298474,
    lat: -21.2780758
  },
  {
    lng: -41.5298284,
    lat: -21.2779986
  },
  {
    lng: -41.5298416,
    lat: -21.2779932
  },
  {
    lng: -41.5299729,
    lat: -21.2779664
  },
  {
    lng: -41.5300558,
    lat: -21.277998
  },
  {
    lng: -41.5301063,
    lat: -21.2779585
  },
  {
    lng: -41.5300495,
    lat: -21.277901
  },
  {
    lng: -41.5297603,
    lat: -21.2777769
  },
  {
    lng: -41.5296308,
    lat: -21.2777748
  },
  {
    lng: -41.529501,
    lat: -21.277728
  },
  {
    lng: -41.5294136,
    lat: -21.2776957
  },
  {
    lng: -41.529379,
    lat: -21.2777572
  },
  {
    lng: -41.5294118,
    lat: -21.2778433
  },
  {
    lng: -41.5293713,
    lat: -21.2778763
  },
  {
    lng: -41.5292739,
    lat: -21.2778437
  },
  {
    lng: -41.529238,
    lat: -21.2777702
  },
  {
    lng: -41.5292648,
    lat: -21.2776422
  },
  {
    lng: -41.5293495,
    lat: -21.2776177
  },
  {
    lng: -41.5294745,
    lat: -21.2776003
  },
  {
    lng: -41.5296027,
    lat: -21.2775192
  },
  {
    lng: -41.5296176,
    lat: -21.2774441
  },
  {
    lng: -41.5296072,
    lat: -21.2774224
  },
  {
    lng: -41.5295622,
    lat: -21.2773337
  },
  {
    lng: -41.5293787,
    lat: -21.277323
  },
  {
    lng: -41.5293063,
    lat: -21.2772974
  },
  {
    lng: -41.5291499,
    lat: -21.2773867
  },
  {
    lng: -41.528977,
    lat: -21.2774805
  },
  {
    lng: -41.5288998,
    lat: -21.2775369
  },
  {
    lng: -41.5287862,
    lat: -21.277553
  },
  {
    lng: -41.5287549,
    lat: -21.2775469
  },
  {
    lng: -41.5287375,
    lat: -21.2774938
  },
  {
    lng: -41.5287467,
    lat: -21.2773658
  },
  {
    lng: -41.5287446,
    lat: -21.2772987
  },
  {
    lng: -41.5286813,
    lat: -21.2772835
  },
  {
    lng: -41.5286526,
    lat: -21.2773236
  },
  {
    lng: -41.528668,
    lat: -21.2774704
  },
  {
    lng: -41.5286217,
    lat: -21.2775088
  },
  {
    lng: -41.5285474,
    lat: -21.2774828
  },
  {
    lng: -41.5284313,
    lat: -21.2774423
  },
  {
    lng: -41.5284586,
    lat: -21.2773711
  },
  {
    lng: -41.5285263,
    lat: -21.2773314
  },
  {
    lng: -41.5285764,
    lat: -21.2772482
  },
  {
    lng: -41.5286529,
    lat: -21.2771056
  },
  {
    lng: -41.5287203,
    lat: -21.2770419
  },
  {
    lng: -41.5287763,
    lat: -21.2769917
  },
  {
    lng: -41.528759,
    lat: -21.2769239
  },
  {
    lng: -41.5286273,
    lat: -21.2769256
  },
  {
    lng: -41.5285613,
    lat: -21.2769587
  },
  {
    lng: -41.5285257,
    lat: -21.2770807
  },
  {
    lng: -41.5284017,
    lat: -21.2771494
  },
  {
    lng: -41.5282773,
    lat: -21.2772048
  },
  {
    lng: -41.5282169,
    lat: -21.2772834
  },
  {
    lng: -41.5281213,
    lat: -21.277278
  },
  {
    lng: -41.528062,
    lat: -21.277212
  },
  {
    lng: -41.528112,
    lat: -21.2770999
  },
  {
    lng: -41.5281783,
    lat: -21.2769893
  },
  {
    lng: -41.5282377,
    lat: -21.2768699
  },
  {
    lng: -41.5283647,
    lat: -21.276849
  },
  {
    lng: -41.5284071,
    lat: -21.2767875
  },
  {
    lng: -41.5283903,
    lat: -21.27666
  },
  {
    lng: -41.5284109,
    lat: -21.2765727
  },
  {
    lng: -41.5285134,
    lat: -21.2764956
  },
  {
    lng: -41.5286204,
    lat: -21.2764615
  },
  {
    lng: -41.5286567,
    lat: -21.2764499
  },
  {
    lng: -41.528705,
    lat: -21.2763928
  },
  {
    lng: -41.5286596,
    lat: -21.2763311
  },
  {
    lng: -41.5286923,
    lat: -21.2762734
  },
  {
    lng: -41.5286501,
    lat: -21.2762185
  },
  {
    lng: -41.5284835,
    lat: -21.2761666
  },
  {
    lng: -41.5284343,
    lat: -21.2761558
  },
  {
    lng: -41.5283392,
    lat: -21.2762421
  },
  {
    lng: -41.5281951,
    lat: -21.2762116
  },
  {
    lng: -41.528132,
    lat: -21.2761855
  },
  {
    lng: -41.5280589,
    lat: -21.2761515
  },
  {
    lng: -41.527999,
    lat: -21.2761473
  },
  {
    lng: -41.5279747,
    lat: -21.2762162
  },
  {
    lng: -41.5279991,
    lat: -21.2763169
  },
  {
    lng: -41.5279507,
    lat: -21.2763925
  },
  {
    lng: -41.5277973,
    lat: -21.2763604
  },
  {
    lng: -41.5276722,
    lat: -21.276287
  },
  {
    lng: -41.5275625,
    lat: -21.2761612
  },
  {
    lng: -41.5274889,
    lat: -21.276136
  },
  {
    lng: -41.5273338,
    lat: -21.2761725
  },
  {
    lng: -41.5271938,
    lat: -21.2761231
  },
  {
    lng: -41.5271812,
    lat: -21.2761017
  },
  {
    lng: -41.5271759,
    lat: -21.2759411
  },
  {
    lng: -41.5271831,
    lat: -21.275817
  },
  {
    lng: -41.5271942,
    lat: -21.2757646
  },
  {
    lng: -41.5271668,
    lat: -21.2756536
  },
  {
    lng: -41.5271545,
    lat: -21.2755086
  },
  {
    lng: -41.5270883,
    lat: -21.275433
  },
  {
    lng: -41.5269956,
    lat: -21.2754542
  },
  {
    lng: -41.5268793,
    lat: -21.2754089
  },
  {
    lng: -41.5267446,
    lat: -21.2753772
  },
  {
    lng: -41.5266905,
    lat: -21.275374
  },
  {
    lng: -41.5266802,
    lat: -21.2754551
  },
  {
    lng: -41.526663,
    lat: -21.2755146
  },
  {
    lng: -41.5266353,
    lat: -21.2755934
  },
  {
    lng: -41.5266692,
    lat: -21.2756605
  },
  {
    lng: -41.5266907,
    lat: -21.2757152
  },
  {
    lng: -41.5266381,
    lat: -21.2757273
  },
  {
    lng: -41.5265484,
    lat: -21.2757031
  },
  {
    lng: -41.5265176,
    lat: -21.2757739
  },
  {
    lng: -41.5264003,
    lat: -21.275839
  },
  {
    lng: -41.5262165,
    lat: -21.2758645
  },
  {
    lng: -41.5260785,
    lat: -21.2758024
  },
  {
    lng: -41.5260443,
    lat: -21.2757308
  },
  {
    lng: -41.5260342,
    lat: -21.275633
  },
  {
    lng: -41.5259809,
    lat: -21.2754853
  },
  {
    lng: -41.5259199,
    lat: -21.2754688
  },
  {
    lng: -41.5258576,
    lat: -21.2754511
  },
  {
    lng: -41.5257399,
    lat: -21.2753978
  },
  {
    lng: -41.5257356,
    lat: -21.2753271
  },
  {
    lng: -41.5257008,
    lat: -21.275252
  },
  {
    lng: -41.52534,
    lat: -21.2751215
  },
  {
    lng: -41.525327,
    lat: -21.2751141
  },
  {
    lng: -41.5251987,
    lat: -21.2751248
  },
  {
    lng: -41.5251538,
    lat: -21.2750831
  },
  {
    lng: -41.5251196,
    lat: -21.2749788
  },
  {
    lng: -41.5251411,
    lat: -21.2748229
  },
  {
    lng: -41.5251326,
    lat: -21.2746765
  },
  {
    lng: -41.5250677,
    lat: -21.2746351
  },
  {
    lng: -41.5249346,
    lat: -21.274675
  },
  {
    lng: -41.5248972,
    lat: -21.2747156
  },
  {
    lng: -41.5248021,
    lat: -21.2748129
  },
  {
    lng: -41.5245911,
    lat: -21.2748038
  },
  {
    lng: -41.5244192,
    lat: -21.2747495
  },
  {
    lng: -41.5243777,
    lat: -21.2747287
  },
  {
    lng: -41.52431,
    lat: -21.2746947
  },
  {
    lng: -41.5242605,
    lat: -21.2746254
  },
  {
    lng: -41.5242178,
    lat: -21.2745277
  },
  {
    lng: -41.5241182,
    lat: -21.2744846
  },
  {
    lng: -41.5240084,
    lat: -21.2744949
  },
  {
    lng: -41.5239527,
    lat: -21.2744513
  },
  {
    lng: -41.524025,
    lat: -21.2743918
  },
  {
    lng: -41.5241433,
    lat: -21.2743226
  },
  {
    lng: -41.5242983,
    lat: -21.2743144
  },
  {
    lng: -41.5244739,
    lat: -21.2743068
  },
  {
    lng: -41.5246115,
    lat: -21.2743119
  },
  {
    lng: -41.5247071,
    lat: -21.2742931
  },
  {
    lng: -41.5247308,
    lat: -21.2741875
  },
  {
    lng: -41.5247147,
    lat: -21.2741095
  },
  {
    lng: -41.5246794,
    lat: -21.2739961
  },
  {
    lng: -41.5246485,
    lat: -21.2739023
  },
  {
    lng: -41.5246492,
    lat: -21.2738688
  },
  {
    lng: -41.5246949,
    lat: -21.2738177
  },
  {
    lng: -41.5247884,
    lat: -21.2737758
  },
  {
    lng: -41.5248224,
    lat: -21.2737141
  },
  {
    lng: -41.5248215,
    lat: -21.273595
  },
  {
    lng: -41.5246956,
    lat: -21.2733971
  },
  {
    lng: -41.5246327,
    lat: -21.2732774
  },
  {
    lng: -41.5246315,
    lat: -21.2732753
  },
  {
    lng: -41.5246362,
    lat: -21.2731829
  },
  {
    lng: -41.5248967,
    lat: -21.2731152
  },
  {
    lng: -41.52496,
    lat: -21.2730571
  },
  {
    lng: -41.5252385,
    lat: -21.2730239
  },
  {
    lng: -41.5253189,
    lat: -21.2729393
  },
  {
    lng: -41.5253265,
    lat: -21.272832
  },
  {
    lng: -41.5252684,
    lat: -21.2726694
  },
  {
    lng: -41.5251221,
    lat: -21.2724284
  },
  {
    lng: -41.5250407,
    lat: -21.2722939
  },
  {
    lng: -41.5249733,
    lat: -21.2721852
  },
  {
    lng: -41.5249662,
    lat: -21.2720699
  },
  {
    lng: -41.5250519,
    lat: -21.2718439
  },
  {
    lng: -41.5250872,
    lat: -21.2717063
  },
  {
    lng: -41.5250766,
    lat: -21.2716615
  },
  {
    lng: -41.5250169,
    lat: -21.2715739
  },
  {
    lng: -41.5250983,
    lat: -21.2712981
  },
  {
    lng: -41.5251794,
    lat: -21.2711503
  },
  {
    lng: -41.5251828,
    lat: -21.2710594
  },
  {
    lng: -41.5251203,
    lat: -21.2710019
  },
  {
    lng: -41.5250452,
    lat: -21.2709083
  },
  {
    lng: -41.5250349,
    lat: -21.2706996
  },
  {
    lng: -41.5250201,
    lat: -21.2705526
  },
  {
    lng: -41.5250532,
    lat: -21.2704361
  },
  {
    lng: -41.525143,
    lat: -21.2703442
  },
  {
    lng: -41.5252521,
    lat: -21.2701816
  },
  {
    lng: -41.5253701,
    lat: -21.2701438
  },
  {
    lng: -41.5253803,
    lat: -21.2701084
  },
  {
    lng: -41.5253875,
    lat: -21.2700837
  },
  {
    lng: -41.5253897,
    lat: -21.2699418
  },
  {
    lng: -41.525409,
    lat: -21.2697992
  },
  {
    lng: -41.5253817,
    lat: -21.2696687
  },
  {
    lng: -41.5253681,
    lat: -21.2696509
  },
  {
    lng: -41.5252212,
    lat: -21.2696974
  },
  {
    lng: -41.5251099,
    lat: -21.2696299
  },
  {
    lng: -41.5251131,
    lat: -21.2694194
  },
  {
    lng: -41.5251313,
    lat: -21.2693059
  },
  {
    lng: -41.5251238,
    lat: -21.2691478
  },
  {
    lng: -41.5251395,
    lat: -21.2690321
  },
  {
    lng: -41.5251414,
    lat: -21.2689975
  },
  {
    lng: -41.5251459,
    lat: -21.2689145
  },
  {
    lng: -41.5251573,
    lat: -21.2687618
  },
  {
    lng: -41.5251867,
    lat: -21.2686493
  },
  {
    lng: -41.525187,
    lat: -21.2685824
  },
  {
    lng: -41.5251821,
    lat: -21.2685788
  },
  {
    lng: -41.5251395,
    lat: -21.2684976
  },
  {
    lng: -41.5251343,
    lat: -21.2684126
  },
  {
    lng: -41.5250303,
    lat: -21.2682415
  },
  {
    lng: -41.5250042,
    lat: -21.2682036
  },
  {
    lng: -41.5249765,
    lat: -21.2681636
  },
  {
    lng: -41.5247757,
    lat: -21.2679791
  },
  {
    lng: -41.5247487,
    lat: -21.2678541
  },
  {
    lng: -41.5247456,
    lat: -21.2678519
  },
  {
    lng: -41.524668,
    lat: -21.2677963
  },
  {
    lng: -41.5246637,
    lat: -21.2676856
  },
  {
    lng: -41.5246136,
    lat: -21.2676004
  },
  {
    lng: -41.5243415,
    lat: -21.2675541
  },
  {
    lng: -41.5242413,
    lat: -21.2675789
  },
  {
    lng: -41.5240754,
    lat: -21.2675153
  },
  {
    lng: -41.5240131,
    lat: -21.2674869
  },
  {
    lng: -41.5238779,
    lat: -21.2674317
  },
  {
    lng: -41.5237605,
    lat: -21.2674486
  },
  {
    lng: -41.5235135,
    lat: -21.2674492
  },
  {
    lng: -41.5234888,
    lat: -21.2673938
  },
  {
    lng: -41.5233782,
    lat: -21.2671959
  },
  {
    lng: -41.5233718,
    lat: -21.2671289
  },
  {
    lng: -41.523376,
    lat: -21.2669774
  },
  {
    lng: -41.5232927,
    lat: -21.2667272
  },
  {
    lng: -41.5232557,
    lat: -21.2666551
  },
  {
    lng: -41.5232618,
    lat: -21.2665779
  },
  {
    lng: -41.5232215,
    lat: -21.2664937
  },
  {
    lng: -41.5230148,
    lat: -21.2664362
  },
  {
    lng: -41.5228788,
    lat: -21.2664106
  },
  {
    lng: -41.5225669,
    lat: -21.2662854
  },
  {
    lng: -41.5223403,
    lat: -21.2661591
  },
  {
    lng: -41.5222342,
    lat: -21.2660696
  },
  {
    lng: -41.5221803,
    lat: -21.266117
  },
  {
    lng: -41.5221775,
    lat: -21.2661194
  },
  {
    lng: -41.5221328,
    lat: -21.2661612
  },
  {
    lng: -41.5220102,
    lat: -21.2662021
  },
  {
    lng: -41.5218348,
    lat: -21.2662759
  },
  {
    lng: -41.5217128,
    lat: -21.2662975
  },
  {
    lng: -41.5216381,
    lat: -21.2663108
  },
  {
    lng: -41.5214313,
    lat: -21.2662275
  },
  {
    lng: -41.5213389,
    lat: -21.2661709
  },
  {
    lng: -41.521054,
    lat: -21.2659277
  },
  {
    lng: -41.5209958,
    lat: -21.265866
  },
  {
    lng: -41.5208318,
    lat: -21.2656643
  },
  {
    lng: -41.5207272,
    lat: -21.2655367
  },
  {
    lng: -41.5205494,
    lat: -21.2653385
  },
  {
    lng: -41.5204453,
    lat: -21.265255
  },
  {
    lng: -41.520329,
    lat: -21.2651861
  },
  {
    lng: -41.5202325,
    lat: -21.2651699
  },
  {
    lng: -41.5200856,
    lat: -21.2650825
  },
  {
    lng: -41.519905,
    lat: -21.2649699
  },
  {
    lng: -41.519732,
    lat: -21.2648854
  },
  {
    lng: -41.5197089,
    lat: -21.2648556
  },
  {
    lng: -41.5197058,
    lat: -21.264643
  },
  {
    lng: -41.5196455,
    lat: -21.2644853
  },
  {
    lng: -41.5196104,
    lat: -21.2644513
  },
  {
    lng: -41.5194782,
    lat: -21.2644497
  },
  {
    lng: -41.5193456,
    lat: -21.2643829
  },
  {
    lng: -41.5191704,
    lat: -21.2642002
  },
  {
    lng: -41.5190873,
    lat: -21.2641136
  },
  {
    lng: -41.5189257,
    lat: -21.263976
  },
  {
    lng: -41.5187972,
    lat: -21.2638735
  },
  {
    lng: -41.5186896,
    lat: -21.2639212
  },
  {
    lng: -41.5185824,
    lat: -21.2639614
  },
  {
    lng: -41.5182918,
    lat: -21.2637241
  },
  {
    lng: -41.5182771,
    lat: -21.263713
  },
  {
    lng: -41.5179737,
    lat: -21.2634891
  },
  {
    lng: -41.5179094,
    lat: -21.2634449
  },
  {
    lng: -41.5175773,
    lat: -21.263254
  },
  {
    lng: -41.5174731,
    lat: -21.26318
  },
  {
    lng: -41.5172165,
    lat: -21.2630039
  },
  {
    lng: -41.5170886,
    lat: -21.2628864
  },
  {
    lng: -41.5169387,
    lat: -21.2627795
  },
  {
    lng: -41.5168828,
    lat: -21.2628054
  },
  {
    lng: -41.5169447,
    lat: -21.263166
  },
  {
    lng: -41.5169447,
    lat: -21.2631722
  },
  {
    lng: -41.5169408,
    lat: -21.2635217
  },
  {
    lng: -41.5168064,
    lat: -21.2635544
  },
  {
    lng: -41.516616,
    lat: -21.2634269
  },
  {
    lng: -41.5164846,
    lat: -21.2632461
  },
  {
    lng: -41.5164381,
    lat: -21.263195
  },
  {
    lng: -41.5162725,
    lat: -21.2630958
  },
  {
    lng: -41.5161379,
    lat: -21.26304
  },
  {
    lng: -41.515979,
    lat: -21.2629223
  },
  {
    lng: -41.5159012,
    lat: -21.2628092
  },
  {
    lng: -41.5157817,
    lat: -21.2627618
  },
  {
    lng: -41.5156345,
    lat: -21.2627065
  },
  {
    lng: -41.5155646,
    lat: -21.2626422
  },
  {
    lng: -41.515406,
    lat: -21.2624134
  },
  {
    lng: -41.5153183,
    lat: -21.2622095
  },
  {
    lng: -41.5152203,
    lat: -21.2620222
  },
  {
    lng: -41.5150583,
    lat: -21.2617543
  },
  {
    lng: -41.5149779,
    lat: -21.2616302
  },
  {
    lng: -41.5148344,
    lat: -21.2615377
  },
  {
    lng: -41.514669,
    lat: -21.2614439
  },
  {
    lng: -41.5145805,
    lat: -21.2613545
  },
  {
    lng: -41.5144247,
    lat: -21.2612469
  },
  {
    lng: -41.5142622,
    lat: -21.2612205
  },
  {
    lng: -41.514091,
    lat: -21.2612239
  },
  {
    lng: -41.5140517,
    lat: -21.2612398
  },
  {
    lng: -41.5140115,
    lat: -21.2612561
  },
  {
    lng: -41.5140407,
    lat: -21.2613406
  },
  {
    lng: -41.5140479,
    lat: -21.2613525
  },
  {
    lng: -41.5142029,
    lat: -21.2616767
  },
  {
    lng: -41.5142782,
    lat: -21.2620311
  },
  {
    lng: -41.5142779,
    lat: -21.2620375
  },
  {
    lng: -41.5142532,
    lat: -21.262097
  },
  {
    lng: -41.5142098,
    lat: -21.2622016
  },
  {
    lng: -41.5140654,
    lat: -21.2621807
  },
  {
    lng: -41.5139323,
    lat: -21.2621189
  },
  {
    lng: -41.5138818,
    lat: -21.2622209
  },
  {
    lng: -41.5139125,
    lat: -21.2623042
  },
  {
    lng: -41.5139488,
    lat: -21.2624229
  },
  {
    lng: -41.5139,
    lat: -21.2626805
  },
  {
    lng: -41.5137739,
    lat: -21.2628156
  },
  {
    lng: -41.5134815,
    lat: -21.2628235
  },
  {
    lng: -41.5132821,
    lat: -21.2627155
  },
  {
    lng: -41.5131236,
    lat: -21.262633
  },
  {
    lng: -41.5129412,
    lat: -21.262585
  },
  {
    lng: -41.5127896,
    lat: -21.2625808
  },
  {
    lng: -41.5126443,
    lat: -21.2625593
  },
  {
    lng: -41.5124112,
    lat: -21.2625767
  },
  {
    lng: -41.5121942,
    lat: -21.2626691
  },
  {
    lng: -41.5121258,
    lat: -21.262753
  },
  {
    lng: -41.5122262,
    lat: -21.2628791
  },
  {
    lng: -41.5123413,
    lat: -21.262973
  },
  {
    lng: -41.5125228,
    lat: -21.2630419
  },
  {
    lng: -41.5126216,
    lat: -21.263143
  },
  {
    lng: -41.5126272,
    lat: -21.2632661
  },
  {
    lng: -41.5125135,
    lat: -21.2633459
  },
  {
    lng: -41.5124919,
    lat: -21.2633863
  },
  {
    lng: -41.5124666,
    lat: -21.2634214
  },
  {
    lng: -41.5123867,
    lat: -21.2635589
  },
  {
    lng: -41.5123215,
    lat: -21.263721
  },
  {
    lng: -41.5121478,
    lat: -21.263885
  },
  {
    lng: -41.5120714,
    lat: -21.2640081
  },
  {
    lng: -41.5120321,
    lat: -21.2640665
  },
  {
    lng: -41.5119744,
    lat: -21.2641879
  },
  {
    lng: -41.5117068,
    lat: -21.2642027
  },
  {
    lng: -41.5113296,
    lat: -21.26412
  },
  {
    lng: -41.5111742,
    lat: -21.2640974
  },
  {
    lng: -41.5109174,
    lat: -21.2640225
  },
  {
    lng: -41.5106759,
    lat: -21.2639886
  },
  {
    lng: -41.5105874,
    lat: -21.2639626
  },
  {
    lng: -41.5103692,
    lat: -21.26388
  },
  {
    lng: -41.5102276,
    lat: -21.2638373
  },
  {
    lng: -41.5100461,
    lat: -21.2638431
  },
  {
    lng: -41.5098369,
    lat: -21.2639453
  },
  {
    lng: -41.509766,
    lat: -21.2639852
  },
  {
    lng: -41.5096605,
    lat: -21.2640557
  },
  {
    lng: -41.5095289,
    lat: -21.2641529
  },
  {
    lng: -41.5094707,
    lat: -21.2642044
  },
  {
    lng: -41.5093136,
    lat: -21.2642515
  },
  {
    lng: -41.5091296,
    lat: -21.2642592
  },
  {
    lng: -41.5090598,
    lat: -21.2642996
  },
  {
    lng: -41.5089474,
    lat: -21.2643647
  },
  {
    lng: -41.5089135,
    lat: -21.2645386
  },
  {
    lng: -41.5089331,
    lat: -21.2646816
  },
  {
    lng: -41.5089408,
    lat: -21.2649384
  },
  {
    lng: -41.508938,
    lat: -21.2649444
  },
  {
    lng: -41.5088772,
    lat: -21.2650739
  },
  {
    lng: -41.5086751,
    lat: -21.2651476
  },
  {
    lng: -41.5085482,
    lat: -21.2652129
  },
  {
    lng: -41.5084584,
    lat: -21.2653421
  },
  {
    lng: -41.5084541,
    lat: -21.2653481
  },
  {
    lng: -41.5083555,
    lat: -21.2654259
  },
  {
    lng: -41.508261,
    lat: -21.2654792
  },
  {
    lng: -41.5082498,
    lat: -21.2654788
  },
  {
    lng: -41.5078695,
    lat: -21.2655381
  },
  {
    lng: -41.5078227,
    lat: -21.2655429
  },
  {
    lng: -41.5077513,
    lat: -21.2655504
  },
  {
    lng: -41.5073953,
    lat: -21.2654121
  },
  {
    lng: -41.507271,
    lat: -21.2653519
  },
  {
    lng: -41.506893,
    lat: -21.2652731
  },
  {
    lng: -41.5068132,
    lat: -21.265223
  },
  {
    lng: -41.506619,
    lat: -21.2651272
  },
  {
    lng: -41.5065072,
    lat: -21.2649945
  },
  {
    lng: -41.5064427,
    lat: -21.2649435
  },
  {
    lng: -41.5064302,
    lat: -21.2649182
  },
  {
    lng: -41.5064079,
    lat: -21.2647135
  },
  {
    lng: -41.5063906,
    lat: -21.2645901
  },
  {
    lng: -41.5063384,
    lat: -21.2644379
  },
  {
    lng: -41.5063887,
    lat: -21.2642571
  },
  {
    lng: -41.5064301,
    lat: -21.2641492
  },
  {
    lng: -41.5065501,
    lat: -21.2640178
  },
  {
    lng: -41.5065835,
    lat: -21.2638488
  },
  {
    lng: -41.5065474,
    lat: -21.2637068
  },
  {
    lng: -41.5063862,
    lat: -21.2635727
  },
  {
    lng: -41.5062731,
    lat: -21.2635086
  },
  {
    lng: -41.5060367,
    lat: -21.2634598
  },
  {
    lng: -41.5057323,
    lat: -21.2634566
  },
  {
    lng: -41.5054798,
    lat: -21.263354
  },
  {
    lng: -41.5054639,
    lat: -21.2632655
  },
  {
    lng: -41.5054631,
    lat: -21.2631791
  },
  {
    lng: -41.5054663,
    lat: -21.2630929
  },
  {
    lng: -41.5053955,
    lat: -21.2629449
  },
  {
    lng: -41.5051785,
    lat: -21.2627911
  },
  {
    lng: -41.505171,
    lat: -21.2627897
  },
  {
    lng: -41.5050521,
    lat: -21.2627679
  },
  {
    lng: -41.5050064,
    lat: -21.2628592
  },
  {
    lng: -41.5048583,
    lat: -21.2629137
  },
  {
    lng: -41.5047134,
    lat: -21.2628825
  },
  {
    lng: -41.5046556,
    lat: -21.2628258
  },
  {
    lng: -41.504667,
    lat: -21.2627623
  },
  {
    lng: -41.5045318,
    lat: -21.2626879
  },
  {
    lng: -41.5044555,
    lat: -21.2625845
  },
  {
    lng: -41.5042591,
    lat: -21.2623754
  },
  {
    lng: -41.5040175,
    lat: -21.2621937
  },
  {
    lng: -41.5037884,
    lat: -21.2620475
  },
  {
    lng: -41.5036011,
    lat: -21.2619692
  },
  {
    lng: -41.503461,
    lat: -21.2619559
  },
  {
    lng: -41.503279,
    lat: -21.2619633
  },
  {
    lng: -41.5031169,
    lat: -21.2621989
  },
  {
    lng: -41.5030179,
    lat: -21.2622585
  },
  {
    lng: -41.5030121,
    lat: -21.2622619
  },
  {
    lng: -41.5028534,
    lat: -21.2622561
  },
  {
    lng: -41.5027419,
    lat: -21.2622894
  },
  {
    lng: -41.5026266,
    lat: -21.262303
  },
  {
    lng: -41.5025021,
    lat: -21.2622336
  },
  {
    lng: -41.5024305,
    lat: -21.262188
  },
  {
    lng: -41.5023354,
    lat: -21.2621498
  },
  {
    lng: -41.5022497,
    lat: -21.2620846
  },
  {
    lng: -41.5022168,
    lat: -21.2619933
  },
  {
    lng: -41.5021606,
    lat: -21.2619521
  },
  {
    lng: -41.5021153,
    lat: -21.2619369
  },
  {
    lng: -41.5018671,
    lat: -21.2618516
  },
  {
    lng: -41.5018424,
    lat: -21.2618275
  },
  {
    lng: -41.501749,
    lat: -21.2617362
  },
  {
    lng: -41.5016723,
    lat: -21.2616288
  },
  {
    lng: -41.501745,
    lat: -21.2614475
  },
  {
    lng: -41.5018554,
    lat: -21.2613321
  },
  {
    lng: -41.5019219,
    lat: -21.2611782
  },
  {
    lng: -41.5019641,
    lat: -21.2610744
  },
  {
    lng: -41.5019802,
    lat: -21.2609696
  },
  {
    lng: -41.502003,
    lat: -21.2608592
  },
  {
    lng: -41.5021628,
    lat: -21.260583
  },
  {
    lng: -41.5024007,
    lat: -21.2604264
  },
  {
    lng: -41.5025931,
    lat: -21.2603811
  },
  {
    lng: -41.5026507,
    lat: -21.2603235
  },
  {
    lng: -41.5026079,
    lat: -21.2601803
  },
  {
    lng: -41.502489,
    lat: -21.2601474
  },
  {
    lng: -41.5023361,
    lat: -21.2601221
  },
  {
    lng: -41.5022006,
    lat: -21.2600198
  },
  {
    lng: -41.50205,
    lat: -21.2599981
  },
  {
    lng: -41.501899,
    lat: -21.2600139
  },
  {
    lng: -41.5018513,
    lat: -21.2598898
  },
  {
    lng: -41.5018172,
    lat: -21.2598593
  },
  {
    lng: -41.5017657,
    lat: -21.2598184
  },
  {
    lng: -41.5017367,
    lat: -21.2597275
  },
  {
    lng: -41.5016425,
    lat: -21.2596871
  },
  {
    lng: -41.5015286,
    lat: -21.2597198
  },
  {
    lng: -41.5015241,
    lat: -21.2597207
  },
  {
    lng: -41.5014574,
    lat: -21.2597277
  },
  {
    lng: -41.501336,
    lat: -21.2596446
  },
  {
    lng: -41.5013345,
    lat: -21.2595576
  },
  {
    lng: -41.5013476,
    lat: -21.2594828
  },
  {
    lng: -41.501292,
    lat: -21.2594061
  },
  {
    lng: -41.5011655,
    lat: -21.2593735
  },
  {
    lng: -41.5011082,
    lat: -21.2592488
  },
  {
    lng: -41.5010842,
    lat: -21.2591176
  },
  {
    lng: -41.5010479,
    lat: -21.2589241
  },
  {
    lng: -41.5010995,
    lat: -21.2587892
  },
  {
    lng: -41.5011264,
    lat: -21.2586028
  },
  {
    lng: -41.5011235,
    lat: -21.2584901
  },
  {
    lng: -41.5011182,
    lat: -21.2584029
  },
  {
    lng: -41.5011823,
    lat: -21.2582449
  },
  {
    lng: -41.5012238,
    lat: -21.2581107
  },
  {
    lng: -41.5011331,
    lat: -21.2580177
  },
  {
    lng: -41.5010717,
    lat: -21.2579567
  },
  {
    lng: -41.501019,
    lat: -21.2579436
  },
  {
    lng: -41.5010119,
    lat: -21.2578633
  },
  {
    lng: -41.5010549,
    lat: -21.2577785
  },
  {
    lng: -41.5010414,
    lat: -21.2576436
  },
  {
    lng: -41.5010403,
    lat: -21.2576413
  },
  {
    lng: -41.5008996,
    lat: -21.2575549
  },
  {
    lng: -41.5007982,
    lat: -21.2574896
  },
  {
    lng: -41.5007359,
    lat: -21.2573957
  },
  {
    lng: -41.500518,
    lat: -21.257318
  },
  {
    lng: -41.500243,
    lat: -21.2571943
  },
  {
    lng: -41.500125,
    lat: -21.2570766
  },
  {
    lng: -41.4999873,
    lat: -21.2569929
  },
  {
    lng: -41.4998652,
    lat: -21.2569537
  },
  {
    lng: -41.4998503,
    lat: -21.2569452
  },
  {
    lng: -41.499806,
    lat: -21.2568996
  },
  {
    lng: -41.4998343,
    lat: -21.2566784
  },
  {
    lng: -41.4998891,
    lat: -21.2565744
  },
  {
    lng: -41.4999437,
    lat: -21.2565266
  },
  {
    lng: -41.4999267,
    lat: -21.2564672
  },
  {
    lng: -41.4998134,
    lat: -21.2563331
  },
  {
    lng: -41.4996347,
    lat: -21.2562515
  },
  {
    lng: -41.4995098,
    lat: -21.256178
  },
  {
    lng: -41.499307,
    lat: -21.2561273
  },
  {
    lng: -41.4991479,
    lat: -21.2560676
  },
  {
    lng: -41.4991118,
    lat: -21.2560033
  },
  {
    lng: -41.4992164,
    lat: -21.2558976
  },
  {
    lng: -41.4993069,
    lat: -21.2558422
  },
  {
    lng: -41.4993849,
    lat: -21.2558747
  },
  {
    lng: -41.4994633,
    lat: -21.2559098
  },
  {
    lng: -41.4995116,
    lat: -21.2558628
  },
  {
    lng: -41.4994187,
    lat: -21.2557825
  },
  {
    lng: -41.4993208,
    lat: -21.2557266
  },
  {
    lng: -41.4992625,
    lat: -21.255699
  },
  {
    lng: -41.4992051,
    lat: -21.2556158
  },
  {
    lng: -41.4991871,
    lat: -21.2554729
  },
  {
    lng: -41.4992037,
    lat: -21.255427
  },
  {
    lng: -41.4992482,
    lat: -21.2552686
  },
  {
    lng: -41.4992508,
    lat: -21.25508
  },
  {
    lng: -41.4992733,
    lat: -21.2549704
  },
  {
    lng: -41.4992752,
    lat: -21.2548587
  },
  {
    lng: -41.4992644,
    lat: -21.2547522
  },
  {
    lng: -41.4993884,
    lat: -21.2547424
  },
  {
    lng: -41.49949,
    lat: -21.2546904
  },
  {
    lng: -41.4994974,
    lat: -21.254573
  },
  {
    lng: -41.4994751,
    lat: -21.2544913
  },
  {
    lng: -41.4995417,
    lat: -21.2544044
  },
  {
    lng: -41.4995896,
    lat: -21.2543221
  },
  {
    lng: -41.499515,
    lat: -21.2541879
  },
  {
    lng: -41.4995688,
    lat: -21.2540954
  },
  {
    lng: -41.4995825,
    lat: -21.2540208
  },
  {
    lng: -41.4995945,
    lat: -21.2539184
  },
  {
    lng: -41.4995401,
    lat: -21.2538217
  },
  {
    lng: -41.4994707,
    lat: -21.2536509
  },
  {
    lng: -41.4994803,
    lat: -21.2535203
  },
  {
    lng: -41.4992588,
    lat: -21.2532809
  },
  {
    lng: -41.4991743,
    lat: -21.2532233
  },
  {
    lng: -41.4990144,
    lat: -21.2531803
  },
  {
    lng: -41.4988488,
    lat: -21.2531346
  },
  {
    lng: -41.498628,
    lat: -21.2531258
  },
  {
    lng: -41.498498,
    lat: -21.2531263
  },
  {
    lng: -41.4983701,
    lat: -21.2530928
  },
  {
    lng: -41.4982841,
    lat: -21.2530105
  },
  {
    lng: -41.4982676,
    lat: -21.2528648
  },
  {
    lng: -41.4982387,
    lat: -21.2526792
  },
  {
    lng: -41.4982388,
    lat: -21.2525417
  },
  {
    lng: -41.4982448,
    lat: -21.2525151
  },
  {
    lng: -41.4981544,
    lat: -21.2525378
  },
  {
    lng: -41.4980796,
    lat: -21.2525413
  },
  {
    lng: -41.4980745,
    lat: -21.2524723
  },
  {
    lng: -41.4981062,
    lat: -21.2523797
  },
  {
    lng: -41.4981979,
    lat: -21.2522804
  },
  {
    lng: -41.4983366,
    lat: -21.2522273
  },
  {
    lng: -41.4984311,
    lat: -21.2521762
  },
  {
    lng: -41.4984583,
    lat: -21.2521102
  },
  {
    lng: -41.4983795,
    lat: -21.2520699
  },
  {
    lng: -41.4982575,
    lat: -21.2520544
  },
  {
    lng: -41.4981897,
    lat: -21.2520184
  },
  {
    lng: -41.4981725,
    lat: -21.2519883
  },
  {
    lng: -41.49816,
    lat: -21.2518691
  },
  {
    lng: -41.4980906,
    lat: -21.2517135
  },
  {
    lng: -41.4980981,
    lat: -21.2516032
  },
  {
    lng: -41.4982197,
    lat: -21.2513815
  },
  {
    lng: -41.4983035,
    lat: -21.2512497
  },
  {
    lng: -41.4984066,
    lat: -21.2510556
  },
  {
    lng: -41.4984645,
    lat: -21.2509937
  },
  {
    lng: -41.4985376,
    lat: -21.250895
  },
  {
    lng: -41.4985088,
    lat: -21.2506799
  },
  {
    lng: -41.4984283,
    lat: -21.2505261
  },
  {
    lng: -41.4983454,
    lat: -21.2504719
  },
  {
    lng: -41.4982072,
    lat: -21.2504714
  },
  {
    lng: -41.4978838,
    lat: -21.2504398
  },
  {
    lng: -41.4977959,
    lat: -21.2503901
  },
  {
    lng: -41.497807,
    lat: -21.2503095
  },
  {
    lng: -41.4979596,
    lat: -21.2502563
  },
  {
    lng: -41.4979401,
    lat: -21.2501249
  },
  {
    lng: -41.4979282,
    lat: -21.250087
  },
  {
    lng: -41.49791,
    lat: -21.2500131
  },
  {
    lng: -41.4979877,
    lat: -21.249806
  },
  {
    lng: -41.4980012,
    lat: -21.2497699
  },
  {
    lng: -41.4981234,
    lat: -21.2494256
  },
  {
    lng: -41.4981301,
    lat: -21.2494076
  },
  {
    lng: -41.4981802,
    lat: -21.2492387
  },
  {
    lng: -41.4982348,
    lat: -21.2490188
  },
  {
    lng: -41.4982397,
    lat: -21.2489989
  },
  {
    lng: -41.4982332,
    lat: -21.2489188
  },
  {
    lng: -41.4982318,
    lat: -21.2489014
  },
  {
    lng: -41.4981418,
    lat: -21.2488815
  },
  {
    lng: -41.49786,
    lat: -21.2489689
  },
  {
    lng: -41.4977225,
    lat: -21.2489528
  },
  {
    lng: -41.497633,
    lat: -21.2488738
  },
  {
    lng: -41.497592,
    lat: -21.2488262
  },
  {
    lng: -41.497543,
    lat: -21.2487259
  },
  {
    lng: -41.4974799,
    lat: -21.2486068
  },
  {
    lng: -41.4974225,
    lat: -21.2485792
  },
  {
    lng: -41.4973289,
    lat: -21.2485685
  },
  {
    lng: -41.4973225,
    lat: -21.2485683
  },
  {
    lng: -41.497292,
    lat: -21.248558
  },
  {
    lng: -41.4971929,
    lat: -21.2485447
  },
  {
    lng: -41.4971914,
    lat: -21.2485446
  },
  {
    lng: -41.4971517,
    lat: -21.2486084
  },
  {
    lng: -41.4970819,
    lat: -21.2486564
  },
  {
    lng: -41.4969085,
    lat: -21.2486347
  },
  {
    lng: -41.4967348,
    lat: -21.2486301
  },
  {
    lng: -41.4966221,
    lat: -21.2486609
  },
  {
    lng: -41.4965792,
    lat: -21.2485431
  },
  {
    lng: -41.496593,
    lat: -21.2485333
  },
  {
    lng: -41.4967012,
    lat: -21.248456
  },
  {
    lng: -41.4968121,
    lat: -21.248477
  },
  {
    lng: -41.4969278,
    lat: -21.2484019
  },
  {
    lng: -41.4970477,
    lat: -21.2483528
  },
  {
    lng: -41.4970933,
    lat: -21.2482946
  },
  {
    lng: -41.4971853,
    lat: -21.2481969
  },
  {
    lng: -41.4972396,
    lat: -21.2480716
  },
  {
    lng: -41.4971995,
    lat: -21.2479356
  },
  {
    lng: -41.497176,
    lat: -21.2478969
  },
  {
    lng: -41.4971353,
    lat: -21.2478406
  },
  {
    lng: -41.4970697,
    lat: -21.2477162
  },
  {
    lng: -41.4970297,
    lat: -21.247606
  },
  {
    lng: -41.4969744,
    lat: -21.247572
  },
  {
    lng: -41.4967344,
    lat: -21.2475547
  },
  {
    lng: -41.4967123,
    lat: -21.2475024
  },
  {
    lng: -41.4967357,
    lat: -21.2474173
  },
  {
    lng: -41.4968924,
    lat: -21.2473184
  },
  {
    lng: -41.497101,
    lat: -21.2472802
  },
  {
    lng: -41.4972525,
    lat: -21.2472241
  },
  {
    lng: -41.4973309,
    lat: -21.2471586
  },
  {
    lng: -41.4973071,
    lat: -21.2470371
  },
  {
    lng: -41.4971937,
    lat: -21.2468771
  },
  {
    lng: -41.4970517,
    lat: -21.2466647
  },
  {
    lng: -41.4969587,
    lat: -21.2463377
  },
  {
    lng: -41.4969158,
    lat: -21.2461145
  },
  {
    lng: -41.496858,
    lat: -21.2460769
  },
  {
    lng: -41.496711,
    lat: -21.24617
  },
  {
    lng: -41.4965379,
    lat: -21.2463247
  },
  {
    lng: -41.4963976,
    lat: -21.2464651
  },
  {
    lng: -41.4961878,
    lat: -21.2464865
  },
  {
    lng: -41.496137,
    lat: -21.2463532
  },
  {
    lng: -41.4961727,
    lat: -21.2461497
  },
  {
    lng: -41.4962709,
    lat: -21.2459127
  },
  {
    lng: -41.4963924,
    lat: -21.2458242
  },
  {
    lng: -41.4964233,
    lat: -21.2457592
  },
  {
    lng: -41.4964236,
    lat: -21.2456766
  },
  {
    lng: -41.4963942,
    lat: -21.2455638
  },
  {
    lng: -41.4963383,
    lat: -21.245419
  },
  {
    lng: -41.4962831,
    lat: -21.2452758
  },
  {
    lng: -41.4962145,
    lat: -21.2451418
  },
  {
    lng: -41.496178,
    lat: -21.2450194
  },
  {
    lng: -41.4959569,
    lat: -21.2448807
  },
  {
    lng: -41.4956291,
    lat: -21.2446909
  },
  {
    lng: -41.4955691,
    lat: -21.24466
  },
  {
    lng: -41.4954997,
    lat: -21.2446511
  },
  {
    lng: -41.4952651,
    lat: -21.244874
  },
  {
    lng: -41.4950817,
    lat: -21.244987
  },
  {
    lng: -41.494885,
    lat: -21.2450205
  },
  {
    lng: -41.4947411,
    lat: -21.24487
  },
  {
    lng: -41.4947877,
    lat: -21.2445814
  },
  {
    lng: -41.4949845,
    lat: -21.2443289
  },
  {
    lng: -41.4950051,
    lat: -21.2442196
  },
  {
    lng: -41.494922,
    lat: -21.2440563
  },
  {
    lng: -41.4948095,
    lat: -21.243942
  },
  {
    lng: -41.494746,
    lat: -21.2438948
  },
  {
    lng: -41.4946141,
    lat: -21.243846
  },
  {
    lng: -41.494451,
    lat: -21.2438011
  },
  {
    lng: -41.4943864,
    lat: -21.2438591
  },
  {
    lng: -41.4943091,
    lat: -21.2439948
  },
  {
    lng: -41.4942266,
    lat: -21.2440923
  },
  {
    lng: -41.4940495,
    lat: -21.2441065
  },
  {
    lng: -41.4939158,
    lat: -21.2440352
  },
  {
    lng: -41.4938055,
    lat: -21.2438402
  },
  {
    lng: -41.4936205,
    lat: -21.2436277
  },
  {
    lng: -41.4934469,
    lat: -21.2435578
  },
  {
    lng: -41.4933167,
    lat: -21.2435016
  },
  {
    lng: -41.4930821,
    lat: -21.2434732
  },
  {
    lng: -41.4927296,
    lat: -21.2433216
  },
  {
    lng: -41.4924301,
    lat: -21.2432408
  },
  {
    lng: -41.4921857,
    lat: -21.2432846
  },
  {
    lng: -41.4919785,
    lat: -21.2432405
  },
  {
    lng: -41.4918733,
    lat: -21.2432072
  },
  {
    lng: -41.4918594,
    lat: -21.2432027
  },
  {
    lng: -41.4917965,
    lat: -21.243174
  },
  {
    lng: -41.4917068,
    lat: -21.2431129
  },
  {
    lng: -41.4916865,
    lat: -21.2431127
  },
  {
    lng: -41.4916524,
    lat: -21.2431192
  },
  {
    lng: -41.4915206,
    lat: -21.2430818
  },
  {
    lng: -41.4914125,
    lat: -21.243081
  },
  {
    lng: -41.4911786,
    lat: -21.2430973
  },
  {
    lng: -41.4910283,
    lat: -21.2430492
  },
  {
    lng: -41.4908857,
    lat: -21.2429692
  },
  {
    lng: -41.4907174,
    lat: -21.2429484
  },
  {
    lng: -41.4905099,
    lat: -21.242958
  },
  {
    lng: -41.4904484,
    lat: -21.2429421
  },
  {
    lng: -41.4903865,
    lat: -21.2429212
  },
  {
    lng: -41.4901819,
    lat: -21.2427053
  },
  {
    lng: -41.490004,
    lat: -21.2424863
  },
  {
    lng: -41.4897563,
    lat: -21.2422585
  },
  {
    lng: -41.4894457,
    lat: -21.2420441
  },
  {
    lng: -41.4893919,
    lat: -21.2420038
  },
  {
    lng: -41.4892804,
    lat: -21.2418789
  },
  {
    lng: -41.4891624,
    lat: -21.2417301
  },
  {
    lng: -41.489162,
    lat: -21.2416055
  },
  {
    lng: -41.4892587,
    lat: -21.2413992
  },
  {
    lng: -41.489293,
    lat: -21.2412324
  },
  {
    lng: -41.4892931,
    lat: -21.2411987
  },
  {
    lng: -41.4892834,
    lat: -21.2411849
  },
  {
    lng: -41.4892067,
    lat: -21.2410747
  },
  {
    lng: -41.4889631,
    lat: -21.2409753
  },
  {
    lng: -41.4887927,
    lat: -21.2409852
  },
  {
    lng: -41.4887595,
    lat: -21.2410796
  },
  {
    lng: -41.4886009,
    lat: -21.2410392
  },
  {
    lng: -41.4883896,
    lat: -21.2409139
  },
  {
    lng: -41.4882523,
    lat: -21.2408351
  },
  {
    lng: -41.4882342,
    lat: -21.2407664
  },
  {
    lng: -41.4883316,
    lat: -21.2407499
  },
  {
    lng: -41.4884582,
    lat: -21.2407053
  },
  {
    lng: -41.4884528,
    lat: -21.2405787
  },
  {
    lng: -41.488364,
    lat: -21.2403869
  },
  {
    lng: -41.4882452,
    lat: -21.2402544
  },
  {
    lng: -41.4880246,
    lat: -21.2399545
  },
  {
    lng: -41.4877205,
    lat: -21.2397315
  },
  {
    lng: -41.4877298,
    lat: -21.2396672
  },
  {
    lng: -41.4879066,
    lat: -21.2396091
  },
  {
    lng: -41.4881999,
    lat: -21.239488
  },
  {
    lng: -41.4880677,
    lat: -21.2392129
  },
  {
    lng: -41.4877593,
    lat: -21.2391182
  },
  {
    lng: -41.4877093,
    lat: -21.2388877
  },
  {
    lng: -41.4873337,
    lat: -21.2387914
  },
  {
    lng: -41.4871945,
    lat: -21.2387727
  },
  {
    lng: -41.487026,
    lat: -21.2390606
  },
  {
    lng: -41.4869799,
    lat: -21.2390406
  },
  {
    lng: -41.4869422,
    lat: -21.2390069
  },
  {
    lng: -41.4868908,
    lat: -21.238785
  },
  {
    lng: -41.486687,
    lat: -21.2385789
  },
  {
    lng: -41.4865786,
    lat: -21.2383225
  },
  {
    lng: -41.4865515,
    lat: -21.2383062
  },
  {
    lng: -41.4864835,
    lat: -21.2382653
  },
  {
    lng: -41.486403,
    lat: -21.2382672
  },
  {
    lng: -41.4863748,
    lat: -21.2382909
  },
  {
    lng: -41.4863576,
    lat: -21.2383474
  },
  {
    lng: -41.4863801,
    lat: -21.2384256
  },
  {
    lng: -41.4864976,
    lat: -21.2385102
  },
  {
    lng: -41.4865719,
    lat: -21.2385772
  },
  {
    lng: -41.4865672,
    lat: -21.2386705
  },
  {
    lng: -41.4864641,
    lat: -21.2387148
  },
  {
    lng: -41.4863221,
    lat: -21.238896
  },
  {
    lng: -41.4862786,
    lat: -21.2389113
  },
  {
    lng: -41.4862468,
    lat: -21.2389225
  },
  {
    lng: -41.4860874,
    lat: -21.2388087
  },
  {
    lng: -41.485958,
    lat: -21.2384662
  },
  {
    lng: -41.485903,
    lat: -21.2383952
  },
  {
    lng: -41.4858311,
    lat: -21.2382769
  },
  {
    lng: -41.4857992,
    lat: -21.2382706
  },
  {
    lng: -41.4857375,
    lat: -21.2383041
  },
  {
    lng: -41.4855608,
    lat: -21.2383266
  },
  {
    lng: -41.4854794,
    lat: -21.238391
  },
  {
    lng: -41.4854648,
    lat: -21.2384225
  },
  {
    lng: -41.4853248,
    lat: -21.2385822
  },
  {
    lng: -41.4852116,
    lat: -21.238598
  },
  {
    lng: -41.4850872,
    lat: -21.23857
  },
  {
    lng: -41.4847126,
    lat: -21.2384822
  },
  {
    lng: -41.4846982,
    lat: -21.2384867
  },
  {
    lng: -41.4846131,
    lat: -21.2385124
  },
  {
    lng: -41.4843209,
    lat: -21.2382715
  },
  {
    lng: -41.4842919,
    lat: -21.2380959
  },
  {
    lng: -41.4844863,
    lat: -21.2377822
  },
  {
    lng: -41.4845665,
    lat: -21.2376947
  },
  {
    lng: -41.4845531,
    lat: -21.23764
  },
  {
    lng: -41.4841817,
    lat: -21.237512
  },
  {
    lng: -41.4838382,
    lat: -21.2373428
  },
  {
    lng: -41.4836647,
    lat: -21.2370142
  },
  {
    lng: -41.4836048,
    lat: -21.2367359
  },
  {
    lng: -41.4835362,
    lat: -21.2366592
  },
  {
    lng: -41.4832466,
    lat: -21.2365784
  },
  {
    lng: -41.4831505,
    lat: -21.2366013
  },
  {
    lng: -41.4830886,
    lat: -21.2366084
  },
  {
    lng: -41.4830593,
    lat: -21.2365735
  },
  {
    lng: -41.4830994,
    lat: -21.2363058
  },
  {
    lng: -41.4831383,
    lat: -21.2360723
  },
  {
    lng: -41.4830185,
    lat: -21.2359104
  },
  {
    lng: -41.482961,
    lat: -21.2358327
  },
  {
    lng: -41.4829353,
    lat: -21.23583
  },
  {
    lng: -41.4827355,
    lat: -21.2358595
  },
  {
    lng: -41.4826459,
    lat: -21.2358015
  },
  {
    lng: -41.4822631,
    lat: -21.2358604
  },
  {
    lng: -41.4821491,
    lat: -21.2358197
  },
  {
    lng: -41.4819837,
    lat: -21.2356793
  },
  {
    lng: -41.4818593,
    lat: -21.2355736
  },
  {
    lng: -41.4819345,
    lat: -21.2354456
  },
  {
    lng: -41.481992,
    lat: -21.2353709
  },
  {
    lng: -41.4821124,
    lat: -21.2352033
  },
  {
    lng: -41.4821494,
    lat: -21.2351327
  },
  {
    lng: -41.4821116,
    lat: -21.2350511
  },
  {
    lng: -41.4820366,
    lat: -21.2350371
  },
  {
    lng: -41.4817346,
    lat: -21.2352646
  },
  {
    lng: -41.4816342,
    lat: -21.2353234
  },
  {
    lng: -41.4812713,
    lat: -21.2354454
  },
  {
    lng: -41.4809027,
    lat: -21.2355645
  },
  {
    lng: -41.4806406,
    lat: -21.2356259
  },
  {
    lng: -41.4802543,
    lat: -21.2355817
  },
  {
    lng: -41.4798643,
    lat: -21.2355696
  },
  {
    lng: -41.4796375,
    lat: -21.2355824
  },
  {
    lng: -41.4795049,
    lat: -21.2355898
  },
  {
    lng: -41.4795101,
    lat: -21.2354761
  },
  {
    lng: -41.4794417,
    lat: -21.2352532
  },
  {
    lng: -41.4794748,
    lat: -21.2351703
  },
  {
    lng: -41.4794823,
    lat: -21.2349825
  },
  {
    lng: -41.4793936,
    lat: -21.2348619
  },
  {
    lng: -41.4794477,
    lat: -21.2345178
  },
  {
    lng: -41.4796333,
    lat: -21.2345146
  },
  {
    lng: -41.4797162,
    lat: -21.2345027
  },
  {
    lng: -41.4797197,
    lat: -21.234296
  },
  {
    lng: -41.4796084,
    lat: -21.2341873
  },
  {
    lng: -41.4792743,
    lat: -21.2339989
  },
  {
    lng: -41.4789916,
    lat: -21.2338831
  },
  {
    lng: -41.4789184,
    lat: -21.2338531
  },
  {
    lng: -41.4785172,
    lat: -21.2338978
  },
  {
    lng: -41.478136,
    lat: -21.2339676
  },
  {
    lng: -41.4778076,
    lat: -21.2341676
  },
  {
    lng: -41.4774243,
    lat: -21.2340814
  },
  {
    lng: -41.4772392,
    lat: -21.2339319
  },
  {
    lng: -41.4772923,
    lat: -21.2335588
  },
  {
    lng: -41.4772814,
    lat: -21.2334235
  },
  {
    lng: -41.4772307,
    lat: -21.2333695
  },
  {
    lng: -41.477223,
    lat: -21.2333613
  },
  {
    lng: -41.4768354,
    lat: -21.2333679
  },
  {
    lng: -41.4765239,
    lat: -21.233315
  },
  {
    lng: -41.4763485,
    lat: -21.2333744
  },
  {
    lng: -41.4760361,
    lat: -21.2334988
  },
  {
    lng: -41.4757951,
    lat: -21.2336273
  },
  {
    lng: -41.4757388,
    lat: -21.2336089
  },
  {
    lng: -41.4755503,
    lat: -21.2333363
  },
  {
    lng: -41.4754348,
    lat: -21.2333215
  },
  {
    lng: -41.4751089,
    lat: -21.2335171
  },
  {
    lng: -41.4747276,
    lat: -21.2335848
  },
  {
    lng: -41.4743417,
    lat: -21.2335497
  },
  {
    lng: -41.4739717,
    lat: -21.233432
  },
  {
    lng: -41.4736187,
    lat: -21.2332804
  },
  {
    lng: -41.4735497,
    lat: -21.2331828
  },
  {
    lng: -41.4734037,
    lat: -21.2329765
  },
  {
    lng: -41.473328,
    lat: -21.2328465
  },
  {
    lng: -41.4729473,
    lat: -21.2329152
  },
  {
    lng: -41.4729024,
    lat: -21.2329197
  },
  {
    lng: -41.4725641,
    lat: -21.2329542
  },
  {
    lng: -41.4724001,
    lat: -21.2328406
  },
  {
    lng: -41.4723973,
    lat: -21.2328926
  },
  {
    lng: -41.4724097,
    lat: -21.2330657
  },
  {
    lng: -41.4720487,
    lat: -21.232939
  },
  {
    lng: -41.4718588,
    lat: -21.2326204
  },
  {
    lng: -41.4714947,
    lat: -21.2324966
  },
  {
    lng: -41.4711951,
    lat: -21.2322688
  },
  {
    lng: -41.4711704,
    lat: -21.2322375
  },
  {
    lng: -41.4708941,
    lat: -21.2320331
  },
  {
    lng: -41.470826,
    lat: -21.2318118
  },
  {
    lng: -41.4707565,
    lat: -21.2317139
  },
  {
    lng: -41.4704985,
    lat: -21.2314442
  },
  {
    lng: -41.4704271,
    lat: -21.2314179
  },
  {
    lng: -41.4701755,
    lat: -21.2313258
  },
  {
    lng: -41.4700815,
    lat: -21.2313927
  },
  {
    lng: -41.4700532,
    lat: -21.2314135
  },
  {
    lng: -41.4700076,
    lat: -21.2283348
  },
  {
    lng: -41.4699564,
    lat: -21.2248742
  },
  {
    lng: -41.4696296,
    lat: -21.2027933
  },
  {
    lng: -41.4691532,
    lat: -21.2030318
  },
  {
    lng: -41.4687508,
    lat: -21.2032258
  },
  {
    lng: -41.4684083,
    lat: -21.2033619
  },
  {
    lng: -41.4681562,
    lat: -21.2034735
  },
  {
    lng: -41.4679433,
    lat: -21.2035774
  },
  {
    lng: -41.4677476,
    lat: -21.2037423
  },
  {
    lng: -41.4669212,
    lat: -21.2043785
  },
  {
    lng: -41.4666462,
    lat: -21.2045837
  },
  {
    lng: -41.4663704,
    lat: -21.204748
  },
  {
    lng: -41.4658726,
    lat: -21.2050286
  },
  {
    lng: -41.4656477,
    lat: -21.2051194
  },
  {
    lng: -41.4655184,
    lat: -21.2051717
  },
  {
    lng: -41.4651536,
    lat: -21.2053114
  },
  {
    lng: -41.4642492,
    lat: -21.2058662
  },
  {
    lng: -41.4640275,
    lat: -21.206011
  },
  {
    lng: -41.463782,
    lat: -21.2061101
  },
  {
    lng: -41.4631862,
    lat: -21.2062382
  },
  {
    lng: -41.4629539,
    lat: -21.2063122
  },
  {
    lng: -41.4627943,
    lat: -21.2063733
  },
  {
    lng: -41.4626122,
    lat: -21.2065055
  },
  {
    lng: -41.4621793,
    lat: -21.206931
  },
  {
    lng: -41.4620049,
    lat: -21.2071703
  },
  {
    lng: -41.4618789,
    lat: -21.2072909
  },
  {
    lng: -41.4615266,
    lat: -21.2075332
  },
  {
    lng: -41.4613989,
    lat: -21.2076122
  },
  {
    lng: -41.4612004,
    lat: -21.2077432
  },
  {
    lng: -41.4610691,
    lat: -21.2078198
  },
  {
    lng: -41.460862,
    lat: -21.207929
  },
  {
    lng: -41.4609353,
    lat: -21.2082344
  },
  {
    lng: -41.4609059,
    lat: -21.2083943
  },
  {
    lng: -41.4608273,
    lat: -21.2085743
  },
  {
    lng: -41.4607775,
    lat: -21.2086409
  },
  {
    lng: -41.459873,
    lat: -21.2089322
  },
  {
    lng: -41.4595594,
    lat: -21.2090267
  },
  {
    lng: -41.4593023,
    lat: -21.2090747
  },
  {
    lng: -41.4590949,
    lat: -21.2090768
  },
  {
    lng: -41.4589152,
    lat: -21.2090429
  },
  {
    lng: -41.4587581,
    lat: -21.2089522
  },
  {
    lng: -41.4586137,
    lat: -21.2087422
  },
  {
    lng: -41.4584364,
    lat: -21.2085369
  },
  {
    lng: -41.4582414,
    lat: -21.208409
  },
  {
    lng: -41.4580183,
    lat: -21.2083172
  },
  {
    lng: -41.4577894,
    lat: -21.2082511
  },
  {
    lng: -41.4576231,
    lat: -21.2082403
  },
  {
    lng: -41.4570135,
    lat: -21.2084312
  },
  {
    lng: -41.4563949,
    lat: -21.2086403
  },
  {
    lng: -41.4556541,
    lat: -21.208837
  },
  {
    lng: -41.455228,
    lat: -21.2089458
  },
  {
    lng: -41.4542164,
    lat: -21.2089828
  },
  {
    lng: -41.4537612,
    lat: -21.2090597
  },
  {
    lng: -41.4535044,
    lat: -21.209171
  },
  {
    lng: -41.4531846,
    lat: -21.2093966
  },
  {
    lng: -41.4526316,
    lat: -21.2099232
  },
  {
    lng: -41.4522465,
    lat: -21.2103375
  },
  {
    lng: -41.4520415,
    lat: -21.2106129
  },
  {
    lng: -41.4519602,
    lat: -21.2108113
  },
  {
    lng: -41.4519399,
    lat: -21.2110211
  },
  {
    lng: -41.4518587,
    lat: -21.2112091
  },
  {
    lng: -41.4516581,
    lat: -21.2115376
  },
  {
    lng: -41.4507475,
    lat: -21.2125479
  },
  {
    lng: -41.4504191,
    lat: -21.2127763
  },
  {
    lng: -41.4502589,
    lat: -21.2129801
  },
  {
    lng: -41.450103,
    lat: -21.2132703
  },
  {
    lng: -41.4500505,
    lat: -21.2133681
  },
  {
    lng: -41.4498233,
    lat: -21.21354
  },
  {
    lng: -41.4493805,
    lat: -21.2138369
  },
  {
    lng: -41.4483536,
    lat: -21.2144451
  },
  {
    lng: -41.4480816,
    lat: -21.2146288
  },
  {
    lng: -41.4479069,
    lat: -21.2146996
  },
  {
    lng: -41.4476921,
    lat: -21.214842
  },
  {
    lng: -41.44748,
    lat: -21.2148688
  },
  {
    lng: -41.4472952,
    lat: -21.2148493
  },
  {
    lng: -41.4470747,
    lat: -21.2150257
  },
  {
    lng: -41.4467587,
    lat: -21.2150919
  },
  {
    lng: -41.4465749,
    lat: -21.2151801
  },
  {
    lng: -41.4463838,
    lat: -21.2153565
  },
  {
    lng: -41.4461707,
    lat: -21.2154814
  },
  {
    lng: -41.4458253,
    lat: -21.2154667
  },
  {
    lng: -41.4455888,
    lat: -21.2153975
  },
  {
    lng: -41.4454798,
    lat: -21.215158
  },
  {
    lng: -41.444928,
    lat: -21.2150082
  },
  {
    lng: -41.4439143,
    lat: -21.2147538
  },
  {
    lng: -41.4433705,
    lat: -21.2146876
  },
  {
    lng: -41.4428854,
    lat: -21.2146876
  },
  {
    lng: -41.4422325,
    lat: -21.214412
  },
  {
    lng: -41.4414595,
    lat: -21.2141217
  },
  {
    lng: -41.4410448,
    lat: -21.2139749
  },
  {
    lng: -41.4406954,
    lat: -21.2139293
  },
  {
    lng: -41.4403847,
    lat: -21.2139428
  },
  {
    lng: -41.4401195,
    lat: -21.2139727
  },
  {
    lng: -41.4400657,
    lat: -21.2139836
  },
  {
    lng: -41.4399172,
    lat: -21.2140138
  },
  {
    lng: -41.439789,
    lat: -21.2140823
  },
  {
    lng: -41.4396419,
    lat: -21.2142308
  },
  {
    lng: -41.4394896,
    lat: -21.2146255
  },
  {
    lng: -41.4394682,
    lat: -21.2147834
  },
  {
    lng: -41.4394555,
    lat: -21.2148767
  },
  {
    lng: -41.4393707,
    lat: -21.2150688
  },
  {
    lng: -41.4392341,
    lat: -21.2152552
  },
  {
    lng: -41.4390576,
    lat: -21.2154147
  },
  {
    lng: -41.4386908,
    lat: -21.2155518
  },
  {
    lng: -41.438366,
    lat: -21.2156034
  },
  {
    lng: -41.4379209,
    lat: -21.2155739
  },
  {
    lng: -41.4375563,
    lat: -21.2155556
  },
  {
    lng: -41.4371616,
    lat: -21.2155694
  },
  {
    lng: -41.4365146,
    lat: -21.2156783
  },
  {
    lng: -41.4360474,
    lat: -21.2157616
  },
  {
    lng: -41.4357033,
    lat: -21.2157812
  },
  {
    lng: -41.4355598,
    lat: -21.2157773
  },
  {
    lng: -41.4354156,
    lat: -21.2157056
  },
  {
    lng: -41.4349445,
    lat: -21.2153805
  },
  {
    lng: -41.4343997,
    lat: -21.2149766
  },
  {
    lng: -41.4339918,
    lat: -21.2147064
  },
  {
    lng: -41.433391,
    lat: -21.2142789
  },
  {
    lng: -41.4331984,
    lat: -21.2141099
  },
  {
    lng: -41.4330191,
    lat: -21.2139527
  },
  {
    lng: -41.4325871,
    lat: -21.2135416
  },
  {
    lng: -41.4320631,
    lat: -21.2130769
  },
  {
    lng: -41.4313426,
    lat: -21.212363
  },
  {
    lng: -41.4305323,
    lat: -21.2113234
  },
  {
    lng: -41.4304159,
    lat: -21.2111734
  },
  {
    lng: -41.4301684,
    lat: -21.2108547
  },
  {
    lng: -41.4288561,
    lat: -21.2095796
  },
  {
    lng: -41.4283118,
    lat: -21.2091361
  },
  {
    lng: -41.4274615,
    lat: -21.2085133
  },
  {
    lng: -41.4267789,
    lat: -21.2081159
  },
  {
    lng: -41.4256029,
    lat: -21.2075722
  },
  {
    lng: -41.4254373,
    lat: -21.2074963
  },
  {
    lng: -41.424831,
    lat: -21.2071217
  },
  {
    lng: -41.424198,
    lat: -21.2064985
  },
  {
    lng: -41.4234967,
    lat: -21.2058501
  },
  {
    lng: -41.4230066,
    lat: -21.2050948
  },
  {
    lng: -41.4223449,
    lat: -21.2042739
  },
  {
    lng: -41.421617,
    lat: -21.2036688
  },
  {
    lng: -41.4210288,
    lat: -21.2030518
  },
  {
    lng: -41.4206269,
    lat: -21.2027648
  },
  {
    lng: -41.4199675,
    lat: -21.2023639
  },
  {
    lng: -41.4192139,
    lat: -21.2018676
  },
  {
    lng: -41.4184078,
    lat: -21.2013163
  },
  {
    lng: -41.4177483,
    lat: -21.2007843
  },
  {
    lng: -41.4173144,
    lat: -21.2004948
  },
  {
    lng: -41.4169283,
    lat: -21.2002612
  },
  {
    lng: -41.4166202,
    lat: -21.2001241
  },
  {
    lng: -41.4163186,
    lat: -21.2000978
  },
  {
    lng: -41.4160828,
    lat: -21.2001183
  },
  {
    lng: -41.4153852,
    lat: -21.2002427
  },
  {
    lng: -41.4147473,
    lat: -21.2004318
  },
  {
    lng: -41.4142092,
    lat: -21.2006526
  },
  {
    lng: -41.4139384,
    lat: -21.2008389
  },
  {
    lng: -41.413694,
    lat: -21.2012692
  },
  {
    lng: -41.4135231,
    lat: -21.2015252
  },
  {
    lng: -41.4134144,
    lat: -21.2016506
  },
  {
    lng: -41.4131956,
    lat: -21.2017929
  },
  {
    lng: -41.412941,
    lat: -21.2018485
  },
  {
    lng: -41.4126218,
    lat: -21.2018287
  },
  {
    lng: -41.4120574,
    lat: -21.2016585
  },
  {
    lng: -41.4118183,
    lat: -21.2015352
  },
  {
    lng: -41.4117943,
    lat: -21.2014703
  },
  {
    lng: -41.4117925,
    lat: -21.2013295
  },
  {
    lng: -41.4118339,
    lat: -21.2009499
  },
  {
    lng: -41.4118292,
    lat: -21.2005868
  },
  {
    lng: -41.4117682,
    lat: -21.2003487
  },
  {
    lng: -41.4114291,
    lat: -21.1996572
  },
  {
    lng: -41.4110082,
    lat: -21.1989015
  },
  {
    lng: -41.4108084,
    lat: -21.19867
  },
  {
    lng: -41.4106509,
    lat: -21.1985683
  },
  {
    lng: -41.4104243,
    lat: -21.1984942
  },
  {
    lng: -41.4103317,
    lat: -21.1984841
  },
  {
    lng: -41.4102395,
    lat: -21.1985066
  },
  {
    lng: -41.410067,
    lat: -21.1985784
  },
  {
    lng: -41.4096243,
    lat: -21.1987444
  },
  {
    lng: -41.4094284,
    lat: -21.1987839
  },
  {
    lng: -41.4091925,
    lat: -21.1988399
  },
  {
    lng: -41.4090776,
    lat: -21.1988787
  },
  {
    lng: -41.4089516,
    lat: -21.19895
  },
  {
    lng: -41.4088773,
    lat: -21.1990047
  },
  {
    lng: -41.4087922,
    lat: -21.1991136
  },
  {
    lng: -41.4087137,
    lat: -21.1992819
  },
  {
    lng: -41.4086531,
    lat: -21.199488
  },
  {
    lng: -41.4085756,
    lat: -21.199732
  },
  {
    lng: -41.4083238,
    lat: -21.2002962
  },
  {
    lng: -41.4081993,
    lat: -21.2006078
  },
  {
    lng: -41.4080662,
    lat: -21.2008493
  },
  {
    lng: -41.4076179,
    lat: -21.2013384
  },
  {
    lng: -41.4069779,
    lat: -21.2020765
  },
  {
    lng: -41.4067916,
    lat: -21.2023204
  },
  {
    lng: -41.4066382,
    lat: -21.2024507
  },
  {
    lng: -41.4065012,
    lat: -21.2025162
  },
  {
    lng: -41.4063807,
    lat: -21.2025276
  },
  {
    lng: -41.4063319,
    lat: -21.20252
  },
  {
    lng: -41.4062792,
    lat: -21.2025117
  },
  {
    lng: -41.4062138,
    lat: -21.2025015
  },
  {
    lng: -41.405833,
    lat: -21.2023686
  },
  {
    lng: -41.4055962,
    lat: -21.2022674
  },
  {
    lng: -41.4055151,
    lat: -21.2022085
  },
  {
    lng: -41.4053467,
    lat: -21.2020693
  },
  {
    lng: -41.4052763,
    lat: -21.2019564
  },
  {
    lng: -41.4051281,
    lat: -21.2016176
  },
  {
    lng: -41.4050025,
    lat: -21.2012517
  },
  {
    lng: -41.4049022,
    lat: -21.2010474
  },
  {
    lng: -41.4047303,
    lat: -21.2006549
  },
  {
    lng: -41.4046599,
    lat: -21.2005367
  },
  {
    lng: -41.4046132,
    lat: -21.2004777
  },
  {
    lng: -41.4045546,
    lat: -21.2003864
  },
  {
    lng: -41.4044827,
    lat: -21.2001712
  },
  {
    lng: -41.4044569,
    lat: -21.1999665
  },
  {
    lng: -41.4044521,
    lat: -21.1996268
  },
  {
    lng: -41.404445,
    lat: -21.1995297
  },
  {
    lng: -41.4043621,
    lat: -21.199347
  },
  {
    lng: -41.4042126,
    lat: -21.198954
  },
  {
    lng: -41.4039509,
    lat: -21.1985958
  },
  {
    lng: -41.4035628,
    lat: -21.198374
  },
  {
    lng: -41.4031055,
    lat: -21.1982632
  },
  {
    lng: -41.4026481,
    lat: -21.1982909
  },
  {
    lng: -41.4021353,
    lat: -21.1984018
  },
  {
    lng: -41.4013731,
    lat: -21.198873
  },
  {
    lng: -41.4009296,
    lat: -21.198873
  },
  {
    lng: -41.4006838,
    lat: -21.1989058
  },
  {
    lng: -41.4005138,
    lat: -21.1989284
  },
  {
    lng: -41.4001951,
    lat: -21.1990531
  },
  {
    lng: -41.3998763,
    lat: -21.199261
  },
  {
    lng: -41.399516,
    lat: -21.1996352
  },
  {
    lng: -41.3993081,
    lat: -21.2000787
  },
  {
    lng: -41.3989755,
    lat: -21.2003697
  },
  {
    lng: -41.3985181,
    lat: -21.2006331
  },
  {
    lng: -41.3980608,
    lat: -21.2007717
  },
  {
    lng: -41.3975896,
    lat: -21.2008132
  },
  {
    lng: -41.3951806,
    lat: -21.2007427
  },
  {
    lng: -41.3947485,
    lat: -21.2007301
  },
  {
    lng: -41.3944574,
    lat: -21.2008548
  },
  {
    lng: -41.3942634,
    lat: -21.2011181
  },
  {
    lng: -41.3939308,
    lat: -21.2015893
  },
  {
    lng: -41.3933764,
    lat: -21.2022269
  },
  {
    lng: -41.3928636,
    lat: -21.2024902
  },
  {
    lng: -41.392531,
    lat: -21.2025179
  },
  {
    lng: -41.3921291,
    lat: -21.202407
  },
  {
    lng: -41.3917272,
    lat: -21.2021853
  },
  {
    lng: -41.3912837,
    lat: -21.2019081
  },
  {
    lng: -41.390903,
    lat: -21.2014703
  },
  {
    lng: -41.3907237,
    lat: -21.201149
  },
  {
    lng: -41.3901888,
    lat: -21.2007855
  },
  {
    lng: -41.3898326,
    lat: -21.20035
  },
  {
    lng: -41.3892969,
    lat: -21.1999726
  },
  {
    lng: -41.388475,
    lat: -21.1991278
  },
  {
    lng: -41.388013,
    lat: -21.1989007
  },
  {
    lng: -41.3876249,
    lat: -21.198873
  },
  {
    lng: -41.3872507,
    lat: -21.1991501
  },
  {
    lng: -41.3870706,
    lat: -21.1994828
  },
  {
    lng: -41.386835,
    lat: -21.1997877
  },
  {
    lng: -41.3865855,
    lat: -21.2002173
  },
  {
    lng: -41.3862806,
    lat: -21.2004529
  },
  {
    lng: -41.3858925,
    lat: -21.2005499
  },
  {
    lng: -41.3855876,
    lat: -21.2007301
  },
  {
    lng: -41.3852827,
    lat: -21.2008825
  },
  {
    lng: -41.3848808,
    lat: -21.2009657
  },
  {
    lng: -41.3844096,
    lat: -21.2009518
  },
  {
    lng: -41.38398,
    lat: -21.2008409
  },
  {
    lng: -41.3830099,
    lat: -21.2002727
  },
  {
    lng: -41.382443,
    lat: -21.20016
  },
  {
    lng: -41.3818551,
    lat: -21.2001428
  },
  {
    lng: -41.3812913,
    lat: -21.1999817
  },
  {
    lng: -41.3811112,
    lat: -21.1998057
  },
  {
    lng: -41.3808479,
    lat: -21.1993858
  },
  {
    lng: -41.3807786,
    lat: -21.1986374
  },
  {
    lng: -41.3807924,
    lat: -21.1979306
  },
  {
    lng: -41.3807786,
    lat: -21.1971406
  },
  {
    lng: -41.3806815,
    lat: -21.1967524
  },
  {
    lng: -41.3805845,
    lat: -21.1963645
  },
  {
    lng: -41.3803351,
    lat: -21.1958378
  },
  {
    lng: -41.3800856,
    lat: -21.1956854
  },
  {
    lng: -41.3788383,
    lat: -21.1955884
  },
  {
    lng: -41.3782442,
    lat: -21.1957475
  },
  {
    lng: -41.3769415,
    lat: -21.1958381
  },
  {
    lng: -41.376795,
    lat: -21.1958172
  },
  {
    lng: -41.3766486,
    lat: -21.1957963
  },
  {
    lng: -41.37623,
    lat: -21.1960924
  },
  {
    lng: -41.3760388,
    lat: -21.1963506
  },
  {
    lng: -41.3760078,
    lat: -21.1968377
  },
  {
    lng: -41.3763298,
    lat: -21.1973485
  },
  {
    lng: -41.3765516,
    lat: -21.1979028
  },
  {
    lng: -41.3764407,
    lat: -21.1985265
  },
  {
    lng: -41.3762882,
    lat: -21.1989838
  },
  {
    lng: -41.3759972,
    lat: -21.1998847
  },
  {
    lng: -41.375623,
    lat: -21.2008964
  },
  {
    lng: -41.3753735,
    lat: -21.2015478
  },
  {
    lng: -41.3749439,
    lat: -21.201922
  },
  {
    lng: -41.3743757,
    lat: -21.2020051
  },
  {
    lng: -41.3739183,
    lat: -21.2023239
  },
  {
    lng: -41.3735441,
    lat: -21.2026981
  },
  {
    lng: -41.3731977,
    lat: -21.2031415
  },
  {
    lng: -41.3728373,
    lat: -21.2033772
  },
  {
    lng: -41.3723523,
    lat: -21.2035435
  },
  {
    lng: -41.3719088,
    lat: -21.2034742
  },
  {
    lng: -41.3712297,
    lat: -21.2035019
  },
  {
    lng: -41.3707585,
    lat: -21.2037375
  },
  {
    lng: -41.3703566,
    lat: -21.2040285
  },
  {
    lng: -41.3699408,
    lat: -21.2042226
  },
  {
    lng: -41.3696082,
    lat: -21.2041671
  },
  {
    lng: -41.3693726,
    lat: -21.2039731
  },
  {
    lng: -41.3692894,
    lat: -21.2035989
  },
  {
    lng: -41.3685965,
    lat: -21.2028782
  },
  {
    lng: -41.3678065,
    lat: -21.2025733
  },
  {
    lng: -41.3671413,
    lat: -21.2024902
  },
  {
    lng: -41.3664899,
    lat: -21.2023516
  },
  {
    lng: -41.3661434,
    lat: -21.202407
  },
  {
    lng: -41.3658801,
    lat: -21.2027951
  },
  {
    lng: -41.3653812,
    lat: -21.2030307
  },
  {
    lng: -41.3651594,
    lat: -21.2034049
  },
  {
    lng: -41.3645358,
    lat: -21.2033772
  },
  {
    lng: -41.3639953,
    lat: -21.2033633
  },
  {
    lng: -41.3633023,
    lat: -21.2027674
  },
  {
    lng: -41.3629252,
    lat: -21.2026908
  },
  {
    lng: -41.3625845,
    lat: -21.2028369
  },
  {
    lng: -41.3622803,
    lat: -21.2030681
  },
  {
    lng: -41.3621586,
    lat: -21.2033236
  },
  {
    lng: -41.3622924,
    lat: -21.2036887
  },
  {
    lng: -41.3622148,
    lat: -21.2040684
  },
  {
    lng: -41.3620734,
    lat: -21.2042363
  },
  {
    lng: -41.3620734,
    lat: -21.2045162
  },
  {
    lng: -41.3619115,
    lat: -21.2046685
  },
  {
    lng: -41.3615988,
    lat: -21.2048326
  },
  {
    lng: -41.3614325,
    lat: -21.2048484
  },
  {
    lng: -41.3613009,
    lat: -21.2049091
  },
  {
    lng: -41.3609298,
    lat: -21.2049673
  },
  {
    lng: -41.3606765,
    lat: -21.2049516
  },
  {
    lng: -41.3602695,
    lat: -21.2048339
  },
  {
    lng: -41.3599774,
    lat: -21.2047833
  },
  {
    lng: -41.3594736,
    lat: -21.2047625
  },
  {
    lng: -41.3593542,
    lat: -21.2047463
  },
  {
    lng: -41.3591502,
    lat: -21.2046974
  },
  {
    lng: -41.3588559,
    lat: -21.2045449
  },
  {
    lng: -41.3587757,
    lat: -21.2044576
  },
  {
    lng: -41.3587537,
    lat: -21.2043757
  },
  {
    lng: -41.3587462,
    lat: -21.2042351
  },
  {
    lng: -41.35873,
    lat: -21.2041259
  },
  {
    lng: -41.3586804,
    lat: -21.2040673
  },
  {
    lng: -41.3586171,
    lat: -21.2040283
  },
  {
    lng: -41.358577,
    lat: -21.2040183
  },
  {
    lng: -41.3585507,
    lat: -21.2040033
  },
  {
    lng: -41.3585303,
    lat: -21.2039801
  },
  {
    lng: -41.3584836,
    lat: -21.2038764
  },
  {
    lng: -41.3584718,
    lat: -21.2038327
  },
  {
    lng: -41.3584179,
    lat: -21.2037809
  },
  {
    lng: -41.3583749,
    lat: -21.2037503
  },
  {
    lng: -41.3583297,
    lat: -21.203751
  },
  {
    lng: -41.3582424,
    lat: -21.2037798
  },
  {
    lng: -41.3582031,
    lat: -21.2037833
  },
  {
    lng: -41.35802,
    lat: -21.2037553
  },
  {
    lng: -41.3575783,
    lat: -21.2036766
  },
  {
    lng: -41.3574028,
    lat: -21.203684
  },
  {
    lng: -41.3573367,
    lat: -21.2036882
  },
  {
    lng: -41.3571081,
    lat: -21.2037268
  },
  {
    lng: -41.3568782,
    lat: -21.2038199
  },
  {
    lng: -41.3562872,
    lat: -21.2038918
  },
  {
    lng: -41.356031,
    lat: -21.2039304
  },
  {
    lng: -41.3559285,
    lat: -21.2039831
  },
  {
    lng: -41.3557459,
    lat: -21.2040891
  },
  {
    lng: -41.3555961,
    lat: -21.2041549
  },
  {
    lng: -41.3554958,
    lat: -21.2042271
  },
  {
    lng: -41.3554709,
    lat: -21.2043044
  },
  {
    lng: -41.3554775,
    lat: -21.2043451
  },
  {
    lng: -41.3554473,
    lat: -21.2044053
  },
  {
    lng: -41.3554465,
    lat: -21.2044681
  },
  {
    lng: -41.3554643,
    lat: -21.2045845
  },
  {
    lng: -41.355468,
    lat: -21.2046411
  },
  {
    lng: -41.3554594,
    lat: -21.2047381
  },
  {
    lng: -41.3554948,
    lat: -21.2050466
  },
  {
    lng: -41.3554931,
    lat: -21.2051046
  },
  {
    lng: -41.3554816,
    lat: -21.2051702
  },
  {
    lng: -41.3553853,
    lat: -21.205496
  },
  {
    lng: -41.3553041,
    lat: -21.2057391
  },
  {
    lng: -41.3552506,
    lat: -21.205974
  },
  {
    lng: -41.3552151,
    lat: -21.2060922
  },
  {
    lng: -41.3551673,
    lat: -21.2062247
  },
  {
    lng: -41.3550795,
    lat: -21.2064133
  },
  {
    lng: -41.3550649,
    lat: -21.2064402
  },
  {
    lng: -41.3550234,
    lat: -21.2064996
  },
  {
    lng: -41.3549595,
    lat: -21.206572
  },
  {
    lng: -41.3548693,
    lat: -21.2066492
  },
  {
    lng: -41.3547709,
    lat: -21.2067211
  },
  {
    lng: -41.3547023,
    lat: -21.2067677
  },
  {
    lng: -41.3546273,
    lat: -21.2068091
  },
  {
    lng: -41.3545575,
    lat: -21.2068318
  },
  {
    lng: -41.3545414,
    lat: -21.2068338
  },
  {
    lng: -41.3545098,
    lat: -21.2068311
  },
  {
    lng: -41.3544528,
    lat: -21.2068154
  },
  {
    lng: -41.354393,
    lat: -21.2067869
  },
  {
    lng: -41.3540811,
    lat: -21.2065661
  },
  {
    lng: -41.3539849,
    lat: -21.2064857
  },
  {
    lng: -41.3538464,
    lat: -21.2063794
  },
  {
    lng: -41.3537618,
    lat: -21.2062921
  },
  {
    lng: -41.3536744,
    lat: -21.2062349
  },
  {
    lng: -41.3535811,
    lat: -21.2061858
  },
  {
    lng: -41.3534034,
    lat: -21.2061615
  },
  {
    lng: -41.3533597,
    lat: -21.2061425
  },
  {
    lng: -41.3532869,
    lat: -21.2061262
  },
  {
    lng: -41.3525598,
    lat: -21.2057538
  },
  {
    lng: -41.3520308,
    lat: -21.2055026
  },
  {
    lng: -41.3518829,
    lat: -21.205448
  },
  {
    lng: -41.3518028,
    lat: -21.2054123
  },
  {
    lng: -41.3515734,
    lat: -21.2053339
  },
  {
    lng: -41.3514103,
    lat: -21.2053177
  },
  {
    lng: -41.3511455,
    lat: -21.2054055
  },
  {
    lng: -41.3504118,
    lat: -21.2054857
  },
  {
    lng: -41.3496009,
    lat: -21.2054386
  },
  {
    lng: -41.3496007,
    lat: -21.2054386
  },
  {
    lng: -41.3494952,
    lat: -21.2055337
  },
  {
    lng: -41.3493876,
    lat: -21.2056076
  },
  {
    lng: -41.34916,
    lat: -21.2057436
  },
  {
    lng: -41.3490858,
    lat: -21.2057745
  },
  {
    lng: -41.3490101,
    lat: -21.2057978
  },
  {
    lng: -41.3489533,
    lat: -21.2058101
  },
  {
    lng: -41.34885,
    lat: -21.2058485
  },
  {
    lng: -41.3487933,
    lat: -21.2058759
  },
  {
    lng: -41.3487191,
    lat: -21.2058978
  },
  {
    lng: -41.348568,
    lat: -21.2059079
  },
  {
    lng: -41.3485423,
    lat: -21.2059053
  },
  {
    lng: -41.3484019,
    lat: -21.2060564
  },
  {
    lng: -41.3480235,
    lat: -21.206407
  },
  {
    lng: -41.3476158,
    lat: -21.2067766
  },
  {
    lng: -41.3471833,
    lat: -21.2070643
  },
  {
    lng: -41.3470786,
    lat: -21.20713
  },
  {
    lng: -41.3470044,
    lat: -21.207182
  },
  {
    lng: -41.3468881,
    lat: -21.2072654
  },
  {
    lng: -41.3466837,
    lat: -21.2074302
  },
  {
    lng: -41.3465681,
    lat: -21.2075068
  },
  {
    lng: -41.3463812,
    lat: -21.2076184
  },
  {
    lng: -41.3462306,
    lat: -21.2076828
  },
  {
    lng: -41.3460589,
    lat: -21.2077649
  },
  {
    lng: -41.3459134,
    lat: -21.2078279
  },
  {
    lng: -41.3455991,
    lat: -21.2079949
  },
  {
    lng: -41.3453663,
    lat: -21.2081072
  },
  {
    lng: -41.3450333,
    lat: -21.2082788
  },
  {
    lng: -41.3449992,
    lat: -21.2082963
  },
  {
    lng: -41.3448384,
    lat: -21.2083684
  },
  {
    lng: -41.3446408,
    lat: -21.2084436
  },
  {
    lng: -41.3444553,
    lat: -21.2084602
  },
  {
    lng: -41.3442612,
    lat: -21.2085428
  },
  {
    lng: -41.3441297,
    lat: -21.2085781
  },
  {
    lng: -41.3441034,
    lat: -21.2085898
  },
  {
    lng: -41.3440866,
    lat: -21.2085848
  },
  {
    lng: -41.3439739,
    lat: -21.2085877
  },
  {
    lng: -41.3439,
    lat: -21.2086032
  },
  {
    lng: -41.3437929,
    lat: -21.208643
  },
  {
    lng: -41.3436228,
    lat: -21.2087187
  },
  {
    lng: -41.343556,
    lat: -21.2087215
  },
  {
    lng: -41.3435473,
    lat: -21.2087218
  },
  {
    lng: -41.3434023,
    lat: -21.2087236
  },
  {
    lng: -41.3432878,
    lat: -21.2087348
  },
  {
    lng: -41.3432294,
    lat: -21.208747
  },
  {
    lng: -41.3431955,
    lat: -21.2087367
  },
  {
    lng: -41.3430309,
    lat: -21.2087493
  },
  {
    lng: -41.3429526,
    lat: -21.2087918
  },
  {
    lng: -41.3427958,
    lat: -21.208784
  },
  {
    lng: -41.3427477,
    lat: -21.2087778
  },
  {
    lng: -41.3427062,
    lat: -21.2086941
  },
  {
    lng: -41.3425197,
    lat: -21.2086614
  },
  {
    lng: -41.3424526,
    lat: -21.2086441
  },
  {
    lng: -41.3423485,
    lat: -21.208639
  },
  {
    lng: -41.3423181,
    lat: -21.2086331
  },
  {
    lng: -41.3422075,
    lat: -21.2086222
  },
  {
    lng: -41.3420844,
    lat: -21.2086286
  },
  {
    lng: -41.342037,
    lat: -21.2086504
  },
  {
    lng: -41.3420174,
    lat: -21.2086521
  },
  {
    lng: -41.3418982,
    lat: -21.2086458
  },
  {
    lng: -41.341749,
    lat: -21.2086146
  },
  {
    lng: -41.341631,
    lat: -21.2086106
  },
  {
    lng: -41.3415578,
    lat: -21.2085909
  },
  {
    lng: -41.3414547,
    lat: -21.2085703
  },
  {
    lng: -41.3413409,
    lat: -21.2085556
  },
  {
    lng: -41.3412989,
    lat: -21.2085703
  },
  {
    lng: -41.3411571,
    lat: -21.2085336
  },
  {
    lng: -41.3410136,
    lat: -21.2085251
  },
  {
    lng: -41.3409763,
    lat: -21.2085129
  },
  {
    lng: -41.3408225,
    lat: -21.2084551
  },
  {
    lng: -41.3406583,
    lat: -21.2083872
  },
  {
    lng: -41.3405401,
    lat: -21.2083334
  },
  {
    lng: -41.3403519,
    lat: -21.2082333
  },
  {
    lng: -41.3403499,
    lat: -21.2082324
  },
  {
    lng: -41.3401955,
    lat: -21.2081516
  },
  {
    lng: -41.3401176,
    lat: -21.2081039
  },
  {
    lng: -41.3399476,
    lat: -21.2079871
  },
  {
    lng: -41.3398635,
    lat: -21.2079405
  },
  {
    lng: -41.3398225,
    lat: -21.2079082
  },
  {
    lng: -41.3396712,
    lat: -21.2078045
  },
  {
    lng: -41.3394833,
    lat: -21.2076629
  },
  {
    lng: -41.3393261,
    lat: -21.2075715
  },
  {
    lng: -41.3392743,
    lat: -21.2075254
  },
  {
    lng: -41.3392283,
    lat: -21.2074973
  },
  {
    lng: -41.3392169,
    lat: -21.207465
  },
  {
    lng: -41.3390997,
    lat: -21.2074027
  },
  {
    lng: -41.3390138,
    lat: -21.2073486
  },
  {
    lng: -41.3389729,
    lat: -21.2072659
  },
  {
    lng: -41.3388966,
    lat: -21.2072085
  },
  {
    lng: -41.3388512,
    lat: -21.2071417
  },
  {
    lng: -41.3388101,
    lat: -21.2071194
  },
  {
    lng: -41.3387688,
    lat: -21.2070664
  },
  {
    lng: -41.3385997,
    lat: -21.2069609
  },
  {
    lng: -41.338556,
    lat: -21.2069193
  },
  {
    lng: -41.3385275,
    lat: -21.2068919
  },
  {
    lng: -41.3384111,
    lat: -21.2068354
  },
  {
    lng: -41.3381786,
    lat: -21.2068489
  },
  {
    lng: -41.338102,
    lat: -21.2068484
  },
  {
    lng: -41.3380162,
    lat: -21.2068536
  },
  {
    lng: -41.3379212,
    lat: -21.2068673
  },
  {
    lng: -41.3378384,
    lat: -21.206884
  },
  {
    lng: -41.3376975,
    lat: -21.206886
  },
  {
    lng: -41.3370595,
    lat: -21.2069441
  },
  {
    lng: -41.3367165,
    lat: -21.2071049
  },
  {
    lng: -41.3366671,
    lat: -21.2071519
  },
  {
    lng: -41.3366402,
    lat: -21.2071697
  },
  {
    lng: -41.3365968,
    lat: -21.2071909
  },
  {
    lng: -41.3364707,
    lat: -21.2072343
  },
  {
    lng: -41.3363478,
    lat: -21.2073268
  },
  {
    lng: -41.3363136,
    lat: -21.2074256
  },
  {
    lng: -41.336279,
    lat: -21.2075489
  },
  {
    lng: -41.3362111,
    lat: -21.207626
  },
  {
    lng: -41.3361648,
    lat: -21.2076659
  },
  {
    lng: -41.3360781,
    lat: -21.2078061
  },
  {
    lng: -41.3360224,
    lat: -21.2078776
  },
  {
    lng: -41.3359575,
    lat: -21.207949
  },
  {
    lng: -41.3358528,
    lat: -21.2080287
  },
  {
    lng: -41.3357974,
    lat: -21.2080657
  },
  {
    lng: -41.3357482,
    lat: -21.2080884
  },
  {
    lng: -41.3357204,
    lat: -21.2081198
  },
  {
    lng: -41.335683,
    lat: -21.2081372
  },
  {
    lng: -41.3356447,
    lat: -21.2081654
  },
  {
    lng: -41.3355188,
    lat: -21.2082732
  },
  {
    lng: -41.3354649,
    lat: -21.2083303
  },
  {
    lng: -41.3353805,
    lat: -21.2084387
  },
  {
    lng: -41.3353122,
    lat: -21.2084922
  },
  {
    lng: -41.3352513,
    lat: -21.2085564
  },
  {
    lng: -41.3351437,
    lat: -21.2086561
  },
  {
    lng: -41.3351103,
    lat: -21.2087032
  },
  {
    lng: -41.3350259,
    lat: -21.2087659
  },
  {
    lng: -41.3349849,
    lat: -21.208807
  },
  {
    lng: -41.3346444,
    lat: -21.2090401
  },
  {
    lng: -41.3345575,
    lat: -21.2091048
  },
  {
    lng: -41.3344839,
    lat: -21.2091704
  },
  {
    lng: -41.3344361,
    lat: -21.2091989
  },
  {
    lng: -41.3343045,
    lat: -21.2092658
  },
  {
    lng: -41.3341897,
    lat: -21.2093384
  },
  {
    lng: -41.3340478,
    lat: -21.2094174
  },
  {
    lng: -41.3339671,
    lat: -21.2094557
  },
  {
    lng: -41.3338245,
    lat: -21.2095143
  },
  {
    lng: -41.3337446,
    lat: -21.2095561
  },
  {
    lng: -41.3336456,
    lat: -21.209621
  },
  {
    lng: -41.3334382,
    lat: -21.2097053
  },
  {
    lng: -41.3331346,
    lat: -21.20986
  },
  {
    lng: -41.3330756,
    lat: -21.2098836
  },
  {
    lng: -41.3330091,
    lat: -21.2099135
  },
  {
    lng: -41.3328375,
    lat: -21.2099625
  },
  {
    lng: -41.3323185,
    lat: -21.2102664
  },
  {
    lng: -41.3318834,
    lat: -21.2106623
  },
  {
    lng: -41.3316554,
    lat: -21.2108831
  },
  {
    lng: -41.3313012,
    lat: -21.2113669
  },
  {
    lng: -41.3311712,
    lat: -21.2118843
  },
  {
    lng: -41.3311596,
    lat: -21.2122902
  },
  {
    lng: -41.3311854,
    lat: -21.212526
  },
  {
    lng: -41.3313269,
    lat: -21.2129265
  },
  {
    lng: -41.331464,
    lat: -21.2131619
  },
  {
    lng: -41.3316828,
    lat: -21.2133989
  },
  {
    lng: -41.3325412,
    lat: -21.2140775
  },
  {
    lng: -41.3327817,
    lat: -21.2142831
  },
  {
    lng: -41.3328899,
    lat: -21.214522
  },
  {
    lng: -41.3329969,
    lat: -21.2148008
  },
  {
    lng: -41.333018,
    lat: -21.2152137
  },
  {
    lng: -41.3329951,
    lat: -21.2153806
  },
  {
    lng: -41.3329106,
    lat: -21.2154916
  },
  {
    lng: -41.3328106,
    lat: -21.2155253
  },
  {
    lng: -41.332554,
    lat: -21.2155536
  },
  {
    lng: -41.3317313,
    lat: -21.2156888
  },
  {
    lng: -41.3310286,
    lat: -21.215901
  },
  {
    lng: -41.3295174,
    lat: -21.2165076
  },
  {
    lng: -41.3284745,
    lat: -21.2170941
  },
  {
    lng: -41.3268513,
    lat: -21.2180974
  },
  {
    lng: -41.326502,
    lat: -21.2182772
  },
  {
    lng: -41.3255919,
    lat: -21.218545
  },
  {
    lng: -41.3254374,
    lat: -21.2185479
  },
  {
    lng: -41.3250969,
    lat: -21.2185391
  },
  {
    lng: -41.3248587,
    lat: -21.2185066
  },
  {
    lng: -41.3245817,
    lat: -21.2184391
  },
  {
    lng: -41.3243888,
    lat: -21.2183858
  },
  {
    lng: -41.3242051,
    lat: -21.2183119
  },
  {
    lng: -41.324035,
    lat: -21.2182063
  },
  {
    lng: -41.323801,
    lat: -21.2180332
  },
  {
    lng: -41.3236612,
    lat: -21.2179171
  },
  {
    lng: -41.3236,
    lat: -21.2178497
  },
  {
    lng: -41.3233188,
    lat: -21.2174058
  },
  {
    lng: -41.3231873,
    lat: -21.2171349
  },
  {
    lng: -41.3231152,
    lat: -21.2169271
  },
  {
    lng: -41.3230837,
    lat: -21.2167913
  },
  {
    lng: -41.3230851,
    lat: -21.2166626
  },
  {
    lng: -41.3231098,
    lat: -21.2163929
  },
  {
    lng: -41.3231279,
    lat: -21.2163021
  },
  {
    lng: -41.3232175,
    lat: -21.2160135
  },
  {
    lng: -41.3233308,
    lat: -21.2157533
  },
  {
    lng: -41.3234856,
    lat: -21.2155534
  },
  {
    lng: -41.3239253,
    lat: -21.215179
  },
  {
    lng: -41.3243925,
    lat: -21.2148555
  },
  {
    lng: -41.3247652,
    lat: -21.2145491
  },
  {
    lng: -41.3250907,
    lat: -21.2142483
  },
  {
    lng: -41.325381,
    lat: -21.2139706
  },
  {
    lng: -41.3255951,
    lat: -21.2137173
  },
  {
    lng: -41.3257976,
    lat: -21.2134576
  },
  {
    lng: -41.3258403,
    lat: -21.2133751
  },
  {
    lng: -41.3258537,
    lat: -21.2133433
  },
  {
    lng: -41.3258619,
    lat: -21.2133066
  },
  {
    lng: -41.3258602,
    lat: -21.2132528
  },
  {
    lng: -41.3258515,
    lat: -21.2132287
  },
  {
    lng: -41.3258338,
    lat: -21.2131977
  },
  {
    lng: -41.3257819,
    lat: -21.2131328
  },
  {
    lng: -41.3256448,
    lat: -21.2130411
  },
  {
    lng: -41.3255145,
    lat: -21.212973
  },
  {
    lng: -41.3251226,
    lat: -21.2128847
  },
  {
    lng: -41.3248422,
    lat: -21.2128756
  },
  {
    lng: -41.3247606,
    lat: -21.2128821
  },
  {
    lng: -41.3243945,
    lat: -21.2129422
  },
  {
    lng: -41.3242388,
    lat: -21.2129939
  },
  {
    lng: -41.3238259,
    lat: -21.2132093
  },
  {
    lng: -41.3236404,
    lat: -21.2132822
  },
  {
    lng: -41.3228968,
    lat: -21.213515
  },
  {
    lng: -41.3226093,
    lat: -21.2136118
  },
  {
    lng: -41.322472,
    lat: -21.2136331
  },
  {
    lng: -41.322227,
    lat: -21.2136836
  },
  {
    lng: -41.3219215,
    lat: -21.2137097
  },
  {
    lng: -41.3215932,
    lat: -21.213748
  },
  {
    lng: -41.3214466,
    lat: -21.2137468
  },
  {
    lng: -41.32076,
    lat: -21.2138102
  },
  {
    lng: -41.3206859,
    lat: -21.2138058
  },
  {
    lng: -41.3202876,
    lat: -21.2138181
  },
  {
    lng: -41.3200796,
    lat: -21.2137983
  },
  {
    lng: -41.3197821,
    lat: -21.2137971
  },
  {
    lng: -41.3193451,
    lat: -21.2137384
  },
  {
    lng: -41.3190051,
    lat: -21.2136821
  },
  {
    lng: -41.3184453,
    lat: -21.2135739
  },
  {
    lng: -41.3180054,
    lat: -21.213517
  },
  {
    lng: -41.3174598,
    lat: -21.2134616
  },
  {
    lng: -41.3171306,
    lat: -21.2134359
  },
  {
    lng: -41.3168384,
    lat: -21.2134187
  },
  {
    lng: -41.3163658,
    lat: -21.2135126
  },
  {
    lng: -41.316273,
    lat: -21.2135505
  },
  {
    lng: -41.3161803,
    lat: -21.2135884
  },
  {
    lng: -41.3160967,
    lat: -21.2136426
  },
  {
    lng: -41.3160365,
    lat: -21.2136902
  },
  {
    lng: -41.3159725,
    lat: -21.2137725
  },
  {
    lng: -41.3159366,
    lat: -21.2138621
  },
  {
    lng: -41.3159223,
    lat: -21.2139305
  },
  {
    lng: -41.3159138,
    lat: -21.2140237
  },
  {
    lng: -41.3159555,
    lat: -21.2144216
  },
  {
    lng: -41.3160513,
    lat: -21.2149041
  },
  {
    lng: -41.3160965,
    lat: -21.2158075
  },
  {
    lng: -41.3161148,
    lat: -21.216589
  },
  {
    lng: -41.316151,
    lat: -21.2174815
  },
  {
    lng: -41.3162101,
    lat: -21.2184895
  },
  {
    lng: -41.316284,
    lat: -21.2190583
  },
  {
    lng: -41.3163679,
    lat: -21.2193972
  },
  {
    lng: -41.3164454,
    lat: -21.2199139
  },
  {
    lng: -41.3167123,
    lat: -21.220856
  },
  {
    lng: -41.3168931,
    lat: -21.2214139
  },
  {
    lng: -41.3169371,
    lat: -21.2215496
  },
  {
    lng: -41.3169483,
    lat: -21.2217064
  },
  {
    lng: -41.3169362,
    lat: -21.2218126
  },
  {
    lng: -41.3169083,
    lat: -21.2218921
  },
  {
    lng: -41.3168523,
    lat: -21.2219891
  },
  {
    lng: -41.3168076,
    lat: -21.2220506
  },
  {
    lng: -41.3167635,
    lat: -21.2221049
  },
  {
    lng: -41.3167188,
    lat: -21.2221494
  },
  {
    lng: -41.3166673,
    lat: -21.2221829
  },
  {
    lng: -41.3165972,
    lat: -21.222196
  },
  {
    lng: -41.3165301,
    lat: -21.2221949
  },
  {
    lng: -41.316465,
    lat: -21.2221769
  },
  {
    lng: -41.3163804,
    lat: -21.2221282
  },
  {
    lng: -41.3161323,
    lat: -21.2219213
  },
  {
    lng: -41.3158487,
    lat: -21.2217756
  },
  {
    lng: -41.3153669,
    lat: -21.2215358
  },
  {
    lng: -41.3150444,
    lat: -21.2213601
  },
  {
    lng: -41.3145899,
    lat: -21.2210774
  },
  {
    lng: -41.3143315,
    lat: -21.2208943
  },
  {
    lng: -41.313904,
    lat: -21.2205446
  },
  {
    lng: -41.3136326,
    lat: -21.2203176
  },
  {
    lng: -41.3131115,
    lat: -21.2198709
  },
  {
    lng: -41.312685,
    lat: -21.2196503
  },
  {
    lng: -41.3122044,
    lat: -21.2194563
  },
  {
    lng: -41.3121087,
    lat: -21.2194177
  },
  {
    lng: -41.3116915,
    lat: -21.2192828
  },
  {
    lng: -41.3113981,
    lat: -21.2192218
  },
  {
    lng: -41.3112684,
    lat: -21.2191939
  },
  {
    lng: -41.3110237,
    lat: -21.2191723
  },
  {
    lng: -41.3107916,
    lat: -21.2191646
  },
  {
    lng: -41.3105605,
    lat: -21.21921
  },
  {
    lng: -41.3104123,
    lat: -21.219249
  },
  {
    lng: -41.3102375,
    lat: -21.2193057
  },
  {
    lng: -41.3100431,
    lat: -21.2193767
  },
  {
    lng: -41.3098024,
    lat: -21.2194898
  },
  {
    lng: -41.3097711,
    lat: -21.2195173
  },
  {
    lng: -41.309694,
    lat: -21.2196199
  },
  {
    lng: -41.3096405,
    lat: -21.2197103
  },
  {
    lng: -41.3096051,
    lat: -21.219762
  },
  {
    lng: -41.3095932,
    lat: -21.2197923
  },
  {
    lng: -41.3095813,
    lat: -21.2198225
  },
  {
    lng: -41.3095693,
    lat: -21.2199345
  },
  {
    lng: -41.3095285,
    lat: -21.220522
  },
  {
    lng: -41.3093943,
    lat: -21.2211921
  },
  {
    lng: -41.3093462,
    lat: -21.2213723
  },
  {
    lng: -41.3090347,
    lat: -21.2218861
  },
  {
    lng: -41.3087368,
    lat: -21.2223585
  },
  {
    lng: -41.3083621,
    lat: -21.2228441
  },
  {
    lng: -41.3078744,
    lat: -21.2234274
  },
  {
    lng: -41.3072762,
    lat: -21.2241343
  },
  {
    lng: -41.3068285,
    lat: -21.2246047
  },
  {
    lng: -41.3061941,
    lat: -21.2253544
  },
  {
    lng: -41.3057505,
    lat: -21.22586
  },
  {
    lng: -41.3054044,
    lat: -21.2262724
  },
  {
    lng: -41.3051031,
    lat: -21.2266836
  },
  {
    lng: -41.3048275,
    lat: -21.2270362
  },
  {
    lng: -41.3043212,
    lat: -21.2277104
  },
  {
    lng: -41.3040443,
    lat: -21.2280377
  },
  {
    lng: -41.3038102,
    lat: -21.2282847
  },
  {
    lng: -41.3032327,
    lat: -21.2287582
  },
  {
    lng: -41.302842,
    lat: -21.2290558
  },
  {
    lng: -41.3021456,
    lat: -21.2295311
  },
  {
    lng: -41.3015157,
    lat: -21.2298996
  },
  {
    lng: -41.3011172,
    lat: -21.2300567
  },
  {
    lng: -41.3007045,
    lat: -21.230181
  },
  {
    lng: -41.3003377,
    lat: -21.2302485
  },
  {
    lng: -41.3001374,
    lat: -21.2302653
  },
  {
    lng: -41.2996653,
    lat: -21.230286
  },
  {
    lng: -41.2993334,
    lat: -21.2303271
  },
  {
    lng: -41.2986403,
    lat: -21.2304238
  },
  {
    lng: -41.298352,
    lat: -21.2304897
  },
  {
    lng: -41.2971561,
    lat: -21.2308859
  },
  {
    lng: -41.2969844,
    lat: -21.2310103
  },
  {
    lng: -41.2968618,
    lat: -21.2311424
  },
  {
    lng: -41.2967537,
    lat: -21.231369
  },
  {
    lng: -41.2966849,
    lat: -21.2315796
  },
  {
    lng: -41.2966626,
    lat: -21.2316806
  },
  {
    lng: -41.2966453,
    lat: -21.2317586
  },
  {
    lng: -41.2965979,
    lat: -21.232048
  },
  {
    lng: -41.296536,
    lat: -21.2324965
  },
  {
    lng: -41.2965537,
    lat: -21.2329052
  },
  {
    lng: -41.2966336,
    lat: -21.2331519
  },
  {
    lng: -41.2967853,
    lat: -21.2334587
  },
  {
    lng: -41.2968806,
    lat: -21.2336292
  },
  {
    lng: -41.2969715,
    lat: -21.2337457
  },
  {
    lng: -41.2973243,
    lat: -21.2341161
  },
  {
    lng: -41.2975407,
    lat: -21.2343951
  },
  {
    lng: -41.29761,
    lat: -21.234521
  },
  {
    lng: -41.2976344,
    lat: -21.2346405
  },
  {
    lng: -41.2976239,
    lat: -21.2347733
  },
  {
    lng: -41.2975685,
    lat: -21.2349194
  },
  {
    lng: -41.2974934,
    lat: -21.2350432
  },
  {
    lng: -41.2973832,
    lat: -21.2351514
  },
  {
    lng: -41.2971497,
    lat: -21.2352601
  },
  {
    lng: -41.2968821,
    lat: -21.2352822
  },
  {
    lng: -41.2964518,
    lat: -21.2352852
  },
  {
    lng: -41.2962726,
    lat: -21.2352821
  },
  {
    lng: -41.2962666,
    lat: -21.235282
  },
  {
    lng: -41.2960577,
    lat: -21.2352552
  },
  {
    lng: -41.2950228,
    lat: -21.2348662
  },
  {
    lng: -41.2946517,
    lat: -21.2346127
  },
  {
    lng: -41.2943928,
    lat: -21.2344007
  },
  {
    lng: -41.2941788,
    lat: -21.2341991
  },
  {
    lng: -41.293959,
    lat: -21.2339344
  },
  {
    lng: -41.2937814,
    lat: -21.2337037
  },
  {
    lng: -41.2933219,
    lat: -21.2331218
  },
  {
    lng: -41.2931442,
    lat: -21.2328728
  },
  {
    lng: -41.2930042,
    lat: -21.2327272
  },
  {
    lng: -41.2929781,
    lat: -21.2326999
  },
  {
    lng: -41.2928346,
    lat: -21.2325953
  },
  {
    lng: -41.2926716,
    lat: -21.232496
  },
  {
    lng: -41.2924441,
    lat: -21.2324049
  },
  {
    lng: -41.2922365,
    lat: -21.2323662
  },
  {
    lng: -41.2919393,
    lat: -21.2323648
  },
  {
    lng: -41.2917235,
    lat: -21.2323919
  },
  {
    lng: -41.2914631,
    lat: -21.2324613
  },
  {
    lng: -41.2913148,
    lat: -21.2325381
  },
  {
    lng: -41.2911723,
    lat: -21.232657
  },
  {
    lng: -41.2910025,
    lat: -21.2329258
  },
  {
    lng: -41.2908749,
    lat: -21.2332392
  },
  {
    lng: -41.2906893,
    lat: -21.2337605
  },
  {
    lng: -41.2904856,
    lat: -21.2339847
  },
  {
    lng: -41.2902564,
    lat: -21.2341565
  },
  {
    lng: -41.2900299,
    lat: -21.2342862
  },
  {
    lng: -41.2897567,
    lat: -21.2343818
  },
  {
    lng: -41.2895621,
    lat: -21.2344195
  },
  {
    lng: -41.289394,
    lat: -21.2344412
  },
  {
    lng: -41.2892062,
    lat: -21.2344524
  },
  {
    lng: -41.2889763,
    lat: -21.2344481
  },
  {
    lng: -41.2883449,
    lat: -21.2343059
  },
  {
    lng: -41.2880167,
    lat: -21.2342677
  },
  {
    lng: -41.2876157,
    lat: -21.2342561
  },
  {
    lng: -41.2870269,
    lat: -21.2342558
  },
  {
    lng: -41.2868391,
    lat: -21.2342697
  },
  {
    lng: -41.2866542,
    lat: -21.2342993
  },
  {
    lng: -41.2864695,
    lat: -21.2343657
  },
  {
    lng: -41.286324,
    lat: -21.2344478
  },
  {
    lng: -41.2860871,
    lat: -21.2347695
  },
  {
    lng: -41.285956,
    lat: -21.2349383
  },
  {
    lng: -41.2858368,
    lat: -21.2352358
  },
  {
    lng: -41.2858042,
    lat: -21.235491
  },
  {
    lng: -41.2857999,
    lat: -21.235796
  },
  {
    lng: -41.2858317,
    lat: -21.2361618
  },
  {
    lng: -41.2860209,
    lat: -21.2369784
  },
  {
    lng: -41.2860471,
    lat: -21.2372123
  },
  {
    lng: -41.2860368,
    lat: -21.2374358
  },
  {
    lng: -41.2859597,
    lat: -21.2377621
  },
  {
    lng: -41.2858068,
    lat: -21.2380651
  },
  {
    lng: -41.2856759,
    lat: -21.238268
  },
  {
    lng: -41.2854916,
    lat: -21.2384423
  },
  {
    lng: -41.2852995,
    lat: -21.2385894
  },
  {
    lng: -41.2852538,
    lat: -21.2386135
  },
  {
    lng: -41.2851808,
    lat: -21.2386425
  },
  {
    lng: -41.2851386,
    lat: -21.2386638
  },
  {
    lng: -41.2850252,
    lat: -21.2387015
  },
  {
    lng: -41.2849936,
    lat: -21.2387171
  },
  {
    lng: -41.2849383,
    lat: -21.2387325
  },
  {
    lng: -41.2849027,
    lat: -21.2387379
  },
  {
    lng: -41.284856,
    lat: -21.2387435
  },
  {
    lng: -41.2848028,
    lat: -21.2387448
  },
  {
    lng: -41.2847482,
    lat: -21.238734
  },
  {
    lng: -41.2847319,
    lat: -21.2387245
  },
  {
    lng: -41.2847066,
    lat: -21.238722
  },
  {
    lng: -41.2846749,
    lat: -21.2387269
  },
  {
    lng: -41.2846453,
    lat: -21.2387168
  },
  {
    lng: -41.2846374,
    lat: -21.238709
  },
  {
    lng: -41.2846149,
    lat: -21.2387084
  },
  {
    lng: -41.2845777,
    lat: -21.2386952
  },
  {
    lng: -41.2845571,
    lat: -21.2386963
  },
  {
    lng: -41.2845334,
    lat: -21.238691
  },
  {
    lng: -41.2845197,
    lat: -21.2386863
  },
  {
    lng: -41.284505,
    lat: -21.2386758
  },
  {
    lng: -41.2844646,
    lat: -21.2386675
  },
  {
    lng: -41.2843529,
    lat: -21.2385822
  },
  {
    lng: -41.2843359,
    lat: -21.2385745
  },
  {
    lng: -41.2842423,
    lat: -21.2385363
  },
  {
    lng: -41.2842037,
    lat: -21.2385318
  },
  {
    lng: -41.2840071,
    lat: -21.2384739
  },
  {
    lng: -41.2839302,
    lat: -21.2384404
  },
  {
    lng: -41.2838401,
    lat: -21.2383931
  },
  {
    lng: -41.2836762,
    lat: -21.2382635
  },
  {
    lng: -41.2836304,
    lat: -21.23822
  },
  {
    lng: -41.2835203,
    lat: -21.2380729
  },
  {
    lng: -41.2834959,
    lat: -21.2380494
  },
  {
    lng: -41.2834147,
    lat: -21.2378984
  },
  {
    lng: -41.2833682,
    lat: -21.2377876
  },
  {
    lng: -41.2833507,
    lat: -21.2377106
  },
  {
    lng: -41.283357,
    lat: -21.2376685
  },
  {
    lng: -41.2833582,
    lat: -21.237594
  },
  {
    lng: -41.2833714,
    lat: -21.2375392
  },
  {
    lng: -41.2833871,
    lat: -21.2374955
  },
  {
    lng: -41.2833885,
    lat: -21.2374744
  },
  {
    lng: -41.2834283,
    lat: -21.2373488
  },
  {
    lng: -41.2834636,
    lat: -21.2371526
  },
  {
    lng: -41.2834984,
    lat: -21.2370395
  },
  {
    lng: -41.2835446,
    lat: -21.2368401
  },
  {
    lng: -41.2836447,
    lat: -21.2365832
  },
  {
    lng: -41.2836836,
    lat: -21.2364975
  },
  {
    lng: -41.2837533,
    lat: -21.236408
  },
  {
    lng: -41.2837631,
    lat: -21.236403
  },
  {
    lng: -41.2837641,
    lat: -21.2364286
  },
  {
    lng: -41.2837732,
    lat: -21.2364182
  },
  {
    lng: -41.2838211,
    lat: -21.2363215
  },
  {
    lng: -41.2838761,
    lat: -21.2362379
  },
  {
    lng: -41.283899,
    lat: -21.2361878
  },
  {
    lng: -41.2839352,
    lat: -21.236142
  },
  {
    lng: -41.2839541,
    lat: -21.2361242
  },
  {
    lng: -41.2840379,
    lat: -21.2360547
  },
  {
    lng: -41.2840505,
    lat: -21.2360515
  },
  {
    lng: -41.284084,
    lat: -21.2360229
  },
  {
    lng: -41.2841212,
    lat: -21.2359812
  },
  {
    lng: -41.2841485,
    lat: -21.2359589
  },
  {
    lng: -41.2842006,
    lat: -21.235899
  },
  {
    lng: -41.284215,
    lat: -21.235873
  },
  {
    lng: -41.2842956,
    lat: -21.2357761
  },
  {
    lng: -41.2843035,
    lat: -21.2357867
  },
  {
    lng: -41.2843094,
    lat: -21.235787
  },
  {
    lng: -41.2843209,
    lat: -21.235757
  },
  {
    lng: -41.2843534,
    lat: -21.2357191
  },
  {
    lng: -41.2843864,
    lat: -21.2356657
  },
  {
    lng: -41.2843863,
    lat: -21.2356435
  },
  {
    lng: -41.2844607,
    lat: -21.235512
  },
  {
    lng: -41.2844747,
    lat: -21.2354731
  },
  {
    lng: -41.2844987,
    lat: -21.2353689
  },
  {
    lng: -41.2845057,
    lat: -21.2353181
  },
  {
    lng: -41.2845021,
    lat: -21.2352587
  },
  {
    lng: -41.2845573,
    lat: -21.2350879
  },
  {
    lng: -41.2845625,
    lat: -21.2350603
  },
  {
    lng: -41.2843085,
    lat: -21.2347648
  },
  {
    lng: -41.2843059,
    lat: -21.2347336
  },
  {
    lng: -41.2842964,
    lat: -21.2347014
  },
  {
    lng: -41.2842355,
    lat: -21.2346559
  },
  {
    lng: -41.2842216,
    lat: -21.2346292
  },
  {
    lng: -41.2841633,
    lat: -21.2346048
  },
  {
    lng: -41.2841546,
    lat: -21.2345932
  },
  {
    lng: -41.2841343,
    lat: -21.2345801
  },
  {
    lng: -41.2841177,
    lat: -21.2345622
  },
  {
    lng: -41.2840948,
    lat: -21.2345512
  },
  {
    lng: -41.2840773,
    lat: -21.2345529
  },
  {
    lng: -41.2840717,
    lat: -21.234561
  },
  {
    lng: -41.2840839,
    lat: -21.2345918
  },
  {
    lng: -41.284074,
    lat: -21.2345924
  },
  {
    lng: -41.2840319,
    lat: -21.2345893
  },
  {
    lng: -41.2838208,
    lat: -21.2345482
  },
  {
    lng: -41.2837569,
    lat: -21.2345526
  },
  {
    lng: -41.2835914,
    lat: -21.234503
  },
  {
    lng: -41.2835808,
    lat: -21.2344986
  },
  {
    lng: -41.2835584,
    lat: -21.2344759
  },
  {
    lng: -41.2835554,
    lat: -21.2344765
  },
  {
    lng: -41.2835401,
    lat: -21.2344942
  },
  {
    lng: -41.2835089,
    lat: -21.2345068
  },
  {
    lng: -41.2834256,
    lat: -21.2345194
  },
  {
    lng: -41.283339,
    lat: -21.2345455
  },
  {
    lng: -41.2830738,
    lat: -21.2346102
  },
  {
    lng: -41.2830192,
    lat: -21.2346283
  },
  {
    lng: -41.2829407,
    lat: -21.2346476
  },
  {
    lng: -41.2828521,
    lat: -21.2346806
  },
  {
    lng: -41.2827555,
    lat: -21.2347333
  },
  {
    lng: -41.2826176,
    lat: -21.2348203
  },
  {
    lng: -41.2825274,
    lat: -21.234894
  },
  {
    lng: -41.2824497,
    lat: -21.234967
  },
  {
    lng: -41.2823742,
    lat: -21.2350496
  },
  {
    lng: -41.2822837,
    lat: -21.2351334
  },
  {
    lng: -41.2822149,
    lat: -21.2352061
  },
  {
    lng: -41.282083,
    lat: -21.2353804
  },
  {
    lng: -41.2820695,
    lat: -21.2354114
  },
  {
    lng: -41.2819994,
    lat: -21.2355293
  },
  {
    lng: -41.2819731,
    lat: -21.2355957
  },
  {
    lng: -41.2819524,
    lat: -21.2356741
  },
  {
    lng: -41.2819418,
    lat: -21.235737
  },
  {
    lng: -41.2819114,
    lat: -21.2358151
  },
  {
    lng: -41.2818766,
    lat: -21.2359544
  },
  {
    lng: -41.2818587,
    lat: -21.2359947
  },
  {
    lng: -41.2818411,
    lat: -21.2360619
  },
  {
    lng: -41.2818264,
    lat: -21.2360856
  },
  {
    lng: -41.2818159,
    lat: -21.2361121
  },
  {
    lng: -41.2817986,
    lat: -21.2361878
  },
  {
    lng: -41.2817829,
    lat: -21.2362161
  },
  {
    lng: -41.2817669,
    lat: -21.2362534
  },
  {
    lng: -41.2817325,
    lat: -21.2364122
  },
  {
    lng: -41.2817192,
    lat: -21.2364927
  },
  {
    lng: -41.2817108,
    lat: -21.2365193
  },
  {
    lng: -41.2816919,
    lat: -21.2366164
  },
  {
    lng: -41.281682,
    lat: -21.2366825
  },
  {
    lng: -41.2816483,
    lat: -21.2367845
  },
  {
    lng: -41.281642,
    lat: -21.2369208
  },
  {
    lng: -41.2816265,
    lat: -21.2370134
  },
  {
    lng: -41.2815426,
    lat: -21.2372322
  },
  {
    lng: -41.2815278,
    lat: -21.2372601
  },
  {
    lng: -41.2814916,
    lat: -21.2373496
  },
  {
    lng: -41.2814754,
    lat: -21.2373733
  },
  {
    lng: -41.2814487,
    lat: -21.237428
  },
  {
    lng: -41.28142,
    lat: -21.2375015
  },
  {
    lng: -41.2813438,
    lat: -21.2376257
  },
  {
    lng: -41.2813001,
    lat: -21.2376817
  },
  {
    lng: -41.2812818,
    lat: -21.2376966
  },
  {
    lng: -41.2811249,
    lat: -21.2378773
  },
  {
    lng: -41.2811054,
    lat: -21.2378932
  },
  {
    lng: -41.2810391,
    lat: -21.2379713
  },
  {
    lng: -41.2810046,
    lat: -21.2380203
  },
  {
    lng: -41.2808867,
    lat: -21.2381291
  },
  {
    lng: -41.2806949,
    lat: -21.2382835
  },
  {
    lng: -41.2805778,
    lat: -21.2383628
  },
  {
    lng: -41.2805015,
    lat: -21.2384049
  },
  {
    lng: -41.2804397,
    lat: -21.2384021
  },
  {
    lng: -41.2804234,
    lat: -21.2384086
  },
  {
    lng: -41.2804183,
    lat: -21.2384153
  },
  {
    lng: -41.2804355,
    lat: -21.2384254
  },
  {
    lng: -41.2804403,
    lat: -21.2384331
  },
  {
    lng: -41.2804093,
    lat: -21.2384615
  },
  {
    lng: -41.2803399,
    lat: -21.2384987
  },
  {
    lng: -41.2803025,
    lat: -21.2385129
  },
  {
    lng: -41.2801899,
    lat: -21.2385831
  },
  {
    lng: -41.2801665,
    lat: -21.2385921
  },
  {
    lng: -41.2800763,
    lat: -21.2386133
  },
  {
    lng: -41.2799481,
    lat: -21.2386561
  },
  {
    lng: -41.2798735,
    lat: -21.238676
  },
  {
    lng: -41.2798412,
    lat: -21.2386812
  },
  {
    lng: -41.2797536,
    lat: -21.238669
  },
  {
    lng: -41.2796686,
    lat: -21.2387059
  },
  {
    lng: -41.2795297,
    lat: -21.2387432
  },
  {
    lng: -41.2794086,
    lat: -21.2387617
  },
  {
    lng: -41.2792296,
    lat: -21.2387952
  },
  {
    lng: -41.2791343,
    lat: -21.238808
  },
  {
    lng: -41.2790854,
    lat: -21.2388222
  },
  {
    lng: -41.2789659,
    lat: -21.2388324
  },
  {
    lng: -41.2789034,
    lat: -21.2388655
  },
  {
    lng: -41.2787004,
    lat: -21.238894
  },
  {
    lng: -41.2786333,
    lat: -21.2389292
  },
  {
    lng: -41.2785226,
    lat: -21.2390121
  },
  {
    lng: -41.2784097,
    lat: -21.2391079
  },
  {
    lng: -41.2783782,
    lat: -21.2391197
  },
  {
    lng: -41.2783696,
    lat: -21.2391043
  },
  {
    lng: -41.2783545,
    lat: -21.2391065
  },
  {
    lng: -41.2778635,
    lat: -21.2395509
  },
  {
    lng: -41.2775593,
    lat: -21.2398795
  },
  {
    lng: -41.2772429,
    lat: -21.2400864
  },
  {
    lng: -41.2771255,
    lat: -21.2401574
  },
  {
    lng: -41.2767152,
    lat: -21.2402293
  },
  {
    lng: -41.2764484,
    lat: -21.2402095
  },
  {
    lng: -41.2762225,
    lat: -21.2401484
  },
  {
    lng: -41.2762888,
    lat: -21.2403702
  },
  {
    lng: -41.2761343,
    lat: -21.2404969
  },
  {
    lng: -41.2760143,
    lat: -21.2405166
  },
  {
    lng: -41.2757665,
    lat: -21.2405978
  },
  {
    lng: -41.2755045,
    lat: -21.2406532
  },
  {
    lng: -41.2752434,
    lat: -21.2407735
  },
  {
    lng: -41.2750508,
    lat: -21.2409008
  },
  {
    lng: -41.2749567,
    lat: -21.2410238
  },
  {
    lng: -41.2748299,
    lat: -21.2412298
  },
  {
    lng: -41.2748059,
    lat: -21.2416
  },
  {
    lng: -41.2748099,
    lat: -21.24164
  },
  {
    lng: -41.2748895,
    lat: -21.2420042
  },
  {
    lng: -41.2749249,
    lat: -21.2423628
  },
  {
    lng: -41.2749284,
    lat: -21.2427471
  },
  {
    lng: -41.2748966,
    lat: -21.2431191
  },
  {
    lng: -41.2748733,
    lat: -21.2434849
  },
  {
    lng: -41.2747763,
    lat: -21.2435944
  },
  {
    lng: -41.2745892,
    lat: -21.2437138
  },
  {
    lng: -41.2743456,
    lat: -21.2438215
  },
  {
    lng: -41.2741652,
    lat: -21.2439727
  },
  {
    lng: -41.2739644,
    lat: -21.2442835
  },
  {
    lng: -41.2737603,
    lat: -21.2443842
  },
  {
    lng: -41.2734427,
    lat: -21.244632
  },
  {
    lng: -41.273132,
    lat: -21.2448681
  },
  {
    lng: -41.2728246,
    lat: -21.2450942
  },
  {
    lng: -41.2724605,
    lat: -21.2452599
  },
  {
    lng: -41.2723436,
    lat: -21.2453328
  },
  {
    lng: -41.2722377,
    lat: -21.2454664
  },
  {
    lng: -41.2721048,
    lat: -21.245595
  },
  {
    lng: -41.2720035,
    lat: -21.2456993
  },
  {
    lng: -41.2718867,
    lat: -21.2460039
  },
  {
    lng: -41.2719047,
    lat: -21.246287
  },
  {
    lng: -41.2720822,
    lat: -21.2466078
  },
  {
    lng: -41.2723277,
    lat: -21.2468943
  },
  {
    lng: -41.2726226,
    lat: -21.2471332
  },
  {
    lng: -41.2728889,
    lat: -21.2473494
  },
  {
    lng: -41.2730106,
    lat: -21.2474673
  },
  {
    lng: -41.2731069,
    lat: -21.2475924
  },
  {
    lng: -41.2731946,
    lat: -21.2476035
  },
  {
    lng: -41.2733508,
    lat: -21.2475293
  },
  {
    lng: -41.2733815,
    lat: -21.2475148
  },
  {
    lng: -41.2735421,
    lat: -21.2474264
  },
  {
    lng: -41.2736281,
    lat: -21.247323
  },
  {
    lng: -41.273735,
    lat: -21.2470751
  },
  {
    lng: -41.2740087,
    lat: -21.2468768
  },
  {
    lng: -41.2742686,
    lat: -21.2466787
  },
  {
    lng: -41.2745295,
    lat: -21.2465455
  },
  {
    lng: -41.2748246,
    lat: -21.2464497
  },
  {
    lng: -41.275149,
    lat: -21.2463425
  },
  {
    lng: -41.2753765,
    lat: -21.2463449
  },
  {
    lng: -41.2756324,
    lat: -21.2462841
  },
  {
    lng: -41.2759514,
    lat: -21.2463317
  },
  {
    lng: -41.2761207,
    lat: -21.2463673
  },
  {
    lng: -41.2766335,
    lat: -21.2465949
  },
  {
    lng: -41.2768571,
    lat: -21.2467346
  },
  {
    lng: -41.2769936,
    lat: -21.2468907
  },
  {
    lng: -41.2772233,
    lat: -21.2471577
  },
  {
    lng: -41.2772246,
    lat: -21.247293
  },
  {
    lng: -41.2772146,
    lat: -21.2477634
  },
  {
    lng: -41.2771543,
    lat: -21.2480667
  },
  {
    lng: -41.2769933,
    lat: -21.2483932
  },
  {
    lng: -41.2767755,
    lat: -21.2486296
  },
  {
    lng: -41.2766072,
    lat: -21.2487607
  },
  {
    lng: -41.2764075,
    lat: -21.2489978
  },
  {
    lng: -41.2762445,
    lat: -21.2491946
  },
  {
    lng: -41.2762467,
    lat: -21.2493373
  },
  {
    lng: -41.2763612,
    lat: -21.2495822
  },
  {
    lng: -41.2764197,
    lat: -21.249789
  },
  {
    lng: -41.2766691,
    lat: -21.2498116
  },
  {
    lng: -41.2768636,
    lat: -21.2498608
  },
  {
    lng: -41.2770182,
    lat: -21.2500144
  },
  {
    lng: -41.2773805,
    lat: -21.2501782
  },
  {
    lng: -41.2779371,
    lat: -21.2503782
  },
  {
    lng: -41.2782158,
    lat: -21.2505041
  },
  {
    lng: -41.2786454,
    lat: -21.2505502
  },
  {
    lng: -41.2786746,
    lat: -21.2505531
  },
  {
    lng: -41.2789898,
    lat: -21.2505844
  },
  {
    lng: -41.2790306,
    lat: -21.2505837
  },
  {
    lng: -41.2791231,
    lat: -21.250579
  },
  {
    lng: -41.2791874,
    lat: -21.2505804
  },
  {
    lng: -41.2791924,
    lat: -21.2505804
  },
  {
    lng: -41.2792448,
    lat: -21.2505814
  },
  {
    lng: -41.2793464,
    lat: -21.2505892
  },
  {
    lng: -41.2794432,
    lat: -21.2505952
  },
  {
    lng: -41.2795341,
    lat: -21.250602
  },
  {
    lng: -41.2796023,
    lat: -21.2505854
  },
  {
    lng: -41.2796806,
    lat: -21.2505859
  },
  {
    lng: -41.279743,
    lat: -21.2505902
  },
  {
    lng: -41.2797983,
    lat: -21.2505887
  },
  {
    lng: -41.2798856,
    lat: -21.2505928
  },
  {
    lng: -41.279979,
    lat: -21.2505967
  },
  {
    lng: -41.2800636,
    lat: -21.2505807
  },
  {
    lng: -41.2801671,
    lat: -21.2505734
  },
  {
    lng: -41.280242,
    lat: -21.2505665
  },
  {
    lng: -41.2803326,
    lat: -21.2505589
  },
  {
    lng: -41.2804028,
    lat: -21.2505611
  },
  {
    lng: -41.2804234,
    lat: -21.2505618
  },
  {
    lng: -41.2805004,
    lat: -21.2505603
  },
  {
    lng: -41.2805951,
    lat: -21.2505665
  },
  {
    lng: -41.2806702,
    lat: -21.2505635
  },
  {
    lng: -41.2806831,
    lat: -21.2505644
  },
  {
    lng: -41.2807762,
    lat: -21.2505648
  },
  {
    lng: -41.2808522,
    lat: -21.2505677
  },
  {
    lng: -41.2809339,
    lat: -21.2505703
  },
  {
    lng: -41.2810273,
    lat: -21.2505662
  },
  {
    lng: -41.2811049,
    lat: -21.250567
  },
  {
    lng: -41.2811826,
    lat: -21.2505638
  },
  {
    lng: -41.2812599,
    lat: -21.2505617
  },
  {
    lng: -41.2813255,
    lat: -21.2505669
  },
  {
    lng: -41.2813814,
    lat: -21.2505786
  },
  {
    lng: -41.2814201,
    lat: -21.2505844
  },
  {
    lng: -41.2814773,
    lat: -21.2505828
  },
  {
    lng: -41.2815749,
    lat: -21.2505477
  },
  {
    lng: -41.2816131,
    lat: -21.250538
  },
  {
    lng: -41.2817138,
    lat: -21.2505283
  },
  {
    lng: -41.2818115,
    lat: -21.2505378
  },
  {
    lng: -41.2819453,
    lat: -21.2505477
  },
  {
    lng: -41.2820987,
    lat: -21.2505355
  },
  {
    lng: -41.2821723,
    lat: -21.2505379
  },
  {
    lng: -41.2823059,
    lat: -21.2505678
  },
  {
    lng: -41.2824075,
    lat: -21.2505883
  },
  {
    lng: -41.282521,
    lat: -21.2506197
  },
  {
    lng: -41.2826092,
    lat: -21.250657
  },
  {
    lng: -41.2826766,
    lat: -21.2506978
  },
  {
    lng: -41.282726,
    lat: -21.2507242
  },
  {
    lng: -41.2827837,
    lat: -21.2507416
  },
  {
    lng: -41.2828319,
    lat: -21.2507755
  },
  {
    lng: -41.2828846,
    lat: -21.2508582
  },
  {
    lng: -41.2829135,
    lat: -21.2509089
  },
  {
    lng: -41.2829436,
    lat: -21.2509717
  },
  {
    lng: -41.2829886,
    lat: -21.2510283
  },
  {
    lng: -41.2830462,
    lat: -21.2510844
  },
  {
    lng: -41.2831392,
    lat: -21.2511714
  },
  {
    lng: -41.283183,
    lat: -21.2512115
  },
  {
    lng: -41.2832172,
    lat: -21.2512705
  },
  {
    lng: -41.2832842,
    lat: -21.2513118
  },
  {
    lng: -41.2833093,
    lat: -21.2513737
  },
  {
    lng: -41.2833711,
    lat: -21.2514971
  },
  {
    lng: -41.2834231,
    lat: -21.2515212
  },
  {
    lng: -41.2834592,
    lat: -21.2515434
  },
  {
    lng: -41.2834881,
    lat: -21.2516092
  },
  {
    lng: -41.2835128,
    lat: -21.2516579
  },
  {
    lng: -41.2835157,
    lat: -21.2516664
  },
  {
    lng: -41.2835389,
    lat: -21.251723
  },
  {
    lng: -41.2835883,
    lat: -21.2517705
  },
  {
    lng: -41.2836827,
    lat: -21.2518417
  },
  {
    lng: -41.2836937,
    lat: -21.2518593
  },
  {
    lng: -41.2837405,
    lat: -21.2519186
  },
  {
    lng: -41.2837763,
    lat: -21.2519581
  },
  {
    lng: -41.2837904,
    lat: -21.2519765
  },
  {
    lng: -41.2838414,
    lat: -21.2520287
  },
  {
    lng: -41.2838471,
    lat: -21.2520435
  },
  {
    lng: -41.2838627,
    lat: -21.2520997
  },
  {
    lng: -41.2838834,
    lat: -21.2521315
  },
  {
    lng: -41.2838925,
    lat: -21.2521412
  },
  {
    lng: -41.2839343,
    lat: -21.2521793
  },
  {
    lng: -41.2839459,
    lat: -21.252208
  },
  {
    lng: -41.2839837,
    lat: -21.2522333
  },
  {
    lng: -41.284046,
    lat: -21.2522971
  },
  {
    lng: -41.2840714,
    lat: -21.2523496
  },
  {
    lng: -41.2841167,
    lat: -21.2523982
  },
  {
    lng: -41.2841631,
    lat: -21.2524841
  },
  {
    lng: -41.2842024,
    lat: -21.2525363
  },
  {
    lng: -41.2842093,
    lat: -21.2525455
  },
  {
    lng: -41.2842727,
    lat: -21.2526463
  },
  {
    lng: -41.2843309,
    lat: -21.2526933
  },
  {
    lng: -41.2844176,
    lat: -21.2527403
  },
  {
    lng: -41.2844842,
    lat: -21.2528254
  },
  {
    lng: -41.2845494,
    lat: -21.2529285
  },
  {
    lng: -41.2845692,
    lat: -21.2529608
  },
  {
    lng: -41.2845732,
    lat: -21.2529741
  },
  {
    lng: -41.2845805,
    lat: -21.2529988
  },
  {
    lng: -41.2845817,
    lat: -21.2530046
  },
  {
    lng: -41.2845892,
    lat: -21.2530175
  },
  {
    lng: -41.2848424,
    lat: -21.2532931
  },
  {
    lng: -41.284971,
    lat: -21.2534364
  },
  {
    lng: -41.2849899,
    lat: -21.2534575
  },
  {
    lng: -41.2850426,
    lat: -21.2535275
  },
  {
    lng: -41.2851125,
    lat: -21.2536147
  },
  {
    lng: -41.2851791,
    lat: -21.253682
  },
  {
    lng: -41.285189,
    lat: -21.2537338
  },
  {
    lng: -41.2852188,
    lat: -21.2537892
  },
  {
    lng: -41.285268,
    lat: -21.2538302
  },
  {
    lng: -41.2853605,
    lat: -21.2539136
  },
  {
    lng: -41.2853892,
    lat: -21.2539919
  },
  {
    lng: -41.2854584,
    lat: -21.2540666
  },
  {
    lng: -41.2855297,
    lat: -21.2541562
  },
  {
    lng: -41.2855931,
    lat: -21.2542676
  },
  {
    lng: -41.28566,
    lat: -21.2543616
  },
  {
    lng: -41.2857082,
    lat: -21.2544023
  },
  {
    lng: -41.2857513,
    lat: -21.2544622
  },
  {
    lng: -41.2858076,
    lat: -21.2545097
  },
  {
    lng: -41.285829,
    lat: -21.2545464
  },
  {
    lng: -41.2858635,
    lat: -21.2545986
  },
  {
    lng: -41.2859053,
    lat: -21.2546488
  },
  {
    lng: -41.2859647,
    lat: -21.2547173
  },
  {
    lng: -41.2860194,
    lat: -21.2547734
  },
  {
    lng: -41.2860691,
    lat: -21.2548235
  },
  {
    lng: -41.2860711,
    lat: -21.2548255
  },
  {
    lng: -41.2862104,
    lat: -21.2549669
  },
  {
    lng: -41.2862729,
    lat: -21.2550546
  },
  {
    lng: -41.2863479,
    lat: -21.2551771
  },
  {
    lng: -41.2864196,
    lat: -21.2552779
  },
  {
    lng: -41.2865234,
    lat: -21.2553676
  },
  {
    lng: -41.2865995,
    lat: -21.2554577
  },
  {
    lng: -41.2866474,
    lat: -21.2555366
  },
  {
    lng: -41.2867688,
    lat: -21.2556687
  },
  {
    lng: -41.2869672,
    lat: -21.255921
  },
  {
    lng: -41.2869824,
    lat: -21.2559605
  },
  {
    lng: -41.2870327,
    lat: -21.2560914
  },
  {
    lng: -41.2872205,
    lat: -21.2563023
  },
  {
    lng: -41.2872913,
    lat: -21.2565776
  },
  {
    lng: -41.2872804,
    lat: -21.2566913
  },
  {
    lng: -41.2873374,
    lat: -21.2569765
  },
  {
    lng: -41.2873567,
    lat: -21.2570867
  },
  {
    lng: -41.2873567,
    lat: -21.2571382
  },
  {
    lng: -41.2874379,
    lat: -21.2573504
  },
  {
    lng: -41.2874734,
    lat: -21.257605
  },
  {
    lng: -41.2874609,
    lat: -21.2577516
  },
  {
    lng: -41.2874808,
    lat: -21.257939
  },
  {
    lng: -41.2874924,
    lat: -21.2579723
  },
  {
    lng: -41.2875767,
    lat: -21.2580366
  },
  {
    lng: -41.2875651,
    lat: -21.2583209
  },
  {
    lng: -41.2875696,
    lat: -21.2583746
  },
  {
    lng: -41.2876311,
    lat: -21.2585201
  },
  {
    lng: -41.2876527,
    lat: -21.2587148
  },
  {
    lng: -41.2876919,
    lat: -21.2588501
  },
  {
    lng: -41.2877226,
    lat: -21.2592177
  },
  {
    lng: -41.2877624,
    lat: -21.2593495
  },
  {
    lng: -41.2878096,
    lat: -21.259714
  },
  {
    lng: -41.2878323,
    lat: -21.2597672
  },
  {
    lng: -41.2878776,
    lat: -21.2598196
  },
  {
    lng: -41.2879876,
    lat: -21.2601677
  },
  {
    lng: -41.2879787,
    lat: -21.2602482
  },
  {
    lng: -41.2879856,
    lat: -21.260359
  },
  {
    lng: -41.2879971,
    lat: -21.2604898
  },
  {
    lng: -41.2880823,
    lat: -21.2607516
  },
  {
    lng: -41.2882055,
    lat: -21.2610966
  },
  {
    lng: -41.2882255,
    lat: -21.2612003
  },
  {
    lng: -41.2882341,
    lat: -21.2612449
  },
  {
    lng: -41.2882703,
    lat: -21.2614559
  },
  {
    lng: -41.288329,
    lat: -21.2616574
  },
  {
    lng: -41.288389,
    lat: -21.2619032
  },
  {
    lng: -41.2884232,
    lat: -21.2620303
  },
  {
    lng: -41.288498,
    lat: -21.2622842
  },
  {
    lng: -41.2884947,
    lat: -21.2623818
  },
  {
    lng: -41.2885687,
    lat: -21.2627041
  },
  {
    lng: -41.2886148,
    lat: -21.2627504
  },
  {
    lng: -41.2885895,
    lat: -21.2628607
  },
  {
    lng: -41.2886227,
    lat: -21.262978
  },
  {
    lng: -41.2887092,
    lat: -21.2632785
  },
  {
    lng: -41.2888059,
    lat: -21.263628
  },
  {
    lng: -41.2888711,
    lat: -21.2639865
  },
  {
    lng: -41.2889235,
    lat: -21.2640624
  },
  {
    lng: -41.2889558,
    lat: -21.2641633
  },
  {
    lng: -41.2889816,
    lat: -21.264405
  },
  {
    lng: -41.2889959,
    lat: -21.2645591
  },
  {
    lng: -41.289001,
    lat: -21.2645744
  },
  {
    lng: -41.2891552,
    lat: -21.2649061
  },
  {
    lng: -41.2891464,
    lat: -21.265149
  },
  {
    lng: -41.2892266,
    lat: -21.2653301
  },
  {
    lng: -41.2892542,
    lat: -21.2655365
  },
  {
    lng: -41.2892829,
    lat: -21.2655997
  },
  {
    lng: -41.2893311,
    lat: -21.2658593
  },
  {
    lng: -41.2893491,
    lat: -21.2659557
  },
  {
    lng: -41.2894628,
    lat: -21.2663014
  },
  {
    lng: -41.2895384,
    lat: -21.2666556
  },
  {
    lng: -41.2895439,
    lat: -21.2669075
  },
  {
    lng: -41.2895433,
    lat: -21.2669124
  },
  {
    lng: -41.2896247,
    lat: -21.2672665
  },
  {
    lng: -41.289679,
    lat: -21.2676242
  },
  {
    lng: -41.2896824,
    lat: -21.2677348
  },
  {
    lng: -41.2897279,
    lat: -21.2678287
  },
  {
    lng: -41.2897658,
    lat: -21.2679549
  },
  {
    lng: -41.2898014,
    lat: -21.2682402
  },
  {
    lng: -41.2898642,
    lat: -21.2683254
  },
  {
    lng: -41.2898525,
    lat: -21.2684752
  },
  {
    lng: -41.2898934,
    lat: -21.2685847
  },
  {
    lng: -41.290004,
    lat: -21.2689315
  },
  {
    lng: -41.2900093,
    lat: -21.269048
  },
  {
    lng: -41.2899847,
    lat: -21.2691927
  },
  {
    lng: -41.2901089,
    lat: -21.2694668
  },
  {
    lng: -41.2901713,
    lat: -21.2697795
  },
  {
    lng: -41.2901879,
    lat: -21.2700187
  },
  {
    lng: -41.290224,
    lat: -21.2701427
  },
  {
    lng: -41.2903042,
    lat: -21.2703034
  },
  {
    lng: -41.2902605,
    lat: -21.2704456
  },
  {
    lng: -41.2902807,
    lat: -21.270614
  },
  {
    lng: -41.2903798,
    lat: -21.2708512
  },
  {
    lng: -41.290447,
    lat: -21.270995
  },
  {
    lng: -41.2904759,
    lat: -21.2711037
  },
  {
    lng: -41.2904949,
    lat: -21.271153
  },
  {
    lng: -41.2905161,
    lat: -21.271248
  },
  {
    lng: -41.290539,
    lat: -21.2713204
  },
  {
    lng: -41.290588,
    lat: -21.2714118
  },
  {
    lng: -41.2905909,
    lat: -21.2714303
  },
  {
    lng: -41.2906517,
    lat: -21.2717876
  },
  {
    lng: -41.2907328,
    lat: -21.2721411
  },
  {
    lng: -41.2907509,
    lat: -21.272266
  },
  {
    lng: -41.2907663,
    lat: -21.2723718
  },
  {
    lng: -41.2908004,
    lat: -21.2724586
  },
  {
    lng: -41.2908342,
    lat: -21.2725123
  },
  {
    lng: -41.2907933,
    lat: -21.272596
  },
  {
    lng: -41.2907955,
    lat: -21.2726485
  },
  {
    lng: -41.2908004,
    lat: -21.2727595
  },
  {
    lng: -41.2907874,
    lat: -21.2729221
  },
  {
    lng: -41.2909078,
    lat: -21.2729558
  },
  {
    lng: -41.2909501,
    lat: -21.2731931
  },
  {
    lng: -41.2910262,
    lat: -21.2735502
  },
  {
    lng: -41.2911237,
    lat: -21.2739051
  },
  {
    lng: -41.2912034,
    lat: -21.2742664
  },
  {
    lng: -41.2912791,
    lat: -21.2746238
  },
  {
    lng: -41.2913347,
    lat: -21.2749819
  },
  {
    lng: -41.2913417,
    lat: -21.2751449
  },
  {
    lng: -41.2914189,
    lat: -21.2754604
  },
  {
    lng: -41.291489,
    lat: -21.2758156
  },
  {
    lng: -41.2915528,
    lat: -21.2761723
  },
  {
    lng: -41.291654,
    lat: -21.2765209
  },
  {
    lng: -41.2917631,
    lat: -21.2768749
  },
  {
    lng: -41.2918563,
    lat: -21.2772257
  },
  {
    lng: -41.2919819,
    lat: -21.2774829
  },
  {
    lng: -41.2920203,
    lat: -21.2775614
  },
  {
    lng: -41.2922414,
    lat: -21.2778576
  },
  {
    lng: -41.2924014,
    lat: -21.2781937
  },
  {
    lng: -41.2925069,
    lat: -21.2782799
  },
  {
    lng: -41.2925231,
    lat: -21.2782931
  },
  {
    lng: -41.2926575,
    lat: -21.278507
  },
  {
    lng: -41.2927714,
    lat: -21.2787933
  },
  {
    lng: -41.2928111,
    lat: -21.2789
  },
  {
    lng: -41.2930294,
    lat: -21.2792038
  },
  {
    lng: -41.2932366,
    lat: -21.2795095
  },
  {
    lng: -41.2933831,
    lat: -21.279848
  },
  {
    lng: -41.2933696,
    lat: -21.2799693
  },
  {
    lng: -41.2935007,
    lat: -21.2802596
  },
  {
    lng: -41.2936542,
    lat: -21.2805926
  },
  {
    lng: -41.2936299,
    lat: -21.2806364
  },
  {
    lng: -41.2935286,
    lat: -21.2807257
  },
  {
    lng: -41.2935538,
    lat: -21.2808639
  },
  {
    lng: -41.2935946,
    lat: -21.2809912
  },
  {
    lng: -41.2937457,
    lat: -21.2811483
  },
  {
    lng: -41.2939665,
    lat: -21.2812731
  },
  {
    lng: -41.2943546,
    lat: -21.2813099
  },
  {
    lng: -41.2944392,
    lat: -21.2814943
  },
  {
    lng: -41.2944633,
    lat: -21.2815162
  },
  {
    lng: -41.2946535,
    lat: -21.2818303
  },
  {
    lng: -41.2948433,
    lat: -21.282152
  },
  {
    lng: -41.2951376,
    lat: -21.282384
  },
  {
    lng: -41.2954532,
    lat: -21.2825932
  },
  {
    lng: -41.2955014,
    lat: -21.2826267
  },
  {
    lng: -41.2957646,
    lat: -21.2828094
  },
  {
    lng: -41.2960971,
    lat: -21.2830055
  },
  {
    lng: -41.2964228,
    lat: -21.2832007
  },
  {
    lng: -41.2965845,
    lat: -21.2833226
  },
  {
    lng: -41.2966433,
    lat: -21.283376
  },
  {
    lng: -41.2966498,
    lat: -21.2833799
  },
  {
    lng: -41.2966575,
    lat: -21.2834467
  },
  {
    lng: -41.2966734,
    lat: -21.2834873
  },
  {
    lng: -41.2966902,
    lat: -21.2835515
  },
  {
    lng: -41.296758,
    lat: -21.2836979
  },
  {
    lng: -41.2967364,
    lat: -21.2838545
  },
  {
    lng: -41.2966619,
    lat: -21.2840877
  },
  {
    lng: -41.2966719,
    lat: -21.2841159
  },
  {
    lng: -41.2967065,
    lat: -21.2841635
  },
  {
    lng: -41.296676,
    lat: -21.2841941
  },
  {
    lng: -41.2966267,
    lat: -21.2842283
  },
  {
    lng: -41.2965391,
    lat: -21.2843485
  },
  {
    lng: -41.2965201,
    lat: -21.2844599
  },
  {
    lng: -41.2965455,
    lat: -21.2845412
  },
  {
    lng: -41.2965287,
    lat: -21.284634
  },
  {
    lng: -41.2966686,
    lat: -21.2848006
  },
  {
    lng: -41.2969622,
    lat: -21.2850404
  },
  {
    lng: -41.2969456,
    lat: -21.2851326
  },
  {
    lng: -41.2970142,
    lat: -21.285379
  },
  {
    lng: -41.2970092,
    lat: -21.2854827
  },
  {
    lng: -41.2969749,
    lat: -21.2856011
  },
  {
    lng: -41.2969762,
    lat: -21.2856857
  },
  {
    lng: -41.2971618,
    lat: -21.2858456
  },
  {
    lng: -41.2971955,
    lat: -21.2859638
  },
  {
    lng: -41.2972536,
    lat: -21.2860543
  },
  {
    lng: -41.2973864,
    lat: -21.2861047
  },
  {
    lng: -41.2973843,
    lat: -21.2861714
  },
  {
    lng: -41.2974256,
    lat: -21.2863164
  },
  {
    lng: -41.2975413,
    lat: -21.2864937
  },
  {
    lng: -41.2977407,
    lat: -21.2868028
  },
  {
    lng: -41.2979758,
    lat: -21.2870906
  },
  {
    lng: -41.2979696,
    lat: -21.2872432
  },
  {
    lng: -41.2980266,
    lat: -21.2876028
  },
  {
    lng: -41.2981687,
    lat: -21.2879466
  },
  {
    lng: -41.298299,
    lat: -21.288008
  },
  {
    lng: -41.2983852,
    lat: -21.2880361
  },
  {
    lng: -41.298391,
    lat: -21.2880799
  },
  {
    lng: -41.2983643,
    lat: -21.2881374
  },
  {
    lng: -41.2983135,
    lat: -21.2881888
  },
  {
    lng: -41.2983594,
    lat: -21.28831
  },
  {
    lng: -41.2983994,
    lat: -21.2884564
  },
  {
    lng: -41.2986143,
    lat: -21.2887637
  },
  {
    lng: -41.298608,
    lat: -21.2889011
  },
  {
    lng: -41.2985759,
    lat: -21.2892613
  },
  {
    lng: -41.2986466,
    lat: -21.2892978
  },
  {
    lng: -41.2987148,
    lat: -21.2893809
  },
  {
    lng: -41.2987215,
    lat: -21.2895721
  },
  {
    lng: -41.2988864,
    lat: -21.2897894
  },
  {
    lng: -41.2989399,
    lat: -21.28991
  },
  {
    lng: -41.2990401,
    lat: -21.2899703
  },
  {
    lng: -41.2991793,
    lat: -21.2901959
  },
  {
    lng: -41.2991837,
    lat: -21.2902758
  },
  {
    lng: -41.2991895,
    lat: -21.2902772
  },
  {
    lng: -41.2993076,
    lat: -21.2903054
  },
  {
    lng: -41.299318,
    lat: -21.2904864
  },
  {
    lng: -41.2993545,
    lat: -21.2908465
  },
  {
    lng: -41.2994222,
    lat: -21.2912052
  },
  {
    lng: -41.2994792,
    lat: -21.2912129
  },
  {
    lng: -41.2994661,
    lat: -21.291281
  },
  {
    lng: -41.2993723,
    lat: -21.2916318
  },
  {
    lng: -41.2993026,
    lat: -21.291743
  },
  {
    lng: -41.299216,
    lat: -21.2921005
  },
  {
    lng: -41.2991744,
    lat: -21.2924642
  },
  {
    lng: -41.2991244,
    lat: -21.2925107
  },
  {
    lng: -41.2991447,
    lat: -21.2926651
  },
  {
    lng: -41.2994372,
    lat: -21.2928442
  },
  {
    lng: -41.2995554,
    lat: -21.2931114
  },
  {
    lng: -41.2996707,
    lat: -21.2934592
  },
  {
    lng: -41.2997377,
    lat: -21.2934693
  },
  {
    lng: -41.2997378,
    lat: -21.2935052
  },
  {
    lng: -41.2997302,
    lat: -21.2937322
  },
  {
    lng: -41.2998118,
    lat: -21.2937463
  },
  {
    lng: -41.2998156,
    lat: -21.2937469
  },
  {
    lng: -41.2999992,
    lat: -21.2936553
  },
  {
    lng: -41.3001427,
    lat: -21.293715
  },
  {
    lng: -41.3002948,
    lat: -21.2937324
  },
  {
    lng: -41.3004935,
    lat: -21.2938638
  },
  {
    lng: -41.3005762,
    lat: -21.2939034
  },
  {
    lng: -41.3009493,
    lat: -21.2939999
  },
  {
    lng: -41.3010053,
    lat: -21.2940302
  },
  {
    lng: -41.3011346,
    lat: -21.2941574
  },
  {
    lng: -41.3013463,
    lat: -21.2941733
  },
  {
    lng: -41.3013931,
    lat: -21.2942706
  },
  {
    lng: -41.3017255,
    lat: -21.2943714
  },
  {
    lng: -41.3017989,
    lat: -21.2944369
  },
  {
    lng: -41.3018932,
    lat: -21.2944837
  },
  {
    lng: -41.3019374,
    lat: -21.2945459
  },
  {
    lng: -41.3020092,
    lat: -21.2946549
  },
  {
    lng: -41.3020091,
    lat: -21.2947483
  },
  {
    lng: -41.3020102,
    lat: -21.2948189
  },
  {
    lng: -41.302127,
    lat: -21.2949667
  },
  {
    lng: -41.3023241,
    lat: -21.2952801
  },
  {
    lng: -41.3023667,
    lat: -21.2952958
  },
  {
    lng: -41.3025155,
    lat: -21.2953233
  },
  {
    lng: -41.3025399,
    lat: -21.2952519
  },
  {
    lng: -41.3026567,
    lat: -21.2952805
  },
  {
    lng: -41.3026859,
    lat: -21.295317
  },
  {
    lng: -41.3027328,
    lat: -21.2953757
  },
  {
    lng: -41.3027662,
    lat: -21.2954669
  },
  {
    lng: -41.3027404,
    lat: -21.2955427
  },
  {
    lng: -41.3026188,
    lat: -21.2955701
  },
  {
    lng: -41.3025991,
    lat: -21.2957297
  },
  {
    lng: -41.302669,
    lat: -21.2957805
  },
  {
    lng: -41.3027503,
    lat: -21.2959391
  },
  {
    lng: -41.3028482,
    lat: -21.2960626
  },
  {
    lng: -41.3029685,
    lat: -21.2961796
  },
  {
    lng: -41.3028795,
    lat: -21.2962326
  },
  {
    lng: -41.3028139,
    lat: -21.2963099
  },
  {
    lng: -41.3026586,
    lat: -21.2963633
  },
  {
    lng: -41.302523,
    lat: -21.2963979
  },
  {
    lng: -41.3024601,
    lat: -21.2963776
  },
  {
    lng: -41.302355,
    lat: -21.2964004
  },
  {
    lng: -41.3022419,
    lat: -21.2964897
  },
  {
    lng: -41.3022132,
    lat: -21.2965534
  },
  {
    lng: -41.3022143,
    lat: -21.2965597
  },
  {
    lng: -41.3023995,
    lat: -21.2968805
  },
  {
    lng: -41.3023998,
    lat: -21.2969327
  },
  {
    lng: -41.3023858,
    lat: -21.2972968
  },
  {
    lng: -41.3024159,
    lat: -21.2976585
  },
  {
    lng: -41.3024475,
    lat: -21.2977382
  },
  {
    lng: -41.302651,
    lat: -21.2978888
  },
  {
    lng: -41.302759,
    lat: -21.2980076
  },
  {
    lng: -41.3028158,
    lat: -21.2981625
  },
  {
    lng: -41.3029649,
    lat: -21.2982128
  },
  {
    lng: -41.3030538,
    lat: -21.2982428
  },
  {
    lng: -41.3034233,
    lat: -21.2983457
  },
  {
    lng: -41.3035799,
    lat: -21.2982692
  },
  {
    lng: -41.3037729,
    lat: -21.2982624
  },
  {
    lng: -41.3038422,
    lat: -21.2982386
  },
  {
    lng: -41.3039767,
    lat: -21.2982813
  },
  {
    lng: -41.3041257,
    lat: -21.2982554
  },
  {
    lng: -41.3043718,
    lat: -21.2983352
  },
  {
    lng: -41.3044037,
    lat: -21.2983578
  },
  {
    lng: -41.304519,
    lat: -21.2983509
  },
  {
    lng: -41.3045563,
    lat: -21.2983722
  },
  {
    lng: -41.304691,
    lat: -21.2984492
  },
  {
    lng: -41.3050097,
    lat: -21.2986575
  },
  {
    lng: -41.3053405,
    lat: -21.2988502
  },
  {
    lng: -41.3056094,
    lat: -21.2990317
  },
  {
    lng: -41.3056553,
    lat: -21.2990627
  },
  {
    lng: -41.3059776,
    lat: -21.299268
  },
  {
    lng: -41.3063043,
    lat: -21.2994692
  },
  {
    lng: -41.3066284,
    lat: -21.2996683
  },
  {
    lng: -41.3069503,
    lat: -21.2998782
  },
  {
    lng: -41.307272,
    lat: -21.3000854
  },
  {
    lng: -41.3075809,
    lat: -21.3003123
  },
  {
    lng: -41.3078637,
    lat: -21.3005609
  },
  {
    lng: -41.3081199,
    lat: -21.3008367
  },
  {
    lng: -41.3084092,
    lat: -21.3010821
  },
  {
    lng: -41.3086302,
    lat: -21.3013788
  },
  {
    lng: -41.3088542,
    lat: -21.301676
  },
  {
    lng: -41.308934,
    lat: -21.3019932
  },
  {
    lng: -41.309006,
    lat: -21.3023518
  },
  {
    lng: -41.3090837,
    lat: -21.3027091
  },
  {
    lng: -41.3091736,
    lat: -21.3030703
  },
  {
    lng: -41.3091759,
    lat: -21.3030838
  },
  {
    lng: -41.3092342,
    lat: -21.303428
  },
  {
    lng: -41.3093113,
    lat: -21.3037846
  },
  {
    lng: -41.3093576,
    lat: -21.3040729
  },
  {
    lng: -41.3093686,
    lat: -21.3041418
  },
  {
    lng: -41.3094403,
    lat: -21.3045035
  },
  {
    lng: -41.3095212,
    lat: -21.3048603
  },
  {
    lng: -41.3096041,
    lat: -21.3052161
  },
  {
    lng: -41.3096504,
    lat: -21.3055762
  },
  {
    lng: -41.3097179,
    lat: -21.3059375
  },
  {
    lng: -41.309792,
    lat: -21.306292
  },
  {
    lng: -41.3098657,
    lat: -21.306651
  },
  {
    lng: -41.3099486,
    lat: -21.3070083
  },
  {
    lng: -41.3100217,
    lat: -21.3073639
  },
  {
    lng: -41.3100739,
    lat: -21.3077259
  },
  {
    lng: -41.3101338,
    lat: -21.3078341
  },
  {
    lng: -41.3101677,
    lat: -21.3078993
  },
  {
    lng: -41.310142,
    lat: -21.3079614
  },
  {
    lng: -41.3101782,
    lat: -21.3082544
  },
  {
    lng: -41.3102393,
    lat: -21.3086112
  },
  {
    lng: -41.310307,
    lat: -21.308971
  },
  {
    lng: -41.31037,
    lat: -21.3093231
  },
  {
    lng: -41.3103709,
    lat: -21.3093282
  },
  {
    lng: -41.3104737,
    lat: -21.3096832
  },
  {
    lng: -41.3105411,
    lat: -21.3098056
  },
  {
    lng: -41.3107397,
    lat: -21.3100441
  },
  {
    lng: -41.311042,
    lat: -21.3102738
  },
  {
    lng: -41.3113638,
    lat: -21.3104759
  },
  {
    lng: -41.3116666,
    lat: -21.3107117
  },
  {
    lng: -41.3119636,
    lat: -21.3109539
  },
  {
    lng: -41.3120383,
    lat: -21.311007
  },
  {
    lng: -41.3122727,
    lat: -21.3111737
  },
  {
    lng: -41.3125798,
    lat: -21.311395
  },
  {
    lng: -41.3128474,
    lat: -21.3116262
  },
  {
    lng: -41.3128949,
    lat: -21.3116815
  },
  {
    lng: -41.3123052,
    lat: -21.3118161
  },
  {
    lng: -41.3117041,
    lat: -21.3119628
  },
  {
    lng: -41.3110993,
    lat: -21.3121501
  },
  {
    lng: -41.3108922,
    lat: -21.3122343
  },
  {
    lng: -41.3105305,
    lat: -21.3124183
  },
  {
    lng: -41.3099634,
    lat: -21.3128003
  },
  {
    lng: -41.3092407,
    lat: -21.313217
  },
  {
    lng: -41.3084469,
    lat: -21.3135371
  },
  {
    lng: -41.3077352,
    lat: -21.3135468
  },
  {
    lng: -41.3071942,
    lat: -21.3133753
  },
  {
    lng: -41.3068095,
    lat: -21.3132016
  },
  {
    lng: -41.3062696,
    lat: -21.3130951
  },
  {
    lng: -41.3057261,
    lat: -21.3127608
  },
  {
    lng: -41.3055267,
    lat: -21.3122266
  },
  {
    lng: -41.3054192,
    lat: -21.3120166
  },
  {
    lng: -41.304997,
    lat: -21.3116644
  },
  {
    lng: -41.3044173,
    lat: -21.3112331
  },
  {
    lng: -41.3040389,
    lat: -21.311466
  },
  {
    lng: -41.303848,
    lat: -21.3114686
  },
  {
    lng: -41.3035329,
    lat: -21.3113103
  },
  {
    lng: -41.3029042,
    lat: -21.3110748
  },
  {
    lng: -41.3023295,
    lat: -21.3109688
  },
  {
    lng: -41.3020344,
    lat: -21.3109728
  },
  {
    lng: -41.3017406,
    lat: -21.3110582
  },
  {
    lng: -41.3014271,
    lat: -21.3109974
  },
  {
    lng: -41.3010615,
    lat: -21.3109373
  },
  {
    lng: -41.3002624,
    lat: -21.3109157
  },
  {
    lng: -41.3000357,
    lat: -21.3108537
  },
  {
    lng: -41.2996508,
    lat: -21.3106637
  },
  {
    lng: -41.2993554,
    lat: -21.3106515
  },
  {
    lng: -41.2990973,
    lat: -21.3108015
  },
  {
    lng: -41.2988402,
    lat: -21.3110165
  },
  {
    lng: -41.2987051,
    lat: -21.3112624
  },
  {
    lng: -41.2984194,
    lat: -21.3118684
  },
  {
    lng: -41.2982362,
    lat: -21.3123753
  },
  {
    lng: -41.297917,
    lat: -21.313063
  },
  {
    lng: -41.2977669,
    lat: -21.3134556
  },
  {
    lng: -41.2974929,
    lat: -21.3137034
  },
  {
    lng: -41.2971143,
    lat: -21.3139201
  },
  {
    lng: -41.2968607,
    lat: -21.3143628
  },
  {
    lng: -41.2965389,
    lat: -21.3148879
  },
  {
    lng: -41.296149,
    lat: -21.3154953
  },
  {
    lng: -41.2959777,
    lat: -21.315644
  },
  {
    lng: -41.2957369,
    lat: -21.3157938
  },
  {
    lng: -41.2953905,
    lat: -21.3158473
  },
  {
    lng: -41.2949912,
    lat: -21.3158528
  },
  {
    lng: -41.2938084,
    lat: -21.3157225
  },
  {
    lng: -41.2934068,
    lat: -21.3155815
  },
  {
    lng: -41.2929136,
    lat: -21.3151326
  },
  {
    lng: -41.292352,
    lat: -21.3147498
  },
  {
    lng: -41.2918473,
    lat: -21.3146753
  },
  {
    lng: -41.2913633,
    lat: -21.3148121
  },
  {
    lng: -41.2905838,
    lat: -21.3149366
  },
  {
    lng: -41.2902534,
    lat: -21.3149086
  },
  {
    lng: -41.2896753,
    lat: -21.3145748
  },
  {
    lng: -41.2884379,
    lat: -21.3142824
  },
  {
    lng: -41.2876197,
    lat: -21.3141471
  },
  {
    lng: -41.2872551,
    lat: -21.3141521
  },
  {
    lng: -41.2864932,
    lat: -21.3142926
  },
  {
    lng: -41.284969,
    lat: -21.3145412
  },
  {
    lng: -41.283427,
    lat: -21.3147574
  },
  {
    lng: -41.2828541,
    lat: -21.3147651
  },
  {
    lng: -41.2818769,
    lat: -21.314453
  },
  {
    lng: -41.2805836,
    lat: -21.3139173
  },
  {
    lng: -41.2793531,
    lat: -21.3129415
  },
  {
    lng: -41.2784257,
    lat: -21.3124822
  },
  {
    lng: -41.2774684,
    lat: -21.3123324
  },
  {
    lng: -41.27667,
    lat: -21.3123595
  },
  {
    lng: -41.2759064,
    lat: -21.3123861
  },
  {
    lng: -41.2750771,
    lat: -21.3126577
  },
  {
    lng: -41.2744904,
    lat: -21.3128934
  },
  {
    lng: -41.2733707,
    lat: -21.313478
  },
  {
    lng: -41.2727324,
    lat: -21.313747
  },
  {
    lng: -41.2723346,
    lat: -21.31385
  },
  {
    lng: -41.2714326,
    lat: -21.313911
  },
  {
    lng: -41.2704262,
    lat: -21.3139572
  },
  {
    lng: -41.2701839,
    lat: -21.3140092
  },
  {
    lng: -41.2693526,
    lat: -21.3141506
  },
  {
    lng: -41.2685366,
    lat: -21.3141616
  },
  {
    lng: -41.2679806,
    lat: -21.3141366
  },
  {
    lng: -41.2675262,
    lat: -21.3139475
  },
  {
    lng: -41.2671589,
    lat: -21.3137734
  },
  {
    lng: -41.2668117,
    lat: -21.3137781
  },
  {
    lng: -41.2659613,
    lat: -21.3138059
  },
  {
    lng: -41.2650389,
    lat: -21.3136719
  },
  {
    lng: -41.2639278,
    lat: -21.3136868
  },
  {
    lng: -41.2630285,
    lat: -21.3139267
  },
  {
    lng: -41.2628572,
    lat: -21.3140755
  },
  {
    lng: -41.262514,
    lat: -21.3143404
  },
  {
    lng: -41.2621526,
    lat: -21.3145568
  },
  {
    lng: -41.2617885,
    lat: -21.3145943
  },
  {
    lng: -41.2614049,
    lat: -21.3144855
  },
  {
    lng: -41.2610368,
    lat: -21.3142627
  },
  {
    lng: -41.2606481,
    lat: -21.3138286
  },
  {
    lng: -41.2601739,
    lat: -21.313477
  },
  {
    lng: -41.2597892,
    lat: -21.3133032
  },
  {
    lng: -41.2592677,
    lat: -21.3132614
  },
  {
    lng: -41.2587468,
    lat: -21.3132684
  },
  {
    lng: -41.2581591,
    lat: -21.313439
  },
  {
    lng: -41.2575882,
    lat: -21.3135768
  },
  {
    lng: -41.2566491,
    lat: -21.3123528
  },
  {
    lng: -41.2559936,
    lat: -21.3114992
  },
  {
    lng: -41.2556261,
    lat: -21.3113089
  },
  {
    lng: -41.2542137,
    lat: -21.310921
  },
  {
    lng: -41.2532417,
    lat: -21.3106615
  },
  {
    lng: -41.2515551,
    lat: -21.3102326
  },
  {
    lng: -41.2506242,
    lat: -21.3098179
  },
  {
    lng: -41.2490244,
    lat: -21.3090949
  },
  {
    lng: -41.249001,
    lat: -21.3091802
  },
  {
    lng: -41.248978,
    lat: -21.3092024
  },
  {
    lng: -41.2489494,
    lat: -21.3092466
  },
  {
    lng: -41.2489501,
    lat: -21.3092904
  },
  {
    lng: -41.2489508,
    lat: -21.3093341
  },
  {
    lng: -41.2489512,
    lat: -21.3093615
  },
  {
    lng: -41.2489401,
    lat: -21.3093999
  },
  {
    lng: -41.2489305,
    lat: -21.3095369
  },
  {
    lng: -41.2488966,
    lat: -21.309614
  },
  {
    lng: -41.2489154,
    lat: -21.3096958
  },
  {
    lng: -41.248893,
    lat: -21.3097563
  },
  {
    lng: -41.2488472,
    lat: -21.3098171
  },
  {
    lng: -41.248836,
    lat: -21.3098501
  },
  {
    lng: -41.2488542,
    lat: -21.3098936
  },
  {
    lng: -41.2488899,
    lat: -21.3099313
  },
  {
    lng: -41.2489313,
    lat: -21.3099747
  },
  {
    lng: -41.248984,
    lat: -21.3099795
  },
  {
    lng: -41.2490879,
    lat: -21.3099015
  },
  {
    lng: -41.2491284,
    lat: -21.309879
  },
  {
    lng: -41.2491518,
    lat: -21.3098787
  },
  {
    lng: -41.2492344,
    lat: -21.3099323
  },
  {
    lng: -41.2492523,
    lat: -21.3099595
  },
  {
    lng: -41.2492175,
    lat: -21.3099763
  },
  {
    lng: -41.2491833,
    lat: -21.3100231
  },
  {
    lng: -41.249263,
    lat: -21.3100714
  },
  {
    lng: -41.2492673,
    lat: -21.3100986
  },
  {
    lng: -41.2491025,
    lat: -21.3102058
  },
  {
    lng: -41.2491098,
    lat: -21.3102949
  },
  {
    lng: -41.2491573,
    lat: -21.3102942
  },
  {
    lng: -41.2493814,
    lat: -21.3103762
  },
  {
    lng: -41.249321,
    lat: -21.3105523
  },
  {
    lng: -41.2493499,
    lat: -21.3106618
  },
  {
    lng: -41.2493962,
    lat: -21.310762
  },
  {
    lng: -41.2494198,
    lat: -21.3108482
  },
  {
    lng: -41.2494146,
    lat: -21.3109147
  },
  {
    lng: -41.2493749,
    lat: -21.3109538
  },
  {
    lng: -41.2492293,
    lat: -21.3109906
  },
  {
    lng: -41.2491287,
    lat: -21.3109934
  },
  {
    lng: -41.248998,
    lat: -21.310961
  },
  {
    lng: -41.248947,
    lat: -21.3109702
  },
  {
    lng: -41.2490201,
    lat: -21.3112073
  },
  {
    lng: -41.2490716,
    lat: -21.3112515
  },
  {
    lng: -41.2492818,
    lat: -21.3111953
  },
  {
    lng: -41.2493437,
    lat: -21.3112196
  },
  {
    lng: -41.249356,
    lat: -21.3112941
  },
  {
    lng: -41.2493292,
    lat: -21.3113256
  },
  {
    lng: -41.2492181,
    lat: -21.3113246
  },
  {
    lng: -41.2491654,
    lat: -21.3113391
  },
  {
    lng: -41.2491582,
    lat: -21.3113879
  },
  {
    lng: -41.24925,
    lat: -21.3114469
  },
  {
    lng: -41.2492515,
    lat: -21.3115954
  },
  {
    lng: -41.2492766,
    lat: -21.3116299
  },
  {
    lng: -41.2493748,
    lat: -21.3115961
  },
  {
    lng: -41.2495376,
    lat: -21.3114935
  },
  {
    lng: -41.2495889,
    lat: -21.3115529
  },
  {
    lng: -41.2495362,
    lat: -21.3116106
  },
  {
    lng: -41.2492306,
    lat: -21.3118343
  },
  {
    lng: -41.2489067,
    lat: -21.312038
  },
  {
    lng: -41.2488227,
    lat: -21.3121426
  },
  {
    lng: -41.2487485,
    lat: -21.3121539
  },
  {
    lng: -41.2487563,
    lat: -21.3122119
  },
  {
    lng: -41.2489233,
    lat: -21.3122741
  },
  {
    lng: -41.2489597,
    lat: -21.3123556
  },
  {
    lng: -41.2489624,
    lat: -21.3123887
  },
  {
    lng: -41.2489297,
    lat: -21.3124157
  },
  {
    lng: -41.2488929,
    lat: -21.3124119
  },
  {
    lng: -41.2487938,
    lat: -21.3123641
  },
  {
    lng: -41.2487099,
    lat: -21.3123979
  },
  {
    lng: -41.2488255,
    lat: -21.3124798
  },
  {
    lng: -41.2488638,
    lat: -21.3125376
  },
  {
    lng: -41.2488085,
    lat: -21.312592
  },
  {
    lng: -41.2487678,
    lat: -21.3126708
  },
  {
    lng: -41.2486089,
    lat: -21.3126526
  },
  {
    lng: -41.2485402,
    lat: -21.3126694
  },
  {
    lng: -41.2485239,
    lat: -21.3127977
  },
  {
    lng: -41.2486657,
    lat: -21.3128217
  },
  {
    lng: -41.2487355,
    lat: -21.3127645
  },
  {
    lng: -41.2487952,
    lat: -21.3127948
  },
  {
    lng: -41.2488163,
    lat: -21.3128475
  },
  {
    lng: -41.2487975,
    lat: -21.3129016
  },
  {
    lng: -41.2486405,
    lat: -21.3128877
  },
  {
    lng: -41.2484588,
    lat: -21.3129744
  },
  {
    lng: -41.2483907,
    lat: -21.3130069
  },
  {
    lng: -41.248221,
    lat: -21.3132182
  },
  {
    lng: -41.2483108,
    lat: -21.3133772
  },
  {
    lng: -41.2482934,
    lat: -21.3134299
  },
  {
    lng: -41.2482858,
    lat: -21.3141563
  },
  {
    lng: -41.2484665,
    lat: -21.3143227
  },
  {
    lng: -41.2486421,
    lat: -21.3143223
  },
  {
    lng: -41.2486685,
    lat: -21.3143604
  },
  {
    lng: -41.2486665,
    lat: -21.3144151
  },
  {
    lng: -41.2486505,
    lat: -21.3144731
  },
  {
    lng: -41.2486798,
    lat: -21.3145151
  },
  {
    lng: -41.2487452,
    lat: -21.3145536
  },
  {
    lng: -41.2487755,
    lat: -21.3145407
  },
  {
    lng: -41.2488171,
    lat: -21.314486
  },
  {
    lng: -41.2488982,
    lat: -21.3144192
  },
  {
    lng: -41.2489555,
    lat: -21.3144499
  },
  {
    lng: -41.2490067,
    lat: -21.3145801
  },
  {
    lng: -41.2489976,
    lat: -21.3146992
  },
  {
    lng: -41.248922,
    lat: -21.3148773
  },
  {
    lng: -41.2489334,
    lat: -21.3150312
  },
  {
    lng: -41.2490465,
    lat: -21.3151441
  },
  {
    lng: -41.249111,
    lat: -21.3154071
  },
  {
    lng: -41.2491913,
    lat: -21.3155444
  },
  {
    lng: -41.2492038,
    lat: -21.3156125
  },
  {
    lng: -41.2491318,
    lat: -21.31561
  },
  {
    lng: -41.2491073,
    lat: -21.3156404
  },
  {
    lng: -41.2490311,
    lat: -21.3156754
  },
  {
    lng: -41.2489829,
    lat: -21.3156485
  },
  {
    lng: -41.248985,
    lat: -21.315584
  },
  {
    lng: -41.2488297,
    lat: -21.3153605
  },
  {
    lng: -41.2487613,
    lat: -21.3154147
  },
  {
    lng: -41.2487603,
    lat: -21.3156048
  },
  {
    lng: -41.2487752,
    lat: -21.3156441
  },
  {
    lng: -41.2488725,
    lat: -21.3157072
  },
  {
    lng: -41.2489221,
    lat: -21.3157995
  },
  {
    lng: -41.248656,
    lat: -21.3158656
  },
  {
    lng: -41.2486597,
    lat: -21.3161476
  },
  {
    lng: -41.2487327,
    lat: -21.316232
  },
  {
    lng: -41.248748,
    lat: -21.3162592
  },
  {
    lng: -41.248811,
    lat: -21.3162446
  },
  {
    lng: -41.2488833,
    lat: -21.3162876
  },
  {
    lng: -41.2489139,
    lat: -21.3164679
  },
  {
    lng: -41.2488664,
    lat: -21.3165296
  },
  {
    lng: -41.2487997,
    lat: -21.3166777
  },
  {
    lng: -41.2489424,
    lat: -21.3168485
  },
  {
    lng: -41.2489614,
    lat: -21.3168908
  },
  {
    lng: -41.2489841,
    lat: -21.3169419
  },
  {
    lng: -41.2490922,
    lat: -21.3169683
  },
  {
    lng: -41.2491219,
    lat: -21.3169226
  },
  {
    lng: -41.2491224,
    lat: -21.3168761
  },
  {
    lng: -41.2490796,
    lat: -21.3168358
  },
  {
    lng: -41.2490892,
    lat: -21.3167886
  },
  {
    lng: -41.2491308,
    lat: -21.3167251
  },
  {
    lng: -41.2491801,
    lat: -21.3166969
  },
  {
    lng: -41.2492955,
    lat: -21.316819
  },
  {
    lng: -41.2494607,
    lat: -21.3168242
  },
  {
    lng: -41.249575,
    lat: -21.3168723
  },
  {
    lng: -41.2495755,
    lat: -21.3169111
  },
  {
    lng: -41.2495181,
    lat: -21.3170215
  },
  {
    lng: -41.2494628,
    lat: -21.3170894
  },
  {
    lng: -41.2493183,
    lat: -21.3171448
  },
  {
    lng: -41.2493002,
    lat: -21.3171951
  },
  {
    lng: -41.2493202,
    lat: -21.3172333
  },
  {
    lng: -41.2494779,
    lat: -21.3172203
  },
  {
    lng: -41.2497747,
    lat: -21.3173741
  },
  {
    lng: -41.2497588,
    lat: -21.3174344
  },
  {
    lng: -41.249793,
    lat: -21.3176974
  },
  {
    lng: -41.2499574,
    lat: -21.3184055
  },
  {
    lng: -41.2500998,
    lat: -21.3191217
  },
  {
    lng: -41.2501706,
    lat: -21.319424
  },
  {
    lng: -41.250183,
    lat: -21.3194769
  },
  {
    lng: -41.2502888,
    lat: -21.3198246
  },
  {
    lng: -41.2503771,
    lat: -21.3201799
  },
  {
    lng: -41.2504872,
    lat: -21.3205282
  },
  {
    lng: -41.2505755,
    lat: -21.3208824
  },
  {
    lng: -41.2504813,
    lat: -21.3210274
  },
  {
    lng: -41.2505003,
    lat: -21.3210545
  },
  {
    lng: -41.2505651,
    lat: -21.3211471
  },
  {
    lng: -41.2505601,
    lat: -21.3212404
  },
  {
    lng: -41.2506281,
    lat: -21.3213811
  },
  {
    lng: -41.2506629,
    lat: -21.3213914
  },
  {
    lng: -41.2507001,
    lat: -21.3213594
  },
  {
    lng: -41.2507278,
    lat: -21.3212923
  },
  {
    lng: -41.2507354,
    lat: -21.3211626
  },
  {
    lng: -41.2507688,
    lat: -21.3211106
  },
  {
    lng: -41.250958,
    lat: -21.3210919
  },
  {
    lng: -41.251061,
    lat: -21.3211176
  },
  {
    lng: -41.2510612,
    lat: -21.3211526
  },
  {
    lng: -41.2510282,
    lat: -21.3211801
  },
  {
    lng: -41.2509869,
    lat: -21.3211956
  },
  {
    lng: -41.2509601,
    lat: -21.3212622
  },
  {
    lng: -41.2509615,
    lat: -21.3213417
  },
  {
    lng: -41.2509387,
    lat: -21.3214301
  },
  {
    lng: -41.2509881,
    lat: -21.3214594
  },
  {
    lng: -41.2510948,
    lat: -21.3214429
  },
  {
    lng: -41.251259,
    lat: -21.3215016
  },
  {
    lng: -41.2513784,
    lat: -21.3215146
  },
  {
    lng: -41.251469,
    lat: -21.3214881
  },
  {
    lng: -41.2515093,
    lat: -21.3214044
  },
  {
    lng: -41.2516296,
    lat: -21.3213601
  },
  {
    lng: -41.2517728,
    lat: -21.3214333
  },
  {
    lng: -41.2518167,
    lat: -21.3214398
  },
  {
    lng: -41.2520289,
    lat: -21.3213916
  },
  {
    lng: -41.2522598,
    lat: -21.3216737
  },
  {
    lng: -41.2524401,
    lat: -21.3216459
  },
  {
    lng: -41.2524955,
    lat: -21.3216859
  },
  {
    lng: -41.2526232,
    lat: -21.3216509
  },
  {
    lng: -41.2526232,
    lat: -21.3216282
  },
  {
    lng: -41.2525487,
    lat: -21.3215337
  },
  {
    lng: -41.2526785,
    lat: -21.3214729
  },
  {
    lng: -41.2527953,
    lat: -21.3213521
  },
  {
    lng: -41.2529213,
    lat: -21.3213586
  },
  {
    lng: -41.2532226,
    lat: -21.3212895
  },
  {
    lng: -41.253267,
    lat: -21.3214998
  },
  {
    lng: -41.2533381,
    lat: -21.3215327
  },
  {
    lng: -41.2535235,
    lat: -21.3214488
  },
  {
    lng: -41.253544,
    lat: -21.3214579
  },
  {
    lng: -41.2535905,
    lat: -21.3215841
  },
  {
    lng: -41.2535709,
    lat: -21.3216039
  },
  {
    lng: -41.2534826,
    lat: -21.3216169
  },
  {
    lng: -41.2534176,
    lat: -21.3217511
  },
  {
    lng: -41.2534488,
    lat: -21.3218062
  },
  {
    lng: -41.253499,
    lat: -21.321852
  },
  {
    lng: -41.2535793,
    lat: -21.3218867
  },
  {
    lng: -41.2537108,
    lat: -21.3218499
  },
  {
    lng: -41.2539413,
    lat: -21.3219013
  },
  {
    lng: -41.2540029,
    lat: -21.321963
  },
  {
    lng: -41.2539867,
    lat: -21.3220691
  },
  {
    lng: -41.2541314,
    lat: -21.3224516
  },
  {
    lng: -41.2542658,
    lat: -21.3225405
  },
  {
    lng: -41.2542816,
    lat: -21.3225731
  },
  {
    lng: -41.2542931,
    lat: -21.322597
  },
  {
    lng: -41.2541907,
    lat: -21.3227309
  },
  {
    lng: -41.2542035,
    lat: -21.3227793
  },
  {
    lng: -41.2543312,
    lat: -21.322862
  },
  {
    lng: -41.2546723,
    lat: -21.3230307
  },
  {
    lng: -41.2546864,
    lat: -21.3231166
  },
  {
    lng: -41.2545788,
    lat: -21.3231672
  },
  {
    lng: -41.2545036,
    lat: -21.3232631
  },
  {
    lng: -41.2545075,
    lat: -21.3233737
  },
  {
    lng: -41.2545744,
    lat: -21.32336
  },
  {
    lng: -41.254569,
    lat: -21.323279
  },
  {
    lng: -41.2548404,
    lat: -21.3233655
  },
  {
    lng: -41.2549154,
    lat: -21.3235219
  },
  {
    lng: -41.2548416,
    lat: -21.3235404
  },
  {
    lng: -41.2547119,
    lat: -21.3236407
  },
  {
    lng: -41.2547428,
    lat: -21.3236814
  },
  {
    lng: -41.2548218,
    lat: -21.3236892
  },
  {
    lng: -41.2549067,
    lat: -21.3237371
  },
  {
    lng: -41.2549481,
    lat: -21.3239319
  },
  {
    lng: -41.2549964,
    lat: -21.3240125
  },
  {
    lng: -41.2551196,
    lat: -21.3241758
  },
  {
    lng: -41.2550729,
    lat: -21.3242951
  },
  {
    lng: -41.2551605,
    lat: -21.3243629
  },
  {
    lng: -41.25534,
    lat: -21.3244023
  },
  {
    lng: -41.2554101,
    lat: -21.3245447
  },
  {
    lng: -41.2553843,
    lat: -21.3245571
  },
  {
    lng: -41.2552813,
    lat: -21.3245724
  },
  {
    lng: -41.2552725,
    lat: -21.3245814
  },
  {
    lng: -41.2552938,
    lat: -21.3246693
  },
  {
    lng: -41.2552854,
    lat: -21.3247287
  },
  {
    lng: -41.2552633,
    lat: -21.3247427
  },
  {
    lng: -41.2552024,
    lat: -21.3247393
  },
  {
    lng: -41.2551489,
    lat: -21.3247479
  },
  {
    lng: -41.2551292,
    lat: -21.3247705
  },
  {
    lng: -41.2551337,
    lat: -21.3247988
  },
  {
    lng: -41.2551382,
    lat: -21.3248269
  },
  {
    lng: -41.255251,
    lat: -21.3249574
  },
  {
    lng: -41.255377,
    lat: -21.3249996
  },
  {
    lng: -41.2553426,
    lat: -21.3248283
  },
  {
    lng: -41.2553403,
    lat: -21.3247821
  },
  {
    lng: -41.2553993,
    lat: -21.3247358
  },
  {
    lng: -41.255573,
    lat: -21.3249017
  },
  {
    lng: -41.2555652,
    lat: -21.3251042
  },
  {
    lng: -41.2556184,
    lat: -21.3251717
  },
  {
    lng: -41.2556708,
    lat: -21.3251833
  },
  {
    lng: -41.2557904,
    lat: -21.3250611
  },
  {
    lng: -41.2558286,
    lat: -21.3250774
  },
  {
    lng: -41.2558924,
    lat: -21.3252132
  },
  {
    lng: -41.2560047,
    lat: -21.3251927
  },
  {
    lng: -41.2561185,
    lat: -21.3251567
  },
  {
    lng: -41.2561892,
    lat: -21.3251618
  },
  {
    lng: -41.2562019,
    lat: -21.3252122
  },
  {
    lng: -41.2562014,
    lat: -21.3252434
  },
  {
    lng: -41.2562103,
    lat: -21.3252683
  },
  {
    lng: -41.2562308,
    lat: -21.325288
  },
  {
    lng: -41.2562658,
    lat: -21.3253104
  },
  {
    lng: -41.256304,
    lat: -21.3253101
  },
  {
    lng: -41.2563677,
    lat: -21.3252934
  },
  {
    lng: -41.2564254,
    lat: -21.325317
  },
  {
    lng: -41.2564715,
    lat: -21.325375
  },
  {
    lng: -41.2564816,
    lat: -21.3255105
  },
  {
    lng: -41.2565642,
    lat: -21.3256695
  },
  {
    lng: -41.2566146,
    lat: -21.3256995
  },
  {
    lng: -41.2566748,
    lat: -21.32568
  },
  {
    lng: -41.2566926,
    lat: -21.3256243
  },
  {
    lng: -41.2567073,
    lat: -21.3254946
  },
  {
    lng: -41.2567455,
    lat: -21.3253874
  },
  {
    lng: -41.2567983,
    lat: -21.3253816
  },
  {
    lng: -41.2568328,
    lat: -21.3253869
  },
  {
    lng: -41.256887,
    lat: -21.3253948
  },
  {
    lng: -41.256948,
    lat: -21.3253853
  },
  {
    lng: -41.2570099,
    lat: -21.3253759
  },
  {
    lng: -41.257063,
    lat: -21.3253911
  },
  {
    lng: -41.2570834,
    lat: -21.325422
  },
  {
    lng: -41.2570958,
    lat: -21.3254655
  },
  {
    lng: -41.2570912,
    lat: -21.3255144
  },
  {
    lng: -41.2570681,
    lat: -21.3255774
  },
  {
    lng: -41.2570483,
    lat: -21.3256773
  },
  {
    lng: -41.2570882,
    lat: -21.3256766
  },
  {
    lng: -41.2571362,
    lat: -21.3256532
  },
  {
    lng: -41.2571919,
    lat: -21.3255999
  },
  {
    lng: -41.257276,
    lat: -21.3255517
  },
  {
    lng: -41.2573404,
    lat: -21.3255555
  },
  {
    lng: -41.2574146,
    lat: -21.3255957
  },
  {
    lng: -41.2575076,
    lat: -21.3256543
  },
  {
    lng: -41.2575584,
    lat: -21.3257404
  },
  {
    lng: -41.2575536,
    lat: -21.3258909
  },
  {
    lng: -41.257527,
    lat: -21.3259678
  },
  {
    lng: -41.2574704,
    lat: -21.3260065
  },
  {
    lng: -41.2573795,
    lat: -21.3260371
  },
  {
    lng: -41.257382,
    lat: -21.3261214
  },
  {
    lng: -41.2574569,
    lat: -21.3261385
  },
  {
    lng: -41.2575235,
    lat: -21.3261215
  },
  {
    lng: -41.2575864,
    lat: -21.3259971
  },
  {
    lng: -41.2576671,
    lat: -21.3259615
  },
  {
    lng: -41.2577959,
    lat: -21.3259961
  },
  {
    lng: -41.257912,
    lat: -21.3260144
  },
  {
    lng: -41.2579769,
    lat: -21.3260152
  },
  {
    lng: -41.2580591,
    lat: -21.3260312
  },
  {
    lng: -41.2581116,
    lat: -21.3261038
  },
  {
    lng: -41.258101,
    lat: -21.3261626
  },
  {
    lng: -41.258033,
    lat: -21.3262066
  },
  {
    lng: -41.2579553,
    lat: -21.3263291
  },
  {
    lng: -41.2580105,
    lat: -21.326378
  },
  {
    lng: -41.2580649,
    lat: -21.3264169
  },
  {
    lng: -41.2581395,
    lat: -21.3264701
  },
  {
    lng: -41.2582258,
    lat: -21.3264822
  },
  {
    lng: -41.2582928,
    lat: -21.3265047
  },
  {
    lng: -41.2583601,
    lat: -21.3265574
  },
  {
    lng: -41.2583568,
    lat: -21.326638
  },
  {
    lng: -41.2583534,
    lat: -21.3267243
  },
  {
    lng: -41.2583751,
    lat: -21.3268038
  },
  {
    lng: -41.2584212,
    lat: -21.326885
  },
  {
    lng: -41.2585487,
    lat: -21.3269199
  },
  {
    lng: -41.2585994,
    lat: -21.3269536
  },
  {
    lng: -41.2586078,
    lat: -21.3270388
  },
  {
    lng: -41.2586375,
    lat: -21.3271034
  },
  {
    lng: -41.2587819,
    lat: -21.3272209
  },
  {
    lng: -41.2588502,
    lat: -21.3273102
  },
  {
    lng: -41.25887,
    lat: -21.327385
  },
  {
    lng: -41.2588792,
    lat: -21.3274928
  },
  {
    lng: -41.2589065,
    lat: -21.3275861
  },
  {
    lng: -41.2589858,
    lat: -21.3276512
  },
  {
    lng: -41.2591234,
    lat: -21.3276825
  },
  {
    lng: -41.2593009,
    lat: -21.3276986
  },
  {
    lng: -41.2593242,
    lat: -21.3278007
  },
  {
    lng: -41.2593251,
    lat: -21.327867
  },
  {
    lng: -41.259356,
    lat: -21.3279086
  },
  {
    lng: -41.2595131,
    lat: -21.3279537
  },
  {
    lng: -41.2596084,
    lat: -21.3279508
  },
  {
    lng: -41.2596516,
    lat: -21.3279027
  },
  {
    lng: -41.2597434,
    lat: -21.3278478
  },
  {
    lng: -41.2598404,
    lat: -21.3278806
  },
  {
    lng: -41.2598982,
    lat: -21.3279122
  },
  {
    lng: -41.2600724,
    lat: -21.3279484
  },
  {
    lng: -41.260167,
    lat: -21.3280041
  },
  {
    lng: -41.2602653,
    lat: -21.3280801
  },
  {
    lng: -41.2603395,
    lat: -21.3281823
  },
  {
    lng: -41.2603592,
    lat: -21.3282524
  },
  {
    lng: -41.2603485,
    lat: -21.3283185
  },
  {
    lng: -41.2603582,
    lat: -21.3283613
  },
  {
    lng: -41.2604112,
    lat: -21.3283457
  },
  {
    lng: -41.2604755,
    lat: -21.3283532
  },
  {
    lng: -41.2604969,
    lat: -21.3284565
  },
  {
    lng: -41.2604984,
    lat: -21.328546
  },
  {
    lng: -41.260499,
    lat: -21.3286039
  },
  {
    lng: -41.260532,
    lat: -21.3286846
  },
  {
    lng: -41.2605612,
    lat: -21.3287262
  },
  {
    lng: -41.2606258,
    lat: -21.328761
  },
  {
    lng: -41.2607453,
    lat: -21.3289035
  },
  {
    lng: -41.2607673,
    lat: -21.3289491
  },
  {
    lng: -41.2608309,
    lat: -21.328983
  },
  {
    lng: -41.260962,
    lat: -21.3290216
  },
  {
    lng: -41.2610261,
    lat: -21.3290402
  },
  {
    lng: -41.261085,
    lat: -21.3290988
  },
  {
    lng: -41.2611157,
    lat: -21.3291768
  },
  {
    lng: -41.2611688,
    lat: -21.3292676
  },
  {
    lng: -41.2612381,
    lat: -21.3293487
  },
  {
    lng: -41.2612893,
    lat: -21.329454
  },
  {
    lng: -41.2614285,
    lat: -21.3295229
  },
  {
    lng: -41.2614306,
    lat: -21.3295888
  },
  {
    lng: -41.261417,
    lat: -21.329657
  },
  {
    lng: -41.2614432,
    lat: -21.3296901
  },
  {
    lng: -41.2615105,
    lat: -21.3297292
  },
  {
    lng: -41.2614855,
    lat: -21.3297977
  },
  {
    lng: -41.261453,
    lat: -21.3298434
  },
  {
    lng: -41.2613719,
    lat: -21.3299027
  },
  {
    lng: -41.2613461,
    lat: -21.3299621
  },
  {
    lng: -41.2613569,
    lat: -21.3300978
  },
  {
    lng: -41.2614287,
    lat: -21.330133
  },
  {
    lng: -41.2614812,
    lat: -21.3300494
  },
  {
    lng: -41.2616373,
    lat: -21.3299061
  },
  {
    lng: -41.2617353,
    lat: -21.3298436
  },
  {
    lng: -41.2618601,
    lat: -21.3299513
  },
  {
    lng: -41.2618674,
    lat: -21.3299647
  },
  {
    lng: -41.2618686,
    lat: -21.3299934
  },
  {
    lng: -41.2618252,
    lat: -21.3300181
  },
  {
    lng: -41.2618048,
    lat: -21.3300427
  },
  {
    lng: -41.2618589,
    lat: -21.3301446
  },
  {
    lng: -41.2618608,
    lat: -21.3302167
  },
  {
    lng: -41.2618183,
    lat: -21.3302736
  },
  {
    lng: -41.2618204,
    lat: -21.3303446
  },
  {
    lng: -41.261831,
    lat: -21.3303871
  },
  {
    lng: -41.2618271,
    lat: -21.3304238
  },
  {
    lng: -41.2617959,
    lat: -21.3304399
  },
  {
    lng: -41.2617519,
    lat: -21.330442
  },
  {
    lng: -41.2617232,
    lat: -21.330469
  },
  {
    lng: -41.2617189,
    lat: -21.3305132
  },
  {
    lng: -41.2617426,
    lat: -21.3305519
  },
  {
    lng: -41.2617873,
    lat: -21.3305883
  },
  {
    lng: -41.2618399,
    lat: -21.3306697
  },
  {
    lng: -41.2618602,
    lat: -21.3307455
  },
  {
    lng: -41.2618425,
    lat: -21.3308333
  },
  {
    lng: -41.2617826,
    lat: -21.3309592
  },
  {
    lng: -41.2617686,
    lat: -21.3310105
  },
  {
    lng: -41.2617629,
    lat: -21.3310702
  },
  {
    lng: -41.2617843,
    lat: -21.3311206
  },
  {
    lng: -41.2618448,
    lat: -21.331102
  },
  {
    lng: -41.261965,
    lat: -21.3310449
  },
  {
    lng: -41.2620148,
    lat: -21.3310441
  },
  {
    lng: -41.2621323,
    lat: -21.331065
  },
  {
    lng: -41.2621889,
    lat: -21.3311145
  },
  {
    lng: -41.2621844,
    lat: -21.3311699
  },
  {
    lng: -41.2622037,
    lat: -21.3312187
  },
  {
    lng: -41.2622782,
    lat: -21.3312471
  },
  {
    lng: -41.2624417,
    lat: -21.3313273
  },
  {
    lng: -41.262473,
    lat: -21.3313794
  },
  {
    lng: -41.2624787,
    lat: -21.3314754
  },
  {
    lng: -41.2625409,
    lat: -21.331498
  },
  {
    lng: -41.262621,
    lat: -21.3315141
  },
  {
    lng: -41.2628308,
    lat: -21.3315171
  },
  {
    lng: -41.2629155,
    lat: -21.3315437
  },
  {
    lng: -41.2630205,
    lat: -21.3316133
  },
  {
    lng: -41.2630657,
    lat: -21.33171
  },
  {
    lng: -41.2630897,
    lat: -21.331738
  },
  {
    lng: -41.2632131,
    lat: -21.3317476
  },
  {
    lng: -41.2632915,
    lat: -21.3317732
  },
  {
    lng: -41.2633484,
    lat: -21.3318334
  },
  {
    lng: -41.2633336,
    lat: -21.3318867
  },
  {
    lng: -41.2632437,
    lat: -21.3319245
  },
  {
    lng: -41.2631442,
    lat: -21.3319196
  },
  {
    lng: -41.2630579,
    lat: -21.3318979
  },
  {
    lng: -41.2629971,
    lat: -21.3319076
  },
  {
    lng: -41.2629685,
    lat: -21.331996
  },
  {
    lng: -41.2629643,
    lat: -21.3320765
  },
  {
    lng: -41.2629321,
    lat: -21.3321669
  },
  {
    lng: -41.2629018,
    lat: -21.3322407
  },
  {
    lng: -41.2628169,
    lat: -21.3323449
  },
  {
    lng: -41.2627975,
    lat: -21.3324275
  },
  {
    lng: -41.2628354,
    lat: -21.3324629
  },
  {
    lng: -41.2629448,
    lat: -21.3324762
  },
  {
    lng: -41.2629814,
    lat: -21.3325452
  },
  {
    lng: -41.2629888,
    lat: -21.332654
  },
  {
    lng: -41.2629741,
    lat: -21.332732
  },
  {
    lng: -41.2630194,
    lat: -21.332781
  },
  {
    lng: -41.2631119,
    lat: -21.3328275
  },
  {
    lng: -41.263221,
    lat: -21.3328655
  },
  {
    lng: -41.2632932,
    lat: -21.3327526
  },
  {
    lng: -41.2633034,
    lat: -21.3325547
  },
  {
    lng: -41.2633242,
    lat: -21.3325342
  },
  {
    lng: -41.2633985,
    lat: -21.3325517
  },
  {
    lng: -41.2634818,
    lat: -21.3326054
  },
  {
    lng: -41.2635585,
    lat: -21.3326815
  },
  {
    lng: -41.2635989,
    lat: -21.3327409
  },
  {
    lng: -41.2636309,
    lat: -21.3328183
  },
  {
    lng: -41.263612,
    lat: -21.3328447
  },
  {
    lng: -41.263562,
    lat: -21.3328435
  },
  {
    lng: -41.2635124,
    lat: -21.3328287
  },
  {
    lng: -41.2634636,
    lat: -21.3328293
  },
  {
    lng: -41.2634454,
    lat: -21.332879
  },
  {
    lng: -41.2634656,
    lat: -21.3329222
  },
  {
    lng: -41.2635043,
    lat: -21.3329672
  },
  {
    lng: -41.2635634,
    lat: -21.3330808
  },
  {
    lng: -41.2635916,
    lat: -21.3331349
  },
  {
    lng: -41.2636167,
    lat: -21.3331671
  },
  {
    lng: -41.2636762,
    lat: -21.3331655
  },
  {
    lng: -41.2637163,
    lat: -21.3331141
  },
  {
    lng: -41.2637486,
    lat: -21.3329687
  },
  {
    lng: -41.2638094,
    lat: -21.3329299
  },
  {
    lng: -41.2638652,
    lat: -21.332971
  },
  {
    lng: -41.263869,
    lat: -21.3331546
  },
  {
    lng: -41.2639051,
    lat: -21.3333004
  },
  {
    lng: -41.2639407,
    lat: -21.3333401
  },
  {
    lng: -41.2639737,
    lat: -21.3334206
  },
  {
    lng: -41.2639512,
    lat: -21.333477
  },
  {
    lng: -41.2638549,
    lat: -21.3335642
  },
  {
    lng: -41.2637674,
    lat: -21.3336194
  },
  {
    lng: -41.2636635,
    lat: -21.3336489
  },
  {
    lng: -41.2636029,
    lat: -21.3336803
  },
  {
    lng: -41.2634911,
    lat: -21.3337204
  },
  {
    lng: -41.2633708,
    lat: -21.3337637
  },
  {
    lng: -41.2633492,
    lat: -21.3338014
  },
  {
    lng: -41.2633934,
    lat: -21.3338508
  },
  {
    lng: -41.2634402,
    lat: -21.3338726
  },
  {
    lng: -41.2635425,
    lat: -21.3338618
  },
  {
    lng: -41.2635887,
    lat: -21.333847
  },
  {
    lng: -41.2637288,
    lat: -21.3338483
  },
  {
    lng: -41.2638174,
    lat: -21.333874
  },
  {
    lng: -41.2638973,
    lat: -21.3338793
  },
  {
    lng: -41.2639191,
    lat: -21.3339201
  },
  {
    lng: -41.263904,
    lat: -21.3339887
  },
  {
    lng: -41.2637948,
    lat: -21.3340993
  },
  {
    lng: -41.2637513,
    lat: -21.3341155
  },
  {
    lng: -41.2636107,
    lat: -21.3341247
  },
  {
    lng: -41.2635515,
    lat: -21.3341462
  },
  {
    lng: -41.2635246,
    lat: -21.3341743
  },
  {
    lng: -41.2635229,
    lat: -21.3342362
  },
  {
    lng: -41.2635749,
    lat: -21.3343477
  },
  {
    lng: -41.2635777,
    lat: -21.3345136
  },
  {
    lng: -41.2635899,
    lat: -21.334595
  },
  {
    lng: -41.263701,
    lat: -21.3347737
  },
  {
    lng: -41.263838,
    lat: -21.3350512
  },
  {
    lng: -41.2638879,
    lat: -21.3350882
  },
  {
    lng: -41.2639284,
    lat: -21.3350878
  },
  {
    lng: -41.2639396,
    lat: -21.3351318
  },
  {
    lng: -41.2639158,
    lat: -21.33518
  },
  {
    lng: -41.2638192,
    lat: -21.3352417
  },
  {
    lng: -41.263736,
    lat: -21.3353147
  },
  {
    lng: -41.263707,
    lat: -21.3353654
  },
  {
    lng: -41.2636938,
    lat: -21.3354336
  },
  {
    lng: -41.2636965,
    lat: -21.3354816
  },
  {
    lng: -41.263725,
    lat: -21.335532
  },
  {
    lng: -41.2637729,
    lat: -21.3355187
  },
  {
    lng: -41.2638294,
    lat: -21.3355033
  },
  {
    lng: -41.2638819,
    lat: -21.3355374
  },
  {
    lng: -41.2639884,
    lat: -21.3355785
  },
  {
    lng: -41.2639742,
    lat: -21.3355909
  },
  {
    lng: -41.26396,
    lat: -21.3356034
  },
  {
    lng: -41.2638901,
    lat: -21.3356404
  },
  {
    lng: -41.2638111,
    lat: -21.3356621
  },
  {
    lng: -41.2637865,
    lat: -21.3356916
  },
  {
    lng: -41.2638025,
    lat: -21.3357251
  },
  {
    lng: -41.263794,
    lat: -21.335752
  },
  {
    lng: -41.2637696,
    lat: -21.3357837
  },
  {
    lng: -41.2637425,
    lat: -21.3358186
  },
  {
    lng: -41.2637233,
    lat: -21.3358964
  },
  {
    lng: -41.2637043,
    lat: -21.3359276
  },
  {
    lng: -41.2637373,
    lat: -21.3360292
  },
  {
    lng: -41.2637791,
    lat: -21.3360987
  },
  {
    lng: -41.2638215,
    lat: -21.3361162
  },
  {
    lng: -41.2638395,
    lat: -21.3361159
  },
  {
    lng: -41.2638763,
    lat: -21.3360951
  },
  {
    lng: -41.263985,
    lat: -21.3360347
  },
  {
    lng: -41.2640388,
    lat: -21.3360216
  },
  {
    lng: -41.2640934,
    lat: -21.3360523
  },
  {
    lng: -41.2641533,
    lat: -21.3360516
  },
  {
    lng: -41.264213,
    lat: -21.3360368
  },
  {
    lng: -41.2643042,
    lat: -21.3360906
  },
  {
    lng: -41.2644166,
    lat: -21.3361256
  },
  {
    lng: -41.264421,
    lat: -21.3361271
  },
  {
    lng: -41.2644796,
    lat: -21.3361912
  },
  {
    lng: -41.2645281,
    lat: -21.3365864
  },
  {
    lng: -41.2645491,
    lat: -21.3366467
  },
  {
    lng: -41.2645817,
    lat: -21.3366772
  },
  {
    lng: -41.2645599,
    lat: -21.3367472
  },
  {
    lng: -41.2645291,
    lat: -21.3367936
  },
  {
    lng: -41.2644419,
    lat: -21.3368987
  },
  {
    lng: -41.2643962,
    lat: -21.3369261
  },
  {
    lng: -41.2643505,
    lat: -21.3369184
  },
  {
    lng: -41.2643547,
    lat: -21.3368795
  },
  {
    lng: -41.2643859,
    lat: -21.3368386
  },
  {
    lng: -41.2643977,
    lat: -21.3367677
  },
  {
    lng: -41.2643986,
    lat: -21.3366329
  },
  {
    lng: -41.2643631,
    lat: -21.3366111
  },
  {
    lng: -41.2643101,
    lat: -21.3365995
  },
  {
    lng: -41.2641763,
    lat: -21.3365959
  },
  {
    lng: -41.264076,
    lat: -21.3366303
  },
  {
    lng: -41.2640011,
    lat: -21.336665
  },
  {
    lng: -41.2639357,
    lat: -21.3367247
  },
  {
    lng: -41.2638768,
    lat: -21.3368
  },
  {
    lng: -41.2638277,
    lat: -21.3368837
  },
  {
    lng: -41.2637514,
    lat: -21.3369696
  },
  {
    lng: -41.2637193,
    lat: -21.337042
  },
  {
    lng: -41.2637432,
    lat: -21.3370874
  },
  {
    lng: -41.2637607,
    lat: -21.3371725
  },
  {
    lng: -41.2637466,
    lat: -21.3372121
  },
  {
    lng: -41.2636543,
    lat: -21.3373042
  },
  {
    lng: -41.2635589,
    lat: -21.3373805
  },
  {
    lng: -41.2635257,
    lat: -21.3374302
  },
  {
    lng: -41.2635089,
    lat: -21.337483
  },
  {
    lng: -41.2634588,
    lat: -21.3375578
  },
  {
    lng: -41.2634205,
    lat: -21.337565
  },
  {
    lng: -41.2633385,
    lat: -21.3375512
  },
  {
    lng: -41.26329,
    lat: -21.3375507
  },
  {
    lng: -41.2631521,
    lat: -21.3375696
  },
  {
    lng: -41.2631045,
    lat: -21.3375669
  },
  {
    lng: -41.2630645,
    lat: -21.3375399
  },
  {
    lng: -41.2630025,
    lat: -21.3375336
  },
  {
    lng: -41.2629638,
    lat: -21.337551
  },
  {
    lng: -41.2629159,
    lat: -21.3375859
  },
  {
    lng: -41.2628944,
    lat: -21.3376368
  },
  {
    lng: -41.2629164,
    lat: -21.3377392
  },
  {
    lng: -41.2629382,
    lat: -21.3377865
  },
  {
    lng: -41.2629895,
    lat: -21.3378266
  },
  {
    lng: -41.2630462,
    lat: -21.3379176
  },
  {
    lng: -41.2631353,
    lat: -21.3379683
  },
  {
    lng: -41.2631865,
    lat: -21.3379855
  },
  {
    lng: -41.2633269,
    lat: -21.337994
  },
  {
    lng: -41.2633895,
    lat: -21.3379809
  },
  {
    lng: -41.2634354,
    lat: -21.3379912
  },
  {
    lng: -41.2634643,
    lat: -21.3380345
  },
  {
    lng: -41.2634697,
    lat: -21.3381054
  },
  {
    lng: -41.263453,
    lat: -21.3382232
  },
  {
    lng: -41.2634166,
    lat: -21.3382504
  },
  {
    lng: -41.2633521,
    lat: -21.3382392
  },
  {
    lng: -41.2633129,
    lat: -21.3382462
  },
  {
    lng: -41.2633299,
    lat: -21.3382955
  },
  {
    lng: -41.2633752,
    lat: -21.3383462
  },
  {
    lng: -41.2633858,
    lat: -21.3383925
  },
  {
    lng: -41.2633492,
    lat: -21.338464
  },
  {
    lng: -41.2632912,
    lat: -21.3385019
  },
  {
    lng: -41.2632351,
    lat: -21.3385051
  },
  {
    lng: -41.2632008,
    lat: -21.3384672
  },
  {
    lng: -41.2631813,
    lat: -21.3384264
  },
  {
    lng: -41.2631471,
    lat: -21.3384209
  },
  {
    lng: -41.2631175,
    lat: -21.3384921
  },
  {
    lng: -41.2631151,
    lat: -21.3385726
  },
  {
    lng: -41.2629794,
    lat: -21.3386854
  },
  {
    lng: -41.2629544,
    lat: -21.3387699
  },
  {
    lng: -41.2629559,
    lat: -21.3389096
  },
  {
    lng: -41.2629258,
    lat: -21.3389565
  },
  {
    lng: -41.2629184,
    lat: -21.3390223
  },
  {
    lng: -41.262961,
    lat: -21.3390443
  },
  {
    lng: -41.2630167,
    lat: -21.3390448
  },
  {
    lng: -41.2630905,
    lat: -21.3390734
  },
  {
    lng: -41.2631383,
    lat: -21.3391218
  },
  {
    lng: -41.2631638,
    lat: -21.3391855
  },
  {
    lng: -41.2631625,
    lat: -21.3392314
  },
  {
    lng: -41.2631364,
    lat: -21.339242
  },
  {
    lng: -41.2630526,
    lat: -21.3391826
  },
  {
    lng: -41.2630213,
    lat: -21.3391604
  },
  {
    lng: -41.2629902,
    lat: -21.3391683
  },
  {
    lng: -41.2629263,
    lat: -21.3392616
  },
  {
    lng: -41.2629069,
    lat: -21.3393195
  },
  {
    lng: -41.2628808,
    lat: -21.3393985
  },
  {
    lng: -41.2628654,
    lat: -21.3394662
  },
  {
    lng: -41.2628682,
    lat: -21.3395485
  },
  {
    lng: -41.2629109,
    lat: -21.3396001
  },
  {
    lng: -41.2629435,
    lat: -21.3395903
  },
  {
    lng: -41.2629761,
    lat: -21.3395806
  },
  {
    lng: -41.2629963,
    lat: -21.3395371
  },
  {
    lng: -41.2630221,
    lat: -21.339443
  },
  {
    lng: -41.2630565,
    lat: -21.3393671
  },
  {
    lng: -41.2631628,
    lat: -21.3393487
  },
  {
    lng: -41.263248,
    lat: -21.3393735
  },
  {
    lng: -41.2632595,
    lat: -21.3393904
  },
  {
    lng: -41.2632347,
    lat: -21.3394149
  },
  {
    lng: -41.2631663,
    lat: -21.3394349
  },
  {
    lng: -41.2631256,
    lat: -21.339482
  },
  {
    lng: -41.2631592,
    lat: -21.3395138
  },
  {
    lng: -41.2633094,
    lat: -21.3395701
  },
  {
    lng: -41.2633591,
    lat: -21.3395888
  },
  {
    lng: -41.2634132,
    lat: -21.3396305
  },
  {
    lng: -41.2634109,
    lat: -21.3396803
  },
  {
    lng: -41.2633686,
    lat: -21.3397865
  },
  {
    lng: -41.2633483,
    lat: -21.3398379
  },
  {
    lng: -41.2632359,
    lat: -21.3399347
  },
  {
    lng: -41.2632228,
    lat: -21.3400038
  },
  {
    lng: -41.2632268,
    lat: -21.3400149
  },
  {
    lng: -41.2632463,
    lat: -21.3400272
  },
  {
    lng: -41.2633015,
    lat: -21.3400452
  },
  {
    lng: -41.2633493,
    lat: -21.3400611
  },
  {
    lng: -41.2634202,
    lat: -21.3400796
  },
  {
    lng: -41.2634735,
    lat: -21.3400845
  },
  {
    lng: -41.2634996,
    lat: -21.3401321
  },
  {
    lng: -41.2634682,
    lat: -21.3402378
  },
  {
    lng: -41.2634037,
    lat: -21.3403568
  },
  {
    lng: -41.263342,
    lat: -21.3403972
  },
  {
    lng: -41.2632642,
    lat: -21.3404483
  },
  {
    lng: -41.2632065,
    lat: -21.3405141
  },
  {
    lng: -41.2632278,
    lat: -21.3405505
  },
  {
    lng: -41.263283,
    lat: -21.3405748
  },
  {
    lng: -41.2633339,
    lat: -21.340558
  },
  {
    lng: -41.2634297,
    lat: -21.3405068
  },
  {
    lng: -41.263518,
    lat: -21.3404456
  },
  {
    lng: -41.2636295,
    lat: -21.3404248
  },
  {
    lng: -41.2636746,
    lat: -21.3403093
  },
  {
    lng: -41.2637199,
    lat: -21.3402849
  },
  {
    lng: -41.2637607,
    lat: -21.3403535
  },
  {
    lng: -41.2637702,
    lat: -21.3404085
  },
  {
    lng: -41.2637621,
    lat: -21.3404782
  },
  {
    lng: -41.2637699,
    lat: -21.3405456
  },
  {
    lng: -41.2638161,
    lat: -21.3405922
  },
  {
    lng: -41.2638423,
    lat: -21.3406477
  },
  {
    lng: -41.2638948,
    lat: -21.3406841
  },
  {
    lng: -41.2640343,
    lat: -21.3407602
  },
  {
    lng: -41.2640421,
    lat: -21.3407929
  },
  {
    lng: -41.2640408,
    lat: -21.3408391
  },
  {
    lng: -41.2639768,
    lat: -21.3409154
  },
  {
    lng: -41.2639146,
    lat: -21.3409573
  },
  {
    lng: -41.2638886,
    lat: -21.3410179
  },
  {
    lng: -41.2639053,
    lat: -21.3410887
  },
  {
    lng: -41.263941,
    lat: -21.3411167
  },
  {
    lng: -41.2640024,
    lat: -21.3411308
  },
  {
    lng: -41.26405,
    lat: -21.3411526
  },
  {
    lng: -41.2640468,
    lat: -21.3411922
  },
  {
    lng: -41.2639678,
    lat: -21.3413185
  },
  {
    lng: -41.2639492,
    lat: -21.3413721
  },
  {
    lng: -41.2639589,
    lat: -21.3414254
  },
  {
    lng: -41.2640196,
    lat: -21.3414364
  },
  {
    lng: -41.2640597,
    lat: -21.341367
  },
  {
    lng: -41.2641046,
    lat: -21.3413434
  },
  {
    lng: -41.2641852,
    lat: -21.3413828
  },
  {
    lng: -41.2642103,
    lat: -21.341445
  },
  {
    lng: -41.2642198,
    lat: -21.3415122
  },
  {
    lng: -41.2642457,
    lat: -21.3415505
  },
  {
    lng: -41.2643011,
    lat: -21.3415486
  },
  {
    lng: -41.2643627,
    lat: -21.341507
  },
  {
    lng: -41.2644438,
    lat: -21.3415061
  },
  {
    lng: -41.2644949,
    lat: -21.3415725
  },
  {
    lng: -41.2645179,
    lat: -21.3416454
  },
  {
    lng: -41.2645162,
    lat: -21.3417751
  },
  {
    lng: -41.2644682,
    lat: -21.3419056
  },
  {
    lng: -41.2644366,
    lat: -21.3419326
  },
  {
    lng: -41.2643842,
    lat: -21.3419326
  },
  {
    lng: -41.2643613,
    lat: -21.3418819
  },
  {
    lng: -41.2643916,
    lat: -21.3418153
  },
  {
    lng: -41.2644238,
    lat: -21.3417835
  },
  {
    lng: -41.2644246,
    lat: -21.3417219
  },
  {
    lng: -41.2643923,
    lat: -21.3416685
  },
  {
    lng: -41.2643301,
    lat: -21.3416517
  },
  {
    lng: -41.2642816,
    lat: -21.3416989
  },
  {
    lng: -41.2642363,
    lat: -21.3417594
  },
  {
    lng: -41.264209,
    lat: -21.3418207
  },
  {
    lng: -41.2642317,
    lat: -21.3418658
  },
  {
    lng: -41.2642342,
    lat: -21.3420464
  },
  {
    lng: -41.2642125,
    lat: -21.3420991
  },
  {
    lng: -41.2642007,
    lat: -21.3421629
  },
  {
    lng: -41.2642354,
    lat: -21.3422114
  },
  {
    lng: -41.2642804,
    lat: -21.3422273
  },
  {
    lng: -41.2645096,
    lat: -21.3422205
  },
  {
    lng: -41.2645585,
    lat: -21.3422342
  },
  {
    lng: -41.2645589,
    lat: -21.3422593
  },
  {
    lng: -41.264487,
    lat: -21.3423263
  },
  {
    lng: -41.2644689,
    lat: -21.3423675
  },
  {
    lng: -41.2645136,
    lat: -21.3424448
  },
  {
    lng: -41.2645482,
    lat: -21.3425044
  },
  {
    lng: -41.2645419,
    lat: -21.3425429
  },
  {
    lng: -41.2645051,
    lat: -21.3425765
  },
  {
    lng: -41.2644659,
    lat: -21.3425988
  },
  {
    lng: -41.264431,
    lat: -21.3426441
  },
  {
    lng: -41.2644285,
    lat: -21.3426953
  },
  {
    lng: -41.2644571,
    lat: -21.342755
  },
  {
    lng: -41.2645476,
    lat: -21.3427898
  },
  {
    lng: -41.2646913,
    lat: -21.3428449
  },
  {
    lng: -41.2647412,
    lat: -21.3428848
  },
  {
    lng: -41.2647481,
    lat: -21.3429756
  },
  {
    lng: -41.2647285,
    lat: -21.3430008
  },
  {
    lng: -41.2646346,
    lat: -21.3430694
  },
  {
    lng: -41.2645892,
    lat: -21.3431365
  },
  {
    lng: -41.2644644,
    lat: -21.3431135
  },
  {
    lng: -41.2644537,
    lat: -21.3431417
  },
  {
    lng: -41.2644766,
    lat: -21.3432413
  },
  {
    lng: -41.2644758,
    lat: -21.3432671
  },
  {
    lng: -41.2644501,
    lat: -21.3433465
  },
  {
    lng: -41.2644261,
    lat: -21.3433685
  },
  {
    lng: -41.2643689,
    lat: -21.3433436
  },
  {
    lng: -41.2642794,
    lat: -21.3433046
  },
  {
    lng: -41.2642477,
    lat: -21.3433302
  },
  {
    lng: -41.2642178,
    lat: -21.3433864
  },
  {
    lng: -41.2642125,
    lat: -21.3435095
  },
  {
    lng: -41.2642563,
    lat: -21.343522
  },
  {
    lng: -41.2643463,
    lat: -21.3435228
  },
  {
    lng: -41.2644114,
    lat: -21.3435635
  },
  {
    lng: -41.2644441,
    lat: -21.3436004
  },
  {
    lng: -41.2645272,
    lat: -21.3436706
  },
  {
    lng: -41.2645426,
    lat: -21.3437197
  },
  {
    lng: -41.2645065,
    lat: -21.3437471
  },
  {
    lng: -41.26446,
    lat: -21.3437246
  },
  {
    lng: -41.2644107,
    lat: -21.3437009
  },
  {
    lng: -41.2643905,
    lat: -21.3437211
  },
  {
    lng: -41.2643741,
    lat: -21.3437656
  },
  {
    lng: -41.2644038,
    lat: -21.3438186
  },
  {
    lng: -41.2643956,
    lat: -21.3438999
  },
  {
    lng: -41.2644094,
    lat: -21.3439233
  },
  {
    lng: -41.2645089,
    lat: -21.3439348
  },
  {
    lng: -41.2645912,
    lat: -21.3439656
  },
  {
    lng: -41.2647236,
    lat: -21.3439761
  },
  {
    lng: -41.2647417,
    lat: -21.3440042
  },
  {
    lng: -41.2647186,
    lat: -21.3440429
  },
  {
    lng: -41.264576,
    lat: -21.3441474
  },
  {
    lng: -41.2645365,
    lat: -21.3441853
  },
  {
    lng: -41.2645403,
    lat: -21.3442216
  },
  {
    lng: -41.2646087,
    lat: -21.3442879
  },
  {
    lng: -41.2646838,
    lat: -21.3443204
  },
  {
    lng: -41.2647147,
    lat: -21.3443117
  },
  {
    lng: -41.2647428,
    lat: -21.3442639
  },
  {
    lng: -41.2648223,
    lat: -21.3442555
  },
  {
    lng: -41.2650134,
    lat: -21.3443534
  },
  {
    lng: -41.2651609,
    lat: -21.3444572
  },
  {
    lng: -41.2652949,
    lat: -21.3445146
  },
  {
    lng: -41.2653113,
    lat: -21.3445455
  },
  {
    lng: -41.265291,
    lat: -21.3445937
  },
  {
    lng: -41.2652602,
    lat: -21.3446382
  },
  {
    lng: -41.2651894,
    lat: -21.344661
  },
  {
    lng: -41.2651294,
    lat: -21.3446658
  },
  {
    lng: -41.2650933,
    lat: -21.3446789
  },
  {
    lng: -41.2650896,
    lat: -21.3447038
  },
  {
    lng: -41.265086,
    lat: -21.3447287
  },
  {
    lng: -41.2651093,
    lat: -21.3447862
  },
  {
    lng: -41.2651504,
    lat: -21.3448219
  },
  {
    lng: -41.26521,
    lat: -21.3448053
  },
  {
    lng: -41.265271,
    lat: -21.3447708
  },
  {
    lng: -41.265381,
    lat: -21.3447634
  },
  {
    lng: -41.2654499,
    lat: -21.3448135
  },
  {
    lng: -41.265501,
    lat: -21.3448166
  },
  {
    lng: -41.2655939,
    lat: -21.3447811
  },
  {
    lng: -41.2656861,
    lat: -21.3447737
  },
  {
    lng: -41.2657738,
    lat: -21.3447803
  },
  {
    lng: -41.2658553,
    lat: -21.3448234
  },
  {
    lng: -41.2659149,
    lat: -21.3448224
  },
  {
    lng: -41.266173,
    lat: -21.3447805
  },
  {
    lng: -41.2661962,
    lat: -21.3447257
  },
  {
    lng: -41.2662652,
    lat: -21.3446806
  },
  {
    lng: -41.2663302,
    lat: -21.3447024
  },
  {
    lng: -41.2663511,
    lat: -21.3447521
  },
  {
    lng: -41.2663282,
    lat: -21.3447878
  },
  {
    lng: -41.2663258,
    lat: -21.3448173
  },
  {
    lng: -41.2663642,
    lat: -21.3448204
  },
  {
    lng: -41.2664187,
    lat: -21.3448018
  },
  {
    lng: -41.2664898,
    lat: -21.3448011
  },
  {
    lng: -41.2666154,
    lat: -21.3448151
  },
  {
    lng: -41.2666946,
    lat: -21.3449009
  },
  {
    lng: -41.2666887,
    lat: -21.3449514
  },
  {
    lng: -41.2666344,
    lat: -21.3450024
  },
  {
    lng: -41.2666315,
    lat: -21.345075
  },
  {
    lng: -41.2666764,
    lat: -21.3451457
  },
  {
    lng: -41.2667231,
    lat: -21.3451771
  },
  {
    lng: -41.2668581,
    lat: -21.3452687
  },
  {
    lng: -41.266842,
    lat: -21.3453164
  },
  {
    lng: -41.2667982,
    lat: -21.345332
  },
  {
    lng: -41.2667399,
    lat: -21.3453189
  },
  {
    lng: -41.2666954,
    lat: -21.3452874
  },
  {
    lng: -41.2666659,
    lat: -21.3452834
  },
  {
    lng: -41.2666575,
    lat: -21.3452894
  },
  {
    lng: -41.2666492,
    lat: -21.3453318
  },
  {
    lng: -41.2666737,
    lat: -21.3453672
  },
  {
    lng: -41.2667914,
    lat: -21.3454397
  },
  {
    lng: -41.2668425,
    lat: -21.3454709
  },
  {
    lng: -41.2668547,
    lat: -21.3455181
  },
  {
    lng: -41.2668421,
    lat: -21.3455515
  },
  {
    lng: -41.2667965,
    lat: -21.3455633
  },
  {
    lng: -41.2666962,
    lat: -21.3455273
  },
  {
    lng: -41.2666348,
    lat: -21.3455135
  },
  {
    lng: -41.2665915,
    lat: -21.3455392
  },
  {
    lng: -41.2665857,
    lat: -21.3455861
  },
  {
    lng: -41.2666035,
    lat: -21.34564
  },
  {
    lng: -41.2666294,
    lat: -21.3456827
  },
  {
    lng: -41.2666443,
    lat: -21.3457537
  },
  {
    lng: -41.2666428,
    lat: -21.3458255
  },
  {
    lng: -41.266603,
    lat: -21.3458831
  },
  {
    lng: -41.2665476,
    lat: -21.3458999
  },
  {
    lng: -41.266471,
    lat: -21.3458847
  },
  {
    lng: -41.2664531,
    lat: -21.3459117
  },
  {
    lng: -41.2664554,
    lat: -21.345974
  },
  {
    lng: -41.2664574,
    lat: -21.3460346
  },
  {
    lng: -41.2664701,
    lat: -21.3461266
  },
  {
    lng: -41.2664842,
    lat: -21.3462292
  },
  {
    lng: -41.2665123,
    lat: -21.3462816
  },
  {
    lng: -41.2665621,
    lat: -21.3463292
  },
  {
    lng: -41.2665444,
    lat: -21.3464277
  },
  {
    lng: -41.2665581,
    lat: -21.3464751
  },
  {
    lng: -41.2665985,
    lat: -21.346493
  },
  {
    lng: -41.266772,
    lat: -21.3464842
  },
  {
    lng: -41.2668373,
    lat: -21.3465005
  },
  {
    lng: -41.2670085,
    lat: -21.3465438
  },
  {
    lng: -41.2670976,
    lat: -21.3465888
  },
  {
    lng: -41.2671921,
    lat: -21.3467059
  },
  {
    lng: -41.2672496,
    lat: -21.346749
  },
  {
    lng: -41.267323,
    lat: -21.3467897
  },
  {
    lng: -41.2673787,
    lat: -21.3467903
  },
  {
    lng: -41.2674541,
    lat: -21.3467352
  },
  {
    lng: -41.2675152,
    lat: -21.346713
  },
  {
    lng: -41.267563,
    lat: -21.3467208
  },
  {
    lng: -41.2676909,
    lat: -21.346769
  },
  {
    lng: -41.267801,
    lat: -21.346827
  },
  {
    lng: -41.2678681,
    lat: -21.3468837
  },
  {
    lng: -41.2678729,
    lat: -21.3469318
  },
  {
    lng: -41.2678607,
    lat: -21.346966
  },
  {
    lng: -41.2678089,
    lat: -21.3470277
  },
  {
    lng: -41.2677295,
    lat: -21.3470648
  },
  {
    lng: -41.267702,
    lat: -21.3471174
  },
  {
    lng: -41.2677192,
    lat: -21.3471453
  },
  {
    lng: -41.2677623,
    lat: -21.3471459
  },
  {
    lng: -41.2679306,
    lat: -21.3471488
  },
  {
    lng: -41.2679545,
    lat: -21.3471662
  },
  {
    lng: -41.2679785,
    lat: -21.3471836
  },
  {
    lng: -41.2679596,
    lat: -21.3472322
  },
  {
    lng: -41.2679381,
    lat: -21.3472442
  },
  {
    lng: -41.2678861,
    lat: -21.3472517
  },
  {
    lng: -41.2678372,
    lat: -21.3472586
  },
  {
    lng: -41.2678364,
    lat: -21.3472969
  },
  {
    lng: -41.2678531,
    lat: -21.347372
  },
  {
    lng: -41.267878,
    lat: -21.3474046
  },
  {
    lng: -41.2679235,
    lat: -21.3474128
  },
  {
    lng: -41.2679582,
    lat: -21.3474275
  },
  {
    lng: -41.2679839,
    lat: -21.3474933
  },
  {
    lng: -41.2679793,
    lat: -21.3475339
  },
  {
    lng: -41.2679535,
    lat: -21.3475729
  },
  {
    lng: -41.2679423,
    lat: -21.3476071
  },
  {
    lng: -41.2679444,
    lat: -21.3476457
  },
  {
    lng: -41.267913,
    lat: -21.3476566
  },
  {
    lng: -41.2678639,
    lat: -21.3476355
  },
  {
    lng: -41.2678256,
    lat: -21.3476188
  },
  {
    lng: -41.267816,
    lat: -21.3476464
  },
  {
    lng: -41.267815,
    lat: -21.347693
  },
  {
    lng: -41.2678143,
    lat: -21.3477145
  },
  {
    lng: -41.2677376,
    lat: -21.3476911
  },
  {
    lng: -41.2676701,
    lat: -21.3476955
  },
  {
    lng: -41.2675994,
    lat: -21.3477086
  },
  {
    lng: -41.2675681,
    lat: -21.3477147
  },
  {
    lng: -41.2675577,
    lat: -21.3477438
  },
  {
    lng: -41.2675679,
    lat: -21.3477758
  },
  {
    lng: -41.2675969,
    lat: -21.3478008
  },
  {
    lng: -41.2676565,
    lat: -21.3478288
  },
  {
    lng: -41.267712,
    lat: -21.3478751
  },
  {
    lng: -41.2677238,
    lat: -21.3479047
  },
  {
    lng: -41.2677044,
    lat: -21.3479647
  },
  {
    lng: -41.2676686,
    lat: -21.3480161
  },
  {
    lng: -41.2676372,
    lat: -21.3480536
  },
  {
    lng: -41.2675872,
    lat: -21.3480916
  },
  {
    lng: -41.2675216,
    lat: -21.3480914
  },
  {
    lng: -41.2674141,
    lat: -21.3480383
  },
  {
    lng: -41.2673367,
    lat: -21.3480391
  },
  {
    lng: -41.2672786,
    lat: -21.3480678
  },
  {
    lng: -41.2672626,
    lat: -21.3481162
  },
  {
    lng: -41.267238,
    lat: -21.3481585
  },
  {
    lng: -41.2672313,
    lat: -21.3481956
  },
  {
    lng: -41.2672521,
    lat: -21.3482457
  },
  {
    lng: -41.2673018,
    lat: -21.3482785
  },
  {
    lng: -41.2673968,
    lat: -21.3483047
  },
  {
    lng: -41.2674735,
    lat: -21.3483058
  },
  {
    lng: -41.2674742,
    lat: -21.348345
  },
  {
    lng: -41.2674588,
    lat: -21.3484104
  },
  {
    lng: -41.2674132,
    lat: -21.3484516
  },
  {
    lng: -41.2672768,
    lat: -21.3485288
  },
  {
    lng: -41.2671853,
    lat: -21.3486044
  },
  {
    lng: -41.2671749,
    lat: -21.3486532
  },
  {
    lng: -41.2671877,
    lat: -21.3487267
  },
  {
    lng: -41.267158,
    lat: -21.3487709
  },
  {
    lng: -41.2671272,
    lat: -21.3488023
  },
  {
    lng: -41.2669726,
    lat: -21.3488888
  },
  {
    lng: -41.26695,
    lat: -21.3489489
  },
  {
    lng: -41.266989,
    lat: -21.3490729
  },
  {
    lng: -41.2670912,
    lat: -21.349098
  },
  {
    lng: -41.2671349,
    lat: -21.3490571
  },
  {
    lng: -41.2671617,
    lat: -21.3490051
  },
  {
    lng: -41.2673391,
    lat: -21.3489236
  },
  {
    lng: -41.26744,
    lat: -21.3489257
  },
  {
    lng: -41.267487,
    lat: -21.348961
  },
  {
    lng: -41.267519,
    lat: -21.3490496
  },
  {
    lng: -41.2675203,
    lat: -21.3491129
  },
  {
    lng: -41.2675498,
    lat: -21.3491876
  },
  {
    lng: -41.2675554,
    lat: -21.3492357
  },
  {
    lng: -41.2675328,
    lat: -21.3493436
  },
  {
    lng: -41.2675262,
    lat: -21.349435
  },
  {
    lng: -41.2675674,
    lat: -21.3495652
  },
  {
    lng: -41.267606,
    lat: -21.349606
  },
  {
    lng: -41.2676812,
    lat: -21.3496134
  },
  {
    lng: -41.2677189,
    lat: -21.3496537
  },
  {
    lng: -41.2677726,
    lat: -21.349676
  },
  {
    lng: -41.2680174,
    lat: -21.3497401
  },
  {
    lng: -41.2680884,
    lat: -21.3497666
  },
  {
    lng: -41.2681945,
    lat: -21.3497875
  },
  {
    lng: -41.2683605,
    lat: -21.3497303
  },
  {
    lng: -41.2684567,
    lat: -21.3497055
  },
  {
    lng: -41.2685089,
    lat: -21.3497066
  },
  {
    lng: -41.2685633,
    lat: -21.3497195
  },
  {
    lng: -41.2686207,
    lat: -21.3497174
  },
  {
    lng: -41.268656,
    lat: -21.349728
  },
  {
    lng: -41.2687777,
    lat: -21.3497912
  },
  {
    lng: -41.2688424,
    lat: -21.3497941
  },
  {
    lng: -41.2689214,
    lat: -21.3497781
  },
  {
    lng: -41.2689682,
    lat: -21.3497822
  },
  {
    lng: -41.2690337,
    lat: -21.3498114
  },
  {
    lng: -41.2691581,
    lat: -21.3498671
  },
  {
    lng: -41.2692253,
    lat: -21.3499107
  },
  {
    lng: -41.2692988,
    lat: -21.3499583
  },
  {
    lng: -41.2693473,
    lat: -21.350008
  },
  {
    lng: -41.2694191,
    lat: -21.3500507
  },
  {
    lng: -41.2694387,
    lat: -21.3500695
  },
  {
    lng: -41.2694372,
    lat: -21.3500785
  },
  {
    lng: -41.269325,
    lat: -21.3501664
  },
  {
    lng: -41.2693021,
    lat: -21.3502358
  },
  {
    lng: -41.2692693,
    lat: -21.3502969
  },
  {
    lng: -41.2692281,
    lat: -21.3503258
  },
  {
    lng: -41.2691589,
    lat: -21.3503361
  },
  {
    lng: -41.2691364,
    lat: -21.3503685
  },
  {
    lng: -41.2691656,
    lat: -21.3503962
  },
  {
    lng: -41.269178,
    lat: -21.3503977
  },
  {
    lng: -41.2692621,
    lat: -21.350409
  },
  {
    lng: -41.2692923,
    lat: -21.3504444
  },
  {
    lng: -41.269308,
    lat: -21.3504851
  },
  {
    lng: -41.2692474,
    lat: -21.3505383
  },
  {
    lng: -41.2692297,
    lat: -21.3505716
  },
  {
    lng: -41.2692215,
    lat: -21.350612
  },
  {
    lng: -41.2692479,
    lat: -21.3506516
  },
  {
    lng: -41.2693461,
    lat: -21.3506922
  },
  {
    lng: -41.2693545,
    lat: -21.3507229
  },
  {
    lng: -41.2693236,
    lat: -21.350753
  },
  {
    lng: -41.2692523,
    lat: -21.3507641
  },
  {
    lng: -41.2692097,
    lat: -21.3507857
  },
  {
    lng: -41.2692024,
    lat: -21.3508467
  },
  {
    lng: -41.2692252,
    lat: -21.3508943
  },
  {
    lng: -41.2692307,
    lat: -21.350934
  },
  {
    lng: -41.2692052,
    lat: -21.350981
  },
  {
    lng: -41.269197,
    lat: -21.3510363
  },
  {
    lng: -41.2691981,
    lat: -21.3511174
  },
  {
    lng: -41.2692162,
    lat: -21.3511674
  },
  {
    lng: -41.2692688,
    lat: -21.3511751
  },
  {
    lng: -41.2693127,
    lat: -21.3511173
  },
  {
    lng: -41.2693402,
    lat: -21.3510195
  },
  {
    lng: -41.2693932,
    lat: -21.3510385
  },
  {
    lng: -41.2694523,
    lat: -21.351119
  },
  {
    lng: -41.2694541,
    lat: -21.3511768
  },
  {
    lng: -41.2694754,
    lat: -21.35121
  },
  {
    lng: -41.2695416,
    lat: -21.3512337
  },
  {
    lng: -41.2696421,
    lat: -21.3513209
  },
  {
    lng: -41.2696436,
    lat: -21.3514069
  },
  {
    lng: -41.2696108,
    lat: -21.3515211
  },
  {
    lng: -41.2695702,
    lat: -21.351621
  },
  {
    lng: -41.2695815,
    lat: -21.3516528
  },
  {
    lng: -41.2697937,
    lat: -21.3517721
  },
  {
    lng: -41.2698516,
    lat: -21.3518482
  },
  {
    lng: -41.2698358,
    lat: -21.351972
  },
  {
    lng: -41.2697348,
    lat: -21.3519649
  },
  {
    lng: -41.2696693,
    lat: -21.3519187
  },
  {
    lng: -41.269607,
    lat: -21.3518967
  },
  {
    lng: -41.2695496,
    lat: -21.3518858
  },
  {
    lng: -41.2693908,
    lat: -21.3517505
  },
  {
    lng: -41.2693197,
    lat: -21.351779
  },
  {
    lng: -41.2692408,
    lat: -21.3518755
  },
  {
    lng: -41.269232,
    lat: -21.35197
  },
  {
    lng: -41.2691727,
    lat: -21.3520918
  },
  {
    lng: -41.2691165,
    lat: -21.3521433
  },
  {
    lng: -41.2690756,
    lat: -21.3521805
  },
  {
    lng: -41.2690344,
    lat: -21.3522833
  },
  {
    lng: -41.2688998,
    lat: -21.352487
  },
  {
    lng: -41.2688876,
    lat: -21.3525375
  },
  {
    lng: -41.2688968,
    lat: -21.352573
  },
  {
    lng: -41.2690635,
    lat: -21.352551
  },
  {
    lng: -41.2691636,
    lat: -21.3525972
  },
  {
    lng: -41.2692161,
    lat: -21.3526056
  },
  {
    lng: -41.2693071,
    lat: -21.3525984
  },
  {
    lng: -41.2693445,
    lat: -21.3526517
  },
  {
    lng: -41.2692884,
    lat: -21.3526801
  },
  {
    lng: -41.2692045,
    lat: -21.3527371
  },
  {
    lng: -41.2691611,
    lat: -21.3528005
  },
  {
    lng: -41.2690112,
    lat: -21.3528902
  },
  {
    lng: -41.2689004,
    lat: -21.3529453
  },
  {
    lng: -41.2688511,
    lat: -21.3530365
  },
  {
    lng: -41.2688559,
    lat: -21.3531165
  },
  {
    lng: -41.269071,
    lat: -21.3531558
  },
  {
    lng: -41.2690945,
    lat: -21.3532541
  },
  {
    lng: -41.2690878,
    lat: -21.3534488
  },
  {
    lng: -41.268969,
    lat: -21.3535091
  },
  {
    lng: -41.2689595,
    lat: -21.3535802
  },
  {
    lng: -41.2689669,
    lat: -21.3537364
  },
  {
    lng: -41.2689394,
    lat: -21.3538188
  },
  {
    lng: -41.2688752,
    lat: -21.35387
  },
  {
    lng: -41.2688777,
    lat: -21.3539534
  },
  {
    lng: -41.268866,
    lat: -21.3540357
  },
  {
    lng: -41.2687715,
    lat: -21.3542494
  },
  {
    lng: -41.2686874,
    lat: -21.3543388
  },
  {
    lng: -41.2686755,
    lat: -21.3544064
  },
  {
    lng: -41.2686096,
    lat: -21.3544507
  },
  {
    lng: -41.2685123,
    lat: -21.3544433
  },
  {
    lng: -41.2684677,
    lat: -21.3544259
  },
  {
    lng: -41.2684232,
    lat: -21.3544085
  },
  {
    lng: -41.2683291,
    lat: -21.3543511
  },
  {
    lng: -41.2682032,
    lat: -21.3543314
  },
  {
    lng: -41.2681477,
    lat: -21.3543443
  },
  {
    lng: -41.2680921,
    lat: -21.3543571
  },
  {
    lng: -41.2679841,
    lat: -21.3544254
  },
  {
    lng: -41.2679325,
    lat: -21.3544928
  },
  {
    lng: -41.2678948,
    lat: -21.3545416
  },
  {
    lng: -41.2678879,
    lat: -21.3545404
  },
  {
    lng: -41.2678796,
    lat: -21.3545386
  },
  {
    lng: -41.2678714,
    lat: -21.3545369
  },
  {
    lng: -41.2678632,
    lat: -21.3545352
  },
  {
    lng: -41.2678549,
    lat: -21.3545334
  },
  {
    lng: -41.2678467,
    lat: -21.3545317
  },
  {
    lng: -41.2678385,
    lat: -21.3545299
  },
  {
    lng: -41.2678303,
    lat: -21.3545279
  },
  {
    lng: -41.2678221,
    lat: -21.354526
  },
  {
    lng: -41.2678139,
    lat: -21.3545243
  },
  {
    lng: -41.2678056,
    lat: -21.3545226
  },
  {
    lng: -41.2677974,
    lat: -21.3545209
  },
  {
    lng: -41.2677891,
    lat: -21.3545192
  },
  {
    lng: -41.2677809,
    lat: -21.3545175
  },
  {
    lng: -41.2677726,
    lat: -21.3545158
  },
  {
    lng: -41.2677644,
    lat: -21.3545141
  },
  {
    lng: -41.2677561,
    lat: -21.3545125
  },
  {
    lng: -41.2675003,
    lat: -21.3544606
  },
  {
    lng: -41.2674921,
    lat: -21.354459
  },
  {
    lng: -41.2674838,
    lat: -21.3544573
  },
  {
    lng: -41.2674756,
    lat: -21.3544556
  },
  {
    lng: -41.2674673,
    lat: -21.354454
  },
  {
    lng: -41.2674591,
    lat: -21.3544523
  },
  {
    lng: -41.2674508,
    lat: -21.3544507
  },
  {
    lng: -41.2674426,
    lat: -21.354449
  },
  {
    lng: -41.2674343,
    lat: -21.3544474
  },
  {
    lng: -41.267426,
    lat: -21.354446
  },
  {
    lng: -41.2674177,
    lat: -21.3544446
  },
  {
    lng: -41.2674094,
    lat: -21.354443
  },
  {
    lng: -41.2674012,
    lat: -21.3544414
  },
  {
    lng: -41.2673929,
    lat: -21.3544398
  },
  {
    lng: -41.2673847,
    lat: -21.3544382
  },
  {
    lng: -41.2673764,
    lat: -21.3544368
  },
  {
    lng: -41.2673681,
    lat: -21.3544354
  },
  {
    lng: -41.2673598,
    lat: -21.354434
  },
  {
    lng: -41.2673515,
    lat: -21.3544326
  },
  {
    lng: -41.2673432,
    lat: -21.3544311
  },
  {
    lng: -41.2673349,
    lat: -21.3544297
  },
  {
    lng: -41.2673266,
    lat: -21.3544283
  },
  {
    lng: -41.2673183,
    lat: -21.3544269
  },
  {
    lng: -41.26731,
    lat: -21.3544255
  },
  {
    lng: -41.2673017,
    lat: -21.3544241
  },
  {
    lng: -41.2672934,
    lat: -21.3544227
  },
  {
    lng: -41.267285,
    lat: -21.3544213
  },
  {
    lng: -41.2672767,
    lat: -21.3544199
  },
  {
    lng: -41.2672684,
    lat: -21.3544186
  },
  {
    lng: -41.2672601,
    lat: -21.3544172
  },
  {
    lng: -41.2672518,
    lat: -21.3544158
  },
  {
    lng: -41.2672435,
    lat: -21.3544144
  },
  {
    lng: -41.2672352,
    lat: -21.354413
  },
  {
    lng: -41.2672269,
    lat: -21.3544116
  },
  {
    lng: -41.2672186,
    lat: -21.3544103
  },
  {
    lng: -41.2672103,
    lat: -21.3544089
  },
  {
    lng: -41.267202,
    lat: -21.3544075
  },
  {
    lng: -41.2671937,
    lat: -21.3544062
  },
  {
    lng: -41.2671854,
    lat: -21.3544048
  },
  {
    lng: -41.2671771,
    lat: -21.3544034
  },
  {
    lng: -41.2671688,
    lat: -21.3544021
  },
  {
    lng: -41.2671605,
    lat: -21.3544007
  },
  {
    lng: -41.2671522,
    lat: -21.3543993
  },
  {
    lng: -41.2671439,
    lat: -21.354398
  },
  {
    lng: -41.2671355,
    lat: -21.3543966
  },
  {
    lng: -41.2671272,
    lat: -21.3543953
  },
  {
    lng: -41.2671246,
    lat: -21.3543948
  },
  {
    lng: -41.2671219,
    lat: -21.3543943
  },
  {
    lng: -41.2671192,
    lat: -21.3543938
  },
  {
    lng: -41.2671165,
    lat: -21.3543934
  },
  {
    lng: -41.2671138,
    lat: -21.3543929
  },
  {
    lng: -41.2671112,
    lat: -21.3543924
  },
  {
    lng: -41.2671085,
    lat: -21.354392
  },
  {
    lng: -41.2671058,
    lat: -21.3543915
  },
  {
    lng: -41.2671031,
    lat: -21.354391
  },
  {
    lng: -41.2671005,
    lat: -21.3543906
  },
  {
    lng: -41.2670978,
    lat: -21.3543901
  },
  {
    lng: -41.2670951,
    lat: -21.3543897
  },
  {
    lng: -41.2670924,
    lat: -21.3543892
  },
  {
    lng: -41.2670897,
    lat: -21.3543888
  },
  {
    lng: -41.267087,
    lat: -21.3543883
  },
  {
    lng: -41.2670844,
    lat: -21.3543879
  },
  {
    lng: -41.2670817,
    lat: -21.3543874
  },
  {
    lng: -41.267079,
    lat: -21.354387
  },
  {
    lng: -41.2670763,
    lat: -21.3543866
  },
  {
    lng: -41.2670736,
    lat: -21.3543861
  },
  {
    lng: -41.2670709,
    lat: -21.3543857
  },
  {
    lng: -41.2670682,
    lat: -21.3543854
  },
  {
    lng: -41.2670655,
    lat: -21.3543851
  },
  {
    lng: -41.2670628,
    lat: -21.3543848
  },
  {
    lng: -41.2670601,
    lat: -21.3543845
  },
  {
    lng: -41.2670574,
    lat: -21.3543842
  },
  {
    lng: -41.2670547,
    lat: -21.3543838
  },
  {
    lng: -41.267052,
    lat: -21.3543835
  },
  {
    lng: -41.2670494,
    lat: -21.354383
  },
  {
    lng: -41.2670467,
    lat: -21.3543825
  },
  {
    lng: -41.267044,
    lat: -21.3543822
  },
  {
    lng: -41.2670413,
    lat: -21.3543819
  },
  {
    lng: -41.2670386,
    lat: -21.3543816
  },
  {
    lng: -41.2670359,
    lat: -21.3543813
  },
  {
    lng: -41.2670332,
    lat: -21.3543811
  },
  {
    lng: -41.2670304,
    lat: -21.3543808
  },
  {
    lng: -41.2670277,
    lat: -21.3543805
  },
  {
    lng: -41.267025,
    lat: -21.3543803
  },
  {
    lng: -41.2670223,
    lat: -21.35438
  },
  {
    lng: -41.2670196,
    lat: -21.3543798
  },
  {
    lng: -41.2670169,
    lat: -21.3543795
  },
  {
    lng: -41.2670142,
    lat: -21.3543792
  },
  {
    lng: -41.2670115,
    lat: -21.354379
  },
  {
    lng: -41.2670088,
    lat: -21.3543787
  },
  {
    lng: -41.2670061,
    lat: -21.3543785
  },
  {
    lng: -41.2670034,
    lat: -21.3543782
  },
  {
    lng: -41.2670007,
    lat: -21.354378
  },
  {
    lng: -41.266998,
    lat: -21.3543777
  },
  {
    lng: -41.2669952,
    lat: -21.3543774
  },
  {
    lng: -41.2669925,
    lat: -21.3543772
  },
  {
    lng: -41.2669898,
    lat: -21.354377
  },
  {
    lng: -41.2669871,
    lat: -21.3543767
  },
  {
    lng: -41.2669844,
    lat: -21.3543765
  },
  {
    lng: -41.2669817,
    lat: -21.3543763
  },
  {
    lng: -41.266979,
    lat: -21.3543762
  },
  {
    lng: -41.2669762,
    lat: -21.3543762
  },
  {
    lng: -41.2669735,
    lat: -21.354376
  },
  {
    lng: -41.2669708,
    lat: -21.3543759
  },
  {
    lng: -41.2669681,
    lat: -21.3543757
  },
  {
    lng: -41.2669654,
    lat: -21.3543754
  },
  {
    lng: -41.2669627,
    lat: -21.3543752
  },
  {
    lng: -41.26696,
    lat: -21.354375
  },
  {
    lng: -41.2669573,
    lat: -21.3543748
  },
  {
    lng: -41.2669546,
    lat: -21.3543748
  },
  {
    lng: -41.2669518,
    lat: -21.3543748
  },
  {
    lng: -41.2669491,
    lat: -21.3543748
  },
  {
    lng: -41.2669464,
    lat: -21.3543748
  },
  {
    lng: -41.2669437,
    lat: -21.3543747
  },
  {
    lng: -41.266941,
    lat: -21.3543745
  },
  {
    lng: -41.2669382,
    lat: -21.3543743
  },
  {
    lng: -41.2669355,
    lat: -21.3543743
  },
  {
    lng: -41.2669328,
    lat: -21.3543743
  },
  {
    lng: -41.2669301,
    lat: -21.3543743
  },
  {
    lng: -41.2669274,
    lat: -21.3543744
  },
  {
    lng: -41.2669247,
    lat: -21.3543744
  },
  {
    lng: -41.2669219,
    lat: -21.3543745
  },
  {
    lng: -41.2669192,
    lat: -21.3543745
  },
  {
    lng: -41.2669165,
    lat: -21.3543745
  },
  {
    lng: -41.2669138,
    lat: -21.3543746
  },
  {
    lng: -41.2669111,
    lat: -21.3543746
  },
  {
    lng: -41.2669083,
    lat: -21.3543748
  },
  {
    lng: -41.2669056,
    lat: -21.3543748
  },
  {
    lng: -41.2669029,
    lat: -21.3543749
  },
  {
    lng: -41.2669002,
    lat: -21.3543749
  },
  {
    lng: -41.2668975,
    lat: -21.3543749
  },
  {
    lng: -41.2668947,
    lat: -21.354375
  },
  {
    lng: -41.266892,
    lat: -21.354375
  },
  {
    lng: -41.2668893,
    lat: -21.3543751
  },
  {
    lng: -41.2668866,
    lat: -21.3543751
  },
  {
    lng: -41.2668839,
    lat: -21.3543752
  },
  {
    lng: -41.2668812,
    lat: -21.3543752
  },
  {
    lng: -41.2668784,
    lat: -21.3543753
  },
  {
    lng: -41.2668757,
    lat: -21.3543754
  },
  {
    lng: -41.266873,
    lat: -21.3543754
  },
  {
    lng: -41.2668703,
    lat: -21.3543754
  },
  {
    lng: -41.2668676,
    lat: -21.3543755
  },
  {
    lng: -41.2668648,
    lat: -21.3543755
  },
  {
    lng: -41.2668621,
    lat: -21.3543756
  },
  {
    lng: -41.2668594,
    lat: -21.3543756
  },
  {
    lng: -41.2668567,
    lat: -21.3543757
  },
  {
    lng: -41.266854,
    lat: -21.3543758
  },
  {
    lng: -41.2668512,
    lat: -21.3543758
  },
  {
    lng: -41.2668485,
    lat: -21.3543759
  },
  {
    lng: -41.2668458,
    lat: -21.354376
  },
  {
    lng: -41.2668431,
    lat: -21.3543761
  },
  {
    lng: -41.2668404,
    lat: -21.3543764
  },
  {
    lng: -41.2668377,
    lat: -21.3543767
  },
  {
    lng: -41.266835,
    lat: -21.3543769
  },
  {
    lng: -41.2668322,
    lat: -21.354377
  },
  {
    lng: -41.2668295,
    lat: -21.3543771
  },
  {
    lng: -41.2668268,
    lat: -21.3543772
  },
  {
    lng: -41.2668241,
    lat: -21.3543773
  },
  {
    lng: -41.2668214,
    lat: -21.3543776
  },
  {
    lng: -41.2668187,
    lat: -21.3543779
  },
  {
    lng: -41.266816,
    lat: -21.3543783
  },
  {
    lng: -41.2668133,
    lat: -21.3543786
  },
  {
    lng: -41.2668106,
    lat: -21.3543789
  },
  {
    lng: -41.2668079,
    lat: -21.354379
  },
  {
    lng: -41.2668052,
    lat: -21.3543792
  },
  {
    lng: -41.2668025,
    lat: -21.3543795
  },
  {
    lng: -41.2667998,
    lat: -21.3543798
  },
  {
    lng: -41.2667971,
    lat: -21.3543802
  },
  {
    lng: -41.2667944,
    lat: -21.3543805
  },
  {
    lng: -41.2667917,
    lat: -21.3543809
  },
  {
    lng: -41.266789,
    lat: -21.3543813
  },
  {
    lng: -41.2667863,
    lat: -21.3543816
  },
  {
    lng: -41.2667836,
    lat: -21.354382
  },
  {
    lng: -41.2667809,
    lat: -21.3543824
  },
  {
    lng: -41.2667782,
    lat: -21.3543828
  },
  {
    lng: -41.2667755,
    lat: -21.3543831
  },
  {
    lng: -41.2667728,
    lat: -21.3543836
  },
  {
    lng: -41.2667701,
    lat: -21.354384
  },
  {
    lng: -41.2667675,
    lat: -21.3543844
  },
  {
    lng: -41.2667648,
    lat: -21.3543847
  },
  {
    lng: -41.2667621,
    lat: -21.3543851
  },
  {
    lng: -41.2667594,
    lat: -21.3543855
  },
  {
    lng: -41.2667567,
    lat: -21.3543859
  },
  {
    lng: -41.266754,
    lat: -21.3543863
  },
  {
    lng: -41.2667513,
    lat: -21.3543866
  },
  {
    lng: -41.2667486,
    lat: -21.354387
  },
  {
    lng: -41.2667459,
    lat: -21.3543874
  },
  {
    lng: -41.2667432,
    lat: -21.3543877
  },
  {
    lng: -41.2667405,
    lat: -21.3543881
  },
  {
    lng: -41.2667378,
    lat: -21.3543885
  },
  {
    lng: -41.2667351,
    lat: -21.3543889
  },
  {
    lng: -41.2667324,
    lat: -21.3543893
  },
  {
    lng: -41.2667298,
    lat: -21.3543897
  },
  {
    lng: -41.2667271,
    lat: -21.35439
  },
  {
    lng: -41.2667244,
    lat: -21.3543904
  },
  {
    lng: -41.2667217,
    lat: -21.3543908
  },
  {
    lng: -41.266719,
    lat: -21.3543912
  },
  {
    lng: -41.2667163,
    lat: -21.3543917
  },
  {
    lng: -41.2667136,
    lat: -21.3543921
  },
  {
    lng: -41.266711,
    lat: -21.3543927
  },
  {
    lng: -41.2667083,
    lat: -21.3543933
  },
  {
    lng: -41.2667056,
    lat: -21.3543938
  },
  {
    lng: -41.266703,
    lat: -21.3543943
  },
  {
    lng: -41.2667003,
    lat: -21.3543947
  },
  {
    lng: -41.2666976,
    lat: -21.3543951
  },
  {
    lng: -41.2666949,
    lat: -21.3543956
  },
  {
    lng: -41.2666923,
    lat: -21.3543962
  },
  {
    lng: -41.2666896,
    lat: -21.3543969
  },
  {
    lng: -41.266687,
    lat: -21.3543975
  },
  {
    lng: -41.2666844,
    lat: -21.3543982
  },
  {
    lng: -41.2666817,
    lat: -21.3543988
  },
  {
    lng: -41.266679,
    lat: -21.3543992
  },
  {
    lng: -41.2666763,
    lat: -21.3543997
  },
  {
    lng: -41.2666737,
    lat: -21.3544004
  },
  {
    lng: -41.2666711,
    lat: -21.354401
  },
  {
    lng: -41.2666684,
    lat: -21.3544017
  },
  {
    lng: -41.2666658,
    lat: -21.3544024
  },
  {
    lng: -41.2666632,
    lat: -21.3544031
  },
  {
    lng: -41.2666605,
    lat: -21.3544038
  },
  {
    lng: -41.2666579,
    lat: -21.3544045
  },
  {
    lng: -41.2666553,
    lat: -21.3544052
  },
  {
    lng: -41.2666527,
    lat: -21.3544059
  },
  {
    lng: -41.2666501,
    lat: -21.3544066
  },
  {
    lng: -41.2666474,
    lat: -21.3544073
  },
  {
    lng: -41.2666448,
    lat: -21.354408
  },
  {
    lng: -41.2666422,
    lat: -21.3544088
  },
  {
    lng: -41.2666395,
    lat: -21.3544095
  },
  {
    lng: -41.2666185,
    lat: -21.3544151
  },
  {
    lng: -41.2666159,
    lat: -21.3544158
  },
  {
    lng: -41.2666133,
    lat: -21.3544165
  },
  {
    lng: -41.2666107,
    lat: -21.3544173
  },
  {
    lng: -41.266608,
    lat: -21.354418
  },
  {
    lng: -41.2666054,
    lat: -21.3544186
  },
  {
    lng: -41.2666028,
    lat: -21.3544193
  },
  {
    lng: -41.2666001,
    lat: -21.3544201
  },
  {
    lng: -41.2665975,
    lat: -21.3544208
  },
  {
    lng: -41.2665949,
    lat: -21.3544215
  },
  {
    lng: -41.2665923,
    lat: -21.3544222
  },
  {
    lng: -41.2665897,
    lat: -21.3544229
  },
  {
    lng: -41.266587,
    lat: -21.3544237
  },
  {
    lng: -41.2665844,
    lat: -21.3544244
  },
  {
    lng: -41.2665818,
    lat: -21.3544252
  },
  {
    lng: -41.2665793,
    lat: -21.3544261
  },
  {
    lng: -41.2665767,
    lat: -21.3544271
  },
  {
    lng: -41.2665741,
    lat: -21.3544279
  },
  {
    lng: -41.2665715,
    lat: -21.3544287
  },
  {
    lng: -41.2665689,
    lat: -21.3544294
  },
  {
    lng: -41.2665663,
    lat: -21.3544302
  },
  {
    lng: -41.2665637,
    lat: -21.3544309
  },
  {
    lng: -41.2665612,
    lat: -21.3544319
  },
  {
    lng: -41.2665586,
    lat: -21.3544329
  },
  {
    lng: -41.2665561,
    lat: -21.3544339
  },
  {
    lng: -41.2665536,
    lat: -21.3544348
  },
  {
    lng: -41.2665509,
    lat: -21.3544356
  },
  {
    lng: -41.2665484,
    lat: -21.3544365
  },
  {
    lng: -41.2665458,
    lat: -21.3544375
  },
  {
    lng: -41.2665433,
    lat: -21.3544385
  },
  {
    lng: -41.2665408,
    lat: -21.3544395
  },
  {
    lng: -41.2665383,
    lat: -21.3544405
  },
  {
    lng: -41.2665358,
    lat: -21.3544416
  },
  {
    lng: -41.2665332,
    lat: -21.3544426
  },
  {
    lng: -41.2665307,
    lat: -21.3544437
  },
  {
    lng: -41.2665282,
    lat: -21.3544447
  },
  {
    lng: -41.2665257,
    lat: -21.3544457
  },
  {
    lng: -41.2665232,
    lat: -21.3544468
  },
  {
    lng: -41.2664731,
    lat: -21.3544676
  },
  {
    lng: -41.2664715,
    lat: -21.3544683
  },
  {
    lng: -41.26647,
    lat: -21.3544689
  },
  {
    lng: -41.2664684,
    lat: -21.3544696
  },
  {
    lng: -41.2664669,
    lat: -21.3544702
  },
  {
    lng: -41.2664653,
    lat: -21.3544709
  },
  {
    lng: -41.2664638,
    lat: -21.3544715
  },
  {
    lng: -41.2664622,
    lat: -21.3544722
  },
  {
    lng: -41.2664607,
    lat: -21.3544729
  },
  {
    lng: -41.2664591,
    lat: -21.3544735
  },
  {
    lng: -41.2664576,
    lat: -21.3544742
  },
  {
    lng: -41.2664561,
    lat: -21.3544751
  },
  {
    lng: -41.2664547,
    lat: -21.354476
  },
  {
    lng: -41.2664532,
    lat: -21.3544767
  },
  {
    lng: -41.2664517,
    lat: -21.3544774
  },
  {
    lng: -41.2664501,
    lat: -21.3544781
  },
  {
    lng: -41.2664486,
    lat: -21.3544788
  },
  {
    lng: -41.2664472,
    lat: -21.3544798
  },
  {
    lng: -41.2664459,
    lat: -21.3544807
  },
  {
    lng: -41.2664444,
    lat: -21.3544816
  },
  {
    lng: -41.2664429,
    lat: -21.3544824
  },
  {
    lng: -41.2664414,
    lat: -21.3544832
  },
  {
    lng: -41.2664401,
    lat: -21.3544842
  },
  {
    lng: -41.2664387,
    lat: -21.3544852
  },
  {
    lng: -41.2664374,
    lat: -21.3544862
  },
  {
    lng: -41.2664361,
    lat: -21.3544872
  },
  {
    lng: -41.2664347,
    lat: -21.3544882
  },
  {
    lng: -41.2664334,
    lat: -21.3544892
  },
  {
    lng: -41.2663662,
    lat: -21.3545399
  },
  {
    lng: -41.2663649,
    lat: -21.354541
  },
  {
    lng: -41.2663636,
    lat: -21.354542
  },
  {
    lng: -41.2663623,
    lat: -21.354543
  },
  {
    lng: -41.2663609,
    lat: -21.354544
  },
  {
    lng: -41.2663596,
    lat: -21.354545
  },
  {
    lng: -41.2663583,
    lat: -21.3545461
  },
  {
    lng: -41.2663571,
    lat: -21.3545473
  },
  {
    lng: -41.2663559,
    lat: -21.3545485
  },
  {
    lng: -41.2663547,
    lat: -21.3545496
  },
  {
    lng: -41.2663534,
    lat: -21.3545507
  },
  {
    lng: -41.2663521,
    lat: -21.3545518
  },
  {
    lng: -41.2663511,
    lat: -21.3545531
  },
  {
    lng: -41.26635,
    lat: -21.3545544
  },
  {
    lng: -41.2663489,
    lat: -21.3545556
  },
  {
    lng: -41.2663477,
    lat: -21.3545568
  },
  {
    lng: -41.2663465,
    lat: -21.354558
  },
  {
    lng: -41.2663455,
    lat: -21.3545593
  },
  {
    lng: -41.2663445,
    lat: -21.3545607
  },
  {
    lng: -41.2663435,
    lat: -21.354562
  },
  {
    lng: -41.2663425,
    lat: -21.3545634
  },
  {
    lng: -41.2663415,
    lat: -21.3545647
  },
  {
    lng: -41.2663405,
    lat: -21.3545661
  },
  {
    lng: -41.2662906,
    lat: -21.3546338
  },
  {
    lng: -41.2662896,
    lat: -21.3546352
  },
  {
    lng: -41.2662886,
    lat: -21.3546366
  },
  {
    lng: -41.2662876,
    lat: -21.3546379
  },
  {
    lng: -41.2662866,
    lat: -21.3546393
  },
  {
    lng: -41.2662857,
    lat: -21.3546406
  },
  {
    lng: -41.2662847,
    lat: -21.354642
  },
  {
    lng: -41.2662839,
    lat: -21.3546435
  },
  {
    lng: -41.2662832,
    lat: -21.354645
  },
  {
    lng: -41.2662823,
    lat: -21.3546464
  },
  {
    lng: -41.2662813,
    lat: -21.3546478
  },
  {
    lng: -41.2662804,
    lat: -21.3546492
  },
  {
    lng: -41.2662786,
    lat: -21.3546536
  },
  {
    lng: -41.2662768,
    lat: -21.3546579
  },
  {
    lng: -41.266275,
    lat: -21.3546623
  },
  {
    lng: -41.2662732,
    lat: -21.3546666
  },
  {
    lng: -41.2662715,
    lat: -21.354671
  },
  {
    lng: -41.2662696,
    lat: -21.3546753
  },
  {
    lng: -41.2662678,
    lat: -21.3546797
  },
  {
    lng: -41.2662658,
    lat: -21.3546839
  },
  {
    lng: -41.266264,
    lat: -21.3546883
  },
  {
    lng: -41.2662621,
    lat: -21.3546926
  },
  {
    lng: -41.2662603,
    lat: -21.3546969
  },
  {
    lng: -41.2662585,
    lat: -21.3547013
  },
  {
    lng: -41.2662567,
    lat: -21.3547057
  },
  {
    lng: -41.266255,
    lat: -21.35471
  },
  {
    lng: -41.2662532,
    lat: -21.3547144
  },
  {
    lng: -41.2662514,
    lat: -21.3547187
  },
  {
    lng: -41.2662496,
    lat: -21.3547231
  },
  {
    lng: -41.2662479,
    lat: -21.3547275
  },
  {
    lng: -41.2662461,
    lat: -21.3547319
  },
  {
    lng: -41.2662444,
    lat: -21.3547362
  },
  {
    lng: -41.2662426,
    lat: -21.3547406
  },
  {
    lng: -41.2662408,
    lat: -21.354745
  },
  {
    lng: -41.2662391,
    lat: -21.3547493
  },
  {
    lng: -41.2662373,
    lat: -21.3547537
  },
  {
    lng: -41.2662356,
    lat: -21.3547581
  },
  {
    lng: -41.2662339,
    lat: -21.3547625
  },
  {
    lng: -41.2662321,
    lat: -21.3547668
  },
  {
    lng: -41.2662304,
    lat: -21.3547712
  },
  {
    lng: -41.2662287,
    lat: -21.3547756
  },
  {
    lng: -41.266227,
    lat: -21.35478
  },
  {
    lng: -41.2662254,
    lat: -21.3547844
  },
  {
    lng: -41.2662236,
    lat: -21.3547888
  },
  {
    lng: -41.2662221,
    lat: -21.3547933
  },
  {
    lng: -41.2662204,
    lat: -21.3547977
  },
  {
    lng: -41.2662188,
    lat: -21.3548021
  },
  {
    lng: -41.266217,
    lat: -21.3548065
  },
  {
    lng: -41.2662153,
    lat: -21.3548108
  },
  {
    lng: -41.2662136,
    lat: -21.3548152
  },
  {
    lng: -41.2662119,
    lat: -21.3548196
  },
  {
    lng: -41.2662102,
    lat: -21.354824
  },
  {
    lng: -41.2662086,
    lat: -21.3548284
  },
  {
    lng: -41.266207,
    lat: -21.3548329
  },
  {
    lng: -41.2662054,
    lat: -21.3548373
  },
  {
    lng: -41.2662038,
    lat: -21.3548417
  },
  {
    lng: -41.2662022,
    lat: -21.3548462
  },
  {
    lng: -41.2662006,
    lat: -21.3548506
  },
  {
    lng: -41.2661991,
    lat: -21.354855
  },
  {
    lng: -41.2661975,
    lat: -21.3548595
  },
  {
    lng: -41.2661959,
    lat: -21.3548639
  },
  {
    lng: -41.2661943,
    lat: -21.3548683
  },
  {
    lng: -41.2661928,
    lat: -21.3548728
  },
  {
    lng: -41.2661912,
    lat: -21.3548772
  },
  {
    lng: -41.2661896,
    lat: -21.3548817
  },
  {
    lng: -41.2661881,
    lat: -21.3548861
  },
  {
    lng: -41.2661865,
    lat: -21.3548905
  },
  {
    lng: -41.2661849,
    lat: -21.354895
  },
  {
    lng: -41.2661834,
    lat: -21.3548994
  },
  {
    lng: -41.2661818,
    lat: -21.3549039
  },
  {
    lng: -41.2661803,
    lat: -21.3549083
  },
  {
    lng: -41.2661787,
    lat: -21.3549128
  },
  {
    lng: -41.2661772,
    lat: -21.3549172
  },
  {
    lng: -41.2661756,
    lat: -21.3549217
  },
  {
    lng: -41.2661741,
    lat: -21.3549261
  },
  {
    lng: -41.2661725,
    lat: -21.3549306
  },
  {
    lng: -41.2661711,
    lat: -21.354935
  },
  {
    lng: -41.2661697,
    lat: -21.3549396
  },
  {
    lng: -41.2661677,
    lat: -21.3549459
  },
  {
    lng: -41.2661655,
    lat: -21.3549523
  },
  {
    lng: -41.2661633,
    lat: -21.3549586
  },
  {
    lng: -41.2661611,
    lat: -21.3549649
  },
  {
    lng: -41.2661589,
    lat: -21.3549712
  },
  {
    lng: -41.2661566,
    lat: -21.3549775
  },
  {
    lng: -41.2661545,
    lat: -21.3549838
  },
  {
    lng: -41.2661523,
    lat: -21.3549901
  },
  {
    lng: -41.26615,
    lat: -21.3549964
  },
  {
    lng: -41.2661478,
    lat: -21.3550027
  },
  {
    lng: -41.2661456,
    lat: -21.355009
  },
  {
    lng: -41.2661433,
    lat: -21.3550153
  },
  {
    lng: -41.2661412,
    lat: -21.3550217
  },
  {
    lng: -41.2660875,
    lat: -21.3551729
  },
  {
    lng: -41.2660851,
    lat: -21.3551791
  },
  {
    lng: -41.2660829,
    lat: -21.3551854
  },
  {
    lng: -41.2660806,
    lat: -21.3551917
  },
  {
    lng: -41.2660784,
    lat: -21.355198
  },
  {
    lng: -41.2660762,
    lat: -21.3552043
  },
  {
    lng: -41.2660739,
    lat: -21.3552106
  },
  {
    lng: -41.2660716,
    lat: -21.3552169
  },
  {
    lng: -41.2660693,
    lat: -21.3552232
  },
  {
    lng: -41.2660671,
    lat: -21.3552295
  },
  {
    lng: -41.2660648,
    lat: -21.3552358
  },
  {
    lng: -41.2660626,
    lat: -21.3552421
  },
  {
    lng: -41.2660603,
    lat: -21.3552483
  },
  {
    lng: -41.2660578,
    lat: -21.3552546
  },
  {
    lng: -41.2660553,
    lat: -21.3552608
  },
  {
    lng: -41.2660529,
    lat: -21.355267
  },
  {
    lng: -41.2660506,
    lat: -21.3552733
  },
  {
    lng: -41.2660483,
    lat: -21.3552796
  },
  {
    lng: -41.266046,
    lat: -21.3552858
  },
  {
    lng: -41.2660435,
    lat: -21.355292
  },
  {
    lng: -41.266041,
    lat: -21.3552982
  },
  {
    lng: -41.2660385,
    lat: -21.3553044
  },
  {
    lng: -41.266036,
    lat: -21.3553107
  },
  {
    lng: -41.2660335,
    lat: -21.3553169
  },
  {
    lng: -41.266031,
    lat: -21.3553231
  },
  {
    lng: -41.2660285,
    lat: -21.3553293
  },
  {
    lng: -41.266026,
    lat: -21.3553355
  },
  {
    lng: -41.2660235,
    lat: -21.3553416
  },
  {
    lng: -41.2660211,
    lat: -21.3553479
  },
  {
    lng: -41.2660186,
    lat: -21.3553541
  },
  {
    lng: -41.2660161,
    lat: -21.3553603
  },
  {
    lng: -41.2660136,
    lat: -21.3553665
  },
  {
    lng: -41.266011,
    lat: -21.3553727
  },
  {
    lng: -41.2660085,
    lat: -21.3553789
  },
  {
    lng: -41.266006,
    lat: -21.355385
  },
  {
    lng: -41.2660035,
    lat: -21.3553912
  },
  {
    lng: -41.2660009,
    lat: -21.3553974
  },
  {
    lng: -41.2659984,
    lat: -21.3554036
  },
  {
    lng: -41.2659958,
    lat: -21.3554098
  },
  {
    lng: -41.2659933,
    lat: -21.355416
  },
  {
    lng: -41.2659907,
    lat: -21.3554221
  },
  {
    lng: -41.2659882,
    lat: -21.3554283
  },
  {
    lng: -41.2659856,
    lat: -21.3554345
  },
  {
    lng: -41.2659848,
    lat: -21.3554367
  },
  {
    lng: -41.2659839,
    lat: -21.3554389
  },
  {
    lng: -41.265983,
    lat: -21.3554411
  },
  {
    lng: -41.2659821,
    lat: -21.3554432
  },
  {
    lng: -41.2659812,
    lat: -21.3554454
  },
  {
    lng: -41.2659803,
    lat: -21.3554476
  },
  {
    lng: -41.2659794,
    lat: -21.3554498
  },
  {
    lng: -41.2659785,
    lat: -21.3554519
  },
  {
    lng: -41.2659776,
    lat: -21.3554541
  },
  {
    lng: -41.2659767,
    lat: -21.3554563
  },
  {
    lng: -41.2659758,
    lat: -21.3554585
  },
  {
    lng: -41.2659747,
    lat: -21.3554606
  },
  {
    lng: -41.2659737,
    lat: -21.3554627
  },
  {
    lng: -41.2659726,
    lat: -21.3554648
  },
  {
    lng: -41.2659716,
    lat: -21.3554669
  },
  {
    lng: -41.2659705,
    lat: -21.355469
  },
  {
    lng: -41.2659696,
    lat: -21.3554712
  },
  {
    lng: -41.2659685,
    lat: -21.3554733
  },
  {
    lng: -41.2659677,
    lat: -21.3554755
  },
  {
    lng: -41.2659666,
    lat: -21.3554776
  },
  {
    lng: -41.2659657,
    lat: -21.3554798
  },
  {
    lng: -41.2659647,
    lat: -21.3554819
  },
  {
    lng: -41.2659636,
    lat: -21.355484
  },
  {
    lng: -41.2659626,
    lat: -21.3554861
  },
  {
    lng: -41.2659615,
    lat: -21.3554882
  },
  {
    lng: -41.2659604,
    lat: -21.3554903
  },
  {
    lng: -41.2659594,
    lat: -21.3554924
  },
  {
    lng: -41.2659583,
    lat: -21.3554945
  },
  {
    lng: -41.2659572,
    lat: -21.3554966
  },
  {
    lng: -41.2659561,
    lat: -21.3554987
  },
  {
    lng: -41.2659551,
    lat: -21.3555008
  },
  {
    lng: -41.265954,
    lat: -21.3555029
  },
  {
    lng: -41.2659529,
    lat: -21.355505
  },
  {
    lng: -41.2659518,
    lat: -21.3555071
  },
  {
    lng: -41.2659508,
    lat: -21.3555091
  },
  {
    lng: -41.2659497,
    lat: -21.3555112
  },
  {
    lng: -41.2659486,
    lat: -21.3555133
  },
  {
    lng: -41.2659475,
    lat: -21.3555154
  },
  {
    lng: -41.2659464,
    lat: -21.3555175
  },
  {
    lng: -41.2659453,
    lat: -21.3555196
  },
  {
    lng: -41.2659442,
    lat: -21.3555216
  },
  {
    lng: -41.2659429,
    lat: -21.3555237
  },
  {
    lng: -41.2659418,
    lat: -21.3555257
  },
  {
    lng: -41.2659405,
    lat: -21.3555277
  },
  {
    lng: -41.2659394,
    lat: -21.3555298
  },
  {
    lng: -41.2659382,
    lat: -21.3555318
  },
  {
    lng: -41.2659371,
    lat: -21.3555339
  },
  {
    lng: -41.265936,
    lat: -21.355536
  },
  {
    lng: -41.2659349,
    lat: -21.355538
  },
  {
    lng: -41.2659338,
    lat: -21.3555401
  },
  {
    lng: -41.2659326,
    lat: -21.3555422
  },
  {
    lng: -41.2659313,
    lat: -21.3555441
  },
  {
    lng: -41.26593,
    lat: -21.3555461
  },
  {
    lng: -41.2659287,
    lat: -21.355548
  },
  {
    lng: -41.2659274,
    lat: -21.35555
  },
  {
    lng: -41.2659263,
    lat: -21.3555521
  },
  {
    lng: -41.2659252,
    lat: -21.3555542
  },
  {
    lng: -41.2659238,
    lat: -21.3555561
  },
  {
    lng: -41.2659224,
    lat: -21.355558
  },
  {
    lng: -41.2659211,
    lat: -21.3555599
  },
  {
    lng: -41.2659197,
    lat: -21.3555618
  },
  {
    lng: -41.2659184,
    lat: -21.3555638
  },
  {
    lng: -41.265917,
    lat: -21.3555657
  },
  {
    lng: -41.2659157,
    lat: -21.3555676
  },
  {
    lng: -41.2659143,
    lat: -21.3555696
  },
  {
    lng: -41.265913,
    lat: -21.3555715
  },
  {
    lng: -41.2659116,
    lat: -21.3555734
  },
  {
    lng: -41.2659102,
    lat: -21.3555753
  },
  {
    lng: -41.2658732,
    lat: -21.355627
  },
  {
    lng: -41.2658719,
    lat: -21.3556289
  },
  {
    lng: -41.2658705,
    lat: -21.3556308
  },
  {
    lng: -41.2658691,
    lat: -21.3556327
  },
  {
    lng: -41.2658677,
    lat: -21.3556346
  },
  {
    lng: -41.2658663,
    lat: -21.3556365
  },
  {
    lng: -41.265865,
    lat: -21.3556384
  },
  {
    lng: -41.2658635,
    lat: -21.3556403
  },
  {
    lng: -41.2658622,
    lat: -21.3556422
  },
  {
    lng: -41.2658608,
    lat: -21.3556441
  },
  {
    lng: -41.2658594,
    lat: -21.355646
  },
  {
    lng: -41.265858,
    lat: -21.3556479
  },
  {
    lng: -41.2658565,
    lat: -21.3556497
  },
  {
    lng: -41.2658548,
    lat: -21.3556514
  },
  {
    lng: -41.2658534,
    lat: -21.3556533
  },
  {
    lng: -41.2658519,
    lat: -21.3556551
  },
  {
    lng: -41.2658505,
    lat: -21.355657
  },
  {
    lng: -41.2658491,
    lat: -21.3556589
  },
  {
    lng: -41.2658475,
    lat: -21.3556606
  },
  {
    lng: -41.2658459,
    lat: -21.3556623
  },
  {
    lng: -41.2658443,
    lat: -21.355664
  },
  {
    lng: -41.2658426,
    lat: -21.3556657
  },
  {
    lng: -41.2658411,
    lat: -21.3556675
  },
  {
    lng: -41.2658395,
    lat: -21.3556692
  },
  {
    lng: -41.265838,
    lat: -21.3556711
  },
  {
    lng: -41.2658365,
    lat: -21.3556729
  },
  {
    lng: -41.2658349,
    lat: -21.3556746
  },
  {
    lng: -41.2658333,
    lat: -21.3556763
  },
  {
    lng: -41.2658316,
    lat: -21.355678
  },
  {
    lng: -41.26583,
    lat: -21.3556797
  },
  {
    lng: -41.2658283,
    lat: -21.3556814
  },
  {
    lng: -41.2658267,
    lat: -21.355683
  },
  {
    lng: -41.2658251,
    lat: -21.3556847
  },
  {
    lng: -41.2658234,
    lat: -21.3556864
  },
  {
    lng: -41.2658218,
    lat: -21.3556881
  },
  {
    lng: -41.2658201,
    lat: -21.3556898
  },
  {
    lng: -41.2658185,
    lat: -21.3556915
  },
  {
    lng: -41.2658168,
    lat: -21.3556931
  },
  {
    lng: -41.2658152,
    lat: -21.3556948
  },
  {
    lng: -41.2658135,
    lat: -21.3556965
  },
  {
    lng: -41.2658119,
    lat: -21.3556982
  },
  {
    lng: -41.2658102,
    lat: -21.3556999
  },
  {
    lng: -41.2658086,
    lat: -21.3557015
  },
  {
    lng: -41.2658069,
    lat: -21.3557032
  },
  {
    lng: -41.2658052,
    lat: -21.3557049
  },
  {
    lng: -41.2658036,
    lat: -21.3557066
  },
  {
    lng: -41.2658019,
    lat: -21.3557082
  },
  {
    lng: -41.2658003,
    lat: -21.3557099
  },
  {
    lng: -41.2657986,
    lat: -21.3557116
  },
  {
    lng: -41.265797,
    lat: -21.3557133
  },
  {
    lng: -41.2657953,
    lat: -21.3557149
  },
  {
    lng: -41.2657937,
    lat: -21.3557166
  },
  {
    lng: -41.265792,
    lat: -21.3557183
  },
  {
    lng: -41.2657903,
    lat: -21.35572
  },
  {
    lng: -41.2657887,
    lat: -21.3557216
  },
  {
    lng: -41.265787,
    lat: -21.3557233
  },
  {
    lng: -41.2657853,
    lat: -21.3557249
  },
  {
    lng: -41.2657829,
    lat: -21.3557271
  },
  {
    lng: -41.2657804,
    lat: -21.3557292
  },
  {
    lng: -41.2657781,
    lat: -21.3557314
  },
  {
    lng: -41.2657758,
    lat: -21.3557336
  },
  {
    lng: -41.2657735,
    lat: -21.3557359
  },
  {
    lng: -41.2657712,
    lat: -21.3557382
  },
  {
    lng: -41.2657689,
    lat: -21.3557405
  },
  {
    lng: -41.2657667,
    lat: -21.3557427
  },
  {
    lng: -41.2657644,
    lat: -21.355745
  },
  {
    lng: -41.2657621,
    lat: -21.3557473
  },
  {
    lng: -41.2657598,
    lat: -21.3557496
  },
  {
    lng: -41.2657575,
    lat: -21.3557519
  },
  {
    lng: -41.2657553,
    lat: -21.3557541
  },
  {
    lng: -41.265753,
    lat: -21.3557564
  },
  {
    lng: -41.2657507,
    lat: -21.3557587
  },
  {
    lng: -41.2657484,
    lat: -21.355761
  },
  {
    lng: -41.2657462,
    lat: -21.3557633
  },
  {
    lng: -41.2657438,
    lat: -21.3557655
  },
  {
    lng: -41.2657416,
    lat: -21.3557678
  },
  {
    lng: -41.2657393,
    lat: -21.3557701
  },
  {
    lng: -41.265737,
    lat: -21.3557724
  },
  {
    lng: -41.2657348,
    lat: -21.3557747
  },
  {
    lng: -41.2657325,
    lat: -21.355777
  },
  {
    lng: -41.2657302,
    lat: -21.3557793
  },
  {
    lng: -41.265728,
    lat: -21.3557816
  },
  {
    lng: -41.2657257,
    lat: -21.3557839
  },
  {
    lng: -41.2657235,
    lat: -21.3557862
  },
  {
    lng: -41.2657213,
    lat: -21.3557886
  },
  {
    lng: -41.265719,
    lat: -21.3557909
  },
  {
    lng: -41.2657168,
    lat: -21.3557932
  },
  {
    lng: -41.2657145,
    lat: -21.3557955
  },
  {
    lng: -41.2657123,
    lat: -21.3557979
  },
  {
    lng: -41.26571,
    lat: -21.3558002
  },
  {
    lng: -41.2657078,
    lat: -21.3558025
  },
  {
    lng: -41.2657056,
    lat: -21.3558048
  },
  {
    lng: -41.2657033,
    lat: -21.3558071
  },
  {
    lng: -41.2657011,
    lat: -21.3558094
  },
  {
    lng: -41.265699,
    lat: -21.3558119
  },
  {
    lng: -41.2656969,
    lat: -21.3558143
  },
  {
    lng: -41.2656948,
    lat: -21.3558168
  },
  {
    lng: -41.2656926,
    lat: -21.3558192
  },
  {
    lng: -41.2656905,
    lat: -21.3558216
  },
  {
    lng: -41.2656884,
    lat: -21.355824
  },
  {
    lng: -41.2656861,
    lat: -21.3558263
  },
  {
    lng: -41.2656839,
    lat: -21.3558287
  },
  {
    lng: -41.2656818,
    lat: -21.3558311
  },
  {
    lng: -41.2656796,
    lat: -21.3558335
  },
  {
    lng: -41.2656775,
    lat: -21.355836
  },
  {
    lng: -41.2656755,
    lat: -21.3558385
  },
  {
    lng: -41.2656734,
    lat: -21.3558409
  },
  {
    lng: -41.2656713,
    lat: -21.3558434
  },
  {
    lng: -41.2656692,
    lat: -21.3558458
  },
  {
    lng: -41.2656671,
    lat: -21.3558483
  },
  {
    lng: -41.2656651,
    lat: -21.3558508
  },
  {
    lng: -41.265663,
    lat: -21.3558532
  },
  {
    lng: -41.2656609,
    lat: -21.3558557
  },
  {
    lng: -41.2656588,
    lat: -21.3558582
  },
  {
    lng: -41.2656568,
    lat: -21.3558607
  },
  {
    lng: -41.2656547,
    lat: -21.3558631
  },
  {
    lng: -41.2656526,
    lat: -21.3558656
  },
  {
    lng: -41.2656505,
    lat: -21.3558681
  },
  {
    lng: -41.2656485,
    lat: -21.3558705
  },
  {
    lng: -41.2656464,
    lat: -21.355873
  },
  {
    lng: -41.2656443,
    lat: -21.3558755
  },
  {
    lng: -41.2656422,
    lat: -21.3558779
  },
  {
    lng: -41.2656402,
    lat: -21.3558804
  },
  {
    lng: -41.2656381,
    lat: -21.3558829
  },
  {
    lng: -41.265636,
    lat: -21.3558854
  },
  {
    lng: -41.2656339,
    lat: -21.3558878
  },
  {
    lng: -41.2656319,
    lat: -21.3558903
  },
  {
    lng: -41.2656298,
    lat: -21.3558928
  },
  {
    lng: -41.2656278,
    lat: -21.3558953
  },
  {
    lng: -41.2656257,
    lat: -21.3558978
  },
  {
    lng: -41.2656237,
    lat: -21.3559003
  },
  {
    lng: -41.2656218,
    lat: -21.3559029
  },
  {
    lng: -41.2656199,
    lat: -21.3559055
  },
  {
    lng: -41.2656178,
    lat: -21.355908
  },
  {
    lng: -41.2656159,
    lat: -21.3559106
  },
  {
    lng: -41.2656138,
    lat: -21.355913
  },
  {
    lng: -41.2656118,
    lat: -21.3559155
  },
  {
    lng: -41.2656098,
    lat: -21.355918
  },
  {
    lng: -41.2656077,
    lat: -21.3559205
  },
  {
    lng: -41.2656058,
    lat: -21.3559232
  },
  {
    lng: -41.265604,
    lat: -21.3559258
  },
  {
    lng: -41.2656021,
    lat: -21.3559284
  },
  {
    lng: -41.2656002,
    lat: -21.355931
  },
  {
    lng: -41.2655983,
    lat: -21.3559336
  },
  {
    lng: -41.2655965,
    lat: -21.3559363
  },
  {
    lng: -41.2655944,
    lat: -21.3559388
  },
  {
    lng: -41.2655924,
    lat: -21.3559413
  },
  {
    lng: -41.2655905,
    lat: -21.3559439
  },
  {
    lng: -41.2655887,
    lat: -21.3559466
  },
  {
    lng: -41.2655868,
    lat: -21.3559492
  },
  {
    lng: -41.265585,
    lat: -21.3559518
  },
  {
    lng: -41.2655831,
    lat: -21.3559545
  },
  {
    lng: -41.2655813,
    lat: -21.3559571
  },
  {
    lng: -41.2655795,
    lat: -21.3559598
  },
  {
    lng: -41.2655776,
    lat: -21.3559625
  },
  {
    lng: -41.2655758,
    lat: -21.3559651
  },
  {
    lng: -41.265574,
    lat: -21.3559678
  },
  {
    lng: -41.2655721,
    lat: -21.3559704
  },
  {
    lng: -41.2655703,
    lat: -21.3559731
  },
  {
    lng: -41.2655685,
    lat: -21.3559757
  },
  {
    lng: -41.2655666,
    lat: -21.3559784
  },
  {
    lng: -41.2655648,
    lat: -21.355981
  },
  {
    lng: -41.265563,
    lat: -21.3559837
  },
  {
    lng: -41.2655611,
    lat: -21.3559864
  },
  {
    lng: -41.2655593,
    lat: -21.355989
  },
  {
    lng: -41.2655575,
    lat: -21.3559917
  },
  {
    lng: -41.2655557,
    lat: -21.3559943
  },
  {
    lng: -41.2655538,
    lat: -21.355997
  },
  {
    lng: -41.265552,
    lat: -21.3559996
  },
  {
    lng: -41.2655502,
    lat: -21.3560023
  },
  {
    lng: -41.2655484,
    lat: -21.356005
  },
  {
    lng: -41.2655465,
    lat: -21.3560076
  },
  {
    lng: -41.2655447,
    lat: -21.3560103
  },
  {
    lng: -41.2655429,
    lat: -21.3560129
  },
  {
    lng: -41.2655411,
    lat: -21.3560156
  },
  {
    lng: -41.2655393,
    lat: -21.3560183
  },
  {
    lng: -41.2655375,
    lat: -21.356021
  },
  {
    lng: -41.2655358,
    lat: -21.3560238
  },
  {
    lng: -41.2655343,
    lat: -21.3560266
  },
  {
    lng: -41.2655324,
    lat: -21.3560293
  },
  {
    lng: -41.2655307,
    lat: -21.356032
  },
  {
    lng: -41.2655289,
    lat: -21.3560347
  },
  {
    lng: -41.2655271,
    lat: -21.3560373
  },
  {
    lng: -41.2655254,
    lat: -21.35604
  },
  {
    lng: -41.2655236,
    lat: -21.3560427
  },
  {
    lng: -41.265522,
    lat: -21.3560455
  },
  {
    lng: -41.2655204,
    lat: -21.3560483
  },
  {
    lng: -41.2655188,
    lat: -21.3560511
  },
  {
    lng: -41.2655172,
    lat: -21.3560539
  },
  {
    lng: -41.2655155,
    lat: -21.3560566
  },
  {
    lng: -41.2655137,
    lat: -21.3560593
  },
  {
    lng: -41.2655121,
    lat: -21.3560621
  },
  {
    lng: -41.2655103,
    lat: -21.3560649
  },
  {
    lng: -41.2655087,
    lat: -21.3560677
  },
  {
    lng: -41.2655071,
    lat: -21.3560704
  },
  {
    lng: -41.2655055,
    lat: -21.3560732
  },
  {
    lng: -41.265504,
    lat: -21.3560761
  },
  {
    lng: -41.2655024,
    lat: -21.3560789
  },
  {
    lng: -41.2655008,
    lat: -21.3560817
  },
  {
    lng: -41.2654993,
    lat: -21.3560845
  },
  {
    lng: -41.2654977,
    lat: -21.3560873
  },
  {
    lng: -41.2654961,
    lat: -21.3560902
  },
  {
    lng: -41.2654946,
    lat: -21.356093
  },
  {
    lng: -41.265493,
    lat: -21.3560958
  },
  {
    lng: -41.2654914,
    lat: -21.3560986
  },
  {
    lng: -41.2654899,
    lat: -21.3561014
  },
  {
    lng: -41.2654883,
    lat: -21.3561043
  },
  {
    lng: -41.2654867,
    lat: -21.3561071
  },
  {
    lng: -41.2654852,
    lat: -21.3561099
  },
  {
    lng: -41.2654836,
    lat: -21.3561127
  },
  {
    lng: -41.2654821,
    lat: -21.3561156
  },
  {
    lng: -41.2654805,
    lat: -21.3561184
  },
  {
    lng: -41.2654789,
    lat: -21.3561212
  },
  {
    lng: -41.2654774,
    lat: -21.356124
  },
  {
    lng: -41.2654758,
    lat: -21.3561269
  },
  {
    lng: -41.2654743,
    lat: -21.3561297
  },
  {
    lng: -41.2654727,
    lat: -21.3561325
  },
  {
    lng: -41.2654712,
    lat: -21.3561353
  },
  {
    lng: -41.2654696,
    lat: -21.3561382
  },
  {
    lng: -41.265468,
    lat: -21.356141
  },
  {
    lng: -41.2654665,
    lat: -21.3561438
  },
  {
    lng: -41.265465,
    lat: -21.3561467
  },
  {
    lng: -41.2654634,
    lat: -21.3561495
  },
  {
    lng: -41.2654619,
    lat: -21.3561523
  },
  {
    lng: -41.2654606,
    lat: -21.3561553
  },
  {
    lng: -41.265459,
    lat: -21.3561581
  },
  {
    lng: -41.2654577,
    lat: -21.3561611
  },
  {
    lng: -41.2654563,
    lat: -21.3561639
  },
  {
    lng: -41.2654547,
    lat: -21.3561668
  },
  {
    lng: -41.2654532,
    lat: -21.3561696
  },
  {
    lng: -41.2654517,
    lat: -21.3561725
  },
  {
    lng: -41.2654502,
    lat: -21.3561753
  },
  {
    lng: -41.2654489,
    lat: -21.3561783
  },
  {
    lng: -41.2654476,
    lat: -21.3561812
  },
  {
    lng: -41.2654463,
    lat: -21.3561842
  },
  {
    lng: -41.2654449,
    lat: -21.3561871
  },
  {
    lng: -41.2654434,
    lat: -21.35619
  },
  {
    lng: -41.265442,
    lat: -21.3561928
  },
  {
    lng: -41.2654407,
    lat: -21.3561958
  },
  {
    lng: -41.2654394,
    lat: -21.3561987
  },
  {
    lng: -41.2654382,
    lat: -21.3562017
  },
  {
    lng: -41.2654369,
    lat: -21.3562047
  },
  {
    lng: -41.2654357,
    lat: -21.3562077
  },
  {
    lng: -41.2654344,
    lat: -21.3562106
  },
  {
    lng: -41.2654332,
    lat: -21.3562136
  },
  {
    lng: -41.2654319,
    lat: -21.3562166
  },
  {
    lng: -41.2653947,
    lat: -21.3563059
  },
  {
    lng: -41.2653935,
    lat: -21.3563089
  },
  {
    lng: -41.2653922,
    lat: -21.3563119
  },
  {
    lng: -41.265391,
    lat: -21.3563148
  },
  {
    lng: -41.2653898,
    lat: -21.3563178
  },
  {
    lng: -41.2653885,
    lat: -21.3563208
  },
  {
    lng: -41.2653873,
    lat: -21.3563238
  },
  {
    lng: -41.2653861,
    lat: -21.3563268
  },
  {
    lng: -41.2653849,
    lat: -21.3563298
  },
  {
    lng: -41.2653839,
    lat: -21.3563328
  },
  {
    lng: -41.2653829,
    lat: -21.3563359
  },
  {
    lng: -41.2653818,
    lat: -21.3563389
  },
  {
    lng: -41.2653806,
    lat: -21.3563419
  },
  {
    lng: -41.2653794,
    lat: -21.3563449
  },
  {
    lng: -41.2653783,
    lat: -21.3563479
  },
  {
    lng: -41.2653773,
    lat: -21.356351
  },
  {
    lng: -41.2653763,
    lat: -21.3563541
  },
  {
    lng: -41.2653754,
    lat: -21.3563572
  },
  {
    lng: -41.2653744,
    lat: -21.3563602
  },
  {
    lng: -41.2653734,
    lat: -21.3563633
  },
  {
    lng: -41.2653724,
    lat: -21.3563664
  },
  {
    lng: -41.2653713,
    lat: -21.3563694
  },
  {
    lng: -41.2653703,
    lat: -21.3563725
  },
  {
    lng: -41.2653692,
    lat: -21.3563755
  },
  {
    lng: -41.2653682,
    lat: -21.3563786
  },
  {
    lng: -41.2653673,
    lat: -21.3563817
  },
  {
    lng: -41.2653663,
    lat: -21.3563847
  },
  {
    lng: -41.2653654,
    lat: -21.3563878
  },
  {
    lng: -41.2653645,
    lat: -21.3563909
  },
  {
    lng: -41.2653635,
    lat: -21.356394
  },
  {
    lng: -41.2653626,
    lat: -21.3563971
  },
  {
    lng: -41.2653617,
    lat: -21.3564002
  },
  {
    lng: -41.2653608,
    lat: -21.3564033
  },
  {
    lng: -41.2653598,
    lat: -21.3564064
  },
  {
    lng: -41.2653589,
    lat: -21.3564095
  },
  {
    lng: -41.265358,
    lat: -21.3564126
  },
  {
    lng: -41.2653571,
    lat: -21.3564157
  },
  {
    lng: -41.2653562,
    lat: -21.3564187
  },
  {
    lng: -41.2653553,
    lat: -21.3564218
  },
  {
    lng: -41.2653543,
    lat: -21.3564249
  },
  {
    lng: -41.2653534,
    lat: -21.356428
  },
  {
    lng: -41.2653525,
    lat: -21.3564311
  },
  {
    lng: -41.2653516,
    lat: -21.3564342
  },
  {
    lng: -41.2653507,
    lat: -21.3564373
  },
  {
    lng: -41.2653498,
    lat: -21.3564404
  },
  {
    lng: -41.2653489,
    lat: -21.3564435
  },
  {
    lng: -41.265348,
    lat: -21.3564466
  },
  {
    lng: -41.2653471,
    lat: -21.3564497
  },
  {
    lng: -41.2653462,
    lat: -21.3564528
  },
  {
    lng: -41.2653455,
    lat: -21.356456
  },
  {
    lng: -41.2653447,
    lat: -21.3564591
  },
  {
    lng: -41.265344,
    lat: -21.3564622
  },
  {
    lng: -41.2653431,
    lat: -21.3564653
  },
  {
    lng: -41.2653423,
    lat: -21.3564685
  },
  {
    lng: -41.2653414,
    lat: -21.3564716
  },
  {
    lng: -41.2653405,
    lat: -21.3564747
  },
  {
    lng: -41.2653397,
    lat: -21.3564778
  },
  {
    lng: -41.2653383,
    lat: -21.3564824
  },
  {
    lng: -41.265337,
    lat: -21.356487
  },
  {
    lng: -41.2653357,
    lat: -21.3564917
  },
  {
    lng: -41.2653343,
    lat: -21.3564963
  },
  {
    lng: -41.265333,
    lat: -21.3565009
  },
  {
    lng: -41.2653317,
    lat: -21.3565056
  },
  {
    lng: -41.2653303,
    lat: -21.3565102
  },
  {
    lng: -41.265329,
    lat: -21.3565148
  },
  {
    lng: -41.2653277,
    lat: -21.3565195
  },
  {
    lng: -41.2653263,
    lat: -21.3565241
  },
  {
    lng: -41.2653252,
    lat: -21.3565288
  },
  {
    lng: -41.2653239,
    lat: -21.3565334
  },
  {
    lng: -41.2653225,
    lat: -21.3565381
  },
  {
    lng: -41.2653213,
    lat: -21.3565427
  },
  {
    lng: -41.26532,
    lat: -21.3565474
  },
  {
    lng: -41.2653186,
    lat: -21.356552
  },
  {
    lng: -41.2653172,
    lat: -21.3565566
  },
  {
    lng: -41.2653159,
    lat: -21.3565612
  },
  {
    lng: -41.2653145,
    lat: -21.3565659
  },
  {
    lng: -41.2653131,
    lat: -21.3565705
  },
  {
    lng: -41.2653117,
    lat: -21.3565751
  },
  {
    lng: -41.2653104,
    lat: -21.3565797
  },
  {
    lng: -41.265309,
    lat: -21.3565844
  },
  {
    lng: -41.2653076,
    lat: -21.356589
  },
  {
    lng: -41.2653061,
    lat: -21.3565936
  },
  {
    lng: -41.2653047,
    lat: -21.3565982
  },
  {
    lng: -41.2653033,
    lat: -21.3566028
  },
  {
    lng: -41.2653016,
    lat: -21.3566073
  },
  {
    lng: -41.2653003,
    lat: -21.356612
  },
  {
    lng: -41.2652989,
    lat: -21.3566166
  },
  {
    lng: -41.2652974,
    lat: -21.3566212
  },
  {
    lng: -41.265296,
    lat: -21.3566258
  },
  {
    lng: -41.2652946,
    lat: -21.3566304
  },
  {
    lng: -41.2652932,
    lat: -21.356635
  },
  {
    lng: -41.2652918,
    lat: -21.3566396
  },
  {
    lng: -41.2652904,
    lat: -21.3566442
  },
  {
    lng: -41.265289,
    lat: -21.3566488
  },
  {
    lng: -41.2652874,
    lat: -21.3566534
  },
  {
    lng: -41.2652858,
    lat: -21.3566579
  },
  {
    lng: -41.2652842,
    lat: -21.3566625
  },
  {
    lng: -41.2652826,
    lat: -21.356667
  },
  {
    lng: -41.2652811,
    lat: -21.3566716
  },
  {
    lng: -41.2652797,
    lat: -21.3566762
  },
  {
    lng: -41.2652782,
    lat: -21.3566808
  },
  {
    lng: -41.2652766,
    lat: -21.3566854
  },
  {
    lng: -41.265275,
    lat: -21.3566899
  },
  {
    lng: -41.2652734,
    lat: -21.3566945
  },
  {
    lng: -41.2652718,
    lat: -21.356699
  },
  {
    lng: -41.2652701,
    lat: -21.3567036
  },
  {
    lng: -41.2652685,
    lat: -21.3567081
  },
  {
    lng: -41.2652668,
    lat: -21.3567126
  },
  {
    lng: -41.2652652,
    lat: -21.3567172
  },
  {
    lng: -41.2652636,
    lat: -21.3567217
  },
  {
    lng: -41.2652619,
    lat: -21.3567262
  },
  {
    lng: -41.2652603,
    lat: -21.3567308
  },
  {
    lng: -41.2652587,
    lat: -21.3567353
  },
  {
    lng: -41.2652571,
    lat: -21.3567399
  },
  {
    lng: -41.2652554,
    lat: -21.3567444
  },
  {
    lng: -41.2652538,
    lat: -21.3567489
  },
  {
    lng: -41.2652522,
    lat: -21.3567535
  },
  {
    lng: -41.2652505,
    lat: -21.356758
  },
  {
    lng: -41.2652489,
    lat: -21.3567625
  },
  {
    lng: -41.2652472,
    lat: -21.3567671
  },
  {
    lng: -41.2652455,
    lat: -21.3567716
  },
  {
    lng: -41.2652439,
    lat: -21.3567761
  },
  {
    lng: -41.2652422,
    lat: -21.3567807
  },
  {
    lng: -41.2652406,
    lat: -21.3567852
  },
  {
    lng: -41.2652389,
    lat: -21.3567897
  },
  {
    lng: -41.2652372,
    lat: -21.3567942
  },
  {
    lng: -41.2652356,
    lat: -21.3567988
  },
  {
    lng: -41.2652339,
    lat: -21.3568033
  },
  {
    lng: -41.2652323,
    lat: -21.3568078
  },
  {
    lng: -41.2652306,
    lat: -21.3568124
  },
  {
    lng: -41.265229,
    lat: -21.3568169
  },
  {
    lng: -41.2652273,
    lat: -21.3568214
  },
  {
    lng: -41.2652257,
    lat: -21.356826
  },
  {
    lng: -41.265224,
    lat: -21.3568305
  },
  {
    lng: -41.2652223,
    lat: -21.356835
  },
  {
    lng: -41.2652206,
    lat: -21.3568395
  },
  {
    lng: -41.2652188,
    lat: -21.356844
  },
  {
    lng: -41.2652169,
    lat: -21.3568484
  },
  {
    lng: -41.2652151,
    lat: -21.3568529
  },
  {
    lng: -41.2652134,
    lat: -21.3568574
  },
  {
    lng: -41.2652117,
    lat: -21.3568619
  },
  {
    lng: -41.26521,
    lat: -21.3568664
  },
  {
    lng: -41.2652083,
    lat: -21.356871
  },
  {
    lng: -41.2652065,
    lat: -21.3568754
  },
  {
    lng: -41.2652046,
    lat: -21.3568798
  },
  {
    lng: -41.2652027,
    lat: -21.3568843
  },
  {
    lng: -41.2652008,
    lat: -21.3568887
  },
  {
    lng: -41.2651989,
    lat: -21.3568931
  },
  {
    lng: -41.2651971,
    lat: -21.3568976
  },
  {
    lng: -41.2651952,
    lat: -21.356902
  },
  {
    lng: -41.2651935,
    lat: -21.3569066
  },
  {
    lng: -41.2651917,
    lat: -21.3569111
  },
  {
    lng: -41.2651898,
    lat: -21.3569155
  },
  {
    lng: -41.2651879,
    lat: -21.3569199
  },
  {
    lng: -41.265186,
    lat: -21.3569244
  },
  {
    lng: -41.2651841,
    lat: -21.3569288
  },
  {
    lng: -41.2651822,
    lat: -21.3569332
  },
  {
    lng: -41.2651802,
    lat: -21.3569376
  },
  {
    lng: -41.2651783,
    lat: -21.356942
  },
  {
    lng: -41.2651764,
    lat: -21.3569465
  },
  {
    lng: -41.2651744,
    lat: -21.3569509
  },
  {
    lng: -41.2651725,
    lat: -21.3569553
  },
  {
    lng: -41.2651706,
    lat: -21.3569597
  },
  {
    lng: -41.2651687,
    lat: -21.3569641
  },
  {
    lng: -41.2651667,
    lat: -21.3569686
  },
  {
    lng: -41.2651648,
    lat: -21.356973
  },
  {
    lng: -41.2651629,
    lat: -21.3569774
  },
  {
    lng: -41.2651609,
    lat: -21.3569818
  },
  {
    lng: -41.265159,
    lat: -21.3569862
  },
  {
    lng: -41.2651571,
    lat: -21.3569906
  },
  {
    lng: -41.2651551,
    lat: -21.3569951
  },
  {
    lng: -41.2651532,
    lat: -21.3569995
  },
  {
    lng: -41.2651512,
    lat: -21.3570039
  },
  {
    lng: -41.2651493,
    lat: -21.3570083
  },
  {
    lng: -41.2651473,
    lat: -21.3570127
  },
  {
    lng: -41.2651453,
    lat: -21.3570171
  },
  {
    lng: -41.2651432,
    lat: -21.3570215
  },
  {
    lng: -41.265141,
    lat: -21.3570258
  },
  {
    lng: -41.2651391,
    lat: -21.3570302
  },
  {
    lng: -41.265137,
    lat: -21.3570345
  },
  {
    lng: -41.2651351,
    lat: -21.3570389
  },
  {
    lng: -41.2651331,
    lat: -21.3570433
  },
  {
    lng: -41.2651311,
    lat: -21.3570477
  },
  {
    lng: -41.2651292,
    lat: -21.3570521
  },
  {
    lng: -41.2651272,
    lat: -21.3570565
  },
  {
    lng: -41.265125,
    lat: -21.3570608
  },
  {
    lng: -41.2651228,
    lat: -21.3570651
  },
  {
    lng: -41.2651206,
    lat: -21.3570694
  },
  {
    lng: -41.2651186,
    lat: -21.3570738
  },
  {
    lng: -41.2651164,
    lat: -21.3570781
  },
  {
    lng: -41.2651141,
    lat: -21.3570823
  },
  {
    lng: -41.2651119,
    lat: -21.3570866
  },
  {
    lng: -41.2651079,
    lat: -21.357094
  },
  {
    lng: -41.2651062,
    lat: -21.3570972
  },
  {
    lng: -41.2651045,
    lat: -21.3571004
  },
  {
    lng: -41.2651028,
    lat: -21.3571035
  },
  {
    lng: -41.2651009,
    lat: -21.3571066
  },
  {
    lng: -41.2650989,
    lat: -21.3571096
  },
  {
    lng: -41.2650971,
    lat: -21.3571127
  },
  {
    lng: -41.2650954,
    lat: -21.3571159
  },
  {
    lng: -41.2650936,
    lat: -21.357119
  },
  {
    lng: -41.2650919,
    lat: -21.3571222
  },
  {
    lng: -41.2650901,
    lat: -21.3571253
  },
  {
    lng: -41.2650884,
    lat: -21.3571285
  },
  {
    lng: -41.2650866,
    lat: -21.3571316
  },
  {
    lng: -41.2650849,
    lat: -21.3571348
  },
  {
    lng: -41.2650831,
    lat: -21.3571379
  },
  {
    lng: -41.2650814,
    lat: -21.3571411
  },
  {
    lng: -41.2650796,
    lat: -21.3571442
  },
  {
    lng: -41.2650779,
    lat: -21.3571474
  },
  {
    lng: -41.2650759,
    lat: -21.3571504
  },
  {
    lng: -41.2650742,
    lat: -21.3571536
  },
  {
    lng: -41.2650723,
    lat: -21.3571566
  },
  {
    lng: -41.2650706,
    lat: -21.3571598
  },
  {
    lng: -41.2650688,
    lat: -21.357163
  },
  {
    lng: -41.2650671,
    lat: -21.3571661
  },
  {
    lng: -41.2650654,
    lat: -21.3571693
  },
  {
    lng: -41.2650637,
    lat: -21.3571724
  },
  {
    lng: -41.2650619,
    lat: -21.3571756
  },
  {
    lng: -41.2650602,
    lat: -21.3571788
  },
  {
    lng: -41.2650585,
    lat: -21.3571819
  },
  {
    lng: -41.2650568,
    lat: -21.3571851
  },
  {
    lng: -41.2650551,
    lat: -21.3571883
  },
  {
    lng: -41.2650534,
    lat: -21.3571915
  },
  {
    lng: -41.2650517,
    lat: -21.3571946
  },
  {
    lng: -41.26505,
    lat: -21.3571978
  },
  {
    lng: -41.2650483,
    lat: -21.357201
  },
  {
    lng: -41.2650466,
    lat: -21.3572042
  },
  {
    lng: -41.2650449,
    lat: -21.3572074
  },
  {
    lng: -41.2650432,
    lat: -21.3572105
  },
  {
    lng: -41.2650415,
    lat: -21.3572137
  },
  {
    lng: -41.2650399,
    lat: -21.3572169
  },
  {
    lng: -41.2650383,
    lat: -21.3572202
  },
  {
    lng: -41.2650366,
    lat: -21.3572234
  },
  {
    lng: -41.2650351,
    lat: -21.3572267
  },
  {
    lng: -41.2650335,
    lat: -21.3572298
  },
  {
    lng: -41.2650319,
    lat: -21.3572331
  },
  {
    lng: -41.2650302,
    lat: -21.3572363
  },
  {
    lng: -41.2650285,
    lat: -21.3572394
  },
  {
    lng: -41.2650268,
    lat: -21.3572426
  },
  {
    lng: -41.2650252,
    lat: -21.3572458
  },
  {
    lng: -41.2650235,
    lat: -21.357249
  },
  {
    lng: -41.265022,
    lat: -21.3572523
  },
  {
    lng: -41.2650205,
    lat: -21.3572556
  },
  {
    lng: -41.265019,
    lat: -21.3572588
  },
  {
    lng: -41.2650176,
    lat: -21.3572621
  },
  {
    lng: -41.265016,
    lat: -21.3572654
  },
  {
    lng: -41.2650143,
    lat: -21.3572686
  },
  {
    lng: -41.2650127,
    lat: -21.3572718
  },
  {
    lng: -41.2650112,
    lat: -21.3572751
  },
  {
    lng: -41.2650097,
    lat: -21.3572784
  },
  {
    lng: -41.2650082,
    lat: -21.3572816
  },
  {
    lng: -41.2650068,
    lat: -21.3572849
  },
  {
    lng: -41.2650053,
    lat: -21.3572882
  },
  {
    lng: -41.2650039,
    lat: -21.3572915
  },
  {
    lng: -41.2650024,
    lat: -21.3572948
  },
  {
    lng: -41.265001,
    lat: -21.3572981
  },
  {
    lng: -41.2649996,
    lat: -21.3573014
  },
  {
    lng: -41.2649981,
    lat: -21.3573047
  },
  {
    lng: -41.2649967,
    lat: -21.3573081
  },
  {
    lng: -41.2649953,
    lat: -21.3573114
  },
  {
    lng: -41.2649938,
    lat: -21.3573147
  },
  {
    lng: -41.2649924,
    lat: -21.357318
  },
  {
    lng: -41.264991,
    lat: -21.3573213
  },
  {
    lng: -41.2649895,
    lat: -21.3573246
  },
  {
    lng: -41.2649881,
    lat: -21.3573279
  },
  {
    lng: -41.2649866,
    lat: -21.3573312
  },
  {
    lng: -41.2649852,
    lat: -21.3573345
  },
  {
    lng: -41.2649838,
    lat: -21.3573378
  },
  {
    lng: -41.2649823,
    lat: -21.3573411
  },
  {
    lng: -41.2649809,
    lat: -21.3573444
  },
  {
    lng: -41.2649795,
    lat: -21.3573477
  },
  {
    lng: -41.264978,
    lat: -21.357351
  },
  {
    lng: -41.2649765,
    lat: -21.3573543
  },
  {
    lng: -41.2649751,
    lat: -21.3573576
  },
  {
    lng: -41.2649737,
    lat: -21.3573609
  },
  {
    lng: -41.2649722,
    lat: -21.3573642
  },
  {
    lng: -41.2649708,
    lat: -21.3573675
  },
  {
    lng: -41.2649694,
    lat: -21.3573708
  },
  {
    lng: -41.2649679,
    lat: -21.3573741
  },
  {
    lng: -41.2649665,
    lat: -21.3573774
  },
  {
    lng: -41.2649651,
    lat: -21.3573807
  },
  {
    lng: -41.2649637,
    lat: -21.3573841
  },
  {
    lng: -41.2649623,
    lat: -21.3573874
  },
  {
    lng: -41.2649611,
    lat: -21.3573908
  },
  {
    lng: -41.2649599,
    lat: -21.3573942
  },
  {
    lng: -41.2649586,
    lat: -21.3573975
  },
  {
    lng: -41.2649572,
    lat: -21.3574009
  },
  {
    lng: -41.2649558,
    lat: -21.3574042
  },
  {
    lng: -41.2649544,
    lat: -21.3574075
  },
  {
    lng: -41.264953,
    lat: -21.3574108
  },
  {
    lng: -41.2649518,
    lat: -21.3574142
  },
  {
    lng: -41.2649506,
    lat: -21.3574176
  },
  {
    lng: -41.2649494,
    lat: -21.357421
  },
  {
    lng: -41.2649482,
    lat: -21.3574244
  },
  {
    lng: -41.2649471,
    lat: -21.3574278
  },
  {
    lng: -41.2649458,
    lat: -21.3574312
  },
  {
    lng: -41.2649446,
    lat: -21.3574346
  },
  {
    lng: -41.2649432,
    lat: -21.3574379
  },
  {
    lng: -41.264942,
    lat: -21.3574413
  },
  {
    lng: -41.2649407,
    lat: -21.3574447
  },
  {
    lng: -41.2649395,
    lat: -21.3574481
  },
  {
    lng: -41.2649383,
    lat: -21.3574515
  },
  {
    lng: -41.2649371,
    lat: -21.3574549
  },
  {
    lng: -41.2649359,
    lat: -21.3574583
  },
  {
    lng: -41.2649348,
    lat: -21.3574617
  },
  {
    lng: -41.2649336,
    lat: -21.3574651
  },
  {
    lng: -41.2649324,
    lat: -21.3574685
  },
  {
    lng: -41.2649313,
    lat: -21.3574719
  },
  {
    lng: -41.2649301,
    lat: -21.3574753
  },
  {
    lng: -41.264929,
    lat: -21.3574787
  },
  {
    lng: -41.2649278,
    lat: -21.3574822
  },
  {
    lng: -41.2649267,
    lat: -21.3574856
  },
  {
    lng: -41.2649255,
    lat: -21.357489
  },
  {
    lng: -41.2649244,
    lat: -21.3574924
  },
  {
    lng: -41.2649232,
    lat: -21.3574958
  },
  {
    lng: -41.2649221,
    lat: -21.3574992
  },
  {
    lng: -41.2649209,
    lat: -21.3575027
  },
  {
    lng: -41.2649198,
    lat: -21.3575061
  },
  {
    lng: -41.2649187,
    lat: -21.3575095
  },
  {
    lng: -41.2649176,
    lat: -21.3575129
  },
  {
    lng: -41.2649164,
    lat: -21.3575163
  },
  {
    lng: -41.2649155,
    lat: -21.3575198
  },
  {
    lng: -41.2649144,
    lat: -21.3575232
  },
  {
    lng: -41.2649135,
    lat: -21.3575267
  },
  {
    lng: -41.2649123,
    lat: -21.3575302
  },
  {
    lng: -41.2649113,
    lat: -21.3575336
  },
  {
    lng: -41.2649102,
    lat: -21.357537
  },
  {
    lng: -41.2649091,
    lat: -21.3575405
  },
  {
    lng: -41.2649079,
    lat: -21.3575439
  },
  {
    lng: -41.2649068,
    lat: -21.3575473
  },
  {
    lng: -41.2649057,
    lat: -21.3575507
  },
  {
    lng: -41.2649048,
    lat: -21.3575542
  },
  {
    lng: -41.2649038,
    lat: -21.3575577
  },
  {
    lng: -41.2649029,
    lat: -21.3575612
  },
  {
    lng: -41.264902,
    lat: -21.3575646
  },
  {
    lng: -41.264901,
    lat: -21.3575681
  },
  {
    lng: -41.2649001,
    lat: -21.3575716
  },
  {
    lng: -41.2648991,
    lat: -21.3575751
  },
  {
    lng: -41.2648982,
    lat: -21.3575785
  },
  {
    lng: -41.2648973,
    lat: -21.357582
  },
  {
    lng: -41.2648961,
    lat: -21.3575855
  },
  {
    lng: -41.2648952,
    lat: -21.3575889
  },
  {
    lng: -41.2648943,
    lat: -21.3575924
  },
  {
    lng: -41.2648932,
    lat: -21.3575959
  },
  {
    lng: -41.2648923,
    lat: -21.3575993
  },
  {
    lng: -41.2648913,
    lat: -21.3576028
  },
  {
    lng: -41.2648904,
    lat: -21.3576063
  },
  {
    lng: -41.2648895,
    lat: -21.3576098
  },
  {
    lng: -41.2648886,
    lat: -21.3576133
  },
  {
    lng: -41.2648877,
    lat: -21.3576168
  },
  {
    lng: -41.2648868,
    lat: -21.3576203
  },
  {
    lng: -41.2648859,
    lat: -21.3576238
  },
  {
    lng: -41.264885,
    lat: -21.3576272
  },
  {
    lng: -41.2648842,
    lat: -21.3576307
  },
  {
    lng: -41.2648834,
    lat: -21.3576343
  },
  {
    lng: -41.2648825,
    lat: -21.3576378
  },
  {
    lng: -41.2648817,
    lat: -21.3576413
  },
  {
    lng: -41.264881,
    lat: -21.3576448
  },
  {
    lng: -41.2648801,
    lat: -21.3576483
  },
  {
    lng: -41.2648792,
    lat: -21.3576518
  },
  {
    lng: -41.2648785,
    lat: -21.3576553
  },
  {
    lng: -41.2648776,
    lat: -21.3576588
  },
  {
    lng: -41.2648767,
    lat: -21.3576623
  },
  {
    lng: -41.2648758,
    lat: -21.3576658
  },
  {
    lng: -41.264875,
    lat: -21.3576693
  },
  {
    lng: -41.2648741,
    lat: -21.3576728
  },
  {
    lng: -41.2648732,
    lat: -21.3576763
  },
  {
    lng: -41.2648725,
    lat: -21.3576792
  },
  {
    lng: -41.2648717,
    lat: -21.357682
  },
  {
    lng: -41.264871,
    lat: -21.3576849
  },
  {
    lng: -41.2648702,
    lat: -21.3576878
  },
  {
    lng: -41.2648695,
    lat: -21.3576906
  },
  {
    lng: -41.2648687,
    lat: -21.3576935
  },
  {
    lng: -41.264868,
    lat: -21.3576964
  },
  {
    lng: -41.2648672,
    lat: -21.3576993
  },
  {
    lng: -41.2648665,
    lat: -21.3577021
  },
  {
    lng: -41.2648658,
    lat: -21.357705
  },
  {
    lng: -41.264865,
    lat: -21.3577079
  },
  {
    lng: -41.2648643,
    lat: -21.3577108
  },
  {
    lng: -41.2648636,
    lat: -21.3577136
  },
  {
    lng: -41.2648628,
    lat: -21.3577165
  },
  {
    lng: -41.2648621,
    lat: -21.3577194
  },
  {
    lng: -41.2648615,
    lat: -21.3577223
  },
  {
    lng: -41.2648609,
    lat: -21.3577252
  },
  {
    lng: -41.2648604,
    lat: -21.3577281
  },
  {
    lng: -41.2648598,
    lat: -21.357731
  },
  {
    lng: -41.2648591,
    lat: -21.3577339
  },
  {
    lng: -41.2648583,
    lat: -21.3577368
  },
  {
    lng: -41.2648577,
    lat: -21.3577397
  },
  {
    lng: -41.264857,
    lat: -21.3577426
  },
  {
    lng: -41.2648564,
    lat: -21.3577455
  },
  {
    lng: -41.2648558,
    lat: -21.3577484
  },
  {
    lng: -41.2648552,
    lat: -21.3577513
  },
  {
    lng: -41.2648547,
    lat: -21.3577542
  },
  {
    lng: -41.2648542,
    lat: -21.3577571
  },
  {
    lng: -41.2648536,
    lat: -21.35776
  },
  {
    lng: -41.2648531,
    lat: -21.357763
  },
  {
    lng: -41.2648525,
    lat: -21.3577659
  },
  {
    lng: -41.264852,
    lat: -21.3577688
  },
  {
    lng: -41.2648514,
    lat: -21.3577717
  },
  {
    lng: -41.2648509,
    lat: -21.3577746
  },
  {
    lng: -41.2648504,
    lat: -21.3577775
  },
  {
    lng: -41.2648498,
    lat: -21.3577805
  },
  {
    lng: -41.2648493,
    lat: -21.3577834
  },
  {
    lng: -41.2648487,
    lat: -21.3577863
  },
  {
    lng: -41.2648482,
    lat: -21.3577892
  },
  {
    lng: -41.2648477,
    lat: -21.3577921
  },
  {
    lng: -41.2648471,
    lat: -21.3577951
  },
  {
    lng: -41.2648466,
    lat: -21.357798
  },
  {
    lng: -41.2648461,
    lat: -21.3578009
  },
  {
    lng: -41.2648455,
    lat: -21.3578038
  },
  {
    lng: -41.264845,
    lat: -21.3578067
  },
  {
    lng: -41.2648445,
    lat: -21.3578097
  },
  {
    lng: -41.2648439,
    lat: -21.3578126
  },
  {
    lng: -41.2648434,
    lat: -21.3578155
  },
  {
    lng: -41.2648429,
    lat: -21.3578184
  },
  {
    lng: -41.2648424,
    lat: -21.3578213
  },
  {
    lng: -41.2648418,
    lat: -21.3578243
  },
  {
    lng: -41.2648413,
    lat: -21.3578272
  },
  {
    lng: -41.2648408,
    lat: -21.3578301
  },
  {
    lng: -41.2648404,
    lat: -21.357833
  },
  {
    lng: -41.26484,
    lat: -21.357836
  },
  {
    lng: -41.2648396,
    lat: -21.3578389
  },
  {
    lng: -41.2648393,
    lat: -21.3578419
  },
  {
    lng: -41.2648389,
    lat: -21.3578448
  },
  {
    lng: -41.2648384,
    lat: -21.3578477
  },
  {
    lng: -41.2648379,
    lat: -21.3578507
  },
  {
    lng: -41.2648374,
    lat: -21.3578536
  },
  {
    lng: -41.2648369,
    lat: -21.3578565
  },
  {
    lng: -41.2648366,
    lat: -21.3578595
  },
  {
    lng: -41.2648364,
    lat: -21.3578624
  },
  {
    lng: -41.2648361,
    lat: -21.3578654
  },
  {
    lng: -41.2648358,
    lat: -21.3578683
  },
  {
    lng: -41.2648355,
    lat: -21.3578713
  },
  {
    lng: -41.264835,
    lat: -21.3578742
  },
  {
    lng: -41.2648346,
    lat: -21.3578772
  },
  {
    lng: -41.2648343,
    lat: -21.3578801
  },
  {
    lng: -41.2648341,
    lat: -21.3578831
  },
  {
    lng: -41.2648338,
    lat: -21.357886
  },
  {
    lng: -41.2648336,
    lat: -21.357889
  },
  {
    lng: -41.2648334,
    lat: -21.3578919
  },
  {
    lng: -41.2648331,
    lat: -21.3578949
  },
  {
    lng: -41.2648329,
    lat: -21.3578978
  },
  {
    lng: -41.2648327,
    lat: -21.3579008
  },
  {
    lng: -41.2648325,
    lat: -21.3579038
  },
  {
    lng: -41.2648322,
    lat: -21.3579067
  },
  {
    lng: -41.264832,
    lat: -21.3579097
  },
  {
    lng: -41.2648319,
    lat: -21.3579126
  },
  {
    lng: -41.2648317,
    lat: -21.3579156
  },
  {
    lng: -41.2648314,
    lat: -21.3579186
  },
  {
    lng: -41.2648312,
    lat: -21.3579215
  },
  {
    lng: -41.264831,
    lat: -21.3579245
  },
  {
    lng: -41.2648308,
    lat: -21.3579274
  },
  {
    lng: -41.2648306,
    lat: -21.3579304
  },
  {
    lng: -41.2648304,
    lat: -21.3579334
  },
  {
    lng: -41.2648301,
    lat: -21.3579363
  },
  {
    lng: -41.2648299,
    lat: -21.3579393
  },
  {
    lng: -41.2648297,
    lat: -21.3579422
  },
  {
    lng: -41.2648294,
    lat: -21.3579452
  },
  {
    lng: -41.2648292,
    lat: -21.3579482
  },
  {
    lng: -41.264829,
    lat: -21.3579511
  },
  {
    lng: -41.2648288,
    lat: -21.3579541
  },
  {
    lng: -41.2648286,
    lat: -21.357957
  },
  {
    lng: -41.2648284,
    lat: -21.35796
  },
  {
    lng: -41.2648282,
    lat: -21.357963
  },
  {
    lng: -41.264828,
    lat: -21.3579659
  },
  {
    lng: -41.2648278,
    lat: -21.3579689
  },
  {
    lng: -41.2648276,
    lat: -21.3579718
  },
  {
    lng: -41.2648274,
    lat: -21.3579748
  },
  {
    lng: -41.2648273,
    lat: -21.3579778
  },
  {
    lng: -41.2648272,
    lat: -21.3579807
  },
  {
    lng: -41.2648273,
    lat: -21.3579837
  },
  {
    lng: -41.2648272,
    lat: -21.3579867
  },
  {
    lng: -41.264827,
    lat: -21.3579896
  },
  {
    lng: -41.2648269,
    lat: -21.3579926
  },
  {
    lng: -41.2648267,
    lat: -21.3579956
  },
  {
    lng: -41.2648265,
    lat: -21.3579985
  },
  {
    lng: -41.2648266,
    lat: -21.3580015
  },
  {
    lng: -41.2648267,
    lat: -21.3580044
  },
  {
    lng: -41.2648267,
    lat: -21.3580074
  },
  {
    lng: -41.2648268,
    lat: -21.3580104
  },
  {
    lng: -41.2648266,
    lat: -21.3580133
  },
  {
    lng: -41.2648265,
    lat: -21.3580163
  },
  {
    lng: -41.2648266,
    lat: -21.3580193
  },
  {
    lng: -41.2648267,
    lat: -21.3580222
  },
  {
    lng: -41.2648268,
    lat: -21.3580252
  },
  {
    lng: -41.2648269,
    lat: -21.3580282
  },
  {
    lng: -41.2648271,
    lat: -21.3580311
  },
  {
    lng: -41.2648272,
    lat: -21.3580341
  },
  {
    lng: -41.2648273,
    lat: -21.3580371
  },
  {
    lng: -41.2648274,
    lat: -21.35804
  },
  {
    lng: -41.2648276,
    lat: -21.358043
  },
  {
    lng: -41.2648277,
    lat: -21.3580459
  },
  {
    lng: -41.2648308,
    lat: -21.3581141
  },
  {
    lng: -41.2648309,
    lat: -21.3581171
  },
  {
    lng: -41.264831,
    lat: -21.3581201
  },
  {
    lng: -41.2648312,
    lat: -21.358123
  },
  {
    lng: -41.2648313,
    lat: -21.358126
  },
  {
    lng: -41.2648315,
    lat: -21.3581289
  },
  {
    lng: -41.2648316,
    lat: -21.3581319
  },
  {
    lng: -41.2648318,
    lat: -21.3581349
  },
  {
    lng: -41.2648319,
    lat: -21.3581378
  },
  {
    lng: -41.2648321,
    lat: -21.3581408
  },
  {
    lng: -41.2648323,
    lat: -21.3581437
  },
  {
    lng: -41.2648326,
    lat: -21.3581467
  },
  {
    lng: -41.2648332,
    lat: -21.3581535
  },
  {
    lng: -41.2648336,
    lat: -21.3581604
  },
  {
    lng: -41.264834,
    lat: -21.3581672
  },
  {
    lng: -41.2648343,
    lat: -21.3581741
  },
  {
    lng: -41.2648347,
    lat: -21.3581809
  },
  {
    lng: -41.264835,
    lat: -21.3581878
  },
  {
    lng: -41.2648354,
    lat: -21.3581946
  },
  {
    lng: -41.2648357,
    lat: -21.3582015
  },
  {
    lng: -41.2648361,
    lat: -21.3582083
  },
  {
    lng: -41.2648364,
    lat: -21.3582152
  },
  {
    lng: -41.2648368,
    lat: -21.358222
  },
  {
    lng: -41.2648372,
    lat: -21.3582289
  },
  {
    lng: -41.2648375,
    lat: -21.3582357
  },
  {
    lng: -41.2648378,
    lat: -21.3582426
  },
  {
    lng: -41.2648384,
    lat: -21.3582494
  },
  {
    lng: -41.2648387,
    lat: -21.3582563
  },
  {
    lng: -41.2648392,
    lat: -21.3582631
  },
  {
    lng: -41.2648396,
    lat: -21.3582699
  },
  {
    lng: -41.2648399,
    lat: -21.3582768
  },
  {
    lng: -41.2648402,
    lat: -21.3582836
  },
  {
    lng: -41.2648405,
    lat: -21.3582905
  },
  {
    lng: -41.2648409,
    lat: -21.3582973
  },
  {
    lng: -41.2648412,
    lat: -21.3583042
  },
  {
    lng: -41.2648415,
    lat: -21.358311
  },
  {
    lng: -41.2648418,
    lat: -21.3583179
  },
  {
    lng: -41.2648421,
    lat: -21.3583247
  },
  {
    lng: -41.2648424,
    lat: -21.3583316
  },
  {
    lng: -41.2648427,
    lat: -21.3583385
  },
  {
    lng: -41.264843,
    lat: -21.3583453
  },
  {
    lng: -41.2648433,
    lat: -21.3583522
  },
  {
    lng: -41.2648436,
    lat: -21.358359
  },
  {
    lng: -41.2648437,
    lat: -21.3583659
  },
  {
    lng: -41.264844,
    lat: -21.3583727
  },
  {
    lng: -41.2648443,
    lat: -21.3583796
  },
  {
    lng: -41.2648443,
    lat: -21.3583864
  },
  {
    lng: -41.2648446,
    lat: -21.3583933
  },
  {
    lng: -41.2648448,
    lat: -21.3584001
  },
  {
    lng: -41.2648451,
    lat: -21.358407
  },
  {
    lng: -41.2648453,
    lat: -21.3584138
  },
  {
    lng: -41.2648456,
    lat: -21.3584207
  },
  {
    lng: -41.2648459,
    lat: -21.3584275
  },
  {
    lng: -41.2648462,
    lat: -21.3584344
  },
  {
    lng: -41.2648464,
    lat: -21.3584413
  },
  {
    lng: -41.2648465,
    lat: -21.3584481
  },
  {
    lng: -41.2648465,
    lat: -21.358455
  },
  {
    lng: -41.2648465,
    lat: -21.3584618
  },
  {
    lng: -41.2648466,
    lat: -21.3584687
  },
  {
    lng: -41.2648452,
    lat: -21.3586975
  },
  {
    lng: -41.264845,
    lat: -21.3586998
  },
  {
    lng: -41.2648449,
    lat: -21.3587021
  },
  {
    lng: -41.2648444,
    lat: -21.3587044
  },
  {
    lng: -41.2648439,
    lat: -21.3587067
  },
  {
    lng: -41.2648434,
    lat: -21.358709
  },
  {
    lng: -41.2648431,
    lat: -21.3587113
  },
  {
    lng: -41.2648428,
    lat: -21.3587136
  },
  {
    lng: -41.2648422,
    lat: -21.3587159
  },
  {
    lng: -41.2648417,
    lat: -21.3587181
  },
  {
    lng: -41.2648411,
    lat: -21.3587204
  },
  {
    lng: -41.2648405,
    lat: -21.3587226
  },
  {
    lng: -41.26484,
    lat: -21.3587249
  },
  {
    lng: -41.2648394,
    lat: -21.3587271
  },
  {
    lng: -41.2648389,
    lat: -21.3587294
  },
  {
    lng: -41.2648383,
    lat: -21.3587317
  },
  {
    lng: -41.2648379,
    lat: -21.358734
  },
  {
    lng: -41.2648146,
    lat: -21.3588244
  },
  {
    lng: -41.2648139,
    lat: -21.3588266
  },
  {
    lng: -41.2648133,
    lat: -21.3588289
  },
  {
    lng: -41.2648127,
    lat: -21.3588312
  },
  {
    lng: -41.2648121,
    lat: -21.3588334
  },
  {
    lng: -41.2648115,
    lat: -21.3588357
  },
  {
    lng: -41.2648109,
    lat: -21.3588379
  },
  {
    lng: -41.2648103,
    lat: -21.3588402
  },
  {
    lng: -41.2648097,
    lat: -21.3588425
  },
  {
    lng: -41.2648091,
    lat: -21.3588447
  },
  {
    lng: -41.2648082,
    lat: -21.3588469
  },
  {
    lng: -41.2648074,
    lat: -21.3588491
  },
  {
    lng: -41.2648067,
    lat: -21.3588514
  },
  {
    lng: -41.264806,
    lat: -21.3588536
  },
  {
    lng: -41.2648054,
    lat: -21.3588559
  },
  {
    lng: -41.2648044,
    lat: -21.358858
  },
  {
    lng: -41.2648035,
    lat: -21.3588602
  },
  {
    lng: -41.2648026,
    lat: -21.3588623
  },
  {
    lng: -41.2648017,
    lat: -21.3588645
  },
  {
    lng: -41.264801,
    lat: -21.3588668
  },
  {
    lng: -41.2648002,
    lat: -21.358869
  },
  {
    lng: -41.2647993,
    lat: -21.3588711
  },
  {
    lng: -41.2647983,
    lat: -21.3588733
  },
  {
    lng: -41.2647974,
    lat: -21.3588754
  },
  {
    lng: -41.2647964,
    lat: -21.3588775
  },
  {
    lng: -41.2647954,
    lat: -21.3588797
  },
  {
    lng: -41.2647945,
    lat: -21.3588818
  },
  {
    lng: -41.2647935,
    lat: -21.358884
  },
  {
    lng: -41.2647925,
    lat: -21.3588861
  },
  {
    lng: -41.2647916,
    lat: -21.3588882
  },
  {
    lng: -41.2647906,
    lat: -21.3588904
  },
  {
    lng: -41.2647896,
    lat: -21.3588925
  },
  {
    lng: -41.2647886,
    lat: -21.3588946
  },
  {
    lng: -41.2647876,
    lat: -21.3588968
  },
  {
    lng: -41.2647867,
    lat: -21.3588989
  },
  {
    lng: -41.2647679,
    lat: -21.3589394
  },
  {
    lng: -41.2647668,
    lat: -21.3589415
  },
  {
    lng: -41.2647659,
    lat: -21.3589436
  },
  {
    lng: -41.2647649,
    lat: -21.3589458
  },
  {
    lng: -41.2647639,
    lat: -21.3589479
  },
  {
    lng: -41.2647628,
    lat: -21.35895
  },
  {
    lng: -41.2647618,
    lat: -21.3589521
  },
  {
    lng: -41.2647605,
    lat: -21.358955
  },
  {
    lng: -41.2647591,
    lat: -21.3589579
  },
  {
    lng: -41.2647577,
    lat: -21.3589608
  },
  {
    lng: -41.2647563,
    lat: -21.3589637
  },
  {
    lng: -41.2647547,
    lat: -21.3589665
  },
  {
    lng: -41.2647532,
    lat: -21.3589694
  },
  {
    lng: -41.2647518,
    lat: -21.3589723
  },
  {
    lng: -41.2647504,
    lat: -21.3589752
  },
  {
    lng: -41.264749,
    lat: -21.3589781
  },
  {
    lng: -41.2647476,
    lat: -21.3589809
  },
  {
    lng: -41.2647462,
    lat: -21.3589838
  },
  {
    lng: -41.2647448,
    lat: -21.3589867
  },
  {
    lng: -41.2647434,
    lat: -21.3589896
  },
  {
    lng: -41.264742,
    lat: -21.3589925
  },
  {
    lng: -41.2647404,
    lat: -21.3589953
  },
  {
    lng: -41.2647388,
    lat: -21.3589982
  },
  {
    lng: -41.2647374,
    lat: -21.3590011
  },
  {
    lng: -41.264736,
    lat: -21.3590039
  },
  {
    lng: -41.2647347,
    lat: -21.3590069
  },
  {
    lng: -41.2647333,
    lat: -21.3590098
  },
  {
    lng: -41.2647319,
    lat: -21.3590127
  },
  {
    lng: -41.2647306,
    lat: -21.3590156
  },
  {
    lng: -41.2647292,
    lat: -21.3590185
  },
  {
    lng: -41.2647279,
    lat: -21.3590214
  },
  {
    lng: -41.2647265,
    lat: -21.3590244
  },
  {
    lng: -41.2647252,
    lat: -21.3590273
  },
  {
    lng: -41.2647239,
    lat: -21.3590302
  },
  {
    lng: -41.2647225,
    lat: -21.3590331
  },
  {
    lng: -41.2647212,
    lat: -21.3590361
  },
  {
    lng: -41.2647198,
    lat: -21.359039
  },
  {
    lng: -41.2647185,
    lat: -21.3590419
  },
  {
    lng: -41.2647171,
    lat: -21.3590448
  },
  {
    lng: -41.2647117,
    lat: -21.3590565
  },
  {
    lng: -41.2647104,
    lat: -21.3590594
  },
  {
    lng: -41.264709,
    lat: -21.3590624
  },
  {
    lng: -41.2647077,
    lat: -21.3590653
  },
  {
    lng: -41.2647063,
    lat: -21.3590682
  },
  {
    lng: -41.264705,
    lat: -21.3590711
  },
  {
    lng: -41.2647036,
    lat: -21.3590741
  },
  {
    lng: -41.2647022,
    lat: -21.359077
  },
  {
    lng: -41.2647009,
    lat: -21.3590799
  },
  {
    lng: -41.2646995,
    lat: -21.3590828
  },
  {
    lng: -41.2646982,
    lat: -21.3590857
  },
  {
    lng: -41.2646969,
    lat: -21.3590887
  },
  {
    lng: -41.2646955,
    lat: -21.3590916
  },
  {
    lng: -41.2646942,
    lat: -21.3590945
  },
  {
    lng: -41.2646929,
    lat: -21.3590974
  },
  {
    lng: -41.2646916,
    lat: -21.3591004
  },
  {
    lng: -41.2646903,
    lat: -21.3591033
  },
  {
    lng: -41.2646891,
    lat: -21.3591063
  },
  {
    lng: -41.264688,
    lat: -21.3591094
  },
  {
    lng: -41.2646868,
    lat: -21.3591124
  },
  {
    lng: -41.2646855,
    lat: -21.3591153
  },
  {
    lng: -41.2646842,
    lat: -21.3591182
  },
  {
    lng: -41.2646829,
    lat: -21.3591212
  },
  {
    lng: -41.2646816,
    lat: -21.3591241
  },
  {
    lng: -41.2646805,
    lat: -21.3591272
  },
  {
    lng: -41.2646795,
    lat: -21.3591302
  },
  {
    lng: -41.2646784,
    lat: -21.3591332
  },
  {
    lng: -41.2646771,
    lat: -21.3591362
  },
  {
    lng: -41.2646759,
    lat: -21.3591392
  },
  {
    lng: -41.2646749,
    lat: -21.3591422
  },
  {
    lng: -41.264674,
    lat: -21.3591453
  },
  {
    lng: -41.264673,
    lat: -21.3591483
  },
  {
    lng: -41.264672,
    lat: -21.3591514
  },
  {
    lng: -41.264671,
    lat: -21.3591545
  },
  {
    lng: -41.26467,
    lat: -21.3591575
  },
  {
    lng: -41.264669,
    lat: -21.3591606
  },
  {
    lng: -41.2646681,
    lat: -21.3591637
  },
  {
    lng: -41.264627,
    lat: -21.3592924
  },
  {
    lng: -41.264626,
    lat: -21.3592955
  },
  {
    lng: -41.2646251,
    lat: -21.3592986
  },
  {
    lng: -41.2646241,
    lat: -21.3593016
  },
  {
    lng: -41.2646231,
    lat: -21.3593047
  },
  {
    lng: -41.2646222,
    lat: -21.3593077
  },
  {
    lng: -41.2646212,
    lat: -21.3593108
  },
  {
    lng: -41.2646202,
    lat: -21.3593139
  },
  {
    lng: -41.2646192,
    lat: -21.3593169
  },
  {
    lng: -41.2646185,
    lat: -21.3593201
  },
  {
    lng: -41.2646178,
    lat: -21.3593232
  },
  {
    lng: -41.264617,
    lat: -21.3593263
  },
  {
    lng: -41.264616,
    lat: -21.3593294
  },
  {
    lng: -41.2646151,
    lat: -21.3593325
  },
  {
    lng: -41.2646145,
    lat: -21.3593356
  },
  {
    lng: -41.2646139,
    lat: -21.3593388
  },
  {
    lng: -41.2646132,
    lat: -21.3593419
  },
  {
    lng: -41.2646125,
    lat: -21.3593451
  },
  {
    lng: -41.2646117,
    lat: -21.3593482
  },
  {
    lng: -41.2646109,
    lat: -21.3593513
  },
  {
    lng: -41.2646103,
    lat: -21.3593545
  },
  {
    lng: -41.2646097,
    lat: -21.3593576
  },
  {
    lng: -41.2646091,
    lat: -21.3593608
  },
  {
    lng: -41.2646085,
    lat: -21.359364
  },
  {
    lng: -41.2646079,
    lat: -21.3593671
  },
  {
    lng: -41.2646073,
    lat: -21.3593703
  },
  {
    lng: -41.2646067,
    lat: -21.3593735
  },
  {
    lng: -41.2646062,
    lat: -21.3593766
  },
  {
    lng: -41.2646056,
    lat: -21.3593798
  },
  {
    lng: -41.264605,
    lat: -21.3593829
  },
  {
    lng: -41.2645923,
    lat: -21.3594526
  },
  {
    lng: -41.2645917,
    lat: -21.3594558
  },
  {
    lng: -41.2645911,
    lat: -21.3594589
  },
  {
    lng: -41.2645906,
    lat: -21.3594621
  },
  {
    lng: -41.26459,
    lat: -21.3594653
  },
  {
    lng: -41.2645894,
    lat: -21.3594684
  },
  {
    lng: -41.2645889,
    lat: -21.3594716
  },
  {
    lng: -41.2645883,
    lat: -21.3594748
  },
  {
    lng: -41.2645877,
    lat: -21.3594779
  },
  {
    lng: -41.2645872,
    lat: -21.3594811
  },
  {
    lng: -41.2645867,
    lat: -21.3594843
  },
  {
    lng: -41.2645863,
    lat: -21.3594875
  },
  {
    lng: -41.264586,
    lat: -21.3594907
  },
  {
    lng: -41.2645856,
    lat: -21.3594939
  },
  {
    lng: -41.264585,
    lat: -21.3594971
  },
  {
    lng: -41.2645845,
    lat: -21.3595002
  },
  {
    lng: -41.264584,
    lat: -21.3595034
  },
  {
    lng: -41.2645835,
    lat: -21.3595066
  },
  {
    lng: -41.264583,
    lat: -21.3595098
  },
  {
    lng: -41.2645825,
    lat: -21.3595129
  },
  {
    lng: -41.2645813,
    lat: -21.3595191
  },
  {
    lng: -41.2645801,
    lat: -21.3595252
  },
  {
    lng: -41.2645789,
    lat: -21.3595314
  },
  {
    lng: -41.2645778,
    lat: -21.3595375
  },
  {
    lng: -41.2645766,
    lat: -21.3595437
  },
  {
    lng: -41.2645754,
    lat: -21.3595498
  },
  {
    lng: -41.2645742,
    lat: -21.359556
  },
  {
    lng: -41.264573,
    lat: -21.3595621
  },
  {
    lng: -41.2645716,
    lat: -21.3595683
  },
  {
    lng: -41.2645703,
    lat: -21.3595744
  },
  {
    lng: -41.2645691,
    lat: -21.3595805
  },
  {
    lng: -41.2645679,
    lat: -21.3595867
  },
  {
    lng: -41.2645668,
    lat: -21.3595929
  },
  {
    lng: -41.2645657,
    lat: -21.359599
  },
  {
    lng: -41.2645645,
    lat: -21.3596052
  },
  {
    lng: -41.2645634,
    lat: -21.3596113
  },
  {
    lng: -41.2645623,
    lat: -21.3596175
  },
  {
    lng: -41.2645611,
    lat: -21.3596237
  },
  {
    lng: -41.26456,
    lat: -21.3596298
  },
  {
    lng: -41.2645589,
    lat: -21.359636
  },
  {
    lng: -41.2645577,
    lat: -21.3596422
  },
  {
    lng: -41.2645567,
    lat: -21.3596483
  },
  {
    lng: -41.2645556,
    lat: -21.3596545
  },
  {
    lng: -41.2645544,
    lat: -21.3596607
  },
  {
    lng: -41.2645533,
    lat: -21.3596668
  },
  {
    lng: -41.2645522,
    lat: -21.359673
  },
  {
    lng: -41.2645511,
    lat: -21.3596792
  },
  {
    lng: -41.26455,
    lat: -21.3596853
  },
  {
    lng: -41.2645488,
    lat: -21.3596915
  },
  {
    lng: -41.2645477,
    lat: -21.3596977
  },
  {
    lng: -41.2645466,
    lat: -21.3597038
  },
  {
    lng: -41.2645455,
    lat: -21.35971
  },
  {
    lng: -41.2645443,
    lat: -21.3597161
  },
  {
    lng: -41.2645432,
    lat: -21.3597223
  },
  {
    lng: -41.264542,
    lat: -21.3597285
  },
  {
    lng: -41.2645409,
    lat: -21.3597346
  },
  {
    lng: -41.2645398,
    lat: -21.3597408
  },
  {
    lng: -41.2645387,
    lat: -21.359747
  },
  {
    lng: -41.2645376,
    lat: -21.3597531
  },
  {
    lng: -41.2645365,
    lat: -21.3597593
  },
  {
    lng: -41.2645354,
    lat: -21.3597655
  },
  {
    lng: -41.2645343,
    lat: -21.3597716
  },
  {
    lng: -41.2645332,
    lat: -21.3597778
  },
  {
    lng: -41.2645321,
    lat: -21.359784
  },
  {
    lng: -41.2645312,
    lat: -21.3597902
  },
  {
    lng: -41.2645303,
    lat: -21.3597964
  },
  {
    lng: -41.2645293,
    lat: -21.3598026
  },
  {
    lng: -41.2645283,
    lat: -21.3598088
  },
  {
    lng: -41.2645272,
    lat: -21.3598149
  },
  {
    lng: -41.2645261,
    lat: -21.3598211
  },
  {
    lng: -41.2645251,
    lat: -21.3598273
  },
  {
    lng: -41.2645242,
    lat: -21.3598335
  },
  {
    lng: -41.2645234,
    lat: -21.3598397
  },
  {
    lng: -41.2645226,
    lat: -21.3598459
  },
  {
    lng: -41.2645217,
    lat: -21.3598521
  },
  {
    lng: -41.2645206,
    lat: -21.3598583
  },
  {
    lng: -41.2645196,
    lat: -21.3598645
  },
  {
    lng: -41.2645188,
    lat: -21.3598707
  },
  {
    lng: -41.264518,
    lat: -21.3598769
  },
  {
    lng: -41.2645172,
    lat: -21.3598831
  },
  {
    lng: -41.2645165,
    lat: -21.3598893
  },
  {
    lng: -41.2645157,
    lat: -21.3598956
  },
  {
    lng: -41.2645149,
    lat: -21.3599018
  },
  {
    lng: -41.2645142,
    lat: -21.359908
  },
  {
    lng: -41.2645134,
    lat: -21.3599142
  },
  {
    lng: -41.2645126,
    lat: -21.3599204
  },
  {
    lng: -41.2645119,
    lat: -21.3599266
  },
  {
    lng: -41.2645111,
    lat: -21.3599329
  },
  {
    lng: -41.2645103,
    lat: -21.3599391
  },
  {
    lng: -41.2645096,
    lat: -21.3599453
  },
  {
    lng: -41.2644935,
    lat: -21.3600759
  },
  {
    lng: -41.2644927,
    lat: -21.3600821
  },
  {
    lng: -41.264492,
    lat: -21.3600884
  },
  {
    lng: -41.2644912,
    lat: -21.3600946
  },
  {
    lng: -41.2644905,
    lat: -21.3601008
  },
  {
    lng: -41.2644897,
    lat: -21.360107
  },
  {
    lng: -41.264489,
    lat: -21.3601132
  },
  {
    lng: -41.2644882,
    lat: -21.3601195
  },
  {
    lng: -41.2644874,
    lat: -21.3601257
  },
  {
    lng: -41.2644867,
    lat: -21.3601319
  },
  {
    lng: -41.2644859,
    lat: -21.3601381
  },
  {
    lng: -41.2644852,
    lat: -21.3601443
  },
  {
    lng: -41.2644844,
    lat: -21.3601505
  },
  {
    lng: -41.2644837,
    lat: -21.3601568
  },
  {
    lng: -41.2644832,
    lat: -21.360163
  },
  {
    lng: -41.2644827,
    lat: -21.3601693
  },
  {
    lng: -41.2644821,
    lat: -21.3601755
  },
  {
    lng: -41.2644814,
    lat: -21.3601817
  },
  {
    lng: -41.2644807,
    lat: -21.360188
  },
  {
    lng: -41.2644803,
    lat: -21.3601913
  },
  {
    lng: -41.2644799,
    lat: -21.3601945
  },
  {
    lng: -41.2644795,
    lat: -21.3601978
  },
  {
    lng: -41.2644791,
    lat: -21.3602011
  },
  {
    lng: -41.2644787,
    lat: -21.3602044
  },
  {
    lng: -41.2644783,
    lat: -21.3602077
  },
  {
    lng: -41.2644779,
    lat: -21.360211
  },
  {
    lng: -41.2644775,
    lat: -21.3602143
  },
  {
    lng: -41.2644771,
    lat: -21.3602176
  },
  {
    lng: -41.2644767,
    lat: -21.3602209
  },
  {
    lng: -41.2644763,
    lat: -21.3602242
  },
  {
    lng: -41.2644759,
    lat: -21.3602275
  },
  {
    lng: -41.2644755,
    lat: -21.3602308
  },
  {
    lng: -41.2644753,
    lat: -21.3602341
  },
  {
    lng: -41.264475,
    lat: -21.3602374
  },
  {
    lng: -41.2644748,
    lat: -21.3602407
  },
  {
    lng: -41.2644745,
    lat: -21.360244
  },
  {
    lng: -41.2644743,
    lat: -21.3602473
  },
  {
    lng: -41.2644739,
    lat: -21.3602506
  },
  {
    lng: -41.2644737,
    lat: -21.3602539
  },
  {
    lng: -41.2644733,
    lat: -21.3602572
  },
  {
    lng: -41.264473,
    lat: -21.3602605
  },
  {
    lng: -41.2644726,
    lat: -21.3602638
  },
  {
    lng: -41.2644724,
    lat: -21.3602671
  },
  {
    lng: -41.2644721,
    lat: -21.3602704
  },
  {
    lng: -41.2644719,
    lat: -21.3602737
  },
  {
    lng: -41.2644717,
    lat: -21.360277
  },
  {
    lng: -41.2644714,
    lat: -21.3602804
  },
  {
    lng: -41.2644712,
    lat: -21.3602837
  },
  {
    lng: -41.264471,
    lat: -21.360287
  },
  {
    lng: -41.2644708,
    lat: -21.3602903
  },
  {
    lng: -41.2644706,
    lat: -21.3602936
  },
  {
    lng: -41.2644703,
    lat: -21.3602969
  },
  {
    lng: -41.2644701,
    lat: -21.3603002
  },
  {
    lng: -41.2644699,
    lat: -21.3603035
  },
  {
    lng: -41.2644698,
    lat: -21.3603068
  },
  {
    lng: -41.2644696,
    lat: -21.3603102
  },
  {
    lng: -41.2644694,
    lat: -21.3603135
  },
  {
    lng: -41.2644692,
    lat: -21.3603168
  },
  {
    lng: -41.264469,
    lat: -21.3603201
  },
  {
    lng: -41.2644688,
    lat: -21.3603234
  },
  {
    lng: -41.2644686,
    lat: -21.3603267
  },
  {
    lng: -41.2644686,
    lat: -21.36033
  },
  {
    lng: -41.2644684,
    lat: -21.3603333
  },
  {
    lng: -41.2644685,
    lat: -21.3603367
  },
  {
    lng: -41.2644683,
    lat: -21.36034
  },
  {
    lng: -41.2644682,
    lat: -21.3603433
  },
  {
    lng: -41.264468,
    lat: -21.3603466
  },
  {
    lng: -41.2644678,
    lat: -21.3603499
  },
  {
    lng: -41.2644677,
    lat: -21.3603532
  },
  {
    lng: -41.2644675,
    lat: -21.3603565
  },
  {
    lng: -41.2644673,
    lat: -21.3603599
  },
  {
    lng: -41.2644673,
    lat: -21.3603632
  },
  {
    lng: -41.2644674,
    lat: -21.3603665
  },
  {
    lng: -41.2644674,
    lat: -21.3603698
  },
  {
    lng: -41.2644674,
    lat: -21.3603731
  },
  {
    lng: -41.2644674,
    lat: -21.3603764
  },
  {
    lng: -41.2644674,
    lat: -21.3603797
  },
  {
    lng: -41.2644674,
    lat: -21.3603831
  },
  {
    lng: -41.2644672,
    lat: -21.3603864
  },
  {
    lng: -41.2644672,
    lat: -21.3603897
  },
  {
    lng: -41.2644671,
    lat: -21.360393
  },
  {
    lng: -41.2644671,
    lat: -21.3603963
  },
  {
    lng: -41.2644671,
    lat: -21.3603997
  },
  {
    lng: -41.2644672,
    lat: -21.360403
  },
  {
    lng: -41.2644672,
    lat: -21.3604063
  },
  {
    lng: -41.2644672,
    lat: -21.3604096
  },
  {
    lng: -41.2644673,
    lat: -21.3604129
  },
  {
    lng: -41.2644673,
    lat: -21.3604162
  },
  {
    lng: -41.2644674,
    lat: -21.3604196
  },
  {
    lng: -41.2644674,
    lat: -21.3604229
  },
  {
    lng: -41.2644675,
    lat: -21.3604262
  },
  {
    lng: -41.2644675,
    lat: -21.3604295
  },
  {
    lng: -41.2644676,
    lat: -21.3604328
  },
  {
    lng: -41.2644677,
    lat: -21.3604361
  },
  {
    lng: -41.2644677,
    lat: -21.3604395
  },
  {
    lng: -41.2644678,
    lat: -21.3604428
  },
  {
    lng: -41.2644679,
    lat: -21.3604461
  },
  {
    lng: -41.264468,
    lat: -21.3604494
  },
  {
    lng: -41.264468,
    lat: -21.3604527
  },
  {
    lng: -41.2644681,
    lat: -21.360456
  },
  {
    lng: -41.2644684,
    lat: -21.3604593
  },
  {
    lng: -41.2644685,
    lat: -21.3604627
  },
  {
    lng: -41.2644688,
    lat: -21.360466
  },
  {
    lng: -41.2644688,
    lat: -21.3604693
  },
  {
    lng: -41.264469,
    lat: -21.3604726
  },
  {
    lng: -41.2644691,
    lat: -21.3604759
  },
  {
    lng: -41.2644692,
    lat: -21.3604792
  },
  {
    lng: -41.2644693,
    lat: -21.3604825
  },
  {
    lng: -41.2644694,
    lat: -21.3604859
  },
  {
    lng: -41.2644695,
    lat: -21.3604892
  },
  {
    lng: -41.2644698,
    lat: -21.3604925
  },
  {
    lng: -41.26447,
    lat: -21.3604958
  },
  {
    lng: -41.2644703,
    lat: -21.3604991
  },
  {
    lng: -41.2644706,
    lat: -21.3605024
  },
  {
    lng: -41.2644709,
    lat: -21.3605057
  },
  {
    lng: -41.2644711,
    lat: -21.360509
  },
  {
    lng: -41.2644714,
    lat: -21.3605123
  },
  {
    lng: -41.2644715,
    lat: -21.3605156
  },
  {
    lng: -41.2644717,
    lat: -21.3605189
  },
  {
    lng: -41.2644719,
    lat: -21.3605223
  },
  {
    lng: -41.2644722,
    lat: -21.3605256
  },
  {
    lng: -41.2644725,
    lat: -21.3605289
  },
  {
    lng: -41.2644728,
    lat: -21.3605322
  },
  {
    lng: -41.2644731,
    lat: -21.3605355
  },
  {
    lng: -41.2644734,
    lat: -21.3605388
  },
  {
    lng: -41.2644737,
    lat: -21.3605421
  },
  {
    lng: -41.264474,
    lat: -21.3605454
  },
  {
    lng: -41.2644743,
    lat: -21.3605487
  },
  {
    lng: -41.2644746,
    lat: -21.360552
  },
  {
    lng: -41.2644749,
    lat: -21.3605553
  },
  {
    lng: -41.2644752,
    lat: -21.3605586
  },
  {
    lng: -41.2644756,
    lat: -21.3605619
  },
  {
    lng: -41.2644759,
    lat: -21.3605652
  },
  {
    lng: -41.2644762,
    lat: -21.3605685
  },
  {
    lng: -41.2644766,
    lat: -21.3605718
  },
  {
    lng: -41.2644769,
    lat: -21.3605751
  },
  {
    lng: -41.2644773,
    lat: -21.3605784
  },
  {
    lng: -41.2644776,
    lat: -21.3605817
  },
  {
    lng: -41.264478,
    lat: -21.360585
  },
  {
    lng: -41.2644785,
    lat: -21.3605883
  },
  {
    lng: -41.2644788,
    lat: -21.3605916
  },
  {
    lng: -41.2644794,
    lat: -21.3605948
  },
  {
    lng: -41.2644797,
    lat: -21.3605981
  },
  {
    lng: -41.2644802,
    lat: -21.3606014
  },
  {
    lng: -41.2644805,
    lat: -21.3606047
  },
  {
    lng: -41.2644809,
    lat: -21.360608
  },
  {
    lng: -41.2644812,
    lat: -21.3606113
  },
  {
    lng: -41.2644816,
    lat: -21.3606146
  },
  {
    lng: -41.264482,
    lat: -21.3606179
  },
  {
    lng: -41.2644825,
    lat: -21.3606212
  },
  {
    lng: -41.2644831,
    lat: -21.3606244
  },
  {
    lng: -41.2644836,
    lat: -21.3606277
  },
  {
    lng: -41.2644841,
    lat: -21.360631
  },
  {
    lng: -41.2644847,
    lat: -21.3606343
  },
  {
    lng: -41.2644852,
    lat: -21.3606375
  },
  {
    lng: -41.2644857,
    lat: -21.3606408
  },
  {
    lng: -41.264486,
    lat: -21.3606441
  },
  {
    lng: -41.2644866,
    lat: -21.3606474
  },
  {
    lng: -41.264487,
    lat: -21.3606507
  },
  {
    lng: -41.2644876,
    lat: -21.360654
  },
  {
    lng: -41.2644881,
    lat: -21.3606572
  },
  {
    lng: -41.2644887,
    lat: -21.3606605
  },
  {
    lng: -41.2644892,
    lat: -21.3606638
  },
  {
    lng: -41.2644898,
    lat: -21.360667
  },
  {
    lng: -41.2644904,
    lat: -21.3606703
  },
  {
    lng: -41.2644909,
    lat: -21.3606736
  },
  {
    lng: -41.2644915,
    lat: -21.3606768
  },
  {
    lng: -41.2644921,
    lat: -21.3606801
  },
  {
    lng: -41.2644927,
    lat: -21.3606834
  },
  {
    lng: -41.2644932,
    lat: -21.3606866
  },
  {
    lng: -41.2644938,
    lat: -21.3606899
  },
  {
    lng: -41.2644944,
    lat: -21.3606932
  },
  {
    lng: -41.264495,
    lat: -21.3606964
  },
  {
    lng: -41.2644956,
    lat: -21.3606997
  },
  {
    lng: -41.2644962,
    lat: -21.360703
  },
  {
    lng: -41.2644968,
    lat: -21.3607062
  },
  {
    lng: -41.2644975,
    lat: -21.3607095
  },
  {
    lng: -41.2644981,
    lat: -21.3607127
  },
  {
    lng: -41.2644988,
    lat: -21.360716
  },
  {
    lng: -41.2644994,
    lat: -21.3607192
  },
  {
    lng: -41.2645003,
    lat: -21.3607224
  },
  {
    lng: -41.2645009,
    lat: -21.3607257
  },
  {
    lng: -41.2645016,
    lat: -21.360729
  },
  {
    lng: -41.2645022,
    lat: -21.3607322
  },
  {
    lng: -41.2645028,
    lat: -21.3607355
  },
  {
    lng: -41.2645034,
    lat: -21.3607387
  },
  {
    lng: -41.2645041,
    lat: -21.360742
  },
  {
    lng: -41.2645047,
    lat: -21.3607452
  },
  {
    lng: -41.2645055,
    lat: -21.3607485
  },
  {
    lng: -41.2645063,
    lat: -21.3607517
  },
  {
    lng: -41.2645071,
    lat: -21.3607549
  },
  {
    lng: -41.2645079,
    lat: -21.3607581
  },
  {
    lng: -41.2645087,
    lat: -21.3607613
  },
  {
    lng: -41.2645095,
    lat: -21.3607646
  },
  {
    lng: -41.2645103,
    lat: -21.3607678
  },
  {
    lng: -41.2645109,
    lat: -21.360771
  },
  {
    lng: -41.2645117,
    lat: -21.3607743
  },
  {
    lng: -41.2645123,
    lat: -21.3607775
  },
  {
    lng: -41.2645131,
    lat: -21.3607807
  },
  {
    lng: -41.264514,
    lat: -21.3607839
  },
  {
    lng: -41.2645148,
    lat: -21.3607872
  },
  {
    lng: -41.2645156,
    lat: -21.3607904
  },
  {
    lng: -41.2645164,
    lat: -21.3607936
  },
  {
    lng: -41.2645173,
    lat: -21.3607968
  },
  {
    lng: -41.2645181,
    lat: -21.3608
  },
  {
    lng: -41.264519,
    lat: -21.3608032
  },
  {
    lng: -41.2645198,
    lat: -21.3608064
  },
  {
    lng: -41.2645207,
    lat: -21.3608096
  },
  {
    lng: -41.2645215,
    lat: -21.3608128
  },
  {
    lng: -41.2645224,
    lat: -21.360816
  },
  {
    lng: -41.2645232,
    lat: -21.3608192
  },
  {
    lng: -41.2645241,
    lat: -21.3608224
  },
  {
    lng: -41.2645249,
    lat: -21.3608257
  },
  {
    lng: -41.2645258,
    lat: -21.3608289
  },
  {
    lng: -41.2645266,
    lat: -21.3608321
  },
  {
    lng: -41.2645275,
    lat: -21.3608353
  },
  {
    lng: -41.2645284,
    lat: -21.3608385
  },
  {
    lng: -41.2645293,
    lat: -21.3608417
  },
  {
    lng: -41.2645301,
    lat: -21.3608448
  },
  {
    lng: -41.2645312,
    lat: -21.360848
  },
  {
    lng: -41.2645321,
    lat: -21.3608512
  },
  {
    lng: -41.2645332,
    lat: -21.3608543
  },
  {
    lng: -41.264534,
    lat: -21.3608575
  },
  {
    lng: -41.264535,
    lat: -21.3608607
  },
  {
    lng: -41.2645359,
    lat: -21.3608639
  },
  {
    lng: -41.2645368,
    lat: -21.3608671
  },
  {
    lng: -41.2645377,
    lat: -21.3608703
  },
  {
    lng: -41.2645386,
    lat: -21.3608735
  },
  {
    lng: -41.2645395,
    lat: -21.3608767
  },
  {
    lng: -41.2645405,
    lat: -21.3608798
  },
  {
    lng: -41.2645416,
    lat: -21.360883
  },
  {
    lng: -41.2645427,
    lat: -21.3608861
  },
  {
    lng: -41.2645437,
    lat: -21.3608892
  },
  {
    lng: -41.2645448,
    lat: -21.3608924
  },
  {
    lng: -41.2645458,
    lat: -21.3608955
  },
  {
    lng: -41.2645469,
    lat: -21.3608987
  },
  {
    lng: -41.2645478,
    lat: -21.3609019
  },
  {
    lng: -41.2645488,
    lat: -21.360905
  },
  {
    lng: -41.2645498,
    lat: -21.3609082
  },
  {
    lng: -41.2645509,
    lat: -21.3609113
  },
  {
    lng: -41.2645519,
    lat: -21.3609145
  },
  {
    lng: -41.264553,
    lat: -21.3609176
  },
  {
    lng: -41.2645541,
    lat: -21.3609207
  },
  {
    lng: -41.2645552,
    lat: -21.3609239
  },
  {
    lng: -41.2645563,
    lat: -21.360927
  },
  {
    lng: -41.2645574,
    lat: -21.3609301
  },
  {
    lng: -41.2645585,
    lat: -21.3609333
  },
  {
    lng: -41.2645596,
    lat: -21.3609364
  },
  {
    lng: -41.2645607,
    lat: -21.3609395
  },
  {
    lng: -41.2645618,
    lat: -21.3609426
  },
  {
    lng: -41.264563,
    lat: -21.3609458
  },
  {
    lng: -41.2645641,
    lat: -21.3609489
  },
  {
    lng: -41.2645652,
    lat: -21.360952
  },
  {
    lng: -41.2645663,
    lat: -21.3609551
  },
  {
    lng: -41.2645675,
    lat: -21.3609582
  },
  {
    lng: -41.2645686,
    lat: -21.3609614
  },
  {
    lng: -41.2645697,
    lat: -21.3609645
  },
  {
    lng: -41.2645709,
    lat: -21.3609676
  },
  {
    lng: -41.264572,
    lat: -21.3609707
  },
  {
    lng: -41.2645733,
    lat: -21.3609738
  },
  {
    lng: -41.2645744,
    lat: -21.3609769
  },
  {
    lng: -41.2645758,
    lat: -21.3609799
  },
  {
    lng: -41.2645769,
    lat: -21.360983
  },
  {
    lng: -41.2645782,
    lat: -21.3609861
  },
  {
    lng: -41.2645793,
    lat: -21.3609892
  },
  {
    lng: -41.2645804,
    lat: -21.3609923
  },
  {
    lng: -41.2645816,
    lat: -21.3609955
  },
  {
    lng: -41.2645827,
    lat: -21.3609986
  },
  {
    lng: -41.2645839,
    lat: -21.3610017
  },
  {
    lng: -41.2645852,
    lat: -21.3610047
  },
  {
    lng: -41.2645866,
    lat: -21.3610077
  },
  {
    lng: -41.2645879,
    lat: -21.3610108
  },
  {
    lng: -41.2645893,
    lat: -21.3610138
  },
  {
    lng: -41.2645905,
    lat: -21.3610169
  },
  {
    lng: -41.2645917,
    lat: -21.36102
  },
  {
    lng: -41.2645929,
    lat: -21.3610231
  },
  {
    lng: -41.2645942,
    lat: -21.3610261
  },
  {
    lng: -41.2645956,
    lat: -21.3610291
  },
  {
    lng: -41.2645969,
    lat: -21.3610322
  },
  {
    lng: -41.2645983,
    lat: -21.3610352
  },
  {
    lng: -41.2645997,
    lat: -21.3610382
  },
  {
    lng: -41.2646011,
    lat: -21.3610412
  },
  {
    lng: -41.2646025,
    lat: -21.3610442
  },
  {
    lng: -41.2646039,
    lat: -21.3610472
  },
  {
    lng: -41.2646053,
    lat: -21.3610502
  },
  {
    lng: -41.2646066,
    lat: -21.3610532
  },
  {
    lng: -41.264608,
    lat: -21.3610563
  },
  {
    lng: -41.2646094,
    lat: -21.3610593
  },
  {
    lng: -41.2646108,
    lat: -21.3610623
  },
  {
    lng: -41.2646122,
    lat: -21.3610653
  },
  {
    lng: -41.2646136,
    lat: -21.3610683
  },
  {
    lng: -41.264615,
    lat: -21.3610713
  },
  {
    lng: -41.2646164,
    lat: -21.3610743
  },
  {
    lng: -41.2646177,
    lat: -21.3610774
  },
  {
    lng: -41.2646191,
    lat: -21.3610804
  },
  {
    lng: -41.2646205,
    lat: -21.3610834
  },
  {
    lng: -41.2646239,
    lat: -21.3610906
  },
  {
    lng: -41.2646272,
    lat: -21.3610979
  },
  {
    lng: -41.2646305,
    lat: -21.3611052
  },
  {
    lng: -41.2646339,
    lat: -21.3611124
  },
  {
    lng: -41.2647744,
    lat: -21.3614174
  },
  {
    lng: -41.2647777,
    lat: -21.3614247
  },
  {
    lng: -41.2647811,
    lat: -21.3614319
  },
  {
    lng: -41.2647844,
    lat: -21.3614392
  },
  {
    lng: -41.2647877,
    lat: -21.3614465
  },
  {
    lng: -41.2647911,
    lat: -21.3614537
  },
  {
    lng: -41.2647944,
    lat: -21.361461
  },
  {
    lng: -41.264798,
    lat: -21.3614681
  },
  {
    lng: -41.2648016,
    lat: -21.3614753
  },
  {
    lng: -41.2648051,
    lat: -21.3614825
  },
  {
    lng: -41.2648085,
    lat: -21.3614897
  },
  {
    lng: -41.2648119,
    lat: -21.3614969
  },
  {
    lng: -41.2648127,
    lat: -21.3614993
  },
  {
    lng: -41.2648135,
    lat: -21.3615016
  },
  {
    lng: -41.2648143,
    lat: -21.3615039
  },
  {
    lng: -41.2648151,
    lat: -21.3615063
  },
  {
    lng: -41.2648159,
    lat: -21.3615086
  },
  {
    lng: -41.2648167,
    lat: -21.3615109
  },
  {
    lng: -41.2648175,
    lat: -21.3615133
  },
  {
    lng: -41.2648183,
    lat: -21.3615156
  },
  {
    lng: -41.2648191,
    lat: -21.3615179
  },
  {
    lng: -41.2648199,
    lat: -21.3615203
  },
  {
    lng: -41.2648207,
    lat: -21.3615226
  },
  {
    lng: -41.2648215,
    lat: -21.3615249
  },
  {
    lng: -41.2648223,
    lat: -21.3615273
  },
  {
    lng: -41.264823,
    lat: -21.3615296
  },
  {
    lng: -41.2648238,
    lat: -21.361532
  },
  {
    lng: -41.2648246,
    lat: -21.3615343
  },
  {
    lng: -41.2648254,
    lat: -21.3615367
  },
  {
    lng: -41.2648261,
    lat: -21.361539
  },
  {
    lng: -41.2648269,
    lat: -21.3615413
  },
  {
    lng: -41.2648277,
    lat: -21.3615437
  },
  {
    lng: -41.2648284,
    lat: -21.361546
  },
  {
    lng: -41.2648291,
    lat: -21.3615484
  },
  {
    lng: -41.2648299,
    lat: -21.3615508
  },
  {
    lng: -41.2648306,
    lat: -21.3615531
  },
  {
    lng: -41.2648314,
    lat: -21.3615555
  },
  {
    lng: -41.2648321,
    lat: -21.3615578
  },
  {
    lng: -41.2648329,
    lat: -21.3615602
  },
  {
    lng: -41.2648336,
    lat: -21.3615625
  },
  {
    lng: -41.2648344,
    lat: -21.3615649
  },
  {
    lng: -41.2648351,
    lat: -21.3615672
  },
  {
    lng: -41.2648357,
    lat: -21.3615696
  },
  {
    lng: -41.2648363,
    lat: -21.361572
  },
  {
    lng: -41.2648369,
    lat: -21.3615744
  },
  {
    lng: -41.2648374,
    lat: -21.3615768
  },
  {
    lng: -41.264838,
    lat: -21.3615792
  },
  {
    lng: -41.2648387,
    lat: -21.3615816
  },
  {
    lng: -41.2648393,
    lat: -21.361584
  },
  {
    lng: -41.2648401,
    lat: -21.3615863
  },
  {
    lng: -41.2648406,
    lat: -21.3615887
  },
  {
    lng: -41.2648414,
    lat: -21.3615911
  },
  {
    lng: -41.264842,
    lat: -21.3615935
  },
  {
    lng: -41.2648425,
    lat: -21.3615959
  },
  {
    lng: -41.2648431,
    lat: -21.3615983
  },
  {
    lng: -41.2648437,
    lat: -21.3616007
  },
  {
    lng: -41.2648442,
    lat: -21.3616031
  },
  {
    lng: -41.2648448,
    lat: -21.3616055
  },
  {
    lng: -41.2648453,
    lat: -21.3616079
  },
  {
    lng: -41.2648458,
    lat: -21.3616103
  },
  {
    lng: -41.2648464,
    lat: -21.3616127
  },
  {
    lng: -41.2648469,
    lat: -21.3616151
  },
  {
    lng: -41.2648475,
    lat: -21.3616175
  },
  {
    lng: -41.264848,
    lat: -21.3616199
  },
  {
    lng: -41.2648486,
    lat: -21.3616223
  },
  {
    lng: -41.2648491,
    lat: -21.3616247
  },
  {
    lng: -41.2648496,
    lat: -21.3616271
  },
  {
    lng: -41.2648502,
    lat: -21.3616295
  },
  {
    lng: -41.2648507,
    lat: -21.361632
  },
  {
    lng: -41.2648512,
    lat: -21.3616344
  },
  {
    lng: -41.2648517,
    lat: -21.3616368
  },
  {
    lng: -41.2648522,
    lat: -21.3616392
  },
  {
    lng: -41.2648528,
    lat: -21.3616416
  },
  {
    lng: -41.2648531,
    lat: -21.3616441
  },
  {
    lng: -41.2648536,
    lat: -21.3616465
  },
  {
    lng: -41.2648539,
    lat: -21.3616489
  },
  {
    lng: -41.2648544,
    lat: -21.3616513
  },
  {
    lng: -41.2648548,
    lat: -21.3616538
  },
  {
    lng: -41.2648553,
    lat: -21.3616562
  },
  {
    lng: -41.2648558,
    lat: -21.3616586
  },
  {
    lng: -41.2648563,
    lat: -21.361661
  },
  {
    lng: -41.2648568,
    lat: -21.3616634
  },
  {
    lng: -41.2648573,
    lat: -21.3616658
  },
  {
    lng: -41.2648576,
    lat: -21.3616683
  },
  {
    lng: -41.264858,
    lat: -21.3616707
  },
  {
    lng: -41.2648583,
    lat: -21.3616732
  },
  {
    lng: -41.2648586,
    lat: -21.3616756
  },
  {
    lng: -41.2648589,
    lat: -21.3616781
  },
  {
    lng: -41.2648593,
    lat: -21.3616805
  },
  {
    lng: -41.2648596,
    lat: -21.361683
  },
  {
    lng: -41.2648601,
    lat: -21.3616854
  },
  {
    lng: -41.2648604,
    lat: -21.3616878
  },
  {
    lng: -41.2648609,
    lat: -21.3616903
  },
  {
    lng: -41.2648612,
    lat: -21.3616927
  },
  {
    lng: -41.2648615,
    lat: -21.3616952
  },
  {
    lng: -41.2648617,
    lat: -21.3616976
  },
  {
    lng: -41.264862,
    lat: -21.3617001
  },
  {
    lng: -41.2648623,
    lat: -21.3617025
  },
  {
    lng: -41.2648626,
    lat: -21.361705
  },
  {
    lng: -41.2648629,
    lat: -21.3617074
  },
  {
    lng: -41.2648631,
    lat: -21.3617099
  },
  {
    lng: -41.2648634,
    lat: -21.3617123
  },
  {
    lng: -41.2648637,
    lat: -21.3617148
  },
  {
    lng: -41.2648639,
    lat: -21.3617172
  },
  {
    lng: -41.2648642,
    lat: -21.3617197
  },
  {
    lng: -41.2648645,
    lat: -21.3617221
  },
  {
    lng: -41.2648647,
    lat: -21.3617246
  },
  {
    lng: -41.264865,
    lat: -21.361727
  },
  {
    lng: -41.2648653,
    lat: -21.3617295
  },
  {
    lng: -41.2648655,
    lat: -21.3617319
  },
  {
    lng: -41.2648657,
    lat: -21.3617344
  },
  {
    lng: -41.264866,
    lat: -21.3617369
  },
  {
    lng: -41.2648662,
    lat: -21.3617393
  },
  {
    lng: -41.2648665,
    lat: -21.3617418
  },
  {
    lng: -41.2648665,
    lat: -21.3617442
  },
  {
    lng: -41.2648668,
    lat: -21.3617467
  },
  {
    lng: -41.2648668,
    lat: -21.3617492
  },
  {
    lng: -41.264867,
    lat: -21.3617516
  },
  {
    lng: -41.2648671,
    lat: -21.3617541
  },
  {
    lng: -41.2648674,
    lat: -21.3617565
  },
  {
    lng: -41.2648676,
    lat: -21.361759
  },
  {
    lng: -41.2648678,
    lat: -21.3617615
  },
  {
    lng: -41.264868,
    lat: -21.3617639
  },
  {
    lng: -41.2648683,
    lat: -21.3617664
  },
  {
    lng: -41.2648683,
    lat: -21.3617688
  },
  {
    lng: -41.2648683,
    lat: -21.3617713
  },
  {
    lng: -41.2648684,
    lat: -21.3617738
  },
  {
    lng: -41.2648684,
    lat: -21.3617762
  },
  {
    lng: -41.2648684,
    lat: -21.3617787
  },
  {
    lng: -41.2648685,
    lat: -21.3617812
  },
  {
    lng: -41.2648685,
    lat: -21.3617836
  },
  {
    lng: -41.2648688,
    lat: -21.3617861
  },
  {
    lng: -41.2648688,
    lat: -21.3617886
  },
  {
    lng: -41.264869,
    lat: -21.361791
  },
  {
    lng: -41.264869,
    lat: -21.3617935
  },
  {
    lng: -41.264869,
    lat: -21.361796
  },
  {
    lng: -41.2648691,
    lat: -21.3617984
  },
  {
    lng: -41.2648691,
    lat: -21.3618009
  },
  {
    lng: -41.2648691,
    lat: -21.3618034
  },
  {
    lng: -41.2648691,
    lat: -21.3618058
  },
  {
    lng: -41.2648691,
    lat: -21.3618083
  },
  {
    lng: -41.2648691,
    lat: -21.3618108
  },
  {
    lng: -41.264869,
    lat: -21.3618132
  },
  {
    lng: -41.264869,
    lat: -21.3618157
  },
  {
    lng: -41.264869,
    lat: -21.3618182
  },
  {
    lng: -41.264869,
    lat: -21.3618206
  },
  {
    lng: -41.264869,
    lat: -21.3618231
  },
  {
    lng: -41.264869,
    lat: -21.3618256
  },
  {
    lng: -41.264869,
    lat: -21.361828
  },
  {
    lng: -41.264869,
    lat: -21.3618305
  },
  {
    lng: -41.2648689,
    lat: -21.361833
  },
  {
    lng: -41.2648689,
    lat: -21.3618354
  },
  {
    lng: -41.2648688,
    lat: -21.3618379
  },
  {
    lng: -41.2648688,
    lat: -21.3618404
  },
  {
    lng: -41.2648688,
    lat: -21.3618428
  },
  {
    lng: -41.2648686,
    lat: -21.3618453
  },
  {
    lng: -41.2648685,
    lat: -21.3618478
  },
  {
    lng: -41.2648682,
    lat: -21.3618502
  },
  {
    lng: -41.2648682,
    lat: -21.3618527
  },
  {
    lng: -41.264868,
    lat: -21.3618552
  },
  {
    lng: -41.264868,
    lat: -21.3618576
  },
  {
    lng: -41.2648679,
    lat: -21.3618601
  },
  {
    lng: -41.2648679,
    lat: -21.3618625
  },
  {
    lng: -41.2648678,
    lat: -21.361865
  },
  {
    lng: -41.2648678,
    lat: -21.3618675
  },
  {
    lng: -41.2648675,
    lat: -21.3618699
  },
  {
    lng: -41.2648673,
    lat: -21.3618724
  },
  {
    lng: -41.264867,
    lat: -21.3618748
  },
  {
    lng: -41.2648668,
    lat: -21.3618773
  },
  {
    lng: -41.2648665,
    lat: -21.3618797
  },
  {
    lng: -41.2648664,
    lat: -21.3618822
  },
  {
    lng: -41.2648661,
    lat: -21.3618846
  },
  {
    lng: -41.2648661,
    lat: -21.3618871
  },
  {
    lng: -41.2648658,
    lat: -21.3618896
  },
  {
    lng: -41.2648657,
    lat: -21.3618921
  },
  {
    lng: -41.2648655,
    lat: -21.3618945
  },
  {
    lng: -41.2648652,
    lat: -21.361897
  },
  {
    lng: -41.264865,
    lat: -21.3618994
  },
  {
    lng: -41.2648647,
    lat: -21.3619019
  },
  {
    lng: -41.2648644,
    lat: -21.3619043
  },
  {
    lng: -41.2648641,
    lat: -21.3619068
  },
  {
    lng: -41.2648638,
    lat: -21.3619092
  },
  {
    lng: -41.2648635,
    lat: -21.3619117
  },
  {
    lng: -41.2648633,
    lat: -21.3619141
  },
  {
    lng: -41.264863,
    lat: -21.3619166
  },
  {
    lng: -41.2648627,
    lat: -21.361919
  },
  {
    lng: -41.2648624,
    lat: -21.3619215
  },
  {
    lng: -41.2648621,
    lat: -21.3619239
  },
  {
    lng: -41.2648618,
    lat: -21.3619264
  },
  {
    lng: -41.2648615,
    lat: -21.3619288
  },
  {
    lng: -41.2648612,
    lat: -21.3619313
  },
  {
    lng: -41.2648609,
    lat: -21.3619337
  },
  {
    lng: -41.2648606,
    lat: -21.3619362
  },
  {
    lng: -41.2648603,
    lat: -21.3619386
  },
  {
    lng: -41.26486,
    lat: -21.3619411
  },
  {
    lng: -41.2648596,
    lat: -21.3619435
  },
  {
    lng: -41.2648591,
    lat: -21.3619459
  },
  {
    lng: -41.2648588,
    lat: -21.3619484
  },
  {
    lng: -41.2648583,
    lat: -21.3619508
  },
  {
    lng: -41.2648579,
    lat: -21.3619532
  },
  {
    lng: -41.2648575,
    lat: -21.3619557
  },
  {
    lng: -41.2648572,
    lat: -21.3619581
  },
  {
    lng: -41.2648569,
    lat: -21.3619606
  },
  {
    lng: -41.2648565,
    lat: -21.361963
  },
  {
    lng: -41.2648562,
    lat: -21.3619654
  },
  {
    lng: -41.2648559,
    lat: -21.3619679
  },
  {
    lng: -41.2648553,
    lat: -21.3619703
  },
  {
    lng: -41.2648548,
    lat: -21.3619727
  },
  {
    lng: -41.2648542,
    lat: -21.3619751
  },
  {
    lng: -41.2648537,
    lat: -21.3619775
  },
  {
    lng: -41.2648534,
    lat: -21.3619799
  },
  {
    lng: -41.264853,
    lat: -21.3619824
  },
  {
    lng: -41.2648524,
    lat: -21.3619848
  },
  {
    lng: -41.2648518,
    lat: -21.3619872
  },
  {
    lng: -41.2648512,
    lat: -21.3619896
  },
  {
    lng: -41.2648506,
    lat: -21.361992
  },
  {
    lng: -41.26485,
    lat: -21.3619943
  },
  {
    lng: -41.2648494,
    lat: -21.3619967
  },
  {
    lng: -41.2648488,
    lat: -21.3619991
  },
  {
    lng: -41.2648482,
    lat: -21.3620015
  },
  {
    lng: -41.2648476,
    lat: -21.3620039
  },
  {
    lng: -41.2648466,
    lat: -21.3620077
  },
  {
    lng: -41.2648457,
    lat: -21.3620115
  },
  {
    lng: -41.2648446,
    lat: -21.3620152
  },
  {
    lng: -41.2648437,
    lat: -21.362019
  },
  {
    lng: -41.2648427,
    lat: -21.3620228
  },
  {
    lng: -41.2648417,
    lat: -21.3620266
  },
  {
    lng: -41.2648408,
    lat: -21.3620303
  },
  {
    lng: -41.2648398,
    lat: -21.3620341
  },
  {
    lng: -41.2648388,
    lat: -21.3620379
  },
  {
    lng: -41.2648378,
    lat: -21.3620417
  },
  {
    lng: -41.2648367,
    lat: -21.3620454
  },
  {
    lng: -41.2648358,
    lat: -21.3620492
  },
  {
    lng: -41.2648348,
    lat: -21.362053
  },
  {
    lng: -41.2648338,
    lat: -21.3620567
  },
  {
    lng: -41.2648328,
    lat: -21.3620605
  },
  {
    lng: -41.2648318,
    lat: -21.3620643
  },
  {
    lng: -41.2648308,
    lat: -21.362068
  },
  {
    lng: -41.2648298,
    lat: -21.3620718
  },
  {
    lng: -41.2648288,
    lat: -21.3620756
  },
  {
    lng: -41.2648276,
    lat: -21.3620793
  },
  {
    lng: -41.2648263,
    lat: -21.362083
  },
  {
    lng: -41.2648252,
    lat: -21.3620867
  },
  {
    lng: -41.2648242,
    lat: -21.3620905
  },
  {
    lng: -41.2648232,
    lat: -21.3620943
  },
  {
    lng: -41.2648221,
    lat: -21.362098
  },
  {
    lng: -41.2648211,
    lat: -21.3621018
  },
  {
    lng: -41.2648198,
    lat: -21.3621055
  },
  {
    lng: -41.2648186,
    lat: -21.3621092
  },
  {
    lng: -41.2648174,
    lat: -21.3621129
  },
  {
    lng: -41.2648161,
    lat: -21.3621166
  },
  {
    lng: -41.2648149,
    lat: -21.3621203
  },
  {
    lng: -41.2648137,
    lat: -21.362124
  },
  {
    lng: -41.2648125,
    lat: -21.3621277
  },
  {
    lng: -41.2648114,
    lat: -21.3621315
  },
  {
    lng: -41.2648103,
    lat: -21.3621352
  },
  {
    lng: -41.2648091,
    lat: -21.3621389
  },
  {
    lng: -41.2648078,
    lat: -21.3621426
  },
  {
    lng: -41.2648066,
    lat: -21.3621463
  },
  {
    lng: -41.2648053,
    lat: -21.36215
  },
  {
    lng: -41.264804,
    lat: -21.3621537
  },
  {
    lng: -41.2648028,
    lat: -21.3621573
  },
  {
    lng: -41.2648015,
    lat: -21.362161
  },
  {
    lng: -41.2648002,
    lat: -21.3621647
  },
  {
    lng: -41.2647989,
    lat: -21.3621684
  },
  {
    lng: -41.2647976,
    lat: -21.3621721
  },
  {
    lng: -41.2647963,
    lat: -21.3621758
  },
  {
    lng: -41.2647951,
    lat: -21.3621794
  },
  {
    lng: -41.2647938,
    lat: -21.3621831
  },
  {
    lng: -41.2647925,
    lat: -21.3621868
  },
  {
    lng: -41.2647912,
    lat: -21.3621905
  },
  {
    lng: -41.2647899,
    lat: -21.3621942
  },
  {
    lng: -41.2647886,
    lat: -21.3621979
  },
  {
    lng: -41.2647874,
    lat: -21.3622016
  },
  {
    lng: -41.2647861,
    lat: -21.3622052
  },
  {
    lng: -41.2647848,
    lat: -21.3622089
  },
  {
    lng: -41.2647835,
    lat: -21.3622126
  },
  {
    lng: -41.2647822,
    lat: -21.3622163
  },
  {
    lng: -41.2647809,
    lat: -21.3622199
  },
  {
    lng: -41.2647795,
    lat: -21.3622236
  },
  {
    lng: -41.2647781,
    lat: -21.3622272
  },
  {
    lng: -41.2647765,
    lat: -21.3622308
  },
  {
    lng: -41.2647752,
    lat: -21.3622345
  },
  {
    lng: -41.2647738,
    lat: -21.3622381
  },
  {
    lng: -41.2647725,
    lat: -21.3622418
  },
  {
    lng: -41.2647712,
    lat: -21.3622455
  },
  {
    lng: -41.2647699,
    lat: -21.3622491
  },
  {
    lng: -41.2647685,
    lat: -21.3622528
  },
  {
    lng: -41.2647672,
    lat: -21.3622565
  },
  {
    lng: -41.2647657,
    lat: -21.3622601
  },
  {
    lng: -41.2647642,
    lat: -21.3622637
  },
  {
    lng: -41.2647627,
    lat: -21.3622673
  },
  {
    lng: -41.2647612,
    lat: -21.3622709
  },
  {
    lng: -41.2647597,
    lat: -21.3622745
  },
  {
    lng: -41.2647582,
    lat: -21.3622781
  },
  {
    lng: -41.2647569,
    lat: -21.3622818
  },
  {
    lng: -41.2647555,
    lat: -21.3622854
  },
  {
    lng: -41.264754,
    lat: -21.362289
  },
  {
    lng: -41.2647525,
    lat: -21.3622926
  },
  {
    lng: -41.264751,
    lat: -21.3622962
  },
  {
    lng: -41.2647494,
    lat: -21.3622998
  },
  {
    lng: -41.2647479,
    lat: -21.3623034
  },
  {
    lng: -41.2647463,
    lat: -21.3623069
  },
  {
    lng: -41.2647448,
    lat: -21.3623105
  },
  {
    lng: -41.2647432,
    lat: -21.3623141
  },
  {
    lng: -41.2647417,
    lat: -21.3623177
  },
  {
    lng: -41.2647401,
    lat: -21.3623213
  },
  {
    lng: -41.2647386,
    lat: -21.3623248
  },
  {
    lng: -41.264737,
    lat: -21.3623284
  },
  {
    lng: -41.2647355,
    lat: -21.362332
  },
  {
    lng: -41.2647339,
    lat: -21.3623356
  },
  {
    lng: -41.2647324,
    lat: -21.3623391
  },
  {
    lng: -41.2647308,
    lat: -21.3623427
  },
  {
    lng: -41.2647293,
    lat: -21.3623463
  },
  {
    lng: -41.2647277,
    lat: -21.3623499
  },
  {
    lng: -41.2647261,
    lat: -21.3623534
  },
  {
    lng: -41.2647246,
    lat: -21.362357
  },
  {
    lng: -41.264723,
    lat: -21.3623606
  },
  {
    lng: -41.2647215,
    lat: -21.3623642
  },
  {
    lng: -41.2647199,
    lat: -21.3623678
  },
  {
    lng: -41.2647183,
    lat: -21.3623713
  },
  {
    lng: -41.2647168,
    lat: -21.3623749
  },
  {
    lng: -41.2647152,
    lat: -21.3623785
  },
  {
    lng: -41.2647136,
    lat: -21.362382
  },
  {
    lng: -41.2647119,
    lat: -21.3623855
  },
  {
    lng: -41.2647103,
    lat: -21.3623891
  },
  {
    lng: -41.2647085,
    lat: -21.3623926
  },
  {
    lng: -41.2647068,
    lat: -21.3623961
  },
  {
    lng: -41.2647052,
    lat: -21.3623996
  },
  {
    lng: -41.2647036,
    lat: -21.3624032
  },
  {
    lng: -41.264702,
    lat: -21.3624068
  },
  {
    lng: -41.2647004,
    lat: -21.3624103
  },
  {
    lng: -41.2646988,
    lat: -21.3624139
  },
  {
    lng: -41.2646972,
    lat: -21.3624174
  },
  {
    lng: -41.2646956,
    lat: -21.362421
  },
  {
    lng: -41.264694,
    lat: -21.3624245
  },
  {
    lng: -41.2646923,
    lat: -21.3624281
  },
  {
    lng: -41.2646905,
    lat: -21.3624315
  },
  {
    lng: -41.2646888,
    lat: -21.362435
  },
  {
    lng: -41.2646872,
    lat: -21.3624385
  },
  {
    lng: -41.2646856,
    lat: -21.3624421
  },
  {
    lng: -41.264683,
    lat: -21.3624482
  },
  {
    lng: -41.2646804,
    lat: -21.3624543
  },
  {
    lng: -41.2646779,
    lat: -21.3624605
  },
  {
    lng: -41.2646756,
    lat: -21.3624667
  },
  {
    lng: -41.264673,
    lat: -21.3624729
  },
  {
    lng: -41.2646704,
    lat: -21.362479
  },
  {
    lng: -41.2646678,
    lat: -21.3624851
  },
  {
    lng: -41.2646652,
    lat: -21.3624913
  },
  {
    lng: -41.2646626,
    lat: -21.3624974
  },
  {
    lng: -41.26466,
    lat: -21.3625035
  },
  {
    lng: -41.2646574,
    lat: -21.3625096
  },
  {
    lng: -41.2646548,
    lat: -21.3625157
  },
  {
    lng: -41.2646523,
    lat: -21.3625219
  },
  {
    lng: -41.2646499,
    lat: -21.3625281
  },
  {
    lng: -41.2646474,
    lat: -21.3625343
  },
  {
    lng: -41.2646448,
    lat: -21.3625404
  },
  {
    lng: -41.2646422,
    lat: -21.3625465
  },
  {
    lng: -41.2646396,
    lat: -21.3625526
  },
  {
    lng: -41.2646369,
    lat: -21.3625587
  },
  {
    lng: -41.2646343,
    lat: -21.3625648
  },
  {
    lng: -41.2646316,
    lat: -21.3625709
  },
  {
    lng: -41.264629,
    lat: -21.362577
  },
  {
    lng: -41.2646264,
    lat: -21.3625831
  },
  {
    lng: -41.2646237,
    lat: -21.3625892
  },
  {
    lng: -41.2646211,
    lat: -21.3625953
  },
  {
    lng: -41.2646184,
    lat: -21.3626014
  },
  {
    lng: -41.2646158,
    lat: -21.3626075
  },
  {
    lng: -41.2646131,
    lat: -21.3626136
  },
  {
    lng: -41.2646105,
    lat: -21.3626197
  },
  {
    lng: -41.2646078,
    lat: -21.3626258
  },
  {
    lng: -41.2646052,
    lat: -21.3626319
  },
  {
    lng: -41.2646025,
    lat: -21.362638
  },
  {
    lng: -41.2645999,
    lat: -21.3626441
  },
  {
    lng: -41.2645972,
    lat: -21.3626502
  },
  {
    lng: -41.2645946,
    lat: -21.3626563
  },
  {
    lng: -41.264592,
    lat: -21.3626624
  },
  {
    lng: -41.2645893,
    lat: -21.3626685
  },
  {
    lng: -41.2645866,
    lat: -21.3626746
  },
  {
    lng: -41.264584,
    lat: -21.3626807
  },
  {
    lng: -41.2645813,
    lat: -21.3626868
  },
  {
    lng: -41.2645787,
    lat: -21.3626929
  },
  {
    lng: -41.264576,
    lat: -21.362699
  },
  {
    lng: -41.2645734,
    lat: -21.3627051
  },
  {
    lng: -41.2645707,
    lat: -21.3627112
  },
  {
    lng: -41.2645681,
    lat: -21.3627173
  },
  {
    lng: -41.2645654,
    lat: -21.3627234
  },
  {
    lng: -41.2645627,
    lat: -21.3627295
  },
  {
    lng: -41.2645598,
    lat: -21.3627355
  },
  {
    lng: -41.2645571,
    lat: -21.3627416
  },
  {
    lng: -41.2645542,
    lat: -21.3627476
  },
  {
    lng: -41.2645515,
    lat: -21.3627536
  },
  {
    lng: -41.2645488,
    lat: -21.3627597
  },
  {
    lng: -41.2645461,
    lat: -21.3627658
  },
  {
    lng: -41.2645434,
    lat: -21.3627718
  },
  {
    lng: -41.2645407,
    lat: -21.3627779
  },
  {
    lng: -41.2645378,
    lat: -21.3627839
  },
  {
    lng: -41.2645348,
    lat: -21.3627898
  },
  {
    lng: -41.2645319,
    lat: -21.3627958
  },
  {
    lng: -41.264529,
    lat: -21.3628018
  },
  {
    lng: -41.2643583,
    lat: -21.3631402
  },
  {
    lng: -41.2643552,
    lat: -21.3631461
  },
  {
    lng: -41.2643521,
    lat: -21.363152
  },
  {
    lng: -41.2643491,
    lat: -21.3631579
  },
  {
    lng: -41.264346,
    lat: -21.3631638
  },
  {
    lng: -41.2643427,
    lat: -21.3631696
  },
  {
    lng: -41.2643393,
    lat: -21.3631753
  },
  {
    lng: -41.2643361,
    lat: -21.3631811
  },
  {
    lng: -41.2643329,
    lat: -21.363187
  },
  {
    lng: -41.2643297,
    lat: -21.3631928
  },
  {
    lng: -41.2643264,
    lat: -21.3631985
  },
  {
    lng: -41.264323,
    lat: -21.3632042
  },
  {
    lng: -41.2643196,
    lat: -21.3632099
  },
  {
    lng: -41.2643161,
    lat: -21.3632156
  },
  {
    lng: -41.264155,
    lat: -21.3634848
  },
  {
    lng: -41.2641513,
    lat: -21.3634905
  },
  {
    lng: -41.2641474,
    lat: -21.3634961
  },
  {
    lng: -41.2641434,
    lat: -21.3635016
  },
  {
    lng: -41.2641394,
    lat: -21.3635071
  },
  {
    lng: -41.2641355,
    lat: -21.3635127
  },
  {
    lng: -41.2641316,
    lat: -21.3635182
  },
  {
    lng: -41.2641278,
    lat: -21.3635239
  },
  {
    lng: -41.2641239,
    lat: -21.3635295
  },
  {
    lng: -41.2641199,
    lat: -21.363535
  },
  {
    lng: -41.264116,
    lat: -21.3635406
  },
  {
    lng: -41.264112,
    lat: -21.3635461
  },
  {
    lng: -41.264108,
    lat: -21.3635516
  },
  {
    lng: -41.264104,
    lat: -21.3635571
  },
  {
    lng: -41.2641,
    lat: -21.3635626
  },
  {
    lng: -41.264096,
    lat: -21.3635681
  },
  {
    lng: -41.2640919,
    lat: -21.3635736
  },
  {
    lng: -41.2640879,
    lat: -21.3635791
  },
  {
    lng: -41.2640839,
    lat: -21.3635846
  },
  {
    lng: -41.26408,
    lat: -21.3635902
  },
  {
    lng: -41.264076,
    lat: -21.3635957
  },
  {
    lng: -41.2640719,
    lat: -21.3636012
  },
  {
    lng: -41.264068,
    lat: -21.3636067
  },
  {
    lng: -41.264064,
    lat: -21.3636122
  },
  {
    lng: -41.2640599,
    lat: -21.3636177
  },
  {
    lng: -41.2640559,
    lat: -21.3636232
  },
  {
    lng: -41.2640519,
    lat: -21.3636287
  },
  {
    lng: -41.2640479,
    lat: -21.3636342
  },
  {
    lng: -41.2640439,
    lat: -21.3636397
  },
  {
    lng: -41.2640399,
    lat: -21.3636452
  },
  {
    lng: -41.2640359,
    lat: -21.3636507
  },
  {
    lng: -41.2640318,
    lat: -21.3636562
  },
  {
    lng: -41.2640278,
    lat: -21.3636617
  },
  {
    lng: -41.2640238,
    lat: -21.3636672
  },
  {
    lng: -41.2640197,
    lat: -21.3636726
  },
  {
    lng: -41.2640157,
    lat: -21.3636781
  },
  {
    lng: -41.2640117,
    lat: -21.3636836
  },
  {
    lng: -41.2640077,
    lat: -21.3636891
  },
  {
    lng: -41.2640036,
    lat: -21.3636946
  },
  {
    lng: -41.2639996,
    lat: -21.3637001
  },
  {
    lng: -41.2639956,
    lat: -21.3637056
  },
  {
    lng: -41.2639916,
    lat: -21.3637111
  },
  {
    lng: -41.2639875,
    lat: -21.3637166
  },
  {
    lng: -41.2639835,
    lat: -21.3637221
  },
  {
    lng: -41.2639794,
    lat: -21.3637275
  },
  {
    lng: -41.2639753,
    lat: -21.3637329
  },
  {
    lng: -41.263971,
    lat: -21.3637382
  },
  {
    lng: -41.2639669,
    lat: -21.3637437
  },
  {
    lng: -41.2639628,
    lat: -21.3637491
  },
  {
    lng: -41.2639588,
    lat: -21.3637546
  },
  {
    lng: -41.2639547,
    lat: -21.3637601
  },
  {
    lng: -41.2639507,
    lat: -21.3637655
  },
  {
    lng: -41.2639464,
    lat: -21.3637708
  },
  {
    lng: -41.2639422,
    lat: -21.3637762
  },
  {
    lng: -41.2639379,
    lat: -21.3637815
  },
  {
    lng: -41.2639337,
    lat: -21.3637869
  },
  {
    lng: -41.2639297,
    lat: -21.3637923
  },
  {
    lng: -41.2639255,
    lat: -21.3637977
  },
  {
    lng: -41.2639213,
    lat: -21.363803
  },
  {
    lng: -41.263917,
    lat: -21.3638083
  },
  {
    lng: -41.2639127,
    lat: -21.3638136
  },
  {
    lng: -41.2639084,
    lat: -21.3638189
  },
  {
    lng: -41.2639042,
    lat: -21.3638242
  },
  {
    lng: -41.2638999,
    lat: -21.3638295
  },
  {
    lng: -41.2638956,
    lat: -21.3638348
  },
  {
    lng: -41.2638914,
    lat: -21.3638401
  },
  {
    lng: -41.2638871,
    lat: -21.3638454
  },
  {
    lng: -41.2638827,
    lat: -21.3638507
  },
  {
    lng: -41.2638785,
    lat: -21.363856
  },
  {
    lng: -41.2638742,
    lat: -21.3638613
  },
  {
    lng: -41.2638699,
    lat: -21.3638666
  },
  {
    lng: -41.2638656,
    lat: -21.3638718
  },
  {
    lng: -41.2638613,
    lat: -21.3638771
  },
  {
    lng: -41.263857,
    lat: -21.3638824
  },
  {
    lng: -41.2638528,
    lat: -21.3638878
  },
  {
    lng: -41.2638485,
    lat: -21.3638931
  },
  {
    lng: -41.2638442,
    lat: -21.3638983
  },
  {
    lng: -41.2638399,
    lat: -21.3639036
  },
  {
    lng: -41.2638228,
    lat: -21.3639248
  },
  {
    lng: -41.2638185,
    lat: -21.36393
  },
  {
    lng: -41.2638142,
    lat: -21.3639353
  },
  {
    lng: -41.2638099,
    lat: -21.3639406
  },
  {
    lng: -41.2638055,
    lat: -21.3639458
  },
  {
    lng: -41.2638012,
    lat: -21.3639511
  },
  {
    lng: -41.2637969,
    lat: -21.3639564
  },
  {
    lng: -41.2637926,
    lat: -21.3639617
  },
  {
    lng: -41.2637883,
    lat: -21.363967
  },
  {
    lng: -41.263787,
    lat: -21.3639686
  },
  {
    lng: -41.2637856,
    lat: -21.3639702
  },
  {
    lng: -41.2637843,
    lat: -21.3639719
  },
  {
    lng: -41.2637829,
    lat: -21.3639735
  },
  {
    lng: -41.2637816,
    lat: -21.3639751
  },
  {
    lng: -41.2637802,
    lat: -21.3639767
  },
  {
    lng: -41.2637789,
    lat: -21.3639784
  },
  {
    lng: -41.2637775,
    lat: -21.36398
  },
  {
    lng: -41.2637762,
    lat: -21.3639816
  },
  {
    lng: -41.2637749,
    lat: -21.3639833
  },
  {
    lng: -41.2637735,
    lat: -21.3639849
  },
  {
    lng: -41.2637722,
    lat: -21.3639865
  },
  {
    lng: -41.2637708,
    lat: -21.3639881
  },
  {
    lng: -41.2637693,
    lat: -21.3639896
  },
  {
    lng: -41.2637678,
    lat: -21.3639911
  },
  {
    lng: -41.2637663,
    lat: -21.3639927
  },
  {
    lng: -41.263765,
    lat: -21.3639943
  },
  {
    lng: -41.2637636,
    lat: -21.3639959
  },
  {
    lng: -41.2637622,
    lat: -21.3639975
  },
  {
    lng: -41.2637607,
    lat: -21.3639989
  },
  {
    lng: -41.2637592,
    lat: -21.3640004
  },
  {
    lng: -41.2637576,
    lat: -21.3640018
  },
  {
    lng: -41.2637561,
    lat: -21.3640033
  },
  {
    lng: -41.2637546,
    lat: -21.3640047
  },
  {
    lng: -41.2637531,
    lat: -21.3640062
  },
  {
    lng: -41.2637516,
    lat: -21.3640077
  },
  {
    lng: -41.26375,
    lat: -21.3640092
  },
  {
    lng: -41.2637487,
    lat: -21.3640108
  },
  {
    lng: -41.2637471,
    lat: -21.3640122
  },
  {
    lng: -41.2637456,
    lat: -21.3640137
  },
  {
    lng: -41.2637441,
    lat: -21.3640152
  },
  {
    lng: -41.2637426,
    lat: -21.3640167
  },
  {
    lng: -41.2637411,
    lat: -21.3640181
  },
  {
    lng: -41.2637395,
    lat: -21.3640196
  },
  {
    lng: -41.263738,
    lat: -21.364021
  },
  {
    lng: -41.2637364,
    lat: -21.3640225
  },
  {
    lng: -41.2637349,
    lat: -21.3640239
  },
  {
    lng: -41.2637333,
    lat: -21.3640253
  },
  {
    lng: -41.2637317,
    lat: -21.3640267
  },
  {
    lng: -41.2637302,
    lat: -21.3640282
  },
  {
    lng: -41.2637286,
    lat: -21.3640296
  },
  {
    lng: -41.2637271,
    lat: -21.364031
  },
  {
    lng: -41.2637255,
    lat: -21.3640324
  },
  {
    lng: -41.2637239,
    lat: -21.3640339
  },
  {
    lng: -41.2637222,
    lat: -21.3640352
  },
  {
    lng: -41.2637207,
    lat: -21.3640366
  },
  {
    lng: -41.2637191,
    lat: -21.364038
  },
  {
    lng: -41.2637174,
    lat: -21.3640392
  },
  {
    lng: -41.2637158,
    lat: -21.3640406
  },
  {
    lng: -41.2637142,
    lat: -21.364042
  },
  {
    lng: -41.2637126,
    lat: -21.3640434
  },
  {
    lng: -41.263711,
    lat: -21.3640448
  },
  {
    lng: -41.2637094,
    lat: -21.3640462
  },
  {
    lng: -41.2637079,
    lat: -21.3640476
  },
  {
    lng: -41.2637063,
    lat: -21.364049
  },
  {
    lng: -41.2637047,
    lat: -21.3640504
  },
  {
    lng: -41.263703,
    lat: -21.3640517
  },
  {
    lng: -41.2637013,
    lat: -21.3640529
  },
  {
    lng: -41.2636996,
    lat: -21.3640542
  },
  {
    lng: -41.2636979,
    lat: -21.3640555
  },
  {
    lng: -41.2636962,
    lat: -21.3640567
  },
  {
    lng: -41.2636946,
    lat: -21.364058
  },
  {
    lng: -41.2636929,
    lat: -21.3640593
  },
  {
    lng: -41.2636912,
    lat: -21.3640606
  },
  {
    lng: -41.2636895,
    lat: -21.3640618
  },
  {
    lng: -41.2636879,
    lat: -21.3640633
  },
  {
    lng: -41.2636862,
    lat: -21.3640646
  },
  {
    lng: -41.2636845,
    lat: -21.3640658
  },
  {
    lng: -41.2636829,
    lat: -21.3640672
  },
  {
    lng: -41.2636812,
    lat: -21.3640684
  },
  {
    lng: -41.2636795,
    lat: -21.3640697
  },
  {
    lng: -41.2636778,
    lat: -21.3640709
  },
  {
    lng: -41.2636761,
    lat: -21.3640722
  },
  {
    lng: -41.2636744,
    lat: -21.3640734
  },
  {
    lng: -41.2636727,
    lat: -21.3640747
  },
  {
    lng: -41.263671,
    lat: -21.3640759
  },
  {
    lng: -41.2636692,
    lat: -21.3640771
  },
  {
    lng: -41.2636675,
    lat: -21.3640784
  },
  {
    lng: -41.2636658,
    lat: -21.3640796
  },
  {
    lng: -41.263664,
    lat: -21.3640807
  },
  {
    lng: -41.2636623,
    lat: -21.3640819
  },
  {
    lng: -41.2636605,
    lat: -21.3640831
  },
  {
    lng: -41.2636587,
    lat: -21.3640842
  },
  {
    lng: -41.2636569,
    lat: -21.3640854
  },
  {
    lng: -41.2636552,
    lat: -21.3640866
  },
  {
    lng: -41.2636534,
    lat: -21.3640877
  },
  {
    lng: -41.2636517,
    lat: -21.364089
  },
  {
    lng: -41.26365,
    lat: -21.3640902
  },
  {
    lng: -41.2636483,
    lat: -21.3640914
  },
  {
    lng: -41.2636465,
    lat: -21.3640926
  },
  {
    lng: -41.2636448,
    lat: -21.3640938
  },
  {
    lng: -41.2636431,
    lat: -21.364095
  },
  {
    lng: -41.2636412,
    lat: -21.3640961
  },
  {
    lng: -41.2636394,
    lat: -21.3640971
  },
  {
    lng: -41.2636376,
    lat: -21.3640982
  },
  {
    lng: -41.2636358,
    lat: -21.3640993
  },
  {
    lng: -41.2636339,
    lat: -21.3641003
  },
  {
    lng: -41.2636321,
    lat: -21.3641014
  },
  {
    lng: -41.2636303,
    lat: -21.3641025
  },
  {
    lng: -41.2636285,
    lat: -21.3641036
  },
  {
    lng: -41.2636267,
    lat: -21.3641048
  },
  {
    lng: -41.2636249,
    lat: -21.3641059
  },
  {
    lng: -41.2636231,
    lat: -21.3641069
  },
  {
    lng: -41.2636213,
    lat: -21.3641081
  },
  {
    lng: -41.2636195,
    lat: -21.3641091
  },
  {
    lng: -41.2636176,
    lat: -21.3641102
  },
  {
    lng: -41.2636158,
    lat: -21.3641112
  },
  {
    lng: -41.263614,
    lat: -21.3641123
  },
  {
    lng: -41.2636121,
    lat: -21.3641133
  },
  {
    lng: -41.2636103,
    lat: -21.3641143
  },
  {
    lng: -41.2636084,
    lat: -21.3641154
  },
  {
    lng: -41.2636066,
    lat: -21.3641164
  },
  {
    lng: -41.2636047,
    lat: -21.3641174
  },
  {
    lng: -41.2636029,
    lat: -21.3641184
  },
  {
    lng: -41.263601,
    lat: -21.3641195
  },
  {
    lng: -41.2635992,
    lat: -21.3641205
  },
  {
    lng: -41.2635973,
    lat: -21.3641215
  },
  {
    lng: -41.2635954,
    lat: -21.3641224
  },
  {
    lng: -41.2635935,
    lat: -21.3641234
  },
  {
    lng: -41.2635917,
    lat: -21.3641244
  },
  {
    lng: -41.2635897,
    lat: -21.3641252
  },
  {
    lng: -41.2635878,
    lat: -21.3641262
  },
  {
    lng: -41.2635859,
    lat: -21.3641271
  },
  {
    lng: -41.2635841,
    lat: -21.3641281
  },
  {
    lng: -41.2635822,
    lat: -21.3641291
  },
  {
    lng: -41.2635804,
    lat: -21.3641301
  },
  {
    lng: -41.2635785,
    lat: -21.3641311
  },
  {
    lng: -41.2635766,
    lat: -21.3641321
  },
  {
    lng: -41.2635748,
    lat: -21.3641331
  },
  {
    lng: -41.2635728,
    lat: -21.3641339
  },
  {
    lng: -41.2635709,
    lat: -21.3641348
  },
  {
    lng: -41.2635689,
    lat: -21.3641356
  },
  {
    lng: -41.263567,
    lat: -21.3641364
  },
  {
    lng: -41.2635651,
    lat: -21.3641373
  },
  {
    lng: -41.2635631,
    lat: -21.3641381
  },
  {
    lng: -41.2635612,
    lat: -21.364139
  },
  {
    lng: -41.2635593,
    lat: -21.3641398
  },
  {
    lng: -41.2635574,
    lat: -21.3641409
  },
  {
    lng: -41.2635555,
    lat: -21.3641417
  },
  {
    lng: -41.2635535,
    lat: -21.3641425
  },
  {
    lng: -41.2635516,
    lat: -21.3641435
  },
  {
    lng: -41.2635497,
    lat: -21.3641443
  },
  {
    lng: -41.2635477,
    lat: -21.3641451
  },
  {
    lng: -41.2635458,
    lat: -21.364146
  },
  {
    lng: -41.2635438,
    lat: -21.3641468
  },
  {
    lng: -41.2635419,
    lat: -21.3641476
  },
  {
    lng: -41.2635399,
    lat: -21.3641484
  },
  {
    lng: -41.263538,
    lat: -21.3641492
  },
  {
    lng: -41.263536,
    lat: -21.36415
  },
  {
    lng: -41.2635341,
    lat: -21.3641508
  },
  {
    lng: -41.2635321,
    lat: -21.3641516
  },
  {
    lng: -41.2635301,
    lat: -21.3641524
  },
  {
    lng: -41.2635282,
    lat: -21.3641532
  },
  {
    lng: -41.2635262,
    lat: -21.3641539
  },
  {
    lng: -41.2635242,
    lat: -21.3641546
  },
  {
    lng: -41.2635222,
    lat: -21.3641554
  },
  {
    lng: -41.2635202,
    lat: -21.3641561
  },
  {
    lng: -41.2635182,
    lat: -21.3641567
  },
  {
    lng: -41.2635162,
    lat: -21.3641575
  },
  {
    lng: -41.2635142,
    lat: -21.3641582
  },
  {
    lng: -41.2635123,
    lat: -21.3641589
  },
  {
    lng: -41.2635103,
    lat: -21.3641597
  },
  {
    lng: -41.2635083,
    lat: -21.3641605
  },
  {
    lng: -41.2635064,
    lat: -21.3641613
  },
  {
    lng: -41.2635044,
    lat: -21.364162
  },
  {
    lng: -41.2635024,
    lat: -21.3641628
  },
  {
    lng: -41.2635004,
    lat: -21.3641633
  },
  {
    lng: -41.2634984,
    lat: -21.3641638
  },
  {
    lng: -41.2634963,
    lat: -21.3641644
  },
  {
    lng: -41.2634943,
    lat: -21.3641652
  },
  {
    lng: -41.2634923,
    lat: -21.3641659
  },
  {
    lng: -41.2634903,
    lat: -21.3641664
  },
  {
    lng: -41.2634882,
    lat: -21.3641668
  },
  {
    lng: -41.2634862,
    lat: -21.3641673
  },
  {
    lng: -41.2634841,
    lat: -21.3641678
  },
  {
    lng: -41.2634821,
    lat: -21.3641683
  },
  {
    lng: -41.26348,
    lat: -21.3641688
  },
  {
    lng: -41.263478,
    lat: -21.3641692
  },
  {
    lng: -41.2632975,
    lat: -21.3642092
  },
  {
    lng: -41.2632925,
    lat: -21.3642103
  },
  {
    lng: -41.2632876,
    lat: -21.3642114
  },
  {
    lng: -41.2632826,
    lat: -21.3642125
  },
  {
    lng: -41.2632777,
    lat: -21.3642135
  },
  {
    lng: -41.2632727,
    lat: -21.3642146
  },
  {
    lng: -41.2632678,
    lat: -21.3642157
  },
  {
    lng: -41.2632628,
    lat: -21.3642167
  },
  {
    lng: -41.2632578,
    lat: -21.3642176
  },
  {
    lng: -41.2632528,
    lat: -21.3642184
  },
  {
    lng: -41.2632479,
    lat: -21.3642193
  },
  {
    lng: -41.2632429,
    lat: -21.3642204
  },
  {
    lng: -41.263238,
    lat: -21.3642214
  },
  {
    lng: -41.2632329,
    lat: -21.3642221
  },
  {
    lng: -41.2632279,
    lat: -21.3642228
  },
  {
    lng: -41.2632229,
    lat: -21.3642235
  },
  {
    lng: -41.2632179,
    lat: -21.3642243
  },
  {
    lng: -41.2629488,
    lat: -21.3642589
  },
  {
    lng: -41.2629452,
    lat: -21.3642593
  },
  {
    lng: -41.2629416,
    lat: -21.3642596
  },
  {
    lng: -41.262938,
    lat: -21.36426
  },
  {
    lng: -41.2629343,
    lat: -21.3642601
  },
  {
    lng: -41.2629307,
    lat: -21.3642601
  },
  {
    lng: -41.2629271,
    lat: -21.3642602
  },
  {
    lng: -41.2629235,
    lat: -21.3642605
  },
  {
    lng: -41.2629198,
    lat: -21.3642607
  },
  {
    lng: -41.2629162,
    lat: -21.3642607
  },
  {
    lng: -41.2629126,
    lat: -21.3642607
  },
  {
    lng: -41.2629089,
    lat: -21.3642607
  },
  {
    lng: -41.2629053,
    lat: -21.3642607
  },
  {
    lng: -41.2629017,
    lat: -21.3642607
  },
  {
    lng: -41.262898,
    lat: -21.3642608
  },
  {
    lng: -41.2628944,
    lat: -21.3642608
  },
  {
    lng: -41.2628908,
    lat: -21.3642608
  },
  {
    lng: -41.2628871,
    lat: -21.3642609
  },
  {
    lng: -41.2627454,
    lat: -21.3642602
  },
  {
    lng: -41.2627417,
    lat: -21.3642601
  },
  {
    lng: -41.2627381,
    lat: -21.36426
  },
  {
    lng: -41.2627345,
    lat: -21.36426
  },
  {
    lng: -41.2627308,
    lat: -21.3642599
  },
  {
    lng: -41.2627272,
    lat: -21.3642599
  },
  {
    lng: -41.2627236,
    lat: -21.3642598
  },
  {
    lng: -41.2627199,
    lat: -21.3642598
  },
  {
    lng: -41.2627163,
    lat: -21.3642598
  },
  {
    lng: -41.2627127,
    lat: -21.3642597
  },
  {
    lng: -41.2627091,
    lat: -21.3642595
  },
  {
    lng: -41.2627054,
    lat: -21.3642592
  },
  {
    lng: -41.2627018,
    lat: -21.364259
  },
  {
    lng: -41.2626982,
    lat: -21.3642589
  },
  {
    lng: -41.2626945,
    lat: -21.3642588
  },
  {
    lng: -41.2626909,
    lat: -21.3642585
  },
  {
    lng: -41.2626873,
    lat: -21.3642581
  },
  {
    lng: -41.2626837,
    lat: -21.3642578
  },
  {
    lng: -41.2626801,
    lat: -21.3642574
  },
  {
    lng: -41.2626764,
    lat: -21.3642572
  },
  {
    lng: -41.2626728,
    lat: -21.3642568
  },
  {
    lng: -41.2626692,
    lat: -21.3642567
  },
  {
    lng: -41.2626656,
    lat: -21.3642565
  },
  {
    lng: -41.2626619,
    lat: -21.3642561
  },
  {
    lng: -41.2626583,
    lat: -21.3642558
  },
  {
    lng: -41.2626547,
    lat: -21.3642554
  },
  {
    lng: -41.2626511,
    lat: -21.364255
  },
  {
    lng: -41.2626475,
    lat: -21.3642546
  },
  {
    lng: -41.2626439,
    lat: -21.3642542
  },
  {
    lng: -41.2626402,
    lat: -21.3642538
  },
  {
    lng: -41.2626366,
    lat: -21.3642534
  },
  {
    lng: -41.262633,
    lat: -21.364253
  },
  {
    lng: -41.2626294,
    lat: -21.3642527
  },
  {
    lng: -41.2626258,
    lat: -21.3642523
  },
  {
    lng: -41.2626222,
    lat: -21.3642519
  },
  {
    lng: -41.2626186,
    lat: -21.3642515
  },
  {
    lng: -41.2626149,
    lat: -21.3642511
  },
  {
    lng: -41.2626113,
    lat: -21.3642507
  },
  {
    lng: -41.2626077,
    lat: -21.3642503
  },
  {
    lng: -41.2626041,
    lat: -21.3642499
  },
  {
    lng: -41.2626005,
    lat: -21.3642495
  },
  {
    lng: -41.2625969,
    lat: -21.3642491
  },
  {
    lng: -41.2625933,
    lat: -21.3642487
  },
  {
    lng: -41.2625897,
    lat: -21.3642483
  },
  {
    lng: -41.262586,
    lat: -21.3642479
  },
  {
    lng: -41.2625824,
    lat: -21.3642475
  },
  {
    lng: -41.2625788,
    lat: -21.364247
  },
  {
    lng: -41.2625752,
    lat: -21.3642466
  },
  {
    lng: -41.2625716,
    lat: -21.3642462
  },
  {
    lng: -41.262568,
    lat: -21.3642458
  },
  {
    lng: -41.2625644,
    lat: -21.3642454
  },
  {
    lng: -41.2625608,
    lat: -21.364245
  },
  {
    lng: -41.2625572,
    lat: -21.3642445
  },
  {
    lng: -41.2625536,
    lat: -21.3642439
  },
  {
    lng: -41.26255,
    lat: -21.3642433
  },
  {
    lng: -41.2625464,
    lat: -21.3642428
  },
  {
    lng: -41.2625428,
    lat: -21.3642423
  },
  {
    lng: -41.2625392,
    lat: -21.3642419
  },
  {
    lng: -41.2625356,
    lat: -21.3642414
  },
  {
    lng: -41.262532,
    lat: -21.364241
  },
  {
    lng: -41.2625284,
    lat: -21.3642405
  },
  {
    lng: -41.2625247,
    lat: -21.3642401
  },
  {
    lng: -41.2625211,
    lat: -21.3642396
  },
  {
    lng: -41.2625175,
    lat: -21.3642392
  },
  {
    lng: -41.2625139,
    lat: -21.3642386
  },
  {
    lng: -41.2625104,
    lat: -21.364238
  },
  {
    lng: -41.2625068,
    lat: -21.3642373
  },
  {
    lng: -41.2625032,
    lat: -21.3642369
  },
  {
    lng: -41.2624996,
    lat: -21.3642365
  },
  {
    lng: -41.262496,
    lat: -21.3642361
  },
  {
    lng: -41.2624924,
    lat: -21.3642357
  },
  {
    lng: -41.2624887,
    lat: -21.3642353
  },
  {
    lng: -41.262375,
    lat: -21.3642227
  },
  {
    lng: -41.2623724,
    lat: -21.3642225
  },
  {
    lng: -41.2623697,
    lat: -21.3642222
  },
  {
    lng: -41.262367,
    lat: -21.3642219
  },
  {
    lng: -41.2623643,
    lat: -21.3642216
  },
  {
    lng: -41.2623616,
    lat: -21.3642213
  },
  {
    lng: -41.262359,
    lat: -21.364221
  },
  {
    lng: -41.2623563,
    lat: -21.364221
  },
  {
    lng: -41.2623536,
    lat: -21.364221
  },
  {
    lng: -41.2623509,
    lat: -21.3642208
  },
  {
    lng: -41.2623482,
    lat: -21.3642206
  },
  {
    lng: -41.2623455,
    lat: -21.3642204
  },
  {
    lng: -41.2623428,
    lat: -21.3642204
  },
  {
    lng: -41.2623401,
    lat: -21.3642205
  },
  {
    lng: -41.2623374,
    lat: -21.3642205
  },
  {
    lng: -41.2623347,
    lat: -21.3642206
  },
  {
    lng: -41.262332,
    lat: -21.3642205
  },
  {
    lng: -41.2623293,
    lat: -21.3642206
  },
  {
    lng: -41.2623266,
    lat: -21.3642204
  },
  {
    lng: -41.2623239,
    lat: -21.3642203
  },
  {
    lng: -41.2623212,
    lat: -21.3642204
  },
  {
    lng: -41.2623185,
    lat: -21.3642204
  },
  {
    lng: -41.2623158,
    lat: -21.3642205
  },
  {
    lng: -41.2623131,
    lat: -21.3642205
  },
  {
    lng: -41.2623104,
    lat: -21.3642206
  },
  {
    lng: -41.2623077,
    lat: -21.3642207
  },
  {
    lng: -41.262305,
    lat: -21.3642208
  },
  {
    lng: -41.2623023,
    lat: -21.3642208
  },
  {
    lng: -41.2622996,
    lat: -21.3642209
  },
  {
    lng: -41.2622969,
    lat: -21.364221
  },
  {
    lng: -41.2622943,
    lat: -21.3642211
  },
  {
    lng: -41.2622916,
    lat: -21.3642212
  },
  {
    lng: -41.2622889,
    lat: -21.3642213
  },
  {
    lng: -41.2622862,
    lat: -21.3642214
  },
  {
    lng: -41.2622835,
    lat: -21.3642215
  },
  {
    lng: -41.2622808,
    lat: -21.3642216
  },
  {
    lng: -41.2622781,
    lat: -21.3642216
  },
  {
    lng: -41.2622754,
    lat: -21.3642217
  },
  {
    lng: -41.2622727,
    lat: -21.3642218
  },
  {
    lng: -41.26227,
    lat: -21.3642219
  },
  {
    lng: -41.2622673,
    lat: -21.364222
  },
  {
    lng: -41.2622646,
    lat: -21.3642221
  },
  {
    lng: -41.2622619,
    lat: -21.3642222
  },
  {
    lng: -41.2622592,
    lat: -21.3642223
  },
  {
    lng: -41.2622565,
    lat: -21.3642224
  },
  {
    lng: -41.2622538,
    lat: -21.3642226
  },
  {
    lng: -41.2622511,
    lat: -21.3642227
  },
  {
    lng: -41.2622484,
    lat: -21.3642228
  },
  {
    lng: -41.2622457,
    lat: -21.3642231
  },
  {
    lng: -41.262243,
    lat: -21.3642235
  },
  {
    lng: -41.2622403,
    lat: -21.3642236
  },
  {
    lng: -41.2622377,
    lat: -21.3642238
  },
  {
    lng: -41.262235,
    lat: -21.3642239
  },
  {
    lng: -41.2622323,
    lat: -21.3642241
  },
  {
    lng: -41.2622296,
    lat: -21.3642242
  },
  {
    lng: -41.2622269,
    lat: -21.3642244
  },
  {
    lng: -41.2622242,
    lat: -21.3642247
  },
  {
    lng: -41.2622215,
    lat: -21.364225
  },
  {
    lng: -41.2622189,
    lat: -21.3642254
  },
  {
    lng: -41.2622162,
    lat: -21.3642257
  },
  {
    lng: -41.2622135,
    lat: -21.364226
  },
  {
    lng: -41.2622108,
    lat: -21.3642264
  },
  {
    lng: -41.2622081,
    lat: -21.3642265
  },
  {
    lng: -41.2622054,
    lat: -21.3642267
  },
  {
    lng: -41.2622027,
    lat: -21.364227
  },
  {
    lng: -41.2622001,
    lat: -21.3642274
  },
  {
    lng: -41.2621974,
    lat: -21.3642277
  },
  {
    lng: -41.2621947,
    lat: -21.3642281
  },
  {
    lng: -41.2621921,
    lat: -21.3642285
  },
  {
    lng: -41.2621894,
    lat: -21.3642289
  },
  {
    lng: -41.2621867,
    lat: -21.3642293
  },
  {
    lng: -41.262184,
    lat: -21.3642296
  },
  {
    lng: -41.2621814,
    lat: -21.36423
  },
  {
    lng: -41.2621787,
    lat: -21.3642304
  },
  {
    lng: -41.262176,
    lat: -21.3642308
  },
  {
    lng: -41.2621734,
    lat: -21.3642312
  },
  {
    lng: -41.2621707,
    lat: -21.3642316
  },
  {
    lng: -41.262168,
    lat: -21.364232
  },
  {
    lng: -41.2621653,
    lat: -21.3642324
  },
  {
    lng: -41.2621627,
    lat: -21.3642327
  },
  {
    lng: -41.26216,
    lat: -21.3642331
  },
  {
    lng: -41.2621573,
    lat: -21.3642335
  },
  {
    lng: -41.2621547,
    lat: -21.3642339
  },
  {
    lng: -41.262152,
    lat: -21.3642343
  },
  {
    lng: -41.2621493,
    lat: -21.3642347
  },
  {
    lng: -41.2621467,
    lat: -21.3642351
  },
  {
    lng: -41.262144,
    lat: -21.3642355
  },
  {
    lng: -41.2621413,
    lat: -21.3642359
  },
  {
    lng: -41.2621387,
    lat: -21.3642363
  },
  {
    lng: -41.262136,
    lat: -21.3642367
  },
  {
    lng: -41.2621333,
    lat: -21.3642371
  },
  {
    lng: -41.2621307,
    lat: -21.3642376
  },
  {
    lng: -41.262128,
    lat: -21.364238
  },
  {
    lng: -41.2621254,
    lat: -21.3642386
  },
  {
    lng: -41.2621227,
    lat: -21.3642393
  },
  {
    lng: -41.2621201,
    lat: -21.3642397
  },
  {
    lng: -41.2621174,
    lat: -21.3642402
  },
  {
    lng: -41.2621148,
    lat: -21.3642406
  },
  {
    lng: -41.2621121,
    lat: -21.3642411
  },
  {
    lng: -41.2621094,
    lat: -21.3642415
  },
  {
    lng: -41.2621068,
    lat: -21.3642419
  },
  {
    lng: -41.2621042,
    lat: -21.3642426
  },
  {
    lng: -41.2621015,
    lat: -21.3642432
  },
  {
    lng: -41.2620989,
    lat: -21.3642438
  },
  {
    lng: -41.2620963,
    lat: -21.3642445
  },
  {
    lng: -41.2620937,
    lat: -21.3642451
  },
  {
    lng: -41.262091,
    lat: -21.3642457
  },
  {
    lng: -41.2620884,
    lat: -21.3642463
  },
  {
    lng: -41.2620857,
    lat: -21.3642467
  },
  {
    lng: -41.2620831,
    lat: -21.3642474
  },
  {
    lng: -41.2620804,
    lat: -21.3642478
  },
  {
    lng: -41.2620778,
    lat: -21.3642485
  },
  {
    lng: -41.2620752,
    lat: -21.3642491
  },
  {
    lng: -41.2620726,
    lat: -21.3642498
  },
  {
    lng: -41.26207,
    lat: -21.3642504
  },
  {
    lng: -41.2620674,
    lat: -21.3642511
  },
  {
    lng: -41.2620647,
    lat: -21.3642517
  },
  {
    lng: -41.2620621,
    lat: -21.3642524
  },
  {
    lng: -41.2620595,
    lat: -21.3642531
  },
  {
    lng: -41.2620569,
    lat: -21.3642537
  },
  {
    lng: -41.2620543,
    lat: -21.3642544
  },
  {
    lng: -41.2620517,
    lat: -21.3642551
  },
  {
    lng: -41.262049,
    lat: -21.3642558
  },
  {
    lng: -41.2620464,
    lat: -21.3642564
  },
  {
    lng: -41.2620438,
    lat: -21.3642571
  },
  {
    lng: -41.2620412,
    lat: -21.3642578
  },
  {
    lng: -41.2620386,
    lat: -21.3642585
  },
  {
    lng: -41.262036,
    lat: -21.3642592
  },
  {
    lng: -41.2620334,
    lat: -21.3642599
  },
  {
    lng: -41.2620308,
    lat: -21.3642606
  },
  {
    lng: -41.2620282,
    lat: -21.3642613
  },
  {
    lng: -41.2620256,
    lat: -21.3642622
  },
  {
    lng: -41.262023,
    lat: -21.3642629
  },
  {
    lng: -41.2620205,
    lat: -21.3642638
  },
  {
    lng: -41.2620179,
    lat: -21.3642645
  },
  {
    lng: -41.2620153,
    lat: -21.3642653
  },
  {
    lng: -41.2620127,
    lat: -21.364266
  },
  {
    lng: -41.2620101,
    lat: -21.3642667
  },
  {
    lng: -41.2620075,
    lat: -21.3642674
  },
  {
    lng: -41.2620049,
    lat: -21.3642681
  },
  {
    lng: -41.2620023,
    lat: -21.3642688
  },
  {
    lng: -41.2619997,
    lat: -21.3642697
  },
  {
    lng: -41.2619972,
    lat: -21.3642706
  },
  {
    lng: -41.2619946,
    lat: -21.3642715
  },
  {
    lng: -41.2619921,
    lat: -21.3642724
  },
  {
    lng: -41.2619895,
    lat: -21.3642733
  },
  {
    lng: -41.261987,
    lat: -21.3642741
  },
  {
    lng: -41.2619844,
    lat: -21.364275
  },
  {
    lng: -41.2619818,
    lat: -21.3642757
  },
  {
    lng: -41.2619793,
    lat: -21.3642766
  },
  {
    lng: -41.2619767,
    lat: -21.3642774
  },
  {
    lng: -41.2619741,
    lat: -21.3642783
  },
  {
    lng: -41.2619716,
    lat: -21.3642792
  },
  {
    lng: -41.261969,
    lat: -21.3642801
  },
  {
    lng: -41.2619665,
    lat: -21.364281
  },
  {
    lng: -41.261964,
    lat: -21.3642819
  },
  {
    lng: -41.2619614,
    lat: -21.3642828
  },
  {
    lng: -41.2619589,
    lat: -21.3642837
  },
  {
    lng: -41.2619563,
    lat: -21.3642846
  },
  {
    lng: -41.2619538,
    lat: -21.3642855
  },
  {
    lng: -41.2619513,
    lat: -21.3642865
  },
  {
    lng: -41.2619487,
    lat: -21.3642874
  },
  {
    lng: -41.2619462,
    lat: -21.3642883
  },
  {
    lng: -41.2619437,
    lat: -21.3642893
  },
  {
    lng: -41.2619411,
    lat: -21.3642902
  },
  {
    lng: -41.2619386,
    lat: -21.3642912
  },
  {
    lng: -41.2619361,
    lat: -21.3642921
  },
  {
    lng: -41.2619336,
    lat: -21.3642931
  },
  {
    lng: -41.261931,
    lat: -21.364294
  },
  {
    lng: -41.2619285,
    lat: -21.364295
  },
  {
    lng: -41.261926,
    lat: -21.3642961
  },
  {
    lng: -41.2619235,
    lat: -21.364297
  },
  {
    lng: -41.2619211,
    lat: -21.3642982
  },
  {
    lng: -41.2619186,
    lat: -21.3642992
  },
  {
    lng: -41.2619161,
    lat: -21.3643002
  },
  {
    lng: -41.2619135,
    lat: -21.3643012
  },
  {
    lng: -41.261911,
    lat: -21.3643021
  },
  {
    lng: -41.2619085,
    lat: -21.3643031
  },
  {
    lng: -41.261906,
    lat: -21.3643041
  },
  {
    lng: -41.2619035,
    lat: -21.364305
  },
  {
    lng: -41.261901,
    lat: -21.3643062
  },
  {
    lng: -41.2618986,
    lat: -21.3643073
  },
  {
    lng: -41.2618962,
    lat: -21.3643085
  },
  {
    lng: -41.2618937,
    lat: -21.3643096
  },
  {
    lng: -41.2618913,
    lat: -21.3643107
  },
  {
    lng: -41.2618887,
    lat: -21.3643117
  },
  {
    lng: -41.2618862,
    lat: -21.3643127
  },
  {
    lng: -41.2618838,
    lat: -21.3643139
  },
  {
    lng: -41.2618814,
    lat: -21.364315
  },
  {
    lng: -41.2618789,
    lat: -21.3643162
  },
  {
    lng: -41.2618765,
    lat: -21.3643174
  },
  {
    lng: -41.2618741,
    lat: -21.3643186
  },
  {
    lng: -41.2618717,
    lat: -21.3643198
  },
  {
    lng: -41.2618693,
    lat: -21.364321
  },
  {
    lng: -41.2618668,
    lat: -21.3643222
  },
  {
    lng: -41.2618644,
    lat: -21.3643234
  },
  {
    lng: -41.261862,
    lat: -21.3643246
  },
  {
    lng: -41.2618596,
    lat: -21.3643258
  },
  {
    lng: -41.2618572,
    lat: -21.364327
  },
  {
    lng: -41.2618548,
    lat: -21.3643283
  },
  {
    lng: -41.2618307,
    lat: -21.3643403
  },
  {
    lng: -41.2618283,
    lat: -21.3643416
  },
  {
    lng: -41.2618258,
    lat: -21.3643428
  },
  {
    lng: -41.2618234,
    lat: -21.364344
  },
  {
    lng: -41.261821,
    lat: -21.3643452
  },
  {
    lng: -41.2618186,
    lat: -21.3643464
  },
  {
    lng: -41.2618162,
    lat: -21.3643476
  },
  {
    lng: -41.2618138,
    lat: -21.3643488
  },
  {
    lng: -41.2618086,
    lat: -21.3643514
  },
  {
    lng: -41.2618034,
    lat: -21.3643541
  },
  {
    lng: -41.2617983,
    lat: -21.364357
  },
  {
    lng: -41.2617931,
    lat: -21.3643596
  },
  {
    lng: -41.261788,
    lat: -21.3643623
  },
  {
    lng: -41.2617828,
    lat: -21.3643649
  },
  {
    lng: -41.2617776,
    lat: -21.3643676
  },
  {
    lng: -41.2617724,
    lat: -21.3643703
  },
  {
    lng: -41.2617673,
    lat: -21.3643731
  },
  {
    lng: -41.2617621,
    lat: -21.3643758
  },
  {
    lng: -41.2617569,
    lat: -21.3643784
  },
  {
    lng: -41.2617517,
    lat: -21.364381
  },
  {
    lng: -41.2617465,
    lat: -21.3643836
  },
  {
    lng: -41.2614596,
    lat: -21.3645262
  },
  {
    lng: -41.2614544,
    lat: -21.3645288
  },
  {
    lng: -41.2614491,
    lat: -21.3645314
  },
  {
    lng: -41.2614439,
    lat: -21.364534
  },
  {
    lng: -41.2614387,
    lat: -21.3645365
  },
  {
    lng: -41.2614334,
    lat: -21.3645389
  },
  {
    lng: -41.261428,
    lat: -21.3645412
  },
  {
    lng: -41.2614227,
    lat: -21.3645437
  },
  {
    lng: -41.2614175,
    lat: -21.3645462
  },
  {
    lng: -41.2614122,
    lat: -21.3645487
  },
  {
    lng: -41.2614069,
    lat: -21.364551
  },
  {
    lng: -41.2614015,
    lat: -21.3645532
  },
  {
    lng: -41.2613961,
    lat: -21.3645555
  },
  {
    lng: -41.2613908,
    lat: -21.3645578
  },
  {
    lng: -41.2613854,
    lat: -21.3645601
  },
  {
    lng: -41.2613801,
    lat: -21.3645626
  },
  {
    lng: -41.2613748,
    lat: -21.3645648
  },
  {
    lng: -41.2613695,
    lat: -21.3645673
  },
  {
    lng: -41.2613641,
    lat: -21.3645695
  },
  {
    lng: -41.2613587,
    lat: -21.3645718
  },
  {
    lng: -41.2613533,
    lat: -21.364574
  },
  {
    lng: -41.261348,
    lat: -21.3645763
  },
  {
    lng: -41.2613426,
    lat: -21.3645785
  },
  {
    lng: -41.2613372,
    lat: -21.3645807
  },
  {
    lng: -41.2613318,
    lat: -21.3645829
  },
  {
    lng: -41.2613264,
    lat: -21.3645852
  },
  {
    lng: -41.261321,
    lat: -21.3645874
  },
  {
    lng: -41.2613157,
    lat: -21.3645896
  },
  {
    lng: -41.2613103,
    lat: -21.3645918
  },
  {
    lng: -41.2613049,
    lat: -21.3645941
  },
  {
    lng: -41.2612995,
    lat: -21.3645963
  },
  {
    lng: -41.2612941,
    lat: -21.3645985
  },
  {
    lng: -41.2612887,
    lat: -21.3646007
  },
  {
    lng: -41.2612833,
    lat: -21.3646029
  },
  {
    lng: -41.2612779,
    lat: -21.3646052
  },
  {
    lng: -41.2612726,
    lat: -21.3646074
  },
  {
    lng: -41.2612672,
    lat: -21.3646096
  },
  {
    lng: -41.2612618,
    lat: -21.3646118
  },
  {
    lng: -41.2612564,
    lat: -21.364614
  },
  {
    lng: -41.261251,
    lat: -21.3646163
  },
  {
    lng: -41.2612456,
    lat: -21.3646185
  },
  {
    lng: -41.2612402,
    lat: -21.3646207
  },
  {
    lng: -41.2612348,
    lat: -21.3646229
  },
  {
    lng: -41.2612294,
    lat: -21.3646251
  },
  {
    lng: -41.261224,
    lat: -21.3646273
  },
  {
    lng: -41.2612187,
    lat: -21.3646295
  },
  {
    lng: -41.2612133,
    lat: -21.3646317
  },
  {
    lng: -41.2612079,
    lat: -21.3646339
  },
  {
    lng: -41.2612025,
    lat: -21.3646361
  },
  {
    lng: -41.2611971,
    lat: -21.3646383
  },
  {
    lng: -41.2611916,
    lat: -21.3646403
  },
  {
    lng: -41.2611861,
    lat: -21.3646423
  },
  {
    lng: -41.2611807,
    lat: -21.3646445
  },
  {
    lng: -41.2611753,
    lat: -21.3646466
  },
  {
    lng: -41.2611699,
    lat: -21.3646488
  },
  {
    lng: -41.2611645,
    lat: -21.3646509
  },
  {
    lng: -41.2611591,
    lat: -21.3646531
  },
  {
    lng: -41.2611537,
    lat: -21.3646553
  },
  {
    lng: -41.2611482,
    lat: -21.3646575
  },
  {
    lng: -41.2611428,
    lat: -21.3646596
  },
  {
    lng: -41.2611374,
    lat: -21.3646618
  },
  {
    lng: -41.261132,
    lat: -21.3646639
  },
  {
    lng: -41.2611265,
    lat: -21.3646658
  },
  {
    lng: -41.2611211,
    lat: -21.364668
  },
  {
    lng: -41.2611157,
    lat: -21.3646702
  },
  {
    lng: -41.2611103,
    lat: -21.3646724
  },
  {
    lng: -41.2611049,
    lat: -21.3646746
  },
  {
    lng: -41.2610995,
    lat: -21.3646768
  },
  {
    lng: -41.2610467,
    lat: -21.3646984
  },
  {
    lng: -41.2610436,
    lat: -21.3646997
  },
  {
    lng: -41.2610405,
    lat: -21.364701
  },
  {
    lng: -41.2610375,
    lat: -21.3647025
  },
  {
    lng: -41.2610345,
    lat: -21.3647041
  },
  {
    lng: -41.2610314,
    lat: -21.3647054
  },
  {
    lng: -41.2610284,
    lat: -21.3647068
  },
  {
    lng: -41.2610253,
    lat: -21.3647081
  },
  {
    lng: -41.2610222,
    lat: -21.3647094
  },
  {
    lng: -41.2610191,
    lat: -21.3647107
  },
  {
    lng: -41.261016,
    lat: -21.364712
  },
  {
    lng: -41.2610129,
    lat: -21.3647133
  },
  {
    lng: -41.2610098,
    lat: -21.3647146
  },
  {
    lng: -41.2610067,
    lat: -21.3647159
  },
  {
    lng: -41.2610036,
    lat: -21.3647172
  },
  {
    lng: -41.2610005,
    lat: -21.3647185
  },
  {
    lng: -41.2609973,
    lat: -21.3647198
  },
  {
    lng: -41.2609942,
    lat: -21.3647211
  },
  {
    lng: -41.2609911,
    lat: -21.3647224
  },
  {
    lng: -41.260988,
    lat: -21.3647237
  },
  {
    lng: -41.2609849,
    lat: -21.3647249
  },
  {
    lng: -41.2609818,
    lat: -21.3647262
  },
  {
    lng: -41.2609787,
    lat: -21.3647275
  },
  {
    lng: -41.2609756,
    lat: -21.3647288
  },
  {
    lng: -41.2609725,
    lat: -21.3647301
  },
  {
    lng: -41.2609693,
    lat: -21.3647313
  },
  {
    lng: -41.2609662,
    lat: -21.3647325
  },
  {
    lng: -41.260963,
    lat: -21.3647337
  },
  {
    lng: -41.2609599,
    lat: -21.3647348
  },
  {
    lng: -41.2609567,
    lat: -21.364736
  },
  {
    lng: -41.2609536,
    lat: -21.3647372
  },
  {
    lng: -41.2609505,
    lat: -21.3647384
  },
  {
    lng: -41.2609473,
    lat: -21.3647396
  },
  {
    lng: -41.2609441,
    lat: -21.3647407
  },
  {
    lng: -41.2609411,
    lat: -21.3647421
  },
  {
    lng: -41.2609379,
    lat: -21.3647433
  },
  {
    lng: -41.2609348,
    lat: -21.3647446
  },
  {
    lng: -41.2609316,
    lat: -21.3647457
  },
  {
    lng: -41.2609285,
    lat: -21.3647469
  },
  {
    lng: -41.2609253,
    lat: -21.364748
  },
  {
    lng: -41.2609221,
    lat: -21.3647492
  },
  {
    lng: -41.260919,
    lat: -21.3647503
  },
  {
    lng: -41.2609158,
    lat: -21.3647515
  },
  {
    lng: -41.2609127,
    lat: -21.3647526
  },
  {
    lng: -41.2609095,
    lat: -21.3647537
  },
  {
    lng: -41.2609063,
    lat: -21.3647549
  },
  {
    lng: -41.2609031,
    lat: -21.364756
  },
  {
    lng: -41.2609,
    lat: -21.3647571
  },
  {
    lng: -41.2608968,
    lat: -21.3647583
  },
  {
    lng: -41.2608936,
    lat: -21.3647594
  },
  {
    lng: -41.2608905,
    lat: -21.3647605
  },
  {
    lng: -41.2608873,
    lat: -21.3647616
  },
  {
    lng: -41.2608841,
    lat: -21.3647627
  },
  {
    lng: -41.2608809,
    lat: -21.3647637
  },
  {
    lng: -41.2608777,
    lat: -21.3647648
  },
  {
    lng: -41.2608744,
    lat: -21.3647657
  },
  {
    lng: -41.2608713,
    lat: -21.3647668
  },
  {
    lng: -41.2608681,
    lat: -21.3647679
  },
  {
    lng: -41.2608649,
    lat: -21.3647689
  },
  {
    lng: -41.2608617,
    lat: -21.36477
  },
  {
    lng: -41.2608585,
    lat: -21.3647711
  },
  {
    lng: -41.2608554,
    lat: -21.3647722
  },
  {
    lng: -41.2608522,
    lat: -21.3647733
  },
  {
    lng: -41.260849,
    lat: -21.3647744
  },
  {
    lng: -41.2608458,
    lat: -21.3647753
  },
  {
    lng: -41.2608425,
    lat: -21.3647762
  },
  {
    lng: -41.2608393,
    lat: -21.3647771
  },
  {
    lng: -41.260836,
    lat: -21.3647781
  },
  {
    lng: -41.2608328,
    lat: -21.3647789
  },
  {
    lng: -41.2608296,
    lat: -21.3647801
  },
  {
    lng: -41.2608264,
    lat: -21.3647811
  },
  {
    lng: -41.2608232,
    lat: -21.364782
  },
  {
    lng: -41.2608199,
    lat: -21.3647829
  },
  {
    lng: -41.2608167,
    lat: -21.3647837
  },
  {
    lng: -41.2608134,
    lat: -21.3647846
  },
  {
    lng: -41.2608102,
    lat: -21.3647854
  },
  {
    lng: -41.2608069,
    lat: -21.3647863
  },
  {
    lng: -41.2608037,
    lat: -21.3647872
  },
  {
    lng: -41.2608004,
    lat: -21.364788
  },
  {
    lng: -41.2607972,
    lat: -21.3647889
  },
  {
    lng: -41.2607939,
    lat: -21.3647897
  },
  {
    lng: -41.2607907,
    lat: -21.3647906
  },
  {
    lng: -41.2607874,
    lat: -21.3647915
  },
  {
    lng: -41.2607841,
    lat: -21.3647923
  },
  {
    lng: -41.2607809,
    lat: -21.3647931
  },
  {
    lng: -41.2607776,
    lat: -21.364794
  },
  {
    lng: -41.2607744,
    lat: -21.3647948
  },
  {
    lng: -41.2607711,
    lat: -21.3647957
  },
  {
    lng: -41.2607679,
    lat: -21.3647965
  },
  {
    lng: -41.2607646,
    lat: -21.3647974
  },
  {
    lng: -41.2607613,
    lat: -21.3647982
  },
  {
    lng: -41.2607581,
    lat: -21.364799
  },
  {
    lng: -41.2607548,
    lat: -21.3647999
  },
  {
    lng: -41.2607516,
    lat: -21.3648007
  },
  {
    lng: -41.2607483,
    lat: -21.3648016
  },
  {
    lng: -41.260745,
    lat: -21.3648024
  },
  {
    lng: -41.2607418,
    lat: -21.3648033
  },
  {
    lng: -41.2607385,
    lat: -21.3648041
  },
  {
    lng: -41.2607353,
    lat: -21.3648049
  },
  {
    lng: -41.260732,
    lat: -21.3648057
  },
  {
    lng: -41.2607287,
    lat: -21.3648065
  },
  {
    lng: -41.2607255,
    lat: -21.3648074
  },
  {
    lng: -41.2607222,
    lat: -21.3648082
  },
  {
    lng: -41.260719,
    lat: -21.364809
  },
  {
    lng: -41.2607157,
    lat: -21.3648099
  },
  {
    lng: -41.2607124,
    lat: -21.3648107
  },
  {
    lng: -41.2607092,
    lat: -21.3648115
  },
  {
    lng: -41.2607059,
    lat: -21.3648123
  },
  {
    lng: -41.2607027,
    lat: -21.3648131
  },
  {
    lng: -41.2606994,
    lat: -21.3648138
  },
  {
    lng: -41.260696,
    lat: -21.3648143
  },
  {
    lng: -41.2606928,
    lat: -21.3648151
  },
  {
    lng: -41.2606895,
    lat: -21.3648158
  },
  {
    lng: -41.2606862,
    lat: -21.3648166
  },
  {
    lng: -41.2606829,
    lat: -21.3648174
  },
  {
    lng: -41.2606797,
    lat: -21.3648182
  },
  {
    lng: -41.2606764,
    lat: -21.3648188
  },
  {
    lng: -41.260673,
    lat: -21.3648193
  },
  {
    lng: -41.2606697,
    lat: -21.3648199
  },
  {
    lng: -41.2606664,
    lat: -21.3648205
  },
  {
    lng: -41.2606631,
    lat: -21.364821
  },
  {
    lng: -41.2606598,
    lat: -21.3648218
  },
  {
    lng: -41.2606565,
    lat: -21.3648225
  },
  {
    lng: -41.2606532,
    lat: -21.3648231
  },
  {
    lng: -41.2606499,
    lat: -21.3648236
  },
  {
    lng: -41.2606466,
    lat: -21.3648241
  },
  {
    lng: -41.2606432,
    lat: -21.3648246
  },
  {
    lng: -41.2606399,
    lat: -21.3648251
  },
  {
    lng: -41.2606366,
    lat: -21.3648256
  },
  {
    lng: -41.2606333,
    lat: -21.3648262
  },
  {
    lng: -41.2606299,
    lat: -21.3648267
  },
  {
    lng: -41.2606266,
    lat: -21.3648272
  },
  {
    lng: -41.2606233,
    lat: -21.3648277
  },
  {
    lng: -41.26062,
    lat: -21.3648283
  },
  {
    lng: -41.2606166,
    lat: -21.3648288
  },
  {
    lng: -41.2606133,
    lat: -21.3648293
  },
  {
    lng: -41.26061,
    lat: -21.3648298
  },
  {
    lng: -41.2606067,
    lat: -21.3648303
  },
  {
    lng: -41.2606033,
    lat: -21.3648307
  },
  {
    lng: -41.2606,
    lat: -21.3648313
  },
  {
    lng: -41.2605967,
    lat: -21.3648318
  },
  {
    lng: -41.2605934,
    lat: -21.3648323
  },
  {
    lng: -41.26059,
    lat: -21.3648328
  },
  {
    lng: -41.2605867,
    lat: -21.3648332
  },
  {
    lng: -41.2605834,
    lat: -21.3648338
  },
  {
    lng: -41.26058,
    lat: -21.3648343
  },
  {
    lng: -41.2605767,
    lat: -21.3648348
  },
  {
    lng: -41.2605734,
    lat: -21.3648353
  },
  {
    lng: -41.2605701,
    lat: -21.3648358
  },
  {
    lng: -41.2605667,
    lat: -21.3648362
  },
  {
    lng: -41.2605634,
    lat: -21.3648367
  },
  {
    lng: -41.2605601,
    lat: -21.3648372
  },
  {
    lng: -41.2605567,
    lat: -21.3648377
  },
  {
    lng: -41.2605534,
    lat: -21.3648382
  },
  {
    lng: -41.2605501,
    lat: -21.3648387
  },
  {
    lng: -41.2605468,
    lat: -21.3648391
  },
  {
    lng: -41.2605434,
    lat: -21.3648396
  },
  {
    lng: -41.2605401,
    lat: -21.3648401
  },
  {
    lng: -41.2605368,
    lat: -21.3648406
  },
  {
    lng: -41.2605334,
    lat: -21.364841
  },
  {
    lng: -41.2605301,
    lat: -21.3648413
  },
  {
    lng: -41.2605267,
    lat: -21.3648416
  },
  {
    lng: -41.2605234,
    lat: -21.3648419
  },
  {
    lng: -41.26052,
    lat: -21.3648424
  },
  {
    lng: -41.2605167,
    lat: -21.3648428
  },
  {
    lng: -41.2605134,
    lat: -21.3648433
  },
  {
    lng: -41.26051,
    lat: -21.3648437
  },
  {
    lng: -41.2605067,
    lat: -21.364844
  },
  {
    lng: -41.2605033,
    lat: -21.3648442
  },
  {
    lng: -41.2605,
    lat: -21.3648444
  },
  {
    lng: -41.2604966,
    lat: -21.3648447
  },
  {
    lng: -41.2604933,
    lat: -21.3648449
  },
  {
    lng: -41.2604899,
    lat: -21.3648452
  },
  {
    lng: -41.2604866,
    lat: -21.3648455
  },
  {
    lng: -41.2604832,
    lat: -21.3648457
  },
  {
    lng: -41.2604799,
    lat: -21.3648462
  },
  {
    lng: -41.2604765,
    lat: -21.3648464
  },
  {
    lng: -41.2604732,
    lat: -21.3648466
  },
  {
    lng: -41.2604698,
    lat: -21.364847
  },
  {
    lng: -41.2604664,
    lat: -21.3648472
  },
  {
    lng: -41.2604631,
    lat: -21.3648475
  },
  {
    lng: -41.2604597,
    lat: -21.3648477
  },
  {
    lng: -41.2604564,
    lat: -21.3648479
  },
  {
    lng: -41.260453,
    lat: -21.3648481
  },
  {
    lng: -41.2604497,
    lat: -21.3648483
  },
  {
    lng: -41.2604463,
    lat: -21.3648485
  },
  {
    lng: -41.2604429,
    lat: -21.3648487
  },
  {
    lng: -41.2604396,
    lat: -21.3648489
  },
  {
    lng: -41.2604362,
    lat: -21.3648491
  },
  {
    lng: -41.2604329,
    lat: -21.3648493
  },
  {
    lng: -41.2604295,
    lat: -21.3648495
  },
  {
    lng: -41.2604261,
    lat: -21.3648497
  },
  {
    lng: -41.2604228,
    lat: -21.3648497
  },
  {
    lng: -41.2604194,
    lat: -21.3648499
  },
  {
    lng: -41.2604161,
    lat: -21.36485
  },
  {
    lng: -41.2604127,
    lat: -21.36485
  },
  {
    lng: -41.2604093,
    lat: -21.3648502
  },
  {
    lng: -41.260406,
    lat: -21.3648503
  },
  {
    lng: -41.2604026,
    lat: -21.3648504
  },
  {
    lng: -41.2603992,
    lat: -21.3648506
  },
  {
    lng: -41.2603959,
    lat: -21.3648508
  },
  {
    lng: -41.2603925,
    lat: -21.3648509
  },
  {
    lng: -41.2603892,
    lat: -21.3648511
  },
  {
    lng: -41.2603858,
    lat: -21.3648513
  },
  {
    lng: -41.2603826,
    lat: -21.3648511
  },
  {
    lng: -41.2603795,
    lat: -21.3648509
  },
  {
    lng: -41.2603763,
    lat: -21.3648507
  },
  {
    lng: -41.2603731,
    lat: -21.3648505
  },
  {
    lng: -41.2603699,
    lat: -21.3648505
  },
  {
    lng: -41.2603668,
    lat: -21.3648505
  },
  {
    lng: -41.2603636,
    lat: -21.3648503
  },
  {
    lng: -41.2603604,
    lat: -21.36485
  },
  {
    lng: -41.2603573,
    lat: -21.3648498
  },
  {
    lng: -41.2603541,
    lat: -21.3648495
  },
  {
    lng: -41.2603509,
    lat: -21.3648493
  },
  {
    lng: -41.2603478,
    lat: -21.364849
  },
  {
    lng: -41.2603446,
    lat: -21.3648488
  },
  {
    lng: -41.2603414,
    lat: -21.3648485
  },
  {
    lng: -41.2603383,
    lat: -21.3648483
  },
  {
    lng: -41.2603351,
    lat: -21.364848
  },
  {
    lng: -41.2603319,
    lat: -21.3648478
  },
  {
    lng: -41.2603288,
    lat: -21.3648475
  },
  {
    lng: -41.2603256,
    lat: -21.3648473
  },
  {
    lng: -41.2603224,
    lat: -21.364847
  },
  {
    lng: -41.2603193,
    lat: -21.3648467
  },
  {
    lng: -41.2603161,
    lat: -21.3648465
  },
  {
    lng: -41.2603129,
    lat: -21.3648462
  },
  {
    lng: -41.2603098,
    lat: -21.364846
  },
  {
    lng: -41.2603066,
    lat: -21.3648457
  },
  {
    lng: -41.2602939,
    lat: -21.3648446
  },
  {
    lng: -41.2602908,
    lat: -21.3648444
  },
  {
    lng: -41.2602876,
    lat: -21.3648441
  },
  {
    lng: -41.2602844,
    lat: -21.3648438
  },
  {
    lng: -41.2602813,
    lat: -21.3648436
  },
  {
    lng: -41.2602781,
    lat: -21.3648433
  },
  {
    lng: -41.2602749,
    lat: -21.364843
  },
  {
    lng: -41.2602718,
    lat: -21.3648427
  },
  {
    lng: -41.2602686,
    lat: -21.3648425
  },
  {
    lng: -41.2602654,
    lat: -21.3648422
  },
  {
    lng: -41.2602623,
    lat: -21.364842
  },
  {
    lng: -41.2602591,
    lat: -21.3648416
  },
  {
    lng: -41.2602559,
    lat: -21.3648414
  },
  {
    lng: -41.2602528,
    lat: -21.3648411
  },
  {
    lng: -41.2602496,
    lat: -21.3648408
  },
  {
    lng: -41.2602465,
    lat: -21.3648405
  },
  {
    lng: -41.2602433,
    lat: -21.3648402
  },
  {
    lng: -41.2602401,
    lat: -21.3648399
  },
  {
    lng: -41.260237,
    lat: -21.3648397
  },
  {
    lng: -41.2602338,
    lat: -21.3648393
  },
  {
    lng: -41.2602307,
    lat: -21.3648389
  },
  {
    lng: -41.2602275,
    lat: -21.3648383
  },
  {
    lng: -41.2602244,
    lat: -21.3648379
  },
  {
    lng: -41.2602212,
    lat: -21.3648376
  },
  {
    lng: -41.2602181,
    lat: -21.3648373
  },
  {
    lng: -41.2602149,
    lat: -21.364837
  },
  {
    lng: -41.2602118,
    lat: -21.3648364
  },
  {
    lng: -41.2602086,
    lat: -21.3648359
  },
  {
    lng: -41.2602055,
    lat: -21.3648354
  },
  {
    lng: -41.2602024,
    lat: -21.3648348
  },
  {
    lng: -41.2601993,
    lat: -21.3648343
  },
  {
    lng: -41.2601961,
    lat: -21.3648338
  },
  {
    lng: -41.260193,
    lat: -21.3648333
  },
  {
    lng: -41.2601899,
    lat: -21.3648327
  },
  {
    lng: -41.2601867,
    lat: -21.3648324
  },
  {
    lng: -41.2601835,
    lat: -21.3648318
  },
  {
    lng: -41.2601804,
    lat: -21.3648314
  },
  {
    lng: -41.2601773,
    lat: -21.3648309
  },
  {
    lng: -41.2601741,
    lat: -21.3648303
  },
  {
    lng: -41.260171,
    lat: -21.3648298
  },
  {
    lng: -41.2601679,
    lat: -21.3648292
  },
  {
    lng: -41.2601648,
    lat: -21.3648287
  },
  {
    lng: -41.2601616,
    lat: -21.3648281
  },
  {
    lng: -41.2601585,
    lat: -21.3648275
  },
  {
    lng: -41.2601554,
    lat: -21.3648269
  },
  {
    lng: -41.2601522,
    lat: -21.3648264
  },
  {
    lng: -41.2601491,
    lat: -21.3648258
  },
  {
    lng: -41.260146,
    lat: -21.3648252
  },
  {
    lng: -41.2601429,
    lat: -21.3648246
  },
  {
    lng: -41.2601398,
    lat: -21.364824
  },
  {
    lng: -41.2601366,
    lat: -21.3648234
  },
  {
    lng: -41.2601335,
    lat: -21.3648228
  },
  {
    lng: -41.2601304,
    lat: -21.3648222
  },
  {
    lng: -41.2601273,
    lat: -21.3648215
  },
  {
    lng: -41.2601242,
    lat: -21.3648209
  },
  {
    lng: -41.2601211,
    lat: -21.36482
  },
  {
    lng: -41.260118,
    lat: -21.3648194
  },
  {
    lng: -41.2601149,
    lat: -21.3648188
  },
  {
    lng: -41.2601118,
    lat: -21.3648181
  },
  {
    lng: -41.2601086,
    lat: -21.3648175
  },
  {
    lng: -41.2601055,
    lat: -21.3648169
  },
  {
    lng: -41.2601024,
    lat: -21.3648163
  },
  {
    lng: -41.2600993,
    lat: -21.3648157
  },
  {
    lng: -41.2600962,
    lat: -21.3648151
  },
  {
    lng: -41.2600931,
    lat: -21.3648143
  },
  {
    lng: -41.26009,
    lat: -21.3648135
  },
  {
    lng: -41.260087,
    lat: -21.3648127
  },
  {
    lng: -41.2600839,
    lat: -21.3648119
  },
  {
    lng: -41.2600808,
    lat: -21.3648111
  },
  {
    lng: -41.2600777,
    lat: -21.3648104
  },
  {
    lng: -41.2600746,
    lat: -21.3648096
  },
  {
    lng: -41.2600716,
    lat: -21.3648088
  },
  {
    lng: -41.2600684,
    lat: -21.3648082
  },
  {
    lng: -41.2600654,
    lat: -21.3648074
  },
  {
    lng: -41.2600622,
    lat: -21.3648068
  },
  {
    lng: -41.2600592,
    lat: -21.364806
  },
  {
    lng: -41.2600561,
    lat: -21.3648051
  },
  {
    lng: -41.260053,
    lat: -21.3648043
  },
  {
    lng: -41.2600499,
    lat: -21.3648035
  },
  {
    lng: -41.2600469,
    lat: -21.3648027
  },
  {
    lng: -41.2600438,
    lat: -21.3648019
  },
  {
    lng: -41.2600407,
    lat: -21.3648011
  },
  {
    lng: -41.2600377,
    lat: -21.3648002
  },
  {
    lng: -41.2600346,
    lat: -21.3647994
  },
  {
    lng: -41.2600315,
    lat: -21.3647986
  },
  {
    lng: -41.2600285,
    lat: -21.3647977
  },
  {
    lng: -41.2600254,
    lat: -21.3647969
  },
  {
    lng: -41.2600223,
    lat: -21.364796
  },
  {
    lng: -41.2600193,
    lat: -21.3647952
  },
  {
    lng: -41.2600162,
    lat: -21.3647943
  },
  {
    lng: -41.2600132,
    lat: -21.3647935
  },
  {
    lng: -41.2600101,
    lat: -21.3647925
  },
  {
    lng: -41.2600071,
    lat: -21.3647916
  },
  {
    lng: -41.2600041,
    lat: -21.3647905
  },
  {
    lng: -41.260001,
    lat: -21.3647897
  },
  {
    lng: -41.259998,
    lat: -21.3647888
  },
  {
    lng: -41.2599949,
    lat: -21.3647879
  },
  {
    lng: -41.2599919,
    lat: -21.364787
  },
  {
    lng: -41.2599888,
    lat: -21.3647862
  },
  {
    lng: -41.2599858,
    lat: -21.3647853
  },
  {
    lng: -41.2599827,
    lat: -21.3647844
  },
  {
    lng: -41.2599796,
    lat: -21.3647836
  },
  {
    lng: -41.2599766,
    lat: -21.3647825
  },
  {
    lng: -41.2599736,
    lat: -21.3647815
  },
  {
    lng: -41.2599706,
    lat: -21.3647805
  },
  {
    lng: -41.2599676,
    lat: -21.3647794
  },
  {
    lng: -41.2599647,
    lat: -21.3647784
  },
  {
    lng: -41.2599616,
    lat: -21.3647774
  },
  {
    lng: -41.2599586,
    lat: -21.3647763
  },
  {
    lng: -41.2599556,
    lat: -21.3647755
  },
  {
    lng: -41.2599526,
    lat: -21.3647745
  },
  {
    lng: -41.2599495,
    lat: -21.3647735
  },
  {
    lng: -41.2599465,
    lat: -21.3647725
  },
  {
    lng: -41.2599435,
    lat: -21.3647714
  },
  {
    lng: -41.2599405,
    lat: -21.3647704
  },
  {
    lng: -41.2599375,
    lat: -21.3647693
  },
  {
    lng: -41.2599345,
    lat: -21.3647683
  },
  {
    lng: -41.2599315,
    lat: -21.3647672
  },
  {
    lng: -41.2599285,
    lat: -21.3647661
  },
  {
    lng: -41.2599255,
    lat: -21.364765
  },
  {
    lng: -41.2599226,
    lat: -21.364764
  },
  {
    lng: -41.2599196,
    lat: -21.3647629
  },
  {
    lng: -41.2599166,
    lat: -21.3647618
  },
  {
    lng: -41.2599136,
    lat: -21.3647607
  },
  {
    lng: -41.2599106,
    lat: -21.3647596
  },
  {
    lng: -41.2599076,
    lat: -21.3647585
  },
  {
    lng: -41.2599046,
    lat: -21.3647574
  },
  {
    lng: -41.2599017,
    lat: -21.3647563
  },
  {
    lng: -41.2598987,
    lat: -21.3647552
  },
  {
    lng: -41.2598957,
    lat: -21.3647541
  },
  {
    lng: -41.2598927,
    lat: -21.364753
  },
  {
    lng: -41.2598898,
    lat: -21.3647518
  },
  {
    lng: -41.2598868,
    lat: -21.3647507
  },
  {
    lng: -41.2598839,
    lat: -21.3647493
  },
  {
    lng: -41.2598809,
    lat: -21.3647482
  },
  {
    lng: -41.259878,
    lat: -21.3647471
  },
  {
    lng: -41.259875,
    lat: -21.3647459
  },
  {
    lng: -41.259872,
    lat: -21.3647448
  },
  {
    lng: -41.2598691,
    lat: -21.3647437
  },
  {
    lng: -41.2598661,
    lat: -21.3647426
  },
  {
    lng: -41.2598631,
    lat: -21.3647415
  },
  {
    lng: -41.2598602,
    lat: -21.3647402
  },
  {
    lng: -41.2598573,
    lat: -21.3647389
  },
  {
    lng: -41.2598544,
    lat: -21.3647376
  },
  {
    lng: -41.2598515,
    lat: -21.3647363
  },
  {
    lng: -41.2598486,
    lat: -21.364735
  },
  {
    lng: -41.2598457,
    lat: -21.3647338
  },
  {
    lng: -41.2598428,
    lat: -21.3647325
  },
  {
    lng: -41.2598399,
    lat: -21.3647312
  },
  {
    lng: -41.2598369,
    lat: -21.3647301
  },
  {
    lng: -41.259834,
    lat: -21.3647288
  },
  {
    lng: -41.259831,
    lat: -21.3647277
  },
  {
    lng: -41.2598281,
    lat: -21.3647264
  },
  {
    lng: -41.2598252,
    lat: -21.3647251
  },
  {
    lng: -41.2598223,
    lat: -21.3647238
  },
  {
    lng: -41.2598194,
    lat: -21.3647225
  },
  {
    lng: -41.2598165,
    lat: -21.3647212
  },
  {
    lng: -41.2598136,
    lat: -21.3647198
  },
  {
    lng: -41.2598107,
    lat: -21.3647185
  },
  {
    lng: -41.2598079,
    lat: -21.3647172
  },
  {
    lng: -41.259805,
    lat: -21.3647159
  },
  {
    lng: -41.2598021,
    lat: -21.3647145
  },
  {
    lng: -41.2597992,
    lat: -21.3647132
  },
  {
    lng: -41.2597963,
    lat: -21.3647119
  },
  {
    lng: -41.2597934,
    lat: -21.3647105
  },
  {
    lng: -41.2597905,
    lat: -21.3647092
  },
  {
    lng: -41.2597877,
    lat: -21.3647079
  },
  {
    lng: -41.2597848,
    lat: -21.3647065
  },
  {
    lng: -41.259782,
    lat: -21.364705
  },
  {
    lng: -41.2597791,
    lat: -21.3647037
  },
  {
    lng: -41.2597763,
    lat: -21.3647021
  },
  {
    lng: -41.2597734,
    lat: -21.3647008
  },
  {
    lng: -41.2597706,
    lat: -21.3646994
  },
  {
    lng: -41.2597677,
    lat: -21.364698
  },
  {
    lng: -41.2597649,
    lat: -21.3646966
  },
  {
    lng: -41.259762,
    lat: -21.3646953
  },
  {
    lng: -41.2597591,
    lat: -21.3646939
  },
  {
    lng: -41.2597562,
    lat: -21.3646926
  },
  {
    lng: -41.2597534,
    lat: -21.3646912
  },
  {
    lng: -41.2597506,
    lat: -21.3646897
  },
  {
    lng: -41.2597478,
    lat: -21.3646882
  },
  {
    lng: -41.259745,
    lat: -21.3646867
  },
  {
    lng: -41.2597422,
    lat: -21.3646852
  },
  {
    lng: -41.2597394,
    lat: -21.3646837
  },
  {
    lng: -41.2597366,
    lat: -21.3646822
  },
  {
    lng: -41.2597338,
    lat: -21.3646807
  },
  {
    lng: -41.259731,
    lat: -21.3646791
  },
  {
    lng: -41.2597282,
    lat: -21.3646777
  },
  {
    lng: -41.2597254,
    lat: -21.3646762
  },
  {
    lng: -41.2597226,
    lat: -21.3646747
  },
  {
    lng: -41.2597198,
    lat: -21.3646731
  },
  {
    lng: -41.259717,
    lat: -21.3646716
  },
  {
    lng: -41.2597142,
    lat: -21.3646701
  },
  {
    lng: -41.2597114,
    lat: -21.3646686
  },
  {
    lng: -41.2597087,
    lat: -21.364667
  },
  {
    lng: -41.2597059,
    lat: -21.3646655
  },
  {
    lng: -41.2597031,
    lat: -21.364664
  },
  {
    lng: -41.2597003,
    lat: -21.3646624
  },
  {
    lng: -41.2596975,
    lat: -21.3646609
  },
  {
    lng: -41.2596947,
    lat: -21.3646593
  },
  {
    lng: -41.259692,
    lat: -21.3646577
  },
  {
    lng: -41.2596892,
    lat: -21.3646562
  },
  {
    lng: -41.2596865,
    lat: -21.3646546
  },
  {
    lng: -41.2596841,
    lat: -21.3646533
  },
  {
    lng: -41.2596818,
    lat: -21.3646519
  },
  {
    lng: -41.2596794,
    lat: -21.3646506
  },
  {
    lng: -41.2596772,
    lat: -21.364649
  },
  {
    lng: -41.259675,
    lat: -21.3646475
  },
  {
    lng: -41.2596728,
    lat: -21.3646459
  },
  {
    lng: -41.2596705,
    lat: -21.3646444
  },
  {
    lng: -41.2596683,
    lat: -21.3646428
  },
  {
    lng: -41.259666,
    lat: -21.3646414
  },
  {
    lng: -41.2596638,
    lat: -21.3646398
  },
  {
    lng: -41.2596614,
    lat: -21.3646384
  },
  {
    lng: -41.2596592,
    lat: -21.3646369
  },
  {
    lng: -41.2596569,
    lat: -21.3646355
  },
  {
    lng: -41.2596547,
    lat: -21.3646339
  },
  {
    lng: -41.2596525,
    lat: -21.3646324
  },
  {
    lng: -41.2596502,
    lat: -21.3646308
  },
  {
    lng: -41.259648,
    lat: -21.3646292
  },
  {
    lng: -41.2596458,
    lat: -21.3646277
  },
  {
    lng: -41.2596436,
    lat: -21.3646261
  },
  {
    lng: -41.2596414,
    lat: -21.3646245
  },
  {
    lng: -41.2596392,
    lat: -21.364623
  },
  {
    lng: -41.259637,
    lat: -21.3646214
  },
  {
    lng: -41.2596348,
    lat: -21.3646198
  },
  {
    lng: -41.2596326,
    lat: -21.3646182
  },
  {
    lng: -41.2596304,
    lat: -21.3646166
  },
  {
    lng: -41.2596282,
    lat: -21.3646151
  },
  {
    lng: -41.2596259,
    lat: -21.3646135
  },
  {
    lng: -41.2596237,
    lat: -21.3646119
  },
  {
    lng: -41.2596215,
    lat: -21.3646103
  },
  {
    lng: -41.2596193,
    lat: -21.3646087
  },
  {
    lng: -41.2596172,
    lat: -21.3646071
  },
  {
    lng: -41.259615,
    lat: -21.3646055
  },
  {
    lng: -41.2596128,
    lat: -21.3646039
  },
  {
    lng: -41.2596106,
    lat: -21.3646023
  },
  {
    lng: -41.2596085,
    lat: -21.3646006
  },
  {
    lng: -41.2596063,
    lat: -21.364599
  },
  {
    lng: -41.2596043,
    lat: -21.3645972
  },
  {
    lng: -41.2596021,
    lat: -21.3645956
  },
  {
    lng: -41.2596,
    lat: -21.3645939
  },
  {
    lng: -41.2595978,
    lat: -21.3645923
  },
  {
    lng: -41.2595956,
    lat: -21.3645907
  },
  {
    lng: -41.2595934,
    lat: -21.364589
  },
  {
    lng: -41.2595912,
    lat: -21.3645874
  },
  {
    lng: -41.2595891,
    lat: -21.3645858
  },
  {
    lng: -41.259587,
    lat: -21.3645841
  },
  {
    lng: -41.2595849,
    lat: -21.3645823
  },
  {
    lng: -41.2595829,
    lat: -21.3645805
  },
  {
    lng: -41.2595808,
    lat: -21.3645788
  },
  {
    lng: -41.2595787,
    lat: -21.364577
  },
  {
    lng: -41.2595766,
    lat: -21.3645753
  },
  {
    lng: -41.2595746,
    lat: -21.3645735
  },
  {
    lng: -41.2595725,
    lat: -21.3645718
  },
  {
    lng: -41.2595703,
    lat: -21.3645702
  },
  {
    lng: -41.2595683,
    lat: -21.3645684
  },
  {
    lng: -41.2595661,
    lat: -21.3645668
  },
  {
    lng: -41.259564,
    lat: -21.364565
  },
  {
    lng: -41.259562,
    lat: -21.3645632
  },
  {
    lng: -41.2595599,
    lat: -21.3645615
  },
  {
    lng: -41.2595579,
    lat: -21.3645597
  },
  {
    lng: -41.2595558,
    lat: -21.3645579
  },
  {
    lng: -41.2595538,
    lat: -21.3645561
  },
  {
    lng: -41.2595518,
    lat: -21.3645543
  },
  {
    lng: -41.2595497,
    lat: -21.3645525
  },
  {
    lng: -41.2595477,
    lat: -21.3645507
  },
  {
    lng: -41.2595456,
    lat: -21.364549
  },
  {
    lng: -41.2595436,
    lat: -21.3645472
  },
  {
    lng: -41.2595416,
    lat: -21.3645454
  },
  {
    lng: -41.2595395,
    lat: -21.3645436
  },
  {
    lng: -41.2595375,
    lat: -21.3645418
  },
  {
    lng: -41.2595355,
    lat: -21.36454
  },
  {
    lng: -41.2595335,
    lat: -21.3645381
  },
  {
    lng: -41.2595316,
    lat: -21.3645362
  },
  {
    lng: -41.2595295,
    lat: -21.3645344
  },
  {
    lng: -41.2595277,
    lat: -21.3645324
  },
  {
    lng: -41.2595257,
    lat: -21.3645306
  },
  {
    lng: -41.2595236,
    lat: -21.3645288
  },
  {
    lng: -41.2595217,
    lat: -21.3645269
  },
  {
    lng: -41.2595197,
    lat: -21.3645251
  },
  {
    lng: -41.2595176,
    lat: -21.3645233
  },
  {
    lng: -41.2595156,
    lat: -21.3645215
  },
  {
    lng: -41.2595136,
    lat: -21.3645197
  },
  {
    lng: -41.2595116,
    lat: -21.3645178
  },
  {
    lng: -41.2595097,
    lat: -21.3645159
  },
  {
    lng: -41.2595078,
    lat: -21.364514
  },
  {
    lng: -41.2595059,
    lat: -21.364512
  },
  {
    lng: -41.2595041,
    lat: -21.3645101
  },
  {
    lng: -41.2595022,
    lat: -21.3645081
  },
  {
    lng: -41.2595002,
    lat: -21.3645062
  },
  {
    lng: -41.2594984,
    lat: -21.3645043
  },
  {
    lng: -41.2594965,
    lat: -21.3645023
  },
  {
    lng: -41.2594944,
    lat: -21.3645005
  },
  {
    lng: -41.2594925,
    lat: -21.3644986
  },
  {
    lng: -41.2594906,
    lat: -21.3644967
  },
  {
    lng: -41.2594887,
    lat: -21.3644947
  },
  {
    lng: -41.2594868,
    lat: -21.3644928
  },
  {
    lng: -41.2594849,
    lat: -21.3644908
  },
  {
    lng: -41.2594831,
    lat: -21.3644889
  },
  {
    lng: -41.2594812,
    lat: -21.3644869
  },
  {
    lng: -41.2594793,
    lat: -21.3644849
  },
  {
    lng: -41.2594775,
    lat: -21.364483
  },
  {
    lng: -41.2594756,
    lat: -21.364481
  },
  {
    lng: -41.2594737,
    lat: -21.364479
  },
  {
    lng: -41.2594719,
    lat: -21.364477
  },
  {
    lng: -41.25947,
    lat: -21.364475
  },
  {
    lng: -41.2594682,
    lat: -21.3644731
  },
  {
    lng: -41.2594663,
    lat: -21.3644711
  },
  {
    lng: -41.2594645,
    lat: -21.3644691
  },
  {
    lng: -41.2594626,
    lat: -21.3644671
  },
  {
    lng: -41.2594608,
    lat: -21.3644651
  },
  {
    lng: -41.2594591,
    lat: -21.364463
  },
  {
    lng: -41.2594572,
    lat: -21.364461
  },
  {
    lng: -41.2594556,
    lat: -21.3644589
  },
  {
    lng: -41.2594537,
    lat: -21.3644569
  },
  {
    lng: -41.2594519,
    lat: -21.3644549
  },
  {
    lng: -41.2594501,
    lat: -21.3644528
  },
  {
    lng: -41.2594483,
    lat: -21.3644508
  },
  {
    lng: -41.2594464,
    lat: -21.3644488
  },
  {
    lng: -41.2594446,
    lat: -21.3644468
  },
  {
    lng: -41.2594428,
    lat: -21.3644448
  },
  {
    lng: -41.259441,
    lat: -21.3644428
  },
  {
    lng: -41.2594393,
    lat: -21.3644407
  },
  {
    lng: -41.2594377,
    lat: -21.3644385
  },
  {
    lng: -41.259436,
    lat: -21.3644364
  },
  {
    lng: -41.2594343,
    lat: -21.3644343
  },
  {
    lng: -41.2593451,
    lat: -21.3643114
  },
  {
    lng: -41.2593437,
    lat: -21.3643092
  },
  {
    lng: -41.2593421,
    lat: -21.3643069
  },
  {
    lng: -41.2593406,
    lat: -21.3643047
  },
  {
    lng: -41.2593391,
    lat: -21.3643025
  },
  {
    lng: -41.2593378,
    lat: -21.3643001
  },
  {
    lng: -41.2593365,
    lat: -21.3642977
  },
  {
    lng: -41.2593352,
    lat: -21.3642953
  },
  {
    lng: -41.2593339,
    lat: -21.364293
  },
  {
    lng: -41.2592654,
    lat: -21.3641575
  },
  {
    lng: -41.2592644,
    lat: -21.364155
  },
  {
    lng: -41.2592632,
    lat: -21.3641526
  },
  {
    lng: -41.259262,
    lat: -21.3641501
  },
  {
    lng: -41.2592609,
    lat: -21.3641477
  },
  {
    lng: -41.2592595,
    lat: -21.3641423
  },
  {
    lng: -41.2592581,
    lat: -21.3641368
  },
  {
    lng: -41.2592567,
    lat: -21.3641314
  },
  {
    lng: -41.2592554,
    lat: -21.364126
  },
  {
    lng: -41.259254,
    lat: -21.3641205
  },
  {
    lng: -41.2592525,
    lat: -21.3641151
  },
  {
    lng: -41.2592512,
    lat: -21.3641097
  },
  {
    lng: -41.2592496,
    lat: -21.3641043
  },
  {
    lng: -41.2592481,
    lat: -21.3640989
  },
  {
    lng: -41.2592467,
    lat: -21.3640935
  },
  {
    lng: -41.2592453,
    lat: -21.3640881
  },
  {
    lng: -41.259244,
    lat: -21.3640827
  },
  {
    lng: -41.2592426,
    lat: -21.3640772
  },
  {
    lng: -41.2592412,
    lat: -21.3640718
  },
  {
    lng: -41.2592399,
    lat: -21.3640663
  },
  {
    lng: -41.2592386,
    lat: -21.3640609
  },
  {
    lng: -41.2592372,
    lat: -21.3640555
  },
  {
    lng: -41.2592359,
    lat: -21.36405
  },
  {
    lng: -41.2592346,
    lat: -21.3640446
  },
  {
    lng: -41.2592332,
    lat: -21.3640392
  },
  {
    lng: -41.2592319,
    lat: -21.3640337
  },
  {
    lng: -41.2592306,
    lat: -21.3640283
  },
  {
    lng: -41.2592292,
    lat: -21.3640228
  },
  {
    lng: -41.2592279,
    lat: -21.3640174
  },
  {
    lng: -41.2592266,
    lat: -21.364012
  },
  {
    lng: -41.2592252,
    lat: -21.3640065
  },
  {
    lng: -41.2592239,
    lat: -21.3640011
  },
  {
    lng: -41.2592226,
    lat: -21.3639956
  },
  {
    lng: -41.2592212,
    lat: -21.3639902
  },
  {
    lng: -41.2592199,
    lat: -21.3639848
  },
  {
    lng: -41.2592186,
    lat: -21.3639793
  },
  {
    lng: -41.2592173,
    lat: -21.3639739
  },
  {
    lng: -41.259216,
    lat: -21.3639684
  },
  {
    lng: -41.2592149,
    lat: -21.3639629
  },
  {
    lng: -41.2592138,
    lat: -21.3639574
  },
  {
    lng: -41.2592125,
    lat: -21.363952
  },
  {
    lng: -41.2592113,
    lat: -21.3639465
  },
  {
    lng: -41.25921,
    lat: -21.3639411
  },
  {
    lng: -41.2592087,
    lat: -21.3639356
  },
  {
    lng: -41.2592074,
    lat: -21.3639302
  },
  {
    lng: -41.2592061,
    lat: -21.3639247
  },
  {
    lng: -41.2592048,
    lat: -21.3639193
  },
  {
    lng: -41.2592037,
    lat: -21.3639138
  },
  {
    lng: -41.2592026,
    lat: -21.3639083
  },
  {
    lng: -41.2592015,
    lat: -21.3639028
  },
  {
    lng: -41.2592004,
    lat: -21.3638973
  },
  {
    lng: -41.2591993,
    lat: -21.3638918
  },
  {
    lng: -41.2591981,
    lat: -21.3638864
  },
  {
    lng: -41.259197,
    lat: -21.3638809
  },
  {
    lng: -41.2591957,
    lat: -21.3638754
  },
  {
    lng: -41.2591946,
    lat: -21.3638699
  },
  {
    lng: -41.2591934,
    lat: -21.3638645
  },
  {
    lng: -41.2591923,
    lat: -21.363859
  },
  {
    lng: -41.2591912,
    lat: -21.3638535
  },
  {
    lng: -41.2591901,
    lat: -21.363848
  },
  {
    lng: -41.259189,
    lat: -21.3638425
  },
  {
    lng: -41.2591879,
    lat: -21.363837
  },
  {
    lng: -41.2591868,
    lat: -21.3638315
  },
  {
    lng: -41.2591858,
    lat: -21.363826
  },
  {
    lng: -41.2591847,
    lat: -21.3638205
  },
  {
    lng: -41.2591836,
    lat: -21.363815
  },
  {
    lng: -41.2591826,
    lat: -21.3638095
  },
  {
    lng: -41.2591815,
    lat: -21.363804
  },
  {
    lng: -41.2591804,
    lat: -21.3637985
  },
  {
    lng: -41.2591794,
    lat: -21.363793
  },
  {
    lng: -41.2591783,
    lat: -21.3637875
  },
  {
    lng: -41.2591773,
    lat: -21.363782
  },
  {
    lng: -41.2591762,
    lat: -21.3637765
  },
  {
    lng: -41.2591752,
    lat: -21.363771
  },
  {
    lng: -41.2591741,
    lat: -21.3637655
  },
  {
    lng: -41.2591731,
    lat: -21.36376
  },
  {
    lng: -41.2591722,
    lat: -21.3637545
  },
  {
    lng: -41.2591712,
    lat: -21.363749
  },
  {
    lng: -41.2591704,
    lat: -21.3637434
  },
  {
    lng: -41.2591693,
    lat: -21.3637379
  },
  {
    lng: -41.2591684,
    lat: -21.3637324
  },
  {
    lng: -41.2591673,
    lat: -21.3637269
  },
  {
    lng: -41.2591663,
    lat: -21.3637214
  },
  {
    lng: -41.2591653,
    lat: -21.3637159
  },
  {
    lng: -41.2591642,
    lat: -21.3637104
  },
  {
    lng: -41.2591632,
    lat: -21.3637049
  },
  {
    lng: -41.2591622,
    lat: -21.3636994
  },
  {
    lng: -41.2591612,
    lat: -21.3636939
  },
  {
    lng: -41.2591602,
    lat: -21.3636884
  },
  {
    lng: -41.2591591,
    lat: -21.3636829
  },
  {
    lng: -41.2591582,
    lat: -21.3636773
  },
  {
    lng: -41.2591576,
    lat: -21.3636751
  },
  {
    lng: -41.2591572,
    lat: -21.3636728
  },
  {
    lng: -41.2591567,
    lat: -21.3636705
  },
  {
    lng: -41.2591562,
    lat: -21.3636682
  },
  {
    lng: -41.2591557,
    lat: -21.3636659
  },
  {
    lng: -41.2591552,
    lat: -21.3636636
  },
  {
    lng: -41.2591545,
    lat: -21.3636613
  },
  {
    lng: -41.2591539,
    lat: -21.3636591
  },
  {
    lng: -41.2591532,
    lat: -21.3636568
  },
  {
    lng: -41.2591525,
    lat: -21.3636546
  },
  {
    lng: -41.2591518,
    lat: -21.3636523
  },
  {
    lng: -41.2591512,
    lat: -21.36365
  },
  {
    lng: -41.2591505,
    lat: -21.3636478
  },
  {
    lng: -41.2591499,
    lat: -21.3636456
  },
  {
    lng: -41.2591494,
    lat: -21.3636432
  },
  {
    lng: -41.2591487,
    lat: -21.363641
  },
  {
    lng: -41.2591482,
    lat: -21.3636387
  },
  {
    lng: -41.2591475,
    lat: -21.3636364
  },
  {
    lng: -41.2591468,
    lat: -21.3636342
  },
  {
    lng: -41.2591461,
    lat: -21.3636319
  },
  {
    lng: -41.2591454,
    lat: -21.3636297
  },
  {
    lng: -41.2591447,
    lat: -21.3636275
  },
  {
    lng: -41.259144,
    lat: -21.3636252
  },
  {
    lng: -41.2591433,
    lat: -21.363623
  },
  {
    lng: -41.2591426,
    lat: -21.3636207
  },
  {
    lng: -41.2591419,
    lat: -21.3636185
  },
  {
    lng: -41.2591412,
    lat: -21.3636162
  },
  {
    lng: -41.2591404,
    lat: -21.363614
  },
  {
    lng: -41.2591397,
    lat: -21.3636118
  },
  {
    lng: -41.259139,
    lat: -21.3636095
  },
  {
    lng: -41.2591383,
    lat: -21.3636073
  },
  {
    lng: -41.2591375,
    lat: -21.3636051
  },
  {
    lng: -41.2591368,
    lat: -21.3636028
  },
  {
    lng: -41.2591359,
    lat: -21.3636006
  },
  {
    lng: -41.2591352,
    lat: -21.3635984
  },
  {
    lng: -41.2591342,
    lat: -21.3635963
  },
  {
    lng: -41.2591335,
    lat: -21.363594
  },
  {
    lng: -41.2591328,
    lat: -21.3635918
  },
  {
    lng: -41.2591319,
    lat: -21.3635896
  },
  {
    lng: -41.2591312,
    lat: -21.3635874
  },
  {
    lng: -41.2591304,
    lat: -21.3635851
  },
  {
    lng: -41.2591297,
    lat: -21.3635829
  },
  {
    lng: -41.259129,
    lat: -21.3635807
  },
  {
    lng: -41.2591282,
    lat: -21.3635784
  },
  {
    lng: -41.2591273,
    lat: -21.3635763
  },
  {
    lng: -41.2591264,
    lat: -21.3635741
  },
  {
    lng: -41.2591255,
    lat: -21.363572
  },
  {
    lng: -41.2591245,
    lat: -21.3635698
  },
  {
    lng: -41.2591236,
    lat: -21.3635676
  },
  {
    lng: -41.2591228,
    lat: -21.3635654
  },
  {
    lng: -41.2591218,
    lat: -21.3635633
  },
  {
    lng: -41.2591209,
    lat: -21.3635611
  },
  {
    lng: -41.2591202,
    lat: -21.3635589
  },
  {
    lng: -41.2591193,
    lat: -21.3635567
  },
  {
    lng: -41.2591185,
    lat: -21.3635545
  },
  {
    lng: -41.2591176,
    lat: -21.3635523
  },
  {
    lng: -41.2591166,
    lat: -21.3635502
  },
  {
    lng: -41.2591157,
    lat: -21.363548
  },
  {
    lng: -41.2591148,
    lat: -21.3635459
  },
  {
    lng: -41.2591138,
    lat: -21.3635437
  },
  {
    lng: -41.2591129,
    lat: -21.3635415
  },
  {
    lng: -41.2591119,
    lat: -21.3635394
  },
  {
    lng: -41.259111,
    lat: -21.3635372
  },
  {
    lng: -41.25911,
    lat: -21.3635351
  },
  {
    lng: -41.2591091,
    lat: -21.3635329
  },
  {
    lng: -41.2591081,
    lat: -21.3635308
  },
  {
    lng: -41.2591071,
    lat: -21.3635287
  },
  {
    lng: -41.2591062,
    lat: -21.3635265
  },
  {
    lng: -41.2591052,
    lat: -21.3635244
  },
  {
    lng: -41.2591042,
    lat: -21.3635222
  },
  {
    lng: -41.2591033,
    lat: -21.3635201
  },
  {
    lng: -41.2591021,
    lat: -21.363518
  },
  {
    lng: -41.2591012,
    lat: -21.3635159
  },
  {
    lng: -41.2591,
    lat: -21.3635138
  },
  {
    lng: -41.259099,
    lat: -21.3635117
  },
  {
    lng: -41.259098,
    lat: -21.3635096
  },
  {
    lng: -41.259097,
    lat: -21.3635075
  },
  {
    lng: -41.259096,
    lat: -21.3635053
  },
  {
    lng: -41.259095,
    lat: -21.3635032
  },
  {
    lng: -41.259094,
    lat: -21.3635011
  },
  {
    lng: -41.259093,
    lat: -21.3634989
  },
  {
    lng: -41.259092,
    lat: -21.3634968
  },
  {
    lng: -41.2590909,
    lat: -21.3634948
  },
  {
    lng: -41.2590897,
    lat: -21.3634927
  },
  {
    lng: -41.2590885,
    lat: -21.3634907
  },
  {
    lng: -41.2590874,
    lat: -21.3634886
  },
  {
    lng: -41.2590863,
    lat: -21.3634866
  },
  {
    lng: -41.2590853,
    lat: -21.3634844
  },
  {
    lng: -41.2590841,
    lat: -21.3634824
  },
  {
    lng: -41.2590831,
    lat: -21.3634803
  },
  {
    lng: -41.2590819,
    lat: -21.3634782
  },
  {
    lng: -41.2590808,
    lat: -21.3634762
  },
  {
    lng: -41.2590796,
    lat: -21.3634741
  },
  {
    lng: -41.2590784,
    lat: -21.3634721
  },
  {
    lng: -41.2590772,
    lat: -21.3634701
  },
  {
    lng: -41.259076,
    lat: -21.3634681
  },
  {
    lng: -41.2590748,
    lat: -21.3634661
  },
  {
    lng: -41.2590736,
    lat: -21.363464
  },
  {
    lng: -41.2590724,
    lat: -21.363462
  },
  {
    lng: -41.2590712,
    lat: -21.36346
  },
  {
    lng: -41.25907,
    lat: -21.363458
  },
  {
    lng: -41.2590688,
    lat: -21.363456
  },
  {
    lng: -41.2590676,
    lat: -21.3634539
  },
  {
    lng: -41.2590664,
    lat: -21.3634519
  },
  {
    lng: -41.2590652,
    lat: -21.3634499
  },
  {
    lng: -41.259064,
    lat: -21.3634479
  },
  {
    lng: -41.2590627,
    lat: -21.3634459
  },
  {
    lng: -41.2590615,
    lat: -21.3634439
  },
  {
    lng: -41.2590603,
    lat: -21.3634418
  },
  {
    lng: -41.2590591,
    lat: -21.3634398
  },
  {
    lng: -41.2590579,
    lat: -21.3634378
  },
  {
    lng: -41.2590567,
    lat: -21.3634358
  },
  {
    lng: -41.2590555,
    lat: -21.3634338
  },
  {
    lng: -41.2590543,
    lat: -21.3634318
  },
  {
    lng: -41.2590531,
    lat: -21.3634298
  },
  {
    lng: -41.2590518,
    lat: -21.3634277
  },
  {
    lng: -41.2590506,
    lat: -21.3634257
  },
  {
    lng: -41.2590494,
    lat: -21.3634237
  },
  {
    lng: -41.2590482,
    lat: -21.3634217
  },
  {
    lng: -41.2590469,
    lat: -21.3634197
  },
  {
    lng: -41.2590457,
    lat: -21.3634177
  },
  {
    lng: -41.2590443,
    lat: -21.3634158
  },
  {
    lng: -41.259043,
    lat: -21.3634139
  },
  {
    lng: -41.2590416,
    lat: -21.363412
  },
  {
    lng: -41.2590403,
    lat: -21.36341
  },
  {
    lng: -41.259039,
    lat: -21.363408
  },
  {
    lng: -41.2590378,
    lat: -21.363406
  },
  {
    lng: -41.2590365,
    lat: -21.3634041
  },
  {
    lng: -41.2590353,
    lat: -21.3634021
  },
  {
    lng: -41.2590339,
    lat: -21.3634002
  },
  {
    lng: -41.2590324,
    lat: -21.3633983
  },
  {
    lng: -41.259031,
    lat: -21.3633965
  },
  {
    lng: -41.2590296,
    lat: -21.3633946
  },
  {
    lng: -41.2590282,
    lat: -21.3633927
  },
  {
    lng: -41.2590269,
    lat: -21.3633907
  },
  {
    lng: -41.2590256,
    lat: -21.3633888
  },
  {
    lng: -41.2590242,
    lat: -21.3633869
  },
  {
    lng: -41.2590227,
    lat: -21.363385
  },
  {
    lng: -41.2590213,
    lat: -21.3633832
  },
  {
    lng: -41.2590198,
    lat: -21.3633813
  },
  {
    lng: -41.2590184,
    lat: -21.3633795
  },
  {
    lng: -41.2590169,
    lat: -21.3633777
  },
  {
    lng: -41.2590155,
    lat: -21.3633758
  },
  {
    lng: -41.259014,
    lat: -21.363374
  },
  {
    lng: -41.2590125,
    lat: -21.3633722
  },
  {
    lng: -41.259011,
    lat: -21.3633703
  },
  {
    lng: -41.2590096,
    lat: -21.3633685
  },
  {
    lng: -41.2590081,
    lat: -21.3633667
  },
  {
    lng: -41.2590066,
    lat: -21.3633649
  },
  {
    lng: -41.2590051,
    lat: -21.363363
  },
  {
    lng: -41.2590036,
    lat: -21.3633612
  },
  {
    lng: -41.2590022,
    lat: -21.3633594
  },
  {
    lng: -41.2590007,
    lat: -21.3633575
  },
  {
    lng: -41.2589992,
    lat: -21.3633557
  },
  {
    lng: -41.2589977,
    lat: -21.3633539
  },
  {
    lng: -41.2589963,
    lat: -21.363352
  },
  {
    lng: -41.2589948,
    lat: -21.3633502
  },
  {
    lng: -41.2589933,
    lat: -21.3633484
  },
  {
    lng: -41.2589919,
    lat: -21.3633465
  },
  {
    lng: -41.2589904,
    lat: -21.3633447
  },
  {
    lng: -41.258989,
    lat: -21.3633428
  },
  {
    lng: -41.2589875,
    lat: -21.363341
  },
  {
    lng: -41.258986,
    lat: -21.3633392
  },
  {
    lng: -41.2589845,
    lat: -21.3633374
  },
  {
    lng: -41.258983,
    lat: -21.3633355
  },
  {
    lng: -41.2589816,
    lat: -21.3633337
  },
  {
    lng: -41.2589801,
    lat: -21.3633319
  },
  {
    lng: -41.2589786,
    lat: -21.3633301
  },
  {
    lng: -41.2589771,
    lat: -21.3633283
  },
  {
    lng: -41.2589756,
    lat: -21.3633265
  },
  {
    lng: -41.2589739,
    lat: -21.3633248
  },
  {
    lng: -41.2589723,
    lat: -21.3633231
  },
  {
    lng: -41.2589707,
    lat: -21.3633214
  },
  {
    lng: -41.2589692,
    lat: -21.3633196
  },
  {
    lng: -41.2589677,
    lat: -21.3633178
  },
  {
    lng: -41.2589662,
    lat: -21.363316
  },
  {
    lng: -41.2589646,
    lat: -21.3633142
  },
  {
    lng: -41.258963,
    lat: -21.3633125
  },
  {
    lng: -41.2589613,
    lat: -21.3633109
  },
  {
    lng: -41.2589596,
    lat: -21.3633092
  },
  {
    lng: -41.258958,
    lat: -21.3633076
  },
  {
    lng: -41.2589563,
    lat: -21.3633059
  },
  {
    lng: -41.2589548,
    lat: -21.3633041
  },
  {
    lng: -41.2589531,
    lat: -21.3633024
  },
  {
    lng: -41.2589516,
    lat: -21.3633007
  },
  {
    lng: -41.2589499,
    lat: -21.363299
  },
  {
    lng: -41.2589482,
    lat: -21.3632974
  },
  {
    lng: -41.2589465,
    lat: -21.3632957
  },
  {
    lng: -41.2589448,
    lat: -21.3632941
  },
  {
    lng: -41.2589431,
    lat: -21.3632925
  },
  {
    lng: -41.2589414,
    lat: -21.3632909
  },
  {
    lng: -41.2589397,
    lat: -21.3632892
  },
  {
    lng: -41.258938,
    lat: -21.3632876
  },
  {
    lng: -41.2589363,
    lat: -21.363286
  },
  {
    lng: -41.2589346,
    lat: -21.3632844
  },
  {
    lng: -41.2589329,
    lat: -21.3632828
  },
  {
    lng: -41.2589312,
    lat: -21.3632812
  },
  {
    lng: -41.2589295,
    lat: -21.3632795
  },
  {
    lng: -41.2589278,
    lat: -21.3632779
  },
  {
    lng: -41.2589261,
    lat: -21.3632763
  },
  {
    lng: -41.2589244,
    lat: -21.3632747
  },
  {
    lng: -41.2589227,
    lat: -21.3632731
  },
  {
    lng: -41.2589209,
    lat: -21.3632715
  },
  {
    lng: -41.2589192,
    lat: -21.3632699
  },
  {
    lng: -41.2589175,
    lat: -21.3632682
  },
  {
    lng: -41.2589158,
    lat: -21.3632666
  },
  {
    lng: -41.2589141,
    lat: -21.363265
  },
  {
    lng: -41.2589124,
    lat: -21.3632634
  },
  {
    lng: -41.2589107,
    lat: -21.3632618
  },
  {
    lng: -41.258909,
    lat: -21.3632602
  },
  {
    lng: -41.2589072,
    lat: -21.3632586
  },
  {
    lng: -41.2589055,
    lat: -21.363257
  },
  {
    lng: -41.2589038,
    lat: -21.3632554
  },
  {
    lng: -41.2589021,
    lat: -21.3632538
  },
  {
    lng: -41.2589003,
    lat: -21.3632522
  },
  {
    lng: -41.2588986,
    lat: -21.3632506
  },
  {
    lng: -41.2588967,
    lat: -21.3632492
  },
  {
    lng: -41.258895,
    lat: -21.3632476
  },
  {
    lng: -41.2588931,
    lat: -21.3632462
  },
  {
    lng: -41.2588913,
    lat: -21.3632447
  },
  {
    lng: -41.2588896,
    lat: -21.3632431
  },
  {
    lng: -41.2588878,
    lat: -21.3632415
  },
  {
    lng: -41.2588861,
    lat: -21.3632399
  },
  {
    lng: -41.2588844,
    lat: -21.3632384
  },
  {
    lng: -41.2588825,
    lat: -21.363237
  },
  {
    lng: -41.2588806,
    lat: -21.3632355
  },
  {
    lng: -41.2588787,
    lat: -21.3632341
  },
  {
    lng: -41.2588768,
    lat: -21.3632327
  },
  {
    lng: -41.258875,
    lat: -21.3632313
  },
  {
    lng: -41.2588732,
    lat: -21.3632297
  },
  {
    lng: -41.2588714,
    lat: -21.3632283
  },
  {
    lng: -41.2588696,
    lat: -21.3632267
  },
  {
    lng: -41.2588677,
    lat: -21.3632253
  },
  {
    lng: -41.2588658,
    lat: -21.3632239
  },
  {
    lng: -41.2588639,
    lat: -21.3632225
  },
  {
    lng: -41.258862,
    lat: -21.3632212
  },
  {
    lng: -41.2588601,
    lat: -21.3632198
  },
  {
    lng: -41.2588582,
    lat: -21.3632184
  },
  {
    lng: -41.2588563,
    lat: -21.363217
  },
  {
    lng: -41.2588544,
    lat: -21.3632157
  },
  {
    lng: -41.2588525,
    lat: -21.3632143
  },
  {
    lng: -41.2588506,
    lat: -21.3632129
  },
  {
    lng: -41.2588487,
    lat: -21.3632115
  },
  {
    lng: -41.2588468,
    lat: -21.3632102
  },
  {
    lng: -41.2588448,
    lat: -21.3632088
  },
  {
    lng: -41.2588429,
    lat: -21.3632074
  },
  {
    lng: -41.258841,
    lat: -21.3632061
  },
  {
    lng: -41.2588391,
    lat: -21.3632047
  },
  {
    lng: -41.2588372,
    lat: -21.3632033
  },
  {
    lng: -41.2588353,
    lat: -21.363202
  },
  {
    lng: -41.2588334,
    lat: -21.3632006
  },
  {
    lng: -41.2588314,
    lat: -21.3631992
  },
  {
    lng: -41.2588295,
    lat: -21.3631979
  },
  {
    lng: -41.2588276,
    lat: -21.3631965
  },
  {
    lng: -41.2588257,
    lat: -21.3631951
  },
  {
    lng: -41.2588238,
    lat: -21.3631938
  },
  {
    lng: -41.2588219,
    lat: -21.3631924
  },
  {
    lng: -41.25882,
    lat: -21.3631911
  },
  {
    lng: -41.258818,
    lat: -21.3631897
  },
  {
    lng: -41.2588161,
    lat: -21.3631883
  },
  {
    lng: -41.2588142,
    lat: -21.363187
  },
  {
    lng: -41.2588122,
    lat: -21.3631857
  },
  {
    lng: -41.2588103,
    lat: -21.3631843
  },
  {
    lng: -41.2588083,
    lat: -21.3631832
  },
  {
    lng: -41.2588063,
    lat: -21.3631818
  },
  {
    lng: -41.2588043,
    lat: -21.3631807
  },
  {
    lng: -41.2588023,
    lat: -21.3631794
  },
  {
    lng: -41.2588004,
    lat: -21.3631781
  },
  {
    lng: -41.2587984,
    lat: -21.3631768
  },
  {
    lng: -41.2587965,
    lat: -21.3631754
  },
  {
    lng: -41.2587945,
    lat: -21.3631741
  },
  {
    lng: -41.2587927,
    lat: -21.3631735
  },
  {
    lng: -41.2587909,
    lat: -21.3631728
  },
  {
    lng: -41.2587891,
    lat: -21.3631721
  },
  {
    lng: -41.2587874,
    lat: -21.3631712
  },
  {
    lng: -41.2587856,
    lat: -21.3631704
  },
  {
    lng: -41.2587838,
    lat: -21.3631698
  },
  {
    lng: -41.258782,
    lat: -21.3631692
  },
  {
    lng: -41.2587801,
    lat: -21.3631686
  },
  {
    lng: -41.2587783,
    lat: -21.3631681
  },
  {
    lng: -41.2587765,
    lat: -21.3631675
  },
  {
    lng: -41.2587746,
    lat: -21.3631669
  },
  {
    lng: -41.2587728,
    lat: -21.3631663
  },
  {
    lng: -41.258771,
    lat: -21.3631657
  },
  {
    lng: -41.2586937,
    lat: -21.363141
  },
  {
    lng: -41.2586919,
    lat: -21.3631404
  },
  {
    lng: -41.25869,
    lat: -21.3631398
  },
  {
    lng: -41.2586882,
    lat: -21.3631393
  },
  {
    lng: -41.2586863,
    lat: -21.3631387
  },
  {
    lng: -41.2586845,
    lat: -21.3631381
  },
  {
    lng: -41.2586827,
    lat: -21.3631375
  },
  {
    lng: -41.2586808,
    lat: -21.3631369
  },
  {
    lng: -41.258679,
    lat: -21.3631364
  },
  {
    lng: -41.2586771,
    lat: -21.363136
  },
  {
    lng: -41.2586752,
    lat: -21.3631357
  },
  {
    lng: -41.2586733,
    lat: -21.3631352
  },
  {
    lng: -41.2586714,
    lat: -21.3631347
  },
  {
    lng: -41.2586696,
    lat: -21.3631342
  },
  {
    lng: -41.2586677,
    lat: -21.363134
  },
  {
    lng: -41.2586658,
    lat: -21.3631338
  },
  {
    lng: -41.2586639,
    lat: -21.3631335
  },
  {
    lng: -41.258662,
    lat: -21.3631331
  },
  {
    lng: -41.2586601,
    lat: -21.3631327
  },
  {
    lng: -41.2586581,
    lat: -21.3631326
  },
  {
    lng: -41.2586562,
    lat: -21.3631325
  },
  {
    lng: -41.2586543,
    lat: -21.3631323
  },
  {
    lng: -41.2586524,
    lat: -21.3631322
  },
  {
    lng: -41.2586505,
    lat: -21.363132
  },
  {
    lng: -41.2586485,
    lat: -21.3631319
  },
  {
    lng: -41.2586447,
    lat: -21.3631316
  },
  {
    lng: -41.2585618,
    lat: -21.3631259
  },
  {
    lng: -41.2585599,
    lat: -21.3631257
  },
  {
    lng: -41.258558,
    lat: -21.3631256
  },
  {
    lng: -41.2585561,
    lat: -21.3631255
  },
  {
    lng: -41.2585542,
    lat: -21.3631254
  },
  {
    lng: -41.2585522,
    lat: -21.3631252
  },
  {
    lng: -41.2585503,
    lat: -21.3631251
  },
  {
    lng: -41.2585484,
    lat: -21.363125
  },
  {
    lng: -41.2585465,
    lat: -21.3631249
  },
  {
    lng: -41.2585445,
    lat: -21.363125
  },
  {
    lng: -41.2585426,
    lat: -21.3631251
  },
  {
    lng: -41.2585407,
    lat: -21.3631251
  },
  {
    lng: -41.2585388,
    lat: -21.3631251
  },
  {
    lng: -41.2585368,
    lat: -21.363125
  },
  {
    lng: -41.2585299,
    lat: -21.3631256
  },
  {
    lng: -41.2585229,
    lat: -21.3631263
  },
  {
    lng: -41.258516,
    lat: -21.3631269
  },
  {
    lng: -41.258509,
    lat: -21.3631274
  },
  {
    lng: -41.258502,
    lat: -21.3631278
  },
  {
    lng: -41.2584951,
    lat: -21.3631282
  },
  {
    lng: -41.2584881,
    lat: -21.3631288
  },
  {
    lng: -41.2584812,
    lat: -21.3631295
  },
  {
    lng: -41.2584742,
    lat: -21.3631302
  },
  {
    lng: -41.2584673,
    lat: -21.3631309
  },
  {
    lng: -41.2584603,
    lat: -21.3631315
  },
  {
    lng: -41.2584534,
    lat: -21.3631322
  },
  {
    lng: -41.2584464,
    lat: -21.3631329
  },
  {
    lng: -41.2584395,
    lat: -21.3631336
  },
  {
    lng: -41.2584325,
    lat: -21.3631342
  },
  {
    lng: -41.2584256,
    lat: -21.3631349
  },
  {
    lng: -41.2584186,
    lat: -21.3631356
  },
  {
    lng: -41.2584117,
    lat: -21.3631363
  },
  {
    lng: -41.2584047,
    lat: -21.3631369
  },
  {
    lng: -41.2582588,
    lat: -21.3631512
  },
  {
    lng: -41.2582519,
    lat: -21.3631519
  },
  {
    lng: -41.2582449,
    lat: -21.3631525
  },
  {
    lng: -41.258238,
    lat: -21.3631532
  },
  {
    lng: -41.258231,
    lat: -21.3631539
  },
  {
    lng: -41.2582241,
    lat: -21.3631546
  },
  {
    lng: -41.2582171,
    lat: -21.3631553
  },
  {
    lng: -41.2582102,
    lat: -21.363156
  },
  {
    lng: -41.2582033,
    lat: -21.3631566
  },
  {
    lng: -41.2581963,
    lat: -21.3631573
  },
  {
    lng: -41.2581894,
    lat: -21.363158
  },
  {
    lng: -41.2581824,
    lat: -21.3631587
  },
  {
    lng: -41.2581755,
    lat: -21.3631594
  },
  {
    lng: -41.2581685,
    lat: -21.3631601
  },
  {
    lng: -41.2581616,
    lat: -21.363161
  },
  {
    lng: -41.2581547,
    lat: -21.363162
  },
  {
    lng: -41.2581478,
    lat: -21.3631628
  },
  {
    lng: -41.2581408,
    lat: -21.3631636
  },
  {
    lng: -41.2581339,
    lat: -21.3631643
  },
  {
    lng: -41.2581269,
    lat: -21.363165
  },
  {
    lng: -41.25812,
    lat: -21.3631661
  },
  {
    lng: -41.2581131,
    lat: -21.3631671
  },
  {
    lng: -41.2581062,
    lat: -21.3631681
  },
  {
    lng: -41.2580993,
    lat: -21.363169
  },
  {
    lng: -41.2580924,
    lat: -21.3631698
  },
  {
    lng: -41.2580854,
    lat: -21.3631707
  },
  {
    lng: -41.2580785,
    lat: -21.3631717
  },
  {
    lng: -41.2580716,
    lat: -21.3631727
  },
  {
    lng: -41.2580647,
    lat: -21.3631738
  },
  {
    lng: -41.2580578,
    lat: -21.3631748
  },
  {
    lng: -41.2580509,
    lat: -21.3631759
  },
  {
    lng: -41.258044,
    lat: -21.3631769
  },
  {
    lng: -41.2580371,
    lat: -21.363178
  },
  {
    lng: -41.2580302,
    lat: -21.3631791
  },
  {
    lng: -41.2578233,
    lat: -21.3632113
  },
  {
    lng: -41.2578164,
    lat: -21.3632124
  },
  {
    lng: -41.2578095,
    lat: -21.3632134
  },
  {
    lng: -41.2578026,
    lat: -21.3632145
  },
  {
    lng: -41.2577957,
    lat: -21.3632156
  },
  {
    lng: -41.2577888,
    lat: -21.3632167
  },
  {
    lng: -41.2577819,
    lat: -21.3632178
  },
  {
    lng: -41.257775,
    lat: -21.3632189
  },
  {
    lng: -41.2577681,
    lat: -21.36322
  },
  {
    lng: -41.2577613,
    lat: -21.3632213
  },
  {
    lng: -41.2577544,
    lat: -21.3632227
  },
  {
    lng: -41.2577475,
    lat: -21.3632239
  },
  {
    lng: -41.2577407,
    lat: -21.363225
  },
  {
    lng: -41.2577338,
    lat: -21.3632262
  },
  {
    lng: -41.2577269,
    lat: -21.3632273
  },
  {
    lng: -41.2577143,
    lat: -21.3632289
  },
  {
    lng: -41.2577017,
    lat: -21.3632306
  },
  {
    lng: -41.2576891,
    lat: -21.3632322
  },
  {
    lng: -41.2576765,
    lat: -21.3632339
  },
  {
    lng: -41.2576639,
    lat: -21.3632355
  },
  {
    lng: -41.2576513,
    lat: -21.3632372
  },
  {
    lng: -41.2576388,
    lat: -21.3632389
  },
  {
    lng: -41.2576262,
    lat: -21.3632406
  },
  {
    lng: -41.2576136,
    lat: -21.3632424
  },
  {
    lng: -41.257601,
    lat: -21.3632441
  },
  {
    lng: -41.2575884,
    lat: -21.3632457
  },
  {
    lng: -41.2575759,
    lat: -21.3632475
  },
  {
    lng: -41.2575633,
    lat: -21.3632491
  },
  {
    lng: -41.2575507,
    lat: -21.3632508
  },
  {
    lng: -41.2575381,
    lat: -21.3632524
  },
  {
    lng: -41.2575255,
    lat: -21.363254
  },
  {
    lng: -41.2575129,
    lat: -21.3632556
  },
  {
    lng: -41.2575003,
    lat: -21.3632573
  },
  {
    lng: -41.2574877,
    lat: -21.3632589
  },
  {
    lng: -41.2574751,
    lat: -21.3632605
  },
  {
    lng: -41.2574625,
    lat: -21.3632621
  },
  {
    lng: -41.2574499,
    lat: -21.3632637
  },
  {
    lng: -41.2574373,
    lat: -21.3632653
  },
  {
    lng: -41.2574247,
    lat: -21.3632669
  },
  {
    lng: -41.2574121,
    lat: -21.3632685
  },
  {
    lng: -41.2573995,
    lat: -21.3632701
  },
  {
    lng: -41.2573869,
    lat: -21.3632715
  },
  {
    lng: -41.2573743,
    lat: -21.3632731
  },
  {
    lng: -41.2573617,
    lat: -21.3632747
  },
  {
    lng: -41.2573491,
    lat: -21.3632761
  },
  {
    lng: -41.2573365,
    lat: -21.3632777
  },
  {
    lng: -41.2573239,
    lat: -21.3632792
  },
  {
    lng: -41.2573113,
    lat: -21.3632808
  },
  {
    lng: -41.2572987,
    lat: -21.3632823
  },
  {
    lng: -41.2572861,
    lat: -21.3632839
  },
  {
    lng: -41.2572735,
    lat: -21.3632855
  },
  {
    lng: -41.2572609,
    lat: -21.3632871
  },
  {
    lng: -41.2572483,
    lat: -21.3632887
  },
  {
    lng: -41.2571957,
    lat: -21.3632919
  },
  {
    lng: -41.2571449,
    lat: -21.3632822
  },
  {
    lng: -41.2570969,
    lat: -21.3632628
  },
  {
    lng: -41.2570534,
    lat: -21.3632319
  },
  {
    lng: -41.2565611,
    lat: -21.3626587
  },
  {
    lng: -41.2564179,
    lat: -21.3625114
  },
  {
    lng: -41.2561847,
    lat: -21.3623355
  },
  {
    lng: -41.2559843,
    lat: -21.3622333
  },
  {
    lng: -41.2558288,
    lat: -21.3621924
  },
  {
    lng: -41.2556488,
    lat: -21.3621719
  },
  {
    lng: -41.2554443,
    lat: -21.3621883
  },
  {
    lng: -41.2552602,
    lat: -21.362221
  },
  {
    lng: -41.2550925,
    lat: -21.3622824
  },
  {
    lng: -41.2549616,
    lat: -21.3623601
  },
  {
    lng: -41.2548021,
    lat: -21.3624705
  },
  {
    lng: -41.2546916,
    lat: -21.362581
  },
  {
    lng: -41.2543848,
    lat: -21.3629491
  },
  {
    lng: -41.254383,
    lat: -21.3629517
  },
  {
    lng: -41.2543812,
    lat: -21.3629542
  },
  {
    lng: -41.2543794,
    lat: -21.3629568
  },
  {
    lng: -41.2543777,
    lat: -21.3629593
  },
  {
    lng: -41.2543758,
    lat: -21.3629618
  },
  {
    lng: -41.254374,
    lat: -21.3629644
  },
  {
    lng: -41.254372,
    lat: -21.3629668
  },
  {
    lng: -41.2543701,
    lat: -21.3629693
  },
  {
    lng: -41.2543683,
    lat: -21.3629718
  },
  {
    lng: -41.2543665,
    lat: -21.3629744
  },
  {
    lng: -41.2543647,
    lat: -21.3629769
  },
  {
    lng: -41.254363,
    lat: -21.3629795
  },
  {
    lng: -41.2543612,
    lat: -21.3629821
  },
  {
    lng: -41.2543594,
    lat: -21.3629846
  },
  {
    lng: -41.2543577,
    lat: -21.3629872
  },
  {
    lng: -41.2543559,
    lat: -21.3629898
  },
  {
    lng: -41.2543541,
    lat: -21.3629924
  },
  {
    lng: -41.2543524,
    lat: -21.3629949
  },
  {
    lng: -41.2543506,
    lat: -21.3629975
  },
  {
    lng: -41.2543489,
    lat: -21.3630001
  },
  {
    lng: -41.2543471,
    lat: -21.3630027
  },
  {
    lng: -41.2543453,
    lat: -21.3630052
  },
  {
    lng: -41.2543436,
    lat: -21.3630078
  },
  {
    lng: -41.2543418,
    lat: -21.3630104
  },
  {
    lng: -41.2543401,
    lat: -21.363013
  },
  {
    lng: -41.2543383,
    lat: -21.3630155
  },
  {
    lng: -41.2543366,
    lat: -21.3630181
  },
  {
    lng: -41.2543348,
    lat: -21.3630207
  },
  {
    lng: -41.254333,
    lat: -21.3630233
  },
  {
    lng: -41.2543313,
    lat: -21.3630259
  },
  {
    lng: -41.2543295,
    lat: -21.3630284
  },
  {
    lng: -41.2543278,
    lat: -21.363031
  },
  {
    lng: -41.254326,
    lat: -21.3630336
  },
  {
    lng: -41.2543243,
    lat: -21.3630362
  },
  {
    lng: -41.2543226,
    lat: -21.3630388
  },
  {
    lng: -41.2543208,
    lat: -21.3630414
  },
  {
    lng: -41.2543191,
    lat: -21.363044
  },
  {
    lng: -41.2543175,
    lat: -21.3630467
  },
  {
    lng: -41.254316,
    lat: -21.3630494
  },
  {
    lng: -41.2543143,
    lat: -21.363052
  },
  {
    lng: -41.2543126,
    lat: -21.3630546
  },
  {
    lng: -41.2543109,
    lat: -21.3630572
  },
  {
    lng: -41.2543092,
    lat: -21.3630598
  },
  {
    lng: -41.2543074,
    lat: -21.3630624
  },
  {
    lng: -41.2543057,
    lat: -21.363065
  },
  {
    lng: -41.2543042,
    lat: -21.3630678
  },
  {
    lng: -41.2543027,
    lat: -21.3630705
  },
  {
    lng: -41.2543012,
    lat: -21.3630732
  },
  {
    lng: -41.2542997,
    lat: -21.3630759
  },
  {
    lng: -41.2542163,
    lat: -21.3632364
  },
  {
    lng: -41.254215,
    lat: -21.3632392
  },
  {
    lng: -41.2542137,
    lat: -21.363242
  },
  {
    lng: -41.2542123,
    lat: -21.3632448
  },
  {
    lng: -41.2542109,
    lat: -21.3632476
  },
  {
    lng: -41.2542098,
    lat: -21.3632505
  },
  {
    lng: -41.2542087,
    lat: -21.3632534
  },
  {
    lng: -41.2542076,
    lat: -21.3632563
  },
  {
    lng: -41.2542065,
    lat: -21.3632592
  },
  {
    lng: -41.2541472,
    lat: -21.3634283
  },
  {
    lng: -41.2541463,
    lat: -21.3634312
  },
  {
    lng: -41.2541454,
    lat: -21.3634342
  },
  {
    lng: -41.2541444,
    lat: -21.3634371
  },
  {
    lng: -41.2541435,
    lat: -21.36344
  },
  {
    lng: -41.2541429,
    lat: -21.3634452
  },
  {
    lng: -41.2541423,
    lat: -21.3634505
  },
  {
    lng: -41.2541418,
    lat: -21.3634557
  },
  {
    lng: -41.2541411,
    lat: -21.363461
  },
  {
    lng: -41.2541403,
    lat: -21.3634662
  },
  {
    lng: -41.2541396,
    lat: -21.3634714
  },
  {
    lng: -41.2541391,
    lat: -21.3634766
  },
  {
    lng: -41.2541386,
    lat: -21.3634819
  },
  {
    lng: -41.2541381,
    lat: -21.3634871
  },
  {
    lng: -41.2541375,
    lat: -21.3634924
  },
  {
    lng: -41.254137,
    lat: -21.3634976
  },
  {
    lng: -41.2541365,
    lat: -21.3635029
  },
  {
    lng: -41.254136,
    lat: -21.3635081
  },
  {
    lng: -41.2541355,
    lat: -21.3635134
  },
  {
    lng: -41.254135,
    lat: -21.3635186
  },
  {
    lng: -41.2541189,
    lat: -21.3636866
  },
  {
    lng: -41.2541184,
    lat: -21.3636918
  },
  {
    lng: -41.2541179,
    lat: -21.3636971
  },
  {
    lng: -41.2541174,
    lat: -21.3637023
  },
  {
    lng: -41.254117,
    lat: -21.3637076
  },
  {
    lng: -41.2541165,
    lat: -21.3637128
  },
  {
    lng: -41.254116,
    lat: -21.3637181
  },
  {
    lng: -41.2541155,
    lat: -21.3637233
  },
  {
    lng: -41.254115,
    lat: -21.3637286
  },
  {
    lng: -41.2541145,
    lat: -21.3637338
  },
  {
    lng: -41.2541142,
    lat: -21.3637391
  },
  {
    lng: -41.254114,
    lat: -21.3637444
  },
  {
    lng: -41.2541137,
    lat: -21.3637496
  },
  {
    lng: -41.2541132,
    lat: -21.3637549
  },
  {
    lng: -41.2541128,
    lat: -21.3637601
  },
  {
    lng: -41.2541123,
    lat: -21.3637654
  },
  {
    lng: -41.2541122,
    lat: -21.3637707
  },
  {
    lng: -41.254112,
    lat: -21.3637759
  },
  {
    lng: -41.2541118,
    lat: -21.3637812
  },
  {
    lng: -41.2541116,
    lat: -21.3637865
  },
  {
    lng: -41.2541114,
    lat: -21.3637917
  },
  {
    lng: -41.254111,
    lat: -21.363797
  },
  {
    lng: -41.2541107,
    lat: -21.3638023
  },
  {
    lng: -41.2541105,
    lat: -21.3638075
  },
  {
    lng: -41.2541104,
    lat: -21.3638128
  },
  {
    lng: -41.2541102,
    lat: -21.3638181
  },
  {
    lng: -41.2541101,
    lat: -21.3638233
  },
  {
    lng: -41.25411,
    lat: -21.3638286
  },
  {
    lng: -41.2541099,
    lat: -21.3638339
  },
  {
    lng: -41.2541098,
    lat: -21.3638392
  },
  {
    lng: -41.2541096,
    lat: -21.3638444
  },
  {
    lng: -41.2541095,
    lat: -21.3638497
  },
  {
    lng: -41.2541094,
    lat: -21.363855
  },
  {
    lng: -41.2541093,
    lat: -21.3638603
  },
  {
    lng: -41.2541092,
    lat: -21.3638655
  },
  {
    lng: -41.254109,
    lat: -21.3638708
  },
  {
    lng: -41.2541076,
    lat: -21.3639393
  },
  {
    lng: -41.2541075,
    lat: -21.3639446
  },
  {
    lng: -41.2541073,
    lat: -21.3639499
  },
  {
    lng: -41.2541072,
    lat: -21.3639552
  },
  {
    lng: -41.2541071,
    lat: -21.3639604
  },
  {
    lng: -41.254107,
    lat: -21.3639657
  },
  {
    lng: -41.2541069,
    lat: -21.363971
  },
  {
    lng: -41.2541068,
    lat: -21.3639762
  },
  {
    lng: -41.2541067,
    lat: -21.3639815
  },
  {
    lng: -41.2541066,
    lat: -21.3639868
  },
  {
    lng: -41.2541065,
    lat: -21.3639921
  },
  {
    lng: -41.2541064,
    lat: -21.3639973
  },
  {
    lng: -41.2541063,
    lat: -21.3640026
  },
  {
    lng: -41.2541063,
    lat: -21.3640079
  },
  {
    lng: -41.2541063,
    lat: -21.3640131
  },
  {
    lng: -41.2541065,
    lat: -21.3640184
  },
  {
    lng: -41.2541065,
    lat: -21.3640237
  },
  {
    lng: -41.2541064,
    lat: -21.364029
  },
  {
    lng: -41.2541064,
    lat: -21.3640342
  },
  {
    lng: -41.2541063,
    lat: -21.3640395
  },
  {
    lng: -41.2541063,
    lat: -21.3640448
  },
  {
    lng: -41.2541062,
    lat: -21.36405
  },
  {
    lng: -41.2541062,
    lat: -21.3640553
  },
  {
    lng: -41.2541062,
    lat: -21.3640606
  },
  {
    lng: -41.2541064,
    lat: -21.3640659
  },
  {
    lng: -41.2541062,
    lat: -21.3640729
  },
  {
    lng: -41.2541061,
    lat: -21.36408
  },
  {
    lng: -41.2541057,
    lat: -21.364087
  },
  {
    lng: -41.2541055,
    lat: -21.3640941
  },
  {
    lng: -41.2541053,
    lat: -21.3641011
  },
  {
    lng: -41.2541052,
    lat: -21.3641082
  },
  {
    lng: -41.2541049,
    lat: -21.3641152
  },
  {
    lng: -41.2541047,
    lat: -21.3641223
  },
  {
    lng: -41.2541045,
    lat: -21.3641293
  },
  {
    lng: -41.2541044,
    lat: -21.3641364
  },
  {
    lng: -41.2541042,
    lat: -21.3641435
  },
  {
    lng: -41.254104,
    lat: -21.3641505
  },
  {
    lng: -41.2541038,
    lat: -21.3641576
  },
  {
    lng: -41.2541036,
    lat: -21.3641646
  },
  {
    lng: -41.2541033,
    lat: -21.3641717
  },
  {
    lng: -41.2541029,
    lat: -21.3641787
  },
  {
    lng: -41.2541025,
    lat: -21.3641858
  },
  {
    lng: -41.2541022,
    lat: -21.3641928
  },
  {
    lng: -41.2541019,
    lat: -21.3641999
  },
  {
    lng: -41.2541015,
    lat: -21.3642069
  },
  {
    lng: -41.2541013,
    lat: -21.364214
  },
  {
    lng: -41.254101,
    lat: -21.364221
  },
  {
    lng: -41.2541008,
    lat: -21.3642281
  },
  {
    lng: -41.2541004,
    lat: -21.3642351
  },
  {
    lng: -41.2541,
    lat: -21.3642422
  },
  {
    lng: -41.2540996,
    lat: -21.3642492
  },
  {
    lng: -41.2540993,
    lat: -21.3642562
  },
  {
    lng: -41.2540989,
    lat: -21.3642633
  },
  {
    lng: -41.2540984,
    lat: -21.3642703
  },
  {
    lng: -41.254098,
    lat: -21.3642774
  },
  {
    lng: -41.2540976,
    lat: -21.3642844
  },
  {
    lng: -41.2540972,
    lat: -21.3642915
  },
  {
    lng: -41.2540968,
    lat: -21.3642985
  },
  {
    lng: -41.2540964,
    lat: -21.3643056
  },
  {
    lng: -41.254096,
    lat: -21.3643126
  },
  {
    lng: -41.2540956,
    lat: -21.3643196
  },
  {
    lng: -41.2540952,
    lat: -21.3643267
  },
  {
    lng: -41.2540948,
    lat: -21.3643337
  },
  {
    lng: -41.2540944,
    lat: -21.3643408
  },
  {
    lng: -41.2540939,
    lat: -21.3643478
  },
  {
    lng: -41.2540935,
    lat: -21.3643549
  },
  {
    lng: -41.2540931,
    lat: -21.3643619
  },
  {
    lng: -41.2540927,
    lat: -21.364369
  },
  {
    lng: -41.2540923,
    lat: -21.364376
  },
  {
    lng: -41.2540919,
    lat: -21.364383
  },
  {
    lng: -41.2540914,
    lat: -21.3643901
  },
  {
    lng: -41.254091,
    lat: -21.3643971
  },
  {
    lng: -41.2540905,
    lat: -21.3644042
  },
  {
    lng: -41.2540899,
    lat: -21.3644112
  },
  {
    lng: -41.2540895,
    lat: -21.3644182
  },
  {
    lng: -41.2540888,
    lat: -21.3644253
  },
  {
    lng: -41.2540883,
    lat: -21.3644323
  },
  {
    lng: -41.2540878,
    lat: -21.3644394
  },
  {
    lng: -41.2540874,
    lat: -21.3644464
  },
  {
    lng: -41.2540869,
    lat: -21.3644534
  },
  {
    lng: -41.2540865,
    lat: -21.3644605
  },
  {
    lng: -41.254086,
    lat: -21.3644675
  },
  {
    lng: -41.2540854,
    lat: -21.3644745
  },
  {
    lng: -41.2540847,
    lat: -21.3644816
  },
  {
    lng: -41.2540841,
    lat: -21.3644886
  },
  {
    lng: -41.2540834,
    lat: -21.3644956
  },
  {
    lng: -41.2540828,
    lat: -21.3645026
  },
  {
    lng: -41.2540821,
    lat: -21.3645097
  },
  {
    lng: -41.2540816,
    lat: -21.3645167
  },
  {
    lng: -41.2540809,
    lat: -21.3645237
  },
  {
    lng: -41.2540805,
    lat: -21.3645308
  },
  {
    lng: -41.2540798,
    lat: -21.3645378
  },
  {
    lng: -41.2540792,
    lat: -21.3645448
  },
  {
    lng: -41.2540787,
    lat: -21.3645519
  },
  {
    lng: -41.254078,
    lat: -21.3645589
  },
  {
    lng: -41.2540774,
    lat: -21.3645659
  },
  {
    lng: -41.2540767,
    lat: -21.364573
  },
  {
    lng: -41.254076,
    lat: -21.36458
  },
  {
    lng: -41.2540753,
    lat: -21.364587
  },
  {
    lng: -41.2540747,
    lat: -21.364594
  },
  {
    lng: -41.254074,
    lat: -21.364601
  },
  {
    lng: -41.2540733,
    lat: -21.3646081
  },
  {
    lng: -41.2540726,
    lat: -21.3646151
  },
  {
    lng: -41.2540719,
    lat: -21.3646221
  },
  {
    lng: -41.2540712,
    lat: -21.3646291
  },
  {
    lng: -41.2540705,
    lat: -21.3646362
  },
  {
    lng: -41.2540698,
    lat: -21.3646432
  },
  {
    lng: -41.254069,
    lat: -21.3646502
  },
  {
    lng: -41.2540683,
    lat: -21.3646572
  },
  {
    lng: -41.2540676,
    lat: -21.3646642
  },
  {
    lng: -41.2540666,
    lat: -21.3646712
  },
  {
    lng: -41.2540659,
    lat: -21.3646783
  },
  {
    lng: -41.2540652,
    lat: -21.3646853
  },
  {
    lng: -41.2540644,
    lat: -21.3646923
  },
  {
    lng: -41.2540637,
    lat: -21.3646993
  },
  {
    lng: -41.254063,
    lat: -21.3647063
  },
  {
    lng: -41.2540623,
    lat: -21.3647133
  },
  {
    lng: -41.2540616,
    lat: -21.3647204
  },
  {
    lng: -41.2540614,
    lat: -21.364722
  },
  {
    lng: -41.2540612,
    lat: -21.3647235
  },
  {
    lng: -41.2540609,
    lat: -21.3647251
  },
  {
    lng: -41.2540605,
    lat: -21.3647266
  },
  {
    lng: -41.2540601,
    lat: -21.3647282
  },
  {
    lng: -41.2540598,
    lat: -21.3647298
  },
  {
    lng: -41.2540597,
    lat: -21.3647314
  },
  {
    lng: -41.2540595,
    lat: -21.364733
  },
  {
    lng: -41.2540591,
    lat: -21.3647345
  },
  {
    lng: -41.2540586,
    lat: -21.3647361
  },
  {
    lng: -41.2540582,
    lat: -21.3647376
  },
  {
    lng: -41.2540578,
    lat: -21.3647391
  },
  {
    lng: -41.2540574,
    lat: -21.3647407
  },
  {
    lng: -41.2540569,
    lat: -21.3647422
  },
  {
    lng: -41.2540403,
    lat: -21.3648007
  },
  {
    lng: -41.25404,
    lat: -21.3648023
  },
  {
    lng: -41.2540395,
    lat: -21.3648038
  },
  {
    lng: -41.254039,
    lat: -21.3648053
  },
  {
    lng: -41.2540385,
    lat: -21.3648068
  },
  {
    lng: -41.2540381,
    lat: -21.3648084
  },
  {
    lng: -41.2540376,
    lat: -21.3648099
  },
  {
    lng: -41.254037,
    lat: -21.3648114
  },
  {
    lng: -41.2540362,
    lat: -21.3648128
  },
  {
    lng: -41.2540357,
    lat: -21.3648143
  },
  {
    lng: -41.2540352,
    lat: -21.3648158
  },
  {
    lng: -41.2540347,
    lat: -21.3648173
  },
  {
    lng: -41.2540342,
    lat: -21.3648188
  },
  {
    lng: -41.2540334,
    lat: -21.3648202
  },
  {
    lng: -41.2540326,
    lat: -21.3648216
  },
  {
    lng: -41.2540319,
    lat: -21.364823
  },
  {
    lng: -41.2540313,
    lat: -21.3648245
  },
  {
    lng: -41.2540307,
    lat: -21.364826
  },
  {
    lng: -41.2540299,
    lat: -21.3648274
  },
  {
    lng: -41.254029,
    lat: -21.3648287
  },
  {
    lng: -41.2540282,
    lat: -21.3648301
  },
  {
    lng: -41.2540274,
    lat: -21.3648315
  },
  {
    lng: -41.2540266,
    lat: -21.3648328
  },
  {
    lng: -41.2540258,
    lat: -21.3648342
  },
  {
    lng: -41.2540249,
    lat: -21.3648355
  },
  {
    lng: -41.253985,
    lat: -21.3648993
  },
  {
    lng: -41.2539842,
    lat: -21.3649006
  },
  {
    lng: -41.2539833,
    lat: -21.3649019
  },
  {
    lng: -41.2539825,
    lat: -21.3649033
  },
  {
    lng: -41.2539816,
    lat: -21.3649046
  },
  {
    lng: -41.2539807,
    lat: -21.3649059
  },
  {
    lng: -41.2539798,
    lat: -21.3649073
  },
  {
    lng: -41.253979,
    lat: -21.3649086
  },
  {
    lng: -41.2539779,
    lat: -21.3649098
  },
  {
    lng: -41.2539768,
    lat: -21.364911
  },
  {
    lng: -41.2539758,
    lat: -21.3649123
  },
  {
    lng: -41.2539749,
    lat: -21.3649136
  },
  {
    lng: -41.253974,
    lat: -21.3649149
  },
  {
    lng: -41.2539729,
    lat: -21.364916
  },
  {
    lng: -41.2539718,
    lat: -21.3649171
  },
  {
    lng: -41.2539706,
    lat: -21.3649183
  },
  {
    lng: -41.2539695,
    lat: -21.3649194
  },
  {
    lng: -41.2539686,
    lat: -21.3649207
  },
  {
    lng: -41.2539675,
    lat: -21.3649219
  },
  {
    lng: -41.2539664,
    lat: -21.3649231
  },
  {
    lng: -41.2539652,
    lat: -21.3649242
  },
  {
    lng: -41.2539641,
    lat: -21.3649253
  },
  {
    lng: -41.2539629,
    lat: -21.3649264
  },
  {
    lng: -41.2539617,
    lat: -21.3649274
  },
  {
    lng: -41.2539606,
    lat: -21.3649285
  },
  {
    lng: -41.2539594,
    lat: -21.3649297
  },
  {
    lng: -41.2539583,
    lat: -21.3649308
  },
  {
    lng: -41.2539571,
    lat: -21.3649319
  },
  {
    lng: -41.2539559,
    lat: -21.3649329
  },
  {
    lng: -41.2539548,
    lat: -21.364934
  },
  {
    lng: -41.2539536,
    lat: -21.3649351
  },
  {
    lng: -41.2539524,
    lat: -21.3649362
  },
  {
    lng: -41.2539512,
    lat: -21.3649373
  },
  {
    lng: -41.2539501,
    lat: -21.3649384
  },
  {
    lng: -41.25393,
    lat: -21.3649568
  },
  {
    lng: -41.2539234,
    lat: -21.3649628
  },
  {
    lng: -41.2539168,
    lat: -21.3649689
  },
  {
    lng: -41.2539102,
    lat: -21.3649749
  },
  {
    lng: -41.2539036,
    lat: -21.364981
  },
  {
    lng: -41.253897,
    lat: -21.364987
  },
  {
    lng: -41.2538903,
    lat: -21.3649929
  },
  {
    lng: -41.2538835,
    lat: -21.3649987
  },
  {
    lng: -41.2538768,
    lat: -21.3650047
  },
  {
    lng: -41.2538702,
    lat: -21.3650107
  },
  {
    lng: -41.2538635,
    lat: -21.3650167
  },
  {
    lng: -41.2538567,
    lat: -21.3650224
  },
  {
    lng: -41.2538499,
    lat: -21.3650282
  },
  {
    lng: -41.253843,
    lat: -21.365034
  },
  {
    lng: -41.2538362,
    lat: -21.3650398
  },
  {
    lng: -41.2538296,
    lat: -21.3650458
  },
  {
    lng: -41.2538228,
    lat: -21.3650517
  },
  {
    lng: -41.253816,
    lat: -21.3650574
  },
  {
    lng: -41.2538091,
    lat: -21.3650631
  },
  {
    lng: -41.2538022,
    lat: -21.3650688
  },
  {
    lng: -41.2537954,
    lat: -21.3650746
  },
  {
    lng: -41.2537885,
    lat: -21.3650803
  },
  {
    lng: -41.2537816,
    lat: -21.365086
  },
  {
    lng: -41.2535132,
    lat: -21.3653089
  },
  {
    lng: -41.2535063,
    lat: -21.3653147
  },
  {
    lng: -41.2534994,
    lat: -21.3653204
  },
  {
    lng: -41.2534925,
    lat: -21.3653261
  },
  {
    lng: -41.2534856,
    lat: -21.3653318
  },
  {
    lng: -41.2534787,
    lat: -21.3653375
  },
  {
    lng: -41.2534718,
    lat: -21.3653432
  },
  {
    lng: -41.2534648,
    lat: -21.3653487
  },
  {
    lng: -41.2534577,
    lat: -21.3653542
  },
  {
    lng: -41.2534508,
    lat: -21.3653598
  },
  {
    lng: -41.2534438,
    lat: -21.3653654
  },
  {
    lng: -41.2534369,
    lat: -21.3653711
  },
  {
    lng: -41.25343,
    lat: -21.3653767
  },
  {
    lng: -41.2534229,
    lat: -21.3653823
  },
  {
    lng: -41.2534159,
    lat: -21.3653878
  },
  {
    lng: -41.2534089,
    lat: -21.3653933
  },
  {
    lng: -41.2534018,
    lat: -21.3653988
  },
  {
    lng: -41.2533948,
    lat: -21.3654043
  },
  {
    lng: -41.2533877,
    lat: -21.3654098
  },
  {
    lng: -41.2533807,
    lat: -21.3654154
  },
  {
    lng: -41.2533736,
    lat: -21.3654209
  },
  {
    lng: -41.2533666,
    lat: -21.3654264
  },
  {
    lng: -41.2533595,
    lat: -21.3654319
  },
  {
    lng: -41.2533525,
    lat: -21.3654374
  },
  {
    lng: -41.2533454,
    lat: -21.3654429
  },
  {
    lng: -41.2533383,
    lat: -21.3654484
  },
  {
    lng: -41.2533313,
    lat: -21.3654539
  },
  {
    lng: -41.2533242,
    lat: -21.3654594
  },
  {
    lng: -41.2533172,
    lat: -21.3654649
  },
  {
    lng: -41.2533157,
    lat: -21.3654658
  },
  {
    lng: -41.2533141,
    lat: -21.3654667
  },
  {
    lng: -41.2533126,
    lat: -21.3654676
  },
  {
    lng: -41.2533111,
    lat: -21.3654684
  },
  {
    lng: -41.2533096,
    lat: -21.3654694
  },
  {
    lng: -41.2533081,
    lat: -21.3654703
  },
  {
    lng: -41.2533067,
    lat: -21.3654714
  },
  {
    lng: -41.2533052,
    lat: -21.3654724
  },
  {
    lng: -41.2533037,
    lat: -21.3654733
  },
  {
    lng: -41.2533022,
    lat: -21.3654742
  },
  {
    lng: -41.2533007,
    lat: -21.3654751
  },
  {
    lng: -41.2532991,
    lat: -21.365476
  },
  {
    lng: -41.2532976,
    lat: -21.3654768
  },
  {
    lng: -41.253296,
    lat: -21.3654777
  },
  {
    lng: -41.2532945,
    lat: -21.3654785
  },
  {
    lng: -41.253293,
    lat: -21.3654794
  },
  {
    lng: -41.2532914,
    lat: -21.3654803
  },
  {
    lng: -41.2532899,
    lat: -21.3654811
  },
  {
    lng: -41.2532883,
    lat: -21.365482
  },
  {
    lng: -41.2532868,
    lat: -21.3654828
  },
  {
    lng: -41.2532852,
    lat: -21.3654837
  },
  {
    lng: -41.2532837,
    lat: -21.3654845
  },
  {
    lng: -41.2532822,
    lat: -21.3654854
  },
  {
    lng: -41.2532806,
    lat: -21.3654863
  },
  {
    lng: -41.2532791,
    lat: -21.3654871
  },
  {
    lng: -41.2532775,
    lat: -21.365488
  },
  {
    lng: -41.253276,
    lat: -21.3654888
  },
  {
    lng: -41.2532744,
    lat: -21.3654897
  },
  {
    lng: -41.2532729,
    lat: -21.3654905
  },
  {
    lng: -41.2532713,
    lat: -21.3654914
  },
  {
    lng: -41.2532698,
    lat: -21.3654922
  },
  {
    lng: -41.2532682,
    lat: -21.3654931
  },
  {
    lng: -41.2532667,
    lat: -21.3654939
  },
  {
    lng: -41.2532651,
    lat: -21.3654947
  },
  {
    lng: -41.2532636,
    lat: -21.3654956
  },
  {
    lng: -41.253262,
    lat: -21.3654964
  },
  {
    lng: -41.2532604,
    lat: -21.3654971
  },
  {
    lng: -41.2532587,
    lat: -21.3654977
  },
  {
    lng: -41.2532571,
    lat: -21.3654985
  },
  {
    lng: -41.2532555,
    lat: -21.3654993
  },
  {
    lng: -41.253254,
    lat: -21.3655001
  },
  {
    lng: -41.2532524,
    lat: -21.3655009
  },
  {
    lng: -41.2532509,
    lat: -21.3655017
  },
  {
    lng: -41.2532493,
    lat: -21.3655025
  },
  {
    lng: -41.2532476,
    lat: -21.3655031
  },
  {
    lng: -41.253246,
    lat: -21.3655037
  },
  {
    lng: -41.2532443,
    lat: -21.3655043
  },
  {
    lng: -41.2532427,
    lat: -21.365505
  },
  {
    lng: -41.2532411,
    lat: -21.3655058
  },
  {
    lng: -41.2532395,
    lat: -21.3655065
  },
  {
    lng: -41.2532379,
    lat: -21.3655072
  },
  {
    lng: -41.2532362,
    lat: -21.3655077
  },
  {
    lng: -41.2532345,
    lat: -21.3655083
  },
  {
    lng: -41.2532328,
    lat: -21.3655088
  },
  {
    lng: -41.2532312,
    lat: -21.3655094
  },
  {
    lng: -41.2532295,
    lat: -21.36551
  },
  {
    lng: -41.2532278,
    lat: -21.3655106
  },
  {
    lng: -41.2532262,
    lat: -21.3655112
  },
  {
    lng: -41.2532245,
    lat: -21.3655117
  },
  {
    lng: -41.2532228,
    lat: -21.3655122
  },
  {
    lng: -41.2532211,
    lat: -21.3655128
  },
  {
    lng: -41.2532195,
    lat: -21.3655133
  },
  {
    lng: -41.2532178,
    lat: -21.3655139
  },
  {
    lng: -41.2532161,
    lat: -21.3655144
  },
  {
    lng: -41.2532144,
    lat: -21.365515
  },
  {
    lng: -41.2532128,
    lat: -21.3655157
  },
  {
    lng: -41.2532111,
    lat: -21.3655162
  },
  {
    lng: -41.2532094,
    lat: -21.3655167
  },
  {
    lng: -41.2532078,
    lat: -21.3655173
  },
  {
    lng: -41.2531994,
    lat: -21.36552
  },
  {
    lng: -41.2531977,
    lat: -21.3655206
  },
  {
    lng: -41.253196,
    lat: -21.3655211
  },
  {
    lng: -41.2531943,
    lat: -21.3655217
  },
  {
    lng: -41.2531926,
    lat: -21.3655221
  },
  {
    lng: -41.2531909,
    lat: -21.3655227
  },
  {
    lng: -41.2531893,
    lat: -21.3655232
  },
  {
    lng: -41.2531876,
    lat: -21.3655238
  },
  {
    lng: -41.2531859,
    lat: -21.3655243
  },
  {
    lng: -41.2531842,
    lat: -21.3655248
  },
  {
    lng: -41.2531825,
    lat: -21.3655254
  },
  {
    lng: -41.2531809,
    lat: -21.3655259
  },
  {
    lng: -41.2531792,
    lat: -21.3655265
  },
  {
    lng: -41.2531775,
    lat: -21.3655269
  },
  {
    lng: -41.2531758,
    lat: -21.3655275
  },
  {
    lng: -41.2531741,
    lat: -21.365528
  },
  {
    lng: -41.2531724,
    lat: -21.3655285
  },
  {
    lng: -41.2531708,
    lat: -21.3655291
  },
  {
    lng: -41.2531691,
    lat: -21.3655296
  },
  {
    lng: -41.2531674,
    lat: -21.3655301
  },
  {
    lng: -41.2531656,
    lat: -21.3655304
  },
  {
    lng: -41.2531639,
    lat: -21.3655307
  },
  {
    lng: -41.2531622,
    lat: -21.3655311
  },
  {
    lng: -41.2531605,
    lat: -21.3655316
  },
  {
    lng: -41.2531588,
    lat: -21.3655321
  },
  {
    lng: -41.2531571,
    lat: -21.3655326
  },
  {
    lng: -41.2531554,
    lat: -21.3655329
  },
  {
    lng: -41.2531536,
    lat: -21.3655331
  },
  {
    lng: -41.2531519,
    lat: -21.3655333
  },
  {
    lng: -41.2531502,
    lat: -21.3655336
  },
  {
    lng: -41.2531484,
    lat: -21.3655341
  },
  {
    lng: -41.2531467,
    lat: -21.3655345
  },
  {
    lng: -41.253145,
    lat: -21.3655347
  },
  {
    lng: -41.2531432,
    lat: -21.3655349
  },
  {
    lng: -41.2531415,
    lat: -21.3655351
  },
  {
    lng: -41.2531397,
    lat: -21.3655353
  },
  {
    lng: -41.253138,
    lat: -21.3655355
  },
  {
    lng: -41.2531362,
    lat: -21.3655357
  },
  {
    lng: -41.2531345,
    lat: -21.365536
  },
  {
    lng: -41.2531327,
    lat: -21.3655362
  },
  {
    lng: -41.2531309,
    lat: -21.3655364
  },
  {
    lng: -41.2531292,
    lat: -21.3655365
  },
  {
    lng: -41.2531274,
    lat: -21.3655367
  },
  {
    lng: -41.2531257,
    lat: -21.3655369
  },
  {
    lng: -41.2531239,
    lat: -21.3655371
  },
  {
    lng: -41.2531222,
    lat: -21.3655373
  },
  {
    lng: -41.2531204,
    lat: -21.3655375
  },
  {
    lng: -41.2531187,
    lat: -21.3655378
  },
  {
    lng: -41.2531169,
    lat: -21.365538
  },
  {
    lng: -41.2531152,
    lat: -21.3655381
  },
  {
    lng: -41.2531134,
    lat: -21.3655383
  },
  {
    lng: -41.2531046,
    lat: -21.3655392
  },
  {
    lng: -41.2531029,
    lat: -21.3655394
  },
  {
    lng: -41.2531011,
    lat: -21.3655396
  },
  {
    lng: -41.2530993,
    lat: -21.3655398
  },
  {
    lng: -41.2530976,
    lat: -21.3655398
  },
  {
    lng: -41.2530958,
    lat: -21.36554
  },
  {
    lng: -41.2530941,
    lat: -21.3655402
  },
  {
    lng: -41.2530923,
    lat: -21.3655404
  },
  {
    lng: -41.2530906,
    lat: -21.3655406
  },
  {
    lng: -41.2530888,
    lat: -21.3655407
  },
  {
    lng: -41.253087,
    lat: -21.3655409
  },
  {
    lng: -41.2530853,
    lat: -21.3655411
  },
  {
    lng: -41.2530835,
    lat: -21.3655413
  },
  {
    lng: -41.2530818,
    lat: -21.3655414
  },
  {
    lng: -41.25308,
    lat: -21.3655415
  },
  {
    lng: -41.2530783,
    lat: -21.3655417
  },
  {
    lng: -41.2530765,
    lat: -21.3655419
  },
  {
    lng: -41.2530748,
    lat: -21.3655421
  },
  {
    lng: -41.253073,
    lat: -21.3655422
  },
  {
    lng: -41.2530712,
    lat: -21.3655423
  },
  {
    lng: -41.2530695,
    lat: -21.3655423
  },
  {
    lng: -41.2530677,
    lat: -21.3655422
  },
  {
    lng: -41.2530659,
    lat: -21.3655423
  },
  {
    lng: -41.2530642,
    lat: -21.3655424
  },
  {
    lng: -41.2530624,
    lat: -21.3655425
  },
  {
    lng: -41.2530607,
    lat: -21.3655426
  },
  {
    lng: -41.2530589,
    lat: -21.3655426
  },
  {
    lng: -41.2530571,
    lat: -21.3655425
  },
  {
    lng: -41.2530554,
    lat: -21.3655425
  },
  {
    lng: -41.2530484,
    lat: -21.3655423
  },
  {
    lng: -41.2530414,
    lat: -21.3655421
  },
  {
    lng: -41.2530345,
    lat: -21.3655419
  },
  {
    lng: -41.2530275,
    lat: -21.3655418
  },
  {
    lng: -41.2530205,
    lat: -21.3655418
  },
  {
    lng: -41.2530135,
    lat: -21.3655418
  },
  {
    lng: -41.2530066,
    lat: -21.3655416
  },
  {
    lng: -41.2529996,
    lat: -21.3655414
  },
  {
    lng: -41.2529926,
    lat: -21.3655411
  },
  {
    lng: -41.2529857,
    lat: -21.3655409
  },
  {
    lng: -41.2529787,
    lat: -21.3655406
  },
  {
    lng: -41.2529717,
    lat: -21.3655404
  },
  {
    lng: -41.2529647,
    lat: -21.3655402
  },
  {
    lng: -41.2529578,
    lat: -21.3655399
  },
  {
    lng: -41.2529508,
    lat: -21.3655397
  },
  {
    lng: -41.2529438,
    lat: -21.3655395
  },
  {
    lng: -41.2529369,
    lat: -21.3655393
  },
  {
    lng: -41.2529299,
    lat: -21.365539
  },
  {
    lng: -41.2529229,
    lat: -21.3655388
  },
  {
    lng: -41.252916,
    lat: -21.3655385
  },
  {
    lng: -41.252909,
    lat: -21.3655383
  },
  {
    lng: -41.252902,
    lat: -21.365538
  },
  {
    lng: -41.252895,
    lat: -21.3655377
  },
  {
    lng: -41.2528881,
    lat: -21.3655375
  },
  {
    lng: -41.2528811,
    lat: -21.3655373
  },
  {
    lng: -41.2528741,
    lat: -21.365537
  },
  {
    lng: -41.2528672,
    lat: -21.3655368
  },
  {
    lng: -41.2528602,
    lat: -21.3655366
  },
  {
    lng: -41.2528532,
    lat: -21.3655363
  },
  {
    lng: -41.2528463,
    lat: -21.3655361
  },
  {
    lng: -41.2528393,
    lat: -21.3655358
  },
  {
    lng: -41.2528323,
    lat: -21.3655356
  },
  {
    lng: -41.2528254,
    lat: -21.3655353
  },
  {
    lng: -41.2528184,
    lat: -21.365535
  },
  {
    lng: -41.2528114,
    lat: -21.3655347
  },
  {
    lng: -41.2528044,
    lat: -21.3655345
  },
  {
    lng: -41.2527975,
    lat: -21.3655342
  },
  {
    lng: -41.2527905,
    lat: -21.3655339
  },
  {
    lng: -41.2527835,
    lat: -21.3655337
  },
  {
    lng: -41.2527766,
    lat: -21.3655334
  },
  {
    lng: -41.2527696,
    lat: -21.3655332
  },
  {
    lng: -41.2527626,
    lat: -21.3655329
  },
  {
    lng: -41.2527557,
    lat: -21.3655326
  },
  {
    lng: -41.2527487,
    lat: -21.3655321
  },
  {
    lng: -41.2527417,
    lat: -21.3655316
  },
  {
    lng: -41.2527348,
    lat: -21.3655312
  },
  {
    lng: -41.2527278,
    lat: -21.3655309
  },
  {
    lng: -41.2527209,
    lat: -21.3655306
  },
  {
    lng: -41.2527139,
    lat: -21.3655303
  },
  {
    lng: -41.2527069,
    lat: -21.36553
  },
  {
    lng: -41.2527,
    lat: -21.3655295
  },
  {
    lng: -41.252693,
    lat: -21.3655289
  },
  {
    lng: -41.2526861,
    lat: -21.3655284
  },
  {
    lng: -41.2526791,
    lat: -21.3655279
  },
  {
    lng: -41.2526722,
    lat: -21.3655274
  },
  {
    lng: -41.2526652,
    lat: -21.3655271
  },
  {
    lng: -41.2526582,
    lat: -21.3655267
  },
  {
    lng: -41.2526513,
    lat: -21.3655262
  },
  {
    lng: -41.2526443,
    lat: -21.3655256
  },
  {
    lng: -41.2526374,
    lat: -21.365525
  },
  {
    lng: -41.2526304,
    lat: -21.3655244
  },
  {
    lng: -41.2526235,
    lat: -21.3655239
  },
  {
    lng: -41.2526165,
    lat: -21.3655233
  },
  {
    lng: -41.2526096,
    lat: -21.3655227
  },
  {
    lng: -41.2526026,
    lat: -21.3655221
  },
  {
    lng: -41.2525957,
    lat: -21.3655216
  },
  {
    lng: -41.2525887,
    lat: -21.365521
  },
  {
    lng: -41.2525818,
    lat: -21.3655204
  },
  {
    lng: -41.2525748,
    lat: -21.3655198
  },
  {
    lng: -41.2525679,
    lat: -21.3655192
  },
  {
    lng: -41.2525609,
    lat: -21.3655187
  },
  {
    lng: -41.252554,
    lat: -21.3655181
  },
  {
    lng: -41.252547,
    lat: -21.3655175
  },
  {
    lng: -41.2525401,
    lat: -21.3655168
  },
  {
    lng: -41.2525331,
    lat: -21.3655163
  },
  {
    lng: -41.2525262,
    lat: -21.3655157
  },
  {
    lng: -41.2525192,
    lat: -21.365515
  },
  {
    lng: -41.2525123,
    lat: -21.3655145
  },
  {
    lng: -41.2525053,
    lat: -21.3655139
  },
  {
    lng: -41.2524984,
    lat: -21.3655133
  },
  {
    lng: -41.2524914,
    lat: -21.3655127
  },
  {
    lng: -41.2524845,
    lat: -21.3655121
  },
  {
    lng: -41.2524775,
    lat: -21.3655115
  },
  {
    lng: -41.2524706,
    lat: -21.3655109
  },
  {
    lng: -41.2524636,
    lat: -21.3655103
  },
  {
    lng: -41.2524567,
    lat: -21.3655097
  },
  {
    lng: -41.2524497,
    lat: -21.3655091
  },
  {
    lng: -41.2524428,
    lat: -21.3655085
  },
  {
    lng: -41.2524359,
    lat: -21.3655079
  },
  {
    lng: -41.2524289,
    lat: -21.3655072
  },
  {
    lng: -41.252422,
    lat: -21.3655067
  },
  {
    lng: -41.252415,
    lat: -21.3655061
  },
  {
    lng: -41.2524081,
    lat: -21.3655054
  },
  {
    lng: -41.2524011,
    lat: -21.3655048
  },
  {
    lng: -41.2523942,
    lat: -21.365504
  },
  {
    lng: -41.2523873,
    lat: -21.3655031
  },
  {
    lng: -41.2523803,
    lat: -21.3655024
  },
  {
    lng: -41.2523734,
    lat: -21.3655017
  },
  {
    lng: -41.2523664,
    lat: -21.3655011
  },
  {
    lng: -41.2523595,
    lat: -21.3655005
  },
  {
    lng: -41.2523526,
    lat: -21.3654998
  },
  {
    lng: -41.2523456,
    lat: -21.3654989
  },
  {
    lng: -41.2523387,
    lat: -21.365498
  },
  {
    lng: -41.2523318,
    lat: -21.3654971
  },
  {
    lng: -41.2523249,
    lat: -21.3654963
  },
  {
    lng: -41.2523179,
    lat: -21.3654956
  },
  {
    lng: -41.252311,
    lat: -21.3654949
  },
  {
    lng: -41.2523041,
    lat: -21.365494
  },
  {
    lng: -41.2522972,
    lat: -21.3654931
  },
  {
    lng: -41.2522903,
    lat: -21.3654922
  },
  {
    lng: -41.2522834,
    lat: -21.3654912
  },
  {
    lng: -41.2522764,
    lat: -21.3654903
  },
  {
    lng: -41.2522695,
    lat: -21.3654894
  },
  {
    lng: -41.2522626,
    lat: -21.3654885
  },
  {
    lng: -41.2522557,
    lat: -21.3654875
  },
  {
    lng: -41.2522488,
    lat: -21.3654866
  },
  {
    lng: -41.2522419,
    lat: -21.3654856
  },
  {
    lng: -41.252235,
    lat: -21.3654847
  },
  {
    lng: -41.2522281,
    lat: -21.3654838
  },
  {
    lng: -41.2522212,
    lat: -21.3654828
  },
  {
    lng: -41.2522142,
    lat: -21.3654819
  },
  {
    lng: -41.2522073,
    lat: -21.365481
  },
  {
    lng: -41.2522004,
    lat: -21.36548
  },
  {
    lng: -41.2521935,
    lat: -21.3654792
  },
  {
    lng: -41.2521866,
    lat: -21.3654782
  },
  {
    lng: -41.2521451,
    lat: -21.3654726
  },
  {
    lng: -41.2521382,
    lat: -21.3654716
  },
  {
    lng: -41.2521313,
    lat: -21.3654706
  },
  {
    lng: -41.2521244,
    lat: -21.3654696
  },
  {
    lng: -41.2521175,
    lat: -21.3654687
  },
  {
    lng: -41.2521106,
    lat: -21.3654677
  },
  {
    lng: -41.2520977,
    lat: -21.3654659
  },
  {
    lng: -41.2520848,
    lat: -21.3654642
  },
  {
    lng: -41.2520718,
    lat: -21.3654625
  },
  {
    lng: -41.251891,
    lat: -21.3654378
  },
  {
    lng: -41.2518781,
    lat: -21.3654359
  },
  {
    lng: -41.2518652,
    lat: -21.3654341
  },
  {
    lng: -41.2518523,
    lat: -21.3654324
  },
  {
    lng: -41.2518394,
    lat: -21.3654306
  },
  {
    lng: -41.2518265,
    lat: -21.3654288
  },
  {
    lng: -41.2518136,
    lat: -21.365427
  },
  {
    lng: -41.2518007,
    lat: -21.3654253
  },
  {
    lng: -41.2517878,
    lat: -21.3654235
  },
  {
    lng: -41.2517748,
    lat: -21.3654216
  },
  {
    lng: -41.2517619,
    lat: -21.3654199
  },
  {
    lng: -41.251749,
    lat: -21.3654181
  },
  {
    lng: -41.2517361,
    lat: -21.3654163
  },
  {
    lng: -41.2517232,
    lat: -21.3654145
  },
  {
    lng: -41.2517103,
    lat: -21.3654127
  },
  {
    lng: -41.2516974,
    lat: -21.3654109
  },
  {
    lng: -41.2516845,
    lat: -21.3654089
  },
  {
    lng: -41.2516716,
    lat: -21.3654069
  },
  {
    lng: -41.2516587,
    lat: -21.365405
  },
  {
    lng: -41.2516458,
    lat: -21.3654031
  },
  {
    lng: -41.2516329,
    lat: -21.3654013
  },
  {
    lng: -41.25162,
    lat: -21.3653995
  },
  {
    lng: -41.2516072,
    lat: -21.3653974
  },
  {
    lng: -41.2515943,
    lat: -21.3653953
  },
  {
    lng: -41.2515814,
    lat: -21.3653932
  },
  {
    lng: -41.2515685,
    lat: -21.3653912
  },
  {
    lng: -41.2515556,
    lat: -21.3653893
  },
  {
    lng: -41.2515427,
    lat: -21.3653874
  },
  {
    lng: -41.2515299,
    lat: -21.3653853
  },
  {
    lng: -41.251517,
    lat: -21.3653831
  },
  {
    lng: -41.2515042,
    lat: -21.365381
  },
  {
    lng: -41.2514913,
    lat: -21.3653788
  },
  {
    lng: -41.2514785,
    lat: -21.3653767
  },
  {
    lng: -41.2514656,
    lat: -21.3653745
  },
  {
    lng: -41.2512174,
    lat: -21.3653327
  },
  {
    lng: -41.2512103,
    lat: -21.3653315
  },
  {
    lng: -41.2512033,
    lat: -21.3653303
  },
  {
    lng: -41.2511962,
    lat: -21.3653291
  },
  {
    lng: -41.2511891,
    lat: -21.3653279
  },
  {
    lng: -41.251182,
    lat: -21.3653267
  },
  {
    lng: -41.2511749,
    lat: -21.3653254
  },
  {
    lng: -41.2511679,
    lat: -21.365324
  },
  {
    lng: -41.2511608,
    lat: -21.3653225
  },
  {
    lng: -41.2511537,
    lat: -21.3653213
  },
  {
    lng: -41.2511467,
    lat: -21.36532
  },
  {
    lng: -41.2511396,
    lat: -21.3653187
  },
  {
    lng: -41.2511325,
    lat: -21.3653175
  },
  {
    lng: -41.2511254,
    lat: -21.3653163
  },
  {
    lng: -41.2511183,
    lat: -21.3653151
  },
  {
    lng: -41.2511112,
    lat: -21.3653138
  },
  {
    lng: -41.2511042,
    lat: -21.3653126
  },
  {
    lng: -41.2510971,
    lat: -21.3653114
  },
  {
    lng: -41.25109,
    lat: -21.3653102
  },
  {
    lng: -41.2510829,
    lat: -21.365309
  },
  {
    lng: -41.2510758,
    lat: -21.3653077
  },
  {
    lng: -41.2510687,
    lat: -21.3653065
  },
  {
    lng: -41.2510616,
    lat: -21.3653053
  },
  {
    lng: -41.2510545,
    lat: -21.3653041
  },
  {
    lng: -41.2510475,
    lat: -21.3653029
  },
  {
    lng: -41.2510404,
    lat: -21.3653017
  },
  {
    lng: -41.2510333,
    lat: -21.3653005
  },
  {
    lng: -41.2510262,
    lat: -21.3652993
  },
  {
    lng: -41.2510191,
    lat: -21.3652981
  },
  {
    lng: -41.251012,
    lat: -21.3652969
  },
  {
    lng: -41.2510049,
    lat: -21.3652958
  },
  {
    lng: -41.2509978,
    lat: -21.3652946
  },
  {
    lng: -41.2509907,
    lat: -21.3652934
  },
  {
    lng: -41.2509836,
    lat: -21.3652922
  },
  {
    lng: -41.2509765,
    lat: -21.365291
  },
  {
    lng: -41.2509694,
    lat: -21.3652898
  },
  {
    lng: -41.2509624,
    lat: -21.3652887
  },
  {
    lng: -41.2509553,
    lat: -21.3652875
  },
  {
    lng: -41.2509482,
    lat: -21.3652863
  },
  {
    lng: -41.2509411,
    lat: -21.3652851
  },
  {
    lng: -41.250934,
    lat: -21.365284
  },
  {
    lng: -41.2509269,
    lat: -21.3652829
  },
  {
    lng: -41.2509197,
    lat: -21.3652819
  },
  {
    lng: -41.2509126,
    lat: -21.3652809
  },
  {
    lng: -41.2509055,
    lat: -21.3652798
  },
  {
    lng: -41.2508984,
    lat: -21.3652788
  },
  {
    lng: -41.2508913,
    lat: -21.3652778
  },
  {
    lng: -41.2508842,
    lat: -21.3652767
  },
  {
    lng: -41.2508771,
    lat: -21.3652756
  },
  {
    lng: -41.2508699,
    lat: -21.3652746
  },
  {
    lng: -41.2508628,
    lat: -21.3652736
  },
  {
    lng: -41.2508557,
    lat: -21.3652726
  },
  {
    lng: -41.2508486,
    lat: -21.3652716
  },
  {
    lng: -41.2508415,
    lat: -21.3652703
  },
  {
    lng: -41.2508344,
    lat: -21.3652693
  },
  {
    lng: -41.2508273,
    lat: -21.3652683
  },
  {
    lng: -41.2508201,
    lat: -21.3652673
  },
  {
    lng: -41.250813,
    lat: -21.3652663
  },
  {
    lng: -41.2508059,
    lat: -21.3652653
  },
  {
    lng: -41.2507988,
    lat: -21.3652643
  },
  {
    lng: -41.2507916,
    lat: -21.3652635
  },
  {
    lng: -41.2507845,
    lat: -21.3652625
  },
  {
    lng: -41.2507774,
    lat: -21.3652615
  },
  {
    lng: -41.2507703,
    lat: -21.3652605
  },
  {
    lng: -41.2507631,
    lat: -21.3652595
  },
  {
    lng: -41.250756,
    lat: -21.3652587
  },
  {
    lng: -41.2507489,
    lat: -21.3652577
  },
  {
    lng: -41.2507418,
    lat: -21.3652567
  },
  {
    lng: -41.2507346,
    lat: -21.3652557
  },
  {
    lng: -41.2507275,
    lat: -21.3652547
  },
  {
    lng: -41.2507204,
    lat: -21.3652538
  },
  {
    lng: -41.2507133,
    lat: -21.3652528
  },
  {
    lng: -41.2507061,
    lat: -21.3652518
  },
  {
    lng: -41.250699,
    lat: -21.3652508
  },
  {
    lng: -41.2506919,
    lat: -21.3652499
  },
  {
    lng: -41.2506848,
    lat: -21.3652489
  },
  {
    lng: -41.2506776,
    lat: -21.365248
  },
  {
    lng: -41.2506705,
    lat: -21.365247
  },
  {
    lng: -41.2506634,
    lat: -21.3652461
  },
  {
    lng: -41.2506562,
    lat: -21.3652454
  },
  {
    lng: -41.2506491,
    lat: -21.3652446
  },
  {
    lng: -41.2506419,
    lat: -21.3652437
  },
  {
    lng: -41.2506356,
    lat: -21.3652428
  },
  {
    lng: -41.2506293,
    lat: -21.3652419
  },
  {
    lng: -41.2506229,
    lat: -21.365241
  },
  {
    lng: -41.2506166,
    lat: -21.3652401
  },
  {
    lng: -41.2506102,
    lat: -21.3652392
  },
  {
    lng: -41.2506039,
    lat: -21.3652384
  },
  {
    lng: -41.2505976,
    lat: -21.3652375
  },
  {
    lng: -41.2505912,
    lat: -21.3652366
  },
  {
    lng: -41.2505849,
    lat: -21.3652357
  },
  {
    lng: -41.2505786,
    lat: -21.3652348
  },
  {
    lng: -41.2505722,
    lat: -21.3652339
  },
  {
    lng: -41.2505659,
    lat: -21.365233
  },
  {
    lng: -41.2505595,
    lat: -21.3652321
  },
  {
    lng: -41.2505532,
    lat: -21.3652312
  },
  {
    lng: -41.2505469,
    lat: -21.3652303
  },
  {
    lng: -41.2505405,
    lat: -21.3652294
  },
  {
    lng: -41.2505342,
    lat: -21.3652285
  },
  {
    lng: -41.2505279,
    lat: -21.3652276
  },
  {
    lng: -41.2505215,
    lat: -21.3652267
  },
  {
    lng: -41.2505152,
    lat: -21.3652258
  },
  {
    lng: -41.2505089,
    lat: -21.3652249
  },
  {
    lng: -41.2505025,
    lat: -21.365224
  },
  {
    lng: -41.2504962,
    lat: -21.3652231
  },
  {
    lng: -41.2504899,
    lat: -21.3652222
  },
  {
    lng: -41.2504835,
    lat: -21.3652211
  },
  {
    lng: -41.2504772,
    lat: -21.3652201
  },
  {
    lng: -41.2504709,
    lat: -21.365219
  },
  {
    lng: -41.2504646,
    lat: -21.365218
  },
  {
    lng: -41.2504583,
    lat: -21.365217
  },
  {
    lng: -41.2504519,
    lat: -21.3652161
  },
  {
    lng: -41.2504456,
    lat: -21.3652152
  },
  {
    lng: -41.2504393,
    lat: -21.3652142
  },
  {
    lng: -41.250433,
    lat: -21.3652133
  },
  {
    lng: -41.2504267,
    lat: -21.3652121
  },
  {
    lng: -41.2504204,
    lat: -21.365211
  },
  {
    lng: -41.2504141,
    lat: -21.3652098
  },
  {
    lng: -41.2504078,
    lat: -21.3652087
  },
  {
    lng: -41.2504014,
    lat: -21.3652077
  },
  {
    lng: -41.2503951,
    lat: -21.3652067
  },
  {
    lng: -41.2503888,
    lat: -21.3652056
  },
  {
    lng: -41.2503825,
    lat: -21.3652044
  },
  {
    lng: -41.2503763,
    lat: -21.3652032
  },
  {
    lng: -41.25037,
    lat: -21.365202
  },
  {
    lng: -41.2503637,
    lat: -21.3652007
  },
  {
    lng: -41.2503574,
    lat: -21.3651995
  },
  {
    lng: -41.2503511,
    lat: -21.3651984
  },
  {
    lng: -41.2503448,
    lat: -21.3651972
  },
  {
    lng: -41.2503385,
    lat: -21.365196
  },
  {
    lng: -41.2503323,
    lat: -21.3651947
  },
  {
    lng: -41.250326,
    lat: -21.3651935
  },
  {
    lng: -41.2503197,
    lat: -21.3651923
  },
  {
    lng: -41.2503134,
    lat: -21.3651911
  },
  {
    lng: -41.2503071,
    lat: -21.3651899
  },
  {
    lng: -41.2503009,
    lat: -21.3651887
  },
  {
    lng: -41.2502946,
    lat: -21.3651874
  },
  {
    lng: -41.2502883,
    lat: -21.3651863
  },
  {
    lng: -41.250282,
    lat: -21.3651851
  },
  {
    lng: -41.2502757,
    lat: -21.3651839
  },
  {
    lng: -41.2502694,
    lat: -21.3651827
  },
  {
    lng: -41.2502317,
    lat: -21.3651753
  },
  {
    lng: -41.2502255,
    lat: -21.365174
  },
  {
    lng: -41.2502192,
    lat: -21.3651728
  },
  {
    lng: -41.2502129,
    lat: -21.3651716
  },
  {
    lng: -41.2502066,
    lat: -21.3651703
  },
  {
    lng: -41.2502003,
    lat: -21.3651691
  },
  {
    lng: -41.2501985,
    lat: -21.3651687
  },
  {
    lng: -41.2501967,
    lat: -21.3651684
  },
  {
    lng: -41.2501948,
    lat: -21.3651679
  },
  {
    lng: -41.250193,
    lat: -21.3651676
  },
  {
    lng: -41.2501911,
    lat: -21.3651672
  },
  {
    lng: -41.2501893,
    lat: -21.3651668
  },
  {
    lng: -41.2501874,
    lat: -21.3651664
  },
  {
    lng: -41.2501856,
    lat: -21.365166
  },
  {
    lng: -41.2501838,
    lat: -21.3651654
  },
  {
    lng: -41.250182,
    lat: -21.3651648
  },
  {
    lng: -41.2501801,
    lat: -21.3651644
  },
  {
    lng: -41.2501783,
    lat: -21.3651639
  },
  {
    lng: -41.2501765,
    lat: -21.3651635
  },
  {
    lng: -41.2501746,
    lat: -21.3651631
  },
  {
    lng: -41.2501728,
    lat: -21.3651628
  },
  {
    lng: -41.2501709,
    lat: -21.3651624
  },
  {
    lng: -41.2501691,
    lat: -21.365162
  },
  {
    lng: -41.2501672,
    lat: -21.3651616
  },
  {
    lng: -41.2501654,
    lat: -21.3651612
  },
  {
    lng: -41.2501635,
    lat: -21.3651608
  },
  {
    lng: -41.2501617,
    lat: -21.3651605
  },
  {
    lng: -41.2501598,
    lat: -21.3651601
  },
  {
    lng: -41.2501579,
    lat: -21.3651597
  },
  {
    lng: -41.2501561,
    lat: -21.3651593
  },
  {
    lng: -41.2501542,
    lat: -21.365159
  },
  {
    lng: -41.2501524,
    lat: -21.3651586
  },
  {
    lng: -41.2501505,
    lat: -21.3651582
  },
  {
    lng: -41.2501487,
    lat: -21.3651579
  },
  {
    lng: -41.2501468,
    lat: -21.3651575
  },
  {
    lng: -41.250145,
    lat: -21.3651572
  },
  {
    lng: -41.2501431,
    lat: -21.3651568
  },
  {
    lng: -41.2501412,
    lat: -21.3651564
  },
  {
    lng: -41.2501394,
    lat: -21.3651561
  },
  {
    lng: -41.2501375,
    lat: -21.3651557
  },
  {
    lng: -41.2501357,
    lat: -21.3651554
  },
  {
    lng: -41.2501338,
    lat: -21.3651551
  },
  {
    lng: -41.2501319,
    lat: -21.3651547
  },
  {
    lng: -41.2501301,
    lat: -21.3651544
  },
  {
    lng: -41.2501282,
    lat: -21.3651542
  },
  {
    lng: -41.2501263,
    lat: -21.365154
  },
  {
    lng: -41.2501245,
    lat: -21.3651538
  },
  {
    lng: -41.2501226,
    lat: -21.3651537
  },
  {
    lng: -41.2501207,
    lat: -21.3651534
  },
  {
    lng: -41.2501188,
    lat: -21.365153
  },
  {
    lng: -41.250117,
    lat: -21.3651527
  },
  {
    lng: -41.2501151,
    lat: -21.3651525
  },
  {
    lng: -41.2501132,
    lat: -21.3651523
  },
  {
    lng: -41.2501113,
    lat: -21.3651522
  },
  {
    lng: -41.2501094,
    lat: -21.365152
  },
  {
    lng: -41.2501076,
    lat: -21.3651519
  },
  {
    lng: -41.2501057,
    lat: -21.3651518
  },
  {
    lng: -41.2501038,
    lat: -21.3651516
  },
  {
    lng: -41.2501019,
    lat: -21.3651515
  },
  {
    lng: -41.2501,
    lat: -21.3651514
  },
  {
    lng: -41.2500981,
    lat: -21.3651513
  },
  {
    lng: -41.2500963,
    lat: -21.3651512
  },
  {
    lng: -41.2500944,
    lat: -21.365151
  },
  {
    lng: -41.2500698,
    lat: -21.3651494
  },
  {
    lng: -41.2500679,
    lat: -21.3651493
  },
  {
    lng: -41.2500661,
    lat: -21.3651492
  },
  {
    lng: -41.2500642,
    lat: -21.3651491
  },
  {
    lng: -41.2500623,
    lat: -21.3651489
  },
  {
    lng: -41.2500604,
    lat: -21.3651488
  },
  {
    lng: -41.2500585,
    lat: -21.3651486
  },
  {
    lng: -41.2500566,
    lat: -21.3651485
  },
  {
    lng: -41.2500547,
    lat: -21.3651484
  },
  {
    lng: -41.2500529,
    lat: -21.3651483
  },
  {
    lng: -41.250051,
    lat: -21.3651482
  },
  {
    lng: -41.2500491,
    lat: -21.3651481
  },
  {
    lng: -41.2500472,
    lat: -21.365148
  },
  {
    lng: -41.2500453,
    lat: -21.3651481
  },
  {
    lng: -41.2500434,
    lat: -21.3651483
  },
  {
    lng: -41.2500415,
    lat: -21.3651483
  },
  {
    lng: -41.2500396,
    lat: -21.3651482
  },
  {
    lng: -41.2500377,
    lat: -21.3651481
  },
  {
    lng: -41.2500359,
    lat: -21.3651481
  },
  {
    lng: -41.250034,
    lat: -21.365148
  },
  {
    lng: -41.2500321,
    lat: -21.3651481
  },
  {
    lng: -41.2500302,
    lat: -21.3651482
  },
  {
    lng: -41.2500283,
    lat: -21.3651483
  },
  {
    lng: -41.2500264,
    lat: -21.3651485
  },
  {
    lng: -41.2500246,
    lat: -21.3651486
  },
  {
    lng: -41.2500227,
    lat: -21.3651487
  },
  {
    lng: -41.2500208,
    lat: -21.3651489
  },
  {
    lng: -41.2500189,
    lat: -21.3651489
  },
  {
    lng: -41.250017,
    lat: -21.365149
  },
  {
    lng: -41.2500151,
    lat: -21.3651492
  },
  {
    lng: -41.2500132,
    lat: -21.3651493
  },
  {
    lng: -41.2500113,
    lat: -21.3651495
  },
  {
    lng: -41.2500095,
    lat: -21.3651496
  },
  {
    lng: -41.2500076,
    lat: -21.3651495
  },
  {
    lng: -41.2500057,
    lat: -21.3651497
  },
  {
    lng: -41.2500038,
    lat: -21.3651498
  },
  {
    lng: -41.2500019,
    lat: -21.36515
  },
  {
    lng: -41.25,
    lat: -21.3651501
  },
  {
    lng: -41.2496436,
    lat: -21.3651796
  },
  {
    lng: -41.2491777,
    lat: -21.3652604
  },
  {
    lng: -41.248284,
    lat: -21.365498
  },
  {
    lng: -41.2479893,
    lat: -21.3655503
  },
  {
    lng: -41.2471955,
    lat: -21.3656074
  },
  {
    lng: -41.2468437,
    lat: -21.3656502
  },
  {
    lng: -41.2463873,
    lat: -21.3657738
  },
  {
    lng: -41.2459976,
    lat: -21.3658593
  },
  {
    lng: -41.2456743,
    lat: -21.3659734
  },
  {
    lng: -41.2454129,
    lat: -21.3660827
  },
  {
    lng: -41.2451514,
    lat: -21.3662634
  },
  {
    lng: -41.244985,
    lat: -21.3664345
  },
  {
    lng: -41.2448662,
    lat: -21.3665866
  },
  {
    lng: -41.2447521,
    lat: -21.3668433
  },
  {
    lng: -41.2446333,
    lat: -21.3670287
  },
  {
    lng: -41.2446308,
    lat: -21.3670309
  },
  {
    lng: -41.2446283,
    lat: -21.3670332
  },
  {
    lng: -41.2446258,
    lat: -21.3670354
  },
  {
    lng: -41.2446233,
    lat: -21.3670377
  },
  {
    lng: -41.244621,
    lat: -21.3670401
  },
  {
    lng: -41.2446186,
    lat: -21.3670424
  },
  {
    lng: -41.244616,
    lat: -21.3670446
  },
  {
    lng: -41.2446135,
    lat: -21.3670468
  },
  {
    lng: -41.244611,
    lat: -21.367049
  },
  {
    lng: -41.2446084,
    lat: -21.3670512
  },
  {
    lng: -41.2446059,
    lat: -21.3670534
  },
  {
    lng: -41.2446033,
    lat: -21.3670555
  },
  {
    lng: -41.2446008,
    lat: -21.3670578
  },
  {
    lng: -41.2445983,
    lat: -21.36706
  },
  {
    lng: -41.2445957,
    lat: -21.3670622
  },
  {
    lng: -41.2445932,
    lat: -21.3670643
  },
  {
    lng: -41.2445906,
    lat: -21.3670665
  },
  {
    lng: -41.2445218,
    lat: -21.3671253
  },
  {
    lng: -41.2445192,
    lat: -21.3671275
  },
  {
    lng: -41.2445167,
    lat: -21.3671297
  },
  {
    lng: -41.2445141,
    lat: -21.3671319
  },
  {
    lng: -41.2445115,
    lat: -21.367134
  },
  {
    lng: -41.2445089,
    lat: -21.3671361
  },
  {
    lng: -41.2445064,
    lat: -21.3671384
  },
  {
    lng: -41.2445038,
    lat: -21.3671405
  },
  {
    lng: -41.2445013,
    lat: -21.3671427
  },
  {
    lng: -41.2444987,
    lat: -21.3671448
  },
  {
    lng: -41.2444962,
    lat: -21.367147
  },
  {
    lng: -41.2444936,
    lat: -21.3671491
  },
  {
    lng: -41.2444909,
    lat: -21.3671511
  },
  {
    lng: -41.2444882,
    lat: -21.3671531
  },
  {
    lng: -41.2444855,
    lat: -21.3671551
  },
  {
    lng: -41.2444829,
    lat: -21.3671573
  },
  {
    lng: -41.2444803,
    lat: -21.3671594
  },
  {
    lng: -41.2444778,
    lat: -21.3671615
  },
  {
    lng: -41.244475,
    lat: -21.3671635
  },
  {
    lng: -41.2444723,
    lat: -21.3671654
  },
  {
    lng: -41.2444695,
    lat: -21.3671673
  },
  {
    lng: -41.2444668,
    lat: -21.3671693
  },
  {
    lng: -41.2444641,
    lat: -21.3671712
  },
  {
    lng: -41.2444614,
    lat: -21.3671732
  },
  {
    lng: -41.2444586,
    lat: -21.3671751
  },
  {
    lng: -41.244456,
    lat: -21.3671773
  },
  {
    lng: -41.2444533,
    lat: -21.3671792
  },
  {
    lng: -41.2444506,
    lat: -21.3671813
  },
  {
    lng: -41.2444479,
    lat: -21.3671832
  },
  {
    lng: -41.2444451,
    lat: -21.3671851
  },
  {
    lng: -41.2444424,
    lat: -21.3671871
  },
  {
    lng: -41.2444397,
    lat: -21.367189
  },
  {
    lng: -41.2444369,
    lat: -21.3671909
  },
  {
    lng: -41.2444341,
    lat: -21.3671928
  },
  {
    lng: -41.2444314,
    lat: -21.3671947
  },
  {
    lng: -41.2444286,
    lat: -21.3671966
  },
  {
    lng: -41.2444259,
    lat: -21.3671985
  },
  {
    lng: -41.2444231,
    lat: -21.3672004
  },
  {
    lng: -41.2444203,
    lat: -21.3672023
  },
  {
    lng: -41.2444176,
    lat: -21.3672042
  },
  {
    lng: -41.2444148,
    lat: -21.3672061
  },
  {
    lng: -41.2444121,
    lat: -21.367208
  },
  {
    lng: -41.2444093,
    lat: -21.36721
  },
  {
    lng: -41.2444065,
    lat: -21.3672119
  },
  {
    lng: -41.2444038,
    lat: -21.3672137
  },
  {
    lng: -41.244401,
    lat: -21.3672156
  },
  {
    lng: -41.2443982,
    lat: -21.3672175
  },
  {
    lng: -41.2443954,
    lat: -21.3672194
  },
  {
    lng: -41.2443926,
    lat: -21.3672213
  },
  {
    lng: -41.2443898,
    lat: -21.367223
  },
  {
    lng: -41.244387,
    lat: -21.3672249
  },
  {
    lng: -41.2443841,
    lat: -21.3672266
  },
  {
    lng: -41.2443813,
    lat: -21.3672284
  },
  {
    lng: -41.2443785,
    lat: -21.3672302
  },
  {
    lng: -41.2443757,
    lat: -21.3672321
  },
  {
    lng: -41.2443729,
    lat: -21.367234
  },
  {
    lng: -41.2443701,
    lat: -21.3672359
  },
  {
    lng: -41.2443673,
    lat: -21.3672377
  },
  {
    lng: -41.2443646,
    lat: -21.3672396
  },
  {
    lng: -41.2443617,
    lat: -21.3672413
  },
  {
    lng: -41.2443588,
    lat: -21.367243
  },
  {
    lng: -41.2443559,
    lat: -21.3672447
  },
  {
    lng: -41.244353,
    lat: -21.3672464
  },
  {
    lng: -41.2443501,
    lat: -21.3672481
  },
  {
    lng: -41.2443473,
    lat: -21.3672499
  },
  {
    lng: -41.2443444,
    lat: -21.3672516
  },
  {
    lng: -41.2443416,
    lat: -21.3672535
  },
  {
    lng: -41.2443387,
    lat: -21.3672552
  },
  {
    lng: -41.2443359,
    lat: -21.367257
  },
  {
    lng: -41.244333,
    lat: -21.3672587
  },
  {
    lng: -41.2443301,
    lat: -21.3672604
  },
  {
    lng: -41.2443272,
    lat: -21.3672621
  },
  {
    lng: -41.2443243,
    lat: -21.3672638
  },
  {
    lng: -41.2443214,
    lat: -21.3672655
  },
  {
    lng: -41.2443185,
    lat: -21.3672672
  },
  {
    lng: -41.2443156,
    lat: -21.3672688
  },
  {
    lng: -41.2443127,
    lat: -21.3672705
  },
  {
    lng: -41.2443098,
    lat: -21.3672722
  },
  {
    lng: -41.2443069,
    lat: -21.3672738
  },
  {
    lng: -41.244304,
    lat: -21.3672755
  },
  {
    lng: -41.244301,
    lat: -21.3672772
  },
  {
    lng: -41.2442981,
    lat: -21.3672789
  },
  {
    lng: -41.2442952,
    lat: -21.3672805
  },
  {
    lng: -41.2442923,
    lat: -21.3672822
  },
  {
    lng: -41.2442894,
    lat: -21.3672839
  },
  {
    lng: -41.2442865,
    lat: -21.3672855
  },
  {
    lng: -41.2442836,
    lat: -21.3672872
  },
  {
    lng: -41.2442806,
    lat: -21.3672888
  },
  {
    lng: -41.2442777,
    lat: -21.3672905
  },
  {
    lng: -41.2442748,
    lat: -21.3672921
  },
  {
    lng: -41.2442718,
    lat: -21.3672936
  },
  {
    lng: -41.2442689,
    lat: -21.3672952
  },
  {
    lng: -41.2442658,
    lat: -21.3672967
  },
  {
    lng: -41.2442629,
    lat: -21.3672983
  },
  {
    lng: -41.2442599,
    lat: -21.3672999
  },
  {
    lng: -41.244257,
    lat: -21.3673015
  },
  {
    lng: -41.2442541,
    lat: -21.3673031
  },
  {
    lng: -41.2442511,
    lat: -21.3673048
  },
  {
    lng: -41.2442482,
    lat: -21.3673064
  },
  {
    lng: -41.2442453,
    lat: -21.367308
  },
  {
    lng: -41.2442423,
    lat: -21.3673095
  },
  {
    lng: -41.2442392,
    lat: -21.367311
  },
  {
    lng: -41.2442362,
    lat: -21.3673124
  },
  {
    lng: -41.2442332,
    lat: -21.3673139
  },
  {
    lng: -41.2442302,
    lat: -21.3673153
  },
  {
    lng: -41.2442272,
    lat: -21.3673169
  },
  {
    lng: -41.2442242,
    lat: -21.3673183
  },
  {
    lng: -41.2442213,
    lat: -21.36732
  },
  {
    lng: -41.2442182,
    lat: -21.3673214
  },
  {
    lng: -41.2442153,
    lat: -21.367323
  },
  {
    lng: -41.2442123,
    lat: -21.3673245
  },
  {
    lng: -41.2442092,
    lat: -21.3673259
  },
  {
    lng: -41.2442062,
    lat: -21.3673274
  },
  {
    lng: -41.2442032,
    lat: -21.3673288
  },
  {
    lng: -41.2442001,
    lat: -21.3673303
  },
  {
    lng: -41.2441971,
    lat: -21.3673317
  },
  {
    lng: -41.2441941,
    lat: -21.3673331
  },
  {
    lng: -41.244191,
    lat: -21.3673345
  },
  {
    lng: -41.244188,
    lat: -21.367336
  },
  {
    lng: -41.244185,
    lat: -21.3673374
  },
  {
    lng: -41.2441819,
    lat: -21.3673388
  },
  {
    lng: -41.2441789,
    lat: -21.3673402
  },
  {
    lng: -41.2441758,
    lat: -21.3673417
  },
  {
    lng: -41.2441728,
    lat: -21.3673431
  },
  {
    lng: -41.2441698,
    lat: -21.3673445
  },
  {
    lng: -41.2441667,
    lat: -21.3673459
  },
  {
    lng: -41.2441637,
    lat: -21.3673473
  },
  {
    lng: -41.2441606,
    lat: -21.3673487
  },
  {
    lng: -41.2441576,
    lat: -21.3673501
  },
  {
    lng: -41.2441545,
    lat: -21.3673515
  },
  {
    lng: -41.2441515,
    lat: -21.3673529
  },
  {
    lng: -41.2441484,
    lat: -21.3673542
  },
  {
    lng: -41.2441453,
    lat: -21.3673556
  },
  {
    lng: -41.2441422,
    lat: -21.3673567
  },
  {
    lng: -41.2441391,
    lat: -21.3673581
  },
  {
    lng: -41.244136,
    lat: -21.3673594
  },
  {
    lng: -41.244133,
    lat: -21.3673608
  },
  {
    lng: -41.2441299,
    lat: -21.3673622
  },
  {
    lng: -41.2441269,
    lat: -21.3673636
  },
  {
    lng: -41.2441238,
    lat: -21.367365
  },
  {
    lng: -41.2441207,
    lat: -21.3673664
  },
  {
    lng: -41.2441176,
    lat: -21.3673676
  },
  {
    lng: -41.2441145,
    lat: -21.3673688
  },
  {
    lng: -41.2441114,
    lat: -21.36737
  },
  {
    lng: -41.2441082,
    lat: -21.3673712
  },
  {
    lng: -41.2441051,
    lat: -21.3673724
  },
  {
    lng: -41.244102,
    lat: -21.3673737
  },
  {
    lng: -41.2440989,
    lat: -21.3673749
  },
  {
    lng: -41.2440958,
    lat: -21.3673763
  },
  {
    lng: -41.2440927,
    lat: -21.3673775
  },
  {
    lng: -41.2440896,
    lat: -21.3673788
  },
  {
    lng: -41.2440865,
    lat: -21.36738
  },
  {
    lng: -41.2440833,
    lat: -21.3673812
  },
  {
    lng: -41.2440802,
    lat: -21.3673824
  },
  {
    lng: -41.2440771,
    lat: -21.3673836
  },
  {
    lng: -41.2440739,
    lat: -21.3673848
  },
  {
    lng: -41.2440708,
    lat: -21.367386
  },
  {
    lng: -41.2440676,
    lat: -21.3673871
  },
  {
    lng: -41.2440645,
    lat: -21.3673883
  },
  {
    lng: -41.2440614,
    lat: -21.3673895
  },
  {
    lng: -41.2440582,
    lat: -21.3673906
  },
  {
    lng: -41.2440551,
    lat: -21.3673918
  },
  {
    lng: -41.2440519,
    lat: -21.367393
  },
  {
    lng: -41.2440488,
    lat: -21.3673941
  },
  {
    lng: -41.2440456,
    lat: -21.3673953
  },
  {
    lng: -41.2440425,
    lat: -21.3673965
  },
  {
    lng: -41.2440393,
    lat: -21.3673976
  },
  {
    lng: -41.2440362,
    lat: -21.3673988
  },
  {
    lng: -41.244033,
    lat: -21.3673999
  },
  {
    lng: -41.2440299,
    lat: -21.3674011
  },
  {
    lng: -41.2440267,
    lat: -21.3674022
  },
  {
    lng: -41.2440236,
    lat: -21.3674033
  },
  {
    lng: -41.2440203,
    lat: -21.3674043
  },
  {
    lng: -41.2440172,
    lat: -21.3674054
  },
  {
    lng: -41.244014,
    lat: -21.3674064
  },
  {
    lng: -41.2440108,
    lat: -21.3674075
  },
  {
    lng: -41.2440076,
    lat: -21.3674086
  },
  {
    lng: -41.2440045,
    lat: -21.3674097
  },
  {
    lng: -41.2440013,
    lat: -21.3674108
  },
  {
    lng: -41.2439981,
    lat: -21.3674119
  },
  {
    lng: -41.243995,
    lat: -21.3674131
  },
  {
    lng: -41.2439918,
    lat: -21.3674142
  },
  {
    lng: -41.2439886,
    lat: -21.3674152
  },
  {
    lng: -41.2439854,
    lat: -21.3674161
  },
  {
    lng: -41.2439822,
    lat: -21.3674171
  },
  {
    lng: -41.243979,
    lat: -21.367418
  },
  {
    lng: -41.2439758,
    lat: -21.367419
  },
  {
    lng: -41.2439725,
    lat: -21.36742
  },
  {
    lng: -41.2439693,
    lat: -21.3674209
  },
  {
    lng: -41.2439661,
    lat: -21.3674219
  },
  {
    lng: -41.2439629,
    lat: -21.3674229
  },
  {
    lng: -41.2439609,
    lat: -21.3674235
  },
  {
    lng: -41.2439589,
    lat: -21.3674244
  },
  {
    lng: -41.2439569,
    lat: -21.367425
  },
  {
    lng: -41.2439549,
    lat: -21.3674258
  },
  {
    lng: -41.2439529,
    lat: -21.3674264
  },
  {
    lng: -41.2439508,
    lat: -21.367427
  },
  {
    lng: -41.2439488,
    lat: -21.3674276
  },
  {
    lng: -41.2439468,
    lat: -21.3674282
  },
  {
    lng: -41.2439447,
    lat: -21.3674289
  },
  {
    lng: -41.2439427,
    lat: -21.3674294
  },
  {
    lng: -41.2439407,
    lat: -21.36743
  },
  {
    lng: -41.2439386,
    lat: -21.3674306
  },
  {
    lng: -41.2439366,
    lat: -21.3674312
  },
  {
    lng: -41.2439345,
    lat: -21.3674318
  },
  {
    lng: -41.2439325,
    lat: -21.3674324
  },
  {
    lng: -41.2439305,
    lat: -21.367433
  },
  {
    lng: -41.2439284,
    lat: -21.3674336
  },
  {
    lng: -41.2439264,
    lat: -21.3674342
  },
  {
    lng: -41.2439243,
    lat: -21.3674348
  },
  {
    lng: -41.2439223,
    lat: -21.3674354
  },
  {
    lng: -41.2439202,
    lat: -21.3674359
  },
  {
    lng: -41.2439182,
    lat: -21.3674365
  },
  {
    lng: -41.2439162,
    lat: -21.3674371
  },
  {
    lng: -41.2439141,
    lat: -21.3674376
  },
  {
    lng: -41.2439121,
    lat: -21.3674382
  },
  {
    lng: -41.24391,
    lat: -21.3674386
  },
  {
    lng: -41.2439079,
    lat: -21.3674392
  },
  {
    lng: -41.2439058,
    lat: -21.3674395
  },
  {
    lng: -41.2439037,
    lat: -21.3674401
  },
  {
    lng: -41.2439017,
    lat: -21.3674405
  },
  {
    lng: -41.2438996,
    lat: -21.3674411
  },
  {
    lng: -41.2438976,
    lat: -21.3674416
  },
  {
    lng: -41.2438955,
    lat: -21.3674422
  },
  {
    lng: -41.2438935,
    lat: -21.3674427
  },
  {
    lng: -41.2438914,
    lat: -21.3674433
  },
  {
    lng: -41.2438893,
    lat: -21.3674436
  },
  {
    lng: -41.2438872,
    lat: -21.367444
  },
  {
    lng: -41.2438852,
    lat: -21.3674443
  },
  {
    lng: -41.2438831,
    lat: -21.3674447
  },
  {
    lng: -41.243881,
    lat: -21.3674451
  },
  {
    lng: -41.2438789,
    lat: -21.3674455
  },
  {
    lng: -41.2438768,
    lat: -21.367446
  },
  {
    lng: -41.2438748,
    lat: -21.3674465
  },
  {
    lng: -41.2438727,
    lat: -21.3674469
  },
  {
    lng: -41.2438706,
    lat: -21.3674472
  },
  {
    lng: -41.2438685,
    lat: -21.3674476
  },
  {
    lng: -41.2438664,
    lat: -21.3674479
  },
  {
    lng: -41.2438643,
    lat: -21.3674482
  },
  {
    lng: -41.2438622,
    lat: -21.3674486
  },
  {
    lng: -41.2438601,
    lat: -21.3674489
  },
  {
    lng: -41.243858,
    lat: -21.3674492
  },
  {
    lng: -41.2438559,
    lat: -21.3674495
  },
  {
    lng: -41.2438538,
    lat: -21.3674498
  },
  {
    lng: -41.2438517,
    lat: -21.3674501
  },
  {
    lng: -41.2438496,
    lat: -21.3674504
  },
  {
    lng: -41.2438475,
    lat: -21.3674507
  },
  {
    lng: -41.2438454,
    lat: -21.3674511
  },
  {
    lng: -41.2438433,
    lat: -21.3674514
  },
  {
    lng: -41.2438412,
    lat: -21.3674517
  },
  {
    lng: -41.2438391,
    lat: -21.367452
  },
  {
    lng: -41.2438369,
    lat: -21.3674523
  },
  {
    lng: -41.2438348,
    lat: -21.3674526
  },
  {
    lng: -41.2438327,
    lat: -21.3674529
  },
  {
    lng: -41.2438306,
    lat: -21.3674532
  },
  {
    lng: -41.2438285,
    lat: -21.3674535
  },
  {
    lng: -41.2438264,
    lat: -21.3674538
  },
  {
    lng: -41.2438243,
    lat: -21.3674541
  },
  {
    lng: -41.2438222,
    lat: -21.3674544
  },
  {
    lng: -41.2438201,
    lat: -21.3674547
  },
  {
    lng: -41.243818,
    lat: -21.3674549
  },
  {
    lng: -41.2438159,
    lat: -21.3674552
  },
  {
    lng: -41.2438138,
    lat: -21.3674553
  },
  {
    lng: -41.2438116,
    lat: -21.3674554
  },
  {
    lng: -41.2438095,
    lat: -21.3674557
  },
  {
    lng: -41.2438074,
    lat: -21.3674558
  },
  {
    lng: -41.2438053,
    lat: -21.3674561
  },
  {
    lng: -41.2438032,
    lat: -21.3674564
  },
  {
    lng: -41.2438011,
    lat: -21.3674566
  },
  {
    lng: -41.243799,
    lat: -21.3674569
  },
  {
    lng: -41.2437969,
    lat: -21.367457
  },
  {
    lng: -41.2437948,
    lat: -21.367457
  },
  {
    lng: -41.2437926,
    lat: -21.3674571
  },
  {
    lng: -41.2437905,
    lat: -21.3674571
  },
  {
    lng: -41.2437884,
    lat: -21.3674572
  },
  {
    lng: -41.2437863,
    lat: -21.3674573
  },
  {
    lng: -41.2437842,
    lat: -21.3674576
  },
  {
    lng: -41.243782,
    lat: -21.3674578
  },
  {
    lng: -41.2437799,
    lat: -21.3674578
  },
  {
    lng: -41.2437778,
    lat: -21.3674579
  },
  {
    lng: -41.2437757,
    lat: -21.3674579
  },
  {
    lng: -41.2437735,
    lat: -21.3674579
  },
  {
    lng: -41.2437714,
    lat: -21.3674579
  },
  {
    lng: -41.2437693,
    lat: -21.3674579
  },
  {
    lng: -41.2437672,
    lat: -21.3674579
  },
  {
    lng: -41.243765,
    lat: -21.3674579
  },
  {
    lng: -41.2437629,
    lat: -21.367458
  },
  {
    lng: -41.2437608,
    lat: -21.367458
  },
  {
    lng: -41.2437587,
    lat: -21.367458
  },
  {
    lng: -41.2437565,
    lat: -21.367458
  },
  {
    lng: -41.2437544,
    lat: -21.367458
  },
  {
    lng: -41.2437523,
    lat: -21.367458
  },
  {
    lng: -41.2437502,
    lat: -21.367458
  },
  {
    lng: -41.243748,
    lat: -21.367458
  },
  {
    lng: -41.2437459,
    lat: -21.367458
  },
  {
    lng: -41.2437438,
    lat: -21.367458
  },
  {
    lng: -41.2437417,
    lat: -21.367458
  },
  {
    lng: -41.2437395,
    lat: -21.367458
  },
  {
    lng: -41.2437374,
    lat: -21.367458
  },
  {
    lng: -41.2437353,
    lat: -21.367458
  },
  {
    lng: -41.2437332,
    lat: -21.367458
  },
  {
    lng: -41.243731,
    lat: -21.367458
  },
  {
    lng: -41.2437289,
    lat: -21.367458
  },
  {
    lng: -41.2437268,
    lat: -21.367458
  },
  {
    lng: -41.2437247,
    lat: -21.367458
  },
  {
    lng: -41.2437226,
    lat: -21.367458
  },
  {
    lng: -41.2437204,
    lat: -21.3674579
  },
  {
    lng: -41.2437183,
    lat: -21.3674579
  },
  {
    lng: -41.2437162,
    lat: -21.3674577
  },
  {
    lng: -41.2437141,
    lat: -21.3674574
  },
  {
    lng: -41.2437119,
    lat: -21.3674574
  },
  {
    lng: -41.2437098,
    lat: -21.3674573
  },
  {
    lng: -41.2437077,
    lat: -21.3674572
  },
  {
    lng: -41.2437056,
    lat: -21.3674572
  },
  {
    lng: -41.2437035,
    lat: -21.3674571
  },
  {
    lng: -41.2437013,
    lat: -21.3674571
  },
  {
    lng: -41.2436992,
    lat: -21.3674568
  },
  {
    lng: -41.2436971,
    lat: -21.3674566
  },
  {
    lng: -41.243695,
    lat: -21.3674563
  },
  {
    lng: -41.2436929,
    lat: -21.3674561
  },
  {
    lng: -41.2436908,
    lat: -21.3674559
  },
  {
    lng: -41.2436887,
    lat: -21.3674556
  },
  {
    lng: -41.2436866,
    lat: -21.3674556
  },
  {
    lng: -41.2436844,
    lat: -21.3674555
  },
  {
    lng: -41.2436823,
    lat: -21.3674552
  },
  {
    lng: -41.2436802,
    lat: -21.3674549
  },
  {
    lng: -41.2436781,
    lat: -21.3674547
  },
  {
    lng: -41.243676,
    lat: -21.3674544
  },
  {
    lng: -41.2436739,
    lat: -21.3674541
  },
  {
    lng: -41.2436718,
    lat: -21.3674538
  },
  {
    lng: -41.2436697,
    lat: -21.3674535
  },
  {
    lng: -41.2436676,
    lat: -21.3674532
  },
  {
    lng: -41.2436655,
    lat: -21.3674529
  },
  {
    lng: -41.2436634,
    lat: -21.3674526
  },
  {
    lng: -41.2436613,
    lat: -21.3674523
  },
  {
    lng: -41.2436592,
    lat: -21.367452
  },
  {
    lng: -41.2436571,
    lat: -21.3674517
  },
  {
    lng: -41.243655,
    lat: -21.3674514
  },
  {
    lng: -41.2436529,
    lat: -21.367451
  },
  {
    lng: -41.2436508,
    lat: -21.3674507
  },
  {
    lng: -41.2436487,
    lat: -21.3674504
  },
  {
    lng: -41.2436466,
    lat: -21.3674501
  },
  {
    lng: -41.2436445,
    lat: -21.3674498
  },
  {
    lng: -41.2436424,
    lat: -21.3674495
  },
  {
    lng: -41.2436402,
    lat: -21.3674492
  },
  {
    lng: -41.2436381,
    lat: -21.3674489
  },
  {
    lng: -41.243636,
    lat: -21.3674486
  },
  {
    lng: -41.2436339,
    lat: -21.3674483
  },
  {
    lng: -41.2436318,
    lat: -21.367448
  },
  {
    lng: -41.2436297,
    lat: -21.3674477
  },
  {
    lng: -41.2436276,
    lat: -21.3674473
  },
  {
    lng: -41.2436255,
    lat: -21.367447
  },
  {
    lng: -41.2436235,
    lat: -21.3674466
  },
  {
    lng: -41.2436214,
    lat: -21.3674461
  },
  {
    lng: -41.2436193,
    lat: -21.3674456
  },
  {
    lng: -41.2436172,
    lat: -21.3674452
  },
  {
    lng: -41.2436151,
    lat: -21.3674448
  },
  {
    lng: -41.243613,
    lat: -21.3674445
  },
  {
    lng: -41.243611,
    lat: -21.3674441
  },
  {
    lng: -41.2436089,
    lat: -21.3674438
  },
  {
    lng: -41.2436068,
    lat: -21.3674434
  },
  {
    lng: -41.2436048,
    lat: -21.3674428
  },
  {
    lng: -41.2436027,
    lat: -21.3674422
  },
  {
    lng: -41.2436007,
    lat: -21.3674416
  },
  {
    lng: -41.2435986,
    lat: -21.3674412
  },
  {
    lng: -41.2435965,
    lat: -21.3674408
  },
  {
    lng: -41.2435945,
    lat: -21.3674401
  },
  {
    lng: -41.2435925,
    lat: -21.3674395
  },
  {
    lng: -41.2435905,
    lat: -21.3674388
  },
  {
    lng: -41.2435884,
    lat: -21.3674382
  },
  {
    lng: -41.2435864,
    lat: -21.3674375
  },
  {
    lng: -41.2435844,
    lat: -21.3674369
  },
  {
    lng: -41.2435824,
    lat: -21.3674362
  },
  {
    lng: -41.24349,
    lat: -21.3674047
  },
  {
    lng: -41.243488,
    lat: -21.367404
  },
  {
    lng: -41.243486,
    lat: -21.3674033
  },
  {
    lng: -41.243484,
    lat: -21.3674026
  },
  {
    lng: -41.243482,
    lat: -21.3674019
  },
  {
    lng: -41.24348,
    lat: -21.3674012
  },
  {
    lng: -41.243478,
    lat: -21.3674005
  },
  {
    lng: -41.243476,
    lat: -21.3673998
  },
  {
    lng: -41.2434741,
    lat: -21.3673988
  },
  {
    lng: -41.2434722,
    lat: -21.3673979
  },
  {
    lng: -41.2434702,
    lat: -21.3673971
  },
  {
    lng: -41.2434682,
    lat: -21.3673963
  },
  {
    lng: -41.2434663,
    lat: -21.3673956
  },
  {
    lng: -41.2434644,
    lat: -21.3673945
  },
  {
    lng: -41.2434626,
    lat: -21.3673935
  },
  {
    lng: -41.2434607,
    lat: -21.3673925
  },
  {
    lng: -41.2434587,
    lat: -21.3673916
  },
  {
    lng: -41.2434568,
    lat: -21.3673907
  },
  {
    lng: -41.243455,
    lat: -21.3673897
  },
  {
    lng: -41.2434532,
    lat: -21.3673886
  },
  {
    lng: -41.2434514,
    lat: -21.3673875
  },
  {
    lng: -41.2434495,
    lat: -21.3673864
  },
  {
    lng: -41.2434477,
    lat: -21.3673853
  },
  {
    lng: -41.2434459,
    lat: -21.3673842
  },
  {
    lng: -41.2434441,
    lat: -21.3673831
  },
  {
    lng: -41.243361,
    lat: -21.3673318
  },
  {
    lng: -41.2433592,
    lat: -21.3673307
  },
  {
    lng: -41.2433574,
    lat: -21.3673296
  },
  {
    lng: -41.2433556,
    lat: -21.3673285
  },
  {
    lng: -41.2433538,
    lat: -21.3673273
  },
  {
    lng: -41.243352,
    lat: -21.3673262
  },
  {
    lng: -41.2433502,
    lat: -21.3673251
  },
  {
    lng: -41.2433484,
    lat: -21.3673239
  },
  {
    lng: -41.2433468,
    lat: -21.3673226
  },
  {
    lng: -41.2433451,
    lat: -21.3673212
  },
  {
    lng: -41.2433434,
    lat: -21.36732
  },
  {
    lng: -41.2433416,
    lat: -21.3673188
  },
  {
    lng: -41.2433399,
    lat: -21.3673177
  },
  {
    lng: -41.2433383,
    lat: -21.3673162
  },
  {
    lng: -41.2433368,
    lat: -21.3673148
  },
  {
    lng: -41.2433352,
    lat: -21.3673134
  },
  {
    lng: -41.2433334,
    lat: -21.3673122
  },
  {
    lng: -41.2433318,
    lat: -21.3673109
  },
  {
    lng: -41.2433302,
    lat: -21.3673094
  },
  {
    lng: -41.2433287,
    lat: -21.3673079
  },
  {
    lng: -41.2433272,
    lat: -21.3673065
  },
  {
    lng: -41.2433256,
    lat: -21.367305
  },
  {
    lng: -41.2433241,
    lat: -21.3673035
  },
  {
    lng: -41.2433226,
    lat: -21.3673021
  },
  {
    lng: -41.2433211,
    lat: -21.3673006
  },
  {
    lng: -41.2432514,
    lat: -21.3672321
  },
  {
    lng: -41.2432499,
    lat: -21.3672306
  },
  {
    lng: -41.2432484,
    lat: -21.3672291
  },
  {
    lng: -41.2432469,
    lat: -21.3672276
  },
  {
    lng: -41.2432455,
    lat: -21.3672261
  },
  {
    lng: -41.243244,
    lat: -21.3672246
  },
  {
    lng: -41.2432425,
    lat: -21.3672231
  },
  {
    lng: -41.243241,
    lat: -21.3672216
  },
  {
    lng: -41.2432396,
    lat: -21.3672199
  },
  {
    lng: -41.2432383,
    lat: -21.3672182
  },
  {
    lng: -41.2432369,
    lat: -21.3672167
  },
  {
    lng: -41.2432355,
    lat: -21.3672151
  },
  {
    lng: -41.243234,
    lat: -21.3672136
  },
  {
    lng: -41.2432328,
    lat: -21.3672119
  },
  {
    lng: -41.2432316,
    lat: -21.3672101
  },
  {
    lng: -41.2432304,
    lat: -21.3672084
  },
  {
    lng: -41.243229,
    lat: -21.3672068
  },
  {
    lng: -41.2432276,
    lat: -21.3672052
  },
  {
    lng: -41.2432264,
    lat: -21.3672034
  },
  {
    lng: -41.2432253,
    lat: -21.3672016
  },
  {
    lng: -41.2432241,
    lat: -21.3671999
  },
  {
    lng: -41.2432229,
    lat: -21.3671981
  },
  {
    lng: -41.2432218,
    lat: -21.3671963
  },
  {
    lng: -41.2432206,
    lat: -21.3671946
  },
  {
    lng: -41.2432195,
    lat: -21.3671928
  },
  {
    lng: -41.2431678,
    lat: -21.3671124
  },
  {
    lng: -41.2431667,
    lat: -21.3671106
  },
  {
    lng: -41.2431655,
    lat: -21.3671088
  },
  {
    lng: -41.2431644,
    lat: -21.367107
  },
  {
    lng: -41.2431633,
    lat: -21.3671052
  },
  {
    lng: -41.2431622,
    lat: -21.3671034
  },
  {
    lng: -41.243161,
    lat: -21.3671016
  },
  {
    lng: -41.2431599,
    lat: -21.3670998
  },
  {
    lng: -41.243159,
    lat: -21.3670979
  },
  {
    lng: -41.2431581,
    lat: -21.367096
  },
  {
    lng: -41.2431571,
    lat: -21.3670941
  },
  {
    lng: -41.243156,
    lat: -21.3670923
  },
  {
    lng: -41.2431549,
    lat: -21.3670905
  },
  {
    lng: -41.2431121,
    lat: -21.3668291
  },
  {
    lng: -41.2431016,
    lat: -21.3665772
  },
  {
    lng: -41.2430708,
    lat: -21.3665204
  },
  {
    lng: -41.243015,
    lat: -21.3664942
  },
  {
    lng: -41.2429662,
    lat: -21.3664995
  },
  {
    lng: -41.2429223,
    lat: -21.3665225
  },
  {
    lng: -41.2427889,
    lat: -21.366696
  },
  {
    lng: -41.2425845,
    lat: -21.3669146
  },
  {
    lng: -41.2423801,
    lat: -21.3670715
  },
  {
    lng: -41.2421852,
    lat: -21.3672093
  },
  {
    lng: -41.2420568,
    lat: -21.3673139
  },
  {
    lng: -41.2419237,
    lat: -21.3675564
  },
  {
    lng: -41.2418049,
    lat: -21.3678463
  },
  {
    lng: -41.2417003,
    lat: -21.368065
  },
  {
    lng: -41.2415862,
    lat: -21.3682076
  },
  {
    lng: -41.2414246,
    lat: -21.3683787
  },
  {
    lng: -41.2411917,
    lat: -21.3686021
  },
  {
    lng: -41.240954,
    lat: -21.3688303
  },
  {
    lng: -41.2408114,
    lat: -21.3690062
  },
  {
    lng: -41.2407116,
    lat: -21.3691536
  },
  {
    lng: -41.2405595,
    lat: -21.3695196
  },
  {
    lng: -41.2404406,
    lat: -21.3697953
  },
  {
    lng: -41.2403265,
    lat: -21.3700472
  },
  {
    lng: -41.2402124,
    lat: -21.3702754
  },
  {
    lng: -41.2401364,
    lat: -21.3704655
  },
  {
    lng: -41.2400746,
    lat: -21.3706937
  },
  {
    lng: -41.2400128,
    lat: -21.3709029
  },
  {
    lng: -41.2400114,
    lat: -21.3709058
  },
  {
    lng: -41.24001,
    lat: -21.3709087
  },
  {
    lng: -41.2400086,
    lat: -21.3709117
  },
  {
    lng: -41.2400072,
    lat: -21.3709146
  },
  {
    lng: -41.2400057,
    lat: -21.3709175
  },
  {
    lng: -41.2400043,
    lat: -21.3709204
  },
  {
    lng: -41.2400029,
    lat: -21.3709233
  },
  {
    lng: -41.2400014,
    lat: -21.3709263
  },
  {
    lng: -41.24,
    lat: -21.3709292
  },
  {
    lng: -41.2399985,
    lat: -21.3709321
  },
  {
    lng: -41.2399971,
    lat: -21.370935
  },
  {
    lng: -41.2399956,
    lat: -21.3709379
  },
  {
    lng: -41.2399941,
    lat: -21.3709408
  },
  {
    lng: -41.2399927,
    lat: -21.3709437
  },
  {
    lng: -41.2399912,
    lat: -21.3709466
  },
  {
    lng: -41.2399897,
    lat: -21.3709494
  },
  {
    lng: -41.2399882,
    lat: -21.3709523
  },
  {
    lng: -41.2399867,
    lat: -21.3709552
  },
  {
    lng: -41.2399852,
    lat: -21.3709581
  },
  {
    lng: -41.2399837,
    lat: -21.370961
  },
  {
    lng: -41.2399822,
    lat: -21.3709638
  },
  {
    lng: -41.2399806,
    lat: -21.3709667
  },
  {
    lng: -41.2399791,
    lat: -21.3709696
  },
  {
    lng: -41.2399776,
    lat: -21.3709724
  },
  {
    lng: -41.239976,
    lat: -21.3709753
  },
  {
    lng: -41.2399745,
    lat: -21.3709782
  },
  {
    lng: -41.2399729,
    lat: -21.370981
  },
  {
    lng: -41.2399713,
    lat: -21.3709839
  },
  {
    lng: -41.2399698,
    lat: -21.3709867
  },
  {
    lng: -41.2399682,
    lat: -21.3709895
  },
  {
    lng: -41.2399666,
    lat: -21.3709924
  },
  {
    lng: -41.239965,
    lat: -21.3709952
  },
  {
    lng: -41.2399635,
    lat: -21.3709981
  },
  {
    lng: -41.2399619,
    lat: -21.3710009
  },
  {
    lng: -41.2399603,
    lat: -21.3710037
  },
  {
    lng: -41.2399586,
    lat: -21.3710065
  },
  {
    lng: -41.239957,
    lat: -21.3710094
  },
  {
    lng: -41.2399554,
    lat: -21.3710122
  },
  {
    lng: -41.2399538,
    lat: -21.371015
  },
  {
    lng: -41.2399522,
    lat: -21.3710178
  },
  {
    lng: -41.2399505,
    lat: -21.3710206
  },
  {
    lng: -41.2399489,
    lat: -21.3710234
  },
  {
    lng: -41.2399472,
    lat: -21.3710262
  },
  {
    lng: -41.2399456,
    lat: -21.371029
  },
  {
    lng: -41.2399439,
    lat: -21.3710318
  },
  {
    lng: -41.2399422,
    lat: -21.3710346
  },
  {
    lng: -41.2399406,
    lat: -21.3710374
  },
  {
    lng: -41.2399389,
    lat: -21.3710402
  },
  {
    lng: -41.2399372,
    lat: -21.3710429
  },
  {
    lng: -41.2399355,
    lat: -21.3710457
  },
  {
    lng: -41.2399338,
    lat: -21.3710485
  },
  {
    lng: -41.2399321,
    lat: -21.3710512
  },
  {
    lng: -41.2399304,
    lat: -21.371054
  },
  {
    lng: -41.2399287,
    lat: -21.3710568
  },
  {
    lng: -41.239927,
    lat: -21.3710595
  },
  {
    lng: -41.2399253,
    lat: -21.3710623
  },
  {
    lng: -41.2399235,
    lat: -21.371065
  },
  {
    lng: -41.2399218,
    lat: -21.3710678
  },
  {
    lng: -41.23992,
    lat: -21.3710705
  },
  {
    lng: -41.2399183,
    lat: -21.3710733
  },
  {
    lng: -41.2399165,
    lat: -21.371076
  },
  {
    lng: -41.2399148,
    lat: -21.3710787
  },
  {
    lng: -41.239913,
    lat: -21.3710815
  },
  {
    lng: -41.2399112,
    lat: -21.3710842
  },
  {
    lng: -41.2399095,
    lat: -21.3710869
  },
  {
    lng: -41.2399077,
    lat: -21.3710896
  },
  {
    lng: -41.2399059,
    lat: -21.3710923
  },
  {
    lng: -41.2399041,
    lat: -21.371095
  },
  {
    lng: -41.2399023,
    lat: -21.3710978
  },
  {
    lng: -41.2399005,
    lat: -21.3711005
  },
  {
    lng: -41.2398987,
    lat: -21.3711032
  },
  {
    lng: -41.2398969,
    lat: -21.3711058
  },
  {
    lng: -41.2398951,
    lat: -21.3711085
  },
  {
    lng: -41.2398932,
    lat: -21.3711112
  },
  {
    lng: -41.2398914,
    lat: -21.3711139
  },
  {
    lng: -41.2398896,
    lat: -21.3711166
  },
  {
    lng: -41.2398877,
    lat: -21.3711193
  },
  {
    lng: -41.2398859,
    lat: -21.3711219
  },
  {
    lng: -41.239884,
    lat: -21.3711246
  },
  {
    lng: -41.2398821,
    lat: -21.3711273
  },
  {
    lng: -41.2398803,
    lat: -21.3711299
  },
  {
    lng: -41.2398784,
    lat: -21.3711326
  },
  {
    lng: -41.2398765,
    lat: -21.3711352
  },
  {
    lng: -41.2398747,
    lat: -21.3711379
  },
  {
    lng: -41.2398728,
    lat: -21.3711405
  },
  {
    lng: -41.2398709,
    lat: -21.3711432
  },
  {
    lng: -41.239869,
    lat: -21.3711458
  },
  {
    lng: -41.2398671,
    lat: -21.3711484
  },
  {
    lng: -41.2398652,
    lat: -21.3711511
  },
  {
    lng: -41.2398632,
    lat: -21.3711537
  },
  {
    lng: -41.2398613,
    lat: -21.3711563
  },
  {
    lng: -41.2398594,
    lat: -21.3711589
  },
  {
    lng: -41.2398575,
    lat: -21.3711615
  },
  {
    lng: -41.2398555,
    lat: -21.3711642
  },
  {
    lng: -41.2398536,
    lat: -21.3711668
  },
  {
    lng: -41.2398516,
    lat: -21.3711694
  },
  {
    lng: -41.2398497,
    lat: -21.371172
  },
  {
    lng: -41.2398477,
    lat: -21.3711745
  },
  {
    lng: -41.2398458,
    lat: -21.3711771
  },
  {
    lng: -41.2398438,
    lat: -21.3711797
  },
  {
    lng: -41.2398418,
    lat: -21.3711823
  },
  {
    lng: -41.2398398,
    lat: -21.3711849
  },
  {
    lng: -41.2398378,
    lat: -21.3711874
  },
  {
    lng: -41.2398358,
    lat: -21.37119
  },
  {
    lng: -41.2398339,
    lat: -21.3711926
  },
  {
    lng: -41.2398318,
    lat: -21.3711951
  },
  {
    lng: -41.2398298,
    lat: -21.3711977
  },
  {
    lng: -41.2398278,
    lat: -21.3712002
  },
  {
    lng: -41.2398258,
    lat: -21.3712028
  },
  {
    lng: -41.2398238,
    lat: -21.3712053
  },
  {
    lng: -41.2398218,
    lat: -21.3712079
  },
  {
    lng: -41.2398197,
    lat: -21.3712104
  },
  {
    lng: -41.2398177,
    lat: -21.3712129
  },
  {
    lng: -41.2398156,
    lat: -21.3712155
  },
  {
    lng: -41.2398136,
    lat: -21.371218
  },
  {
    lng: -41.2398115,
    lat: -21.3712205
  },
  {
    lng: -41.2398095,
    lat: -21.371223
  },
  {
    lng: -41.2398074,
    lat: -21.3712255
  },
  {
    lng: -41.2398053,
    lat: -21.371228
  },
  {
    lng: -41.2398033,
    lat: -21.3712305
  },
  {
    lng: -41.2398012,
    lat: -21.371233
  },
  {
    lng: -41.2397991,
    lat: -21.3712355
  },
  {
    lng: -41.239797,
    lat: -21.371238
  },
  {
    lng: -41.2397949,
    lat: -21.3712405
  },
  {
    lng: -41.2397928,
    lat: -21.371243
  },
  {
    lng: -41.2397907,
    lat: -21.3712454
  },
  {
    lng: -41.2397886,
    lat: -21.3712479
  },
  {
    lng: -41.2397865,
    lat: -21.3712504
  },
  {
    lng: -41.2397843,
    lat: -21.3712528
  },
  {
    lng: -41.2397822,
    lat: -21.3712553
  },
  {
    lng: -41.2397801,
    lat: -21.3712577
  },
  {
    lng: -41.2397779,
    lat: -21.3712602
  },
  {
    lng: -41.2397758,
    lat: -21.3712626
  },
  {
    lng: -41.2397737,
    lat: -21.3712651
  },
  {
    lng: -41.2397715,
    lat: -21.3712675
  },
  {
    lng: -41.2397693,
    lat: -21.3712699
  },
  {
    lng: -41.2397672,
    lat: -21.3712723
  },
  {
    lng: -41.239765,
    lat: -21.3712748
  },
  {
    lng: -41.2397628,
    lat: -21.3712772
  },
  {
    lng: -41.2397607,
    lat: -21.3712796
  },
  {
    lng: -41.2397585,
    lat: -21.371282
  },
  {
    lng: -41.2397563,
    lat: -21.3712844
  },
  {
    lng: -41.2397541,
    lat: -21.3712868
  },
  {
    lng: -41.2397519,
    lat: -21.3712892
  },
  {
    lng: -41.2397497,
    lat: -21.3712916
  },
  {
    lng: -41.2397475,
    lat: -21.371294
  },
  {
    lng: -41.2397453,
    lat: -21.3712963
  },
  {
    lng: -41.239743,
    lat: -21.3712987
  },
  {
    lng: -41.2397408,
    lat: -21.3713011
  },
  {
    lng: -41.2397386,
    lat: -21.3713034
  },
  {
    lng: -41.2397364,
    lat: -21.3713058
  },
  {
    lng: -41.2397341,
    lat: -21.3713082
  },
  {
    lng: -41.2397319,
    lat: -21.3713105
  },
  {
    lng: -41.2397296,
    lat: -21.3713129
  },
  {
    lng: -41.2397274,
    lat: -21.3713152
  },
  {
    lng: -41.2397251,
    lat: -21.3713175
  },
  {
    lng: -41.2397229,
    lat: -21.3713199
  },
  {
    lng: -41.2397206,
    lat: -21.3713222
  },
  {
    lng: -41.2397183,
    lat: -21.3713245
  },
  {
    lng: -41.239716,
    lat: -21.3713268
  },
  {
    lng: -41.2397138,
    lat: -21.3713291
  },
  {
    lng: -41.2397115,
    lat: -21.3713315
  },
  {
    lng: -41.2397092,
    lat: -21.3713338
  },
  {
    lng: -41.2397069,
    lat: -21.3713361
  },
  {
    lng: -41.2397046,
    lat: -21.3713384
  },
  {
    lng: -41.2397023,
    lat: -21.3713406
  },
  {
    lng: -41.2397,
    lat: -21.3713429
  },
  {
    lng: -41.2396976,
    lat: -21.3713452
  },
  {
    lng: -41.2396953,
    lat: -21.3713475
  },
  {
    lng: -41.239693,
    lat: -21.3713498
  },
  {
    lng: -41.2396907,
    lat: -21.371352
  },
  {
    lng: -41.2396883,
    lat: -21.3713543
  },
  {
    lng: -41.239686,
    lat: -21.3713565
  },
  {
    lng: -41.2396837,
    lat: -21.3713588
  },
  {
    lng: -41.2396813,
    lat: -21.371361
  },
  {
    lng: -41.2396789,
    lat: -21.3713633
  },
  {
    lng: -41.2396766,
    lat: -21.3713655
  },
  {
    lng: -41.2396742,
    lat: -21.3713677
  },
  {
    lng: -41.2396719,
    lat: -21.37137
  },
  {
    lng: -41.2396695,
    lat: -21.3713722
  },
  {
    lng: -41.2396671,
    lat: -21.3713744
  },
  {
    lng: -41.2396647,
    lat: -21.3713766
  },
  {
    lng: -41.2396623,
    lat: -21.3713788
  },
  {
    lng: -41.23966,
    lat: -21.371381
  },
  {
    lng: -41.2396576,
    lat: -21.3713832
  },
  {
    lng: -41.2396552,
    lat: -21.3713854
  },
  {
    lng: -41.2396528,
    lat: -21.3713876
  },
  {
    lng: -41.2396503,
    lat: -21.3713898
  },
  {
    lng: -41.2396479,
    lat: -21.3713919
  },
  {
    lng: -41.2396455,
    lat: -21.3713941
  },
  {
    lng: -41.2396431,
    lat: -21.3713963
  },
  {
    lng: -41.2396407,
    lat: -21.3713984
  },
  {
    lng: -41.2396382,
    lat: -21.3714006
  },
  {
    lng: -41.2396358,
    lat: -21.3714027
  },
  {
    lng: -41.2396334,
    lat: -21.3714049
  },
  {
    lng: -41.2396309,
    lat: -21.371407
  },
  {
    lng: -41.2396285,
    lat: -21.3714092
  },
  {
    lng: -41.239626,
    lat: -21.3714113
  },
  {
    lng: -41.2396236,
    lat: -21.3714134
  },
  {
    lng: -41.2396211,
    lat: -21.3714155
  },
  {
    lng: -41.2396186,
    lat: -21.3714177
  },
  {
    lng: -41.2396161,
    lat: -21.3714198
  },
  {
    lng: -41.2396137,
    lat: -21.3714219
  },
  {
    lng: -41.2396112,
    lat: -21.371424
  },
  {
    lng: -41.2396087,
    lat: -21.3714261
  },
  {
    lng: -41.2396062,
    lat: -21.3714282
  },
  {
    lng: -41.2396037,
    lat: -21.3714302
  },
  {
    lng: -41.2396012,
    lat: -21.3714323
  },
  {
    lng: -41.2395987,
    lat: -21.3714344
  },
  {
    lng: -41.2395962,
    lat: -21.3714365
  },
  {
    lng: -41.2395937,
    lat: -21.3714385
  },
  {
    lng: -41.2395912,
    lat: -21.3714406
  },
  {
    lng: -41.2395887,
    lat: -21.3714426
  },
  {
    lng: -41.2395862,
    lat: -21.3714447
  },
  {
    lng: -41.2395836,
    lat: -21.3714467
  },
  {
    lng: -41.2395811,
    lat: -21.3714488
  },
  {
    lng: -41.2395786,
    lat: -21.3714508
  },
  {
    lng: -41.239576,
    lat: -21.3714528
  },
  {
    lng: -41.2395735,
    lat: -21.3714548
  },
  {
    lng: -41.2395709,
    lat: -21.3714569
  },
  {
    lng: -41.2395684,
    lat: -21.3714589
  },
  {
    lng: -41.2395658,
    lat: -21.3714609
  },
  {
    lng: -41.2395633,
    lat: -21.3714629
  },
  {
    lng: -41.2395607,
    lat: -21.3714649
  },
  {
    lng: -41.2395581,
    lat: -21.3714668
  },
  {
    lng: -41.2395555,
    lat: -21.3714688
  },
  {
    lng: -41.239553,
    lat: -21.3714708
  },
  {
    lng: -41.2395504,
    lat: -21.3714728
  },
  {
    lng: -41.2395478,
    lat: -21.3714747
  },
  {
    lng: -41.2395452,
    lat: -21.3714767
  },
  {
    lng: -41.2395426,
    lat: -21.3714787
  },
  {
    lng: -41.23954,
    lat: -21.3714806
  },
  {
    lng: -41.2395374,
    lat: -21.3714826
  },
  {
    lng: -41.2395348,
    lat: -21.3714845
  },
  {
    lng: -41.2395322,
    lat: -21.3714864
  },
  {
    lng: -41.2395296,
    lat: -21.3714884
  },
  {
    lng: -41.239527,
    lat: -21.3714903
  },
  {
    lng: -41.2395243,
    lat: -21.3714922
  },
  {
    lng: -41.2395217,
    lat: -21.3714941
  },
  {
    lng: -41.2395191,
    lat: -21.371496
  },
  {
    lng: -41.2395164,
    lat: -21.3714979
  },
  {
    lng: -41.2395138,
    lat: -21.3714998
  },
  {
    lng: -41.2395112,
    lat: -21.3715017
  },
  {
    lng: -41.2395085,
    lat: -21.3715036
  },
  {
    lng: -41.2395059,
    lat: -21.3715055
  },
  {
    lng: -41.2395032,
    lat: -21.3715074
  },
  {
    lng: -41.2395005,
    lat: -21.3715092
  },
  {
    lng: -41.2394979,
    lat: -21.3715111
  },
  {
    lng: -41.2394952,
    lat: -21.3715129
  },
  {
    lng: -41.2394926,
    lat: -21.3715148
  },
  {
    lng: -41.2394899,
    lat: -21.3715166
  },
  {
    lng: -41.2394872,
    lat: -21.3715185
  },
  {
    lng: -41.2394845,
    lat: -21.3715203
  },
  {
    lng: -41.2394818,
    lat: -21.3715221
  },
  {
    lng: -41.2394791,
    lat: -21.371524
  },
  {
    lng: -41.2394765,
    lat: -21.3715258
  },
  {
    lng: -41.2394738,
    lat: -21.3715276
  },
  {
    lng: -41.2394711,
    lat: -21.3715294
  },
  {
    lng: -41.2394683,
    lat: -21.3715312
  },
  {
    lng: -41.2394656,
    lat: -21.371533
  },
  {
    lng: -41.2394629,
    lat: -21.3715348
  },
  {
    lng: -41.2394602,
    lat: -21.3715366
  },
  {
    lng: -41.2394575,
    lat: -21.3715384
  },
  {
    lng: -41.2394548,
    lat: -21.3715401
  },
  {
    lng: -41.239452,
    lat: -21.3715419
  },
  {
    lng: -41.2394493,
    lat: -21.3715437
  },
  {
    lng: -41.2394466,
    lat: -21.3715454
  },
  {
    lng: -41.2394438,
    lat: -21.3715472
  },
  {
    lng: -41.2394411,
    lat: -21.3715489
  },
  {
    lng: -41.2394384,
    lat: -21.3715507
  },
  {
    lng: -41.2394356,
    lat: -21.3715524
  },
  {
    lng: -41.2394329,
    lat: -21.3715541
  },
  {
    lng: -41.2394299,
    lat: -21.3715558
  },
  {
    lng: -41.2394269,
    lat: -21.3715576
  },
  {
    lng: -41.239424,
    lat: -21.3715593
  },
  {
    lng: -41.239421,
    lat: -21.3715611
  },
  {
    lng: -41.2394181,
    lat: -21.3715628
  },
  {
    lng: -41.2394152,
    lat: -21.3715646
  },
  {
    lng: -41.2394122,
    lat: -21.3715663
  },
  {
    lng: -41.2394093,
    lat: -21.3715681
  },
  {
    lng: -41.2394064,
    lat: -21.3715699
  },
  {
    lng: -41.2394034,
    lat: -21.3715716
  },
  {
    lng: -41.2394005,
    lat: -21.3715734
  },
  {
    lng: -41.2393976,
    lat: -21.3715752
  },
  {
    lng: -41.2393947,
    lat: -21.371577
  },
  {
    lng: -41.2393918,
    lat: -21.3715788
  },
  {
    lng: -41.2393888,
    lat: -21.3715806
  },
  {
    lng: -41.2393859,
    lat: -21.3715824
  },
  {
    lng: -41.239383,
    lat: -21.3715843
  },
  {
    lng: -41.2393801,
    lat: -21.3715861
  },
  {
    lng: -41.2393772,
    lat: -21.3715879
  },
  {
    lng: -41.2393744,
    lat: -21.3715897
  },
  {
    lng: -41.2393715,
    lat: -21.3715916
  },
  {
    lng: -41.2393686,
    lat: -21.3715934
  },
  {
    lng: -41.2393657,
    lat: -21.3715953
  },
  {
    lng: -41.2393628,
    lat: -21.3715972
  },
  {
    lng: -41.23936,
    lat: -21.371599
  },
  {
    lng: -41.2393571,
    lat: -21.3716009
  },
  {
    lng: -41.2393542,
    lat: -21.3716028
  },
  {
    lng: -41.2393514,
    lat: -21.3716046
  },
  {
    lng: -41.2393485,
    lat: -21.3716065
  },
  {
    lng: -41.2393456,
    lat: -21.3716084
  },
  {
    lng: -41.2393428,
    lat: -21.3716103
  },
  {
    lng: -41.23934,
    lat: -21.3716122
  },
  {
    lng: -41.2393371,
    lat: -21.3716141
  },
  {
    lng: -41.2393343,
    lat: -21.3716161
  },
  {
    lng: -41.2393314,
    lat: -21.371618
  },
  {
    lng: -41.2393286,
    lat: -21.3716199
  },
  {
    lng: -41.2393258,
    lat: -21.3716218
  },
  {
    lng: -41.239323,
    lat: -21.3716238
  },
  {
    lng: -41.2393201,
    lat: -21.3716257
  },
  {
    lng: -41.2393173,
    lat: -21.3716277
  },
  {
    lng: -41.2393145,
    lat: -21.3716296
  },
  {
    lng: -41.2393117,
    lat: -21.3716316
  },
  {
    lng: -41.2393089,
    lat: -21.3716336
  },
  {
    lng: -41.2393061,
    lat: -21.3716355
  },
  {
    lng: -41.2393033,
    lat: -21.3716375
  },
  {
    lng: -41.2393005,
    lat: -21.3716395
  },
  {
    lng: -41.2392977,
    lat: -21.3716415
  },
  {
    lng: -41.2392949,
    lat: -21.3716435
  },
  {
    lng: -41.2392921,
    lat: -21.3716455
  },
  {
    lng: -41.2392894,
    lat: -21.3716475
  },
  {
    lng: -41.2392866,
    lat: -21.3716495
  },
  {
    lng: -41.2392838,
    lat: -21.3716515
  },
  {
    lng: -41.2392811,
    lat: -21.3716535
  },
  {
    lng: -41.2392783,
    lat: -21.3716556
  },
  {
    lng: -41.2392756,
    lat: -21.3716576
  },
  {
    lng: -41.2392728,
    lat: -21.3716596
  },
  {
    lng: -41.2392701,
    lat: -21.3716617
  },
  {
    lng: -41.2392673,
    lat: -21.3716637
  },
  {
    lng: -41.2392646,
    lat: -21.3716658
  },
  {
    lng: -41.2392618,
    lat: -21.3716678
  },
  {
    lng: -41.2392591,
    lat: -21.3716699
  },
  {
    lng: -41.2392564,
    lat: -21.371672
  },
  {
    lng: -41.2392536,
    lat: -21.3716741
  },
  {
    lng: -41.2392509,
    lat: -21.3716761
  },
  {
    lng: -41.2392482,
    lat: -21.3716782
  },
  {
    lng: -41.2392455,
    lat: -21.3716803
  },
  {
    lng: -41.2392428,
    lat: -21.3716824
  },
  {
    lng: -41.2392401,
    lat: -21.3716845
  },
  {
    lng: -41.2392374,
    lat: -21.3716866
  },
  {
    lng: -41.2392347,
    lat: -21.3716887
  },
  {
    lng: -41.239232,
    lat: -21.3716909
  },
  {
    lng: -41.2392293,
    lat: -21.371693
  },
  {
    lng: -41.2392266,
    lat: -21.3716951
  },
  {
    lng: -41.239224,
    lat: -21.3716972
  },
  {
    lng: -41.2392213,
    lat: -21.3716994
  },
  {
    lng: -41.2392186,
    lat: -21.3717015
  },
  {
    lng: -41.239216,
    lat: -21.3717037
  },
  {
    lng: -41.2392133,
    lat: -21.3717058
  },
  {
    lng: -41.2392106,
    lat: -21.371708
  },
  {
    lng: -41.239208,
    lat: -21.3717102
  },
  {
    lng: -41.2392053,
    lat: -21.3717123
  },
  {
    lng: -41.2392027,
    lat: -21.3717145
  },
  {
    lng: -41.2392001,
    lat: -21.3717167
  },
  {
    lng: -41.2391974,
    lat: -21.3717189
  },
  {
    lng: -41.2391948,
    lat: -21.3717211
  },
  {
    lng: -41.2391922,
    lat: -21.3717233
  },
  {
    lng: -41.2391895,
    lat: -21.3717255
  },
  {
    lng: -41.2391869,
    lat: -21.3717277
  },
  {
    lng: -41.2391843,
    lat: -21.3717299
  },
  {
    lng: -41.2391817,
    lat: -21.3717321
  },
  {
    lng: -41.2391791,
    lat: -21.3717344
  },
  {
    lng: -41.2391765,
    lat: -21.3717366
  },
  {
    lng: -41.2391739,
    lat: -21.3717388
  },
  {
    lng: -41.2391713,
    lat: -21.3717411
  },
  {
    lng: -41.2391687,
    lat: -21.3717433
  },
  {
    lng: -41.2391661,
    lat: -21.3717456
  },
  {
    lng: -41.2391636,
    lat: -21.3717478
  },
  {
    lng: -41.239161,
    lat: -21.3717501
  },
  {
    lng: -41.2391584,
    lat: -21.3717523
  },
  {
    lng: -41.2391559,
    lat: -21.3717546
  },
  {
    lng: -41.2391533,
    lat: -21.3717569
  },
  {
    lng: -41.2391507,
    lat: -21.3717592
  },
  {
    lng: -41.2391482,
    lat: -21.3717615
  },
  {
    lng: -41.2391456,
    lat: -21.3717637
  },
  {
    lng: -41.2391431,
    lat: -21.371766
  },
  {
    lng: -41.2391406,
    lat: -21.3717683
  },
  {
    lng: -41.239138,
    lat: -21.3717706
  },
  {
    lng: -41.2391355,
    lat: -21.371773
  },
  {
    lng: -41.239133,
    lat: -21.3717753
  },
  {
    lng: -41.2391305,
    lat: -21.3717776
  },
  {
    lng: -41.239128,
    lat: -21.3717799
  },
  {
    lng: -41.2391254,
    lat: -21.3717823
  },
  {
    lng: -41.2391229,
    lat: -21.3717846
  },
  {
    lng: -41.2391204,
    lat: -21.3717869
  },
  {
    lng: -41.2391179,
    lat: -21.3717893
  },
  {
    lng: -41.2391155,
    lat: -21.3717916
  },
  {
    lng: -41.239113,
    lat: -21.371794
  },
  {
    lng: -41.2391105,
    lat: -21.3717963
  },
  {
    lng: -41.239108,
    lat: -21.3717987
  },
  {
    lng: -41.2391055,
    lat: -21.3718011
  },
  {
    lng: -41.2391031,
    lat: -21.3718035
  },
  {
    lng: -41.2391006,
    lat: -21.3718058
  },
  {
    lng: -41.2390981,
    lat: -21.3718082
  },
  {
    lng: -41.2390957,
    lat: -21.3718106
  },
  {
    lng: -41.2390932,
    lat: -21.371813
  },
  {
    lng: -41.2390908,
    lat: -21.3718154
  },
  {
    lng: -41.2390884,
    lat: -21.3718178
  },
  {
    lng: -41.2390859,
    lat: -21.3718202
  },
  {
    lng: -41.2390835,
    lat: -21.3718226
  },
  {
    lng: -41.2390811,
    lat: -21.3718251
  },
  {
    lng: -41.2390787,
    lat: -21.3718275
  },
  {
    lng: -41.2390762,
    lat: -21.3718299
  },
  {
    lng: -41.2390738,
    lat: -21.3718323
  },
  {
    lng: -41.2390714,
    lat: -21.3718348
  },
  {
    lng: -41.239069,
    lat: -21.3718372
  },
  {
    lng: -41.2390666,
    lat: -21.3718397
  },
  {
    lng: -41.2390642,
    lat: -21.3718421
  },
  {
    lng: -41.2390619,
    lat: -21.3718446
  },
  {
    lng: -41.2390595,
    lat: -21.3718471
  },
  {
    lng: -41.2390571,
    lat: -21.3718495
  },
  {
    lng: -41.2390547,
    lat: -21.371852
  },
  {
    lng: -41.2390524,
    lat: -21.3718545
  },
  {
    lng: -41.23905,
    lat: -21.3718569
  },
  {
    lng: -41.2390476,
    lat: -21.3718594
  },
  {
    lng: -41.2390453,
    lat: -21.3718619
  },
  {
    lng: -41.239043,
    lat: -21.3718644
  },
  {
    lng: -41.2390406,
    lat: -21.3718669
  },
  {
    lng: -41.2390383,
    lat: -21.3718694
  },
  {
    lng: -41.2390359,
    lat: -21.3718719
  },
  {
    lng: -41.2390336,
    lat: -21.3718744
  },
  {
    lng: -41.2390313,
    lat: -21.371877
  },
  {
    lng: -41.239029,
    lat: -21.3718795
  },
  {
    lng: -41.2390267,
    lat: -21.371882
  },
  {
    lng: -41.2390244,
    lat: -21.3718845
  },
  {
    lng: -41.2390221,
    lat: -21.3718871
  },
  {
    lng: -41.2390198,
    lat: -21.3718896
  },
  {
    lng: -41.2390175,
    lat: -21.3718922
  },
  {
    lng: -41.2390152,
    lat: -21.3718947
  },
  {
    lng: -41.2390129,
    lat: -21.3718973
  },
  {
    lng: -41.2390106,
    lat: -21.3718998
  },
  {
    lng: -41.2390084,
    lat: -21.3719024
  },
  {
    lng: -41.2390061,
    lat: -21.371905
  },
  {
    lng: -41.2390038,
    lat: -21.3719075
  },
  {
    lng: -41.2390016,
    lat: -21.3719101
  },
  {
    lng: -41.2389993,
    lat: -21.3719127
  },
  {
    lng: -41.2389971,
    lat: -21.3719153
  },
  {
    lng: -41.2389948,
    lat: -21.3719179
  },
  {
    lng: -41.2389926,
    lat: -21.3719205
  },
  {
    lng: -41.2389904,
    lat: -21.3719231
  },
  {
    lng: -41.2389882,
    lat: -21.3719257
  },
  {
    lng: -41.2389859,
    lat: -21.3719283
  },
  {
    lng: -41.2389837,
    lat: -21.3719309
  },
  {
    lng: -41.2389815,
    lat: -21.3719335
  },
  {
    lng: -41.2389793,
    lat: -21.3719361
  },
  {
    lng: -41.2389771,
    lat: -21.3719388
  },
  {
    lng: -41.2389749,
    lat: -21.3719414
  },
  {
    lng: -41.2389727,
    lat: -21.371944
  },
  {
    lng: -41.2389705,
    lat: -21.3719467
  },
  {
    lng: -41.2389684,
    lat: -21.3719493
  },
  {
    lng: -41.2389662,
    lat: -21.371952
  },
  {
    lng: -41.238964,
    lat: -21.3719546
  },
  {
    lng: -41.2389619,
    lat: -21.3719573
  },
  {
    lng: -41.2389597,
    lat: -21.3719599
  },
  {
    lng: -41.2389576,
    lat: -21.3719626
  },
  {
    lng: -41.2389554,
    lat: -21.3719653
  },
  {
    lng: -41.2389533,
    lat: -21.3719679
  },
  {
    lng: -41.2389511,
    lat: -21.3719706
  },
  {
    lng: -41.238949,
    lat: -21.3719733
  },
  {
    lng: -41.2389469,
    lat: -21.371976
  },
  {
    lng: -41.2389448,
    lat: -21.3719787
  },
  {
    lng: -41.2389426,
    lat: -21.3719814
  },
  {
    lng: -41.2389405,
    lat: -21.3719841
  },
  {
    lng: -41.2389384,
    lat: -21.3719868
  },
  {
    lng: -41.2389363,
    lat: -21.3719895
  },
  {
    lng: -41.2389342,
    lat: -21.3719922
  },
  {
    lng: -41.2389322,
    lat: -21.3719949
  },
  {
    lng: -41.2389301,
    lat: -21.3719976
  },
  {
    lng: -41.238928,
    lat: -21.3720004
  },
  {
    lng: -41.2389259,
    lat: -21.3720031
  },
  {
    lng: -41.2389239,
    lat: -21.3720058
  },
  {
    lng: -41.2389218,
    lat: -21.3720085
  },
  {
    lng: -41.2389197,
    lat: -21.3720113
  },
  {
    lng: -41.2389177,
    lat: -21.372014
  },
  {
    lng: -41.2389156,
    lat: -21.3720168
  },
  {
    lng: -41.2389136,
    lat: -21.3720195
  },
  {
    lng: -41.2389116,
    lat: -21.3720223
  },
  {
    lng: -41.2389095,
    lat: -21.372025
  },
  {
    lng: -41.2389075,
    lat: -21.3720278
  },
  {
    lng: -41.2389055,
    lat: -21.3720306
  },
  {
    lng: -41.2389035,
    lat: -21.3720334
  },
  {
    lng: -41.2389015,
    lat: -21.3720361
  },
  {
    lng: -41.2388995,
    lat: -21.3720389
  },
  {
    lng: -41.2388975,
    lat: -21.3720417
  },
  {
    lng: -41.2388955,
    lat: -21.3720445
  },
  {
    lng: -41.2388935,
    lat: -21.3720473
  },
  {
    lng: -41.2388915,
    lat: -21.3720501
  },
  {
    lng: -41.2388896,
    lat: -21.3720529
  },
  {
    lng: -41.2388876,
    lat: -21.3720557
  },
  {
    lng: -41.2388856,
    lat: -21.3720585
  },
  {
    lng: -41.2388837,
    lat: -21.3720613
  },
  {
    lng: -41.2388817,
    lat: -21.3720641
  },
  {
    lng: -41.2388798,
    lat: -21.3720669
  },
  {
    lng: -41.2388779,
    lat: -21.3720698
  },
  {
    lng: -41.2388759,
    lat: -21.3720726
  },
  {
    lng: -41.238874,
    lat: -21.3720754
  },
  {
    lng: -41.2388721,
    lat: -21.3720783
  },
  {
    lng: -41.2388702,
    lat: -21.3720811
  },
  {
    lng: -41.2388683,
    lat: -21.3720839
  },
  {
    lng: -41.2388663,
    lat: -21.3720868
  },
  {
    lng: -41.2388644,
    lat: -21.3720896
  },
  {
    lng: -41.2388626,
    lat: -21.3720925
  },
  {
    lng: -41.2388607,
    lat: -21.3720953
  },
  {
    lng: -41.2388588,
    lat: -21.3720982
  },
  {
    lng: -41.2388569,
    lat: -21.3721011
  },
  {
    lng: -41.238855,
    lat: -21.3721039
  },
  {
    lng: -41.2388532,
    lat: -21.3721068
  },
  {
    lng: -41.2388513,
    lat: -21.3721097
  },
  {
    lng: -41.2388495,
    lat: -21.3721126
  },
  {
    lng: -41.2388476,
    lat: -21.3721154
  },
  {
    lng: -41.2388458,
    lat: -21.3721183
  },
  {
    lng: -41.2388439,
    lat: -21.3721212
  },
  {
    lng: -41.2388421,
    lat: -21.3721241
  },
  {
    lng: -41.2388403,
    lat: -21.372127
  },
  {
    lng: -41.2388385,
    lat: -21.3721299
  },
  {
    lng: -41.2388366,
    lat: -21.3721328
  },
  {
    lng: -41.2388348,
    lat: -21.3721357
  },
  {
    lng: -41.238833,
    lat: -21.3721386
  },
  {
    lng: -41.2388312,
    lat: -21.3721416
  },
  {
    lng: -41.2388294,
    lat: -21.3721445
  },
  {
    lng: -41.2388277,
    lat: -21.3721474
  },
  {
    lng: -41.2388259,
    lat: -21.3721503
  },
  {
    lng: -41.2388241,
    lat: -21.3721533
  },
  {
    lng: -41.2388223,
    lat: -21.3721562
  },
  {
    lng: -41.2388206,
    lat: -21.3721591
  },
  {
    lng: -41.2388188,
    lat: -21.3721621
  },
  {
    lng: -41.2388171,
    lat: -21.372165
  },
  {
    lng: -41.2388153,
    lat: -21.372168
  },
  {
    lng: -41.2388136,
    lat: -21.3721709
  },
  {
    lng: -41.2388119,
    lat: -21.3721739
  },
  {
    lng: -41.2388101,
    lat: -21.3721768
  },
  {
    lng: -41.2388079,
    lat: -21.3721801
  },
  {
    lng: -41.2388057,
    lat: -21.3721834
  },
  {
    lng: -41.2388034,
    lat: -21.3721867
  },
  {
    lng: -41.2388012,
    lat: -21.3721899
  },
  {
    lng: -41.238799,
    lat: -21.3721932
  },
  {
    lng: -41.2387968,
    lat: -21.3721965
  },
  {
    lng: -41.2387945,
    lat: -21.3721998
  },
  {
    lng: -41.2387923,
    lat: -21.3722031
  },
  {
    lng: -41.2387901,
    lat: -21.3722064
  },
  {
    lng: -41.238788,
    lat: -21.3722097
  },
  {
    lng: -41.2387858,
    lat: -21.372213
  },
  {
    lng: -41.2387836,
    lat: -21.3722163
  },
  {
    lng: -41.2387814,
    lat: -21.3722197
  },
  {
    lng: -41.2387792,
    lat: -21.372223
  },
  {
    lng: -41.2387771,
    lat: -21.3722263
  },
  {
    lng: -41.2387749,
    lat: -21.3722296
  },
  {
    lng: -41.2387728,
    lat: -21.372233
  },
  {
    lng: -41.2387706,
    lat: -21.3722363
  },
  {
    lng: -41.2387685,
    lat: -21.3722396
  },
  {
    lng: -41.2387663,
    lat: -21.372243
  },
  {
    lng: -41.2387642,
    lat: -21.3722463
  },
  {
    lng: -41.2387621,
    lat: -21.3722497
  },
  {
    lng: -41.23876,
    lat: -21.372253
  },
  {
    lng: -41.2387579,
    lat: -21.3722564
  },
  {
    lng: -41.2387557,
    lat: -21.3722597
  },
  {
    lng: -41.2387536,
    lat: -21.3722631
  },
  {
    lng: -41.2387515,
    lat: -21.3722665
  },
  {
    lng: -41.2387495,
    lat: -21.3722698
  },
  {
    lng: -41.2387474,
    lat: -21.3722732
  },
  {
    lng: -41.2387453,
    lat: -21.3722766
  },
  {
    lng: -41.2387432,
    lat: -21.37228
  },
  {
    lng: -41.2387412,
    lat: -21.3722834
  },
  {
    lng: -41.2387391,
    lat: -21.3722868
  },
  {
    lng: -41.238737,
    lat: -21.3722902
  },
  {
    lng: -41.238735,
    lat: -21.3722935
  },
  {
    lng: -41.238733,
    lat: -21.3722969
  },
  {
    lng: -41.2387309,
    lat: -21.3723004
  },
  {
    lng: -41.2387289,
    lat: -21.3723038
  },
  {
    lng: -41.2387269,
    lat: -21.3723072
  },
  {
    lng: -41.2387248,
    lat: -21.3723106
  },
  {
    lng: -41.2387228,
    lat: -21.372314
  },
  {
    lng: -41.2387208,
    lat: -21.3723174
  },
  {
    lng: -41.2387188,
    lat: -21.3723208
  },
  {
    lng: -41.2387168,
    lat: -21.3723243
  },
  {
    lng: -41.2387148,
    lat: -21.3723277
  },
  {
    lng: -41.2387128,
    lat: -21.3723311
  },
  {
    lng: -41.2387109,
    lat: -21.3723346
  },
  {
    lng: -41.2387089,
    lat: -21.372338
  },
  {
    lng: -41.2387069,
    lat: -21.3723415
  },
  {
    lng: -41.238705,
    lat: -21.3723449
  },
  {
    lng: -41.238703,
    lat: -21.3723484
  },
  {
    lng: -41.2387011,
    lat: -21.3723518
  },
  {
    lng: -41.2386991,
    lat: -21.3723553
  },
  {
    lng: -41.2386972,
    lat: -21.3723587
  },
  {
    lng: -41.2386952,
    lat: -21.3723622
  },
  {
    lng: -41.2386933,
    lat: -21.3723657
  },
  {
    lng: -41.2386914,
    lat: -21.3723691
  },
  {
    lng: -41.2386895,
    lat: -21.3723726
  },
  {
    lng: -41.2386876,
    lat: -21.3723761
  },
  {
    lng: -41.2386857,
    lat: -21.3723796
  },
  {
    lng: -41.2386838,
    lat: -21.3723831
  },
  {
    lng: -41.2386819,
    lat: -21.3723865
  },
  {
    lng: -41.23868,
    lat: -21.37239
  },
  {
    lng: -41.2386781,
    lat: -21.3723935
  },
  {
    lng: -41.2386763,
    lat: -21.372397
  },
  {
    lng: -41.2386744,
    lat: -21.3724005
  },
  {
    lng: -41.2386725,
    lat: -21.372404
  },
  {
    lng: -41.2386707,
    lat: -21.3724075
  },
  {
    lng: -41.2386688,
    lat: -21.372411
  },
  {
    lng: -41.238667,
    lat: -21.3724146
  },
  {
    lng: -41.2386651,
    lat: -21.3724181
  },
  {
    lng: -41.2386633,
    lat: -21.3724216
  },
  {
    lng: -41.2386615,
    lat: -21.3724251
  },
  {
    lng: -41.2386597,
    lat: -21.3724286
  },
  {
    lng: -41.2386579,
    lat: -21.3724322
  },
  {
    lng: -41.2386561,
    lat: -21.3724357
  },
  {
    lng: -41.2386543,
    lat: -21.3724392
  },
  {
    lng: -41.2386525,
    lat: -21.3724428
  },
  {
    lng: -41.2386507,
    lat: -21.3724463
  },
  {
    lng: -41.2386489,
    lat: -21.3724499
  },
  {
    lng: -41.2386471,
    lat: -21.3724534
  },
  {
    lng: -41.2386454,
    lat: -21.372457
  },
  {
    lng: -41.2386436,
    lat: -21.3724605
  },
  {
    lng: -41.2386418,
    lat: -21.3724641
  },
  {
    lng: -41.2386401,
    lat: -21.3724676
  },
  {
    lng: -41.2386383,
    lat: -21.3724712
  },
  {
    lng: -41.2386366,
    lat: -21.3724747
  },
  {
    lng: -41.2386349,
    lat: -21.3724783
  },
  {
    lng: -41.2386331,
    lat: -21.3724819
  },
  {
    lng: -41.2386314,
    lat: -21.3724855
  },
  {
    lng: -41.2386297,
    lat: -21.372489
  },
  {
    lng: -41.238628,
    lat: -21.3724926
  },
  {
    lng: -41.2386263,
    lat: -21.3724962
  },
  {
    lng: -41.2386246,
    lat: -21.3724998
  },
  {
    lng: -41.2386229,
    lat: -21.3725034
  },
  {
    lng: -41.2386212,
    lat: -21.372507
  },
  {
    lng: -41.2386195,
    lat: -21.3725106
  },
  {
    lng: -41.2386179,
    lat: -21.3725142
  },
  {
    lng: -41.2386162,
    lat: -21.3725178
  },
  {
    lng: -41.2386145,
    lat: -21.3725214
  },
  {
    lng: -41.2386129,
    lat: -21.372525
  },
  {
    lng: -41.2386113,
    lat: -21.3725286
  },
  {
    lng: -41.2386096,
    lat: -21.3725322
  },
  {
    lng: -41.238608,
    lat: -21.3725358
  },
  {
    lng: -41.2386063,
    lat: -21.3725394
  },
  {
    lng: -41.2386047,
    lat: -21.372543
  },
  {
    lng: -41.2386031,
    lat: -21.3725467
  },
  {
    lng: -41.2386015,
    lat: -21.3725503
  },
  {
    lng: -41.2385999,
    lat: -21.3725539
  },
  {
    lng: -41.2385983,
    lat: -21.3725575
  },
  {
    lng: -41.2385967,
    lat: -21.3725612
  },
  {
    lng: -41.2385951,
    lat: -21.3725648
  },
  {
    lng: -41.2385935,
    lat: -21.3725685
  },
  {
    lng: -41.238592,
    lat: -21.3725721
  },
  {
    lng: -41.2385904,
    lat: -21.3725757
  },
  {
    lng: -41.2385888,
    lat: -21.3725794
  },
  {
    lng: -41.2385873,
    lat: -21.372583
  },
  {
    lng: -41.2385857,
    lat: -21.3725867
  },
  {
    lng: -41.2385842,
    lat: -21.3725903
  },
  {
    lng: -41.2385827,
    lat: -21.372594
  },
  {
    lng: -41.2385811,
    lat: -21.3725977
  },
  {
    lng: -41.2385796,
    lat: -21.3726013
  },
  {
    lng: -41.2385781,
    lat: -21.372605
  },
  {
    lng: -41.2385766,
    lat: -21.3726087
  },
  {
    lng: -41.2385751,
    lat: -21.3726123
  },
  {
    lng: -41.2385736,
    lat: -21.372616
  },
  {
    lng: -41.2385721,
    lat: -21.3726197
  },
  {
    lng: -41.2385706,
    lat: -21.3726234
  },
  {
    lng: -41.2385691,
    lat: -21.372627
  },
  {
    lng: -41.2385677,
    lat: -21.3726307
  },
  {
    lng: -41.2385662,
    lat: -21.3726344
  },
  {
    lng: -41.2385647,
    lat: -21.3726381
  },
  {
    lng: -41.2385633,
    lat: -21.3726418
  },
  {
    lng: -41.2385618,
    lat: -21.3726455
  },
  {
    lng: -41.2385604,
    lat: -21.3726492
  },
  {
    lng: -41.238559,
    lat: -21.3726529
  },
  {
    lng: -41.2385575,
    lat: -21.3726566
  },
  {
    lng: -41.2385561,
    lat: -21.3726603
  },
  {
    lng: -41.2385547,
    lat: -21.372664
  },
  {
    lng: -41.2385533,
    lat: -21.3726677
  },
  {
    lng: -41.2385519,
    lat: -21.3726714
  },
  {
    lng: -41.2385505,
    lat: -21.3726751
  },
  {
    lng: -41.2385491,
    lat: -21.3726788
  },
  {
    lng: -41.2385477,
    lat: -21.3726825
  },
  {
    lng: -41.2385464,
    lat: -21.3726863
  },
  {
    lng: -41.238545,
    lat: -21.37269
  },
  {
    lng: -41.2385436,
    lat: -21.3726937
  },
  {
    lng: -41.2385423,
    lat: -21.3726974
  },
  {
    lng: -41.2385409,
    lat: -21.3727012
  },
  {
    lng: -41.2385396,
    lat: -21.3727049
  },
  {
    lng: -41.2385382,
    lat: -21.3727086
  },
  {
    lng: -41.2385369,
    lat: -21.3727124
  },
  {
    lng: -41.2385356,
    lat: -21.3727161
  },
  {
    lng: -41.2385343,
    lat: -21.3727199
  },
  {
    lng: -41.2385329,
    lat: -21.3727236
  },
  {
    lng: -41.2385316,
    lat: -21.3727273
  },
  {
    lng: -41.2385303,
    lat: -21.3727311
  },
  {
    lng: -41.238529,
    lat: -21.3727348
  },
  {
    lng: -41.2385278,
    lat: -21.3727386
  },
  {
    lng: -41.2385265,
    lat: -21.3727423
  },
  {
    lng: -41.2385252,
    lat: -21.3727461
  },
  {
    lng: -41.2385239,
    lat: -21.3727499
  },
  {
    lng: -41.2385227,
    lat: -21.3727536
  },
  {
    lng: -41.2385214,
    lat: -21.3727574
  },
  {
    lng: -41.2385202,
    lat: -21.3727611
  },
  {
    lng: -41.2385189,
    lat: -21.3727649
  },
  {
    lng: -41.2385177,
    lat: -21.3727687
  },
  {
    lng: -41.2385165,
    lat: -21.3727725
  },
  {
    lng: -41.2385152,
    lat: -21.3727762
  },
  {
    lng: -41.238514,
    lat: -21.37278
  },
  {
    lng: -41.2385128,
    lat: -21.3727838
  },
  {
    lng: -41.2385116,
    lat: -21.3727876
  },
  {
    lng: -41.2385104,
    lat: -21.3727913
  },
  {
    lng: -41.2385092,
    lat: -21.3727951
  },
  {
    lng: -41.238508,
    lat: -21.3727989
  },
  {
    lng: -41.2385069,
    lat: -21.3728027
  },
  {
    lng: -41.2385057,
    lat: -21.3728065
  },
  {
    lng: -41.2385045,
    lat: -21.3728103
  },
  {
    lng: -41.2385034,
    lat: -21.3728141
  },
  {
    lng: -41.2385022,
    lat: -21.3728179
  },
  {
    lng: -41.2385011,
    lat: -21.3728217
  },
  {
    lng: -41.2384999,
    lat: -21.3728255
  },
  {
    lng: -41.2384988,
    lat: -21.3728293
  },
  {
    lng: -41.2384977,
    lat: -21.3728331
  },
  {
    lng: -41.2384966,
    lat: -21.3728369
  },
  {
    lng: -41.2384954,
    lat: -21.3728407
  },
  {
    lng: -41.2384943,
    lat: -21.3728445
  },
  {
    lng: -41.2384932,
    lat: -21.3728483
  },
  {
    lng: -41.2384921,
    lat: -21.3728521
  },
  {
    lng: -41.2384911,
    lat: -21.3728559
  },
  {
    lng: -41.23849,
    lat: -21.3728598
  },
  {
    lng: -41.2384889,
    lat: -21.3728636
  },
  {
    lng: -41.2384878,
    lat: -21.3728674
  },
  {
    lng: -41.2384868,
    lat: -21.3728712
  },
  {
    lng: -41.2384857,
    lat: -21.372875
  },
  {
    lng: -41.2384847,
    lat: -21.3728789
  },
  {
    lng: -41.2384836,
    lat: -21.3728827
  },
  {
    lng: -41.2384826,
    lat: -21.3728865
  },
  {
    lng: -41.2384816,
    lat: -21.3728904
  },
  {
    lng: -41.2384806,
    lat: -21.3728942
  },
  {
    lng: -41.2384795,
    lat: -21.372898
  },
  {
    lng: -41.2384785,
    lat: -21.3729019
  },
  {
    lng: -41.2384775,
    lat: -21.3729057
  },
  {
    lng: -41.2384765,
    lat: -21.3729095
  },
  {
    lng: -41.2384756,
    lat: -21.3729134
  },
  {
    lng: -41.2384746,
    lat: -21.3729172
  },
  {
    lng: -41.2384736,
    lat: -21.3729211
  },
  {
    lng: -41.2384726,
    lat: -21.3729249
  },
  {
    lng: -41.2384717,
    lat: -21.3729288
  },
  {
    lng: -41.2384707,
    lat: -21.3729326
  },
  {
    lng: -41.2384698,
    lat: -21.3729365
  },
  {
    lng: -41.2384688,
    lat: -21.3729403
  },
  {
    lng: -41.2384679,
    lat: -21.3729442
  },
  {
    lng: -41.238467,
    lat: -21.372948
  },
  {
    lng: -41.238466,
    lat: -21.3729519
  },
  {
    lng: -41.2384651,
    lat: -21.3729557
  },
  {
    lng: -41.2384642,
    lat: -21.3729596
  },
  {
    lng: -41.2384633,
    lat: -21.3729635
  },
  {
    lng: -41.2384624,
    lat: -21.3729673
  },
  {
    lng: -41.2384615,
    lat: -21.3729712
  },
  {
    lng: -41.2384607,
    lat: -21.3729751
  },
  {
    lng: -41.2384598,
    lat: -21.3729789
  },
  {
    lng: -41.2384589,
    lat: -21.3729828
  },
  {
    lng: -41.238458,
    lat: -21.3729867
  },
  {
    lng: -41.2384572,
    lat: -21.3729906
  },
  {
    lng: -41.2384563,
    lat: -21.3729944
  },
  {
    lng: -41.2384555,
    lat: -21.3729983
  },
  {
    lng: -41.2384547,
    lat: -21.3730022
  },
  {
    lng: -41.2384538,
    lat: -21.3730061
  },
  {
    lng: -41.238453,
    lat: -21.3730099
  },
  {
    lng: -41.2384522,
    lat: -21.3730138
  },
  {
    lng: -41.2384514,
    lat: -21.3730177
  },
  {
    lng: -41.2384506,
    lat: -21.3730216
  },
  {
    lng: -41.2384498,
    lat: -21.3730255
  },
  {
    lng: -41.238449,
    lat: -21.3730294
  },
  {
    lng: -41.2384482,
    lat: -21.3730333
  },
  {
    lng: -41.2384474,
    lat: -21.3730371
  },
  {
    lng: -41.2384467,
    lat: -21.373041
  },
  {
    lng: -41.2384459,
    lat: -21.3730449
  },
  {
    lng: -41.2384452,
    lat: -21.3730488
  },
  {
    lng: -41.2384444,
    lat: -21.3730527
  },
  {
    lng: -41.2384437,
    lat: -21.3730566
  },
  {
    lng: -41.2384429,
    lat: -21.3730605
  },
  {
    lng: -41.2384422,
    lat: -21.3730644
  },
  {
    lng: -41.2384415,
    lat: -21.3730683
  },
  {
    lng: -41.2384408,
    lat: -21.3730722
  },
  {
    lng: -41.2384401,
    lat: -21.3730761
  },
  {
    lng: -41.2384394,
    lat: -21.37308
  },
  {
    lng: -41.2383918,
    lat: -21.3734365
  },
  {
    lng: -41.2382967,
    lat: -21.3738501
  },
  {
    lng: -41.2381541,
    lat: -21.3742542
  },
  {
    lng: -41.2380737,
    lat: -21.3744784
  },
  {
    lng: -41.2380638,
    lat: -21.3745061
  },
  {
    lng: -41.2379878,
    lat: -21.374739
  },
  {
    lng: -41.2378927,
    lat: -21.3748816
  },
  {
    lng: -41.2377073,
    lat: -21.375
  },
  {
    lng: -41.2375104,
    lat: -21.3750986
  },
  {
    lng: -41.2372442,
    lat: -21.3751984
  },
  {
    lng: -41.2372426,
    lat: -21.3751991
  },
  {
    lng: -41.237241,
    lat: -21.3751999
  },
  {
    lng: -41.2372394,
    lat: -21.3752007
  },
  {
    lng: -41.2372378,
    lat: -21.3752014
  },
  {
    lng: -41.2372362,
    lat: -21.3752022
  },
  {
    lng: -41.2372346,
    lat: -21.375203
  },
  {
    lng: -41.2372331,
    lat: -21.3752038
  },
  {
    lng: -41.2372315,
    lat: -21.3752046
  },
  {
    lng: -41.2372299,
    lat: -21.3752053
  },
  {
    lng: -41.2372283,
    lat: -21.3752062
  },
  {
    lng: -41.2372267,
    lat: -21.375207
  },
  {
    lng: -41.2372252,
    lat: -21.3752078
  },
  {
    lng: -41.2372236,
    lat: -21.3752086
  },
  {
    lng: -41.2372221,
    lat: -21.3752094
  },
  {
    lng: -41.2372205,
    lat: -21.3752103
  },
  {
    lng: -41.2372189,
    lat: -21.3752111
  },
  {
    lng: -41.2372174,
    lat: -21.3752119
  },
  {
    lng: -41.2372158,
    lat: -21.3752128
  },
  {
    lng: -41.2372143,
    lat: -21.3752136
  },
  {
    lng: -41.2372128,
    lat: -21.3752145
  },
  {
    lng: -41.2372112,
    lat: -21.3752154
  },
  {
    lng: -41.2372097,
    lat: -21.3752163
  },
  {
    lng: -41.2372081,
    lat: -21.3752171
  },
  {
    lng: -41.2372066,
    lat: -21.375218
  },
  {
    lng: -41.2372051,
    lat: -21.3752189
  },
  {
    lng: -41.2372036,
    lat: -21.3752198
  },
  {
    lng: -41.2372021,
    lat: -21.3752207
  },
  {
    lng: -41.2372005,
    lat: -21.3752216
  },
  {
    lng: -41.237199,
    lat: -21.3752225
  },
  {
    lng: -41.2371975,
    lat: -21.3752235
  },
  {
    lng: -41.237196,
    lat: -21.3752244
  },
  {
    lng: -41.2371945,
    lat: -21.3752253
  },
  {
    lng: -41.237193,
    lat: -21.3752263
  },
  {
    lng: -41.2371915,
    lat: -21.3752272
  },
  {
    lng: -41.23719,
    lat: -21.3752282
  },
  {
    lng: -41.2371885,
    lat: -21.3752291
  },
  {
    lng: -41.2371871,
    lat: -21.3752301
  },
  {
    lng: -41.2371856,
    lat: -21.375231
  },
  {
    lng: -41.2371841,
    lat: -21.375232
  },
  {
    lng: -41.2371826,
    lat: -21.375233
  },
  {
    lng: -41.2371812,
    lat: -21.375234
  },
  {
    lng: -41.2371797,
    lat: -21.375235
  },
  {
    lng: -41.2371782,
    lat: -21.375236
  },
  {
    lng: -41.2371768,
    lat: -21.375237
  },
  {
    lng: -41.2371753,
    lat: -21.375238
  },
  {
    lng: -41.2371739,
    lat: -21.375239
  },
  {
    lng: -41.2371724,
    lat: -21.37524
  },
  {
    lng: -41.237171,
    lat: -21.375241
  },
  {
    lng: -41.2371696,
    lat: -21.3752421
  },
  {
    lng: -41.2371681,
    lat: -21.3752431
  },
  {
    lng: -41.2371667,
    lat: -21.3752441
  },
  {
    lng: -41.2371653,
    lat: -21.3752452
  },
  {
    lng: -41.2371639,
    lat: -21.3752462
  },
  {
    lng: -41.2371624,
    lat: -21.3752473
  },
  {
    lng: -41.237161,
    lat: -21.3752483
  },
  {
    lng: -41.2371596,
    lat: -21.3752494
  },
  {
    lng: -41.2371582,
    lat: -21.3752505
  },
  {
    lng: -41.2371568,
    lat: -21.3752516
  },
  {
    lng: -41.2371554,
    lat: -21.3752526
  },
  {
    lng: -41.237154,
    lat: -21.3752537
  },
  {
    lng: -41.2371526,
    lat: -21.3752548
  },
  {
    lng: -41.2371513,
    lat: -21.3752559
  },
  {
    lng: -41.2371499,
    lat: -21.375257
  },
  {
    lng: -41.2371485,
    lat: -21.3752581
  },
  {
    lng: -41.2371471,
    lat: -21.3752593
  },
  {
    lng: -41.2371458,
    lat: -21.3752604
  },
  {
    lng: -41.2371444,
    lat: -21.3752615
  },
  {
    lng: -41.2371431,
    lat: -21.3752626
  },
  {
    lng: -41.2371417,
    lat: -21.3752638
  },
  {
    lng: -41.2371403,
    lat: -21.3752649
  },
  {
    lng: -41.237139,
    lat: -21.3752661
  },
  {
    lng: -41.2371377,
    lat: -21.3752672
  },
  {
    lng: -41.2371363,
    lat: -21.3752684
  },
  {
    lng: -41.237135,
    lat: -21.3752695
  },
  {
    lng: -41.2371337,
    lat: -21.3752707
  },
  {
    lng: -41.2371323,
    lat: -21.3752719
  },
  {
    lng: -41.237131,
    lat: -21.375273
  },
  {
    lng: -41.2371297,
    lat: -21.3752742
  },
  {
    lng: -41.2371284,
    lat: -21.3752754
  },
  {
    lng: -41.2371271,
    lat: -21.3752766
  },
  {
    lng: -41.2371258,
    lat: -21.3752778
  },
  {
    lng: -41.2371245,
    lat: -21.375279
  },
  {
    lng: -41.2371232,
    lat: -21.3752802
  },
  {
    lng: -41.2371219,
    lat: -21.3752814
  },
  {
    lng: -41.2371206,
    lat: -21.3752826
  },
  {
    lng: -41.2371194,
    lat: -21.3752839
  },
  {
    lng: -41.2371181,
    lat: -21.3752851
  },
  {
    lng: -41.2371168,
    lat: -21.3752863
  },
  {
    lng: -41.2371156,
    lat: -21.3752876
  },
  {
    lng: -41.2371143,
    lat: -21.3752888
  },
  {
    lng: -41.2371131,
    lat: -21.37529
  },
  {
    lng: -41.2371118,
    lat: -21.3752913
  },
  {
    lng: -41.2371106,
    lat: -21.3752926
  },
  {
    lng: -41.2371093,
    lat: -21.3752938
  },
  {
    lng: -41.2371081,
    lat: -21.3752951
  },
  {
    lng: -41.2371069,
    lat: -21.3752964
  },
  {
    lng: -41.2371056,
    lat: -21.3752976
  },
  {
    lng: -41.2371044,
    lat: -21.3752989
  },
  {
    lng: -41.2371032,
    lat: -21.3753002
  },
  {
    lng: -41.237102,
    lat: -21.3753015
  },
  {
    lng: -41.2371008,
    lat: -21.3753028
  },
  {
    lng: -41.2370996,
    lat: -21.3753041
  },
  {
    lng: -41.2370984,
    lat: -21.3753054
  },
  {
    lng: -41.2370972,
    lat: -21.3753067
  },
  {
    lng: -41.237096,
    lat: -21.375308
  },
  {
    lng: -41.2370949,
    lat: -21.3753093
  },
  {
    lng: -41.2370937,
    lat: -21.3753106
  },
  {
    lng: -41.2370925,
    lat: -21.375312
  },
  {
    lng: -41.2370913,
    lat: -21.3753133
  },
  {
    lng: -41.2370902,
    lat: -21.3753146
  },
  {
    lng: -41.237089,
    lat: -21.375316
  },
  {
    lng: -41.2370879,
    lat: -21.3753173
  },
  {
    lng: -41.2370867,
    lat: -21.3753186
  },
  {
    lng: -41.2370856,
    lat: -21.37532
  },
  {
    lng: -41.2370845,
    lat: -21.3753214
  },
  {
    lng: -41.2370833,
    lat: -21.3753227
  },
  {
    lng: -41.2370822,
    lat: -21.3753241
  },
  {
    lng: -41.2370811,
    lat: -21.3753254
  },
  {
    lng: -41.23708,
    lat: -21.3753268
  },
  {
    lng: -41.2370789,
    lat: -21.3753282
  },
  {
    lng: -41.2370778,
    lat: -21.3753296
  },
  {
    lng: -41.2370767,
    lat: -21.375331
  },
  {
    lng: -41.2370756,
    lat: -21.3753324
  },
  {
    lng: -41.2370745,
    lat: -21.3753338
  },
  {
    lng: -41.2370734,
    lat: -21.3753352
  },
  {
    lng: -41.2370724,
    lat: -21.3753366
  },
  {
    lng: -41.2370713,
    lat: -21.375338
  },
  {
    lng: -41.2370702,
    lat: -21.3753394
  },
  {
    lng: -41.2370692,
    lat: -21.3753408
  },
  {
    lng: -41.2370681,
    lat: -21.3753422
  },
  {
    lng: -41.2370671,
    lat: -21.3753436
  },
  {
    lng: -41.237066,
    lat: -21.3753451
  },
  {
    lng: -41.237065,
    lat: -21.3753465
  },
  {
    lng: -41.237064,
    lat: -21.3753479
  },
  {
    lng: -41.2370629,
    lat: -21.3753494
  },
  {
    lng: -41.2370619,
    lat: -21.3753508
  },
  {
    lng: -41.2370609,
    lat: -21.3753523
  },
  {
    lng: -41.2370599,
    lat: -21.3753537
  },
  {
    lng: -41.2370589,
    lat: -21.3753552
  },
  {
    lng: -41.2370579,
    lat: -21.3753566
  },
  {
    lng: -41.2370569,
    lat: -21.3753581
  },
  {
    lng: -41.2370559,
    lat: -21.3753595
  },
  {
    lng: -41.2370549,
    lat: -21.375361
  },
  {
    lng: -41.2370539,
    lat: -21.3753625
  },
  {
    lng: -41.237053,
    lat: -21.375364
  },
  {
    lng: -41.237052,
    lat: -21.3753654
  },
  {
    lng: -41.2370511,
    lat: -21.3753669
  },
  {
    lng: -41.2370501,
    lat: -21.3753684
  },
  {
    lng: -41.2370492,
    lat: -21.3753699
  },
  {
    lng: -41.2370482,
    lat: -21.3753714
  },
  {
    lng: -41.2370473,
    lat: -21.3753729
  },
  {
    lng: -41.2370463,
    lat: -21.3753744
  },
  {
    lng: -41.2370454,
    lat: -21.3753759
  },
  {
    lng: -41.2370445,
    lat: -21.3753774
  },
  {
    lng: -41.2370436,
    lat: -21.3753789
  },
  {
    lng: -41.2370427,
    lat: -21.3753805
  },
  {
    lng: -41.2370418,
    lat: -21.375382
  },
  {
    lng: -41.2370409,
    lat: -21.3753835
  },
  {
    lng: -41.23704,
    lat: -21.375385
  },
  {
    lng: -41.2370391,
    lat: -21.3753866
  },
  {
    lng: -41.2370382,
    lat: -21.3753881
  },
  {
    lng: -41.2370374,
    lat: -21.3753896
  },
  {
    lng: -41.2370365,
    lat: -21.3753912
  },
  {
    lng: -41.2370356,
    lat: -21.3753927
  },
  {
    lng: -41.2370348,
    lat: -21.3753943
  },
  {
    lng: -41.2370339,
    lat: -21.3753958
  },
  {
    lng: -41.2370331,
    lat: -21.3753974
  },
  {
    lng: -41.2370323,
    lat: -21.3753989
  },
  {
    lng: -41.2370314,
    lat: -21.3754005
  },
  {
    lng: -41.2370306,
    lat: -21.375402
  },
  {
    lng: -41.2370298,
    lat: -21.3754036
  },
  {
    lng: -41.237029,
    lat: -21.3754052
  },
  {
    lng: -41.2370282,
    lat: -21.3754068
  },
  {
    lng: -41.2370274,
    lat: -21.3754083
  },
  {
    lng: -41.2370266,
    lat: -21.3754099
  },
  {
    lng: -41.2370258,
    lat: -21.3754115
  },
  {
    lng: -41.237025,
    lat: -21.3754131
  },
  {
    lng: -41.2370242,
    lat: -21.3754147
  },
  {
    lng: -41.2370235,
    lat: -21.3754163
  },
  {
    lng: -41.2370227,
    lat: -21.3754178
  },
  {
    lng: -41.237022,
    lat: -21.3754194
  },
  {
    lng: -41.2370212,
    lat: -21.375421
  },
  {
    lng: -41.2370205,
    lat: -21.3754226
  },
  {
    lng: -41.2370197,
    lat: -21.3754243
  },
  {
    lng: -41.237019,
    lat: -21.3754259
  },
  {
    lng: -41.2370183,
    lat: -21.3754275
  },
  {
    lng: -41.2370175,
    lat: -21.3754291
  },
  {
    lng: -41.2370168,
    lat: -21.3754307
  },
  {
    lng: -41.2370161,
    lat: -21.3754323
  },
  {
    lng: -41.2370154,
    lat: -21.3754339
  },
  {
    lng: -41.2370147,
    lat: -21.3754356
  },
  {
    lng: -41.237014,
    lat: -21.3754372
  },
  {
    lng: -41.2370134,
    lat: -21.3754388
  },
  {
    lng: -41.2370127,
    lat: -21.3754405
  },
  {
    lng: -41.237012,
    lat: -21.3754421
  },
  {
    lng: -41.2370113,
    lat: -21.3754437
  },
  {
    lng: -41.2370107,
    lat: -21.3754454
  },
  {
    lng: -41.23701,
    lat: -21.375447
  },
  {
    lng: -41.2370094,
    lat: -21.3754487
  },
  {
    lng: -41.2370088,
    lat: -21.3754503
  },
  {
    lng: -41.2370081,
    lat: -21.375452
  },
  {
    lng: -41.2370075,
    lat: -21.3754536
  },
  {
    lng: -41.2370069,
    lat: -21.3754553
  },
  {
    lng: -41.2370063,
    lat: -21.3754569
  },
  {
    lng: -41.2370057,
    lat: -21.3754586
  },
  {
    lng: -41.2370051,
    lat: -21.3754602
  },
  {
    lng: -41.2370045,
    lat: -21.3754619
  },
  {
    lng: -41.2370039,
    lat: -21.3754636
  },
  {
    lng: -41.2370033,
    lat: -21.3754652
  },
  {
    lng: -41.2370027,
    lat: -21.3754669
  },
  {
    lng: -41.2370021,
    lat: -21.3754686
  },
  {
    lng: -41.2370016,
    lat: -21.3754703
  },
  {
    lng: -41.237001,
    lat: -21.3754719
  },
  {
    lng: -41.2370005,
    lat: -21.3754736
  },
  {
    lng: -41.2369999,
    lat: -21.3754753
  },
  {
    lng: -41.2369994,
    lat: -21.375477
  },
  {
    lng: -41.2369989,
    lat: -21.3754787
  },
  {
    lng: -41.2369984,
    lat: -21.3754804
  },
  {
    lng: -41.2369978,
    lat: -21.3754821
  },
  {
    lng: -41.2369973,
    lat: -21.3754837
  },
  {
    lng: -41.2369968,
    lat: -21.3754854
  },
  {
    lng: -41.2369963,
    lat: -21.3754871
  },
  {
    lng: -41.2369958,
    lat: -21.3754888
  },
  {
    lng: -41.2369953,
    lat: -21.3754905
  },
  {
    lng: -41.2369949,
    lat: -21.3754922
  },
  {
    lng: -41.2369944,
    lat: -21.3754939
  },
  {
    lng: -41.2369939,
    lat: -21.3754956
  },
  {
    lng: -41.2369935,
    lat: -21.3754973
  },
  {
    lng: -41.236993,
    lat: -21.3754991
  },
  {
    lng: -41.2369926,
    lat: -21.3755008
  },
  {
    lng: -41.2369921,
    lat: -21.3755025
  },
  {
    lng: -41.2369917,
    lat: -21.3755042
  },
  {
    lng: -41.2369913,
    lat: -21.3755059
  },
  {
    lng: -41.2369909,
    lat: -21.3755076
  },
  {
    lng: -41.2369905,
    lat: -21.3755093
  },
  {
    lng: -41.23699,
    lat: -21.3755111
  },
  {
    lng: -41.2369896,
    lat: -21.3755128
  },
  {
    lng: -41.2369893,
    lat: -21.3755145
  },
  {
    lng: -41.2369889,
    lat: -21.3755162
  },
  {
    lng: -41.2369885,
    lat: -21.375518
  },
  {
    lng: -41.2369881,
    lat: -21.3755197
  },
  {
    lng: -41.2369878,
    lat: -21.3755214
  },
  {
    lng: -41.2369874,
    lat: -21.3755231
  },
  {
    lng: -41.236987,
    lat: -21.3755249
  },
  {
    lng: -41.2369867,
    lat: -21.3755266
  },
  {
    lng: -41.2369864,
    lat: -21.3755283
  },
  {
    lng: -41.236986,
    lat: -21.3755301
  },
  {
    lng: -41.2369857,
    lat: -21.3755318
  },
  {
    lng: -41.2369854,
    lat: -21.3755336
  },
  {
    lng: -41.2369851,
    lat: -21.3755353
  },
  {
    lng: -41.2369848,
    lat: -21.375537
  },
  {
    lng: -41.2369845,
    lat: -21.3755388
  },
  {
    lng: -41.2369842,
    lat: -21.3755405
  },
  {
    lng: -41.2369839,
    lat: -21.3755423
  },
  {
    lng: -41.2369836,
    lat: -21.375544
  },
  {
    lng: -41.2369833,
    lat: -21.3755457
  },
  {
    lng: -41.2369831,
    lat: -21.3755475
  },
  {
    lng: -41.2369828,
    lat: -21.3755492
  },
  {
    lng: -41.2369826,
    lat: -21.375551
  },
  {
    lng: -41.2369823,
    lat: -21.3755527
  },
  {
    lng: -41.2369821,
    lat: -21.3755545
  },
  {
    lng: -41.2369818,
    lat: -21.3755562
  },
  {
    lng: -41.2369816,
    lat: -21.375558
  },
  {
    lng: -41.2369814,
    lat: -21.3755598
  },
  {
    lng: -41.2369812,
    lat: -21.3755615
  },
  {
    lng: -41.236981,
    lat: -21.3755633
  },
  {
    lng: -41.2369808,
    lat: -21.375565
  },
  {
    lng: -41.2369806,
    lat: -21.3755668
  },
  {
    lng: -41.2369804,
    lat: -21.3755685
  },
  {
    lng: -41.2369802,
    lat: -21.3755703
  },
  {
    lng: -41.2369801,
    lat: -21.375572
  },
  {
    lng: -41.2369799,
    lat: -21.3755738
  },
  {
    lng: -41.2369797,
    lat: -21.3755756
  },
  {
    lng: -41.2369796,
    lat: -21.3755773
  },
  {
    lng: -41.2369794,
    lat: -21.3755791
  },
  {
    lng: -41.2369793,
    lat: -21.3755809
  },
  {
    lng: -41.2369792,
    lat: -21.3755826
  },
  {
    lng: -41.236979,
    lat: -21.3755844
  },
  {
    lng: -41.2369789,
    lat: -21.3755861
  },
  {
    lng: -41.2369788,
    lat: -21.3755879
  },
  {
    lng: -41.2369787,
    lat: -21.3755897
  },
  {
    lng: -41.2369786,
    lat: -21.3755914
  },
  {
    lng: -41.2369785,
    lat: -21.3755932
  },
  {
    lng: -41.2369784,
    lat: -21.375595
  },
  {
    lng: -41.2369784,
    lat: -21.3755967
  },
  {
    lng: -41.2369783,
    lat: -21.3755985
  },
  {
    lng: -41.2369782,
    lat: -21.3756003
  },
  {
    lng: -41.2369782,
    lat: -21.375602
  },
  {
    lng: -41.2369781,
    lat: -21.3756038
  },
  {
    lng: -41.2369781,
    lat: -21.3756056
  },
  {
    lng: -41.236978,
    lat: -21.3756073
  },
  {
    lng: -41.236978,
    lat: -21.3756091
  },
  {
    lng: -41.236978,
    lat: -21.3756109
  },
  {
    lng: -41.236978,
    lat: -21.3756126
  },
  {
    lng: -41.236978,
    lat: -21.3756144
  },
  {
    lng: -41.236978,
    lat: -21.3756162
  },
  {
    lng: -41.236978,
    lat: -21.3756179
  },
  {
    lng: -41.236978,
    lat: -21.3756197
  },
  {
    lng: -41.236978,
    lat: -21.3756215
  },
  {
    lng: -41.2370683,
    lat: -21.3759447
  },
  {
    lng: -41.2371967,
    lat: -21.3764106
  },
  {
    lng: -41.237325,
    lat: -21.3767813
  },
  {
    lng: -41.2374153,
    lat: -21.3769667
  },
  {
    lng: -41.2374162,
    lat: -21.3769683
  },
  {
    lng: -41.2374171,
    lat: -21.3769698
  },
  {
    lng: -41.237418,
    lat: -21.3769713
  },
  {
    lng: -41.2374188,
    lat: -21.3769729
  },
  {
    lng: -41.2374197,
    lat: -21.3769744
  },
  {
    lng: -41.2374206,
    lat: -21.3769759
  },
  {
    lng: -41.2374214,
    lat: -21.3769775
  },
  {
    lng: -41.2374223,
    lat: -21.376979
  },
  {
    lng: -41.2374231,
    lat: -21.3769806
  },
  {
    lng: -41.2374239,
    lat: -21.3769822
  },
  {
    lng: -41.2374248,
    lat: -21.3769837
  },
  {
    lng: -41.2374256,
    lat: -21.3769853
  },
  {
    lng: -41.2374264,
    lat: -21.3769869
  },
  {
    lng: -41.2374272,
    lat: -21.3769884
  },
  {
    lng: -41.237428,
    lat: -21.37699
  },
  {
    lng: -41.2374288,
    lat: -21.3769916
  },
  {
    lng: -41.2374296,
    lat: -21.3769932
  },
  {
    lng: -41.2374304,
    lat: -21.3769947
  },
  {
    lng: -41.2374312,
    lat: -21.3769963
  },
  {
    lng: -41.237432,
    lat: -21.3769979
  },
  {
    lng: -41.2374327,
    lat: -21.3769995
  },
  {
    lng: -41.2374335,
    lat: -21.3770011
  },
  {
    lng: -41.2374343,
    lat: -21.3770027
  },
  {
    lng: -41.237435,
    lat: -21.3770043
  },
  {
    lng: -41.2374357,
    lat: -21.3770059
  },
  {
    lng: -41.2374365,
    lat: -21.3770075
  },
  {
    lng: -41.2374372,
    lat: -21.3770091
  },
  {
    lng: -41.2374379,
    lat: -21.3770107
  },
  {
    lng: -41.2374387,
    lat: -21.3770123
  },
  {
    lng: -41.2374394,
    lat: -21.377014
  },
  {
    lng: -41.2374401,
    lat: -21.3770156
  },
  {
    lng: -41.2374408,
    lat: -21.3770172
  },
  {
    lng: -41.2374415,
    lat: -21.3770188
  },
  {
    lng: -41.2374422,
    lat: -21.3770205
  },
  {
    lng: -41.2374428,
    lat: -21.3770221
  },
  {
    lng: -41.2374435,
    lat: -21.3770237
  },
  {
    lng: -41.2374442,
    lat: -21.3770254
  },
  {
    lng: -41.2374449,
    lat: -21.377027
  },
  {
    lng: -41.2374455,
    lat: -21.3770286
  },
  {
    lng: -41.2374462,
    lat: -21.3770303
  },
  {
    lng: -41.2374468,
    lat: -21.3770319
  },
  {
    lng: -41.2374474,
    lat: -21.3770336
  },
  {
    lng: -41.2374481,
    lat: -21.3770352
  },
  {
    lng: -41.2374487,
    lat: -21.3770369
  },
  {
    lng: -41.2374493,
    lat: -21.3770385
  },
  {
    lng: -41.2374499,
    lat: -21.3770402
  },
  {
    lng: -41.2374505,
    lat: -21.3770418
  },
  {
    lng: -41.2374511,
    lat: -21.3770435
  },
  {
    lng: -41.2374517,
    lat: -21.3770452
  },
  {
    lng: -41.2374523,
    lat: -21.3770468
  },
  {
    lng: -41.2374529,
    lat: -21.3770485
  },
  {
    lng: -41.2374535,
    lat: -21.3770502
  },
  {
    lng: -41.237454,
    lat: -21.3770519
  },
  {
    lng: -41.2374546,
    lat: -21.3770535
  },
  {
    lng: -41.2374552,
    lat: -21.3770552
  },
  {
    lng: -41.2374557,
    lat: -21.3770569
  },
  {
    lng: -41.2374562,
    lat: -21.3770586
  },
  {
    lng: -41.2374568,
    lat: -21.3770603
  },
  {
    lng: -41.2374573,
    lat: -21.3770619
  },
  {
    lng: -41.2374578,
    lat: -21.3770636
  },
  {
    lng: -41.2374583,
    lat: -21.3770653
  },
  {
    lng: -41.2374589,
    lat: -21.377067
  },
  {
    lng: -41.2374594,
    lat: -21.3770687
  },
  {
    lng: -41.2374599,
    lat: -21.3770704
  },
  {
    lng: -41.2374603,
    lat: -21.3770721
  },
  {
    lng: -41.2374608,
    lat: -21.3770738
  },
  {
    lng: -41.2374613,
    lat: -21.3770755
  },
  {
    lng: -41.2374618,
    lat: -21.3770772
  },
  {
    lng: -41.2374622,
    lat: -21.3770789
  },
  {
    lng: -41.2374627,
    lat: -21.3770806
  },
  {
    lng: -41.2374631,
    lat: -21.3770823
  },
  {
    lng: -41.2374636,
    lat: -21.377084
  },
  {
    lng: -41.237464,
    lat: -21.3770858
  },
  {
    lng: -41.2374645,
    lat: -21.3770875
  },
  {
    lng: -41.2374649,
    lat: -21.3770892
  },
  {
    lng: -41.2374653,
    lat: -21.3770909
  },
  {
    lng: -41.2374657,
    lat: -21.3770926
  },
  {
    lng: -41.2374661,
    lat: -21.3770944
  },
  {
    lng: -41.2374665,
    lat: -21.3770961
  },
  {
    lng: -41.2374669,
    lat: -21.3770978
  },
  {
    lng: -41.2374673,
    lat: -21.3770995
  },
  {
    lng: -41.2374677,
    lat: -21.3771012
  },
  {
    lng: -41.237468,
    lat: -21.377103
  },
  {
    lng: -41.2374684,
    lat: -21.3771047
  },
  {
    lng: -41.2374687,
    lat: -21.3771064
  },
  {
    lng: -41.2374691,
    lat: -21.3771082
  },
  {
    lng: -41.2374694,
    lat: -21.3771099
  },
  {
    lng: -41.2374698,
    lat: -21.3771116
  },
  {
    lng: -41.2374701,
    lat: -21.3771134
  },
  {
    lng: -41.2374704,
    lat: -21.3771151
  },
  {
    lng: -41.2374708,
    lat: -21.3771169
  },
  {
    lng: -41.2374711,
    lat: -21.3771186
  },
  {
    lng: -41.2374714,
    lat: -21.3771203
  },
  {
    lng: -41.2374717,
    lat: -21.3771221
  },
  {
    lng: -41.237472,
    lat: -21.3771238
  },
  {
    lng: -41.2374722,
    lat: -21.3771256
  },
  {
    lng: -41.2374725,
    lat: -21.3771273
  },
  {
    lng: -41.2374728,
    lat: -21.3771291
  },
  {
    lng: -41.2374731,
    lat: -21.3771308
  },
  {
    lng: -41.2374733,
    lat: -21.3771326
  },
  {
    lng: -41.2374736,
    lat: -21.3771343
  },
  {
    lng: -41.2374738,
    lat: -21.3771361
  },
  {
    lng: -41.237474,
    lat: -21.3771378
  },
  {
    lng: -41.2374743,
    lat: -21.3771396
  },
  {
    lng: -41.2374745,
    lat: -21.3771413
  },
  {
    lng: -41.2374747,
    lat: -21.3771431
  },
  {
    lng: -41.2374749,
    lat: -21.3771448
  },
  {
    lng: -41.2374751,
    lat: -21.3771466
  },
  {
    lng: -41.2374753,
    lat: -21.3771483
  },
  {
    lng: -41.2374755,
    lat: -21.3771501
  },
  {
    lng: -41.2374757,
    lat: -21.3771518
  },
  {
    lng: -41.2374759,
    lat: -21.3771536
  },
  {
    lng: -41.237476,
    lat: -21.3771554
  },
  {
    lng: -41.2374762,
    lat: -21.3771571
  },
  {
    lng: -41.2374764,
    lat: -21.3771589
  },
  {
    lng: -41.2374765,
    lat: -21.3771606
  },
  {
    lng: -41.2374767,
    lat: -21.3771624
  },
  {
    lng: -41.2374768,
    lat: -21.3771642
  },
  {
    lng: -41.2374769,
    lat: -21.3771659
  },
  {
    lng: -41.237477,
    lat: -21.3771677
  },
  {
    lng: -41.2374772,
    lat: -21.3771695
  },
  {
    lng: -41.2374773,
    lat: -21.3771712
  },
  {
    lng: -41.2374774,
    lat: -21.377173
  },
  {
    lng: -41.2374775,
    lat: -21.3771748
  },
  {
    lng: -41.2374775,
    lat: -21.3771765
  },
  {
    lng: -41.2374776,
    lat: -21.3771783
  },
  {
    lng: -41.2374777,
    lat: -21.3771801
  },
  {
    lng: -41.2374778,
    lat: -21.3771818
  },
  {
    lng: -41.2374778,
    lat: -21.3771836
  },
  {
    lng: -41.2374779,
    lat: -21.3771854
  },
  {
    lng: -41.2374779,
    lat: -21.3771871
  },
  {
    lng: -41.237478,
    lat: -21.3771889
  },
  {
    lng: -41.237478,
    lat: -21.3771907
  },
  {
    lng: -41.237478,
    lat: -21.3771924
  },
  {
    lng: -41.2374781,
    lat: -21.3771942
  },
  {
    lng: -41.2374781,
    lat: -21.377196
  },
  {
    lng: -41.2374781,
    lat: -21.3771977
  },
  {
    lng: -41.2374781,
    lat: -21.3771995
  },
  {
    lng: -41.2374781,
    lat: -21.3772013
  },
  {
    lng: -41.2374781,
    lat: -21.377203
  },
  {
    lng: -41.237478,
    lat: -21.3772048
  },
  {
    lng: -41.237478,
    lat: -21.3772066
  },
  {
    lng: -41.237478,
    lat: -21.3772083
  },
  {
    lng: -41.2374779,
    lat: -21.3772101
  },
  {
    lng: -41.2374779,
    lat: -21.3772119
  },
  {
    lng: -41.2374778,
    lat: -21.3772136
  },
  {
    lng: -41.2374778,
    lat: -21.3772154
  },
  {
    lng: -41.2374777,
    lat: -21.3772172
  },
  {
    lng: -41.2374776,
    lat: -21.3772189
  },
  {
    lng: -41.2374775,
    lat: -21.3772207
  },
  {
    lng: -41.2374775,
    lat: -21.3772225
  },
  {
    lng: -41.2374774,
    lat: -21.3772242
  },
  {
    lng: -41.2374773,
    lat: -21.377226
  },
  {
    lng: -41.2374771,
    lat: -21.3772278
  },
  {
    lng: -41.237477,
    lat: -21.3772295
  },
  {
    lng: -41.2374769,
    lat: -21.3772313
  },
  {
    lng: -41.2374768,
    lat: -21.377233
  },
  {
    lng: -41.2374766,
    lat: -21.3772348
  },
  {
    lng: -41.2374765,
    lat: -21.3772366
  },
  {
    lng: -41.2374764,
    lat: -21.3772383
  },
  {
    lng: -41.2374762,
    lat: -21.3772401
  },
  {
    lng: -41.237476,
    lat: -21.3772418
  },
  {
    lng: -41.2374759,
    lat: -21.3772436
  },
  {
    lng: -41.2374757,
    lat: -21.3772454
  },
  {
    lng: -41.2374755,
    lat: -21.3772471
  },
  {
    lng: -41.2374753,
    lat: -21.3772489
  },
  {
    lng: -41.2374751,
    lat: -21.3772506
  },
  {
    lng: -41.2374749,
    lat: -21.3772524
  },
  {
    lng: -41.2374747,
    lat: -21.3772541
  },
  {
    lng: -41.2374745,
    lat: -21.3772559
  },
  {
    lng: -41.2374743,
    lat: -21.3772577
  },
  {
    lng: -41.237474,
    lat: -21.3772594
  },
  {
    lng: -41.2374738,
    lat: -21.3772612
  },
  {
    lng: -41.2374736,
    lat: -21.3772629
  },
  {
    lng: -41.2374733,
    lat: -21.3772647
  },
  {
    lng: -41.237473,
    lat: -21.3772664
  },
  {
    lng: -41.2374728,
    lat: -21.3772682
  },
  {
    lng: -41.2374725,
    lat: -21.3772699
  },
  {
    lng: -41.2374722,
    lat: -21.3772717
  },
  {
    lng: -41.2374719,
    lat: -21.3772734
  },
  {
    lng: -41.2374717,
    lat: -21.3772751
  },
  {
    lng: -41.2374714,
    lat: -21.3772769
  },
  {
    lng: -41.2374711,
    lat: -21.3772786
  },
  {
    lng: -41.2374707,
    lat: -21.3772804
  },
  {
    lng: -41.2374704,
    lat: -21.3772821
  },
  {
    lng: -41.2374701,
    lat: -21.3772838
  },
  {
    lng: -41.2374698,
    lat: -21.3772856
  },
  {
    lng: -41.2374694,
    lat: -21.3772873
  },
  {
    lng: -41.2374691,
    lat: -21.377289
  },
  {
    lng: -41.2374687,
    lat: -21.3772908
  },
  {
    lng: -41.2374684,
    lat: -21.3772925
  },
  {
    lng: -41.237468,
    lat: -21.3772942
  },
  {
    lng: -41.2374676,
    lat: -21.377296
  },
  {
    lng: -41.2374673,
    lat: -21.3772977
  },
  {
    lng: -41.2374669,
    lat: -21.3772994
  },
  {
    lng: -41.2374665,
    lat: -21.3773011
  },
  {
    lng: -41.2374661,
    lat: -21.3773029
  },
  {
    lng: -41.2374657,
    lat: -21.3773046
  },
  {
    lng: -41.2374653,
    lat: -21.3773063
  },
  {
    lng: -41.2374649,
    lat: -21.377308
  },
  {
    lng: -41.2374644,
    lat: -21.3773097
  },
  {
    lng: -41.237464,
    lat: -21.3773114
  },
  {
    lng: -41.2374636,
    lat: -21.3773132
  },
  {
    lng: -41.2374631,
    lat: -21.3773149
  },
  {
    lng: -41.2374627,
    lat: -21.3773166
  },
  {
    lng: -41.2374622,
    lat: -21.3773183
  },
  {
    lng: -41.2374617,
    lat: -21.37732
  },
  {
    lng: -41.2374613,
    lat: -21.3773217
  },
  {
    lng: -41.2374608,
    lat: -21.3773234
  },
  {
    lng: -41.2374603,
    lat: -21.3773251
  },
  {
    lng: -41.2374598,
    lat: -21.3773268
  },
  {
    lng: -41.2374593,
    lat: -21.3773285
  },
  {
    lng: -41.2374588,
    lat: -21.3773302
  },
  {
    lng: -41.2374583,
    lat: -21.3773319
  },
  {
    lng: -41.2374578,
    lat: -21.3773336
  },
  {
    lng: -41.2374573,
    lat: -21.3773353
  },
  {
    lng: -41.2374568,
    lat: -21.377337
  },
  {
    lng: -41.2374562,
    lat: -21.3773386
  },
  {
    lng: -41.2374557,
    lat: -21.3773403
  },
  {
    lng: -41.2374551,
    lat: -21.377342
  },
  {
    lng: -41.2374546,
    lat: -21.3773437
  },
  {
    lng: -41.237454,
    lat: -21.3773454
  },
  {
    lng: -41.2374534,
    lat: -21.377347
  },
  {
    lng: -41.2374529,
    lat: -21.3773487
  },
  {
    lng: -41.2374523,
    lat: -21.3773504
  },
  {
    lng: -41.2374517,
    lat: -21.377352
  },
  {
    lng: -41.2374511,
    lat: -21.3773537
  },
  {
    lng: -41.2374505,
    lat: -21.3773554
  },
  {
    lng: -41.2374499,
    lat: -21.377357
  },
  {
    lng: -41.2374493,
    lat: -21.3773587
  },
  {
    lng: -41.2374487,
    lat: -21.3773603
  },
  {
    lng: -41.237448,
    lat: -21.377362
  },
  {
    lng: -41.2374474,
    lat: -21.3773636
  },
  {
    lng: -41.2374468,
    lat: -21.3773653
  },
  {
    lng: -41.2374461,
    lat: -21.3773669
  },
  {
    lng: -41.2374455,
    lat: -21.3773686
  },
  {
    lng: -41.2374448,
    lat: -21.3773702
  },
  {
    lng: -41.2374442,
    lat: -21.3773719
  },
  {
    lng: -41.2374435,
    lat: -21.3773735
  },
  {
    lng: -41.2374428,
    lat: -21.3773751
  },
  {
    lng: -41.2374421,
    lat: -21.3773768
  },
  {
    lng: -41.2374414,
    lat: -21.3773784
  },
  {
    lng: -41.2374407,
    lat: -21.37738
  },
  {
    lng: -41.23744,
    lat: -21.3773816
  },
  {
    lng: -41.2374393,
    lat: -21.3773833
  },
  {
    lng: -41.2374386,
    lat: -21.3773849
  },
  {
    lng: -41.2374379,
    lat: -21.3773865
  },
  {
    lng: -41.2374372,
    lat: -21.3773881
  },
  {
    lng: -41.2374365,
    lat: -21.3773897
  },
  {
    lng: -41.2374357,
    lat: -21.3773913
  },
  {
    lng: -41.237435,
    lat: -21.3773929
  },
  {
    lng: -41.2374342,
    lat: -21.3773945
  },
  {
    lng: -41.2374335,
    lat: -21.3773961
  },
  {
    lng: -41.2374327,
    lat: -21.3773977
  },
  {
    lng: -41.2374319,
    lat: -21.3773993
  },
  {
    lng: -41.2374312,
    lat: -21.3774009
  },
  {
    lng: -41.2374304,
    lat: -21.3774025
  },
  {
    lng: -41.2374296,
    lat: -21.3774041
  },
  {
    lng: -41.2374282,
    lat: -21.3774074
  },
  {
    lng: -41.2374268,
    lat: -21.3774108
  },
  {
    lng: -41.2374254,
    lat: -21.3774141
  },
  {
    lng: -41.237424,
    lat: -21.3774175
  },
  {
    lng: -41.2374226,
    lat: -21.3774209
  },
  {
    lng: -41.2374212,
    lat: -21.3774242
  },
  {
    lng: -41.2374198,
    lat: -21.3774276
  },
  {
    lng: -41.2374185,
    lat: -21.377431
  },
  {
    lng: -41.2374171,
    lat: -21.3774344
  },
  {
    lng: -41.2374157,
    lat: -21.3774377
  },
  {
    lng: -41.2374144,
    lat: -21.3774411
  },
  {
    lng: -41.2374131,
    lat: -21.3774445
  },
  {
    lng: -41.2374117,
    lat: -21.3774479
  },
  {
    lng: -41.2374104,
    lat: -21.3774513
  },
  {
    lng: -41.2374091,
    lat: -21.3774547
  },
  {
    lng: -41.2374077,
    lat: -21.3774581
  },
  {
    lng: -41.2374064,
    lat: -21.3774615
  },
  {
    lng: -41.2374051,
    lat: -21.3774649
  },
  {
    lng: -41.2374038,
    lat: -21.3774683
  },
  {
    lng: -41.2374025,
    lat: -21.3774717
  },
  {
    lng: -41.2374013,
    lat: -21.3774751
  },
  {
    lng: -41.2374,
    lat: -21.3774785
  },
  {
    lng: -41.2373987,
    lat: -21.3774819
  },
  {
    lng: -41.2373974,
    lat: -21.3774853
  },
  {
    lng: -41.2373962,
    lat: -21.3774888
  },
  {
    lng: -41.2373949,
    lat: -21.3774922
  },
  {
    lng: -41.2373937,
    lat: -21.3774956
  },
  {
    lng: -41.2373924,
    lat: -21.377499
  },
  {
    lng: -41.2373912,
    lat: -21.3775025
  },
  {
    lng: -41.23739,
    lat: -21.3775059
  },
  {
    lng: -41.2373887,
    lat: -21.3775093
  },
  {
    lng: -41.2373875,
    lat: -21.3775127
  },
  {
    lng: -41.2373863,
    lat: -21.3775162
  },
  {
    lng: -41.2373851,
    lat: -21.3775196
  },
  {
    lng: -41.2373839,
    lat: -21.3775231
  },
  {
    lng: -41.2373827,
    lat: -21.3775265
  },
  {
    lng: -41.2373815,
    lat: -21.3775299
  },
  {
    lng: -41.2373804,
    lat: -21.3775334
  },
  {
    lng: -41.2373792,
    lat: -21.3775368
  },
  {
    lng: -41.237378,
    lat: -21.3775403
  },
  {
    lng: -41.2373769,
    lat: -21.3775437
  },
  {
    lng: -41.2373757,
    lat: -21.3775472
  },
  {
    lng: -41.2373746,
    lat: -21.3775507
  },
  {
    lng: -41.2373734,
    lat: -21.3775541
  },
  {
    lng: -41.2373723,
    lat: -21.3775576
  },
  {
    lng: -41.2373712,
    lat: -21.377561
  },
  {
    lng: -41.2373701,
    lat: -21.3775645
  },
  {
    lng: -41.2373689,
    lat: -21.377568
  },
  {
    lng: -41.2373678,
    lat: -21.3775715
  },
  {
    lng: -41.2373667,
    lat: -21.3775749
  },
  {
    lng: -41.2373656,
    lat: -21.3775784
  },
  {
    lng: -41.2373646,
    lat: -21.3775819
  },
  {
    lng: -41.2373635,
    lat: -21.3775854
  },
  {
    lng: -41.2373624,
    lat: -21.3775888
  },
  {
    lng: -41.2373613,
    lat: -21.3775923
  },
  {
    lng: -41.2373603,
    lat: -21.3775958
  },
  {
    lng: -41.2373592,
    lat: -21.3775993
  },
  {
    lng: -41.2373582,
    lat: -21.3776028
  },
  {
    lng: -41.2373571,
    lat: -21.3776063
  },
  {
    lng: -41.2373561,
    lat: -21.3776098
  },
  {
    lng: -41.2373551,
    lat: -21.3776133
  },
  {
    lng: -41.237354,
    lat: -21.3776167
  },
  {
    lng: -41.237353,
    lat: -21.3776202
  },
  {
    lng: -41.237352,
    lat: -21.3776237
  },
  {
    lng: -41.237351,
    lat: -21.3776272
  },
  {
    lng: -41.23735,
    lat: -21.3776308
  },
  {
    lng: -41.237349,
    lat: -21.3776343
  },
  {
    lng: -41.237348,
    lat: -21.3776378
  },
  {
    lng: -41.2373471,
    lat: -21.3776413
  },
  {
    lng: -41.2373461,
    lat: -21.3776448
  },
  {
    lng: -41.2373451,
    lat: -21.3776483
  },
  {
    lng: -41.2373442,
    lat: -21.3776518
  },
  {
    lng: -41.2373432,
    lat: -21.3776553
  },
  {
    lng: -41.2373423,
    lat: -21.3776588
  },
  {
    lng: -41.2373413,
    lat: -21.3776624
  },
  {
    lng: -41.2373404,
    lat: -21.3776659
  },
  {
    lng: -41.2373395,
    lat: -21.3776694
  },
  {
    lng: -41.2373386,
    lat: -21.3776729
  },
  {
    lng: -41.2373377,
    lat: -21.3776765
  },
  {
    lng: -41.2373368,
    lat: -21.37768
  },
  {
    lng: -41.2373359,
    lat: -21.3776835
  },
  {
    lng: -41.237335,
    lat: -21.3776871
  },
  {
    lng: -41.2373341,
    lat: -21.3776906
  },
  {
    lng: -41.2373332,
    lat: -21.3776941
  },
  {
    lng: -41.2373323,
    lat: -21.3776977
  },
  {
    lng: -41.2373315,
    lat: -21.3777012
  },
  {
    lng: -41.2373306,
    lat: -21.3777047
  },
  {
    lng: -41.2373298,
    lat: -21.3777083
  },
  {
    lng: -41.2373289,
    lat: -21.3777118
  },
  {
    lng: -41.2373281,
    lat: -21.3777154
  },
  {
    lng: -41.2373272,
    lat: -21.3777189
  },
  {
    lng: -41.2373264,
    lat: -21.3777225
  },
  {
    lng: -41.2373256,
    lat: -21.377726
  },
  {
    lng: -41.2373248,
    lat: -21.3777296
  },
  {
    lng: -41.237324,
    lat: -21.3777331
  },
  {
    lng: -41.2373232,
    lat: -21.3777367
  },
  {
    lng: -41.2373224,
    lat: -21.3777402
  },
  {
    lng: -41.2373216,
    lat: -21.3777438
  },
  {
    lng: -41.2373208,
    lat: -21.3777473
  },
  {
    lng: -41.23732,
    lat: -21.3777509
  },
  {
    lng: -41.2373193,
    lat: -21.3777545
  },
  {
    lng: -41.2373185,
    lat: -21.377758
  },
  {
    lng: -41.2373178,
    lat: -21.3777616
  },
  {
    lng: -41.237317,
    lat: -21.3777651
  },
  {
    lng: -41.2373163,
    lat: -21.3777687
  },
  {
    lng: -41.2373156,
    lat: -21.3777723
  },
  {
    lng: -41.2373148,
    lat: -21.3777759
  },
  {
    lng: -41.2373141,
    lat: -21.3777794
  },
  {
    lng: -41.2373134,
    lat: -21.377783
  },
  {
    lng: -41.2373127,
    lat: -21.3777866
  },
  {
    lng: -41.237312,
    lat: -21.3777901
  },
  {
    lng: -41.2373113,
    lat: -21.3777937
  },
  {
    lng: -41.2373106,
    lat: -21.3777973
  },
  {
    lng: -41.2373099,
    lat: -21.3778009
  },
  {
    lng: -41.2373093,
    lat: -21.3778045
  },
  {
    lng: -41.2373086,
    lat: -21.377808
  },
  {
    lng: -41.2373079,
    lat: -21.3778116
  },
  {
    lng: -41.2373073,
    lat: -21.3778152
  },
  {
    lng: -41.2373066,
    lat: -21.3778188
  },
  {
    lng: -41.237306,
    lat: -21.3778224
  },
  {
    lng: -41.2372917,
    lat: -21.3782122
  },
  {
    lng: -41.2372775,
    lat: -21.3785307
  },
  {
    lng: -41.2372777,
    lat: -21.3785325
  },
  {
    lng: -41.2372779,
    lat: -21.3785344
  },
  {
    lng: -41.2372781,
    lat: -21.3785362
  },
  {
    lng: -41.2372783,
    lat: -21.3785381
  },
  {
    lng: -41.2372785,
    lat: -21.3785399
  },
  {
    lng: -41.2372788,
    lat: -21.3785418
  },
  {
    lng: -41.237279,
    lat: -21.3785436
  },
  {
    lng: -41.2372792,
    lat: -21.3785455
  },
  {
    lng: -41.2372795,
    lat: -21.3785473
  },
  {
    lng: -41.2372797,
    lat: -21.3785492
  },
  {
    lng: -41.23728,
    lat: -21.378551
  },
  {
    lng: -41.2372803,
    lat: -21.3785529
  },
  {
    lng: -41.2372806,
    lat: -21.3785547
  },
  {
    lng: -41.2372808,
    lat: -21.3785566
  },
  {
    lng: -41.2372811,
    lat: -21.3785584
  },
  {
    lng: -41.2372814,
    lat: -21.3785602
  },
  {
    lng: -41.2372817,
    lat: -21.3785621
  },
  {
    lng: -41.237282,
    lat: -21.3785639
  },
  {
    lng: -41.2372824,
    lat: -21.3785657
  },
  {
    lng: -41.2372827,
    lat: -21.3785676
  },
  {
    lng: -41.237283,
    lat: -21.3785694
  },
  {
    lng: -41.2372833,
    lat: -21.3785713
  },
  {
    lng: -41.2372837,
    lat: -21.3785731
  },
  {
    lng: -41.237284,
    lat: -21.3785749
  },
  {
    lng: -41.2372844,
    lat: -21.3785768
  },
  {
    lng: -41.2372848,
    lat: -21.3785786
  },
  {
    lng: -41.2372851,
    lat: -21.3785804
  },
  {
    lng: -41.2372855,
    lat: -21.3785822
  },
  {
    lng: -41.2372859,
    lat: -21.3785841
  },
  {
    lng: -41.2372863,
    lat: -21.3785859
  },
  {
    lng: -41.2372867,
    lat: -21.3785877
  },
  {
    lng: -41.2372871,
    lat: -21.3785895
  },
  {
    lng: -41.2372875,
    lat: -21.3785914
  },
  {
    lng: -41.2372879,
    lat: -21.3785932
  },
  {
    lng: -41.2372883,
    lat: -21.378595
  },
  {
    lng: -41.2372888,
    lat: -21.3785968
  },
  {
    lng: -41.2372892,
    lat: -21.3785986
  },
  {
    lng: -41.2372896,
    lat: -21.3786004
  },
  {
    lng: -41.2372901,
    lat: -21.3786022
  },
  {
    lng: -41.2372906,
    lat: -21.378604
  },
  {
    lng: -41.237291,
    lat: -21.3786059
  },
  {
    lng: -41.2372915,
    lat: -21.3786077
  },
  {
    lng: -41.237292,
    lat: -21.3786095
  },
  {
    lng: -41.2372924,
    lat: -21.3786113
  },
  {
    lng: -41.2372929,
    lat: -21.3786131
  },
  {
    lng: -41.2372934,
    lat: -21.3786149
  },
  {
    lng: -41.2372939,
    lat: -21.3786167
  },
  {
    lng: -41.2372944,
    lat: -21.3786184
  },
  {
    lng: -41.237295,
    lat: -21.3786202
  },
  {
    lng: -41.2372955,
    lat: -21.378622
  },
  {
    lng: -41.237296,
    lat: -21.3786238
  },
  {
    lng: -41.2372965,
    lat: -21.3786256
  },
  {
    lng: -41.2372971,
    lat: -21.3786274
  },
  {
    lng: -41.2372976,
    lat: -21.3786292
  },
  {
    lng: -41.2372982,
    lat: -21.378631
  },
  {
    lng: -41.2372987,
    lat: -21.3786327
  },
  {
    lng: -41.2372993,
    lat: -21.3786345
  },
  {
    lng: -41.2372999,
    lat: -21.3786363
  },
  {
    lng: -41.2373005,
    lat: -21.3786381
  },
  {
    lng: -41.2373011,
    lat: -21.3786398
  },
  {
    lng: -41.2373016,
    lat: -21.3786416
  },
  {
    lng: -41.2373022,
    lat: -21.3786434
  },
  {
    lng: -41.2373029,
    lat: -21.3786451
  },
  {
    lng: -41.2373035,
    lat: -21.3786469
  },
  {
    lng: -41.2373041,
    lat: -21.3786487
  },
  {
    lng: -41.2373047,
    lat: -21.3786504
  },
  {
    lng: -41.2373053,
    lat: -21.3786522
  },
  {
    lng: -41.237306,
    lat: -21.3786539
  },
  {
    lng: -41.2373066,
    lat: -21.3786557
  },
  {
    lng: -41.2373073,
    lat: -21.3786574
  },
  {
    lng: -41.2373079,
    lat: -21.3786592
  },
  {
    lng: -41.2373086,
    lat: -21.3786609
  },
  {
    lng: -41.2373093,
    lat: -21.3786626
  },
  {
    lng: -41.2373099,
    lat: -21.3786644
  },
  {
    lng: -41.2373106,
    lat: -21.3786661
  },
  {
    lng: -41.2373113,
    lat: -21.3786679
  },
  {
    lng: -41.237312,
    lat: -21.3786696
  },
  {
    lng: -41.2373127,
    lat: -21.3786713
  },
  {
    lng: -41.2373134,
    lat: -21.378673
  },
  {
    lng: -41.2373141,
    lat: -21.3786748
  },
  {
    lng: -41.2373149,
    lat: -21.3786765
  },
  {
    lng: -41.2373156,
    lat: -21.3786782
  },
  {
    lng: -41.2373163,
    lat: -21.3786799
  },
  {
    lng: -41.2373171,
    lat: -21.3786816
  },
  {
    lng: -41.2373178,
    lat: -21.3786833
  },
  {
    lng: -41.2373185,
    lat: -21.378685
  },
  {
    lng: -41.2373193,
    lat: -21.3786868
  },
  {
    lng: -41.2373201,
    lat: -21.3786885
  },
  {
    lng: -41.2373208,
    lat: -21.3786902
  },
  {
    lng: -41.2373216,
    lat: -21.3786918
  },
  {
    lng: -41.2373224,
    lat: -21.3786935
  },
  {
    lng: -41.2373232,
    lat: -21.3786952
  },
  {
    lng: -41.237324,
    lat: -21.3786969
  },
  {
    lng: -41.2373248,
    lat: -21.3786986
  },
  {
    lng: -41.2373256,
    lat: -21.3787003
  },
  {
    lng: -41.2373264,
    lat: -21.378702
  },
  {
    lng: -41.2373272,
    lat: -21.3787036
  },
  {
    lng: -41.237328,
    lat: -21.3787053
  },
  {
    lng: -41.2373289,
    lat: -21.378707
  },
  {
    lng: -41.2373297,
    lat: -21.3787086
  },
  {
    lng: -41.2373306,
    lat: -21.3787103
  },
  {
    lng: -41.2373314,
    lat: -21.378712
  },
  {
    lng: -41.2373323,
    lat: -21.3787136
  },
  {
    lng: -41.2373331,
    lat: -21.3787153
  },
  {
    lng: -41.237334,
    lat: -21.3787169
  },
  {
    lng: -41.2373349,
    lat: -21.3787186
  },
  {
    lng: -41.2373357,
    lat: -21.3787202
  },
  {
    lng: -41.2373366,
    lat: -21.3787219
  },
  {
    lng: -41.2373375,
    lat: -21.3787235
  },
  {
    lng: -41.2373384,
    lat: -21.3787251
  },
  {
    lng: -41.2373393,
    lat: -21.3787268
  },
  {
    lng: -41.2373402,
    lat: -21.3787284
  },
  {
    lng: -41.2373411,
    lat: -21.37873
  },
  {
    lng: -41.2373421,
    lat: -21.3787317
  },
  {
    lng: -41.237343,
    lat: -21.3787333
  },
  {
    lng: -41.2373439,
    lat: -21.3787349
  },
  {
    lng: -41.2373449,
    lat: -21.3787365
  },
  {
    lng: -41.2373458,
    lat: -21.3787381
  },
  {
    lng: -41.2373468,
    lat: -21.3787397
  },
  {
    lng: -41.2373477,
    lat: -21.3787413
  },
  {
    lng: -41.2373487,
    lat: -21.3787429
  },
  {
    lng: -41.2373496,
    lat: -21.3787445
  },
  {
    lng: -41.2373506,
    lat: -21.3787461
  },
  {
    lng: -41.2373516,
    lat: -21.3787477
  },
  {
    lng: -41.2373526,
    lat: -21.3787493
  },
  {
    lng: -41.2373536,
    lat: -21.3787509
  },
  {
    lng: -41.2373546,
    lat: -21.3787524
  },
  {
    lng: -41.2373556,
    lat: -21.378754
  },
  {
    lng: -41.2373566,
    lat: -21.3787556
  },
  {
    lng: -41.2373576,
    lat: -21.3787571
  },
  {
    lng: -41.2373586,
    lat: -21.3787587
  },
  {
    lng: -41.2373596,
    lat: -21.3787603
  },
  {
    lng: -41.2373607,
    lat: -21.3787618
  },
  {
    lng: -41.2373617,
    lat: -21.3787634
  },
  {
    lng: -41.2373627,
    lat: -21.3787649
  },
  {
    lng: -41.2373638,
    lat: -21.3787665
  },
  {
    lng: -41.2373648,
    lat: -21.378768
  },
  {
    lng: -41.2373659,
    lat: -21.3787695
  },
  {
    lng: -41.237367,
    lat: -21.3787711
  },
  {
    lng: -41.237368,
    lat: -21.3787726
  },
  {
    lng: -41.2373691,
    lat: -21.3787741
  },
  {
    lng: -41.2373702,
    lat: -21.3787756
  },
  {
    lng: -41.2373713,
    lat: -21.3787771
  },
  {
    lng: -41.2373724,
    lat: -21.3787787
  },
  {
    lng: -41.2373735,
    lat: -21.3787802
  },
  {
    lng: -41.2373746,
    lat: -21.3787817
  },
  {
    lng: -41.2373757,
    lat: -21.3787832
  },
  {
    lng: -41.2373768,
    lat: -21.3787847
  },
  {
    lng: -41.2373779,
    lat: -21.3787862
  },
  {
    lng: -41.237379,
    lat: -21.3787876
  },
  {
    lng: -41.2373802,
    lat: -21.3787891
  },
  {
    lng: -41.2373813,
    lat: -21.3787906
  },
  {
    lng: -41.2373824,
    lat: -21.3787921
  },
  {
    lng: -41.2373836,
    lat: -21.3787936
  },
  {
    lng: -41.2373847,
    lat: -21.378795
  },
  {
    lng: -41.2373859,
    lat: -21.3787965
  },
  {
    lng: -41.2373871,
    lat: -21.3787979
  },
  {
    lng: -41.2373882,
    lat: -21.3787994
  },
  {
    lng: -41.2373894,
    lat: -21.3788009
  },
  {
    lng: -41.2373906,
    lat: -21.3788023
  },
  {
    lng: -41.2373918,
    lat: -21.3788037
  },
  {
    lng: -41.237393,
    lat: -21.3788052
  },
  {
    lng: -41.2373941,
    lat: -21.3788066
  },
  {
    lng: -41.2373953,
    lat: -21.378808
  },
  {
    lng: -41.2373966,
    lat: -21.3788095
  },
  {
    lng: -41.2373978,
    lat: -21.3788109
  },
  {
    lng: -41.237399,
    lat: -21.3788123
  },
  {
    lng: -41.2374002,
    lat: -21.3788137
  },
  {
    lng: -41.2374014,
    lat: -21.3788151
  },
  {
    lng: -41.2374027,
    lat: -21.3788165
  },
  {
    lng: -41.2374039,
    lat: -21.3788179
  },
  {
    lng: -41.2374051,
    lat: -21.3788193
  },
  {
    lng: -41.2374064,
    lat: -21.3788207
  },
  {
    lng: -41.2374076,
    lat: -21.3788221
  },
  {
    lng: -41.2374089,
    lat: -21.3788235
  },
  {
    lng: -41.2374101,
    lat: -21.3788248
  },
  {
    lng: -41.2374114,
    lat: -21.3788262
  },
  {
    lng: -41.2374127,
    lat: -21.3788276
  },
  {
    lng: -41.2374139,
    lat: -21.3788289
  },
  {
    lng: -41.2374152,
    lat: -21.3788303
  },
  {
    lng: -41.2374165,
    lat: -21.3788316
  },
  {
    lng: -41.2374178,
    lat: -21.378833
  },
  {
    lng: -41.2374191,
    lat: -21.3788343
  },
  {
    lng: -41.2374204,
    lat: -21.3788357
  },
  {
    lng: -41.2374217,
    lat: -21.378837
  },
  {
    lng: -41.237423,
    lat: -21.3788383
  },
  {
    lng: -41.2374243,
    lat: -21.3788397
  },
  {
    lng: -41.2374256,
    lat: -21.378841
  },
  {
    lng: -41.237427,
    lat: -21.3788423
  },
  {
    lng: -41.2374283,
    lat: -21.3788436
  },
  {
    lng: -41.2374296,
    lat: -21.3788449
  },
  {
    lng: -41.237431,
    lat: -21.3788462
  },
  {
    lng: -41.2374323,
    lat: -21.3788475
  },
  {
    lng: -41.2374337,
    lat: -21.3788488
  },
  {
    lng: -41.237435,
    lat: -21.3788501
  },
  {
    lng: -41.2374364,
    lat: -21.3788514
  },
  {
    lng: -41.2374377,
    lat: -21.3788526
  },
  {
    lng: -41.2374391,
    lat: -21.3788539
  },
  {
    lng: -41.237691,
    lat: -21.3791106
  },
  {
    lng: -41.2378027,
    lat: -21.3792651
  },
  {
    lng: -41.2379145,
    lat: -21.3794196
  },
  {
    lng: -41.2380998,
    lat: -21.379624
  },
  {
    lng: -41.2381006,
    lat: -21.3796256
  },
  {
    lng: -41.2381013,
    lat: -21.3796273
  },
  {
    lng: -41.238102,
    lat: -21.3796289
  },
  {
    lng: -41.2381027,
    lat: -21.3796306
  },
  {
    lng: -41.2381034,
    lat: -21.3796323
  },
  {
    lng: -41.238104,
    lat: -21.3796339
  },
  {
    lng: -41.2381047,
    lat: -21.3796356
  },
  {
    lng: -41.2381054,
    lat: -21.3796373
  },
  {
    lng: -41.2381061,
    lat: -21.3796389
  },
  {
    lng: -41.2381067,
    lat: -21.3796406
  },
  {
    lng: -41.2381074,
    lat: -21.3796423
  },
  {
    lng: -41.238108,
    lat: -21.379644
  },
  {
    lng: -41.2381087,
    lat: -21.3796456
  },
  {
    lng: -41.2381093,
    lat: -21.3796473
  },
  {
    lng: -41.2381099,
    lat: -21.379649
  },
  {
    lng: -41.2381106,
    lat: -21.3796507
  },
  {
    lng: -41.2381112,
    lat: -21.3796524
  },
  {
    lng: -41.2381118,
    lat: -21.3796541
  },
  {
    lng: -41.2381124,
    lat: -21.3796558
  },
  {
    lng: -41.238113,
    lat: -21.3796575
  },
  {
    lng: -41.2381136,
    lat: -21.3796592
  },
  {
    lng: -41.2381142,
    lat: -21.3796609
  },
  {
    lng: -41.2381147,
    lat: -21.3796626
  },
  {
    lng: -41.2381153,
    lat: -21.3796643
  },
  {
    lng: -41.2381159,
    lat: -21.379666
  },
  {
    lng: -41.2381164,
    lat: -21.3796677
  },
  {
    lng: -41.238117,
    lat: -21.3796694
  },
  {
    lng: -41.2381175,
    lat: -21.3796711
  },
  {
    lng: -41.2381181,
    lat: -21.3796729
  },
  {
    lng: -41.2381186,
    lat: -21.3796746
  },
  {
    lng: -41.2381191,
    lat: -21.3796763
  },
  {
    lng: -41.2381196,
    lat: -21.379678
  },
  {
    lng: -41.2381202,
    lat: -21.3796797
  },
  {
    lng: -41.2381207,
    lat: -21.3796815
  },
  {
    lng: -41.2381212,
    lat: -21.3796832
  },
  {
    lng: -41.2381217,
    lat: -21.3796849
  },
  {
    lng: -41.2381221,
    lat: -21.3796867
  },
  {
    lng: -41.2381226,
    lat: -21.3796884
  },
  {
    lng: -41.2381231,
    lat: -21.3796901
  },
  {
    lng: -41.2381236,
    lat: -21.3796919
  },
  {
    lng: -41.238124,
    lat: -21.3796936
  },
  {
    lng: -41.2381245,
    lat: -21.3796954
  },
  {
    lng: -41.2381249,
    lat: -21.3796971
  },
  {
    lng: -41.2381254,
    lat: -21.3796988
  },
  {
    lng: -41.2381258,
    lat: -21.3797006
  },
  {
    lng: -41.2381262,
    lat: -21.3797023
  },
  {
    lng: -41.2381266,
    lat: -21.3797041
  },
  {
    lng: -41.2381271,
    lat: -21.3797058
  },
  {
    lng: -41.2381275,
    lat: -21.3797076
  },
  {
    lng: -41.2381279,
    lat: -21.3797093
  },
  {
    lng: -41.2381283,
    lat: -21.3797111
  },
  {
    lng: -41.2381287,
    lat: -21.3797129
  },
  {
    lng: -41.238129,
    lat: -21.3797146
  },
  {
    lng: -41.2381294,
    lat: -21.3797164
  },
  {
    lng: -41.2381298,
    lat: -21.3797181
  },
  {
    lng: -41.2381301,
    lat: -21.3797199
  },
  {
    lng: -41.2381305,
    lat: -21.3797217
  },
  {
    lng: -41.2381308,
    lat: -21.3797234
  },
  {
    lng: -41.2381312,
    lat: -21.3797252
  },
  {
    lng: -41.2381315,
    lat: -21.379727
  },
  {
    lng: -41.2381319,
    lat: -21.3797287
  },
  {
    lng: -41.2381322,
    lat: -21.3797305
  },
  {
    lng: -41.2381325,
    lat: -21.3797323
  },
  {
    lng: -41.2381328,
    lat: -21.379734
  },
  {
    lng: -41.2381331,
    lat: -21.3797358
  },
  {
    lng: -41.2381334,
    lat: -21.3797376
  },
  {
    lng: -41.2381337,
    lat: -21.3797394
  },
  {
    lng: -41.238134,
    lat: -21.3797412
  },
  {
    lng: -41.2381342,
    lat: -21.3797429
  },
  {
    lng: -41.2381345,
    lat: -21.3797447
  },
  {
    lng: -41.2381348,
    lat: -21.3797465
  },
  {
    lng: -41.238135,
    lat: -21.3797483
  },
  {
    lng: -41.2381353,
    lat: -21.3797501
  },
  {
    lng: -41.2381355,
    lat: -21.3797518
  },
  {
    lng: -41.2381357,
    lat: -21.3797536
  },
  {
    lng: -41.238136,
    lat: -21.3797554
  },
  {
    lng: -41.2381362,
    lat: -21.3797572
  },
  {
    lng: -41.2381364,
    lat: -21.379759
  },
  {
    lng: -41.2381366,
    lat: -21.3797608
  },
  {
    lng: -41.2381368,
    lat: -21.3797626
  },
  {
    lng: -41.238137,
    lat: -21.3797643
  },
  {
    lng: -41.2381372,
    lat: -21.3797661
  },
  {
    lng: -41.2381374,
    lat: -21.3797679
  },
  {
    lng: -41.2381376,
    lat: -21.3797697
  },
  {
    lng: -41.2381377,
    lat: -21.3797715
  },
  {
    lng: -41.2381379,
    lat: -21.3797733
  },
  {
    lng: -41.238138,
    lat: -21.3797751
  },
  {
    lng: -41.2381382,
    lat: -21.3797769
  },
  {
    lng: -41.2381383,
    lat: -21.3797787
  },
  {
    lng: -41.2381385,
    lat: -21.3797805
  },
  {
    lng: -41.2381386,
    lat: -21.3797823
  },
  {
    lng: -41.2381387,
    lat: -21.3797841
  },
  {
    lng: -41.2381388,
    lat: -21.3797859
  },
  {
    lng: -41.2381389,
    lat: -21.3797877
  },
  {
    lng: -41.238139,
    lat: -21.3797895
  },
  {
    lng: -41.2381391,
    lat: -21.3797913
  },
  {
    lng: -41.2381392,
    lat: -21.3797931
  },
  {
    lng: -41.2381393,
    lat: -21.3797948
  },
  {
    lng: -41.2381394,
    lat: -21.3797966
  },
  {
    lng: -41.2381394,
    lat: -21.3797984
  },
  {
    lng: -41.2381395,
    lat: -21.3798002
  },
  {
    lng: -41.2381395,
    lat: -21.379802
  },
  {
    lng: -41.2381396,
    lat: -21.3798038
  },
  {
    lng: -41.2381396,
    lat: -21.3798056
  },
  {
    lng: -41.2381397,
    lat: -21.3798074
  },
  {
    lng: -41.2381397,
    lat: -21.3798092
  },
  {
    lng: -41.2381397,
    lat: -21.379811
  },
  {
    lng: -41.2381397,
    lat: -21.3798128
  },
  {
    lng: -41.2381397,
    lat: -21.3798146
  },
  {
    lng: -41.2381397,
    lat: -21.3798164
  },
  {
    lng: -41.2381397,
    lat: -21.3798182
  },
  {
    lng: -41.2381397,
    lat: -21.37982
  },
  {
    lng: -41.2381397,
    lat: -21.3798218
  },
  {
    lng: -41.2381396,
    lat: -21.3798236
  },
  {
    lng: -41.2381396,
    lat: -21.3798254
  },
  {
    lng: -41.2381396,
    lat: -21.3798272
  },
  {
    lng: -41.2381395,
    lat: -21.379829
  },
  {
    lng: -41.2381394,
    lat: -21.3798308
  },
  {
    lng: -41.2381394,
    lat: -21.3798326
  },
  {
    lng: -41.2381393,
    lat: -21.3798344
  },
  {
    lng: -41.2381392,
    lat: -21.3798362
  },
  {
    lng: -41.2381392,
    lat: -21.379838
  },
  {
    lng: -41.2381391,
    lat: -21.3798398
  },
  {
    lng: -41.238139,
    lat: -21.3798416
  },
  {
    lng: -41.2381389,
    lat: -21.3798434
  },
  {
    lng: -41.2381388,
    lat: -21.3798452
  },
  {
    lng: -41.2381386,
    lat: -21.379847
  },
  {
    lng: -41.2381385,
    lat: -21.3798488
  },
  {
    lng: -41.2381384,
    lat: -21.3798506
  },
  {
    lng: -41.2381382,
    lat: -21.3798524
  },
  {
    lng: -41.2381381,
    lat: -21.3798542
  },
  {
    lng: -41.238138,
    lat: -21.379856
  },
  {
    lng: -41.2381378,
    lat: -21.3798578
  },
  {
    lng: -41.2381376,
    lat: -21.3798596
  },
  {
    lng: -41.2381375,
    lat: -21.3798614
  },
  {
    lng: -41.2381373,
    lat: -21.3798631
  },
  {
    lng: -41.2381371,
    lat: -21.3798649
  },
  {
    lng: -41.2381369,
    lat: -21.3798667
  },
  {
    lng: -41.2381367,
    lat: -21.3798685
  },
  {
    lng: -41.2381365,
    lat: -21.3798703
  },
  {
    lng: -41.2381363,
    lat: -21.3798721
  },
  {
    lng: -41.2381361,
    lat: -21.3798739
  },
  {
    lng: -41.2381358,
    lat: -21.3798757
  },
  {
    lng: -41.2381356,
    lat: -21.3798774
  },
  {
    lng: -41.2381354,
    lat: -21.3798792
  },
  {
    lng: -41.2381351,
    lat: -21.379881
  },
  {
    lng: -41.2381349,
    lat: -21.3798828
  },
  {
    lng: -41.2381346,
    lat: -21.3798846
  },
  {
    lng: -41.2381344,
    lat: -21.3798864
  },
  {
    lng: -41.2381341,
    lat: -21.3798881
  },
  {
    lng: -41.2381338,
    lat: -21.3798899
  },
  {
    lng: -41.2381335,
    lat: -21.3798917
  },
  {
    lng: -41.2381332,
    lat: -21.3798935
  },
  {
    lng: -41.2381329,
    lat: -21.3798952
  },
  {
    lng: -41.2381326,
    lat: -21.379897
  },
  {
    lng: -41.2381323,
    lat: -21.3798988
  },
  {
    lng: -41.238132,
    lat: -21.3799006
  },
  {
    lng: -41.2381317,
    lat: -21.3799023
  },
  {
    lng: -41.2381313,
    lat: -21.3799041
  },
  {
    lng: -41.238131,
    lat: -21.3799059
  },
  {
    lng: -41.2381306,
    lat: -21.3799076
  },
  {
    lng: -41.2381303,
    lat: -21.3799094
  },
  {
    lng: -41.2381299,
    lat: -21.3799112
  },
  {
    lng: -41.2381296,
    lat: -21.3799129
  },
  {
    lng: -41.2381292,
    lat: -21.3799147
  },
  {
    lng: -41.2381288,
    lat: -21.3799164
  },
  {
    lng: -41.2381284,
    lat: -21.3799182
  },
  {
    lng: -41.238128,
    lat: -21.37992
  },
  {
    lng: -41.2381276,
    lat: -21.3799217
  },
  {
    lng: -41.2381272,
    lat: -21.3799235
  },
  {
    lng: -41.2381268,
    lat: -21.3799252
  },
  {
    lng: -41.2381264,
    lat: -21.379927
  },
  {
    lng: -41.238126,
    lat: -21.3799287
  },
  {
    lng: -41.2381256,
    lat: -21.3799305
  },
  {
    lng: -41.2381251,
    lat: -21.3799322
  },
  {
    lng: -41.2381247,
    lat: -21.3799339
  },
  {
    lng: -41.2381242,
    lat: -21.3799357
  },
  {
    lng: -41.2381238,
    lat: -21.3799374
  },
  {
    lng: -41.2381233,
    lat: -21.3799392
  },
  {
    lng: -41.2381228,
    lat: -21.3799409
  },
  {
    lng: -41.2381223,
    lat: -21.3799426
  },
  {
    lng: -41.2381219,
    lat: -21.3799444
  },
  {
    lng: -41.2381214,
    lat: -21.3799461
  },
  {
    lng: -41.2381209,
    lat: -21.3799478
  },
  {
    lng: -41.2381204,
    lat: -21.3799496
  },
  {
    lng: -41.2381199,
    lat: -21.3799513
  },
  {
    lng: -41.2381193,
    lat: -21.379953
  },
  {
    lng: -41.2381188,
    lat: -21.3799547
  },
  {
    lng: -41.2381183,
    lat: -21.3799565
  },
  {
    lng: -41.2381178,
    lat: -21.3799582
  },
  {
    lng: -41.2381172,
    lat: -21.3799599
  },
  {
    lng: -41.2381167,
    lat: -21.3799616
  },
  {
    lng: -41.2381161,
    lat: -21.3799633
  },
  {
    lng: -41.2381155,
    lat: -21.379965
  },
  {
    lng: -41.238115,
    lat: -21.3799667
  },
  {
    lng: -41.2381144,
    lat: -21.3799684
  },
  {
    lng: -41.2381138,
    lat: -21.3799701
  },
  {
    lng: -41.2381132,
    lat: -21.3799718
  },
  {
    lng: -41.2381126,
    lat: -21.3799735
  },
  {
    lng: -41.238112,
    lat: -21.3799752
  },
  {
    lng: -41.2381114,
    lat: -21.3799769
  },
  {
    lng: -41.2381108,
    lat: -21.3799786
  },
  {
    lng: -41.2381102,
    lat: -21.3799803
  },
  {
    lng: -41.2381096,
    lat: -21.379982
  },
  {
    lng: -41.2381089,
    lat: -21.3799837
  },
  {
    lng: -41.2381083,
    lat: -21.3799854
  },
  {
    lng: -41.2381077,
    lat: -21.379987
  },
  {
    lng: -41.238107,
    lat: -21.3799887
  },
  {
    lng: -41.2381064,
    lat: -21.3799904
  },
  {
    lng: -41.2381057,
    lat: -21.3799921
  },
  {
    lng: -41.238105,
    lat: -21.3799937
  },
  {
    lng: -41.2381043,
    lat: -21.3799954
  },
  {
    lng: -41.2381037,
    lat: -21.3799971
  },
  {
    lng: -41.238103,
    lat: -21.3799987
  },
  {
    lng: -41.2381023,
    lat: -21.3800004
  },
  {
    lng: -41.2381016,
    lat: -21.3800021
  },
  {
    lng: -41.2381009,
    lat: -21.3800037
  },
  {
    lng: -41.2381001,
    lat: -21.3800054
  },
  {
    lng: -41.2380994,
    lat: -21.380007
  },
  {
    lng: -41.2380987,
    lat: -21.3800087
  },
  {
    lng: -41.238098,
    lat: -21.3800103
  },
  {
    lng: -41.2380972,
    lat: -21.3800119
  },
  {
    lng: -41.2380965,
    lat: -21.3800136
  },
  {
    lng: -41.2380957,
    lat: -21.3800152
  },
  {
    lng: -41.238095,
    lat: -21.3800168
  },
  {
    lng: -41.2380942,
    lat: -21.3800185
  },
  {
    lng: -41.2380934,
    lat: -21.3800201
  },
  {
    lng: -41.2380927,
    lat: -21.3800217
  },
  {
    lng: -41.2380919,
    lat: -21.3800233
  },
  {
    lng: -41.2380911,
    lat: -21.380025
  },
  {
    lng: -41.2380903,
    lat: -21.3800266
  },
  {
    lng: -41.2380895,
    lat: -21.3800282
  },
  {
    lng: -41.2380887,
    lat: -21.3800298
  },
  {
    lng: -41.2380879,
    lat: -21.3800314
  },
  {
    lng: -41.2380871,
    lat: -21.380033
  },
  {
    lng: -41.2380862,
    lat: -21.3800346
  },
  {
    lng: -41.2380854,
    lat: -21.3800362
  },
  {
    lng: -41.2380846,
    lat: -21.3800378
  },
  {
    lng: -41.2380837,
    lat: -21.3800394
  },
  {
    lng: -41.2380829,
    lat: -21.380041
  },
  {
    lng: -41.238082,
    lat: -21.3800426
  },
  {
    lng: -41.2380812,
    lat: -21.3800441
  },
  {
    lng: -41.2380803,
    lat: -21.3800457
  },
  {
    lng: -41.2380794,
    lat: -21.3800473
  },
  {
    lng: -41.2380786,
    lat: -21.3800489
  },
  {
    lng: -41.2380777,
    lat: -21.3800504
  },
  {
    lng: -41.2380768,
    lat: -21.380052
  },
  {
    lng: -41.2380759,
    lat: -21.3800536
  },
  {
    lng: -41.238075,
    lat: -21.3800551
  },
  {
    lng: -41.2380741,
    lat: -21.3800567
  },
  {
    lng: -41.2380732,
    lat: -21.3800582
  },
  {
    lng: -41.2380722,
    lat: -21.3800598
  },
  {
    lng: -41.2380713,
    lat: -21.3800613
  },
  {
    lng: -41.238069,
    lat: -21.3800645
  },
  {
    lng: -41.2380666,
    lat: -21.3800677
  },
  {
    lng: -41.2380643,
    lat: -21.3800708
  },
  {
    lng: -41.2380619,
    lat: -21.380074
  },
  {
    lng: -41.2380596,
    lat: -21.3800772
  },
  {
    lng: -41.2380573,
    lat: -21.3800804
  },
  {
    lng: -41.238055,
    lat: -21.3800836
  },
  {
    lng: -41.2380526,
    lat: -21.3800868
  },
  {
    lng: -41.2380503,
    lat: -21.38009
  },
  {
    lng: -41.238048,
    lat: -21.3800932
  },
  {
    lng: -41.2380457,
    lat: -21.3800964
  },
  {
    lng: -41.2380434,
    lat: -21.3800996
  },
  {
    lng: -41.2380411,
    lat: -21.3801028
  },
  {
    lng: -41.2380389,
    lat: -21.380106
  },
  {
    lng: -41.2380366,
    lat: -21.3801093
  },
  {
    lng: -41.2380343,
    lat: -21.3801125
  },
  {
    lng: -41.238032,
    lat: -21.3801157
  },
  {
    lng: -41.2380298,
    lat: -21.380119
  },
  {
    lng: -41.2380275,
    lat: -21.3801222
  },
  {
    lng: -41.2380253,
    lat: -21.3801254
  },
  {
    lng: -41.238023,
    lat: -21.3801287
  },
  {
    lng: -41.2380208,
    lat: -21.3801319
  },
  {
    lng: -41.2380185,
    lat: -21.3801352
  },
  {
    lng: -41.2380163,
    lat: -21.3801385
  },
  {
    lng: -41.2380141,
    lat: -21.3801417
  },
  {
    lng: -41.2380119,
    lat: -21.380145
  },
  {
    lng: -41.2380097,
    lat: -21.3801483
  },
  {
    lng: -41.2380075,
    lat: -21.3801515
  },
  {
    lng: -41.2380053,
    lat: -21.3801548
  },
  {
    lng: -41.2380031,
    lat: -21.3801581
  },
  {
    lng: -41.2380009,
    lat: -21.3801614
  },
  {
    lng: -41.2379987,
    lat: -21.3801647
  },
  {
    lng: -41.2379965,
    lat: -21.380168
  },
  {
    lng: -41.2379943,
    lat: -21.3801713
  },
  {
    lng: -41.2379922,
    lat: -21.3801746
  },
  {
    lng: -41.23799,
    lat: -21.3801779
  },
  {
    lng: -41.2379879,
    lat: -21.3801812
  },
  {
    lng: -41.2379857,
    lat: -21.3801845
  },
  {
    lng: -41.2379836,
    lat: -21.3801878
  },
  {
    lng: -41.2379814,
    lat: -21.3801911
  },
  {
    lng: -41.2379793,
    lat: -21.3801944
  },
  {
    lng: -41.2379772,
    lat: -21.3801978
  },
  {
    lng: -41.237975,
    lat: -21.3802011
  },
  {
    lng: -41.2379729,
    lat: -21.3802044
  },
  {
    lng: -41.2379708,
    lat: -21.3802078
  },
  {
    lng: -41.2379687,
    lat: -21.3802111
  },
  {
    lng: -41.2379666,
    lat: -21.3802144
  },
  {
    lng: -41.2379645,
    lat: -21.3802178
  },
  {
    lng: -41.2379624,
    lat: -21.3802211
  },
  {
    lng: -41.2379604,
    lat: -21.3802245
  },
  {
    lng: -41.2379583,
    lat: -21.3802279
  },
  {
    lng: -41.2379562,
    lat: -21.3802312
  },
  {
    lng: -41.2379541,
    lat: -21.3802346
  },
  {
    lng: -41.2379521,
    lat: -21.380238
  },
  {
    lng: -41.23795,
    lat: -21.3802413
  },
  {
    lng: -41.237948,
    lat: -21.3802447
  },
  {
    lng: -41.2379459,
    lat: -21.3802481
  },
  {
    lng: -41.2379439,
    lat: -21.3802515
  },
  {
    lng: -41.2379419,
    lat: -21.3802549
  },
  {
    lng: -41.2379399,
    lat: -21.3802582
  },
  {
    lng: -41.2379378,
    lat: -21.3802616
  },
  {
    lng: -41.2379358,
    lat: -21.380265
  },
  {
    lng: -41.2379338,
    lat: -21.3802684
  },
  {
    lng: -41.2379318,
    lat: -21.3802718
  },
  {
    lng: -41.2379298,
    lat: -21.3802752
  },
  {
    lng: -41.2379278,
    lat: -21.3802787
  },
  {
    lng: -41.2379259,
    lat: -21.3802821
  },
  {
    lng: -41.2379239,
    lat: -21.3802855
  },
  {
    lng: -41.2379219,
    lat: -21.3802889
  },
  {
    lng: -41.2379199,
    lat: -21.3802923
  },
  {
    lng: -41.237918,
    lat: -21.3802958
  },
  {
    lng: -41.237916,
    lat: -21.3802992
  },
  {
    lng: -41.2379141,
    lat: -21.3803026
  },
  {
    lng: -41.2379121,
    lat: -21.3803061
  },
  {
    lng: -41.2379102,
    lat: -21.3803095
  },
  {
    lng: -41.2379083,
    lat: -21.3803129
  },
  {
    lng: -41.2379063,
    lat: -21.3803164
  },
  {
    lng: -41.2379044,
    lat: -21.3803198
  },
  {
    lng: -41.2379025,
    lat: -21.3803233
  },
  {
    lng: -41.2379006,
    lat: -21.3803268
  },
  {
    lng: -41.2378987,
    lat: -21.3803302
  },
  {
    lng: -41.2378968,
    lat: -21.3803337
  },
  {
    lng: -41.2378949,
    lat: -21.3803371
  },
  {
    lng: -41.237893,
    lat: -21.3803406
  },
  {
    lng: -41.2378912,
    lat: -21.3803441
  },
  {
    lng: -41.2378893,
    lat: -21.3803476
  },
  {
    lng: -41.2378874,
    lat: -21.380351
  },
  {
    lng: -41.2378856,
    lat: -21.3803545
  },
  {
    lng: -41.2378837,
    lat: -21.380358
  },
  {
    lng: -41.2378819,
    lat: -21.3803615
  },
  {
    lng: -41.23788,
    lat: -21.380365
  },
  {
    lng: -41.2378782,
    lat: -21.3803685
  },
  {
    lng: -41.2378764,
    lat: -21.380372
  },
  {
    lng: -41.2378745,
    lat: -21.3803755
  },
  {
    lng: -41.2378727,
    lat: -21.380379
  },
  {
    lng: -41.2378709,
    lat: -21.3803825
  },
  {
    lng: -41.2378691,
    lat: -21.380386
  },
  {
    lng: -41.2378673,
    lat: -21.3803895
  },
  {
    lng: -41.2378655,
    lat: -21.380393
  },
  {
    lng: -41.2378637,
    lat: -21.3803966
  },
  {
    lng: -41.2378619,
    lat: -21.3804001
  },
  {
    lng: -41.2378602,
    lat: -21.3804036
  },
  {
    lng: -41.2378584,
    lat: -21.3804071
  },
  {
    lng: -41.2378566,
    lat: -21.3804107
  },
  {
    lng: -41.2378549,
    lat: -21.3804142
  },
  {
    lng: -41.2378531,
    lat: -21.3804178
  },
  {
    lng: -41.2378514,
    lat: -21.3804213
  },
  {
    lng: -41.2378496,
    lat: -21.3804248
  },
  {
    lng: -41.2378479,
    lat: -21.3804284
  },
  {
    lng: -41.2378462,
    lat: -21.3804319
  },
  {
    lng: -41.2378445,
    lat: -21.3804355
  },
  {
    lng: -41.2378427,
    lat: -21.380439
  },
  {
    lng: -41.237841,
    lat: -21.3804426
  },
  {
    lng: -41.2378393,
    lat: -21.3804462
  },
  {
    lng: -41.2378376,
    lat: -21.3804497
  },
  {
    lng: -41.2378359,
    lat: -21.3804533
  },
  {
    lng: -41.2378343,
    lat: -21.3804569
  },
  {
    lng: -41.2378326,
    lat: -21.3804604
  },
  {
    lng: -41.2378309,
    lat: -21.380464
  },
  {
    lng: -41.2378292,
    lat: -21.3804676
  },
  {
    lng: -41.2378276,
    lat: -21.3804712
  },
  {
    lng: -41.2378259,
    lat: -21.3804748
  },
  {
    lng: -41.2378243,
    lat: -21.3804784
  },
  {
    lng: -41.2378226,
    lat: -21.3804819
  },
  {
    lng: -41.237821,
    lat: -21.3804855
  },
  {
    lng: -41.2378194,
    lat: -21.3804891
  },
  {
    lng: -41.2377005,
    lat: -21.3808647
  },
  {
    lng: -41.2376387,
    lat: -21.3810833
  },
  {
    lng: -41.2376067,
    lat: -21.3811558
  },
  {
    lng: -41.2375484,
    lat: -21.3812877
  },
  {
    lng: -41.2373899,
    lat: -21.3815558
  },
  {
    lng: -41.2373488,
    lat: -21.3816252
  },
  {
    lng: -41.2372442,
    lat: -21.3818487
  },
  {
    lng: -41.2372432,
    lat: -21.3818509
  },
  {
    lng: -41.2372423,
    lat: -21.3818532
  },
  {
    lng: -41.2372413,
    lat: -21.3818555
  },
  {
    lng: -41.2372404,
    lat: -21.3818578
  },
  {
    lng: -41.2372394,
    lat: -21.38186
  },
  {
    lng: -41.2372385,
    lat: -21.3818623
  },
  {
    lng: -41.2372376,
    lat: -21.3818646
  },
  {
    lng: -41.2372367,
    lat: -21.3818669
  },
  {
    lng: -41.2372357,
    lat: -21.3818692
  },
  {
    lng: -41.2372348,
    lat: -21.3818715
  },
  {
    lng: -41.2372339,
    lat: -21.3818738
  },
  {
    lng: -41.237233,
    lat: -21.3818761
  },
  {
    lng: -41.2372321,
    lat: -21.3818784
  },
  {
    lng: -41.2372313,
    lat: -21.3818807
  },
  {
    lng: -41.2372304,
    lat: -21.381883
  },
  {
    lng: -41.2372295,
    lat: -21.3818853
  },
  {
    lng: -41.2372286,
    lat: -21.3818876
  },
  {
    lng: -41.2372278,
    lat: -21.38189
  },
  {
    lng: -41.2372269,
    lat: -21.3818923
  },
  {
    lng: -41.2372261,
    lat: -21.3818946
  },
  {
    lng: -41.2372253,
    lat: -21.3818969
  },
  {
    lng: -41.2372244,
    lat: -21.3818992
  },
  {
    lng: -41.2372236,
    lat: -21.3819016
  },
  {
    lng: -41.2372228,
    lat: -21.3819039
  },
  {
    lng: -41.237222,
    lat: -21.3819062
  },
  {
    lng: -41.2372212,
    lat: -21.3819086
  },
  {
    lng: -41.2372204,
    lat: -21.3819109
  },
  {
    lng: -41.2372196,
    lat: -21.3819132
  },
  {
    lng: -41.2372188,
    lat: -21.3819156
  },
  {
    lng: -41.237218,
    lat: -21.3819179
  },
  {
    lng: -41.2372172,
    lat: -21.3819203
  },
  {
    lng: -41.2372164,
    lat: -21.3819226
  },
  {
    lng: -41.2372157,
    lat: -21.381925
  },
  {
    lng: -41.2372149,
    lat: -21.3819273
  },
  {
    lng: -41.2372142,
    lat: -21.3819297
  },
  {
    lng: -41.2372134,
    lat: -21.381932
  },
  {
    lng: -41.2372127,
    lat: -21.3819344
  },
  {
    lng: -41.237212,
    lat: -21.3819367
  },
  {
    lng: -41.2372113,
    lat: -21.3819391
  },
  {
    lng: -41.2372105,
    lat: -21.3819415
  },
  {
    lng: -41.2372098,
    lat: -21.3819438
  },
  {
    lng: -41.2372091,
    lat: -21.3819462
  },
  {
    lng: -41.2372084,
    lat: -21.3819486
  },
  {
    lng: -41.2372077,
    lat: -21.3819509
  },
  {
    lng: -41.2372071,
    lat: -21.3819533
  },
  {
    lng: -41.2372064,
    lat: -21.3819557
  },
  {
    lng: -41.2372057,
    lat: -21.3819581
  },
  {
    lng: -41.237205,
    lat: -21.3819604
  },
  {
    lng: -41.2372044,
    lat: -21.3819628
  },
  {
    lng: -41.2372037,
    lat: -21.3819652
  },
  {
    lng: -41.2372031,
    lat: -21.3819676
  },
  {
    lng: -41.2372025,
    lat: -21.38197
  },
  {
    lng: -41.2372018,
    lat: -21.3819724
  },
  {
    lng: -41.2372012,
    lat: -21.3819748
  },
  {
    lng: -41.2372006,
    lat: -21.3819771
  },
  {
    lng: -41.2372,
    lat: -21.3819795
  },
  {
    lng: -41.2371994,
    lat: -21.3819819
  },
  {
    lng: -41.2371988,
    lat: -21.3819843
  },
  {
    lng: -41.2371982,
    lat: -21.3819867
  },
  {
    lng: -41.2371976,
    lat: -21.3819891
  },
  {
    lng: -41.237197,
    lat: -21.3819915
  },
  {
    lng: -41.2371964,
    lat: -21.3819939
  },
  {
    lng: -41.2371959,
    lat: -21.3819963
  },
  {
    lng: -41.2371953,
    lat: -21.3819987
  },
  {
    lng: -41.2371948,
    lat: -21.3820011
  },
  {
    lng: -41.2371942,
    lat: -21.3820036
  },
  {
    lng: -41.2371937,
    lat: -21.382006
  },
  {
    lng: -41.2371932,
    lat: -21.3820084
  },
  {
    lng: -41.2371926,
    lat: -21.3820108
  },
  {
    lng: -41.2371921,
    lat: -21.3820132
  },
  {
    lng: -41.2371916,
    lat: -21.3820156
  },
  {
    lng: -41.2371911,
    lat: -21.382018
  },
  {
    lng: -41.2371906,
    lat: -21.3820205
  },
  {
    lng: -41.2371901,
    lat: -21.3820229
  },
  {
    lng: -41.2371896,
    lat: -21.3820253
  },
  {
    lng: -41.2371891,
    lat: -21.3820277
  },
  {
    lng: -41.2371887,
    lat: -21.3820301
  },
  {
    lng: -41.2371882,
    lat: -21.3820326
  },
  {
    lng: -41.2371878,
    lat: -21.382035
  },
  {
    lng: -41.2371873,
    lat: -21.3820374
  },
  {
    lng: -41.2371869,
    lat: -21.3820399
  },
  {
    lng: -41.2371864,
    lat: -21.3820423
  },
  {
    lng: -41.237186,
    lat: -21.3820447
  },
  {
    lng: -41.2371856,
    lat: -21.3820471
  },
  {
    lng: -41.2371851,
    lat: -21.3820496
  },
  {
    lng: -41.2371847,
    lat: -21.382052
  },
  {
    lng: -41.2371843,
    lat: -21.3820544
  },
  {
    lng: -41.2371839,
    lat: -21.3820569
  },
  {
    lng: -41.2371835,
    lat: -21.3820593
  },
  {
    lng: -41.2371832,
    lat: -21.3820618
  },
  {
    lng: -41.2371828,
    lat: -21.3820642
  },
  {
    lng: -41.2371824,
    lat: -21.3820666
  },
  {
    lng: -41.237182,
    lat: -21.3820691
  },
  {
    lng: -41.2371817,
    lat: -21.3820715
  },
  {
    lng: -41.2371813,
    lat: -21.382074
  },
  {
    lng: -41.237181,
    lat: -21.3820764
  },
  {
    lng: -41.2371807,
    lat: -21.3820789
  },
  {
    lng: -41.2371803,
    lat: -21.3820813
  },
  {
    lng: -41.23718,
    lat: -21.3820838
  },
  {
    lng: -41.2371797,
    lat: -21.3820862
  },
  {
    lng: -41.2371794,
    lat: -21.3820887
  },
  {
    lng: -41.2371791,
    lat: -21.3820911
  },
  {
    lng: -41.2371788,
    lat: -21.3820936
  },
  {
    lng: -41.2371785,
    lat: -21.382096
  },
  {
    lng: -41.2371782,
    lat: -21.3820985
  },
  {
    lng: -41.2371779,
    lat: -21.3821009
  },
  {
    lng: -41.2371777,
    lat: -21.3821034
  },
  {
    lng: -41.2371774,
    lat: -21.3821058
  },
  {
    lng: -41.2371771,
    lat: -21.3821083
  },
  {
    lng: -41.2371769,
    lat: -21.3821107
  },
  {
    lng: -41.2371766,
    lat: -21.3821132
  },
  {
    lng: -41.2371764,
    lat: -21.3821157
  },
  {
    lng: -41.2371762,
    lat: -21.3821181
  },
  {
    lng: -41.237176,
    lat: -21.3821206
  },
  {
    lng: -41.2371757,
    lat: -21.382123
  },
  {
    lng: -41.2371755,
    lat: -21.3821255
  },
  {
    lng: -41.2371753,
    lat: -21.382128
  },
  {
    lng: -41.2371751,
    lat: -21.3821304
  },
  {
    lng: -41.2371749,
    lat: -21.3821329
  },
  {
    lng: -41.2371748,
    lat: -21.3821353
  },
  {
    lng: -41.2371746,
    lat: -21.3821378
  },
  {
    lng: -41.2371744,
    lat: -21.3821403
  },
  {
    lng: -41.2371743,
    lat: -21.3821427
  },
  {
    lng: -41.2371741,
    lat: -21.3821452
  },
  {
    lng: -41.237174,
    lat: -21.3821477
  },
  {
    lng: -41.2371738,
    lat: -21.3821501
  },
  {
    lng: -41.2371737,
    lat: -21.3821526
  },
  {
    lng: -41.2371736,
    lat: -21.3821551
  },
  {
    lng: -41.2371734,
    lat: -21.3821575
  },
  {
    lng: -41.2371733,
    lat: -21.38216
  },
  {
    lng: -41.2371732,
    lat: -21.3821625
  },
  {
    lng: -41.2371731,
    lat: -21.3821649
  },
  {
    lng: -41.237173,
    lat: -21.3821674
  },
  {
    lng: -41.2371729,
    lat: -21.3821699
  },
  {
    lng: -41.2371729,
    lat: -21.3821723
  },
  {
    lng: -41.2371728,
    lat: -21.3821748
  },
  {
    lng: -41.2371727,
    lat: -21.3821773
  },
  {
    lng: -41.2371727,
    lat: -21.3821797
  },
  {
    lng: -41.2371726,
    lat: -21.3821822
  },
  {
    lng: -41.2371726,
    lat: -21.3821847
  },
  {
    lng: -41.2371725,
    lat: -21.3821872
  },
  {
    lng: -41.2371725,
    lat: -21.3821896
  },
  {
    lng: -41.2371725,
    lat: -21.3821921
  },
  {
    lng: -41.2371724,
    lat: -21.3821946
  },
  {
    lng: -41.2371724,
    lat: -21.382197
  },
  {
    lng: -41.2371724,
    lat: -21.3821995
  },
  {
    lng: -41.2371724,
    lat: -21.382202
  },
  {
    lng: -41.2371724,
    lat: -21.3822044
  },
  {
    lng: -41.2371725,
    lat: -21.3822069
  },
  {
    lng: -41.2371725,
    lat: -21.3822094
  },
  {
    lng: -41.2371725,
    lat: -21.3822118
  },
  {
    lng: -41.2371725,
    lat: -21.3822143
  },
  {
    lng: -41.2371726,
    lat: -21.3822168
  },
  {
    lng: -41.2371726,
    lat: -21.3822193
  },
  {
    lng: -41.2371727,
    lat: -21.3822217
  },
  {
    lng: -41.2371728,
    lat: -21.3822242
  },
  {
    lng: -41.2371728,
    lat: -21.3822267
  },
  {
    lng: -41.2371729,
    lat: -21.3822291
  },
  {
    lng: -41.237173,
    lat: -21.3822316
  },
  {
    lng: -41.2371731,
    lat: -21.3822341
  },
  {
    lng: -41.2371732,
    lat: -21.3822365
  },
  {
    lng: -41.2371733,
    lat: -21.382239
  },
  {
    lng: -41.2371734,
    lat: -21.3822415
  },
  {
    lng: -41.2371735,
    lat: -21.3822439
  },
  {
    lng: -41.2371736,
    lat: -21.3822464
  },
  {
    lng: -41.2371738,
    lat: -21.3822489
  },
  {
    lng: -41.2371739,
    lat: -21.3822513
  },
  {
    lng: -41.237174,
    lat: -21.3822538
  },
  {
    lng: -41.2371742,
    lat: -21.3822563
  },
  {
    lng: -41.2371744,
    lat: -21.3822587
  },
  {
    lng: -41.2371745,
    lat: -21.3822612
  },
  {
    lng: -41.2371747,
    lat: -21.3822636
  },
  {
    lng: -41.2371749,
    lat: -21.3822661
  },
  {
    lng: -41.2371751,
    lat: -21.3822686
  },
  {
    lng: -41.2371752,
    lat: -21.382271
  },
  {
    lng: -41.2371754,
    lat: -21.3822735
  },
  {
    lng: -41.2371757,
    lat: -21.382276
  },
  {
    lng: -41.2371759,
    lat: -21.3822784
  },
  {
    lng: -41.2371761,
    lat: -21.3822809
  },
  {
    lng: -41.2371763,
    lat: -21.3822833
  },
  {
    lng: -41.2371765,
    lat: -21.3822858
  },
  {
    lng: -41.2371768,
    lat: -21.3822883
  },
  {
    lng: -41.237177,
    lat: -21.3822907
  },
  {
    lng: -41.2371773,
    lat: -21.3822932
  },
  {
    lng: -41.2371775,
    lat: -21.3822956
  },
  {
    lng: -41.2371778,
    lat: -21.3822981
  },
  {
    lng: -41.2371781,
    lat: -21.3823005
  },
  {
    lng: -41.2371784,
    lat: -21.382303
  },
  {
    lng: -41.2371787,
    lat: -21.3823054
  },
  {
    lng: -41.2371789,
    lat: -21.3823079
  },
  {
    lng: -41.2371792,
    lat: -21.3823103
  },
  {
    lng: -41.2371796,
    lat: -21.3823128
  },
  {
    lng: -41.2371799,
    lat: -21.3823152
  },
  {
    lng: -41.2371802,
    lat: -21.3823177
  },
  {
    lng: -41.2371805,
    lat: -21.3823201
  },
  {
    lng: -41.2371809,
    lat: -21.3823226
  },
  {
    lng: -41.2371812,
    lat: -21.382325
  },
  {
    lng: -41.2371815,
    lat: -21.3823275
  },
  {
    lng: -41.2371819,
    lat: -21.3823299
  },
  {
    lng: -41.2371823,
    lat: -21.3823324
  },
  {
    lng: -41.2371826,
    lat: -21.3823348
  },
  {
    lng: -41.237183,
    lat: -21.3823372
  },
  {
    lng: -41.2371834,
    lat: -21.3823397
  },
  {
    lng: -41.2371838,
    lat: -21.3823421
  },
  {
    lng: -41.2371842,
    lat: -21.3823446
  },
  {
    lng: -41.2371846,
    lat: -21.382347
  },
  {
    lng: -41.237185,
    lat: -21.3823494
  },
  {
    lng: -41.2371854,
    lat: -21.3823519
  },
  {
    lng: -41.2371858,
    lat: -21.3823543
  },
  {
    lng: -41.2371862,
    lat: -21.3823567
  },
  {
    lng: -41.2371867,
    lat: -21.3823592
  },
  {
    lng: -41.2371871,
    lat: -21.3823616
  },
  {
    lng: -41.2371876,
    lat: -21.382364
  },
  {
    lng: -41.237188,
    lat: -21.3823664
  },
  {
    lng: -41.2371885,
    lat: -21.3823689
  },
  {
    lng: -41.237189,
    lat: -21.3823713
  },
  {
    lng: -41.2371894,
    lat: -21.3823737
  },
  {
    lng: -41.2371899,
    lat: -21.3823761
  },
  {
    lng: -41.2371904,
    lat: -21.3823786
  },
  {
    lng: -41.2371909,
    lat: -21.382381
  },
  {
    lng: -41.2371914,
    lat: -21.3823834
  },
  {
    lng: -41.2371919,
    lat: -21.3823858
  },
  {
    lng: -41.2371925,
    lat: -21.3823874
  },
  {
    lng: -41.2371931,
    lat: -21.382389
  },
  {
    lng: -41.2371937,
    lat: -21.3823906
  },
  {
    lng: -41.2371943,
    lat: -21.3823921
  },
  {
    lng: -41.2371949,
    lat: -21.3823937
  },
  {
    lng: -41.2371955,
    lat: -21.3823953
  },
  {
    lng: -41.2371961,
    lat: -21.3823969
  },
  {
    lng: -41.2371968,
    lat: -21.3823984
  },
  {
    lng: -41.2371974,
    lat: -21.3824
  },
  {
    lng: -41.237198,
    lat: -21.3824016
  },
  {
    lng: -41.2371987,
    lat: -21.3824031
  },
  {
    lng: -41.2371993,
    lat: -21.3824047
  },
  {
    lng: -41.2372,
    lat: -21.3824062
  },
  {
    lng: -41.2372007,
    lat: -21.3824078
  },
  {
    lng: -41.2372013,
    lat: -21.3824093
  },
  {
    lng: -41.237202,
    lat: -21.3824109
  },
  {
    lng: -41.2372027,
    lat: -21.3824124
  },
  {
    lng: -41.2372034,
    lat: -21.382414
  },
  {
    lng: -41.2372041,
    lat: -21.3824155
  },
  {
    lng: -41.2372048,
    lat: -21.382417
  },
  {
    lng: -41.2372055,
    lat: -21.3824186
  },
  {
    lng: -41.2372062,
    lat: -21.3824201
  },
  {
    lng: -41.2372069,
    lat: -21.3824216
  },
  {
    lng: -41.2372077,
    lat: -21.3824231
  },
  {
    lng: -41.2372084,
    lat: -21.3824247
  },
  {
    lng: -41.2372091,
    lat: -21.3824262
  },
  {
    lng: -41.2372099,
    lat: -21.3824277
  },
  {
    lng: -41.2372106,
    lat: -21.3824292
  },
  {
    lng: -41.2372114,
    lat: -21.3824307
  },
  {
    lng: -41.2372122,
    lat: -21.3824322
  },
  {
    lng: -41.2372129,
    lat: -21.3824337
  },
  {
    lng: -41.2372137,
    lat: -21.3824352
  },
  {
    lng: -41.2372145,
    lat: -21.3824367
  },
  {
    lng: -41.2372153,
    lat: -21.3824382
  },
  {
    lng: -41.2372161,
    lat: -21.3824397
  },
  {
    lng: -41.2372169,
    lat: -21.3824412
  },
  {
    lng: -41.2372177,
    lat: -21.3824427
  },
  {
    lng: -41.2372185,
    lat: -21.3824442
  },
  {
    lng: -41.2372193,
    lat: -21.3824456
  },
  {
    lng: -41.2372201,
    lat: -21.3824471
  },
  {
    lng: -41.237221,
    lat: -21.3824486
  },
  {
    lng: -41.2372218,
    lat: -21.3824501
  },
  {
    lng: -41.2372227,
    lat: -21.3824515
  },
  {
    lng: -41.2372235,
    lat: -21.382453
  },
  {
    lng: -41.2372244,
    lat: -21.3824544
  },
  {
    lng: -41.2372252,
    lat: -21.3824559
  },
  {
    lng: -41.2372261,
    lat: -21.3824573
  },
  {
    lng: -41.237227,
    lat: -21.3824588
  },
  {
    lng: -41.2372278,
    lat: -21.3824602
  },
  {
    lng: -41.2372287,
    lat: -21.3824617
  },
  {
    lng: -41.2372296,
    lat: -21.3824631
  },
  {
    lng: -41.2372305,
    lat: -21.3824645
  },
  {
    lng: -41.2372314,
    lat: -21.382466
  },
  {
    lng: -41.2372323,
    lat: -21.3824674
  },
  {
    lng: -41.2372332,
    lat: -21.3824688
  },
  {
    lng: -41.2372341,
    lat: -21.3824702
  },
  {
    lng: -41.2372351,
    lat: -21.3824716
  },
  {
    lng: -41.237236,
    lat: -21.3824731
  },
  {
    lng: -41.2372369,
    lat: -21.3824745
  },
  {
    lng: -41.2372379,
    lat: -21.3824759
  },
  {
    lng: -41.2372388,
    lat: -21.3824773
  },
  {
    lng: -41.2372398,
    lat: -21.3824787
  },
  {
    lng: -41.2372407,
    lat: -21.3824801
  },
  {
    lng: -41.2372417,
    lat: -21.3824814
  },
  {
    lng: -41.2372426,
    lat: -21.3824828
  },
  {
    lng: -41.2372436,
    lat: -21.3824842
  },
  {
    lng: -41.2372446,
    lat: -21.3824856
  },
  {
    lng: -41.2372456,
    lat: -21.382487
  },
  {
    lng: -41.2372466,
    lat: -21.3824883
  },
  {
    lng: -41.2372476,
    lat: -21.3824897
  },
  {
    lng: -41.2372486,
    lat: -21.382491
  },
  {
    lng: -41.2372496,
    lat: -21.3824924
  },
  {
    lng: -41.2372506,
    lat: -21.3824938
  },
  {
    lng: -41.2372516,
    lat: -21.3824951
  },
  {
    lng: -41.2372526,
    lat: -21.3824965
  },
  {
    lng: -41.2372537,
    lat: -21.3824978
  },
  {
    lng: -41.2372547,
    lat: -21.3824991
  },
  {
    lng: -41.2372557,
    lat: -21.3825005
  },
  {
    lng: -41.2372568,
    lat: -21.3825018
  },
  {
    lng: -41.2372578,
    lat: -21.3825031
  },
  {
    lng: -41.2372589,
    lat: -21.3825044
  },
  {
    lng: -41.2372599,
    lat: -21.3825057
  },
  {
    lng: -41.237261,
    lat: -21.3825071
  },
  {
    lng: -41.2372621,
    lat: -21.3825084
  },
  {
    lng: -41.2372631,
    lat: -21.3825097
  },
  {
    lng: -41.2372642,
    lat: -21.382511
  },
  {
    lng: -41.2372653,
    lat: -21.3825123
  },
  {
    lng: -41.2372664,
    lat: -21.3825135
  },
  {
    lng: -41.2372675,
    lat: -21.3825148
  },
  {
    lng: -41.2372686,
    lat: -21.3825161
  },
  {
    lng: -41.2372697,
    lat: -21.3825174
  },
  {
    lng: -41.2372708,
    lat: -21.3825187
  },
  {
    lng: -41.2372719,
    lat: -21.3825199
  },
  {
    lng: -41.2372731,
    lat: -21.3825212
  },
  {
    lng: -41.2372742,
    lat: -21.3825224
  },
  {
    lng: -41.2372753,
    lat: -21.3825237
  },
  {
    lng: -41.2372765,
    lat: -21.3825249
  },
  {
    lng: -41.2372776,
    lat: -21.3825262
  },
  {
    lng: -41.2372787,
    lat: -21.3825274
  },
  {
    lng: -41.2372799,
    lat: -21.3825287
  },
  {
    lng: -41.2372811,
    lat: -21.3825299
  },
  {
    lng: -41.2372822,
    lat: -21.3825311
  },
  {
    lng: -41.2372834,
    lat: -21.3825323
  },
  {
    lng: -41.2372846,
    lat: -21.3825336
  },
  {
    lng: -41.2372857,
    lat: -21.3825348
  },
  {
    lng: -41.2372869,
    lat: -21.382536
  },
  {
    lng: -41.2372881,
    lat: -21.3825372
  },
  {
    lng: -41.2372893,
    lat: -21.3825384
  },
  {
    lng: -41.2372905,
    lat: -21.3825396
  },
  {
    lng: -41.2372917,
    lat: -21.3825408
  },
  {
    lng: -41.2372929,
    lat: -21.3825419
  },
  {
    lng: -41.2372941,
    lat: -21.3825431
  },
  {
    lng: -41.2372953,
    lat: -21.3825443
  },
  {
    lng: -41.2372965,
    lat: -21.3825455
  },
  {
    lng: -41.2372978,
    lat: -21.3825466
  },
  {
    lng: -41.237299,
    lat: -21.3825478
  },
  {
    lng: -41.2373002,
    lat: -21.3825489
  },
  {
    lng: -41.2373015,
    lat: -21.3825501
  },
  {
    lng: -41.2373027,
    lat: -21.3825512
  },
  {
    lng: -41.237304,
    lat: -21.3825524
  },
  {
    lng: -41.2373052,
    lat: -21.3825535
  },
  {
    lng: -41.2373065,
    lat: -21.3825546
  },
  {
    lng: -41.2373077,
    lat: -21.3825558
  },
  {
    lng: -41.237309,
    lat: -21.3825569
  },
  {
    lng: -41.2373103,
    lat: -21.382558
  },
  {
    lng: -41.2373115,
    lat: -21.3825591
  },
  {
    lng: -41.2373128,
    lat: -21.3825602
  },
  {
    lng: -41.2373141,
    lat: -21.3825613
  },
  {
    lng: -41.2373154,
    lat: -21.3825624
  },
  {
    lng: -41.2373167,
    lat: -21.3825635
  },
  {
    lng: -41.237318,
    lat: -21.3825646
  },
  {
    lng: -41.2373193,
    lat: -21.3825656
  },
  {
    lng: -41.2373206,
    lat: -21.3825667
  },
  {
    lng: -41.2373219,
    lat: -21.3825678
  },
  {
    lng: -41.2373232,
    lat: -21.3825688
  },
  {
    lng: -41.2373245,
    lat: -21.3825699
  },
  {
    lng: -41.2373258,
    lat: -21.382571
  },
  {
    lng: -41.2373272,
    lat: -21.382572
  },
  {
    lng: -41.2373285,
    lat: -21.382573
  },
  {
    lng: -41.2373298,
    lat: -21.3825741
  },
  {
    lng: -41.2373312,
    lat: -21.3825751
  },
  {
    lng: -41.2373325,
    lat: -21.3825761
  },
  {
    lng: -41.2373339,
    lat: -21.3825771
  },
  {
    lng: -41.2373352,
    lat: -21.3825782
  },
  {
    lng: -41.2373366,
    lat: -21.3825792
  },
  {
    lng: -41.2373379,
    lat: -21.3825802
  },
  {
    lng: -41.2373393,
    lat: -21.3825812
  },
  {
    lng: -41.2373407,
    lat: -21.3825822
  },
  {
    lng: -41.237342,
    lat: -21.3825831
  },
  {
    lng: -41.2373434,
    lat: -21.3825841
  },
  {
    lng: -41.2373448,
    lat: -21.3825851
  },
  {
    lng: -41.2373462,
    lat: -21.3825861
  },
  {
    lng: -41.2373476,
    lat: -21.382587
  },
  {
    lng: -41.2373489,
    lat: -21.382588
  },
  {
    lng: -41.2373503,
    lat: -21.382589
  },
  {
    lng: -41.2373517,
    lat: -21.3825899
  },
  {
    lng: -41.2373531,
    lat: -21.3825908
  },
  {
    lng: -41.2373545,
    lat: -21.3825918
  },
  {
    lng: -41.237356,
    lat: -21.3825927
  },
  {
    lng: -41.2373574,
    lat: -21.3825936
  },
  {
    lng: -41.2373588,
    lat: -21.3825946
  },
  {
    lng: -41.2373602,
    lat: -21.3825955
  },
  {
    lng: -41.2373616,
    lat: -21.3825964
  },
  {
    lng: -41.2373631,
    lat: -21.3825973
  },
  {
    lng: -41.2373645,
    lat: -21.3825982
  },
  {
    lng: -41.2373659,
    lat: -21.3825991
  },
  {
    lng: -41.2373674,
    lat: -21.3825999
  },
  {
    lng: -41.2373688,
    lat: -21.3826008
  },
  {
    lng: -41.2373703,
    lat: -21.3826017
  },
  {
    lng: -41.2373717,
    lat: -21.3826026
  },
  {
    lng: -41.2373732,
    lat: -21.3826034
  },
  {
    lng: -41.2373746,
    lat: -21.3826043
  },
  {
    lng: -41.2373761,
    lat: -21.3826051
  },
  {
    lng: -41.2373775,
    lat: -21.382606
  },
  {
    lng: -41.237379,
    lat: -21.3826068
  },
  {
    lng: -41.2373805,
    lat: -21.3826076
  },
  {
    lng: -41.2373819,
    lat: -21.3826085
  },
  {
    lng: -41.2373834,
    lat: -21.3826093
  },
  {
    lng: -41.2373849,
    lat: -21.3826101
  },
  {
    lng: -41.2373864,
    lat: -21.3826109
  },
  {
    lng: -41.2373879,
    lat: -21.3826117
  },
  {
    lng: -41.2373894,
    lat: -21.3826125
  },
  {
    lng: -41.2373908,
    lat: -21.3826133
  },
  {
    lng: -41.2373923,
    lat: -21.3826141
  },
  {
    lng: -41.2373938,
    lat: -21.3826149
  },
  {
    lng: -41.2373953,
    lat: -21.3826156
  },
  {
    lng: -41.2373969,
    lat: -21.3826164
  },
  {
    lng: -41.2373984,
    lat: -21.3826172
  },
  {
    lng: -41.2373999,
    lat: -21.3826179
  },
  {
    lng: -41.2374014,
    lat: -21.3826187
  },
  {
    lng: -41.2374029,
    lat: -21.3826194
  },
  {
    lng: -41.2374044,
    lat: -21.3826202
  },
  {
    lng: -41.2374059,
    lat: -21.3826209
  },
  {
    lng: -41.2374075,
    lat: -21.3826216
  },
  {
    lng: -41.237409,
    lat: -21.3826223
  },
  {
    lng: -41.2374105,
    lat: -21.382623
  },
  {
    lng: -41.2374121,
    lat: -21.3826237
  },
  {
    lng: -41.2374136,
    lat: -21.3826244
  },
  {
    lng: -41.2374151,
    lat: -21.3826251
  },
  {
    lng: -41.2374167,
    lat: -21.3826258
  },
  {
    lng: -41.2374182,
    lat: -21.3826265
  },
  {
    lng: -41.2374198,
    lat: -21.3826272
  },
  {
    lng: -41.2374213,
    lat: -21.3826279
  },
  {
    lng: -41.2374229,
    lat: -21.3826285
  },
  {
    lng: -41.2374244,
    lat: -21.3826292
  },
  {
    lng: -41.237426,
    lat: -21.3826298
  },
  {
    lng: -41.2374276,
    lat: -21.3826305
  },
  {
    lng: -41.2374291,
    lat: -21.3826311
  },
  {
    lng: -41.2374307,
    lat: -21.3826317
  },
  {
    lng: -41.2374323,
    lat: -21.3826324
  },
  {
    lng: -41.2374338,
    lat: -21.382633
  },
  {
    lng: -41.2374354,
    lat: -21.3826336
  },
  {
    lng: -41.237437,
    lat: -21.3826342
  },
  {
    lng: -41.2374386,
    lat: -21.3826348
  },
  {
    lng: -41.2374401,
    lat: -21.3826354
  },
  {
    lng: -41.2374417,
    lat: -21.382636
  },
  {
    lng: -41.2374433,
    lat: -21.3826366
  },
  {
    lng: -41.2374449,
    lat: -21.3826371
  },
  {
    lng: -41.2374465,
    lat: -21.3826377
  },
  {
    lng: -41.2374481,
    lat: -21.3826383
  },
  {
    lng: -41.2374497,
    lat: -21.3826388
  },
  {
    lng: -41.2374513,
    lat: -21.3826394
  },
  {
    lng: -41.2374529,
    lat: -21.3826399
  },
  {
    lng: -41.2374545,
    lat: -21.3826404
  },
  {
    lng: -41.2374561,
    lat: -21.382641
  },
  {
    lng: -41.2374577,
    lat: -21.3826415
  },
  {
    lng: -41.2374593,
    lat: -21.382642
  },
  {
    lng: -41.2374609,
    lat: -21.3826425
  },
  {
    lng: -41.2374625,
    lat: -21.382643
  },
  {
    lng: -41.2374641,
    lat: -21.3826435
  },
  {
    lng: -41.2374658,
    lat: -21.382644
  },
  {
    lng: -41.2374674,
    lat: -21.3826445
  },
  {
    lng: -41.237469,
    lat: -21.382645
  },
  {
    lng: -41.2374706,
    lat: -21.3826454
  },
  {
    lng: -41.2374722,
    lat: -21.3826459
  },
  {
    lng: -41.2374739,
    lat: -21.3826464
  },
  {
    lng: -41.2374755,
    lat: -21.3826468
  },
  {
    lng: -41.2374771,
    lat: -21.3826473
  },
  {
    lng: -41.2378289,
    lat: -21.3827091
  },
  {
    lng: -41.2381189,
    lat: -21.3827756
  },
  {
    lng: -41.2383447,
    lat: -21.3828374
  },
  {
    lng: -41.2385704,
    lat: -21.3828992
  },
  {
    lng: -41.2390363,
    lat: -21.3830038
  },
  {
    lng: -41.2392977,
    lat: -21.3830989
  },
  {
    lng: -41.239621,
    lat: -21.383251
  },
  {
    lng: -41.2398349,
    lat: -21.3833508
  },
  {
    lng: -41.2401677,
    lat: -21.3834411
  },
  {
    lng: -41.240567,
    lat: -21.3835457
  },
  {
    lng: -41.240895,
    lat: -21.3836598
  },
  {
    lng: -41.2412039,
    lat: -21.3838119
  },
  {
    lng: -41.2414321,
    lat: -21.383945
  },
  {
    lng: -41.2416365,
    lat: -21.3841161
  },
  {
    lng: -41.2418837,
    lat: -21.3844156
  },
  {
    lng: -41.2421261,
    lat: -21.3847626
  },
  {
    lng: -41.2422687,
    lat: -21.3850241
  },
  {
    lng: -41.2423448,
    lat: -21.3852475
  },
  {
    lng: -41.2424399,
    lat: -21.3855992
  },
  {
    lng: -41.2425587,
    lat: -21.3858845
  },
  {
    lng: -41.2426348,
    lat: -21.3860793
  },
  {
    lng: -41.2426585,
    lat: -21.3862457
  },
  {
    lng: -41.2426775,
    lat: -21.3866118
  },
  {
    lng: -41.2426918,
    lat: -21.3869017
  },
  {
    lng: -41.2427346,
    lat: -21.3871156
  },
  {
    lng: -41.2428202,
    lat: -21.3873818
  },
  {
    lng: -41.2428867,
    lat: -21.3876195
  },
  {
    lng: -41.2429105,
    lat: -21.3878429
  },
  {
    lng: -41.2429247,
    lat: -21.3881234
  },
  {
    lng: -41.242958,
    lat: -21.3883278
  },
  {
    lng: -41.2429584,
    lat: -21.3883293
  },
  {
    lng: -41.2429587,
    lat: -21.3883307
  },
  {
    lng: -41.2429591,
    lat: -21.3883322
  },
  {
    lng: -41.2429595,
    lat: -21.3883337
  },
  {
    lng: -41.2429598,
    lat: -21.3883352
  },
  {
    lng: -41.2429602,
    lat: -21.3883366
  },
  {
    lng: -41.2429606,
    lat: -21.3883381
  },
  {
    lng: -41.242961,
    lat: -21.3883396
  },
  {
    lng: -41.2429614,
    lat: -21.388341
  },
  {
    lng: -41.2429619,
    lat: -21.3883425
  },
  {
    lng: -41.2429623,
    lat: -21.388344
  },
  {
    lng: -41.2429627,
    lat: -21.3883454
  },
  {
    lng: -41.2429631,
    lat: -21.3883469
  },
  {
    lng: -41.2429636,
    lat: -21.3883483
  },
  {
    lng: -41.242964,
    lat: -21.3883498
  },
  {
    lng: -41.2429645,
    lat: -21.3883512
  },
  {
    lng: -41.2429649,
    lat: -21.3883527
  },
  {
    lng: -41.2429654,
    lat: -21.3883541
  },
  {
    lng: -41.2429659,
    lat: -21.3883556
  },
  {
    lng: -41.2429664,
    lat: -21.388357
  },
  {
    lng: -41.2429668,
    lat: -21.3883584
  },
  {
    lng: -41.2429673,
    lat: -21.3883599
  },
  {
    lng: -41.2429678,
    lat: -21.3883613
  },
  {
    lng: -41.2429683,
    lat: -21.3883628
  },
  {
    lng: -41.2429688,
    lat: -21.3883642
  },
  {
    lng: -41.2429694,
    lat: -21.3883656
  },
  {
    lng: -41.2429699,
    lat: -21.388367
  },
  {
    lng: -41.2429704,
    lat: -21.3883685
  },
  {
    lng: -41.242971,
    lat: -21.3883699
  },
  {
    lng: -41.2429715,
    lat: -21.3883713
  },
  {
    lng: -41.2429721,
    lat: -21.3883727
  },
  {
    lng: -41.2429726,
    lat: -21.3883741
  },
  {
    lng: -41.2429732,
    lat: -21.3883755
  },
  {
    lng: -41.2429737,
    lat: -21.388377
  },
  {
    lng: -41.2429743,
    lat: -21.3883784
  },
  {
    lng: -41.2429749,
    lat: -21.3883798
  },
  {
    lng: -41.2429755,
    lat: -21.3883812
  },
  {
    lng: -41.2429761,
    lat: -21.3883826
  },
  {
    lng: -41.2429767,
    lat: -21.388384
  },
  {
    lng: -41.2429773,
    lat: -21.3883854
  },
  {
    lng: -41.2429779,
    lat: -21.3883867
  },
  {
    lng: -41.2429785,
    lat: -21.3883881
  },
  {
    lng: -41.2429791,
    lat: -21.3883895
  },
  {
    lng: -41.2429798,
    lat: -21.3883909
  },
  {
    lng: -41.2429804,
    lat: -21.3883923
  },
  {
    lng: -41.2429811,
    lat: -21.3883937
  },
  {
    lng: -41.2429817,
    lat: -21.388395
  },
  {
    lng: -41.2429824,
    lat: -21.3883964
  },
  {
    lng: -41.242983,
    lat: -21.3883978
  },
  {
    lng: -41.2429837,
    lat: -21.3883991
  },
  {
    lng: -41.2429844,
    lat: -21.3884005
  },
  {
    lng: -41.242985,
    lat: -21.3884019
  },
  {
    lng: -41.2429857,
    lat: -21.3884032
  },
  {
    lng: -41.2429864,
    lat: -21.3884046
  },
  {
    lng: -41.2429871,
    lat: -21.3884059
  },
  {
    lng: -41.2429878,
    lat: -21.3884073
  },
  {
    lng: -41.2429885,
    lat: -21.3884086
  },
  {
    lng: -41.2429893,
    lat: -21.3884099
  },
  {
    lng: -41.24299,
    lat: -21.3884113
  },
  {
    lng: -41.2429907,
    lat: -21.3884126
  },
  {
    lng: -41.2429914,
    lat: -21.3884139
  },
  {
    lng: -41.2429922,
    lat: -21.3884153
  },
  {
    lng: -41.2429929,
    lat: -21.3884166
  },
  {
    lng: -41.2429937,
    lat: -21.3884179
  },
  {
    lng: -41.2429944,
    lat: -21.3884192
  },
  {
    lng: -41.2429952,
    lat: -21.3884205
  },
  {
    lng: -41.242996,
    lat: -21.3884218
  },
  {
    lng: -41.2429968,
    lat: -21.3884232
  },
  {
    lng: -41.2429975,
    lat: -21.3884245
  },
  {
    lng: -41.2429983,
    lat: -21.3884258
  },
  {
    lng: -41.2429991,
    lat: -21.3884271
  },
  {
    lng: -41.2429999,
    lat: -21.3884283
  },
  {
    lng: -41.2430007,
    lat: -21.3884296
  },
  {
    lng: -41.2430015,
    lat: -21.3884309
  },
  {
    lng: -41.2430024,
    lat: -21.3884322
  },
  {
    lng: -41.2430032,
    lat: -21.3884335
  },
  {
    lng: -41.243004,
    lat: -21.3884348
  },
  {
    lng: -41.2430048,
    lat: -21.388436
  },
  {
    lng: -41.2430057,
    lat: -21.3884373
  },
  {
    lng: -41.2430065,
    lat: -21.3884385
  },
  {
    lng: -41.2430074,
    lat: -21.3884398
  },
  {
    lng: -41.2430082,
    lat: -21.3884411
  },
  {
    lng: -41.2430091,
    lat: -21.3884423
  },
  {
    lng: -41.24301,
    lat: -21.3884436
  },
  {
    lng: -41.2430108,
    lat: -21.3884448
  },
  {
    lng: -41.2430117,
    lat: -21.388446
  },
  {
    lng: -41.2430126,
    lat: -21.3884473
  },
  {
    lng: -41.2430135,
    lat: -21.3884485
  },
  {
    lng: -41.2430144,
    lat: -21.3884497
  },
  {
    lng: -41.2430153,
    lat: -21.388451
  },
  {
    lng: -41.2430162,
    lat: -21.3884522
  },
  {
    lng: -41.2430171,
    lat: -21.3884534
  },
  {
    lng: -41.243018,
    lat: -21.3884546
  },
  {
    lng: -41.2430189,
    lat: -21.3884558
  },
  {
    lng: -41.2430199,
    lat: -21.388457
  },
  {
    lng: -41.2430208,
    lat: -21.3884582
  },
  {
    lng: -41.2430217,
    lat: -21.3884594
  },
  {
    lng: -41.2430227,
    lat: -21.3884606
  },
  {
    lng: -41.2430236,
    lat: -21.3884618
  },
  {
    lng: -41.2430246,
    lat: -21.388463
  },
  {
    lng: -41.2430256,
    lat: -21.3884641
  },
  {
    lng: -41.2430265,
    lat: -21.3884653
  },
  {
    lng: -41.2430275,
    lat: -21.3884665
  },
  {
    lng: -41.2430285,
    lat: -21.3884677
  },
  {
    lng: -41.2430295,
    lat: -21.3884688
  },
  {
    lng: -41.2430304,
    lat: -21.38847
  },
  {
    lng: -41.2430314,
    lat: -21.3884711
  },
  {
    lng: -41.2430324,
    lat: -21.3884723
  },
  {
    lng: -41.2430334,
    lat: -21.3884734
  },
  {
    lng: -41.2430344,
    lat: -21.3884745
  },
  {
    lng: -41.2430355,
    lat: -21.3884757
  },
  {
    lng: -41.2430365,
    lat: -21.3884768
  },
  {
    lng: -41.2430375,
    lat: -21.3884779
  },
  {
    lng: -41.2430385,
    lat: -21.3884791
  },
  {
    lng: -41.2430396,
    lat: -21.3884802
  },
  {
    lng: -41.2430406,
    lat: -21.3884813
  },
  {
    lng: -41.2430416,
    lat: -21.3884824
  },
  {
    lng: -41.2430427,
    lat: -21.3884835
  },
  {
    lng: -41.2430437,
    lat: -21.3884846
  },
  {
    lng: -41.2430448,
    lat: -21.3884857
  },
  {
    lng: -41.2430459,
    lat: -21.3884868
  },
  {
    lng: -41.2430469,
    lat: -21.3884878
  },
  {
    lng: -41.243048,
    lat: -21.3884889
  },
  {
    lng: -41.2430491,
    lat: -21.38849
  },
  {
    lng: -41.2430501,
    lat: -21.3884911
  },
  {
    lng: -41.2430512,
    lat: -21.3884921
  },
  {
    lng: -41.2430523,
    lat: -21.3884932
  },
  {
    lng: -41.2430534,
    lat: -21.3884942
  },
  {
    lng: -41.2430545,
    lat: -21.3884953
  },
  {
    lng: -41.2430556,
    lat: -21.3884963
  },
  {
    lng: -41.2430567,
    lat: -21.3884974
  },
  {
    lng: -41.2430579,
    lat: -21.3884984
  },
  {
    lng: -41.243059,
    lat: -21.3884994
  },
  {
    lng: -41.2430601,
    lat: -21.3885004
  },
  {
    lng: -41.2430612,
    lat: -21.3885015
  },
  {
    lng: -41.2430624,
    lat: -21.3885025
  },
  {
    lng: -41.2430635,
    lat: -21.3885035
  },
  {
    lng: -41.2430646,
    lat: -21.3885045
  },
  {
    lng: -41.2430658,
    lat: -21.3885055
  },
  {
    lng: -41.2430669,
    lat: -21.3885065
  },
  {
    lng: -41.2430681,
    lat: -21.3885075
  },
  {
    lng: -41.2430692,
    lat: -21.3885084
  },
  {
    lng: -41.2430704,
    lat: -21.3885094
  },
  {
    lng: -41.2430716,
    lat: -21.3885104
  },
  {
    lng: -41.2430728,
    lat: -21.3885114
  },
  {
    lng: -41.2430739,
    lat: -21.3885123
  },
  {
    lng: -41.2430751,
    lat: -21.3885133
  },
  {
    lng: -41.2430763,
    lat: -21.3885142
  },
  {
    lng: -41.2430775,
    lat: -21.3885152
  },
  {
    lng: -41.2430787,
    lat: -21.3885161
  },
  {
    lng: -41.2430799,
    lat: -21.388517
  },
  {
    lng: -41.2430811,
    lat: -21.388518
  },
  {
    lng: -41.2430823,
    lat: -21.3885189
  },
  {
    lng: -41.2430835,
    lat: -21.3885198
  },
  {
    lng: -41.2430847,
    lat: -21.3885207
  },
  {
    lng: -41.2430859,
    lat: -21.3885216
  },
  {
    lng: -41.2430872,
    lat: -21.3885225
  },
  {
    lng: -41.2430884,
    lat: -21.3885234
  },
  {
    lng: -41.2430896,
    lat: -21.3885243
  },
  {
    lng: -41.2430909,
    lat: -21.3885252
  },
  {
    lng: -41.2430921,
    lat: -21.3885261
  },
  {
    lng: -41.2430933,
    lat: -21.388527
  },
  {
    lng: -41.2430946,
    lat: -21.3885278
  },
  {
    lng: -41.2430958,
    lat: -21.3885287
  },
  {
    lng: -41.2430971,
    lat: -21.3885295
  },
  {
    lng: -41.2430983,
    lat: -21.3885304
  },
  {
    lng: -41.2430996,
    lat: -21.3885312
  },
  {
    lng: -41.2431009,
    lat: -21.3885321
  },
  {
    lng: -41.2431021,
    lat: -21.3885329
  },
  {
    lng: -41.2431034,
    lat: -21.3885338
  },
  {
    lng: -41.2431047,
    lat: -21.3885346
  },
  {
    lng: -41.243106,
    lat: -21.3885354
  },
  {
    lng: -41.2431073,
    lat: -21.3885362
  },
  {
    lng: -41.2431085,
    lat: -21.388537
  },
  {
    lng: -41.2431098,
    lat: -21.3885378
  },
  {
    lng: -41.2431111,
    lat: -21.3885386
  },
  {
    lng: -41.2431124,
    lat: -21.3885394
  },
  {
    lng: -41.2431137,
    lat: -21.3885402
  },
  {
    lng: -41.243115,
    lat: -21.388541
  },
  {
    lng: -41.2431164,
    lat: -21.3885417
  },
  {
    lng: -41.2431177,
    lat: -21.3885425
  },
  {
    lng: -41.243119,
    lat: -21.3885432
  },
  {
    lng: -41.2431203,
    lat: -21.388544
  },
  {
    lng: -41.2431216,
    lat: -21.3885447
  },
  {
    lng: -41.243123,
    lat: -21.3885455
  },
  {
    lng: -41.2431243,
    lat: -21.3885462
  },
  {
    lng: -41.2431256,
    lat: -21.388547
  },
  {
    lng: -41.2431269,
    lat: -21.3885477
  },
  {
    lng: -41.2431283,
    lat: -21.3885484
  },
  {
    lng: -41.2431296,
    lat: -21.3885491
  },
  {
    lng: -41.243131,
    lat: -21.3885498
  },
  {
    lng: -41.2431323,
    lat: -21.3885505
  },
  {
    lng: -41.2431337,
    lat: -21.3885512
  },
  {
    lng: -41.243135,
    lat: -21.3885519
  },
  {
    lng: -41.2431364,
    lat: -21.3885526
  },
  {
    lng: -41.2431378,
    lat: -21.3885532
  },
  {
    lng: -41.2431391,
    lat: -21.3885539
  },
  {
    lng: -41.2431405,
    lat: -21.3885546
  },
  {
    lng: -41.2431419,
    lat: -21.3885552
  },
  {
    lng: -41.2431432,
    lat: -21.3885559
  },
  {
    lng: -41.2431446,
    lat: -21.3885565
  },
  {
    lng: -41.243146,
    lat: -21.3885572
  },
  {
    lng: -41.2431474,
    lat: -21.3885578
  },
  {
    lng: -41.2431487,
    lat: -21.3885584
  },
  {
    lng: -41.2431501,
    lat: -21.388559
  },
  {
    lng: -41.2431515,
    lat: -21.3885597
  },
  {
    lng: -41.2431529,
    lat: -21.3885603
  },
  {
    lng: -41.2431543,
    lat: -21.3885609
  },
  {
    lng: -41.2431557,
    lat: -21.3885615
  },
  {
    lng: -41.2431571,
    lat: -21.3885621
  },
  {
    lng: -41.2431585,
    lat: -21.3885626
  },
  {
    lng: -41.2431599,
    lat: -21.3885632
  },
  {
    lng: -41.2431613,
    lat: -21.3885638
  },
  {
    lng: -41.2431627,
    lat: -21.3885643
  },
  {
    lng: -41.2431642,
    lat: -21.3885649
  },
  {
    lng: -41.2431656,
    lat: -21.3885654
  },
  {
    lng: -41.243167,
    lat: -21.388566
  },
  {
    lng: -41.2431684,
    lat: -21.3885665
  },
  {
    lng: -41.2431698,
    lat: -21.3885671
  },
  {
    lng: -41.2431713,
    lat: -21.3885676
  },
  {
    lng: -41.2431727,
    lat: -21.3885681
  },
  {
    lng: -41.2431741,
    lat: -21.3885686
  },
  {
    lng: -41.2431756,
    lat: -21.3885691
  },
  {
    lng: -41.243177,
    lat: -21.3885696
  },
  {
    lng: -41.2431784,
    lat: -21.3885701
  },
  {
    lng: -41.2431799,
    lat: -21.3885706
  },
  {
    lng: -41.2431813,
    lat: -21.3885711
  },
  {
    lng: -41.2431828,
    lat: -21.3885716
  },
  {
    lng: -41.2431842,
    lat: -21.388572
  },
  {
    lng: -41.2431856,
    lat: -21.3885725
  },
  {
    lng: -41.2431871,
    lat: -21.3885729
  },
  {
    lng: -41.2431886,
    lat: -21.3885734
  },
  {
    lng: -41.24319,
    lat: -21.3885738
  },
  {
    lng: -41.2431915,
    lat: -21.3885743
  },
  {
    lng: -41.2431929,
    lat: -21.3885747
  },
  {
    lng: -41.2431944,
    lat: -21.3885751
  },
  {
    lng: -41.2431958,
    lat: -21.3885755
  },
  {
    lng: -41.2431973,
    lat: -21.3885759
  },
  {
    lng: -41.2431988,
    lat: -21.3885763
  },
  {
    lng: -41.2432002,
    lat: -21.3885767
  },
  {
    lng: -41.2432017,
    lat: -21.3885771
  },
  {
    lng: -41.2432032,
    lat: -21.3885775
  },
  {
    lng: -41.2432047,
    lat: -21.3885779
  },
  {
    lng: -41.2432061,
    lat: -21.3885782
  },
  {
    lng: -41.2432076,
    lat: -21.3885786
  },
  {
    lng: -41.2432091,
    lat: -21.388579
  },
  {
    lng: -41.2432106,
    lat: -21.3885793
  },
  {
    lng: -41.243212,
    lat: -21.3885796
  },
  {
    lng: -41.2432135,
    lat: -21.38858
  },
  {
    lng: -41.243215,
    lat: -21.3885803
  },
  {
    lng: -41.2432165,
    lat: -21.3885806
  },
  {
    lng: -41.243218,
    lat: -21.388581
  },
  {
    lng: -41.2432195,
    lat: -21.3885813
  },
  {
    lng: -41.243221,
    lat: -21.3885816
  },
  {
    lng: -41.2432224,
    lat: -21.3885819
  },
  {
    lng: -41.2432239,
    lat: -21.3885821
  },
  {
    lng: -41.2432254,
    lat: -21.3885824
  },
  {
    lng: -41.2432269,
    lat: -21.3885827
  },
  {
    lng: -41.2432284,
    lat: -21.388583
  },
  {
    lng: -41.2432299,
    lat: -21.3885832
  },
  {
    lng: -41.2432314,
    lat: -21.3885835
  },
  {
    lng: -41.2432329,
    lat: -21.3885837
  },
  {
    lng: -41.2432344,
    lat: -21.388584
  },
  {
    lng: -41.2432359,
    lat: -21.3885842
  },
  {
    lng: -41.2432374,
    lat: -21.3885844
  },
  {
    lng: -41.2432389,
    lat: -21.3885847
  },
  {
    lng: -41.2432404,
    lat: -21.3885849
  },
  {
    lng: -41.2432419,
    lat: -21.3885851
  },
  {
    lng: -41.2432434,
    lat: -21.3885853
  },
  {
    lng: -41.2432449,
    lat: -21.3885855
  },
  {
    lng: -41.2432465,
    lat: -21.3885857
  },
  {
    lng: -41.243248,
    lat: -21.3885859
  },
  {
    lng: -41.2432495,
    lat: -21.388586
  },
  {
    lng: -41.243251,
    lat: -21.3885862
  },
  {
    lng: -41.2432525,
    lat: -21.3885864
  },
  {
    lng: -41.243254,
    lat: -21.3885865
  },
  {
    lng: -41.2432555,
    lat: -21.3885867
  },
  {
    lng: -41.243257,
    lat: -21.3885868
  },
  {
    lng: -41.2432585,
    lat: -21.3885869
  },
  {
    lng: -41.2432601,
    lat: -21.3885871
  },
  {
    lng: -41.2432616,
    lat: -21.3885872
  },
  {
    lng: -41.2432631,
    lat: -21.3885873
  },
  {
    lng: -41.2432646,
    lat: -21.3885874
  },
  {
    lng: -41.2432661,
    lat: -21.3885875
  },
  {
    lng: -41.2432676,
    lat: -21.3885876
  },
  {
    lng: -41.2432692,
    lat: -21.3885877
  },
  {
    lng: -41.2432707,
    lat: -21.3885878
  },
  {
    lng: -41.2432722,
    lat: -21.3885878
  },
  {
    lng: -41.2432737,
    lat: -21.3885879
  },
  {
    lng: -41.2432752,
    lat: -21.388588
  },
  {
    lng: -41.2432767,
    lat: -21.388588
  },
  {
    lng: -41.2432783,
    lat: -21.388588
  },
  {
    lng: -41.2432798,
    lat: -21.3885881
  },
  {
    lng: -41.2432813,
    lat: -21.3885881
  },
  {
    lng: -41.2432828,
    lat: -21.3885881
  },
  {
    lng: -41.2432843,
    lat: -21.3885882
  },
  {
    lng: -41.2432859,
    lat: -21.3885882
  },
  {
    lng: -41.2432874,
    lat: -21.3885882
  },
  {
    lng: -41.2432889,
    lat: -21.3885882
  },
  {
    lng: -41.2432904,
    lat: -21.3885882
  },
  {
    lng: -41.2432919,
    lat: -21.3885882
  },
  {
    lng: -41.2432935,
    lat: -21.3885881
  },
  {
    lng: -41.243295,
    lat: -21.3885881
  },
  {
    lng: -41.2432965,
    lat: -21.3885881
  },
  {
    lng: -41.243298,
    lat: -21.388588
  },
  {
    lng: -41.2432995,
    lat: -21.388588
  },
  {
    lng: -41.2433011,
    lat: -21.3885879
  },
  {
    lng: -41.2433026,
    lat: -21.3885878
  },
  {
    lng: -41.2433041,
    lat: -21.3885878
  },
  {
    lng: -41.2433056,
    lat: -21.3885877
  },
  {
    lng: -41.2433071,
    lat: -21.3885876
  },
  {
    lng: -41.2433086,
    lat: -21.3885875
  },
  {
    lng: -41.2433102,
    lat: -21.3885874
  },
  {
    lng: -41.2433117,
    lat: -21.3885873
  },
  {
    lng: -41.2433132,
    lat: -21.3885872
  },
  {
    lng: -41.2433147,
    lat: -21.3885871
  },
  {
    lng: -41.2433162,
    lat: -21.388587
  },
  {
    lng: -41.2433177,
    lat: -21.3885868
  },
  {
    lng: -41.2433192,
    lat: -21.3885867
  },
  {
    lng: -41.2433208,
    lat: -21.3885865
  },
  {
    lng: -41.2433223,
    lat: -21.3885864
  },
  {
    lng: -41.2433238,
    lat: -21.3885862
  },
  {
    lng: -41.2433253,
    lat: -21.3885861
  },
  {
    lng: -41.2433268,
    lat: -21.3885859
  },
  {
    lng: -41.2433283,
    lat: -21.3885857
  },
  {
    lng: -41.2433298,
    lat: -21.3885855
  },
  {
    lng: -41.2433313,
    lat: -21.3885853
  },
  {
    lng: -41.2433328,
    lat: -21.3885851
  },
  {
    lng: -41.2433343,
    lat: -21.3885849
  },
  {
    lng: -41.2433358,
    lat: -21.3885847
  },
  {
    lng: -41.2433373,
    lat: -21.3885845
  },
  {
    lng: -41.2433388,
    lat: -21.3885843
  },
  {
    lng: -41.2433403,
    lat: -21.388584
  },
  {
    lng: -41.2433418,
    lat: -21.3885838
  },
  {
    lng: -41.2433433,
    lat: -21.3885836
  },
  {
    lng: -41.2433448,
    lat: -21.3885833
  },
  {
    lng: -41.2433463,
    lat: -21.388583
  },
  {
    lng: -41.2433478,
    lat: -21.3885828
  },
  {
    lng: -41.2433493,
    lat: -21.3885825
  },
  {
    lng: -41.2433508,
    lat: -21.3885822
  },
  {
    lng: -41.2433523,
    lat: -21.3885819
  },
  {
    lng: -41.2433538,
    lat: -21.3885816
  },
  {
    lng: -41.2433553,
    lat: -21.3885813
  },
  {
    lng: -41.2433568,
    lat: -21.388581
  },
  {
    lng: -41.2433583,
    lat: -21.3885807
  },
  {
    lng: -41.2433598,
    lat: -21.3885804
  },
  {
    lng: -41.2433612,
    lat: -21.3885801
  },
  {
    lng: -41.2433627,
    lat: -21.3885797
  },
  {
    lng: -41.2433642,
    lat: -21.3885794
  },
  {
    lng: -41.2433657,
    lat: -21.388579
  },
  {
    lng: -41.2433672,
    lat: -21.3885787
  },
  {
    lng: -41.2433686,
    lat: -21.3885783
  },
  {
    lng: -41.2433701,
    lat: -21.388578
  },
  {
    lng: -41.2433716,
    lat: -21.3885776
  },
  {
    lng: -41.2433731,
    lat: -21.3885772
  },
  {
    lng: -41.2433745,
    lat: -21.3885768
  },
  {
    lng: -41.243376,
    lat: -21.3885764
  },
  {
    lng: -41.2433775,
    lat: -21.388576
  },
  {
    lng: -41.2433789,
    lat: -21.3885756
  },
  {
    lng: -41.2433804,
    lat: -21.3885752
  },
  {
    lng: -41.2433819,
    lat: -21.3885748
  },
  {
    lng: -41.2433833,
    lat: -21.3885744
  },
  {
    lng: -41.2433848,
    lat: -21.3885739
  },
  {
    lng: -41.2433862,
    lat: -21.3885735
  },
  {
    lng: -41.2433877,
    lat: -21.388573
  },
  {
    lng: -41.2433891,
    lat: -21.3885726
  },
  {
    lng: -41.2433906,
    lat: -21.3885721
  },
  {
    lng: -41.243392,
    lat: -21.3885717
  },
  {
    lng: -41.2433935,
    lat: -21.3885712
  },
  {
    lng: -41.2433949,
    lat: -21.3885707
  },
  {
    lng: -41.2433963,
    lat: -21.3885702
  },
  {
    lng: -41.2433978,
    lat: -21.3885697
  },
  {
    lng: -41.2433992,
    lat: -21.3885692
  },
  {
    lng: -41.2434007,
    lat: -21.3885687
  },
  {
    lng: -41.2434021,
    lat: -21.3885682
  },
  {
    lng: -41.2434035,
    lat: -21.3885677
  },
  {
    lng: -41.2434049,
    lat: -21.3885672
  },
  {
    lng: -41.2434064,
    lat: -21.3885667
  },
  {
    lng: -41.2434078,
    lat: -21.3885661
  },
  {
    lng: -41.2434092,
    lat: -21.3885656
  },
  {
    lng: -41.2434106,
    lat: -21.388565
  },
  {
    lng: -41.243412,
    lat: -21.3885645
  },
  {
    lng: -41.2434134,
    lat: -21.3885639
  },
  {
    lng: -41.2434149,
    lat: -21.3885634
  },
  {
    lng: -41.2434163,
    lat: -21.3885628
  },
  {
    lng: -41.2434177,
    lat: -21.3885622
  },
  {
    lng: -41.2434191,
    lat: -21.3885616
  },
  {
    lng: -41.2434205,
    lat: -21.388561
  },
  {
    lng: -41.2434219,
    lat: -21.3885604
  },
  {
    lng: -41.2434233,
    lat: -21.3885598
  },
  {
    lng: -41.2434247,
    lat: -21.3885592
  },
  {
    lng: -41.243426,
    lat: -21.3885586
  },
  {
    lng: -41.2434274,
    lat: -21.388558
  },
  {
    lng: -41.2434288,
    lat: -21.3885573
  },
  {
    lng: -41.2434302,
    lat: -21.3885567
  },
  {
    lng: -41.2434316,
    lat: -21.388556
  },
  {
    lng: -41.2434329,
    lat: -21.3885554
  },
  {
    lng: -41.2434343,
    lat: -21.3885547
  },
  {
    lng: -41.2434357,
    lat: -21.3885541
  },
  {
    lng: -41.243437,
    lat: -21.3885534
  },
  {
    lng: -41.2434384,
    lat: -21.3885527
  },
  {
    lng: -41.2434398,
    lat: -21.3885521
  },
  {
    lng: -41.2434411,
    lat: -21.3885514
  },
  {
    lng: -41.2434425,
    lat: -21.3885507
  },
  {
    lng: -41.2434438,
    lat: -21.38855
  },
  {
    lng: -41.2434452,
    lat: -21.3885493
  },
  {
    lng: -41.2434465,
    lat: -21.3885486
  },
  {
    lng: -41.2434479,
    lat: -21.3885479
  },
  {
    lng: -41.2434492,
    lat: -21.3885471
  },
  {
    lng: -41.2434505,
    lat: -21.3885464
  },
  {
    lng: -41.2434519,
    lat: -21.3885457
  },
  {
    lng: -41.2434532,
    lat: -21.3885449
  },
  {
    lng: -41.2434545,
    lat: -21.3885442
  },
  {
    lng: -41.2434558,
    lat: -21.3885434
  },
  {
    lng: -41.2434571,
    lat: -21.3885427
  },
  {
    lng: -41.2434585,
    lat: -21.3885419
  },
  {
    lng: -41.2434598,
    lat: -21.3885411
  },
  {
    lng: -41.2434611,
    lat: -21.3885404
  },
  {
    lng: -41.2434624,
    lat: -21.3885396
  },
  {
    lng: -41.2434637,
    lat: -21.3885388
  },
  {
    lng: -41.243465,
    lat: -21.388538
  },
  {
    lng: -41.2434663,
    lat: -21.3885372
  },
  {
    lng: -41.2434676,
    lat: -21.3885364
  },
  {
    lng: -41.2434688,
    lat: -21.3885356
  },
  {
    lng: -41.2434701,
    lat: -21.3885348
  },
  {
    lng: -41.2434714,
    lat: -21.388534
  },
  {
    lng: -41.2434727,
    lat: -21.3885331
  },
  {
    lng: -41.2434739,
    lat: -21.3885323
  },
  {
    lng: -41.2434752,
    lat: -21.3885315
  },
  {
    lng: -41.2434765,
    lat: -21.3885306
  },
  {
    lng: -41.2434777,
    lat: -21.3885298
  },
  {
    lng: -41.243479,
    lat: -21.3885289
  },
  {
    lng: -41.2434802,
    lat: -21.388528
  },
  {
    lng: -41.2434815,
    lat: -21.3885272
  },
  {
    lng: -41.2434827,
    lat: -21.3885263
  },
  {
    lng: -41.243484,
    lat: -21.3885254
  },
  {
    lng: -41.2434852,
    lat: -21.3885245
  },
  {
    lng: -41.2434864,
    lat: -21.3885237
  },
  {
    lng: -41.2434877,
    lat: -21.3885228
  },
  {
    lng: -41.2434889,
    lat: -21.3885219
  },
  {
    lng: -41.2434901,
    lat: -21.388521
  },
  {
    lng: -41.2434913,
    lat: -21.38852
  },
  {
    lng: -41.2434925,
    lat: -21.3885191
  },
  {
    lng: -41.2434938,
    lat: -21.3885182
  },
  {
    lng: -41.243495,
    lat: -21.3885173
  },
  {
    lng: -41.2434962,
    lat: -21.3885163
  },
  {
    lng: -41.2434974,
    lat: -21.3885154
  },
  {
    lng: -41.2434985,
    lat: -21.3885145
  },
  {
    lng: -41.2434997,
    lat: -21.3885135
  },
  {
    lng: -41.2435009,
    lat: -21.3885126
  },
  {
    lng: -41.2435021,
    lat: -21.3885116
  },
  {
    lng: -41.2435033,
    lat: -21.3885106
  },
  {
    lng: -41.2435044,
    lat: -21.3885097
  },
  {
    lng: -41.2435056,
    lat: -21.3885087
  },
  {
    lng: -41.2435068,
    lat: -21.3885077
  },
  {
    lng: -41.2435079,
    lat: -21.3885067
  },
  {
    lng: -41.2435091,
    lat: -21.3885057
  },
  {
    lng: -41.2435102,
    lat: -21.3885047
  },
  {
    lng: -41.2435114,
    lat: -21.3885037
  },
  {
    lng: -41.2435125,
    lat: -21.3885027
  },
  {
    lng: -41.2435136,
    lat: -21.3885017
  },
  {
    lng: -41.2435148,
    lat: -21.3885007
  },
  {
    lng: -41.2435159,
    lat: -21.3884997
  },
  {
    lng: -41.243517,
    lat: -21.3884986
  },
  {
    lng: -41.2435181,
    lat: -21.3884976
  },
  {
    lng: -41.2435192,
    lat: -21.3884966
  },
  {
    lng: -41.2435203,
    lat: -21.3884955
  },
  {
    lng: -41.2435214,
    lat: -21.3884945
  },
  {
    lng: -41.2435225,
    lat: -21.3884934
  },
  {
    lng: -41.2435236,
    lat: -21.3884924
  },
  {
    lng: -41.2435247,
    lat: -21.3884913
  },
  {
    lng: -41.2435258,
    lat: -21.3884903
  },
  {
    lng: -41.2435269,
    lat: -21.3884892
  },
  {
    lng: -41.2435279,
    lat: -21.3884881
  },
  {
    lng: -41.243529,
    lat: -21.388487
  },
  {
    lng: -41.2435301,
    lat: -21.3884859
  },
  {
    lng: -41.2435311,
    lat: -21.3884848
  },
  {
    lng: -41.2435322,
    lat: -21.3884838
  },
  {
    lng: -41.2435332,
    lat: -21.3884827
  },
  {
    lng: -41.2435343,
    lat: -21.3884815
  },
  {
    lng: -41.2435353,
    lat: -21.3884804
  },
  {
    lng: -41.2435364,
    lat: -21.3884793
  },
  {
    lng: -41.2435374,
    lat: -21.3884782
  },
  {
    lng: -41.2435384,
    lat: -21.3884771
  },
  {
    lng: -41.2435394,
    lat: -21.388476
  },
  {
    lng: -41.2435404,
    lat: -21.3884748
  },
  {
    lng: -41.2435415,
    lat: -21.3884737
  },
  {
    lng: -41.2435425,
    lat: -21.3884725
  },
  {
    lng: -41.2435435,
    lat: -21.3884714
  },
  {
    lng: -41.2435444,
    lat: -21.3884703
  },
  {
    lng: -41.2435454,
    lat: -21.3884691
  },
  {
    lng: -41.2435464,
    lat: -21.3884679
  },
  {
    lng: -41.2435474,
    lat: -21.3884668
  },
  {
    lng: -41.2435484,
    lat: -21.3884656
  },
  {
    lng: -41.2435493,
    lat: -21.3884644
  },
  {
    lng: -41.2435503,
    lat: -21.3884633
  },
  {
    lng: -41.2435513,
    lat: -21.3884621
  },
  {
    lng: -41.2435522,
    lat: -21.3884609
  },
  {
    lng: -41.2435565,
    lat: -21.3884547
  },
  {
    lng: -41.2435609,
    lat: -21.3884486
  },
  {
    lng: -41.2435652,
    lat: -21.3884424
  },
  {
    lng: -41.2435696,
    lat: -21.3884363
  },
  {
    lng: -41.2435739,
    lat: -21.3884301
  },
  {
    lng: -41.2435783,
    lat: -21.388424
  },
  {
    lng: -41.2435827,
    lat: -21.3884179
  },
  {
    lng: -41.2435871,
    lat: -21.3884117
  },
  {
    lng: -41.2435914,
    lat: -21.3884056
  },
  {
    lng: -41.2435958,
    lat: -21.3883995
  },
  {
    lng: -41.2436002,
    lat: -21.3883934
  },
  {
    lng: -41.2436046,
    lat: -21.3883873
  },
  {
    lng: -41.243609,
    lat: -21.3883812
  },
  {
    lng: -41.2436134,
    lat: -21.388375
  },
  {
    lng: -41.2436178,
    lat: -21.3883689
  },
  {
    lng: -41.2436223,
    lat: -21.3883628
  },
  {
    lng: -41.2436267,
    lat: -21.3883567
  },
  {
    lng: -41.2436311,
    lat: -21.3883507
  },
  {
    lng: -41.2436356,
    lat: -21.3883446
  },
  {
    lng: -41.24364,
    lat: -21.3883385
  },
  {
    lng: -41.2436444,
    lat: -21.3883324
  },
  {
    lng: -41.2436489,
    lat: -21.3883263
  },
  {
    lng: -41.2436534,
    lat: -21.3883203
  },
  {
    lng: -41.2436578,
    lat: -21.3883142
  },
  {
    lng: -41.2436623,
    lat: -21.3883081
  },
  {
    lng: -41.2436668,
    lat: -21.3883021
  },
  {
    lng: -41.2436712,
    lat: -21.388296
  },
  {
    lng: -41.2436757,
    lat: -21.38829
  },
  {
    lng: -41.2436802,
    lat: -21.3882839
  },
  {
    lng: -41.2436847,
    lat: -21.3882779
  },
  {
    lng: -41.2436892,
    lat: -21.3882718
  },
  {
    lng: -41.2436937,
    lat: -21.3882658
  },
  {
    lng: -41.2436982,
    lat: -21.3882598
  },
  {
    lng: -41.2437028,
    lat: -21.3882537
  },
  {
    lng: -41.2437073,
    lat: -21.3882477
  },
  {
    lng: -41.2437118,
    lat: -21.3882417
  },
  {
    lng: -41.2437163,
    lat: -21.3882357
  },
  {
    lng: -41.2437209,
    lat: -21.3882297
  },
  {
    lng: -41.2437254,
    lat: -21.3882237
  },
  {
    lng: -41.24373,
    lat: -21.3882177
  },
  {
    lng: -41.2437345,
    lat: -21.3882117
  },
  {
    lng: -41.2437391,
    lat: -21.3882057
  },
  {
    lng: -41.2437437,
    lat: -21.3881997
  },
  {
    lng: -41.2437482,
    lat: -21.3881937
  },
  {
    lng: -41.2437528,
    lat: -21.3881877
  },
  {
    lng: -41.2437574,
    lat: -21.3881817
  },
  {
    lng: -41.243762,
    lat: -21.3881758
  },
  {
    lng: -41.2437666,
    lat: -21.3881698
  },
  {
    lng: -41.2437712,
    lat: -21.3881638
  },
  {
    lng: -41.2437758,
    lat: -21.3881579
  },
  {
    lng: -41.2437804,
    lat: -21.3881519
  },
  {
    lng: -41.2437818,
    lat: -21.3881503
  },
  {
    lng: -41.2437831,
    lat: -21.3881487
  },
  {
    lng: -41.2437845,
    lat: -21.3881472
  },
  {
    lng: -41.2437859,
    lat: -21.3881456
  },
  {
    lng: -41.2437873,
    lat: -21.388144
  },
  {
    lng: -41.2437887,
    lat: -21.3881425
  },
  {
    lng: -41.2437902,
    lat: -21.3881409
  },
  {
    lng: -41.2437916,
    lat: -21.3881394
  },
  {
    lng: -41.243793,
    lat: -21.3881378
  },
  {
    lng: -41.2437944,
    lat: -21.3881363
  },
  {
    lng: -41.2437959,
    lat: -21.3881347
  },
  {
    lng: -41.2437973,
    lat: -21.3881332
  },
  {
    lng: -41.2437987,
    lat: -21.3881317
  },
  {
    lng: -41.2438002,
    lat: -21.3881301
  },
  {
    lng: -41.2438016,
    lat: -21.3881286
  },
  {
    lng: -41.2438031,
    lat: -21.3881271
  },
  {
    lng: -41.2438046,
    lat: -21.3881256
  },
  {
    lng: -41.243806,
    lat: -21.3881241
  },
  {
    lng: -41.2438075,
    lat: -21.3881226
  },
  {
    lng: -41.243809,
    lat: -21.3881211
  },
  {
    lng: -41.2438105,
    lat: -21.3881196
  },
  {
    lng: -41.243812,
    lat: -21.3881181
  },
  {
    lng: -41.2438135,
    lat: -21.3881166
  },
  {
    lng: -41.2438149,
    lat: -21.3881151
  },
  {
    lng: -41.2438164,
    lat: -21.3881137
  },
  {
    lng: -41.243818,
    lat: -21.3881122
  },
  {
    lng: -41.2438195,
    lat: -21.3881107
  },
  {
    lng: -41.243821,
    lat: -21.3881093
  },
  {
    lng: -41.2438225,
    lat: -21.3881078
  },
  {
    lng: -41.243824,
    lat: -21.3881064
  },
  {
    lng: -41.2438256,
    lat: -21.3881049
  },
  {
    lng: -41.2438271,
    lat: -21.3881035
  },
  {
    lng: -41.2438286,
    lat: -21.3881021
  },
  {
    lng: -41.2438302,
    lat: -21.3881006
  },
  {
    lng: -41.2438317,
    lat: -21.3880992
  },
  {
    lng: -41.2438333,
    lat: -21.3880978
  },
  {
    lng: -41.2438348,
    lat: -21.3880964
  },
  {
    lng: -41.2438364,
    lat: -21.388095
  },
  {
    lng: -41.243838,
    lat: -21.3880936
  },
  {
    lng: -41.2438395,
    lat: -21.3880922
  },
  {
    lng: -41.2438411,
    lat: -21.3880908
  },
  {
    lng: -41.2438427,
    lat: -21.3880894
  },
  {
    lng: -41.2438443,
    lat: -21.388088
  },
  {
    lng: -41.2438459,
    lat: -21.3880866
  },
  {
    lng: -41.2438475,
    lat: -21.3880853
  },
  {
    lng: -41.2438491,
    lat: -21.3880839
  },
  {
    lng: -41.2438507,
    lat: -21.3880825
  },
  {
    lng: -41.2438523,
    lat: -21.3880812
  },
  {
    lng: -41.2438539,
    lat: -21.3880798
  },
  {
    lng: -41.2438555,
    lat: -21.3880785
  },
  {
    lng: -41.2438571,
    lat: -21.3880771
  },
  {
    lng: -41.2438587,
    lat: -21.3880758
  },
  {
    lng: -41.2438604,
    lat: -21.3880745
  },
  {
    lng: -41.243862,
    lat: -21.3880731
  },
  {
    lng: -41.2438636,
    lat: -21.3880718
  },
  {
    lng: -41.2438653,
    lat: -21.3880705
  },
  {
    lng: -41.2438669,
    lat: -21.3880692
  },
  {
    lng: -41.2438686,
    lat: -21.3880679
  },
  {
    lng: -41.2438702,
    lat: -21.3880666
  },
  {
    lng: -41.2438719,
    lat: -21.3880653
  },
  {
    lng: -41.2438736,
    lat: -21.388064
  },
  {
    lng: -41.2438752,
    lat: -21.3880627
  },
  {
    lng: -41.2438769,
    lat: -21.3880614
  },
  {
    lng: -41.2438786,
    lat: -21.3880602
  },
  {
    lng: -41.2438803,
    lat: -21.3880589
  },
  {
    lng: -41.2438819,
    lat: -21.3880576
  },
  {
    lng: -41.2438836,
    lat: -21.3880564
  },
  {
    lng: -41.2438853,
    lat: -21.3880551
  },
  {
    lng: -41.243887,
    lat: -21.3880539
  },
  {
    lng: -41.2438887,
    lat: -21.3880527
  },
  {
    lng: -41.2438904,
    lat: -21.3880514
  },
  {
    lng: -41.2438921,
    lat: -21.3880502
  },
  {
    lng: -41.2438938,
    lat: -21.388049
  },
  {
    lng: -41.2438956,
    lat: -21.3880478
  },
  {
    lng: -41.2438973,
    lat: -21.3880465
  },
  {
    lng: -41.243899,
    lat: -21.3880453
  },
  {
    lng: -41.2439007,
    lat: -21.3880441
  },
  {
    lng: -41.2439025,
    lat: -21.3880429
  },
  {
    lng: -41.2439042,
    lat: -21.3880418
  },
  {
    lng: -41.2439059,
    lat: -21.3880406
  },
  {
    lng: -41.2439077,
    lat: -21.3880394
  },
  {
    lng: -41.2439094,
    lat: -21.3880382
  },
  {
    lng: -41.2439112,
    lat: -21.3880371
  },
  {
    lng: -41.2439129,
    lat: -21.3880359
  },
  {
    lng: -41.2439147,
    lat: -21.3880347
  },
  {
    lng: -41.2439164,
    lat: -21.3880336
  },
  {
    lng: -41.2439182,
    lat: -21.3880325
  },
  {
    lng: -41.24392,
    lat: -21.3880313
  },
  {
    lng: -41.2439218,
    lat: -21.3880302
  },
  {
    lng: -41.2439235,
    lat: -21.3880291
  },
  {
    lng: -41.2439253,
    lat: -21.3880279
  },
  {
    lng: -41.2439271,
    lat: -21.3880268
  },
  {
    lng: -41.2439289,
    lat: -21.3880257
  },
  {
    lng: -41.2439307,
    lat: -21.3880246
  },
  {
    lng: -41.2439325,
    lat: -21.3880235
  },
  {
    lng: -41.2439343,
    lat: -21.3880224
  },
  {
    lng: -41.2439361,
    lat: -21.3880213
  },
  {
    lng: -41.2439379,
    lat: -21.3880203
  },
  {
    lng: -41.2439397,
    lat: -21.3880192
  },
  {
    lng: -41.2439415,
    lat: -21.3880181
  },
  {
    lng: -41.2439433,
    lat: -21.3880171
  },
  {
    lng: -41.2439451,
    lat: -21.388016
  },
  {
    lng: -41.2439469,
    lat: -21.3880149
  },
  {
    lng: -41.2439488,
    lat: -21.3880139
  },
  {
    lng: -41.2439506,
    lat: -21.3880129
  },
  {
    lng: -41.2439524,
    lat: -21.3880118
  },
  {
    lng: -41.2439543,
    lat: -21.3880108
  },
  {
    lng: -41.2439561,
    lat: -21.3880098
  },
  {
    lng: -41.243958,
    lat: -21.3880088
  },
  {
    lng: -41.2439598,
    lat: -21.3880078
  },
  {
    lng: -41.2439616,
    lat: -21.3880068
  },
  {
    lng: -41.2439635,
    lat: -21.3880058
  },
  {
    lng: -41.2439654,
    lat: -21.3880048
  },
  {
    lng: -41.2439672,
    lat: -21.3880038
  },
  {
    lng: -41.2439691,
    lat: -21.3880028
  },
  {
    lng: -41.2439709,
    lat: -21.3880018
  },
  {
    lng: -41.2439728,
    lat: -21.3880009
  },
  {
    lng: -41.2439747,
    lat: -21.3879999
  },
  {
    lng: -41.2439766,
    lat: -21.387999
  },
  {
    lng: -41.2439784,
    lat: -21.387998
  },
  {
    lng: -41.2439803,
    lat: -21.3879971
  },
  {
    lng: -41.2439822,
    lat: -21.3879961
  },
  {
    lng: -41.2439841,
    lat: -21.3879952
  },
  {
    lng: -41.243986,
    lat: -21.3879943
  },
  {
    lng: -41.2439879,
    lat: -21.3879934
  },
  {
    lng: -41.2439898,
    lat: -21.3879924
  },
  {
    lng: -41.2439917,
    lat: -21.3879915
  },
  {
    lng: -41.2439936,
    lat: -21.3879906
  },
  {
    lng: -41.2439955,
    lat: -21.3879897
  },
  {
    lng: -41.2439974,
    lat: -21.3879889
  },
  {
    lng: -41.2439993,
    lat: -21.387988
  },
  {
    lng: -41.2440012,
    lat: -21.3879871
  },
  {
    lng: -41.2440031,
    lat: -21.3879862
  },
  {
    lng: -41.244005,
    lat: -21.3879854
  },
  {
    lng: -41.244007,
    lat: -21.3879845
  },
  {
    lng: -41.2440089,
    lat: -21.3879837
  },
  {
    lng: -41.2440108,
    lat: -21.3879828
  },
  {
    lng: -41.2440127,
    lat: -21.387982
  },
  {
    lng: -41.2440147,
    lat: -21.3879812
  },
  {
    lng: -41.2440166,
    lat: -21.3879803
  },
  {
    lng: -41.2440185,
    lat: -21.3879795
  },
  {
    lng: -41.2440205,
    lat: -21.3879787
  },
  {
    lng: -41.2440224,
    lat: -21.3879779
  },
  {
    lng: -41.2440244,
    lat: -21.3879771
  },
  {
    lng: -41.2440263,
    lat: -21.3879763
  },
  {
    lng: -41.2440283,
    lat: -21.3879755
  },
  {
    lng: -41.2440302,
    lat: -21.3879747
  },
  {
    lng: -41.2440322,
    lat: -21.387974
  },
  {
    lng: -41.2440341,
    lat: -21.3879732
  },
  {
    lng: -41.2440361,
    lat: -21.3879724
  },
  {
    lng: -41.2440381,
    lat: -21.3879717
  },
  {
    lng: -41.24404,
    lat: -21.3879709
  },
  {
    lng: -41.244042,
    lat: -21.3879702
  },
  {
    lng: -41.244044,
    lat: -21.3879694
  },
  {
    lng: -41.2440459,
    lat: -21.3879687
  },
  {
    lng: -41.2440479,
    lat: -21.387968
  },
  {
    lng: -41.2440499,
    lat: -21.3879673
  },
  {
    lng: -41.2440519,
    lat: -21.3879666
  },
  {
    lng: -41.2440539,
    lat: -21.3879659
  },
  {
    lng: -41.2440558,
    lat: -21.3879652
  },
  {
    lng: -41.2440578,
    lat: -21.3879645
  },
  {
    lng: -41.2440598,
    lat: -21.3879638
  },
  {
    lng: -41.2440618,
    lat: -21.3879631
  },
  {
    lng: -41.2440638,
    lat: -21.3879624
  },
  {
    lng: -41.2440658,
    lat: -21.3879618
  },
  {
    lng: -41.2440678,
    lat: -21.3879611
  },
  {
    lng: -41.2440698,
    lat: -21.3879605
  },
  {
    lng: -41.2440718,
    lat: -21.3879598
  },
  {
    lng: -41.2440738,
    lat: -21.3879592
  },
  {
    lng: -41.2440758,
    lat: -21.3879585
  },
  {
    lng: -41.2440778,
    lat: -21.3879579
  },
  {
    lng: -41.2440798,
    lat: -21.3879573
  },
  {
    lng: -41.2440818,
    lat: -21.3879567
  },
  {
    lng: -41.2440838,
    lat: -21.3879561
  },
  {
    lng: -41.2440859,
    lat: -21.3879555
  },
  {
    lng: -41.2440879,
    lat: -21.3879549
  },
  {
    lng: -41.2440899,
    lat: -21.3879543
  },
  {
    lng: -41.2440919,
    lat: -21.3879537
  },
  {
    lng: -41.2440939,
    lat: -21.3879531
  },
  {
    lng: -41.244096,
    lat: -21.3879526
  },
  {
    lng: -41.244098,
    lat: -21.387952
  },
  {
    lng: -41.2441,
    lat: -21.3879515
  },
  {
    lng: -41.2441021,
    lat: -21.3879509
  },
  {
    lng: -41.2441041,
    lat: -21.3879504
  },
  {
    lng: -41.2441061,
    lat: -21.3879498
  },
  {
    lng: -41.2441082,
    lat: -21.3879493
  },
  {
    lng: -41.2441102,
    lat: -21.3879488
  },
  {
    lng: -41.2441122,
    lat: -21.3879483
  },
  {
    lng: -41.2441143,
    lat: -21.3879478
  },
  {
    lng: -41.2441163,
    lat: -21.3879473
  },
  {
    lng: -41.2441184,
    lat: -21.3879468
  },
  {
    lng: -41.2441204,
    lat: -21.3879463
  },
  {
    lng: -41.2441225,
    lat: -21.3879458
  },
  {
    lng: -41.2441245,
    lat: -21.3879453
  },
  {
    lng: -41.2441266,
    lat: -21.3879448
  },
  {
    lng: -41.2441286,
    lat: -21.3879444
  },
  {
    lng: -41.2441307,
    lat: -21.3879439
  },
  {
    lng: -41.2441327,
    lat: -21.3879435
  },
  {
    lng: -41.2441348,
    lat: -21.387943
  },
  {
    lng: -41.2441368,
    lat: -21.3879426
  },
  {
    lng: -41.2441389,
    lat: -21.3879422
  },
  {
    lng: -41.244141,
    lat: -21.3879418
  },
  {
    lng: -41.244143,
    lat: -21.3879413
  },
  {
    lng: -41.2441451,
    lat: -21.3879409
  },
  {
    lng: -41.2441471,
    lat: -21.3879405
  },
  {
    lng: -41.2441492,
    lat: -21.3879401
  },
  {
    lng: -41.2441513,
    lat: -21.3879397
  },
  {
    lng: -41.2441533,
    lat: -21.3879394
  },
  {
    lng: -41.2441554,
    lat: -21.387939
  },
  {
    lng: -41.2441575,
    lat: -21.3879386
  },
  {
    lng: -41.2441596,
    lat: -21.3879383
  },
  {
    lng: -41.2441616,
    lat: -21.3879379
  },
  {
    lng: -41.2441637,
    lat: -21.3879376
  },
  {
    lng: -41.2441658,
    lat: -21.3879372
  },
  {
    lng: -41.2441679,
    lat: -21.3879369
  },
  {
    lng: -41.2441699,
    lat: -21.3879366
  },
  {
    lng: -41.244172,
    lat: -21.3879362
  },
  {
    lng: -41.2441741,
    lat: -21.3879359
  },
  {
    lng: -41.2441762,
    lat: -21.3879356
  },
  {
    lng: -41.2441783,
    lat: -21.3879353
  },
  {
    lng: -41.2441803,
    lat: -21.387935
  },
  {
    lng: -41.2441824,
    lat: -21.3879347
  },
  {
    lng: -41.2441845,
    lat: -21.3879344
  },
  {
    lng: -41.2441866,
    lat: -21.3879342
  },
  {
    lng: -41.2441887,
    lat: -21.3879339
  },
  {
    lng: -41.2441908,
    lat: -21.3879336
  },
  {
    lng: -41.2441929,
    lat: -21.3879334
  },
  {
    lng: -41.2441949,
    lat: -21.3879331
  },
  {
    lng: -41.244197,
    lat: -21.3879329
  },
  {
    lng: -41.2441991,
    lat: -21.3879327
  },
  {
    lng: -41.2442012,
    lat: -21.3879324
  },
  {
    lng: -41.2442033,
    lat: -21.3879322
  },
  {
    lng: -41.2442054,
    lat: -21.387932
  },
  {
    lng: -41.2442075,
    lat: -21.3879318
  },
  {
    lng: -41.2442096,
    lat: -21.3879316
  },
  {
    lng: -41.2442117,
    lat: -21.3879314
  },
  {
    lng: -41.2442138,
    lat: -21.3879312
  },
  {
    lng: -41.2442159,
    lat: -21.387931
  },
  {
    lng: -41.244218,
    lat: -21.3879309
  },
  {
    lng: -41.2442201,
    lat: -21.3879307
  },
  {
    lng: -41.2442222,
    lat: -21.3879305
  },
  {
    lng: -41.2442243,
    lat: -21.3879304
  },
  {
    lng: -41.2442264,
    lat: -21.3879303
  },
  {
    lng: -41.2442285,
    lat: -21.3879301
  },
  {
    lng: -41.2442306,
    lat: -21.38793
  },
  {
    lng: -41.2442327,
    lat: -21.3879299
  },
  {
    lng: -41.2442348,
    lat: -21.3879297
  },
  {
    lng: -41.2442369,
    lat: -21.3879296
  },
  {
    lng: -41.244239,
    lat: -21.3879295
  },
  {
    lng: -41.2442411,
    lat: -21.3879294
  },
  {
    lng: -41.2442432,
    lat: -21.3879293
  },
  {
    lng: -41.2442453,
    lat: -21.3879293
  },
  {
    lng: -41.2442474,
    lat: -21.3879292
  },
  {
    lng: -41.2442495,
    lat: -21.3879291
  },
  {
    lng: -41.2442516,
    lat: -21.387929
  },
  {
    lng: -41.2442537,
    lat: -21.387929
  },
  {
    lng: -41.2442558,
    lat: -21.3879289
  },
  {
    lng: -41.2442579,
    lat: -21.3879289
  },
  {
    lng: -41.24426,
    lat: -21.3879289
  },
  {
    lng: -41.2442621,
    lat: -21.3879288
  },
  {
    lng: -41.2442642,
    lat: -21.3879288
  },
  {
    lng: -41.2442663,
    lat: -21.3879288
  },
  {
    lng: -41.2442684,
    lat: -21.3879288
  },
  {
    lng: -41.2442705,
    lat: -21.3879288
  },
  {
    lng: -41.2442726,
    lat: -21.3879288
  },
  {
    lng: -41.2442747,
    lat: -21.3879288
  },
  {
    lng: -41.2442768,
    lat: -21.3879288
  },
  {
    lng: -41.2442789,
    lat: -21.3879288
  },
  {
    lng: -41.244281,
    lat: -21.3879289
  },
  {
    lng: -41.2442831,
    lat: -21.3879289
  },
  {
    lng: -41.2442852,
    lat: -21.387929
  },
  {
    lng: -41.2442873,
    lat: -21.387929
  },
  {
    lng: -41.2442894,
    lat: -21.3879291
  },
  {
    lng: -41.2442915,
    lat: -21.3879291
  },
  {
    lng: -41.2442936,
    lat: -21.3879292
  },
  {
    lng: -41.2442957,
    lat: -21.3879293
  },
  {
    lng: -41.2442978,
    lat: -21.3879294
  },
  {
    lng: -41.2442999,
    lat: -21.3879295
  },
  {
    lng: -41.244302,
    lat: -21.3879296
  },
  {
    lng: -41.2443041,
    lat: -21.3879297
  },
  {
    lng: -41.2443062,
    lat: -21.3879298
  },
  {
    lng: -41.2443083,
    lat: -21.3879299
  },
  {
    lng: -41.2443104,
    lat: -21.38793
  },
  {
    lng: -41.2443125,
    lat: -21.3879302
  },
  {
    lng: -41.2443146,
    lat: -21.3879303
  },
  {
    lng: -41.2443167,
    lat: -21.3879305
  },
  {
    lng: -41.2443188,
    lat: -21.3879306
  },
  {
    lng: -41.2443209,
    lat: -21.3879308
  },
  {
    lng: -41.244323,
    lat: -21.3879309
  },
  {
    lng: -41.2443251,
    lat: -21.3879311
  },
  {
    lng: -41.2443272,
    lat: -21.3879313
  },
  {
    lng: -41.2443293,
    lat: -21.3879315
  },
  {
    lng: -41.2443314,
    lat: -21.3879317
  },
  {
    lng: -41.2443335,
    lat: -21.3879319
  },
  {
    lng: -41.2443356,
    lat: -21.3879321
  },
  {
    lng: -41.2443377,
    lat: -21.3879323
  },
  {
    lng: -41.2443398,
    lat: -21.3879325
  },
  {
    lng: -41.2443419,
    lat: -21.3879328
  },
  {
    lng: -41.244344,
    lat: -21.387933
  },
  {
    lng: -41.2443461,
    lat: -21.3879332
  },
  {
    lng: -41.2443558,
    lat: -21.3879326
  },
  {
    lng: -41.2443655,
    lat: -21.387932
  },
  {
    lng: -41.2443753,
    lat: -21.3879315
  },
  {
    lng: -41.244385,
    lat: -21.3879309
  },
  {
    lng: -41.2443948,
    lat: -21.3879303
  },
  {
    lng: -41.2444045,
    lat: -21.3879297
  },
  {
    lng: -41.2444143,
    lat: -21.3879292
  },
  {
    lng: -41.244424,
    lat: -21.3879286
  },
  {
    lng: -41.2444338,
    lat: -21.3879281
  },
  {
    lng: -41.2444436,
    lat: -21.3879275
  },
  {
    lng: -41.2444533,
    lat: -21.387927
  },
  {
    lng: -41.2444631,
    lat: -21.3879265
  },
  {
    lng: -41.2444728,
    lat: -21.3879259
  },
  {
    lng: -41.2444826,
    lat: -21.3879254
  },
  {
    lng: -41.2444923,
    lat: -21.3879249
  },
  {
    lng: -41.2445021,
    lat: -21.3879244
  },
  {
    lng: -41.2445118,
    lat: -21.3879239
  },
  {
    lng: -41.2445216,
    lat: -21.3879234
  },
  {
    lng: -41.2445313,
    lat: -21.3879229
  },
  {
    lng: -41.2445411,
    lat: -21.3879225
  },
  {
    lng: -41.2445508,
    lat: -21.387922
  },
  {
    lng: -41.2445606,
    lat: -21.3879215
  },
  {
    lng: -41.2445704,
    lat: -21.3879211
  },
  {
    lng: -41.2445801,
    lat: -21.3879206
  },
  {
    lng: -41.2445899,
    lat: -21.3879202
  },
  {
    lng: -41.2445996,
    lat: -21.3879197
  },
  {
    lng: -41.2446094,
    lat: -21.3879193
  },
  {
    lng: -41.2446191,
    lat: -21.3879189
  },
  {
    lng: -41.2446289,
    lat: -21.3879185
  },
  {
    lng: -41.2446387,
    lat: -21.3879181
  },
  {
    lng: -41.2446484,
    lat: -21.3879177
  },
  {
    lng: -41.2446582,
    lat: -21.3879173
  },
  {
    lng: -41.2446679,
    lat: -21.3879169
  },
  {
    lng: -41.2446777,
    lat: -21.3879165
  },
  {
    lng: -41.2446875,
    lat: -21.3879161
  },
  {
    lng: -41.2446972,
    lat: -21.3879157
  },
  {
    lng: -41.244707,
    lat: -21.3879154
  },
  {
    lng: -41.2447167,
    lat: -21.387915
  },
  {
    lng: -41.2447265,
    lat: -21.3879147
  },
  {
    lng: -41.2447363,
    lat: -21.3879143
  },
  {
    lng: -41.244746,
    lat: -21.387914
  },
  {
    lng: -41.2447558,
    lat: -21.3879137
  },
  {
    lng: -41.2447655,
    lat: -21.3879133
  },
  {
    lng: -41.2447753,
    lat: -21.387913
  },
  {
    lng: -41.2447851,
    lat: -21.3879127
  },
  {
    lng: -41.2447948,
    lat: -21.3879124
  },
  {
    lng: -41.2448046,
    lat: -21.3879121
  },
  {
    lng: -41.2448144,
    lat: -21.3879118
  },
  {
    lng: -41.2448241,
    lat: -21.3879115
  },
  {
    lng: -41.2448339,
    lat: -21.3879112
  },
  {
    lng: -41.2448436,
    lat: -21.387911
  },
  {
    lng: -41.2448534,
    lat: -21.3879107
  },
  {
    lng: -41.2448632,
    lat: -21.3879104
  },
  {
    lng: -41.2448729,
    lat: -21.3879102
  },
  {
    lng: -41.2448827,
    lat: -21.38791
  },
  {
    lng: -41.2448925,
    lat: -21.3879097
  },
  {
    lng: -41.2449022,
    lat: -21.3879095
  },
  {
    lng: -41.2449071,
    lat: -21.3879093
  },
  {
    lng: -41.244912,
    lat: -21.3879091
  },
  {
    lng: -41.2449169,
    lat: -21.387909
  },
  {
    lng: -41.2449218,
    lat: -21.3879088
  },
  {
    lng: -41.2449267,
    lat: -21.3879086
  },
  {
    lng: -41.2449316,
    lat: -21.3879084
  },
  {
    lng: -41.2449365,
    lat: -21.3879082
  },
  {
    lng: -41.2449414,
    lat: -21.387908
  },
  {
    lng: -41.2449463,
    lat: -21.3879077
  },
  {
    lng: -41.2449512,
    lat: -21.3879075
  },
  {
    lng: -41.2449561,
    lat: -21.3879073
  },
  {
    lng: -41.244961,
    lat: -21.387907
  },
  {
    lng: -41.2449659,
    lat: -21.3879068
  },
  {
    lng: -41.2449708,
    lat: -21.3879065
  },
  {
    lng: -41.2449757,
    lat: -21.3879063
  },
  {
    lng: -41.2449806,
    lat: -21.387906
  },
  {
    lng: -41.2449855,
    lat: -21.3879057
  },
  {
    lng: -41.2449904,
    lat: -21.3879054
  },
  {
    lng: -41.2449953,
    lat: -21.3879052
  },
  {
    lng: -41.2450002,
    lat: -21.3879049
  },
  {
    lng: -41.2450051,
    lat: -21.3879046
  },
  {
    lng: -41.24501,
    lat: -21.3879042
  },
  {
    lng: -41.2450149,
    lat: -21.3879039
  },
  {
    lng: -41.2450198,
    lat: -21.3879036
  },
  {
    lng: -41.2450247,
    lat: -21.3879033
  },
  {
    lng: -41.2450296,
    lat: -21.3879029
  },
  {
    lng: -41.2450344,
    lat: -21.3879026
  },
  {
    lng: -41.2450393,
    lat: -21.3879022
  },
  {
    lng: -41.2450442,
    lat: -21.3879019
  },
  {
    lng: -41.2450491,
    lat: -21.3879015
  },
  {
    lng: -41.245054,
    lat: -21.3879012
  },
  {
    lng: -41.2450589,
    lat: -21.3879008
  },
  {
    lng: -41.2450638,
    lat: -21.3879004
  },
  {
    lng: -41.2450687,
    lat: -21.3879
  },
  {
    lng: -41.2450736,
    lat: -21.3878996
  },
  {
    lng: -41.2450785,
    lat: -21.3878992
  },
  {
    lng: -41.2450833,
    lat: -21.3878988
  },
  {
    lng: -41.2450882,
    lat: -21.3878984
  },
  {
    lng: -41.2450931,
    lat: -21.387898
  },
  {
    lng: -41.245098,
    lat: -21.3878975
  },
  {
    lng: -41.2451029,
    lat: -21.3878971
  },
  {
    lng: -41.2451078,
    lat: -21.3878966
  },
  {
    lng: -41.2451126,
    lat: -21.3878962
  },
  {
    lng: -41.2451175,
    lat: -21.3878957
  },
  {
    lng: -41.2451224,
    lat: -21.3878953
  },
  {
    lng: -41.2451273,
    lat: -21.3878948
  },
  {
    lng: -41.2451322,
    lat: -21.3878943
  },
  {
    lng: -41.2451371,
    lat: -21.3878938
  },
  {
    lng: -41.2451419,
    lat: -21.3878933
  },
  {
    lng: -41.2451468,
    lat: -21.3878928
  },
  {
    lng: -41.2451517,
    lat: -21.3878923
  },
  {
    lng: -41.2451566,
    lat: -21.3878918
  },
  {
    lng: -41.2451614,
    lat: -21.3878913
  },
  {
    lng: -41.2451663,
    lat: -21.3878908
  },
  {
    lng: -41.2451712,
    lat: -21.3878902
  },
  {
    lng: -41.2451761,
    lat: -21.3878897
  },
  {
    lng: -41.2451809,
    lat: -21.3878892
  },
  {
    lng: -41.2451858,
    lat: -21.3878886
  },
  {
    lng: -41.2451907,
    lat: -21.387888
  },
  {
    lng: -41.2451956,
    lat: -21.3878875
  },
  {
    lng: -41.2452004,
    lat: -21.3878869
  },
  {
    lng: -41.2452053,
    lat: -21.3878863
  },
  {
    lng: -41.2452102,
    lat: -21.3878857
  },
  {
    lng: -41.245215,
    lat: -21.3878851
  },
  {
    lng: -41.2452199,
    lat: -21.3878845
  },
  {
    lng: -41.2452248,
    lat: -21.3878839
  },
  {
    lng: -41.2452296,
    lat: -21.3878833
  },
  {
    lng: -41.2452345,
    lat: -21.3878827
  },
  {
    lng: -41.2452394,
    lat: -21.3878821
  },
  {
    lng: -41.2452442,
    lat: -21.3878814
  },
  {
    lng: -41.2452491,
    lat: -21.3878808
  },
  {
    lng: -41.2452539,
    lat: -21.3878801
  },
  {
    lng: -41.2452588,
    lat: -21.3878795
  },
  {
    lng: -41.2452637,
    lat: -21.3878788
  },
  {
    lng: -41.2452685,
    lat: -21.3878782
  },
  {
    lng: -41.2452734,
    lat: -21.3878775
  },
  {
    lng: -41.2452782,
    lat: -21.3878768
  },
  {
    lng: -41.2452831,
    lat: -21.3878761
  },
  {
    lng: -41.2452879,
    lat: -21.3878754
  },
  {
    lng: -41.2452928,
    lat: -21.3878747
  },
  {
    lng: -41.2452977,
    lat: -21.387874
  },
  {
    lng: -41.2453025,
    lat: -21.3878733
  },
  {
    lng: -41.2453074,
    lat: -21.3878726
  },
  {
    lng: -41.2453122,
    lat: -21.3878718
  },
  {
    lng: -41.2453171,
    lat: -21.3878711
  },
  {
    lng: -41.2453219,
    lat: -21.3878704
  },
  {
    lng: -41.2453267,
    lat: -21.3878696
  },
  {
    lng: -41.2453316,
    lat: -21.3878689
  },
  {
    lng: -41.2453364,
    lat: -21.3878681
  },
  {
    lng: -41.2453413,
    lat: -21.3878673
  },
  {
    lng: -41.2453461,
    lat: -21.3878666
  },
  {
    lng: -41.245351,
    lat: -21.3878658
  },
  {
    lng: -41.2453558,
    lat: -21.387865
  },
  {
    lng: -41.2453606,
    lat: -21.3878642
  },
  {
    lng: -41.2453655,
    lat: -21.3878634
  },
  {
    lng: -41.2453703,
    lat: -21.3878626
  },
  {
    lng: -41.2453752,
    lat: -21.3878618
  },
  {
    lng: -41.24538,
    lat: -21.3878609
  },
  {
    lng: -41.2453848,
    lat: -21.3878601
  },
  {
    lng: -41.2453897,
    lat: -21.3878593
  },
  {
    lng: -41.2453945,
    lat: -21.3878584
  },
  {
    lng: -41.2453993,
    lat: -21.3878576
  },
  {
    lng: -41.2454041,
    lat: -21.3878567
  },
  {
    lng: -41.245409,
    lat: -21.3878559
  },
  {
    lng: -41.2454138,
    lat: -21.387855
  },
  {
    lng: -41.2454186,
    lat: -21.3878541
  },
  {
    lng: -41.2454234,
    lat: -21.3878532
  },
  {
    lng: -41.2454283,
    lat: -21.3878524
  },
  {
    lng: -41.2454331,
    lat: -21.3878515
  },
  {
    lng: -41.2454379,
    lat: -21.3878506
  },
  {
    lng: -41.2454427,
    lat: -21.3878496
  },
  {
    lng: -41.2454475,
    lat: -21.3878487
  },
  {
    lng: -41.2454524,
    lat: -21.3878478
  },
  {
    lng: -41.2454572,
    lat: -21.3878469
  },
  {
    lng: -41.245462,
    lat: -21.3878459
  },
  {
    lng: -41.2454668,
    lat: -21.387845
  },
  {
    lng: -41.2454716,
    lat: -21.387844
  },
  {
    lng: -41.2454764,
    lat: -21.3878431
  },
  {
    lng: -41.2454812,
    lat: -21.3878421
  },
  {
    lng: -41.245486,
    lat: -21.3878412
  },
  {
    lng: -41.2454908,
    lat: -21.3878402
  },
  {
    lng: -41.2454957,
    lat: -21.3878392
  },
  {
    lng: -41.2455005,
    lat: -21.3878382
  },
  {
    lng: -41.2455053,
    lat: -21.3878372
  },
  {
    lng: -41.2455101,
    lat: -21.3878362
  },
  {
    lng: -41.2455149,
    lat: -21.3878352
  },
  {
    lng: -41.2455197,
    lat: -21.3878342
  },
  {
    lng: -41.2455244,
    lat: -21.3878332
  },
  {
    lng: -41.2455292,
    lat: -21.3878321
  },
  {
    lng: -41.245534,
    lat: -21.3878311
  },
  {
    lng: -41.2455388,
    lat: -21.38783
  },
  {
    lng: -41.2455436,
    lat: -21.387829
  },
  {
    lng: -41.2455484,
    lat: -21.3878279
  },
  {
    lng: -41.2455532,
    lat: -21.3878269
  },
  {
    lng: -41.245558,
    lat: -21.3878258
  },
  {
    lng: -41.2455628,
    lat: -21.3878247
  },
  {
    lng: -41.2455675,
    lat: -21.3878236
  },
  {
    lng: -41.2455723,
    lat: -21.3878226
  },
  {
    lng: -41.2455771,
    lat: -21.3878215
  },
  {
    lng: -41.2455819,
    lat: -21.3878204
  },
  {
    lng: -41.2455867,
    lat: -21.3878192
  },
  {
    lng: -41.2455914,
    lat: -21.3878181
  },
  {
    lng: -41.2455962,
    lat: -21.387817
  },
  {
    lng: -41.245601,
    lat: -21.3878159
  },
  {
    lng: -41.2456058,
    lat: -21.3878147
  },
  {
    lng: -41.2456105,
    lat: -21.3878136
  },
  {
    lng: -41.2456153,
    lat: -21.3878125
  },
  {
    lng: -41.2456201,
    lat: -21.3878113
  },
  {
    lng: -41.2456248,
    lat: -21.3878101
  },
  {
    lng: -41.2456296,
    lat: -21.387809
  },
  {
    lng: -41.2456343,
    lat: -21.3878078
  },
  {
    lng: -41.2456391,
    lat: -21.3878066
  },
  {
    lng: -41.2456439,
    lat: -21.3878054
  },
  {
    lng: -41.2456486,
    lat: -21.3878042
  },
  {
    lng: -41.2456534,
    lat: -21.387803
  },
  {
    lng: -41.2456581,
    lat: -21.3878018
  },
  {
    lng: -41.2456629,
    lat: -21.3878006
  },
  {
    lng: -41.2456676,
    lat: -21.3877994
  },
  {
    lng: -41.2456724,
    lat: -21.3877981
  },
  {
    lng: -41.2456771,
    lat: -21.3877969
  },
  {
    lng: -41.2456819,
    lat: -21.3877957
  },
  {
    lng: -41.2456866,
    lat: -21.3877944
  },
  {
    lng: -41.2456913,
    lat: -21.3877932
  },
  {
    lng: -41.2456961,
    lat: -21.3877919
  },
  {
    lng: -41.2457008,
    lat: -21.3877906
  },
  {
    lng: -41.2457046,
    lat: -21.3877894
  },
  {
    lng: -41.2457083,
    lat: -21.3877883
  },
  {
    lng: -41.245712,
    lat: -21.3877871
  },
  {
    lng: -41.2457158,
    lat: -21.3877859
  },
  {
    lng: -41.2457195,
    lat: -21.3877847
  },
  {
    lng: -41.2457233,
    lat: -21.3877836
  },
  {
    lng: -41.245727,
    lat: -21.3877824
  },
  {
    lng: -41.2457308,
    lat: -21.3877813
  },
  {
    lng: -41.2457345,
    lat: -21.3877801
  },
  {
    lng: -41.2457383,
    lat: -21.387779
  },
  {
    lng: -41.245742,
    lat: -21.3877779
  },
  {
    lng: -41.2457458,
    lat: -21.3877767
  },
  {
    lng: -41.2457496,
    lat: -21.3877756
  },
  {
    lng: -41.2457533,
    lat: -21.3877745
  },
  {
    lng: -41.2457571,
    lat: -21.3877734
  },
  {
    lng: -41.2457609,
    lat: -21.3877723
  },
  {
    lng: -41.2457646,
    lat: -21.3877712
  },
  {
    lng: -41.2457684,
    lat: -21.3877701
  },
  {
    lng: -41.2457722,
    lat: -21.3877691
  },
  {
    lng: -41.2457759,
    lat: -21.387768
  },
  {
    lng: -41.2457797,
    lat: -21.3877669
  },
  {
    lng: -41.2457835,
    lat: -21.3877659
  },
  {
    lng: -41.2457873,
    lat: -21.3877648
  },
  {
    lng: -41.2457911,
    lat: -21.3877638
  },
  {
    lng: -41.2457948,
    lat: -21.3877627
  },
  {
    lng: -41.2457986,
    lat: -21.3877617
  },
  {
    lng: -41.2458024,
    lat: -21.3877607
  },
  {
    lng: -41.2458062,
    lat: -21.3877597
  },
  {
    lng: -41.24581,
    lat: -21.3877587
  },
  {
    lng: -41.2458138,
    lat: -21.3877577
  },
  {
    lng: -41.2458176,
    lat: -21.3877567
  },
  {
    lng: -41.2458214,
    lat: -21.3877557
  },
  {
    lng: -41.2458252,
    lat: -21.3877547
  },
  {
    lng: -41.245829,
    lat: -21.3877537
  },
  {
    lng: -41.2458328,
    lat: -21.3877527
  },
  {
    lng: -41.2458366,
    lat: -21.3877518
  },
  {
    lng: -41.2458404,
    lat: -21.3877508
  },
  {
    lng: -41.2458442,
    lat: -21.3877499
  },
  {
    lng: -41.245848,
    lat: -21.3877489
  },
  {
    lng: -41.2458518,
    lat: -21.387748
  },
  {
    lng: -41.2458556,
    lat: -21.3877471
  },
  {
    lng: -41.2458594,
    lat: -21.3877461
  },
  {
    lng: -41.2458632,
    lat: -21.3877452
  },
  {
    lng: -41.245867,
    lat: -21.3877443
  },
  {
    lng: -41.2458709,
    lat: -21.3877434
  },
  {
    lng: -41.2458747,
    lat: -21.3877425
  },
  {
    lng: -41.2458785,
    lat: -21.3877416
  },
  {
    lng: -41.2458823,
    lat: -21.3877407
  },
  {
    lng: -41.2458861,
    lat: -21.3877398
  },
  {
    lng: -41.24589,
    lat: -21.387739
  },
  {
    lng: -41.2458938,
    lat: -21.3877381
  },
  {
    lng: -41.2458976,
    lat: -21.3877372
  },
  {
    lng: -41.2459014,
    lat: -21.3877364
  },
  {
    lng: -41.2459053,
    lat: -21.3877355
  },
  {
    lng: -41.2459091,
    lat: -21.3877347
  },
  {
    lng: -41.2459129,
    lat: -21.3877339
  },
  {
    lng: -41.2459168,
    lat: -21.387733
  },
  {
    lng: -41.2459206,
    lat: -21.3877322
  },
  {
    lng: -41.2459245,
    lat: -21.3877314
  },
  {
    lng: -41.2459283,
    lat: -21.3877306
  },
  {
    lng: -41.2459321,
    lat: -21.3877298
  },
  {
    lng: -41.245936,
    lat: -21.387729
  },
  {
    lng: -41.2459398,
    lat: -21.3877282
  },
  {
    lng: -41.2459437,
    lat: -21.3877275
  },
  {
    lng: -41.2459475,
    lat: -21.3877267
  },
  {
    lng: -41.2459514,
    lat: -21.3877259
  },
  {
    lng: -41.2459552,
    lat: -21.3877252
  },
  {
    lng: -41.2459591,
    lat: -21.3877244
  },
  {
    lng: -41.2459629,
    lat: -21.3877237
  },
  {
    lng: -41.2459668,
    lat: -21.3877229
  },
  {
    lng: -41.2459706,
    lat: -21.3877222
  },
  {
    lng: -41.2459745,
    lat: -21.3877215
  },
  {
    lng: -41.2459783,
    lat: -21.3877208
  },
  {
    lng: -41.2459822,
    lat: -21.38772
  },
  {
    lng: -41.245986,
    lat: -21.3877193
  },
  {
    lng: -41.2459881,
    lat: -21.3877188
  },
  {
    lng: -41.2459903,
    lat: -21.3877183
  },
  {
    lng: -41.2459924,
    lat: -21.3877178
  },
  {
    lng: -41.2459945,
    lat: -21.3877173
  },
  {
    lng: -41.2459966,
    lat: -21.3877168
  },
  {
    lng: -41.2459987,
    lat: -21.3877163
  },
  {
    lng: -41.2460008,
    lat: -21.3877158
  },
  {
    lng: -41.246003,
    lat: -21.3877153
  },
  {
    lng: -41.2460051,
    lat: -21.3877148
  },
  {
    lng: -41.2460072,
    lat: -21.3877144
  },
  {
    lng: -41.2460093,
    lat: -21.3877139
  },
  {
    lng: -41.2460115,
    lat: -21.3877135
  },
  {
    lng: -41.2460136,
    lat: -21.387713
  },
  {
    lng: -41.2460157,
    lat: -21.3877126
  },
  {
    lng: -41.2460179,
    lat: -21.3877121
  },
  {
    lng: -41.24602,
    lat: -21.3877117
  },
  {
    lng: -41.2460221,
    lat: -21.3877113
  },
  {
    lng: -41.2460243,
    lat: -21.3877109
  },
  {
    lng: -41.2460264,
    lat: -21.3877105
  },
  {
    lng: -41.2460285,
    lat: -21.3877101
  },
  {
    lng: -41.2460307,
    lat: -21.3877097
  },
  {
    lng: -41.2460328,
    lat: -21.3877093
  },
  {
    lng: -41.246035,
    lat: -21.3877089
  },
  {
    lng: -41.2460371,
    lat: -21.3877085
  },
  {
    lng: -41.2460392,
    lat: -21.3877082
  },
  {
    lng: -41.2460414,
    lat: -21.3877078
  },
  {
    lng: -41.2460435,
    lat: -21.3877075
  },
  {
    lng: -41.2460457,
    lat: -21.3877071
  },
  {
    lng: -41.2460478,
    lat: -21.3877068
  },
  {
    lng: -41.24605,
    lat: -21.3877064
  },
  {
    lng: -41.2460521,
    lat: -21.3877061
  },
  {
    lng: -41.2460543,
    lat: -21.3877058
  },
  {
    lng: -41.2460564,
    lat: -21.3877055
  },
  {
    lng: -41.2460586,
    lat: -21.3877052
  },
  {
    lng: -41.2460607,
    lat: -21.3877049
  },
  {
    lng: -41.2460629,
    lat: -21.3877046
  },
  {
    lng: -41.2460651,
    lat: -21.3877043
  },
  {
    lng: -41.2460672,
    lat: -21.387704
  },
  {
    lng: -41.2460694,
    lat: -21.3877037
  },
  {
    lng: -41.2460715,
    lat: -21.3877035
  },
  {
    lng: -41.2460737,
    lat: -21.3877032
  },
  {
    lng: -41.2460758,
    lat: -21.387703
  },
  {
    lng: -41.246078,
    lat: -21.3877027
  },
  {
    lng: -41.2460802,
    lat: -21.3877025
  },
  {
    lng: -41.2460823,
    lat: -21.3877022
  },
  {
    lng: -41.2460845,
    lat: -21.387702
  },
  {
    lng: -41.2460867,
    lat: -21.3877018
  },
  {
    lng: -41.2460888,
    lat: -21.3877016
  },
  {
    lng: -41.246091,
    lat: -21.3877014
  },
  {
    lng: -41.2460932,
    lat: -21.3877012
  },
  {
    lng: -41.2460953,
    lat: -21.387701
  },
  {
    lng: -41.2460975,
    lat: -21.3877008
  },
  {
    lng: -41.2460997,
    lat: -21.3877006
  },
  {
    lng: -41.2461018,
    lat: -21.3877005
  },
  {
    lng: -41.246104,
    lat: -21.3877003
  },
  {
    lng: -41.2461062,
    lat: -21.3877001
  },
  {
    lng: -41.2461083,
    lat: -21.3877
  },
  {
    lng: -41.2461105,
    lat: -21.3876999
  },
  {
    lng: -41.2461127,
    lat: -21.3876997
  },
  {
    lng: -41.2461149,
    lat: -21.3876996
  },
  {
    lng: -41.246117,
    lat: -21.3876995
  },
  {
    lng: -41.2461192,
    lat: -21.3876993
  },
  {
    lng: -41.2461214,
    lat: -21.3876992
  },
  {
    lng: -41.2461235,
    lat: -21.3876991
  },
  {
    lng: -41.2461257,
    lat: -21.387699
  },
  {
    lng: -41.2461279,
    lat: -21.3876989
  },
  {
    lng: -41.2461301,
    lat: -21.3876989
  },
  {
    lng: -41.2461322,
    lat: -21.3876988
  },
  {
    lng: -41.2461344,
    lat: -21.3876987
  },
  {
    lng: -41.2461366,
    lat: -21.3876987
  },
  {
    lng: -41.2461388,
    lat: -21.3876986
  },
  {
    lng: -41.2461409,
    lat: -21.3876986
  },
  {
    lng: -41.2461431,
    lat: -21.3876985
  },
  {
    lng: -41.2461453,
    lat: -21.3876985
  },
  {
    lng: -41.2461475,
    lat: -21.3876984
  },
  {
    lng: -41.2461496,
    lat: -21.3876984
  },
  {
    lng: -41.2461518,
    lat: -21.3876984
  },
  {
    lng: -41.246154,
    lat: -21.3876984
  },
  {
    lng: -41.2461562,
    lat: -21.3876984
  },
  {
    lng: -41.2461583,
    lat: -21.3876984
  },
  {
    lng: -41.2461605,
    lat: -21.3876984
  },
  {
    lng: -41.2461627,
    lat: -21.3876984
  },
  {
    lng: -41.2461649,
    lat: -21.3876985
  },
  {
    lng: -41.246167,
    lat: -21.3876985
  },
  {
    lng: -41.2461692,
    lat: -21.3876985
  },
  {
    lng: -41.2461714,
    lat: -21.3876986
  },
  {
    lng: -41.2461736,
    lat: -21.3876986
  },
  {
    lng: -41.2461757,
    lat: -21.3876987
  },
  {
    lng: -41.2461779,
    lat: -21.3876988
  },
  {
    lng: -41.2461801,
    lat: -21.3876988
  },
  {
    lng: -41.2461822,
    lat: -21.3876989
  },
  {
    lng: -41.2461844,
    lat: -21.387699
  },
  {
    lng: -41.2461866,
    lat: -21.3876991
  },
  {
    lng: -41.2461888,
    lat: -21.3876992
  },
  {
    lng: -41.2461909,
    lat: -21.3876993
  },
  {
    lng: -41.2461931,
    lat: -21.3876994
  },
  {
    lng: -41.2461953,
    lat: -21.3876995
  },
  {
    lng: -41.2461975,
    lat: -21.3876997
  },
  {
    lng: -41.2461996,
    lat: -21.3876998
  },
  {
    lng: -41.2462018,
    lat: -21.3877
  },
  {
    lng: -41.246204,
    lat: -21.3877001
  },
  {
    lng: -41.2462061,
    lat: -21.3877003
  },
  {
    lng: -41.2462083,
    lat: -21.3877004
  },
  {
    lng: -41.2462105,
    lat: -21.3877006
  },
  {
    lng: -41.2462126,
    lat: -21.3877008
  },
  {
    lng: -41.2462148,
    lat: -21.3877009
  },
  {
    lng: -41.246217,
    lat: -21.3877011
  },
  {
    lng: -41.2462191,
    lat: -21.3877013
  },
  {
    lng: -41.2462213,
    lat: -21.3877015
  },
  {
    lng: -41.2462235,
    lat: -21.3877017
  },
  {
    lng: -41.2462256,
    lat: -21.387702
  },
  {
    lng: -41.2462278,
    lat: -21.3877022
  },
  {
    lng: -41.24623,
    lat: -21.3877024
  },
  {
    lng: -41.2462321,
    lat: -21.3877026
  },
  {
    lng: -41.2462343,
    lat: -21.3877029
  },
  {
    lng: -41.2462365,
    lat: -21.3877031
  },
  {
    lng: -41.2462386,
    lat: -21.3877034
  },
  {
    lng: -41.2462408,
    lat: -21.3877037
  },
  {
    lng: -41.2462429,
    lat: -21.3877039
  },
  {
    lng: -41.2462451,
    lat: -21.3877042
  },
  {
    lng: -41.2462472,
    lat: -21.3877045
  },
  {
    lng: -41.2462494,
    lat: -21.3877048
  },
  {
    lng: -41.2462516,
    lat: -21.3877051
  },
  {
    lng: -41.2462537,
    lat: -21.3877054
  },
  {
    lng: -41.2462559,
    lat: -21.3877057
  },
  {
    lng: -41.246258,
    lat: -21.387706
  },
  {
    lng: -41.2462602,
    lat: -21.3877063
  },
  {
    lng: -41.2462623,
    lat: -21.3877067
  },
  {
    lng: -41.2462645,
    lat: -21.387707
  },
  {
    lng: -41.2462666,
    lat: -21.3877074
  },
  {
    lng: -41.2462688,
    lat: -21.3877077
  },
  {
    lng: -41.2462709,
    lat: -21.3877081
  },
  {
    lng: -41.246273,
    lat: -21.3877084
  },
  {
    lng: -41.2462752,
    lat: -21.3877088
  },
  {
    lng: -41.2462773,
    lat: -21.3877092
  },
  {
    lng: -41.2462795,
    lat: -21.3877096
  },
  {
    lng: -41.2462816,
    lat: -21.38771
  },
  {
    lng: -41.2462837,
    lat: -21.3877103
  },
  {
    lng: -41.2462859,
    lat: -21.3877108
  },
  {
    lng: -41.246288,
    lat: -21.3877112
  },
  {
    lng: -41.2462902,
    lat: -21.3877116
  },
  {
    lng: -41.2462923,
    lat: -21.387712
  },
  {
    lng: -41.2462944,
    lat: -21.3877124
  },
  {
    lng: -41.2462965,
    lat: -21.3877129
  },
  {
    lng: -41.2462987,
    lat: -21.3877133
  },
  {
    lng: -41.2463008,
    lat: -21.3877138
  },
  {
    lng: -41.2463029,
    lat: -21.3877142
  },
  {
    lng: -41.2463051,
    lat: -21.3877147
  },
  {
    lng: -41.2463072,
    lat: -21.3877152
  },
  {
    lng: -41.2463093,
    lat: -21.3877156
  },
  {
    lng: -41.2463114,
    lat: -21.3877161
  },
  {
    lng: -41.2463135,
    lat: -21.3877166
  },
  {
    lng: -41.2463157,
    lat: -21.3877171
  },
  {
    lng: -41.2463178,
    lat: -21.3877176
  },
  {
    lng: -41.2463199,
    lat: -21.3877181
  },
  {
    lng: -41.246322,
    lat: -21.3877187
  },
  {
    lng: -41.2463241,
    lat: -21.3877192
  },
  {
    lng: -41.2463262,
    lat: -21.3877197
  },
  {
    lng: -41.2463283,
    lat: -21.3877202
  },
  {
    lng: -41.2463304,
    lat: -21.3877208
  },
  {
    lng: -41.2463325,
    lat: -21.3877213
  },
  {
    lng: -41.2463346,
    lat: -21.3877219
  },
  {
    lng: -41.2463367,
    lat: -21.3877225
  },
  {
    lng: -41.2463388,
    lat: -21.387723
  },
  {
    lng: -41.2463409,
    lat: -21.3877236
  },
  {
    lng: -41.246343,
    lat: -21.3877242
  },
  {
    lng: -41.2463451,
    lat: -21.3877248
  },
  {
    lng: -41.2463472,
    lat: -21.3877254
  },
  {
    lng: -41.2463493,
    lat: -21.387726
  },
  {
    lng: -41.2463514,
    lat: -21.3877266
  },
  {
    lng: -41.2463535,
    lat: -21.3877272
  },
  {
    lng: -41.2463556,
    lat: -21.3877278
  },
  {
    lng: -41.2463577,
    lat: -21.3877285
  },
  {
    lng: -41.2463597,
    lat: -21.3877291
  },
  {
    lng: -41.2463618,
    lat: -21.3877297
  },
  {
    lng: -41.2463639,
    lat: -21.3877304
  },
  {
    lng: -41.246366,
    lat: -21.387731
  },
  {
    lng: -41.246368,
    lat: -21.3877317
  },
  {
    lng: -41.2463701,
    lat: -21.3877324
  },
  {
    lng: -41.2463722,
    lat: -21.3877331
  },
  {
    lng: -41.2463742,
    lat: -21.3877337
  },
  {
    lng: -41.2463763,
    lat: -21.3877344
  },
  {
    lng: -41.2463784,
    lat: -21.3877351
  },
  {
    lng: -41.2463804,
    lat: -21.3877358
  },
  {
    lng: -41.2463825,
    lat: -21.3877365
  },
  {
    lng: -41.2463845,
    lat: -21.3877372
  },
  {
    lng: -41.2463866,
    lat: -21.387738
  },
  {
    lng: -41.2463886,
    lat: -21.3877387
  },
  {
    lng: -41.2463907,
    lat: -21.3877394
  },
  {
    lng: -41.2463927,
    lat: -21.3877402
  },
  {
    lng: -41.2463948,
    lat: -21.3877409
  },
  {
    lng: -41.2463968,
    lat: -21.3877417
  },
  {
    lng: -41.2463989,
    lat: -21.3877424
  },
  {
    lng: -41.2464009,
    lat: -21.3877432
  },
  {
    lng: -41.2464029,
    lat: -21.3877439
  },
  {
    lng: -41.246405,
    lat: -21.3877447
  },
  {
    lng: -41.246407,
    lat: -21.3877455
  },
  {
    lng: -41.246409,
    lat: -21.3877463
  },
  {
    lng: -41.246411,
    lat: -21.3877471
  },
  {
    lng: -41.2464131,
    lat: -21.3877479
  },
  {
    lng: -41.2464151,
    lat: -21.3877487
  },
  {
    lng: -41.2464171,
    lat: -21.3877495
  },
  {
    lng: -41.2464191,
    lat: -21.3877503
  },
  {
    lng: -41.2464211,
    lat: -21.3877512
  },
  {
    lng: -41.2464231,
    lat: -21.387752
  },
  {
    lng: -41.2464251,
    lat: -21.3877528
  },
  {
    lng: -41.2464271,
    lat: -21.3877537
  },
  {
    lng: -41.2464291,
    lat: -21.3877545
  },
  {
    lng: -41.2464311,
    lat: -21.3877554
  },
  {
    lng: -41.2464331,
    lat: -21.3877563
  },
  {
    lng: -41.2464351,
    lat: -21.3877571
  },
  {
    lng: -41.2464371,
    lat: -21.387758
  },
  {
    lng: -41.2464391,
    lat: -21.3877589
  },
  {
    lng: -41.2464411,
    lat: -21.3877598
  },
  {
    lng: -41.2464431,
    lat: -21.3877607
  },
  {
    lng: -41.246445,
    lat: -21.3877616
  },
  {
    lng: -41.246447,
    lat: -21.3877625
  },
  {
    lng: -41.246449,
    lat: -21.3877634
  },
  {
    lng: -41.246451,
    lat: -21.3877643
  },
  {
    lng: -41.2464529,
    lat: -21.3877653
  },
  {
    lng: -41.2464549,
    lat: -21.3877662
  },
  {
    lng: -41.2464569,
    lat: -21.3877671
  },
  {
    lng: -41.2464588,
    lat: -21.3877681
  },
  {
    lng: -41.2464608,
    lat: -21.387769
  },
  {
    lng: -41.2464627,
    lat: -21.38777
  },
  {
    lng: -41.2464647,
    lat: -21.387771
  },
  {
    lng: -41.2464666,
    lat: -21.3877719
  },
  {
    lng: -41.2464686,
    lat: -21.3877729
  },
  {
    lng: -41.2464705,
    lat: -21.3877739
  },
  {
    lng: -41.2464724,
    lat: -21.3877749
  },
  {
    lng: -41.2464744,
    lat: -21.3877759
  },
  {
    lng: -41.2464763,
    lat: -21.3877769
  },
  {
    lng: -41.2464782,
    lat: -21.3877779
  },
  {
    lng: -41.2464802,
    lat: -21.3877789
  },
  {
    lng: -41.2464821,
    lat: -21.3877799
  },
  {
    lng: -41.246484,
    lat: -21.3877809
  },
  {
    lng: -41.2464859,
    lat: -21.387782
  },
  {
    lng: -41.2464878,
    lat: -21.387783
  },
  {
    lng: -41.2464897,
    lat: -21.387784
  },
  {
    lng: -41.2464916,
    lat: -21.3877851
  },
  {
    lng: -41.2464935,
    lat: -21.3877861
  },
  {
    lng: -41.2464954,
    lat: -21.3877872
  },
  {
    lng: -41.2464973,
    lat: -21.3877883
  },
  {
    lng: -41.2464992,
    lat: -21.3877893
  },
  {
    lng: -41.2465011,
    lat: -21.3877904
  },
  {
    lng: -41.246503,
    lat: -21.3877915
  },
  {
    lng: -41.2465049,
    lat: -21.3877926
  },
  {
    lng: -41.2465068,
    lat: -21.3877937
  },
  {
    lng: -41.2465086,
    lat: -21.3877948
  },
  {
    lng: -41.2465105,
    lat: -21.3877959
  },
  {
    lng: -41.2465124,
    lat: -21.387797
  },
  {
    lng: -41.2465142,
    lat: -21.3877981
  },
  {
    lng: -41.2465161,
    lat: -21.3877993
  },
  {
    lng: -41.246518,
    lat: -21.3878004
  },
  {
    lng: -41.2465198,
    lat: -21.3878015
  },
  {
    lng: -41.2465217,
    lat: -21.3878027
  },
  {
    lng: -41.2465235,
    lat: -21.3878038
  },
  {
    lng: -41.2465254,
    lat: -21.387805
  },
  {
    lng: -41.2465272,
    lat: -21.3878061
  },
  {
    lng: -41.246529,
    lat: -21.3878073
  },
  {
    lng: -41.2465309,
    lat: -21.3878085
  },
  {
    lng: -41.2465327,
    lat: -21.3878097
  },
  {
    lng: -41.2469368,
    lat: -21.3880188
  },
  {
    lng: -41.2471887,
    lat: -21.3881424
  },
  {
    lng: -41.2474216,
    lat: -21.388247
  },
  {
    lng: -41.2476783,
    lat: -21.3883325
  },
  {
    lng: -41.2480919,
    lat: -21.3885132
  },
  {
    lng: -41.2482868,
    lat: -21.3886035
  },
  {
    lng: -41.2485149,
    lat: -21.3887651
  },
  {
    lng: -41.2487479,
    lat: -21.3889077
  },
  {
    lng: -41.2489,
    lat: -21.388979
  },
  {
    lng: -41.2490378,
    lat: -21.3890313
  },
  {
    lng: -41.2492803,
    lat: -21.3890598
  },
  {
    lng: -41.2495655,
    lat: -21.3890694
  },
  {
    lng: -41.25,
    lat: -21.3890041
  },
  {
    lng: -41.2505254,
    lat: -21.388925
  },
  {
    lng: -41.2507339,
    lat: -21.3887237
  },
  {
    lng: -41.251079,
    lat: -21.388393
  },
  {
    lng: -41.2512228,
    lat: -21.3882779
  },
  {
    lng: -41.2514385,
    lat: -21.3881773
  },
  {
    lng: -41.2518196,
    lat: -21.3880263
  },
  {
    lng: -41.2521719,
    lat: -21.3879112
  },
  {
    lng: -41.252934,
    lat: -21.3877171
  },
  {
    lng: -41.2531641,
    lat: -21.3876668
  },
  {
    lng: -41.2532791,
    lat: -21.3876596
  },
  {
    lng: -41.2533726,
    lat: -21.3876812
  },
  {
    lng: -41.2534516,
    lat: -21.3877171
  },
  {
    lng: -41.2535523,
    lat: -21.387789
  },
  {
    lng: -41.253617,
    lat: -21.3878681
  },
  {
    lng: -41.253732,
    lat: -21.3880478
  },
  {
    lng: -41.2538902,
    lat: -21.3882779
  },
  {
    lng: -41.2540268,
    lat: -21.3884217
  },
  {
    lng: -41.2541994,
    lat: -21.3885439
  },
  {
    lng: -41.2543791,
    lat: -21.3886446
  },
  {
    lng: -41.2545732,
    lat: -21.3887165
  },
  {
    lng: -41.2548465,
    lat: -21.3887956
  },
  {
    lng: -41.2550478,
    lat: -21.3888459
  },
  {
    lng: -41.2553425,
    lat: -21.3888747
  },
  {
    lng: -41.2555726,
    lat: -21.3888675
  },
  {
    lng: -41.2557739,
    lat: -21.3888675
  },
  {
    lng: -41.2559537,
    lat: -21.3888459
  },
  {
    lng: -41.2561047,
    lat: -21.3888171
  },
  {
    lng: -41.2566583,
    lat: -21.388659
  },
  {
    lng: -41.256874,
    lat: -21.3886302
  },
  {
    lng: -41.256989,
    lat: -21.3886518
  },
  {
    lng: -41.2571112,
    lat: -21.3887021
  },
  {
    lng: -41.2572047,
    lat: -21.3887524
  },
  {
    lng: -41.2572694,
    lat: -21.38881
  },
  {
    lng: -41.2573844,
    lat: -21.3889538
  },
  {
    lng: -41.2576504,
    lat: -21.3893636
  },
  {
    lng: -41.257974,
    lat: -21.3899747
  },
  {
    lng: -41.2581322,
    lat: -21.3903126
  },
  {
    lng: -41.2581609,
    lat: -21.3903989
  },
  {
    lng: -41.2581609,
    lat: -21.3905002
  },
  {
    lng: -41.2581609,
    lat: -21.3905139
  },
  {
    lng: -41.2581393,
    lat: -21.3906002
  },
  {
    lng: -41.2580603,
    lat: -21.3907296
  },
  {
    lng: -41.2579524,
    lat: -21.390859
  },
  {
    lng: -41.2578374,
    lat: -21.3909597
  },
  {
    lng: -41.2577798,
    lat: -21.3909993
  },
  {
    lng: -41.2577223,
    lat: -21.3910388
  },
  {
    lng: -41.2576217,
    lat: -21.3910891
  },
  {
    lng: -41.2574779,
    lat: -21.3911394
  },
  {
    lng: -41.2573557,
    lat: -21.3912041
  },
  {
    lng: -41.2571903,
    lat: -21.3913479
  },
  {
    lng: -41.2565236,
    lat: -21.3920621
  },
  {
    lng: -41.2557883,
    lat: -21.3928722
  },
  {
    lng: -41.2557164,
    lat: -21.3929872
  },
  {
    lng: -41.255702,
    lat: -21.393095
  },
  {
    lng: -41.2557236,
    lat: -21.3931957
  },
  {
    lng: -41.2557955,
    lat: -21.3933107
  },
  {
    lng: -41.2559177,
    lat: -21.3934617
  },
  {
    lng: -41.2560112,
    lat: -21.3935624
  },
  {
    lng: -41.2561047,
    lat: -21.3936415
  },
  {
    lng: -41.2562628,
    lat: -21.3937493
  },
  {
    lng: -41.2563347,
    lat: -21.393814
  },
  {
    lng: -41.2563922,
    lat: -21.3938787
  },
  {
    lng: -41.2564282,
    lat: -21.3939578
  },
  {
    lng: -41.2564498,
    lat: -21.3940585
  },
  {
    lng: -41.256457,
    lat: -21.3941879
  },
  {
    lng: -41.2564641,
    lat: -21.3946983
  },
  {
    lng: -41.2564785,
    lat: -21.3947918
  },
  {
    lng: -41.2565217,
    lat: -21.3949068
  },
  {
    lng: -41.2566798,
    lat: -21.395216
  },
  {
    lng: -41.256874,
    lat: -21.3956402
  },
  {
    lng: -41.2569027,
    lat: -21.3957337
  },
  {
    lng: -41.2568955,
    lat: -21.3958415
  },
  {
    lng: -41.2568524,
    lat: -21.3960428
  },
  {
    lng: -41.2568524,
    lat: -21.3961722
  },
  {
    lng: -41.2568811,
    lat: -21.3963088
  },
  {
    lng: -41.2569171,
    lat: -21.3964167
  },
  {
    lng: -41.2569674,
    lat: -21.3965102
  },
  {
    lng: -41.2570321,
    lat: -21.396618
  },
  {
    lng: -41.2570792,
    lat: -21.3966703
  },
  {
    lng: -41.2571606,
    lat: -21.3967209
  },
  {
    lng: -41.2573125,
    lat: -21.396769
  },
  {
    lng: -41.257592,
    lat: -21.3968519
  },
  {
    lng: -41.2578347,
    lat: -21.3969281
  },
  {
    lng: -41.2579918,
    lat: -21.397009
  },
  {
    lng: -41.2581203,
    lat: -21.3970899
  },
  {
    lng: -41.2582107,
    lat: -21.3971661
  },
  {
    lng: -41.2582821,
    lat: -21.3972517
  },
  {
    lng: -41.2583916,
    lat: -21.3974421
  },
  {
    lng: -41.2585011,
    lat: -21.3975944
  },
  {
    lng: -41.2585724,
    lat: -21.3976706
  },
  {
    lng: -41.25862,
    lat: -21.3976944
  },
  {
    lng: -41.2587343,
    lat: -21.3977134
  },
  {
    lng: -41.258958,
    lat: -21.3977325
  },
  {
    lng: -41.2590246,
    lat: -21.3977467
  },
  {
    lng: -41.2591198,
    lat: -21.39778
  },
  {
    lng: -41.2592959,
    lat: -21.3978705
  },
  {
    lng: -41.2595196,
    lat: -21.3979847
  },
  {
    lng: -41.2596433,
    lat: -21.3980275
  },
  {
    lng: -41.2598004,
    lat: -21.3980847
  },
  {
    lng: -41.2599575,
    lat: -21.398118
  },
  {
    lng: -41.2600812,
    lat: -21.3981418
  },
  {
    lng: -41.2602573,
    lat: -21.3981703
  },
  {
    lng: -41.2604334,
    lat: -21.3982036
  },
  {
    lng: -41.260619,
    lat: -21.3982655
  },
  {
    lng: -41.260995,
    lat: -21.3984178
  },
  {
    lng: -41.2622991,
    lat: -21.3989366
  },
  {
    lng: -41.262461,
    lat: -21.3990318
  },
  {
    lng: -41.2625895,
    lat: -21.399108
  },
  {
    lng: -41.2626751,
    lat: -21.3991793
  },
  {
    lng: -41.2627656,
    lat: -21.3992698
  },
  {
    lng: -41.2628703,
    lat: -21.3993935
  },
  {
    lng: -41.2630036,
    lat: -21.3995791
  },
  {
    lng: -41.2630654,
    lat: -21.3997077
  },
  {
    lng: -41.2631083,
    lat: -21.39986
  },
  {
    lng: -41.2631225,
    lat: -21.4000027
  },
  {
    lng: -41.2631368,
    lat: -21.4006738
  },
  {
    lng: -41.2631606,
    lat: -21.4009308
  },
  {
    lng: -41.2631987,
    lat: -21.4010927
  },
  {
    lng: -41.2632415,
    lat: -21.4012069
  },
  {
    lng: -41.2633034,
    lat: -21.4013402
  },
  {
    lng: -41.2633653,
    lat: -21.4014496
  },
  {
    lng: -41.263489,
    lat: -21.4016257
  },
  {
    lng: -41.2635557,
    lat: -21.4017352
  },
  {
    lng: -41.2635985,
    lat: -21.4018256
  },
  {
    lng: -41.2636318,
    lat: -21.4019399
  },
  {
    lng: -41.2636746,
    lat: -21.4021445
  },
  {
    lng: -41.2637127,
    lat: -21.4023635
  },
  {
    lng: -41.2637222,
    lat: -21.4025634
  },
  {
    lng: -41.2637222,
    lat: -21.4030584
  },
  {
    lng: -41.2637413,
    lat: -21.4033011
  },
  {
    lng: -41.2637651,
    lat: -21.4034534
  },
  {
    lng: -41.2638127,
    lat: -21.4035771
  },
  {
    lng: -41.2638745,
    lat: -21.4036961
  },
  {
    lng: -41.2639697,
    lat: -21.4038246
  },
  {
    lng: -41.2640887,
    lat: -21.4039341
  },
  {
    lng: -41.2642077,
    lat: -21.4040103
  },
  {
    lng: -41.2644171,
    lat: -21.4041578
  },
  {
    lng: -41.2646218,
    lat: -21.4043053
  },
  {
    lng: -41.2647836,
    lat: -21.4044291
  },
  {
    lng: -41.2648693,
    lat: -21.4045338
  },
  {
    lng: -41.264955,
    lat: -21.4046338
  },
  {
    lng: -41.2650026,
    lat: -21.4046909
  },
  {
    lng: -41.2650264,
    lat: -21.404748
  },
  {
    lng: -41.265093,
    lat: -21.4050193
  },
  {
    lng: -41.265212,
    lat: -21.4054286
  },
  {
    lng: -41.2652976,
    lat: -21.4056571
  },
  {
    lng: -41.265369,
    lat: -21.4058332
  },
  {
    lng: -41.2654595,
    lat: -21.4059712
  },
  {
    lng: -41.2656261,
    lat: -21.4062044
  },
  {
    lng: -41.26624,
    lat: -21.4069469
  },
  {
    lng: -41.266616,
    lat: -21.4074704
  },
  {
    lng: -41.2666969,
    lat: -21.4075942
  },
  {
    lng: -41.2667207,
    lat: -21.407656
  },
  {
    lng: -41.2667255,
    lat: -21.4077703
  },
  {
    lng: -41.2667017,
    lat: -21.4078512
  },
  {
    lng: -41.2666446,
    lat: -21.4079226
  },
  {
    lng: -41.2664828,
    lat: -21.4080606
  },
  {
    lng: -41.2660021,
    lat: -21.4084271
  },
  {
    lng: -41.2656879,
    lat: -21.4086984
  },
  {
    lng: -41.2655832,
    lat: -21.4087936
  },
  {
    lng: -41.2655261,
    lat: -21.4088602
  },
  {
    lng: -41.2654499,
    lat: -21.4089792
  },
  {
    lng: -41.2652596,
    lat: -21.409398
  },
  {
    lng: -41.2651739,
    lat: -21.4095694
  },
  {
    lng: -41.2650787,
    lat: -21.4097026
  },
  {
    lng: -41.2649883,
    lat: -21.4097883
  },
  {
    lng: -41.2648693,
    lat: -21.4098692
  },
  {
    lng: -41.2646028,
    lat: -21.410012
  },
  {
    lng: -41.2643172,
    lat: -21.4101786
  },
  {
    lng: -41.264222,
    lat: -21.4102643
  },
  {
    lng: -41.2641554,
    lat: -21.4103404
  },
  {
    lng: -41.264122,
    lat: -21.4104213
  },
  {
    lng: -41.264103,
    lat: -21.4105118
  },
  {
    lng: -41.2641125,
    lat: -21.4105927
  },
  {
    lng: -41.2641554,
    lat: -21.4107259
  },
  {
    lng: -41.2642648,
    lat: -21.4110448
  },
  {
    lng: -41.2642981,
    lat: -21.4111543
  },
  {
    lng: -41.2642934,
    lat: -21.4112019
  },
  {
    lng: -41.2642696,
    lat: -21.4112542
  },
  {
    lng: -41.2641316,
    lat: -21.4114684
  },
  {
    lng: -41.2639269,
    lat: -21.4117825
  },
  {
    lng: -41.263865,
    lat: -21.4118635
  },
  {
    lng: -41.2637508,
    lat: -21.4119682
  },
  {
    lng: -41.2634272,
    lat: -21.4122014
  },
  {
    lng: -41.2631654,
    lat: -21.4124298
  },
  {
    lng: -41.2626038,
    lat: -21.4129106
  },
  {
    lng: -41.2623372,
    lat: -21.4131581
  },
  {
    lng: -41.2622611,
    lat: -21.4132437
  },
  {
    lng: -41.262204,
    lat: -21.4133437
  },
  {
    lng: -41.2621611,
    lat: -21.4135103
  },
  {
    lng: -41.2620802,
    lat: -21.4139101
  },
  {
    lng: -41.2620231,
    lat: -21.4143146
  },
  {
    lng: -41.2620136,
    lat: -21.4145336
  },
  {
    lng: -41.2620326,
    lat: -21.4147715
  },
  {
    lng: -41.2620755,
    lat: -21.415019
  },
  {
    lng: -41.262123,
    lat: -21.415276
  },
  {
    lng: -41.2621802,
    lat: -21.4154283
  },
  {
    lng: -41.2622373,
    lat: -21.4155902
  },
  {
    lng: -41.2622658,
    lat: -21.4156949
  },
  {
    lng: -41.2622801,
    lat: -21.4158377
  },
  {
    lng: -41.262361,
    lat: -21.4168419
  },
  {
    lng: -41.2621193,
    lat: -21.4170474
  },
  {
    lng: -41.2618393,
    lat: -21.4174102
  },
  {
    lng: -41.2614446,
    lat: -21.4179767
  },
  {
    lng: -41.2611519,
    lat: -21.418314
  },
  {
    lng: -41.26084,
    lat: -21.418785
  },
  {
    lng: -41.2606936,
    lat: -21.4189696
  },
  {
    lng: -41.260579,
    lat: -21.4190842
  },
  {
    lng: -41.2604263,
    lat: -21.4191924
  },
  {
    lng: -41.2601844,
    lat: -21.4193197
  },
  {
    lng: -41.2587459,
    lat: -21.420128
  },
  {
    lng: -41.2585231,
    lat: -21.4202617
  },
  {
    lng: -41.2583513,
    lat: -21.4204081
  },
  {
    lng: -41.2579458,
    lat: -21.4209695
  },
  {
    lng: -41.2578548,
    lat: -21.4210955
  },
  {
    lng: -41.2577148,
    lat: -21.4213564
  },
  {
    lng: -41.2576702,
    lat: -21.4215219
  },
  {
    lng: -41.2576448,
    lat: -21.4218338
  },
  {
    lng: -41.2575939,
    lat: -21.4226485
  },
  {
    lng: -41.2575366,
    lat: -21.4233996
  },
  {
    lng: -41.2575366,
    lat: -21.4238006
  },
  {
    lng: -41.2575811,
    lat: -21.4242843
  },
  {
    lng: -41.2576512,
    lat: -21.4248699
  },
  {
    lng: -41.2578039,
    lat: -21.4256782
  },
  {
    lng: -41.2578676,
    lat: -21.4260919
  },
  {
    lng: -41.2578676,
    lat: -21.4262319
  },
  {
    lng: -41.2578166,
    lat: -21.4264993
  },
  {
    lng: -41.2576893,
    lat: -21.4269575
  },
  {
    lng: -41.2576512,
    lat: -21.4270976
  },
  {
    lng: -41.2576512,
    lat: -21.4272067
  },
  {
    lng: -41.2576512,
    lat: -21.4273967
  },
  {
    lng: -41.2576066,
    lat: -21.4278486
  },
  {
    lng: -41.2576321,
    lat: -21.4282942
  },
  {
    lng: -41.2577021,
    lat: -21.4291343
  },
  {
    lng: -41.2577084,
    lat: -21.4297199
  },
  {
    lng: -41.2577212,
    lat: -21.4301464
  },
  {
    lng: -41.2577785,
    lat: -21.4306237
  },
  {
    lng: -41.2578103,
    lat: -21.4310438
  },
  {
    lng: -41.2578294,
    lat: -21.4316548
  },
  {
    lng: -41.2578438,
    lat: -21.4320488
  },
  {
    lng: -41.2578485,
    lat: -21.4321768
  },
  {
    lng: -41.2578739,
    lat: -21.4324059
  },
  {
    lng: -41.2578739,
    lat: -21.4326223
  },
  {
    lng: -41.2578485,
    lat: -21.4328514
  },
  {
    lng: -41.2577848,
    lat: -21.4330806
  },
  {
    lng: -41.2577084,
    lat: -21.4332906
  },
  {
    lng: -41.2575239,
    lat: -21.4336025
  },
  {
    lng: -41.2573138,
    lat: -21.4339208
  },
  {
    lng: -41.2571674,
    lat: -21.4341435
  },
  {
    lng: -41.2570465,
    lat: -21.4343981
  },
  {
    lng: -41.2567919,
    lat: -21.4350155
  },
  {
    lng: -41.2567346,
    lat: -21.4352065
  },
  {
    lng: -41.2567282,
    lat: -21.4353274
  },
  {
    lng: -41.256741,
    lat: -21.4354802
  },
  {
    lng: -41.2567855,
    lat: -21.4360403
  },
  {
    lng: -41.2568492,
    lat: -21.4365049
  },
  {
    lng: -41.2568555,
    lat: -21.437065
  },
  {
    lng: -41.2568619,
    lat: -21.4374024
  },
  {
    lng: -41.2568301,
    lat: -21.4376697
  },
  {
    lng: -41.2567601,
    lat: -21.4379879
  },
  {
    lng: -41.2566837,
    lat: -21.4383253
  },
  {
    lng: -41.2566391,
    lat: -21.4385098
  },
  {
    lng: -41.2565628,
    lat: -21.4391782
  },
  {
    lng: -41.2565182,
    lat: -21.4396046
  },
  {
    lng: -41.2565055,
    lat: -21.4398974
  },
  {
    lng: -41.2565309,
    lat: -21.4401711
  },
  {
    lng: -41.2565691,
    lat: -21.4404957
  },
  {
    lng: -41.2565691,
    lat: -21.4408458
  },
  {
    lng: -41.2565309,
    lat: -21.4412722
  },
  {
    lng: -41.2564546,
    lat: -21.4416987
  },
  {
    lng: -41.25634,
    lat: -21.4423033
  },
  {
    lng: -41.2563051,
    lat: -21.4425
  },
  {
    lng: -41.2562509,
    lat: -21.4428062
  },
  {
    lng: -41.2561554,
    lat: -21.4433408
  },
  {
    lng: -41.2560918,
    lat: -21.4437927
  },
  {
    lng: -41.256009,
    lat: -21.4445947
  },
  {
    lng: -41.2559135,
    lat: -21.4452948
  },
  {
    lng: -41.2558626,
    lat: -21.4455749
  },
  {
    lng: -41.2558372,
    lat: -21.4457531
  },
  {
    lng: -41.2558372,
    lat: -21.445874
  },
  {
    lng: -41.2558753,
    lat: -21.4460013
  },
  {
    lng: -41.2559772,
    lat: -21.4463069
  },
  {
    lng: -41.2560408,
    lat: -21.4465869
  },
  {
    lng: -41.2561363,
    lat: -21.4470006
  },
  {
    lng: -41.2562827,
    lat: -21.4474398
  },
  {
    lng: -41.2563845,
    lat: -21.4477071
  },
  {
    lng: -41.2565628,
    lat: -21.4480254
  },
  {
    lng: -41.2568364,
    lat: -21.4484773
  },
  {
    lng: -41.2569383,
    lat: -21.4486746
  },
  {
    lng: -41.2570274,
    lat: -21.448891
  },
  {
    lng: -41.2571611,
    lat: -21.4493938
  },
  {
    lng: -41.2572438,
    lat: -21.449693
  },
  {
    lng: -41.2572884,
    lat: -21.4498457
  },
  {
    lng: -41.2573077,
    lat: -21.4498921
  },
  {
    lng: -41.257352,
    lat: -21.4499985
  },
  {
    lng: -41.257492,
    lat: -21.4502276
  },
  {
    lng: -41.2577339,
    lat: -21.4506095
  },
  {
    lng: -41.2578612,
    lat: -21.4508259
  },
  {
    lng: -41.2579758,
    lat: -21.4510996
  },
  {
    lng: -41.2581222,
    lat: -21.4514688
  },
  {
    lng: -41.2582304,
    lat: -21.4518189
  },
  {
    lng: -41.2583322,
    lat: -21.452258
  },
  {
    lng: -41.2583704,
    lat: -21.4525126
  },
  {
    lng: -41.2584277,
    lat: -21.4529518
  },
  {
    lng: -41.2585104,
    lat: -21.4536138
  },
  {
    lng: -41.2585741,
    lat: -21.4540275
  },
  {
    lng: -41.2585868,
    lat: -21.4543648
  },
  {
    lng: -41.2585995,
    lat: -21.4546576
  },
  {
    lng: -41.2585741,
    lat: -21.4548677
  },
  {
    lng: -41.2585168,
    lat: -21.4550459
  },
  {
    lng: -41.2584277,
    lat: -21.4553259
  },
  {
    lng: -41.258294,
    lat: -21.4556824
  },
  {
    lng: -41.2581094,
    lat: -21.456147
  },
  {
    lng: -41.2578803,
    lat: -21.4566244
  },
  {
    lng: -41.2578103,
    lat: -21.4567517
  },
  {
    lng: -41.2577275,
    lat: -21.456879
  },
  {
    lng: -41.2576321,
    lat: -21.4569872
  },
  {
    lng: -41.2575493,
    lat: -21.457089
  },
  {
    lng: -41.257422,
    lat: -21.4572163
  },
  {
    lng: -41.2572756,
    lat: -21.4573627
  },
  {
    lng: -41.2570083,
    lat: -21.4575918
  },
  {
    lng: -41.2568301,
    lat: -21.4577382
  },
  {
    lng: -41.2566837,
    lat: -21.4578337
  },
  {
    lng: -41.2565309,
    lat: -21.4579419
  },
  {
    lng: -41.2563782,
    lat: -21.458031
  },
  {
    lng: -41.2561809,
    lat: -21.4581329
  },
  {
    lng: -41.2560536,
    lat: -21.4582029
  },
  {
    lng: -41.2559836,
    lat: -21.4582602
  },
  {
    lng: -41.255939,
    lat: -21.4583302
  },
  {
    lng: -41.2559135,
    lat: -21.4584256
  },
  {
    lng: -41.2559199,
    lat: -21.4585147
  },
  {
    lng: -41.2559517,
    lat: -21.4586484
  },
  {
    lng: -41.2560217,
    lat: -21.458763
  },
  {
    lng: -41.2561872,
    lat: -21.458903
  },
  {
    lng: -41.2564036,
    lat: -21.4590367
  },
  {
    lng: -41.2565309,
    lat: -21.4591576
  },
  {
    lng: -41.256671,
    lat: -21.4593549
  },
  {
    lng: -41.2567919,
    lat: -21.4595841
  },
  {
    lng: -41.2568619,
    lat: -21.4597495
  },
  {
    lng: -41.2568874,
    lat: -21.459845
  },
  {
    lng: -41.2568937,
    lat: -21.4599596
  },
  {
    lng: -41.2568046,
    lat: -21.4604942
  },
  {
    lng: -41.2565628,
    lat: -21.4618818
  },
  {
    lng: -41.2565182,
    lat: -21.4622128
  },
  {
    lng: -41.2565182,
    lat: -21.4623846
  },
  {
    lng: -41.25655,
    lat: -21.462601
  },
  {
    lng: -41.2565819,
    lat: -21.4627665
  },
  {
    lng: -41.2566901,
    lat: -21.4630211
  },
  {
    lng: -41.2567537,
    lat: -21.4631293
  },
  {
    lng: -41.2568746,
    lat: -21.4632184
  },
  {
    lng: -41.2569608,
    lat: -21.4632471
  },
  {
    lng: -41.2570847,
    lat: -21.4632884
  },
  {
    lng: -41.2573902,
    lat: -21.4633457
  },
  {
    lng: -41.257683,
    lat: -21.4634094
  },
  {
    lng: -41.2578485,
    lat: -21.4634666
  },
  {
    lng: -41.2579567,
    lat: -21.4635176
  },
  {
    lng: -41.2580394,
    lat: -21.4635876
  },
  {
    lng: -41.2580967,
    lat: -21.4637021
  },
  {
    lng: -41.2581413,
    lat: -21.4638358
  },
  {
    lng: -41.2582367,
    lat: -21.4643514
  },
  {
    lng: -41.2583577,
    lat: -21.465217
  },
  {
    lng: -41.2584595,
    lat: -21.4656116
  },
  {
    lng: -41.2584913,
    lat: -21.4659299
  },
  {
    lng: -41.2584977,
    lat: -21.4662163
  },
  {
    lng: -41.2584659,
    lat: -21.4664836
  },
  {
    lng: -41.2583958,
    lat: -21.4667
  },
  {
    lng: -41.2582749,
    lat: -21.4669483
  },
  {
    lng: -41.2581794,
    lat: -21.4671265
  },
  {
    lng: -41.2581158,
    lat: -21.4672856
  },
  {
    lng: -41.2580203,
    lat: -21.4675338
  },
  {
    lng: -41.2577785,
    lat: -21.468234
  },
  {
    lng: -41.257021,
    lat: -21.4701816
  },
  {
    lng: -41.2567855,
    lat: -21.4708054
  },
  {
    lng: -41.2566519,
    lat: -21.4711873
  },
  {
    lng: -41.2565882,
    lat: -21.471461
  },
  {
    lng: -41.2565118,
    lat: -21.4718174
  },
  {
    lng: -41.2563909,
    lat: -21.4722439
  },
  {
    lng: -41.2562636,
    lat: -21.4727403
  },
  {
    lng: -41.2561299,
    lat: -21.4731731
  },
  {
    lng: -41.2559072,
    lat: -21.4738223
  },
  {
    lng: -41.2557735,
    lat: -21.474217
  },
  {
    lng: -41.2557099,
    lat: -21.4745034
  },
  {
    lng: -41.2556653,
    lat: -21.474688
  },
  {
    lng: -41.2556335,
    lat: -21.4751972
  },
  {
    lng: -41.2555889,
    lat: -21.4756363
  },
  {
    lng: -41.2555189,
    lat: -21.476241
  },
  {
    lng: -41.2554553,
    lat: -21.4766611
  },
  {
    lng: -41.2554298,
    lat: -21.476903
  },
  {
    lng: -41.2554362,
    lat: -21.4771639
  },
  {
    lng: -41.2554935,
    lat: -21.4776031
  },
  {
    lng: -41.2555253,
    lat: -21.4780614
  },
  {
    lng: -41.255538,
    lat: -21.4784751
  },
  {
    lng: -41.2555316,
    lat: -21.4790416
  },
  {
    lng: -41.2555762,
    lat: -21.4792643
  },
  {
    lng: -41.2556271,
    lat: -21.4794235
  },
  {
    lng: -41.2556971,
    lat: -21.4795571
  },
  {
    lng: -41.2557735,
    lat: -21.479659
  },
  {
    lng: -41.2561299,
    lat: -21.4798945
  },
  {
    lng: -41.2566328,
    lat: -21.4801936
  },
  {
    lng: -41.2567282,
    lat: -21.4802636
  },
  {
    lng: -41.2567792,
    lat: -21.4803655
  },
  {
    lng: -41.2568174,
    lat: -21.4805819
  },
  {
    lng: -41.2568174,
    lat: -21.4808365
  },
  {
    lng: -41.2567091,
    lat: -21.4812757
  },
  {
    lng: -41.2566264,
    lat: -21.4815493
  },
  {
    lng: -41.2566073,
    lat: -21.4816766
  },
  {
    lng: -41.2566137,
    lat: -21.4818103
  },
  {
    lng: -41.2566646,
    lat: -21.4823131
  },
  {
    lng: -41.2567473,
    lat: -21.4826441
  },
  {
    lng: -41.2567792,
    lat: -21.4831406
  },
  {
    lng: -41.2567346,
    lat: -21.4837834
  },
  {
    lng: -41.2566646,
    lat: -21.4843181
  },
  {
    lng: -41.2566137,
    lat: -21.4846618
  },
  {
    lng: -41.2565946,
    lat: -21.4849673
  },
  {
    lng: -41.2566073,
    lat: -21.4851328
  },
  {
    lng: -41.256671,
    lat: -21.4854001
  },
  {
    lng: -41.2567664,
    lat: -21.4856483
  },
  {
    lng: -41.2569256,
    lat: -21.4859029
  },
  {
    lng: -41.2572884,
    lat: -21.4862912
  },
  {
    lng: -41.2578612,
    lat: -21.4868449
  },
  {
    lng: -41.2584977,
    lat: -21.4874114
  },
  {
    lng: -41.2587077,
    lat: -21.4876087
  },
  {
    lng: -41.2588796,
    lat: -21.4877233
  },
  {
    lng: -41.2591151,
    lat: -21.4878315
  },
  {
    lng: -41.2593633,
    lat: -21.4879142
  },
  {
    lng: -41.2596497,
    lat: -21.4879779
  },
  {
    lng: -41.260369,
    lat: -21.4881179
  },
  {
    lng: -41.2606299,
    lat: -21.4881688
  },
  {
    lng: -41.2607318,
    lat: -21.4882134
  },
  {
    lng: -41.2608145,
    lat: -21.488277
  },
  {
    lng: -41.2609223,
    lat: -21.4883848
  },
  {
    lng: -41.2610818,
    lat: -21.4885444
  },
  {
    lng: -41.2612155,
    lat: -21.4887353
  },
  {
    lng: -41.2612664,
    lat: -21.4888944
  },
  {
    lng: -41.2614031,
    lat: -21.4895577
  },
  {
    lng: -41.2614852,
    lat: -21.4897352
  },
  {
    lng: -41.2599446,
    lat: -21.4911675
  },
  {
    lng: -41.257722,
    lat: -21.4932339
  },
  {
    lng: -41.257214,
    lat: -21.4937152
  },
  {
    lng: -41.2552918,
    lat: -21.4955361
  },
  {
    lng: -41.2548612,
    lat: -21.4959441
  },
  {
    lng: -41.250482,
    lat: -21.5
  },
  {
    lng: -41.25,
    lat: -21.500453
  },
  {
    lng: -41.2495939,
    lat: -21.500906
  },
  {
    lng: -41.2491755,
    lat: -21.5013244
  },
  {
    lng: -41.2488316,
    lat: -21.5016798
  },
  {
    lng: -41.2487485,
    lat: -21.5018517
  },
  {
    lng: -41.2485679,
    lat: -21.5017772
  },
  {
    lng: -41.2481323,
    lat: -21.5013932
  },
  {
    lng: -41.2473528,
    lat: -21.5007341
  },
  {
    lng: -41.2467109,
    lat: -21.5001953
  },
  {
    lng: -41.2465504,
    lat: -21.5000864
  },
  {
    lng: -41.2463612,
    lat: -21.5000806
  },
  {
    lng: -41.2459199,
    lat: -21.5002182
  },
  {
    lng: -41.2453009,
    lat: -21.5003386
  },
  {
    lng: -41.2445111,
    lat: -21.5004817
  },
  {
    lng: -41.2440917,
    lat: -21.5005508
  },
  {
    lng: -41.2440643,
    lat: -21.5005576
  },
  {
    lng: -41.2481623,
    lat: -21.5230129
  },
  {
    lng: -41.2544674,
    lat: -21.5563113
  },
  {
    lng: -41.2543433,
    lat: -21.5563009
  },
  {
    lng: -41.2541632,
    lat: -21.5563352
  },
  {
    lng: -41.2539654,
    lat: -21.5564074
  },
  {
    lng: -41.2537142,
    lat: -21.5564842
  },
  {
    lng: -41.2534908,
    lat: -21.5564461
  },
  {
    lng: -41.253286,
    lat: -21.5563627
  },
  {
    lng: -41.2530533,
    lat: -21.5564213
  },
  {
    lng: -41.252819,
    lat: -21.5565351
  },
  {
    lng: -41.2526408,
    lat: -21.5566573
  },
  {
    lng: -41.2524599,
    lat: -21.5567924
  },
  {
    lng: -41.2523904,
    lat: -21.5568958
  },
  {
    lng: -41.2522179,
    lat: -21.556964
  },
  {
    lng: -41.2520502,
    lat: -21.5570715
  },
  {
    lng: -41.2518647,
    lat: -21.557172
  },
  {
    lng: -41.251653,
    lat: -21.5573697
  },
  {
    lng: -41.2515768,
    lat: -21.5573678
  },
  {
    lng: -41.2514234,
    lat: -21.5573186
  },
  {
    lng: -41.2513176,
    lat: -21.557274
  },
  {
    lng: -41.2512454,
    lat: -21.5572508
  },
  {
    lng: -41.2510711,
    lat: -21.5572761
  },
  {
    lng: -41.2509393,
    lat: -21.5573607
  },
  {
    lng: -41.2507497,
    lat: -21.5574904
  },
  {
    lng: -41.2505015,
    lat: -21.5576523
  },
  {
    lng: -41.2502783,
    lat: -21.5577904
  },
  {
    lng: -41.2500785,
    lat: -21.5579525
  },
  {
    lng: -41.2498497,
    lat: -21.5580153
  },
  {
    lng: -41.2494471,
    lat: -21.5581029
  },
  {
    lng: -41.2492446,
    lat: -21.5581487
  },
  {
    lng: -41.2491056,
    lat: -21.5581521
  },
  {
    lng: -41.248832,
    lat: -21.5581387
  },
  {
    lng: -41.2486789,
    lat: -21.558149
  },
  {
    lng: -41.2486375,
    lat: -21.5581611
  },
  {
    lng: -41.2484637,
    lat: -21.5582155
  },
  {
    lng: -41.2481328,
    lat: -21.5583171
  },
  {
    lng: -41.2479104,
    lat: -21.5584189
  },
  {
    lng: -41.247745,
    lat: -21.5584949
  },
  {
    lng: -41.2475158,
    lat: -21.5586089
  },
  {
    lng: -41.2473231,
    lat: -21.5586864
  },
  {
    lng: -41.2471234,
    lat: -21.5587591
  },
  {
    lng: -41.2469148,
    lat: -21.55876
  },
  {
    lng: -41.2467633,
    lat: -21.5586894
  },
  {
    lng: -41.2466688,
    lat: -21.5586301
  },
  {
    lng: -41.246554,
    lat: -21.5586088
  },
  {
    lng: -41.2463615,
    lat: -21.5586417
  },
  {
    lng: -41.2462541,
    lat: -21.5587375
  },
  {
    lng: -41.246176,
    lat: -21.5588715
  },
  {
    lng: -41.2460788,
    lat: -21.5589447
  },
  {
    lng: -41.2458664,
    lat: -21.5589011
  },
  {
    lng: -41.2456695,
    lat: -21.5588849
  },
  {
    lng: -41.2455071,
    lat: -21.5588984
  },
  {
    lng: -41.2453836,
    lat: -21.558957
  },
  {
    lng: -41.245278,
    lat: -21.5589535
  },
  {
    lng: -41.2451468,
    lat: -21.5588631
  },
  {
    lng: -41.2451096,
    lat: -21.5587838
  },
  {
    lng: -41.2450574,
    lat: -21.55869
  },
  {
    lng: -41.2449676,
    lat: -21.5586826
  },
  {
    lng: -41.2449357,
    lat: -21.5587499
  },
  {
    lng: -41.244954,
    lat: -21.5588478
  },
  {
    lng: -41.2449514,
    lat: -21.5589063
  },
  {
    lng: -41.2449031,
    lat: -21.5589225
  },
  {
    lng: -41.244806,
    lat: -21.5588843
  },
  {
    lng: -41.2447139,
    lat: -21.5588482
  },
  {
    lng: -41.2445902,
    lat: -21.5588661
  },
  {
    lng: -41.2444381,
    lat: -21.558877
  },
  {
    lng: -41.2442461,
    lat: -21.5588257
  },
  {
    lng: -41.2441014,
    lat: -21.5587193
  },
  {
    lng: -41.2439506,
    lat: -21.5586654
  },
  {
    lng: -41.2437925,
    lat: -21.5586485
  },
  {
    lng: -41.2436387,
    lat: -21.5586277
  },
  {
    lng: -41.243508,
    lat: -21.5586758
  },
  {
    lng: -41.2435052,
    lat: -21.5586768
  },
  {
    lng: -41.2433503,
    lat: -21.558826
  },
  {
    lng: -41.2432538,
    lat: -21.5589603
  },
  {
    lng: -41.2431115,
    lat: -21.5590947
  },
  {
    lng: -41.2430516,
    lat: -21.5592384
  },
  {
    lng: -41.2430345,
    lat: -21.5592795
  },
  {
    lng: -41.2427901,
    lat: -21.5599958
  },
  {
    lng: -41.2422638,
    lat: -21.5602086
  },
  {
    lng: -41.2422074,
    lat: -21.5604369
  },
  {
    lng: -41.2422281,
    lat: -21.5604635
  },
  {
    lng: -41.2422279,
    lat: -21.5604844
  },
  {
    lng: -41.2422273,
    lat: -21.5605744
  },
  {
    lng: -41.2421633,
    lat: -21.5607141
  },
  {
    lng: -41.2420455,
    lat: -21.5608179
  },
  {
    lng: -41.2419873,
    lat: -21.5608966
  },
  {
    lng: -41.2419717,
    lat: -21.5609929
  },
  {
    lng: -41.2419482,
    lat: -21.5610635
  },
  {
    lng: -41.2419571,
    lat: -21.5613068
  },
  {
    lng: -41.2419374,
    lat: -21.5614522
  },
  {
    lng: -41.2418723,
    lat: -21.5616438
  },
  {
    lng: -41.2417753,
    lat: -21.561804
  },
  {
    lng: -41.2416698,
    lat: -21.561871
  },
  {
    lng: -41.2414969,
    lat: -21.5618324
  },
  {
    lng: -41.2413225,
    lat: -21.5618175
  },
  {
    lng: -41.2411882,
    lat: -21.561891
  },
  {
    lng: -41.2410739,
    lat: -21.5620222
  },
  {
    lng: -41.2410324,
    lat: -21.5621999
  },
  {
    lng: -41.2409306,
    lat: -21.5622702
  },
  {
    lng: -41.2406452,
    lat: -21.5623641
  },
  {
    lng: -41.2405298,
    lat: -21.5624646
  },
  {
    lng: -41.2403803,
    lat: -21.5627449
  },
  {
    lng: -41.2403568,
    lat: -21.5628333
  },
  {
    lng: -41.2402951,
    lat: -21.5629005
  },
  {
    lng: -41.2401743,
    lat: -21.5629762
  },
  {
    lng: -41.2400765,
    lat: -21.5630626
  },
  {
    lng: -41.2398322,
    lat: -21.5631458
  },
  {
    lng: -41.2397143,
    lat: -21.5631645
  },
  {
    lng: -41.2395871,
    lat: -21.5632358
  },
  {
    lng: -41.2393705,
    lat: -21.5632337
  },
  {
    lng: -41.2391842,
    lat: -21.5631916
  },
  {
    lng: -41.2389742,
    lat: -21.5632039
  },
  {
    lng: -41.2388783,
    lat: -21.5632782
  },
  {
    lng: -41.2387735,
    lat: -21.5633335
  },
  {
    lng: -41.2386428,
    lat: -21.5633337
  },
  {
    lng: -41.2385409,
    lat: -21.5633965
  },
  {
    lng: -41.238469,
    lat: -21.5634074
  },
  {
    lng: -41.2384002,
    lat: -21.5634066
  },
  {
    lng: -41.2383496,
    lat: -21.5634066
  },
  {
    lng: -41.2383211,
    lat: -21.5633449
  },
  {
    lng: -41.2382215,
    lat: -21.5633297
  },
  {
    lng: -41.2381353,
    lat: -21.5633693
  },
  {
    lng: -41.2379701,
    lat: -21.5634073
  },
  {
    lng: -41.2378553,
    lat: -21.5634305
  },
  {
    lng: -41.2377641,
    lat: -21.5634657
  },
  {
    lng: -41.2376782,
    lat: -21.5634547
  },
  {
    lng: -41.2376383,
    lat: -21.5634232
  },
  {
    lng: -41.2375204,
    lat: -21.563422
  },
  {
    lng: -41.23741,
    lat: -21.5634335
  },
  {
    lng: -41.2373168,
    lat: -21.563423
  },
  {
    lng: -41.2372267,
    lat: -21.563373
  },
  {
    lng: -41.2371074,
    lat: -21.5633391
  },
  {
    lng: -41.2370126,
    lat: -21.5633875
  },
  {
    lng: -41.2368865,
    lat: -21.5634068
  },
  {
    lng: -41.2367922,
    lat: -21.5634251
  },
  {
    lng: -41.2366693,
    lat: -21.5634125
  },
  {
    lng: -41.2365826,
    lat: -21.5633959
  },
  {
    lng: -41.2365213,
    lat: -21.5634071
  },
  {
    lng: -41.2363922,
    lat: -21.5634729
  },
  {
    lng: -41.2363004,
    lat: -21.5635342
  },
  {
    lng: -41.2361957,
    lat: -21.5635664
  },
  {
    lng: -41.2360907,
    lat: -21.5635905
  },
  {
    lng: -41.2359519,
    lat: -21.5636238
  },
  {
    lng: -41.2358301,
    lat: -21.5636927
  },
  {
    lng: -41.2356765,
    lat: -21.5636813
  },
  {
    lng: -41.2355781,
    lat: -21.5636703
  },
  {
    lng: -41.2355106,
    lat: -21.5636759
  },
  {
    lng: -41.2353879,
    lat: -21.5636831
  },
  {
    lng: -41.2352577,
    lat: -21.5636766
  },
  {
    lng: -41.2351599,
    lat: -21.5636432
  },
  {
    lng: -41.2350928,
    lat: -21.5636297
  },
  {
    lng: -41.2349434,
    lat: -21.5635645
  },
  {
    lng: -41.2348631,
    lat: -21.563514
  },
  {
    lng: -41.2347678,
    lat: -21.5635461
  },
  {
    lng: -41.2347447,
    lat: -21.5636005
  },
  {
    lng: -41.2346635,
    lat: -21.5636638
  },
  {
    lng: -41.234565,
    lat: -21.5637563
  },
  {
    lng: -41.2344255,
    lat: -21.5638316
  },
  {
    lng: -41.2342923,
    lat: -21.5639126
  },
  {
    lng: -41.2341874,
    lat: -21.5640048
  },
  {
    lng: -41.2340528,
    lat: -21.5641544
  },
  {
    lng: -41.2338977,
    lat: -21.5642671
  },
  {
    lng: -41.2338191,
    lat: -21.5643574
  },
  {
    lng: -41.23369,
    lat: -21.564475
  },
  {
    lng: -41.233536,
    lat: -21.5645834
  },
  {
    lng: -41.2333774,
    lat: -21.5646195
  },
  {
    lng: -41.2332058,
    lat: -21.5646372
  },
  {
    lng: -41.2331333,
    lat: -21.5646768
  },
  {
    lng: -41.2330987,
    lat: -21.5647756
  },
  {
    lng: -41.233151,
    lat: -21.5648428
  },
  {
    lng: -41.2332122,
    lat: -21.5649286
  },
  {
    lng: -41.2331815,
    lat: -21.5650031
  },
  {
    lng: -41.2330911,
    lat: -21.5650995
  },
  {
    lng: -41.2330013,
    lat: -21.5652109
  },
  {
    lng: -41.232865,
    lat: -21.5652881
  },
  {
    lng: -41.2327905,
    lat: -21.5653966
  },
  {
    lng: -41.2328232,
    lat: -21.5654931
  },
  {
    lng: -41.2328928,
    lat: -21.5656442
  },
  {
    lng: -41.2328644,
    lat: -21.5656969
  },
  {
    lng: -41.2327837,
    lat: -21.5657369
  },
  {
    lng: -41.2326956,
    lat: -21.5657897
  },
  {
    lng: -41.2326668,
    lat: -21.5659517
  },
  {
    lng: -41.2326648,
    lat: -21.5660087
  },
  {
    lng: -41.2326472,
    lat: -21.5660727
  },
  {
    lng: -41.2325666,
    lat: -21.5661548
  },
  {
    lng: -41.2324679,
    lat: -21.5662298
  },
  {
    lng: -41.2324307,
    lat: -21.5662726
  },
  {
    lng: -41.2323909,
    lat: -21.566372
  },
  {
    lng: -41.2322947,
    lat: -21.5664022
  },
  {
    lng: -41.2321971,
    lat: -21.5664369
  },
  {
    lng: -41.232099,
    lat: -21.5665129
  },
  {
    lng: -41.2320275,
    lat: -21.5665916
  },
  {
    lng: -41.2319644,
    lat: -21.5666541
  },
  {
    lng: -41.2319064,
    lat: -21.5667066
  },
  {
    lng: -41.2317958,
    lat: -21.5667063
  },
  {
    lng: -41.2317342,
    lat: -21.5667797
  },
  {
    lng: -41.2316464,
    lat: -21.5668339
  },
  {
    lng: -41.231543,
    lat: -21.5667939
  },
  {
    lng: -41.2315045,
    lat: -21.5667067
  },
  {
    lng: -41.2315065,
    lat: -21.5666145
  },
  {
    lng: -41.2314856,
    lat: -21.5665508
  },
  {
    lng: -41.2314217,
    lat: -21.5664877
  },
  {
    lng: -41.231343,
    lat: -21.5664616
  },
  {
    lng: -41.2312023,
    lat: -21.5665125
  },
  {
    lng: -41.2311503,
    lat: -21.5666196
  },
  {
    lng: -41.2310616,
    lat: -21.5666851
  },
  {
    lng: -41.2309483,
    lat: -21.566709
  },
  {
    lng: -41.2308251,
    lat: -21.5667534
  },
  {
    lng: -41.2307681,
    lat: -21.5667315
  },
  {
    lng: -41.2307683,
    lat: -21.5668046
  },
  {
    lng: -41.230728,
    lat: -21.5668884
  },
  {
    lng: -41.230679,
    lat: -21.5669562
  },
  {
    lng: -41.2306342,
    lat: -21.5670617
  },
  {
    lng: -41.2305619,
    lat: -21.5671626
  },
  {
    lng: -41.2304953,
    lat: -21.5672417
  },
  {
    lng: -41.2304685,
    lat: -21.5672958
  },
  {
    lng: -41.2304771,
    lat: -21.5673677
  },
  {
    lng: -41.2305101,
    lat: -21.5674151
  },
  {
    lng: -41.2304831,
    lat: -21.5674872
  },
  {
    lng: -41.2304045,
    lat: -21.5675432
  },
  {
    lng: -41.2303809,
    lat: -21.5676324
  },
  {
    lng: -41.2303412,
    lat: -21.5677374
  },
  {
    lng: -41.2303354,
    lat: -21.5677989
  },
  {
    lng: -41.2303594,
    lat: -21.5678581
  },
  {
    lng: -41.2303437,
    lat: -21.567906
  },
  {
    lng: -41.2303031,
    lat: -21.5679299
  },
  {
    lng: -41.2303295,
    lat: -21.5679682
  },
  {
    lng: -41.2303448,
    lat: -21.5680019
  },
  {
    lng: -41.2303015,
    lat: -21.5681196
  },
  {
    lng: -41.2303407,
    lat: -21.5681706
  },
  {
    lng: -41.2303846,
    lat: -21.5682259
  },
  {
    lng: -41.2304061,
    lat: -21.5682863
  },
  {
    lng: -41.2304303,
    lat: -21.5683375
  },
  {
    lng: -41.2304005,
    lat: -21.5684115
  },
  {
    lng: -41.2303243,
    lat: -21.5684608
  },
  {
    lng: -41.2302429,
    lat: -21.5684937
  },
  {
    lng: -41.2301556,
    lat: -21.5685559
  },
  {
    lng: -41.2301035,
    lat: -21.5686808
  },
  {
    lng: -41.2301003,
    lat: -21.5687477
  },
  {
    lng: -41.2301119,
    lat: -21.5687979
  },
  {
    lng: -41.2300304,
    lat: -21.56888
  },
  {
    lng: -41.2299734,
    lat: -21.5689328
  },
  {
    lng: -41.2299171,
    lat: -21.5689552
  },
  {
    lng: -41.2298508,
    lat: -21.5690089
  },
  {
    lng: -41.2298453,
    lat: -21.5690916
  },
  {
    lng: -41.2298308,
    lat: -21.5691755
  },
  {
    lng: -41.2298489,
    lat: -21.5692389
  },
  {
    lng: -41.2298391,
    lat: -21.5693253
  },
  {
    lng: -41.2298444,
    lat: -21.5693856
  },
  {
    lng: -41.2298918,
    lat: -21.5695051
  },
  {
    lng: -41.2299012,
    lat: -21.569555
  },
  {
    lng: -41.2298702,
    lat: -21.5696808
  },
  {
    lng: -41.2298559,
    lat: -21.5699404
  },
  {
    lng: -41.2298411,
    lat: -21.570147
  },
  {
    lng: -41.2298194,
    lat: -21.5702204
  },
  {
    lng: -41.2298526,
    lat: -21.5703264
  },
  {
    lng: -41.2299236,
    lat: -21.570473
  },
  {
    lng: -41.2299543,
    lat: -21.5705793
  },
  {
    lng: -41.2299657,
    lat: -21.5706567
  },
  {
    lng: -41.2299456,
    lat: -21.5707609
  },
  {
    lng: -41.2299065,
    lat: -21.5708229
  },
  {
    lng: -41.229898,
    lat: -21.5708824
  },
  {
    lng: -41.2298629,
    lat: -21.5709783
  },
  {
    lng: -41.2298805,
    lat: -21.5711256
  },
  {
    lng: -41.2299339,
    lat: -21.5712649
  },
  {
    lng: -41.2299166,
    lat: -21.5713138
  },
  {
    lng: -41.2299028,
    lat: -21.5713527
  },
  {
    lng: -41.2298328,
    lat: -21.571419
  },
  {
    lng: -41.2297275,
    lat: -21.5713859
  },
  {
    lng: -41.2296378,
    lat: -21.5713782
  },
  {
    lng: -41.2295233,
    lat: -21.571429
  },
  {
    lng: -41.2294087,
    lat: -21.5714425
  },
  {
    lng: -41.2293424,
    lat: -21.5714577
  },
  {
    lng: -41.2292498,
    lat: -21.5715492
  },
  {
    lng: -41.2292245,
    lat: -21.5716806
  },
  {
    lng: -41.2291971,
    lat: -21.5718084
  },
  {
    lng: -41.2291065,
    lat: -21.5718955
  },
  {
    lng: -41.22898,
    lat: -21.5718802
  },
  {
    lng: -41.2288416,
    lat: -21.5718728
  },
  {
    lng: -41.2285984,
    lat: -21.571948
  },
  {
    lng: -41.2284826,
    lat: -21.5719882
  },
  {
    lng: -41.2283952,
    lat: -21.5720368
  },
  {
    lng: -41.2283273,
    lat: -21.5721377
  },
  {
    lng: -41.228225,
    lat: -21.5721995
  },
  {
    lng: -41.2281119,
    lat: -21.5721993
  },
  {
    lng: -41.2280164,
    lat: -21.5721994
  },
  {
    lng: -41.2279189,
    lat: -21.5722277
  },
  {
    lng: -41.2278612,
    lat: -21.5722769
  },
  {
    lng: -41.2278318,
    lat: -21.5722825
  },
  {
    lng: -41.2276878,
    lat: -21.5723285
  },
  {
    lng: -41.2276023,
    lat: -21.5724103
  },
  {
    lng: -41.2274724,
    lat: -21.572555
  },
  {
    lng: -41.2273504,
    lat: -21.5726843
  },
  {
    lng: -41.2271979,
    lat: -21.5727738
  },
  {
    lng: -41.22703,
    lat: -21.57283
  },
  {
    lng: -41.2268885,
    lat: -21.5728835
  },
  {
    lng: -41.2267895,
    lat: -21.5729322
  },
  {
    lng: -41.226753,
    lat: -21.5730692
  },
  {
    lng: -41.2266936,
    lat: -21.5731472
  },
  {
    lng: -41.2266204,
    lat: -21.5732462
  },
  {
    lng: -41.2265157,
    lat: -21.5733593
  },
  {
    lng: -41.2263337,
    lat: -21.5733902
  },
  {
    lng: -41.2261489,
    lat: -21.5733725
  },
  {
    lng: -41.2258701,
    lat: -21.573295
  },
  {
    lng: -41.2257994,
    lat: -21.5732816
  },
  {
    lng: -41.2257292,
    lat: -21.5731777
  },
  {
    lng: -41.225668,
    lat: -21.5731394
  },
  {
    lng: -41.2255897,
    lat: -21.5731308
  },
  {
    lng: -41.2255291,
    lat: -21.5730509
  },
  {
    lng: -41.2254646,
    lat: -21.5730151
  },
  {
    lng: -41.2253819,
    lat: -21.5729826
  },
  {
    lng: -41.2253108,
    lat: -21.5729902
  },
  {
    lng: -41.2251808,
    lat: -21.5730708
  },
  {
    lng: -41.2250277,
    lat: -21.5731109
  },
  {
    lng: -41.2248738,
    lat: -21.5732285
  },
  {
    lng: -41.224737,
    lat: -21.5732851
  },
  {
    lng: -41.2246101,
    lat: -21.5732965
  },
  {
    lng: -41.2244959,
    lat: -21.5733193
  },
  {
    lng: -41.224376,
    lat: -21.5732918
  },
  {
    lng: -41.224303,
    lat: -21.5732672
  },
  {
    lng: -41.2241992,
    lat: -21.5732477
  },
  {
    lng: -41.2241108,
    lat: -21.5732881
  },
  {
    lng: -41.2240381,
    lat: -21.5733723
  },
  {
    lng: -41.2241328,
    lat: -21.5735314
  },
  {
    lng: -41.2240428,
    lat: -21.573601
  },
  {
    lng: -41.2239286,
    lat: -21.5736061
  },
  {
    lng: -41.223834,
    lat: -21.5736163
  },
  {
    lng: -41.2237243,
    lat: -21.5736805
  },
  {
    lng: -41.2236346,
    lat: -21.5737447
  },
  {
    lng: -41.2235553,
    lat: -21.5737888
  },
  {
    lng: -41.2234909,
    lat: -21.5738477
  },
  {
    lng: -41.2234348,
    lat: -21.5738611
  },
  {
    lng: -41.2233563,
    lat: -21.5738095
  },
  {
    lng: -41.223275,
    lat: -21.5738289
  },
  {
    lng: -41.2231791,
    lat: -21.5738737
  },
  {
    lng: -41.2230504,
    lat: -21.5738712
  },
  {
    lng: -41.222955,
    lat: -21.5739324
  },
  {
    lng: -41.2228703,
    lat: -21.5739081
  },
  {
    lng: -41.2228308,
    lat: -21.5739053
  },
  {
    lng: -41.2227527,
    lat: -21.5738999
  },
  {
    lng: -41.2226452,
    lat: -21.573963
  },
  {
    lng: -41.2225771,
    lat: -21.5740379
  },
  {
    lng: -41.2225495,
    lat: -21.5741114
  },
  {
    lng: -41.2224773,
    lat: -21.5742321
  },
  {
    lng: -41.2224217,
    lat: -21.5743188
  },
  {
    lng: -41.2223779,
    lat: -21.5743966
  },
  {
    lng: -41.2223934,
    lat: -21.5744867
  },
  {
    lng: -41.2224875,
    lat: -21.5745993
  },
  {
    lng: -41.222567,
    lat: -21.5746694
  },
  {
    lng: -41.2226021,
    lat: -21.5747379
  },
  {
    lng: -41.2227486,
    lat: -21.5749574
  },
  {
    lng: -41.2228228,
    lat: -21.5750513
  },
  {
    lng: -41.222871,
    lat: -21.5751378
  },
  {
    lng: -41.2228631,
    lat: -21.5752292
  },
  {
    lng: -41.2227346,
    lat: -21.5754463
  },
  {
    lng: -41.2226749,
    lat: -21.5755447
  },
  {
    lng: -41.2226237,
    lat: -21.5756262
  },
  {
    lng: -41.2225166,
    lat: -21.5757292
  },
  {
    lng: -41.2224219,
    lat: -21.5758087
  },
  {
    lng: -41.2223201,
    lat: -21.5759359
  },
  {
    lng: -41.2222496,
    lat: -21.5759969
  },
  {
    lng: -41.2222033,
    lat: -21.5760682
  },
  {
    lng: -41.2221799,
    lat: -21.5761658
  },
  {
    lng: -41.2221265,
    lat: -21.5762775
  },
  {
    lng: -41.2220856,
    lat: -21.5763556
  },
  {
    lng: -41.2220371,
    lat: -21.5764159
  },
  {
    lng: -41.2219446,
    lat: -21.5764441
  },
  {
    lng: -41.2217762,
    lat: -21.5765034
  },
  {
    lng: -41.2216091,
    lat: -21.576573
  },
  {
    lng: -41.2215874,
    lat: -21.576582
  },
  {
    lng: -41.2215313,
    lat: -21.5766035
  },
  {
    lng: -41.2214788,
    lat: -21.5766244
  },
  {
    lng: -41.2214336,
    lat: -21.5766463
  },
  {
    lng: -41.2213517,
    lat: -21.5766489
  },
  {
    lng: -41.2212982,
    lat: -21.5766337
  },
  {
    lng: -41.2212371,
    lat: -21.5766372
  },
  {
    lng: -41.2211916,
    lat: -21.5766684
  },
  {
    lng: -41.2212025,
    lat: -21.5767188
  },
  {
    lng: -41.2211971,
    lat: -21.5767589
  },
  {
    lng: -41.2211368,
    lat: -21.5767915
  },
  {
    lng: -41.2210651,
    lat: -21.5767854
  },
  {
    lng: -41.2209953,
    lat: -21.5768007
  },
  {
    lng: -41.2209626,
    lat: -21.5768267
  },
  {
    lng: -41.2209531,
    lat: -21.5768792
  },
  {
    lng: -41.2209857,
    lat: -21.576923
  },
  {
    lng: -41.2209822,
    lat: -21.5769583
  },
  {
    lng: -41.2210264,
    lat: -21.5769974
  },
  {
    lng: -41.2210337,
    lat: -21.577041
  },
  {
    lng: -41.2210076,
    lat: -21.5771042
  },
  {
    lng: -41.2210067,
    lat: -21.5771694
  },
  {
    lng: -41.2210405,
    lat: -21.577229
  },
  {
    lng: -41.221066,
    lat: -21.5773113
  },
  {
    lng: -41.2210606,
    lat: -21.5773828
  },
  {
    lng: -41.221061,
    lat: -21.5774385
  },
  {
    lng: -41.2211101,
    lat: -21.5775172
  },
  {
    lng: -41.2211588,
    lat: -21.5775838
  },
  {
    lng: -41.2211555,
    lat: -21.5776474
  },
  {
    lng: -41.2210782,
    lat: -21.5776648
  },
  {
    lng: -41.2209321,
    lat: -21.5777174
  },
  {
    lng: -41.2208075,
    lat: -21.5777623
  },
  {
    lng: -41.2207405,
    lat: -21.5777571
  },
  {
    lng: -41.2206375,
    lat: -21.5777521
  },
  {
    lng: -41.2205883,
    lat: -21.5777967
  },
  {
    lng: -41.2205565,
    lat: -21.5778591
  },
  {
    lng: -41.2205058,
    lat: -21.5778952
  },
  {
    lng: -41.2203204,
    lat: -21.5779471
  },
  {
    lng: -41.2202243,
    lat: -21.5779863
  },
  {
    lng: -41.2201463,
    lat: -21.5780324
  },
  {
    lng: -41.2200829,
    lat: -21.5781123
  },
  {
    lng: -41.2200301,
    lat: -21.5781867
  },
  {
    lng: -41.2199786,
    lat: -21.5782691
  },
  {
    lng: -41.2199257,
    lat: -21.5783137
  },
  {
    lng: -41.2198236,
    lat: -21.5783109
  },
  {
    lng: -41.2197766,
    lat: -21.5783011
  },
  {
    lng: -41.2197358,
    lat: -21.5783215
  },
  {
    lng: -41.2197185,
    lat: -21.5783873
  },
  {
    lng: -41.2196879,
    lat: -21.5784412
  },
  {
    lng: -41.219665,
    lat: -21.5784765
  },
  {
    lng: -41.219649,
    lat: -21.5785772
  },
  {
    lng: -41.21964,
    lat: -21.578643
  },
  {
    lng: -41.2196175,
    lat: -21.5787541
  },
  {
    lng: -41.2196408,
    lat: -21.5788588
  },
  {
    lng: -41.2196121,
    lat: -21.5789079
  },
  {
    lng: -41.2196109,
    lat: -21.5789099
  },
  {
    lng: -41.2195397,
    lat: -21.5789581
  },
  {
    lng: -41.2194388,
    lat: -21.5789979
  },
  {
    lng: -41.2193136,
    lat: -21.5790169
  },
  {
    lng: -41.2192039,
    lat: -21.5790541
  },
  {
    lng: -41.2190825,
    lat: -21.5790707
  },
  {
    lng: -41.2190078,
    lat: -21.5790561
  },
  {
    lng: -41.2189105,
    lat: -21.5790284
  },
  {
    lng: -41.2188217,
    lat: -21.5789917
  },
  {
    lng: -41.2188085,
    lat: -21.5790822
  },
  {
    lng: -41.2187108,
    lat: -21.579092
  },
  {
    lng: -41.218554,
    lat: -21.5791795
  },
  {
    lng: -41.2183672,
    lat: -21.579326
  },
  {
    lng: -41.2182035,
    lat: -21.579421
  },
  {
    lng: -41.2180002,
    lat: -21.5795348
  },
  {
    lng: -41.2177099,
    lat: -21.5796233
  },
  {
    lng: -41.2175796,
    lat: -21.5797195
  },
  {
    lng: -41.217508,
    lat: -21.5797928
  },
  {
    lng: -41.2174324,
    lat: -21.5798394
  },
  {
    lng: -41.2173576,
    lat: -21.5799405
  },
  {
    lng: -41.2172653,
    lat: -21.5799729
  },
  {
    lng: -41.2171068,
    lat: -21.5799861
  },
  {
    lng: -41.216976,
    lat: -21.5799769
  },
  {
    lng: -41.2168135,
    lat: -21.5800697
  },
  {
    lng: -41.2166441,
    lat: -21.5800755
  },
  {
    lng: -41.2165408,
    lat: -21.5800908
  },
  {
    lng: -41.2164444,
    lat: -21.5801709
  },
  {
    lng: -41.2164348,
    lat: -21.580266
  },
  {
    lng: -41.2163944,
    lat: -21.580363
  },
  {
    lng: -41.2162986,
    lat: -21.5804364
  },
  {
    lng: -41.2162031,
    lat: -21.5805055
  },
  {
    lng: -41.21611,
    lat: -21.5805694
  },
  {
    lng: -41.2159557,
    lat: -21.5805959
  },
  {
    lng: -41.2158505,
    lat: -21.5806478
  },
  {
    lng: -41.2157347,
    lat: -21.5806777
  },
  {
    lng: -41.2155959,
    lat: -21.5807077
  },
  {
    lng: -41.2155142,
    lat: -21.5807582
  },
  {
    lng: -41.2154288,
    lat: -21.5809001
  },
  {
    lng: -41.2153076,
    lat: -21.5809623
  },
  {
    lng: -41.2151439,
    lat: -21.5810018
  },
  {
    lng: -41.2149908,
    lat: -21.5809723
  },
  {
    lng: -41.2148971,
    lat: -21.5809298
  },
  {
    lng: -41.2147855,
    lat: -21.5808945
  },
  {
    lng: -41.214696,
    lat: -21.5809153
  },
  {
    lng: -41.2145931,
    lat: -21.5808748
  },
  {
    lng: -41.2144842,
    lat: -21.5808477
  },
  {
    lng: -41.2143635,
    lat: -21.5807963
  },
  {
    lng: -41.2142623,
    lat: -21.5807767
  },
  {
    lng: -41.2141489,
    lat: -21.5807748
  },
  {
    lng: -41.2140822,
    lat: -21.5808227
  },
  {
    lng: -41.2140147,
    lat: -21.5810223
  },
  {
    lng: -41.2129715,
    lat: -21.5814881
  },
  {
    lng: -41.2129388,
    lat: -21.5815009
  },
  {
    lng: -41.2128531,
    lat: -21.5815344
  },
  {
    lng: -41.2127483,
    lat: -21.5815285
  },
  {
    lng: -41.2126368,
    lat: -21.5815055
  },
  {
    lng: -41.2125317,
    lat: -21.5815115
  },
  {
    lng: -41.2123828,
    lat: -21.5815273
  },
  {
    lng: -41.2122074,
    lat: -21.5815747
  },
  {
    lng: -41.2121048,
    lat: -21.5816226
  },
  {
    lng: -41.2120194,
    lat: -21.5817022
  },
  {
    lng: -41.2119356,
    lat: -21.5817637
  },
  {
    lng: -41.211856,
    lat: -21.5818272
  },
  {
    lng: -41.2117826,
    lat: -21.5818514
  },
  {
    lng: -41.2116594,
    lat: -21.5818642
  },
  {
    lng: -41.2115409,
    lat: -21.5818476
  },
  {
    lng: -41.211319,
    lat: -21.5818389
  },
  {
    lng: -41.2112313,
    lat: -21.5818646
  },
  {
    lng: -41.2111211,
    lat: -21.5819116
  },
  {
    lng: -41.2110457,
    lat: -21.5819537
  },
  {
    lng: -41.2109008,
    lat: -21.5819401
  },
  {
    lng: -41.2107784,
    lat: -21.5819228
  },
  {
    lng: -41.2106572,
    lat: -21.5819244
  },
  {
    lng: -41.2103567,
    lat: -21.582014
  },
  {
    lng: -41.2102738,
    lat: -21.5820574
  },
  {
    lng: -41.2102628,
    lat: -21.5820631
  },
  {
    lng: -41.2101408,
    lat: -21.5821206
  },
  {
    lng: -41.2100047,
    lat: -21.5822
  },
  {
    lng: -41.2098702,
    lat: -21.582278
  },
  {
    lng: -41.2097613,
    lat: -21.5823552
  },
  {
    lng: -41.2097145,
    lat: -21.5824117
  },
  {
    lng: -41.2096846,
    lat: -21.5824749
  },
  {
    lng: -41.2096618,
    lat: -21.5825663
  },
  {
    lng: -41.2096209,
    lat: -21.5827143
  },
  {
    lng: -41.2095534,
    lat: -21.5827892
  },
  {
    lng: -41.209426,
    lat: -21.582821
  },
  {
    lng: -41.2092891,
    lat: -21.5828363
  },
  {
    lng: -41.2090564,
    lat: -21.5828628
  },
  {
    lng: -41.2089965,
    lat: -21.5828674
  },
  {
    lng: -41.2089043,
    lat: -21.5828664
  },
  {
    lng: -41.2087782,
    lat: -21.5828675
  },
  {
    lng: -41.2086497,
    lat: -21.582901
  },
  {
    lng: -41.208553,
    lat: -21.5829214
  },
  {
    lng: -41.2084336,
    lat: -21.5829464
  },
  {
    lng: -41.2083244,
    lat: -21.582961
  },
  {
    lng: -41.2082073,
    lat: -21.5829805
  },
  {
    lng: -41.2081168,
    lat: -21.5830015
  },
  {
    lng: -41.2079677,
    lat: -21.5830484
  },
  {
    lng: -41.2078882,
    lat: -21.5830851
  },
  {
    lng: -41.20785,
    lat: -21.5831095
  },
  {
    lng: -41.2078547,
    lat: -21.5831732
  },
  {
    lng: -41.2078071,
    lat: -21.5832367
  },
  {
    lng: -41.2076763,
    lat: -21.5834444
  },
  {
    lng: -41.2075818,
    lat: -21.5835797
  },
  {
    lng: -41.2075347,
    lat: -21.5836531
  },
  {
    lng: -41.2074029,
    lat: -21.5837069
  },
  {
    lng: -41.2072853,
    lat: -21.5837721
  },
  {
    lng: -41.2069383,
    lat: -21.5839525
  },
  {
    lng: -41.2068578,
    lat: -21.5840104
  },
  {
    lng: -41.2067184,
    lat: -21.5841212
  },
  {
    lng: -41.2065927,
    lat: -21.5842107
  },
  {
    lng: -41.2064188,
    lat: -21.5842699
  },
  {
    lng: -41.2063369,
    lat: -21.584364
  },
  {
    lng: -41.2062229,
    lat: -21.5844364
  },
  {
    lng: -41.2060759,
    lat: -21.584551
  },
  {
    lng: -41.2058522,
    lat: -21.5846985
  },
  {
    lng: -41.205731,
    lat: -21.5848025
  },
  {
    lng: -41.2056824,
    lat: -21.5848376
  },
  {
    lng: -41.2056442,
    lat: -21.5848612
  },
  {
    lng: -41.2056344,
    lat: -21.5848914
  },
  {
    lng: -41.2055287,
    lat: -21.5849834
  },
  {
    lng: -41.205439,
    lat: -21.5850909
  },
  {
    lng: -41.2053353,
    lat: -21.585156
  },
  {
    lng: -41.2052716,
    lat: -21.5852327
  },
  {
    lng: -41.2051785,
    lat: -21.5853095
  },
  {
    lng: -41.2051051,
    lat: -21.5853745
  },
  {
    lng: -41.2050134,
    lat: -21.5854361
  },
  {
    lng: -41.204919,
    lat: -21.5854605
  },
  {
    lng: -41.2048642,
    lat: -21.5854746
  },
  {
    lng: -41.2047327,
    lat: -21.5854102
  },
  {
    lng: -41.2046367,
    lat: -21.5853066
  },
  {
    lng: -41.2045454,
    lat: -21.5852039
  },
  {
    lng: -41.2044437,
    lat: -21.5850839
  },
  {
    lng: -41.2043544,
    lat: -21.5850485
  },
  {
    lng: -41.2041654,
    lat: -21.5850374
  },
  {
    lng: -41.204047,
    lat: -21.5850385
  },
  {
    lng: -41.2039496,
    lat: -21.5850716
  },
  {
    lng: -41.2037689,
    lat: -21.585211
  },
  {
    lng: -41.2034597,
    lat: -21.5854506
  },
  {
    lng: -41.2032571,
    lat: -21.585576
  },
  {
    lng: -41.2030525,
    lat: -21.5857266
  },
  {
    lng: -41.202893,
    lat: -21.5858525
  },
  {
    lng: -41.2027784,
    lat: -21.5859152
  },
  {
    lng: -41.2027054,
    lat: -21.5859472
  },
  {
    lng: -41.2026441,
    lat: -21.5860182
  },
  {
    lng: -41.2025667,
    lat: -21.5860995
  },
  {
    lng: -41.2024432,
    lat: -21.5861773
  },
  {
    lng: -41.2023026,
    lat: -21.5862795
  },
  {
    lng: -41.202166,
    lat: -21.5863774
  },
  {
    lng: -41.2020408,
    lat: -21.5864492
  },
  {
    lng: -41.2019338,
    lat: -21.5865164
  },
  {
    lng: -41.2018775,
    lat: -21.5865426
  },
  {
    lng: -41.2018142,
    lat: -21.5866034
  },
  {
    lng: -41.2016952,
    lat: -21.5867186
  },
  {
    lng: -41.2015517,
    lat: -21.5867955
  },
  {
    lng: -41.2014454,
    lat: -21.5868628
  },
  {
    lng: -41.2013584,
    lat: -21.5869296
  },
  {
    lng: -41.2012058,
    lat: -21.5870316
  },
  {
    lng: -41.2009655,
    lat: -21.5872022
  },
  {
    lng: -41.2007261,
    lat: -21.5873749
  },
  {
    lng: -41.2006186,
    lat: -21.5874542
  },
  {
    lng: -41.2003334,
    lat: -21.5876817
  },
  {
    lng: -41.2002533,
    lat: -21.5877389
  },
  {
    lng: -41.2001469,
    lat: -21.5877974
  },
  {
    lng: -41.2000334,
    lat: -21.5879142
  },
  {
    lng: -41.2000316,
    lat: -21.588003
  },
  {
    lng: -41.1999953,
    lat: -21.5880777
  },
  {
    lng: -41.1999218,
    lat: -21.5881499
  },
  {
    lng: -41.1998893,
    lat: -21.5882186
  },
  {
    lng: -41.1998673,
    lat: -21.5883178
  },
  {
    lng: -41.1998202,
    lat: -21.5886932
  },
  {
    lng: -41.1998123,
    lat: -21.5887716
  },
  {
    lng: -41.1998007,
    lat: -21.5888945
  },
  {
    lng: -41.1998031,
    lat: -21.5890274
  },
  {
    lng: -41.1997602,
    lat: -21.5893751
  },
  {
    lng: -41.1997369,
    lat: -21.5897281
  },
  {
    lng: -41.1997207,
    lat: -21.589888
  },
  {
    lng: -41.1996941,
    lat: -21.5900981
  },
  {
    lng: -41.1996775,
    lat: -21.5901646
  },
  {
    lng: -41.1996512,
    lat: -21.5903811
  },
  {
    lng: -41.1996229,
    lat: -21.5904819
  },
  {
    lng: -41.1996061,
    lat: -21.5905766
  },
  {
    lng: -41.1996136,
    lat: -21.5907478
  },
  {
    lng: -41.199593,
    lat: -21.5908754
  },
  {
    lng: -41.1995727,
    lat: -21.5910146
  },
  {
    lng: -41.1995594,
    lat: -21.5911622
  },
  {
    lng: -41.1994529,
    lat: -21.5913869
  },
  {
    lng: -41.1993778,
    lat: -21.5914862
  },
  {
    lng: -41.199207,
    lat: -21.5916066
  },
  {
    lng: -41.1991089,
    lat: -21.5917083
  },
  {
    lng: -41.1990231,
    lat: -21.5917642
  },
  {
    lng: -41.1989275,
    lat: -21.5918468
  },
  {
    lng: -41.1988299,
    lat: -21.5919268
  },
  {
    lng: -41.1987168,
    lat: -21.5919949
  },
  {
    lng: -41.1985355,
    lat: -21.5921592
  },
  {
    lng: -41.1983582,
    lat: -21.592318
  },
  {
    lng: -41.1982796,
    lat: -21.5923759
  },
  {
    lng: -41.1982388,
    lat: -21.5924189
  },
  {
    lng: -41.1982057,
    lat: -21.5924825
  },
  {
    lng: -41.1981597,
    lat: -21.5925283
  },
  {
    lng: -41.1981117,
    lat: -21.5925385
  },
  {
    lng: -41.198024,
    lat: -21.592591
  },
  {
    lng: -41.1978499,
    lat: -21.5927531
  },
  {
    lng: -41.1977204,
    lat: -21.5928833
  },
  {
    lng: -41.1975234,
    lat: -21.5929805
  },
  {
    lng: -41.1973142,
    lat: -21.593032
  },
  {
    lng: -41.1969855,
    lat: -21.5930413
  },
  {
    lng: -41.1966843,
    lat: -21.5930003
  },
  {
    lng: -41.1963016,
    lat: -21.592937
  },
  {
    lng: -41.1962321,
    lat: -21.5929302
  },
  {
    lng: -41.1959206,
    lat: -21.5928892
  },
  {
    lng: -41.1955439,
    lat: -21.5928385
  },
  {
    lng: -41.195333,
    lat: -21.5928092
  },
  {
    lng: -41.1951617,
    lat: -21.5927853
  },
  {
    lng: -41.1949425,
    lat: -21.5927625
  },
  {
    lng: -41.1945507,
    lat: -21.5927318
  },
  {
    lng: -41.1943581,
    lat: -21.5926951
  },
  {
    lng: -41.1941026,
    lat: -21.5926591
  },
  {
    lng: -41.193959,
    lat: -21.5926389
  },
  {
    lng: -41.1936843,
    lat: -21.5926188
  },
  {
    lng: -41.1932703,
    lat: -21.5925718
  },
  {
    lng: -41.1928679,
    lat: -21.5925189
  },
  {
    lng: -41.1924798,
    lat: -21.5924701
  },
  {
    lng: -41.1923952,
    lat: -21.5924548
  },
  {
    lng: -41.1920086,
    lat: -21.5924114
  },
  {
    lng: -41.1919547,
    lat: -21.592407
  },
  {
    lng: -41.1915367,
    lat: -21.5923628
  },
  {
    lng: -41.1911957,
    lat: -21.5923048
  },
  {
    lng: -41.1909314,
    lat: -21.5922382
  },
  {
    lng: -41.1905325,
    lat: -21.5921902
  },
  {
    lng: -41.1903541,
    lat: -21.5921649
  },
  {
    lng: -41.1900033,
    lat: -21.5921079
  },
  {
    lng: -41.1898183,
    lat: -21.5919903
  },
  {
    lng: -41.1894737,
    lat: -21.5916121
  },
  {
    lng: -41.1892792,
    lat: -21.5916227
  },
  {
    lng: -41.1881701,
    lat: -21.5919455
  },
  {
    lng: -41.1876985,
    lat: -21.5920255
  },
  {
    lng: -41.1871635,
    lat: -21.5920587
  },
  {
    lng: -41.1870787,
    lat: -21.5922081
  },
  {
    lng: -41.1864485,
    lat: -21.5921634
  },
  {
    lng: -41.1846028,
    lat: -21.5921816
  },
  {
    lng: -41.1829195,
    lat: -21.5921732
  },
  {
    lng: -41.1811243,
    lat: -21.5921168
  },
  {
    lng: -41.1810899,
    lat: -21.5920603
  },
  {
    lng: -41.181219,
    lat: -21.5926389
  },
  {
    lng: -41.1812957,
    lat: -21.5929681
  },
  {
    lng: -41.1813107,
    lat: -21.5930229
  },
  {
    lng: -41.1813894,
    lat: -21.5933978
  },
  {
    lng: -41.1814216,
    lat: -21.5936164
  },
  {
    lng: -41.1814319,
    lat: -21.5937065
  },
  {
    lng: -41.1814423,
    lat: -21.5937966
  },
  {
    lng: -41.1814532,
    lat: -21.5939363
  },
  {
    lng: -41.1815075,
    lat: -21.5943099
  },
  {
    lng: -41.1816617,
    lat: -21.5958063
  },
  {
    lng: -41.1816675,
    lat: -21.5958629
  },
  {
    lng: -41.1817636,
    lat: -21.5965806
  },
  {
    lng: -41.1817559,
    lat: -21.596969
  },
  {
    lng: -41.1817503,
    lat: -21.5970824
  },
  {
    lng: -41.1817379,
    lat: -21.5974718
  },
  {
    lng: -41.1817376,
    lat: -21.5975209
  },
  {
    lng: -41.1817288,
    lat: -21.5978595
  },
  {
    lng: -41.1826046,
    lat: -21.5991126
  },
  {
    lng: -41.1826412,
    lat: -21.6021935
  },
  {
    lng: -41.1826046,
    lat: -21.6043575
  },
  {
    lng: -41.1830447,
    lat: -21.6057146
  },
  {
    lng: -41.1834115,
    lat: -21.6074752
  },
  {
    lng: -41.1837416,
    lat: -21.6091623
  },
  {
    lng: -41.1837144,
    lat: -21.6107585
  },
  {
    lng: -41.1837678,
    lat: -21.6127483
  },
  {
    lng: -41.183925,
    lat: -21.6227521
  },
  {
    lng: -41.1839616,
    lat: -21.6250806
  },
  {
    lng: -41.1849376,
    lat: -21.6314987
  },
  {
    lng: -41.1855755,
    lat: -21.6364325
  },
  {
    lng: -41.1923647,
    lat: -21.663219
  },
  {
    lng: -41.1942132,
    lat: -21.6713317
  },
  {
    lng: -41.1962488,
    lat: -21.6783372
  },
  {
    lng: -41.1963106,
    lat: -21.6786393
  },
  {
    lng: -41.1969198,
    lat: -21.681619
  },
  {
    lng: -41.1968623,
    lat: -21.6824102
  },
  {
    lng: -41.1968536,
    lat: -21.6825284
  },
  {
    lng: -41.1960708,
    lat: -21.6832887
  },
  {
    lng: -41.1954865,
    lat: -21.6834245
  },
  {
    lng: -41.1944108,
    lat: -21.68343
  },
  {
    lng: -41.1926819,
    lat: -21.6834079
  },
  {
    lng: -41.1918291,
    lat: -21.6835088
  },
  {
    lng: -41.1910864,
    lat: -21.6837564
  },
  {
    lng: -41.1904628,
    lat: -21.6840956
  },
  {
    lng: -41.1898485,
    lat: -21.6845816
  },
  {
    lng: -41.1866758,
    lat: -21.688011
  },
  {
    lng: -41.1863641,
    lat: -21.6881669
  },
  {
    lng: -41.1860615,
    lat: -21.6882494
  },
  {
    lng: -41.1857589,
    lat: -21.6882403
  },
  {
    lng: -41.1855571,
    lat: -21.6883136
  },
  {
    lng: -41.1853829,
    lat: -21.6884924
  },
  {
    lng: -41.1852087,
    lat: -21.6886804
  },
  {
    lng: -41.1850161,
    lat: -21.6887538
  },
  {
    lng: -41.1848052,
    lat: -21.6887904
  },
  {
    lng: -41.1844843,
    lat: -21.6887262
  },
  {
    lng: -41.1841359,
    lat: -21.6887171
  },
  {
    lng: -41.1833656,
    lat: -21.6888913
  },
  {
    lng: -41.1820269,
    lat: -21.6889555
  },
  {
    lng: -41.1810091,
    lat: -21.6891205
  },
  {
    lng: -41.1805506,
    lat: -21.6890563
  },
  {
    lng: -41.1800004,
    lat: -21.688928
  },
  {
    lng: -41.179276,
    lat: -21.6887721
  },
  {
    lng: -41.1785516,
    lat: -21.6887446
  },
  {
    lng: -41.1782032,
    lat: -21.6887996
  },
  {
    lng: -41.1779006,
    lat: -21.6889188
  },
  {
    lng: -41.1774146,
    lat: -21.6891755
  },
  {
    lng: -41.1771212,
    lat: -21.6891297
  },
  {
    lng: -41.176626,
    lat: -21.6888546
  },
  {
    lng: -41.1760392,
    lat: -21.6883961
  },
  {
    lng: -41.1757824,
    lat: -21.6882678
  },
  {
    lng: -41.1752964,
    lat: -21.6877543
  },
  {
    lng: -41.1750947,
    lat: -21.6875159
  },
  {
    lng: -41.1750764,
    lat: -21.6873325
  },
  {
    lng: -41.1751406,
    lat: -21.6872041
  },
  {
    lng: -41.1752598,
    lat: -21.6870574
  },
  {
    lng: -41.1754982,
    lat: -21.6867273
  },
  {
    lng: -41.175544,
    lat: -21.6865164
  },
  {
    lng: -41.1754802,
    lat: -21.686287
  },
  {
    lng: -41.1752873,
    lat: -21.6858562
  },
  {
    lng: -41.1747646,
    lat: -21.6855077
  },
  {
    lng: -41.173866,
    lat: -21.6850951
  },
  {
    lng: -41.1729887,
    lat: -21.6845905
  },
  {
    lng: -41.1725181,
    lat: -21.6843065
  },
  {
    lng: -41.1722063,
    lat: -21.6839948
  },
  {
    lng: -41.1715186,
    lat: -21.6832337
  },
  {
    lng: -41.1713719,
    lat: -21.6830411
  },
  {
    lng: -41.1711427,
    lat: -21.6828853
  },
  {
    lng: -41.1708722,
    lat: -21.682899
  },
  {
    lng: -41.1705466,
    lat: -21.6828944
  },
  {
    lng: -41.1696389,
    lat: -21.6828394
  },
  {
    lng: -41.1690153,
    lat: -21.6826652
  },
  {
    lng: -41.1687678,
    lat: -21.6825276
  },
  {
    lng: -41.168346,
    lat: -21.682115
  },
  {
    lng: -41.1678966,
    lat: -21.68195
  },
  {
    lng: -41.1675574,
    lat: -21.68195
  },
  {
    lng: -41.166888,
    lat: -21.6820325
  },
  {
    lng: -41.1663928,
    lat: -21.6821609
  },
  {
    lng: -41.1660811,
    lat: -21.6819225
  },
  {
    lng: -41.1653292,
    lat: -21.6818308
  },
  {
    lng: -41.1651091,
    lat: -21.6816565
  },
  {
    lng: -41.1648524,
    lat: -21.6815924
  },
  {
    lng: -41.1647882,
    lat: -21.6814273
  },
  {
    lng: -41.1647973,
    lat: -21.6812531
  },
  {
    lng: -41.1648615,
    lat: -21.6810972
  },
  {
    lng: -41.1648244,
    lat: -21.680903
  },
  {
    lng: -41.1647032,
    lat: -21.6807481
  },
  {
    lng: -41.1643847,
    lat: -21.6806571
  },
  {
    lng: -41.1640913,
    lat: -21.6804278
  },
  {
    lng: -41.1639629,
    lat: -21.6801619
  },
  {
    lng: -41.1638345,
    lat: -21.6799418
  },
  {
    lng: -41.1636695,
    lat: -21.679786
  },
  {
    lng: -41.1636328,
    lat: -21.6796668
  },
  {
    lng: -41.1636695,
    lat: -21.6795567
  },
  {
    lng: -41.1637429,
    lat: -21.6794467
  },
  {
    lng: -41.1637612,
    lat: -21.6793183
  },
  {
    lng: -41.1636695,
    lat: -21.679245
  },
  {
    lng: -41.1635411,
    lat: -21.679245
  },
  {
    lng: -41.1634036,
    lat: -21.6792083
  },
  {
    lng: -41.1633944,
    lat: -21.6790524
  },
  {
    lng: -41.1633669,
    lat: -21.6789057
  },
  {
    lng: -41.1628351,
    lat: -21.6777045
  },
  {
    lng: -41.162725,
    lat: -21.6776311
  },
  {
    lng: -41.1625325,
    lat: -21.6776953
  },
  {
    lng: -41.1623949,
    lat: -21.6776311
  },
  {
    lng: -41.1623399,
    lat: -21.6774844
  },
  {
    lng: -41.1622024,
    lat: -21.677301
  },
  {
    lng: -41.1620006,
    lat: -21.6770443
  },
  {
    lng: -41.1616889,
    lat: -21.6770168
  },
  {
    lng: -41.1612396,
    lat: -21.6769618
  },
  {
    lng: -41.1611662,
    lat: -21.6768976
  },
  {
    lng: -41.1611662,
    lat: -21.6767233
  },
  {
    lng: -41.1611662,
    lat: -21.6765491
  },
  {
    lng: -41.1610287,
    lat: -21.6764299
  },
  {
    lng: -41.1608086,
    lat: -21.6764666
  },
  {
    lng: -41.1606527,
    lat: -21.6763749
  },
  {
    lng: -41.1605519,
    lat: -21.6761823
  },
  {
    lng: -41.1603318,
    lat: -21.6757972
  },
  {
    lng: -41.1602138,
    lat: -21.675761
  },
  {
    lng: -41.1599428,
    lat: -21.6756883
  },
  {
    lng: -41.1596899,
    lat: -21.6755221
  },
  {
    lng: -41.158938,
    lat: -21.6752195
  },
  {
    lng: -41.1585162,
    lat: -21.6748528
  },
  {
    lng: -41.1583695,
    lat: -21.6746419
  },
  {
    lng: -41.1580119,
    lat: -21.6745685
  },
  {
    lng: -41.1575076,
    lat: -21.6747061
  },
  {
    lng: -41.1570674,
    lat: -21.6749169
  },
  {
    lng: -41.1568204,
    lat: -21.6748593
  },
  {
    lng: -41.1562697,
    lat: -21.6746052
  },
  {
    lng: -41.1559213,
    lat: -21.6742476
  },
  {
    lng: -41.1556462,
    lat: -21.6741284
  },
  {
    lng: -41.1554628,
    lat: -21.6742384
  },
  {
    lng: -41.1554078,
    lat: -21.6744035
  },
  {
    lng: -41.1555086,
    lat: -21.6746327
  },
  {
    lng: -41.1554811,
    lat: -21.6747519
  },
  {
    lng: -41.1553252,
    lat: -21.6747702
  },
  {
    lng: -41.1551969,
    lat: -21.6746144
  },
  {
    lng: -41.1550135,
    lat: -21.6746052
  },
  {
    lng: -41.1549585,
    lat: -21.6747794
  },
  {
    lng: -41.1546742,
    lat: -21.6746144
  },
  {
    lng: -41.1540965,
    lat: -21.6745593
  },
  {
    lng: -41.1532804,
    lat: -21.6742659
  },
  {
    lng: -41.1522901,
    lat: -21.6740642
  },
  {
    lng: -41.1511348,
    lat: -21.6739817
  },
  {
    lng: -41.1503576,
    lat: -21.6740226
  },
  {
    lng: -41.1496218,
    lat: -21.6741559
  },
  {
    lng: -41.1486773,
    lat: -21.6745135
  },
  {
    lng: -41.1478521,
    lat: -21.6749536
  },
  {
    lng: -41.1472469,
    lat: -21.6753204
  },
  {
    lng: -41.1465867,
    lat: -21.6757605
  },
  {
    lng: -41.1460732,
    lat: -21.6762557
  },
  {
    lng: -41.1457981,
    lat: -21.6763749
  },
  {
    lng: -41.1456422,
    lat: -21.6763566
  },
  {
    lng: -41.1456331,
    lat: -21.6761915
  },
  {
    lng: -41.145523,
    lat: -21.675458
  },
  {
    lng: -41.1455414,
    lat: -21.6752654
  },
  {
    lng: -41.1456697,
    lat: -21.675082
  },
  {
    lng: -41.1459173,
    lat: -21.6748528
  },
  {
    lng: -41.1460182,
    lat: -21.6746785
  },
  {
    lng: -41.1459357,
    lat: -21.6745227
  },
  {
    lng: -41.1457614,
    lat: -21.6744585
  },
  {
    lng: -41.1456331,
    lat: -21.6743759
  },
  {
    lng: -41.1456771,
    lat: -21.6742512
  },
  {
    lng: -41.1458073,
    lat: -21.6739908
  },
  {
    lng: -41.1457981,
    lat: -21.6737616
  },
  {
    lng: -41.1457156,
    lat: -21.6735048
  },
  {
    lng: -41.1457706,
    lat: -21.6734131
  },
  {
    lng: -41.1459265,
    lat: -21.6733398
  },
  {
    lng: -41.1461374,
    lat: -21.6732206
  },
  {
    lng: -41.14644,
    lat: -21.6731472
  },
  {
    lng: -41.1467609,
    lat: -21.6730922
  },
  {
    lng: -41.1469443,
    lat: -21.6731289
  },
  {
    lng: -41.147146,
    lat: -21.6734223
  },
  {
    lng: -41.1473478,
    lat: -21.6734682
  },
  {
    lng: -41.1473661,
    lat: -21.6731472
  },
  {
    lng: -41.1475036,
    lat: -21.6729914
  },
  {
    lng: -41.1475403,
    lat: -21.6728721
  },
  {
    lng: -41.1470543,
    lat: -21.6726704
  },
  {
    lng: -41.1470452,
    lat: -21.6725329
  },
  {
    lng: -41.1472102,
    lat: -21.672377
  },
  {
    lng: -41.1472561,
    lat: -21.6722853
  },
  {
    lng: -41.1472102,
    lat: -21.6721753
  },
  {
    lng: -41.1470452,
    lat: -21.6720469
  },
  {
    lng: -41.1469626,
    lat: -21.6718452
  },
  {
    lng: -41.1467976,
    lat: -21.6717351
  },
  {
    lng: -41.1465959,
    lat: -21.6718818
  },
  {
    lng: -41.1465225,
    lat: -21.6720652
  },
  {
    lng: -41.1465317,
    lat: -21.6723587
  },
  {
    lng: -41.1465042,
    lat: -21.6725237
  },
  {
    lng: -41.1463758,
    lat: -21.6725696
  },
  {
    lng: -41.1462382,
    lat: -21.6725879
  },
  {
    lng: -41.1459632,
    lat: -21.672542
  },
  {
    lng: -41.1457248,
    lat: -21.672487
  },
  {
    lng: -41.1454497,
    lat: -21.6723678
  },
  {
    lng: -41.1452388,
    lat: -21.6723678
  },
  {
    lng: -41.1448812,
    lat: -21.6724412
  },
  {
    lng: -41.1445052,
    lat: -21.6727071
  },
  {
    lng: -41.1442943,
    lat: -21.6728446
  },
  {
    lng: -41.1441017,
    lat: -21.6728171
  },
  {
    lng: -41.14368,
    lat: -21.6725971
  },
  {
    lng: -41.1433957,
    lat: -21.6725054
  },
  {
    lng: -41.1433223,
    lat: -21.6723953
  },
  {
    lng: -41.1433407,
    lat: -21.672267
  },
  {
    lng: -41.1434691,
    lat: -21.6720836
  },
  {
    lng: -41.1435057,
    lat: -21.6719002
  },
  {
    lng: -41.1434049,
    lat: -21.6717443
  },
  {
    lng: -41.1432215,
    lat: -21.671726
  },
  {
    lng: -41.1430748,
    lat: -21.6718543
  },
  {
    lng: -41.1429556,
    lat: -21.6719919
  },
  {
    lng: -41.1426988,
    lat: -21.6720377
  },
  {
    lng: -41.1424971,
    lat: -21.672001
  },
  {
    lng: -41.1421853,
    lat: -21.6720561
  },
  {
    lng: -41.1419653,
    lat: -21.6720744
  },
  {
    lng: -41.1411308,
    lat: -21.6722303
  },
  {
    lng: -41.1408374,
    lat: -21.672001
  },
  {
    lng: -41.1403056,
    lat: -21.6722486
  },
  {
    lng: -41.1400488,
    lat: -21.6719919
  },
  {
    lng: -41.1398288,
    lat: -21.6717076
  },
  {
    lng: -41.1396912,
    lat: -21.6713775
  },
  {
    lng: -41.1395445,
    lat: -21.6713317
  },
  {
    lng: -41.1394345,
    lat: -21.6713867
  },
  {
    lng: -41.1393978,
    lat: -21.6719185
  },
  {
    lng: -41.1393611,
    lat: -21.6721661
  },
  {
    lng: -41.139407,
    lat: -21.6730739
  },
  {
    lng: -41.1393611,
    lat: -21.6740642
  },
  {
    lng: -41.1394895,
    lat: -21.6744126
  },
  {
    lng: -41.1399571,
    lat: -21.6750453
  },
  {
    lng: -41.1401301,
    lat: -21.6754683
  },
  {
    lng: -41.1408832,
    lat: -21.6762557
  },
  {
    lng: -41.1410575,
    lat: -21.6765124
  },
  {
    lng: -41.141195,
    lat: -21.676815
  },
  {
    lng: -41.1412134,
    lat: -21.6770718
  },
  {
    lng: -41.1411217,
    lat: -21.6773194
  },
  {
    lng: -41.1409749,
    lat: -21.6774202
  },
  {
    lng: -41.1406907,
    lat: -21.6774386
  },
  {
    lng: -41.1404156,
    lat: -21.6773377
  },
  {
    lng: -41.1401313,
    lat: -21.677191
  },
  {
    lng: -41.140003,
    lat: -21.6770534
  },
  {
    lng: -41.139517,
    lat: -21.6768609
  },
  {
    lng: -41.1393336,
    lat: -21.6768517
  },
  {
    lng: -41.1391594,
    lat: -21.6769251
  },
  {
    lng: -41.1390493,
    lat: -21.6770076
  },
  {
    lng: -41.1390035,
    lat: -21.6772002
  },
  {
    lng: -41.1389026,
    lat: -21.6772185
  },
  {
    lng: -41.1387926,
    lat: -21.6772093
  },
  {
    lng: -41.1383616,
    lat: -21.6764941
  },
  {
    lng: -41.1383891,
    lat: -21.6763841
  },
  {
    lng: -41.1382333,
    lat: -21.6762924
  },
  {
    lng: -41.1377381,
    lat: -21.6763749
  },
  {
    lng: -41.1365094,
    lat: -21.6765033
  },
  {
    lng: -41.1361609,
    lat: -21.6766958
  },
  {
    lng: -41.1343509,
    lat: -21.6779495
  },
  {
    lng: -41.1366429,
    lat: -21.6801953
  },
  {
    lng: -41.13738,
    lat: -21.6817957
  },
  {
    lng: -41.137836,
    lat: -21.6825937
  },
  {
    lng: -41.1373671,
    lat: -21.6845632
  },
  {
    lng: -41.1393881,
    lat: -21.6864467
  },
  {
    lng: -41.1402724,
    lat: -21.6875964
  },
  {
    lng: -41.1460374,
    lat: -21.6949786
  },
  {
    lng: -41.1530211,
    lat: -21.6995328
  },
  {
    lng: -41.1578918,
    lat: -21.7036196
  },
  {
    lng: -41.1639046,
    lat: -21.7068438
  },
  {
    lng: -41.1645356,
    lat: -21.7071763
  },
  {
    lng: -41.1645657,
    lat: -21.7071922
  },
  {
    lng: -41.1682637,
    lat: -21.7091407
  },
  {
    lng: -41.1696427,
    lat: -21.7105692
  },
  {
    lng: -41.1713688,
    lat: -21.7123571
  },
  {
    lng: -41.1722391,
    lat: -21.7132587
  },
  {
    lng: -41.1728065,
    lat: -21.714353
  },
  {
    lng: -41.1741323,
    lat: -21.7169098
  },
  {
    lng: -41.1749008,
    lat: -21.7183919
  },
  {
    lng: -41.1761082,
    lat: -21.7194252
  },
  {
    lng: -41.1787309,
    lat: -21.7216698
  },
  {
    lng: -41.1829803,
    lat: -21.7239116
  },
  {
    lng: -41.1880231,
    lat: -21.7236619
  },
  {
    lng: -41.192689,
    lat: -21.7249719
  },
  {
    lng: -41.1943175,
    lat: -21.7264689
  },
  {
    lng: -41.1897616,
    lat: -21.7310212
  },
  {
    lng: -41.1854356,
    lat: -21.7353438
  },
  {
    lng: -41.1827255,
    lat: -21.7380517
  },
  {
    lng: -41.1827216,
    lat: -21.7380556
  },
  {
    lng: -41.1773643,
    lat: -21.7434087
  },
  {
    lng: -41.1720442,
    lat: -21.7487245
  },
  {
    lng: -41.1718294,
    lat: -21.7499969
  },
  {
    lng: -41.1718218,
    lat: -21.7503603
  },
  {
    lng: -41.171921,
    lat: -21.7517865
  },
  {
    lng: -41.1720962,
    lat: -21.7524558
  },
  {
    lng: -41.1723774,
    lat: -21.7536005
  },
  {
    lng: -41.1737985,
    lat: -21.7601738
  },
  {
    lng: -41.1750946,
    lat: -21.765963
  },
  {
    lng: -41.1765059,
    lat: -21.7724531
  },
  {
    lng: -41.1770256,
    lat: -21.7749579
  },
  {
    lng: -41.1772249,
    lat: -21.7757057
  },
  {
    lng: -41.1772851,
    lat: -21.7761336
  },
  {
    lng: -41.1773188,
    lat: -21.7765036
  },
  {
    lng: -41.1772515,
    lat: -21.7768653
  },
  {
    lng: -41.1769976,
    lat: -21.7773101
  },
  {
    lng: -41.1764693,
    lat: -21.7778745
  },
  {
    lng: -41.1745176,
    lat: -21.7801102
  },
  {
    lng: -41.1706999,
    lat: -21.7844681
  },
  {
    lng: -41.166663,
    lat: -21.7891274
  },
  {
    lng: -41.1661898,
    lat: -21.7896776
  },
  {
    lng: -41.1626344,
    lat: -21.7938119
  },
  {
    lng: -41.1616925,
    lat: -21.7950398
  },
  {
    lng: -41.1612299,
    lat: -21.7958388
  },
  {
    lng: -41.1605907,
    lat: -21.7971088
  },
  {
    lng: -41.1557044,
    lat: -21.80636
  },
  {
    lng: -41.1546983,
    lat: -21.8082653
  },
  {
    lng: -41.150538,
    lat: -21.8160733
  },
  {
    lng: -41.1492271,
    lat: -21.8186019
  },
  {
    lng: -41.1490446,
    lat: -21.8192094
  },
  {
    lng: -41.1490256,
    lat: -21.8193439
  },
  {
    lng: -41.1489868,
    lat: -21.8197797
  },
  {
    lng: -41.148986,
    lat: -21.8199519
  },
  {
    lng: -41.1490125,
    lat: -21.8204158
  },
  {
    lng: -41.1492288,
    lat: -21.8220226
  },
  {
    lng: -41.1493271,
    lat: -21.8231439
  },
  {
    lng: -41.1495121,
    lat: -21.8244525
  },
  {
    lng: -41.1501522,
    lat: -21.8296819
  },
  {
    lng: -41.1502434,
    lat: -21.8301149
  },
  {
    lng: -41.1502712,
    lat: -21.8306629
  },
  {
    lng: -41.1503613,
    lat: -21.8312421
  },
  {
    lng: -41.1508842,
    lat: -21.8356924
  },
  {
    lng: -41.1509256,
    lat: -21.8359319
  },
  {
    lng: -41.1509564,
    lat: -21.8362916
  },
  {
    lng: -41.1512837,
    lat: -21.8387093
  },
  {
    lng: -41.1513585,
    lat: -21.8393114
  },
  {
    lng: -41.1529387,
    lat: -21.8520279
  },
  {
    lng: -41.1533231,
    lat: -21.8551084
  },
  {
    lng: -41.1533531,
    lat: -21.8552576
  },
  {
    lng: -41.1533903,
    lat: -21.8555749
  },
  {
    lng: -41.1533991,
    lat: -21.8558144
  },
  {
    lng: -41.1535876,
    lat: -21.8569871
  },
  {
    lng: -41.1537924,
    lat: -21.8588959
  },
  {
    lng: -41.1539674,
    lat: -21.8598384
  },
  {
    lng: -41.1540039,
    lat: -21.8604153
  },
  {
    lng: -41.1540187,
    lat: -21.8610939
  },
  {
    lng: -41.1541176,
    lat: -21.8614706
  },
  {
    lng: -41.1546114,
    lat: -21.8623433
  },
  {
    lng: -41.1555181,
    lat: -21.8630165
  },
  {
    lng: -41.1566112,
    lat: -21.8633809
  },
  {
    lng: -41.1580087,
    lat: -21.8637925
  },
  {
    lng: -41.1582359,
    lat: -21.8638896
  },
  {
    lng: -41.1588114,
    lat: -21.8643347
  },
  {
    lng: -41.1589646,
    lat: -21.8645943
  },
  {
    lng: -41.1591917,
    lat: -21.8653963
  },
  {
    lng: -41.1596707,
    lat: -21.8687991
  },
  {
    lng: -41.1594098,
    lat: -21.8697657
  },
  {
    lng: -41.1593298,
    lat: -21.8700537
  },
  {
    lng: -41.15903,
    lat: -21.8707592
  },
  {
    lng: -41.1578313,
    lat: -21.8732467
  },
  {
    lng: -41.1565925,
    lat: -21.8759111
  },
  {
    lng: -41.1541037,
    lat: -21.8811947
  },
  {
    lng: -41.1538579,
    lat: -21.8817214
  },
  {
    lng: -41.1535557,
    lat: -21.8823287
  },
  {
    lng: -41.1533319,
    lat: -21.8826766
  },
  {
    lng: -41.1531242,
    lat: -21.8829772
  },
  {
    lng: -41.1530413,
    lat: -21.8831063
  },
  {
    lng: -41.1527821,
    lat: -21.8834327
  },
  {
    lng: -41.1524785,
    lat: -21.8837522
  },
  {
    lng: -41.1515442,
    lat: -21.884616
  },
  {
    lng: -41.1491845,
    lat: -21.8867493
  },
  {
    lng: -41.1454841,
    lat: -21.8900948
  },
  {
    lng: -41.1402964,
    lat: -21.894836
  },
  {
    lng: -41.1364058,
    lat: -21.8983963
  },
  {
    lng: -41.1347425,
    lat: -21.8999368
  },
  {
    lng: -41.1344407,
    lat: -21.9002626
  },
  {
    lng: -41.1340007,
    lat: -21.9008312
  },
  {
    lng: -41.1338311,
    lat: -21.9011335
  },
  {
    lng: -41.1335625,
    lat: -21.9015738
  },
  {
    lng: -41.1318439,
    lat: -21.9047856
  },
  {
    lng: -41.1316549,
    lat: -21.9051155
  },
  {
    lng: -41.1313133,
    lat: -21.9058407
  },
  {
    lng: -41.1301158,
    lat: -21.9080984
  },
  {
    lng: -41.1292647,
    lat: -21.9097347
  },
  {
    lng: -41.1285482,
    lat: -21.911133
  },
  {
    lng: -41.1283612,
    lat: -21.9114337
  },
  {
    lng: -41.1282554,
    lat: -21.9115759
  },
  {
    lng: -41.1279192,
    lat: -21.9119058
  },
  {
    lng: -41.1278754,
    lat: -21.911936
  },
  {
    lng: -41.1275373,
    lat: -21.911934
  },
  {
    lng: -41.126481,
    lat: -21.9119308
  },
  {
    lng: -41.0890059,
    lat: -21.9117035
  },
  {
    lng: -41.0773631,
    lat: -21.9116338
  },
  {
    lng: -41.0532137,
    lat: -21.9114894
  },
  {
    lng: -41.0346176,
    lat: -21.9113781
  },
  {
    lng: -40.9997978,
    lat: -21.9111698
  },
  {
    lng: -40.9913358,
    lat: -21.9111192
  },
  {
    lng: -40.9889782,
    lat: -21.9111051
  },
  {
    lng: -40.9887913,
    lat: -21.911104
  },
  {
    lng: -40.9874332,
    lat: -21.9110958
  },
  {
    lng: -40.9873936,
    lat: -21.9110956
  },
  {
    lng: -40.9869489,
    lat: -21.9110929
  },
  {
    lng: -40.9867621,
    lat: -21.9110918
  },
  {
    lng: -40.9863007,
    lat: -21.9110891
  },
  {
    lng: -40.9862026,
    lat: -21.9110885
  },
  {
    lng: -40.9853251,
    lat: -21.9110832
  },
  {
    lng: -40.9852305,
    lat: -21.9110827
  },
  {
    lng: -40.983906,
    lat: -21.9110747
  },
  {
    lng: -40.9818258,
    lat: -21.9110623
  },
  {
    lng: -40.981731,
    lat: -21.911413
  },
  {
    lng: -40.9816387,
    lat: -21.9119093
  },
  {
    lng: -40.9815937,
    lat: -21.912132
  },
  {
    lng: -40.9814678,
    lat: -21.9124792
  },
  {
    lng: -40.981361,
    lat: -21.9128282
  },
  {
    lng: -40.9811321,
    lat: -21.9135206
  },
  {
    lng: -40.9809147,
    lat: -21.9142168
  },
  {
    lng: -40.9808193,
    lat: -21.9145677
  },
  {
    lng: -40.9807354,
    lat: -21.9149263
  },
  {
    lng: -40.9806477,
    lat: -21.9152792
  },
  {
    lng: -40.9805408,
    lat: -21.9156301
  },
  {
    lng: -40.9804417,
    lat: -21.9159792
  },
  {
    lng: -40.9803539,
    lat: -21.916332
  },
  {
    lng: -40.9802586,
    lat: -21.9166868
  },
  {
    lng: -40.9800526,
    lat: -21.9173849
  },
  {
    lng: -40.9799686,
    lat: -21.9177397
  },
  {
    lng: -40.9797512,
    lat: -21.918495
  },
  {
    lng: -40.9796596,
    lat: -21.9188478
  },
  {
    lng: -40.9794956,
    lat: -21.9195612
  },
  {
    lng: -40.9793735,
    lat: -21.9199064
  },
  {
    lng: -40.97924,
    lat: -21.9206236
  },
  {
    lng: -40.979076,
    lat: -21.9213331
  },
  {
    lng: -40.9789577,
    lat: -21.9216821
  },
  {
    lng: -40.9788738,
    lat: -21.9220388
  },
  {
    lng: -40.9788052,
    lat: -21.9223993
  },
  {
    lng: -40.9786983,
    lat: -21.9227464
  },
  {
    lng: -40.9785686,
    lat: -21.9230898
  },
  {
    lng: -40.9784199,
    lat: -21.923805
  },
  {
    lng: -40.9783665,
    lat: -21.9241636
  },
  {
    lng: -40.9782787,
    lat: -21.9245165
  },
  {
    lng: -40.978149,
    lat: -21.9251726
  },
  {
    lng: -40.978046,
    lat: -21.9255254
  },
  {
    lng: -40.9779697,
    lat: -21.9258821
  },
  {
    lng: -40.9779049,
    lat: -21.9262426
  },
  {
    lng: -40.9778515,
    lat: -21.9266012
  },
  {
    lng: -40.9777523,
    lat: -21.9269521
  },
  {
    lng: -40.9777332,
    lat: -21.9270361
  },
  {
    lng: -40.9773937,
    lat: -21.9289263
  },
  {
    lng: -40.9771343,
    lat: -21.9304445
  },
  {
    lng: -40.9770695,
    lat: -21.9307897
  },
  {
    lng: -40.9769283,
    lat: -21.9313505
  },
  {
    lng: -40.9769092,
    lat: -21.931463
  },
  {
    lng: -40.9765278,
    lat: -21.9333589
  },
  {
    lng: -40.9763065,
    lat: -21.934429
  },
  {
    lng: -40.9762684,
    lat: -21.934757
  },
  {
    lng: -40.9761425,
    lat: -21.9352606
  },
  {
    lng: -40.9760967,
    lat: -21.9355924
  },
  {
    lng: -40.9760624,
    lat: -21.93589
  },
  {
    lng: -40.9759937,
    lat: -21.9361532
  },
  {
    lng: -40.9758335,
    lat: -21.9370191
  },
  {
    lng: -40.9757496,
    lat: -21.937618
  },
  {
    lng: -40.9756695,
    lat: -21.9380987
  },
  {
    lng: -40.975536,
    lat: -21.9387949
  },
  {
    lng: -40.9754673,
    lat: -21.9392164
  },
  {
    lng: -40.9754635,
    lat: -21.9395197
  },
  {
    lng: -40.9754139,
    lat: -21.9399526
  },
  {
    lng: -40.9753147,
    lat: -21.9403112
  },
  {
    lng: -40.9752727,
    lat: -21.9405954
  },
  {
    lng: -40.9751888,
    lat: -21.9410341
  },
  {
    lng: -40.9751392,
    lat: -21.9415529
  },
  {
    lng: -40.9750935,
    lat: -21.9419153
  },
  {
    lng: -40.9750858,
    lat: -21.9422872
  },
  {
    lng: -40.9750515,
    lat: -21.9426477
  },
  {
    lng: -40.9750133,
    lat: -21.943012
  },
  {
    lng: -40.9749485,
    lat: -21.9433725
  },
  {
    lng: -40.9748989,
    lat: -21.9441068
  },
  {
    lng: -40.9748112,
    lat: -21.9448335
  },
  {
    lng: -40.974773,
    lat: -21.945194
  },
  {
    lng: -40.9747616,
    lat: -21.9455641
  },
  {
    lng: -40.9747349,
    lat: -21.9459284
  },
  {
    lng: -40.9747196,
    lat: -21.9462965
  },
  {
    lng: -40.9747158,
    lat: -21.9466665
  },
  {
    lng: -40.9746815,
    lat: -21.947027
  },
  {
    lng: -40.9746815,
    lat: -21.9473894
  },
  {
    lng: -40.9746509,
    lat: -21.9477499
  },
  {
    lng: -40.9746357,
    lat: -21.9481123
  },
  {
    lng: -40.9746052,
    lat: -21.9483221
  },
  {
    lng: -40.9746433,
    lat: -21.9486845
  },
  {
    lng: -40.9746014,
    lat: -21.949045
  },
  {
    lng: -40.974609,
    lat: -21.9494074
  },
  {
    lng: -40.9745899,
    lat: -21.9497736
  },
  {
    lng: -40.9745861,
    lat: -21.9501379
  },
  {
    lng: -40.9746014,
    lat: -21.9505117
  },
  {
    lng: -40.9746014,
    lat: -21.9508836
  },
  {
    lng: -40.9746281,
    lat: -21.951248
  },
  {
    lng: -40.9746471,
    lat: -21.9516161
  },
  {
    lng: -40.9746166,
    lat: -21.9519785
  },
  {
    lng: -40.9746166,
    lat: -21.9523409
  },
  {
    lng: -40.9746357,
    lat: -21.9527071
  },
  {
    lng: -40.9746395,
    lat: -21.9530733
  },
  {
    lng: -40.9746319,
    lat: -21.9534376
  },
  {
    lng: -40.9746395,
    lat: -21.9538038
  },
  {
    lng: -40.9746586,
    lat: -21.9541681
  },
  {
    lng: -40.9746853,
    lat: -21.9545343
  },
  {
    lng: -40.9746853,
    lat: -21.9548967
  },
  {
    lng: -40.9747082,
    lat: -21.9556329
  },
  {
    lng: -40.9747158,
    lat: -21.9560011
  },
  {
    lng: -40.9747158,
    lat: -21.9563673
  },
  {
    lng: -40.9747387,
    lat: -21.9567354
  },
  {
    lng: -40.9747234,
    lat: -21.9571054
  },
  {
    lng: -40.9747616,
    lat: -21.9578321
  },
  {
    lng: -40.9747539,
    lat: -21.9581945
  },
  {
    lng: -40.9747234,
    lat: -21.9585664
  },
  {
    lng: -40.9747196,
    lat: -21.9593027
  },
  {
    lng: -40.9747501,
    lat: -21.9600294
  },
  {
    lng: -40.9747692,
    lat: -21.9603899
  },
  {
    lng: -40.9748073,
    lat: -21.9607618
  },
  {
    lng: -40.9748226,
    lat: -21.9611242
  },
  {
    lng: -40.9748493,
    lat: -21.9614904
  },
  {
    lng: -40.9748531,
    lat: -21.9618623
  },
  {
    lng: -40.9748684,
    lat: -21.9622324
  },
  {
    lng: -40.9749027,
    lat: -21.9625948
  },
  {
    lng: -40.9749447,
    lat: -21.9629572
  },
  {
    lng: -40.9749485,
    lat: -21.9633234
  },
  {
    lng: -40.9749447,
    lat: -21.9636953
  },
  {
    lng: -40.9749332,
    lat: -21.9640672
  },
  {
    lng: -40.9749485,
    lat: -21.9644373
  },
  {
    lng: -40.9749561,
    lat: -21.965183
  },
  {
    lng: -40.9749828,
    lat: -21.9655473
  },
  {
    lng: -40.9750324,
    lat: -21.9659097
  },
  {
    lng: -40.9750553,
    lat: -21.9662836
  },
  {
    lng: -40.9750667,
    lat: -21.966646
  },
  {
    lng: -40.9751087,
    lat: -21.9670065
  },
  {
    lng: -40.9751697,
    lat: -21.9673631
  },
  {
    lng: -40.9752193,
    lat: -21.9677236
  },
  {
    lng: -40.9752804,
    lat: -21.9680898
  },
  {
    lng: -40.975349,
    lat: -21.9684599
  },
  {
    lng: -40.9754444,
    lat: -21.9691942
  },
  {
    lng: -40.9754749,
    lat: -21.9695566
  },
  {
    lng: -40.9754864,
    lat: -21.9696462
  },
  {
    lng: -40.9755436,
    lat: -21.9700182
  },
  {
    lng: -40.9755894,
    lat: -21.9703844
  },
  {
    lng: -40.9757152,
    lat: -21.9711054
  },
  {
    lng: -40.9757687,
    lat: -21.9714658
  },
  {
    lng: -40.9758297,
    lat: -21.9718397
  },
  {
    lng: -40.9759251,
    lat: -21.9725721
  },
  {
    lng: -40.9759785,
    lat: -21.9729326
  },
  {
    lng: -40.9760128,
    lat: -21.9732931
  },
  {
    lng: -40.9760586,
    lat: -21.9736536
  },
  {
    lng: -40.9761654,
    lat: -21.9740083
  },
  {
    lng: -40.9762836,
    lat: -21.9743555
  },
  {
    lng: -40.9762953,
    lat: -21.9744106
  },
  {
    lng: -40.976318,
    lat: -21.9745176
  },
  {
    lng: -40.9763714,
    lat: -21.974901
  },
  {
    lng: -40.9764782,
    lat: -21.9752519
  },
  {
    lng: -40.9765392,
    lat: -21.9756162
  },
  {
    lng: -40.9766384,
    lat: -21.9759729
  },
  {
    lng: -40.9768406,
    lat: -21.9770544
  },
  {
    lng: -40.9770237,
    lat: -21.9777601
  },
  {
    lng: -40.9770847,
    lat: -21.9781225
  },
  {
    lng: -40.9771343,
    lat: -21.9784887
  },
  {
    lng: -40.9772602,
    lat: -21.9792059
  },
  {
    lng: -40.9773823,
    lat: -21.979553
  },
  {
    lng: -40.9774509,
    lat: -21.9799078
  },
  {
    lng: -40.9775082,
    lat: -21.9802721
  },
  {
    lng: -40.9776188,
    lat: -21.9806211
  },
  {
    lng: -40.9776684,
    lat: -21.9809816
  },
  {
    lng: -40.9777294,
    lat: -21.981344
  },
  {
    lng: -40.977821,
    lat: -21.9816988
  },
  {
    lng: -40.9779049,
    lat: -21.9820612
  },
  {
    lng: -40.9780003,
    lat: -21.9824102
  },
  {
    lng: -40.97813,
    lat: -21.9827554
  },
  {
    lng: -40.9782482,
    lat: -21.9831045
  },
  {
    lng: -40.9783398,
    lat: -21.9834631
  },
  {
    lng: -40.9784389,
    lat: -21.9838159
  },
  {
    lng: -40.9785305,
    lat: -21.9841707
  },
  {
    lng: -40.9785953,
    lat: -21.9845274
  },
  {
    lng: -40.9787136,
    lat: -21.9848745
  },
  {
    lng: -40.9788128,
    lat: -21.9852407
  },
  {
    lng: -40.9789387,
    lat: -21.9855917
  },
  {
    lng: -40.9791714,
    lat: -21.9863241
  },
  {
    lng: -40.9794193,
    lat: -21.9870393
  },
  {
    lng: -40.9795338,
    lat: -21.9873903
  },
  {
    lng: -40.9797741,
    lat: -21.9880941
  },
  {
    lng: -40.9798885,
    lat: -21.9884432
  },
  {
    lng: -40.9800144,
    lat: -21.9887922
  },
  {
    lng: -40.980106,
    lat: -21.9891451
  },
  {
    lng: -40.9801289,
    lat: -21.9895113
  },
  {
    lng: -40.9803234,
    lat: -21.9902227
  },
  {
    lng: -40.980415,
    lat: -21.9905908
  },
  {
    lng: -40.9805408,
    lat: -21.9909437
  },
  {
    lng: -40.9806705,
    lat: -21.9912908
  },
  {
    lng: -40.9809109,
    lat: -21.9920023
  },
  {
    lng: -40.9810558,
    lat: -21.9923437
  },
  {
    lng: -40.9811703,
    lat: -21.9927023
  },
  {
    lng: -40.9813038,
    lat: -21.9930399
  },
  {
    lng: -40.9814526,
    lat: -21.9933832
  },
  {
    lng: -40.9818455,
    lat: -21.9944132
  },
  {
    lng: -40.9821392,
    lat: -21.9950922
  },
  {
    lng: -40.9823261,
    lat: -21.9954183
  },
  {
    lng: -40.9824558,
    lat: -21.9957597
  },
  {
    lng: -40.9829594,
    lat: -21.9967706
  },
  {
    lng: -40.9831234,
    lat: -21.9971063
  },
  {
    lng: -40.983276,
    lat: -21.9974363
  },
  {
    lng: -40.983398,
    lat: -21.9977834
  },
  {
    lng: -40.9835506,
    lat: -21.9981287
  },
  {
    lng: -40.9837452,
    lat: -21.9984472
  },
  {
    lng: -40.9840084,
    lat: -21.9991319
  },
  {
    lng: -40.9841762,
    lat: -21.9994657
  },
  {
    lng: -40.9843746,
    lat: -21.9999769
  },
  {
    lng: -40.9845577,
    lat: -22.0004957
  },
  {
    lng: -40.9846912,
    lat: -22.0008352
  },
  {
    lng: -40.9848629,
    lat: -22.001169
  },
  {
    lng: -40.985046,
    lat: -22.0014913
  },
  {
    lng: -40.9851833,
    lat: -22.0018385
  },
  {
    lng: -40.985313,
    lat: -22.0021818
  },
  {
    lng: -40.985458,
    lat: -22.002527
  },
  {
    lng: -40.9859806,
    lat: -22.0035036
  },
  {
    lng: -40.9862171,
    lat: -22.0038011
  },
  {
    lng: -40.9864689,
    lat: -22.0040796
  },
  {
    lng: -40.98661,
    lat: -22.0044229
  },
  {
    lng: -40.9867283,
    lat: -22.0047777
  },
  {
    lng: -40.986919,
    lat: -22.0050962
  },
  {
    lng: -40.9873348,
    lat: -22.0057371
  },
  {
    lng: -40.9875141,
    lat: -22.0060632
  },
  {
    lng: -40.9877239,
    lat: -22.006378
  },
  {
    lng: -40.9879948,
    lat: -22.0066583
  },
  {
    lng: -40.9882503,
    lat: -22.0069387
  },
  {
    lng: -40.9884869,
    lat: -22.0072344
  },
  {
    lng: -40.9887157,
    lat: -22.0075281
  },
  {
    lng: -40.9889332,
    lat: -22.0078409
  },
  {
    lng: -40.9893833,
    lat: -22.0085237
  },
  {
    lng: -40.9896198,
    lat: -22.0088194
  },
  {
    lng: -40.9898754,
    lat: -22.0090921
  },
  {
    lng: -40.990089,
    lat: -22.009403
  },
  {
    lng: -40.9903332,
    lat: -22.0096891
  },
  {
    lng: -40.9905773,
    lat: -22.0099924
  },
  {
    lng: -40.9908291,
    lat: -22.0102766
  },
  {
    lng: -40.9911343,
    lat: -22.0105035
  },
  {
    lng: -40.9914394,
    lat: -22.0107458
  },
  {
    lng: -40.9916798,
    lat: -22.0110433
  },
  {
    lng: -40.991962,
    lat: -22.0113008
  },
  {
    lng: -40.9922672,
    lat: -22.0115354
  },
  {
    lng: -40.9925533,
    lat: -22.0117853
  },
  {
    lng: -40.9928471,
    lat: -22.0120256
  },
  {
    lng: -40.9931255,
    lat: -22.0122793
  },
  {
    lng: -40.9934498,
    lat: -22.0124967
  },
  {
    lng: -40.9937244,
    lat: -22.012758
  },
  {
    lng: -40.9943157,
    lat: -22.0132559
  },
  {
    lng: -40.9949222,
    lat: -22.0137251
  },
  {
    lng: -40.9951855,
    lat: -22.013994
  },
  {
    lng: -40.9954792,
    lat: -22.014242
  },
  {
    lng: -40.9957539,
    lat: -22.0145147
  },
  {
    lng: -40.996059,
    lat: -22.0147398
  },
  {
    lng: -40.9963146,
    lat: -22.0150202
  },
  {
    lng: -40.9966083,
    lat: -22.0152624
  },
  {
    lng: -40.9968906,
    lat: -22.0155161
  },
  {
    lng: -40.9972073,
    lat: -22.0157411
  },
  {
    lng: -40.9975124,
    lat: -22.0159643
  },
  {
    lng: -40.9977833,
    lat: -22.0162332
  },
  {
    lng: -40.9980961,
    lat: -22.0164507
  },
  {
    lng: -40.9983631,
    lat: -22.0167158
  },
  {
    lng: -40.9985172,
    lat: -22.0168562
  },
  {
    lng: -40.9986416,
    lat: -22.0169695
  },
  {
    lng: -40.9989468,
    lat: -22.0171964
  },
  {
    lng: -40.9996029,
    lat: -22.017597
  },
  {
    lng: -40.9999271,
    lat: -22.0178068
  },
  {
    lng: -41.0002285,
    lat: -22.0180433
  },
  {
    lng: -41.000526,
    lat: -22.0182893
  },
  {
    lng: -41.0008617,
    lat: -22.0185068
  },
  {
    lng: -41.0012203,
    lat: -22.018749
  },
  {
    lng: -41.0019298,
    lat: -22.0191076
  },
  {
    lng: -41.0020512,
    lat: -22.019245
  },
  {
    lng: -41.0021778,
    lat: -22.0193883
  },
  {
    lng: -41.0021892,
    lat: -22.0194013
  },
  {
    lng: -41.0024944,
    lat: -22.0196684
  },
  {
    lng: -41.0028072,
    lat: -22.0199106
  },
  {
    lng: -41.0034634,
    lat: -22.02054
  },
  {
    lng: -41.0037495,
    lat: -22.0208261
  },
  {
    lng: -41.0040317,
    lat: -22.0210932
  },
  {
    lng: -41.0043255,
    lat: -22.0213316
  },
  {
    lng: -41.0046307,
    lat: -22.0215681
  },
  {
    lng: -41.0049702,
    lat: -22.0217741
  },
  {
    lng: -41.005344,
    lat: -22.02194
  },
  {
    lng: -41.0056988,
    lat: -22.0221269
  },
  {
    lng: -41.0064083,
    lat: -22.0224645
  },
  {
    lng: -41.0067478,
    lat: -22.02264
  },
  {
    lng: -41.0070258,
    lat: -22.0228374
  },
  {
    lng: -41.0070568,
    lat: -22.0228594
  },
  {
    lng: -41.0080944,
    lat: -22.0234678
  },
  {
    lng: -41.0084492,
    lat: -22.0236891
  },
  {
    lng: -41.0087772,
    lat: -22.0239027
  },
  {
    lng: -41.0091015,
    lat: -22.0241354
  },
  {
    lng: -41.0097233,
    lat: -22.0246122
  },
  {
    lng: -41.0101009,
    lat: -22.0247648
  },
  {
    lng: -41.0104786,
    lat: -22.0249307
  },
  {
    lng: -41.0108295,
    lat: -22.0251234
  },
  {
    lng: -41.0111614,
    lat: -22.0253389
  },
  {
    lng: -41.0115086,
    lat: -22.0255258
  },
  {
    lng: -41.0118519,
    lat: -22.0257185
  },
  {
    lng: -41.0130421,
    lat: -22.026283
  },
  {
    lng: -41.0134045,
    lat: -22.02647
  },
  {
    lng: -41.0137821,
    lat: -22.026655
  },
  {
    lng: -41.0141407,
    lat: -22.0268457
  },
  {
    lng: -41.014484,
    lat: -22.0270364
  },
  {
    lng: -41.0153271,
    lat: -22.0274713
  },
  {
    lng: -41.0156933,
    lat: -22.0276411
  },
  {
    lng: -41.0159985,
    lat: -22.0278757
  },
  {
    lng: -41.0163608,
    lat: -22.0280664
  },
  {
    lng: -41.016708,
    lat: -22.02828
  },
  {
    lng: -41.0170399,
    lat: -22.0285127
  },
  {
    lng: -41.017387,
    lat: -22.0287359
  },
  {
    lng: -41.0181156,
    lat: -22.0290792
  },
  {
    lng: -41.0192104,
    lat: -22.029577
  },
  {
    lng: -41.0194958,
    lat: -22.029715
  },
  {
    lng: -41.0195576,
    lat: -22.0297449
  },
  {
    lng: -41.0199085,
    lat: -22.0299242
  },
  {
    lng: -41.0204578,
    lat: -22.0302999
  },
  {
    lng: -41.0208126,
    lat: -22.030462
  },
  {
    lng: -41.0211597,
    lat: -22.0306261
  },
  {
    lng: -41.0214916,
    lat: -22.030834
  },
  {
    lng: -41.0218693,
    lat: -22.0309999
  },
  {
    lng: -41.0225902,
    lat: -22.0313051
  },
  {
    lng: -41.0229526,
    lat: -22.0314768
  },
  {
    lng: -41.0233303,
    lat: -22.0316408
  },
  {
    lng: -41.0240436,
    lat: -22.0319956
  },
  {
    lng: -41.0244837,
    lat: -22.032205
  },
  {
    lng: -41.024757,
    lat: -22.0323332
  },
  {
    lng: -41.0254055,
    lat: -22.032646
  },
  {
    lng: -41.0256,
    lat: -22.0327318
  },
  {
    lng: -41.0263325,
    lat: -22.0329893
  },
  {
    lng: -41.0267025,
    lat: -22.0331094
  },
  {
    lng: -41.0270649,
    lat: -22.0332449
  },
  {
    lng: -41.0274082,
    lat: -22.0334299
  },
  {
    lng: -41.0277553,
    lat: -22.0335996
  },
  {
    lng: -41.0281177,
    lat: -22.0337503
  },
  {
    lng: -41.0284725,
    lat: -22.0339029
  },
  {
    lng: -41.0288311,
    lat: -22.0340612
  },
  {
    lng: -41.0291859,
    lat: -22.0342233
  },
  {
    lng: -41.0295444,
    lat: -22.0343721
  },
  {
    lng: -41.0302463,
    lat: -22.0346925
  },
  {
    lng: -41.0306087,
    lat: -22.034847
  },
  {
    lng: -41.0310739,
    lat: -22.0350247
  },
  {
    lng: -41.0313488,
    lat: -22.0351331
  },
  {
    lng: -41.0316883,
    lat: -22.0353067
  },
  {
    lng: -41.0320469,
    lat: -22.0354459
  },
  {
    lng: -41.0324016,
    lat: -22.0356024
  },
  {
    lng: -41.0327564,
    lat: -22.0357664
  },
  {
    lng: -41.0330997,
    lat: -22.0359495
  },
  {
    lng: -41.0334507,
    lat: -22.0361097
  },
  {
    lng: -41.0337978,
    lat: -22.036289
  },
  {
    lng: -41.0341564,
    lat: -22.0364397
  },
  {
    lng: -41.0345226,
    lat: -22.0365865
  },
  {
    lng: -41.0348583,
    lat: -22.0367696
  },
  {
    lng: -41.0352207,
    lat: -22.036907
  },
  {
    lng: -41.0362698,
    lat: -22.0374181
  },
  {
    lng: -41.036636,
    lat: -22.0375364
  },
  {
    lng: -41.0369717,
    lat: -22.037729
  },
  {
    lng: -41.037315,
    lat: -22.0379083
  },
  {
    lng: -41.0376736,
    lat: -22.0380819
  },
  {
    lng: -41.0380398,
    lat: -22.038244
  },
  {
    lng: -41.0387722,
    lat: -22.0385912
  },
  {
    lng: -41.039146,
    lat: -22.0387457
  },
  {
    lng: -41.0391943,
    lat: -22.038769
  },
  {
    lng: -41.0394932,
    lat: -22.0389135
  },
  {
    lng: -41.0398479,
    lat: -22.0390814
  },
  {
    lng: -41.0405651,
    lat: -22.0394361
  },
  {
    lng: -41.0409161,
    lat: -22.0395906
  },
  {
    lng: -41.0412823,
    lat: -22.0397432
  },
  {
    lng: -41.0416447,
    lat: -22.0399187
  },
  {
    lng: -41.0420109,
    lat: -22.0400827
  },
  {
    lng: -41.0423618,
    lat: -22.0402544
  },
  {
    lng: -41.0427128,
    lat: -22.040407
  },
  {
    lng: -41.0430599,
    lat: -22.040592
  },
  {
    lng: -41.0433956,
    lat: -22.0407865
  },
  {
    lng: -41.0437618,
    lat: -22.0409544
  },
  {
    lng: -41.0441013,
    lat: -22.0411623
  },
  {
    lng: -41.0444561,
    lat: -22.041332
  },
  {
    lng: -41.0448147,
    lat: -22.0414884
  },
  {
    lng: -41.0451771,
    lat: -22.0416544
  },
  {
    lng: -41.0455357,
    lat: -22.0417955
  },
  {
    lng: -41.0458942,
    lat: -22.0419653
  },
  {
    lng: -41.046023,
    lat: -22.0420461
  },
  {
    lng: -41.0462223,
    lat: -22.0421713
  },
  {
    lng: -41.0465656,
    lat: -22.042341
  },
  {
    lng: -41.0466991,
    lat: -22.0424001
  },
  {
    lng: -41.0469166,
    lat: -22.0425279
  },
  {
    lng: -41.047279,
    lat: -22.0426748
  },
  {
    lng: -41.0476375,
    lat: -22.0428541
  },
  {
    lng: -41.0479847,
    lat: -22.0430582
  },
  {
    lng: -41.048164,
    lat: -22.0431383
  },
  {
    lng: -41.0485111,
    lat: -22.0433157
  },
  {
    lng: -41.0488468,
    lat: -22.0435178
  },
  {
    lng: -41.0491978,
    lat: -22.0436762
  },
  {
    lng: -41.0495449,
    lat: -22.0438593
  },
  {
    lng: -41.0498997,
    lat: -22.0440233
  },
  {
    lng: -41.0502354,
    lat: -22.044214
  },
  {
    lng: -41.0502812,
    lat: -22.0442357
  },
  {
    lng: -41.0505863,
    lat: -22.04438
  },
  {
    lng: -41.050922,
    lat: -22.0445726
  },
  {
    lng: -41.0512615,
    lat: -22.0447557
  },
  {
    lng: -41.0516201,
    lat: -22.0449312
  },
  {
    lng: -41.0519596,
    lat: -22.0451086
  },
  {
    lng: -41.0523106,
    lat: -22.045265
  },
  {
    lng: -41.0526539,
    lat: -22.0454538
  },
  {
    lng: -41.0529972,
    lat: -22.045656
  },
  {
    lng: -41.0533482,
    lat: -22.0458086
  },
  {
    lng: -41.0536991,
    lat: -22.0459707
  },
  {
    lng: -41.0540501,
    lat: -22.0461271
  },
  {
    lng: -41.0543667,
    lat: -22.046335
  },
  {
    lng: -41.0547138,
    lat: -22.0465009
  },
  {
    lng: -41.0550533,
    lat: -22.0466783
  },
  {
    lng: -41.0554043,
    lat: -22.0468462
  },
  {
    lng: -41.0557552,
    lat: -22.0470083
  },
  {
    lng: -41.0560795,
    lat: -22.0472086
  },
  {
    lng: -41.0564419,
    lat: -22.0473573
  },
  {
    lng: -41.0567421,
    lat: -22.0475026
  },
  {
    lng: -41.0567928,
    lat: -22.0475271
  },
  {
    lng: -41.0571476,
    lat: -22.0477083
  },
  {
    lng: -41.0578686,
    lat: -22.0479925
  },
  {
    lng: -41.0579626,
    lat: -22.0480416
  },
  {
    lng: -41.0582081,
    lat: -22.0481699
  },
  {
    lng: -41.0588985,
    lat: -22.0485189
  },
  {
    lng: -41.0592647,
    lat: -22.0486696
  },
  {
    lng: -41.0596043,
    lat: -22.0488641
  },
  {
    lng: -41.0599552,
    lat: -22.0490377
  },
  {
    lng: -41.0602871,
    lat: -22.0492342
  },
  {
    lng: -41.0606304,
    lat: -22.0494211
  },
  {
    lng: -41.0610946,
    lat: -22.0496443
  },
  {
    lng: -41.0613285,
    lat: -22.0497587
  },
  {
    lng: -41.0616795,
    lat: -22.0499227
  },
  {
    lng: -41.062019,
    lat: -22.050102
  },
  {
    lng: -41.0623623,
    lat: -22.050266
  },
  {
    lng: -41.0627018,
    lat: -22.0504415
  },
  {
    lng: -41.0632778,
    lat: -22.0507164
  },
  {
    lng: -41.0634037,
    lat: -22.0507753
  },
  {
    lng: -41.0637432,
    lat: -22.0509584
  },
  {
    lng: -41.0640903,
    lat: -22.0511358
  },
  {
    lng: -41.0644413,
    lat: -22.0512979
  },
  {
    lng: -41.0647655,
    lat: -22.0515039
  },
  {
    lng: -41.0655323,
    lat: -22.0518568
  },
  {
    lng: -41.0655872,
    lat: -22.0518861
  },
  {
    lng: -41.0658718,
    lat: -22.052038
  },
  {
    lng: -41.0662342,
    lat: -22.052202
  },
  {
    lng: -41.0665852,
    lat: -22.0523756
  },
  {
    lng: -41.0669132,
    lat: -22.052572
  },
  {
    lng: -41.0672604,
    lat: -22.0527475
  },
  {
    lng: -41.067596,
    lat: -22.0529363
  },
  {
    lng: -41.0679508,
    lat: -22.0530985
  },
  {
    lng: -41.0683056,
    lat: -22.0532663
  },
  {
    lng: -41.0686527,
    lat: -22.0534532
  },
  {
    lng: -41.068977,
    lat: -22.0536516
  },
  {
    lng: -41.0692461,
    lat: -22.0537832
  },
  {
    lng: -41.0693241,
    lat: -22.0538213
  },
  {
    lng: -41.0696865,
    lat: -22.0539949
  },
  {
    lng: -41.0700413,
    lat: -22.0541551
  },
  {
    lng: -41.0703884,
    lat: -22.0543306
  },
  {
    lng: -41.0705266,
    lat: -22.0544058
  },
  {
    lng: -41.0707317,
    lat: -22.0545175
  },
  {
    lng: -41.0710789,
    lat: -22.0546911
  },
  {
    lng: -41.0713955,
    lat: -22.0549028
  },
  {
    lng: -41.0717159,
    lat: -22.055105
  },
  {
    lng: -41.0720783,
    lat: -22.0552366
  },
  {
    lng: -41.0724216,
    lat: -22.0554083
  },
  {
    lng: -41.0730892,
    lat: -22.0558031
  },
  {
    lng: -41.0734402,
    lat: -22.0559805
  },
  {
    lng: -41.0737987,
    lat: -22.0561426
  },
  {
    lng: -41.074123,
    lat: -22.056341
  },
  {
    lng: -41.0744549,
    lat: -22.0565298
  },
  {
    lng: -41.0747933,
    lat: -22.0566725
  },
  {
    lng: -41.0748211,
    lat: -22.0566843
  },
  {
    lng: -41.0751377,
    lat: -22.0568998
  },
  {
    lng: -41.0754887,
    lat: -22.0570753
  },
  {
    lng: -41.075832,
    lat: -22.0572603
  },
  {
    lng: -41.0761753,
    lat: -22.0574644
  },
  {
    lng: -41.076511,
    lat: -22.0576456
  },
  {
    lng: -41.0768543,
    lat: -22.0578153
  },
  {
    lng: -41.0771976,
    lat: -22.0580099
  },
  {
    lng: -41.0778461,
    lat: -22.0584066
  },
  {
    lng: -41.0781856,
    lat: -22.0585878
  },
  {
    lng: -41.078529,
    lat: -22.0587595
  },
  {
    lng: -41.0790058,
    lat: -22.0590589
  },
  {
    lng: -41.0793415,
    lat: -22.0592573
  },
  {
    lng: -41.079681,
    lat: -22.0594328
  },
  {
    lng: -41.0799976,
    lat: -22.0596407
  },
  {
    lng: -41.0803409,
    lat: -22.0598219
  },
  {
    lng: -41.0806652,
    lat: -22.0600202
  },
  {
    lng: -41.0809933,
    lat: -22.0602148
  },
  {
    lng: -41.0813442,
    lat: -22.0603903
  },
  {
    lng: -41.0816608,
    lat: -22.0605982
  },
  {
    lng: -41.082008,
    lat: -22.0607679
  },
  {
    lng: -41.0823399,
    lat: -22.0609625
  },
  {
    lng: -41.0826908,
    lat: -22.0611417
  },
  {
    lng: -41.0830991,
    lat: -22.0613995
  },
  {
    lng: -41.0833431,
    lat: -22.0615499
  },
  {
    lng: -41.0836864,
    lat: -22.0617388
  },
  {
    lng: -41.0840336,
    lat: -22.0619123
  },
  {
    lng: -41.0846935,
    lat: -22.0623071
  },
  {
    lng: -41.0850178,
    lat: -22.0625189
  },
  {
    lng: -41.0853496,
    lat: -22.0627077
  },
  {
    lng: -41.0857044,
    lat: -22.0628965
  },
  {
    lng: -41.0860363,
    lat: -22.0630872
  },
  {
    lng: -41.0866924,
    lat: -22.0634802
  },
  {
    lng: -41.0873638,
    lat: -22.0638578
  },
  {
    lng: -41.0876919,
    lat: -22.0640619
  },
  {
    lng: -41.0880428,
    lat: -22.0642297
  },
  {
    lng: -41.0883556,
    lat: -22.0644453
  },
  {
    lng: -41.0890346,
    lat: -22.0648096
  },
  {
    lng: -41.0893665,
    lat: -22.0650194
  },
  {
    lng: -41.0896831,
    lat: -22.065233
  },
  {
    lng: -41.0900074,
    lat: -22.0654371
  },
  {
    lng: -41.0903431,
    lat: -22.0656374
  },
  {
    lng: -41.0906826,
    lat: -22.0658319
  },
  {
    lng: -41.0910221,
    lat: -22.0660074
  },
  {
    lng: -41.0916897,
    lat: -22.0663965
  },
  {
    lng: -41.0920368,
    lat: -22.0665739
  },
  {
    lng: -41.0923611,
    lat: -22.0667837
  },
  {
    lng: -41.0926929,
    lat: -22.0669725
  },
  {
    lng: -41.0930363,
    lat: -22.0671461
  },
  {
    lng: -41.0933605,
    lat: -22.0673464
  },
  {
    lng: -41.0940205,
    lat: -22.067745
  },
  {
    lng: -41.0944963,
    lat: -22.0680118
  },
  {
    lng: -41.0946995,
    lat: -22.0681284
  },
  {
    lng: -41.0953785,
    lat: -22.0685213
  },
  {
    lng: -41.0957218,
    lat: -22.068712
  },
  {
    lng: -41.0960689,
    lat: -22.0688875
  },
  {
    lng: -41.096397,
    lat: -22.0690897
  },
  {
    lng: -41.096748,
    lat: -22.0692518
  },
  {
    lng: -41.0970798,
    lat: -22.0694463
  },
  {
    lng: -41.0977283,
    lat: -22.0698507
  },
  {
    lng: -41.0980717,
    lat: -22.0700529
  },
  {
    lng: -41.0984112,
    lat: -22.0702474
  },
  {
    lng: -41.0987354,
    lat: -22.0704439
  },
  {
    lng: -41.0990864,
    lat: -22.0706136
  },
  {
    lng: -41.0992886,
    lat: -22.0707205
  },
  {
    lng: -41.0996014,
    lat: -22.0709074
  },
  {
    lng: -41.0999485,
    lat: -22.0711076
  },
  {
    lng: -41.1006847,
    lat: -22.071491
  },
  {
    lng: -41.1010471,
    lat: -22.0716722
  },
  {
    lng: -41.1013905,
    lat: -22.0718572
  },
  {
    lng: -41.101749,
    lat: -22.0720689
  },
  {
    lng: -41.102531,
    lat: -22.0725076
  },
  {
    lng: -41.1028667,
    lat: -22.0727022
  },
  {
    lng: -41.1032139,
    lat: -22.0729139
  },
  {
    lng: -41.1039387,
    lat: -22.0732897
  },
  {
    lng: -41.1046635,
    lat: -22.0736807
  },
  {
    lng: -41.1048504,
    lat: -22.0738065
  },
  {
    lng: -41.105537,
    lat: -22.0742223
  },
  {
    lng: -41.1058842,
    lat: -22.0744188
  },
  {
    lng: -41.1062237,
    lat: -22.0746038
  },
  {
    lng: -41.1065823,
    lat: -22.0747831
  },
  {
    lng: -41.1070286,
    lat: -22.0750215
  },
  {
    lng: -41.1073757,
    lat: -22.0752218
  },
  {
    lng: -41.107682,
    lat: -22.0753873
  },
  {
    lng: -41.1077572,
    lat: -22.0754278
  },
  {
    lng: -41.1080929,
    lat: -22.0756109
  },
  {
    lng: -41.1082531,
    lat: -22.075712
  },
  {
    lng: -41.1085926,
    lat: -22.0759142
  },
  {
    lng: -41.1089664,
    lat: -22.0761259
  },
  {
    lng: -41.1093098,
    lat: -22.0763395
  },
  {
    lng: -41.1096455,
    lat: -22.0765207
  },
  {
    lng: -41.1100117,
    lat: -22.0767324
  },
  {
    lng: -41.1103474,
    lat: -22.0769212
  },
  {
    lng: -41.1110416,
    lat: -22.077337
  },
  {
    lng: -41.1113735,
    lat: -22.0775278
  },
  {
    lng: -41.1120716,
    lat: -22.0779493
  },
  {
    lng: -41.1124493,
    lat: -22.0781877
  },
  {
    lng: -41.1128155,
    lat: -22.0783956
  },
  {
    lng: -41.1131588,
    lat: -22.0786321
  },
  {
    lng: -41.1135632,
    lat: -22.0788553
  },
  {
    lng: -41.1139141,
    lat: -22.0790689
  },
  {
    lng: -41.1147533,
    lat: -22.0795954
  },
  {
    lng: -41.1151005,
    lat: -22.0797861
  },
  {
    lng: -41.1154781,
    lat: -22.0799463
  },
  {
    lng: -41.1158291,
    lat: -22.080118
  },
  {
    lng: -41.1161648,
    lat: -22.0803259
  },
  {
    lng: -41.1163402,
    lat: -22.0804556
  },
  {
    lng: -41.1164852,
    lat: -22.0805986
  },
  {
    lng: -41.1165996,
    lat: -22.0807817
  },
  {
    lng: -41.1166531,
    lat: -22.0808809
  },
  {
    lng: -41.1167217,
    lat: -22.080961
  },
  {
    lng: -41.1168018,
    lat: -22.0810087
  },
  {
    lng: -41.1169544,
    lat: -22.0810297
  },
  {
    lng: -41.1172443,
    lat: -22.081043
  },
  {
    lng: -41.1173588,
    lat: -22.0810564
  },
  {
    lng: -41.1177402,
    lat: -22.0811422
  },
  {
    lng: -41.1181255,
    lat: -22.0812948
  },
  {
    lng: -41.1184727,
    lat: -22.0814646
  },
  {
    lng: -41.1188579,
    lat: -22.0816801
  },
  {
    lng: -41.1192051,
    lat: -22.0818975
  },
  {
    lng: -41.119556,
    lat: -22.0820844
  },
  {
    lng: -41.1198841,
    lat: -22.0822962
  },
  {
    lng: -41.1202541,
    lat: -22.0824754
  },
  {
    lng: -41.1206127,
    lat: -22.0826814
  },
  {
    lng: -41.120998,
    lat: -22.0828893
  },
  {
    lng: -41.1213413,
    lat: -22.0831201
  },
  {
    lng: -41.121574,
    lat: -22.0832651
  },
  {
    lng: -41.1219212,
    lat: -22.0834711
  },
  {
    lng: -41.1221958,
    lat: -22.0836046
  },
  {
    lng: -41.1224667,
    lat: -22.083761
  },
  {
    lng: -41.1225544,
    lat: -22.0838068
  },
  {
    lng: -41.1229168,
    lat: -22.0840204
  },
  {
    lng: -41.1232334,
    lat: -22.0841749
  },
  {
    lng: -41.1235691,
    lat: -22.0843828
  },
  {
    lng: -41.1240078,
    lat: -22.0846822
  },
  {
    lng: -41.124332,
    lat: -22.0849149
  },
  {
    lng: -41.1250149,
    lat: -22.0853441
  },
  {
    lng: -41.1254002,
    lat: -22.0855673
  },
  {
    lng: -41.1257587,
    lat: -22.0857465
  },
  {
    lng: -41.1260944,
    lat: -22.0859316
  },
  {
    lng: -41.1264568,
    lat: -22.0861604
  },
  {
    lng: -41.1267887,
    lat: -22.0863912
  },
  {
    lng: -41.1270977,
    lat: -22.0866144
  },
  {
    lng: -41.1274181,
    lat: -22.0868299
  },
  {
    lng: -41.1277271,
    lat: -22.0870474
  },
  {
    lng: -41.1283832,
    lat: -22.0874727
  },
  {
    lng: -41.1287418,
    lat: -22.0877226
  },
  {
    lng: -41.1291042,
    lat: -22.0879381
  },
  {
    lng: -41.1294323,
    lat: -22.0881746
  },
  {
    lng: -41.1297947,
    lat: -22.0884035
  },
  {
    lng: -41.1301037,
    lat: -22.0886419
  },
  {
    lng: -41.130447,
    lat: -22.088886
  },
  {
    lng: -41.1307636,
    lat: -22.0890978
  },
  {
    lng: -41.1310993,
    lat: -22.0893381
  },
  {
    lng: -41.1314236,
    lat: -22.0896051
  },
  {
    lng: -41.1317287,
    lat: -22.0898435
  },
  {
    lng: -41.1319462,
    lat: -22.0900324
  },
  {
    lng: -41.1322475,
    lat: -22.0903089
  },
  {
    lng: -41.1325069,
    lat: -22.0905206
  },
  {
    lng: -41.1326672,
    lat: -22.090637
  },
  {
    lng: -41.132877,
    lat: -22.0908411
  },
  {
    lng: -41.1329723,
    lat: -22.0909708
  },
  {
    lng: -41.1329914,
    lat: -22.0910032
  },
  {
    lng: -41.1332241,
    lat: -22.0913103
  },
  {
    lng: -41.1333157,
    lat: -22.0913999
  },
  {
    lng: -41.133411,
    lat: -22.091522
  },
  {
    lng: -41.1336018,
    lat: -22.0918195
  },
  {
    lng: -41.1337429,
    lat: -22.0920103
  },
  {
    lng: -41.133823,
    lat: -22.0920942
  },
  {
    lng: -41.1338726,
    lat: -22.0921533
  },
  {
    lng: -41.1338802,
    lat: -22.0921571
  },
  {
    lng: -41.1339413,
    lat: -22.0922315
  },
  {
    lng: -41.133968,
    lat: -22.0922582
  },
  {
    lng: -41.133968,
    lat: -22.092262
  },
  {
    lng: -41.1339718,
    lat: -22.092262
  },
  {
    lng: -41.1339718,
    lat: -22.0922659
  },
  {
    lng: -41.1339756,
    lat: -22.0922659
  },
  {
    lng: -41.1339947,
    lat: -22.0922926
  },
  {
    lng: -41.1339985,
    lat: -22.0922926
  },
  {
    lng: -41.1339985,
    lat: -22.0922983
  },
  {
    lng: -41.1340023,
    lat: -22.0922983
  },
  {
    lng: -41.1340023,
    lat: -22.092304
  },
  {
    lng: -41.1340099,
    lat: -22.0923097
  },
  {
    lng: -41.1340099,
    lat: -22.0923155
  },
  {
    lng: -41.1340137,
    lat: -22.0923155
  },
  {
    lng: -41.1340137,
    lat: -22.0923212
  },
  {
    lng: -41.1340214,
    lat: -22.0923288
  },
  {
    lng: -41.1340214,
    lat: -22.0923345
  },
  {
    lng: -41.1340252,
    lat: -22.0923345
  },
  {
    lng: -41.1340328,
    lat: -22.0923574
  },
  {
    lng: -41.1340366,
    lat: -22.0923574
  },
  {
    lng: -41.1340404,
    lat: -22.0923746
  },
  {
    lng: -41.1340443,
    lat: -22.0923765
  },
  {
    lng: -41.1340443,
    lat: -22.092386
  },
  {
    lng: -41.1340519,
    lat: -22.0923975
  },
  {
    lng: -41.1340519,
    lat: -22.0924108
  },
  {
    lng: -41.1340557,
    lat: -22.0924108
  },
  {
    lng: -41.1340557,
    lat: -22.0924261
  },
  {
    lng: -41.1340595,
    lat: -22.0924261
  },
  {
    lng: -41.1340595,
    lat: -22.09247
  },
  {
    lng: -41.1339451,
    lat: -22.0925005
  },
  {
    lng: -41.133865,
    lat: -22.092552
  },
  {
    lng: -41.1338268,
    lat: -22.0926225
  },
  {
    lng: -41.1338726,
    lat: -22.0926283
  },
  {
    lng: -41.1339565,
    lat: -22.0925901
  },
  {
    lng: -41.1340252,
    lat: -22.0926435
  },
  {
    lng: -41.134132,
    lat: -22.0927885
  },
  {
    lng: -41.1342274,
    lat: -22.0929487
  },
  {
    lng: -41.1342426,
    lat: -22.0931013
  },
  {
    lng: -41.1341663,
    lat: -22.0932462
  },
  {
    lng: -41.1339909,
    lat: -22.0934217
  },
  {
    lng: -41.1338459,
    lat: -22.0936296
  },
  {
    lng: -41.1337238,
    lat: -22.0937555
  },
  {
    lng: -41.1336648,
    lat: -22.0938374
  },
  {
    lng: -41.1335844,
    lat: -22.0939295
  },
  {
    lng: -41.1334759,
    lat: -22.0940321
  },
  {
    lng: -41.1334148,
    lat: -22.0941065
  },
  {
    lng: -41.1333538,
    lat: -22.0941484
  },
  {
    lng: -41.1332508,
    lat: -22.0942056
  },
  {
    lng: -41.1331936,
    lat: -22.0942724
  },
  {
    lng: -41.1331554,
    lat: -22.0943945
  },
  {
    lng: -41.1331249,
    lat: -22.0944689
  },
  {
    lng: -41.1330257,
    lat: -22.0946291
  },
  {
    lng: -41.1329723,
    lat: -22.0947397
  },
  {
    lng: -41.1328121,
    lat: -22.0949171
  },
  {
    lng: -41.1326443,
    lat: -22.0951231
  },
  {
    lng: -41.1326214,
    lat: -22.0952146
  },
  {
    lng: -41.1326557,
    lat: -22.095331
  },
  {
    lng: -41.1328159,
    lat: -22.0953405
  },
  {
    lng: -41.1335187,
    lat: -22.0943681
  },
  {
    lng: -41.1338108,
    lat: -22.0954562
  },
  {
    lng: -41.1345979,
    lat: -22.094181
  },
  {
    lng: -41.1348895,
    lat: -22.0938338
  },
  {
    lng: -41.1351714,
    lat: -22.0934982
  },
  {
    lng: -41.1358487,
    lat: -22.0931966
  },
  {
    lng: -41.1363983,
    lat: -22.0928886
  },
  {
    lng: -41.1384416,
    lat: -22.0918414
  },
  {
    lng: -41.1384592,
    lat: -22.0918334
  },
  {
    lng: -41.1392181,
    lat: -22.0914906
  },
  {
    lng: -41.1394531,
    lat: -22.091364
  },
  {
    lng: -41.1396308,
    lat: -22.0912604
  },
  {
    lng: -41.1410987,
    lat: -22.090394
  },
  {
    lng: -41.1412302,
    lat: -22.0903032
  },
  {
    lng: -41.141321,
    lat: -22.0902566
  },
  {
    lng: -41.1414048,
    lat: -22.0902252
  },
  {
    lng: -41.1415345,
    lat: -22.0901676
  },
  {
    lng: -41.1416392,
    lat: -22.0901133
  },
  {
    lng: -41.1424243,
    lat: -22.089794
  },
  {
    lng: -41.142463,
    lat: -22.089746
  },
  {
    lng: -41.1426099,
    lat: -22.089654
  },
  {
    lng: -41.1426513,
    lat: -22.0896338
  },
  {
    lng: -41.1431241,
    lat: -22.0903563
  },
  {
    lng: -41.1432058,
    lat: -22.0904812
  },
  {
    lng: -41.1432076,
    lat: -22.0905211
  },
  {
    lng: -41.1431953,
    lat: -22.0905815
  },
  {
    lng: -41.1432208,
    lat: -22.0906734
  },
  {
    lng: -41.1433313,
    lat: -22.090915
  },
  {
    lng: -41.1433701,
    lat: -22.0909884
  },
  {
    lng: -41.143492,
    lat: -22.091336
  },
  {
    lng: -41.1436426,
    lat: -22.0916845
  },
  {
    lng: -41.143765,
    lat: -22.0920282
  },
  {
    lng: -41.1438212,
    lat: -22.0921041
  },
  {
    lng: -41.1438753,
    lat: -22.0921809
  },
  {
    lng: -41.1438915,
    lat: -22.0922664
  },
  {
    lng: -41.1438606,
    lat: -22.0923392
  },
  {
    lng: -41.1438079,
    lat: -22.0924031
  },
  {
    lng: -41.1436982,
    lat: -22.0925045
  },
  {
    lng: -41.1436514,
    lat: -22.0925537
  },
  {
    lng: -41.1435995,
    lat: -22.0925983
  },
  {
    lng: -41.1435755,
    lat: -22.0926397
  },
  {
    lng: -41.1433055,
    lat: -22.0929394
  },
  {
    lng: -41.1431,
    lat: -22.0931509
  },
  {
    lng: -41.1429384,
    lat: -22.0932844
  },
  {
    lng: -41.1426032,
    lat: -22.0934387
  },
  {
    lng: -41.1419957,
    lat: -22.0936288
  },
  {
    lng: -41.1416227,
    lat: -22.0937756
  },
  {
    lng: -41.1415424,
    lat: -22.0938006
  },
  {
    lng: -41.1414842,
    lat: -22.0938342
  },
  {
    lng: -41.1414643,
    lat: -22.0938909
  },
  {
    lng: -41.1414041,
    lat: -22.0939971
  },
  {
    lng: -41.1413591,
    lat: -22.0942039
  },
  {
    lng: -41.141333,
    lat: -22.0944414
  },
  {
    lng: -41.1413475,
    lat: -22.0945115
  },
  {
    lng: -41.1414343,
    lat: -22.0947029
  },
  {
    lng: -41.1417421,
    lat: -22.0949892
  },
  {
    lng: -41.1418603,
    lat: -22.0950933
  },
  {
    lng: -41.14223,
    lat: -22.0953066
  },
  {
    lng: -41.1424409,
    lat: -22.0954465
  },
  {
    lng: -41.1425783,
    lat: -22.0955378
  },
  {
    lng: -41.1427425,
    lat: -22.0956179
  },
  {
    lng: -41.1431628,
    lat: -22.0958096
  },
  {
    lng: -41.1432522,
    lat: -22.0958516
  },
  {
    lng: -41.143321,
    lat: -22.095895
  },
  {
    lng: -41.143455,
    lat: -22.0959962
  },
  {
    lng: -41.1436715,
    lat: -22.0961519
  },
  {
    lng: -41.1438403,
    lat: -22.0963093
  },
  {
    lng: -41.1441173,
    lat: -22.0965676
  },
  {
    lng: -41.1442808,
    lat: -22.0967136
  },
  {
    lng: -41.1443665,
    lat: -22.0967988
  },
  {
    lng: -41.1443958,
    lat: -22.0968895
  },
  {
    lng: -41.1444943,
    lat: -22.0971623
  },
  {
    lng: -41.144556,
    lat: -22.0973384
  },
  {
    lng: -41.14458,
    lat: -22.0974324
  },
  {
    lng: -41.1445574,
    lat: -22.097779
  },
  {
    lng: -41.1445124,
    lat: -22.0979946
  },
  {
    lng: -41.1445113,
    lat: -22.0980607
  },
  {
    lng: -41.1445002,
    lat: -22.0981427
  },
  {
    lng: -41.144514,
    lat: -22.0982799
  },
  {
    lng: -41.1445282,
    lat: -22.0985951
  },
  {
    lng: -41.1445466,
    lat: -22.0987086
  },
  {
    lng: -41.1446016,
    lat: -22.0989378
  },
  {
    lng: -41.144637,
    lat: -22.0990943
  },
  {
    lng: -41.1447194,
    lat: -22.0992023
  },
  {
    lng: -41.1449699,
    lat: -22.0993523
  },
  {
    lng: -41.1451756,
    lat: -22.0994167
  },
  {
    lng: -41.145471,
    lat: -22.0992935
  },
  {
    lng: -41.1454913,
    lat: -22.099285
  },
  {
    lng: -41.1457298,
    lat: -22.0991185
  },
  {
    lng: -41.1457442,
    lat: -22.0991084
  },
  {
    lng: -41.1458548,
    lat: -22.0989703
  },
  {
    lng: -41.1461839,
    lat: -22.0983553
  },
  {
    lng: -41.1467123,
    lat: -22.0969374
  },
  {
    lng: -41.1467293,
    lat: -22.0969139
  },
  {
    lng: -41.1469017,
    lat: -22.0965632
  },
  {
    lng: -41.147033,
    lat: -22.0963759
  },
  {
    lng: -41.1471659,
    lat: -22.0961354
  },
  {
    lng: -41.147283,
    lat: -22.0959677
  },
  {
    lng: -41.147374,
    lat: -22.0958471
  },
  {
    lng: -41.1476398,
    lat: -22.0955714
  },
  {
    lng: -41.1477977,
    lat: -22.0954469
  },
  {
    lng: -41.1479631,
    lat: -22.0953562
  },
  {
    lng: -41.148094,
    lat: -22.095305
  },
  {
    lng: -41.1482622,
    lat: -22.0952763
  },
  {
    lng: -41.1484542,
    lat: -22.0952912
  },
  {
    lng: -41.1487683,
    lat: -22.0954357
  },
  {
    lng: -41.148898,
    lat: -22.0956305
  },
  {
    lng: -41.1490402,
    lat: -22.0959338
  },
  {
    lng: -41.1490786,
    lat: -22.0963574
  },
  {
    lng: -41.1490247,
    lat: -22.0968275
  },
  {
    lng: -41.1489816,
    lat: -22.0971923
  },
  {
    lng: -41.1489482,
    lat: -22.0973927
  },
  {
    lng: -41.1489202,
    lat: -22.0977247
  },
  {
    lng: -41.1488926,
    lat: -22.0978463
  },
  {
    lng: -41.1487751,
    lat: -22.0981192
  },
  {
    lng: -41.1487548,
    lat: -22.0982386
  },
  {
    lng: -41.1487526,
    lat: -22.0984522
  },
  {
    lng: -41.1488052,
    lat: -22.098546
  },
  {
    lng: -41.1489082,
    lat: -22.0986471
  },
  {
    lng: -41.1490509,
    lat: -22.0987433
  },
  {
    lng: -41.1491531,
    lat: -22.098796
  },
  {
    lng: -41.1491732,
    lat: -22.0988027
  },
  {
    lng: -41.1495595,
    lat: -22.0988771
  },
  {
    lng: -41.1499477,
    lat: -22.0989319
  },
  {
    lng: -41.1501303,
    lat: -22.098962
  },
  {
    lng: -41.1503436,
    lat: -22.0989904
  },
  {
    lng: -41.1505681,
    lat: -22.0990426
  },
  {
    lng: -41.1507899,
    lat: -22.0990954
  },
  {
    lng: -41.151076,
    lat: -22.0991299
  },
  {
    lng: -41.1512451,
    lat: -22.0991756
  },
  {
    lng: -41.1514102,
    lat: -22.0992071
  },
  {
    lng: -41.1517468,
    lat: -22.0992628
  },
  {
    lng: -41.1520139,
    lat: -22.0991523
  },
  {
    lng: -41.1521926,
    lat: -22.0989341
  },
  {
    lng: -41.1522988,
    lat: -22.0987979
  },
  {
    lng: -41.1523509,
    lat: -22.0987257
  },
  {
    lng: -41.1526093,
    lat: -22.0984313
  },
  {
    lng: -41.1526638,
    lat: -22.0983537
  },
  {
    lng: -41.1528861,
    lat: -22.0980469
  },
  {
    lng: -41.1529377,
    lat: -22.0979415
  },
  {
    lng: -41.1529448,
    lat: -22.0978144
  },
  {
    lng: -41.1529087,
    lat: -22.0976721
  },
  {
    lng: -41.1528447,
    lat: -22.097573
  },
  {
    lng: -41.1527857,
    lat: -22.0975114
  },
  {
    lng: -41.1525789,
    lat: -22.0972992
  },
  {
    lng: -41.1524715,
    lat: -22.097214
  },
  {
    lng: -41.1523501,
    lat: -22.0971587
  },
  {
    lng: -41.152184,
    lat: -22.0970843
  },
  {
    lng: -41.1520415,
    lat: -22.0969621
  },
  {
    lng: -41.1518586,
    lat: -22.0968104
  },
  {
    lng: -41.1516706,
    lat: -22.0966249
  },
  {
    lng: -41.1515758,
    lat: -22.0964408
  },
  {
    lng: -41.1515085,
    lat: -22.0963079
  },
  {
    lng: -41.1514464,
    lat: -22.0961164
  },
  {
    lng: -41.15135,
    lat: -22.0959937
  },
  {
    lng: -41.1512575,
    lat: -22.0958561
  },
  {
    lng: -41.1512251,
    lat: -22.0957748
  },
  {
    lng: -41.1512022,
    lat: -22.095666
  },
  {
    lng: -41.1511846,
    lat: -22.0955783
  },
  {
    lng: -41.1511833,
    lat: -22.0954748
  },
  {
    lng: -41.1512291,
    lat: -22.0953182
  },
  {
    lng: -41.1513018,
    lat: -22.0952046
  },
  {
    lng: -41.1513863,
    lat: -22.0950813
  },
  {
    lng: -41.1514829,
    lat: -22.0950013
  },
  {
    lng: -41.1516087,
    lat: -22.0949329
  },
  {
    lng: -41.1518061,
    lat: -22.0949026
  },
  {
    lng: -41.1520025,
    lat: -22.0948681
  },
  {
    lng: -41.1521563,
    lat: -22.0948952
  },
  {
    lng: -41.1523176,
    lat: -22.0949017
  },
  {
    lng: -41.1524413,
    lat: -22.0949256
  },
  {
    lng: -41.1527632,
    lat: -22.0949837
  },
  {
    lng: -41.1529764,
    lat: -22.0950503
  },
  {
    lng: -41.1532638,
    lat: -22.0951516
  },
  {
    lng: -41.1536647,
    lat: -22.0953504
  },
  {
    lng: -41.1537752,
    lat: -22.0953857
  },
  {
    lng: -41.1544358,
    lat: -22.0957336
  },
  {
    lng: -41.1551309,
    lat: -22.09644
  },
  {
    lng: -41.1552359,
    lat: -22.0965348
  },
  {
    lng: -41.1554255,
    lat: -22.0966158
  },
  {
    lng: -41.155546,
    lat: -22.0966739
  },
  {
    lng: -41.155685,
    lat: -22.0966818
  },
  {
    lng: -41.1558326,
    lat: -22.0966193
  },
  {
    lng: -41.1559668,
    lat: -22.0965273
  },
  {
    lng: -41.1560426,
    lat: -22.0964214
  },
  {
    lng: -41.1566031,
    lat: -22.0954153
  },
  {
    lng: -41.156708,
    lat: -22.0951568
  },
  {
    lng: -41.15684,
    lat: -22.0948076
  },
  {
    lng: -41.1569578,
    lat: -22.0945473
  },
  {
    lng: -41.1570127,
    lat: -22.0944411
  },
  {
    lng: -41.1572667,
    lat: -22.0940429
  },
  {
    lng: -41.1573704,
    lat: -22.0939063
  },
  {
    lng: -41.1575149,
    lat: -22.0937531
  },
  {
    lng: -41.1576537,
    lat: -22.0936217
  },
  {
    lng: -41.1577576,
    lat: -22.0934961
  },
  {
    lng: -41.1578501,
    lat: -22.0934328
  },
  {
    lng: -41.1579119,
    lat: -22.0934351
  },
  {
    lng: -41.1582121,
    lat: -22.0935092
  },
  {
    lng: -41.1585289,
    lat: -22.0936438
  },
  {
    lng: -41.1586868,
    lat: -22.093692
  },
  {
    lng: -41.1588557,
    lat: -22.0937457
  },
  {
    lng: -41.1589656,
    lat: -22.0938362
  },
  {
    lng: -41.1591474,
    lat: -22.0939548
  },
  {
    lng: -41.1591779,
    lat: -22.0940402
  },
  {
    lng: -41.159218,
    lat: -22.0941184
  },
  {
    lng: -41.1592925,
    lat: -22.0942794
  },
  {
    lng: -41.1593962,
    lat: -22.0944632
  },
  {
    lng: -41.1594793,
    lat: -22.094709
  },
  {
    lng: -41.1595518,
    lat: -22.0949689
  },
  {
    lng: -41.1596266,
    lat: -22.095214
  },
  {
    lng: -41.1597173,
    lat: -22.0955917
  },
  {
    lng: -41.1597437,
    lat: -22.0957669
  },
  {
    lng: -41.1598244,
    lat: -22.0960498
  },
  {
    lng: -41.1599719,
    lat: -22.0964766
  },
  {
    lng: -41.1600121,
    lat: -22.0966183
  },
  {
    lng: -41.1601559,
    lat: -22.0969276
  },
  {
    lng: -41.1602243,
    lat: -22.0970599
  },
  {
    lng: -41.1603558,
    lat: -22.097193
  },
  {
    lng: -41.1604169,
    lat: -22.097239
  },
  {
    lng: -41.1605239,
    lat: -22.0972965
  },
  {
    lng: -41.1608533,
    lat: -22.0974987
  },
  {
    lng: -41.161094,
    lat: -22.0976425
  },
  {
    lng: -41.1611735,
    lat: -22.0977475
  },
  {
    lng: -41.1611655,
    lat: -22.0978417
  },
  {
    lng: -41.1609962,
    lat: -22.0983824
  },
  {
    lng: -41.1609452,
    lat: -22.0984823
  },
  {
    lng: -41.1608299,
    lat: -22.0986417
  },
  {
    lng: -41.1606798,
    lat: -22.0987831
  },
  {
    lng: -41.1605861,
    lat: -22.0988985
  },
  {
    lng: -41.1604433,
    lat: -22.0990255
  },
  {
    lng: -41.1603761,
    lat: -22.0991128
  },
  {
    lng: -41.1601369,
    lat: -22.0994057
  },
  {
    lng: -41.1600036,
    lat: -22.099547
  },
  {
    lng: -41.1598636,
    lat: -22.0997198
  },
  {
    lng: -41.1597063,
    lat: -22.0999293
  },
  {
    lng: -41.1595642,
    lat: -22.1001739
  },
  {
    lng: -41.1595193,
    lat: -22.1003691
  },
  {
    lng: -41.1594879,
    lat: -22.1005653
  },
  {
    lng: -41.1594929,
    lat: -22.1006938
  },
  {
    lng: -41.1594998,
    lat: -22.1008182
  },
  {
    lng: -41.159525,
    lat: -22.1010525
  },
  {
    lng: -41.1595756,
    lat: -22.1012597
  },
  {
    lng: -41.1597032,
    lat: -22.1015253
  },
  {
    lng: -41.1597448,
    lat: -22.1016284
  },
  {
    lng: -41.1598165,
    lat: -22.1017057
  },
  {
    lng: -41.1598982,
    lat: -22.101763
  },
  {
    lng: -41.1599951,
    lat: -22.1018223
  },
  {
    lng: -41.1601458,
    lat: -22.1018566
  },
  {
    lng: -41.1602827,
    lat: -22.1018583
  },
  {
    lng: -41.1604077,
    lat: -22.1018662
  },
  {
    lng: -41.1605613,
    lat: -22.1018258
  },
  {
    lng: -41.1608198,
    lat: -22.1017386
  },
  {
    lng: -41.1609923,
    lat: -22.1016957
  },
  {
    lng: -41.1611445,
    lat: -22.1016636
  },
  {
    lng: -41.161312,
    lat: -22.10161
  },
  {
    lng: -41.161415,
    lat: -22.1015813
  },
  {
    lng: -41.1618174,
    lat: -22.1015104
  },
  {
    lng: -41.1619476,
    lat: -22.1015018
  },
  {
    lng: -41.1623731,
    lat: -22.1014734
  },
  {
    lng: -41.1625195,
    lat: -22.1014595
  },
  {
    lng: -41.1626585,
    lat: -22.1014039
  },
  {
    lng: -41.1629239,
    lat: -22.1012959
  },
  {
    lng: -41.1631155,
    lat: -22.1011628
  },
  {
    lng: -41.1633233,
    lat: -22.1009924
  },
  {
    lng: -41.1634905,
    lat: -22.1008567
  },
  {
    lng: -41.1635754,
    lat: -22.1007666
  },
  {
    lng: -41.1636142,
    lat: -22.1007418
  },
  {
    lng: -41.1639204,
    lat: -22.100519
  },
  {
    lng: -41.1644035,
    lat: -22.1001951
  },
  {
    lng: -41.164499,
    lat: -22.1001499
  },
  {
    lng: -41.1646035,
    lat: -22.1000729
  },
  {
    lng: -41.1646878,
    lat: -22.1000085
  },
  {
    lng: -41.1647606,
    lat: -22.0999506
  },
  {
    lng: -41.1648642,
    lat: -22.0998809
  },
  {
    lng: -41.1649857,
    lat: -22.0997874
  },
  {
    lng: -41.1652089,
    lat: -22.0996426
  },
  {
    lng: -41.165293,
    lat: -22.0996008
  },
  {
    lng: -41.1653857,
    lat: -22.0995346
  },
  {
    lng: -41.1655615,
    lat: -22.0993804
  },
  {
    lng: -41.1656614,
    lat: -22.0992815
  },
  {
    lng: -41.1657295,
    lat: -22.0992257
  },
  {
    lng: -41.1657705,
    lat: -22.0992147
  },
  {
    lng: -41.1658455,
    lat: -22.0992201
  },
  {
    lng: -41.1659537,
    lat: -22.0992562
  },
  {
    lng: -41.1660256,
    lat: -22.0993142
  },
  {
    lng: -41.166148,
    lat: -22.0994064
  },
  {
    lng: -41.1662499,
    lat: -22.0994786
  },
  {
    lng: -41.1664404,
    lat: -22.0995577
  },
  {
    lng: -41.1665387,
    lat: -22.0995758
  },
  {
    lng: -41.1666065,
    lat: -22.0995815
  },
  {
    lng: -41.1666806,
    lat: -22.0995555
  },
  {
    lng: -41.1667156,
    lat: -22.0995169
  },
  {
    lng: -41.1667414,
    lat: -22.0993026
  },
  {
    lng: -41.166756,
    lat: -22.0991586
  },
  {
    lng: -41.1667231,
    lat: -22.0989937
  },
  {
    lng: -41.1666914,
    lat: -22.0988736
  },
  {
    lng: -41.1666755,
    lat: -22.0987895
  },
  {
    lng: -41.1665604,
    lat: -22.0985213
  },
  {
    lng: -41.1665441,
    lat: -22.0983784
  },
  {
    lng: -41.1665053,
    lat: -22.0981902
  },
  {
    lng: -41.1665652,
    lat: -22.0979713
  },
  {
    lng: -41.166596,
    lat: -22.097915
  },
  {
    lng: -41.166666,
    lat: -22.0978902
  },
  {
    lng: -41.1667705,
    lat: -22.0978352
  },
  {
    lng: -41.1668518,
    lat: -22.0978129
  },
  {
    lng: -41.1669335,
    lat: -22.0978232
  },
  {
    lng: -41.1670778,
    lat: -22.0978307
  },
  {
    lng: -41.1672761,
    lat: -22.0978774
  },
  {
    lng: -41.1674124,
    lat: -22.0979003
  },
  {
    lng: -41.1676124,
    lat: -22.0979514
  },
  {
    lng: -41.1677038,
    lat: -22.09797
  },
  {
    lng: -41.1677951,
    lat: -22.0979731
  },
  {
    lng: -41.1679373,
    lat: -22.0980253
  },
  {
    lng: -41.1680937,
    lat: -22.0980692
  },
  {
    lng: -41.1682015,
    lat: -22.0980966
  },
  {
    lng: -41.1682871,
    lat: -22.0981268
  },
  {
    lng: -41.1683357,
    lat: -22.0981576
  },
  {
    lng: -41.168686,
    lat: -22.0981576
  },
  {
    lng: -41.1687939,
    lat: -22.0981445
  },
  {
    lng: -41.168962,
    lat: -22.0981253
  },
  {
    lng: -41.1691967,
    lat: -22.0981069
  },
  {
    lng: -41.1694181,
    lat: -22.0980624
  },
  {
    lng: -41.1696559,
    lat: -22.0980576
  },
  {
    lng: -41.169855,
    lat: -22.0980957
  },
  {
    lng: -41.1702026,
    lat: -22.098268
  },
  {
    lng: -41.1704655,
    lat: -22.0983722
  },
  {
    lng: -41.1706074,
    lat: -22.0983731
  },
  {
    lng: -41.1707263,
    lat: -22.0983477
  },
  {
    lng: -41.1708225,
    lat: -22.0983268
  },
  {
    lng: -41.1709345,
    lat: -22.0983137
  },
  {
    lng: -41.1714359,
    lat: -22.0981557
  },
  {
    lng: -41.1717603,
    lat: -22.0980353
  },
  {
    lng: -41.1721838,
    lat: -22.0979218
  },
  {
    lng: -41.1724569,
    lat: -22.097867
  },
  {
    lng: -41.1727126,
    lat: -22.0978408
  },
  {
    lng: -41.1728653,
    lat: -22.0978342
  },
  {
    lng: -41.1734379,
    lat: -22.0977782
  },
  {
    lng: -41.1737933,
    lat: -22.0976493
  },
  {
    lng: -41.1742452,
    lat: -22.0975699
  },
  {
    lng: -41.1746192,
    lat: -22.0975325
  },
  {
    lng: -41.1747867,
    lat: -22.0975163
  },
  {
    lng: -41.1750298,
    lat: -22.0974783
  },
  {
    lng: -41.1751983,
    lat: -22.0974336
  },
  {
    lng: -41.175278,
    lat: -22.0974103
  },
  {
    lng: -41.1754037,
    lat: -22.097323
  },
  {
    lng: -41.175489,
    lat: -22.0971916
  },
  {
    lng: -41.1755704,
    lat: -22.097021
  },
  {
    lng: -41.1755457,
    lat: -22.0968732
  },
  {
    lng: -41.1755056,
    lat: -22.0967652
  },
  {
    lng: -41.1753308,
    lat: -22.0964217
  },
  {
    lng: -41.1753071,
    lat: -22.0963342
  },
  {
    lng: -41.1753208,
    lat: -22.0961738
  },
  {
    lng: -41.1753584,
    lat: -22.0961171
  },
  {
    lng: -41.1754323,
    lat: -22.0960528
  },
  {
    lng: -41.1755947,
    lat: -22.0959998
  },
  {
    lng: -41.1760402,
    lat: -22.0958619
  },
  {
    lng: -41.1761326,
    lat: -22.0958476
  },
  {
    lng: -41.1762573,
    lat: -22.0958283
  },
  {
    lng: -41.1765256,
    lat: -22.0958591
  },
  {
    lng: -41.1766952,
    lat: -22.0959339
  },
  {
    lng: -41.1767778,
    lat: -22.0960693
  },
  {
    lng: -41.1767327,
    lat: -22.0962434
  },
  {
    lng: -41.176577,
    lat: -22.0964565
  },
  {
    lng: -41.1763926,
    lat: -22.0967077
  },
  {
    lng: -41.1763765,
    lat: -22.0968709
  },
  {
    lng: -41.1764361,
    lat: -22.097039
  },
  {
    lng: -41.1766207,
    lat: -22.0972713
  },
  {
    lng: -41.176818,
    lat: -22.0974385
  },
  {
    lng: -41.1770053,
    lat: -22.0975459
  },
  {
    lng: -41.1771045,
    lat: -22.0975974
  },
  {
    lng: -41.1775736,
    lat: -22.0976173
  },
  {
    lng: -41.1777419,
    lat: -22.0975873
  },
  {
    lng: -41.1778234,
    lat: -22.0975792
  },
  {
    lng: -41.177887,
    lat: -22.0975587
  },
  {
    lng: -41.1779767,
    lat: -22.0975281
  },
  {
    lng: -41.1781084,
    lat: -22.097526
  },
  {
    lng: -41.1782313,
    lat: -22.0975453
  },
  {
    lng: -41.178283,
    lat: -22.0975856
  },
  {
    lng: -41.1782932,
    lat: -22.0976343
  },
  {
    lng: -41.1783149,
    lat: -22.0976917
  },
  {
    lng: -41.1783404,
    lat: -22.097791
  },
  {
    lng: -41.1783599,
    lat: -22.0978841
  },
  {
    lng: -41.1783547,
    lat: -22.098017
  },
  {
    lng: -41.1782944,
    lat: -22.0982183
  },
  {
    lng: -41.1782773,
    lat: -22.0984662
  },
  {
    lng: -41.1782673,
    lat: -22.0986782
  },
  {
    lng: -41.1782887,
    lat: -22.0987967
  },
  {
    lng: -41.1784172,
    lat: -22.0991106
  },
  {
    lng: -41.1784521,
    lat: -22.0991962
  },
  {
    lng: -41.1786625,
    lat: -22.0995047
  },
  {
    lng: -41.1788532,
    lat: -22.0996967
  },
  {
    lng: -41.1791136,
    lat: -22.0998651
  },
  {
    lng: -41.179452,
    lat: -22.0999449
  },
  {
    lng: -41.1796086,
    lat: -22.0999371
  },
  {
    lng: -41.179992,
    lat: -22.0998705
  },
  {
    lng: -41.1802302,
    lat: -22.0997832
  },
  {
    lng: -41.1804134,
    lat: -22.0996358
  },
  {
    lng: -41.1804924,
    lat: -22.0995096
  },
  {
    lng: -41.1806155,
    lat: -22.099328
  },
  {
    lng: -41.1806839,
    lat: -22.0992155
  },
  {
    lng: -41.1807066,
    lat: -22.0991447
  },
  {
    lng: -41.1807235,
    lat: -22.0990794
  },
  {
    lng: -41.1807424,
    lat: -22.0990383
  },
  {
    lng: -41.1807519,
    lat: -22.0989937
  },
  {
    lng: -41.1809031,
    lat: -22.0989422
  },
  {
    lng: -41.1809983,
    lat: -22.0989441
  },
  {
    lng: -41.1811138,
    lat: -22.0989252
  },
  {
    lng: -41.1814319,
    lat: -22.0989323
  },
  {
    lng: -41.1817626,
    lat: -22.0989146
  },
  {
    lng: -41.1818844,
    lat: -22.0988551
  },
  {
    lng: -41.1821148,
    lat: -22.0987779
  },
  {
    lng: -41.1823252,
    lat: -22.0986505
  },
  {
    lng: -41.1826036,
    lat: -22.0984457
  },
  {
    lng: -41.1827844,
    lat: -22.0984167
  },
  {
    lng: -41.1828829,
    lat: -22.0983924
  },
  {
    lng: -41.1830139,
    lat: -22.098404
  },
  {
    lng: -41.1831415,
    lat: -22.0984581
  },
  {
    lng: -41.1833459,
    lat: -22.0985085
  },
  {
    lng: -41.1834951,
    lat: -22.0985382
  },
  {
    lng: -41.1836801,
    lat: -22.0985798
  },
  {
    lng: -41.1838872,
    lat: -22.0985791
  },
  {
    lng: -41.1839464,
    lat: -22.0985758
  },
  {
    lng: -41.1840533,
    lat: -22.098549
  },
  {
    lng: -41.1844105,
    lat: -22.0984971
  },
  {
    lng: -41.1845302,
    lat: -22.0984757
  },
  {
    lng: -41.1846958,
    lat: -22.0984542
  },
  {
    lng: -41.1848035,
    lat: -22.0984449
  },
  {
    lng: -41.1848927,
    lat: -22.098454
  },
  {
    lng: -41.1851059,
    lat: -22.098459
  },
  {
    lng: -41.1852594,
    lat: -22.098444
  },
  {
    lng: -41.185457,
    lat: -22.0984092
  },
  {
    lng: -41.1855963,
    lat: -22.098412
  },
  {
    lng: -41.1857569,
    lat: -22.0984661
  },
  {
    lng: -41.1859125,
    lat: -22.0985185
  },
  {
    lng: -41.1860326,
    lat: -22.0985906
  },
  {
    lng: -41.1861206,
    lat: -22.098605
  },
  {
    lng: -41.1863388,
    lat: -22.0986126
  },
  {
    lng: -41.1866008,
    lat: -22.0986372
  },
  {
    lng: -41.1866884,
    lat: -22.0986434
  },
  {
    lng: -41.1867234,
    lat: -22.0986988
  },
  {
    lng: -41.1867191,
    lat: -22.0987979
  },
  {
    lng: -41.1867179,
    lat: -22.0988502
  },
  {
    lng: -41.1866431,
    lat: -22.0990686
  },
  {
    lng: -41.1865508,
    lat: -22.0991631
  },
  {
    lng: -41.1864958,
    lat: -22.0992278
  },
  {
    lng: -41.1863977,
    lat: -22.0994058
  },
  {
    lng: -41.1862745,
    lat: -22.0995727
  },
  {
    lng: -41.1862734,
    lat: -22.0998066
  },
  {
    lng: -41.1863476,
    lat: -22.0998914
  },
  {
    lng: -41.1864171,
    lat: -22.0999446
  },
  {
    lng: -41.1865773,
    lat: -22.1000661
  },
  {
    lng: -41.1866577,
    lat: -22.1001188
  },
  {
    lng: -41.1868565,
    lat: -22.1001989
  },
  {
    lng: -41.1870388,
    lat: -22.1002691
  },
  {
    lng: -41.1872132,
    lat: -22.1003648
  },
  {
    lng: -41.187446,
    lat: -22.1003197
  },
  {
    lng: -41.1876022,
    lat: -22.1001937
  },
  {
    lng: -41.1878562,
    lat: -22.0999693
  },
  {
    lng: -41.1878767,
    lat: -22.0999513
  },
  {
    lng: -41.1880446,
    lat: -22.0997507
  },
  {
    lng: -41.1881276,
    lat: -22.0996756
  },
  {
    lng: -41.1882294,
    lat: -22.0995861
  },
  {
    lng: -41.1883304,
    lat: -22.0994696
  },
  {
    lng: -41.1884091,
    lat: -22.0993349
  },
  {
    lng: -41.1884766,
    lat: -22.0992456
  },
  {
    lng: -41.1885354,
    lat: -22.0991758
  },
  {
    lng: -41.1886198,
    lat: -22.0991077
  },
  {
    lng: -41.1886719,
    lat: -22.0990762
  },
  {
    lng: -41.1887814,
    lat: -22.0990277
  },
  {
    lng: -41.1888671,
    lat: -22.0989865
  },
  {
    lng: -41.188987,
    lat: -22.0989903
  },
  {
    lng: -41.1890392,
    lat: -22.0989955
  },
  {
    lng: -41.1891084,
    lat: -22.0990429
  },
  {
    lng: -41.1891783,
    lat: -22.099101
  },
  {
    lng: -41.1892548,
    lat: -22.0992091
  },
  {
    lng: -41.1893163,
    lat: -22.0994022
  },
  {
    lng: -41.1892145,
    lat: -22.0995771
  },
  {
    lng: -41.1890505,
    lat: -22.0998791
  },
  {
    lng: -41.1888306,
    lat: -22.1001795
  },
  {
    lng: -41.188682,
    lat: -22.1004798
  },
  {
    lng: -41.1885825,
    lat: -22.1005878
  },
  {
    lng: -41.1885159,
    lat: -22.1007671
  },
  {
    lng: -41.1884645,
    lat: -22.1008493
  },
  {
    lng: -41.1884414,
    lat: -22.1009268
  },
  {
    lng: -41.1884189,
    lat: -22.1010085
  },
  {
    lng: -41.1884487,
    lat: -22.1011006
  },
  {
    lng: -41.1884967,
    lat: -22.1012688
  },
  {
    lng: -41.1886509,
    lat: -22.1014814
  },
  {
    lng: -41.1889756,
    lat: -22.101676
  },
  {
    lng: -41.1890985,
    lat: -22.1016873
  },
  {
    lng: -41.1892159,
    lat: -22.10166
  },
  {
    lng: -41.1892922,
    lat: -22.10166
  },
  {
    lng: -41.1893672,
    lat: -22.101626
  },
  {
    lng: -41.1894525,
    lat: -22.1015689
  },
  {
    lng: -41.1895388,
    lat: -22.1014851
  },
  {
    lng: -41.1896652,
    lat: -22.1013632
  },
  {
    lng: -41.1897549,
    lat: -22.1012226
  },
  {
    lng: -41.1898303,
    lat: -22.1010677
  },
  {
    lng: -41.1898897,
    lat: -22.1009875
  },
  {
    lng: -41.1899312,
    lat: -22.1009199
  },
  {
    lng: -41.1900251,
    lat: -22.1007743
  },
  {
    lng: -41.190113,
    lat: -22.1006582
  },
  {
    lng: -41.1903189,
    lat: -22.1003424
  },
  {
    lng: -41.1903648,
    lat: -22.1002717
  },
  {
    lng: -41.1904063,
    lat: -22.1001989
  },
  {
    lng: -41.1904324,
    lat: -22.1001492
  },
  {
    lng: -41.190516,
    lat: -22.0999245
  },
  {
    lng: -41.1906419,
    lat: -22.0995251
  },
  {
    lng: -41.1906503,
    lat: -22.0994408
  },
  {
    lng: -41.1906554,
    lat: -22.0990489
  },
  {
    lng: -41.1906364,
    lat: -22.0988408
  },
  {
    lng: -41.1905848,
    lat: -22.0986849
  },
  {
    lng: -41.1904551,
    lat: -22.098483
  },
  {
    lng: -41.190384,
    lat: -22.0983368
  },
  {
    lng: -41.1904125,
    lat: -22.0981881
  },
  {
    lng: -41.1904322,
    lat: -22.0981689
  },
  {
    lng: -41.1904993,
    lat: -22.098136
  },
  {
    lng: -41.1906676,
    lat: -22.0981036
  },
  {
    lng: -41.1911793,
    lat: -22.0979724
  },
  {
    lng: -41.1913722,
    lat: -22.0978749
  },
  {
    lng: -41.191458,
    lat: -22.0978512
  },
  {
    lng: -41.1915704,
    lat: -22.0977845
  },
  {
    lng: -41.1916129,
    lat: -22.0976743
  },
  {
    lng: -41.1916788,
    lat: -22.0975756
  },
  {
    lng: -41.1918415,
    lat: -22.0972392
  },
  {
    lng: -41.191907,
    lat: -22.0971793
  },
  {
    lng: -41.1919417,
    lat: -22.0971464
  },
  {
    lng: -41.1920071,
    lat: -22.0971172
  },
  {
    lng: -41.1922032,
    lat: -22.0970575
  },
  {
    lng: -41.1924267,
    lat: -22.0970216
  },
  {
    lng: -41.1925596,
    lat: -22.0970512
  },
  {
    lng: -41.1927333,
    lat: -22.0971135
  },
  {
    lng: -41.1927906,
    lat: -22.0971558
  },
  {
    lng: -41.1929591,
    lat: -22.0973017
  },
  {
    lng: -41.1932037,
    lat: -22.097552
  },
  {
    lng: -41.1933127,
    lat: -22.0976587
  },
  {
    lng: -41.1933592,
    lat: -22.097727
  },
  {
    lng: -41.1933632,
    lat: -22.0977875
  },
  {
    lng: -41.1933808,
    lat: -22.0978874
  },
  {
    lng: -41.1933661,
    lat: -22.0980727
  },
  {
    lng: -41.1932859,
    lat: -22.0983463
  },
  {
    lng: -41.1932158,
    lat: -22.0987007
  },
  {
    lng: -41.1932159,
    lat: -22.0989851
  },
  {
    lng: -41.1932439,
    lat: -22.099063
  },
  {
    lng: -41.1932622,
    lat: -22.0991394
  },
  {
    lng: -41.1933064,
    lat: -22.0992712
  },
  {
    lng: -41.1933376,
    lat: -22.0994241
  },
  {
    lng: -41.1933958,
    lat: -22.0996374
  },
  {
    lng: -41.1934,
    lat: -22.0999358
  },
  {
    lng: -41.1933681,
    lat: -22.100068
  },
  {
    lng: -41.1932254,
    lat: -22.1002078
  },
  {
    lng: -41.1930776,
    lat: -22.1003391
  },
  {
    lng: -41.1929371,
    lat: -22.1003796
  },
  {
    lng: -41.1927687,
    lat: -22.1004306
  },
  {
    lng: -41.1924003,
    lat: -22.1005516
  },
  {
    lng: -41.1923189,
    lat: -22.1005908
  },
  {
    lng: -41.191965,
    lat: -22.1007005
  },
  {
    lng: -41.1919063,
    lat: -22.1007369
  },
  {
    lng: -41.1918349,
    lat: -22.1008219
  },
  {
    lng: -41.1918243,
    lat: -22.1008522
  },
  {
    lng: -41.1918089,
    lat: -22.1009866
  },
  {
    lng: -41.1917996,
    lat: -22.1010617
  },
  {
    lng: -41.1918306,
    lat: -22.1011689
  },
  {
    lng: -41.1919615,
    lat: -22.1014778
  },
  {
    lng: -41.1920055,
    lat: -22.1015272
  },
  {
    lng: -41.1920799,
    lat: -22.1015854
  },
  {
    lng: -41.1921747,
    lat: -22.1018998
  },
  {
    lng: -41.1921541,
    lat: -22.1019657
  },
  {
    lng: -41.1921405,
    lat: -22.1020638
  },
  {
    lng: -41.1920473,
    lat: -22.1022107
  },
  {
    lng: -41.1919862,
    lat: -22.1023151
  },
  {
    lng: -41.191678,
    lat: -22.1025481
  },
  {
    lng: -41.1915866,
    lat: -22.1026183
  },
  {
    lng: -41.1913077,
    lat: -22.102873
  },
  {
    lng: -41.191249,
    lat: -22.1029175
  },
  {
    lng: -41.191197,
    lat: -22.1029776
  },
  {
    lng: -41.1911452,
    lat: -22.1030649
  },
  {
    lng: -41.1911065,
    lat: -22.1031526
  },
  {
    lng: -41.191115,
    lat: -22.1033233
  },
  {
    lng: -41.1911704,
    lat: -22.1033904
  },
  {
    lng: -41.1912535,
    lat: -22.103434
  },
  {
    lng: -41.1913055,
    lat: -22.1034225
  },
  {
    lng: -41.1914512,
    lat: -22.103416
  },
  {
    lng: -41.1915559,
    lat: -22.103399
  },
  {
    lng: -41.191723,
    lat: -22.1033682
  },
  {
    lng: -41.1918716,
    lat: -22.1033477
  },
  {
    lng: -41.192235,
    lat: -22.1032658
  },
  {
    lng: -41.1925448,
    lat: -22.1032017
  },
  {
    lng: -41.1926991,
    lat: -22.103221
  },
  {
    lng: -41.1927954,
    lat: -22.103237
  },
  {
    lng: -41.1930033,
    lat: -22.1032651
  },
  {
    lng: -41.1930771,
    lat: -22.1033114
  },
  {
    lng: -41.1931288,
    lat: -22.1033503
  },
  {
    lng: -41.1931847,
    lat: -22.1034012
  },
  {
    lng: -41.1932555,
    lat: -22.1034996
  },
  {
    lng: -41.1933097,
    lat: -22.1035717
  },
  {
    lng: -41.1933545,
    lat: -22.1035946
  },
  {
    lng: -41.1935913,
    lat: -22.1037713
  },
  {
    lng: -41.1937963,
    lat: -22.103952
  },
  {
    lng: -41.1944051,
    lat: -22.104219
  },
  {
    lng: -41.1945286,
    lat: -22.1042701
  },
  {
    lng: -41.1948082,
    lat: -22.1043133
  },
  {
    lng: -41.1950358,
    lat: -22.1043158
  },
  {
    lng: -41.1951526,
    lat: -22.104281
  },
  {
    lng: -41.1952274,
    lat: -22.1041608
  },
  {
    lng: -41.1952668,
    lat: -22.1039867
  },
  {
    lng: -41.1953001,
    lat: -22.1037962
  },
  {
    lng: -41.1953494,
    lat: -22.1036331
  },
  {
    lng: -41.1953585,
    lat: -22.1034353
  },
  {
    lng: -41.1953627,
    lat: -22.1032843
  },
  {
    lng: -41.1953568,
    lat: -22.1031079
  },
  {
    lng: -41.1953807,
    lat: -22.1030391
  },
  {
    lng: -41.1954377,
    lat: -22.1029649
  },
  {
    lng: -41.195589,
    lat: -22.1028459
  },
  {
    lng: -41.1957692,
    lat: -22.1027547
  },
  {
    lng: -41.1960125,
    lat: -22.1026924
  },
  {
    lng: -41.1961238,
    lat: -22.1026652
  },
  {
    lng: -41.1965291,
    lat: -22.1026163
  },
  {
    lng: -41.1969243,
    lat: -22.1025814
  },
  {
    lng: -41.1970247,
    lat: -22.1025794
  },
  {
    lng: -41.1974243,
    lat: -22.1025655
  },
  {
    lng: -41.1978585,
    lat: -22.1025318
  },
  {
    lng: -41.1979802,
    lat: -22.1025023
  },
  {
    lng: -41.1981185,
    lat: -22.1024125
  },
  {
    lng: -41.1982053,
    lat: -22.1023032
  },
  {
    lng: -41.1983719,
    lat: -22.101972
  },
  {
    lng: -41.1985195,
    lat: -22.1018229
  },
  {
    lng: -41.1986837,
    lat: -22.1017339
  },
  {
    lng: -41.1988301,
    lat: -22.1016679
  },
  {
    lng: -41.1989724,
    lat: -22.101691
  },
  {
    lng: -41.1990738,
    lat: -22.1017668
  },
  {
    lng: -41.1991114,
    lat: -22.1018962
  },
  {
    lng: -41.1991029,
    lat: -22.1020321
  },
  {
    lng: -41.1990207,
    lat: -22.1022059
  },
  {
    lng: -41.1988939,
    lat: -22.1024525
  },
  {
    lng: -41.1989015,
    lat: -22.1026483
  },
  {
    lng: -41.1989699,
    lat: -22.1027881
  },
  {
    lng: -41.1991883,
    lat: -22.1030999
  },
  {
    lng: -41.1993952,
    lat: -22.1033436
  },
  {
    lng: -41.199676,
    lat: -22.1036314
  },
  {
    lng: -41.1997454,
    lat: -22.1036937
  },
  {
    lng: -41.2001065,
    lat: -22.1038967
  },
  {
    lng: -41.2002891,
    lat: -22.1039502
  },
  {
    lng: -41.2004458,
    lat: -22.103947
  },
  {
    lng: -41.2005954,
    lat: -22.1039316
  },
  {
    lng: -41.2008433,
    lat: -22.1038912
  },
  {
    lng: -41.2011128,
    lat: -22.1037699
  },
  {
    lng: -41.2011585,
    lat: -22.1037324
  },
  {
    lng: -41.2012877,
    lat: -22.1036262
  },
  {
    lng: -41.2013658,
    lat: -22.1035317
  },
  {
    lng: -41.2016328,
    lat: -22.1032387
  },
  {
    lng: -41.2016454,
    lat: -22.1032254
  },
  {
    lng: -41.2018345,
    lat: -22.1028927
  },
  {
    lng: -41.2019458,
    lat: -22.1026571
  },
  {
    lng: -41.2019532,
    lat: -22.102639
  },
  {
    lng: -41.2020961,
    lat: -22.1022984
  },
  {
    lng: -41.2022776,
    lat: -22.101941
  },
  {
    lng: -41.2024531,
    lat: -22.1016782
  },
  {
    lng: -41.2026916,
    lat: -22.1013836
  },
  {
    lng: -41.2028069,
    lat: -22.101274
  },
  {
    lng: -41.2030906,
    lat: -22.101014
  },
  {
    lng: -41.203231,
    lat: -22.10082
  },
  {
    lng: -41.2032442,
    lat: -22.1007958
  },
  {
    lng: -41.2033605,
    lat: -22.1004303
  },
  {
    lng: -41.2033823,
    lat: -22.1002783
  },
  {
    lng: -41.2033425,
    lat: -22.0999772
  },
  {
    lng: -41.2032684,
    lat: -22.0996003
  },
  {
    lng: -41.203222,
    lat: -22.09941
  },
  {
    lng: -41.203047,
    lat: -22.0990802
  },
  {
    lng: -41.20292,
    lat: -22.0989235
  },
  {
    lng: -41.2027071,
    lat: -22.0986026
  },
  {
    lng: -41.2026729,
    lat: -22.0985376
  },
  {
    lng: -41.2025334,
    lat: -22.0981991
  },
  {
    lng: -41.2025035,
    lat: -22.0978349
  },
  {
    lng: -41.2025368,
    lat: -22.0977137
  },
  {
    lng: -41.202589,
    lat: -22.0975556
  },
  {
    lng: -41.202613,
    lat: -22.0974408
  },
  {
    lng: -41.2026287,
    lat: -22.0973659
  },
  {
    lng: -41.2026289,
    lat: -22.0973409
  },
  {
    lng: -41.202621,
    lat: -22.096969
  },
  {
    lng: -41.2026089,
    lat: -22.0967396
  },
  {
    lng: -41.2026509,
    lat: -22.0966262
  },
  {
    lng: -41.2027532,
    lat: -22.09653
  },
  {
    lng: -41.2028841,
    lat: -22.0965012
  },
  {
    lng: -41.2030315,
    lat: -22.0964943
  },
  {
    lng: -41.203177,
    lat: -22.096464
  },
  {
    lng: -41.2032548,
    lat: -22.0964067
  },
  {
    lng: -41.2033925,
    lat: -22.0962219
  },
  {
    lng: -41.2034635,
    lat: -22.0961262
  },
  {
    lng: -41.2036179,
    lat: -22.0961205
  },
  {
    lng: -41.2037305,
    lat: -22.0962053
  },
  {
    lng: -41.2038263,
    lat: -22.0964237
  },
  {
    lng: -41.2039804,
    lat: -22.0965512
  },
  {
    lng: -41.2041023,
    lat: -22.0966245
  },
  {
    lng: -41.2042164,
    lat: -22.0966659
  },
  {
    lng: -41.2043247,
    lat: -22.0967226
  },
  {
    lng: -41.2045592,
    lat: -22.0968097
  },
  {
    lng: -41.2047234,
    lat: -22.0968157
  },
  {
    lng: -41.205103,
    lat: -22.0967465
  },
  {
    lng: -41.2052775,
    lat: -22.0966994
  },
  {
    lng: -41.2054607,
    lat: -22.0966574
  },
  {
    lng: -41.2058416,
    lat: -22.0965461
  },
  {
    lng: -41.2059641,
    lat: -22.0965249
  },
  {
    lng: -41.2060421,
    lat: -22.0965634
  },
  {
    lng: -41.206098,
    lat: -22.0967134
  },
  {
    lng: -41.2061057,
    lat: -22.0967716
  },
  {
    lng: -41.2060887,
    lat: -22.0971454
  },
  {
    lng: -41.2060781,
    lat: -22.0975198
  },
  {
    lng: -41.2061252,
    lat: -22.0976387
  },
  {
    lng: -41.2062461,
    lat: -22.0977782
  },
  {
    lng: -41.2063771,
    lat: -22.0979073
  },
  {
    lng: -41.2065179,
    lat: -22.098005
  },
  {
    lng: -41.2066789,
    lat: -22.0980741
  },
  {
    lng: -41.2068882,
    lat: -22.0980738
  },
  {
    lng: -41.2069127,
    lat: -22.0980686
  },
  {
    lng: -41.2070054,
    lat: -22.0979997
  },
  {
    lng: -41.2070127,
    lat: -22.0978467
  },
  {
    lng: -41.2069171,
    lat: -22.0976061
  },
  {
    lng: -41.2068608,
    lat: -22.0973697
  },
  {
    lng: -41.2068375,
    lat: -22.097202
  },
  {
    lng: -41.2068998,
    lat: -22.0968595
  },
  {
    lng: -41.206931,
    lat: -22.0967669
  },
  {
    lng: -41.2071327,
    lat: -22.0964476
  },
  {
    lng: -41.2072074,
    lat: -22.096329
  },
  {
    lng: -41.2072851,
    lat: -22.096258
  },
  {
    lng: -41.2073745,
    lat: -22.0962396
  },
  {
    lng: -41.2074926,
    lat: -22.0962543
  },
  {
    lng: -41.2076262,
    lat: -22.0963565
  },
  {
    lng: -41.2077404,
    lat: -22.0964873
  },
  {
    lng: -41.2077611,
    lat: -22.096516
  },
  {
    lng: -41.2080108,
    lat: -22.0968325
  },
  {
    lng: -41.208226,
    lat: -22.0970249
  },
  {
    lng: -41.2084988,
    lat: -22.0972857
  },
  {
    lng: -41.2086621,
    lat: -22.0973639
  },
  {
    lng: -41.208814,
    lat: -22.0973964
  },
  {
    lng: -41.2091565,
    lat: -22.097413
  },
  {
    lng: -41.2092638,
    lat: -22.0974098
  },
  {
    lng: -41.2096493,
    lat: -22.0973488
  },
  {
    lng: -41.2096564,
    lat: -22.0973469
  },
  {
    lng: -41.2099159,
    lat: -22.0972768
  },
  {
    lng: -41.2099187,
    lat: -22.0972747
  },
  {
    lng: -41.2101183,
    lat: -22.0971246
  },
  {
    lng: -41.210233,
    lat: -22.0970637
  },
  {
    lng: -41.2103935,
    lat: -22.0970408
  },
  {
    lng: -41.2105405,
    lat: -22.097038
  },
  {
    lng: -41.210679,
    lat: -22.0970791
  },
  {
    lng: -41.2108736,
    lat: -22.0971513
  },
  {
    lng: -41.2111753,
    lat: -22.0971148
  },
  {
    lng: -41.2115482,
    lat: -22.0969976
  },
  {
    lng: -41.2117344,
    lat: -22.0969388
  },
  {
    lng: -41.2119054,
    lat: -22.0969004
  },
  {
    lng: -41.2121252,
    lat: -22.0969129
  },
  {
    lng: -41.2122491,
    lat: -22.0969481
  },
  {
    lng: -41.212509,
    lat: -22.0970438
  },
  {
    lng: -41.212747,
    lat: -22.0971046
  },
  {
    lng: -41.2129301,
    lat: -22.097122
  },
  {
    lng: -41.2131262,
    lat: -22.0971004
  },
  {
    lng: -41.2131417,
    lat: -22.0970962
  },
  {
    lng: -41.2134714,
    lat: -22.0968962
  },
  {
    lng: -41.2136834,
    lat: -22.0967936
  },
  {
    lng: -41.2138473,
    lat: -22.0967806
  },
  {
    lng: -41.214005,
    lat: -22.0968131
  },
  {
    lng: -41.2143506,
    lat: -22.0969103
  },
  {
    lng: -41.2145325,
    lat: -22.0968709
  },
  {
    lng: -41.2147255,
    lat: -22.0967667
  },
  {
    lng: -41.2148726,
    lat: -22.0966857
  },
  {
    lng: -41.2149941,
    lat: -22.0966788
  },
  {
    lng: -41.2150023,
    lat: -22.0966783
  },
  {
    lng: -41.2151345,
    lat: -22.0967503
  },
  {
    lng: -41.2153341,
    lat: -22.0969412
  },
  {
    lng: -41.2154719,
    lat: -22.0970572
  },
  {
    lng: -41.2155858,
    lat: -22.0971463
  },
  {
    lng: -41.2156784,
    lat: -22.0972556
  },
  {
    lng: -41.2158218,
    lat: -22.0975039
  },
  {
    lng: -41.2159102,
    lat: -22.0976945
  },
  {
    lng: -41.2160221,
    lat: -22.0979542
  },
  {
    lng: -41.216193,
    lat: -22.0981885
  },
  {
    lng: -41.2162808,
    lat: -22.0982774
  },
  {
    lng: -41.2164082,
    lat: -22.0983334
  },
  {
    lng: -41.2166895,
    lat: -22.0983824
  },
  {
    lng: -41.2168881,
    lat: -22.0984539
  },
  {
    lng: -41.2170866,
    lat: -22.098548
  },
  {
    lng: -41.2172935,
    lat: -22.0986144
  },
  {
    lng: -41.2173917,
    lat: -22.0986272
  },
  {
    lng: -41.2176537,
    lat: -22.0986201
  },
  {
    lng: -41.2180377,
    lat: -22.09861
  },
  {
    lng: -41.2183296,
    lat: -22.0985926
  },
  {
    lng: -41.2185772,
    lat: -22.098528
  },
  {
    lng: -41.2187307,
    lat: -22.098439
  },
  {
    lng: -41.2189447,
    lat: -22.0982934
  },
  {
    lng: -41.219067,
    lat: -22.0981518
  },
  {
    lng: -41.2191224,
    lat: -22.0980372
  },
  {
    lng: -41.2191782,
    lat: -22.0976745
  },
  {
    lng: -41.2192509,
    lat: -22.0974709
  },
  {
    lng: -41.2192532,
    lat: -22.0973324
  },
  {
    lng: -41.2192088,
    lat: -22.0969815
  },
  {
    lng: -41.2192143,
    lat: -22.096875
  },
  {
    lng: -41.2192457,
    lat: -22.0967446
  },
  {
    lng: -41.2193318,
    lat: -22.0966018
  },
  {
    lng: -41.2194468,
    lat: -22.0965057
  },
  {
    lng: -41.2195742,
    lat: -22.096466
  },
  {
    lng: -41.2197161,
    lat: -22.0964897
  },
  {
    lng: -41.2198277,
    lat: -22.0965691
  },
  {
    lng: -41.219935,
    lat: -22.0966854
  },
  {
    lng: -41.220151,
    lat: -22.0968917
  },
  {
    lng: -41.2203037,
    lat: -22.0970118
  },
  {
    lng: -41.2203981,
    lat: -22.0970432
  },
  {
    lng: -41.2207684,
    lat: -22.0971946
  },
  {
    lng: -41.2210827,
    lat: -22.0972481
  },
  {
    lng: -41.2212156,
    lat: -22.0972421
  },
  {
    lng: -41.2213767,
    lat: -22.0971754
  },
  {
    lng: -41.2214806,
    lat: -22.0970903
  },
  {
    lng: -41.2215452,
    lat: -22.0970036
  },
  {
    lng: -41.2216492,
    lat: -22.0969257
  },
  {
    lng: -41.2217791,
    lat: -22.0968676
  },
  {
    lng: -41.2218662,
    lat: -22.0968692
  },
  {
    lng: -41.2219914,
    lat: -22.0969092
  },
  {
    lng: -41.2221217,
    lat: -22.0969889
  },
  {
    lng: -41.222257,
    lat: -22.0971012
  },
  {
    lng: -41.2223195,
    lat: -22.0972071
  },
  {
    lng: -41.2223929,
    lat: -22.0974682
  },
  {
    lng: -41.2224635,
    lat: -22.0975857
  },
  {
    lng: -41.2225965,
    lat: -22.0977011
  },
  {
    lng: -41.2227506,
    lat: -22.0977467
  },
  {
    lng: -41.2229674,
    lat: -22.0977526
  },
  {
    lng: -41.2233702,
    lat: -22.0977392
  },
  {
    lng: -41.22338,
    lat: -22.0977365
  },
  {
    lng: -41.2234197,
    lat: -22.0977326
  },
  {
    lng: -41.2235056,
    lat: -22.0977241
  },
  {
    lng: -41.2237783,
    lat: -22.0976971
  },
  {
    lng: -41.2238564,
    lat: -22.0976879
  },
  {
    lng: -41.2242693,
    lat: -22.0976162
  },
  {
    lng: -41.2242905,
    lat: -22.0976098
  },
  {
    lng: -41.2246775,
    lat: -22.0974808
  },
  {
    lng: -41.2248315,
    lat: -22.0974156
  },
  {
    lng: -41.2250111,
    lat: -22.0972875
  },
  {
    lng: -41.2250872,
    lat: -22.0971106
  },
  {
    lng: -41.2251484,
    lat: -22.0969727
  },
  {
    lng: -41.225172,
    lat: -22.0969195
  },
  {
    lng: -41.2253001,
    lat: -22.0967791
  },
  {
    lng: -41.2255627,
    lat: -22.0966171
  },
  {
    lng: -41.225941,
    lat: -22.0964642
  },
  {
    lng: -41.2261403,
    lat: -22.0963844
  },
  {
    lng: -41.2263629,
    lat: -22.0962731
  },
  {
    lng: -41.226575,
    lat: -22.0962122
  },
  {
    lng: -41.2268641,
    lat: -22.0961414
  },
  {
    lng: -41.2269581,
    lat: -22.0961058
  },
  {
    lng: -41.2273978,
    lat: -22.0959091
  },
  {
    lng: -41.2276084,
    lat: -22.0957701
  },
  {
    lng: -41.2277458,
    lat: -22.0957299
  },
  {
    lng: -41.2278635,
    lat: -22.0957435
  },
  {
    lng: -41.227947,
    lat: -22.0957188
  },
  {
    lng: -41.2280796,
    lat: -22.0956368
  },
  {
    lng: -41.2282387,
    lat: -22.0955754
  },
  {
    lng: -41.2284224,
    lat: -22.0955517
  },
  {
    lng: -41.2286388,
    lat: -22.0955092
  },
  {
    lng: -41.2287987,
    lat: -22.0954827
  },
  {
    lng: -41.2289783,
    lat: -22.0955073
  },
  {
    lng: -41.2292057,
    lat: -22.0955491
  },
  {
    lng: -41.2296165,
    lat: -22.0956147
  },
  {
    lng: -41.2298274,
    lat: -22.0956445
  },
  {
    lng: -41.2301246,
    lat: -22.0957318
  },
  {
    lng: -41.2303447,
    lat: -22.0957745
  },
  {
    lng: -41.23049,
    lat: -22.0958184
  },
  {
    lng: -41.2306633,
    lat: -22.0958675
  },
  {
    lng: -41.2309048,
    lat: -22.0958858
  },
  {
    lng: -41.2311316,
    lat: -22.0959178
  },
  {
    lng: -41.2313536,
    lat: -22.0959935
  },
  {
    lng: -41.2314855,
    lat: -22.0960562
  },
  {
    lng: -41.2316076,
    lat: -22.0960784
  },
  {
    lng: -41.2317068,
    lat: -22.0960607
  },
  {
    lng: -41.231799,
    lat: -22.0960884
  },
  {
    lng: -41.231978,
    lat: -22.0961652
  },
  {
    lng: -41.23217,
    lat: -22.0962801
  },
  {
    lng: -41.2322151,
    lat: -22.0963023
  },
  {
    lng: -41.2325552,
    lat: -22.096519
  },
  {
    lng: -41.2327382,
    lat: -22.0965865
  },
  {
    lng: -41.2328391,
    lat: -22.0966346
  },
  {
    lng: -41.2331154,
    lat: -22.0968393
  },
  {
    lng: -41.2333111,
    lat: -22.0969604
  },
  {
    lng: -41.2334932,
    lat: -22.0970207
  },
  {
    lng: -41.2337491,
    lat: -22.097122
  },
  {
    lng: -41.2339162,
    lat: -22.0972068
  },
  {
    lng: -41.2340982,
    lat: -22.0972804
  },
  {
    lng: -41.2342272,
    lat: -22.0973199
  },
  {
    lng: -41.2344799,
    lat: -22.0973074
  },
  {
    lng: -41.2345368,
    lat: -22.0973211
  },
  {
    lng: -41.2347891,
    lat: -22.0974781
  },
  {
    lng: -41.2349273,
    lat: -22.0975222
  },
  {
    lng: -41.2349507,
    lat: -22.0975273
  },
  {
    lng: -41.2353199,
    lat: -22.0976501
  },
  {
    lng: -41.2353726,
    lat: -22.097664
  },
  {
    lng: -41.2357778,
    lat: -22.097757
  },
  {
    lng: -41.2359428,
    lat: -22.097811
  },
  {
    lng: -41.2361532,
    lat: -22.0978973
  },
  {
    lng: -41.2364178,
    lat: -22.0979419
  },
  {
    lng: -41.236561,
    lat: -22.097989
  },
  {
    lng: -41.2370428,
    lat: -22.0981819
  },
  {
    lng: -41.2372688,
    lat: -22.0981801
  },
  {
    lng: -41.2375711,
    lat: -22.0981995
  },
  {
    lng: -41.2381139,
    lat: -22.0982623
  },
  {
    lng: -41.2385018,
    lat: -22.0983148
  },
  {
    lng: -41.2389157,
    lat: -22.0983334
  },
  {
    lng: -41.2391023,
    lat: -22.0983538
  },
  {
    lng: -41.2392715,
    lat: -22.0983688
  },
  {
    lng: -41.2393931,
    lat: -22.0984095
  },
  {
    lng: -41.2395572,
    lat: -22.0984196
  },
  {
    lng: -41.2397099,
    lat: -22.0983647
  },
  {
    lng: -41.2398425,
    lat: -22.0983767
  },
  {
    lng: -41.240078,
    lat: -22.0983728
  },
  {
    lng: -41.2402043,
    lat: -22.0983751
  },
  {
    lng: -41.2406451,
    lat: -22.0984495
  },
  {
    lng: -41.2409346,
    lat: -22.0985114
  },
  {
    lng: -41.2412453,
    lat: -22.0985901
  },
  {
    lng: -41.2413675,
    lat: -22.0986377
  },
  {
    lng: -41.241467,
    lat: -22.0986885
  },
  {
    lng: -41.2415924,
    lat: -22.0987269
  },
  {
    lng: -41.2425161,
    lat: -22.0989758
  },
  {
    lng: -41.2428654,
    lat: -22.0991411
  },
  {
    lng: -41.2429542,
    lat: -22.0991828
  },
  {
    lng: -41.2431709,
    lat: -22.0992309
  },
  {
    lng: -41.2433961,
    lat: -22.099269
  },
  {
    lng: -41.2435038,
    lat: -22.0992528
  },
  {
    lng: -41.2435541,
    lat: -22.0992568
  },
  {
    lng: -41.2436304,
    lat: -22.0992538
  },
  {
    lng: -41.2437684,
    lat: -22.0992534
  },
  {
    lng: -41.2438871,
    lat: -22.0992613
  },
  {
    lng: -41.2441067,
    lat: -22.0992416
  },
  {
    lng: -41.244677,
    lat: -22.0991289
  },
  {
    lng: -41.2448765,
    lat: -22.0990701
  },
  {
    lng: -41.2451883,
    lat: -22.0989748
  },
  {
    lng: -41.2455282,
    lat: -22.098893
  },
  {
    lng: -41.2456558,
    lat: -22.0988268
  },
  {
    lng: -41.2456698,
    lat: -22.0988235
  },
  {
    lng: -41.2458831,
    lat: -22.0987733
  },
  {
    lng: -41.246991,
    lat: -22.098458
  },
  {
    lng: -41.248007,
    lat: -22.0981729
  },
  {
    lng: -41.2482765,
    lat: -22.098126
  },
  {
    lng: -41.2484207,
    lat: -22.0980872
  },
  {
    lng: -41.2487733,
    lat: -22.0979829
  },
  {
    lng: -41.25011,
    lat: -22.0975693
  },
  {
    lng: -41.2516566,
    lat: -22.098774
  },
  {
    lng: -41.2531087,
    lat: -22.0991027
  },
  {
    lng: -41.2534076,
    lat: -22.0991703
  },
  {
    lng: -41.2552399,
    lat: -22.0992627
  },
  {
    lng: -41.2572985,
    lat: -22.0989579
  },
  {
    lng: -41.2624213,
    lat: -22.0915201
  },
  {
    lng: -41.2707739,
    lat: -22.0793924
  },
  {
    lng: -41.2708802,
    lat: -22.0792373
  },
  {
    lng: -41.2710304,
    lat: -22.0790193
  },
  {
    lng: -41.2712784,
    lat: -22.0785839
  },
  {
    lng: -41.2713883,
    lat: -22.0783884
  },
  {
    lng: -41.2714142,
    lat: -22.0783466
  },
  {
    lng: -41.2716122,
    lat: -22.0780192
  },
  {
    lng: -41.2716643,
    lat: -22.0779247
  },
  {
    lng: -41.2718619,
    lat: -22.077589
  },
  {
    lng: -41.2719277,
    lat: -22.0774432
  },
  {
    lng: -41.2720163,
    lat: -22.0772516
  },
  {
    lng: -41.2720493,
    lat: -22.0771803
  },
  {
    lng: -41.272139,
    lat: -22.0769693
  },
  {
    lng: -41.2721786,
    lat: -22.0768727
  },
  {
    lng: -41.2722366,
    lat: -22.076731
  },
  {
    lng: -41.2723351,
    lat: -22.0765058
  },
  {
    lng: -41.272391,
    lat: -22.0763732
  },
  {
    lng: -41.272518,
    lat: -22.0761311
  },
  {
    lng: -41.272667,
    lat: -22.0758639
  },
  {
    lng: -41.2728861,
    lat: -22.0753503
  },
  {
    lng: -41.2730554,
    lat: -22.0750007
  },
  {
    lng: -41.2732398,
    lat: -22.0746554
  },
  {
    lng: -41.2734055,
    lat: -22.0743118
  },
  {
    lng: -41.2735654,
    lat: -22.073964
  },
  {
    lng: -41.2737321,
    lat: -22.0736132
  },
  {
    lng: -41.2739106,
    lat: -22.0732143
  },
  {
    lng: -41.2740824,
    lat: -22.0728601
  },
  {
    lng: -41.2741032,
    lat: -22.0728234
  },
  {
    lng: -41.2742747,
    lat: -22.0724902
  },
  {
    lng: -41.2744428,
    lat: -22.0721549
  },
  {
    lng: -41.274604,
    lat: -22.0717967
  },
  {
    lng: -41.2747124,
    lat: -22.0715226
  },
  {
    lng: -41.274779,
    lat: -22.0714006
  },
  {
    lng: -41.2748567,
    lat: -22.0712101
  },
  {
    lng: -41.2750886,
    lat: -22.0707123
  },
  {
    lng: -41.2758026,
    lat: -22.0692614
  },
  {
    lng: -41.276227,
    lat: -22.0684027
  },
  {
    lng: -41.276259,
    lat: -22.0683264
  },
  {
    lng: -41.2764659,
    lat: -22.0678325
  },
  {
    lng: -41.2766127,
    lat: -22.0676
  },
  {
    lng: -41.2766139,
    lat: -22.0675977
  },
  {
    lng: -41.277672,
    lat: -22.0653238
  },
  {
    lng: -41.3100475,
    lat: -22.049387
  },
  {
    lng: -41.3489394,
    lat: -22.0302426
  },
  {
    lng: -41.4066479,
    lat: -22.0018372
  },
  {
    lng: -41.4376289,
    lat: -21.9865853
  },
  {
    lng: -41.4390009,
    lat: -21.9871509
  },
  {
    lng: -41.4393667,
    lat: -21.9872782
  },
  {
    lng: -41.4407745,
    lat: -21.9879024
  },
  {
    lng: -41.4418663,
    lat: -21.9882876
  },
  {
    lng: -41.4422474,
    lat: -21.9883971
  },
  {
    lng: -41.4426285,
    lat: -21.9884812
  },
  {
    lng: -41.443,
    lat: -21.9886068
  },
  {
    lng: -41.4433715,
    lat: -21.9887334
  },
  {
    lng: -41.4437423,
    lat: -21.9888391
  },
  {
    lng: -41.444105,
    lat: -21.9889899
  },
  {
    lng: -41.4448189,
    lat: -21.989291
  },
  {
    lng: -41.4451925,
    lat: -21.9894006
  },
  {
    lng: -41.4455545,
    lat: -21.9895353
  },
  {
    lng: -41.4466324,
    lat: -21.9899334
  },
  {
    lng: -41.4469954,
    lat: -21.9900666
  },
  {
    lng: -41.4473568,
    lat: -21.9902175
  },
  {
    lng: -41.4477062,
    lat: -21.9903743
  },
  {
    lng: -41.448782,
    lat: -21.9908209
  },
  {
    lng: -41.4491506,
    lat: -21.9909566
  },
  {
    lng: -41.449873,
    lat: -21.9912354
  },
  {
    lng: -41.4502535,
    lat: -21.9913768
  },
  {
    lng: -41.4509862,
    lat: -21.9916354
  },
  {
    lng: -41.4513491,
    lat: -21.9917618
  },
  {
    lng: -41.4531949,
    lat: -21.9923962
  },
  {
    lng: -41.4532519,
    lat: -21.9925064
  },
  {
    lng: -41.4532959,
    lat: -21.9924372
  },
  {
    lng: -41.4543709,
    lat: -21.9928737
  },
  {
    lng: -41.4550216,
    lat: -21.9931534
  },
  {
    lng: -41.4553328,
    lat: -21.9932665
  },
  {
    lng: -41.4556904,
    lat: -21.9934093
  },
  {
    lng: -41.456523,
    lat: -21.9936956
  },
  {
    lng: -41.4568877,
    lat: -21.9938243
  },
  {
    lng: -41.4572518,
    lat: -21.9939556
  },
  {
    lng: -41.4573077,
    lat: -21.9939776
  },
  {
    lng: -41.4579724,
    lat: -21.9942388
  },
  {
    lng: -41.4590488,
    lat: -21.9946617
  },
  {
    lng: -41.4590532,
    lat: -21.9946634
  },
  {
    lng: -41.4602177,
    lat: -21.9950984
  },
  {
    lng: -41.4605794,
    lat: -21.9952335
  },
  {
    lng: -41.462299,
    lat: -21.995876
  },
  {
    lng: -41.4634145,
    lat: -21.996307
  },
  {
    lng: -41.463841,
    lat: -21.9964718
  },
  {
    lng: -41.4641054,
    lat: -21.996574
  },
  {
    lng: -41.4644696,
    lat: -21.9967025
  },
  {
    lng: -41.4666711,
    lat: -21.997503
  },
  {
    lng: -41.4668552,
    lat: -21.9975643
  },
  {
    lng: -41.4671406,
    lat: -21.9976005
  },
  {
    lng: -41.4675352,
    lat: -21.9978105
  },
  {
    lng: -41.4689376,
    lat: -21.9983333
  },
  {
    lng: -41.4690396,
    lat: -21.9983713
  },
  {
    lng: -41.4695713,
    lat: -21.9985695
  },
  {
    lng: -41.469794,
    lat: -21.9986503
  },
  {
    lng: -41.4699335,
    lat: -21.9987009
  },
  {
    lng: -41.4717334,
    lat: -21.9993882
  },
  {
    lng: -41.4720994,
    lat: -21.9995119
  },
  {
    lng: -41.4723748,
    lat: -21.9996101
  },
  {
    lng: -41.4739425,
    lat: -22.000169
  },
  {
    lng: -41.4742855,
    lat: -22.0003373
  },
  {
    lng: -41.4746443,
    lat: -22.0004734
  },
  {
    lng: -41.4757128,
    lat: -22.0008688
  },
  {
    lng: -41.4760706,
    lat: -22.0010012
  },
  {
    lng: -41.4767034,
    lat: -22.0012354
  },
  {
    lng: -41.4772219,
    lat: -22.0014842
  },
  {
    lng: -41.4775893,
    lat: -22.0016099
  },
  {
    lng: -41.4786817,
    lat: -22.0020306
  },
  {
    lng: -41.4790474,
    lat: -22.0021643
  },
  {
    lng: -41.4793983,
    lat: -22.0023236
  },
  {
    lng: -41.4815898,
    lat: -22.003146
  },
  {
    lng: -41.482443,
    lat: -22.0034684
  },
  {
    lng: -41.482671,
    lat: -22.0035517
  },
  {
    lng: -41.4830382,
    lat: -22.0036795
  },
  {
    lng: -41.4834026,
    lat: -22.0038079
  },
  {
    lng: -41.4837735,
    lat: -22.0039427
  },
  {
    lng: -41.4841407,
    lat: -22.0040702
  },
  {
    lng: -41.4845156,
    lat: -22.0041949
  },
  {
    lng: -41.4853408,
    lat: -22.0044911
  },
  {
    lng: -41.485595,
    lat: -22.0045824
  },
  {
    lng: -41.4863492,
    lat: -22.0048531
  },
  {
    lng: -41.4870802,
    lat: -22.0051286
  },
  {
    lng: -41.4874466,
    lat: -22.0052616
  },
  {
    lng: -41.48926,
    lat: -22.0059575
  },
  {
    lng: -41.4903173,
    lat: -22.0063388
  },
  {
    lng: -41.4906399,
    lat: -22.0064551
  },
  {
    lng: -41.4929195,
    lat: -22.0072771
  },
  {
    lng: -41.4932875,
    lat: -22.0073951
  },
  {
    lng: -41.4972822,
    lat: -22.0088977
  },
  {
    lng: -41.4987205,
    lat: -22.0094539
  },
  {
    lng: -41.4996786,
    lat: -22.0098244
  },
  {
    lng: -41.5001637,
    lat: -22.010012
  },
  {
    lng: -41.5009071,
    lat: -22.0102995
  },
  {
    lng: -41.5012756,
    lat: -22.0104188
  },
  {
    lng: -41.5019445,
    lat: -22.0106527
  },
  {
    lng: -41.5034827,
    lat: -22.0111905
  },
  {
    lng: -41.504162,
    lat: -22.0114685
  },
  {
    lng: -41.5045131,
    lat: -22.0116339
  },
  {
    lng: -41.5058308,
    lat: -22.0121044
  },
  {
    lng: -41.5061927,
    lat: -22.012243
  },
  {
    lng: -41.5065602,
    lat: -22.012375
  },
  {
    lng: -41.5069221,
    lat: -22.0125222
  },
  {
    lng: -41.5071134,
    lat: -22.0125958
  },
  {
    lng: -41.5074805,
    lat: -22.0127341
  },
  {
    lng: -41.5077222,
    lat: -22.0128478
  },
  {
    lng: -41.507825,
    lat: -22.0128963
  },
  {
    lng: -41.5078336,
    lat: -22.0129003
  },
  {
    lng: -41.5094489,
    lat: -22.0134883
  },
  {
    lng: -41.5095493,
    lat: -22.0135248
  },
  {
    lng: -41.5099212,
    lat: -22.0136368
  },
  {
    lng: -41.5102912,
    lat: -22.01377
  },
  {
    lng: -41.510651,
    lat: -22.0138958
  },
  {
    lng: -41.5117572,
    lat: -22.0142827
  },
  {
    lng: -41.5121305,
    lat: -22.0144105
  },
  {
    lng: -41.5124899,
    lat: -22.0145596
  },
  {
    lng: -41.5131817,
    lat: -22.0147367
  },
  {
    lng: -41.5134948,
    lat: -22.0148563
  },
  {
    lng: -41.5138485,
    lat: -22.0150063
  },
  {
    lng: -41.5142018,
    lat: -22.015171
  },
  {
    lng: -41.5145518,
    lat: -22.0153266
  },
  {
    lng: -41.5147725,
    lat: -22.0154215
  },
  {
    lng: -41.5151234,
    lat: -22.0155752
  },
  {
    lng: -41.5159169,
    lat: -22.0160006
  },
  {
    lng: -41.5163956,
    lat: -22.0162573
  },
  {
    lng: -41.5179889,
    lat: -22.0171745
  },
  {
    lng: -41.5187594,
    lat: -22.0177102
  },
  {
    lng: -41.5191989,
    lat: -22.0180283
  },
  {
    lng: -41.5192887,
    lat: -22.0180933
  },
  {
    lng: -41.5193785,
    lat: -22.0181582
  },
  {
    lng: -41.5196199,
    lat: -22.0183889
  },
  {
    lng: -41.5197082,
    lat: -22.018475
  },
  {
    lng: -41.5197531,
    lat: -22.0185148
  },
  {
    lng: -41.520771,
    lat: -22.0194176
  },
  {
    lng: -41.5209797,
    lat: -22.0196182
  },
  {
    lng: -41.5211697,
    lat: -22.019849
  },
  {
    lng: -41.5219288,
    lat: -22.0206982
  },
  {
    lng: -41.5221638,
    lat: -22.0209963
  },
  {
    lng: -41.5224638,
    lat: -22.0213554
  },
  {
    lng: -41.5226785,
    lat: -22.021661
  },
  {
    lng: -41.5228887,
    lat: -22.0219167
  },
  {
    lng: -41.5231959,
    lat: -22.02237
  },
  {
    lng: -41.5239256,
    lat: -22.0235854
  },
  {
    lng: -41.5252737,
    lat: -22.0257848
  },
  {
    lng: -41.5265134,
    lat: -22.0278072
  },
  {
    lng: -41.5276761,
    lat: -22.0297509
  },
  {
    lng: -41.5300287,
    lat: -22.0336842
  },
  {
    lng: -41.5316809,
    lat: -22.0364723
  },
  {
    lng: -41.5357487,
    lat: -22.0433368
  },
  {
    lng: -41.5363099,
    lat: -22.0442838
  },
  {
    lng: -41.5368632,
    lat: -22.0452174
  },
  {
    lng: -41.5370592,
    lat: -22.0455482
  },
  {
    lng: -41.537502,
    lat: -22.0463125
  },
  {
    lng: -41.5375626,
    lat: -22.0464172
  },
  {
    lng: -41.5383957,
    lat: -22.0478551
  },
  {
    lng: -41.5384334,
    lat: -22.0479257
  },
  {
    lng: -41.5386318,
    lat: -22.0482973
  },
  {
    lng: -41.5389725,
    lat: -22.0489353
  },
  {
    lng: -41.5395492,
    lat: -22.0500155
  },
  {
    lng: -41.5400984,
    lat: -22.0507113
  },
  {
    lng: -41.5407982,
    lat: -22.0514918
  },
  {
    lng: -41.5410505,
    lat: -22.0517732
  },
  {
    lng: -41.5418378,
    lat: -22.0524872
  },
  {
    lng: -41.5421343,
    lat: -22.0527324
  },
  {
    lng: -41.5429135,
    lat: -22.0533764
  },
  {
    lng: -41.5447122,
    lat: -22.054373
  },
  {
    lng: -41.5463234,
    lat: -22.0549955
  },
  {
    lng: -41.5463334,
    lat: -22.0549977
  },
  {
    lng: -41.5477881,
    lat: -22.055325
  },
  {
    lng: -41.5490147,
    lat: -22.0554715
  },
  {
    lng: -41.550278,
    lat: -22.0554898
  },
  {
    lng: -41.5503365,
    lat: -22.0554877
  },
  {
    lng: -41.5512667,
    lat: -22.0554532
  },
  {
    lng: -41.5530793,
    lat: -22.0551237
  },
  {
    lng: -41.5532442,
    lat: -22.0550904
  },
  {
    lng: -41.5537938,
    lat: -22.0549794
  },
  {
    lng: -41.5539926,
    lat: -22.0549393
  },
  {
    lng: -41.5550749,
    lat: -22.0547209
  },
  {
    lng: -41.5550834,
    lat: -22.0547186
  },
  {
    lng: -41.5550919,
    lat: -22.0547163
  },
  {
    lng: -41.5559885,
    lat: -22.0544731
  },
  {
    lng: -41.5562359,
    lat: -22.054406
  },
  {
    lng: -41.5567347,
    lat: -22.0542708
  },
  {
    lng: -41.5573455,
    lat: -22.053931
  },
  {
    lng: -41.5575962,
    lat: -22.0539666
  },
  {
    lng: -41.5578738,
    lat: -22.0540167
  },
  {
    lng: -41.5581282,
    lat: -22.0541004
  },
  {
    lng: -41.5582776,
    lat: -22.0541085
  },
  {
    lng: -41.5584007,
    lat: -22.0540876
  },
  {
    lng: -41.5586146,
    lat: -22.0540415
  },
  {
    lng: -41.558739,
    lat: -22.0540033
  },
  {
    lng: -41.5590637,
    lat: -22.0539208
  },
  {
    lng: -41.5595089,
    lat: -22.0538565
  },
  {
    lng: -41.5599415,
    lat: -22.0536161
  },
  {
    lng: -41.5599873,
    lat: -22.0535585
  },
  {
    lng: -41.5601214,
    lat: -22.0535016
  },
  {
    lng: -41.5602985,
    lat: -22.0534712
  },
  {
    lng: -41.5604661,
    lat: -22.0534479
  },
  {
    lng: -41.56062,
    lat: -22.0534187
  },
  {
    lng: -41.560761,
    lat: -22.0534369
  },
  {
    lng: -41.5608065,
    lat: -22.053439
  },
  {
    lng: -41.5612983,
    lat: -22.0534609
  },
  {
    lng: -41.5618085,
    lat: -22.0534261
  },
  {
    lng: -41.5619632,
    lat: -22.0534088
  },
  {
    lng: -41.5620334,
    lat: -22.0533819
  },
  {
    lng: -41.5621359,
    lat: -22.0533501
  },
  {
    lng: -41.5625283,
    lat: -22.0532545
  },
  {
    lng: -41.5629734,
    lat: -22.0531919
  },
  {
    lng: -41.563034,
    lat: -22.0531578
  },
  {
    lng: -41.5635109,
    lat: -22.0530282
  },
  {
    lng: -41.5636649,
    lat: -22.0530026
  },
  {
    lng: -41.5639425,
    lat: -22.0529795
  },
  {
    lng: -41.5642905,
    lat: -22.0529036
  },
  {
    lng: -41.564333,
    lat: -22.0528874
  },
  {
    lng: -41.5644359,
    lat: -22.0528703
  },
  {
    lng: -41.5645192,
    lat: -22.0528564
  },
  {
    lng: -41.5648858,
    lat: -22.0527764
  },
  {
    lng: -41.565208,
    lat: -22.0527185
  },
  {
    lng: -41.5655887,
    lat: -22.0526805
  },
  {
    lng: -41.5656712,
    lat: -22.0526782
  },
  {
    lng: -41.5658516,
    lat: -22.0526441
  },
  {
    lng: -41.5661158,
    lat: -22.0525651
  },
  {
    lng: -41.5661944,
    lat: -22.0525412
  },
  {
    lng: -41.5664645,
    lat: -22.0524339
  },
  {
    lng: -41.5666009,
    lat: -22.0524196
  },
  {
    lng: -41.5671144,
    lat: -22.0523207
  },
  {
    lng: -41.5676184,
    lat: -22.0522129
  },
  {
    lng: -41.5677928,
    lat: -22.052216
  },
  {
    lng: -41.5686759,
    lat: -22.0520802
  },
  {
    lng: -41.5688671,
    lat: -22.0520364
  },
  {
    lng: -41.5697427,
    lat: -22.0518537
  },
  {
    lng: -41.5700196,
    lat: -22.0517064
  },
  {
    lng: -41.5701058,
    lat: -22.0516636
  },
  {
    lng: -41.5703286,
    lat: -22.0515898
  },
  {
    lng: -41.5708966,
    lat: -22.0514519
  },
  {
    lng: -41.5712632,
    lat: -22.051358
  },
  {
    lng: -41.5714825,
    lat: -22.0513018
  },
  {
    lng: -41.5717862,
    lat: -22.0512486
  },
  {
    lng: -41.5720324,
    lat: -22.0512108
  },
  {
    lng: -41.57246,
    lat: -22.0511468
  },
  {
    lng: -41.5727184,
    lat: -22.0511296
  },
  {
    lng: -41.5728676,
    lat: -22.0511099
  },
  {
    lng: -41.5730595,
    lat: -22.051089
  },
  {
    lng: -41.5735691,
    lat: -22.0510268
  },
  {
    lng: -41.5737513,
    lat: -22.0510547
  },
  {
    lng: -41.5739728,
    lat: -22.0510615
  },
  {
    lng: -41.5744287,
    lat: -22.0511673
  },
  {
    lng: -41.5745204,
    lat: -22.0511897
  },
  {
    lng: -41.5749163,
    lat: -22.0512189
  },
  {
    lng: -41.5754015,
    lat: -22.0511694
  },
  {
    lng: -41.5755254,
    lat: -22.0511749
  },
  {
    lng: -41.5762049,
    lat: -22.0512544
  },
  {
    lng: -41.5764632,
    lat: -22.0512757
  },
  {
    lng: -41.5780189,
    lat: -22.051521
  },
  {
    lng: -41.5780835,
    lat: -22.0515246
  },
  {
    lng: -41.5782727,
    lat: -22.051535
  },
  {
    lng: -41.5784562,
    lat: -22.0515406
  },
  {
    lng: -41.5785718,
    lat: -22.0515474
  },
  {
    lng: -41.5789122,
    lat: -22.0515723
  },
  {
    lng: -41.5791354,
    lat: -22.0515498
  },
  {
    lng: -41.5793397,
    lat: -22.0515601
  },
  {
    lng: -41.5795071,
    lat: -22.0515747
  },
  {
    lng: -41.5796336,
    lat: -22.0515272
  },
  {
    lng: -41.5801242,
    lat: -22.0514536
  },
  {
    lng: -41.5803916,
    lat: -22.0514731
  },
  {
    lng: -41.580745,
    lat: -22.0514209
  },
  {
    lng: -41.5809599,
    lat: -22.0513394
  },
  {
    lng: -41.5809961,
    lat: -22.0513086
  },
  {
    lng: -41.5813375,
    lat: -22.0512187
  },
  {
    lng: -41.581466,
    lat: -22.0511802
  },
  {
    lng: -41.5815553,
    lat: -22.0511562
  },
  {
    lng: -41.5817161,
    lat: -22.0511365
  },
  {
    lng: -41.5818276,
    lat: -22.0511088
  },
  {
    lng: -41.5818301,
    lat: -22.0511083
  },
  {
    lng: -41.5819947,
    lat: -22.0510721
  },
  {
    lng: -41.5821922,
    lat: -22.0510322
  },
  {
    lng: -41.5824351,
    lat: -22.0509909
  },
  {
    lng: -41.582592,
    lat: -22.0509525
  },
  {
    lng: -41.5827517,
    lat: -22.0509069
  },
  {
    lng: -41.5829065,
    lat: -22.0508626
  },
  {
    lng: -41.5837628,
    lat: -22.0506686
  },
  {
    lng: -41.5840659,
    lat: -22.0505574
  },
  {
    lng: -41.5843631,
    lat: -22.0504254
  },
  {
    lng: -41.5849194,
    lat: -22.0503083
  },
  {
    lng: -41.5852695,
    lat: -22.050193
  },
  {
    lng: -41.5855765,
    lat: -22.0500475
  },
  {
    lng: -41.5857083,
    lat: -22.0500007
  },
  {
    lng: -41.585822,
    lat: -22.0499587
  },
  {
    lng: -41.5862593,
    lat: -22.0498579
  },
  {
    lng: -41.5864435,
    lat: -22.049799
  },
  {
    lng: -41.5866064,
    lat: -22.049722
  },
  {
    lng: -41.5867046,
    lat: -22.0496638
  },
  {
    lng: -41.5869669,
    lat: -22.0494888
  },
  {
    lng: -41.5870746,
    lat: -22.0494159
  },
  {
    lng: -41.5873202,
    lat: -22.0492505
  },
  {
    lng: -41.587389,
    lat: -22.0492187
  },
  {
    lng: -41.5874885,
    lat: -22.0491743
  },
  {
    lng: -41.5878355,
    lat: -22.0490469
  },
  {
    lng: -41.5879718,
    lat: -22.0489917
  },
  {
    lng: -41.5881579,
    lat: -22.0489286
  },
  {
    lng: -41.5886742,
    lat: -22.0487447
  },
  {
    lng: -41.588941,
    lat: -22.048677
  },
  {
    lng: -41.5891722,
    lat: -22.0485916
  },
  {
    lng: -41.5893809,
    lat: -22.0485238
  },
  {
    lng: -41.5895412,
    lat: -22.0484673
  },
  {
    lng: -41.5897311,
    lat: -22.0484175
  },
  {
    lng: -41.5899288,
    lat: -22.0483731
  },
  {
    lng: -41.5901427,
    lat: -22.0483323
  },
  {
    lng: -41.5903701,
    lat: -22.0482965
  },
  {
    lng: -41.5903824,
    lat: -22.0482946
  },
  {
    lng: -41.5904456,
    lat: -22.0482747
  },
  {
    lng: -41.5905626,
    lat: -22.0482176
  },
  {
    lng: -41.5905832,
    lat: -22.0482109
  },
  {
    lng: -41.5907429,
    lat: -22.0481588
  },
  {
    lng: -41.5908759,
    lat: -22.0481071
  },
  {
    lng: -41.5909859,
    lat: -22.0480612
  },
  {
    lng: -41.591068,
    lat: -22.048038
  },
  {
    lng: -41.5912354,
    lat: -22.0479906
  },
  {
    lng: -41.5916211,
    lat: -22.0479235
  },
  {
    lng: -41.591648,
    lat: -22.0479174
  },
  {
    lng: -41.5919956,
    lat: -22.0478384
  },
  {
    lng: -41.5920068,
    lat: -22.0478359
  },
  {
    lng: -41.5921443,
    lat: -22.0477661
  },
  {
    lng: -41.5926034,
    lat: -22.0475351
  },
  {
    lng: -41.5927678,
    lat: -22.0475213
  },
  {
    lng: -41.5929642,
    lat: -22.047477
  },
  {
    lng: -41.5932183,
    lat: -22.0474501
  },
  {
    lng: -41.5934502,
    lat: -22.0473905
  },
  {
    lng: -41.5936125,
    lat: -22.0473509
  },
  {
    lng: -41.5938301,
    lat: -22.0472849
  },
  {
    lng: -41.59397,
    lat: -22.0472999
  },
  {
    lng: -41.5939762,
    lat: -22.0473002
  },
  {
    lng: -41.594218,
    lat: -22.0473105
  },
  {
    lng: -41.5948381,
    lat: -22.0472447
  },
  {
    lng: -41.595225,
    lat: -22.0471968
  },
  {
    lng: -41.5956081,
    lat: -22.0471217
  },
  {
    lng: -41.595993,
    lat: -22.047081
  },
  {
    lng: -41.5963816,
    lat: -22.0470721
  },
  {
    lng: -41.597167,
    lat: -22.0471096
  },
  {
    lng: -41.597486,
    lat: -22.0471208
  },
  {
    lng: -41.5982956,
    lat: -22.0472094
  },
  {
    lng: -41.5987509,
    lat: -22.0472951
  },
  {
    lng: -41.5987612,
    lat: -22.0472987
  },
  {
    lng: -41.5990942,
    lat: -22.0473636
  },
  {
    lng: -41.5994342,
    lat: -22.0474326
  },
  {
    lng: -41.5994723,
    lat: -22.047442
  },
  {
    lng: -41.5996312,
    lat: -22.0474813
  },
  {
    lng: -41.6000117,
    lat: -22.0475522
  },
  {
    lng: -41.6008488,
    lat: -22.0477521
  },
  {
    lng: -41.6008571,
    lat: -22.0477539
  },
  {
    lng: -41.6009383,
    lat: -22.0477602
  },
  {
    lng: -41.6010381,
    lat: -22.0477732
  },
  {
    lng: -41.6010851,
    lat: -22.0477763
  },
  {
    lng: -41.6013351,
    lat: -22.0478042
  },
  {
    lng: -41.6018497,
    lat: -22.0478828
  },
  {
    lng: -41.6024047,
    lat: -22.0480067
  },
  {
    lng: -41.602509,
    lat: -22.048034
  },
  {
    lng: -41.6025844,
    lat: -22.0480396
  },
  {
    lng: -41.6027846,
    lat: -22.0480824
  },
  {
    lng: -41.6028394,
    lat: -22.048094
  },
  {
    lng: -41.6034662,
    lat: -22.0481423
  },
  {
    lng: -41.6034899,
    lat: -22.0481432
  },
  {
    lng: -41.6037478,
    lat: -22.0481523
  },
  {
    lng: -41.6040756,
    lat: -22.048199
  },
  {
    lng: -41.6043229,
    lat: -22.0482257
  },
  {
    lng: -41.6047483,
    lat: -22.0482511
  },
  {
    lng: -41.6057009,
    lat: -22.0482038
  },
  {
    lng: -41.6057338,
    lat: -22.0482015
  },
  {
    lng: -41.6065877,
    lat: -22.0480055
  },
  {
    lng: -41.6069382,
    lat: -22.0479008
  },
  {
    lng: -41.6072161,
    lat: -22.0478178
  },
  {
    lng: -41.6077073,
    lat: -22.0477797
  },
  {
    lng: -41.6082026,
    lat: -22.0476978
  },
  {
    lng: -41.6085005,
    lat: -22.0476261
  },
  {
    lng: -41.6088424,
    lat: -22.0475371
  },
  {
    lng: -41.6088979,
    lat: -22.0475187
  },
  {
    lng: -41.6093081,
    lat: -22.0474305
  },
  {
    lng: -41.6094222,
    lat: -22.0474123
  },
  {
    lng: -41.609789,
    lat: -22.0473924
  },
  {
    lng: -41.6100405,
    lat: -22.0473266
  },
  {
    lng: -41.6104038,
    lat: -22.0472202
  },
  {
    lng: -41.6105127,
    lat: -22.0472151
  },
  {
    lng: -41.6106851,
    lat: -22.0471737
  },
  {
    lng: -41.6112615,
    lat: -22.0470753
  },
  {
    lng: -41.6114441,
    lat: -22.0470369
  },
  {
    lng: -41.6116491,
    lat: -22.0469991
  },
  {
    lng: -41.6121451,
    lat: -22.0469028
  },
  {
    lng: -41.6122567,
    lat: -22.0468689
  },
  {
    lng: -41.6127941,
    lat: -22.046721
  },
  {
    lng: -41.6132461,
    lat: -22.0466402
  },
  {
    lng: -41.613301,
    lat: -22.046623
  },
  {
    lng: -41.6133318,
    lat: -22.0466225
  },
  {
    lng: -41.6134035,
    lat: -22.0466017
  },
  {
    lng: -41.6135943,
    lat: -22.0465705
  },
  {
    lng: -41.6136827,
    lat: -22.0465635
  },
  {
    lng: -41.6137707,
    lat: -22.0465484
  },
  {
    lng: -41.6138129,
    lat: -22.0465411
  },
  {
    lng: -41.6138703,
    lat: -22.0465209
  },
  {
    lng: -41.6144096,
    lat: -22.0463869
  },
  {
    lng: -41.6145591,
    lat: -22.0463573
  },
  {
    lng: -41.6150172,
    lat: -22.0462351
  },
  {
    lng: -41.6151423,
    lat: -22.0462006
  },
  {
    lng: -41.6152746,
    lat: -22.0461584
  },
  {
    lng: -41.6154138,
    lat: -22.0461426
  },
  {
    lng: -41.6156516,
    lat: -22.0461242
  },
  {
    lng: -41.6159734,
    lat: -22.0460898
  },
  {
    lng: -41.6162708,
    lat: -22.0460754
  },
  {
    lng: -41.6166507,
    lat: -22.0459865
  },
  {
    lng: -41.616662,
    lat: -22.045979
  },
  {
    lng: -41.6169726,
    lat: -22.0459418
  },
  {
    lng: -41.6173593,
    lat: -22.0459454
  },
  {
    lng: -41.6174619,
    lat: -22.0459306
  },
  {
    lng: -41.6178188,
    lat: -22.045969
  },
  {
    lng: -41.6179272,
    lat: -22.0460078
  },
  {
    lng: -41.6183097,
    lat: -22.0461019
  },
  {
    lng: -41.6186086,
    lat: -22.0461844
  },
  {
    lng: -41.6186858,
    lat: -22.0462057
  },
  {
    lng: -41.6190612,
    lat: -22.0463027
  },
  {
    lng: -41.6194424,
    lat: -22.0464298
  },
  {
    lng: -41.6198217,
    lat: -22.0465335
  },
  {
    lng: -41.6201665,
    lat: -22.0466937
  },
  {
    lng: -41.6205336,
    lat: -22.0468147
  },
  {
    lng: -41.620896,
    lat: -22.0469587
  },
  {
    lng: -41.6212583,
    lat: -22.0471158
  },
  {
    lng: -41.6212973,
    lat: -22.0471293
  },
  {
    lng: -41.6216285,
    lat: -22.0472435
  },
  {
    lng: -41.6219845,
    lat: -22.047388
  },
  {
    lng: -41.6223593,
    lat: -22.0474977
  },
  {
    lng: -41.6227333,
    lat: -22.0476206
  },
  {
    lng: -41.6230996,
    lat: -22.0477585
  },
  {
    lng: -41.6234697,
    lat: -22.047897
  },
  {
    lng: -41.6238477,
    lat: -22.0480289
  },
  {
    lng: -41.624069,
    lat: -22.0481097
  },
  {
    lng: -41.6242172,
    lat: -22.0481638
  },
  {
    lng: -41.6245738,
    lat: -22.0483083
  },
  {
    lng: -41.6249349,
    lat: -22.0484402
  },
  {
    lng: -41.6249485,
    lat: -22.0484426
  },
  {
    lng: -41.6251307,
    lat: -22.0485008
  },
  {
    lng: -41.625396,
    lat: -22.0485873
  },
  {
    lng: -41.6257636,
    lat: -22.0487103
  },
  {
    lng: -41.6261267,
    lat: -22.0488433
  },
  {
    lng: -41.6262749,
    lat: -22.0488683
  },
  {
    lng: -41.6265446,
    lat: -22.0489411
  },
  {
    lng: -41.6267548,
    lat: -22.0490121
  },
  {
    lng: -41.6268518,
    lat: -22.0490449
  },
  {
    lng: -41.6269116,
    lat: -22.0490651
  },
  {
    lng: -41.6272489,
    lat: -22.0492222
  },
  {
    lng: -41.6276106,
    lat: -22.0493859
  },
  {
    lng: -41.6276415,
    lat: -22.0493938
  },
  {
    lng: -41.6279936,
    lat: -22.0495612
  },
  {
    lng: -41.6280554,
    lat: -22.0495883
  },
  {
    lng: -41.6288044,
    lat: -22.0497241
  },
  {
    lng: -41.6288462,
    lat: -22.0497553
  },
  {
    lng: -41.6289209,
    lat: -22.0497939
  },
  {
    lng: -41.6291303,
    lat: -22.0498576
  },
  {
    lng: -41.6292897,
    lat: -22.0499093
  },
  {
    lng: -41.6296362,
    lat: -22.0500565
  },
  {
    lng: -41.6298134,
    lat: -22.0500794
  },
  {
    lng: -41.6301151,
    lat: -22.0501078
  },
  {
    lng: -41.6302698,
    lat: -22.0501259
  },
  {
    lng: -41.6305039,
    lat: -22.0501529
  },
  {
    lng: -41.6306785,
    lat: -22.0501751
  },
  {
    lng: -41.6309302,
    lat: -22.0501849
  },
  {
    lng: -41.6313067,
    lat: -22.050229
  },
  {
    lng: -41.6313466,
    lat: -22.0502297
  },
  {
    lng: -41.631636,
    lat: -22.0502509
  },
  {
    lng: -41.6318407,
    lat: -22.0503145
  },
  {
    lng: -41.6318832,
    lat: -22.0503392
  },
  {
    lng: -41.6321906,
    lat: -22.0503939
  },
  {
    lng: -41.6322691,
    lat: -22.0504032
  },
  {
    lng: -41.6326653,
    lat: -22.0504276
  },
  {
    lng: -41.6328651,
    lat: -22.0504276
  },
  {
    lng: -41.6331965,
    lat: -22.0503364
  },
  {
    lng: -41.6333384,
    lat: -22.0503266
  },
  {
    lng: -41.6337282,
    lat: -22.050345
  },
  {
    lng: -41.6337727,
    lat: -22.0503577
  },
  {
    lng: -41.6339962,
    lat: -22.0504117
  },
  {
    lng: -41.6341817,
    lat: -22.0504392
  },
  {
    lng: -41.6343969,
    lat: -22.0504837
  },
  {
    lng: -41.6345597,
    lat: -22.0505428
  },
  {
    lng: -41.6346903,
    lat: -22.0505434
  },
  {
    lng: -41.6350393,
    lat: -22.0505341
  },
  {
    lng: -41.6354419,
    lat: -22.0505847
  },
  {
    lng: -41.6358271,
    lat: -22.0506457
  },
  {
    lng: -41.6361261,
    lat: -22.0506536
  },
  {
    lng: -41.6365191,
    lat: -22.0507045
  },
  {
    lng: -41.636905,
    lat: -22.0507391
  },
  {
    lng: -41.6373039,
    lat: -22.0507508
  },
  {
    lng: -41.6376373,
    lat: -22.0507433
  },
  {
    lng: -41.6378523,
    lat: -22.0507651
  },
  {
    lng: -41.6382492,
    lat: -22.0508189
  },
  {
    lng: -41.6383472,
    lat: -22.0508063
  },
  {
    lng: -41.6387402,
    lat: -22.0508054
  },
  {
    lng: -41.6390142,
    lat: -22.0507803
  },
  {
    lng: -41.6391122,
    lat: -22.0507763
  },
  {
    lng: -41.6392012,
    lat: -22.0507699
  },
  {
    lng: -41.6393191,
    lat: -22.0507864
  },
  {
    lng: -41.6393686,
    lat: -22.0507962
  },
  {
    lng: -41.6395425,
    lat: -22.0508392
  },
  {
    lng: -41.6398789,
    lat: -22.0508436
  },
  {
    lng: -41.6401617,
    lat: -22.050859
  },
  {
    lng: -41.6405065,
    lat: -22.050889
  },
  {
    lng: -41.6410478,
    lat: -22.050909
  },
  {
    lng: -41.6414499,
    lat: -22.050904
  },
  {
    lng: -41.6418661,
    lat: -22.0509296
  },
  {
    lng: -41.6422077,
    lat: -22.0509368
  },
  {
    lng: -41.6426207,
    lat: -22.0509747
  },
  {
    lng: -41.643004,
    lat: -22.0510303
  },
  {
    lng: -41.6434086,
    lat: -22.0510445
  },
  {
    lng: -41.643812,
    lat: -22.051091
  },
  {
    lng: -41.6441946,
    lat: -22.0511551
  },
  {
    lng: -41.6445941,
    lat: -22.0511831
  },
  {
    lng: -41.6449802,
    lat: -22.0511492
  },
  {
    lng: -41.6451491,
    lat: -22.0511746
  },
  {
    lng: -41.6453901,
    lat: -22.051201
  },
  {
    lng: -41.6455967,
    lat: -22.0512245
  },
  {
    lng: -41.6459853,
    lat: -22.0512537
  },
  {
    lng: -41.646176,
    lat: -22.0512745
  },
  {
    lng: -41.6465631,
    lat: -22.0513362
  },
  {
    lng: -41.646949,
    lat: -22.051402
  },
  {
    lng: -41.647338,
    lat: -22.051457
  },
  {
    lng: -41.6477103,
    lat: -22.0515277
  },
  {
    lng: -41.6480662,
    lat: -22.0516715
  },
  {
    lng: -41.6483076,
    lat: -22.0517448
  },
  {
    lng: -41.6486701,
    lat: -22.0518748
  },
  {
    lng: -41.6490462,
    lat: -22.0519916
  },
  {
    lng: -41.6491697,
    lat: -22.0520512
  },
  {
    lng: -41.6493957,
    lat: -22.0521601
  },
  {
    lng: -41.6497439,
    lat: -22.0523237
  },
  {
    lng: -41.6498623,
    lat: -22.0523745
  },
  {
    lng: -41.6500893,
    lat: -22.0524416
  },
  {
    lng: -41.6502031,
    lat: -22.0524753
  },
  {
    lng: -41.6506202,
    lat: -22.0525901
  },
  {
    lng: -41.6509873,
    lat: -22.0527093
  },
  {
    lng: -41.6512608,
    lat: -22.052823
  },
  {
    lng: -41.6517142,
    lat: -22.052964
  },
  {
    lng: -41.6520206,
    lat: -22.0530759
  },
  {
    lng: -41.6525757,
    lat: -22.0532495
  },
  {
    lng: -41.6528497,
    lat: -22.0533443
  },
  {
    lng: -41.6529913,
    lat: -22.0534061
  },
  {
    lng: -41.6532346,
    lat: -22.0534809
  },
  {
    lng: -41.6535993,
    lat: -22.0535897
  },
  {
    lng: -41.6538288,
    lat: -22.0536769
  },
  {
    lng: -41.6540251,
    lat: -22.0537879
  },
  {
    lng: -41.654976,
    lat: -22.0541356
  },
  {
    lng: -41.6560857,
    lat: -22.0545413
  },
  {
    lng: -41.656814,
    lat: -22.0547759
  },
  {
    lng: -41.6571298,
    lat: -22.0548975
  },
  {
    lng: -41.657244,
    lat: -22.0549428
  },
  {
    lng: -41.6573152,
    lat: -22.0549716
  },
  {
    lng: -41.6574756,
    lat: -22.0550294
  },
  {
    lng: -41.6575372,
    lat: -22.0550478
  },
  {
    lng: -41.6576439,
    lat: -22.0550717
  },
  {
    lng: -41.6576952,
    lat: -22.0550954
  },
  {
    lng: -41.6578318,
    lat: -22.0551812
  },
  {
    lng: -41.6579991,
    lat: -22.0552812
  },
  {
    lng: -41.6583899,
    lat: -22.0553798
  },
  {
    lng: -41.659204,
    lat: -22.0556661
  },
  {
    lng: -41.6594558,
    lat: -22.0557362
  },
  {
    lng: -41.6596997,
    lat: -22.0558275
  },
  {
    lng: -41.6601306,
    lat: -22.0559825
  },
  {
    lng: -41.6605762,
    lat: -22.0561506
  },
  {
    lng: -41.6609347,
    lat: -22.0562499
  },
  {
    lng: -41.6613228,
    lat: -22.0563864
  },
  {
    lng: -41.661755,
    lat: -22.0565189
  },
  {
    lng: -41.6621328,
    lat: -22.056654
  },
  {
    lng: -41.6624532,
    lat: -22.0567866
  },
  {
    lng: -41.6626957,
    lat: -22.0568866
  },
  {
    lng: -41.6629878,
    lat: -22.0570072
  },
  {
    lng: -41.6635481,
    lat: -22.0571879
  },
  {
    lng: -41.6637581,
    lat: -22.0572495
  },
  {
    lng: -41.6639854,
    lat: -22.0572812
  },
  {
    lng: -41.6645772,
    lat: -22.0573619
  },
  {
    lng: -41.6648102,
    lat: -22.0573678
  },
  {
    lng: -41.6651512,
    lat: -22.0573219
  },
  {
    lng: -41.6658496,
    lat: -22.0571804
  },
  {
    lng: -41.6663418,
    lat: -22.0570892
  },
  {
    lng: -41.6668483,
    lat: -22.0569935
  },
  {
    lng: -41.6673065,
    lat: -22.0569124
  },
  {
    lng: -41.6675199,
    lat: -22.0569014
  },
  {
    lng: -41.6676103,
    lat: -22.0569034
  },
  {
    lng: -41.6676142,
    lat: -22.0569035
  },
  {
    lng: -41.6676481,
    lat: -22.0568988
  },
  {
    lng: -41.6677462,
    lat: -22.056885
  },
  {
    lng: -41.6684953,
    lat: -22.0567575
  },
  {
    lng: -41.6687778,
    lat: -22.0566957
  },
  {
    lng: -41.6693948,
    lat: -22.0565992
  },
  {
    lng: -41.6699583,
    lat: -22.0564893
  },
  {
    lng: -41.6704711,
    lat: -22.0564044
  },
  {
    lng: -41.6713968,
    lat: -22.0562229
  },
  {
    lng: -41.6724284,
    lat: -22.0560341
  },
  {
    lng: -41.6727037,
    lat: -22.0559782
  },
  {
    lng: -41.6730951,
    lat: -22.0558909
  },
  {
    lng: -41.6733131,
    lat: -22.0558702
  },
  {
    lng: -41.6735064,
    lat: -22.0558517
  },
  {
    lng: -41.6736683,
    lat: -22.0557888
  },
  {
    lng: -41.6738549,
    lat: -22.0557372
  },
  {
    lng: -41.6740345,
    lat: -22.0557052
  },
  {
    lng: -41.6743283,
    lat: -22.0556183
  },
  {
    lng: -41.6746206,
    lat: -22.0555749
  },
  {
    lng: -41.6746515,
    lat: -22.0555703
  },
  {
    lng: -41.6751051,
    lat: -22.0554899
  },
  {
    lng: -41.6754921,
    lat: -22.0554426
  },
  {
    lng: -41.6755953,
    lat: -22.0554258
  },
  {
    lng: -41.6761159,
    lat: -22.0553442
  },
  {
    lng: -41.6765745,
    lat: -22.0552481
  },
  {
    lng: -41.6768326,
    lat: -22.0551947
  },
  {
    lng: -41.6773422,
    lat: -22.0551029
  },
  {
    lng: -41.6775048,
    lat: -22.0550946
  },
  {
    lng: -41.6776158,
    lat: -22.0550934
  },
  {
    lng: -41.6782008,
    lat: -22.0549932
  },
  {
    lng: -41.6782918,
    lat: -22.0549691
  },
  {
    lng: -41.6794039,
    lat: -22.05475
  },
  {
    lng: -41.6798207,
    lat: -22.0546846
  },
  {
    lng: -41.6798865,
    lat: -22.0546762
  },
  {
    lng: -41.6801897,
    lat: -22.0546505
  },
  {
    lng: -41.6803909,
    lat: -22.0545784
  },
  {
    lng: -41.6805503,
    lat: -22.0544997
  },
  {
    lng: -41.6806722,
    lat: -22.054445
  },
  {
    lng: -41.6809574,
    lat: -22.0543098
  },
  {
    lng: -41.6810696,
    lat: -22.0542606
  },
  {
    lng: -41.681147,
    lat: -22.0542336
  },
  {
    lng: -41.6815289,
    lat: -22.0541206
  },
  {
    lng: -41.6817186,
    lat: -22.0540834
  },
  {
    lng: -41.6818527,
    lat: -22.0540762
  },
  {
    lng: -41.6819895,
    lat: -22.0540642
  },
  {
    lng: -41.6820205,
    lat: -22.0540642
  },
  {
    lng: -41.6822469,
    lat: -22.0540204
  },
  {
    lng: -41.6823733,
    lat: -22.054003
  },
  {
    lng: -41.6825139,
    lat: -22.0540205
  },
  {
    lng: -41.6825997,
    lat: -22.0540223
  },
  {
    lng: -41.6829003,
    lat: -22.0540044
  },
  {
    lng: -41.6832093,
    lat: -22.0539732
  },
  {
    lng: -41.6832889,
    lat: -22.0539556
  },
  {
    lng: -41.6835603,
    lat: -22.0538957
  },
  {
    lng: -41.6836544,
    lat: -22.0538712
  },
  {
    lng: -41.6837921,
    lat: -22.0538304
  },
  {
    lng: -41.6841357,
    lat: -22.0537287
  },
  {
    lng: -41.6845479,
    lat: -22.053624
  },
  {
    lng: -41.6846389,
    lat: -22.0536009
  },
  {
    lng: -41.6848925,
    lat: -22.05353
  },
  {
    lng: -41.6853201,
    lat: -22.0534664
  },
  {
    lng: -41.6856738,
    lat: -22.0533999
  },
  {
    lng: -41.6858277,
    lat: -22.0533709
  },
  {
    lng: -41.6862077,
    lat: -22.0533133
  },
  {
    lng: -41.6867303,
    lat: -22.0532323
  },
  {
    lng: -41.6871746,
    lat: -22.0531398
  },
  {
    lng: -41.6876488,
    lat: -22.0530383
  },
  {
    lng: -41.6881874,
    lat: -22.0529303
  },
  {
    lng: -41.6893305,
    lat: -22.0527411
  },
  {
    lng: -41.6898691,
    lat: -22.0526565
  },
  {
    lng: -41.6907251,
    lat: -22.0525233
  },
  {
    lng: -41.6913289,
    lat: -22.0524164
  },
  {
    lng: -41.691425,
    lat: -22.0523918
  },
  {
    lng: -41.6915218,
    lat: -22.0523564
  },
  {
    lng: -41.6916637,
    lat: -22.0523179
  },
  {
    lng: -41.6919752,
    lat: -22.0522657
  },
  {
    lng: -41.692185,
    lat: -22.0522592
  },
  {
    lng: -41.692292,
    lat: -22.0522561
  },
  {
    lng: -41.6925339,
    lat: -22.0522027
  },
  {
    lng: -41.6930216,
    lat: -22.0521132
  },
  {
    lng: -41.6932661,
    lat: -22.0520442
  },
  {
    lng: -41.6936912,
    lat: -22.0519577
  },
  {
    lng: -41.6938169,
    lat: -22.0519312
  },
  {
    lng: -41.6939788,
    lat: -22.0518994
  },
  {
    lng: -41.6940401,
    lat: -22.0518874
  },
  {
    lng: -41.6942446,
    lat: -22.0518809
  },
  {
    lng: -41.694362,
    lat: -22.0518604
  },
  {
    lng: -41.6946858,
    lat: -22.0518377
  },
  {
    lng: -41.6948729,
    lat: -22.0517939
  },
  {
    lng: -41.6949967,
    lat: -22.0517524
  },
  {
    lng: -41.6953315,
    lat: -22.0516707
  },
  {
    lng: -41.6955541,
    lat: -22.0516485
  },
  {
    lng: -41.6958204,
    lat: -22.0516558
  },
  {
    lng: -41.696112,
    lat: -22.0516811
  },
  {
    lng: -41.6964732,
    lat: -22.0517206
  },
  {
    lng: -41.6965635,
    lat: -22.0517305
  },
  {
    lng: -41.6968009,
    lat: -22.0517053
  },
  {
    lng: -41.6974982,
    lat: -22.0515348
  },
  {
    lng: -41.6978787,
    lat: -22.0514735
  },
  {
    lng: -41.6980381,
    lat: -22.0514621
  },
  {
    lng: -41.6981729,
    lat: -22.0514717
  },
  {
    lng: -41.6983405,
    lat: -22.0515247
  },
  {
    lng: -41.6985036,
    lat: -22.0515448
  },
  {
    lng: -41.6985979,
    lat: -22.051544
  },
  {
    lng: -41.698917,
    lat: -22.0515514
  },
  {
    lng: -41.6991895,
    lat: -22.0514564
  },
  {
    lng: -41.6993519,
    lat: -22.0513644
  },
  {
    lng: -41.6995116,
    lat: -22.051238
  },
  {
    lng: -41.6997175,
    lat: -22.0512341
  },
  {
    lng: -41.7000066,
    lat: -22.0512104
  },
  {
    lng: -41.700372,
    lat: -22.0513487
  },
  {
    lng: -41.7008684,
    lat: -22.0513402
  },
  {
    lng: -41.7011119,
    lat: -22.0512316
  },
  {
    lng: -41.701309,
    lat: -22.0511668
  },
  {
    lng: -41.7014504,
    lat: -22.0511275
  },
  {
    lng: -41.7017062,
    lat: -22.0511169
  },
  {
    lng: -41.7018294,
    lat: -22.0511232
  },
  {
    lng: -41.7020499,
    lat: -22.0511849
  },
  {
    lng: -41.7020987,
    lat: -22.0511985
  },
  {
    lng: -41.7021764,
    lat: -22.0512222
  },
  {
    lng: -41.7027816,
    lat: -22.0514068
  },
  {
    lng: -41.7032266,
    lat: -22.0516085
  },
  {
    lng: -41.7036135,
    lat: -22.0518184
  },
  {
    lng: -41.7038262,
    lat: -22.0520325
  },
  {
    lng: -41.7041022,
    lat: -22.0522173
  },
  {
    lng: -41.7044308,
    lat: -22.0523152
  },
  {
    lng: -41.7045057,
    lat: -22.0523124
  },
  {
    lng: -41.7046339,
    lat: -22.0523561
  },
  {
    lng: -41.7048644,
    lat: -22.0524687
  },
  {
    lng: -41.7048854,
    lat: -22.0524881
  },
  {
    lng: -41.7050329,
    lat: -22.052625
  },
  {
    lng: -41.7051023,
    lat: -22.0526901
  },
  {
    lng: -41.705394,
    lat: -22.0529929
  },
  {
    lng: -41.7057031,
    lat: -22.0533371
  },
  {
    lng: -41.7060311,
    lat: -22.0535985
  },
  {
    lng: -41.7061763,
    lat: -22.0537421
  },
  {
    lng: -41.7065381,
    lat: -22.0539387
  },
  {
    lng: -41.7066611,
    lat: -22.0540034
  },
  {
    lng: -41.7068549,
    lat: -22.0540918
  },
  {
    lng: -41.7074114,
    lat: -22.0545072
  },
  {
    lng: -41.707961,
    lat: -22.0550098
  },
  {
    lng: -41.7079625,
    lat: -22.0550108
  },
  {
    lng: -41.7081386,
    lat: -22.0551354
  },
  {
    lng: -41.7084051,
    lat: -22.0552835
  },
  {
    lng: -41.7087698,
    lat: -22.0555902
  },
  {
    lng: -41.7092143,
    lat: -22.0559271
  },
  {
    lng: -41.7093301,
    lat: -22.056008
  },
  {
    lng: -41.7095621,
    lat: -22.0560779
  },
  {
    lng: -41.7097337,
    lat: -22.0562781
  },
  {
    lng: -41.7097426,
    lat: -22.0562979
  },
  {
    lng: -41.709767,
    lat: -22.0563106
  },
  {
    lng: -41.709904,
    lat: -22.0564079
  },
  {
    lng: -41.7099953,
    lat: -22.0565049
  },
  {
    lng: -41.710088,
    lat: -22.0565581
  },
  {
    lng: -41.7102322,
    lat: -22.0566452
  },
  {
    lng: -41.7103107,
    lat: -22.0566899
  },
  {
    lng: -41.7104594,
    lat: -22.0567908
  },
  {
    lng: -41.7106486,
    lat: -22.0568978
  },
  {
    lng: -41.7108018,
    lat: -22.056979
  },
  {
    lng: -41.7108198,
    lat: -22.0569923
  },
  {
    lng: -41.710868,
    lat: -22.0570279
  },
  {
    lng: -41.7110312,
    lat: -22.0571293
  },
  {
    lng: -41.7112242,
    lat: -22.0572142
  },
  {
    lng: -41.7113355,
    lat: -22.0572728
  },
  {
    lng: -41.7114433,
    lat: -22.0573399
  },
  {
    lng: -41.7115922,
    lat: -22.0573794
  },
  {
    lng: -41.7117624,
    lat: -22.0574422
  },
  {
    lng: -41.7121101,
    lat: -22.0575668
  },
  {
    lng: -41.7122339,
    lat: -22.0575876
  },
  {
    lng: -41.7124748,
    lat: -22.0576357
  },
  {
    lng: -41.7126037,
    lat: -22.0576629
  },
  {
    lng: -41.7131275,
    lat: -22.0577051
  },
  {
    lng: -41.7131834,
    lat: -22.0577592
  },
  {
    lng: -41.7133174,
    lat: -22.0578137
  },
  {
    lng: -41.7134548,
    lat: -22.0579054
  },
  {
    lng: -41.7135191,
    lat: -22.057959
  },
  {
    lng: -41.713575,
    lat: -22.0580586
  },
  {
    lng: -41.7137206,
    lat: -22.0580997
  },
  {
    lng: -41.7139107,
    lat: -22.0581417
  },
  {
    lng: -41.7139945,
    lat: -22.0581686
  },
  {
    lng: -41.7140881,
    lat: -22.0581617
  },
  {
    lng: -41.7141288,
    lat: -22.0581365
  },
  {
    lng: -41.7144282,
    lat: -22.0581064
  },
  {
    lng: -41.7147525,
    lat: -22.0581797
  },
  {
    lng: -41.7149382,
    lat: -22.0582349
  },
  {
    lng: -41.7151054,
    lat: -22.0583212
  },
  {
    lng: -41.7155334,
    lat: -22.0585774
  },
  {
    lng: -41.7157815,
    lat: -22.0586661
  },
  {
    lng: -41.7161039,
    lat: -22.0588584
  },
  {
    lng: -41.7163906,
    lat: -22.0590499
  },
  {
    lng: -41.7164762,
    lat: -22.0591133
  },
  {
    lng: -41.7165616,
    lat: -22.0591686
  },
  {
    lng: -41.7168124,
    lat: -22.0594117
  },
  {
    lng: -41.7170559,
    lat: -22.0596592
  },
  {
    lng: -41.7172897,
    lat: -22.0599191
  },
  {
    lng: -41.7174034,
    lat: -22.059969
  },
  {
    lng: -41.7175093,
    lat: -22.0600602
  },
  {
    lng: -41.7175553,
    lat: -22.0601006
  },
  {
    lng: -41.7176975,
    lat: -22.0602374
  },
  {
    lng: -41.7178028,
    lat: -22.0602797
  },
  {
    lng: -41.7178629,
    lat: -22.0603368
  },
  {
    lng: -41.7180273,
    lat: -22.0605231
  },
  {
    lng: -41.7181675,
    lat: -22.0606018
  },
  {
    lng: -41.7183032,
    lat: -22.0607525
  },
  {
    lng: -41.7183835,
    lat: -22.0608951
  },
  {
    lng: -41.7184633,
    lat: -22.0609741
  },
  {
    lng: -41.7185697,
    lat: -22.0611096
  },
  {
    lng: -41.7186232,
    lat: -22.0611778
  },
  {
    lng: -41.7186791,
    lat: -22.0612327
  },
  {
    lng: -41.7190404,
    lat: -22.0615489
  },
  {
    lng: -41.7192495,
    lat: -22.061722
  },
  {
    lng: -41.719328,
    lat: -22.0618012
  },
  {
    lng: -41.7194874,
    lat: -22.0619454
  },
  {
    lng: -41.7196109,
    lat: -22.0620584
  },
  {
    lng: -41.7197638,
    lat: -22.0621927
  },
  {
    lng: -41.7199907,
    lat: -22.0624038
  },
  {
    lng: -41.7201595,
    lat: -22.0626076
  },
  {
    lng: -41.7204018,
    lat: -22.0628316
  },
  {
    lng: -41.7206386,
    lat: -22.0630122
  },
  {
    lng: -41.7207169,
    lat: -22.0630699
  },
  {
    lng: -41.7207844,
    lat: -22.0631098
  },
  {
    lng: -41.720863,
    lat: -22.0631735
  },
  {
    lng: -41.7209005,
    lat: -22.0632079
  },
  {
    lng: -41.721164,
    lat: -22.0634498
  },
  {
    lng: -41.7217732,
    lat: -22.0640856
  },
  {
    lng: -41.7219768,
    lat: -22.0642981
  },
  {
    lng: -41.7219853,
    lat: -22.0643069
  },
  {
    lng: -41.7222665,
    lat: -22.0645725
  },
  {
    lng: -41.7222734,
    lat: -22.0645789
  },
  {
    lng: -41.7224085,
    lat: -22.0647065
  },
  {
    lng: -41.7224932,
    lat: -22.0647865
  },
  {
    lng: -41.7225181,
    lat: -22.0648108
  },
  {
    lng: -41.7225544,
    lat: -22.0648462
  },
  {
    lng: -41.7226002,
    lat: -22.0648964
  },
  {
    lng: -41.7226134,
    lat: -22.0649108
  },
  {
    lng: -41.7226338,
    lat: -22.0649248
  },
  {
    lng: -41.7227236,
    lat: -22.0649862
  },
  {
    lng: -41.7227307,
    lat: -22.0649911
  },
  {
    lng: -41.7227771,
    lat: -22.0650379
  },
  {
    lng: -41.7229003,
    lat: -22.0651623
  },
  {
    lng: -41.7235077,
    lat: -22.0657107
  },
  {
    lng: -41.7239546,
    lat: -22.0661024
  },
  {
    lng: -41.7241649,
    lat: -22.0662974
  },
  {
    lng: -41.7259312,
    lat: -22.0679344
  },
  {
    lng: -41.726006,
    lat: -22.0679986
  },
  {
    lng: -41.7260207,
    lat: -22.0680128
  },
  {
    lng: -41.7260499,
    lat: -22.068041
  },
  {
    lng: -41.7261783,
    lat: -22.0681858
  },
  {
    lng: -41.7267441,
    lat: -22.0686814
  },
  {
    lng: -41.7269914,
    lat: -22.0688839
  },
  {
    lng: -41.7271178,
    lat: -22.0690414
  },
  {
    lng: -41.7271701,
    lat: -22.0691126
  },
  {
    lng: -41.7272791,
    lat: -22.0691969
  },
  {
    lng: -41.7274224,
    lat: -22.0693674
  },
  {
    lng: -41.7274709,
    lat: -22.0694123
  },
  {
    lng: -41.7275806,
    lat: -22.0694805
  },
  {
    lng: -41.7277959,
    lat: -22.0696536
  },
  {
    lng: -41.7282032,
    lat: -22.0700831
  },
  {
    lng: -41.7284465,
    lat: -22.0703032
  },
  {
    lng: -41.7287276,
    lat: -22.0705605
  },
  {
    lng: -41.7289233,
    lat: -22.0707396
  },
  {
    lng: -41.7291672,
    lat: -22.0709675
  },
  {
    lng: -41.7292786,
    lat: -22.0710191
  },
  {
    lng: -41.7295774,
    lat: -22.0713026
  },
  {
    lng: -41.7296406,
    lat: -22.0713652
  },
  {
    lng: -41.7297286,
    lat: -22.0715009
  },
  {
    lng: -41.7298777,
    lat: -22.0716336
  },
  {
    lng: -41.7299667,
    lat: -22.0716963
  },
  {
    lng: -41.7302122,
    lat: -22.0719511
  },
  {
    lng: -41.7303125,
    lat: -22.0720641
  },
  {
    lng: -41.7304533,
    lat: -22.072155
  },
  {
    lng: -41.7305634,
    lat: -22.0722357
  },
  {
    lng: -41.7307072,
    lat: -22.0723325
  },
  {
    lng: -41.7307643,
    lat: -22.072389
  },
  {
    lng: -41.7308982,
    lat: -22.0725213
  },
  {
    lng: -41.7311602,
    lat: -22.0727804
  },
  {
    lng: -41.7313372,
    lat: -22.0729406
  },
  {
    lng: -41.7313563,
    lat: -22.0729672
  },
  {
    lng: -41.7314193,
    lat: -22.073055
  },
  {
    lng: -41.7315014,
    lat: -22.0731695
  },
  {
    lng: -41.731723,
    lat: -22.0734189
  },
  {
    lng: -41.7319359,
    lat: -22.0736209
  },
  {
    lng: -41.7320047,
    lat: -22.0736862
  },
  {
    lng: -41.7322729,
    lat: -22.0739402
  },
  {
    lng: -41.7323624,
    lat: -22.0740339
  },
  {
    lng: -41.7324989,
    lat: -22.0741698
  },
  {
    lng: -41.7325449,
    lat: -22.074213
  },
  {
    lng: -41.7326606,
    lat: -22.0743216
  },
  {
    lng: -41.7327652,
    lat: -22.074418
  },
  {
    lng: -41.7328815,
    lat: -22.0745339
  },
  {
    lng: -41.7329628,
    lat: -22.07462
  },
  {
    lng: -41.7330454,
    lat: -22.0747049
  },
  {
    lng: -41.7331,
    lat: -22.0747736
  },
  {
    lng: -41.7332453,
    lat: -22.0749696
  },
  {
    lng: -41.7333807,
    lat: -22.0751239
  },
  {
    lng: -41.7334794,
    lat: -22.07522
  },
  {
    lng: -41.7335537,
    lat: -22.0752949
  },
  {
    lng: -41.733659,
    lat: -22.0753914
  },
  {
    lng: -41.7338461,
    lat: -22.0755573
  },
  {
    lng: -41.7340133,
    lat: -22.0756985
  },
  {
    lng: -41.7340717,
    lat: -22.0757664
  },
  {
    lng: -41.7341539,
    lat: -22.0758592
  },
  {
    lng: -41.7341862,
    lat: -22.0758818
  },
  {
    lng: -41.7342916,
    lat: -22.0759888
  },
  {
    lng: -41.7343924,
    lat: -22.0761138
  },
  {
    lng: -41.734618,
    lat: -22.0763582
  },
  {
    lng: -41.7348612,
    lat: -22.0766644
  },
  {
    lng: -41.7350465,
    lat: -22.0769144
  },
  {
    lng: -41.7351585,
    lat: -22.0770528
  },
  {
    lng: -41.7352361,
    lat: -22.0771327
  },
  {
    lng: -41.7353728,
    lat: -22.0773185
  },
  {
    lng: -41.7353886,
    lat: -22.0773397
  },
  {
    lng: -41.7355661,
    lat: -22.0776612
  },
  {
    lng: -41.7356073,
    lat: -22.0777782
  },
  {
    lng: -41.7356724,
    lat: -22.0779421
  },
  {
    lng: -41.7357202,
    lat: -22.0780583
  },
  {
    lng: -41.7357388,
    lat: -22.0781558
  },
  {
    lng: -41.7357701,
    lat: -22.0782762
  },
  {
    lng: -41.7358207,
    lat: -22.0785303
  },
  {
    lng: -41.7358507,
    lat: -22.0786447
  },
  {
    lng: -41.7358664,
    lat: -22.0786799
  },
  {
    lng: -41.7358968,
    lat: -22.0787483
  },
  {
    lng: -41.7359205,
    lat: -22.0788322
  },
  {
    lng: -41.7359603,
    lat: -22.0791145
  },
  {
    lng: -41.7359839,
    lat: -22.0791944
  },
  {
    lng: -41.7360282,
    lat: -22.0792629
  },
  {
    lng: -41.7361401,
    lat: -22.079408
  },
  {
    lng: -41.7362816,
    lat: -22.0796254
  },
  {
    lng: -41.7364554,
    lat: -22.079849
  },
  {
    lng: -41.7365447,
    lat: -22.0799325
  },
  {
    lng: -41.7366477,
    lat: -22.0800285
  },
  {
    lng: -41.7367486,
    lat: -22.0801431
  },
  {
    lng: -41.7368286,
    lat: -22.0802394
  },
  {
    lng: -41.7368985,
    lat: -22.0803455
  },
  {
    lng: -41.7369821,
    lat: -22.0805025
  },
  {
    lng: -41.7370278,
    lat: -22.0805962
  },
  {
    lng: -41.7370514,
    lat: -22.0807052
  },
  {
    lng: -41.7370752,
    lat: -22.0808444
  },
  {
    lng: -41.7371181,
    lat: -22.0817227
  },
  {
    lng: -41.7371456,
    lat: -22.0821513
  },
  {
    lng: -41.7370944,
    lat: -22.0823733
  },
  {
    lng: -41.7370719,
    lat: -22.0824709
  },
  {
    lng: -41.7369854,
    lat: -22.0826851
  },
  {
    lng: -41.7369711,
    lat: -22.083024
  },
  {
    lng: -41.7369479,
    lat: -22.0832867
  },
  {
    lng: -41.7371399,
    lat: -22.0836416
  },
  {
    lng: -41.7372505,
    lat: -22.0838712
  },
  {
    lng: -41.7372797,
    lat: -22.0839759
  },
  {
    lng: -41.7373545,
    lat: -22.0843147
  },
  {
    lng: -41.737366,
    lat: -22.0843671
  },
  {
    lng: -41.7374193,
    lat: -22.0844494
  },
  {
    lng: -41.7378798,
    lat: -22.0848046
  },
  {
    lng: -41.7379864,
    lat: -22.0848851
  },
  {
    lng: -41.7385249,
    lat: -22.0852587
  },
  {
    lng: -41.7390652,
    lat: -22.0856081
  },
  {
    lng: -41.7396093,
    lat: -22.0860493
  },
  {
    lng: -41.7397445,
    lat: -22.0861373
  },
  {
    lng: -41.7401175,
    lat: -22.0864353
  },
  {
    lng: -41.7402791,
    lat: -22.0865317
  },
  {
    lng: -41.7402875,
    lat: -22.0865367
  },
  {
    lng: -41.740382,
    lat: -22.0865608
  },
  {
    lng: -41.7404349,
    lat: -22.0865676
  },
  {
    lng: -41.74083,
    lat: -22.0866188
  },
  {
    lng: -41.741004,
    lat: -22.0866288
  },
  {
    lng: -41.7411575,
    lat: -22.0866216
  },
  {
    lng: -41.7415555,
    lat: -22.0865753
  },
  {
    lng: -41.7422011,
    lat: -22.0865416
  },
  {
    lng: -41.7423598,
    lat: -22.0865314
  },
  {
    lng: -41.742537,
    lat: -22.0865153
  },
  {
    lng: -41.7430835,
    lat: -22.0864753
  },
  {
    lng: -41.7431884,
    lat: -22.086447
  },
  {
    lng: -41.7434407,
    lat: -22.0863788
  },
  {
    lng: -41.7436845,
    lat: -22.0863274
  },
  {
    lng: -41.743794,
    lat: -22.0863344
  },
  {
    lng: -41.7440572,
    lat: -22.0863266
  },
  {
    lng: -41.7444487,
    lat: -22.0862582
  },
  {
    lng: -41.7448536,
    lat: -22.0862391
  },
  {
    lng: -41.745211,
    lat: -22.0862765
  },
  {
    lng: -41.7453405,
    lat: -22.0862824
  },
  {
    lng: -41.745677,
    lat: -22.0862641
  },
  {
    lng: -41.7457893,
    lat: -22.0862574
  },
  {
    lng: -41.7459525,
    lat: -22.0862349
  },
  {
    lng: -41.7461225,
    lat: -22.0861779
  },
  {
    lng: -41.7462262,
    lat: -22.0861755
  },
  {
    lng: -41.7463691,
    lat: -22.0861657
  },
  {
    lng: -41.7464797,
    lat: -22.0861382
  },
  {
    lng: -41.746606,
    lat: -22.0861214
  },
  {
    lng: -41.7467671,
    lat: -22.0860929
  },
  {
    lng: -41.7470057,
    lat: -22.08609
  },
  {
    lng: -41.7471134,
    lat: -22.0861028
  },
  {
    lng: -41.7473132,
    lat: -22.0861264
  },
  {
    lng: -41.7476616,
    lat: -22.0861729
  },
  {
    lng: -41.7480144,
    lat: -22.0861926
  },
  {
    lng: -41.7482106,
    lat: -22.0862111
  },
  {
    lng: -41.7483619,
    lat: -22.0862348
  },
  {
    lng: -41.7485528,
    lat: -22.0862129
  },
  {
    lng: -41.7487772,
    lat: -22.0862196
  },
  {
    lng: -41.7488697,
    lat: -22.0862212
  },
  {
    lng: -41.7489632,
    lat: -22.0862136
  },
  {
    lng: -41.7490878,
    lat: -22.0861924
  },
  {
    lng: -41.7491426,
    lat: -22.0861965
  },
  {
    lng: -41.7492304,
    lat: -22.0861877
  },
  {
    lng: -41.7494467,
    lat: -22.0862615
  },
  {
    lng: -41.7496665,
    lat: -22.0863834
  },
  {
    lng: -41.7498032,
    lat: -22.0864094
  },
  {
    lng: -41.7499666,
    lat: -22.0864189
  },
  {
    lng: -41.7503198,
    lat: -22.0864202
  },
  {
    lng: -41.7503921,
    lat: -22.0864077
  },
  {
    lng: -41.7504535,
    lat: -22.0863971
  },
  {
    lng: -41.7505392,
    lat: -22.0863099
  },
  {
    lng: -41.750588,
    lat: -22.0862603
  },
  {
    lng: -41.7506212,
    lat: -22.0862186
  },
  {
    lng: -41.7506285,
    lat: -22.086161
  },
  {
    lng: -41.7506587,
    lat: -22.0861041
  },
  {
    lng: -41.7507238,
    lat: -22.0860568
  },
  {
    lng: -41.7508277,
    lat: -22.085952
  },
  {
    lng: -41.7508808,
    lat: -22.0858839
  },
  {
    lng: -41.7509507,
    lat: -22.0858018
  },
  {
    lng: -41.7510106,
    lat: -22.0857076
  },
  {
    lng: -41.7510986,
    lat: -22.0855758
  },
  {
    lng: -41.7511493,
    lat: -22.0855217
  },
  {
    lng: -41.7512262,
    lat: -22.0854542
  },
  {
    lng: -41.751321,
    lat: -22.0853542
  },
  {
    lng: -41.7515648,
    lat: -22.085262
  },
  {
    lng: -41.7519194,
    lat: -22.0851286
  },
  {
    lng: -41.7520107,
    lat: -22.0850601
  },
  {
    lng: -41.7520977,
    lat: -22.0849678
  },
  {
    lng: -41.7522389,
    lat: -22.0848193
  },
  {
    lng: -41.75236,
    lat: -22.0846517
  },
  {
    lng: -41.7523701,
    lat: -22.0846336
  },
  {
    lng: -41.7525955,
    lat: -22.0843165
  },
  {
    lng: -41.7526214,
    lat: -22.0842912
  },
  {
    lng: -41.7527288,
    lat: -22.0841863
  },
  {
    lng: -41.7527715,
    lat: -22.0841171
  },
  {
    lng: -41.7529778,
    lat: -22.0838098
  },
  {
    lng: -41.7532194,
    lat: -22.0834732
  },
  {
    lng: -41.7533622,
    lat: -22.0832693
  },
  {
    lng: -41.7534551,
    lat: -22.0831269
  },
  {
    lng: -41.7536872,
    lat: -22.0828245
  },
  {
    lng: -41.7538789,
    lat: -22.0825339
  },
  {
    lng: -41.7539289,
    lat: -22.0824554
  },
  {
    lng: -41.7539992,
    lat: -22.0823944
  },
  {
    lng: -41.754152,
    lat: -22.0821087
  },
  {
    lng: -41.7542227,
    lat: -22.0820292
  },
  {
    lng: -41.7543083,
    lat: -22.0819724
  },
  {
    lng: -41.7543694,
    lat: -22.0818705
  },
  {
    lng: -41.7544241,
    lat: -22.0818115
  },
  {
    lng: -41.7545058,
    lat: -22.0817818
  },
  {
    lng: -41.7545121,
    lat: -22.0817335
  },
  {
    lng: -41.7545366,
    lat: -22.0814651
  },
  {
    lng: -41.7545371,
    lat: -22.0814479
  },
  {
    lng: -41.7544859,
    lat: -22.0810728
  },
  {
    lng: -41.7544887,
    lat: -22.0809209
  },
  {
    lng: -41.7544735,
    lat: -22.0808039
  },
  {
    lng: -41.7544403,
    lat: -22.0806796
  },
  {
    lng: -41.7544295,
    lat: -22.0805677
  },
  {
    lng: -41.7544574,
    lat: -22.0805112
  },
  {
    lng: -41.7545063,
    lat: -22.0804766
  },
  {
    lng: -41.7545119,
    lat: -22.0804298
  },
  {
    lng: -41.7544796,
    lat: -22.0803893
  },
  {
    lng: -41.7544724,
    lat: -22.0803269
  },
  {
    lng: -41.7544502,
    lat: -22.0801668
  },
  {
    lng: -41.754439,
    lat: -22.0801117
  },
  {
    lng: -41.754409,
    lat: -22.0800684
  },
  {
    lng: -41.7543361,
    lat: -22.0800175
  },
  {
    lng: -41.7542946,
    lat: -22.0799385
  },
  {
    lng: -41.7541973,
    lat: -22.079847
  },
  {
    lng: -41.7541491,
    lat: -22.0797593
  },
  {
    lng: -41.7540665,
    lat: -22.0796039
  },
  {
    lng: -41.7539521,
    lat: -22.0794452
  },
  {
    lng: -41.753896,
    lat: -22.079335
  },
  {
    lng: -41.7538366,
    lat: -22.079178
  },
  {
    lng: -41.7536664,
    lat: -22.0788923
  },
  {
    lng: -41.7534932,
    lat: -22.0786628
  },
  {
    lng: -41.7533768,
    lat: -22.0785237
  },
  {
    lng: -41.753351,
    lat: -22.0784243
  },
  {
    lng: -41.7533565,
    lat: -22.0782265
  },
  {
    lng: -41.7533778,
    lat: -22.0781356
  },
  {
    lng: -41.7533975,
    lat: -22.0780624
  },
  {
    lng: -41.7533835,
    lat: -22.0779707
  },
  {
    lng: -41.7533375,
    lat: -22.0778287
  },
  {
    lng: -41.7532634,
    lat: -22.0777565
  },
  {
    lng: -41.7532352,
    lat: -22.0776893
  },
  {
    lng: -41.7532309,
    lat: -22.0775018
  },
  {
    lng: -41.7532656,
    lat: -22.0774214
  },
  {
    lng: -41.7532896,
    lat: -22.0773167
  },
  {
    lng: -41.7532853,
    lat: -22.0772284
  },
  {
    lng: -41.7533178,
    lat: -22.0771641
  },
  {
    lng: -41.7533833,
    lat: -22.0771506
  },
  {
    lng: -41.753428,
    lat: -22.0771963
  },
  {
    lng: -41.7534764,
    lat: -22.077325
  },
  {
    lng: -41.7535504,
    lat: -22.0773729
  },
  {
    lng: -41.7536144,
    lat: -22.077335
  },
  {
    lng: -41.7536329,
    lat: -22.0772543
  },
  {
    lng: -41.7537289,
    lat: -22.0769675
  },
  {
    lng: -41.7537767,
    lat: -22.0769052
  },
  {
    lng: -41.753845,
    lat: -22.0768321
  },
  {
    lng: -41.7538559,
    lat: -22.0767687
  },
  {
    lng: -41.7538996,
    lat: -22.0765686
  },
  {
    lng: -41.7539275,
    lat: -22.0764844
  },
  {
    lng: -41.7539201,
    lat: -22.0763951
  },
  {
    lng: -41.7539471,
    lat: -22.0763053
  },
  {
    lng: -41.7539537,
    lat: -22.0761987
  },
  {
    lng: -41.7540142,
    lat: -22.0760124
  },
  {
    lng: -41.7541038,
    lat: -22.0758592
  },
  {
    lng: -41.7541779,
    lat: -22.0757714
  },
  {
    lng: -41.7542723,
    lat: -22.0756975
  },
  {
    lng: -41.754365,
    lat: -22.0756063
  },
  {
    lng: -41.7544071,
    lat: -22.0755273
  },
  {
    lng: -41.7543897,
    lat: -22.0754699
  },
  {
    lng: -41.7542861,
    lat: -22.0754397
  },
  {
    lng: -41.7542113,
    lat: -22.0754031
  },
  {
    lng: -41.7541676,
    lat: -22.0753267
  },
  {
    lng: -41.7541278,
    lat: -22.0752112
  },
  {
    lng: -41.7540571,
    lat: -22.0749876
  },
  {
    lng: -41.7540748,
    lat: -22.0748744
  },
  {
    lng: -41.7541289,
    lat: -22.0748019
  },
  {
    lng: -41.7542202,
    lat: -22.0747426
  },
  {
    lng: -41.7543499,
    lat: -22.0746222
  },
  {
    lng: -41.7544542,
    lat: -22.0745708
  },
  {
    lng: -41.7545083,
    lat: -22.0745554
  },
  {
    lng: -41.7546163,
    lat: -22.0745247
  },
  {
    lng: -41.7547356,
    lat: -22.0743633
  },
  {
    lng: -41.7548426,
    lat: -22.0741959
  },
  {
    lng: -41.7549298,
    lat: -22.0741183
  },
  {
    lng: -41.7549517,
    lat: -22.0740208
  },
  {
    lng: -41.7549109,
    lat: -22.0739278
  },
  {
    lng: -41.7548702,
    lat: -22.073785
  },
  {
    lng: -41.7548679,
    lat: -22.0736818
  },
  {
    lng: -41.7548816,
    lat: -22.0735096
  },
  {
    lng: -41.7548549,
    lat: -22.0734138
  },
  {
    lng: -41.7548073,
    lat: -22.0733486
  },
  {
    lng: -41.7547346,
    lat: -22.0732186
  },
  {
    lng: -41.7546505,
    lat: -22.0730581
  },
  {
    lng: -41.7546725,
    lat: -22.0729295
  },
  {
    lng: -41.7546968,
    lat: -22.0728585
  },
  {
    lng: -41.7547879,
    lat: -22.0728027
  },
  {
    lng: -41.7547871,
    lat: -22.072781
  },
  {
    lng: -41.7547644,
    lat: -22.0727235
  },
  {
    lng: -41.7547431,
    lat: -22.0727026
  },
  {
    lng: -41.7547422,
    lat: -22.0727008
  },
  {
    lng: -41.7546913,
    lat: -22.0725996
  },
  {
    lng: -41.7546757,
    lat: -22.0725577
  },
  {
    lng: -41.7546465,
    lat: -22.0724713
  },
  {
    lng: -41.7545769,
    lat: -22.0722401
  },
  {
    lng: -41.7545895,
    lat: -22.0721392
  },
  {
    lng: -41.7545159,
    lat: -22.0720896
  },
  {
    lng: -41.7545242,
    lat: -22.0720477
  },
  {
    lng: -41.7545394,
    lat: -22.0719792
  },
  {
    lng: -41.7544767,
    lat: -22.0718864
  },
  {
    lng: -41.754316,
    lat: -22.0719282
  },
  {
    lng: -41.7542156,
    lat: -22.0719189
  },
  {
    lng: -41.7541768,
    lat: -22.0718884
  },
  {
    lng: -41.7541798,
    lat: -22.0718111
  },
  {
    lng: -41.7542474,
    lat: -22.0716129
  },
  {
    lng: -41.754357,
    lat: -22.071449
  },
  {
    lng: -41.7544543,
    lat: -22.0713035
  },
  {
    lng: -41.7544947,
    lat: -22.0712038
  },
  {
    lng: -41.7545948,
    lat: -22.0709564
  },
  {
    lng: -41.7547281,
    lat: -22.0706022
  },
  {
    lng: -41.7548308,
    lat: -22.0703134
  },
  {
    lng: -41.7549139,
    lat: -22.070129
  },
  {
    lng: -41.7549751,
    lat: -22.0699615
  },
  {
    lng: -41.7550178,
    lat: -22.0698265
  },
  {
    lng: -41.7550128,
    lat: -22.0696969
  },
  {
    lng: -41.7550763,
    lat: -22.0696206
  },
  {
    lng: -41.7551624,
    lat: -22.069567
  },
  {
    lng: -41.7552485,
    lat: -22.0695133
  },
  {
    lng: -41.7552538,
    lat: -22.0694011
  },
  {
    lng: -41.7551221,
    lat: -22.0692612
  },
  {
    lng: -41.7550764,
    lat: -22.0690628
  },
  {
    lng: -41.7551309,
    lat: -22.0687687
  },
  {
    lng: -41.7552409,
    lat: -22.0687372
  },
  {
    lng: -41.7555166,
    lat: -22.0686549
  },
  {
    lng: -41.7555863,
    lat: -22.0685131
  },
  {
    lng: -41.7555996,
    lat: -22.068431
  },
  {
    lng: -41.7556568,
    lat: -22.0682281
  },
  {
    lng: -41.7557356,
    lat: -22.0681085
  },
  {
    lng: -41.7558974,
    lat: -22.0680013
  },
  {
    lng: -41.7559912,
    lat: -22.0679506
  },
  {
    lng: -41.7560804,
    lat: -22.0678994
  },
  {
    lng: -41.7563398,
    lat: -22.0676971
  },
  {
    lng: -41.7563833,
    lat: -22.0676095
  },
  {
    lng: -41.7564508,
    lat: -22.0676027
  },
  {
    lng: -41.7565063,
    lat: -22.0676403
  },
  {
    lng: -41.7565541,
    lat: -22.0676532
  },
  {
    lng: -41.756586,
    lat: -22.0676618
  },
  {
    lng: -41.7566499,
    lat: -22.0676789
  },
  {
    lng: -41.7567294,
    lat: -22.0675887
  },
  {
    lng: -41.7567659,
    lat: -22.0673181
  },
  {
    lng: -41.7568442,
    lat: -22.0670582
  },
  {
    lng: -41.7570062,
    lat: -22.0670332
  },
  {
    lng: -41.7571248,
    lat: -22.0670964
  },
  {
    lng: -41.7572064,
    lat: -22.0670602
  },
  {
    lng: -41.7572863,
    lat: -22.067081
  },
  {
    lng: -41.7574614,
    lat: -22.0672922
  },
  {
    lng: -41.7575841,
    lat: -22.0670358
  },
  {
    lng: -41.7577424,
    lat: -22.0668392
  },
  {
    lng: -41.7578158,
    lat: -22.0666518
  },
  {
    lng: -41.757933,
    lat: -22.0666516
  },
  {
    lng: -41.7580717,
    lat: -22.0665948
  },
  {
    lng: -41.7580417,
    lat: -22.0664647
  },
  {
    lng: -41.7581023,
    lat: -22.066305
  },
  {
    lng: -41.7581486,
    lat: -22.0662694
  },
  {
    lng: -41.7583424,
    lat: -22.0663157
  },
  {
    lng: -41.7583646,
    lat: -22.0662389
  },
  {
    lng: -41.7584178,
    lat: -22.066165
  },
  {
    lng: -41.7584966,
    lat: -22.066052
  },
  {
    lng: -41.7585273,
    lat: -22.0660275
  },
  {
    lng: -41.7585948,
    lat: -22.0659738
  },
  {
    lng: -41.7586613,
    lat: -22.0658446
  },
  {
    lng: -41.7586689,
    lat: -22.0657876
  },
  {
    lng: -41.7586815,
    lat: -22.0657372
  },
  {
    lng: -41.7587665,
    lat: -22.0657393
  },
  {
    lng: -41.758914,
    lat: -22.0658008
  },
  {
    lng: -41.7589875,
    lat: -22.065808
  },
  {
    lng: -41.7589998,
    lat: -22.0658092
  },
  {
    lng: -41.7590022,
    lat: -22.0658095
  },
  {
    lng: -41.7594025,
    lat: -22.065803
  },
  {
    lng: -41.7594942,
    lat: -22.0657224
  },
  {
    lng: -41.7595003,
    lat: -22.0656215
  },
  {
    lng: -41.759603,
    lat: -22.0655601
  },
  {
    lng: -41.7595662,
    lat: -22.065472
  },
  {
    lng: -41.7595241,
    lat: -22.0653828
  },
  {
    lng: -41.7595716,
    lat: -22.0653634
  },
  {
    lng: -41.7596904,
    lat: -22.0653025
  },
  {
    lng: -41.759702,
    lat: -22.0652887
  },
  {
    lng: -41.7598456,
    lat: -22.0651522
  },
  {
    lng: -41.7599346,
    lat: -22.0649936
  },
  {
    lng: -41.760033,
    lat: -22.0649903
  },
  {
    lng: -41.7600894,
    lat: -22.0649068
  },
  {
    lng: -41.7601858,
    lat: -22.0648597
  },
  {
    lng: -41.7602623,
    lat: -22.0648667
  },
  {
    lng: -41.7603435,
    lat: -22.0648911
  },
  {
    lng: -41.7606746,
    lat: -22.0649843
  },
  {
    lng: -41.7609869,
    lat: -22.0648881
  },
  {
    lng: -41.7612136,
    lat: -22.0647435
  },
  {
    lng: -41.7613229,
    lat: -22.0646922
  },
  {
    lng: -41.7616988,
    lat: -22.0645376
  },
  {
    lng: -41.7618215,
    lat: -22.0644677
  },
  {
    lng: -41.7619306,
    lat: -22.0643739
  },
  {
    lng: -41.7619685,
    lat: -22.064195
  },
  {
    lng: -41.7619619,
    lat: -22.0641194
  },
  {
    lng: -41.7619241,
    lat: -22.0639761
  },
  {
    lng: -41.7619978,
    lat: -22.0638662
  },
  {
    lng: -41.762149,
    lat: -22.0636703
  },
  {
    lng: -41.7622679,
    lat: -22.0636238
  },
  {
    lng: -41.762382,
    lat: -22.0634981
  },
  {
    lng: -41.7623585,
    lat: -22.0634326
  },
  {
    lng: -41.7623528,
    lat: -22.0634165
  },
  {
    lng: -41.7622436,
    lat: -22.0632694
  },
  {
    lng: -41.7621866,
    lat: -22.0631795
  },
  {
    lng: -41.7621348,
    lat: -22.0630699
  },
  {
    lng: -41.762139,
    lat: -22.0629649
  },
  {
    lng: -41.7619712,
    lat: -22.0626356
  },
  {
    lng: -41.7619111,
    lat: -22.0625409
  },
  {
    lng: -41.7618962,
    lat: -22.062508
  },
  {
    lng: -41.7618196,
    lat: -22.0622971
  },
  {
    lng: -41.7617896,
    lat: -22.0621652
  },
  {
    lng: -41.7617652,
    lat: -22.0619782
  },
  {
    lng: -41.7617975,
    lat: -22.0618173
  },
  {
    lng: -41.7619141,
    lat: -22.0614715
  },
  {
    lng: -41.7619457,
    lat: -22.0611038
  },
  {
    lng: -41.761954,
    lat: -22.0610642
  },
  {
    lng: -41.7619565,
    lat: -22.0610478
  },
  {
    lng: -41.7620069,
    lat: -22.0607066
  },
  {
    lng: -41.7619301,
    lat: -22.060633
  },
  {
    lng: -41.7618621,
    lat: -22.0604989
  },
  {
    lng: -41.7618711,
    lat: -22.060299
  },
  {
    lng: -41.761883,
    lat: -22.0602211
  },
  {
    lng: -41.7616674,
    lat: -22.0599847
  },
  {
    lng: -41.7616027,
    lat: -22.0598896
  },
  {
    lng: -41.7614465,
    lat: -22.0597076
  },
  {
    lng: -41.7613404,
    lat: -22.0595454
  },
  {
    lng: -41.7612088,
    lat: -22.0594474
  },
  {
    lng: -41.7611862,
    lat: -22.0594097
  },
  {
    lng: -41.7611228,
    lat: -22.059296
  },
  {
    lng: -41.7610858,
    lat: -22.0591929
  },
  {
    lng: -41.76103,
    lat: -22.0588727
  },
  {
    lng: -41.7609471,
    lat: -22.0586942
  },
  {
    lng: -41.7608777,
    lat: -22.0587304
  },
  {
    lng: -41.760715,
    lat: -22.0585329
  },
  {
    lng: -41.7606659,
    lat: -22.0584677
  },
  {
    lng: -41.7606689,
    lat: -22.0583987
  },
  {
    lng: -41.7607345,
    lat: -22.0584039
  },
  {
    lng: -41.7608717,
    lat: -22.0584281
  },
  {
    lng: -41.760908,
    lat: -22.0583507
  },
  {
    lng: -41.7608088,
    lat: -22.0582862
  },
  {
    lng: -41.7607674,
    lat: -22.0582029
  },
  {
    lng: -41.7607355,
    lat: -22.0581118
  },
  {
    lng: -41.7606658,
    lat: -22.0578559
  },
  {
    lng: -41.7605467,
    lat: -22.0578269
  },
  {
    lng: -41.7604676,
    lat: -22.0578198
  },
  {
    lng: -41.7604777,
    lat: -22.0577563
  },
  {
    lng: -41.7605509,
    lat: -22.0577207
  },
  {
    lng: -41.7605194,
    lat: -22.0575157
  },
  {
    lng: -41.7605003,
    lat: -22.0574071
  },
  {
    lng: -41.7605304,
    lat: -22.0573447
  },
  {
    lng: -41.7604817,
    lat: -22.0572068
  },
  {
    lng: -41.7605136,
    lat: -22.0571312
  },
  {
    lng: -41.760543,
    lat: -22.0570645
  },
  {
    lng: -41.7604899,
    lat: -22.0569663
  },
  {
    lng: -41.7603792,
    lat: -22.056951
  },
  {
    lng: -41.7603369,
    lat: -22.0568186
  },
  {
    lng: -41.76021,
    lat: -22.056732
  },
  {
    lng: -41.7600898,
    lat: -22.0567917
  },
  {
    lng: -41.7600398,
    lat: -22.0566515
  },
  {
    lng: -41.7600911,
    lat: -22.0565932
  },
  {
    lng: -41.7600283,
    lat: -22.0564818
  },
  {
    lng: -41.7599473,
    lat: -22.0562948
  },
  {
    lng: -41.7599146,
    lat: -22.0561312
  },
  {
    lng: -41.7598253,
    lat: -22.0559575
  },
  {
    lng: -41.7597639,
    lat: -22.0559097
  },
  {
    lng: -41.7596335,
    lat: -22.0557824
  },
  {
    lng: -41.7595976,
    lat: -22.0557539
  },
  {
    lng: -41.7595407,
    lat: -22.0557088
  },
  {
    lng: -41.7594218,
    lat: -22.0555544
  },
  {
    lng: -41.7592865,
    lat: -22.0554678
  },
  {
    lng: -41.7592612,
    lat: -22.0552015
  },
  {
    lng: -41.7592134,
    lat: -22.0551759
  },
  {
    lng: -41.7591097,
    lat: -22.0551468
  },
  {
    lng: -41.7590863,
    lat: -22.0550587
  },
  {
    lng: -41.7591769,
    lat: -22.055011
  },
  {
    lng: -41.7592144,
    lat: -22.0548688
  },
  {
    lng: -41.7592007,
    lat: -22.0548221
  },
  {
    lng: -41.7590115,
    lat: -22.0548124
  },
  {
    lng: -41.7589252,
    lat: -22.0547682
  },
  {
    lng: -41.7589018,
    lat: -22.0547114
  },
  {
    lng: -41.759029,
    lat: -22.054657
  },
  {
    lng: -41.7591512,
    lat: -22.0546026
  },
  {
    lng: -41.7591592,
    lat: -22.0545175
  },
  {
    lng: -41.7591726,
    lat: -22.0544587
  },
  {
    lng: -41.7592407,
    lat: -22.0544297
  },
  {
    lng: -41.7593363,
    lat: -22.0543784
  },
  {
    lng: -41.7593852,
    lat: -22.0543507
  },
  {
    lng: -41.7594359,
    lat: -22.0541388
  },
  {
    lng: -41.759392,
    lat: -22.0540862
  },
  {
    lng: -41.759385,
    lat: -22.0541
  },
  {
    lng: -41.7592936,
    lat: -22.0540961
  },
  {
    lng: -41.7592207,
    lat: -22.0540159
  },
  {
    lng: -41.7591497,
    lat: -22.0539471
  },
  {
    lng: -41.7591101,
    lat: -22.0538513
  },
  {
    lng: -41.7591112,
    lat: -22.0537859
  },
  {
    lng: -41.7591767,
    lat: -22.0537595
  },
  {
    lng: -41.7592776,
    lat: -22.0537188
  },
  {
    lng: -41.7593392,
    lat: -22.0536647
  },
  {
    lng: -41.7596338,
    lat: -22.0534263
  },
  {
    lng: -41.7597978,
    lat: -22.0531938
  },
  {
    lng: -41.760013,
    lat: -22.0528915
  },
  {
    lng: -41.7602681,
    lat: -22.0526077
  },
  {
    lng: -41.7605304,
    lat: -22.0523412
  },
  {
    lng: -41.7607812,
    lat: -22.0520689
  },
  {
    lng: -41.7609968,
    lat: -22.0519033
  },
  {
    lng: -41.7610532,
    lat: -22.0518198
  },
  {
    lng: -41.7613722,
    lat: -22.051609
  },
  {
    lng: -41.7615547,
    lat: -22.0514945
  },
  {
    lng: -41.7616799,
    lat: -22.0514204
  },
  {
    lng: -41.7617352,
    lat: -22.0512337
  },
  {
    lng: -41.7617149,
    lat: -22.0511133
  },
  {
    lng: -41.7617759,
    lat: -22.0508773
  },
  {
    lng: -41.7617503,
    lat: -22.0505127
  },
  {
    lng: -41.7617177,
    lat: -22.0503971
  },
  {
    lng: -41.7617374,
    lat: -22.0503245
  },
  {
    lng: -41.7618601,
    lat: -22.0502437
  },
  {
    lng: -41.7619088,
    lat: -22.05018
  },
  {
    lng: -41.7619718,
    lat: -22.0499807
  },
  {
    lng: -41.7619699,
    lat: -22.0497851
  },
  {
    lng: -41.7620107,
    lat: -22.0496807
  },
  {
    lng: -41.7620414,
    lat: -22.049593
  },
  {
    lng: -41.7620438,
    lat: -22.0495904
  },
  {
    lng: -41.7621106,
    lat: -22.0495185
  },
  {
    lng: -41.7623202,
    lat: -22.0494711
  },
  {
    lng: -41.7624674,
    lat: -22.0494587
  },
  {
    lng: -41.7625967,
    lat: -22.0494116
  },
  {
    lng: -41.762794,
    lat: -22.049378
  },
  {
    lng: -41.7629864,
    lat: -22.0493721
  },
  {
    lng: -41.7630525,
    lat: -22.0493132
  },
  {
    lng: -41.7631592,
    lat: -22.0493008
  },
  {
    lng: -41.7632321,
    lat: -22.0493162
  },
  {
    lng: -41.7633371,
    lat: -22.0493885
  },
  {
    lng: -41.7635637,
    lat: -22.0494257
  },
  {
    lng: -41.7637013,
    lat: -22.0493899
  },
  {
    lng: -41.7638748,
    lat: -22.0493204
  },
  {
    lng: -41.763989,
    lat: -22.0492307
  },
  {
    lng: -41.7640555,
    lat: -22.0491064
  },
  {
    lng: -41.7640264,
    lat: -22.0488366
  },
  {
    lng: -41.7640278,
    lat: -22.0484653
  },
  {
    lng: -41.7640894,
    lat: -22.048443
  },
  {
    lng: -41.7641782,
    lat: -22.0484271
  },
  {
    lng: -41.7642891,
    lat: -22.0481275
  },
  {
    lng: -41.7643327,
    lat: -22.0480578
  },
  {
    lng: -41.7645119,
    lat: -22.0479655
  },
  {
    lng: -41.7645421,
    lat: -22.0479559
  },
  {
    lng: -41.7646559,
    lat: -22.0479423
  },
  {
    lng: -41.7647602,
    lat: -22.0479853
  },
  {
    lng: -41.7649912,
    lat: -22.0479648
  },
  {
    lng: -41.7651202,
    lat: -22.0478769
  },
  {
    lng: -41.765266,
    lat: -22.0477871
  },
  {
    lng: -41.7652933,
    lat: -22.0476988
  },
  {
    lng: -41.7655248,
    lat: -22.0474637
  },
  {
    lng: -41.765594,
    lat: -22.0473753
  },
  {
    lng: -41.7657012,
    lat: -22.0473031
  },
  {
    lng: -41.7658995,
    lat: -22.0473187
  },
  {
    lng: -41.7660108,
    lat: -22.0473172
  },
  {
    lng: -41.7661419,
    lat: -22.0472706
  },
  {
    lng: -41.7663208,
    lat: -22.0473127
  },
  {
    lng: -41.7663966,
    lat: -22.0472855
  },
  {
    lng: -41.7664017,
    lat: -22.0472459
  },
  {
    lng: -41.7665842,
    lat: -22.0472814
  },
  {
    lng: -41.7666298,
    lat: -22.0472903
  },
  {
    lng: -41.766645,
    lat: -22.0472933
  },
  {
    lng: -41.7667157,
    lat: -22.0472606
  },
  {
    lng: -41.7667425,
    lat: -22.0472018
  },
  {
    lng: -41.766722,
    lat: -22.0470238
  },
  {
    lng: -41.7666883,
    lat: -22.0469578
  },
  {
    lng: -41.7666708,
    lat: -22.0469201
  },
  {
    lng: -41.7666163,
    lat: -22.0468717
  },
  {
    lng: -41.7665618,
    lat: -22.0468233
  },
  {
    lng: -41.7665758,
    lat: -22.046792
  },
  {
    lng: -41.7666033,
    lat: -22.0467086
  },
  {
    lng: -41.7666328,
    lat: -22.0465621
  },
  {
    lng: -41.7666539,
    lat: -22.0464578
  },
  {
    lng: -41.7666272,
    lat: -22.0463606
  },
  {
    lng: -41.7665482,
    lat: -22.0461815
  },
  {
    lng: -41.7665071,
    lat: -22.0460371
  },
  {
    lng: -41.7664781,
    lat: -22.0460102
  },
  {
    lng: -41.7663454,
    lat: -22.0459457
  },
  {
    lng: -41.7663328,
    lat: -22.0458312
  },
  {
    lng: -41.7662556,
    lat: -22.0456245
  },
  {
    lng: -41.7662385,
    lat: -22.0455263
  },
  {
    lng: -41.7661755,
    lat: -22.0455294
  },
  {
    lng: -41.7661255,
    lat: -22.0455883
  },
  {
    lng: -41.7660683,
    lat: -22.0456215
  },
  {
    lng: -41.7660342,
    lat: -22.0456192
  },
  {
    lng: -41.765989,
    lat: -22.0455869
  },
  {
    lng: -41.7659349,
    lat: -22.0455463
  },
  {
    lng: -41.7658845,
    lat: -22.0454847
  },
  {
    lng: -41.7657814,
    lat: -22.0454363
  },
  {
    lng: -41.7654412,
    lat: -22.0452628
  },
  {
    lng: -41.7651028,
    lat: -22.045082
  },
  {
    lng: -41.7648925,
    lat: -22.0449159
  },
  {
    lng: -41.7648301,
    lat: -22.0449034
  },
  {
    lng: -41.764775,
    lat: -22.044789
  },
  {
    lng: -41.7647389,
    lat: -22.0447837
  },
  {
    lng: -41.7646881,
    lat: -22.0447833
  },
  {
    lng: -41.7645624,
    lat: -22.0446702
  },
  {
    lng: -41.7644921,
    lat: -22.0446266
  },
  {
    lng: -41.7643992,
    lat: -22.0445825
  },
  {
    lng: -41.7641561,
    lat: -22.0443775
  },
  {
    lng: -41.7641181,
    lat: -22.044386
  },
  {
    lng: -41.7640203,
    lat: -22.0443731
  },
  {
    lng: -41.7639899,
    lat: -22.0443042
  },
  {
    lng: -41.7639085,
    lat: -22.0442066
  },
  {
    lng: -41.7638061,
    lat: -22.0442033
  },
  {
    lng: -41.7637471,
    lat: -22.0442473
  },
  {
    lng: -41.7637156,
    lat: -22.044248
  },
  {
    lng: -41.7636371,
    lat: -22.0442266
  },
  {
    lng: -41.7636239,
    lat: -22.0441583
  },
  {
    lng: -41.7636367,
    lat: -22.0441016
  },
  {
    lng: -41.7636404,
    lat: -22.044085
  },
  {
    lng: -41.7636146,
    lat: -22.0440371
  },
  {
    lng: -41.7636181,
    lat: -22.0439562
  },
  {
    lng: -41.7637491,
    lat: -22.0438694
  },
  {
    lng: -41.7637864,
    lat: -22.0438423
  },
  {
    lng: -41.7637604,
    lat: -22.0437818
  },
  {
    lng: -41.763736,
    lat: -22.0437915
  },
  {
    lng: -41.7636916,
    lat: -22.0437916
  },
  {
    lng: -41.7636823,
    lat: -22.0437172
  },
  {
    lng: -41.7636925,
    lat: -22.0436824
  },
  {
    lng: -41.7637279,
    lat: -22.0436733
  },
  {
    lng: -41.7638056,
    lat: -22.0436204
  },
  {
    lng: -41.763804,
    lat: -22.0436194
  },
  {
    lng: -41.7638023,
    lat: -22.0436185
  },
  {
    lng: -41.763761,
    lat: -22.0435586
  },
  {
    lng: -41.7637378,
    lat: -22.0435293
  },
  {
    lng: -41.7637259,
    lat: -22.043479
  },
  {
    lng: -41.763875,
    lat: -22.043409
  },
  {
    lng: -41.7639973,
    lat: -22.0434261
  },
  {
    lng: -41.7640371,
    lat: -22.0433756
  },
  {
    lng: -41.7639828,
    lat: -22.0433031
  },
  {
    lng: -41.7640199,
    lat: -22.043228
  },
  {
    lng: -41.7640569,
    lat: -22.0431518
  },
  {
    lng: -41.7640962,
    lat: -22.0429921
  },
  {
    lng: -41.7640949,
    lat: -22.0429802
  },
  {
    lng: -41.7641343,
    lat: -22.0427911
  },
  {
    lng: -41.7641367,
    lat: -22.0427737
  },
  {
    lng: -41.7641542,
    lat: -22.0424036
  },
  {
    lng: -41.7641891,
    lat: -22.0420394
  },
  {
    lng: -41.7642299,
    lat: -22.0419122
  },
  {
    lng: -41.7642297,
    lat: -22.0418486
  },
  {
    lng: -41.76418,
    lat: -22.0416022
  },
  {
    lng: -41.7641488,
    lat: -22.0415285
  },
  {
    lng: -41.7641963,
    lat: -22.041502
  },
  {
    lng: -41.7642227,
    lat: -22.0415049
  },
  {
    lng: -41.7643153,
    lat: -22.0414723
  },
  {
    lng: -41.7643324,
    lat: -22.0413979
  },
  {
    lng: -41.7643052,
    lat: -22.0413386
  },
  {
    lng: -41.7642491,
    lat: -22.0412752
  },
  {
    lng: -41.7642304,
    lat: -22.0412698
  },
  {
    lng: -41.7641537,
    lat: -22.0412466
  },
  {
    lng: -41.7638186,
    lat: -22.0410568
  },
  {
    lng: -41.7638272,
    lat: -22.0409308
  },
  {
    lng: -41.7639202,
    lat: -22.0408508
  },
  {
    lng: -41.7640802,
    lat: -22.0407598
  },
  {
    lng: -41.7642853,
    lat: -22.0407268
  },
  {
    lng: -41.764563,
    lat: -22.0406799
  },
  {
    lng: -41.7646593,
    lat: -22.040616
  },
  {
    lng: -41.7646976,
    lat: -22.0405235
  },
  {
    lng: -41.7646815,
    lat: -22.0404628
  },
  {
    lng: -41.7646488,
    lat: -22.0403395
  },
  {
    lng: -41.7645905,
    lat: -22.0400045
  },
  {
    lng: -41.7645105,
    lat: -22.0397545
  },
  {
    lng: -41.7644052,
    lat: -22.039612
  },
  {
    lng: -41.7643026,
    lat: -22.0395206
  },
  {
    lng: -41.7642168,
    lat: -22.0394554
  },
  {
    lng: -41.7640528,
    lat: -22.0394625
  },
  {
    lng: -41.7639899,
    lat: -22.0395257
  },
  {
    lng: -41.7639218,
    lat: -22.0395426
  },
  {
    lng: -41.7637726,
    lat: -22.0393578
  },
  {
    lng: -41.7637492,
    lat: -22.0392894
  },
  {
    lng: -41.7636624,
    lat: -22.039301
  },
  {
    lng: -41.7636265,
    lat: -22.0393312
  },
  {
    lng: -41.7635711,
    lat: -22.0393157
  },
  {
    lng: -41.7635389,
    lat: -22.0392888
  },
  {
    lng: -41.7635187,
    lat: -22.0392444
  },
  {
    lng: -41.763585,
    lat: -22.0390416
  },
  {
    lng: -41.7635461,
    lat: -22.0389367
  },
  {
    lng: -41.7635055,
    lat: -22.0389224
  },
  {
    lng: -41.763419,
    lat: -22.0388447
  },
  {
    lng: -41.7634053,
    lat: -22.0387697
  },
  {
    lng: -41.7633743,
    lat: -22.0387321
  },
  {
    lng: -41.7633357,
    lat: -22.0387274
  },
  {
    lng: -41.7633235,
    lat: -22.0387274
  },
  {
    lng: -41.7630671,
    lat: -22.0384558
  },
  {
    lng: -41.7630927,
    lat: -22.038193
  },
  {
    lng: -41.7630844,
    lat: -22.0380029
  },
  {
    lng: -41.7631392,
    lat: -22.0376351
  },
  {
    lng: -41.7631463,
    lat: -22.0376151
  },
  {
    lng: -41.7632004,
    lat: -22.037461
  },
  {
    lng: -41.7633356,
    lat: -22.0371205
  },
  {
    lng: -41.7633677,
    lat: -22.0370748
  },
  {
    lng: -41.7635978,
    lat: -22.0367827
  },
  {
    lng: -41.7637499,
    lat: -22.0364956
  },
  {
    lng: -41.7638118,
    lat: -22.0363329
  },
  {
    lng: -41.7638544,
    lat: -22.0361727
  },
  {
    lng: -41.7640148,
    lat: -22.0362412
  },
  {
    lng: -41.7641263,
    lat: -22.0362889
  },
  {
    lng: -41.7642377,
    lat: -22.0363365
  },
  {
    lng: -41.7642872,
    lat: -22.0363322
  },
  {
    lng: -41.7644253,
    lat: -22.0360595
  },
  {
    lng: -41.7646662,
    lat: -22.0359329
  },
  {
    lng: -41.7647942,
    lat: -22.0357352
  },
  {
    lng: -41.7648237,
    lat: -22.0355186
  },
  {
    lng: -41.7647784,
    lat: -22.035424
  },
  {
    lng: -41.7647315,
    lat: -22.035267
  },
  {
    lng: -41.764755,
    lat: -22.0351433
  },
  {
    lng: -41.7647547,
    lat: -22.035042
  },
  {
    lng: -41.7647604,
    lat: -22.03485
  },
  {
    lng: -41.7647789,
    lat: -22.034775
  },
  {
    lng: -41.7648786,
    lat: -22.0345942
  },
  {
    lng: -41.7647251,
    lat: -22.0342521
  },
  {
    lng: -41.7646221,
    lat: -22.0340431
  },
  {
    lng: -41.7646165,
    lat: -22.0338992
  },
  {
    lng: -41.7646755,
    lat: -22.0338169
  },
  {
    lng: -41.7649056,
    lat: -22.033761
  },
  {
    lng: -41.7650861,
    lat: -22.0336753
  },
  {
    lng: -41.7651454,
    lat: -22.0335313
  },
  {
    lng: -41.7653527,
    lat: -22.0333621
  },
  {
    lng: -41.7654642,
    lat: -22.0332274
  },
  {
    lng: -41.7655152,
    lat: -22.0330834
  },
  {
    lng: -41.7655171,
    lat: -22.0330725
  },
  {
    lng: -41.7656614,
    lat: -22.0327303
  },
  {
    lng: -41.7657804,
    lat: -22.0327431
  },
  {
    lng: -41.7659632,
    lat: -22.0327828
  },
  {
    lng: -41.766115,
    lat: -22.032753
  },
  {
    lng: -41.7662311,
    lat: -22.0326621
  },
  {
    lng: -41.7662899,
    lat: -22.0325294
  },
  {
    lng: -41.7664053,
    lat: -22.0324211
  },
  {
    lng: -41.7665116,
    lat: -22.0323017
  },
  {
    lng: -41.7667933,
    lat: -22.0320478
  },
  {
    lng: -41.7667917,
    lat: -22.0318404
  },
  {
    lng: -41.7667651,
    lat: -22.0315966
  },
  {
    lng: -41.7667525,
    lat: -22.0314807
  },
  {
    lng: -41.7667944,
    lat: -22.0312598
  },
  {
    lng: -41.7669576,
    lat: -22.030998
  },
  {
    lng: -41.7671624,
    lat: -22.0306886
  },
  {
    lng: -41.7672494,
    lat: -22.0305741
  },
  {
    lng: -41.7673873,
    lat: -22.0303925
  },
  {
    lng: -41.7676723,
    lat: -22.0301428
  },
  {
    lng: -41.7679774,
    lat: -22.0299186
  },
  {
    lng: -41.7683337,
    lat: -22.0297562
  },
  {
    lng: -41.7687025,
    lat: -22.0296431
  },
  {
    lng: -41.7690887,
    lat: -22.029597
  },
  {
    lng: -41.7694349,
    lat: -22.0295668
  },
  {
    lng: -41.7695982,
    lat: -22.0296127
  },
  {
    lng: -41.7696215,
    lat: -22.0296192
  },
  {
    lng: -41.7699892,
    lat: -22.0295057
  },
  {
    lng: -41.7702896,
    lat: -22.0292472
  },
  {
    lng: -41.770589,
    lat: -22.0290175
  },
  {
    lng: -41.7708116,
    lat: -22.0287112
  },
  {
    lng: -41.7711087,
    lat: -22.0284726
  },
  {
    lng: -41.771454,
    lat: -22.0282937
  },
  {
    lng: -41.771796,
    lat: -22.0280813
  },
  {
    lng: -41.7719029,
    lat: -22.028005
  },
  {
    lng: -41.7721176,
    lat: -22.0278519
  },
  {
    lng: -41.7722922,
    lat: -22.0275294
  },
  {
    lng: -41.7724433,
    lat: -22.0271855
  },
  {
    lng: -41.772451,
    lat: -22.0271471
  },
  {
    lng: -41.7725157,
    lat: -22.0268257
  },
  {
    lng: -41.7724128,
    lat: -22.026476
  },
  {
    lng: -41.7723914,
    lat: -22.0263009
  },
  {
    lng: -41.7723686,
    lat: -22.0261137
  },
  {
    lng: -41.7723936,
    lat: -22.0260827
  },
  {
    lng: -41.7725745,
    lat: -22.0257627
  },
  {
    lng: -41.772567,
    lat: -22.0257713
  },
  {
    lng: -41.7726994,
    lat: -22.0254705
  },
  {
    lng: -41.7728383,
    lat: -22.0251282
  },
  {
    lng: -41.7728328,
    lat: -22.0248777
  },
  {
    lng: -41.7729169,
    lat: -22.0247585
  },
  {
    lng: -41.773177,
    lat: -22.0244837
  },
  {
    lng: -41.773408,
    lat: -22.0241928
  },
  {
    lng: -41.7734309,
    lat: -22.0240878
  },
  {
    lng: -41.7735067,
    lat: -22.0239468
  },
  {
    lng: -41.7737629,
    lat: -22.0236696
  },
  {
    lng: -41.7739792,
    lat: -22.0233678
  },
  {
    lng: -41.7741803,
    lat: -22.0230543
  },
  {
    lng: -41.7742646,
    lat: -22.0230494
  },
  {
    lng: -41.7746555,
    lat: -22.0230193
  },
  {
    lng: -41.7750461,
    lat: -22.0229824
  },
  {
    lng: -41.7751356,
    lat: -22.0229164
  },
  {
    lng: -41.7751948,
    lat: -22.0228716
  },
  {
    lng: -41.7754452,
    lat: -22.0226824
  },
  {
    lng: -41.7757242,
    lat: -22.0224233
  },
  {
    lng: -41.7760219,
    lat: -22.0221898
  },
  {
    lng: -41.7761235,
    lat: -22.0221062
  },
  {
    lng: -41.7763188,
    lat: -22.0219455
  },
  {
    lng: -41.7763495,
    lat: -22.021944
  },
  {
    lng: -41.7767358,
    lat: -22.0219914
  },
  {
    lng: -41.7768793,
    lat: -22.021787
  },
  {
    lng: -41.7770789,
    lat: -22.0217467
  },
  {
    lng: -41.7774693,
    lat: -22.0217291
  },
  {
    lng: -41.7778563,
    lat: -22.0217516
  },
  {
    lng: -41.7782429,
    lat: -22.0217816
  },
  {
    lng: -41.7786351,
    lat: -22.0217818
  },
  {
    lng: -41.7790302,
    lat: -22.0217425
  },
  {
    lng: -41.7794278,
    lat: -22.0217281
  },
  {
    lng: -41.7795547,
    lat: -22.0217661
  },
  {
    lng: -41.7798001,
    lat: -22.0218396
  },
  {
    lng: -41.7801858,
    lat: -22.0217521
  },
  {
    lng: -41.7805643,
    lat: -22.021654
  },
  {
    lng: -41.7809478,
    lat: -22.0215888
  },
  {
    lng: -41.7811432,
    lat: -22.0215372
  },
  {
    lng: -41.7813227,
    lat: -22.0214899
  },
  {
    lng: -41.7816888,
    lat: -22.0213523
  },
  {
    lng: -41.7820657,
    lat: -22.0212368
  },
  {
    lng: -41.782464,
    lat: -22.0213091
  },
  {
    lng: -41.7828185,
    lat: -22.021456
  },
  {
    lng: -41.7831831,
    lat: -22.0215796
  },
  {
    lng: -41.7835775,
    lat: -22.0215585
  },
  {
    lng: -41.7839363,
    lat: -22.0214164
  },
  {
    lng: -41.7843049,
    lat: -22.0212788
  },
  {
    lng: -41.7843441,
    lat: -22.0212864
  },
  {
    lng: -41.7846289,
    lat: -22.0213417
  },
  {
    lng: -41.7850154,
    lat: -22.0213752
  },
  {
    lng: -41.7852146,
    lat: -22.0211945
  },
  {
    lng: -41.7852595,
    lat: -22.0211823
  },
  {
    lng: -41.7855698,
    lat: -22.0212634
  },
  {
    lng: -41.7859604,
    lat: -22.0212303
  },
  {
    lng: -41.7863042,
    lat: -22.0210593
  },
  {
    lng: -41.7866756,
    lat: -22.0209473
  },
  {
    lng: -41.7868304,
    lat: -22.0210001
  },
  {
    lng: -41.7870401,
    lat: -22.0210718
  },
  {
    lng: -41.7873523,
    lat: -22.0208631
  },
  {
    lng: -41.7877412,
    lat: -22.0208174
  },
  {
    lng: -41.788105,
    lat: -22.0209524
  },
  {
    lng: -41.7884193,
    lat: -22.0211488
  },
  {
    lng: -41.7887302,
    lat: -22.0213581
  },
  {
    lng: -41.7889999,
    lat: -22.0217522
  },
  {
    lng: -41.7890774,
    lat: -22.0218754
  },
  {
    lng: -41.7891893,
    lat: -22.0220532
  },
  {
    lng: -41.7894617,
    lat: -22.022315
  },
  {
    lng: -41.7897747,
    lat: -22.0225097
  },
  {
    lng: -41.7900241,
    lat: -22.022726
  },
  {
    lng: -41.7902028,
    lat: -22.0229446
  },
  {
    lng: -41.7902547,
    lat: -22.0230082
  },
  {
    lng: -41.7904326,
    lat: -22.0233213
  },
  {
    lng: -41.7906253,
    lat: -22.023643
  },
  {
    lng: -41.7908809,
    lat: -22.0238442
  },
  {
    lng: -41.7909252,
    lat: -22.0238715
  },
  {
    lng: -41.7911487,
    lat: -22.024009
  },
  {
    lng: -41.7911949,
    lat: -22.0240515
  },
  {
    lng: -41.7913205,
    lat: -22.0241672
  },
  {
    lng: -41.7913219,
    lat: -22.0241565
  },
  {
    lng: -41.7913215,
    lat: -22.0241551
  },
  {
    lng: -41.7914402,
    lat: -22.0242556
  },
  {
    lng: -41.7914735,
    lat: -22.0242837
  },
  {
    lng: -41.7915189,
    lat: -22.0243222
  },
  {
    lng: -41.791614,
    lat: -22.0243633
  },
  {
    lng: -41.7917374,
    lat: -22.0244167
  },
  {
    lng: -41.7918646,
    lat: -22.0244717
  },
  {
    lng: -41.7919938,
    lat: -22.0245275
  },
  {
    lng: -41.7921006,
    lat: -22.0245737
  },
  {
    lng: -41.7922036,
    lat: -22.0246182
  },
  {
    lng: -41.7923088,
    lat: -22.0246637
  },
  {
    lng: -41.7923931,
    lat: -22.0247002
  },
  {
    lng: -41.7924753,
    lat: -22.0247357
  },
  {
    lng: -41.7925459,
    lat: -22.0247662
  },
  {
    lng: -41.7926434,
    lat: -22.0248084
  },
  {
    lng: -41.7927433,
    lat: -22.0248516
  },
  {
    lng: -41.7926893,
    lat: -22.0247246
  },
  {
    lng: -41.7926405,
    lat: -22.0246101
  },
  {
    lng: -41.7925971,
    lat: -22.0245081
  },
  {
    lng: -41.7925461,
    lat: -22.0243882
  },
  {
    lng: -41.7924934,
    lat: -22.0242645
  },
  {
    lng: -41.7924407,
    lat: -22.0241407
  },
  {
    lng: -41.7923776,
    lat: -22.0239924
  },
  {
    lng: -41.7923169,
    lat: -22.02385
  },
  {
    lng: -41.7922547,
    lat: -22.0237039
  },
  {
    lng: -41.7921859,
    lat: -22.0235422
  },
  {
    lng: -41.7920564,
    lat: -22.023238
  },
  {
    lng: -41.7919608,
    lat: -22.0231142
  },
  {
    lng: -41.7918813,
    lat: -22.0230112
  },
  {
    lng: -41.7918223,
    lat: -22.0229348
  },
  {
    lng: -41.7917596,
    lat: -22.0228536
  },
  {
    lng: -41.7916996,
    lat: -22.0227758
  },
  {
    lng: -41.7915153,
    lat: -22.0225372
  },
  {
    lng: -41.7904243,
    lat: -22.0219135
  },
  {
    lng: -41.7894959,
    lat: -22.0211929
  },
  {
    lng: -41.789453,
    lat: -22.020311
  },
  {
    lng: -41.7894491,
    lat: -22.0202312
  },
  {
    lng: -41.7889207,
    lat: -22.0187357
  },
  {
    lng: -41.7877464,
    lat: -22.0183201
  },
  {
    lng: -41.786766,
    lat: -22.0174694
  },
  {
    lng: -41.7857666,
    lat: -22.0171413
  },
  {
    lng: -41.7853096,
    lat: -22.0168123
  },
  {
    lng: -41.785124,
    lat: -22.0166787
  },
  {
    lng: -41.7849976,
    lat: -22.0165877
  },
  {
    lng: -41.78488,
    lat: -22.0165031
  },
  {
    lng: -41.7847565,
    lat: -22.0164142
  },
  {
    lng: -41.784578,
    lat: -22.0162857
  },
  {
    lng: -41.7844577,
    lat: -22.01614
  },
  {
    lng: -41.784352,
    lat: -22.016012
  },
  {
    lng: -41.7842314,
    lat: -22.0158661
  },
  {
    lng: -41.7841034,
    lat: -22.0157112
  },
  {
    lng: -41.7839458,
    lat: -22.0155204
  },
  {
    lng: -41.7838069,
    lat: -22.0153523
  },
  {
    lng: -41.783697,
    lat: -22.0151599
  },
  {
    lng: -41.783606,
    lat: -22.0150007
  },
  {
    lng: -41.7836036,
    lat: -22.0149965
  },
  {
    lng: -41.7835576,
    lat: -22.0148492
  },
  {
    lng: -41.7835133,
    lat: -22.0147074
  },
  {
    lng: -41.7833913,
    lat: -22.0144418
  },
  {
    lng: -41.7832418,
    lat: -22.0141163
  },
  {
    lng: -41.7826974,
    lat: -22.0138321
  },
  {
    lng: -41.7821385,
    lat: -22.0135403
  },
  {
    lng: -41.7818415,
    lat: -22.0134735
  },
  {
    lng: -41.7813027,
    lat: -22.0133524
  },
  {
    lng: -41.7804046,
    lat: -22.0132106
  },
  {
    lng: -41.7797058,
    lat: -22.0128626
  },
  {
    lng: -41.7793628,
    lat: -22.0127239
  },
  {
    lng: -41.7789337,
    lat: -22.0125504
  },
  {
    lng: -41.7787173,
    lat: -22.0124368
  },
  {
    lng: -41.7784973,
    lat: -22.0123214
  },
  {
    lng: -41.7781246,
    lat: -22.0121418
  },
  {
    lng: -41.7778797,
    lat: -22.0120239
  },
  {
    lng: -41.7776849,
    lat: -22.0119523
  },
  {
    lng: -41.7775436,
    lat: -22.0119004
  },
  {
    lng: -41.7772827,
    lat: -22.0118046
  },
  {
    lng: -41.7770468,
    lat: -22.0117575
  },
  {
    lng: -41.7766326,
    lat: -22.0116748
  },
  {
    lng: -41.7758422,
    lat: -22.0116002
  },
  {
    lng: -41.7753772,
    lat: -22.0114943
  },
  {
    lng: -41.7749068,
    lat: -22.0112973
  },
  {
    lng: -41.7740246,
    lat: -22.0112805
  },
  {
    lng: -41.7735863,
    lat: -22.0113311
  },
  {
    lng: -41.7730089,
    lat: -22.0113977
  },
  {
    lng: -41.7724259,
    lat: -22.0114013
  },
  {
    lng: -41.7722804,
    lat: -22.0113315
  },
  {
    lng: -41.7720304,
    lat: -22.0112117
  },
  {
    lng: -41.7716906,
    lat: -22.0110488
  },
  {
    lng: -41.7713635,
    lat: -22.010892
  },
  {
    lng: -41.7711999,
    lat: -22.0108136
  },
  {
    lng: -41.7710919,
    lat: -22.0107923
  },
  {
    lng: -41.7708539,
    lat: -22.0107453
  },
  {
    lng: -41.7701954,
    lat: -22.0106152
  },
  {
    lng: -41.7698072,
    lat: -22.0105385
  },
  {
    lng: -41.7692528,
    lat: -22.0104408
  },
  {
    lng: -41.7689955,
    lat: -22.0103766
  },
  {
    lng: -41.7688233,
    lat: -22.0103335
  },
  {
    lng: -41.7685042,
    lat: -22.0102538
  },
  {
    lng: -41.7682873,
    lat: -22.0099794
  },
  {
    lng: -41.7680473,
    lat: -22.0098934
  },
  {
    lng: -41.767792,
    lat: -22.0098202
  },
  {
    lng: -41.7674747,
    lat: -22.0097292
  },
  {
    lng: -41.7671283,
    lat: -22.0095974
  },
  {
    lng: -41.7668795,
    lat: -22.0095028
  },
  {
    lng: -41.7665825,
    lat: -22.0093899
  },
  {
    lng: -41.7662112,
    lat: -22.0091501
  },
  {
    lng: -41.7659212,
    lat: -22.0089629
  },
  {
    lng: -41.7659148,
    lat: -22.0089587
  },
  {
    lng: -41.7657937,
    lat: -22.0088477
  },
  {
    lng: -41.7657825,
    lat: -22.0088374
  },
  {
    lng: -41.7656974,
    lat: -22.0087594
  },
  {
    lng: -41.7655945,
    lat: -22.0086651
  },
  {
    lng: -41.7654979,
    lat: -22.0086031
  },
  {
    lng: -41.7654313,
    lat: -22.0085604
  },
  {
    lng: -41.7652756,
    lat: -22.0084604
  },
  {
    lng: -41.7650774,
    lat: -22.0083332
  },
  {
    lng: -41.7648695,
    lat: -22.0081998
  },
  {
    lng: -41.764675,
    lat: -22.0080749
  },
  {
    lng: -41.76447,
    lat: -22.0079434
  },
  {
    lng: -41.7641958,
    lat: -22.0077674
  },
  {
    lng: -41.7641111,
    lat: -22.007713
  },
  {
    lng: -41.7641246,
    lat: -22.0077732
  },
  {
    lng: -41.7641364,
    lat: -22.0078263
  },
  {
    lng: -41.7641542,
    lat: -22.007906
  },
  {
    lng: -41.7641709,
    lat: -22.0079806
  },
  {
    lng: -41.7641839,
    lat: -22.0080392
  },
  {
    lng: -41.7641987,
    lat: -22.0081053
  },
  {
    lng: -41.7642122,
    lat: -22.0081659
  },
  {
    lng: -41.7642222,
    lat: -22.0082106
  },
  {
    lng: -41.7642323,
    lat: -22.008256
  },
  {
    lng: -41.764242,
    lat: -22.0082995
  },
  {
    lng: -41.7642523,
    lat: -22.0083453
  },
  {
    lng: -41.7642623,
    lat: -22.0083905
  },
  {
    lng: -41.7642765,
    lat: -22.008454
  },
  {
    lng: -41.7642783,
    lat: -22.0085122
  },
  {
    lng: -41.7642807,
    lat: -22.0085894
  },
  {
    lng: -41.7642836,
    lat: -22.0086804
  },
  {
    lng: -41.7642863,
    lat: -22.008769
  },
  {
    lng: -41.7642891,
    lat: -22.008859
  },
  {
    lng: -41.764292,
    lat: -22.0089523
  },
  {
    lng: -41.7642949,
    lat: -22.009044
  },
  {
    lng: -41.7642976,
    lat: -22.009133
  },
  {
    lng: -41.7643004,
    lat: -22.0092225
  },
  {
    lng: -41.7643035,
    lat: -22.0093218
  },
  {
    lng: -41.7643062,
    lat: -22.009409
  },
  {
    lng: -41.7643089,
    lat: -22.0094941
  },
  {
    lng: -41.7643117,
    lat: -22.009586
  },
  {
    lng: -41.7643152,
    lat: -22.0096967
  },
  {
    lng: -41.7643159,
    lat: -22.0097202
  },
  {
    lng: -41.7643197,
    lat: -22.0098419
  },
  {
    lng: -41.7643132,
    lat: -22.0099524
  },
  {
    lng: -41.7643051,
    lat: -22.010089
  },
  {
    lng: -41.7642973,
    lat: -22.0102206
  },
  {
    lng: -41.7642894,
    lat: -22.0103539
  },
  {
    lng: -41.7642815,
    lat: -22.0104875
  },
  {
    lng: -41.7642667,
    lat: -22.010618
  },
  {
    lng: -41.764251,
    lat: -22.0107568
  },
  {
    lng: -41.7642333,
    lat: -22.0109133
  },
  {
    lng: -41.7642172,
    lat: -22.0110546
  },
  {
    lng: -41.7642135,
    lat: -22.0110876
  },
  {
    lng: -41.7642181,
    lat: -22.0112384
  },
  {
    lng: -41.7642184,
    lat: -22.0112486
  },
  {
    lng: -41.7642245,
    lat: -22.0114495
  },
  {
    lng: -41.7642298,
    lat: -22.0116233
  },
  {
    lng: -41.7642343,
    lat: -22.0117713
  },
  {
    lng: -41.7642386,
    lat: -22.0119149
  },
  {
    lng: -41.7642416,
    lat: -22.0120147
  },
  {
    lng: -41.7641779,
    lat: -22.01228
  },
  {
    lng: -41.7641507,
    lat: -22.0125812
  },
  {
    lng: -41.764199,
    lat: -22.0128942
  },
  {
    lng: -41.7643327,
    lat: -22.0132183
  },
  {
    lng: -41.7643612,
    lat: -22.0135575
  },
  {
    lng: -41.7643483,
    lat: -22.0139206
  },
  {
    lng: -41.7642414,
    lat: -22.0142678
  },
  {
    lng: -41.7640964,
    lat: -22.0145796
  },
  {
    lng: -41.7640793,
    lat: -22.0149551
  },
  {
    lng: -41.7640478,
    lat: -22.0153174
  },
  {
    lng: -41.7639181,
    lat: -22.0156508
  },
  {
    lng: -41.7637656,
    lat: -22.0159728
  },
  {
    lng: -41.7635334,
    lat: -22.0162837
  },
  {
    lng: -41.7632913,
    lat: -22.0165626
  },
  {
    lng: -41.7631817,
    lat: -22.0169122
  },
  {
    lng: -41.7630585,
    lat: -22.0172759
  },
  {
    lng: -41.7631177,
    lat: -22.0176368
  },
  {
    lng: -41.7631781,
    lat: -22.0179975
  },
  {
    lng: -41.7631693,
    lat: -22.0183641
  },
  {
    lng: -41.7629636,
    lat: -22.0186786
  },
  {
    lng: -41.762676,
    lat: -22.0189312
  },
  {
    lng: -41.7623623,
    lat: -22.0191545
  },
  {
    lng: -41.7621314,
    lat: -22.0194512
  },
  {
    lng: -41.7621201,
    lat: -22.0194629
  },
  {
    lng: -41.7620835,
    lat: -22.0194758
  },
  {
    lng: -41.7620502,
    lat: -22.0194876
  },
  {
    lng: -41.7620428,
    lat: -22.0194903
  },
  {
    lng: -41.7620142,
    lat: -22.0195004
  },
  {
    lng: -41.7620118,
    lat: -22.0195013
  },
  {
    lng: -41.7619908,
    lat: -22.0195087
  },
  {
    lng: -41.7619793,
    lat: -22.0195128
  },
  {
    lng: -41.7619756,
    lat: -22.0195103
  },
  {
    lng: -41.7619445,
    lat: -22.0194896
  },
  {
    lng: -41.7619397,
    lat: -22.0194864
  },
  {
    lng: -41.7618,
    lat: -22.0193934
  },
  {
    lng: -41.7617783,
    lat: -22.0193789
  },
  {
    lng: -41.7616597,
    lat: -22.0192999
  },
  {
    lng: -41.7615434,
    lat: -22.0192484
  },
  {
    lng: -41.761309,
    lat: -22.0191446
  },
  {
    lng: -41.7612683,
    lat: -22.0191079
  },
  {
    lng: -41.7611414,
    lat: -22.0189936
  },
  {
    lng: -41.7610298,
    lat: -22.0188929
  },
  {
    lng: -41.7608509,
    lat: -22.0185722
  },
  {
    lng: -41.7604969,
    lat: -22.0184073
  },
  {
    lng: -41.7601063,
    lat: -22.0183357
  },
  {
    lng: -41.7597703,
    lat: -22.0181545
  },
  {
    lng: -41.75942,
    lat: -22.0179376
  },
  {
    lng: -41.7591467,
    lat: -22.017718
  },
  {
    lng: -41.7591265,
    lat: -22.0177018
  },
  {
    lng: -41.7588825,
    lat: -22.0174144
  },
  {
    lng: -41.7586514,
    lat: -22.0171169
  },
  {
    lng: -41.758296,
    lat: -22.0169698
  },
  {
    lng: -41.7580835,
    lat: -22.0169423
  },
  {
    lng: -41.7580366,
    lat: -22.0166097
  },
  {
    lng: -41.7578349,
    lat: -22.016487
  },
  {
    lng: -41.7574475,
    lat: -22.0165117
  },
  {
    lng: -41.7574263,
    lat: -22.016508
  },
  {
    lng: -41.7573768,
    lat: -22.0163556
  },
  {
    lng: -41.7574268,
    lat: -22.0162606
  },
  {
    lng: -41.7573503,
    lat: -22.0162135
  },
  {
    lng: -41.7572334,
    lat: -22.0161414
  },
  {
    lng: -41.7571018,
    lat: -22.0160603
  },
  {
    lng: -41.7570658,
    lat: -22.0160393
  },
  {
    lng: -41.7567902,
    lat: -22.0160083
  },
  {
    lng: -41.756523,
    lat: -22.0160932
  },
  {
    lng: -41.7563862,
    lat: -22.0159923
  },
  {
    lng: -41.7563544,
    lat: -22.0159254
  },
  {
    lng: -41.756297,
    lat: -22.0158579
  },
  {
    lng: -41.7559081,
    lat: -22.0158672
  },
  {
    lng: -41.7555243,
    lat: -22.0157923
  },
  {
    lng: -41.7551387,
    lat: -22.0158476
  },
  {
    lng: -41.7550048,
    lat: -22.0158593
  },
  {
    lng: -41.7549444,
    lat: -22.0158162
  },
  {
    lng: -41.7546876,
    lat: -22.0156326
  },
  {
    lng: -41.7545646,
    lat: -22.0155658
  },
  {
    lng: -41.7541771,
    lat: -22.0155217
  },
  {
    lng: -41.7540593,
    lat: -22.0154992
  },
  {
    lng: -41.7537878,
    lat: -22.0154472
  },
  {
    lng: -41.7536275,
    lat: -22.0153875
  },
  {
    lng: -41.7534589,
    lat: -22.0150426
  },
  {
    lng: -41.7531769,
    lat: -22.0147951
  },
  {
    lng: -41.7528354,
    lat: -22.0146134
  },
  {
    lng: -41.7527479,
    lat: -22.0145681
  },
  {
    lng: -41.7527167,
    lat: -22.014208
  },
  {
    lng: -41.7525868,
    lat: -22.0138576
  },
  {
    lng: -41.7524944,
    lat: -22.0135996
  },
  {
    lng: -41.7522494,
    lat: -22.0134463
  },
  {
    lng: -41.7519021,
    lat: -22.013265
  },
  {
    lng: -41.7515576,
    lat: -22.0130797
  },
  {
    lng: -41.7513841,
    lat: -22.0129636
  },
  {
    lng: -41.7511704,
    lat: -22.0126568
  },
  {
    lng: -41.7511392,
    lat: -22.012295
  },
  {
    lng: -41.7511466,
    lat: -22.0119667
  },
  {
    lng: -41.750979,
    lat: -22.0119974
  },
  {
    lng: -41.7508999,
    lat: -22.0119685
  },
  {
    lng: -41.7508631,
    lat: -22.0119035
  },
  {
    lng: -41.7508288,
    lat: -22.0118318
  },
  {
    lng: -41.7507811,
    lat: -22.0118044
  },
  {
    lng: -41.7507314,
    lat: -22.0118644
  },
  {
    lng: -41.7504168,
    lat: -22.0116459
  },
  {
    lng: -41.7503878,
    lat: -22.0116092
  },
  {
    lng: -41.7503265,
    lat: -22.0115012
  },
  {
    lng: -41.7501848,
    lat: -22.0113691
  },
  {
    lng: -41.7500955,
    lat: -22.0112275
  },
  {
    lng: -41.7500435,
    lat: -22.0111766
  },
  {
    lng: -41.7499897,
    lat: -22.0111572
  },
  {
    lng: -41.7498914,
    lat: -22.011124
  },
  {
    lng: -41.7498196,
    lat: -22.0109295
  },
  {
    lng: -41.7498217,
    lat: -22.0106713
  },
  {
    lng: -41.7496839,
    lat: -22.0104744
  },
  {
    lng: -41.7493166,
    lat: -22.0103297
  },
  {
    lng: -41.7489547,
    lat: -22.010194
  },
  {
    lng: -41.7488675,
    lat: -22.0101444
  },
  {
    lng: -41.7487742,
    lat: -22.0101352
  },
  {
    lng: -41.7486679,
    lat: -22.0101347
  },
  {
    lng: -41.7485522,
    lat: -22.0101003
  },
  {
    lng: -41.7483167,
    lat: -22.0098084
  },
  {
    lng: -41.7481095,
    lat: -22.0094938
  },
  {
    lng: -41.747841,
    lat: -22.009231
  },
  {
    lng: -41.747827,
    lat: -22.0092118
  },
  {
    lng: -41.7475925,
    lat: -22.0093521
  },
  {
    lng: -41.7473429,
    lat: -22.0094266
  },
  {
    lng: -41.7470349,
    lat: -22.0096471
  },
  {
    lng: -41.7470052,
    lat: -22.0096924
  },
  {
    lng: -41.7468247,
    lat: -22.0100157
  },
  {
    lng: -41.7466749,
    lat: -22.0103507
  },
  {
    lng: -41.7464269,
    lat: -22.0106803
  },
  {
    lng: -41.7463408,
    lat: -22.0107354
  },
  {
    lng: -41.7461428,
    lat: -22.0106507
  },
  {
    lng: -41.7457419,
    lat: -22.010686
  },
  {
    lng: -41.7453623,
    lat: -22.0106013
  },
  {
    lng: -41.7450553,
    lat: -22.0103726
  },
  {
    lng: -41.745012,
    lat: -22.0103488
  },
  {
    lng: -41.74476,
    lat: -22.0104356
  },
  {
    lng: -41.7444224,
    lat: -22.0102378
  },
  {
    lng: -41.7441528,
    lat: -22.0099603
  },
  {
    lng: -41.7438722,
    lat: -22.0096945
  },
  {
    lng: -41.7435718,
    lat: -22.0094563
  },
  {
    lng: -41.7432856,
    lat: -22.0092087
  },
  {
    lng: -41.7429683,
    lat: -22.0089944
  },
  {
    lng: -41.7426151,
    lat: -22.0088264
  },
  {
    lng: -41.7422361,
    lat: -22.0087464
  },
  {
    lng: -41.742018,
    lat: -22.008752
  },
  {
    lng: -41.7417695,
    lat: -22.0085455
  },
  {
    lng: -41.7415375,
    lat: -22.008254
  },
  {
    lng: -41.7412372,
    lat: -22.0080062
  },
  {
    lng: -41.7409629,
    lat: -22.0077446
  },
  {
    lng: -41.7406764,
    lat: -22.0074699
  },
  {
    lng: -41.7405612,
    lat: -22.0071177
  },
  {
    lng: -41.7406178,
    lat: -22.0067571
  },
  {
    lng: -41.7408686,
    lat: -22.0064751
  },
  {
    lng: -41.7410977,
    lat: -22.0061718
  },
  {
    lng: -41.7410039,
    lat: -22.0058088
  },
  {
    lng: -41.740858,
    lat: -22.0054633
  },
  {
    lng: -41.7406501,
    lat: -22.0051485
  },
  {
    lng: -41.7405152,
    lat: -22.0049288
  },
  {
    lng: -41.7403592,
    lat: -22.004804
  },
  {
    lng: -41.740327,
    lat: -22.0046559
  },
  {
    lng: -41.7403727,
    lat: -22.004357
  },
  {
    lng: -41.7402074,
    lat: -22.00402
  },
  {
    lng: -41.7401996,
    lat: -22.003985
  },
  {
    lng: -41.7401489,
    lat: -22.0039195
  },
  {
    lng: -41.7400648,
    lat: -22.0037772
  },
  {
    lng: -41.7400541,
    lat: -22.0037786
  },
  {
    lng: -41.7398187,
    lat: -22.0036937
  },
  {
    lng: -41.7394376,
    lat: -22.0036078
  },
  {
    lng: -41.739049,
    lat: -22.003561
  },
  {
    lng: -41.7386597,
    lat: -22.0036287
  },
  {
    lng: -41.7382822,
    lat: -22.003746
  },
  {
    lng: -41.7378941,
    lat: -22.0037678
  },
  {
    lng: -41.7375169,
    lat: -22.0036822
  },
  {
    lng: -41.7374558,
    lat: -22.0036805
  },
  {
    lng: -41.7370732,
    lat: -22.0036057
  },
  {
    lng: -41.7367826,
    lat: -22.0038522
  },
  {
    lng: -41.7364143,
    lat: -22.0039795
  },
  {
    lng: -41.7360999,
    lat: -22.0041948
  },
  {
    lng: -41.7359194,
    lat: -22.004227
  },
  {
    lng: -41.7357154,
    lat: -22.0042633
  },
  {
    lng: -41.7353666,
    lat: -22.0044341
  },
  {
    lng: -41.7350065,
    lat: -22.0045827
  },
  {
    lng: -41.7348277,
    lat: -22.0046156
  },
  {
    lng: -41.7346201,
    lat: -22.004298
  },
  {
    lng: -41.7344606,
    lat: -22.0039483
  },
  {
    lng: -41.7343885,
    lat: -22.003586
  },
  {
    lng: -41.7343831,
    lat: -22.0032129
  },
  {
    lng: -41.7343802,
    lat: -22.0028507
  },
  {
    lng: -41.734342,
    lat: -22.0024794
  },
  {
    lng: -41.7342715,
    lat: -22.00211
  },
  {
    lng: -41.7341619,
    lat: -22.0017516
  },
  {
    lng: -41.7338788,
    lat: -22.0014844
  },
  {
    lng: -41.7335816,
    lat: -22.0012407
  },
  {
    lng: -41.733371,
    lat: -22.0009353
  },
  {
    lng: -41.7332201,
    lat: -22.0005961
  },
  {
    lng: -41.7331326,
    lat: -22.0002383
  },
  {
    lng: -41.7328227,
    lat: -21.9999572
  },
  {
    lng: -41.7327409,
    lat: -21.9995807
  },
  {
    lng: -41.7327608,
    lat: -21.9992154
  },
  {
    lng: -41.7325139,
    lat: -21.9989655
  },
  {
    lng: -41.7324898,
    lat: -21.9989411
  },
  {
    lng: -41.7322836,
    lat: -21.9986341
  },
  {
    lng: -41.7321644,
    lat: -21.9982821
  },
  {
    lng: -41.7321026,
    lat: -21.9979244
  },
  {
    lng: -41.7320914,
    lat: -21.997665
  },
  {
    lng: -41.7319435,
    lat: -21.9974187
  },
  {
    lng: -41.7318674,
    lat: -21.9972899
  },
  {
    lng: -41.7318346,
    lat: -21.9972222
  },
  {
    lng: -41.7318917,
    lat: -21.9970346
  },
  {
    lng: -41.7318389,
    lat: -21.9969972
  },
  {
    lng: -41.731788,
    lat: -21.9969855
  },
  {
    lng: -41.7315826,
    lat: -21.9966736
  },
  {
    lng: -41.7315618,
    lat: -21.9966559
  },
  {
    lng: -41.7313851,
    lat: -21.9963346
  },
  {
    lng: -41.7311358,
    lat: -21.9962043
  },
  {
    lng: -41.7309602,
    lat: -21.9962919
  },
  {
    lng: -41.7306057,
    lat: -21.9961397
  },
  {
    lng: -41.7304191,
    lat: -21.9960628
  },
  {
    lng: -41.7302479,
    lat: -21.9959923
  },
  {
    lng: -41.7298957,
    lat: -21.9958292
  },
  {
    lng: -41.7295824,
    lat: -21.9957194
  },
  {
    lng: -41.729531,
    lat: -21.9957013
  },
  {
    lng: -41.7295162,
    lat: -21.9956955
  },
  {
    lng: -41.7291525,
    lat: -21.9955464
  },
  {
    lng: -41.7287824,
    lat: -21.9953692
  },
  {
    lng: -41.7284247,
    lat: -21.9952266
  },
  {
    lng: -41.7280696,
    lat: -21.9950605
  },
  {
    lng: -41.7277231,
    lat: -21.9948924
  },
  {
    lng: -41.7273574,
    lat: -21.9947483
  },
  {
    lng: -41.7269999,
    lat: -21.9946066
  },
  {
    lng: -41.7266326,
    lat: -21.994489
  },
  {
    lng: -41.7262625,
    lat: -21.9943663
  },
  {
    lng: -41.726223,
    lat: -21.9943519
  },
  {
    lng: -41.7261421,
    lat: -21.9942641
  },
  {
    lng: -41.726056,
    lat: -21.9941592
  },
  {
    lng: -41.7258641,
    lat: -21.9941506
  },
  {
    lng: -41.7255331,
    lat: -21.9939574
  },
  {
    lng: -41.7252102,
    lat: -21.9937505
  },
  {
    lng: -41.7251879,
    lat: -21.9937445
  },
  {
    lng: -41.724832,
    lat: -21.9936484
  },
  {
    lng: -41.7246063,
    lat: -21.9936285
  },
  {
    lng: -41.7244451,
    lat: -21.9936143
  },
  {
    lng: -41.7241018,
    lat: -21.9934372
  },
  {
    lng: -41.7237449,
    lat: -21.9932898
  },
  {
    lng: -41.7233877,
    lat: -21.993141
  },
  {
    lng: -41.7232606,
    lat: -21.9930533
  },
  {
    lng: -41.7231576,
    lat: -21.9930255
  },
  {
    lng: -41.7230162,
    lat: -21.9930216
  },
  {
    lng: -41.7228985,
    lat: -21.992996
  },
  {
    lng: -41.7227481,
    lat: -21.9926617
  },
  {
    lng: -41.7225551,
    lat: -21.9923466
  },
  {
    lng: -41.7223522,
    lat: -21.9920367
  },
  {
    lng: -41.7223453,
    lat: -21.9920282
  },
  {
    lng: -41.722353,
    lat: -21.9918747
  },
  {
    lng: -41.72236,
    lat: -21.9917338
  },
  {
    lng: -41.7223081,
    lat: -21.9916026
  },
  {
    lng: -41.7222159,
    lat: -21.9914383
  },
  {
    lng: -41.7221107,
    lat: -21.9913826
  },
  {
    lng: -41.7219073,
    lat: -21.9910909
  },
  {
    lng: -41.7218921,
    lat: -21.991011
  },
  {
    lng: -41.7218863,
    lat: -21.9909807
  },
  {
    lng: -41.721697,
    lat: -21.9909333
  },
  {
    lng: -41.7216132,
    lat: -21.9909021
  },
  {
    lng: -41.7215316,
    lat: -21.9908809
  },
  {
    lng: -41.7214589,
    lat: -21.9908758
  },
  {
    lng: -41.7213638,
    lat: -21.9907946
  },
  {
    lng: -41.7211749,
    lat: -21.990473
  },
  {
    lng: -41.7209783,
    lat: -21.9901537
  },
  {
    lng: -41.7207727,
    lat: -21.9898459
  },
  {
    lng: -41.7205664,
    lat: -21.9895396
  },
  {
    lng: -41.7204434,
    lat: -21.9893745
  },
  {
    lng: -41.7203452,
    lat: -21.9892428
  },
  {
    lng: -41.7202404,
    lat: -21.9890509
  },
  {
    lng: -41.7200516,
    lat: -21.9887283
  },
  {
    lng: -41.7198432,
    lat: -21.9884207
  },
  {
    lng: -41.7196916,
    lat: -21.9881973
  },
  {
    lng: -41.719633,
    lat: -21.988111
  },
  {
    lng: -41.7194203,
    lat: -21.9877952
  },
  {
    lng: -41.7191929,
    lat: -21.9874994
  },
  {
    lng: -41.7189737,
    lat: -21.9871951
  },
  {
    lng: -41.7187883,
    lat: -21.9869665
  },
  {
    lng: -41.7186568,
    lat: -21.9867495
  },
  {
    lng: -41.7184472,
    lat: -21.9864377
  },
  {
    lng: -41.7182458,
    lat: -21.9861273
  },
  {
    lng: -41.7180299,
    lat: -21.9858169
  },
  {
    lng: -41.7178173,
    lat: -21.9855047
  },
  {
    lng: -41.7176304,
    lat: -21.9851722
  },
  {
    lng: -41.7174519,
    lat: -21.98483
  },
  {
    lng: -41.7173233,
    lat: -21.9845754
  },
  {
    lng: -41.7172821,
    lat: -21.984494
  },
  {
    lng: -41.7172478,
    lat: -21.9844047
  },
  {
    lng: -41.7171282,
    lat: -21.9840583
  },
  {
    lng: -41.7170736,
    lat: -21.9836839
  },
  {
    lng: -41.7170139,
    lat: -21.9833217
  },
  {
    lng: -41.7169696,
    lat: -21.9829617
  },
  {
    lng: -41.716933,
    lat: -21.9825862
  },
  {
    lng: -41.7168785,
    lat: -21.9822234
  },
  {
    lng: -41.7168619,
    lat: -21.9818561
  },
  {
    lng: -41.7169077,
    lat: -21.9814822
  },
  {
    lng: -41.7170453,
    lat: -21.981137
  },
  {
    lng: -41.7171902,
    lat: -21.9807987
  },
  {
    lng: -41.7173451,
    lat: -21.980451
  },
  {
    lng: -41.7175037,
    lat: -21.9801042
  },
  {
    lng: -41.7176662,
    lat: -21.9797606
  },
  {
    lng: -41.7178192,
    lat: -21.9794127
  },
  {
    lng: -41.7179764,
    lat: -21.9790717
  },
  {
    lng: -41.7181229,
    lat: -21.9787232
  },
  {
    lng: -41.7182688,
    lat: -21.9783888
  },
  {
    lng: -41.718415,
    lat: -21.9780363
  },
  {
    lng: -41.7184957,
    lat: -21.9778629
  },
  {
    lng: -41.7185713,
    lat: -21.9777005
  },
  {
    lng: -41.7187262,
    lat: -21.9773488
  },
  {
    lng: -41.71882,
    lat: -21.9769956
  },
  {
    lng: -41.7189036,
    lat: -21.9766401
  },
  {
    lng: -41.7189768,
    lat: -21.9762838
  },
  {
    lng: -41.7190389,
    lat: -21.9759266
  },
  {
    lng: -41.7190541,
    lat: -21.9758475
  },
  {
    lng: -41.7191084,
    lat: -21.9755666
  },
  {
    lng: -41.7191372,
    lat: -21.9754671
  },
  {
    lng: -41.7192156,
    lat: -21.9751059
  },
  {
    lng: -41.7192868,
    lat: -21.9747321
  },
  {
    lng: -41.7193583,
    lat: -21.9743532
  },
  {
    lng: -41.7193771,
    lat: -21.9742654
  },
  {
    lng: -41.7194347,
    lat: -21.973997
  },
  {
    lng: -41.7195187,
    lat: -21.9737845
  },
  {
    lng: -41.7195574,
    lat: -21.9734229
  },
  {
    lng: -41.7196247,
    lat: -21.9730553
  },
  {
    lng: -41.719705,
    lat: -21.9726981
  },
  {
    lng: -41.7198224,
    lat: -21.9723434
  },
  {
    lng: -41.7198696,
    lat: -21.9720989
  },
  {
    lng: -41.7198927,
    lat: -21.9719796
  },
  {
    lng: -41.7199797,
    lat: -21.9716255
  },
  {
    lng: -41.720073,
    lat: -21.9713108
  },
  {
    lng: -41.7201399,
    lat: -21.9709499
  },
  {
    lng: -41.7202087,
    lat: -21.9705844
  },
  {
    lng: -41.7202909,
    lat: -21.9702293
  },
  {
    lng: -41.7203773,
    lat: -21.9698784
  },
  {
    lng: -41.7204589,
    lat: -21.9695183
  },
  {
    lng: -41.7205192,
    lat: -21.9691612
  },
  {
    lng: -41.7205262,
    lat: -21.9690957
  },
  {
    lng: -41.7206223,
    lat: -21.9687445
  },
  {
    lng: -41.72064,
    lat: -21.9686774
  },
  {
    lng: -41.7206488,
    lat: -21.968502
  },
  {
    lng: -41.7206497,
    lat: -21.9684876
  },
  {
    lng: -41.720626,
    lat: -21.9684163
  },
  {
    lng: -41.7206298,
    lat: -21.9683264
  },
  {
    lng: -41.7206132,
    lat: -21.9680787
  },
  {
    lng: -41.7205568,
    lat: -21.9679824
  },
  {
    lng: -41.7203808,
    lat: -21.967659
  },
  {
    lng: -41.720349,
    lat: -21.9675982
  },
  {
    lng: -41.7201707,
    lat: -21.9672776
  },
  {
    lng: -41.7201539,
    lat: -21.967254
  },
  {
    lng: -41.7199454,
    lat: -21.9669447
  },
  {
    lng: -41.7198208,
    lat: -21.9667799
  },
  {
    lng: -41.7197627,
    lat: -21.9666134
  },
  {
    lng: -41.7195929,
    lat: -21.9662797
  },
  {
    lng: -41.7195651,
    lat: -21.9662352
  },
  {
    lng: -41.7193632,
    lat: -21.9660161
  },
  {
    lng: -41.7192487,
    lat: -21.9659529
  },
  {
    lng: -41.7191549,
    lat: -21.9658974
  },
  {
    lng: -41.7190706,
    lat: -21.9658117
  },
  {
    lng: -41.7189576,
    lat: -21.965785
  },
  {
    lng: -41.71882,
    lat: -21.9657594
  },
  {
    lng: -41.7186828,
    lat: -21.965662
  },
  {
    lng: -41.7183418,
    lat: -21.9654757
  },
  {
    lng: -41.7182079,
    lat: -21.9654153
  },
  {
    lng: -41.7179175,
    lat: -21.9653051
  },
  {
    lng: -41.7178173,
    lat: -21.9652304
  },
  {
    lng: -41.7174783,
    lat: -21.9650509
  },
  {
    lng: -41.7172767,
    lat: -21.964952
  },
  {
    lng: -41.7171473,
    lat: -21.9648793
  },
  {
    lng: -41.7170108,
    lat: -21.9648238
  },
  {
    lng: -41.7169052,
    lat: -21.9646641
  },
  {
    lng: -41.7168439,
    lat: -21.9645958
  },
  {
    lng: -41.7167451,
    lat: -21.9645977
  },
  {
    lng: -41.7166934,
    lat: -21.96456
  },
  {
    lng: -41.7166442,
    lat: -21.9645057
  },
  {
    lng: -41.7166037,
    lat: -21.9644609
  },
  {
    lng: -41.7165688,
    lat: -21.9644289
  },
  {
    lng: -41.7164307,
    lat: -21.9643541
  },
  {
    lng: -41.7163411,
    lat: -21.9642923
  },
  {
    lng: -41.7163251,
    lat: -21.964259
  },
  {
    lng: -41.7162785,
    lat: -21.9642106
  },
  {
    lng: -41.7162298,
    lat: -21.9641221
  },
  {
    lng: -41.7161761,
    lat: -21.9640552
  },
  {
    lng: -41.7160843,
    lat: -21.9639934
  },
  {
    lng: -41.7159486,
    lat: -21.9638776
  },
  {
    lng: -41.715828,
    lat: -21.9637489
  },
  {
    lng: -41.7155821,
    lat: -21.96346
  },
  {
    lng: -41.7155473,
    lat: -21.9634295
  },
  {
    lng: -41.7153559,
    lat: -21.9633383
  },
  {
    lng: -41.7152084,
    lat: -21.9632503
  },
  {
    lng: -41.7151661,
    lat: -21.9632177
  },
  {
    lng: -41.7149911,
    lat: -21.9630065
  },
  {
    lng: -41.7148903,
    lat: -21.9629431
  },
  {
    lng: -41.7147332,
    lat: -21.9628975
  },
  {
    lng: -41.7146384,
    lat: -21.9628057
  },
  {
    lng: -41.7145998,
    lat: -21.9626816
  },
  {
    lng: -41.7145322,
    lat: -21.9626416
  },
  {
    lng: -41.7144043,
    lat: -21.9625719
  },
  {
    lng: -41.7142597,
    lat: -21.9624784
  },
  {
    lng: -41.7142553,
    lat: -21.9624772
  },
  {
    lng: -41.7141269,
    lat: -21.9623921
  },
  {
    lng: -41.7140147,
    lat: -21.9622624
  },
  {
    lng: -41.7139109,
    lat: -21.9622216
  },
  {
    lng: -41.7139065,
    lat: -21.9622204
  },
  {
    lng: -41.7138573,
    lat: -21.9621513
  },
  {
    lng: -41.7137638,
    lat: -21.9620135
  },
  {
    lng: -41.7136634,
    lat: -21.9619508
  },
  {
    lng: -41.7135944,
    lat: -21.9618905
  },
  {
    lng: -41.7134559,
    lat: -21.9616688
  },
  {
    lng: -41.7133991,
    lat: -21.9614893
  },
  {
    lng: -41.7134413,
    lat: -21.9611204
  },
  {
    lng: -41.7134884,
    lat: -21.9609163
  },
  {
    lng: -41.7136088,
    lat: -21.9606933
  },
  {
    lng: -41.7137144,
    lat: -21.960468
  },
  {
    lng: -41.7138309,
    lat: -21.9602425
  },
  {
    lng: -41.7139574,
    lat: -21.959995
  },
  {
    lng: -41.7140956,
    lat: -21.9596502
  },
  {
    lng: -41.714182,
    lat: -21.9594693
  },
  {
    lng: -41.7142525,
    lat: -21.9593199
  },
  {
    lng: -41.714307,
    lat: -21.9592269
  },
  {
    lng: -41.714348,
    lat: -21.9591503
  },
  {
    lng: -41.7143981,
    lat: -21.9590567
  },
  {
    lng: -41.7145218,
    lat: -21.9588973
  },
  {
    lng: -41.7145698,
    lat: -21.9586814
  },
  {
    lng: -41.7146363,
    lat: -21.95856
  },
  {
    lng: -41.7146575,
    lat: -21.9585213
  },
  {
    lng: -41.7148199,
    lat: -21.958218
  },
  {
    lng: -41.7148834,
    lat: -21.9580369
  },
  {
    lng: -41.7150019,
    lat: -21.9577994
  },
  {
    lng: -41.7151915,
    lat: -21.9575015
  },
  {
    lng: -41.7152203,
    lat: -21.9574044
  },
  {
    lng: -41.7153552,
    lat: -21.9570624
  },
  {
    lng: -41.7154242,
    lat: -21.9568805
  },
  {
    lng: -41.7156284,
    lat: -21.9565622
  },
  {
    lng: -41.7157056,
    lat: -21.9563767
  },
  {
    lng: -41.7158297,
    lat: -21.9560262
  },
  {
    lng: -41.7159694,
    lat: -21.9557783
  },
  {
    lng: -41.716116,
    lat: -21.9554332
  },
  {
    lng: -41.7161961,
    lat: -21.9552056
  },
  {
    lng: -41.7162799,
    lat: -21.955107
  },
  {
    lng: -41.7162857,
    lat: -21.9550943
  },
  {
    lng: -41.7164455,
    lat: -21.9547639
  },
  {
    lng: -41.7165606,
    lat: -21.9544832
  },
  {
    lng: -41.7165925,
    lat: -21.9544053
  },
  {
    lng: -41.7167472,
    lat: -21.9540683
  },
  {
    lng: -41.7169023,
    lat: -21.9537271
  },
  {
    lng: -41.7169461,
    lat: -21.9536452
  },
  {
    lng: -41.7171408,
    lat: -21.9533135
  },
  {
    lng: -41.7172864,
    lat: -21.9529741
  },
  {
    lng: -41.7172972,
    lat: -21.952953
  },
  {
    lng: -41.7174727,
    lat: -21.9526233
  },
  {
    lng: -41.7176325,
    lat: -21.9522812
  },
  {
    lng: -41.7176978,
    lat: -21.9521108
  },
  {
    lng: -41.7177652,
    lat: -21.951935
  },
  {
    lng: -41.7179514,
    lat: -21.9515887
  },
  {
    lng: -41.7181369,
    lat: -21.9512416
  },
  {
    lng: -41.7182851,
    lat: -21.9509043
  },
  {
    lng: -41.7184719,
    lat: -21.9505702
  },
  {
    lng: -41.7186668,
    lat: -21.9502484
  },
  {
    lng: -41.718712,
    lat: -21.9501513
  },
  {
    lng: -41.7188151,
    lat: -21.9498287
  },
  {
    lng: -41.7188481,
    lat: -21.9497459
  },
  {
    lng: -41.7188945,
    lat: -21.9496291
  },
  {
    lng: -41.7190299,
    lat: -21.9493893
  },
  {
    lng: -41.7191291,
    lat: -21.9491239
  },
  {
    lng: -41.7192525,
    lat: -21.9488718
  },
  {
    lng: -41.7192958,
    lat: -21.9487855
  },
  {
    lng: -41.7193913,
    lat: -21.9485645
  },
  {
    lng: -41.719556,
    lat: -21.9482311
  },
  {
    lng: -41.7197161,
    lat: -21.9479826
  },
  {
    lng: -41.7198017,
    lat: -21.9477273
  },
  {
    lng: -41.7198918,
    lat: -21.947526
  },
  {
    lng: -41.7199899,
    lat: -21.9474117
  },
  {
    lng: -41.7201326,
    lat: -21.9471681
  },
  {
    lng: -41.7202046,
    lat: -21.9469882
  },
  {
    lng: -41.7202642,
    lat: -21.9468654
  },
  {
    lng: -41.7203293,
    lat: -21.9467652
  },
  {
    lng: -41.7203389,
    lat: -21.9467312
  },
  {
    lng: -41.7204017,
    lat: -21.9465222
  },
  {
    lng: -41.7204606,
    lat: -21.9463953
  },
  {
    lng: -41.720484,
    lat: -21.9463371
  },
  {
    lng: -41.7205644,
    lat: -21.9461588
  },
  {
    lng: -41.7207773,
    lat: -21.9458503
  },
  {
    lng: -41.7208138,
    lat: -21.9457983
  },
  {
    lng: -41.7208912,
    lat: -21.9455715
  },
  {
    lng: -41.7209011,
    lat: -21.9455305
  },
  {
    lng: -41.7209471,
    lat: -21.9453564
  },
  {
    lng: -41.7209562,
    lat: -21.9452917
  },
  {
    lng: -41.7209551,
    lat: -21.9452312
  },
  {
    lng: -41.7209815,
    lat: -21.9450829
  },
  {
    lng: -41.7210062,
    lat: -21.9449891
  },
  {
    lng: -41.721023,
    lat: -21.944889
  },
  {
    lng: -41.7210155,
    lat: -21.9448226
  },
  {
    lng: -41.7210101,
    lat: -21.9447752
  },
  {
    lng: -41.7209308,
    lat: -21.9445396
  },
  {
    lng: -41.720912,
    lat: -21.9444391
  },
  {
    lng: -41.7209214,
    lat: -21.9443749
  },
  {
    lng: -41.7209291,
    lat: -21.9443487
  },
  {
    lng: -41.7209331,
    lat: -21.9442911
  },
  {
    lng: -41.7208599,
    lat: -21.9441654
  },
  {
    lng: -41.7208018,
    lat: -21.9439887
  },
  {
    lng: -41.7207547,
    lat: -21.9438599
  },
  {
    lng: -41.720712,
    lat: -21.9437521
  },
  {
    lng: -41.7207082,
    lat: -21.9436006
  },
  {
    lng: -41.7207083,
    lat: -21.9435235
  },
  {
    lng: -41.7207014,
    lat: -21.9433917
  },
  {
    lng: -41.7206899,
    lat: -21.9433721
  },
  {
    lng: -41.7206116,
    lat: -21.9430182
  },
  {
    lng: -41.7205193,
    lat: -21.9426672
  },
  {
    lng: -41.7204643,
    lat: -21.9423091
  },
  {
    lng: -41.7204278,
    lat: -21.9421224
  },
  {
    lng: -41.7203828,
    lat: -21.9419092
  },
  {
    lng: -41.7203815,
    lat: -21.9417951
  },
  {
    lng: -41.7203813,
    lat: -21.9417756
  },
  {
    lng: -41.7203707,
    lat: -21.9417477
  },
  {
    lng: -41.7203257,
    lat: -21.9415686
  },
  {
    lng: -41.7202683,
    lat: -21.9413628
  },
  {
    lng: -41.7202526,
    lat: -21.9413088
  },
  {
    lng: -41.7202425,
    lat: -21.9412742
  },
  {
    lng: -41.7202229,
    lat: -21.9410723
  },
  {
    lng: -41.7202207,
    lat: -21.9409687
  },
  {
    lng: -41.7201675,
    lat: -21.9407765
  },
  {
    lng: -41.720135,
    lat: -21.9406399
  },
  {
    lng: -41.7200483,
    lat: -21.9404091
  },
  {
    lng: -41.7200258,
    lat: -21.9402141
  },
  {
    lng: -41.7200243,
    lat: -21.9400124
  },
  {
    lng: -41.7199758,
    lat: -21.9398435
  },
  {
    lng: -41.7199646,
    lat: -21.9397872
  },
  {
    lng: -41.7199494,
    lat: -21.9396578
  },
  {
    lng: -41.7199392,
    lat: -21.9395908
  },
  {
    lng: -41.7199362,
    lat: -21.9395731
  },
  {
    lng: -41.7198998,
    lat: -21.9394695
  },
  {
    lng: -41.7198473,
    lat: -21.9393489
  },
  {
    lng: -41.7198461,
    lat: -21.9393282
  },
  {
    lng: -41.7198431,
    lat: -21.9391684
  },
  {
    lng: -41.7198369,
    lat: -21.9390829
  },
  {
    lng: -41.7198019,
    lat: -21.9389931
  },
  {
    lng: -41.7197956,
    lat: -21.9388754
  },
  {
    lng: -41.7197163,
    lat: -21.9386533
  },
  {
    lng: -41.7196555,
    lat: -21.938554
  },
  {
    lng: -41.7196244,
    lat: -21.9384632
  },
  {
    lng: -41.7196275,
    lat: -21.9384414
  },
  {
    lng: -41.7196459,
    lat: -21.9383037
  },
  {
    lng: -41.7196438,
    lat: -21.9381646
  },
  {
    lng: -41.7195926,
    lat: -21.9380152
  },
  {
    lng: -41.7195502,
    lat: -21.9379197
  },
  {
    lng: -41.7195258,
    lat: -21.9378447
  },
  {
    lng: -41.7194811,
    lat: -21.9376794
  },
  {
    lng: -41.7194958,
    lat: -21.9375673
  },
  {
    lng: -41.7195054,
    lat: -21.9374357
  },
  {
    lng: -41.7194744,
    lat: -21.9372551
  },
  {
    lng: -41.7194402,
    lat: -21.9371455
  },
  {
    lng: -41.7193997,
    lat: -21.9370138
  },
  {
    lng: -41.7193523,
    lat: -21.9368948
  },
  {
    lng: -41.7193365,
    lat: -21.9368414
  },
  {
    lng: -41.7192736,
    lat: -21.9367241
  },
  {
    lng: -41.7192604,
    lat: -21.9365494
  },
  {
    lng: -41.719259,
    lat: -21.9362831
  },
  {
    lng: -41.7192585,
    lat: -21.9362795
  },
  {
    lng: -41.7192431,
    lat: -21.936203
  },
  {
    lng: -41.7191645,
    lat: -21.9359835
  },
  {
    lng: -41.7191487,
    lat: -21.9357087
  },
  {
    lng: -41.7191282,
    lat: -21.9355822
  },
  {
    lng: -41.7191246,
    lat: -21.93557
  },
  {
    lng: -41.7190223,
    lat: -21.9352165
  },
  {
    lng: -41.7189793,
    lat: -21.9351107
  },
  {
    lng: -41.7189295,
    lat: -21.9350284
  },
  {
    lng: -41.7188828,
    lat: -21.9348849
  },
  {
    lng: -41.718871,
    lat: -21.9348166
  },
  {
    lng: -41.7188679,
    lat: -21.934705
  },
  {
    lng: -41.7188667,
    lat: -21.9346993
  },
  {
    lng: -41.718856,
    lat: -21.9346196
  },
  {
    lng: -41.7188333,
    lat: -21.934468
  },
  {
    lng: -41.7187686,
    lat: -21.9343335
  },
  {
    lng: -41.7187389,
    lat: -21.9341771
  },
  {
    lng: -41.7187373,
    lat: -21.9341411
  },
  {
    lng: -41.7187116,
    lat: -21.9340321
  },
  {
    lng: -41.7186225,
    lat: -21.933872
  },
  {
    lng: -41.7185739,
    lat: -21.9337337
  },
  {
    lng: -41.7184844,
    lat: -21.93359
  },
  {
    lng: -41.7182268,
    lat: -21.9333194
  },
  {
    lng: -41.717943,
    lat: -21.9330682
  },
  {
    lng: -41.7176666,
    lat: -21.932812
  },
  {
    lng: -41.7173827,
    lat: -21.9325583
  },
  {
    lng: -41.7171153,
    lat: -21.9322942
  },
  {
    lng: -41.7168797,
    lat: -21.9320067
  },
  {
    lng: -41.716627,
    lat: -21.9317322
  },
  {
    lng: -41.7164274,
    lat: -21.9314191
  },
  {
    lng: -41.716221,
    lat: -21.9311137
  },
  {
    lng: -41.7160526,
    lat: -21.9307877
  },
  {
    lng: -41.7159057,
    lat: -21.9304533
  },
  {
    lng: -41.7158373,
    lat: -21.9300963
  },
  {
    lng: -41.7158236,
    lat: -21.9300523
  },
  {
    lng: -41.7157277,
    lat: -21.9297457
  },
  {
    lng: -41.7156392,
    lat: -21.9293931
  },
  {
    lng: -41.7155338,
    lat: -21.9290438
  },
  {
    lng: -41.715383,
    lat: -21.9287083
  },
  {
    lng: -41.7152685,
    lat: -21.9283616
  },
  {
    lng: -41.7152397,
    lat: -21.9279991
  },
  {
    lng: -41.7151148,
    lat: -21.9277391
  },
  {
    lng: -41.7149944,
    lat: -21.9274171
  },
  {
    lng: -41.7149224,
    lat: -21.9271249
  },
  {
    lng: -41.7148586,
    lat: -21.9268576
  },
  {
    lng: -41.7147887,
    lat: -21.9265009
  },
  {
    lng: -41.7147033,
    lat: -21.9262406
  },
  {
    lng: -41.7146934,
    lat: -21.9262103
  },
  {
    lng: -41.7146214,
    lat: -21.9260242
  },
  {
    lng: -41.7145211,
    lat: -21.9257643
  },
  {
    lng: -41.7144191,
    lat: -21.9255011
  },
  {
    lng: -41.7143216,
    lat: -21.9251485
  },
  {
    lng: -41.7142132,
    lat: -21.9248008
  },
  {
    lng: -41.714117,
    lat: -21.9244494
  },
  {
    lng: -41.7140144,
    lat: -21.9240999
  },
  {
    lng: -41.7139496,
    lat: -21.9237424
  },
  {
    lng: -41.7139061,
    lat: -21.9233794
  },
  {
    lng: -41.7139634,
    lat: -21.9230188
  },
  {
    lng: -41.7141016,
    lat: -21.9226809
  },
  {
    lng: -41.7142878,
    lat: -21.9223556
  },
  {
    lng: -41.7144215,
    lat: -21.9220148
  },
  {
    lng: -41.7145136,
    lat: -21.9216601
  },
  {
    lng: -41.7144904,
    lat: -21.9212979
  },
  {
    lng: -41.7144441,
    lat: -21.9209356
  },
  {
    lng: -41.7143734,
    lat: -21.9205744
  },
  {
    lng: -41.7143002,
    lat: -21.920218
  },
  {
    lng: -41.7142416,
    lat: -21.9198602
  },
  {
    lng: -41.7141771,
    lat: -21.9195023
  },
  {
    lng: -41.7141705,
    lat: -21.9194551
  },
  {
    lng: -41.7141267,
    lat: -21.9191426
  },
  {
    lng: -41.7141168,
    lat: -21.9188436
  },
  {
    lng: -41.7141146,
    lat: -21.9187785
  },
  {
    lng: -41.7141159,
    lat: -21.9184151
  },
  {
    lng: -41.7141159,
    lat: -21.9182673
  },
  {
    lng: -41.7141159,
    lat: -21.9180501
  },
  {
    lng: -41.7141791,
    lat: -21.917691
  },
  {
    lng: -41.7142844,
    lat: -21.9173394
  },
  {
    lng: -41.7144083,
    lat: -21.9169918
  },
  {
    lng: -41.7145506,
    lat: -21.9166408
  },
  {
    lng: -41.7146744,
    lat: -21.9162978
  },
  {
    lng: -41.7151987,
    lat: -21.9146894
  },
  {
    lng: -41.7153478,
    lat: -21.9141973
  },
  {
    lng: -41.7156383,
    lat: -21.913238
  },
  {
    lng: -41.7160254,
    lat: -21.9121526
  },
  {
    lng: -41.7160977,
    lat: -21.9113885
  },
  {
    lng: -41.7160839,
    lat: -21.9113183
  },
  {
    lng: -41.7159967,
    lat: -21.9110514
  },
  {
    lng: -41.7157701,
    lat: -21.9107548
  },
  {
    lng: -41.7157374,
    lat: -21.9107163
  },
  {
    lng: -41.7155084,
    lat: -21.9104207
  },
  {
    lng: -41.7153122,
    lat: -21.9101076
  },
  {
    lng: -41.715078,
    lat: -21.9098155
  },
  {
    lng: -41.7149738,
    lat: -21.9096884
  },
  {
    lng: -41.7148417,
    lat: -21.9095273
  },
  {
    lng: -41.7146235,
    lat: -21.9092231
  },
  {
    lng: -41.7144136,
    lat: -21.9089176
  },
  {
    lng: -41.7143051,
    lat: -21.9087765
  },
  {
    lng: -41.7141841,
    lat: -21.9086192
  },
  {
    lng: -41.7139259,
    lat: -21.9083428
  },
  {
    lng: -41.7136551,
    lat: -21.9080844
  },
  {
    lng: -41.7134032,
    lat: -21.907807
  },
  {
    lng: -41.7131867,
    lat: -21.907505
  },
  {
    lng: -41.7129791,
    lat: -21.9071978
  },
  {
    lng: -41.7127873,
    lat: -21.9068822
  },
  {
    lng: -41.7126775,
    lat: -21.9065344
  },
  {
    lng: -41.7126793,
    lat: -21.9065219
  },
  {
    lng: -41.7128011,
    lat: -21.9061754
  },
  {
    lng: -41.7128185,
    lat: -21.9061225
  },
  {
    lng: -41.7128248,
    lat: -21.9060971
  },
  {
    lng: -41.7128261,
    lat: -21.9060906
  },
  {
    lng: -41.7128358,
    lat: -21.9059853
  },
  {
    lng: -41.7127894,
    lat: -21.9059131
  },
  {
    lng: -41.7126957,
    lat: -21.9058817
  },
  {
    lng: -41.7126647,
    lat: -21.9058956
  },
  {
    lng: -41.712526,
    lat: -21.9060123
  },
  {
    lng: -41.7123335,
    lat: -21.9061704
  },
  {
    lng: -41.7123093,
    lat: -21.9061819
  },
  {
    lng: -41.712159,
    lat: -21.9062429
  },
  {
    lng: -41.7121232,
    lat: -21.9062455
  },
  {
    lng: -41.7119751,
    lat: -21.9061935
  },
  {
    lng: -41.7119573,
    lat: -21.9061829
  },
  {
    lng: -41.7119263,
    lat: -21.9061649
  },
  {
    lng: -41.7118403,
    lat: -21.9061152
  },
  {
    lng: -41.711801,
    lat: -21.906088
  },
  {
    lng: -41.7117515,
    lat: -21.9060514
  },
  {
    lng: -41.7115488,
    lat: -21.9059046
  },
  {
    lng: -41.7114088,
    lat: -21.9057466
  },
  {
    lng: -41.711323,
    lat: -21.905654
  },
  {
    lng: -41.711084,
    lat: -21.9055425
  },
  {
    lng: -41.7107574,
    lat: -21.9053484
  },
  {
    lng: -41.7105801,
    lat: -21.9052183
  },
  {
    lng: -41.7105675,
    lat: -21.9052051
  },
  {
    lng: -41.7104419,
    lat: -21.9050845
  },
  {
    lng: -41.7103218,
    lat: -21.904907
  },
  {
    lng: -41.7102994,
    lat: -21.9048247
  },
  {
    lng: -41.7102896,
    lat: -21.9046591
  },
  {
    lng: -41.7103482,
    lat: -21.9044736
  },
  {
    lng: -41.71038,
    lat: -21.9044349
  },
  {
    lng: -41.7105232,
    lat: -21.9043351
  },
  {
    lng: -41.7105948,
    lat: -21.9042905
  },
  {
    lng: -41.7106219,
    lat: -21.9042455
  },
  {
    lng: -41.7106223,
    lat: -21.9042266
  },
  {
    lng: -41.7106031,
    lat: -21.9041793
  },
  {
    lng: -41.7105864,
    lat: -21.9040757
  },
  {
    lng: -41.7105312,
    lat: -21.9039965
  },
  {
    lng: -41.7104294,
    lat: -21.9039332
  },
  {
    lng: -41.7103154,
    lat: -21.9038502
  },
  {
    lng: -41.7102966,
    lat: -21.9037713
  },
  {
    lng: -41.7103532,
    lat: -21.9037125
  },
  {
    lng: -41.7104214,
    lat: -21.9036415
  },
  {
    lng: -41.7106442,
    lat: -21.9036086
  },
  {
    lng: -41.7107625,
    lat: -21.9035982
  },
  {
    lng: -41.7109045,
    lat: -21.9036101
  },
  {
    lng: -41.7110502,
    lat: -21.9036667
  },
  {
    lng: -41.7112834,
    lat: -21.9035774
  },
  {
    lng: -41.7113163,
    lat: -21.9035266
  },
  {
    lng: -41.7114162,
    lat: -21.9034503
  },
  {
    lng: -41.7116794,
    lat: -21.9033617
  },
  {
    lng: -41.7117856,
    lat: -21.9031991
  },
  {
    lng: -41.7117435,
    lat: -21.9030211
  },
  {
    lng: -41.7116939,
    lat: -21.902848
  },
  {
    lng: -41.7117008,
    lat: -21.9027106
  },
  {
    lng: -41.7116975,
    lat: -21.9024999
  },
  {
    lng: -41.7117004,
    lat: -21.902135
  },
  {
    lng: -41.7116968,
    lat: -21.9020646
  },
  {
    lng: -41.7116498,
    lat: -21.9018909
  },
  {
    lng: -41.7115198,
    lat: -21.9017007
  },
  {
    lng: -41.7115048,
    lat: -21.9014465
  },
  {
    lng: -41.7116498,
    lat: -21.9013436
  },
  {
    lng: -41.7118053,
    lat: -21.9013341
  },
  {
    lng: -41.712019,
    lat: -21.9014537
  },
  {
    lng: -41.7121973,
    lat: -21.9013699
  },
  {
    lng: -41.712286,
    lat: -21.901233
  },
  {
    lng: -41.7122895,
    lat: -21.901209
  },
  {
    lng: -41.712153,
    lat: -21.9010992
  },
  {
    lng: -41.7119955,
    lat: -21.9010478
  },
  {
    lng: -41.7118493,
    lat: -21.9010245
  },
  {
    lng: -41.7117291,
    lat: -21.9009882
  },
  {
    lng: -41.7116597,
    lat: -21.9009454
  },
  {
    lng: -41.7115675,
    lat: -21.9008992
  },
  {
    lng: -41.711397,
    lat: -21.900915
  },
  {
    lng: -41.7111587,
    lat: -21.9008477
  },
  {
    lng: -41.7111529,
    lat: -21.900846
  },
  {
    lng: -41.7110983,
    lat: -21.9008281
  },
  {
    lng: -41.7109412,
    lat: -21.9007821
  },
  {
    lng: -41.7107428,
    lat: -21.90072
  },
  {
    lng: -41.7106235,
    lat: -21.9006847
  },
  {
    lng: -41.7104075,
    lat: -21.9006262
  },
  {
    lng: -41.7103968,
    lat: -21.9006226
  },
  {
    lng: -41.7102239,
    lat: -21.9005478
  },
  {
    lng: -41.7099441,
    lat: -21.9005408
  },
  {
    lng: -41.7097751,
    lat: -21.9005245
  },
  {
    lng: -41.7097052,
    lat: -21.900506
  },
  {
    lng: -41.7095751,
    lat: -21.9004387
  },
  {
    lng: -41.7095245,
    lat: -21.9003581
  },
  {
    lng: -41.7094959,
    lat: -21.9001276
  },
  {
    lng: -41.7094184,
    lat: -21.9000462
  },
  {
    lng: -41.7093275,
    lat: -21.8998445
  },
  {
    lng: -41.7093127,
    lat: -21.8995576
  },
  {
    lng: -41.7093614,
    lat: -21.8993317
  },
  {
    lng: -41.7094615,
    lat: -21.8989658
  },
  {
    lng: -41.7094691,
    lat: -21.8989371
  },
  {
    lng: -41.7095153,
    lat: -21.8988238
  },
  {
    lng: -41.7095187,
    lat: -21.8988057
  },
  {
    lng: -41.7095523,
    lat: -21.8986312
  },
  {
    lng: -41.7095133,
    lat: -21.8982835
  },
  {
    lng: -41.7094599,
    lat: -21.8978941
  },
  {
    lng: -41.7094364,
    lat: -21.8978039
  },
  {
    lng: -41.7093195,
    lat: -21.8976239
  },
  {
    lng: -41.7091799,
    lat: -21.8973673
  },
  {
    lng: -41.709032,
    lat: -21.8970613
  },
  {
    lng: -41.7088714,
    lat: -21.8967178
  },
  {
    lng: -41.708767,
    lat: -21.8965211
  },
  {
    lng: -41.7087091,
    lat: -21.8963587
  },
  {
    lng: -41.7087877,
    lat: -21.8961898
  },
  {
    lng: -41.7089374,
    lat: -21.8960964
  },
  {
    lng: -41.7091745,
    lat: -21.8960608
  },
  {
    lng: -41.7093582,
    lat: -21.8961066
  },
  {
    lng: -41.709544,
    lat: -21.8961374
  },
  {
    lng: -41.7096975,
    lat: -21.8960851
  },
  {
    lng: -41.7097412,
    lat: -21.8959441
  },
  {
    lng: -41.7097287,
    lat: -21.8959204
  },
  {
    lng: -41.7096376,
    lat: -21.8957477
  },
  {
    lng: -41.7095959,
    lat: -21.8955884
  },
  {
    lng: -41.7096216,
    lat: -21.8953719
  },
  {
    lng: -41.7096775,
    lat: -21.8951906
  },
  {
    lng: -41.7096764,
    lat: -21.894958
  },
  {
    lng: -41.7096444,
    lat: -21.8948114
  },
  {
    lng: -41.7096374,
    lat: -21.8947792
  },
  {
    lng: -41.7095954,
    lat: -21.8945871
  },
  {
    lng: -41.7095886,
    lat: -21.8945405
  },
  {
    lng: -41.7094193,
    lat: -21.8942969
  },
  {
    lng: -41.7092141,
    lat: -21.8941527
  },
  {
    lng: -41.7089169,
    lat: -21.8941542
  },
  {
    lng: -41.7088082,
    lat: -21.894295
  },
  {
    lng: -41.7085707,
    lat: -21.8942753
  },
  {
    lng: -41.7084365,
    lat: -21.8941471
  },
  {
    lng: -41.7083588,
    lat: -21.8939795
  },
  {
    lng: -41.7082636,
    lat: -21.8938185
  },
  {
    lng: -41.7080929,
    lat: -21.8934827
  },
  {
    lng: -41.7080492,
    lat: -21.8934078
  },
  {
    lng: -41.7078715,
    lat: -21.8930696
  },
  {
    lng: -41.707791,
    lat: -21.892969
  },
  {
    lng: -41.7076337,
    lat: -21.8928527
  },
  {
    lng: -41.707412,
    lat: -21.8928228
  },
  {
    lng: -41.7071763,
    lat: -21.8928194
  },
  {
    lng: -41.7070245,
    lat: -21.8927503
  },
  {
    lng: -41.7069906,
    lat: -21.8926536
  },
  {
    lng: -41.7070052,
    lat: -21.8925765
  },
  {
    lng: -41.7070597,
    lat: -21.8925534
  },
  {
    lng: -41.7071486,
    lat: -21.8924891
  },
  {
    lng: -41.7070879,
    lat: -21.892365
  },
  {
    lng: -41.7069091,
    lat: -21.8923077
  },
  {
    lng: -41.7066363,
    lat: -21.8923457
  },
  {
    lng: -41.7064631,
    lat: -21.8923861
  },
  {
    lng: -41.7063419,
    lat: -21.8924806
  },
  {
    lng: -41.7062632,
    lat: -21.8926115
  },
  {
    lng: -41.7062474,
    lat: -21.8926374
  },
  {
    lng: -41.7061969,
    lat: -21.8926791
  },
  {
    lng: -41.7060536,
    lat: -21.8926883
  },
  {
    lng: -41.7058532,
    lat: -21.8926534
  },
  {
    lng: -41.7057143,
    lat: -21.8925954
  },
  {
    lng: -41.7055481,
    lat: -21.8924769
  },
  {
    lng: -41.705431,
    lat: -21.8923263
  },
  {
    lng: -41.7053932,
    lat: -21.8921552
  },
  {
    lng: -41.7054074,
    lat: -21.892096
  },
  {
    lng: -41.7054323,
    lat: -21.8918369
  },
  {
    lng: -41.7054151,
    lat: -21.8917373
  },
  {
    lng: -41.7052388,
    lat: -21.8915618
  },
  {
    lng: -41.7050818,
    lat: -21.8914842
  },
  {
    lng: -41.7048552,
    lat: -21.891468
  },
  {
    lng: -41.7047119,
    lat: -21.8915358
  },
  {
    lng: -41.704558,
    lat: -21.8916717
  },
  {
    lng: -41.7043608,
    lat: -21.8918865
  },
  {
    lng: -41.7041346,
    lat: -21.8919002
  },
  {
    lng: -41.703919,
    lat: -21.8917281
  },
  {
    lng: -41.7037232,
    lat: -21.8915249
  },
  {
    lng: -41.7036392,
    lat: -21.8913709
  },
  {
    lng: -41.703317,
    lat: -21.8912738
  },
  {
    lng: -41.7030897,
    lat: -21.8913321
  },
  {
    lng: -41.7029699,
    lat: -21.8913661
  },
  {
    lng: -41.7028387,
    lat: -21.8914262
  },
  {
    lng: -41.7026755,
    lat: -21.8914274
  },
  {
    lng: -41.702614,
    lat: -21.8913376
  },
  {
    lng: -41.7026004,
    lat: -21.8912055
  },
  {
    lng: -41.7026385,
    lat: -21.8911007
  },
  {
    lng: -41.7028406,
    lat: -21.8907783
  },
  {
    lng: -41.7028511,
    lat: -21.890765
  },
  {
    lng: -41.7030385,
    lat: -21.8905496
  },
  {
    lng: -41.7031782,
    lat: -21.890479
  },
  {
    lng: -41.7033604,
    lat: -21.890424
  },
  {
    lng: -41.7034967,
    lat: -21.8903052
  },
  {
    lng: -41.7035021,
    lat: -21.8901646
  },
  {
    lng: -41.7034645,
    lat: -21.890125
  },
  {
    lng: -41.7033587,
    lat: -21.8900494
  },
  {
    lng: -41.7033104,
    lat: -21.8900009
  },
  {
    lng: -41.7032722,
    lat: -21.8898692
  },
  {
    lng: -41.7032778,
    lat: -21.8898088
  },
  {
    lng: -41.7032966,
    lat: -21.8898019
  },
  {
    lng: -41.7034045,
    lat: -21.8897958
  },
  {
    lng: -41.7035425,
    lat: -21.8897622
  },
  {
    lng: -41.703668,
    lat: -21.8897113
  },
  {
    lng: -41.7037375,
    lat: -21.8896672
  },
  {
    lng: -41.7039333,
    lat: -21.8896665
  },
  {
    lng: -41.7041803,
    lat: -21.8896606
  },
  {
    lng: -41.7044701,
    lat: -21.8896813
  },
  {
    lng: -41.7046632,
    lat: -21.889694
  },
  {
    lng: -41.7046951,
    lat: -21.8896881
  },
  {
    lng: -41.7050834,
    lat: -21.8896924
  },
  {
    lng: -41.7054345,
    lat: -21.889777
  },
  {
    lng: -41.705443,
    lat: -21.889779
  },
  {
    lng: -41.7058204,
    lat: -21.8898334
  },
  {
    lng: -41.706179,
    lat: -21.8899285
  },
  {
    lng: -41.7062172,
    lat: -21.8899303
  },
  {
    lng: -41.7066216,
    lat: -21.8899419
  },
  {
    lng: -41.7068761,
    lat: -21.8899799
  },
  {
    lng: -41.7069368,
    lat: -21.8899958
  },
  {
    lng: -41.7071465,
    lat: -21.8900313
  },
  {
    lng: -41.7073448,
    lat: -21.890065
  },
  {
    lng: -41.7074023,
    lat: -21.8900685
  },
  {
    lng: -41.7078369,
    lat: -21.8901035
  },
  {
    lng: -41.7082216,
    lat: -21.8901771
  },
  {
    lng: -41.7083045,
    lat: -21.8901943
  },
  {
    lng: -41.7086966,
    lat: -21.8902337
  },
  {
    lng: -41.7087818,
    lat: -21.8902478
  },
  {
    lng: -41.7090761,
    lat: -21.8903043
  },
  {
    lng: -41.7091914,
    lat: -21.8903264
  },
  {
    lng: -41.7094772,
    lat: -21.8903543
  },
  {
    lng: -41.7098067,
    lat: -21.8904355
  },
  {
    lng: -41.7101236,
    lat: -21.89049
  },
  {
    lng: -41.7103306,
    lat: -21.8905697
  },
  {
    lng: -41.7107143,
    lat: -21.8906195
  },
  {
    lng: -41.7110996,
    lat: -21.8906693
  },
  {
    lng: -41.7112994,
    lat: -21.8907223
  },
  {
    lng: -41.7117087,
    lat: -21.890766
  },
  {
    lng: -41.7120525,
    lat: -21.8907388
  },
  {
    lng: -41.7123752,
    lat: -21.8907034
  },
  {
    lng: -41.7125312,
    lat: -21.8906403
  },
  {
    lng: -41.712682,
    lat: -21.8904518
  },
  {
    lng: -41.712803,
    lat: -21.8902408
  },
  {
    lng: -41.7129149,
    lat: -21.8900577
  },
  {
    lng: -41.7129611,
    lat: -21.889982
  },
  {
    lng: -41.7130749,
    lat: -21.8898735
  },
  {
    lng: -41.7131484,
    lat: -21.8898195
  },
  {
    lng: -41.713279,
    lat: -21.8897743
  },
  {
    lng: -41.7132985,
    lat: -21.8897229
  },
  {
    lng: -41.7133633,
    lat: -21.8896619
  },
  {
    lng: -41.7134974,
    lat: -21.8896372
  },
  {
    lng: -41.7136596,
    lat: -21.889675
  },
  {
    lng: -41.7137579,
    lat: -21.8897104
  },
  {
    lng: -41.7139462,
    lat: -21.8896852
  },
  {
    lng: -41.7141016,
    lat: -21.8896637
  },
  {
    lng: -41.7142196,
    lat: -21.8897224
  },
  {
    lng: -41.7143085,
    lat: -21.8898222
  },
  {
    lng: -41.7143922,
    lat: -21.8899592
  },
  {
    lng: -41.7145054,
    lat: -21.8901001
  },
  {
    lng: -41.7145989,
    lat: -21.8901531
  },
  {
    lng: -41.7148102,
    lat: -21.8900032
  },
  {
    lng: -41.7149455,
    lat: -21.8898996
  },
  {
    lng: -41.7150496,
    lat: -21.8897855
  },
  {
    lng: -41.7151322,
    lat: -21.8896839
  },
  {
    lng: -41.7151475,
    lat: -21.8895629
  },
  {
    lng: -41.7151812,
    lat: -21.889449
  },
  {
    lng: -41.7151893,
    lat: -21.8893898
  },
  {
    lng: -41.7151721,
    lat: -21.889222
  },
  {
    lng: -41.715242,
    lat: -21.8891423
  },
  {
    lng: -41.7154078,
    lat: -21.8891401
  },
  {
    lng: -41.715525,
    lat: -21.8891981
  },
  {
    lng: -41.7156191,
    lat: -21.8893219
  },
  {
    lng: -41.7157586,
    lat: -21.8894453
  },
  {
    lng: -41.7158915,
    lat: -21.8894387
  },
  {
    lng: -41.7158922,
    lat: -21.8893213
  },
  {
    lng: -41.7159078,
    lat: -21.8891611
  },
  {
    lng: -41.7159553,
    lat: -21.8890425
  },
  {
    lng: -41.7159757,
    lat: -21.8888834
  },
  {
    lng: -41.7159704,
    lat: -21.8887711
  },
  {
    lng: -41.7160431,
    lat: -21.8886283
  },
  {
    lng: -41.7161511,
    lat: -21.8886092
  },
  {
    lng: -41.7162517,
    lat: -21.8886711
  },
  {
    lng: -41.7163885,
    lat: -21.888805
  },
  {
    lng: -41.7163903,
    lat: -21.888807
  },
  {
    lng: -41.7164946,
    lat: -21.8889217
  },
  {
    lng: -41.7165749,
    lat: -21.8889911
  },
  {
    lng: -41.716694,
    lat: -21.8890892
  },
  {
    lng: -41.7168322,
    lat: -21.8891392
  },
  {
    lng: -41.7170122,
    lat: -21.8891158
  },
  {
    lng: -41.7171639,
    lat: -21.8890573
  },
  {
    lng: -41.7172747,
    lat: -21.8889807
  },
  {
    lng: -41.7172389,
    lat: -21.888885
  },
  {
    lng: -41.7171443,
    lat: -21.8888155
  },
  {
    lng: -41.7169729,
    lat: -21.888805
  },
  {
    lng: -41.7168335,
    lat: -21.8887971
  },
  {
    lng: -41.7167212,
    lat: -21.8887311
  },
  {
    lng: -41.7167164,
    lat: -21.8886464
  },
  {
    lng: -41.7167287,
    lat: -21.8885376
  },
  {
    lng: -41.7167376,
    lat: -21.8884314
  },
  {
    lng: -41.7168621,
    lat: -21.8881705
  },
  {
    lng: -41.7169168,
    lat: -21.8880243
  },
  {
    lng: -41.7171593,
    lat: -21.8879987
  },
  {
    lng: -41.7173731,
    lat: -21.8881143
  },
  {
    lng: -41.7174652,
    lat: -21.8882101
  },
  {
    lng: -41.7175515,
    lat: -21.8883686
  },
  {
    lng: -41.7175601,
    lat: -21.888481
  },
  {
    lng: -41.7175847,
    lat: -21.8886002
  },
  {
    lng: -41.717702,
    lat: -21.8886296
  },
  {
    lng: -41.7178865,
    lat: -21.8885575
  },
  {
    lng: -41.7178914,
    lat: -21.8884438
  },
  {
    lng: -41.7178345,
    lat: -21.8883475
  },
  {
    lng: -41.7177462,
    lat: -21.8882101
  },
  {
    lng: -41.717731,
    lat: -21.8880714
  },
  {
    lng: -41.7179058,
    lat: -21.8879861
  },
  {
    lng: -41.7180589,
    lat: -21.8880267
  },
  {
    lng: -41.7181952,
    lat: -21.8880548
  },
  {
    lng: -41.7183239,
    lat: -21.8880571
  },
  {
    lng: -41.7184791,
    lat: -21.8880105
  },
  {
    lng: -41.7186344,
    lat: -21.8879214
  },
  {
    lng: -41.718849,
    lat: -21.8877911
  },
  {
    lng: -41.7189864,
    lat: -21.8877108
  },
  {
    lng: -41.7191932,
    lat: -21.8875851
  },
  {
    lng: -41.719325,
    lat: -21.8874996
  },
  {
    lng: -41.719362,
    lat: -21.8874277
  },
  {
    lng: -41.7193655,
    lat: -21.8872686
  },
  {
    lng: -41.719384,
    lat: -21.887158
  },
  {
    lng: -41.7192902,
    lat: -21.8870972
  },
  {
    lng: -41.7191986,
    lat: -21.8870535
  },
  {
    lng: -41.7191251,
    lat: -21.8869659
  },
  {
    lng: -41.7191039,
    lat: -21.886854
  },
  {
    lng: -41.7191325,
    lat: -21.8867625
  },
  {
    lng: -41.719197,
    lat: -21.8866999
  },
  {
    lng: -41.7195072,
    lat: -21.8866563
  },
  {
    lng: -41.7196531,
    lat: -21.8867334
  },
  {
    lng: -41.7198125,
    lat: -21.8868
  },
  {
    lng: -41.7199727,
    lat: -21.8867896
  },
  {
    lng: -41.7200532,
    lat: -21.8867299
  },
  {
    lng: -41.7201882,
    lat: -21.8866337
  },
  {
    lng: -41.7203098,
    lat: -21.8865564
  },
  {
    lng: -41.7204647,
    lat: -21.8865588
  },
  {
    lng: -41.7206009,
    lat: -21.8866045
  },
  {
    lng: -41.7206971,
    lat: -21.8867144
  },
  {
    lng: -41.7207045,
    lat: -21.8868099
  },
  {
    lng: -41.7206505,
    lat: -21.8868803
  },
  {
    lng: -41.7205968,
    lat: -21.886976
  },
  {
    lng: -41.7206207,
    lat: -21.8870983
  },
  {
    lng: -41.720684,
    lat: -21.8872437
  },
  {
    lng: -41.7207726,
    lat: -21.8874563
  },
  {
    lng: -41.7209081,
    lat: -21.8876777
  },
  {
    lng: -41.721002,
    lat: -21.8878504
  },
  {
    lng: -41.7210217,
    lat: -21.8878866
  },
  {
    lng: -41.7210933,
    lat: -21.8880985
  },
  {
    lng: -41.7211763,
    lat: -21.8883226
  },
  {
    lng: -41.7212726,
    lat: -21.8885504
  },
  {
    lng: -41.7213093,
    lat: -21.8886374
  },
  {
    lng: -41.7214575,
    lat: -21.8887977
  },
  {
    lng: -41.7216208,
    lat: -21.8889397
  },
  {
    lng: -41.721849,
    lat: -21.889068
  },
  {
    lng: -41.7220855,
    lat: -21.889113
  },
  {
    lng: -41.7223592,
    lat: -21.8891293
  },
  {
    lng: -41.7225942,
    lat: -21.8891771
  },
  {
    lng: -41.7227877,
    lat: -21.8892019
  },
  {
    lng: -41.7229673,
    lat: -21.889217
  },
  {
    lng: -41.7229317,
    lat: -21.8893133
  },
  {
    lng: -41.7228778,
    lat: -21.8894097
  },
  {
    lng: -41.7229341,
    lat: -21.8894712
  },
  {
    lng: -41.7230703,
    lat: -21.889493
  },
  {
    lng: -41.7232383,
    lat: -21.8894429
  },
  {
    lng: -41.7234032,
    lat: -21.8893841
  },
  {
    lng: -41.7235665,
    lat: -21.8894336
  },
  {
    lng: -41.7236393,
    lat: -21.8894891
  },
  {
    lng: -41.7237044,
    lat: -21.8896109
  },
  {
    lng: -41.7237018,
    lat: -21.8897426
  },
  {
    lng: -41.7237415,
    lat: -21.8900154
  },
  {
    lng: -41.7238618,
    lat: -21.8900686
  },
  {
    lng: -41.724101,
    lat: -21.8900161
  },
  {
    lng: -41.7242469,
    lat: -21.8898892
  },
  {
    lng: -41.7242546,
    lat: -21.8898745
  },
  {
    lng: -41.7243609,
    lat: -21.8896722
  },
  {
    lng: -41.7244592,
    lat: -21.8895308
  },
  {
    lng: -41.7245445,
    lat: -21.8893473
  },
  {
    lng: -41.7246567,
    lat: -21.8891727
  },
  {
    lng: -41.7247665,
    lat: -21.8890742
  },
  {
    lng: -41.7248799,
    lat: -21.8888383
  },
  {
    lng: -41.7249862,
    lat: -21.8887998
  },
  {
    lng: -41.7250903,
    lat: -21.8888489
  },
  {
    lng: -41.7252482,
    lat: -21.8890018
  },
  {
    lng: -41.72535,
    lat: -21.8889964
  },
  {
    lng: -41.725455,
    lat: -21.8888699
  },
  {
    lng: -41.7255682,
    lat: -21.8886976
  },
  {
    lng: -41.7256639,
    lat: -21.8885492
  },
  {
    lng: -41.7257535,
    lat: -21.8884527
  },
  {
    lng: -41.7258825,
    lat: -21.888438
  },
  {
    lng: -41.7260026,
    lat: -21.8885162
  },
  {
    lng: -41.7261305,
    lat: -21.8885741
  },
  {
    lng: -41.7262372,
    lat: -21.8885173
  },
  {
    lng: -41.7262582,
    lat: -21.8883438
  },
  {
    lng: -41.726296,
    lat: -21.8881534
  },
  {
    lng: -41.7264128,
    lat: -21.8880364
  },
  {
    lng: -41.7265951,
    lat: -21.8880227
  },
  {
    lng: -41.7268236,
    lat: -21.8880336
  },
  {
    lng: -41.726955,
    lat: -21.8881341
  },
  {
    lng: -41.7269527,
    lat: -21.8883256
  },
  {
    lng: -41.7269681,
    lat: -21.8884101
  },
  {
    lng: -41.7270054,
    lat: -21.8884978
  },
  {
    lng: -41.727162,
    lat: -21.8886163
  },
  {
    lng: -41.7273233,
    lat: -21.8886696
  },
  {
    lng: -41.7275677,
    lat: -21.8887766
  },
  {
    lng: -41.7277492,
    lat: -21.8888644
  },
  {
    lng: -41.7277994,
    lat: -21.889069
  },
  {
    lng: -41.7277795,
    lat: -21.8892515
  },
  {
    lng: -41.7278823,
    lat: -21.8893557
  },
  {
    lng: -41.7281134,
    lat: -21.8894472
  },
  {
    lng: -41.7282376,
    lat: -21.8894872
  },
  {
    lng: -41.7283384,
    lat: -21.889604
  },
  {
    lng: -41.7284521,
    lat: -21.8896461
  },
  {
    lng: -41.7285312,
    lat: -21.8896569
  },
  {
    lng: -41.7285512,
    lat: -21.8897428
  },
  {
    lng: -41.728671,
    lat: -21.8898045
  },
  {
    lng: -41.7287586,
    lat: -21.8898155
  },
  {
    lng: -41.7288461,
    lat: -21.8898264
  },
  {
    lng: -41.7289719,
    lat: -21.8897568
  },
  {
    lng: -41.7290161,
    lat: -21.8897323
  },
  {
    lng: -41.7290785,
    lat: -21.8896
  },
  {
    lng: -41.7290923,
    lat: -21.8893304
  },
  {
    lng: -41.7290554,
    lat: -21.8891815
  },
  {
    lng: -41.7290722,
    lat: -21.8890462
  },
  {
    lng: -41.7292131,
    lat: -21.8889739
  },
  {
    lng: -41.7293352,
    lat: -21.8890138
  },
  {
    lng: -41.7294437,
    lat: -21.8891391
  },
  {
    lng: -41.7295698,
    lat: -21.8893084
  },
  {
    lng: -41.7296822,
    lat: -21.8894221
  },
  {
    lng: -41.7298593,
    lat: -21.8895747
  },
  {
    lng: -41.7300036,
    lat: -21.8896325
  },
  {
    lng: -41.7301644,
    lat: -21.8896536
  },
  {
    lng: -41.7303464,
    lat: -21.8896395
  },
  {
    lng: -41.730476,
    lat: -21.8896029
  },
  {
    lng: -41.7306013,
    lat: -21.8895099
  },
  {
    lng: -41.7306999,
    lat: -21.8894133
  },
  {
    lng: -41.7308577,
    lat: -21.8892995
  },
  {
    lng: -41.7310005,
    lat: -21.8892517
  },
  {
    lng: -41.7310703,
    lat: -21.8891325
  },
  {
    lng: -41.7311267,
    lat: -21.888957
  },
  {
    lng: -41.7311279,
    lat: -21.8887224
  },
  {
    lng: -41.7311141,
    lat: -21.8885597
  },
  {
    lng: -41.7311417,
    lat: -21.8882283
  },
  {
    lng: -41.7311493,
    lat: -21.8881551
  },
  {
    lng: -41.7311815,
    lat: -21.8878436
  },
  {
    lng: -41.7313699,
    lat: -21.8877157
  },
  {
    lng: -41.7315126,
    lat: -21.8876829
  },
  {
    lng: -41.7315951,
    lat: -21.8877485
  },
  {
    lng: -41.7316735,
    lat: -21.8878684
  },
  {
    lng: -41.7316447,
    lat: -21.8879885
  },
  {
    lng: -41.7315618,
    lat: -21.8881048
  },
  {
    lng: -41.7315933,
    lat: -21.8882984
  },
  {
    lng: -41.7316796,
    lat: -21.8883751
  },
  {
    lng: -41.7317851,
    lat: -21.8883545
  },
  {
    lng: -41.7318943,
    lat: -21.8882233
  },
  {
    lng: -41.7320328,
    lat: -21.8882089
  },
  {
    lng: -41.7320707,
    lat: -21.8882801
  },
  {
    lng: -41.7321058,
    lat: -21.8884199
  },
  {
    lng: -41.7322392,
    lat: -21.8885046
  },
  {
    lng: -41.7324073,
    lat: -21.8885204
  },
  {
    lng: -41.7325527,
    lat: -21.8884499
  },
  {
    lng: -41.7326111,
    lat: -21.8883521
  },
  {
    lng: -41.7327224,
    lat: -21.8883346
  },
  {
    lng: -41.732857,
    lat: -21.8882667
  },
  {
    lng: -41.7329581,
    lat: -21.888089
  },
  {
    lng: -41.7329155,
    lat: -21.8878173
  },
  {
    lng: -41.7329048,
    lat: -21.8878024
  },
  {
    lng: -41.7328397,
    lat: -21.8876192
  },
  {
    lng: -41.7329415,
    lat: -21.8874924
  },
  {
    lng: -41.733114,
    lat: -21.8874261
  },
  {
    lng: -41.7332891,
    lat: -21.8874747
  },
  {
    lng: -41.7336133,
    lat: -21.8875767
  },
  {
    lng: -41.7336864,
    lat: -21.8876874
  },
  {
    lng: -41.7336912,
    lat: -21.8878075
  },
  {
    lng: -41.733693,
    lat: -21.8879059
  },
  {
    lng: -41.7337894,
    lat: -21.8881276
  },
  {
    lng: -41.7338535,
    lat: -21.8882515
  },
  {
    lng: -41.7338411,
    lat: -21.8884032
  },
  {
    lng: -41.7338334,
    lat: -21.8885474
  },
  {
    lng: -41.7338757,
    lat: -21.8886114
  },
  {
    lng: -41.734028,
    lat: -21.8886772
  },
  {
    lng: -41.7341842,
    lat: -21.8887381
  },
  {
    lng: -41.7343672,
    lat: -21.8888556
  },
  {
    lng: -41.7345575,
    lat: -21.8889089
  },
  {
    lng: -41.7347253,
    lat: -21.8889661
  },
  {
    lng: -41.7349306,
    lat: -21.888999
  },
  {
    lng: -41.7351525,
    lat: -21.8891939
  },
  {
    lng: -41.7353354,
    lat: -21.8892403
  },
  {
    lng: -41.7354478,
    lat: -21.8892337
  },
  {
    lng: -41.7355214,
    lat: -21.8892294
  },
  {
    lng: -41.7356639,
    lat: -21.8891774
  },
  {
    lng: -41.7358135,
    lat: -21.8890512
  },
  {
    lng: -41.7358855,
    lat: -21.888902
  },
  {
    lng: -41.7359385,
    lat: -21.8887305
  },
  {
    lng: -41.7359722,
    lat: -21.8886008
  },
  {
    lng: -41.7359819,
    lat: -21.888566
  },
  {
    lng: -41.7360464,
    lat: -21.8883849
  },
  {
    lng: -41.7361837,
    lat: -21.8883229
  },
  {
    lng: -41.7365568,
    lat: -21.8883428
  },
  {
    lng: -41.7368082,
    lat: -21.8884445
  },
  {
    lng: -41.7370099,
    lat: -21.8886098
  },
  {
    lng: -41.737173,
    lat: -21.8887696
  },
  {
    lng: -41.7374066,
    lat: -21.8889561
  },
  {
    lng: -41.7374946,
    lat: -21.8890303
  },
  {
    lng: -41.7375714,
    lat: -21.8890342
  },
  {
    lng: -41.7376497,
    lat: -21.8889845
  },
  {
    lng: -41.737724,
    lat: -21.8888459
  },
  {
    lng: -41.7378026,
    lat: -21.8886976
  },
  {
    lng: -41.7379978,
    lat: -21.8885611
  },
  {
    lng: -41.7381371,
    lat: -21.8885486
  },
  {
    lng: -41.7382867,
    lat: -21.8886389
  },
  {
    lng: -41.7383311,
    lat: -21.8887328
  },
  {
    lng: -41.7383287,
    lat: -21.8888139
  },
  {
    lng: -41.7382602,
    lat: -21.8889712
  },
  {
    lng: -41.7381687,
    lat: -21.8890869
  },
  {
    lng: -41.7380449,
    lat: -21.8892287
  },
  {
    lng: -41.7379556,
    lat: -21.8894102
  },
  {
    lng: -41.7379575,
    lat: -21.8895456
  },
  {
    lng: -41.7380274,
    lat: -21.8896561
  },
  {
    lng: -41.7381198,
    lat: -21.8897548
  },
  {
    lng: -41.738272,
    lat: -21.8897797
  },
  {
    lng: -41.7383114,
    lat: -21.8897862
  },
  {
    lng: -41.7384502,
    lat: -21.8896989
  },
  {
    lng: -41.7385051,
    lat: -21.8895893
  },
  {
    lng: -41.738566,
    lat: -21.8894017
  },
  {
    lng: -41.7386618,
    lat: -21.8892497
  },
  {
    lng: -41.7386662,
    lat: -21.8891156
  },
  {
    lng: -41.7385816,
    lat: -21.8890547
  },
  {
    lng: -41.7385129,
    lat: -21.888958
  },
  {
    lng: -41.738556,
    lat: -21.8887929
  },
  {
    lng: -41.7386711,
    lat: -21.8887273
  },
  {
    lng: -41.738985,
    lat: -21.8888099
  },
  {
    lng: -41.7390415,
    lat: -21.8888981
  },
  {
    lng: -41.7391606,
    lat: -21.8890907
  },
  {
    lng: -41.7392362,
    lat: -21.8892435
  },
  {
    lng: -41.7393893,
    lat: -21.8894761
  },
  {
    lng: -41.739415,
    lat: -21.8895198
  },
  {
    lng: -41.739584,
    lat: -21.8897517
  },
  {
    lng: -41.7396407,
    lat: -21.8898296
  },
  {
    lng: -41.739745,
    lat: -21.8900313
  },
  {
    lng: -41.7398708,
    lat: -21.8901723
  },
  {
    lng: -41.7399726,
    lat: -21.8902444
  },
  {
    lng: -41.7401253,
    lat: -21.8903104
  },
  {
    lng: -41.7402418,
    lat: -21.8903068
  },
  {
    lng: -41.7403819,
    lat: -21.8902271
  },
  {
    lng: -41.740474,
    lat: -21.8901095
  },
  {
    lng: -41.7405796,
    lat: -21.8900233
  },
  {
    lng: -41.740718,
    lat: -21.8899598
  },
  {
    lng: -41.7408401,
    lat: -21.8898654
  },
  {
    lng: -41.7408878,
    lat: -21.889785
  },
  {
    lng: -41.7408838,
    lat: -21.8897016
  },
  {
    lng: -41.7408345,
    lat: -21.8895973
  },
  {
    lng: -41.7407349,
    lat: -21.889517
  },
  {
    lng: -41.7406098,
    lat: -21.8894191
  },
  {
    lng: -41.7404696,
    lat: -21.8893247
  },
  {
    lng: -41.7403008,
    lat: -21.8892676
  },
  {
    lng: -41.7400398,
    lat: -21.8893126
  },
  {
    lng: -41.7399492,
    lat: -21.889247
  },
  {
    lng: -41.7399451,
    lat: -21.8891484
  },
  {
    lng: -41.7399995,
    lat: -21.8890426
  },
  {
    lng: -41.7401905,
    lat: -21.8889001
  },
  {
    lng: -41.7404445,
    lat: -21.8887958
  },
  {
    lng: -41.7407195,
    lat: -21.8887648
  },
  {
    lng: -41.7409903,
    lat: -21.8888038
  },
  {
    lng: -41.7410611,
    lat: -21.8889383
  },
  {
    lng: -41.7410341,
    lat: -21.8890431
  },
  {
    lng: -41.741007,
    lat: -21.8892053
  },
  {
    lng: -41.7411664,
    lat: -21.8893871
  },
  {
    lng: -41.7413271,
    lat: -21.8894381
  },
  {
    lng: -41.7415103,
    lat: -21.8894185
  },
  {
    lng: -41.7417116,
    lat: -21.8893633
  },
  {
    lng: -41.7418839,
    lat: -21.8892685
  },
  {
    lng: -41.7420517,
    lat: -21.8892073
  },
  {
    lng: -41.742213,
    lat: -21.8891569
  },
  {
    lng: -41.7423738,
    lat: -21.8891114
  },
  {
    lng: -41.7425743,
    lat: -21.8891043
  },
  {
    lng: -41.7426593,
    lat: -21.889109
  },
  {
    lng: -41.7426729,
    lat: -21.8891098
  },
  {
    lng: -41.7428191,
    lat: -21.8891424
  },
  {
    lng: -41.7429585,
    lat: -21.8891888
  },
  {
    lng: -41.7431533,
    lat: -21.8892464
  },
  {
    lng: -41.7432851,
    lat: -21.8892511
  },
  {
    lng: -41.7435077,
    lat: -21.8891867
  },
  {
    lng: -41.7435651,
    lat: -21.8891424
  },
  {
    lng: -41.7436073,
    lat: -21.8891098
  },
  {
    lng: -41.743701,
    lat: -21.8890425
  },
  {
    lng: -41.7438439,
    lat: -21.8889697
  },
  {
    lng: -41.7440245,
    lat: -21.8887213
  },
  {
    lng: -41.7441533,
    lat: -21.888565
  },
  {
    lng: -41.7443185,
    lat: -21.8885671
  },
  {
    lng: -41.7444884,
    lat: -21.8886386
  },
  {
    lng: -41.7446525,
    lat: -21.8886862
  },
  {
    lng: -41.7447862,
    lat: -21.8887186
  },
  {
    lng: -41.7448773,
    lat: -21.8887413
  },
  {
    lng: -41.7450543,
    lat: -21.8887956
  },
  {
    lng: -41.7453237,
    lat: -21.8889162
  },
  {
    lng: -41.7454724,
    lat: -21.8889742
  },
  {
    lng: -41.7456851,
    lat: -21.8891172
  },
  {
    lng: -41.7457699,
    lat: -21.8892561
  },
  {
    lng: -41.7458762,
    lat: -21.8894336
  },
  {
    lng: -41.7459751,
    lat: -21.8895332
  },
  {
    lng: -41.7461191,
    lat: -21.8895366
  },
  {
    lng: -41.7462071,
    lat: -21.8894536
  },
  {
    lng: -41.7462775,
    lat: -21.8893273
  },
  {
    lng: -41.7462892,
    lat: -21.8891926
  },
  {
    lng: -41.7462587,
    lat: -21.8890336
  },
  {
    lng: -41.7462908,
    lat: -21.888901
  },
  {
    lng: -41.7463771,
    lat: -21.8888477
  },
  {
    lng: -41.7465186,
    lat: -21.8888453
  },
  {
    lng: -41.74674,
    lat: -21.8888358
  },
  {
    lng: -41.7469214,
    lat: -21.8888551
  },
  {
    lng: -41.747016,
    lat: -21.8889312
  },
  {
    lng: -41.7470475,
    lat: -21.8890134
  },
  {
    lng: -41.746927,
    lat: -21.8890947
  },
  {
    lng: -41.7467656,
    lat: -21.8892136
  },
  {
    lng: -41.7467303,
    lat: -21.8893033
  },
  {
    lng: -41.7467866,
    lat: -21.8895704
  },
  {
    lng: -41.7469511,
    lat: -21.8897657
  },
  {
    lng: -41.7470809,
    lat: -21.8897888
  },
  {
    lng: -41.7472318,
    lat: -21.8897244
  },
  {
    lng: -41.7473073,
    lat: -21.8896225
  },
  {
    lng: -41.7473698,
    lat: -21.8895475
  },
  {
    lng: -41.7474638,
    lat: -21.8894866
  },
  {
    lng: -41.7476276,
    lat: -21.8894875
  },
  {
    lng: -41.7479373,
    lat: -21.8893774
  },
  {
    lng: -41.748059,
    lat: -21.8892866
  },
  {
    lng: -41.7483131,
    lat: -21.8890957
  },
  {
    lng: -41.7484577,
    lat: -21.8889666
  },
  {
    lng: -41.7486111,
    lat: -21.8889018
  },
  {
    lng: -41.7487929,
    lat: -21.8889011
  },
  {
    lng: -41.7489921,
    lat: -21.8889771
  },
  {
    lng: -41.7492531,
    lat: -21.8890868
  },
  {
    lng: -41.7495084,
    lat: -21.8892251
  },
  {
    lng: -41.7498704,
    lat: -21.8893723
  },
  {
    lng: -41.7499482,
    lat: -21.889408
  },
  {
    lng: -41.7499993,
    lat: -21.8894331
  },
  {
    lng: -41.7503182,
    lat: -21.8895899
  },
  {
    lng: -41.7505684,
    lat: -21.8896679
  },
  {
    lng: -41.7507247,
    lat: -21.8896706
  },
  {
    lng: -41.7509403,
    lat: -21.8896271
  },
  {
    lng: -41.751254,
    lat: -21.8896232
  },
  {
    lng: -41.7514476,
    lat: -21.8896612
  },
  {
    lng: -41.7516646,
    lat: -21.8897642
  },
  {
    lng: -41.7519167,
    lat: -21.8898793
  },
  {
    lng: -41.7520955,
    lat: -21.8899203
  },
  {
    lng: -41.7523126,
    lat: -21.889917
  },
  {
    lng: -41.752443,
    lat: -21.8899052
  },
  {
    lng: -41.7527055,
    lat: -21.8898311
  },
  {
    lng: -41.7528839,
    lat: -21.8897961
  },
  {
    lng: -41.7532003,
    lat: -21.8897134
  },
  {
    lng: -41.7533089,
    lat: -21.8896738
  },
  {
    lng: -41.7534427,
    lat: -21.8896251
  },
  {
    lng: -41.7535091,
    lat: -21.8895715
  },
  {
    lng: -41.7535752,
    lat: -21.8895182
  },
  {
    lng: -41.7536544,
    lat: -21.8894123
  },
  {
    lng: -41.7537319,
    lat: -21.8892364
  },
  {
    lng: -41.7538538,
    lat: -21.8889983
  },
  {
    lng: -41.7540171,
    lat: -21.8888945
  },
  {
    lng: -41.7541307,
    lat: -21.8889079
  },
  {
    lng: -41.754357,
    lat: -21.888969
  },
  {
    lng: -41.7544933,
    lat: -21.8890354
  },
  {
    lng: -41.7546742,
    lat: -21.8891788
  },
  {
    lng: -41.7547647,
    lat: -21.8892788
  },
  {
    lng: -41.7548919,
    lat: -21.8894509
  },
  {
    lng: -41.7550165,
    lat: -21.8895404
  },
  {
    lng: -41.7551647,
    lat: -21.8895021
  },
  {
    lng: -41.7552797,
    lat: -21.8894019
  },
  {
    lng: -41.7553497,
    lat: -21.8892788
  },
  {
    lng: -41.7554721,
    lat: -21.889309
  },
  {
    lng: -41.7556299,
    lat: -21.8893667
  },
  {
    lng: -41.7557585,
    lat: -21.8893184
  },
  {
    lng: -41.7558602,
    lat: -21.8892076
  },
  {
    lng: -41.7559945,
    lat: -21.8891298
  },
  {
    lng: -41.756106,
    lat: -21.8891162
  },
  {
    lng: -41.7562539,
    lat: -21.8891026
  },
  {
    lng: -41.7563618,
    lat: -21.8891157
  },
  {
    lng: -41.7563896,
    lat: -21.8891135
  },
  {
    lng: -41.7565278,
    lat: -21.889102
  },
  {
    lng: -41.7566277,
    lat: -21.8890861
  },
  {
    lng: -41.7569524,
    lat: -21.888995
  },
  {
    lng: -41.7571622,
    lat: -21.8889743
  },
  {
    lng: -41.7572279,
    lat: -21.8888867
  },
  {
    lng: -41.7573421,
    lat: -21.8887143
  },
  {
    lng: -41.75747,
    lat: -21.8886451
  },
  {
    lng: -41.7577064,
    lat: -21.8886336
  },
  {
    lng: -41.7578581,
    lat: -21.888725
  },
  {
    lng: -41.7579869,
    lat: -21.8888967
  },
  {
    lng: -41.7580042,
    lat: -21.88891
  },
  {
    lng: -41.758166,
    lat: -21.8890347
  },
  {
    lng: -41.7582328,
    lat: -21.8890583
  },
  {
    lng: -41.7582443,
    lat: -21.8890624
  },
  {
    lng: -41.7584238,
    lat: -21.889126
  },
  {
    lng: -41.7587605,
    lat: -21.8890709
  },
  {
    lng: -41.7589151,
    lat: -21.8890857
  },
  {
    lng: -41.7591111,
    lat: -21.8891449
  },
  {
    lng: -41.7592447,
    lat: -21.8892019
  },
  {
    lng: -41.7593584,
    lat: -21.8892611
  },
  {
    lng: -41.7595079,
    lat: -21.8893397
  },
  {
    lng: -41.7596517,
    lat: -21.8894572
  },
  {
    lng: -41.7597655,
    lat: -21.8895946
  },
  {
    lng: -41.7598556,
    lat: -21.8897512
  },
  {
    lng: -41.7599168,
    lat: -21.8899475
  },
  {
    lng: -41.7599861,
    lat: -21.8900897
  },
  {
    lng: -41.7601149,
    lat: -21.890187
  },
  {
    lng: -41.7602838,
    lat: -21.8901926
  },
  {
    lng: -41.7604793,
    lat: -21.8901614
  },
  {
    lng: -41.7606337,
    lat: -21.890101
  },
  {
    lng: -41.7608456,
    lat: -21.8899755
  },
  {
    lng: -41.7610081,
    lat: -21.889862
  },
  {
    lng: -41.761159,
    lat: -21.889691
  },
  {
    lng: -41.7613346,
    lat: -21.8894972
  },
  {
    lng: -41.7615253,
    lat: -21.8892906
  },
  {
    lng: -41.7616928,
    lat: -21.8891376
  },
  {
    lng: -41.761892,
    lat: -21.8891207
  },
  {
    lng: -41.7619692,
    lat: -21.8892246
  },
  {
    lng: -41.7618652,
    lat: -21.8893271
  },
  {
    lng: -41.7617478,
    lat: -21.8894179
  },
  {
    lng: -41.7616413,
    lat: -21.889552
  },
  {
    lng: -41.7615825,
    lat: -21.8897024
  },
  {
    lng: -41.7615333,
    lat: -21.8898502
  },
  {
    lng: -41.7615667,
    lat: -21.8899752
  },
  {
    lng: -41.7617638,
    lat: -21.8899888
  },
  {
    lng: -41.761884,
    lat: -21.8898932
  },
  {
    lng: -41.762042,
    lat: -21.8897675
  },
  {
    lng: -41.7622265,
    lat: -21.8897165
  },
  {
    lng: -41.7623745,
    lat: -21.8897623
  },
  {
    lng: -41.7624686,
    lat: -21.8898317
  },
  {
    lng: -41.7625524,
    lat: -21.8899201
  },
  {
    lng: -41.7626682,
    lat: -21.8900529
  },
  {
    lng: -41.7627941,
    lat: -21.8901687
  },
  {
    lng: -41.7630233,
    lat: -21.890308
  },
  {
    lng: -41.7631435,
    lat: -21.8903359
  },
  {
    lng: -41.7633364,
    lat: -21.8903456
  },
  {
    lng: -41.763425,
    lat: -21.890313
  },
  {
    lng: -41.7634708,
    lat: -21.8903025
  },
  {
    lng: -41.7635314,
    lat: -21.8902886
  },
  {
    lng: -41.7636434,
    lat: -21.8903084
  },
  {
    lng: -41.7637656,
    lat: -21.8903502
  },
  {
    lng: -41.763883,
    lat: -21.8903219
  },
  {
    lng: -41.763985,
    lat: -21.8902726
  },
  {
    lng: -41.7641909,
    lat: -21.8902116
  },
  {
    lng: -41.7643861,
    lat: -21.8901755
  },
  {
    lng: -41.7644437,
    lat: -21.8901678
  },
  {
    lng: -41.7648319,
    lat: -21.8901578
  },
  {
    lng: -41.7650358,
    lat: -21.8901839
  },
  {
    lng: -41.7651571,
    lat: -21.8902628
  },
  {
    lng: -41.7652614,
    lat: -21.890334
  },
  {
    lng: -41.7653548,
    lat: -21.8903943
  },
  {
    lng: -41.7654747,
    lat: -21.8904174
  },
  {
    lng: -41.7655716,
    lat: -21.8904085
  },
  {
    lng: -41.7656688,
    lat: -21.890438
  },
  {
    lng: -41.7657631,
    lat: -21.8905242
  },
  {
    lng: -41.7658787,
    lat: -21.8905874
  },
  {
    lng: -41.7659967,
    lat: -21.8906342
  },
  {
    lng: -41.7661459,
    lat: -21.8906278
  },
  {
    lng: -41.7662265,
    lat: -21.8905919
  },
  {
    lng: -41.7663055,
    lat: -21.8905568
  },
  {
    lng: -41.7664453,
    lat: -21.8904996
  },
  {
    lng: -41.7665817,
    lat: -21.8904016
  },
  {
    lng: -41.7667137,
    lat: -21.8903194
  },
  {
    lng: -41.7668898,
    lat: -21.8902223
  },
  {
    lng: -41.7670812,
    lat: -21.8901144
  },
  {
    lng: -41.7672597,
    lat: -21.8900489
  },
  {
    lng: -41.7673462,
    lat: -21.8900532
  },
  {
    lng: -41.7674244,
    lat: -21.8900571
  },
  {
    lng: -41.7675522,
    lat: -21.8900377
  },
  {
    lng: -41.7676658,
    lat: -21.8899964
  },
  {
    lng: -41.7677015,
    lat: -21.8899583
  },
  {
    lng: -41.7677931,
    lat: -21.8898603
  },
  {
    lng: -41.7679065,
    lat: -21.8898683
  },
  {
    lng: -41.7679776,
    lat: -21.8899181
  },
  {
    lng: -41.7682403,
    lat: -21.8899725
  },
  {
    lng: -41.7683528,
    lat: -21.8899859
  },
  {
    lng: -41.7683806,
    lat: -21.8899893
  },
  {
    lng: -41.7685253,
    lat: -21.8899725
  },
  {
    lng: -41.7686187,
    lat: -21.8899882
  },
  {
    lng: -41.7687594,
    lat: -21.8901376
  },
  {
    lng: -41.7688909,
    lat: -21.8902487
  },
  {
    lng: -41.7690455,
    lat: -21.8903519
  },
  {
    lng: -41.7692467,
    lat: -21.8904287
  },
  {
    lng: -41.769448,
    lat: -21.8904221
  },
  {
    lng: -41.7696407,
    lat: -21.8903884
  },
  {
    lng: -41.7699215,
    lat: -21.8903172
  },
  {
    lng: -41.7701305,
    lat: -21.8902501
  },
  {
    lng: -41.7703816,
    lat: -21.8901666
  },
  {
    lng: -41.7705535,
    lat: -21.8900808
  },
  {
    lng: -41.7707186,
    lat: -21.8900442
  },
  {
    lng: -41.7709782,
    lat: -21.8901201
  },
  {
    lng: -41.7711689,
    lat: -21.8901889
  },
  {
    lng: -41.7713318,
    lat: -21.8903116
  },
  {
    lng: -41.7713116,
    lat: -21.8904056
  },
  {
    lng: -41.7712009,
    lat: -21.8904986
  },
  {
    lng: -41.7711546,
    lat: -21.8906212
  },
  {
    lng: -41.7711509,
    lat: -21.8907745
  },
  {
    lng: -41.7711848,
    lat: -21.8909743
  },
  {
    lng: -41.7713127,
    lat: -21.8911145
  },
  {
    lng: -41.7714128,
    lat: -21.8911737
  },
  {
    lng: -41.7714321,
    lat: -21.8911806
  },
  {
    lng: -41.7718157,
    lat: -21.8910942
  },
  {
    lng: -41.7719709,
    lat: -21.8909777
  },
  {
    lng: -41.7721505,
    lat: -21.8908434
  },
  {
    lng: -41.7724047,
    lat: -21.8906527
  },
  {
    lng: -41.7725886,
    lat: -21.8906982
  },
  {
    lng: -41.772687,
    lat: -21.890764
  },
  {
    lng: -41.7726975,
    lat: -21.890771
  },
  {
    lng: -41.7727074,
    lat: -21.8907776
  },
  {
    lng: -41.7727872,
    lat: -21.8907339
  },
  {
    lng: -41.772792,
    lat: -21.890716
  },
  {
    lng: -41.7728213,
    lat: -21.8906068
  },
  {
    lng: -41.7728059,
    lat: -21.8904478
  },
  {
    lng: -41.7727743,
    lat: -21.8902398
  },
  {
    lng: -41.7727407,
    lat: -21.8899315
  },
  {
    lng: -41.7727883,
    lat: -21.8898199
  },
  {
    lng: -41.7729424,
    lat: -21.8897668
  },
  {
    lng: -41.7730581,
    lat: -21.8897351
  },
  {
    lng: -41.7731531,
    lat: -21.8897631
  },
  {
    lng: -41.7731562,
    lat: -21.8898356
  },
  {
    lng: -41.7731543,
    lat: -21.889984
  },
  {
    lng: -41.7732392,
    lat: -21.8900773
  },
  {
    lng: -41.7733339,
    lat: -21.8901365
  },
  {
    lng: -41.7734308,
    lat: -21.890129
  },
  {
    lng: -41.7736204,
    lat: -21.8900503
  },
  {
    lng: -41.7737547,
    lat: -21.8900234
  },
  {
    lng: -41.7738619,
    lat: -21.8901193
  },
  {
    lng: -41.7739816,
    lat: -21.8902838
  },
  {
    lng: -41.7740933,
    lat: -21.8903755
  },
  {
    lng: -41.7742528,
    lat: -21.8905209
  },
  {
    lng: -41.7744057,
    lat: -21.8905929
  },
  {
    lng: -41.7745487,
    lat: -21.8905768
  },
  {
    lng: -41.7747281,
    lat: -21.890523
  },
  {
    lng: -41.7748392,
    lat: -21.8904526
  },
  {
    lng: -41.7749792,
    lat: -21.8904145
  },
  {
    lng: -41.7751183,
    lat: -21.8903982
  },
  {
    lng: -41.7752536,
    lat: -21.8903896
  },
  {
    lng: -41.7753415,
    lat: -21.8903863
  },
  {
    lng: -41.7755585,
    lat: -21.8903781
  },
  {
    lng: -41.7757444,
    lat: -21.8903464
  },
  {
    lng: -41.7758534,
    lat: -21.8902528
  },
  {
    lng: -41.776203,
    lat: -21.8900692
  },
  {
    lng: -41.7763229,
    lat: -21.8900042
  },
  {
    lng: -41.7766704,
    lat: -21.8898055
  },
  {
    lng: -41.7768029,
    lat: -21.8896713
  },
  {
    lng: -41.776865,
    lat: -21.8895083
  },
  {
    lng: -41.7769044,
    lat: -21.8893401
  },
  {
    lng: -41.7769003,
    lat: -21.8891852
  },
  {
    lng: -41.776835,
    lat: -21.889002
  },
  {
    lng: -41.776861,
    lat: -21.8888532
  },
  {
    lng: -41.7769846,
    lat: -21.8887461
  },
  {
    lng: -41.7771331,
    lat: -21.8887823
  },
  {
    lng: -41.7772062,
    lat: -21.8888538
  },
  {
    lng: -41.7772264,
    lat: -21.8888736
  },
  {
    lng: -41.7773178,
    lat: -21.8890257
  },
  {
    lng: -41.7773919,
    lat: -21.8891597
  },
  {
    lng: -41.777495,
    lat: -21.8893153
  },
  {
    lng: -41.7776399,
    lat: -21.8893985
  },
  {
    lng: -41.7778299,
    lat: -21.8894614
  },
  {
    lng: -41.7780746,
    lat: -21.8895339
  },
  {
    lng: -41.7782353,
    lat: -21.8896427
  },
  {
    lng: -41.778426,
    lat: -21.8895981
  },
  {
    lng: -41.7784825,
    lat: -21.889563
  },
  {
    lng: -41.7785158,
    lat: -21.8894131
  },
  {
    lng: -41.7784385,
    lat: -21.8892747
  },
  {
    lng: -41.7784139,
    lat: -21.8890966
  },
  {
    lng: -41.7785186,
    lat: -21.8889812
  },
  {
    lng: -41.7786215,
    lat: -21.8888693
  },
  {
    lng: -41.778669,
    lat: -21.8886922
  },
  {
    lng: -41.7787979,
    lat: -21.8886427
  },
  {
    lng: -41.778909,
    lat: -21.8887634
  },
  {
    lng: -41.7790099,
    lat: -21.8889193
  },
  {
    lng: -41.779113,
    lat: -21.8891069
  },
  {
    lng: -41.7792659,
    lat: -21.8892889
  },
  {
    lng: -41.7794215,
    lat: -21.8892979
  },
  {
    lng: -41.7796756,
    lat: -21.8892119
  },
  {
    lng: -41.7799279,
    lat: -21.88909
  },
  {
    lng: -41.7800938,
    lat: -21.8890211
  },
  {
    lng: -41.7801742,
    lat: -21.888874
  },
  {
    lng: -41.780217,
    lat: -21.8887475
  },
  {
    lng: -41.7801255,
    lat: -21.8886372
  },
  {
    lng: -41.7799427,
    lat: -21.8884798
  },
  {
    lng: -41.7797033,
    lat: -21.8882044
  },
  {
    lng: -41.7795273,
    lat: -21.8879135
  },
  {
    lng: -41.7795588,
    lat: -21.8877733
  },
  {
    lng: -41.7796914,
    lat: -21.8876689
  },
  {
    lng: -41.7798471,
    lat: -21.8875871
  },
  {
    lng: -41.7800702,
    lat: -21.8874774
  },
  {
    lng: -41.7802269,
    lat: -21.8874606
  },
  {
    lng: -41.7803476,
    lat: -21.8874792
  },
  {
    lng: -41.7806709,
    lat: -21.8876161
  },
  {
    lng: -41.7808051,
    lat: -21.8876629
  },
  {
    lng: -41.7809702,
    lat: -21.8876704
  },
  {
    lng: -41.7812474,
    lat: -21.8875519
  },
  {
    lng: -41.7814438,
    lat: -21.8874457
  },
  {
    lng: -41.7818256,
    lat: -21.8871398
  },
  {
    lng: -41.781964,
    lat: -21.8869722
  },
  {
    lng: -41.7820358,
    lat: -21.886841
  },
  {
    lng: -41.7820684,
    lat: -21.8867393
  },
  {
    lng: -41.7821328,
    lat: -21.8866705
  },
  {
    lng: -41.7822397,
    lat: -21.8866368
  },
  {
    lng: -41.7824373,
    lat: -21.8866792
  },
  {
    lng: -41.7825959,
    lat: -21.8866507
  },
  {
    lng: -41.7828505,
    lat: -21.8866947
  },
  {
    lng: -41.782973,
    lat: -21.8867619
  },
  {
    lng: -41.7830864,
    lat: -21.8868978
  },
  {
    lng: -41.7831772,
    lat: -21.8870604
  },
  {
    lng: -41.7833579,
    lat: -21.8872711
  },
  {
    lng: -41.7837979,
    lat: -21.88738
  },
  {
    lng: -41.7839274,
    lat: -21.8873804
  },
  {
    lng: -41.7840386,
    lat: -21.8873296
  },
  {
    lng: -41.7840558,
    lat: -21.8873154
  },
  {
    lng: -41.784109,
    lat: -21.8871663
  },
  {
    lng: -41.784208,
    lat: -21.8870584
  },
  {
    lng: -41.7843488,
    lat: -21.8870308
  },
  {
    lng: -41.7845015,
    lat: -21.8870259
  },
  {
    lng: -41.7845793,
    lat: -21.8870771
  },
  {
    lng: -41.7846184,
    lat: -21.8871355
  },
  {
    lng: -41.7846289,
    lat: -21.8871872
  },
  {
    lng: -41.7846076,
    lat: -21.8872512
  },
  {
    lng: -41.7845569,
    lat: -21.8873011
  },
  {
    lng: -41.7841513,
    lat: -21.8873986
  },
  {
    lng: -41.7838936,
    lat: -21.8875034
  },
  {
    lng: -41.7838382,
    lat: -21.8875399
  },
  {
    lng: -41.7837792,
    lat: -21.8876437
  },
  {
    lng: -41.7837812,
    lat: -21.8878125
  },
  {
    lng: -41.7838221,
    lat: -21.8878717
  },
  {
    lng: -41.7838975,
    lat: -21.8878789
  },
  {
    lng: -41.7842369,
    lat: -21.8875667
  },
  {
    lng: -41.7843325,
    lat: -21.8875496
  },
  {
    lng: -41.7844218,
    lat: -21.8875939
  },
  {
    lng: -41.7844585,
    lat: -21.8876648
  },
  {
    lng: -41.7844612,
    lat: -21.887812
  },
  {
    lng: -41.7845072,
    lat: -21.8879086
  },
  {
    lng: -41.78458,
    lat: -21.8879803
  },
  {
    lng: -41.7848383,
    lat: -21.8881466
  },
  {
    lng: -41.7848942,
    lat: -21.8882368
  },
  {
    lng: -41.7849043,
    lat: -21.888306
  },
  {
    lng: -41.7848918,
    lat: -21.8883724
  },
  {
    lng: -41.7847599,
    lat: -21.8885912
  },
  {
    lng: -41.7847067,
    lat: -21.8887209
  },
  {
    lng: -41.7847113,
    lat: -21.8887758
  },
  {
    lng: -41.7847371,
    lat: -21.8888309
  },
  {
    lng: -41.7847782,
    lat: -21.8888719
  },
  {
    lng: -41.784838,
    lat: -21.8889004
  },
  {
    lng: -41.7849639,
    lat: -21.8889189
  },
  {
    lng: -41.7850555,
    lat: -21.8889163
  },
  {
    lng: -41.7850892,
    lat: -21.8889153
  },
  {
    lng: -41.7852029,
    lat: -21.8888935
  },
  {
    lng: -41.785264,
    lat: -21.8888514
  },
  {
    lng: -41.7852922,
    lat: -21.8888002
  },
  {
    lng: -41.7852961,
    lat: -21.8887435
  },
  {
    lng: -41.7852349,
    lat: -21.8885789
  },
  {
    lng: -41.7851536,
    lat: -21.888439
  },
  {
    lng: -41.7851738,
    lat: -21.888327
  },
  {
    lng: -41.7852042,
    lat: -21.8882866
  },
  {
    lng: -41.7853043,
    lat: -21.8882649
  },
  {
    lng: -41.7854149,
    lat: -21.8882604
  },
  {
    lng: -41.7855401,
    lat: -21.8882792
  },
  {
    lng: -41.7856614,
    lat: -21.8882123
  },
  {
    lng: -41.7857163,
    lat: -21.8881405
  },
  {
    lng: -41.7857423,
    lat: -21.8880614
  },
  {
    lng: -41.7857417,
    lat: -21.8879837
  },
  {
    lng: -41.7857084,
    lat: -21.8878615
  },
  {
    lng: -41.785735,
    lat: -21.8877344
  },
  {
    lng: -41.7857716,
    lat: -21.8876766
  },
  {
    lng: -41.7858067,
    lat: -21.8876512
  },
  {
    lng: -41.7859503,
    lat: -21.8875993
  },
  {
    lng: -41.7860589,
    lat: -21.8876008
  },
  {
    lng: -41.7861616,
    lat: -21.8876356
  },
  {
    lng: -41.7863399,
    lat: -21.8877431
  },
  {
    lng: -41.786483,
    lat: -21.8878639
  },
  {
    lng: -41.7865437,
    lat: -21.8879518
  },
  {
    lng: -41.7865838,
    lat: -21.8880608
  },
  {
    lng: -41.7865925,
    lat: -21.8881186
  },
  {
    lng: -41.7865696,
    lat: -21.888233
  },
  {
    lng: -41.7865845,
    lat: -21.8883275
  },
  {
    lng: -41.7865967,
    lat: -21.8883526
  },
  {
    lng: -41.7866528,
    lat: -21.8883792
  },
  {
    lng: -41.7867425,
    lat: -21.8883788
  },
  {
    lng: -41.7868166,
    lat: -21.8883356
  },
  {
    lng: -41.7869239,
    lat: -21.8882016
  },
  {
    lng: -41.787088,
    lat: -21.8879404
  },
  {
    lng: -41.7871922,
    lat: -21.8878243
  },
  {
    lng: -41.7872624,
    lat: -21.8877721
  },
  {
    lng: -41.7873696,
    lat: -21.8877145
  },
  {
    lng: -41.7874788,
    lat: -21.8876769
  },
  {
    lng: -41.7877559,
    lat: -21.8876547
  },
  {
    lng: -41.787835,
    lat: -21.88768
  },
  {
    lng: -41.7878755,
    lat: -21.8877468
  },
  {
    lng: -41.787818,
    lat: -21.8880278
  },
  {
    lng: -41.7878112,
    lat: -21.8883276
  },
  {
    lng: -41.7878454,
    lat: -21.88848
  },
  {
    lng: -41.7878749,
    lat: -21.888539
  },
  {
    lng: -41.7879167,
    lat: -21.8885799
  },
  {
    lng: -41.788019,
    lat: -21.8886066
  },
  {
    lng: -41.7880455,
    lat: -21.8885982
  },
  {
    lng: -41.7881567,
    lat: -21.8885627
  },
  {
    lng: -41.7882473,
    lat: -21.8885003
  },
  {
    lng: -41.7883257,
    lat: -21.8883932
  },
  {
    lng: -41.7883953,
    lat: -21.8883577
  },
  {
    lng: -41.7884571,
    lat: -21.8883559
  },
  {
    lng: -41.7885909,
    lat: -21.8883998
  },
  {
    lng: -41.7887342,
    lat: -21.8884183
  },
  {
    lng: -41.7888537,
    lat: -21.888368
  },
  {
    lng: -41.7889166,
    lat: -21.8882938
  },
  {
    lng: -41.7889423,
    lat: -21.888196
  },
  {
    lng: -41.7889182,
    lat: -21.8881156
  },
  {
    lng: -41.7888576,
    lat: -21.8880345
  },
  {
    lng: -41.78877,
    lat: -21.8879706
  },
  {
    lng: -41.7886579,
    lat: -21.887933
  },
  {
    lng: -41.7885529,
    lat: -21.8877754
  },
  {
    lng: -41.7883541,
    lat: -21.8875817
  },
  {
    lng: -41.7882883,
    lat: -21.8875503
  },
  {
    lng: -41.7882156,
    lat: -21.8875359
  },
  {
    lng: -41.7880751,
    lat: -21.8875592
  },
  {
    lng: -41.7879637,
    lat: -21.887496
  },
  {
    lng: -41.7878689,
    lat: -21.887402
  },
  {
    lng: -41.787814,
    lat: -21.8873086
  },
  {
    lng: -41.7877795,
    lat: -21.8871886
  },
  {
    lng: -41.78778,
    lat: -21.8871501
  },
  {
    lng: -41.7877808,
    lat: -21.8870769
  },
  {
    lng: -41.787817,
    lat: -21.8869656
  },
  {
    lng: -41.7878751,
    lat: -21.8868799
  },
  {
    lng: -41.7879446,
    lat: -21.886836
  },
  {
    lng: -41.7880473,
    lat: -21.8868041
  },
  {
    lng: -41.7881513,
    lat: -21.8868022
  },
  {
    lng: -41.7882057,
    lat: -21.8868128
  },
  {
    lng: -41.7889214,
    lat: -21.8872108
  },
  {
    lng: -41.7890322,
    lat: -21.887243
  },
  {
    lng: -41.7891462,
    lat: -21.887246
  },
  {
    lng: -41.7892631,
    lat: -21.8873028
  },
  {
    lng: -41.7893882,
    lat: -21.8873424
  },
  {
    lng: -41.7894201,
    lat: -21.8873495
  },
  {
    lng: -41.7895385,
    lat: -21.8873028
  },
  {
    lng: -41.7897268,
    lat: -21.8871872
  },
  {
    lng: -41.7898186,
    lat: -21.8870718
  },
  {
    lng: -41.7898778,
    lat: -21.8869218
  },
  {
    lng: -41.7898369,
    lat: -21.886855
  },
  {
    lng: -41.7897749,
    lat: -21.8868056
  },
  {
    lng: -41.7896682,
    lat: -21.8867749
  },
  {
    lng: -41.7894653,
    lat: -21.8867929
  },
  {
    lng: -41.788939,
    lat: -21.8867605
  },
  {
    lng: -41.7888569,
    lat: -21.8867299
  },
  {
    lng: -41.7888016,
    lat: -21.8866742
  },
  {
    lng: -41.7887788,
    lat: -21.8866196
  },
  {
    lng: -41.7887757,
    lat: -21.8865622
  },
  {
    lng: -41.7888921,
    lat: -21.8859122
  },
  {
    lng: -41.7889749,
    lat: -21.8857966
  },
  {
    lng: -41.7890983,
    lat: -21.8857333
  },
  {
    lng: -41.7892999,
    lat: -21.8857056
  },
  {
    lng: -41.7893845,
    lat: -21.8857152
  },
  {
    lng: -41.7894739,
    lat: -21.88575
  },
  {
    lng: -41.7895598,
    lat: -21.8857515
  },
  {
    lng: -41.7896635,
    lat: -21.8857121
  },
  {
    lng: -41.7896939,
    lat: -21.885669
  },
  {
    lng: -41.7897135,
    lat: -21.8856412
  },
  {
    lng: -41.7897646,
    lat: -21.8854634
  },
  {
    lng: -41.7898167,
    lat: -21.885369
  },
  {
    lng: -41.7898152,
    lat: -21.8853045
  },
  {
    lng: -41.7897795,
    lat: -21.8852357
  },
  {
    lng: -41.7896494,
    lat: -21.885125
  },
  {
    lng: -41.7895668,
    lat: -21.8850202
  },
  {
    lng: -41.7895192,
    lat: -21.8849182
  },
  {
    lng: -41.7894943,
    lat: -21.884791
  },
  {
    lng: -41.7895116,
    lat: -21.8846183
  },
  {
    lng: -41.7896422,
    lat: -21.8844512
  },
  {
    lng: -41.7897841,
    lat: -21.8843649
  },
  {
    lng: -41.7899633,
    lat: -21.8843259
  },
  {
    lng: -41.7900956,
    lat: -21.8843842
  },
  {
    lng: -41.7902462,
    lat: -21.8845379
  },
  {
    lng: -41.7903654,
    lat: -21.8846065
  },
  {
    lng: -41.7905328,
    lat: -21.8846355
  },
  {
    lng: -41.790695,
    lat: -21.8846036
  },
  {
    lng: -41.7908344,
    lat: -21.8845122
  },
  {
    lng: -41.7909126,
    lat: -21.8844157
  },
  {
    lng: -41.7909703,
    lat: -21.8843141
  },
  {
    lng: -41.7910086,
    lat: -21.8841532
  },
  {
    lng: -41.7910326,
    lat: -21.8838842
  },
  {
    lng: -41.7910035,
    lat: -21.883765
  },
  {
    lng: -41.7909207,
    lat: -21.8836662
  },
  {
    lng: -41.7908144,
    lat: -21.8836201
  },
  {
    lng: -41.7906562,
    lat: -21.8835981
  },
  {
    lng: -41.7903559,
    lat: -21.883634
  },
  {
    lng: -41.7902139,
    lat: -21.8836702
  },
  {
    lng: -41.7900829,
    lat: -21.8837319
  },
  {
    lng: -41.7898976,
    lat: -21.8838582
  },
  {
    lng: -41.7897623,
    lat: -21.8839216
  },
  {
    lng: -41.7896646,
    lat: -21.8839009
  },
  {
    lng: -41.7895799,
    lat: -21.8838412
  },
  {
    lng: -41.7895283,
    lat: -21.8837479
  },
  {
    lng: -41.7895125,
    lat: -21.8835884
  },
  {
    lng: -41.7895442,
    lat: -21.8834407
  },
  {
    lng: -41.7896118,
    lat: -21.8833556
  },
  {
    lng: -41.7897036,
    lat: -21.8833162
  },
  {
    lng: -41.7898912,
    lat: -21.8832966
  },
  {
    lng: -41.7903272,
    lat: -21.8833549
  },
  {
    lng: -41.7903884,
    lat: -21.8833332
  },
  {
    lng: -41.7904435,
    lat: -21.8832926
  },
  {
    lng: -41.7904838,
    lat: -21.8832382
  },
  {
    lng: -41.7905006,
    lat: -21.8831744
  },
  {
    lng: -41.7904958,
    lat: -21.8831244
  },
  {
    lng: -41.7903947,
    lat: -21.8830019
  },
  {
    lng: -41.7903085,
    lat: -21.8828568
  },
  {
    lng: -41.7901904,
    lat: -21.8827255
  },
  {
    lng: -41.7900431,
    lat: -21.8826097
  },
  {
    lng: -41.7898341,
    lat: -21.8825021
  },
  {
    lng: -41.7896442,
    lat: -21.882371
  },
  {
    lng: -41.7895237,
    lat: -21.8823424
  },
  {
    lng: -41.7894071,
    lat: -21.8823722
  },
  {
    lng: -41.7889387,
    lat: -21.8828093
  },
  {
    lng: -41.7888256,
    lat: -21.8828586
  },
  {
    lng: -41.7887071,
    lat: -21.8828621
  },
  {
    lng: -41.7885996,
    lat: -21.8828249
  },
  {
    lng: -41.7885123,
    lat: -21.8827502
  },
  {
    lng: -41.7882675,
    lat: -21.882685
  },
  {
    lng: -41.7880383,
    lat: -21.8825681
  },
  {
    lng: -41.7875045,
    lat: -21.8821499
  },
  {
    lng: -41.7874029,
    lat: -21.8820129
  },
  {
    lng: -41.7873571,
    lat: -21.8818759
  },
  {
    lng: -41.787357,
    lat: -21.8817511
  },
  {
    lng: -41.7874253,
    lat: -21.8816635
  },
  {
    lng: -41.7875026,
    lat: -21.8815969
  },
  {
    lng: -41.7877334,
    lat: -21.8814819
  },
  {
    lng: -41.787886,
    lat: -21.8814285
  },
  {
    lng: -41.7880463,
    lat: -21.8813999
  },
  {
    lng: -41.7885985,
    lat: -21.8814098
  },
  {
    lng: -41.7886199,
    lat: -21.8814102
  },
  {
    lng: -41.7887254,
    lat: -21.8813859
  },
  {
    lng: -41.7888435,
    lat: -21.8813796
  },
  {
    lng: -41.7890339,
    lat: -21.8814147
  },
  {
    lng: -41.7891991,
    lat: -21.8815001
  },
  {
    lng: -41.7893662,
    lat: -21.8814821
  },
  {
    lng: -41.7895356,
    lat: -21.8814414
  },
  {
    lng: -41.7901386,
    lat: -21.8811942
  },
  {
    lng: -41.7906431,
    lat: -21.8810299
  },
  {
    lng: -41.7910808,
    lat: -21.8808215
  },
  {
    lng: -41.7915439,
    lat: -21.8806287
  },
  {
    lng: -41.7930564,
    lat: -21.8800802
  },
  {
    lng: -41.7932558,
    lat: -21.8800319
  },
  {
    lng: -41.7934766,
    lat: -21.8800094
  },
  {
    lng: -41.7936507,
    lat: -21.8800623
  },
  {
    lng: -41.7938371,
    lat: -21.8800751
  },
  {
    lng: -41.7939059,
    lat: -21.8800189
  },
  {
    lng: -41.7939874,
    lat: -21.8799814
  },
  {
    lng: -41.7940691,
    lat: -21.8799653
  },
  {
    lng: -41.7941568,
    lat: -21.8799684
  },
  {
    lng: -41.7942963,
    lat: -21.8799322
  },
  {
    lng: -41.7944083,
    lat: -21.8798814
  },
  {
    lng: -41.7945313,
    lat: -21.8797962
  },
  {
    lng: -41.7947477,
    lat: -21.8796824
  },
  {
    lng: -41.7950886,
    lat: -21.8794442
  },
  {
    lng: -41.7953032,
    lat: -21.879326
  },
  {
    lng: -41.795491,
    lat: -21.8792845
  },
  {
    lng: -41.7956687,
    lat: -21.8791727
  },
  {
    lng: -41.7958648,
    lat: -21.879094
  },
  {
    lng: -41.7961242,
    lat: -21.8790486
  },
  {
    lng: -41.796276,
    lat: -21.8789845
  },
  {
    lng: -41.796364,
    lat: -21.8789757
  },
  {
    lng: -41.7964531,
    lat: -21.8789855
  },
  {
    lng: -41.7965011,
    lat: -21.8789631
  },
  {
    lng: -41.7965777,
    lat: -21.8788946
  },
  {
    lng: -41.7966175,
    lat: -21.8788122
  },
  {
    lng: -41.796619,
    lat: -21.87877
  },
  {
    lng: -41.7966254,
    lat: -21.8785908
  },
  {
    lng: -41.7966706,
    lat: -21.8783397
  },
  {
    lng: -41.7966425,
    lat: -21.8782371
  },
  {
    lng: -41.7964754,
    lat: -21.8779451
  },
  {
    lng: -41.7963844,
    lat: -21.8776669
  },
  {
    lng: -41.7963509,
    lat: -21.877513
  },
  {
    lng: -41.7963779,
    lat: -21.8773694
  },
  {
    lng: -41.7963656,
    lat: -21.8771731
  },
  {
    lng: -41.796385,
    lat: -21.8770608
  },
  {
    lng: -41.7964304,
    lat: -21.8769527
  },
  {
    lng: -41.796513,
    lat: -21.876898
  },
  {
    lng: -41.7966073,
    lat: -21.8768595
  },
  {
    lng: -41.7967852,
    lat: -21.8768333
  },
  {
    lng: -41.7969496,
    lat: -21.8768386
  },
  {
    lng: -41.7973299,
    lat: -21.8769063
  },
  {
    lng: -41.7974531,
    lat: -21.8769274
  },
  {
    lng: -41.7977136,
    lat: -21.8769719
  },
  {
    lng: -41.7978529,
    lat: -21.8770005
  },
  {
    lng: -41.7980621,
    lat: -21.8770856
  },
  {
    lng: -41.7984005,
    lat: -21.8772536
  },
  {
    lng: -41.7988435,
    lat: -21.877423
  },
  {
    lng: -41.7991911,
    lat: -21.8776411
  },
  {
    lng: -41.7992116,
    lat: -21.8776509
  },
  {
    lng: -41.7994101,
    lat: -21.8777463
  },
  {
    lng: -41.7996703,
    lat: -21.8777427
  },
  {
    lng: -41.7999442,
    lat: -21.8777797
  },
  {
    lng: -41.8000619,
    lat: -21.8777629
  },
  {
    lng: -41.8001962,
    lat: -21.8777644
  },
  {
    lng: -41.8002679,
    lat: -21.8777799
  },
  {
    lng: -41.8003925,
    lat: -21.8778068
  },
  {
    lng: -41.8005997,
    lat: -21.8778033
  },
  {
    lng: -41.800788,
    lat: -21.8778233
  },
  {
    lng: -41.8012338,
    lat: -21.8779319
  },
  {
    lng: -41.8017608,
    lat: -21.8779771
  },
  {
    lng: -41.8018196,
    lat: -21.8779821
  },
  {
    lng: -41.8019527,
    lat: -21.8779935
  },
  {
    lng: -41.8024053,
    lat: -21.8780144
  },
  {
    lng: -41.802547,
    lat: -21.878021
  },
  {
    lng: -41.8029794,
    lat: -21.8781192
  },
  {
    lng: -41.8031152,
    lat: -21.8781941
  },
  {
    lng: -41.8032281,
    lat: -21.8782993
  },
  {
    lng: -41.803404,
    lat: -21.8782854
  },
  {
    lng: -41.8035082,
    lat: -21.8783076
  },
  {
    lng: -41.8036003,
    lat: -21.8783505
  },
  {
    lng: -41.8043641,
    lat: -21.8784095
  },
  {
    lng: -41.8049518,
    lat: -21.8785301
  },
  {
    lng: -41.8050916,
    lat: -21.8785991
  },
  {
    lng: -41.8051508,
    lat: -21.8786038
  },
  {
    lng: -41.8052423,
    lat: -21.8786235
  },
  {
    lng: -41.8053246,
    lat: -21.878649
  },
  {
    lng: -41.8054403,
    lat: -21.8786998
  },
  {
    lng: -41.8055197,
    lat: -21.8787349
  },
  {
    lng: -41.8056211,
    lat: -21.8787764
  },
  {
    lng: -41.8057223,
    lat: -21.8788282
  },
  {
    lng: -41.8058178,
    lat: -21.8788841
  },
  {
    lng: -41.8059384,
    lat: -21.8789617
  },
  {
    lng: -41.8061138,
    lat: -21.8790858
  },
  {
    lng: -41.8061758,
    lat: -21.8791529
  },
  {
    lng: -41.8063004,
    lat: -21.8792696
  },
  {
    lng: -41.8063964,
    lat: -21.8793875
  },
  {
    lng: -41.8064953,
    lat: -21.8794906
  },
  {
    lng: -41.8065875,
    lat: -21.8795404
  },
  {
    lng: -41.806612,
    lat: -21.8795536
  },
  {
    lng: -41.8067201,
    lat: -21.8795879
  },
  {
    lng: -41.8068022,
    lat: -21.8796029
  },
  {
    lng: -41.8068874,
    lat: -21.8795774
  },
  {
    lng: -41.8070985,
    lat: -21.8794298
  },
  {
    lng: -41.8072624,
    lat: -21.8793543
  },
  {
    lng: -41.8075623,
    lat: -21.8792553
  },
  {
    lng: -41.8077054,
    lat: -21.8792746
  },
  {
    lng: -41.8078129,
    lat: -21.8793148
  },
  {
    lng: -41.8079076,
    lat: -21.879379
  },
  {
    lng: -41.8079566,
    lat: -21.8794265
  },
  {
    lng: -41.8080302,
    lat: -21.879515
  },
  {
    lng: -41.808074,
    lat: -21.8795864
  },
  {
    lng: -41.8081126,
    lat: -21.8796759
  },
  {
    lng: -41.8081459,
    lat: -21.879748
  },
  {
    lng: -41.8081929,
    lat: -21.8798482
  },
  {
    lng: -41.8082218,
    lat: -21.879943
  },
  {
    lng: -41.8082349,
    lat: -21.8800165
  },
  {
    lng: -41.8082701,
    lat: -21.8800834
  },
  {
    lng: -41.8083187,
    lat: -21.8801882
  },
  {
    lng: -41.8083559,
    lat: -21.880262
  },
  {
    lng: -41.8084052,
    lat: -21.8803592
  },
  {
    lng: -41.8084869,
    lat: -21.8804459
  },
  {
    lng: -41.808599,
    lat: -21.880535
  },
  {
    lng: -41.8087053,
    lat: -21.8806222
  },
  {
    lng: -41.8087902,
    lat: -21.8806758
  },
  {
    lng: -41.8089452,
    lat: -21.8807604
  },
  {
    lng: -41.809153,
    lat: -21.8808629
  },
  {
    lng: -41.8093141,
    lat: -21.880875
  },
  {
    lng: -41.809502,
    lat: -21.880857
  },
  {
    lng: -41.8096436,
    lat: -21.8808488
  },
  {
    lng: -41.8096693,
    lat: -21.8808473
  },
  {
    lng: -41.8098115,
    lat: -21.8807968
  },
  {
    lng: -41.8099263,
    lat: -21.8807148
  },
  {
    lng: -41.8100929,
    lat: -21.8806096
  },
  {
    lng: -41.8102372,
    lat: -21.8805422
  },
  {
    lng: -41.8102423,
    lat: -21.8805399
  },
  {
    lng: -41.8103503,
    lat: -21.8804922
  },
  {
    lng: -41.8104635,
    lat: -21.8804687
  },
  {
    lng: -41.8106903,
    lat: -21.8803474
  },
  {
    lng: -41.8109034,
    lat: -21.8802765
  },
  {
    lng: -41.8110948,
    lat: -21.8802652
  },
  {
    lng: -41.8111049,
    lat: -21.8802635
  },
  {
    lng: -41.8112968,
    lat: -21.8802299
  },
  {
    lng: -41.8113713,
    lat: -21.8802222
  },
  {
    lng: -41.8115098,
    lat: -21.8801637
  },
  {
    lng: -41.8116219,
    lat: -21.8801034
  },
  {
    lng: -41.8117071,
    lat: -21.8800646
  },
  {
    lng: -41.8118618,
    lat: -21.880016
  },
  {
    lng: -41.8119398,
    lat: -21.8800059
  },
  {
    lng: -41.8120239,
    lat: -21.8799704
  },
  {
    lng: -41.8120832,
    lat: -21.8799335
  },
  {
    lng: -41.8121448,
    lat: -21.8799088
  },
  {
    lng: -41.8122278,
    lat: -21.8798552
  },
  {
    lng: -41.8123771,
    lat: -21.8798011
  },
  {
    lng: -41.8124436,
    lat: -21.8797756
  },
  {
    lng: -41.8125318,
    lat: -21.8797269
  },
  {
    lng: -41.8126107,
    lat: -21.8796823
  },
  {
    lng: -41.8126217,
    lat: -21.8796746
  },
  {
    lng: -41.8126889,
    lat: -21.8796277
  },
  {
    lng: -41.8128746,
    lat: -21.8795438
  },
  {
    lng: -41.8129895,
    lat: -21.8794922
  },
  {
    lng: -41.8130722,
    lat: -21.8794768
  },
  {
    lng: -41.8131349,
    lat: -21.8795013
  },
  {
    lng: -41.8131965,
    lat: -21.8794989
  },
  {
    lng: -41.8133455,
    lat: -21.8794288
  },
  {
    lng: -41.8134388,
    lat: -21.8793941
  },
  {
    lng: -41.8135381,
    lat: -21.8793845
  },
  {
    lng: -41.8138075,
    lat: -21.8793517
  },
  {
    lng: -41.8139471,
    lat: -21.8793662
  },
  {
    lng: -41.8140149,
    lat: -21.8794057
  },
  {
    lng: -41.814133,
    lat: -21.8794391
  },
  {
    lng: -41.8142156,
    lat: -21.8794747
  },
  {
    lng: -41.8143032,
    lat: -21.8794931
  },
  {
    lng: -41.8143998,
    lat: -21.8794659
  },
  {
    lng: -41.8144776,
    lat: -21.8794416
  },
  {
    lng: -41.814581,
    lat: -21.8793996
  },
  {
    lng: -41.8146396,
    lat: -21.8793756
  },
  {
    lng: -41.8147567,
    lat: -21.8794013
  },
  {
    lng: -41.8148052,
    lat: -21.8794556
  },
  {
    lng: -41.8148945,
    lat: -21.8795496
  },
  {
    lng: -41.8149734,
    lat: -21.8796379
  },
  {
    lng: -41.8150373,
    lat: -21.8797165
  },
  {
    lng: -41.8150687,
    lat: -21.8798238
  },
  {
    lng: -41.8151525,
    lat: -21.8799254
  },
  {
    lng: -41.8153447,
    lat: -21.8799624
  },
  {
    lng: -41.8155014,
    lat: -21.8799857
  },
  {
    lng: -41.8156185,
    lat: -21.8799785
  },
  {
    lng: -41.815697,
    lat: -21.8799651
  },
  {
    lng: -41.8159387,
    lat: -21.8801117
  },
  {
    lng: -41.8160894,
    lat: -21.8801684
  },
  {
    lng: -41.8162294,
    lat: -21.8802341
  },
  {
    lng: -41.8164237,
    lat: -21.8802937
  },
  {
    lng: -41.8165495,
    lat: -21.8802577
  },
  {
    lng: -41.8167592,
    lat: -21.8802928
  },
  {
    lng: -41.8169197,
    lat: -21.8803616
  },
  {
    lng: -41.816999,
    lat: -21.8803989
  },
  {
    lng: -41.8172292,
    lat: -21.8804965
  },
  {
    lng: -41.8173532,
    lat: -21.8805579
  },
  {
    lng: -41.8175166,
    lat: -21.8806406
  },
  {
    lng: -41.817646,
    lat: -21.8807059
  },
  {
    lng: -41.8177612,
    lat: -21.880773
  },
  {
    lng: -41.8178881,
    lat: -21.8808486
  },
  {
    lng: -41.8180323,
    lat: -21.8809156
  },
  {
    lng: -41.8181056,
    lat: -21.8809217
  },
  {
    lng: -41.818232,
    lat: -21.8809262
  },
  {
    lng: -41.8183552,
    lat: -21.880946
  },
  {
    lng: -41.8184278,
    lat: -21.8809579
  },
  {
    lng: -41.8184862,
    lat: -21.8809658
  },
  {
    lng: -41.8185505,
    lat: -21.8809744
  },
  {
    lng: -41.8186167,
    lat: -21.8810278
  },
  {
    lng: -41.8186771,
    lat: -21.8810664
  },
  {
    lng: -41.8187756,
    lat: -21.8810813
  },
  {
    lng: -41.8189007,
    lat: -21.8811505
  },
  {
    lng: -41.8190442,
    lat: -21.8812273
  },
  {
    lng: -41.8191393,
    lat: -21.8812589
  },
  {
    lng: -41.8192367,
    lat: -21.8812991
  },
  {
    lng: -41.8193322,
    lat: -21.8813592
  },
  {
    lng: -41.8194114,
    lat: -21.8814239
  },
  {
    lng: -41.8195559,
    lat: -21.8815233
  },
  {
    lng: -41.819647,
    lat: -21.8815671
  },
  {
    lng: -41.8197641,
    lat: -21.881613
  },
  {
    lng: -41.819843,
    lat: -21.8816614
  },
  {
    lng: -41.8199611,
    lat: -21.8817401
  },
  {
    lng: -41.8200486,
    lat: -21.8818116
  },
  {
    lng: -41.8200832,
    lat: -21.8818407
  },
  {
    lng: -41.8201514,
    lat: -21.8818981
  },
  {
    lng: -41.8203026,
    lat: -21.8819427
  },
  {
    lng: -41.8204237,
    lat: -21.881961
  },
  {
    lng: -41.8205271,
    lat: -21.881975
  },
  {
    lng: -41.820709,
    lat: -21.8819986
  },
  {
    lng: -41.8208789,
    lat: -21.8820137
  },
  {
    lng: -41.8210128,
    lat: -21.8820168
  },
  {
    lng: -41.821154,
    lat: -21.882021
  },
  {
    lng: -41.8213368,
    lat: -21.8820416
  },
  {
    lng: -41.8214402,
    lat: -21.8820423
  },
  {
    lng: -41.8215749,
    lat: -21.8820149
  },
  {
    lng: -41.8217253,
    lat: -21.8819694
  },
  {
    lng: -41.821823,
    lat: -21.8819414
  },
  {
    lng: -41.8220229,
    lat: -21.8819004
  },
  {
    lng: -41.8221375,
    lat: -21.8819274
  },
  {
    lng: -41.8222463,
    lat: -21.8819561
  },
  {
    lng: -41.822312,
    lat: -21.8819977
  },
  {
    lng: -41.8223891,
    lat: -21.882021
  },
  {
    lng: -41.8224509,
    lat: -21.8820898
  },
  {
    lng: -41.8225224,
    lat: -21.8821472
  },
  {
    lng: -41.8226149,
    lat: -21.8821968
  },
  {
    lng: -41.8227196,
    lat: -21.8822027
  },
  {
    lng: -41.8228302,
    lat: -21.8822161
  },
  {
    lng: -41.8229485,
    lat: -21.8822018
  },
  {
    lng: -41.8229977,
    lat: -21.8822293
  },
  {
    lng: -41.8230818,
    lat: -21.8822977
  },
  {
    lng: -41.8231403,
    lat: -21.8823698
  },
  {
    lng: -41.8232017,
    lat: -21.8824116
  },
  {
    lng: -41.8232993,
    lat: -21.882447
  },
  {
    lng: -41.8234017,
    lat: -21.8824943
  },
  {
    lng: -41.8235304,
    lat: -21.8825277
  },
  {
    lng: -41.8236333,
    lat: -21.8825703
  },
  {
    lng: -41.8237234,
    lat: -21.8825692
  },
  {
    lng: -41.8238009,
    lat: -21.8825751
  },
  {
    lng: -41.823921,
    lat: -21.8826271
  },
  {
    lng: -41.8240097,
    lat: -21.8825926
  },
  {
    lng: -41.8241095,
    lat: -21.8826105
  },
  {
    lng: -41.8241277,
    lat: -21.8826517
  },
  {
    lng: -41.8241797,
    lat: -21.8827041
  },
  {
    lng: -41.8242808,
    lat: -21.8827656
  },
  {
    lng: -41.8244024,
    lat: -21.8828262
  },
  {
    lng: -41.8244777,
    lat: -21.8828915
  },
  {
    lng: -41.8245462,
    lat: -21.8829344
  },
  {
    lng: -41.8246189,
    lat: -21.8829574
  },
  {
    lng: -41.8247408,
    lat: -21.8830258
  },
  {
    lng: -41.8249111,
    lat: -21.8830681
  },
  {
    lng: -41.824992,
    lat: -21.8831041
  },
  {
    lng: -41.8250806,
    lat: -21.8831435
  },
  {
    lng: -41.8253754,
    lat: -21.8832462
  },
  {
    lng: -41.8254346,
    lat: -21.8832612
  },
  {
    lng: -41.8255644,
    lat: -21.8833134
  },
  {
    lng: -41.8256454,
    lat: -21.8833551
  },
  {
    lng: -41.8257344,
    lat: -21.8833942
  },
  {
    lng: -41.8258176,
    lat: -21.8834147
  },
  {
    lng: -41.8259199,
    lat: -21.883431
  },
  {
    lng: -41.8259988,
    lat: -21.8834308
  },
  {
    lng: -41.8261367,
    lat: -21.8834383
  },
  {
    lng: -41.8262269,
    lat: -21.8834573
  },
  {
    lng: -41.826305,
    lat: -21.8834991
  },
  {
    lng: -41.8263811,
    lat: -21.8835391
  },
  {
    lng: -41.8264775,
    lat: -21.8835743
  },
  {
    lng: -41.8265404,
    lat: -21.8836077
  },
  {
    lng: -41.8265965,
    lat: -21.8836668
  },
  {
    lng: -41.8266918,
    lat: -21.8837344
  },
  {
    lng: -41.826749,
    lat: -21.8837707
  },
  {
    lng: -41.826883,
    lat: -21.8838092
  },
  {
    lng: -41.8270223,
    lat: -21.8838743
  },
  {
    lng: -41.8271285,
    lat: -21.8839594
  },
  {
    lng: -41.8272875,
    lat: -21.8840726
  },
  {
    lng: -41.8274727,
    lat: -21.8841795
  },
  {
    lng: -41.8275799,
    lat: -21.8842143
  },
  {
    lng: -41.8278153,
    lat: -21.8843491
  },
  {
    lng: -41.827988,
    lat: -21.8844784
  },
  {
    lng: -41.8281463,
    lat: -21.8846079
  },
  {
    lng: -41.8281963,
    lat: -21.8846879
  },
  {
    lng: -41.8282553,
    lat: -21.8847791
  },
  {
    lng: -41.8283302,
    lat: -21.8848559
  },
  {
    lng: -41.8283983,
    lat: -21.8849722
  },
  {
    lng: -41.8284566,
    lat: -21.8850377
  },
  {
    lng: -41.8285162,
    lat: -21.8851111
  },
  {
    lng: -41.828595,
    lat: -21.885203
  },
  {
    lng: -41.8286596,
    lat: -21.8852687
  },
  {
    lng: -41.8286944,
    lat: -21.885306
  },
  {
    lng: -41.8287438,
    lat: -21.8853404
  },
  {
    lng: -41.8287501,
    lat: -21.8853446
  },
  {
    lng: -41.8288075,
    lat: -21.8853827
  },
  {
    lng: -41.8288861,
    lat: -21.8854244
  },
  {
    lng: -41.8289396,
    lat: -21.8854795
  },
  {
    lng: -41.8290143,
    lat: -21.8855527
  },
  {
    lng: -41.8291174,
    lat: -21.8856139
  },
  {
    lng: -41.8292417,
    lat: -21.8856987
  },
  {
    lng: -41.8293184,
    lat: -21.8857436
  },
  {
    lng: -41.8295301,
    lat: -21.8857527
  },
  {
    lng: -41.8296527,
    lat: -21.8856901
  },
  {
    lng: -41.8299344,
    lat: -21.8856102
  },
  {
    lng: -41.8301292,
    lat: -21.8855853
  },
  {
    lng: -41.8302551,
    lat: -21.8856037
  },
  {
    lng: -41.8302878,
    lat: -21.8856187
  },
  {
    lng: -41.8303625,
    lat: -21.8856388
  },
  {
    lng: -41.8304818,
    lat: -21.8856464
  },
  {
    lng: -41.8306569,
    lat: -21.8855405
  },
  {
    lng: -41.830724,
    lat: -21.8854647
  },
  {
    lng: -41.8307899,
    lat: -21.8853706
  },
  {
    lng: -41.8310193,
    lat: -21.8852516
  },
  {
    lng: -41.8311338,
    lat: -21.8852622
  },
  {
    lng: -41.8312767,
    lat: -21.8853558
  },
  {
    lng: -41.8313516,
    lat: -21.8854251
  },
  {
    lng: -41.8314701,
    lat: -21.8855271
  },
  {
    lng: -41.8317831,
    lat: -21.885721
  },
  {
    lng: -41.8319318,
    lat: -21.8857306
  },
  {
    lng: -41.8320742,
    lat: -21.88576
  },
  {
    lng: -41.8321926,
    lat: -21.8858274
  },
  {
    lng: -41.8322967,
    lat: -21.8859171
  },
  {
    lng: -41.8323519,
    lat: -21.8859692
  },
  {
    lng: -41.8324809,
    lat: -21.8860745
  },
  {
    lng: -41.8325472,
    lat: -21.8861133
  },
  {
    lng: -41.8326427,
    lat: -21.8861956
  },
  {
    lng: -41.8327453,
    lat: -21.8862434
  },
  {
    lng: -41.8328666,
    lat: -21.8862561
  },
  {
    lng: -41.8330618,
    lat: -21.8863316
  },
  {
    lng: -41.8330642,
    lat: -21.8863326
  },
  {
    lng: -41.8333447,
    lat: -21.8864572
  },
  {
    lng: -41.8334598,
    lat: -21.8865162
  },
  {
    lng: -41.8338442,
    lat: -21.8866452
  },
  {
    lng: -41.8341963,
    lat: -21.8866992
  },
  {
    lng: -41.8343408,
    lat: -21.8866889
  },
  {
    lng: -41.8346688,
    lat: -21.8868321
  },
  {
    lng: -41.8348862,
    lat: -21.8869656
  },
  {
    lng: -41.835263,
    lat: -21.8870864
  },
  {
    lng: -41.8356453,
    lat: -21.8872019
  },
  {
    lng: -41.8360429,
    lat: -21.887225
  },
  {
    lng: -41.8362554,
    lat: -21.8872219
  },
  {
    lng: -41.8364246,
    lat: -21.8872193
  },
  {
    lng: -41.8368228,
    lat: -21.8871121
  },
  {
    lng: -41.8372066,
    lat: -21.8870686
  },
  {
    lng: -41.8375181,
    lat: -21.8870833
  },
  {
    lng: -41.8378723,
    lat: -21.8872586
  },
  {
    lng: -41.8378949,
    lat: -21.8872695
  },
  {
    lng: -41.8382409,
    lat: -21.8874512
  },
  {
    lng: -41.838593,
    lat: -21.8876002
  },
  {
    lng: -41.8389885,
    lat: -21.8876739
  },
  {
    lng: -41.8394108,
    lat: -21.8877138
  },
  {
    lng: -41.8397189,
    lat: -21.8877827
  },
  {
    lng: -41.8400235,
    lat: -21.8876994
  },
  {
    lng: -41.8402262,
    lat: -21.8877793
  },
  {
    lng: -41.8406509,
    lat: -21.887767
  },
  {
    lng: -41.8407228,
    lat: -21.8877909
  },
  {
    lng: -41.8411024,
    lat: -21.8878688
  },
  {
    lng: -41.8412178,
    lat: -21.8878374
  },
  {
    lng: -41.8415086,
    lat: -21.8875793
  },
  {
    lng: -41.8417412,
    lat: -21.887489
  },
  {
    lng: -41.8418188,
    lat: -21.8874881
  },
  {
    lng: -41.8419708,
    lat: -21.8874862
  },
  {
    lng: -41.8423594,
    lat: -21.8874057
  },
  {
    lng: -41.8425485,
    lat: -21.8873657
  },
  {
    lng: -41.8429085,
    lat: -21.8872111
  },
  {
    lng: -41.843187,
    lat: -21.8871802
  },
  {
    lng: -41.8433687,
    lat: -21.8870313
  },
  {
    lng: -41.8434656,
    lat: -21.8869705
  },
  {
    lng: -41.8438519,
    lat: -21.8869152
  },
  {
    lng: -41.8442381,
    lat: -21.8868586
  },
  {
    lng: -41.8443571,
    lat: -21.8868957
  },
  {
    lng: -41.8447353,
    lat: -21.8869724
  },
  {
    lng: -41.8449236,
    lat: -21.8869205
  },
  {
    lng: -41.8449933,
    lat: -21.8869013
  },
  {
    lng: -41.8452215,
    lat: -21.8869114
  },
  {
    lng: -41.8456333,
    lat: -21.8868659
  },
  {
    lng: -41.845999,
    lat: -21.8868564
  },
  {
    lng: -41.8461619,
    lat: -21.8868816
  },
  {
    lng: -41.8465685,
    lat: -21.8868653
  },
  {
    lng: -41.8468707,
    lat: -21.886819
  },
  {
    lng: -41.8469208,
    lat: -21.8868129
  },
  {
    lng: -41.8473048,
    lat: -21.8868456
  },
  {
    lng: -41.8475275,
    lat: -21.8870059
  },
  {
    lng: -41.8477874,
    lat: -21.8872014
  },
  {
    lng: -41.848148,
    lat: -21.8873738
  },
  {
    lng: -41.8483711,
    lat: -21.8874966
  },
  {
    lng: -41.8487587,
    lat: -21.8876058
  },
  {
    lng: -41.8489865,
    lat: -21.8875764
  },
  {
    lng: -41.8492611,
    lat: -21.8873538
  },
  {
    lng: -41.8493862,
    lat: -21.8870051
  },
  {
    lng: -41.8494684,
    lat: -21.8867344
  },
  {
    lng: -41.8496075,
    lat: -21.8863767
  },
  {
    lng: -41.8499337,
    lat: -21.8861221
  },
  {
    lng: -41.8500609,
    lat: -21.8860156
  },
  {
    lng: -41.8504005,
    lat: -21.8859003
  },
  {
    lng: -41.8507755,
    lat: -21.8859284
  },
  {
    lng: -41.8510183,
    lat: -21.8859649
  },
  {
    lng: -41.8511794,
    lat: -21.8859891
  },
  {
    lng: -41.8515464,
    lat: -21.8860825
  },
  {
    lng: -41.8519133,
    lat: -21.8860936
  },
  {
    lng: -41.8522707,
    lat: -21.886036
  },
  {
    lng: -41.8523086,
    lat: -21.8860299
  },
  {
    lng: -41.8526866,
    lat: -21.8859603
  },
  {
    lng: -41.8530986,
    lat: -21.8858158
  },
  {
    lng: -41.8534945,
    lat: -21.8856795
  },
  {
    lng: -41.8538203,
    lat: -21.8854806
  },
  {
    lng: -41.8541878,
    lat: -21.8853396
  },
  {
    lng: -41.8545173,
    lat: -21.8851681
  },
  {
    lng: -41.85453,
    lat: -21.8851615
  },
  {
    lng: -41.854918,
    lat: -21.8850595
  },
  {
    lng: -41.8553276,
    lat: -21.8849441
  },
  {
    lng: -41.8557631,
    lat: -21.8848898
  },
  {
    lng: -41.8561906,
    lat: -21.8848853
  },
  {
    lng: -41.8564919,
    lat: -21.8848551
  },
  {
    lng: -41.856882,
    lat: -21.8848283
  },
  {
    lng: -41.8572178,
    lat: -21.8848041
  },
  {
    lng: -41.8573298,
    lat: -21.884796
  },
  {
    lng: -41.8577394,
    lat: -21.8847706
  },
  {
    lng: -41.8581301,
    lat: -21.884747
  },
  {
    lng: -41.8585448,
    lat: -21.8847696
  },
  {
    lng: -41.8588964,
    lat: -21.8849593
  },
  {
    lng: -41.8592393,
    lat: -21.8851775
  },
  {
    lng: -41.8595426,
    lat: -21.8852407
  },
  {
    lng: -41.8597207,
    lat: -21.8851954
  },
  {
    lng: -41.8600417,
    lat: -21.8850533
  },
  {
    lng: -41.8601049,
    lat: -21.8850364
  },
  {
    lng: -41.8604839,
    lat: -21.885012
  },
  {
    lng: -41.8609019,
    lat: -21.8849893
  },
  {
    lng: -41.8612762,
    lat: -21.8850128
  },
  {
    lng: -41.8616682,
    lat: -21.8850999
  },
  {
    lng: -41.862042,
    lat: -21.8851882
  },
  {
    lng: -41.8624357,
    lat: -21.8851529
  },
  {
    lng: -41.8628302,
    lat: -21.8851118
  },
  {
    lng: -41.8631936,
    lat: -21.8850453
  },
  {
    lng: -41.8635462,
    lat: -21.8848588
  },
  {
    lng: -41.8636032,
    lat: -21.8848065
  },
  {
    lng: -41.8636267,
    lat: -21.8847849
  },
  {
    lng: -41.8640333,
    lat: -21.8846941
  },
  {
    lng: -41.8641165,
    lat: -21.8846973
  },
  {
    lng: -41.8645126,
    lat: -21.8846342
  },
  {
    lng: -41.8649164,
    lat: -21.8845828
  },
  {
    lng: -41.8649445,
    lat: -21.8845792
  },
  {
    lng: -41.8653153,
    lat: -21.884547
  },
  {
    lng: -41.8656192,
    lat: -21.8846212
  },
  {
    lng: -41.8657286,
    lat: -21.8847249
  },
  {
    lng: -41.8660284,
    lat: -21.884957
  },
  {
    lng: -41.8662782,
    lat: -21.8850346
  },
  {
    lng: -41.8666761,
    lat: -21.8849994
  },
  {
    lng: -41.867069,
    lat: -21.8849086
  },
  {
    lng: -41.8670779,
    lat: -21.8849065
  },
  {
    lng: -41.867273,
    lat: -21.8848919
  },
  {
    lng: -41.8675264,
    lat: -21.8847901
  },
  {
    lng: -41.8675844,
    lat: -21.8847445
  },
  {
    lng: -41.867936,
    lat: -21.8845872
  },
  {
    lng: -41.8680229,
    lat: -21.8845639
  },
  {
    lng: -41.8684222,
    lat: -21.8845248
  },
  {
    lng: -41.8688278,
    lat: -21.8845518
  },
  {
    lng: -41.8688473,
    lat: -21.8845519
  },
  {
    lng: -41.8688709,
    lat: -21.8845566
  },
  {
    lng: -41.8691127,
    lat: -21.8843131
  },
  {
    lng: -41.8694377,
    lat: -21.884103
  },
  {
    lng: -41.8698142,
    lat: -21.8839718
  },
  {
    lng: -41.8702003,
    lat: -21.8838407
  },
  {
    lng: -41.8703663,
    lat: -21.8838093
  },
  {
    lng: -41.870593,
    lat: -21.8837665
  },
  {
    lng: -41.8709227,
    lat: -21.8835767
  },
  {
    lng: -41.8710093,
    lat: -21.8835229
  },
  {
    lng: -41.871348,
    lat: -21.8833403
  },
  {
    lng: -41.8716695,
    lat: -21.8831387
  },
  {
    lng: -41.8718149,
    lat: -21.8830167
  },
  {
    lng: -41.8718901,
    lat: -21.8829758
  },
  {
    lng: -41.8722689,
    lat: -21.8829761
  },
  {
    lng: -41.8723446,
    lat: -21.8829848
  },
  {
    lng: -41.8727566,
    lat: -21.8830532
  },
  {
    lng: -41.873177,
    lat: -21.883141
  },
  {
    lng: -41.8732512,
    lat: -21.8831615
  },
  {
    lng: -41.8736365,
    lat: -21.883181
  },
  {
    lng: -41.8738101,
    lat: -21.8831754
  },
  {
    lng: -41.8741848,
    lat: -21.8829792
  },
  {
    lng: -41.8744857,
    lat: -21.8827299
  },
  {
    lng: -41.8745074,
    lat: -21.8827258
  },
  {
    lng: -41.874695,
    lat: -21.8826903
  },
  {
    lng: -41.875104,
    lat: -21.8826995
  },
  {
    lng: -41.875493,
    lat: -21.8826848
  },
  {
    lng: -41.8758922,
    lat: -21.8826876
  },
  {
    lng: -41.8762988,
    lat: -21.882632
  },
  {
    lng: -41.8766281,
    lat: -21.882501
  },
  {
    lng: -41.8770078,
    lat: -21.8824083
  },
  {
    lng: -41.8773683,
    lat: -21.8822728
  },
  {
    lng: -41.8777914,
    lat: -21.8821442
  },
  {
    lng: -41.8781653,
    lat: -21.8820787
  },
  {
    lng: -41.8785272,
    lat: -21.8820722
  },
  {
    lng: -41.8788565,
    lat: -21.8819333
  },
  {
    lng: -41.8790318,
    lat: -21.8817929
  },
  {
    lng: -41.8791434,
    lat: -21.8817035
  },
  {
    lng: -41.8794746,
    lat: -21.8814686
  },
  {
    lng: -41.8798008,
    lat: -21.8812838
  },
  {
    lng: -41.8801965,
    lat: -21.8811802
  },
  {
    lng: -41.8806455,
    lat: -21.8811178
  },
  {
    lng: -41.8810428,
    lat: -21.8811031
  },
  {
    lng: -41.8812589,
    lat: -21.8811098
  },
  {
    lng: -41.8814684,
    lat: -21.8811163
  },
  {
    lng: -41.8818795,
    lat: -21.8811107
  },
  {
    lng: -41.8822744,
    lat: -21.8810338
  },
  {
    lng: -41.8826865,
    lat: -21.8809834
  },
  {
    lng: -41.8830835,
    lat: -21.8809123
  },
  {
    lng: -41.8834555,
    lat: -21.8808333
  },
  {
    lng: -41.8838882,
    lat: -21.8807046
  },
  {
    lng: -41.884301,
    lat: -21.8806497
  },
  {
    lng: -41.8846866,
    lat: -21.8806201
  },
  {
    lng: -41.8850746,
    lat: -21.880646
  },
  {
    lng: -41.8854853,
    lat: -21.8806009
  },
  {
    lng: -41.8856164,
    lat: -21.8805732
  },
  {
    lng: -41.8858712,
    lat: -21.8805193
  },
  {
    lng: -41.8862481,
    lat: -21.8806575
  },
  {
    lng: -41.8866353,
    lat: -21.8807075
  },
  {
    lng: -41.8868175,
    lat: -21.8807408
  },
  {
    lng: -41.8871058,
    lat: -21.8805272
  },
  {
    lng: -41.887475,
    lat: -21.8803412
  },
  {
    lng: -41.8877598,
    lat: -21.8801041
  },
  {
    lng: -41.8879651,
    lat: -21.8797974
  },
  {
    lng: -41.8880527,
    lat: -21.8794368
  },
  {
    lng: -41.887998,
    lat: -21.8790541
  },
  {
    lng: -41.8881232,
    lat: -21.8786873
  },
  {
    lng: -41.8882123,
    lat: -21.8783021
  },
  {
    lng: -41.8884012,
    lat: -21.8779589
  },
  {
    lng: -41.8883945,
    lat: -21.8779217
  },
  {
    lng: -41.8883374,
    lat: -21.8776002
  },
  {
    lng: -41.8880898,
    lat: -21.8773092
  },
  {
    lng: -41.8877948,
    lat: -21.8770775
  },
  {
    lng: -41.8874628,
    lat: -21.8769559
  },
  {
    lng: -41.8873606,
    lat: -21.8768659
  },
  {
    lng: -41.8871544,
    lat: -21.8765174
  },
  {
    lng: -41.8871066,
    lat: -21.8763875
  },
  {
    lng: -41.8868398,
    lat: -21.8760782
  },
  {
    lng: -41.8865286,
    lat: -21.8758666
  },
  {
    lng: -41.8861803,
    lat: -21.8755899
  },
  {
    lng: -41.8858748,
    lat: -21.8753511
  },
  {
    lng: -41.8855449,
    lat: -21.8751284
  },
  {
    lng: -41.8853222,
    lat: -21.8747578
  },
  {
    lng: -41.8850975,
    lat: -21.8745796
  },
  {
    lng: -41.8847851,
    lat: -21.874355
  },
  {
    lng: -41.8844556,
    lat: -21.8741718
  },
  {
    lng: -41.8840968,
    lat: -21.8739139
  },
  {
    lng: -41.8838373,
    lat: -21.873652
  },
  {
    lng: -41.8835799,
    lat: -21.8733396
  },
  {
    lng: -41.8832301,
    lat: -21.8731395
  },
  {
    lng: -41.8826525,
    lat: -21.8726932
  },
  {
    lng: -41.8834298,
    lat: -21.8722967
  },
  {
    lng: -41.8838798,
    lat: -21.8723442
  },
  {
    lng: -41.8840891,
    lat: -21.8721641
  },
  {
    lng: -41.8843342,
    lat: -21.8717639
  },
  {
    lng: -41.8844731,
    lat: -21.8713004
  },
  {
    lng: -41.8846343,
    lat: -21.8709248
  },
  {
    lng: -41.8847623,
    lat: -21.8705967
  },
  {
    lng: -41.8848724,
    lat: -21.8703005
  },
  {
    lng: -41.885059,
    lat: -21.8699499
  },
  {
    lng: -41.8853763,
    lat: -21.8697699
  },
  {
    lng: -41.8858116,
    lat: -21.8696088
  },
  {
    lng: -41.8861702,
    lat: -21.8694062
  },
  {
    lng: -41.886425,
    lat: -21.8692736
  },
  {
    lng: -41.8866277,
    lat: -21.8691099
  },
  {
    lng: -41.8868465,
    lat: -21.8688978
  },
  {
    lng: -41.8870495,
    lat: -21.86875
  },
  {
    lng: -41.8871631,
    lat: -21.8682175
  },
  {
    lng: -41.8875953,
    lat: -21.8676047
  },
  {
    lng: -41.8877787,
    lat: -21.8675151
  },
  {
    lng: -41.8879572,
    lat: -21.8671835
  },
  {
    lng: -41.8880601,
    lat: -21.8670876
  },
  {
    lng: -41.8882454,
    lat: -21.8669057
  },
  {
    lng: -41.8882949,
    lat: -21.8666164
  },
  {
    lng: -41.8883167,
    lat: -21.8664072
  },
  {
    lng: -41.8882728,
    lat: -21.8660436
  },
  {
    lng: -41.8882285,
    lat: -21.8656961
  },
  {
    lng: -41.8884729,
    lat: -21.8651767
  },
  {
    lng: -41.8883322,
    lat: -21.8644968
  }
];

export default polygonCampos;